/* ═══════════════════════════════════════════════════════════════
   DEMO DEL PORTAL DE COMPRAS · Kennedy Center

   Los datos son INVENTADOS: proveedores, órdenes, artículos,
   bancos y montos. No se conecta a SAP ni a la base real.
   Lo que se cambia vive en memoria y se pierde al recargar.

   Orden de este archivo:
     1. los datos falsos
     2. la capa que sustituye a Supabase
     3. la aplicación, igual que en producción
   ═══════════════════════════════════════════════════════════════ */

/* ── 1 · LOS DATOS ─────────────────────────────────────────── */
window.__DEMO_DATOS={"opor_ordenes": [{"docentry": 12510, "docnum": "12510", "docdate": "2026-07-26", "duedate": "2026-10-20", "vendor_code": "P2101", "vendor_name": "AURELIA HOMEWARE LTD", "estado": "O", "total": 8928.0, "comentarios": "Reposición Hogar temporada", "num_proveedor": "PI-9930", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "PUERTO AZUL", "contenedor": "DEMO8246185", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "pedido", "fecha_abono": "2026-07-31", "eta": "2026-10-20", "pais": "India", "puerto_embarque": "Alexandria", "marca_cliente": "DKC-26001", "abono": 0.0, "doc_status": "O", "saldo_cxp": 8928.0, "vendor_email": "ventas@aurelia.com", "unidades": 2100, "grupo_items": "..Hogar", "primera_desc": "SET DE 3 RECIPIENTES HERMÉTICOS"}, {"docentry": 12516, "docnum": "12516", "docdate": "2026-07-08", "duedate": "2026-09-11", "vendor_code": "P2103", "vendor_name": "CASA NORDIA TRADING", "estado": "O", "total": 6708.0, "comentarios": "Reposición Hogar temporada", "num_proveedor": "PI-2487", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "VIENTO NORTE", "contenedor": "DEMO8154073", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "deposito", "fecha_abono": "2026-07-13", "eta": "2026-09-11", "pais": "Indonesia", "puerto_embarque": "Chittagong", "marca_cliente": "DKC-26002", "abono": 2012.4, "doc_status": "O", "saldo_cxp": 4695.6, "vendor_email": "ventas@casa.com", "unidades": 1800, "grupo_items": "..Hogar", "primera_desc": "TABLA DE PICAR BAMBÚ"}, {"docentry": 12526, "docnum": "12526", "docdate": "2026-07-07", "duedate": "2026-11-21", "vendor_code": "P2103", "vendor_name": "CASA NORDIA TRADING", "estado": "O", "total": 1710.0, "comentarios": "Reposición Hogar temporada", "num_proveedor": "PI-7281", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "PUERTO AZUL", "contenedor": "DEMO8214264", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "artes", "fecha_abono": "2026-07-12", "eta": "2026-11-21", "pais": "China", "puerto_embarque": "Shanghai", "marca_cliente": "DKC-26003", "abono": 513.0, "doc_status": "O", "saldo_cxp": 1197.0, "vendor_email": "ventas@casa.com", "unidades": 600, "grupo_items": "..Hogar", "primera_desc": "DISPENSADOR DE JABÓN ESPUMOSO"}, {"docentry": 12537, "docnum": "12537", "docdate": "2026-06-16", "duedate": "2026-10-26", "vendor_code": "P2101", "vendor_name": "AURELIA HOMEWARE LTD", "estado": "O", "total": 9108.0, "comentarios": "Reposición Hogar temporada", "num_proveedor": "PI-9238", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO9246832", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "produccion", "fecha_abono": "2026-06-21", "eta": "2026-10-26", "pais": "India", "puerto_embarque": "Chittagong", "marca_cliente": "DKC-26004", "abono": 2732.4, "doc_status": "O", "saldo_cxp": 6375.6, "vendor_email": "ventas@aurelia.com", "unidades": 1800, "grupo_items": "..Hogar", "primera_desc": "DISPENSADOR DE CEREALES"}, {"docentry": 12547, "docnum": "12547", "docdate": "2026-05-22", "duedate": "2026-11-10", "vendor_code": "P2103", "vendor_name": "CASA NORDIA TRADING", "estado": "O", "total": 10072.8, "comentarios": "Reposición Hogar temporada", "num_proveedor": "PI-8139", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO9373809", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "logistica", "fecha_abono": "2026-05-27", "eta": "2026-11-10", "pais": "Bangladesh", "puerto_embarque": "Hai Phong", "marca_cliente": "DKC-26005", "abono": 3021.84, "doc_status": "O", "saldo_cxp": 7050.96, "vendor_email": "ventas@casa.com", "unidades": 2520, "grupo_items": "..Hogar", "primera_desc": "SET DE 3 RECIPIENTES HERMÉTICOS"}, {"docentry": 12553, "docnum": "12553", "docdate": "2026-05-15", "duedate": "2026-09-11", "vendor_code": "P2101", "vendor_name": "AURELIA HOMEWARE LTD", "estado": "O", "total": 12564.0, "comentarios": "Reposición Hogar temporada", "num_proveedor": "PI-5190", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO4404331", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "aduana", "fecha_abono": "2026-05-20", "eta": "2026-09-11", "pais": "Bangladesh", "puerto_embarque": "Shanghai", "marca_cliente": "DKC-26006", "abono": 3769.2, "doc_status": "O", "saldo_cxp": 8794.8, "vendor_email": "ventas@aurelia.com", "unidades": 3240, "grupo_items": "..Hogar", "primera_desc": "ORGANIZADOR DE GAVETAS 4 DIVISIONES"}, {"docentry": 12557, "docnum": "12557", "docdate": "2026-04-21", "duedate": "2026-09-09", "vendor_code": "P2103", "vendor_name": "CASA NORDIA TRADING", "estado": "O", "total": 8172.0, "comentarios": "Reposición Hogar temporada", "num_proveedor": "PI-6389", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO4332055", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "bodega", "fecha_abono": "2026-04-26", "eta": "2026-09-09", "pais": "Indonesia", "puerto_embarque": "Shanghai", "marca_cliente": "DKC-26007", "abono": 2451.6, "doc_status": "O", "saldo_cxp": 5720.4, "vendor_email": "ventas@casa.com", "unidades": 3240, "grupo_items": "..Hogar", "primera_desc": "ORGANIZADOR DE GAVETAS 4 DIVISIONES"}, {"docentry": 12566, "docnum": "12566", "docdate": "2026-07-20", "duedate": "2026-09-25", "vendor_code": "P1503", "vendor_name": "PALMERA TEXTIL EXPORT", "estado": "O", "total": 49988.4, "comentarios": "Reposición Alfombra temporada", "num_proveedor": "PI-2764", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "MAR SERENO", "contenedor": "DEMO7155565", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "pedido", "fecha_abono": "2026-07-25", "eta": "2026-09-25", "pais": "China", "puerto_embarque": "Chittagong", "marca_cliente": "DKC-26008", "abono": 0.0, "doc_status": "O", "saldo_cxp": 49988.4, "vendor_email": "ventas@palmera.com", "unidades": 2760, "grupo_items": "..Alfombra", "primera_desc": "ALFOMBRA DE ENTRADA ANTIDESLIZANTE"}, {"docentry": 12571, "docnum": "12571", "docdate": "2026-07-01", "duedate": "2026-09-25", "vendor_code": "P1503", "vendor_name": "PALMERA TEXTIL EXPORT", "estado": "O", "total": 35616.0, "comentarios": "Reposición Alfombra temporada", "num_proveedor": "PI-8831", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "MAR SERENO", "contenedor": "DEMO5809405", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "deposito", "fecha_abono": "2026-07-06", "eta": "2026-09-25", "pais": "Vietnam", "puerto_embarque": "Ningbo", "marca_cliente": "DKC-26009", "abono": 10684.8, "doc_status": "O", "saldo_cxp": 24931.2, "vendor_email": "ventas@palmera.com", "unidades": 3000, "grupo_items": "..Alfombra", "primera_desc": "TAPETE DE BAÑO MEMORY FOAM"}, {"docentry": 12581, "docnum": "12581", "docdate": "2026-07-02", "duedate": "2026-11-12", "vendor_code": "P1503", "vendor_name": "PALMERA TEXTIL EXPORT", "estado": "O", "total": 26755.2, "comentarios": "Reposición Alfombra temporada", "num_proveedor": "PI-5826", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "PUERTO AZUL", "contenedor": "DEMO8426849", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "artes", "fecha_abono": "2026-07-07", "eta": "2026-11-12", "pais": "Bangladesh", "puerto_embarque": "Ningbo", "marca_cliente": "DKC-26010", "abono": 8026.56, "doc_status": "O", "saldo_cxp": 18728.64, "vendor_email": "ventas@palmera.com", "unidades": 2880, "grupo_items": "..Alfombra", "primera_desc": "ALFOMBRA SHAGGY SALA"}, {"docentry": 12588, "docnum": "12588", "docdate": "2026-05-31", "duedate": "2026-11-03", "vendor_code": "P1501", "vendor_name": "TERRANOVA RUGS CO.", "estado": "O", "total": 7389.0, "comentarios": "Reposición Alfombra temporada", "num_proveedor": "PI-5560", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "VIENTO NORTE", "contenedor": "DEMO8156976", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "produccion", "fecha_abono": "2026-06-05", "eta": "2026-11-03", "pais": "China", "puerto_embarque": "Hai Phong", "marca_cliente": "DKC-26011", "abono": 2216.7, "doc_status": "O", "saldo_cxp": 5172.3, "vendor_email": "ventas@terranova.com", "unidades": 1500, "grupo_items": "..Alfombra", "primera_desc": "ALFOMBRA DE ENTRADA ANTIDESLIZANTE"}, {"docentry": 12597, "docnum": "12597", "docdate": "2026-05-08", "duedate": "2026-10-12", "vendor_code": "P1502", "vendor_name": "SUNRAY WEAVING GROUP", "estado": "O", "total": 26485.8, "comentarios": "Reposición Alfombra temporada", "num_proveedor": "PI-6517", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "MAR SERENO", "contenedor": "DEMO2342931", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "logistica", "fecha_abono": "2026-05-13", "eta": "2026-10-12", "pais": "China", "puerto_embarque": "Hai Phong", "marca_cliente": "DKC-26012", "abono": 7945.74, "doc_status": "O", "saldo_cxp": 18540.06, "vendor_email": "ventas@sunray.com", "unidades": 2280, "grupo_items": "..Alfombra", "primera_desc": "ALFOMBRA FRUITS MULTICOLOR"}, {"docentry": 12602, "docnum": "12602", "docdate": "2026-07-30", "duedate": "2026-11-18", "vendor_code": "P1801", "vendor_name": "ROBLEDO MUEBLES INTL", "estado": "O", "total": 28789.2, "comentarios": "Reposición Muebles temporada", "num_proveedor": "PI-9052", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "PUERTO AZUL", "contenedor": "DEMO2562153", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "pedido", "fecha_abono": "2026-08-04", "eta": "2026-11-18", "pais": "Vietnam", "puerto_embarque": "Ningbo", "marca_cliente": "DKC-26013", "abono": 0.0, "doc_status": "O", "saldo_cxp": 28789.2, "vendor_email": "ventas@robledo.com", "unidades": 2040, "grupo_items": "..Muebles", "primera_desc": "MESA AUXILIAR REDONDA"}, {"docentry": 12606, "docnum": "12606", "docdate": "2026-07-20", "duedate": "2026-10-05", "vendor_code": "P1801", "vendor_name": "ROBLEDO MUEBLES INTL", "estado": "O", "total": 18360.0, "comentarios": "Reposición Muebles temporada", "num_proveedor": "PI-8413", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "MAR SERENO", "contenedor": "DEMO5272119", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "deposito", "fecha_abono": "2026-07-25", "eta": "2026-10-05", "pais": "Bangladesh", "puerto_embarque": "Alexandria", "marca_cliente": "DKC-26014", "abono": 5508.0, "doc_status": "O", "saldo_cxp": 12852.0, "vendor_email": "ventas@robledo.com", "unidades": 900, "grupo_items": "..Muebles", "primera_desc": "BANCO DE ENTRADA CON COJÍN"}, {"docentry": 12611, "docnum": "12611", "docdate": "2026-07-02", "duedate": "2026-10-31", "vendor_code": "P1802", "vendor_name": "GREENOAK WOODWORKS", "estado": "O", "total": 41013.6, "comentarios": "Reposición Muebles temporada", "num_proveedor": "PI-9604", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO5911570", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "artes", "fecha_abono": "2026-07-07", "eta": "2026-10-31", "pais": "Bangladesh", "puerto_embarque": "Alexandria", "marca_cliente": "DKC-26015", "abono": 12304.08, "doc_status": "O", "saldo_cxp": 28709.52, "vendor_email": "ventas@greenoak.com", "unidades": 2640, "grupo_items": "..Muebles", "primera_desc": "ESTANTERÍA 4 NIVELES"}, {"docentry": 12618, "docnum": "12618", "docdate": "2026-06-06", "duedate": "2026-10-28", "vendor_code": "P1802", "vendor_name": "GREENOAK WOODWORKS", "estado": "O", "total": 23648.4, "comentarios": "Reposición Muebles temporada", "num_proveedor": "PI-8909", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "PUERTO AZUL", "contenedor": "DEMO6465414", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "produccion", "fecha_abono": "2026-06-11", "eta": "2026-10-28", "pais": "China", "puerto_embarque": "Ningbo", "marca_cliente": "DKC-26016", "abono": 7094.52, "doc_status": "O", "saldo_cxp": 16553.88, "vendor_email": "ventas@greenoak.com", "unidades": 1380, "grupo_items": "..Muebles", "primera_desc": "BANCO DE ENTRADA CON COJÍN"}, {"docentry": 12624, "docnum": "12624", "docdate": "2026-07-25", "duedate": "2026-10-31", "vendor_code": "P1201", "vendor_name": "MERIDIAN APPAREL CO.", "estado": "O", "total": 1702.2, "comentarios": "Reposición Ropa temporada", "num_proveedor": "PI-5450", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO5725534", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "pedido", "fecha_abono": "2026-07-30", "eta": "2026-10-31", "pais": "Bangladesh", "puerto_embarque": "Jakarta", "marca_cliente": "DKC-26017", "abono": 0.0, "doc_status": "O", "saldo_cxp": 1702.2, "vendor_email": "ventas@meridian.com", "unidades": 780, "grupo_items": "..Ropa", "primera_desc": "CAMISETA ALGODÓN CUELLO REDONDO"}, {"docentry": 12634, "docnum": "12634", "docdate": "2026-07-13", "duedate": "2026-09-12", "vendor_code": "P1202", "vendor_name": "COTTONFIELD MILLS LTD", "estado": "O", "total": 5596.8, "comentarios": "Reposición Ropa temporada", "num_proveedor": "PI-3979", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "VIENTO NORTE", "contenedor": "DEMO3937662", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "deposito", "fecha_abono": "2026-07-18", "eta": "2026-09-12", "pais": "Vietnam", "puerto_embarque": "Alexandria", "marca_cliente": "DKC-26018", "abono": 1679.04, "doc_status": "O", "saldo_cxp": 3917.76, "vendor_email": "ventas@cottonfield.com", "unidades": 1440, "grupo_items": "..Ropa", "primera_desc": "SUDADERA CON CAPUCHA"}, {"docentry": 12645, "docnum": "12645", "docdate": "2026-06-21", "duedate": "2026-09-11", "vendor_code": "P1201", "vendor_name": "MERIDIAN APPAREL CO.", "estado": "O", "total": 3727.2, "comentarios": "Reposición Ropa temporada", "num_proveedor": "PI-5222", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO7749698", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "artes", "fecha_abono": "2026-06-26", "eta": "2026-09-11", "pais": "India", "puerto_embarque": "Shanghai", "marca_cliente": "DKC-26019", "abono": 1118.16, "doc_status": "O", "saldo_cxp": 2609.04, "vendor_email": "ventas@meridian.com", "unidades": 1680, "grupo_items": "..Ropa", "primera_desc": "CAMISETA ALGODÓN CUELLO REDONDO"}, {"docentry": 12648, "docnum": "12648", "docdate": "2026-06-14", "duedate": "2026-10-03", "vendor_code": "P1203", "vendor_name": "VESTIA GARMENTS LTD", "estado": "O", "total": 8942.4, "comentarios": "Reposición Ropa temporada", "num_proveedor": "PI-4941", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO5900365", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "produccion", "fecha_abono": "2026-06-19", "eta": "2026-10-03", "pais": "Vietnam", "puerto_embarque": "Alexandria", "marca_cliente": "DKC-26020", "abono": 2682.72, "doc_status": "O", "saldo_cxp": 6259.68, "vendor_email": "ventas@vestia.com", "unidades": 1560, "grupo_items": "..Ropa", "primera_desc": "PIJAMA DOS PIEZAS"}, {"docentry": 12655, "docnum": "12655", "docdate": "2026-06-01", "duedate": "2026-10-12", "vendor_code": "P1201", "vendor_name": "MERIDIAN APPAREL CO.", "estado": "O", "total": 5044.8, "comentarios": "Reposición Ropa temporada", "num_proveedor": "PI-4665", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "VIENTO NORTE", "contenedor": "DEMO2132629", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "logistica", "fecha_abono": "2026-06-06", "eta": "2026-10-12", "pais": "Egipto", "puerto_embarque": "Chittagong", "marca_cliente": "DKC-26021", "abono": 1513.44, "doc_status": "O", "saldo_cxp": 3531.36, "vendor_email": "ventas@meridian.com", "unidades": 1080, "grupo_items": "..Ropa", "primera_desc": "SUDADERA CON CAPUCHA"}, {"docentry": 12665, "docnum": "12665", "docdate": "2026-04-22", "duedate": "2026-11-19", "vendor_code": "P1202", "vendor_name": "COTTONFIELD MILLS LTD", "estado": "O", "total": 12496.2, "comentarios": "Reposición Ropa temporada", "num_proveedor": "PI-5707", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "MAR SERENO", "contenedor": "DEMO3285513", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "aduana", "fecha_abono": "2026-04-27", "eta": "2026-11-19", "pais": "India", "puerto_embarque": "Chittagong", "marca_cliente": "DKC-26022", "abono": 3748.86, "doc_status": "O", "saldo_cxp": 8747.34, "vendor_email": "ventas@cottonfield.com", "unidades": 2700, "grupo_items": "..Ropa", "primera_desc": "PIJAMA DOS PIEZAS"}, {"docentry": 12668, "docnum": "12668", "docdate": "2026-07-25", "duedate": "2026-11-09", "vendor_code": "P1701", "vendor_name": "TRAILMARK OUTDOOR GEAR", "estado": "O", "total": 27615.0, "comentarios": "Reposición Campamento temporada", "num_proveedor": "PI-8051", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO3374947", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "pedido", "fecha_abono": "2026-07-30", "eta": "2026-11-09", "pais": "Egipto", "puerto_embarque": "Alexandria", "marca_cliente": "DKC-26023", "abono": 0.0, "doc_status": "O", "saldo_cxp": 27615.0, "vendor_email": "ventas@trailmark.com", "unidades": 2460, "grupo_items": "..Campamento", "primera_desc": "SILLA PLEGABLE CAMPING"}, {"docentry": 12679, "docnum": "12679", "docdate": "2026-07-03", "duedate": "2026-11-13", "vendor_code": "P1701", "vendor_name": "TRAILMARK OUTDOOR GEAR", "estado": "O", "total": 15590.4, "comentarios": "Reposición Campamento temporada", "num_proveedor": "PI-7686", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "VIENTO NORTE", "contenedor": "DEMO2387976", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "deposito", "fecha_abono": "2026-07-08", "eta": "2026-11-13", "pais": "China", "puerto_embarque": "Alexandria", "marca_cliente": "DKC-26024", "abono": 4677.12, "doc_status": "O", "saldo_cxp": 10913.28, "vendor_email": "ventas@trailmark.com", "unidades": 1680, "grupo_items": "..Campamento", "primera_desc": "LINTERNA RECARGABLE LED"}, {"docentry": 12688, "docnum": "12688", "docdate": "2026-06-27", "duedate": "2026-10-13", "vendor_code": "P1701", "vendor_name": "TRAILMARK OUTDOOR GEAR", "estado": "O", "total": 15667.2, "comentarios": "Reposición Campamento temporada", "num_proveedor": "PI-7228", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO5872457", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "artes", "fecha_abono": "2026-07-02", "eta": "2026-10-13", "pais": "Bangladesh", "puerto_embarque": "Jakarta", "marca_cliente": "DKC-26025", "abono": 4700.16, "doc_status": "O", "saldo_cxp": 10967.04, "vendor_email": "ventas@trailmark.com", "unidades": 1440, "grupo_items": "..Campamento", "primera_desc": "NEVERA PORTÁTIL 24L"}, {"docentry": 12695, "docnum": "12695", "docdate": "2026-07-28", "duedate": "2026-10-13", "vendor_code": "P1302", "vendor_name": "BRIGHTLINE APPLIANCES", "estado": "O", "total": 17040.0, "comentarios": "Reposición Electronica temporada", "num_proveedor": "PI-7608", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "MAR SERENO", "contenedor": "DEMO3771996", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "pedido", "fecha_abono": "2026-08-02", "eta": "2026-10-13", "pais": "Bangladesh", "puerto_embarque": "Chittagong", "marca_cliente": "DKC-26026", "abono": 0.0, "doc_status": "O", "saldo_cxp": 17040.0, "vendor_email": "ventas@brightline.com", "unidades": 1260, "grupo_items": "..Electronica", "primera_desc": "LICUADORA PERSONAL 600W"}, {"docentry": 12700, "docnum": "12700", "docdate": "2026-07-02", "duedate": "2026-11-05", "vendor_code": "P1301", "vendor_name": "VOLTIA ELECTRONICS", "estado": "O", "total": 23839.2, "comentarios": "Reposición Electronica temporada", "num_proveedor": "PI-7238", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "CABO VERDE", "contenedor": "DEMO6563021", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "deposito", "fecha_abono": "2026-07-07", "eta": "2026-11-05", "pais": "Egipto", "puerto_embarque": "Ningbo", "marca_cliente": "DKC-26027", "abono": 7151.76, "doc_status": "O", "saldo_cxp": 16687.44, "vendor_email": "ventas@voltia.com", "unidades": 2160, "grupo_items": "..Electronica", "primera_desc": "LICUADORA PERSONAL 600W"}, {"docentry": 12706, "docnum": "12706", "docdate": "2026-06-24", "duedate": "2026-09-17", "vendor_code": "P1302", "vendor_name": "BRIGHTLINE APPLIANCES", "estado": "O", "total": 25742.4, "comentarios": "Reposición Electronica temporada", "num_proveedor": "PI-2067", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "MAR SERENO", "contenedor": "DEMO2192452", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "artes", "fecha_abono": "2026-06-29", "eta": "2026-09-17", "pais": "Bangladesh", "puerto_embarque": "Chittagong", "marca_cliente": "DKC-26028", "abono": 7722.72, "doc_status": "O", "saldo_cxp": 18019.68, "vendor_email": "ventas@brightline.com", "unidades": 2040, "grupo_items": "..Electronica", "primera_desc": "VENTILADOR DE TORRE 3 VELOCIDADES"}, {"docentry": 12709, "docnum": "12709", "docdate": "2026-08-11", "duedate": "2026-11-21", "vendor_code": "P1901", "vendor_name": "ATELIER DECO HOUSE", "estado": "O", "total": 14871.6, "comentarios": "Reposición Home Deco temporada", "num_proveedor": "PI-3951", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "CABO VERDE", "contenedor": "DEMO2222499", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "pedido", "fecha_abono": "2026-08-16", "eta": "2026-11-21", "pais": "India", "puerto_embarque": "Hai Phong", "marca_cliente": "DKC-26029", "abono": 0.0, "doc_status": "O", "saldo_cxp": 14871.6, "vendor_email": "ventas@atelier.com", "unidades": 1680, "grupo_items": "..Home Deco", "primera_desc": "SET 3 CUADROS BOTÁNICOS"}, {"docentry": 12715, "docnum": "12715", "docdate": "2026-07-14", "duedate": "2026-10-30", "vendor_code": "P1901", "vendor_name": "ATELIER DECO HOUSE", "estado": "O", "total": 10917.6, "comentarios": "Reposición Home Deco temporada", "num_proveedor": "PI-9722", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "VIENTO NORTE", "contenedor": "DEMO8396050", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "deposito", "fecha_abono": "2026-07-19", "eta": "2026-10-30", "pais": "Bangladesh", "puerto_embarque": "Alexandria", "marca_cliente": "DKC-26030", "abono": 3275.28, "doc_status": "O", "saldo_cxp": 7642.32, "vendor_email": "ventas@atelier.com", "unidades": 1680, "grupo_items": "..Home Deco", "primera_desc": "RELOJ DE PARED MINIMALISTA"}, {"docentry": 12719, "docnum": "12719", "docdate": "2026-06-27", "duedate": "2026-09-14", "vendor_code": "P1901", "vendor_name": "ATELIER DECO HOUSE", "estado": "O", "total": 18430.8, "comentarios": "Reposición Home Deco temporada", "num_proveedor": "PI-8166", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO5934232", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "artes", "fecha_abono": "2026-07-02", "eta": "2026-09-14", "pais": "Indonesia", "puerto_embarque": "Chittagong", "marca_cliente": "DKC-26031", "abono": 5529.24, "doc_status": "O", "saldo_cxp": 12901.56, "vendor_email": "ventas@atelier.com", "unidades": 2040, "grupo_items": "..Home Deco", "primera_desc": "SET 3 CUADROS BOTÁNICOS"}, {"docentry": 12727, "docnum": "12727", "docdate": "2026-06-13", "duedate": "2026-09-12", "vendor_code": "P1902", "vendor_name": "LUNARIA HOME ARTS", "estado": "O", "total": 15043.2, "comentarios": "Reposición Home Deco temporada", "num_proveedor": "PI-9761", "grupo_pago": "30% ANTICIPO 70% BL", "fecha_actualizacion": "2026-09-02T00:00:00Z", "barco": "ESTRELLA DEL SUR", "contenedor": "DEMO1933071", "num_contenedor_campo": "1x40HQ", "tamanio_contenedor": "40'HQ", "estado_compra": "produccion", "fecha_abono": "2026-06-18", "eta": "2026-09-12", "pais": "India", "puerto_embarque": "Shanghai", "marca_cliente": "DKC-26032", "abono": 4512.96, "doc_status": "O", "saldo_cxp": 10530.24, "vendor_email": "ventas@lunaria.com", "unidades": 1860, "grupo_items": "..Home Deco", "primera_desc": "SET 3 CUADROS BOTÁNICOS"}], "opor_lineas": [{"docnum": "12510", "linenum": 0, "itemcode": "HOG-2003", "itemname": "SET DE 3 RECIPIENTES HERMÉTICOS", "cantidad": 300, "precio": 4.44, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12510", "linenum": 1, "itemcode": "HOG-2008", "itemname": "DISPENSADOR DE CEREALES", "cantidad": 1200, "precio": 3.38, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12510", "linenum": 2, "itemcode": "HOG-2004", "itemname": "ESCURRIDOR DE PLATOS PLEGABLE", "cantidad": 600, "precio": 5.9, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12516", "linenum": 0, "itemcode": "HOG-2005", "itemname": "TABLA DE PICAR BAMBÚ", "cantidad": 1200, "precio": 3.37, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12516", "linenum": 1, "itemcode": "HOG-2003", "itemname": "SET DE 3 RECIPIENTES HERMÉTICOS", "cantidad": 600, "precio": 4.44, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12526", "linenum": 0, "itemcode": "HOG-2001", "itemname": "DISPENSADOR DE JABÓN ESPUMOSO", "cantidad": 300, "precio": 1.26, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12526", "linenum": 1, "itemcode": "HOG-2003", "itemname": "SET DE 3 RECIPIENTES HERMÉTICOS", "cantidad": 300, "precio": 4.44, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12537", "linenum": 0, "itemcode": "HOG-2008", "itemname": "DISPENSADOR DE CEREALES", "cantidad": 600, "precio": 3.38, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12537", "linenum": 1, "itemcode": "HOG-2004", "itemname": "ESCURRIDOR DE PLATOS PLEGABLE", "cantidad": 1200, "precio": 5.9, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12547", "linenum": 0, "itemcode": "HOG-2003", "itemname": "SET DE 3 RECIPIENTES HERMÉTICOS", "cantidad": 960, "precio": 4.44, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12547", "linenum": 1, "itemcode": "HOG-2008", "itemname": "DISPENSADOR DE CEREALES", "cantidad": 600, "precio": 3.38, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12547", "linenum": 2, "itemcode": "HOG-2007", "itemname": "CESTA DE ROPA PLEGABLE", "cantidad": 960, "precio": 3.94, "grupo_items": "..Hogar", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12553", "linenum": 0, "itemcode": "HOG-2002", "itemname": "ORGANIZADOR DE GAVETAS 4 DIVISIONES", "cantidad": 480, "precio": 2.19, "grupo_items": "..Hogar", "cantidad_recibida": 288, "openqty": 192}, {"docnum": "12553", "linenum": 1, "itemcode": "HOG-2008", "itemname": "DISPENSADOR DE CEREALES", "cantidad": 960, "precio": 3.38, "grupo_items": "..Hogar", "cantidad_recibida": 576, "openqty": 384}, {"docnum": "12553", "linenum": 2, "itemcode": "HOG-2007", "itemname": "CESTA DE ROPA PLEGABLE", "cantidad": 1200, "precio": 3.94, "grupo_items": "..Hogar", "cantidad_recibida": 720, "openqty": 480}, {"docnum": "12553", "linenum": 3, "itemcode": "HOG-2004", "itemname": "ESCURRIDOR DE PLATOS PLEGABLE", "cantidad": 600, "precio": 5.9, "grupo_items": "..Hogar", "cantidad_recibida": 360, "openqty": 240}, {"docnum": "12557", "linenum": 0, "itemcode": "HOG-2002", "itemname": "ORGANIZADOR DE GAVETAS 4 DIVISIONES", "cantidad": 480, "precio": 2.19, "grupo_items": "..Hogar", "cantidad_recibida": 480, "openqty": 0}, {"docnum": "12557", "linenum": 1, "itemcode": "HOG-2007", "itemname": "CESTA DE ROPA PLEGABLE", "cantidad": 600, "precio": 3.94, "grupo_items": "..Hogar", "cantidad_recibida": 600, "openqty": 0}, {"docnum": "12557", "linenum": 2, "itemcode": "HOG-2008", "itemname": "DISPENSADOR DE CEREALES", "cantidad": 960, "precio": 3.38, "grupo_items": "..Hogar", "cantidad_recibida": 960, "openqty": 0}, {"docnum": "12557", "linenum": 3, "itemcode": "HOG-2001", "itemname": "DISPENSADOR DE JABÓN ESPUMOSO", "cantidad": 1200, "precio": 1.26, "grupo_items": "..Hogar", "cantidad_recibida": 1200, "openqty": 0}, {"docnum": "12566", "linenum": 0, "itemcode": "ALF-2010", "itemname": "ALFOMBRA DE ENTRADA ANTIDESLIZANTE", "cantidad": 600, "precio": 3.39, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12566", "linenum": 1, "itemcode": "ALF-2013", "itemname": "PASILLO DECORATIVO KILIM", "cantidad": 1200, "precio": 16.01, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12566", "linenum": 2, "itemcode": "ALF-2012", "itemname": "ALFOMBRA SHAGGY SALA", "cantidad": 960, "precio": 29.94, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12571", "linenum": 0, "itemcode": "ALF-2011", "itemname": "TAPETE DE BAÑO MEMORY FOAM", "cantidad": 1200, "precio": 5.01, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12571", "linenum": 1, "itemcode": "ALF-2012", "itemname": "ALFOMBRA SHAGGY SALA", "cantidad": 600, "precio": 29.94, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12571", "linenum": 2, "itemcode": "ALF-2010", "itemname": "ALFOMBRA DE ENTRADA ANTIDESLIZANTE", "cantidad": 600, "precio": 3.39, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12571", "linenum": 3, "itemcode": "ALF-2013", "itemname": "PASILLO DECORATIVO KILIM", "cantidad": 600, "precio": 16.01, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12581", "linenum": 0, "itemcode": "ALF-2012", "itemname": "ALFOMBRA SHAGGY SALA", "cantidad": 480, "precio": 29.94, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12581", "linenum": 1, "itemcode": "ALF-2014", "itemname": "ALFOMBRA COCINA LAVABLE", "cantidad": 1200, "precio": 5.31, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12581", "linenum": 2, "itemcode": "ALF-2011", "itemname": "TAPETE DE BAÑO MEMORY FOAM", "cantidad": 1200, "precio": 5.01, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12588", "linenum": 0, "itemcode": "ALF-2010", "itemname": "ALFOMBRA DE ENTRADA ANTIDESLIZANTE", "cantidad": 300, "precio": 3.39, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12588", "linenum": 1, "itemcode": "ALF-2014", "itemname": "ALFOMBRA COCINA LAVABLE", "cantidad": 1200, "precio": 5.31, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12597", "linenum": 0, "itemcode": "ALF-2009", "itemname": "ALFOMBRA FRUITS MULTICOLOR", "cantidad": 1200, "precio": 8.46, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12597", "linenum": 1, "itemcode": "ALF-2013", "itemname": "PASILLO DECORATIVO KILIM", "cantidad": 300, "precio": 16.01, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12597", "linenum": 2, "itemcode": "ALF-2014", "itemname": "ALFOMBRA COCINA LAVABLE", "cantidad": 480, "precio": 5.31, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12597", "linenum": 3, "itemcode": "ALF-2012", "itemname": "ALFOMBRA SHAGGY SALA", "cantidad": 300, "precio": 29.94, "grupo_items": "..Alfombra", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12602", "linenum": 0, "itemcode": "MUE-2016", "itemname": "MESA AUXILIAR REDONDA", "cantidad": 600, "precio": 8.99, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12602", "linenum": 1, "itemcode": "MUE-2015", "itemname": "SILLA PLEGABLE DE MADERA", "cantidad": 960, "precio": 13.58, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12602", "linenum": 2, "itemcode": "MUE-2017", "itemname": "ESTANTERÍA 4 NIVELES", "cantidad": 480, "precio": 21.58, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12606", "linenum": 0, "itemcode": "MUE-2018", "itemname": "BANCO DE ENTRADA CON COJÍN", "cantidad": 600, "precio": 19.81, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12606", "linenum": 1, "itemcode": "MUE-2017", "itemname": "ESTANTERÍA 4 NIVELES", "cantidad": 300, "precio": 21.58, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12611", "linenum": 0, "itemcode": "MUE-2017", "itemname": "ESTANTERÍA 4 NIVELES", "cantidad": 960, "precio": 21.58, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12611", "linenum": 1, "itemcode": "MUE-2016", "itemname": "MESA AUXILIAR REDONDA", "cantidad": 1200, "precio": 8.99, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12611", "linenum": 2, "itemcode": "MUE-2018", "itemname": "BANCO DE ENTRADA CON COJÍN", "cantidad": 480, "precio": 19.81, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12618", "linenum": 0, "itemcode": "MUE-2018", "itemname": "BANCO DE ENTRADA CON COJÍN", "cantidad": 300, "precio": 19.81, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12618", "linenum": 1, "itemcode": "MUE-2017", "itemname": "ESTANTERÍA 4 NIVELES", "cantidad": 480, "precio": 21.58, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12618", "linenum": 2, "itemcode": "MUE-2019", "itemname": "PERCHERO DE PIE", "cantidad": 300, "precio": 10.91, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12618", "linenum": 3, "itemcode": "MUE-2015", "itemname": "SILLA PLEGABLE DE MADERA", "cantidad": 300, "precio": 13.58, "grupo_items": "..Muebles", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12624", "linenum": 0, "itemcode": "ROP-2020", "itemname": "CAMISETA ALGODÓN CUELLO REDONDO", "cantidad": 300, "precio": 2.25, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12624", "linenum": 1, "itemcode": "ROP-2025", "itemname": "GORRA AJUSTABLE", "cantidad": 480, "precio": 2.14, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12634", "linenum": 0, "itemcode": "ROP-2022", "itemname": "SUDADERA CON CAPUCHA", "cantidad": 480, "precio": 6.24, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12634", "linenum": 1, "itemcode": "ROP-2023", "itemname": "CALCETINES PACK 6 PARES", "cantidad": 960, "precio": 2.71, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12645", "linenum": 0, "itemcode": "ROP-2020", "itemname": "CAMISETA ALGODÓN CUELLO REDONDO", "cantidad": 1200, "precio": 2.25, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12645", "linenum": 1, "itemcode": "ROP-2025", "itemname": "GORRA AJUSTABLE", "cantidad": 480, "precio": 2.14, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12648", "linenum": 0, "itemcode": "ROP-2024", "itemname": "PIJAMA DOS PIEZAS", "cantidad": 960, "precio": 6.34, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12648", "linenum": 1, "itemcode": "ROP-2021", "itemname": "PANTALÓN DEPORTIVO UNISEX", "cantidad": 600, "precio": 4.76, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12655", "linenum": 0, "itemcode": "ROP-2022", "itemname": "SUDADERA CON CAPUCHA", "cantidad": 600, "precio": 6.24, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12655", "linenum": 1, "itemcode": "ROP-2023", "itemname": "CALCETINES PACK 6 PARES", "cantidad": 480, "precio": 2.71, "grupo_items": "..Ropa", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12665", "linenum": 0, "itemcode": "ROP-2024", "itemname": "PIJAMA DOS PIEZAS", "cantidad": 960, "precio": 6.34, "grupo_items": "..Ropa", "cantidad_recibida": 576, "openqty": 384}, {"docnum": "12665", "linenum": 1, "itemcode": "ROP-2021", "itemname": "PANTALÓN DEPORTIVO UNISEX", "cantidad": 960, "precio": 4.76, "grupo_items": "..Ropa", "cantidad_recibida": 576, "openqty": 384}, {"docnum": "12665", "linenum": 2, "itemcode": "ROP-2023", "itemname": "CALCETINES PACK 6 PARES", "cantidad": 300, "precio": 2.71, "grupo_items": "..Ropa", "cantidad_recibida": 180, "openqty": 120}, {"docnum": "12665", "linenum": 3, "itemcode": "ROP-2025", "itemname": "GORRA AJUSTABLE", "cantidad": 480, "precio": 2.14, "grupo_items": "..Ropa", "cantidad_recibida": 288, "openqty": 192}, {"docnum": "12668", "linenum": 0, "itemcode": "CAM-2027", "itemname": "SILLA PLEGABLE CAMPING", "cantidad": 600, "precio": 7.62, "grupo_items": "..Campamento", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12668", "linenum": 1, "itemcode": "CAM-2028", "itemname": "NEVERA PORTÁTIL 24L", "cantidad": 960, "precio": 11.2, "grupo_items": "..Campamento", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12668", "linenum": 2, "itemcode": "CAM-2026", "itemname": "TIENDA DE CAMPAÑA 4 PERSONAS", "cantidad": 300, "precio": 32.01, "grupo_items": "..Campamento", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12668", "linenum": 3, "itemcode": "CAM-2029", "itemname": "LINTERNA RECARGABLE LED", "cantidad": 600, "precio": 4.48, "grupo_items": "..Campamento", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12679", "linenum": 0, "itemcode": "CAM-2029", "itemname": "LINTERNA RECARGABLE LED", "cantidad": 480, "precio": 4.48, "grupo_items": "..Campamento", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12679", "linenum": 1, "itemcode": "CAM-2028", "itemname": "NEVERA PORTÁTIL 24L", "cantidad": 1200, "precio": 11.2, "grupo_items": "..Campamento", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12688", "linenum": 0, "itemcode": "CAM-2028", "itemname": "NEVERA PORTÁTIL 24L", "cantidad": 960, "precio": 11.2, "grupo_items": "..Campamento", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12688", "linenum": 1, "itemcode": "CAM-2030", "itemname": "SACO DE DORMIR 3 ESTACIONES", "cantidad": 480, "precio": 10.24, "grupo_items": "..Campamento", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12695", "linenum": 0, "itemcode": "ELE-2032", "itemname": "LICUADORA PERSONAL 600W", "cantidad": 300, "precio": 9.92, "grupo_items": "..Electronica", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12695", "linenum": 1, "itemcode": "ELE-2031", "itemname": "VENTILADOR DE TORRE 3 VELOCIDADES", "cantidad": 960, "precio": 14.65, "grupo_items": "..Electronica", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12700", "linenum": 0, "itemcode": "ELE-2032", "itemname": "LICUADORA PERSONAL 600W", "cantidad": 960, "precio": 9.92, "grupo_items": "..Electronica", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12700", "linenum": 1, "itemcode": "ELE-2034", "itemname": "CAFETERA DE GOTEO 12 TAZAS", "cantidad": 1200, "precio": 11.93, "grupo_items": "..Electronica", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12706", "linenum": 0, "itemcode": "ELE-2031", "itemname": "VENTILADOR DE TORRE 3 VELOCIDADES", "cantidad": 960, "precio": 14.65, "grupo_items": "..Electronica", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12706", "linenum": 1, "itemcode": "ELE-2034", "itemname": "CAFETERA DE GOTEO 12 TAZAS", "cantidad": 480, "precio": 11.93, "grupo_items": "..Electronica", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12706", "linenum": 2, "itemcode": "ELE-2032", "itemname": "LICUADORA PERSONAL 600W", "cantidad": 600, "precio": 9.92, "grupo_items": "..Electronica", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12709", "linenum": 0, "itemcode": "HOM-2038", "itemname": "SET 3 CUADROS BOTÁNICOS", "cantidad": 480, "precio": 10.12, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12709", "linenum": 1, "itemcode": "HOM-2037", "itemname": "JARRÓN CERÁMICA ESMALTADA", "cantidad": 600, "precio": 5.87, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12709", "linenum": 2, "itemcode": "HOM-2036", "itemname": "ESPEJO DECORATIVO REDONDO", "cantidad": 600, "precio": 10.82, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12715", "linenum": 0, "itemcode": "HOM-2039", "itemname": "RELOJ DE PARED MINIMALISTA", "cantidad": 1200, "precio": 5.05, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 1200}, {"docnum": "12715", "linenum": 1, "itemcode": "HOM-2038", "itemname": "SET 3 CUADROS BOTÁNICOS", "cantidad": 480, "precio": 10.12, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12719", "linenum": 0, "itemcode": "HOM-2038", "itemname": "SET 3 CUADROS BOTÁNICOS", "cantidad": 960, "precio": 10.12, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 960}, {"docnum": "12719", "linenum": 1, "itemcode": "HOM-2037", "itemname": "JARRÓN CERÁMICA ESMALTADA", "cantidad": 600, "precio": 5.87, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12719", "linenum": 2, "itemcode": "HOM-2036", "itemname": "ESPEJO DECORATIVO REDONDO", "cantidad": 480, "precio": 10.82, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12727", "linenum": 0, "itemcode": "HOM-2038", "itemname": "SET 3 CUADROS BOTÁNICOS", "cantidad": 600, "precio": 10.12, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 600}, {"docnum": "12727", "linenum": 1, "itemcode": "HOM-2035", "itemname": "MARCO DE FOTOS 20X25", "cantidad": 300, "precio": 3.2, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 300}, {"docnum": "12727", "linenum": 2, "itemcode": "HOM-2037", "itemname": "JARRÓN CERÁMICA ESMALTADA", "cantidad": 480, "precio": 5.87, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 480}, {"docnum": "12727", "linenum": 3, "itemcode": "HOM-2036", "itemname": "ESPEJO DECORATIVO REDONDO", "cantidad": 480, "precio": 10.82, "grupo_items": "..Home Deco", "cantidad_recibida": 0, "openqty": 480}], "inventario": [{"itemcode": "HOG-2001", "itemname": "DISPENSADOR DE JABÓN ESPUMOSO", "grupo": "..Hogar", "grupo_cod": 100, "cardcode": "P2102", "nombre_proveedor": "BLUEPEAK KITCHEN SUPPLY", "disponible": 699, "onhand": 700, "iscommited": 1, "onorder": 960, "u_cant_ult_ent": 1440, "fechaentrada": "2026-06-09", "vendido_3a": 1663, "primera_venta": "2024-01-25", "hist_comprado": 4320, "unidadesbulto": 6, "salpackun": 24, "precioventa": 3.9, "lastpurprc": 1.26, "picturname": "HOG-2001.jpg", "u_color": "BLANCO", "u_tamano": "12x8 cm", "codebars": "7493372335", "subg": "", "fob": 1.26, "cif": 1.54, "prox_llegada": "", "ultima_llegada": "2025-12-17", "u_cxblt": 24}, {"itemcode": "HOG-2002", "itemname": "ORGANIZADOR DE GAVETAS 4 DIVISIONES", "grupo": "..Hogar", "grupo_cod": 100, "cardcode": "P2102", "nombre_proveedor": "BLUEPEAK KITCHEN SUPPLY", "disponible": 681, "onhand": 700, "iscommited": 19, "onorder": 960, "u_cant_ult_ent": 1440, "fechaentrada": "2026-04-14", "vendido_3a": 2040, "primera_venta": "2024-04-05", "hist_comprado": 2880, "unidadesbulto": 6, "salpackun": 6, "precioventa": 6.5, "lastpurprc": 2.19, "picturname": "HOG-2002.jpg", "u_color": "GRIS", "u_tamano": "30x20 cm", "codebars": "7404398317", "subg": "", "fob": 2.19, "cif": 2.67, "prox_llegada": "", "ultima_llegada": "2026-04-25", "u_cxblt": 12}, {"itemcode": "HOG-2003", "itemname": "SET DE 3 RECIPIENTES HERMÉTICOS", "grupo": "..Hogar", "grupo_cod": 100, "cardcode": "P2102", "nombre_proveedor": "BLUEPEAK KITCHEN SUPPLY", "disponible": 126, "onhand": 140, "iscommited": 14, "onorder": 0, "u_cant_ult_ent": 960, "fechaentrada": "2025-12-28", "vendido_3a": 2784, "primera_venta": "2024-09-14", "hist_comprado": 1920, "unidadesbulto": 24, "salpackun": 12, "precioventa": 12.9, "lastpurprc": 4.44, "picturname": "HOG-2003.jpg", "u_color": "TRANSPARENTE", "u_tamano": "1L/2L/3L", "codebars": "7497699828", "subg": "", "fob": 4.44, "cif": 5.42, "prox_llegada": "", "ultima_llegada": "2026-06-13", "u_cxblt": 12}, {"itemcode": "HOG-2004", "itemname": "ESCURRIDOR DE PLATOS PLEGABLE", "grupo": "..Hogar", "grupo_cod": 100, "cardcode": "P2103", "nombre_proveedor": "CASA NORDIA TRADING", "disponible": 130, "onhand": 140, "iscommited": 10, "onorder": 960, "u_cant_ult_ent": 480, "fechaentrada": "2026-04-10", "vendido_3a": 1917, "primera_venta": "2024-06-22", "hist_comprado": 1440, "unidadesbulto": 6, "salpackun": 6, "precioventa": 15.5, "lastpurprc": 5.9, "picturname": "HOG-2004.jpg", "u_color": "NEGRO", "u_tamano": "40x30 cm", "codebars": "7424239666", "subg": "", "fob": 5.9, "cif": 7.2, "prox_llegada": "", "ultima_llegada": "2026-07-15", "u_cxblt": 12}, {"itemcode": "HOG-2005", "itemname": "TABLA DE PICAR BAMBÚ", "grupo": "..Hogar", "grupo_cod": 100, "cardcode": "P2101", "nombre_proveedor": "AURELIA HOMEWARE LTD", "disponible": 7, "onhand": 8, "iscommited": 1, "onorder": 960, "u_cant_ult_ent": 480, "fechaentrada": "2025-10-28", "vendido_3a": 2675, "primera_venta": "2023-12-25", "hist_comprado": 1920, "unidadesbulto": 24, "salpackun": 24, "precioventa": 8.9, "lastpurprc": 3.37, "picturname": "HOG-2005.jpg", "u_color": "NATURAL", "u_tamano": "35x25 cm", "codebars": "7487554182", "subg": "", "fob": 3.37, "cif": 4.11, "prox_llegada": "", "ultima_llegada": "2025-11-20", "u_cxblt": 6}, {"itemcode": "HOG-2006", "itemname": "PORTACUBIERTOS DE MESA", "grupo": "..Hogar", "grupo_cod": 100, "cardcode": "P2101", "nombre_proveedor": "AURELIA HOMEWARE LTD", "disponible": 2, "onhand": 8, "iscommited": 6, "onorder": 0, "u_cant_ult_ent": 600, "fechaentrada": "2025-12-15", "vendido_3a": 2025, "primera_venta": "2025-05-08", "hist_comprado": 1200, "unidadesbulto": 24, "salpackun": 6, "precioventa": 4.5, "lastpurprc": 1.65, "picturname": "HOG-2006.jpg", "u_color": "BEIGE", "u_tamano": "25x15 cm", "codebars": "7409247749", "subg": "", "fob": 1.65, "cif": 2.01, "prox_llegada": "", "ultima_llegada": "2026-03-18", "u_cxblt": 24}, {"itemcode": "HOG-2007", "itemname": "CESTA DE ROPA PLEGABLE", "grupo": "..Hogar", "grupo_cod": 100, "cardcode": "P2102", "nombre_proveedor": "BLUEPEAK KITCHEN SUPPLY", "disponible": 111, "onhand": 140, "iscommited": 29, "onorder": 0, "u_cant_ult_ent": 1200, "fechaentrada": "2025-11-27", "vendido_3a": 3100, "primera_venta": "2024-12-02", "hist_comprado": 1200, "unidadesbulto": 12, "salpackun": 24, "precioventa": 11.9, "lastpurprc": 3.94, "picturname": "HOG-2007.jpg", "u_color": "AZUL", "u_tamano": "50L", "codebars": "7400096534", "subg": "", "fob": 3.94, "cif": 4.81, "prox_llegada": "", "ultima_llegada": "2025-11-06", "u_cxblt": 12}, {"itemcode": "HOG-2008", "itemname": "DISPENSADOR DE CEREALES", "grupo": "..Hogar", "grupo_cod": 100, "cardcode": "P2102", "nombre_proveedor": "BLUEPEAK KITCHEN SUPPLY", "disponible": 685, "onhand": 700, "iscommited": 15, "onorder": 0, "u_cant_ult_ent": 1440, "fechaentrada": "2025-11-07", "vendido_3a": 217, "primera_venta": "2024-07-18", "hist_comprado": 1440, "unidadesbulto": 24, "salpackun": 24, "precioventa": 9.9, "lastpurprc": 3.38, "picturname": "HOG-2008.jpg", "u_color": "BLANCO", "u_tamano": "2L", "codebars": "7404688502", "subg": "", "fob": 3.38, "cif": 4.12, "prox_llegada": "", "ultima_llegada": "2026-06-02", "u_cxblt": 12}, {"itemcode": "ALF-2009", "itemname": "ALFOMBRA FRUITS MULTICOLOR", "grupo": "..Alfombra", "grupo_cod": 101, "cardcode": "P1501", "nombre_proveedor": "TERRANOVA RUGS CO.", "disponible": 0, "onhand": 0, "iscommited": 0, "onorder": 0, "u_cant_ult_ent": 1200, "fechaentrada": "2025-09-25", "vendido_3a": 689, "primera_venta": "2024-02-27", "hist_comprado": 3600, "unidadesbulto": 12, "salpackun": 12, "precioventa": 24.9, "lastpurprc": 8.46, "picturname": "ALF-2009.jpg", "u_color": "MULTI", "u_tamano": "60x220 cm", "codebars": "7470627745", "subg": "", "fob": 8.46, "cif": 10.32, "prox_llegada": "", "ultima_llegada": "2026-07-20", "u_cxblt": 24}, {"itemcode": "ALF-2010", "itemname": "ALFOMBRA DE ENTRADA ANTIDESLIZANTE", "grupo": "..Alfombra", "grupo_cod": 101, "cardcode": "P1503", "nombre_proveedor": "PALMERA TEXTIL EXPORT", "disponible": 23, "onhand": 60, "iscommited": 37, "onorder": 960, "u_cant_ult_ent": 960, "fechaentrada": "2026-05-20", "vendido_3a": 2118, "primera_venta": "2025-07-01", "hist_comprado": 3840, "unidadesbulto": 48, "salpackun": 12, "precioventa": 9.9, "lastpurprc": 3.39, "picturname": "ALF-2010.jpg", "u_color": "GRIS", "u_tamano": "40x60 cm", "codebars": "7463081749", "subg": "", "fob": 3.39, "cif": 4.14, "prox_llegada": "", "ultima_llegada": "2026-02-25", "u_cxblt": 12}, {"itemcode": "ALF-2011", "itemname": "TAPETE DE BAÑO MEMORY FOAM", "grupo": "..Alfombra", "grupo_cod": 101, "cardcode": "P1501", "nombre_proveedor": "TERRANOVA RUGS CO.", "disponible": 683, "onhand": 700, "iscommited": 17, "onorder": 0, "u_cant_ult_ent": 600, "fechaentrada": "2026-03-16", "vendido_3a": 4060, "primera_venta": "2024-10-05", "hist_comprado": 1800, "unidadesbulto": 6, "salpackun": 6, "precioventa": 14.5, "lastpurprc": 5.01, "picturname": "ALF-2011.jpg", "u_color": "BEIGE", "u_tamano": "50x80 cm", "codebars": "7423430417", "subg": "", "fob": 5.01, "cif": 6.11, "prox_llegada": "", "ultima_llegada": "2026-01-19", "u_cxblt": 12}, {"itemcode": "ALF-2012", "itemname": "ALFOMBRA SHAGGY SALA", "grupo": "..Alfombra", "grupo_cod": 101, "cardcode": "P1501", "nombre_proveedor": "TERRANOVA RUGS CO.", "disponible": 300, "onhand": 320, "iscommited": 20, "onorder": 960, "u_cant_ult_ent": 1440, "fechaentrada": "2026-02-06", "vendido_3a": 385, "primera_venta": "2024-12-16", "hist_comprado": 1440, "unidadesbulto": 24, "salpackun": 12, "precioventa": 89.0, "lastpurprc": 29.94, "picturname": "ALF-2012.jpg", "u_color": "CRUDO", "u_tamano": "160x230 cm", "codebars": "7430801775", "subg": "", "fob": 29.94, "cif": 36.53, "prox_llegada": "", "ultima_llegada": "2026-01-20", "u_cxblt": 24}, {"itemcode": "ALF-2013", "itemname": "PASILLO DECORATIVO KILIM", "grupo": "..Alfombra", "grupo_cod": 101, "cardcode": "P1502", "nombre_proveedor": "SUNRAY WEAVING GROUP", "disponible": 297, "onhand": 320, "iscommited": 23, "onorder": 480, "u_cant_ult_ent": 600, "fechaentrada": "2025-11-06", "vendido_3a": 3109, "primera_venta": "2025-07-24", "hist_comprado": 600, "unidadesbulto": 48, "salpackun": 12, "precioventa": 45.0, "lastpurprc": 16.01, "picturname": "ALF-2013.jpg", "u_color": "ROJO", "u_tamano": "80x300 cm", "codebars": "7421659234", "subg": "", "fob": 16.01, "cif": 19.53, "prox_llegada": "", "ultima_llegada": "2026-05-17", "u_cxblt": 6}, {"itemcode": "ALF-2014", "itemname": "ALFOMBRA COCINA LAVABLE", "grupo": "..Alfombra", "grupo_cod": 101, "cardcode": "P1501", "nombre_proveedor": "TERRANOVA RUGS CO.", "disponible": 671, "onhand": 700, "iscommited": 29, "onorder": 0, "u_cant_ult_ent": 480, "fechaentrada": "2025-12-02", "vendido_3a": 2355, "primera_venta": "2025-05-21", "hist_comprado": 1920, "unidadesbulto": 48, "salpackun": 6, "precioventa": 16.9, "lastpurprc": 5.31, "picturname": "ALF-2014.jpg", "u_color": "VERDE", "u_tamano": "45x120 cm", "codebars": "7417078858", "subg": "", "fob": 5.31, "cif": 6.48, "prox_llegada": "", "ultima_llegada": "2026-01-06", "u_cxblt": 6}, {"itemcode": "MUE-2015", "itemname": "SILLA PLEGABLE DE MADERA", "grupo": "..Muebles", "grupo_cod": 102, "cardcode": "P1801", "nombre_proveedor": "ROBLEDO MUEBLES INTL", "disponible": 320, "onhand": 320, "iscommited": 0, "onorder": 960, "u_cant_ult_ent": 300, "fechaentrada": "2025-08-16", "vendido_3a": 4027, "primera_venta": "2025-02-04", "hist_comprado": 1200, "unidadesbulto": 48, "salpackun": 24, "precioventa": 39.9, "lastpurprc": 13.58, "picturname": "MUE-2015.jpg", "u_color": "NOGAL", "u_tamano": "45x50x90 cm", "codebars": "7494463972", "subg": "", "fob": 13.58, "cif": 16.57, "prox_llegada": "", "ultima_llegada": "2026-07-11", "u_cxblt": 6}, {"itemcode": "MUE-2016", "itemname": "MESA AUXILIAR REDONDA", "grupo": "..Muebles", "grupo_cod": 102, "cardcode": "P1802", "nombre_proveedor": "GREENOAK WOODWORKS", "disponible": 138, "onhand": 140, "iscommited": 2, "onorder": 0, "u_cant_ult_ent": 960, "fechaentrada": "2026-04-03", "vendido_3a": 933, "primera_venta": "2025-02-28", "hist_comprado": 2880, "unidadesbulto": 48, "salpackun": 12, "precioventa": 29.9, "lastpurprc": 8.99, "picturname": "MUE-2016.jpg", "u_color": "BLANCO", "u_tamano": "50x50 cm", "codebars": "7486080230", "subg": "", "fob": 8.99, "cif": 10.97, "prox_llegada": "", "ultima_llegada": "2026-02-04", "u_cxblt": 24}, {"itemcode": "MUE-2017", "itemname": "ESTANTERÍA 4 NIVELES", "grupo": "..Muebles", "grupo_cod": 102, "cardcode": "P1801", "nombre_proveedor": "ROBLEDO MUEBLES INTL", "disponible": 1, "onhand": 8, "iscommited": 7, "onorder": 0, "u_cant_ult_ent": 1200, "fechaentrada": "2025-12-03", "vendido_3a": 2587, "primera_venta": "2024-02-04", "hist_comprado": 3600, "unidadesbulto": 12, "salpackun": 24, "precioventa": 69.0, "lastpurprc": 21.58, "picturname": "MUE-2017.jpg", "u_color": "ROBLE", "u_tamano": "60x30x150 cm", "codebars": "7457665655", "subg": "", "fob": 21.58, "cif": 26.33, "prox_llegada": "", "ultima_llegada": "2025-11-23", "u_cxblt": 12}, {"itemcode": "MUE-2018", "itemname": "BANCO DE ENTRADA CON COJÍN", "grupo": "..Muebles", "grupo_cod": 102, "cardcode": "P1801", "nombre_proveedor": "ROBLEDO MUEBLES INTL", "disponible": 313, "onhand": 320, "iscommited": 7, "onorder": 0, "u_cant_ult_ent": 480, "fechaentrada": "2025-08-15", "vendido_3a": 572, "primera_venta": "2024-11-12", "hist_comprado": 480, "unidadesbulto": 12, "salpackun": 12, "precioventa": 55.0, "lastpurprc": 19.81, "picturname": "MUE-2018.jpg", "u_color": "GRIS", "u_tamano": "90x35x45 cm", "codebars": "7420210367", "subg": "", "fob": 19.81, "cif": 24.17, "prox_llegada": "", "ultima_llegada": "2026-07-10", "u_cxblt": 6}, {"itemcode": "MUE-2019", "itemname": "PERCHERO DE PIE", "grupo": "..Muebles", "grupo_cod": 102, "cardcode": "P1802", "nombre_proveedor": "GREENOAK WOODWORKS", "disponible": 135, "onhand": 140, "iscommited": 5, "onorder": 960, "u_cant_ult_ent": 960, "fechaentrada": "2026-05-29", "vendido_3a": 967, "primera_venta": "2025-02-17", "hist_comprado": 1920, "unidadesbulto": 24, "salpackun": 12, "precioventa": 32.5, "lastpurprc": 10.91, "picturname": "MUE-2019.jpg", "u_color": "NEGRO", "u_tamano": "40x175 cm", "codebars": "7479742641", "subg": "", "fob": 10.91, "cif": 13.31, "prox_llegada": "", "ultima_llegada": "2026-04-13", "u_cxblt": 6}, {"itemcode": "ROP-2020", "itemname": "CAMISETA ALGODÓN CUELLO REDONDO", "grupo": "..Ropa", "grupo_cod": 103, "cardcode": "P1203", "nombre_proveedor": "VESTIA GARMENTS LTD", "disponible": 17, "onhand": 24, "iscommited": 7, "onorder": 0, "u_cant_ult_ent": 480, "fechaentrada": "2026-01-20", "vendido_3a": 3374, "primera_venta": "2024-07-18", "hist_comprado": 1440, "unidadesbulto": 12, "salpackun": 24, "precioventa": 6.9, "lastpurprc": 2.25, "picturname": "ROP-2020.jpg", "u_color": "BLANCO", "u_tamano": "S/M/L/XL", "codebars": "7437279090", "subg": "", "fob": 2.25, "cif": 2.75, "prox_llegada": "", "ultima_llegada": "2026-06-15", "u_cxblt": 6}, {"itemcode": "ROP-2021", "itemname": "PANTALÓN DEPORTIVO UNISEX", "grupo": "..Ropa", "grupo_cod": 103, "cardcode": "P1202", "nombre_proveedor": "COTTONFIELD MILLS LTD", "disponible": 0, "onhand": 0, "iscommited": 0, "onorder": 0, "u_cant_ult_ent": 300, "fechaentrada": "2025-12-06", "vendido_3a": 3055, "primera_venta": "2024-11-12", "hist_comprado": 300, "unidadesbulto": 12, "salpackun": 6, "precioventa": 14.9, "lastpurprc": 4.76, "picturname": "ROP-2021.jpg", "u_color": "NEGRO", "u_tamano": "S/M/L/XL", "codebars": "7466351895", "subg": "", "fob": 4.76, "cif": 5.81, "prox_llegada": "", "ultima_llegada": "2026-04-07", "u_cxblt": 24}, {"itemcode": "ROP-2022", "itemname": "SUDADERA CON CAPUCHA", "grupo": "..Ropa", "grupo_cod": 103, "cardcode": "P1203", "nombre_proveedor": "VESTIA GARMENTS LTD", "disponible": 110, "onhand": 140, "iscommited": 30, "onorder": 960, "u_cant_ult_ent": 960, "fechaentrada": "2026-02-19", "vendido_3a": 2250, "primera_venta": "2025-02-22", "hist_comprado": 1920, "unidadesbulto": 12, "salpackun": 12, "precioventa": 19.9, "lastpurprc": 6.24, "picturname": "ROP-2022.jpg", "u_color": "GRIS", "u_tamano": "M/L/XL", "codebars": "7490869540", "subg": "", "fob": 6.24, "cif": 7.61, "prox_llegada": "", "ultima_llegada": "2026-03-15", "u_cxblt": 24}, {"itemcode": "ROP-2023", "itemname": "CALCETINES PACK 6 PARES", "grupo": "..Ropa", "grupo_cod": 103, "cardcode": "P1201", "nombre_proveedor": "MERIDIAN APPAREL CO.", "disponible": 53, "onhand": 60, "iscommited": 7, "onorder": 0, "u_cant_ult_ent": 1440, "fechaentrada": "2026-02-19", "vendido_3a": 3598, "primera_venta": "2024-09-01", "hist_comprado": 4320, "unidadesbulto": 12, "salpackun": 12, "precioventa": 7.5, "lastpurprc": 2.71, "picturname": "ROP-2023.jpg", "u_color": "SURTIDO", "u_tamano": "ÚNICA", "codebars": "7451574218", "subg": "", "fob": 2.71, "cif": 3.31, "prox_llegada": "", "ultima_llegada": "2026-01-24", "u_cxblt": 6}, {"itemcode": "ROP-2024", "itemname": "PIJAMA DOS PIEZAS", "grupo": "..Ropa", "grupo_cod": 103, "cardcode": "P1203", "nombre_proveedor": "VESTIA GARMENTS LTD", "disponible": 0, "onhand": 0, "iscommited": 0, "onorder": 0, "u_cant_ult_ent": 1200, "fechaentrada": "2025-08-14", "vendido_3a": 2638, "primera_venta": "2025-07-04", "hist_comprado": 3600, "unidadesbulto": 48, "salpackun": 12, "precioventa": 16.9, "lastpurprc": 6.34, "picturname": "ROP-2024.jpg", "u_color": "AZUL", "u_tamano": "S/M/L", "codebars": "7497272934", "subg": "", "fob": 6.34, "cif": 7.73, "prox_llegada": "", "ultima_llegada": "2025-12-04", "u_cxblt": 6}, {"itemcode": "ROP-2025", "itemname": "GORRA AJUSTABLE", "grupo": "..Ropa", "grupo_cod": 103, "cardcode": "P1201", "nombre_proveedor": "MERIDIAN APPAREL CO.", "disponible": 1, "onhand": 24, "iscommited": 23, "onorder": 0, "u_cant_ult_ent": 960, "fechaentrada": "2026-04-01", "vendido_3a": 3713, "primera_venta": "2024-05-21", "hist_comprado": 3840, "unidadesbulto": 24, "salpackun": 12, "precioventa": 5.9, "lastpurprc": 2.14, "picturname": "ROP-2025.jpg", "u_color": "NEGRO", "u_tamano": "ÚNICA", "codebars": "7426336788", "subg": "", "fob": 2.14, "cif": 2.61, "prox_llegada": "", "ultima_llegada": "2026-03-17", "u_cxblt": 12}, {"itemcode": "CAM-2026", "itemname": "TIENDA DE CAMPAÑA 4 PERSONAS", "grupo": "..Campamento", "grupo_cod": 104, "cardcode": "P1701", "nombre_proveedor": "TRAILMARK OUTDOOR GEAR", "disponible": 122, "onhand": 140, "iscommited": 18, "onorder": 0, "u_cant_ult_ent": 300, "fechaentrada": "2026-01-10", "vendido_3a": 3303, "primera_venta": "2024-05-16", "hist_comprado": 900, "unidadesbulto": 12, "salpackun": 24, "precioventa": 89.0, "lastpurprc": 32.01, "picturname": "CAM-2026.jpg", "u_color": "VERDE", "u_tamano": "240x210x130", "codebars": "7442303449", "subg": "", "fob": 32.01, "cif": 39.05, "prox_llegada": "", "ultima_llegada": "2026-05-31", "u_cxblt": 24}, {"itemcode": "CAM-2027", "itemname": "SILLA PLEGABLE CAMPING", "grupo": "..Campamento", "grupo_cod": 104, "cardcode": "P1701", "nombre_proveedor": "TRAILMARK OUTDOOR GEAR", "disponible": 4, "onhand": 8, "iscommited": 4, "onorder": 0, "u_cant_ult_ent": 300, "fechaentrada": "2025-11-03", "vendido_3a": 1262, "primera_venta": "2024-04-26", "hist_comprado": 300, "unidadesbulto": 12, "salpackun": 12, "precioventa": 22.9, "lastpurprc": 7.62, "picturname": "CAM-2027.jpg", "u_color": "AZUL", "u_tamano": "55x50x80 cm", "codebars": "7477276158", "subg": "", "fob": 7.62, "cif": 9.3, "prox_llegada": "", "ultima_llegada": "2025-12-19", "u_cxblt": 12}, {"itemcode": "CAM-2028", "itemname": "NEVERA PORTÁTIL 24L", "grupo": "..Campamento", "grupo_cod": 104, "cardcode": "P1701", "nombre_proveedor": "TRAILMARK OUTDOOR GEAR", "disponible": 134, "onhand": 140, "iscommited": 6, "onorder": 480, "u_cant_ult_ent": 300, "fechaentrada": "2026-02-04", "vendido_3a": 1514, "primera_venta": "2024-07-20", "hist_comprado": 1200, "unidadesbulto": 48, "salpackun": 24, "precioventa": 34.9, "lastpurprc": 11.2, "picturname": "CAM-2028.jpg", "u_color": "BLANCO", "u_tamano": "24L", "codebars": "7449390304", "subg": "", "fob": 11.2, "cif": 13.66, "prox_llegada": "", "ultima_llegada": "2026-04-30", "u_cxblt": 6}, {"itemcode": "CAM-2029", "itemname": "LINTERNA RECARGABLE LED", "grupo": "..Campamento", "grupo_cod": 104, "cardcode": "P1701", "nombre_proveedor": "TRAILMARK OUTDOOR GEAR", "disponible": 0, "onhand": 0, "iscommited": 0, "onorder": 0, "u_cant_ult_ent": 480, "fechaentrada": "2026-07-02", "vendido_3a": 413, "primera_venta": "2024-09-15", "hist_comprado": 1440, "unidadesbulto": 48, "salpackun": 6, "precioventa": 12.5, "lastpurprc": 4.48, "picturname": "CAM-2029.jpg", "u_color": "NEGRO", "u_tamano": "15 cm", "codebars": "7474707297", "subg": "", "fob": 4.48, "cif": 5.47, "prox_llegada": "", "ultima_llegada": "2026-05-09", "u_cxblt": 12}, {"itemcode": "CAM-2030", "itemname": "SACO DE DORMIR 3 ESTACIONES", "grupo": "..Campamento", "grupo_cod": 104, "cardcode": "P1701", "nombre_proveedor": "TRAILMARK OUTDOOR GEAR", "disponible": 668, "onhand": 700, "iscommited": 32, "onorder": 0, "u_cant_ult_ent": 960, "fechaentrada": "2025-10-04", "vendido_3a": 2287, "primera_venta": "2025-04-16", "hist_comprado": 2880, "unidadesbulto": 6, "salpackun": 12, "precioventa": 29.9, "lastpurprc": 10.24, "picturname": "CAM-2030.jpg", "u_color": "GRIS", "u_tamano": "210x75 cm", "codebars": "7456949738", "subg": "", "fob": 10.24, "cif": 12.49, "prox_llegada": "", "ultima_llegada": "2025-11-09", "u_cxblt": 24}, {"itemcode": "ELE-2031", "itemname": "VENTILADOR DE TORRE 3 VELOCIDADES", "grupo": "..Electronica", "grupo_cod": 105, "cardcode": "P1301", "nombre_proveedor": "VOLTIA ELECTRONICS", "disponible": 43, "onhand": 60, "iscommited": 17, "onorder": 480, "u_cant_ult_ent": 1440, "fechaentrada": "2026-07-01", "vendido_3a": 3451, "primera_venta": "2025-05-17", "hist_comprado": 1440, "unidadesbulto": 24, "salpackun": 6, "precioventa": 45.0, "lastpurprc": 14.65, "picturname": "ELE-2031.jpg", "u_color": "BLANCO", "u_tamano": "80 cm", "codebars": "7489156175", "subg": "", "fob": 14.65, "cif": 17.87, "prox_llegada": "", "ultima_llegada": "2026-06-21", "u_cxblt": 6}, {"itemcode": "ELE-2032", "itemname": "LICUADORA PERSONAL 600W", "grupo": "..Electronica", "grupo_cod": 105, "cardcode": "P1301", "nombre_proveedor": "VOLTIA ELECTRONICS", "disponible": 5, "onhand": 8, "iscommited": 3, "onorder": 0, "u_cant_ult_ent": 1200, "fechaentrada": "2026-06-30", "vendido_3a": 2854, "primera_venta": "2025-02-13", "hist_comprado": 2400, "unidadesbulto": 6, "salpackun": 6, "precioventa": 27.9, "lastpurprc": 9.92, "picturname": "ELE-2032.jpg", "u_color": "NEGRO", "u_tamano": "600 ml", "codebars": "7424167065", "subg": "", "fob": 9.92, "cif": 12.1, "prox_llegada": "", "ultima_llegada": "2026-03-16", "u_cxblt": 24}, {"itemcode": "ELE-2033", "itemname": "PLANCHA DE VAPOR CERÁMICA", "grupo": "..Electronica", "grupo_cod": 105, "cardcode": "P1302", "nombre_proveedor": "BRIGHTLINE APPLIANCES", "disponible": 675, "onhand": 700, "iscommited": 25, "onorder": 0, "u_cant_ult_ent": 1440, "fechaentrada": "2025-11-03", "vendido_3a": 414, "primera_venta": "2024-06-12", "hist_comprado": 2880, "unidadesbulto": 6, "salpackun": 24, "precioventa": 24.5, "lastpurprc": 8.51, "picturname": "ELE-2033.jpg", "u_color": "AZUL", "u_tamano": "2200W", "codebars": "7469416366", "subg": "", "fob": 8.51, "cif": 10.38, "prox_llegada": "", "ultima_llegada": "2026-01-27", "u_cxblt": 12}, {"itemcode": "ELE-2034", "itemname": "CAFETERA DE GOTEO 12 TAZAS", "grupo": "..Electronica", "grupo_cod": 105, "cardcode": "P1301", "nombre_proveedor": "VOLTIA ELECTRONICS", "disponible": 320, "onhand": 320, "iscommited": 0, "onorder": 960, "u_cant_ult_ent": 600, "fechaentrada": "2025-09-16", "vendido_3a": 925, "primera_venta": "2024-10-01", "hist_comprado": 1800, "unidadesbulto": 24, "salpackun": 12, "precioventa": 39.9, "lastpurprc": 11.93, "picturname": "ELE-2034.jpg", "u_color": "NEGRO", "u_tamano": "1.8L", "codebars": "7438637825", "subg": "", "fob": 11.93, "cif": 14.55, "prox_llegada": "", "ultima_llegada": "2025-11-08", "u_cxblt": 6}, {"itemcode": "HOM-2035", "itemname": "MARCO DE FOTOS 20X25", "grupo": "..Home Deco", "grupo_cod": 106, "cardcode": "P1901", "nombre_proveedor": "ATELIER DECO HOUSE", "disponible": 668, "onhand": 700, "iscommited": 32, "onorder": 0, "u_cant_ult_ent": 960, "fechaentrada": "2025-11-01", "vendido_3a": 1584, "primera_venta": "2024-10-28", "hist_comprado": 3840, "unidadesbulto": 24, "salpackun": 24, "precioventa": 8.9, "lastpurprc": 3.2, "picturname": "HOM-2035.jpg", "u_color": "DORADO", "u_tamano": "20x25 cm", "codebars": "7442747599", "subg": "", "fob": 3.2, "cif": 3.9, "prox_llegada": "", "ultima_llegada": "2026-04-30", "u_cxblt": 12}, {"itemcode": "HOM-2036", "itemname": "ESPEJO DECORATIVO REDONDO", "grupo": "..Home Deco", "grupo_cod": 106, "cardcode": "P1902", "nombre_proveedor": "LUNARIA HOME ARTS", "disponible": 103, "onhand": 140, "iscommited": 37, "onorder": 960, "u_cant_ult_ent": 300, "fechaentrada": "2026-07-20", "vendido_3a": 656, "primera_venta": "2024-09-14", "hist_comprado": 900, "unidadesbulto": 48, "salpackun": 12, "precioventa": 34.9, "lastpurprc": 10.82, "picturname": "HOM-2036.jpg", "u_color": "NEGRO", "u_tamano": "50 cm", "codebars": "7411318793", "subg": "", "fob": 10.82, "cif": 13.2, "prox_llegada": "", "ultima_llegada": "2025-12-11", "u_cxblt": 6}, {"itemcode": "HOM-2037", "itemname": "JARRÓN CERÁMICA ESMALTADA", "grupo": "..Home Deco", "grupo_cod": 106, "cardcode": "P1902", "nombre_proveedor": "LUNARIA HOME ARTS", "disponible": 689, "onhand": 700, "iscommited": 11, "onorder": 960, "u_cant_ult_ent": 600, "fechaentrada": "2026-02-13", "vendido_3a": 2822, "primera_venta": "2024-06-01", "hist_comprado": 600, "unidadesbulto": 6, "salpackun": 6, "precioventa": 19.9, "lastpurprc": 5.87, "picturname": "HOM-2037.jpg", "u_color": "VERDE", "u_tamano": "30 cm", "codebars": "7488186622", "subg": "", "fob": 5.87, "cif": 7.16, "prox_llegada": "", "ultima_llegada": "2025-12-25", "u_cxblt": 12}, {"itemcode": "HOM-2038", "itemname": "SET 3 CUADROS BOTÁNICOS", "grupo": "..Home Deco", "grupo_cod": 106, "cardcode": "P1901", "nombre_proveedor": "ATELIER DECO HOUSE", "disponible": 683, "onhand": 700, "iscommited": 17, "onorder": 0, "u_cant_ult_ent": 960, "fechaentrada": "2025-09-17", "vendido_3a": 2288, "primera_venta": "2024-12-01", "hist_comprado": 2880, "unidadesbulto": 6, "salpackun": 6, "precioventa": 27.5, "lastpurprc": 10.12, "picturname": "HOM-2038.jpg", "u_color": "MULTI", "u_tamano": "30x40 cm", "codebars": "7490193280", "subg": "", "fob": 10.12, "cif": 12.35, "prox_llegada": "", "ultima_llegada": "2025-11-21", "u_cxblt": 12}, {"itemcode": "HOM-2039", "itemname": "RELOJ DE PARED MINIMALISTA", "grupo": "..Home Deco", "grupo_cod": 106, "cardcode": "P1902", "nombre_proveedor": "LUNARIA HOME ARTS", "disponible": 15, "onhand": 24, "iscommited": 9, "onorder": 0, "u_cant_ult_ent": 480, "fechaentrada": "2025-10-13", "vendido_3a": 3083, "primera_venta": "2025-01-11", "hist_comprado": 480, "unidadesbulto": 6, "salpackun": 6, "precioventa": 15.9, "lastpurprc": 5.05, "picturname": "HOM-2039.jpg", "u_color": "BLANCO", "u_tamano": "35 cm", "codebars": "7406567396", "subg": "", "fob": 5.05, "cif": 6.16, "prox_llegada": "", "ultima_llegada": "2025-12-13", "u_cxblt": 6}], "proveedores": [{"cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "email": "ventas@aurelia.com", "pais": "Bangladesh", "saldo": 43881.13}, {"cardcode": "P2102", "cardname": "BLUEPEAK KITCHEN SUPPLY", "email": "ventas@bluepeak.com", "pais": "India", "saldo": 74683.71}, {"cardcode": "P2103", "cardname": "CASA NORDIA TRADING", "email": "ventas@casa.com", "pais": "India", "saldo": 13511.96}, {"cardcode": "P1501", "cardname": "TERRANOVA RUGS CO.", "email": "ventas@terranova.com", "pais": "Indonesia", "saldo": 67343.53}, {"cardcode": "P1502", "cardname": "SUNRAY WEAVING GROUP", "email": "ventas@sunray.com", "pais": "Indonesia", "saldo": 55374.97}, {"cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "email": "ventas@palmera.com", "pais": "Vietnam", "saldo": 3842.58}, {"cardcode": "P1801", "cardname": "ROBLEDO MUEBLES INTL", "email": "ventas@robledo.com", "pais": "Vietnam", "saldo": 10266.1}, {"cardcode": "P1802", "cardname": "GREENOAK WOODWORKS", "email": "ventas@greenoak.com", "pais": "Egipto", "saldo": 33440.49}, {"cardcode": "P1201", "cardname": "MERIDIAN APPAREL CO.", "email": "ventas@meridian.com", "pais": "China", "saldo": 82751.02}, {"cardcode": "P1202", "cardname": "COTTONFIELD MILLS LTD", "email": "ventas@cottonfield.com", "pais": "Vietnam", "saldo": 31329.4}, {"cardcode": "P1203", "cardname": "VESTIA GARMENTS LTD", "email": "ventas@vestia.com", "pais": "China", "saldo": 59460.62}, {"cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "email": "ventas@trailmark.com", "pais": "India", "saldo": 4302.66}, {"cardcode": "P1702", "cardname": "NORTHWIND CAMP SUPPLY", "email": "ventas@northwind.com", "pais": "Vietnam", "saldo": 76619.76}, {"cardcode": "P1301", "cardname": "VOLTIA ELECTRONICS", "email": "ventas@voltia.com", "pais": "India", "saldo": 17004.27}, {"cardcode": "P1302", "cardname": "BRIGHTLINE APPLIANCES", "email": "ventas@brightline.com", "pais": "Egipto", "saldo": 19652.15}, {"cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "email": "ventas@atelier.com", "pais": "Egipto", "saldo": 43034.34}, {"cardcode": "P1902", "cardname": "LUNARIA HOME ARTS", "email": "ventas@lunaria.com", "pais": "Egipto", "saldo": 29675.91}], "compras_seguimiento": [{"docnum": "12510", "etapa": "pedido", "progreso": "{\"pedido\": {\"stepIdx\": 1, \"stepDates\": [\"2026-08-05\"]}}", "actualizado_en": "2026-08-22T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12516", "etapa": "deposito", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-11\"]}, \"deposito\": {\"stepIdx\": 0, \"stepDates\": [\"2026-07-18\"]}}", "actualizado_en": "2026-08-21T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12526", "etapa": "artes", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-10\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-10\"]}, \"artes\": {\"stepIdx\": 0, \"stepDates\": [\"2026-07-17\"]}}", "actualizado_en": "2026-08-31T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12537", "etapa": "produccion", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-19\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-19\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-19\"]}, \"produccion\": {\"stepIdx\": 0, \"stepDates\": [\"2026-06-26\"]}}", "actualizado_en": "2026-08-23T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12547", "etapa": "logistica", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-25\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-25\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-25\"]}, \"produccion\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-25\"]}, \"logistica\": {\"stepIdx\": 1, \"stepDates\": [\"2026-06-01\"]}}", "actualizado_en": "2026-08-28T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12553", "etapa": "aduana", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-18\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-18\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-18\"]}, \"produccion\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-18\"]}, \"logistica\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-18\"]}, \"aduana\": {\"stepIdx\": 0, \"stepDates\": [\"2026-05-25\"]}}", "actualizado_en": "2026-09-02T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12557", "etapa": "bodega", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-24\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-24\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-24\"]}, \"produccion\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-24\"]}, \"logistica\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-24\"]}, \"aduana\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-24\"]}, \"bodega\": {\"stepIdx\": 1, \"stepDates\": [\"2026-05-01\"]}}", "actualizado_en": "2026-08-27T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12566", "etapa": "pedido", "progreso": "{\"pedido\": {\"stepIdx\": 1, \"stepDates\": [\"2026-07-30\"]}}", "actualizado_en": "2026-09-01T00:00:00Z", "actualizado_por": "Gady"}, {"docnum": "12571", "etapa": "deposito", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-04\"]}, \"deposito\": {\"stepIdx\": 1, \"stepDates\": [\"2026-07-11\"]}}", "actualizado_en": "2026-08-21T00:00:00Z", "actualizado_por": "Gady"}, {"docnum": "12581", "etapa": "artes", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-05\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-05\"]}, \"artes\": {\"stepIdx\": 1, \"stepDates\": [\"2026-07-12\"]}}", "actualizado_en": "2026-08-28T00:00:00Z", "actualizado_por": "Gady"}, {"docnum": "12588", "etapa": "produccion", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-03\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-03\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-03\"]}, \"produccion\": {\"stepIdx\": 0, \"stepDates\": [\"2026-06-10\"]}}", "actualizado_en": "2026-08-28T00:00:00Z", "actualizado_por": "Gady"}, {"docnum": "12597", "etapa": "logistica", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-11\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-11\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-11\"]}, \"produccion\": {\"stepIdx\": 9, \"stepDates\": [\"2026-05-11\"]}, \"logistica\": {\"stepIdx\": 0, \"stepDates\": [\"2026-05-18\"]}}", "actualizado_en": "2026-08-31T00:00:00Z", "actualizado_por": "Gady"}, {"docnum": "12602", "etapa": "pedido", "progreso": "{\"pedido\": {\"stepIdx\": 0, \"stepDates\": [\"2026-08-09\"]}}", "actualizado_en": "2026-09-01T00:00:00Z", "actualizado_por": "Aleyda"}, {"docnum": "12606", "etapa": "deposito", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-23\"]}, \"deposito\": {\"stepIdx\": 0, \"stepDates\": [\"2026-07-30\"]}}", "actualizado_en": "2026-08-22T00:00:00Z", "actualizado_por": "Aleyda"}, {"docnum": "12611", "etapa": "artes", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-05\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-05\"]}, \"artes\": {\"stepIdx\": 0, \"stepDates\": [\"2026-07-12\"]}}", "actualizado_en": "2026-08-25T00:00:00Z", "actualizado_por": "Aleyda"}, {"docnum": "12618", "etapa": "produccion", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-09\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-09\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-09\"]}, \"produccion\": {\"stepIdx\": 1, \"stepDates\": [\"2026-06-16\"]}}", "actualizado_en": "2026-08-23T00:00:00Z", "actualizado_por": "Aleyda"}, {"docnum": "12624", "etapa": "pedido", "progreso": "{\"pedido\": {\"stepIdx\": 1, \"stepDates\": [\"2026-08-04\"]}}", "actualizado_en": "2026-08-28T00:00:00Z", "actualizado_por": "Yagizel"}, {"docnum": "12634", "etapa": "deposito", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-16\"]}, \"deposito\": {\"stepIdx\": 1, \"stepDates\": [\"2026-07-23\"]}}", "actualizado_en": "2026-08-27T00:00:00Z", "actualizado_por": "Yagizel"}, {"docnum": "12645", "etapa": "artes", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-24\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-24\"]}, \"artes\": {\"stepIdx\": 1, \"stepDates\": [\"2026-07-01\"]}}", "actualizado_en": "2026-08-25T00:00:00Z", "actualizado_por": "Yagizel"}, {"docnum": "12648", "etapa": "produccion", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-17\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-17\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-17\"]}, \"produccion\": {\"stepIdx\": 1, \"stepDates\": [\"2026-06-24\"]}}", "actualizado_en": "2026-09-01T00:00:00Z", "actualizado_por": "Yagizel"}, {"docnum": "12655", "etapa": "logistica", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-04\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-04\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-04\"]}, \"produccion\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-04\"]}, \"logistica\": {\"stepIdx\": 0, \"stepDates\": [\"2026-06-11\"]}}", "actualizado_en": "2026-08-23T00:00:00Z", "actualizado_por": "Yagizel"}, {"docnum": "12665", "etapa": "aduana", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-25\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-25\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-25\"]}, \"produccion\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-25\"]}, \"logistica\": {\"stepIdx\": 9, \"stepDates\": [\"2026-04-25\"]}, \"aduana\": {\"stepIdx\": 1, \"stepDates\": [\"2026-05-02\"]}}", "actualizado_en": "2026-09-02T00:00:00Z", "actualizado_por": "Yagizel"}, {"docnum": "12668", "etapa": "pedido", "progreso": "{\"pedido\": {\"stepIdx\": 0, \"stepDates\": [\"2026-08-04\"]}}", "actualizado_en": "2026-09-01T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12679", "etapa": "deposito", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-06\"]}, \"deposito\": {\"stepIdx\": 1, \"stepDates\": [\"2026-07-13\"]}}", "actualizado_en": "2026-08-30T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12688", "etapa": "artes", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-30\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-30\"]}, \"artes\": {\"stepIdx\": 0, \"stepDates\": [\"2026-07-07\"]}}", "actualizado_en": "2026-08-21T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12695", "etapa": "pedido", "progreso": "{\"pedido\": {\"stepIdx\": 1, \"stepDates\": [\"2026-08-07\"]}}", "actualizado_en": "2026-08-31T00:00:00Z", "actualizado_por": "Aleyda"}, {"docnum": "12700", "etapa": "deposito", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-05\"]}, \"deposito\": {\"stepIdx\": 1, \"stepDates\": [\"2026-07-12\"]}}", "actualizado_en": "2026-08-26T00:00:00Z", "actualizado_por": "Aleyda"}, {"docnum": "12706", "etapa": "artes", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-27\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-27\"]}, \"artes\": {\"stepIdx\": 0, \"stepDates\": [\"2026-07-04\"]}}", "actualizado_en": "2026-08-29T00:00:00Z", "actualizado_por": "Aleyda"}, {"docnum": "12709", "etapa": "pedido", "progreso": "{\"pedido\": {\"stepIdx\": 0, \"stepDates\": [\"2026-08-21\"]}}", "actualizado_en": "2026-08-29T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12715", "etapa": "deposito", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-07-17\"]}, \"deposito\": {\"stepIdx\": 1, \"stepDates\": [\"2026-07-24\"]}}", "actualizado_en": "2026-08-30T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12719", "etapa": "artes", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-30\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-30\"]}, \"artes\": {\"stepIdx\": 0, \"stepDates\": [\"2026-07-07\"]}}", "actualizado_en": "2026-08-27T00:00:00Z", "actualizado_por": "Sherene"}, {"docnum": "12727", "etapa": "produccion", "progreso": "{\"pedido\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-16\"]}, \"deposito\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-16\"]}, \"artes\": {\"stepIdx\": 9, \"stepDates\": [\"2026-06-16\"]}, \"produccion\": {\"stepIdx\": 0, \"stepDates\": [\"2026-06-23\"]}}", "actualizado_en": "2026-08-30T00:00:00Z", "actualizado_por": "Sherene"}], "compras_comentarios": [{"docnum": "12510", "etapa": "pedido", "paso": 0, "autor": "Sherene", "texto": "El proveedor confirma embarque para la próxima semana.", "creado_en": "2026-08-25T00:00:00Z"}, {"docnum": "12526", "etapa": "artes", "paso": 0, "autor": "Sherene", "texto": "Ya se aprobó el arte, pueden empezar producción.", "creado_en": "2026-08-25T00:00:00Z"}, {"docnum": "12547", "etapa": "logistica", "paso": 0, "autor": "Sherene", "texto": "Ya se aprobó el arte, pueden empezar producción.", "creado_en": "2026-08-28T00:00:00Z"}, {"docnum": "12557", "etapa": "bodega", "paso": 0, "autor": "Sherene", "texto": "El proveedor confirma embarque para la próxima semana.", "creado_en": "2026-08-22T00:00:00Z"}, {"docnum": "12566", "etapa": "pedido", "paso": 0, "autor": "Gady", "texto": "El proveedor confirma embarque para la próxima semana.", "creado_en": "2026-08-24T00:00:00Z"}, {"docnum": "12581", "etapa": "artes", "paso": 0, "autor": "Gady", "texto": "Pendiente que envíen la PI firmada.", "creado_en": "2026-08-20T00:00:00Z"}, {"docnum": "12597", "etapa": "logistica", "paso": 0, "autor": "Gady", "texto": "El proveedor confirma embarque para la próxima semana.", "creado_en": "2026-09-01T00:00:00Z"}, {"docnum": "12602", "etapa": "pedido", "paso": 0, "autor": "Aleyda", "texto": "Ojo con las medidas del empaque, revisar antes de cerrar.", "creado_en": "2026-08-24T00:00:00Z"}, {"docnum": "12611", "etapa": "artes", "paso": 0, "autor": "Aleyda", "texto": "Pendiente que envíen la PI firmada.", "creado_en": "2026-08-29T00:00:00Z"}, {"docnum": "12624", "etapa": "pedido", "paso": 0, "autor": "Yagizel", "texto": "Ojo con las medidas del empaque, revisar antes de cerrar.", "creado_en": "2026-08-23T00:00:00Z"}, {"docnum": "12645", "etapa": "artes", "paso": 0, "autor": "Yagizel", "texto": "El proveedor confirma embarque para la próxima semana.", "creado_en": "2026-08-30T00:00:00Z"}, {"docnum": "12655", "etapa": "logistica", "paso": 0, "autor": "Yagizel", "texto": "Ojo con las medidas del empaque, revisar antes de cerrar.", "creado_en": "2026-08-19T00:00:00Z"}, {"docnum": "12668", "etapa": "pedido", "paso": 0, "autor": "Sherene", "texto": "Ya se aprobó el arte, pueden empezar producción.", "creado_en": "2026-08-15T00:00:00Z"}, {"docnum": "12688", "etapa": "artes", "paso": 0, "autor": "Sherene", "texto": "Ya se aprobó el arte, pueden empezar producción.", "creado_en": "2026-08-27T00:00:00Z"}, {"docnum": "12695", "etapa": "pedido", "paso": 0, "autor": "Aleyda", "texto": "El proveedor confirma embarque para la próxima semana.", "creado_en": "2026-08-31T00:00:00Z"}, {"docnum": "12706", "etapa": "artes", "paso": 0, "autor": "Aleyda", "texto": "Ya se aprobó el arte, pueden empezar producción.", "creado_en": "2026-08-18T00:00:00Z"}, {"docnum": "12709", "etapa": "pedido", "paso": 0, "autor": "Sherene", "texto": "El proveedor confirma embarque para la próxima semana.", "creado_en": "2026-09-01T00:00:00Z"}, {"docnum": "12719", "etapa": "artes", "paso": 0, "autor": "Sherene", "texto": "Pendiente que envíen la PI firmada.", "creado_en": "2026-08-14T00:00:00Z"}], "compras_documentos": [], "compras_artes_envio": [{"docnum": "12526", "enviado_por": "Franco", "enviado_en": "2026-07-27T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12537", "enviado_por": "Franco", "enviado_en": "2026-07-06T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12547", "enviado_por": "Franco", "enviado_en": "2026-06-11T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12553", "enviado_por": "Franco", "enviado_en": "2026-06-04T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12557", "enviado_por": "Franco", "enviado_en": "2026-05-11T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12581", "enviado_por": "Franco", "enviado_en": "2026-07-22T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12588", "enviado_por": "Franco", "enviado_en": "2026-06-20T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12597", "enviado_por": "Franco", "enviado_en": "2026-05-28T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12611", "enviado_por": "Franco", "enviado_en": "2026-07-22T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12618", "enviado_por": "Franco", "enviado_en": "2026-06-26T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12645", "enviado_por": "Franco", "enviado_en": "2026-07-11T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12648", "enviado_por": "Franco", "enviado_en": "2026-07-04T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12655", "enviado_por": "Franco", "enviado_en": "2026-06-21T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12665", "enviado_por": "Franco", "enviado_en": "2026-05-12T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12688", "enviado_por": "Franco", "enviado_en": "2026-07-17T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12706", "enviado_por": "Franco", "enviado_en": "2026-07-14T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12719", "enviado_por": "Franco", "enviado_en": "2026-07-17T00:00:00Z", "nota": "Arte v2 para aprobación"}, {"docnum": "12727", "enviado_por": "Franco", "enviado_en": "2026-07-03T00:00:00Z", "nota": "Arte v2 para aprobación"}], "compras_artes_aprob": [{"docnum": "12537", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-07-04T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12547", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-06-09T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12553", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-06-02T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12557", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-05-09T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12588", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-06-18T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12597", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-05-26T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12618", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-06-24T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12648", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-07-02T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12655", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-06-19T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12665", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-05-10T00:00:00Z", "nota": "Aprobado sin cambios"}, {"docnum": "12727", "aprobado_por": "Edy Guindi", "aprobado_en": "2026-07-01T00:00:00Z", "nota": "Aprobado sin cambios"}], "compras_booking": [{"docnum": "12547", "booking": "BK369029", "naviera": "RUTA PACIFICO", "etd": "2026-06-21", "eta": "2026-11-10", "contenedores": "[{\"num\": \"DEMO1245726\", \"tipo\": \"40'HQ\", \"etd\": \"2026-06-21\", \"eta\": \"2026-11-10\"}]", "creado_en": "2026-06-21T00:00:00Z"}, {"docnum": "12553", "booking": "BK264589", "naviera": "RUTA PACIFICO", "etd": "2026-06-14", "eta": "2026-09-11", "contenedores": "[{\"num\": \"DEMO5470965\", \"tipo\": \"40'HQ\", \"etd\": \"2026-06-14\", \"eta\": \"2026-09-11\"}]", "creado_en": "2026-06-14T00:00:00Z"}, {"docnum": "12557", "booking": "BK769766", "naviera": "RUTA PACIFICO", "etd": "2026-05-21", "eta": "2026-09-09", "contenedores": "[{\"num\": \"DEMO9892106\", \"tipo\": \"40'HQ\", \"etd\": \"2026-05-21\", \"eta\": \"2026-09-09\"}]", "creado_en": "2026-05-21T00:00:00Z"}, {"docnum": "12597", "booking": "BK303378", "naviera": "RUTA PACIFICO", "etd": "2026-06-07", "eta": "2026-10-12", "contenedores": "[{\"num\": \"DEMO1381681\", \"tipo\": \"40'HQ\", \"etd\": \"2026-06-07\", \"eta\": \"2026-10-12\"}]", "creado_en": "2026-06-07T00:00:00Z"}, {"docnum": "12655", "booking": "BK666280", "naviera": "LINEA MERIDIANA", "etd": "2026-07-01", "eta": "2026-10-12", "contenedores": "[{\"num\": \"DEMO1579607\", \"tipo\": \"40'HQ\", \"etd\": \"2026-07-01\", \"eta\": \"2026-10-12\"}]", "creado_en": "2026-07-01T00:00:00Z"}, {"docnum": "12665", "booking": "BK695563", "naviera": "NAVIERA ATLANTIS", "etd": "2026-05-22", "eta": "2026-11-19", "contenedores": "[{\"num\": \"DEMO7243416\", \"tipo\": \"40'HQ\", \"etd\": \"2026-05-22\", \"eta\": \"2026-11-19\"}]", "creado_en": "2026-05-22T00:00:00Z"}], "compras_llegada": [{"docnum": "12557", "llegada": "2026-08-18", "registrado_por": "David", "registrado_en": "2026-08-29T00:00:00Z"}], "compras_logistica": [], "compras_pend_sap": [{"dkc": "DKC-NS100", "num_orden": "DKC-NS100", "po": "PO-6542", "dept": "hogar", "proveedor": "AURELIA HOMEWARE LTD", "cardcode": "P2101", "total": 43114.93, "abonado": 12934.48, "saldo": 30180.45, "agregado_por": "Sherene", "fecha": "2026-07-30", "creado_en": "2026-07-26T00:00:00Z", "fecha_abono": "2026-07-24", "editada": false, "editado_en": "", "editado_por": "", "motivo_edicion": "", "num_reposicion": "", "dif_reposicion": null, "pago_contra_bl": false, "items": [{"sku": "HOG-2001", "cant": 244, "precio": 5.85}, {"sku": "HOG-2002", "cant": 430, "precio": 9.71}, {"sku": "HOG-2003", "cant": 689, "precio": 13.97}]}, {"dkc": "DKC-NS101", "num_orden": "DKC-NS101", "po": "PO-4534", "dept": "alfombras", "proveedor": "TERRANOVA RUGS CO.", "cardcode": "P1501", "total": 57278.0, "abonado": 17183.4, "saldo": 40094.6, "agregado_por": "Gady", "fecha": "2026-07-05", "creado_en": "2026-07-04T00:00:00Z", "fecha_abono": "2026-07-26", "editada": false, "editado_en": "", "editado_por": "", "motivo_edicion": "", "num_reposicion": "", "dif_reposicion": null, "pago_contra_bl": false, "items": [{"sku": "ALF-2009", "cant": 652, "precio": 13.29}, {"sku": "ALF-2010", "cant": 733, "precio": 14.4}, {"sku": "ALF-2011", "cant": 261, "precio": 9.94}]}, {"dkc": "DKC-NS102", "num_orden": "DKC-NS102", "po": "PO-8134", "dept": "muebles", "proveedor": "ROBLEDO MUEBLES INTL", "cardcode": "P1801", "total": 50156.99, "abonado": 15047.1, "saldo": 35109.89, "agregado_por": "Aleyda", "fecha": "2026-07-16", "creado_en": "2026-08-13T00:00:00Z", "fecha_abono": "2026-07-31", "editada": false, "editado_en": "", "editado_por": "", "motivo_edicion": "", "num_reposicion": "", "dif_reposicion": null, "pago_contra_bl": true, "items": [{"sku": "MUE-2015", "cant": 283, "precio": 7.91}, {"sku": "MUE-2016", "cant": 788, "precio": 5.62}, {"sku": "MUE-2017", "cant": 589, "precio": 7.98}]}, {"dkc": "DKC-NS103", "num_orden": "DKC-NS103", "po": "PO-7417", "dept": "ropa", "proveedor": "MERIDIAN APPAREL CO.", "cardcode": "P1201", "total": 48753.02, "abonado": 14625.91, "saldo": 34127.11, "agregado_por": "Yagizel", "fecha": "2026-08-03", "creado_en": "2026-07-26T00:00:00Z", "fecha_abono": "2026-07-31", "editada": false, "editado_en": "", "editado_por": "", "motivo_edicion": "", "num_reposicion": "", "dif_reposicion": null, "pago_contra_bl": true, "items": [{"sku": "ROP-2020", "cant": 573, "precio": 19.63}, {"sku": "ROP-2021", "cant": 302, "precio": 14.64}, {"sku": "ROP-2022", "cant": 354, "precio": 9.66}]}, {"dkc": "DKC-NS104", "num_orden": "DKC-NS104", "po": "PO-9791", "dept": "campamento", "proveedor": "TRAILMARK OUTDOOR GEAR", "cardcode": "P1701", "total": 42875.18, "abonado": 12862.55, "saldo": 30012.63, "agregado_por": "Sherene", "fecha": "2026-08-18", "creado_en": "2026-08-20T00:00:00Z", "fecha_abono": "2026-08-13", "editada": false, "editado_en": "", "editado_por": "", "motivo_edicion": "", "num_reposicion": "", "dif_reposicion": null, "pago_contra_bl": false, "items": [{"sku": "CAM-2026", "cant": 553, "precio": 19.85}, {"sku": "CAM-2027", "cant": 551, "precio": 14.72}, {"sku": "CAM-2028", "cant": 260, "precio": 18.92}]}], "solicitudes_pago": [{"id": 1000, "docnum": "12510", "dkc": "DKC-26001", "proveedor": "AURELIA HOMEWARE LTD", "cardcode": "P2101", "tipo": "cancelacion", "monto": 6249.6, "estado": "pendiente", "solicitado_por": "Sherene", "solicitado_en": "2026-08-28T00:00:00Z", "creado_en": "2026-08-19T00:00:00Z", "banco": "Banco Primero", "financiado": false, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1001, "docnum": "12516", "dkc": "DKC-26002", "proveedor": "CASA NORDIA TRADING", "cardcode": "P2103", "tipo": "abono", "monto": 2012.4, "estado": "financiado", "solicitado_por": "Sherene", "solicitado_en": "2026-08-22T00:00:00Z", "creado_en": "2026-08-05T00:00:00Z", "banco": "Banco Tercero", "financiado": true, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1002, "docnum": "12526", "dkc": "DKC-26003", "proveedor": "CASA NORDIA TRADING", "cardcode": "P2103", "tipo": "abono", "monto": 513.0, "estado": "abono_enviado", "solicitado_por": "Sherene", "solicitado_en": "2026-08-12T00:00:00Z", "creado_en": "2026-08-19T00:00:00Z", "banco": "Banco Segundo", "financiado": true, "pagado": true, "nota": "", "escalado_nivel": 0}, {"id": 1003, "docnum": "12537", "dkc": "DKC-26004", "proveedor": "AURELIA HOMEWARE LTD", "cardcode": "P2101", "tipo": "cancelacion", "monto": 6375.6, "estado": "pendiente", "solicitado_por": "Sherene", "solicitado_en": "2026-08-09T00:00:00Z", "creado_en": "2026-08-10T00:00:00Z", "banco": "Banco Segundo", "financiado": false, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1004, "docnum": "12547", "dkc": "DKC-26005", "proveedor": "CASA NORDIA TRADING", "cardcode": "P2103", "tipo": "abono", "monto": 3021.84, "estado": "pendiente", "solicitado_por": "Sherene", "solicitado_en": "2026-08-11T00:00:00Z", "creado_en": "2026-08-25T00:00:00Z", "banco": "Banco Segundo", "financiado": false, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1005, "docnum": "12553", "dkc": "DKC-26006", "proveedor": "AURELIA HOMEWARE LTD", "cardcode": "P2101", "tipo": "abono", "monto": 3769.2, "estado": "pendiente", "solicitado_por": "Sherene", "solicitado_en": "2026-08-16T00:00:00Z", "creado_en": "2026-08-17T00:00:00Z", "banco": "Banco Segundo", "financiado": false, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1006, "docnum": "12557", "dkc": "DKC-26007", "proveedor": "CASA NORDIA TRADING", "cardcode": "P2103", "tipo": "cancelacion", "monto": 5720.4, "estado": "financiado", "solicitado_por": "Sherene", "solicitado_en": "2026-08-23T00:00:00Z", "creado_en": "2026-08-30T00:00:00Z", "banco": "Banco Tercero", "financiado": true, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1007, "docnum": "12566", "dkc": "DKC-26008", "proveedor": "PALMERA TEXTIL EXPORT", "cardcode": "P1503", "tipo": "abono", "monto": 14996.52, "estado": "abono_enviado", "solicitado_por": "Sherene", "solicitado_en": "2026-08-29T00:00:00Z", "creado_en": "2026-08-03T00:00:00Z", "banco": "Banco Segundo", "financiado": true, "pagado": true, "nota": "", "escalado_nivel": 0}, {"id": 1008, "docnum": "12571", "dkc": "DKC-26009", "proveedor": "PALMERA TEXTIL EXPORT", "cardcode": "P1503", "tipo": "abono", "monto": 10684.8, "estado": "pendiente", "solicitado_por": "Sherene", "solicitado_en": "2026-08-31T00:00:00Z", "creado_en": "2026-08-12T00:00:00Z", "banco": "Banco Segundo", "financiado": false, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1009, "docnum": "12581", "dkc": "DKC-26010", "proveedor": "PALMERA TEXTIL EXPORT", "cardcode": "P1503", "tipo": "cancelacion", "monto": 18728.64, "estado": "pendiente", "solicitado_por": "Sherene", "solicitado_en": "2026-08-22T00:00:00Z", "creado_en": "2026-08-18T00:00:00Z", "banco": "Banco Tercero", "financiado": false, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1010, "docnum": "12588", "dkc": "DKC-26011", "proveedor": "TERRANOVA RUGS CO.", "cardcode": "P1501", "tipo": "abono", "monto": 2216.7, "estado": "pendiente", "solicitado_por": "Sherene", "solicitado_en": "2026-08-20T00:00:00Z", "creado_en": "2026-08-26T00:00:00Z", "banco": "Banco Segundo", "financiado": false, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1011, "docnum": "12597", "dkc": "DKC-26012", "proveedor": "SUNRAY WEAVING GROUP", "cardcode": "P1502", "tipo": "abono", "monto": 7945.74, "estado": "financiado", "solicitado_por": "Sherene", "solicitado_en": "2026-08-12T00:00:00Z", "creado_en": "2026-08-19T00:00:00Z", "banco": "Banco Segundo", "financiado": true, "pagado": false, "nota": "", "escalado_nivel": 0}, {"id": 1012, "docnum": "12602", "dkc": "DKC-26013", "proveedor": "ROBLEDO MUEBLES INTL", "cardcode": "P1801", "tipo": "cancelacion", "monto": 20152.44, "estado": "abono_enviado", "solicitado_por": "Sherene", "solicitado_en": "2026-08-24T00:00:00Z", "creado_en": "2026-08-03T00:00:00Z", "banco": "Banco Primero", "financiado": true, "pagado": true, "nota": "", "escalado_nivel": 0}, {"id": 1013, "docnum": "12606", "dkc": "DKC-26014", "proveedor": "ROBLEDO MUEBLES INTL", "cardcode": "P1801", "tipo": "abono", "monto": 5508.0, "estado": "pendiente", "solicitado_por": "Sherene", "solicitado_en": "2026-08-10T00:00:00Z", "creado_en": "2026-08-23T00:00:00Z", "banco": "Banco Tercero", "financiado": false, "pagado": false, "nota": "", "escalado_nivel": 0}], "ordenes_firma": [], "reclamos": [], "menciones": [], "mensajes_dm": [{"id": 1, "de": "sherene", "para": "dan", "mensaje": "¿Puedes revisar la orden de Ningbo? Falta tu firma.", "tipo": "texto", "borrado": false, "leido_en": null, "creado_en": "2026-09-02T00:00:00Z", "adjunto_nombre": ""}, {"id": 2, "de": "dan", "para": "sherene", "mensaje": "Ya la firmé, avísale a contabilidad.", "tipo": "texto", "borrado": false, "leido_en": "2026-09-01T00:00:00Z", "creado_en": "2026-09-01T00:00:00Z", "adjunto_nombre": ""}, {"id": 3, "de": "yeini", "para": "sherene", "mensaje": "El abono de MAC Carpet salió esta mañana.", "tipo": "texto", "borrado": false, "leido_en": "2026-09-01T00:00:00Z", "creado_en": "2026-09-02T00:00:00Z", "adjunto_nombre": ""}, {"id": 4, "de": "franco", "para": "edy", "mensaje": "Subí los artes de la orden de alfombras.", "tipo": "texto", "borrado": false, "leido_en": null, "creado_en": "2026-08-29T00:00:00Z", "adjunto_nombre": ""}, {"id": 5, "de": "edy", "para": "franco", "mensaje": "Aprobados. Buen trabajo.", "tipo": "texto", "borrado": false, "leido_en": "2026-09-01T00:00:00Z", "creado_en": "2026-09-02T00:00:00Z", "adjunto_nombre": ""}], "perfiles": [{"usuario": "dan", "nombre": "Dan Benzaquen", "rol": "gerencia", "foto": ""}, {"usuario": "edy", "nombre": "Edy Guindi", "rol": "gerencia", "foto": ""}, {"usuario": "sherene", "nombre": "Sherene", "rol": "compras", "foto": ""}, {"usuario": "yagizel", "nombre": "Yagizel", "rol": "compras", "foto": ""}, {"usuario": "yeini", "nombre": "Yeini", "rol": "contabilidad", "foto": ""}, {"usuario": "franco", "nombre": "Franco", "rol": "diseno", "foto": ""}, {"usuario": "david", "nombre": "David", "rol": "bodega", "foto": ""}, {"usuario": "jamileth", "nombre": "Jamileth", "rol": "importacion", "foto": ""}], "inventario_valores": [{"grupo": "..Hogar", "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "cantidad": 16, "fob": 40.16, "cif": 49.0, "promedio": 42.17, "precio": 107.2, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Hogar", "cardcode": "P2102", "cardname": "BLUEPEAK KITCHEN SUPPLY", "cantidad": 2380, "fob": 5954.2, "cif": 7264.12, "promedio": 6251.91, "precio": 17682.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Hogar", "cardcode": "P2103", "cardname": "CASA NORDIA TRADING", "cantidad": 140, "fob": 826.0, "cif": 1007.72, "promedio": 867.3, "precio": 2170.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Alfombra", "cardcode": "P1501", "cardname": "TERRANOVA RUGS CO.", "cantidad": 1720, "fob": 16804.8, "cif": 20501.86, "promedio": 17645.04, "precio": 50460.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Alfombra", "cardcode": "P1502", "cardname": "SUNRAY WEAVING GROUP", "cantidad": 320, "fob": 5123.2, "cif": 6250.3, "promedio": 5379.36, "precio": 14400.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Alfombra", "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "cantidad": 60, "fob": 203.4, "cif": 248.15, "promedio": 213.57, "precio": 594.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Muebles", "cardcode": "P1801", "cardname": "ROBLEDO MUEBLES INTL", "cantidad": 648, "fob": 10857.44, "cif": 13246.08, "promedio": 11400.31, "precio": 30920.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Muebles", "cardcode": "P1802", "cardname": "GREENOAK WOODWORKS", "cantidad": 280, "fob": 2786.0, "cif": 3398.92, "promedio": 2925.3, "precio": 8736.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Ropa", "cardcode": "P1201", "cardname": "MERIDIAN APPAREL CO.", "cantidad": 84, "fob": 213.96, "cif": 261.03, "promedio": 224.66, "precio": 591.6, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Ropa", "cardcode": "P1202", "cardname": "COTTONFIELD MILLS LTD", "cantidad": 0, "fob": 0.0, "cif": 0.0, "promedio": 0.0, "precio": 0.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Ropa", "cardcode": "P1203", "cardname": "VESTIA GARMENTS LTD", "cantidad": 164, "fob": 927.6, "cif": 1131.67, "promedio": 973.98, "precio": 2951.6, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Campamento", "cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "cantidad": 988, "fob": 13278.36, "cif": 16199.6, "promedio": 13942.28, "precio": 38459.2, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Electronica", "cardcode": "P1301", "cardname": "VOLTIA ELECTRONICS", "cantidad": 388, "fob": 4775.96, "cif": 5826.67, "promedio": 5014.76, "precio": 15691.2, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Electronica", "cardcode": "P1302", "cardname": "BRIGHTLINE APPLIANCES", "cantidad": 700, "fob": 5957.0, "cif": 7267.54, "promedio": 6254.85, "precio": 17150.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Home Deco", "cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "cantidad": 1400, "fob": 9324.0, "cif": 11375.28, "promedio": 9790.2, "precio": 25480.0, "actualizado": "2026-09-02T00:00:00Z"}, {"grupo": "..Home Deco", "cardcode": "P1902", "cardname": "LUNARIA HOME ARTS", "cantidad": 864, "fob": 5745.0, "cif": 7008.9, "promedio": 6032.25, "precio": 19197.6, "actualizado": "2026-09-02T00:00:00Z"}], "ventas_departamento": [{"grupo": "..Hogar", "cantidad": 35198, "cantidad_prev": 54464, "monto": 503140.41, "monto_prev": 600337.08, "bruto": 171067.74, "bruto_prev": 155973.53, "desde": "2026-01-01", "hasta": "2026-09-02"}, {"grupo": "..Alfombra", "cantidad": 18092, "cantidad_prev": 6525, "monto": 287011.11, "monto_prev": 229292.84, "bruto": 97583.78, "bruto_prev": 88973.44, "desde": "2026-01-01", "hasta": "2026-09-02"}, {"grupo": "..Muebles", "cantidad": 17556, "cantidad_prev": 46897, "monto": 1296312.58, "monto_prev": 1481153.09, "bruto": 440746.28, "bruto_prev": 401856.9, "desde": "2026-01-01", "hasta": "2026-09-02"}, {"grupo": "..Ropa", "cantidad": 59771, "cantidad_prev": 28336, "monto": 1240416.81, "monto_prev": 994457.37, "bruto": 421741.72, "bruto_prev": 384529.21, "desde": "2026-01-01", "hasta": "2026-09-02"}, {"grupo": "..Campamento", "cantidad": 53493, "cantidad_prev": 44890, "monto": 1335210.28, "monto_prev": 1561140.06, "bruto": 453971.5, "bruto_prev": 413915.19, "desde": "2026-01-01", "hasta": "2026-09-02"}, {"grupo": "..Electronica", "cantidad": 53595, "cantidad_prev": 17447, "monto": 1158131.43, "monto_prev": 1069188.35, "bruto": 393764.69, "bruto_prev": 359020.74, "desde": "2026-01-01", "hasta": "2026-09-02"}, {"grupo": "..Home Deco", "cantidad": 25095, "cantidad_prev": 37628, "monto": 871124.27, "monto_prev": 1068349.96, "bruto": 296182.25, "bruto_prev": 270048.52, "desde": "2026-01-01", "hasta": "2026-09-02"}], "ordenes_pendientes": [{"docnum": 12510, "docentry": 12510, "linenum": 0, "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "grupo": "..Hogar", "itemcode": "HOG-2003", "descripcion": "SET DE 3 RECIPIENTES HERMÉTICOS", "cantidad": 300, "pendiente": 300, "precio": 4.44, "total_linea": 1332.0, "monto_pendiente": 1332.0, "fecha": "2026-07-26", "fecha_llegada": "2026-10-21", "eta": "2026-09-11", "referencia": "DKC-26001", "estado_compra": "pedido", "doc_total": 8928.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-31", "contenedor": "DEMO6897553", "barco": "CABO VERDE", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12510, "docentry": 12510, "linenum": 1, "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "grupo": "..Hogar", "itemcode": "HOG-2008", "descripcion": "DISPENSADOR DE CEREALES", "cantidad": 1200, "pendiente": 1200, "precio": 3.38, "total_linea": 4056.0, "monto_pendiente": 4056.0, "fecha": "2026-07-26", "fecha_llegada": "2026-09-25", "eta": "2026-09-28", "referencia": "DKC-26001", "estado_compra": "pedido", "doc_total": 8928.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-31", "contenedor": "DEMO8371855", "barco": "VIENTO NORTE", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12510, "docentry": 12510, "linenum": 2, "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "grupo": "..Hogar", "itemcode": "HOG-2004", "descripcion": "ESCURRIDOR DE PLATOS PLEGABLE", "cantidad": 600, "pendiente": 600, "precio": 5.9, "total_linea": 3540.0, "monto_pendiente": 3540.0, "fecha": "2026-07-26", "fecha_llegada": "2026-09-30", "eta": "2026-10-24", "referencia": "DKC-26001", "estado_compra": "pedido", "doc_total": 8928.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-31", "contenedor": "DEMO6183618", "barco": "PUERTO AZUL", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12516, "docentry": 12516, "linenum": 0, "cardcode": "P2103", "cardname": "CASA NORDIA TRADING", "grupo": "..Hogar", "itemcode": "HOG-2005", "descripcion": "TABLA DE PICAR BAMBÚ", "cantidad": 1200, "pendiente": 1200, "precio": 3.37, "total_linea": 4044.0, "monto_pendiente": 4044.0, "fecha": "2026-07-08", "fecha_llegada": "2026-09-20", "eta": "2026-10-22", "referencia": "DKC-26002", "estado_compra": "deposito", "doc_total": 6708.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-13", "contenedor": "DEMO2935587", "barco": "CABO VERDE", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12516, "docentry": 12516, "linenum": 1, "cardcode": "P2103", "cardname": "CASA NORDIA TRADING", "grupo": "..Hogar", "itemcode": "HOG-2003", "descripcion": "SET DE 3 RECIPIENTES HERMÉTICOS", "cantidad": 600, "pendiente": 600, "precio": 4.44, "total_linea": 2664.0, "monto_pendiente": 2664.0, "fecha": "2026-07-08", "fecha_llegada": "2026-10-07", "eta": "2026-09-15", "referencia": "DKC-26002", "estado_compra": "deposito", "doc_total": 6708.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-13", "contenedor": "DEMO5246349", "barco": "MAR SERENO", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12526, "docentry": 12526, "linenum": 0, "cardcode": "P2103", "cardname": "CASA NORDIA TRADING", "grupo": "..Hogar", "itemcode": "HOG-2001", "descripcion": "DISPENSADOR DE JABÓN ESPUMOSO", "cantidad": 300, "pendiente": 300, "precio": 1.26, "total_linea": 378.0, "monto_pendiente": 378.0, "fecha": "2026-07-07", "fecha_llegada": "2026-09-20", "eta": "2026-10-13", "referencia": "DKC-26003", "estado_compra": "artes", "doc_total": 1710.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-12", "contenedor": "DEMO3734549", "barco": "PUERTO AZUL", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12526, "docentry": 12526, "linenum": 1, "cardcode": "P2103", "cardname": "CASA NORDIA TRADING", "grupo": "..Hogar", "itemcode": "HOG-2003", "descripcion": "SET DE 3 RECIPIENTES HERMÉTICOS", "cantidad": 300, "pendiente": 300, "precio": 4.44, "total_linea": 1332.0, "monto_pendiente": 1332.0, "fecha": "2026-07-07", "fecha_llegada": "2026-10-12", "eta": "2026-09-16", "referencia": "DKC-26003", "estado_compra": "artes", "doc_total": 1710.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-12", "contenedor": "DEMO7127911", "barco": "PUERTO AZUL", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12537, "docentry": 12537, "linenum": 0, "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "grupo": "..Hogar", "itemcode": "HOG-2008", "descripcion": "DISPENSADOR DE CEREALES", "cantidad": 600, "pendiente": 600, "precio": 3.38, "total_linea": 2028.0, "monto_pendiente": 2028.0, "fecha": "2026-06-16", "fecha_llegada": "2026-10-31", "eta": "2026-11-05", "referencia": "DKC-26004", "estado_compra": "produccion", "doc_total": 9108.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-21", "contenedor": "DEMO6025311", "barco": "PUERTO AZUL", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12537, "docentry": 12537, "linenum": 1, "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "grupo": "..Hogar", "itemcode": "HOG-2004", "descripcion": "ESCURRIDOR DE PLATOS PLEGABLE", "cantidad": 1200, "pendiente": 1200, "precio": 5.9, "total_linea": 7080.0, "monto_pendiente": 7080.0, "fecha": "2026-06-16", "fecha_llegada": "2026-09-29", "eta": "2026-09-22", "referencia": "DKC-26004", "estado_compra": "produccion", "doc_total": 9108.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-21", "contenedor": "DEMO2654230", "barco": "VIENTO NORTE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12547, "docentry": 12547, "linenum": 0, "cardcode": "P2103", "cardname": "CASA NORDIA TRADING", "grupo": "..Hogar", "itemcode": "HOG-2003", "descripcion": "SET DE 3 RECIPIENTES HERMÉTICOS", "cantidad": 960, "pendiente": 960, "precio": 4.44, "total_linea": 4262.4, "monto_pendiente": 4262.4, "fecha": "2026-05-22", "fecha_llegada": "2026-09-18", "eta": "2026-11-01", "referencia": "DKC-26005", "estado_compra": "logistica", "doc_total": 10072.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-27", "contenedor": "DEMO8588708", "barco": "CABO VERDE", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12547, "docentry": 12547, "linenum": 1, "cardcode": "P2103", "cardname": "CASA NORDIA TRADING", "grupo": "..Hogar", "itemcode": "HOG-2008", "descripcion": "DISPENSADOR DE CEREALES", "cantidad": 600, "pendiente": 600, "precio": 3.38, "total_linea": 2028.0, "monto_pendiente": 2028.0, "fecha": "2026-05-22", "fecha_llegada": "2026-10-18", "eta": "2026-09-17", "referencia": "DKC-26005", "estado_compra": "logistica", "doc_total": 10072.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-27", "contenedor": "DEMO4463525", "barco": "MAR SERENO", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12547, "docentry": 12547, "linenum": 2, "cardcode": "P2103", "cardname": "CASA NORDIA TRADING", "grupo": "..Hogar", "itemcode": "HOG-2007", "descripcion": "CESTA DE ROPA PLEGABLE", "cantidad": 960, "pendiente": 960, "precio": 3.94, "total_linea": 3782.4, "monto_pendiente": 3782.4, "fecha": "2026-05-22", "fecha_llegada": "2026-10-01", "eta": "2026-09-14", "referencia": "DKC-26005", "estado_compra": "logistica", "doc_total": 10072.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-27", "contenedor": "DEMO4401335", "barco": "CABO VERDE", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12553, "docentry": 12553, "linenum": 0, "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "grupo": "..Hogar", "itemcode": "HOG-2002", "descripcion": "ORGANIZADOR DE GAVETAS 4 DIVISIONES", "cantidad": 480, "pendiente": 192, "precio": 2.19, "total_linea": 1051.2, "monto_pendiente": 420.48, "fecha": "2026-05-15", "fecha_llegada": "2026-11-06", "eta": "2026-11-03", "referencia": "DKC-26006", "estado_compra": "aduana", "doc_total": 12564.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-20", "contenedor": "DEMO9554575", "barco": "MAR SERENO", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12553, "docentry": 12553, "linenum": 1, "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "grupo": "..Hogar", "itemcode": "HOG-2008", "descripcion": "DISPENSADOR DE CEREALES", "cantidad": 960, "pendiente": 384, "precio": 3.38, "total_linea": 3244.8, "monto_pendiente": 1297.92, "fecha": "2026-05-15", "fecha_llegada": "2026-10-23", "eta": "2026-09-12", "referencia": "DKC-26006", "estado_compra": "aduana", "doc_total": 12564.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-20", "contenedor": "DEMO6951843", "barco": "VIENTO NORTE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12553, "docentry": 12553, "linenum": 2, "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "grupo": "..Hogar", "itemcode": "HOG-2007", "descripcion": "CESTA DE ROPA PLEGABLE", "cantidad": 1200, "pendiente": 480, "precio": 3.94, "total_linea": 4728.0, "monto_pendiente": 1891.2, "fecha": "2026-05-15", "fecha_llegada": "2026-09-08", "eta": "2026-10-23", "referencia": "DKC-26006", "estado_compra": "aduana", "doc_total": 12564.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-20", "contenedor": "DEMO2429934", "barco": "VIENTO NORTE", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12553, "docentry": 12553, "linenum": 3, "cardcode": "P2101", "cardname": "AURELIA HOMEWARE LTD", "grupo": "..Hogar", "itemcode": "HOG-2004", "descripcion": "ESCURRIDOR DE PLATOS PLEGABLE", "cantidad": 600, "pendiente": 240, "precio": 5.9, "total_linea": 3540.0, "monto_pendiente": 1416.0, "fecha": "2026-05-15", "fecha_llegada": "2026-10-06", "eta": "2026-09-20", "referencia": "DKC-26006", "estado_compra": "aduana", "doc_total": 12564.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-20", "contenedor": "DEMO2863812", "barco": "PUERTO AZUL", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12566, "docentry": 12566, "linenum": 0, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2010", "descripcion": "ALFOMBRA DE ENTRADA ANTIDESLIZANTE", "cantidad": 600, "pendiente": 600, "precio": 3.39, "total_linea": 2034.0, "monto_pendiente": 2034.0, "fecha": "2026-07-20", "fecha_llegada": "2026-10-11", "eta": "2026-09-24", "referencia": "DKC-26008", "estado_compra": "pedido", "doc_total": 49988.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-25", "contenedor": "DEMO1620203", "barco": "CABO VERDE", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12566, "docentry": 12566, "linenum": 1, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2013", "descripcion": "PASILLO DECORATIVO KILIM", "cantidad": 1200, "pendiente": 1200, "precio": 16.01, "total_linea": 19212.0, "monto_pendiente": 19212.0, "fecha": "2026-07-20", "fecha_llegada": "2026-09-25", "eta": "2026-11-09", "referencia": "DKC-26008", "estado_compra": "pedido", "doc_total": 49988.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-25", "contenedor": "DEMO2297700", "barco": "MAR SERENO", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12566, "docentry": 12566, "linenum": 2, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2012", "descripcion": "ALFOMBRA SHAGGY SALA", "cantidad": 960, "pendiente": 960, "precio": 29.94, "total_linea": 28742.4, "monto_pendiente": 28742.4, "fecha": "2026-07-20", "fecha_llegada": "2026-10-30", "eta": "2026-09-09", "referencia": "DKC-26008", "estado_compra": "pedido", "doc_total": 49988.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-25", "contenedor": "DEMO8289026", "barco": "CABO VERDE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12571, "docentry": 12571, "linenum": 0, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2011", "descripcion": "TAPETE DE BAÑO MEMORY FOAM", "cantidad": 1200, "pendiente": 1200, "precio": 5.01, "total_linea": 6012.0, "monto_pendiente": 6012.0, "fecha": "2026-07-01", "fecha_llegada": "2026-09-14", "eta": "2026-09-26", "referencia": "DKC-26009", "estado_compra": "deposito", "doc_total": 35616.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-06", "contenedor": "DEMO7921624", "barco": "VIENTO NORTE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12571, "docentry": 12571, "linenum": 1, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2012", "descripcion": "ALFOMBRA SHAGGY SALA", "cantidad": 600, "pendiente": 600, "precio": 29.94, "total_linea": 17964.0, "monto_pendiente": 17964.0, "fecha": "2026-07-01", "fecha_llegada": "2026-10-08", "eta": "2026-09-18", "referencia": "DKC-26009", "estado_compra": "deposito", "doc_total": 35616.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-06", "contenedor": "DEMO9562805", "barco": "PUERTO AZUL", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12571, "docentry": 12571, "linenum": 2, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2010", "descripcion": "ALFOMBRA DE ENTRADA ANTIDESLIZANTE", "cantidad": 600, "pendiente": 600, "precio": 3.39, "total_linea": 2034.0, "monto_pendiente": 2034.0, "fecha": "2026-07-01", "fecha_llegada": "2026-09-24", "eta": "2026-10-21", "referencia": "DKC-26009", "estado_compra": "deposito", "doc_total": 35616.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-06", "contenedor": "DEMO6990683", "barco": "VIENTO NORTE", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12571, "docentry": 12571, "linenum": 3, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2013", "descripcion": "PASILLO DECORATIVO KILIM", "cantidad": 600, "pendiente": 600, "precio": 16.01, "total_linea": 9606.0, "monto_pendiente": 9606.0, "fecha": "2026-07-01", "fecha_llegada": "2026-09-14", "eta": "2026-09-14", "referencia": "DKC-26009", "estado_compra": "deposito", "doc_total": 35616.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-06", "contenedor": "DEMO9271559", "barco": "CABO VERDE", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12581, "docentry": 12581, "linenum": 0, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2012", "descripcion": "ALFOMBRA SHAGGY SALA", "cantidad": 480, "pendiente": 480, "precio": 29.94, "total_linea": 14371.2, "monto_pendiente": 14371.2, "fecha": "2026-07-02", "fecha_llegada": "2026-10-24", "eta": "2026-10-19", "referencia": "DKC-26010", "estado_compra": "artes", "doc_total": 26755.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-07", "contenedor": "DEMO4084448", "barco": "PUERTO AZUL", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12581, "docentry": 12581, "linenum": 1, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2014", "descripcion": "ALFOMBRA COCINA LAVABLE", "cantidad": 1200, "pendiente": 1200, "precio": 5.31, "total_linea": 6372.0, "monto_pendiente": 6372.0, "fecha": "2026-07-02", "fecha_llegada": "2026-11-09", "eta": "2026-10-04", "referencia": "DKC-26010", "estado_compra": "artes", "doc_total": 26755.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-07", "contenedor": "DEMO6103504", "barco": "ESTRELLA DEL SUR", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12581, "docentry": 12581, "linenum": 2, "cardcode": "P1503", "cardname": "PALMERA TEXTIL EXPORT", "grupo": "..Alfombra", "itemcode": "ALF-2011", "descripcion": "TAPETE DE BAÑO MEMORY FOAM", "cantidad": 1200, "pendiente": 1200, "precio": 5.01, "total_linea": 6012.0, "monto_pendiente": 6012.0, "fecha": "2026-07-02", "fecha_llegada": "2026-09-09", "eta": "2026-09-27", "referencia": "DKC-26010", "estado_compra": "artes", "doc_total": 26755.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-07", "contenedor": "DEMO2368998", "barco": "MAR SERENO", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12588, "docentry": 12588, "linenum": 0, "cardcode": "P1501", "cardname": "TERRANOVA RUGS CO.", "grupo": "..Alfombra", "itemcode": "ALF-2010", "descripcion": "ALFOMBRA DE ENTRADA ANTIDESLIZANTE", "cantidad": 300, "pendiente": 300, "precio": 3.39, "total_linea": 1017.0, "monto_pendiente": 1017.0, "fecha": "2026-05-31", "fecha_llegada": "2026-10-15", "eta": "2026-11-10", "referencia": "DKC-26011", "estado_compra": "produccion", "doc_total": 7389.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-05", "contenedor": "DEMO1356198", "barco": "MAR SERENO", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12588, "docentry": 12588, "linenum": 1, "cardcode": "P1501", "cardname": "TERRANOVA RUGS CO.", "grupo": "..Alfombra", "itemcode": "ALF-2014", "descripcion": "ALFOMBRA COCINA LAVABLE", "cantidad": 1200, "pendiente": 1200, "precio": 5.31, "total_linea": 6372.0, "monto_pendiente": 6372.0, "fecha": "2026-05-31", "fecha_llegada": "2026-10-20", "eta": "2026-10-06", "referencia": "DKC-26011", "estado_compra": "produccion", "doc_total": 7389.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-05", "contenedor": "DEMO6734524", "barco": "VIENTO NORTE", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12597, "docentry": 12597, "linenum": 0, "cardcode": "P1502", "cardname": "SUNRAY WEAVING GROUP", "grupo": "..Alfombra", "itemcode": "ALF-2009", "descripcion": "ALFOMBRA FRUITS MULTICOLOR", "cantidad": 1200, "pendiente": 1200, "precio": 8.46, "total_linea": 10152.0, "monto_pendiente": 10152.0, "fecha": "2026-05-08", "fecha_llegada": "2026-10-04", "eta": "2026-10-25", "referencia": "DKC-26012", "estado_compra": "logistica", "doc_total": 26485.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-13", "contenedor": "DEMO6527787", "barco": "MAR SERENO", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12597, "docentry": 12597, "linenum": 1, "cardcode": "P1502", "cardname": "SUNRAY WEAVING GROUP", "grupo": "..Alfombra", "itemcode": "ALF-2013", "descripcion": "PASILLO DECORATIVO KILIM", "cantidad": 300, "pendiente": 300, "precio": 16.01, "total_linea": 4803.0, "monto_pendiente": 4803.0, "fecha": "2026-05-08", "fecha_llegada": "2026-09-25", "eta": "2026-09-25", "referencia": "DKC-26012", "estado_compra": "logistica", "doc_total": 26485.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-13", "contenedor": "DEMO8978006", "barco": "PUERTO AZUL", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12597, "docentry": 12597, "linenum": 2, "cardcode": "P1502", "cardname": "SUNRAY WEAVING GROUP", "grupo": "..Alfombra", "itemcode": "ALF-2014", "descripcion": "ALFOMBRA COCINA LAVABLE", "cantidad": 480, "pendiente": 480, "precio": 5.31, "total_linea": 2548.8, "monto_pendiente": 2548.8, "fecha": "2026-05-08", "fecha_llegada": "2026-09-09", "eta": "2026-10-24", "referencia": "DKC-26012", "estado_compra": "logistica", "doc_total": 26485.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-13", "contenedor": "DEMO7173044", "barco": "MAR SERENO", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12597, "docentry": 12597, "linenum": 3, "cardcode": "P1502", "cardname": "SUNRAY WEAVING GROUP", "grupo": "..Alfombra", "itemcode": "ALF-2012", "descripcion": "ALFOMBRA SHAGGY SALA", "cantidad": 300, "pendiente": 300, "precio": 29.94, "total_linea": 8982.0, "monto_pendiente": 8982.0, "fecha": "2026-05-08", "fecha_llegada": "2026-11-08", "eta": "2026-10-26", "referencia": "DKC-26012", "estado_compra": "logistica", "doc_total": 26485.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-05-13", "contenedor": "DEMO9359857", "barco": "VIENTO NORTE", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12602, "docentry": 12602, "linenum": 0, "cardcode": "P1801", "cardname": "ROBLEDO MUEBLES INTL", "grupo": "..Muebles", "itemcode": "MUE-2016", "descripcion": "MESA AUXILIAR REDONDA", "cantidad": 600, "pendiente": 600, "precio": 8.99, "total_linea": 5394.0, "monto_pendiente": 5394.0, "fecha": "2026-07-30", "fecha_llegada": "2026-09-18", "eta": "2026-09-09", "referencia": "DKC-26013", "estado_compra": "pedido", "doc_total": 28789.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-08-04", "contenedor": "DEMO5912307", "barco": "VIENTO NORTE", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12602, "docentry": 12602, "linenum": 1, "cardcode": "P1801", "cardname": "ROBLEDO MUEBLES INTL", "grupo": "..Muebles", "itemcode": "MUE-2015", "descripcion": "SILLA PLEGABLE DE MADERA", "cantidad": 960, "pendiente": 960, "precio": 13.58, "total_linea": 13036.8, "monto_pendiente": 13036.8, "fecha": "2026-07-30", "fecha_llegada": "2026-09-23", "eta": "2026-10-05", "referencia": "DKC-26013", "estado_compra": "pedido", "doc_total": 28789.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-08-04", "contenedor": "DEMO7263028", "barco": "MAR SERENO", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12602, "docentry": 12602, "linenum": 2, "cardcode": "P1801", "cardname": "ROBLEDO MUEBLES INTL", "grupo": "..Muebles", "itemcode": "MUE-2017", "descripcion": "ESTANTERÍA 4 NIVELES", "cantidad": 480, "pendiente": 480, "precio": 21.58, "total_linea": 10358.4, "monto_pendiente": 10358.4, "fecha": "2026-07-30", "fecha_llegada": "2026-09-16", "eta": "2026-10-10", "referencia": "DKC-26013", "estado_compra": "pedido", "doc_total": 28789.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-08-04", "contenedor": "DEMO2509141", "barco": "VIENTO NORTE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12606, "docentry": 12606, "linenum": 0, "cardcode": "P1801", "cardname": "ROBLEDO MUEBLES INTL", "grupo": "..Muebles", "itemcode": "MUE-2018", "descripcion": "BANCO DE ENTRADA CON COJÍN", "cantidad": 600, "pendiente": 600, "precio": 19.81, "total_linea": 11886.0, "monto_pendiente": 11886.0, "fecha": "2026-07-20", "fecha_llegada": "2026-10-25", "eta": "2026-10-13", "referencia": "DKC-26014", "estado_compra": "deposito", "doc_total": 18360.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-25", "contenedor": "DEMO1342238", "barco": "PUERTO AZUL", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12606, "docentry": 12606, "linenum": 1, "cardcode": "P1801", "cardname": "ROBLEDO MUEBLES INTL", "grupo": "..Muebles", "itemcode": "MUE-2017", "descripcion": "ESTANTERÍA 4 NIVELES", "cantidad": 300, "pendiente": 300, "precio": 21.58, "total_linea": 6474.0, "monto_pendiente": 6474.0, "fecha": "2026-07-20", "fecha_llegada": "2026-09-18", "eta": "2026-10-29", "referencia": "DKC-26014", "estado_compra": "deposito", "doc_total": 18360.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-25", "contenedor": "DEMO2310555", "barco": "ESTRELLA DEL SUR", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12611, "docentry": 12611, "linenum": 0, "cardcode": "P1802", "cardname": "GREENOAK WOODWORKS", "grupo": "..Muebles", "itemcode": "MUE-2017", "descripcion": "ESTANTERÍA 4 NIVELES", "cantidad": 960, "pendiente": 960, "precio": 21.58, "total_linea": 20716.8, "monto_pendiente": 20716.8, "fecha": "2026-07-02", "fecha_llegada": "2026-10-30", "eta": "2026-09-27", "referencia": "DKC-26015", "estado_compra": "artes", "doc_total": 41013.6, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-07", "contenedor": "DEMO4816323", "barco": "ESTRELLA DEL SUR", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12611, "docentry": 12611, "linenum": 1, "cardcode": "P1802", "cardname": "GREENOAK WOODWORKS", "grupo": "..Muebles", "itemcode": "MUE-2016", "descripcion": "MESA AUXILIAR REDONDA", "cantidad": 1200, "pendiente": 1200, "precio": 8.99, "total_linea": 10788.0, "monto_pendiente": 10788.0, "fecha": "2026-07-02", "fecha_llegada": "2026-10-13", "eta": "2026-09-15", "referencia": "DKC-26015", "estado_compra": "artes", "doc_total": 41013.6, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-07", "contenedor": "DEMO9161778", "barco": "CABO VERDE", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12611, "docentry": 12611, "linenum": 2, "cardcode": "P1802", "cardname": "GREENOAK WOODWORKS", "grupo": "..Muebles", "itemcode": "MUE-2018", "descripcion": "BANCO DE ENTRADA CON COJÍN", "cantidad": 480, "pendiente": 480, "precio": 19.81, "total_linea": 9508.8, "monto_pendiente": 9508.8, "fecha": "2026-07-02", "fecha_llegada": "2026-09-19", "eta": "2026-11-06", "referencia": "DKC-26015", "estado_compra": "artes", "doc_total": 41013.6, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-07", "contenedor": "DEMO9072340", "barco": "CABO VERDE", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12618, "docentry": 12618, "linenum": 0, "cardcode": "P1802", "cardname": "GREENOAK WOODWORKS", "grupo": "..Muebles", "itemcode": "MUE-2018", "descripcion": "BANCO DE ENTRADA CON COJÍN", "cantidad": 300, "pendiente": 300, "precio": 19.81, "total_linea": 5943.0, "monto_pendiente": 5943.0, "fecha": "2026-06-06", "fecha_llegada": "2026-11-11", "eta": "2026-09-10", "referencia": "DKC-26016", "estado_compra": "produccion", "doc_total": 23648.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-11", "contenedor": "DEMO1149534", "barco": "ESTRELLA DEL SUR", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12618, "docentry": 12618, "linenum": 1, "cardcode": "P1802", "cardname": "GREENOAK WOODWORKS", "grupo": "..Muebles", "itemcode": "MUE-2017", "descripcion": "ESTANTERÍA 4 NIVELES", "cantidad": 480, "pendiente": 480, "precio": 21.58, "total_linea": 10358.4, "monto_pendiente": 10358.4, "fecha": "2026-06-06", "fecha_llegada": "2026-10-02", "eta": "2026-10-21", "referencia": "DKC-26016", "estado_compra": "produccion", "doc_total": 23648.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-11", "contenedor": "DEMO4977272", "barco": "MAR SERENO", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12618, "docentry": 12618, "linenum": 2, "cardcode": "P1802", "cardname": "GREENOAK WOODWORKS", "grupo": "..Muebles", "itemcode": "MUE-2019", "descripcion": "PERCHERO DE PIE", "cantidad": 300, "pendiente": 300, "precio": 10.91, "total_linea": 3273.0, "monto_pendiente": 3273.0, "fecha": "2026-06-06", "fecha_llegada": "2026-09-11", "eta": "2026-10-17", "referencia": "DKC-26016", "estado_compra": "produccion", "doc_total": 23648.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-11", "contenedor": "DEMO8310437", "barco": "VIENTO NORTE", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12618, "docentry": 12618, "linenum": 3, "cardcode": "P1802", "cardname": "GREENOAK WOODWORKS", "grupo": "..Muebles", "itemcode": "MUE-2015", "descripcion": "SILLA PLEGABLE DE MADERA", "cantidad": 300, "pendiente": 300, "precio": 13.58, "total_linea": 4074.0, "monto_pendiente": 4074.0, "fecha": "2026-06-06", "fecha_llegada": "2026-09-29", "eta": "2026-10-13", "referencia": "DKC-26016", "estado_compra": "produccion", "doc_total": 23648.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-11", "contenedor": "DEMO9003648", "barco": "CABO VERDE", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12624, "docentry": 12624, "linenum": 0, "cardcode": "P1201", "cardname": "MERIDIAN APPAREL CO.", "grupo": "..Ropa", "itemcode": "ROP-2020", "descripcion": "CAMISETA ALGODÓN CUELLO REDONDO", "cantidad": 300, "pendiente": 300, "precio": 2.25, "total_linea": 675.0, "monto_pendiente": 675.0, "fecha": "2026-07-25", "fecha_llegada": "2026-09-08", "eta": "2026-09-07", "referencia": "DKC-26017", "estado_compra": "pedido", "doc_total": 1702.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-30", "contenedor": "DEMO2091748", "barco": "VIENTO NORTE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12624, "docentry": 12624, "linenum": 1, "cardcode": "P1201", "cardname": "MERIDIAN APPAREL CO.", "grupo": "..Ropa", "itemcode": "ROP-2025", "descripcion": "GORRA AJUSTABLE", "cantidad": 480, "pendiente": 480, "precio": 2.14, "total_linea": 1027.2, "monto_pendiente": 1027.2, "fecha": "2026-07-25", "fecha_llegada": "2026-10-18", "eta": "2026-09-12", "referencia": "DKC-26017", "estado_compra": "pedido", "doc_total": 1702.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-30", "contenedor": "DEMO7760420", "barco": "CABO VERDE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12634, "docentry": 12634, "linenum": 0, "cardcode": "P1202", "cardname": "COTTONFIELD MILLS LTD", "grupo": "..Ropa", "itemcode": "ROP-2022", "descripcion": "SUDADERA CON CAPUCHA", "cantidad": 480, "pendiente": 480, "precio": 6.24, "total_linea": 2995.2, "monto_pendiente": 2995.2, "fecha": "2026-07-13", "fecha_llegada": "2026-09-12", "eta": "2026-11-05", "referencia": "DKC-26018", "estado_compra": "deposito", "doc_total": 5596.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-18", "contenedor": "DEMO3146437", "barco": "ESTRELLA DEL SUR", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12634, "docentry": 12634, "linenum": 1, "cardcode": "P1202", "cardname": "COTTONFIELD MILLS LTD", "grupo": "..Ropa", "itemcode": "ROP-2023", "descripcion": "CALCETINES PACK 6 PARES", "cantidad": 960, "pendiente": 960, "precio": 2.71, "total_linea": 2601.6, "monto_pendiente": 2601.6, "fecha": "2026-07-13", "fecha_llegada": "2026-10-18", "eta": "2026-09-21", "referencia": "DKC-26018", "estado_compra": "deposito", "doc_total": 5596.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-18", "contenedor": "DEMO1435694", "barco": "ESTRELLA DEL SUR", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12645, "docentry": 12645, "linenum": 0, "cardcode": "P1201", "cardname": "MERIDIAN APPAREL CO.", "grupo": "..Ropa", "itemcode": "ROP-2020", "descripcion": "CAMISETA ALGODÓN CUELLO REDONDO", "cantidad": 1200, "pendiente": 1200, "precio": 2.25, "total_linea": 2700.0, "monto_pendiente": 2700.0, "fecha": "2026-06-21", "fecha_llegada": "2026-09-09", "eta": "2026-10-21", "referencia": "DKC-26019", "estado_compra": "artes", "doc_total": 3727.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-26", "contenedor": "DEMO9457707", "barco": "MAR SERENO", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12645, "docentry": 12645, "linenum": 1, "cardcode": "P1201", "cardname": "MERIDIAN APPAREL CO.", "grupo": "..Ropa", "itemcode": "ROP-2025", "descripcion": "GORRA AJUSTABLE", "cantidad": 480, "pendiente": 480, "precio": 2.14, "total_linea": 1027.2, "monto_pendiente": 1027.2, "fecha": "2026-06-21", "fecha_llegada": "2026-11-10", "eta": "2026-11-07", "referencia": "DKC-26019", "estado_compra": "artes", "doc_total": 3727.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-26", "contenedor": "DEMO3485581", "barco": "MAR SERENO", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12648, "docentry": 12648, "linenum": 0, "cardcode": "P1203", "cardname": "VESTIA GARMENTS LTD", "grupo": "..Ropa", "itemcode": "ROP-2024", "descripcion": "PIJAMA DOS PIEZAS", "cantidad": 960, "pendiente": 960, "precio": 6.34, "total_linea": 6086.4, "monto_pendiente": 6086.4, "fecha": "2026-06-14", "fecha_llegada": "2026-09-10", "eta": "2026-09-08", "referencia": "DKC-26020", "estado_compra": "produccion", "doc_total": 8942.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-19", "contenedor": "DEMO4300403", "barco": "PUERTO AZUL", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12648, "docentry": 12648, "linenum": 1, "cardcode": "P1203", "cardname": "VESTIA GARMENTS LTD", "grupo": "..Ropa", "itemcode": "ROP-2021", "descripcion": "PANTALÓN DEPORTIVO UNISEX", "cantidad": 600, "pendiente": 600, "precio": 4.76, "total_linea": 2856.0, "monto_pendiente": 2856.0, "fecha": "2026-06-14", "fecha_llegada": "2026-09-16", "eta": "2026-11-09", "referencia": "DKC-26020", "estado_compra": "produccion", "doc_total": 8942.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-19", "contenedor": "DEMO4000626", "barco": "PUERTO AZUL", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12655, "docentry": 12655, "linenum": 0, "cardcode": "P1201", "cardname": "MERIDIAN APPAREL CO.", "grupo": "..Ropa", "itemcode": "ROP-2022", "descripcion": "SUDADERA CON CAPUCHA", "cantidad": 600, "pendiente": 600, "precio": 6.24, "total_linea": 3744.0, "monto_pendiente": 3744.0, "fecha": "2026-06-01", "fecha_llegada": "2026-10-03", "eta": "2026-11-02", "referencia": "DKC-26021", "estado_compra": "logistica", "doc_total": 5044.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-06", "contenedor": "DEMO7991379", "barco": "PUERTO AZUL", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12655, "docentry": 12655, "linenum": 1, "cardcode": "P1201", "cardname": "MERIDIAN APPAREL CO.", "grupo": "..Ropa", "itemcode": "ROP-2023", "descripcion": "CALCETINES PACK 6 PARES", "cantidad": 480, "pendiente": 480, "precio": 2.71, "total_linea": 1300.8, "monto_pendiente": 1300.8, "fecha": "2026-06-01", "fecha_llegada": "2026-10-16", "eta": "2026-09-09", "referencia": "DKC-26021", "estado_compra": "logistica", "doc_total": 5044.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-06", "contenedor": "DEMO2595221", "barco": "PUERTO AZUL", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12665, "docentry": 12665, "linenum": 0, "cardcode": "P1202", "cardname": "COTTONFIELD MILLS LTD", "grupo": "..Ropa", "itemcode": "ROP-2024", "descripcion": "PIJAMA DOS PIEZAS", "cantidad": 960, "pendiente": 384, "precio": 6.34, "total_linea": 6086.4, "monto_pendiente": 2434.56, "fecha": "2026-04-22", "fecha_llegada": "2026-09-17", "eta": "2026-09-22", "referencia": "DKC-26022", "estado_compra": "aduana", "doc_total": 12496.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-04-27", "contenedor": "DEMO2915239", "barco": "MAR SERENO", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12665, "docentry": 12665, "linenum": 1, "cardcode": "P1202", "cardname": "COTTONFIELD MILLS LTD", "grupo": "..Ropa", "itemcode": "ROP-2021", "descripcion": "PANTALÓN DEPORTIVO UNISEX", "cantidad": 960, "pendiente": 384, "precio": 4.76, "total_linea": 4569.6, "monto_pendiente": 1827.84, "fecha": "2026-04-22", "fecha_llegada": "2026-10-05", "eta": "2026-11-02", "referencia": "DKC-26022", "estado_compra": "aduana", "doc_total": 12496.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-04-27", "contenedor": "DEMO9899773", "barco": "VIENTO NORTE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12665, "docentry": 12665, "linenum": 2, "cardcode": "P1202", "cardname": "COTTONFIELD MILLS LTD", "grupo": "..Ropa", "itemcode": "ROP-2023", "descripcion": "CALCETINES PACK 6 PARES", "cantidad": 300, "pendiente": 120, "precio": 2.71, "total_linea": 813.0, "monto_pendiente": 325.2, "fecha": "2026-04-22", "fecha_llegada": "2026-10-22", "eta": "2026-09-21", "referencia": "DKC-26022", "estado_compra": "aduana", "doc_total": 12496.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-04-27", "contenedor": "DEMO3241436", "barco": "VIENTO NORTE", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12665, "docentry": 12665, "linenum": 3, "cardcode": "P1202", "cardname": "COTTONFIELD MILLS LTD", "grupo": "..Ropa", "itemcode": "ROP-2025", "descripcion": "GORRA AJUSTABLE", "cantidad": 480, "pendiente": 192, "precio": 2.14, "total_linea": 1027.2, "monto_pendiente": 410.88, "fecha": "2026-04-22", "fecha_llegada": "2026-09-25", "eta": "2026-10-24", "referencia": "DKC-26022", "estado_compra": "aduana", "doc_total": 12496.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-04-27", "contenedor": "DEMO7416919", "barco": "ESTRELLA DEL SUR", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12668, "docentry": 12668, "linenum": 0, "cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "grupo": "..Campamento", "itemcode": "CAM-2027", "descripcion": "SILLA PLEGABLE CAMPING", "cantidad": 600, "pendiente": 600, "precio": 7.62, "total_linea": 4572.0, "monto_pendiente": 4572.0, "fecha": "2026-07-25", "fecha_llegada": "2026-09-07", "eta": "2026-10-13", "referencia": "DKC-26023", "estado_compra": "pedido", "doc_total": 27615.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-30", "contenedor": "DEMO3578982", "barco": "VIENTO NORTE", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12668, "docentry": 12668, "linenum": 1, "cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "grupo": "..Campamento", "itemcode": "CAM-2028", "descripcion": "NEVERA PORTÁTIL 24L", "cantidad": 960, "pendiente": 960, "precio": 11.2, "total_linea": 10752.0, "monto_pendiente": 10752.0, "fecha": "2026-07-25", "fecha_llegada": "2026-11-03", "eta": "2026-09-30", "referencia": "DKC-26023", "estado_compra": "pedido", "doc_total": 27615.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-30", "contenedor": "DEMO9748138", "barco": "MAR SERENO", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12668, "docentry": 12668, "linenum": 2, "cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "grupo": "..Campamento", "itemcode": "CAM-2026", "descripcion": "TIENDA DE CAMPAÑA 4 PERSONAS", "cantidad": 300, "pendiente": 300, "precio": 32.01, "total_linea": 9603.0, "monto_pendiente": 9603.0, "fecha": "2026-07-25", "fecha_llegada": "2026-11-09", "eta": "2026-09-16", "referencia": "DKC-26023", "estado_compra": "pedido", "doc_total": 27615.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-30", "contenedor": "DEMO4971495", "barco": "ESTRELLA DEL SUR", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12668, "docentry": 12668, "linenum": 3, "cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "grupo": "..Campamento", "itemcode": "CAM-2029", "descripcion": "LINTERNA RECARGABLE LED", "cantidad": 600, "pendiente": 600, "precio": 4.48, "total_linea": 2688.0, "monto_pendiente": 2688.0, "fecha": "2026-07-25", "fecha_llegada": "2026-10-15", "eta": "2026-10-13", "referencia": "DKC-26023", "estado_compra": "pedido", "doc_total": 27615.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-30", "contenedor": "DEMO2302261", "barco": "MAR SERENO", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12679, "docentry": 12679, "linenum": 0, "cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "grupo": "..Campamento", "itemcode": "CAM-2029", "descripcion": "LINTERNA RECARGABLE LED", "cantidad": 480, "pendiente": 480, "precio": 4.48, "total_linea": 2150.4, "monto_pendiente": 2150.4, "fecha": "2026-07-03", "fecha_llegada": "2026-11-11", "eta": "2026-11-11", "referencia": "DKC-26024", "estado_compra": "deposito", "doc_total": 15590.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-08", "contenedor": "DEMO4807126", "barco": "CABO VERDE", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12679, "docentry": 12679, "linenum": 1, "cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "grupo": "..Campamento", "itemcode": "CAM-2028", "descripcion": "NEVERA PORTÁTIL 24L", "cantidad": 1200, "pendiente": 1200, "precio": 11.2, "total_linea": 13440.0, "monto_pendiente": 13440.0, "fecha": "2026-07-03", "fecha_llegada": "2026-10-19", "eta": "2026-09-26", "referencia": "DKC-26024", "estado_compra": "deposito", "doc_total": 15590.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-08", "contenedor": "DEMO2312662", "barco": "CABO VERDE", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12688, "docentry": 12688, "linenum": 0, "cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "grupo": "..Campamento", "itemcode": "CAM-2028", "descripcion": "NEVERA PORTÁTIL 24L", "cantidad": 960, "pendiente": 960, "precio": 11.2, "total_linea": 10752.0, "monto_pendiente": 10752.0, "fecha": "2026-06-27", "fecha_llegada": "2026-09-07", "eta": "2026-11-02", "referencia": "DKC-26025", "estado_compra": "artes", "doc_total": 15667.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-02", "contenedor": "DEMO1987150", "barco": "ESTRELLA DEL SUR", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12688, "docentry": 12688, "linenum": 1, "cardcode": "P1701", "cardname": "TRAILMARK OUTDOOR GEAR", "grupo": "..Campamento", "itemcode": "CAM-2030", "descripcion": "SACO DE DORMIR 3 ESTACIONES", "cantidad": 480, "pendiente": 480, "precio": 10.24, "total_linea": 4915.2, "monto_pendiente": 4915.2, "fecha": "2026-06-27", "fecha_llegada": "2026-09-22", "eta": "2026-09-28", "referencia": "DKC-26025", "estado_compra": "artes", "doc_total": 15667.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-02", "contenedor": "DEMO8480144", "barco": "VIENTO NORTE", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12695, "docentry": 12695, "linenum": 0, "cardcode": "P1302", "cardname": "BRIGHTLINE APPLIANCES", "grupo": "..Electronica", "itemcode": "ELE-2032", "descripcion": "LICUADORA PERSONAL 600W", "cantidad": 300, "pendiente": 300, "precio": 9.92, "total_linea": 2976.0, "monto_pendiente": 2976.0, "fecha": "2026-07-28", "fecha_llegada": "2026-11-10", "eta": "2026-10-10", "referencia": "DKC-26026", "estado_compra": "pedido", "doc_total": 17040.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-08-02", "contenedor": "DEMO6825939", "barco": "MAR SERENO", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12695, "docentry": 12695, "linenum": 1, "cardcode": "P1302", "cardname": "BRIGHTLINE APPLIANCES", "grupo": "..Electronica", "itemcode": "ELE-2031", "descripcion": "VENTILADOR DE TORRE 3 VELOCIDADES", "cantidad": 960, "pendiente": 960, "precio": 14.65, "total_linea": 14064.0, "monto_pendiente": 14064.0, "fecha": "2026-07-28", "fecha_llegada": "2026-10-16", "eta": "2026-10-12", "referencia": "DKC-26026", "estado_compra": "pedido", "doc_total": 17040.0, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-08-02", "contenedor": "DEMO9056295", "barco": "ESTRELLA DEL SUR", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12700, "docentry": 12700, "linenum": 0, "cardcode": "P1301", "cardname": "VOLTIA ELECTRONICS", "grupo": "..Electronica", "itemcode": "ELE-2032", "descripcion": "LICUADORA PERSONAL 600W", "cantidad": 960, "pendiente": 960, "precio": 9.92, "total_linea": 9523.2, "monto_pendiente": 9523.2, "fecha": "2026-07-02", "fecha_llegada": "2026-09-16", "eta": "2026-11-11", "referencia": "DKC-26027", "estado_compra": "deposito", "doc_total": 23839.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-07", "contenedor": "DEMO6006166", "barco": "CABO VERDE", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12700, "docentry": 12700, "linenum": 1, "cardcode": "P1301", "cardname": "VOLTIA ELECTRONICS", "grupo": "..Electronica", "itemcode": "ELE-2034", "descripcion": "CAFETERA DE GOTEO 12 TAZAS", "cantidad": 1200, "pendiente": 1200, "precio": 11.93, "total_linea": 14316.0, "monto_pendiente": 14316.0, "fecha": "2026-07-02", "fecha_llegada": "2026-09-18", "eta": "2026-10-03", "referencia": "DKC-26027", "estado_compra": "deposito", "doc_total": 23839.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-07", "contenedor": "DEMO9140254", "barco": "PUERTO AZUL", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12706, "docentry": 12706, "linenum": 0, "cardcode": "P1302", "cardname": "BRIGHTLINE APPLIANCES", "grupo": "..Electronica", "itemcode": "ELE-2031", "descripcion": "VENTILADOR DE TORRE 3 VELOCIDADES", "cantidad": 960, "pendiente": 960, "precio": 14.65, "total_linea": 14064.0, "monto_pendiente": 14064.0, "fecha": "2026-06-24", "fecha_llegada": "2026-11-11", "eta": "2026-10-17", "referencia": "DKC-26028", "estado_compra": "artes", "doc_total": 25742.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-29", "contenedor": "DEMO2420210", "barco": "ESTRELLA DEL SUR", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12706, "docentry": 12706, "linenum": 1, "cardcode": "P1302", "cardname": "BRIGHTLINE APPLIANCES", "grupo": "..Electronica", "itemcode": "ELE-2034", "descripcion": "CAFETERA DE GOTEO 12 TAZAS", "cantidad": 480, "pendiente": 480, "precio": 11.93, "total_linea": 5726.4, "monto_pendiente": 5726.4, "fecha": "2026-06-24", "fecha_llegada": "2026-09-10", "eta": "2026-10-04", "referencia": "DKC-26028", "estado_compra": "artes", "doc_total": 25742.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-29", "contenedor": "DEMO2180627", "barco": "VIENTO NORTE", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12706, "docentry": 12706, "linenum": 2, "cardcode": "P1302", "cardname": "BRIGHTLINE APPLIANCES", "grupo": "..Electronica", "itemcode": "ELE-2032", "descripcion": "LICUADORA PERSONAL 600W", "cantidad": 600, "pendiente": 600, "precio": 9.92, "total_linea": 5952.0, "monto_pendiente": 5952.0, "fecha": "2026-06-24", "fecha_llegada": "2026-09-23", "eta": "2026-10-04", "referencia": "DKC-26028", "estado_compra": "artes", "doc_total": 25742.4, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-29", "contenedor": "DEMO5598770", "barco": "PUERTO AZUL", "pais": "Vietnam", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12709, "docentry": 12709, "linenum": 0, "cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "grupo": "..Home Deco", "itemcode": "HOM-2038", "descripcion": "SET 3 CUADROS BOTÁNICOS", "cantidad": 480, "pendiente": 480, "precio": 10.12, "total_linea": 4857.6, "monto_pendiente": 4857.6, "fecha": "2026-08-11", "fecha_llegada": "2026-10-23", "eta": "2026-10-31", "referencia": "DKC-26029", "estado_compra": "pedido", "doc_total": 14871.6, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-08-16", "contenedor": "DEMO2733138", "barco": "VIENTO NORTE", "pais": "Indonesia", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12709, "docentry": 12709, "linenum": 1, "cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "grupo": "..Home Deco", "itemcode": "HOM-2037", "descripcion": "JARRÓN CERÁMICA ESMALTADA", "cantidad": 600, "pendiente": 600, "precio": 5.87, "total_linea": 3522.0, "monto_pendiente": 3522.0, "fecha": "2026-08-11", "fecha_llegada": "2026-09-16", "eta": "2026-09-28", "referencia": "DKC-26029", "estado_compra": "pedido", "doc_total": 14871.6, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-08-16", "contenedor": "DEMO2024254", "barco": "MAR SERENO", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12709, "docentry": 12709, "linenum": 2, "cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "grupo": "..Home Deco", "itemcode": "HOM-2036", "descripcion": "ESPEJO DECORATIVO REDONDO", "cantidad": 600, "pendiente": 600, "precio": 10.82, "total_linea": 6492.0, "monto_pendiente": 6492.0, "fecha": "2026-08-11", "fecha_llegada": "2026-09-30", "eta": "2026-10-22", "referencia": "DKC-26029", "estado_compra": "pedido", "doc_total": 14871.6, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-08-16", "contenedor": "DEMO3623183", "barco": "VIENTO NORTE", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12715, "docentry": 12715, "linenum": 0, "cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "grupo": "..Home Deco", "itemcode": "HOM-2039", "descripcion": "RELOJ DE PARED MINIMALISTA", "cantidad": 1200, "pendiente": 1200, "precio": 5.05, "total_linea": 6060.0, "monto_pendiente": 6060.0, "fecha": "2026-07-14", "fecha_llegada": "2026-10-30", "eta": "2026-10-06", "referencia": "DKC-26030", "estado_compra": "deposito", "doc_total": 10917.6, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-19", "contenedor": "DEMO3545292", "barco": "CABO VERDE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12715, "docentry": 12715, "linenum": 1, "cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "grupo": "..Home Deco", "itemcode": "HOM-2038", "descripcion": "SET 3 CUADROS BOTÁNICOS", "cantidad": 480, "pendiente": 480, "precio": 10.12, "total_linea": 4857.6, "monto_pendiente": 4857.6, "fecha": "2026-07-14", "fecha_llegada": "2026-11-11", "eta": "2026-10-06", "referencia": "DKC-26030", "estado_compra": "deposito", "doc_total": 10917.6, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-19", "contenedor": "DEMO5442628", "barco": "MAR SERENO", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12719, "docentry": 12719, "linenum": 0, "cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "grupo": "..Home Deco", "itemcode": "HOM-2038", "descripcion": "SET 3 CUADROS BOTÁNICOS", "cantidad": 960, "pendiente": 960, "precio": 10.12, "total_linea": 9715.2, "monto_pendiente": 9715.2, "fecha": "2026-06-27", "fecha_llegada": "2026-10-16", "eta": "2026-10-06", "referencia": "DKC-26031", "estado_compra": "artes", "doc_total": 18430.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-02", "contenedor": "DEMO2786335", "barco": "VIENTO NORTE", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12719, "docentry": 12719, "linenum": 1, "cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "grupo": "..Home Deco", "itemcode": "HOM-2037", "descripcion": "JARRÓN CERÁMICA ESMALTADA", "cantidad": 600, "pendiente": 600, "precio": 5.87, "total_linea": 3522.0, "monto_pendiente": 3522.0, "fecha": "2026-06-27", "fecha_llegada": "2026-11-03", "eta": "2026-09-20", "referencia": "DKC-26031", "estado_compra": "artes", "doc_total": 18430.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-02", "contenedor": "DEMO2509129", "barco": "ESTRELLA DEL SUR", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12719, "docentry": 12719, "linenum": 2, "cardcode": "P1901", "cardname": "ATELIER DECO HOUSE", "grupo": "..Home Deco", "itemcode": "HOM-2036", "descripcion": "ESPEJO DECORATIVO REDONDO", "cantidad": 480, "pendiente": 480, "precio": 10.82, "total_linea": 5193.6, "monto_pendiente": 5193.6, "fecha": "2026-06-27", "fecha_llegada": "2026-10-07", "eta": "2026-09-28", "referencia": "DKC-26031", "estado_compra": "artes", "doc_total": 18430.8, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-07-02", "contenedor": "DEMO9375889", "barco": "PUERTO AZUL", "pais": "Egipto", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12727, "docentry": 12727, "linenum": 0, "cardcode": "P1902", "cardname": "LUNARIA HOME ARTS", "grupo": "..Home Deco", "itemcode": "HOM-2038", "descripcion": "SET 3 CUADROS BOTÁNICOS", "cantidad": 600, "pendiente": 600, "precio": 10.12, "total_linea": 6072.0, "monto_pendiente": 6072.0, "fecha": "2026-06-13", "fecha_llegada": "2026-11-01", "eta": "2026-10-25", "referencia": "DKC-26032", "estado_compra": "produccion", "doc_total": 15043.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-18", "contenedor": "DEMO2210081", "barco": "MAR SERENO", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12727, "docentry": 12727, "linenum": 1, "cardcode": "P1902", "cardname": "LUNARIA HOME ARTS", "grupo": "..Home Deco", "itemcode": "HOM-2035", "descripcion": "MARCO DE FOTOS 20X25", "cantidad": 300, "pendiente": 300, "precio": 3.2, "total_linea": 960.0, "monto_pendiente": 960.0, "fecha": "2026-06-13", "fecha_llegada": "2026-10-26", "eta": "2026-10-09", "referencia": "DKC-26032", "estado_compra": "produccion", "doc_total": 15043.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-18", "contenedor": "DEMO8962600", "barco": "ESTRELLA DEL SUR", "pais": "Bangladesh", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12727, "docentry": 12727, "linenum": 2, "cardcode": "P1902", "cardname": "LUNARIA HOME ARTS", "grupo": "..Home Deco", "itemcode": "HOM-2037", "descripcion": "JARRÓN CERÁMICA ESMALTADA", "cantidad": 480, "pendiente": 480, "precio": 5.87, "total_linea": 2817.6, "monto_pendiente": 2817.6, "fecha": "2026-06-13", "fecha_llegada": "2026-09-30", "eta": "2026-10-03", "referencia": "DKC-26032", "estado_compra": "produccion", "doc_total": 15043.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-18", "contenedor": "DEMO4661165", "barco": "ESTRELLA DEL SUR", "pais": "China", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}, {"docnum": 12727, "docentry": 12727, "linenum": 3, "cardcode": "P1902", "cardname": "LUNARIA HOME ARTS", "grupo": "..Home Deco", "itemcode": "HOM-2036", "descripcion": "ESPEJO DECORATIVO REDONDO", "cantidad": 480, "pendiente": 480, "precio": 10.82, "total_linea": 5193.6, "monto_pendiente": 5193.6, "fecha": "2026-06-13", "fecha_llegada": "2026-11-10", "eta": "2026-10-09", "referencia": "DKC-26032", "estado_compra": "produccion", "doc_total": 15043.2, "terminos": "30% ANTICIPO", "abono_pct": 30, "fecha_abono": "2026-06-18", "contenedor": "DEMO5363443", "barco": "VIENTO NORTE", "pais": "India", "comentarios": "", "actualizado": "2026-09-02T00:00:00Z"}], "margen_items": [{"itemcode": "HOG-2001", "margen": 0.3444, "precio_prom": 3.9}, {"itemcode": "HOG-2002", "margen": 0.4731, "precio_prom": 6.5}, {"itemcode": "HOG-2003", "margen": 0.5608, "precio_prom": 12.9}, {"itemcode": "HOG-2004", "margen": 0.3916, "precio_prom": 15.5}, {"itemcode": "HOG-2005", "margen": 0.3412, "precio_prom": 8.9}, {"itemcode": "HOG-2006", "margen": 0.5236, "precio_prom": 4.5}, {"itemcode": "HOG-2007", "margen": 0.4064, "precio_prom": 11.9}, {"itemcode": "HOG-2008", "margen": 0.4899, "precio_prom": 9.9}, {"itemcode": "ALF-2009", "margen": 0.4534, "precio_prom": 24.9}, {"itemcode": "ALF-2010", "margen": 0.6064, "precio_prom": 9.9}, {"itemcode": "ALF-2011", "margen": 0.5723, "precio_prom": 14.5}, {"itemcode": "ALF-2012", "margen": 0.4843, "precio_prom": 89.0}, {"itemcode": "ALF-2013", "margen": 0.5819, "precio_prom": 45.0}, {"itemcode": "ALF-2014", "margen": 0.572, "precio_prom": 16.9}, {"itemcode": "MUE-2015", "margen": 0.4325, "precio_prom": 39.9}, {"itemcode": "MUE-2016", "margen": 0.2945, "precio_prom": 29.9}, {"itemcode": "MUE-2017", "margen": 0.566, "precio_prom": 69.0}, {"itemcode": "MUE-2018", "margen": 0.5105, "precio_prom": 55.0}, {"itemcode": "MUE-2019", "margen": 0.5792, "precio_prom": 32.5}, {"itemcode": "ROP-2020", "margen": 0.6061, "precio_prom": 6.9}, {"itemcode": "ROP-2021", "margen": 0.6038, "precio_prom": 14.9}, {"itemcode": "ROP-2022", "margen": 0.5076, "precio_prom": 19.9}, {"itemcode": "ROP-2023", "margen": 0.3183, "precio_prom": 7.5}, {"itemcode": "ROP-2024", "margen": 0.3829, "precio_prom": 16.9}, {"itemcode": "ROP-2025", "margen": 0.583, "precio_prom": 5.9}, {"itemcode": "CAM-2026", "margen": 0.3498, "precio_prom": 89.0}, {"itemcode": "CAM-2027", "margen": 0.6045, "precio_prom": 22.9}, {"itemcode": "CAM-2028", "margen": 0.5825, "precio_prom": 34.9}, {"itemcode": "CAM-2029", "margen": 0.3081, "precio_prom": 12.5}, {"itemcode": "CAM-2030", "margen": 0.5176, "precio_prom": 29.9}, {"itemcode": "ELE-2031", "margen": 0.3978, "precio_prom": 45.0}, {"itemcode": "ELE-2032", "margen": 0.4411, "precio_prom": 27.9}, {"itemcode": "ELE-2033", "margen": 0.3682, "precio_prom": 24.5}, {"itemcode": "ELE-2034", "margen": 0.3371, "precio_prom": 39.9}, {"itemcode": "HOM-2035", "margen": 0.2868, "precio_prom": 8.9}, {"itemcode": "HOM-2036", "margen": 0.3647, "precio_prom": 34.9}, {"itemcode": "HOM-2037", "margen": 0.5571, "precio_prom": 19.9}, {"itemcode": "HOM-2038", "margen": 0.5963, "precio_prom": 27.5}, {"itemcode": "HOM-2039", "margen": 0.3899, "precio_prom": 15.9}], "libro_mayor": [{"clave": "700001-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-16", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700001", "trans_id": 700001, "detalle": "COMISION BANCARIA", "ref1": "PS 38218", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 20469.41, "monto": -20469.41}, {"clave": "700002-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-18", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700002", "trans_id": 700002, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38494", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 14837.42, "monto": -14837.42}, {"clave": "700003-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-05", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700003", "trans_id": 700003, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38756", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 8998.41, "haber": 0, "monto": 8998.41}, {"clave": "700004-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-09", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700004", "trans_id": 700004, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38526", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 35930.99, "monto": -35930.99}, {"clave": "700005-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-17", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700005", "trans_id": 700005, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38964", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 5435.18, "haber": 0, "monto": 5435.18}, {"clave": "700006-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-26", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700006", "trans_id": 700006, "detalle": "COMISION BANCARIA", "ref1": "PS 38685", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 20338.59, "haber": 0, "monto": 20338.59}, {"clave": "700007-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-13", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700007", "trans_id": 700007, "detalle": "COMISION BANCARIA", "ref1": "PS 38510", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 8383.52, "monto": -8383.52}, {"clave": "700008-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-19", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700008", "trans_id": 700008, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38942", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 14382.16, "haber": 0, "monto": 14382.16}, {"clave": "700009-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-11", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700009", "trans_id": 700009, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38555", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 38413.52, "haber": 0, "monto": 38413.52}, {"clave": "700010-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-07-11", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700010", "trans_id": 700010, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38428", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 11052.71, "haber": 0, "monto": 11052.71}, {"clave": "700011-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-21", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700011", "trans_id": 700011, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38482", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 21149.17, "monto": -21149.17}, {"clave": "700012-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-14", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700012", "trans_id": 700012, "detalle": "PAGO A PRESTAMO", "ref1": "PS 38761", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 18282.61, "haber": 0, "monto": 18282.61}, {"clave": "700013-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-22", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700013", "trans_id": 700013, "detalle": "ND ACH KENNEDY", "ref1": "PS 38127", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 30999.97, "haber": 0, "monto": 30999.97}, {"clave": "700014-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-03", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700014", "trans_id": 700014, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38620", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 11422.01, "haber": 0, "monto": 11422.01}, {"clave": "700015-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-15", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700015", "trans_id": 700015, "detalle": "COMISION BANCARIA", "ref1": "PS 38496", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 33076.46, "monto": -33076.46}, {"clave": "700016-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-14", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700016", "trans_id": 700016, "detalle": "PAGO A PRESTAMO", "ref1": "PS 38509", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 28472.34, "monto": -28472.34}, {"clave": "700017-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-05", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700017", "trans_id": 700017, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38682", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 10568.09, "monto": -10568.09}, {"clave": "700018-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-21", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700018", "trans_id": 700018, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38633", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 40715.48, "haber": 0, "monto": 40715.48}, {"clave": "700019-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-23", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700019", "trans_id": 700019, "detalle": "ND ACH KENNEDY", "ref1": "PS 38002", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 8462.22, "haber": 0, "monto": 8462.22}, {"clave": "700020-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-10", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700020", "trans_id": 700020, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38463", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 37770.18, "haber": 0, "monto": 37770.18}, {"clave": "700021-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-23", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700021", "trans_id": 700021, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38207", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 23076.81, "haber": 0, "monto": 23076.81}, {"clave": "700022-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-14", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700022", "trans_id": 700022, "detalle": "ND ACH KENNEDY", "ref1": "PS 38799", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 27727.22, "monto": -27727.22}, {"clave": "700023-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-16", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700023", "trans_id": 700023, "detalle": "PAGO A PRESTAMO", "ref1": "PS 38218", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 18422.89, "monto": -18422.89}, {"clave": "700024-1", "cuenta": "1002-002", "cuenta_nombre": "BANCO PRIMERO (demo)", "fecha": "2026-08-20", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700024", "trans_id": 700024, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38589", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 7481.17, "monto": -7481.17}, {"clave": "700025-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-07-07", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700025", "trans_id": 700025, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38571", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 16599.6, "monto": -16599.6}, {"clave": "700026-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-07-04", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700026", "trans_id": 700026, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38802", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 33087.23, "monto": -33087.23}, {"clave": "700027-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-07-28", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700027", "trans_id": 700027, "detalle": "ND ACH KENNEDY", "ref1": "PS 38783", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 10444.99, "haber": 0, "monto": 10444.99}, {"clave": "700028-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-07-22", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700028", "trans_id": 700028, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38962", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 18979.23, "haber": 0, "monto": 18979.23}, {"clave": "700029-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-07-17", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700029", "trans_id": 700029, "detalle": "COMISION BANCARIA", "ref1": "PS 38991", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 24757.08, "monto": -24757.08}, {"clave": "700030-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-07-15", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700030", "trans_id": 700030, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38900", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 20806.6, "haber": 0, "monto": 20806.6}, {"clave": "700031-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-07-18", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700031", "trans_id": 700031, "detalle": "PAGO A PRESTAMO", "ref1": "PS 38479", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 13122.32, "monto": -13122.32}, {"clave": "700032-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-07-12", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700032", "trans_id": 700032, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38760", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 19435.57, "haber": 0, "monto": 19435.57}, {"clave": "700033-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-07-16", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700033", "trans_id": 700033, "detalle": "ND ACH KENNEDY", "ref1": "PS 38777", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 38326.88, "haber": 0, "monto": 38326.88}, {"clave": "700034-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-09", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700034", "trans_id": 700034, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38292", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 1752.37, "haber": 0, "monto": 1752.37}, {"clave": "700035-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-24", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700035", "trans_id": 700035, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38996", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 9110.29, "monto": -9110.29}, {"clave": "700036-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-03", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700036", "trans_id": 700036, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38464", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 3576.23, "haber": 0, "monto": 3576.23}, {"clave": "700037-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-11", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700037", "trans_id": 700037, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38292", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 507.85, "monto": -507.85}, {"clave": "700038-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-19", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700038", "trans_id": 700038, "detalle": "ND ACH KENNEDY", "ref1": "PS 38507", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 5053.02, "haber": 0, "monto": 5053.02}, {"clave": "700039-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-12", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700039", "trans_id": 700039, "detalle": "PAGO A PRESTAMO", "ref1": "PS 38443", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 10391.41, "monto": -10391.41}, {"clave": "700040-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-20", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700040", "trans_id": 700040, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38235", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 11754.34, "monto": -11754.34}, {"clave": "700041-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-14", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700041", "trans_id": 700041, "detalle": "COMISION BANCARIA", "ref1": "PS 38202", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 22227.7, "haber": 0, "monto": 22227.7}, {"clave": "700042-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-23", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700042", "trans_id": 700042, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38123", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 10281.16, "monto": -10281.16}, {"clave": "700043-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-04", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700043", "trans_id": 700043, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38464", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 37068.88, "haber": 0, "monto": 37068.88}, {"clave": "700044-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-23", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700044", "trans_id": 700044, "detalle": "ND ACH KENNEDY", "ref1": "PS 38428", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 28477.09, "monto": -28477.09}, {"clave": "700045-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-03", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700045", "trans_id": 700045, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38861", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 29868.07, "haber": 0, "monto": 29868.07}, {"clave": "700046-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-15", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700046", "trans_id": 700046, "detalle": "ND ACH KENNEDY", "ref1": "PS 38516", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 44760.3, "haber": 0, "monto": 44760.3}, {"clave": "700047-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-06", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700047", "trans_id": 700047, "detalle": "COMISION BANCARIA", "ref1": "PS 38920", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 11529.81, "haber": 0, "monto": 11529.81}, {"clave": "700048-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-17", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700048", "trans_id": 700048, "detalle": "PAGO A PRESTAMO", "ref1": "PS 38165", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 6905.79, "haber": 0, "monto": 6905.79}, {"clave": "700049-1", "cuenta": "1002-019", "cuenta_nombre": "BANCO SEGUNDO (demo)", "fecha": "2026-08-27", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700049", "trans_id": 700049, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38927", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 6106.76, "monto": -6106.76}, {"clave": "700050-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-17", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700050", "trans_id": 700050, "detalle": "ND ACH KENNEDY", "ref1": "PS 38629", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 11633.22, "monto": -11633.22}, {"clave": "700051-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-07", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700051", "trans_id": 700051, "detalle": "COMISION BANCARIA", "ref1": "PS 38016", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 12537.0, "haber": 0, "monto": 12537.0}, {"clave": "700052-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-23", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700052", "trans_id": 700052, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38414", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 216.53, "monto": -216.53}, {"clave": "700053-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-09", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700053", "trans_id": 700053, "detalle": "PAGO A PRESTAMO", "ref1": "PS 38439", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 21982.26, "monto": -21982.26}, {"clave": "700054-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-04", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700054", "trans_id": 700054, "detalle": "ND ACH KENNEDY", "ref1": "PS 38154", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 1818.7, "haber": 0, "monto": 1818.7}, {"clave": "700055-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-11", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700055", "trans_id": 700055, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38919", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 33119.94, "monto": -33119.94}, {"clave": "700056-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-07", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700056", "trans_id": 700056, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38598", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 28982.03, "monto": -28982.03}, {"clave": "700057-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-07", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700057", "trans_id": 700057, "detalle": "ND ACH KENNEDY", "ref1": "PS 38864", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 15228.82, "haber": 0, "monto": 15228.82}, {"clave": "700058-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-02", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700058", "trans_id": 700058, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38794", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 28425.74, "monto": -28425.74}, {"clave": "700059-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-07", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700059", "trans_id": 700059, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38182", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 2595.09, "haber": 0, "monto": 2595.09}, {"clave": "700060-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-05", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700060", "trans_id": 700060, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38199", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 29621.73, "monto": -29621.73}, {"clave": "700061-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-08", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700061", "trans_id": 700061, "detalle": "COMISION BANCARIA", "ref1": "PS 38574", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 3016.72, "monto": -3016.72}, {"clave": "700062-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-07-02", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700062", "trans_id": 700062, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38157", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 25303.68, "haber": 0, "monto": 25303.68}, {"clave": "700063-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-08-08", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700063", "trans_id": 700063, "detalle": "PAGO A PRESTAMO", "ref1": "PS 38286", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 18001.37, "monto": -18001.37}, {"clave": "700064-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-08-09", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700064", "trans_id": 700064, "detalle": "ND ACH KENNEDY", "ref1": "PS 38041", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 12703.15, "monto": -12703.15}, {"clave": "700065-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-08-06", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700065", "trans_id": 700065, "detalle": "ND ACH KENNEDY", "ref1": "PS 38433", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 19798.09, "monto": -19798.09}, {"clave": "700066-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-08-22", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700066", "trans_id": 700066, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38009", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 2156.77, "monto": -2156.77}, {"clave": "700067-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-08-19", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700067", "trans_id": 700067, "detalle": "PAGO A PRESTAMO", "ref1": "PS 38823", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 22970.6, "monto": -22970.6}, {"clave": "700068-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-08-28", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700068", "trans_id": 700068, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38503", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 1564.78, "haber": 0, "monto": 1564.78}, {"clave": "700069-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-08-23", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700069", "trans_id": 700069, "detalle": "ND ACH KENNEDY", "ref1": "PS 38195", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 26103.22, "monto": -26103.22}, {"clave": "700070-1", "cuenta": "1002-026", "cuenta_nombre": "BANCO TERCERO (demo)", "fecha": "2026-08-22", "anio": 2026, "mes": 8, "tipo": 30, "num_asiento": "700070", "trans_id": 700070, "detalle": "ND ACH KENNEDY", "ref1": "PS 38368", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 29414.78, "monto": -29414.78}, {"clave": "700071-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-05", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700071", "trans_id": 700071, "detalle": "ND ACH KENNEDY", "ref1": "PS 38460", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 1801.59, "monto": -1801.59}, {"clave": "700072-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-09", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700072", "trans_id": 700072, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38663", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 13464.37, "haber": 0, "monto": 13464.37}, {"clave": "700073-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-15", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700073", "trans_id": 700073, "detalle": "ND ACH KENNEDY", "ref1": "PS 38323", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 1240.81, "monto": -1240.81}, {"clave": "700074-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-13", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700074", "trans_id": 700074, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38374", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 34401.14, "haber": 0, "monto": 34401.14}, {"clave": "700075-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-09", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700075", "trans_id": 700075, "detalle": "ND ACH KENNEDY", "ref1": "PS 38393", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 2449.42, "haber": 0, "monto": 2449.42}, {"clave": "700076-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-15", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700076", "trans_id": 700076, "detalle": "ABONO A PROVEEDOR", "ref1": "PS 38037", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 0, "haber": 15723.53, "monto": -15723.53}, {"clave": "700077-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-11", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700077", "trans_id": 700077, "detalle": "ND ACH KENNEDY", "ref1": "PS 38522", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 4694.69, "haber": 0, "monto": 4694.69}, {"clave": "700078-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-09", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700078", "trans_id": 700078, "detalle": "ND ACH KENNEDY", "ref1": "PS 38840", "ref2": "", "contra_cuenta": "1002-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 36645.5, "haber": 0, "monto": 36645.5}, {"clave": "700079-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-25", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700079", "trans_id": 700079, "detalle": "TRASLADO DE FONDOS", "ref1": "PS 38688", "ref2": "", "contra_cuenta": "2008-002", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 40972.16, "haber": 0, "monto": 40972.16}, {"clave": "700080-1", "cuenta": "1002-028", "cuenta_nombre": "BANCO CUARTO (demo)", "fecha": "2026-07-14", "anio": 2026, "mes": 7, "tipo": 30, "num_asiento": "700080", "trans_id": 700080, "detalle": "DEPOSITO CLIENTE", "ref1": "PS 38497", "ref2": "", "contra_cuenta": "6000-016", "contra_nombre": "CONTRAPARTIDA", "cardname": "", "debe": 38311.56, "haber": 0, "monto": 38311.56}], "libro_mayor_saldos": [{"clave": "1002-002-2026-7", "cuenta": "1002-002", "anio": 2026, "mes": 7, "saldo_inicial": 134104.51, "saldo_final": 153103.74, "total_debe": 30498.18, "total_haber": 17936.62}, {"clave": "1002-002-2026-8", "cuenta": "1002-002", "anio": 2026, "mes": 8, "saldo_inicial": 153103.74, "saldo_final": 176935.68, "total_debe": 41341.4, "total_haber": 50805.61}, {"clave": "1002-019-2026-7", "cuenta": "1002-019", "anio": 2026, "mes": 7, "saldo_inicial": 28489.04, "saldo_final": 48916.08, "total_debe": 18644.63, "total_haber": 43141.05}, {"clave": "1002-019-2026-8", "cuenta": "1002-019", "anio": 2026, "mes": 8, "saldo_inicial": 48916.08, "saldo_final": 135029.35, "total_debe": 82554.79, "total_haber": 21899.81}, {"clave": "1002-026-2026-7", "cuenta": "1002-026", "anio": 2026, "mes": 7, "saldo_inicial": 103438.34, "saldo_final": 3923.46, "total_debe": 87808.88, "total_haber": 73330.17}, {"clave": "1002-026-2026-8", "cuenta": "1002-026", "anio": 2026, "mes": 8, "saldo_inicial": 3923.46, "saldo_final": -125659.74, "total_debe": 69787.06, "total_haber": 66054.84}, {"clave": "1002-028-2026-7", "cuenta": "1002-028", "anio": 2026, "mes": 7, "saldo_inicial": 114925.17, "saldo_final": 267098.08, "total_debe": 31344.41, "total_haber": 37784.55}, {"clave": "1002-028-2026-8", "cuenta": "1002-028", "anio": 2026, "mes": 8, "saldo_inicial": 267098.08, "saldo_final": 267098.08, "total_debe": 22312.28, "total_haber": 83239.35}], "cuentas_bancos": [{"cuenta": "1002-002", "nombre": "BANCO PRIMERO (demo)", "moneda": "USD"}, {"cuenta": "1002-019", "nombre": "BANCO SEGUNDO (demo)", "moneda": "USD"}, {"cuenta": "1002-026", "nombre": "BANCO TERCERO (demo)", "moneda": "USD"}, {"cuenta": "1002-028", "nombre": "BANCO CUARTO (demo)", "moneda": "USD"}], "conciliaciones": [], "reposiciones_pedidos": [], "reposiciones_envios": [], "catalogo_nosap": [], "fotos": [], "accesos": [{"id": 1, "usuario_id": "dan", "usuario": "Dan Benzaquen", "rol": "gerencia", "dept": "", "tipo": "entrada", "detalle": "Inició sesión", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-30T00:00:00Z"}, {"id": 2, "usuario_id": "dan", "usuario": "Dan Benzaquen", "rol": "gerencia", "dept": "", "tipo": "pantalla", "detalle": "ordenes", "referencia": "", "navegador": "Chrome", "creado_en": "2026-09-01T00:00:00Z"}, {"id": 3, "usuario_id": "dan", "usuario": "Dan Benzaquen", "rol": "gerencia", "dept": "", "tipo": "pantalla", "detalle": "ordenes", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-27T00:00:00Z"}, {"id": 4, "usuario_id": "dan", "usuario": "Dan Benzaquen", "rol": "gerencia", "dept": "", "tipo": "pantalla", "detalle": "ordenes", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-30T00:00:00Z"}, {"id": 5, "usuario_id": "edy", "usuario": "Edy Guindi", "rol": "gerencia", "dept": "", "tipo": "entrada", "detalle": "Inició sesión", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-27T00:00:00Z"}, {"id": 6, "usuario_id": "edy", "usuario": "Edy Guindi", "rol": "gerencia", "dept": "", "tipo": "pantalla", "detalle": "dashboard", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-29T00:00:00Z"}, {"id": 7, "usuario_id": "edy", "usuario": "Edy Guindi", "rol": "gerencia", "dept": "", "tipo": "pantalla", "detalle": "ordenes", "referencia": "", "navegador": "Chrome", "creado_en": "2026-09-02T00:00:00Z"}, {"id": 8, "usuario_id": "edy", "usuario": "Edy Guindi", "rol": "gerencia", "dept": "", "tipo": "pantalla", "detalle": "alertas", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-31T00:00:00Z"}, {"id": 9, "usuario_id": "sherene", "usuario": "Sherene", "rol": "compras", "dept": "", "tipo": "entrada", "detalle": "Inició sesión", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-29T00:00:00Z"}, {"id": 10, "usuario_id": "sherene", "usuario": "Sherene", "rol": "compras", "dept": "", "tipo": "pantalla", "detalle": "reposiciones", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-28T00:00:00Z"}, {"id": 11, "usuario_id": "sherene", "usuario": "Sherene", "rol": "compras", "dept": "", "tipo": "pantalla", "detalle": "dashboard", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-28T00:00:00Z"}, {"id": 12, "usuario_id": "sherene", "usuario": "Sherene", "rol": "compras", "dept": "", "tipo": "pantalla", "detalle": "dashboard", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-30T00:00:00Z"}, {"id": 13, "usuario_id": "yagizel", "usuario": "Yagizel", "rol": "compras", "dept": "", "tipo": "entrada", "detalle": "Inició sesión", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-27T00:00:00Z"}, {"id": 14, "usuario_id": "yagizel", "usuario": "Yagizel", "rol": "compras", "dept": "", "tipo": "pantalla", "detalle": "alertas", "referencia": "", "navegador": "Chrome", "creado_en": "2026-09-01T00:00:00Z"}, {"id": 15, "usuario_id": "yagizel", "usuario": "Yagizel", "rol": "compras", "dept": "", "tipo": "pantalla", "detalle": "dashboard", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-29T00:00:00Z"}, {"id": 16, "usuario_id": "yagizel", "usuario": "Yagizel", "rol": "compras", "dept": "", "tipo": "pantalla", "detalle": "ordenes", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-31T00:00:00Z"}, {"id": 17, "usuario_id": "yeini", "usuario": "Yeini", "rol": "contabilidad", "dept": "", "tipo": "entrada", "detalle": "Inició sesión", "referencia": "", "navegador": "Chrome", "creado_en": "2026-09-01T00:00:00Z"}, {"id": 18, "usuario_id": "yeini", "usuario": "Yeini", "rol": "contabilidad", "dept": "", "tipo": "pantalla", "detalle": "ordenes", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-31T00:00:00Z"}, {"id": 19, "usuario_id": "yeini", "usuario": "Yeini", "rol": "contabilidad", "dept": "", "tipo": "pantalla", "detalle": "ordenes", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-30T00:00:00Z"}, {"id": 20, "usuario_id": "yeini", "usuario": "Yeini", "rol": "contabilidad", "dept": "", "tipo": "pantalla", "detalle": "ordenes", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-29T00:00:00Z"}, {"id": 21, "usuario_id": "franco", "usuario": "Franco", "rol": "diseno", "dept": "", "tipo": "entrada", "detalle": "Inició sesión", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-27T00:00:00Z"}, {"id": 22, "usuario_id": "franco", "usuario": "Franco", "rol": "diseno", "dept": "", "tipo": "pantalla", "detalle": "alertas", "referencia": "", "navegador": "Chrome", "creado_en": "2026-09-01T00:00:00Z"}, {"id": 23, "usuario_id": "franco", "usuario": "Franco", "rol": "diseno", "dept": "", "tipo": "pantalla", "detalle": "alertas", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-28T00:00:00Z"}, {"id": 24, "usuario_id": "franco", "usuario": "Franco", "rol": "diseno", "dept": "", "tipo": "pantalla", "detalle": "dashboard", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-27T00:00:00Z"}, {"id": 25, "usuario_id": "david", "usuario": "David", "rol": "bodega", "dept": "", "tipo": "entrada", "detalle": "Inició sesión", "referencia": "", "navegador": "Chrome", "creado_en": "2026-09-01T00:00:00Z"}, {"id": 26, "usuario_id": "david", "usuario": "David", "rol": "bodega", "dept": "", "tipo": "pantalla", "detalle": "reposiciones", "referencia": "", "navegador": "Chrome", "creado_en": "2026-09-02T00:00:00Z"}, {"id": 27, "usuario_id": "david", "usuario": "David", "rol": "bodega", "dept": "", "tipo": "pantalla", "detalle": "dashboard", "referencia": "", "navegador": "Chrome", "creado_en": "2026-09-02T00:00:00Z"}, {"id": 28, "usuario_id": "david", "usuario": "David", "rol": "bodega", "dept": "", "tipo": "pantalla", "detalle": "dashboard", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-29T00:00:00Z"}, {"id": 29, "usuario_id": "jamileth", "usuario": "Jamileth", "rol": "importacion", "dept": "", "tipo": "entrada", "detalle": "Inició sesión", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-31T00:00:00Z"}, {"id": 30, "usuario_id": "jamileth", "usuario": "Jamileth", "rol": "importacion", "dept": "", "tipo": "pantalla", "detalle": "reposiciones", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-29T00:00:00Z"}, {"id": 31, "usuario_id": "jamileth", "usuario": "Jamileth", "rol": "importacion", "dept": "", "tipo": "pantalla", "detalle": "dashboard", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-31T00:00:00Z"}, {"id": 32, "usuario_id": "jamileth", "usuario": "Jamileth", "rol": "importacion", "dept": "", "tipo": "pantalla", "detalle": "dashboard", "referencia": "", "navegador": "Chrome", "creado_en": "2026-08-27T00:00:00Z"}], "compras_com_pend": [], "compras_dep_mail": [], "chat_leidos": [], "dm_marcas": [], "extractos_bancarios": [], "pedidos": [], "vista_inventario": [], "correos_queue": [], "costeo_queue": [], "descargas_queue": [], "entradas_queue": []};

/* ── 2 · LA CAPA SIN SERVIDOR ──────────────────────────────── */
// ══════════════════════════════════════════════════════════════════════
//  MODO DEMO · sin conexión, sin Supabase
//
//  Sustituye fetch() por una base de datos en memoria. El portal funciona
//  igual: se puede navegar, avanzar etapas, aprobar artes, pedir abonos,
//  generar informes y catálogos. Todo lo que se escriba se guarda en esta
//  misma memoria, así que los cambios se ven al momento, pero se pierden
//  al recargar la página.
//
//  NADA de lo que aparece es real: proveedores, órdenes, artículos y
//  montos están inventados.
// ══════════════════════════════════════════════════════════════════════
(function(){
  var DB = window.__DEMO_DATOS || {};
  window.__DEMO = true;

  // Las tablas que el portal consulta y aquí están vacías: en vez de dar
  // error, devuelven una lista vacía, que es lo que el portal espera.
  function tabla(n){
    if(!DB[n]) DB[n] = [];
    return DB[n];
  }

  // ── Traducir los filtros de PostgREST ──
  // El portal escribe cosas como  &dept=eq.hogar  o  &anio=gte.2026
  function pasa(fila, campo, expr){
    var i = expr.indexOf('.');
    var op = expr.slice(0, i), val = decodeURIComponent(expr.slice(i + 1));
    var v = fila[campo];
    var num = function(x){ var n = Number(x); return isNaN(n) ? x : n; };
    switch(op){
      case 'eq':   return String(v) === String(val);
      case 'neq':  return String(v) !== String(val);
      case 'gt':   return num(v) >  num(val);
      case 'gte':  return num(v) >= num(val);
      case 'lt':   return num(v) <  num(val);
      case 'lte':  return num(v) <= num(val);
      case 'is':   return (val === 'null') ? (v == null) :
                          (val === 'true') ? (v === true) :
                          (val === 'false') ? (v === false || v == null) : true;
      case 'like':
      case 'ilike':{
        var re = new RegExp('^' + val.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                                     .replace(/\\\*/g, '.*') + '$', 'i');
        return re.test(String(v == null ? '' : v));
      }
      case 'in': {
        var lista = val.replace(/^\(|\)$/g, '').split(',')
                       .map(function(x){ return x.replace(/^"|"$/g, ''); });
        return lista.indexOf(String(v)) >= 0;
      }
      case 'not': return true;
      default:    return true;
    }
  }

  function consultar(nombre, params){
    var filas = tabla(nombre).slice();

    // "or=(a.eq.x,b.eq.y)" se trata aparte
    var or = params.get('or');
    if(or){
      var partes = or.replace(/^\(|\)$/g, '').split(',');
      filas = filas.filter(function(f){
        return partes.some(function(p){
          var j = p.indexOf('.');
          return pasa(f, p.slice(0, j), p.slice(j + 1));
        });
      });
    }

    params.forEach(function(expr, campo){
      if(['select','order','limit','offset','or'].indexOf(campo) >= 0) return;
      filas = filas.filter(function(f){ return pasa(f, campo, expr); });
    });

    var order = params.get('order');
    if(order){
      var cols = order.split(',').map(function(o){
        var p = o.split('.');
        return {c: p[0], desc: p.indexOf('desc') > 0};
      });
      filas.sort(function(a, b){
        for(var i = 0; i < cols.length; i++){
          var c = cols[i], x = a[c.c], y = b[c.c];
          if(x === y) continue;
          var r = (x > y) ? 1 : -1;
          return c.desc ? -r : r;
        }
        return 0;
      });
    }

    var off = Number(params.get('offset')) || 0;
    var lim = Number(params.get('limit'));
    if(off) filas = filas.slice(off);
    if(lim) filas = filas.slice(0, lim);
    return filas;
  }

  function respuesta(cuerpo, estado){
    var txt = JSON.stringify(cuerpo === undefined ? [] : cuerpo);
    return Promise.resolve({
      ok: (estado || 200) < 300, status: estado || 200,
      json:  function(){ return Promise.resolve(JSON.parse(txt)); },
      text:  function(){ return Promise.resolve(txt); },
      blob:  function(){ return Promise.resolve(new Blob([txt])); },
      arrayBuffer: function(){ return Promise.resolve(new ArrayBuffer(8)); },
      headers: { get: function(){ return null; } }
    });
  }

  var real = window.fetch;
  window.fetch = function(url, opciones){
    url = String(url); opciones = opciones || {};
    var metodo = (opciones.method || 'GET').toUpperCase();

    // Lo que no sea Supabase (fuentes, iconos) pasa de largo
    if(url.indexOf('/rest/v1/') < 0 && url.indexOf('/storage/v1/') < 0
       && url.indexOf('/functions/v1/') < 0){
      return real.apply(window, arguments);
    }

    // Almacenamiento: se acepta todo y se devuelve una imagen de muestra
    if(url.indexOf('/storage/v1/') >= 0){
      if(metodo === 'POST' || metodo === 'PUT'){
        return respuesta({Key: 'demo/archivo'}, 200);
      }
      return respuesta({}, 200);
    }

    // Funciones del servidor (correo, IA): se responde que sí
    if(url.indexOf('/functions/v1/') >= 0){
      return respuesta({ok: true, demo: true, mensaje: 'En la demo no se envía nada.'}, 200);
    }

    var u = new URL(url, 'https://demo.local');
    var nombre = u.pathname.split('/rest/v1/')[1].split('?')[0];

    if(metodo === 'GET'){
      return respuesta(consultar(nombre, u.searchParams));
    }

    if(metodo === 'POST'){
      var filas = [];
      try{ filas = JSON.parse(opciones.body || '[]'); }catch(e){}
      if(!Array.isArray(filas)) filas = [filas];
      var t = tabla(nombre);
      filas.forEach(function(f){
        // Si ya existe una fila con la misma clave, se actualiza
        var claves = ['id','clave','docnum','dkc','itemcode','cuenta','usuario'];
        var k = claves.find(function(c){ return f[c] != null; });
        var ya = k ? t.find(function(x){ return String(x[k]) === String(f[k]); }) : null;
        if(ya && (opciones.headers||{})['Prefer']
              && String((opciones.headers||{})['Prefer']).indexOf('merge') >= 0){
          Object.assign(ya, f);
        } else {
          if(f.id == null) f.id = t.length + 1;
          t.push(f);
        }
      });
      return respuesta(filas, 201);
    }

    if(metodo === 'PATCH'){
      var cambios = {};
      try{ cambios = JSON.parse(opciones.body || '{}'); }catch(e){}
      var afectadas = consultar(nombre, u.searchParams);
      afectadas.forEach(function(f){ Object.assign(f, cambios); });
      return respuesta(afectadas, 200);
    }

    if(metodo === 'DELETE'){
      var fuera = consultar(nombre, u.searchParams);
      DB[nombre] = tabla(nombre).filter(function(f){ return fuera.indexOf(f) < 0; });
      return respuesta([], 204);
    }

    return respuesta([], 200);
  };

  // ── Las fotos de los artículos ──
  // UNA sola foto para todos, así el archivo no engorda. Se sustituyen las
  // funciones que arman la URL: el portal pinta las fotos con <img src>,
  // no con el objeto Image, así que interceptar Image no servía de nada.
  var FOTO_DEMO = 'data:image/jpeg;base64,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';
  window.__demoFoto = function(){ return FOTO_DEMO; };

  // Se espera a que la aplicación exista para pisarle las funciones
  function _demoFotos(){
    ['_repFotoUrl','_fotoDeSku','_fotoNoSapDeSku','_catFotoUrl'].forEach(function(fn){
      if(typeof window[fn] === 'function'){
        window[fn] = function(){ return FOTO_DEMO; };
      }
    });
    // FOTO_BASE se usa para armar rutas sueltas
    try{ if(typeof FOTO_BASE !== 'undefined') window.FOTO_BASE = ''; }catch(e){}
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(_demoFotos, 0); });
  } else { setTimeout(_demoFotos, 0); }
  setTimeout(_demoFotos, 400);
  setTimeout(_demoFotos, 1500);

  // ── Los catálogos y los informes ──
  // Aquí tenía una comprobación que abortaba si ExcelJS o jsPDF no estaban
  // cargados. Era un error: esas librerías se descargan JUSTO AL PULSAR el
  // botón, dentro de _ensureExcelJS, así que mi comprobación las daba por
  // ausentes y cancelaba el catálogo antes de que pudieran cargarse.
  //
  // Se deja que el portal haga su trabajo. Si no hay conexión, la propia
  // carga falla y el portal ya avisa con su mensaje.

  console.log('%c MODO DEMO ', 'background:#7C3AED;color:#fff;font-weight:700',
              'datos inventados, sin conexión. Nada se guarda al recargar.');
})();

/* ── 3 · LA APLICACIÓN ─────────────────────────────────────── */
// ── Almacenes en memoria, declarados ANTES de que nadie los use ──
// Estos tres se creaban dentro de repGenerar() y enviarCorreoProveedor(),
// que hasta ahora siempre corrían primero. Al cargar los datos en paralelo
// y al añadir la pantalla de Top selling, dejó de ser cierto: quien llegaba
// antes se encontraba con "undefined" y reventaba.
window._atts     = window._atts     || {};   // adjuntos por orden y etapa
window._repSugIA = window._repSugIA || {};   // sugerencias de la IA por SKU
window._nsapFotos= window._nsapFotos|| {};   // fotos sacadas del Excel

// ═══════════════════════════════════════════════════════════════
//  CONEXIÓN A SUPABASE (datos reales de OPOR + seguimiento)
// ═══════════════════════════════════════════════════════════════
// Versión del portal: si no coincide con la última, el navegador tiene una copia vieja
const APP_VERSION = 'v306';
const SB = 'https://sutnfihpmfsejdlkghjp.supabase.co';
const KEY = 'sb_publishable_5ZJdu4hX49XRH1q0dCFsAQ_0S0Eps95';
const SBH = { 'apikey': KEY, 'Authorization': 'Bearer ' + KEY, 'Content-Type': 'application/json' };

// Base pública del bucket de fotos de items en Supabase Storage
const FOTO_BASE = SB + '/storage/v1/object/public/fotos-items/';

// Construye la URL de la foto de una línea de OPOR.
// Usa picturname (nombre del archivo en SAP) en MINÚSCULA para que coincida con
// el bucket (el sync sube las fotos en minúscula). Respaldo: foto_url de Shopify.
function fotoDeLinea(l){
  if(!l) return '';
  var pn = (l.picturname || l.PicturName || '').toString().trim();
  if(pn) return FOTO_BASE + encodeURIComponent(pn);   // nombre TAL CUAL está en el bucket
  if(l.foto_url) return l.foto_url;
  if(l.imagen_url) return l.imagen_url;   // compatibilidad con el campo viejo
  return '';
}
// Variantes de URL de la foto para intentar en orden (cubre mayúsc/minúsc del bucket)
function fotoVariantes(l){
  if(!l) return [];
  var pn = (l.picturname || l.PicturName || '').toString().trim();
  var urls = [];
  if(pn){
    urls.push(FOTO_BASE + encodeURIComponent(pn));                  // tal cual (ej. 25421-FEJ.jpg)
    if(pn.toLowerCase() !== pn) urls.push(FOTO_BASE + encodeURIComponent(pn.toLowerCase())); // minúscula
    if(pn.toUpperCase() !== pn) urls.push(FOTO_BASE + encodeURIComponent(pn.toUpperCase())); // mayúscula
  }
  if(l._fotoUrl) urls.push(l._fotoUrl);
  if(l.foto) urls.push(l.foto);
  if(l.foto_url) urls.push(l.foto_url);
  if(l.imagen_url) urls.push(l.imagen_url);
  // Último recurso: la imagen que guardó el catálogo NO SAP. Es la única que
  // existe mientras SAP no cargue la suya, y como va al final solo se usa si
  // ninguna de las de SAP responde. El código llega con distintos nombres de
  // campo según la pantalla, así que se prueban todos.
  try{
    var nf=_fotoNoSapDeSku(l.itemcode || l.ItemCode || l.item_code || l.sku || l.SKU);
    if(nf && urls.indexOf(nf)<0) urls.push(nf);
  }catch(e){}
  return urls;
}

// ── La foto que tenemos de un SKU fuera de SAP ──
// Las fichas temporales guardan la imagen que vino del Excel del proveedor.
// Mientras SAP no tenga una foto usable, esa es la única que existe, así que
// cualquier pantalla que no encuentre imagen en SAP tiene que mirar aquí.
function _fotoNoSapDeSku(itemcode){
  var sku=String(itemcode||'').trim().toUpperCase();
  if(!sku) return '';
  // 1) Lo guardado en la ficha temporal (sobrevive a recargar la página).
  //    La imagen puede estar en 'foto' o en 'foto_url' según cómo se creó la
  //    ficha: el resto del portal mira los dos, y aquí solo se miraba uno.
  //    Por eso la fila en ámbar enseñaba la foto y la de SAP no.
  var f=(window._catNoSap||[]).find(function(x){
    return x && x.tipo!=='proveedor' && String(x.itemcode||'').trim().toUpperCase()===sku;
  });
  var u=f && (f.foto || f.foto_url || f.imagen_url || '');
  if(u) return _fotoNoSapUrl(u);
  // 2) Lo que se sacó del Excel en esta misma sesión
  var m=(window._nsapFotos||{})[sku];
  if(m && m.url) return m.url;
  return '';
}

// Si lo guardado es una ruta del almacenamiento y no una dirección completa,
// se le pone delante la base del bucket.
function _fotoNoSapUrl(v){
  var s=String(v||'').trim();
  if(!s) return '';
  if(/^(https?:|data:|blob:)/i.test(s)) return s;
  try{ return DOCS_BASE + s.split('/').map(encodeURIComponent).join('/'); }
  catch(e){ return s; }
}

// Normaliza el grupo de artículos de SAP a un departamento de la app
// Ej: "..Hogar" -> "hogar", "..Alfombra" -> "alfombras"
function normDept(g){
  if(!g) return 'otros';
  // Quitar los puntos al inicio (ej: "..Hogar" -> "hogar")
  var s = g.replace(/^\.+/,'').trim().toLowerCase();
  // Mapeo exacto basado en los valores reales de SAP B1
  var map = {
    // Con puntos al inicio (valores SAP confirmados)
    'hogar'       : 'hogar',
    'ropa'        : 'ropa',
    'muebles'     : 'muebles',
    'alfombra'    : 'alfombras',
    'alfombras'   : 'alfombras',
    'campamento'  : 'campamento',
    'electronica' : 'electronica',
    'electrónica' : 'electronica',
    'ferreteria'  : 'ferreteria',
    'ferretería'  : 'ferreteria',
    // Sin puntos - "Artículos" es un grupo genérico en SAP → otros
    // Home Deco caía en "otros" y por eso no se podía asignar a nadie
    'home deco'   : 'homedeco',
    'homedeco'    : 'homedeco',
    'home-deco'   : 'homedeco',
    'articulos'   : 'otros',
    'artículos'   : 'otros',
    'articulo'    : 'otros',
    'artículo'    : 'otros',
  };
  return map[s] || 'otros';
}

// Emoji por departamento
function deptEmoji(d){
  return {hogar:'🏠',ropa:'👗',muebles:'🪑',alfombras:'🟫',campamento:'⛺',
          electronica:'📱',homedeco:'🖼️',ferreteria:'🔧',otros:'📦'}[d] || '📦';
}

// Formatea fecha ISO (2026-01-22) al formato de la app ("22 ene 2026")
function isoADisplay(iso){
  if(!iso) return '';
  var m=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  var p=String(iso).slice(0,10).split('-');
  if(p.length<3) return iso;
  return p[2]+' '+(m[parseInt(p[1])-1]||'')+' '+p[0];
}

// Carga TODAS las órdenes OPOR + sus líneas + el seguimiento guardado,
// y arma el array `orders` y `stageProgress` que la app ya sabe usar.
// Los cargadores de apoyo. Cada uno se mide por separado para saber cuál
// tarda; el que se pase de 3 segundos queda anotado en la consola.
function _cargarAuxiliares(){
  var tareas=[
    ['bookings',              cargarBookings],
    ['artes',                 cargarArtes],
    ['aprobaciones',          cargarAprob],
    ['correos de depósito',   cargarDepMail],
    ['comentarios pendientes',cargarComPend],
    ['llegadas',              cargarLlegadas],
    ['pendientes SAP',        cargarPendSAP]
  ];
  var t0=Date.now();
  var todas=tareas.map(function(t){
    var ti=Date.now();
    var pr;
    try{ pr=Promise.resolve(t[1]()); }catch(e){ pr=Promise.reject(e); }
    return pr.then(function(){
      var ms=Date.now()-ti;
      if(ms>3000) console.warn('[carga] '+t[0]+' tardó '+(ms/1000).toFixed(1)+'s');
      return {n:t[0], ms:ms, ok:true};
    }).catch(function(e){
      console.warn('[carga] '+t[0]+' falló:', e && e.message || e);
      return {n:t[0], ms:Date.now()-ti, ok:false};
    });
  });
  return Promise.all(todas).then(function(rs){
    rs.sort(function(a,b){ return b.ms-a.ms; });
    console.log('[carga] apoyo terminado en '+((Date.now()-t0)/1000).toFixed(1)+'s · '
      +rs.map(function(r){ return r.n+' '+(r.ms/1000).toFixed(1)+'s'+(r.ok?'':' (falló)'); }).join(' · '));
    return true;
  });
}

async function cargarDatosReales(){
  try{
    try{ window._ultimoSync=localStorage.getItem('kcc_ultimoSync')||window._ultimoSync; }catch(e){}
    // Las consultas de abajo no dependen unas de otras, así que se lanzan
    // TODAS A LA VEZ. Antes iban en fila india —cada una esperaba a que
    // terminara la anterior—, y con once viajes al servidor eso es lo que
    // hacía que "Cargando órdenes…" se quedara tanto rato en pantalla.
    console.time('[carga] datos iniciales');

    // Una consulta minúscula para saber si la cabecera ya trae los datos
    // agregados. Cuesta milisegundos y ahorra megabytes.
    try{
      var _sonda=await fetch(SB+'/rest/v1/opor_ordenes?select=unidades,grupo_items&limit=1',
        {headers:SBH});
      if(_sonda.ok){
        var _f=(await _sonda.json()||[])[0];
        window._lineasNoHacenFalta = !!(_f && (_f.grupo_items!=null || _f.unidades!=null));
      }
    }catch(e){ window._lineasNoHacenFalta=false; }
    if(window._lineasNoHacenFalta)
      console.log('[carga] la cabecera trae los datos de línea: arranque ligero');

    // Las líneas se traen en tandas de 1000. La primera dice cuántas hay;
    // si hay más, el resto de tandas también se piden a la vez.
    async function _traerLineas(){
      var _t0=Date.now();
      var base=SB+'/rest/v1/opor_lineas?select=docnum,itemname,cantidad,grupo_items&limit=1000&offset=';
      var hdr=Object.assign({},SBH,{'Prefer':'count=none'});
      var out=[], offset=0;
      // Las cabeceras ya traen unidades, grupo y descripción calculados en
      // SAP. Si están, no se bajan las líneas: son unos 4 MB que retrasaban
      // el arranque, sobre todo en tableta.
      if(window._lineasNoHacenFalta){
        console.log('[carga] líneas omitidas: la cabecera ya trae los datos');
        return [];
      }
      while(true){
        // Cuatro tandas en paralelo por vuelta: suficiente para ir rápido
        // sin abrir demasiadas conexiones a la vez.
        var lote=await Promise.all([0,1,2,3].map(function(k){
          return fetch(base+(offset+k*1000), {headers:hdr})
            .then(function(r){ return r.ok?r.json():[]; })
            .catch(function(){ return []; });
        }));
        var vacias=0;
        for(var i=0;i<lote.length;i++){
          var pg=Array.isArray(lote[i])?lote[i]:[];
          out=out.concat(pg);
          if(pg.length<1000) vacias++;
        }
        if(vacias>0) break;             // alguna tanda vino corta: ya no hay más
        offset+=4000;
        if(offset>50000) break;
      }
      var _ms=Date.now()-_t0;
      if(_ms>3000) console.warn('[carga] líneas tardó '+(_ms/1000).toFixed(1)+'s para '+out.length+' fila(s)');
      return out;
    }

    async function _json(url, hdr, nombre){
      var t=Date.now();
      try{
        var r=await fetch(url, {headers:hdr||SBH});
        if(!r.ok){
          var txt=''; try{ txt=await r.text(); }catch(e){}
          console.warn('[carga] '+(nombre||'consulta')+' '+r.status+': '+txt.slice(0,160));
          return [];
        }
        var j=await r.json();
        var ms=Date.now()-t;
        if(ms>3000) console.warn('[carga] '+(nombre||'consulta')+' tardó '+(ms/1000).toFixed(1)+'s');
        return Array.isArray(j)?j:[];
      }catch(e){ console.warn('[carga] '+(nombre||'consulta')+':', e&&e.message||e); return []; }
    }

    var _res = await Promise.all([
      _json(SB+'/rest/v1/opor_ordenes?select=*&order=docnum.desc',null,'órdenes'),
      _traerLineas(),                                                         // 2) líneas
      _json(SB+'/rest/v1/compras_seguimiento?select=*',null,'seguimiento'),
      _json(SB+'/rest/v1/compras_comentarios?select=*&order=creado_en.asc',null,'comentarios'),
      // 5) Y los siete cargadores propios. SÍ se espera a que terminen: uno de
      //    ellos trae las órdenes NO SAP, y sin ellas el tablero se dibujaba
      //    vacío. Se miden por separado para saber cuál es el lento.
      _cargarAuxiliares()
    ]);

    var ordEnes=_res[0], lineas=_res[1], segui=_res[2], coments=_res[3];
    console.timeEnd('[carga] datos iniciales');
    console.log('[carga] '+ordEnes.length+' órdenes · '+lineas.length+' líneas · '
      +segui.length+' seguimientos · '+coments.length+' comentarios');

    // --- Agrupa líneas por orden ---
    // Si la cabecera ya trae los tres datos calculados en SAP (unidades,
    // grupo y descripción), NO hace falta bajarse las líneas: eran unos 4 MB
    // antes de pintar nada, y en un iPad eso son treinta segundos de espera.
    var porOrden = {};
    var _cabeceraTraeTodo = ordEnes.length>0 &&
      ordEnes.some(function(o){ return o.grupo_items!=null || o.unidades!=null; });

    if(_cabeceraTraeTodo){
      ordEnes.forEach(function(o){
        var dn=String(o.docnum);
        porOrden[dn]={
          grupos:(o.grupo_items?({}, (function(){ var g={}; g[o.grupo_items]=1; return g; })()):{}),
          unidades:Number(o.unidades)||0,
          primeraDesc:o.primera_desc||''
        };
      });
      console.log('[carga] los datos de línea vienen en la cabecera: '
        +'no hace falta descargarlas');
    } else {
      lineas.forEach(function(l){
        var dn = String(l.docnum);
        if(!porOrden[dn]) porOrden[dn] = {grupos:{}, unidades:0, primeraDesc:''};
        var g = l.grupo_items || '';
        porOrden[dn].grupos[g] = (porOrden[dn].grupos[g]||0) + 1;
        porOrden[dn].unidades += parseFloat(l.cantidad)||0;
        if(!porOrden[dn].primeraDesc && l.itemname) porOrden[dn].primeraDesc = l.itemname;
      });
    }
function deptDominante(dn){
      var g = porOrden[dn] ? porOrden[dn].grupos : {};
      var best='', max=-1;
      Object.keys(g).forEach(function(k){ if(g[k]>max){max=g[k];best=k;} });
      return normDept(best);
    }

    // --- Construye el array orders con el formato de la app ---
    orders = ordEnes.map(function(o){
      var dn = String(o.docnum);
      var info = porOrden[dn] || {unidades:0, primeraDesc:''};
      var dept = deptDominante(dn) || 'otros';
      var total = parseFloat(o.total)||0;
      var abono = parseFloat(o.abono)||0;
      return {
        id: dn,
        dept: dept,
        prov: o.vendor_name || '-',
        valor: total,
        abono: abono,
        desc: info.primeraDesc || o.comentarios || 'Orden '+dn,
        alerta: false,
        resp: o.vendor_code || '',
        fechaCreacion: isoADisplay(o.docdate),
        fechaEst: isoADisplay(o.eta || o.duedate),
        uni: Math.round(info.unidades),
        emoji: deptEmoji(dept),
        pend: false,          // las OPOR ya vienen aprobadas en SAP
        completada: false,
        _estadoSap: o.estado_compra || '',
        _docstatus: o.doc_status || '',
        vendorEmail: o.vendor_email || '',        // correo del proveedor (OCRD.E_Mail)
        fechaAbono: isoADisplay(o.fecha_abono),   // fecha del abono en SAP
        num_proveedor: o.num_proveedor || ''
      };
    });

    // --- Cargar actividad reciente (últimas 48h) ---
    try{
      var hace48h=new Date(Date.now()-48*60*60*1000).toISOString();
      // La columna actualizado_en puede no existir en la tabla: el portal la
      // manda al guardar, pero si nunca se creó, PostgREST la descarta en
      // silencio y luego rechaza la consulta que la pide. Si eso pasa, se
      // sigue sin la actividad de seguimiento en vez de llenar el log.
      var rAct1=await fetch(SB+'/rest/v1/compras_seguimiento?select=docnum,etapa,actualizado_en&actualizado_en=gte.'+hace48h+'&order=actualizado_en.desc&limit=100',{headers:SBH});
      var act1=[];
      if(rAct1.ok){ act1=await rAct1.json(); }
      else if(!window._avisoActEn){
        window._avisoActEn=1;
        var _ta=''; try{ _ta=await rAct1.text(); }catch(e){}
        console.warn('[actividad] compras_seguimiento '+rAct1.status+': '+_ta.slice(0,160)
          +' — la actividad reciente se muestra solo con los comentarios.');
      }
      var rAct2=await fetch(SB+'/rest/v1/compras_comentarios?select=docnum,etapa,autor,creado_en&creado_en=gte.'+hace48h+'&order=creado_en.desc&limit=100',{headers:SBH});
      var act2=rAct2.ok?(await rAct2.json()):[];
      // Combinar y deduplicar por docnum, quedarse con el más reciente
      var actMap={};
      (Array.isArray(act1)?act1:[]).forEach(function(r){
        var ts=r.actualizado_en||'';
        if(!actMap[r.docnum]||ts>actMap[r.docnum].ts)
          actMap[r.docnum]={docnum:String(r.docnum),etapa:r.etapa||'',autor:r.usuario||'',ts:ts,tipo:'etapa'};
      });
      (Array.isArray(act2)?act2:[]).forEach(function(r){
        var ts=r.creado_en||'';
        if(!actMap[r.docnum]||ts>actMap[r.docnum].ts)
          actMap[r.docnum]={docnum:String(r.docnum),etapa:r.etapa||'',autor:r.autor||'',ts:ts,tipo:'comentario'};
      });
      _recentActivity=Object.values(actMap).sort(function(a,b){return b.ts.localeCompare(a.ts);});
    }catch(e){_recentActivity=[];}
    // --- Reconstruye stageProgress desde compras_seguimiento ---
    stageProgress = {};
    orders.forEach(function(o){ initP(o.id); });
    segui.forEach(function(s){
      var dn = String(s.docnum);
      initP(dn);
      if(stageProgress[dn] && stageProgress[dn][s.etapa]){
        var fechas = [];
        try { fechas = Array.isArray(s.fechas_pasos) ? s.fechas_pasos : JSON.parse(s.fechas_pasos||'[]'); } catch(e){ fechas=[]; }
        stageProgress[dn][s.etapa].stepIdx = s.paso_actual || 0;
        stageProgress[dn][s.etapa].startDate = isoADisplay(s.fecha_inicio);
        stageProgress[dn][s.etapa].stepDates = fechas.map(isoADisplay);
        // guardar también las ISO para poder re-guardar sin perder formato
        stageProgress[dn][s.etapa]._isoInicio = s.fecha_inicio || '';
        stageProgress[dn][s.etapa]._isoPasos = fechas.slice();
      }
    });
    // Si una orden NO SAP ya entró a SAP, el avance se mueve a la clave nueva
    try{ await _migrarEtapasNoSap(true); }catch(e){ console.warn('migrar etapas:',e); }
    // Marca como completadas las órdenes cuya última etapa (bodega) esté terminada
    orders.forEach(function(o){
      var sp = stageProgress[o.id];
      if(sp && sp.bodega && STAGES.length){
        var ult = STAGES[STAGES.length-1];
        if(sp[ult.key] && sp[ult.key].stepIdx >= ult.steps.length) o.completada = true;
      }
    });

    // --- Inyecta comentarios ---
    // Se vacía primero: antes se hacía push sobre lo que ya había y cada
    // recarga duplicaba todos los comentarios.
    window._subComs={};
    (orders||[]).forEach(function(o){
      if(stageProgress[o.id]) STAGES.forEach(function(st){
        if(stageProgress[o.id][st.key]) stageProgress[o.id][st.key].comments=[];
      });
    });
    var _vistosCom={};
    coments.forEach(function(c){
      // Ni el mismo comentario dos veces
      var _k=String(c.id||'')||(String(c.docnum)+'|'+String(c.etapa)+'|'+String(c.autor)+'|'+String(c.texto)+'|'+String(c.creado_en));
      if(_vistosCom[_k]) return;
      _vistosCom[_k]=1;
      var dn = String(c.docnum);
      var et = c.etapa||'';
      // Comentarios de sub-etapa (live chat de pasos) y de pendientes SAP van a _subComs
      if(et.indexOf('sub_')===0 || et.indexOf('pendsap_')===0 || et.indexOf('_step')>=0){
        var ck = et.indexOf('sub_')===0 ? et : (et.indexOf('pendsap_')===0 ? et : ('sub_'+dn+'_'+et));
        if(!window._subComs[ck]) window._subComs[ck]=[];
        window._subComs[ck].push({
          id: c.id,
          autor: c.autor + (c.autor_rol?' ('+c.autor_rol+')':''),
          ini: (c.autor||'--').slice(0,2).toUpperCase(),
          texto: c.texto, time: isoADisplay(c.creado_en),
          role: c.autor_rol||'', by: c.autor||''
        });
        return;
      }
      if(stageProgress[dn] && stageProgress[dn][c.etapa]){
        if(!stageProgress[dn][c.etapa].comments) stageProgress[dn][c.etapa].comments=[];
        stageProgress[dn][c.etapa].comments.push({
          autor: c.autor + (c.autor_rol?' ('+c.autor_rol+')':''),
          ini: (c.autor||'--').slice(0,2).toUpperCase(),
          texto: c.texto,
          time: isoADisplay(c.creado_en)
        });
      }
    });

    return true;
  }catch(e){
    console.error('Error cargando datos reales:', e);
    return false;
  }
}

// ── Guardado en Supabase (se llama al avanzar/revertir/comentar) ──
async function guardarEtapa(docnum, etapa){
  try{
    var sp = stageProgress[docnum] && stageProgress[docnum][etapa];
    if(!sp) return;
    // Convierte fechas display de nuevo a ISO no es trivial; guardamos las ISO
    // que ya generamos al avanzar (usamos hoy en ISO). Para robustez, guardamos
    // fecha_inicio y fechas_pasos tal cual estén (la app las relee bien).
    var body = {
      docnum: String(docnum),
      etapa: etapa,
      paso_actual: sp.stepIdx || 0,
      fecha_inicio: sp._isoInicio || null,
      fechas_pasos: JSON.stringify(sp._isoPasos || []),
      completada: (sp.stepIdx||0) >= (STAGES.find(function(s){return s.key===etapa;})?.steps.length||99),
      actualizado_por: CU ? CU.name : '',
      actualizado_en: new Date().toISOString()
    };
    await fetch(SB+'/rest/v1/compras_seguimiento?on_conflict=docnum,etapa', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify(body)
    });
  }catch(e){ console.error('guardarEtapa:', e); }
}

async function guardarComentario(docnum, etapa, texto){
  try{
    await fetch(SB+'/rest/v1/compras_comentarios', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'return=minimal'}),
      body: JSON.stringify({
        docnum:String(docnum), etapa:etapa,
        autor: CU?CU.name:'', autor_rol: CU?CU.role:'',
        texto: texto, creado_en: new Date().toISOString()
      })
    });
  }catch(e){ console.error('guardarComentario:', e); }
}

// Guarda el booking + contenedores de una orden (upsert por docnum)
async function guardarBooking(oid){
  try{
    var bk = getBK(oid);
    await fetch(SB+'/rest/v1/compras_booking?on_conflict=docnum', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({
        docnum: String(oid),
        naviera: bk.naviera || '',
        booking: bk.booking || '',
        containers: bk.containers || [],
        actualizado_por: CU ? CU.name : '',
        actualizado_en: new Date().toISOString()
      })
    });
  }catch(e){ console.error('guardarBooking:', e); }
}

// Carga TODOS los bookings guardados a memoria (se llama al iniciar la app)
async function cargarBookings(){
  try{
    var r = await fetch(SB+'/rest/v1/compras_booking?select=*', {headers:SBH});
    var rows = await r.json();
    if(!window._bookingData) window._bookingData={};
    if(Array.isArray(rows)){
      rows.forEach(function(row){
        var conts = row.containers;
        if(typeof conts==='string'){ try{conts=JSON.parse(conts);}catch(e){conts=[];} }
        window._bookingData[String(row.docnum)] = {
          naviera: row.naviera||'',
          booking: row.booking||'',
          containers: Array.isArray(conts)?conts:[]
        };
      });
    }
  }catch(e){ console.error('cargarBookings:', e); }
}

const DEPTS_ALL=['hogar','alfombras','muebles','ropa','campamento','electronica','homedeco','ferreteria','otros'];
// Los departamentos que puede ver quien está dentro. Gerencia sin área los ve
// todos; con área asignada (Gady en alfombras, Henry en ropa) solo la suya.
// Las pantallas que pintan un panel por departamento pasan por aquí.
function _deptsVisibles(){
  try{
    // Un usuario puede tener VARIOS departamentos (los diseñadores llevan
    // varias líneas cada uno). "dept" sigue valiendo para quien tiene uno
    // solo, como las compradoras.
    if(CU && CU.depts && CU.depts.length) return CU.depts.slice();
    if(CU && CU.dept) return [CU.dept];
  }catch(e){}
  return DEPTS_ALL;
}

// El texto del área del usuario: "Hogar" con uno, "Hogar · Muebles · Home
// Deco" con varios. Se usa en la barra y en los avisos.
function _deptEtiqueta(){
  var ds=_deptsVisibles();
  if(!_deptAcotado()) return '';
  return ds.map(function(d){ return dL(d); }).join(' · ');
}
function _deptEmojis(){
  if(!_deptAcotado()) return '';
  return _deptsVisibles().map(function(d){ return EMOJIS2[d]||''; }).join('');
}
// El trozo de URL para acotar una consulta por departamento. Con uno solo
// va "eq."; con varios, "in.(a,b,c)". Sin límite, cadena vacía.
function _deptFiltroURL(campo){
  var c=campo||'dept';
  if(!_deptAcotado()) return '';
  var ds=_deptsVisibles();
  if(ds.length===1) return '&'+c+'=eq.'+encodeURIComponent(ds[0]);
  return '&'+c+'=in.('+ds.map(encodeURIComponent).join(',')+')';
}

// El primero, para los sitios que necesitan UNO solo (el filtro inicial de
// una pantalla, la orden nueva que se va a crear).
function _deptPrimero(){
  var ds=_deptsVisibles();
  return _deptAcotado() ? (ds[0]||'') : '';
}

// ¿Este usuario puede ver este departamento?
function _deptPermitido(d){
  if(!CU) return false;
  if(CU.depts && CU.depts.length) return CU.depts.indexOf(d)>=0;
  if(CU.dept) return String(d)===String(CU.dept);
  return true;      // sin límite: lo ve todo
}

// ¿Tiene el usuario algún límite de departamento?
function _deptAcotado(){
  return !!(CU && ((CU.depts && CU.depts.length) || CU.dept));
}
const DEPT_LABELS={hogar:'Hogar',alfombras:'Alfombras',muebles:'Muebles',ropa:'Ropa',campamento:'Campamento',electronica:'Electrónica',homedeco:'Home Deco',ferreteria:'Ferretería',otros:'Otros'};
const EMOJIS2={hogar:'🛋️',alfombras:'🟫',muebles:'🪑',ropa:'👗',campamento:'⛺',electronica:'📱',homedeco:'🖼️',ferreteria:'🔧',otros:'📦'};

// ═══════ ILUSTRACIONES SVG POR DEPARTAMENTO (tarjetas de inicio) ═══════
const DEPT_SVG = {
  hogar: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="44" rx="17" ry="4" fill="#00000012"/><path d="M17 30h30v8a6 6 0 0 1-6 6H23a6 6 0 0 1-6-6v-8Z" fill="#F5F0E8" stroke="#B99A6B" stroke-width="1.5"/><rect x="14" y="27" width="36" height="4" rx="2" fill="#D9C4A3" stroke="#B99A6B" stroke-width="1.2"/><path d="M30 27c0-3 4-3 4-6" stroke="#B99A6B" stroke-width="1.5" stroke-linecap="round"/><rect x="40" y="14" width="4" height="14" rx="2" fill="#C69A6B"/><rect x="45" y="16" width="4" height="12" rx="2" fill="#B5895A"/><circle cx="25" cy="20" r="5" fill="#7FA9A0"/></svg>`,
  alfombras: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="14" y="18" width="36" height="28" rx="3" fill="#EDE0CC" stroke="#C4A878" stroke-width="1.5"/><rect x="18" y="22" width="28" height="20" rx="2" fill="none" stroke="#C4A878" stroke-width="1"/><path d="M22 38c4-6 8-6 10-10s6-4 10 0" stroke="#B08D57" stroke-width="1.5" fill="none" stroke-linecap="round"/><path d="M22 42c4-6 8-6 10-10" stroke="#CDB68C" stroke-width="1.2" fill="none" stroke-linecap="round"/><rect x="14" y="16" width="36" height="3" fill="#B08D57"/><rect x="14" y="45" width="36" height="3" fill="#B08D57"/></svg>`,
  muebles: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="46" rx="18" ry="3" fill="#00000010"/><path d="M16 32c0-3 2-5 5-5h22c3 0 5 2 5 5v8H16v-8Z" fill="#D8DCCB" stroke="#8B9576" stroke-width="1.5"/><rect x="14" y="30" width="8" height="14" rx="3" fill="#C3C9B0" stroke="#8B9576" stroke-width="1.3"/><rect x="42" y="30" width="8" height="14" rx="3" fill="#C3C9B0" stroke="#8B9576" stroke-width="1.3"/><rect x="20" y="33" width="24" height="7" rx="2" fill="#E8EBDD"/><rect x="19" y="44" width="3" height="6" fill="#8B7355"/><rect x="42" y="44" width="3" height="6" fill="#8B7355"/></svg>`,
  ropa: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 16h12l8 6-4 6-3-2v20a2 2 0 0 1-2 2H27a2 2 0 0 1-2-2V26l-3 2-4-6 8-6Z" fill="#3D4E63" stroke="#2A3646" stroke-width="1.5" stroke-linejoin="round"/><path d="M26 16c0 3 2 5 6 5s6-2 6-5" fill="#4A5D75" stroke="#2A3646" stroke-width="1.3"/></svg>`,
  campamento: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="46" rx="18" ry="3" fill="#00000010"/><path d="M32 18 16 44h32L32 18Z" fill="#6B8E4E" stroke="#4A6533" stroke-width="1.5" stroke-linejoin="round"/><path d="M32 18v26" stroke="#4A6533" stroke-width="1.3"/><path d="M28 44l4-10 4 10" fill="#4A6533"/><path d="M14 44h36" stroke="#8B7355" stroke-width="2" stroke-linecap="round"/><circle cx="44" cy="24" r="3" fill="#E8B84B"/></svg>`,
  electronica: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="20" y="16" width="24" height="34" rx="4" fill="#3A3A3E" stroke="#222" stroke-width="1.5"/><rect x="24" y="20" width="16" height="10" rx="2" fill="#5A9FD4"/><circle cx="28" cy="38" r="2.5" fill="#888"/><circle cx="36" cy="38" r="2.5" fill="#888"/><rect x="26" y="44" width="12" height="3" rx="1.5" fill="#666"/></svg>`,
  ferreteria: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40 20a7 7 0 0 0-9 8l-13 13 4 4 13-13a7 7 0 0 0 8-9l-4 4-3-1-1-3 5-3Z" fill="#B0B4BA" stroke="#7A7E85" stroke-width="1.5" stroke-linejoin="round"/><rect x="18" y="40" width="8" height="10" rx="2" transform="rotate(-45 22 45)" fill="#C89A5B"/></svg>`,
  otros: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 26l14-7 14 7-14 7-14-7Z" fill="#D9C4A3" stroke="#B08D57" stroke-width="1.5" stroke-linejoin="round"/><path d="M18 26v14l14 7V33L18 26Z" fill="#C9B08A" stroke="#B08D57" stroke-width="1.5" stroke-linejoin="round"/><path d="M46 26v14l-14 7V33l14-7Z" fill="#E0CFAF" stroke="#B08D57" stroke-width="1.5" stroke-linejoin="round"/></svg>`
};
const DEPT_BG = { hogar:'#FCEBD8', alfombras:'#F3EAD8', muebles:'#E8EDDD', ropa:'#E4E8EF', campamento:'#E7EFD9', electronica:'#E5E5EA', ferreteria:'#EDEDF0', otros:'#F3EAD8' };
const DEPT_IMG = {
  hogar: 'data:image/jpeg;base64,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',
  alfombras: 'data:image/jpeg;base64,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',
  muebles: 'data:image/jpeg;base64,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',
  ropa: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCADIAMgDASIAAhEBAxEB/8QAHAAAAgIDAQEAAAAAAAAAAAAAAAUBBAIDBgcI/8QAPRAAAgEDAgMFBAcHAwUAAAAAAAECAwQRBSEGEjETQVFhcRUiMoEUU5GSobHBIzRCQ1LR8Acz4SY1RGJy/8QAGQEBAAMBAQAAAAAAAAAAAAAAAAECAwQF/8QAIREBAQACAgICAwEAAAAAAAAAAAECEQMxEiETUTJBYQT/2gAMAwEAAhEDEQA/APqkAyGQAAyGQAAyGQAADIAAZMZTjH4ml6sDIDTK6ox61I/Ix+m0P6/wZHlPtOqsAaPplH+v8DONenLpOP2jcNVsAM+AZJQADIZAADIZAADIZAADIZAADIAQBBIAAAAAD89ijdX0YZjSxKXj3Ii2TtMlvS5UnGnHM5KK8ylW1CK2pRz5sXVKk6knKcnJ+ZCMbyW9NJxz9t9W6rTe82l4LY0Sm+8khpMzttaa00Kq61RwoySxvKT3x8vE1cte1nzzuHXotrmU4KLgm8ZTWM9Vs0XFFRWI4S8jRVlKtUVKKxTi06kn396ivwz5epAtbp79TLJit2ZEjKE5Qfuya9GWad5Uj8eJIqAWmVnStkprSuqdTbPLLwZvEeSxQuZ08Jvmj4M0x5PtS4fRoBhSqxqxzF58vAzNd7ZgAAAYAAAAAAAAABEpKMW5PCROUt+4UX912suSHwL8SuWXjFscfKpvLx1cwp7Q/Mp9QJOa233W8knqAAAAyQ5qKzJ4REpcqbfQ4fjPiF2tJ06E0qsvdivMpllMZurY43K6h1rvFNjpMuzcpV7jq6VNrb/6fRfmI7P/AFEt/pE43On1YQnLPNTqKTWyXTCz0PPG5OblKcpzk25SfVt9Wasx7R+8m1htJ7o83L/ZnbvH1HpY/wCTCTWXuvoCwvLfULWFzaVY1aM+ko/k/BlhnknAOv8As3Vo21eeLS6ajLPSM+6X6M9cO/g5vlx3+3Dz8XxZa/SAJIN2IJTAghDOnUlCSlB4aGdtcKssPaa6oVExk4yUovDRfHLxVyx2dgabWuq0PCS6o3G8u2NmgAASAAAAADXXqKlSlJ9wFPU7jlXZwe76ismpN1JuT6sMHLll5V0YzxiUZEIlvBCUMiUlFZbK13e0rZe/LfwXUQ3upzuMxg+WPkymWci0xtZ8RavGhbVuyblKEXLlj5I81o22oa9qLdtbzr1X4fDBeLb2S82dbUW0otJpvKXjnqijo1KGj1ZxoTuLV5z2mXKNRdzbWfxOTlxvJZu+nTx5Tjl1PZ/oHA9naqNXVMXVdb9msqnH9ZfPbyG2s8NadqVLlqW1OMksRlBcrj6Y6CmvxS7Cxq3Vzd2jtaMeepVm1iK8XgSS/wBW9Aj8Ws6Sl49ozfDHCY+MjHLPO3ytVNV4OvbGUpW8fpdHw6TX6P8ABl/h7jerp1FWmrUa1WnBqEJ4xVi84UWnjPVLxN+s6/eXNk5219CjTqQUoyo4Taaymnu+h5lwXpN5qHH7uZXVadlav6RcupKUu0n/AC089+d/HETD45jl5cd03+Xyx1yTb6RjOMs8soyx1wycnKWlxOi5zhN5lJfYhxaarTm1Gr7svHuOuZy9uW4WGhiyYyUo5i014oC6gRJBJIzo1HTmpR6ob05qpBSj0YlLlhV5ZuD6Pp6l8MtXSmc37MAADdkAAAAWarVy1TT27xlJqMW/DcQXE3OrJvxM+W6mmnHN3bWSgZKOdql7CXWNVVv+xotOs19i8S9qVwra2lNvGEcFGvO5udQuFvOnTzFPy7jPPLXqL4Y79r8ZzrSqOUnKUJ8s8+Jkkugv0e67XX7mn/LrUo1F9g1rU+STMZ7a9K9SmpJlfnwuzqZ2e0l3f54F1GM6cKkcSQC27tYV7ecLi3pVqUlh80FOL9cr8yrPS+HHQi3pWmqbhH/x4Zzt5DV0qkJZpz/QyhGtndRz4l8crj0rlj5EV1a3d7i306lGjR+F1px5YQXku/0X4D7RtLtdKsFaWibWXOpUl8VSb6yf+bLYtQTl8csm1LHQrJpNu0LqEmZLoabmahBtgXLK+qWrdTmfZ8yi0+h1FKpGrBSg8prJwt/inptnHPxylUl6JYHHD2oS9k2NxU2jNuE/LL2Zphnq6Vzx3Nul6EEgbsUIyi8PK6mJIDmhU7SlGS7zMo6dP4oP1ReOjG7m2GU1QAAWQ0Xs+S3k/kI2NdWlijGPixUc/LfbbjnoYJbwgRQ1a6Vtbyed+4zt007I+I7vtpulF+5DeQj4e96nfSf8UWjZqE5RtqkpP35bt+Zlw3TxZ12+9M5bd5N5NQh4drN8RUk3uouH4na3kcPJ59w/L/qucf6Zs9Fu1mAw6M+y/JksNGtv3tzOO5KEpbmXeQ1hhkDNGSZqyTkDbli/UanuJPvL2dhVqL95eoqY3cTy7LS6LWzVHlXzZe0GLnwmod8VlCbjeriyso/1QQ84USejcmeqZE/Iv4uj0S7V3ZQy/fisMvnHaNd/Q7+dN/Dk7CMlOKa3TOjjy3GOc1WQEAaKN1rPlrwfngbiOLw0/AdxeYp+KNuOss4kAA0ULtY6Ul6i0Zauv9p+otObk/Jvh0iT5Yts5LVrv6VecsXmnTePmdJqPO7eUafVnHzpSt21UUvKRhyX9NsIo6vNcnKhhocOSxl5oV1069TGOj+0eWK5LKSx3GE7aXp5/wAMS7Xja+iv4JZPTbn/AGvkeXcC+9xnrdTwqxj+bPUrjej8icejLsmqPE9izSWYoX1ZvtkhjbLMSYUTNfT0N9RbbmiT3CBzGaWxpybV8AGUHltC/Ulhr1LdB/tkmaNWjhkVMJOO6uFo6WcSpP8ACX/KOm4PnmyUTlePv3HQKiX8dWH4Qf6MecHXDVPlb6Mies038W3VE6F8pJ43Op4fvlWpKlJrmXTzOf4iotw50vmMOF9MrqnGvcZorrGP8T8/I0w3MvSmWrj7dSyGAHSwA6oPNGD/APVCVDm32oU8+Brx9s82wAA1ZqOrLNGD8GKh3fw57aXluJTn5J7bcfSJJNYYv1CyhUpvZZGJrqrMcGdm2kcNd0XbXGeXMc7pDDEZWDqU5Jwa6oYX1h22dhPLSrmiqzjVcKcotNdcmFx013twXAqjT4g1med5XWPsiv7nplWWaBxGlWlO01WUaSwm2zsqssW3yKYrZEVR5uV6jm1+BCBzzdY8zoLRZghimiv0Kki3WWxTkEI7ywtqZWXQ3zlikwKtKpi8Xgb9Yimk/IpRli6T8xlqMOe1TwP0OZ43jz6BpLX8N7y58M05f2J4alV+mQp0cylPokdPbafDU9IdtUgpR51Jp/P+434e4ft9IpNUszqS+KpLrjuXoTOO5WUuck0uWdq2ousk2unkMYJRWxCWDI6ZNOe3aWyMkEkoZRHVJYpR9BNRjzVIodrZJG3FGfIAADVmiUeaLT7xBVi4VJRfczoBXqlLlmppbS6mfLNza/HfelAloxJOdsOVFHVIpW8vQYIoat+7S9CL0mdvOaW2sr5/mdJdSxQ+RzdLfV9v83Hd9UxQXocs/bopMveus+Z01kv2aOWtm5V16nVWXwE4oyFeO7F9V4kxlcLcXVtmyaRhDuyZ15NU9jVHOSa8vcISXKo1cR8MnSqPa2RydR4qp+Z1mlPtLVp9cEYmRhw3FRc4PwHon0aPLcS80ODp4/xYZ9ggkguoCSAAuafDmq57kNCtYU+Sll9WWTpwmoxyu6AACyoNdxSVWlKL69xsAdjnZxcZNPqiBlqdvn9rBeosOXLHxunRjdxkUNW/dZehfKGsPFpP0KXpadvOqX/dXjw/UYahP3EvIXW7b1Ob7kb7qbqTON0tdnBqon5nU2XwI523wpJHRWS91F8Vck3OzFtbqM7rCW4srdWTURpT3MKr2wzLp1NFw9mVWUqizM6fQZ/s8HO00nPoO9Ibg8dBj2ZdOj03a5a8mNBZYfvSfc0Mzpw6c+XYBgQXVBvtKXa1Uu5GmKcmkt2xxZ0VRp+bL4Y7qud1FiKwsIAA6GIAAAAyAAQ0mmnumKL61dKTlFZg/wABwROKlFqSymVyx8otjlpzqF+svFpP0Hl5aSpNygsw/IR61HNnP0OXOWeq3xsrzqntdVZL0LCjhZl1K1OaV5VjtlMsVW8f8nE6my3alVR0Nnsk89xzdlntOmfmdHZvEVlF8Vcmdw8i242Yxrp74xkXVZLOJY64JpFd95VuZJFxKMoLGE+jKNzFxznG3UpVmFpLFRZ6HQ2tLCUo9DnLRrtVnHh1Or07eK5UTijI00x5qRXethqKrHMbmOUNWdOHTDLsAtwSbeFuxjZ2eMTqI0xxuTPLKRNhbY9+fUvhjC2A6ZNTUY27AABKAAAAATgMAQBOAwBDSaw+gq1PS43EJcm2eqG2AwRljMpqpls9xwlTh62jN81PEvNGiroFFv3Yr7DvqtCFVe8l6lSWmxb2qNfI58uD6bTm+3ER4fgn3L0LEOH6D+PL+Z13s1fWv7pPs5fWv7pX4P4t8v8AXMU9Cso9aSfqbHotl9RD7Do/Zy+tf3Q9nL61/dJ+G/SPl/rmvYtmv5MPsNFbQbafSCXyOs9nL61/dD2avrX90fDfo+X+uLfDlHOyX2G6joFGHVyx5PB13s1fWv7oezl9a/ukfB/D5f6SWtlRtYvso4b6vqy5RpSqPEV8xjDT4LrJy+Rap04wWIo0x4vtTLk+la2tI095bstk4DBtJrplbtAE4DBIgCcBgCAJwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB//2Q==',
  campamento: 'data:image/jpeg;base64,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',
  electronica: 'data:image/jpeg;base64,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',
};
function _deptIconHTML(d, size){
  size = size||54;
  var img = DEPT_IMG[d];
  if(img){
    // Imagen real del departamento, recortada en círculo
    return '<div style="width:'+size+'px;height:'+size+'px;border-radius:50%;overflow:hidden;flex-shrink:0;background:#F3EAD8">'
      +'<img src="'+img+'" style="width:100%;height:100%;object-fit:cover;display:block" alt=""></div>';
  }
  // Fallback: dibujo SVG para los que no tienen imagen
  var svg = DEPT_SVG[d] || DEPT_SVG.otros;
  var bg = DEPT_BG[d] || '#F0F0F0';
  return '<div style="width:'+size+'px;height:'+size+'px;border-radius:50%;background:'+bg+';display:flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden">'
    +'<div style="width:'+Math.round(size*0.72)+'px;height:'+Math.round(size*0.72)+'px">'+svg+'</div></div>';
}

function dL(d){return d==='todos'?'Todos':(DEPT_LABELS[d]||d);}
const PASS_DEFAULT='kennedy2024';
function ini(n){const p=n.trim().split(' ');return p.length>=2?(p[0][0]+p[1][0]).toUpperCase():n.trim().slice(0,2).toUpperCase();}
const USERS=[
  {id:'edy',name:'Edy Guindi',email:'edy@kennedyzl.com',pass:'isla-vivo90',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'jimmy',name:'Jimmy Guindi',email:'jimmys@kennedyzl.com',pass:'uva-tenaz67',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'samuel',name:'Samuel Guindi',email:'samy@kennedyzl.com',pass:'flete-pleno59',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'eli',name:'Eli Guindi',email:'eli@kennedyzl.com',pass:'sable-justo81',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'itay',name:'Itay Guindi',email:'itay@kennedyzl.com',pass:'vela-bravo16',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'ariel',name:'Ariel Guindi',email:'ariel@kennedyzl.com',pass:'grulla-bravo13',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'saul',name:'Saul Noblesilla',email:'sano@kennedyzl.com',pass:'rumbo-bravo50',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'dan',name:'Dan Benzaquen',email:'dan@kennedyzl.com',pass:'isla-largo50',role:'gerencia',dept:null,color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'lorena',name:'Lorena Cabrera',email:'lorena@kennedyzl.com',pass:'barco-largo60',role:'compras',dept:'hogar',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'sherene',name:'Sherene Muor',email:'sherene@kennedyzl.com',pass:'duna-firme77',role:'compras',dept:'hogar',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'edgardo',name:'Edgardo Chiru',email:'furniture@kennedyzl.com',pass:'flete-tenaz41',role:'compras',dept:'muebles',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'zeida',name:'Zeida',email:'zeida@kennedyzl.com',pass:'vela-claro98',role:'compras',dept:'electronica',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'yagizel',name:'Yagizel Ortega',email:'yagizel@kennedyzl.com',pass:'rumbo-pleno46',role:'compras',dept:'ropa',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'henry',name:'Henry Pérez',email:'henry@kennedyzl.com',pass:'sable-doble53',role:'gerencia',dept:'ropa',color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'eimy',name:'Eimy English',email:'carpets2@kennedyzl.com',pass:'nudo-pleno45',role:'compras',dept:'alfombras',color:'#e6f1fb',tc:'#0c447c',nav:['dashboard','ordenes','completadas','pendientes','alertas','reposiciones','nueva'],verCostos:false},
  {id:'gady',name:'Gady Naor',email:'gady@kennedyzl.com',pass:'ancla-rapido37',role:'gerencia',dept:'alfombras',color:'#EAF3DE',tc:'#27500A',nav:['dashboard','ordenes','completadas','pendientes','deptos','alertas','reposiciones'],verCostos:true,canApprove:true},
  {id:'franco',name:'Franco',email:'nfranco@kennedyzl.com',pass:'duna-pleno80',role:'diseno',dept:null,depts:['hogar','muebles','homedeco'],color:'#EEEDFE',tc:'#3C3489',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'osmar',name:'Osmar',email:'osmar@kennedyzl.com',pass:'grulla-claro53',role:'diseno',dept:null,depts:['campamento','electronica','ropa'],color:'#EEEDFE',tc:'#3C3489',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'xinara',name:'Xinara',email:'diseno1@kennedyzl.com',pass:'nudo-pleno96',role:'diseno',dept:null,depts:['hogar'],color:'#EEEDFE',tc:'#3C3489',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'erwin',name:'Erwin',email:'diseno3@kennedyzl.com',pass:'uva-grande74',role:'diseno',dept:null,depts:['hogar'],color:'#EEEDFE',tc:'#3C3489',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'jamileth',name:'Jamileth',email:'jami@kennedyzl.com',pass:'marea-bravo60',role:'importacion',dept:null,color:'#E1F5EE',tc:'#085041',nav:['dashboard','ordenes','mistarea','deptos','alertas','reposiciones'],verCostos:false},
  {id:'nasly',name:'Nasly',email:'importacion2@kennedyzl.com',pass:'cedro-pleno63',role:'importacion',dept:null,color:'#E1F5EE',tc:'#085041',nav:['dashboard','ordenes','mistarea','deptos','alertas','reposiciones'],verCostos:false},
  {id:'yeini',name:'Yeini',email:'yeini@kennedyzl.com',pass:'duna-tenaz43',role:'contabilidad',dept:null,color:'#FBEAF0',tc:'#72243E',nav:['dashboard','ordenes','completadas','deptos','alertas','reposiciones'],verCostos:true},
  {id:'deici',name:'Deici',email:'contabilidad3@kennedyzl.com',pass:'puerto-rapido20',role:'contabilidad',dept:null,color:'#FBEAF0',tc:'#72243E',nav:['dashboard','ordenes','completadas','deptos','alertas','reposiciones'],verCostos:true},
  {id:'deicisoto',name:'Deici Soto',email:'deici@kennedyzl.com',pass:'marea-grande85',role:'contabilidad',dept:null,color:'#FBEAF0',tc:'#72243E',nav:['dashboard','ordenes','completadas','deptos','alertas','reposiciones'],verCostos:true},
  {id:'edwin',name:'Edwin Quintero',email:'edwin@kennedyzl.com',pass:'zafra-nuevo95',role:'bodega',dept:null,color:'#FEF3E8',tc:'#7C3D12',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'david',name:'David',email:'david@kennedyzl.com',pass:'duna-tenaz62',role:'bodega',dept:null,color:'#FEF3E8',tc:'#7C3D12',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'jhon',name:'Jhon',email:'john@kennedyzl.com',pass:'barco-firme97',role:'bodega',dept:null,color:'#FEF3E8',tc:'#7C3D12',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
  {id:'neder',name:'Neder',email:'neder@kennedyzl.com',pass:'duna-sereno82',role:'bodega',dept:null,color:'#FEF3E8',tc:'#7C3D12',nav:['dashboard','ordenes','mistarea','alertas','reposiciones'],verCostos:false},
];
USERS.forEach(u=>{if(!u.ini)u.ini=ini(u.name);});
// Diseño, importación, bodega y contabilidad NO tienen acceso a Reposiciones
USERS.forEach(function(u){
  if(['diseno','importacion','bodega','contabilidad'].indexOf(u.role)>=0){
    u.nav=(u.nav||[]).filter(function(n){ return n!=='reposiciones' && n!=='reppedidos'; });
  }
});
// Gerencia también accede a "Compras para firmar" (aprobar/firmar órdenes)
USERS.forEach(function(u){ if(u.role==='gerencia' && (u.nav||[]).indexOf('nueva')<0){ u.nav.push('nueva'); } });
USERS.forEach(function(u){ if((u.nav||[]).indexOf('livechat')<0) u.nav.push('livechat'); });
// Reportes: lo ven todos menos diseño, que no trabaja con embarques
USERS.forEach(function(u){
  if(u.role==='diseno') return;
  if((u.nav||[]).indexOf('reportes')<0) u.nav.push('reportes');
});
const SAP_STOCK={'Juego de sábanas premium':{stock:280,min:50,status:'high'},'Sofás esquineros':{stock:12,min:10,status:'low'},'Cuadros decorativos':{stock:0,min:20,status:'out'},'Colección verano':{stock:450,min:100,status:'high'},'Alfombras persas 3x4':{stock:8,min:15,status:'low'},'Televisores 55" Smart':{stock:35,min:20,status:'ok'}};

// ════════════════════════════════════════════════════════════════════
//  CORREO DESDE LAS ETAPAS
//  Se escribe y se envia sin salir de la ventana. El navegador no manda
//  el correo: lo deja en `correos_queue` y kennedy_live.py lo envia por
//  Brevo, que es el mecanismo que ya existia.
// ════════════════════════════════════════════════════════════════════
window._mailAdj = [];   // adjuntos elegidos: {nombre, mime, contenido(base64), kb}

function _mailEsc(t){
  return String(t==null?'':t).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function mailAbrir(oid, etapaKey, pasoIdx){
  var stage = STAGES.find(function(x){return x.key===etapaKey;}) || {};
  var paso  = (pasoIdx!=null && stage.steps) ? stage.steps[pasoIdx] : null;
  var o     = (typeof orders!=='undefined') ? orders.find(function(x){return x.id===oid;}) : null;
  window._mailAdj = [];

  var titulo = stage.label || etapaKey;
  if(paso) titulo += ' \u2192 ' + paso.name;

  // Asunto y cuerpo ya escritos, para no partir de cero
  var asunto = '[' + oid + '] ' + titulo;
  var cuerpo = 'Orden: ' + oid + '\n'
             + (o && o.desc ? ('Descripcion: ' + o.desc + '\n') : '')
             + (o && o.prov ? ('Proveedor: ' + o.prov + '\n') : '')
             + 'Etapa: ' + (stage.label||etapaKey) + '\n'
             + (paso ? ('Paso: ' + paso.name + '\n') : '')
             + '\n';

  // Destinatarios sugeridos: quien es responsable de la etapa
  var rolObjetivo = (paso && paso.role) || stage.alertRole || '';
  var chips = USERS.filter(function(u){ return u.email; }).map(function(u){
    var sug = rolObjetivo && u.role===rolObjetivo && u.id!==CU.id;
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 8px;border:0.5px solid var(--border);border-radius:8px;cursor:pointer;font-size:12px;background:var(--surface-2)">'
      +'<input type="checkbox" value="'+_mailEsc(u.email)+'" data-n="'+_mailEsc(u.name)+'"'+(sug?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(u.color||'#eee')+';color:'+(u.tc||'#333')+';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:600;flex-shrink:0">'
      +_mailEsc((u.name||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join(''))+'</span>'
      +'<span>'+_mailEsc(u.name)+'</span>'
      +'</label>';
  }).join('');

  var ov=document.createElement('div');
  ov.id='modalMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10000;display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:660px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">'
      +'<div style="font-size:15px;font-weight:600"><i class="ti ti-mail" style="color:var(--text-accent)"></i> Enviar correo</div>'
      +'<button onclick="mailCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'

    +'<div style="font-size:11.5px;color:var(--text-muted);background:var(--surface-1);border-radius:8px;padding:8px 10px;margin-bottom:12px">'
      +'<b>'+_mailEsc(titulo)+'</b> \u00b7 orden '+_mailEsc(oid)+'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_mailEsc(CU.name)+' &lt;'+_mailEsc(CU.email||'')+'&gt;'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">El correo sale con tu direcci\u00f3n, y las respuestas te llegan a ti.</div></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA \u2014 marca uno o varios</div>'
    +'<div id="mail-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px;max-height:170px;overflow-y:auto">'+chips+'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="mail-asunto" value="'+_mailEsc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);box-sizing:border-box">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="mail-cuerpo" rows="7" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);box-sizing:border-box;font-family:inherit;resize:vertical">'+_mailEsc(cuerpo)+'</textarea>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:6px">'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="mailCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="mail-btn" onclick="mailEnviar(\'' + oid + '\',\'' + etapaKey + '\',' + (pasoIdx==null?'null':pasoIdx) + ')"><i class="ti ti-send"></i> Enviar</button>'
    +'</div>'
  +'</div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) mailCerrar(); });
  document.body.appendChild(ov);
}

function mailCerrar(){
  var m=document.getElementById('modalMail'); if(m) m.remove();
  window._mailAdj=[];
}

function _mailMsg(txt, tipo){
  var m=document.getElementById('mail-msg'); if(!m) return;
  if(!txt){ m.style.display='none'; m.innerHTML=''; return; }
  m.style.display='block';
  m.style.color = tipo==='ok' ? '#27500A' : (tipo==='err' ? '#A32D2D' : 'var(--text-muted)');
  m.innerHTML=txt;
}

// Limite de Brevo por correo. Se avisa antes de enviar, no despues.
// Graph manda los adjuntos dentro de la propia petición: por encima de unos
// 3 MB puede rechazarlos. Antes eso BLOQUEABA el envío; ahora solo se avisa y
// se deja intentar, porque el resultado real lo devuelve la cola de correos.
var MAIL_AVISO_MB = 3;    // a partir de aquí se avisa
var MAIL_MAX_MB = 25;     // tope duro: por encima no se intenta

function mailAddFiles(files){
  var pend=Array.prototype.slice.call(files||[]);
  if(!pend.length) return;
  pend.forEach(function(f){
    var fr=new FileReader();
    fr.onload=function(){
      window._mailAdj.push({ nombre:f.name, mime:f.type||'application/octet-stream',
                             contenido:String(fr.result).split(',')[1]||'',
                             kb:Math.round(f.size/1024) });
      mailPintarAdjuntos();
    };
    fr.readAsDataURL(f);
  });
  var inp=document.getElementById('mail-files'); if(inp) inp.value='';
}

function mailQuitarAdj(i){ window._mailAdj.splice(i,1); mailPintarAdjuntos(); }

function mailPintarAdjuntos(){
  // Limpieza antes de pintar: nunca dos veces el mismo documento
  try{ window._mailAdj=_dedupDocs((window._mailAdj||[]).map(function(a){ return Object.assign({},a,{name:a.nombre}); }))
        .map(function(a){ var b=Object.assign({},a); delete b.name; return b; }); }catch(e){}
  var box=document.getElementById('mail-adjs'); if(!box) return;
  var totalKb=window._mailAdj.reduce(function(a,x){return a+(x.kb||0);},0);
  box.innerHTML=window._mailAdj.map(function(a,i){
    return '<div style="display:flex;align-items:center;gap:8px;font-size:12px;background:var(--surface-1);border-radius:7px;padding:5px 9px">'
      +'<i class="ti ti-paperclip" style="font-size:12px;color:var(--text-muted)"></i>'
      +'<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_mailEsc(a.nombre)+'</span>'
      +'<span style="color:var(--text-muted);font-size:10.5px">'+(a.kb>=1024?((a.kb/1024).toFixed(1)+' MB'):(a.kb+' KB'))+'</span>'
      +'<button onclick="mailQuitarAdj('+i+')" style="background:none;border:none;cursor:pointer;color:var(--text-danger);font-size:15px;line-height:1">&times;</button>'
      +'</div>';
  }).join('');
  if(window._mailAdj.length){
    var mb=(totalKb/1024).toFixed(1);
    var pasado=totalKb/1024 > MAIL_MAX_MB;
    box.innerHTML += '<div style="font-size:10.5px;margin-top:2px;color:'+(pasado?'var(--text-danger)':'var(--text-muted)')+'">'
      +'Total: '+mb+' MB'+(pasado?(' \u2014 pasa del l\u00edmite de '+MAIL_MAX_MB+' MB, quita alguno'):'')+'</div>';
  }
}

async function mailEnviar(oid, etapaKey, pasoIdx){
  var box=document.getElementById('mail-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ _mailMsg('Marca al menos un destinatario.','err'); return; }

  var asunto=(document.getElementById('mail-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('mail-cuerpo')||{}).value||'';
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }

  var totalKb=window._mailAdj.reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el l\u00edmite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('mail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando\u2026'; }
  _mailMsg('','info');

  var stage=STAGES.find(function(x){return x.key===etapaKey;})||{};
  var fila={
    docnum: String(oid),
    para_lista: marcados.map(function(c){return c.value;}),
    para_email: marcados[0].value,          // compatibilidad con lo anterior
    asunto: asunto,
    cuerpo: cuerpo,
    adjuntos: window._mailAdj.map(function(a){
      return {nombre:a.nombre, contenido:a.contenido, mime:a.mime};
    }),
    de_nombre: CU.name || '',
    de_email:  CU.email || '',
    origen: (stage.label||etapaKey) + (pasoIdx!=null && stage.steps ? (' \u2192 '+stage.steps[pasoIdx].name) : ''),
    estado: 'pendiente'
  };

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+KEY,'Content-Type':'application/json','Prefer':'return=representation'},
      body:JSON.stringify(fila)
    });
    if(!r.ok){
      var t=await r.text();
      _mailMsg('No se pudo enviar: '+t.slice(0,180),'err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
    var creado=await r.json();
    _mailSeguir((creado&&creado[0]&&creado[0].id)||null, marcados.length);
  }catch(e){
    _mailMsg('Error de conexi\u00f3n: '+e.message,'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
  }
}

// Espera a que el sync lo mande de verdad, para poder decir "enviado"
// en vez de "encolado".
async function _mailSeguir(id, nDest){
  var btn=document.getElementById('mail-btn');
  if(!id){
    _mailMsg('\u2713 En cola. Saldr\u00e1 en unos segundos.','ok');
    setTimeout(mailCerrar, 1800); return;
  }
  _mailMsg('Enviando\u2026','info');
  var intentos=0;
  var timer=setInterval(async function(){
    if(++intentos>20){
      clearInterval(timer);
      _mailMsg('Sigue en cola. Saldr\u00e1 en cuanto el sync lo procese.','info');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
    try{
      var r=await fetch(SB+'/rest/v1/correos_queue?select=estado,error_msg&id=eq.'+id+'&limit=1',{headers:SBH});
      var f=r.ok?(await r.json()):[];
      var row=(f&&f[0])||null; if(!row) return;
      if(row.estado==='enviado'){
        clearInterval(timer);
        _mailMsg('\u2713 Enviado a '+nDest+' destinatario(s).','ok');
        setTimeout(mailCerrar, 1500);
      }else if(row.estado==='error'){
        clearInterval(timer);
        _mailMsg('No se pudo enviar: '+(row.error_msg||'sin detalle'),'err');
        if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      }
    }catch(e){}
  },2500);
}

const STAGES=[
  {key:'pedido',label:'Pedido',icon:'ti-shopping-cart',color:'#2a78d6',resp:'Compras / Gerencia',alertRole:'compras',steps:[{name:'Pedido creado por compras',role:'compras',docs:[{icon:'📄',name:'Cotización.pdf',meta:'Proveedor'},{icon:'🖼️',name:'Foto.jpg',meta:'Ref'}]},{name:'Aprobado y firmado por gerencia',role:'gerencia',docs:[{icon:'📋',name:'PO-firmada.pdf',meta:'Oficial'}]}]},
  {key:'deposito',label:'Depósito & Pago',icon:'ti-coin',color:'#D4537E',resp:'Contabilidad',alertRole:'contabilidad',noBloquea:true,steps:[{name:'Solicitud de depósito enviada',role:'contabilidad',docs:[{icon:'💰',name:'Solicitud-pago.pdf',meta:'50%'}]},{name:'Depósito enviado al proveedor',role:'contabilidad',docs:[{icon:'🏦',name:'Comprobante.pdf',meta:'Transferencia'}]},{name:'Comprobante enviado al proveedor',role:'compras',docs:[{icon:'📤',name:'Comprobante-proveedor.pdf',meta:'Al proveedor'}]},{name:'Solicitud de final del balance',role:'contabilidad',docs:[{icon:'🏦',name:'Pago-final.pdf',meta:'BL/Embarque'}]},{name:'Comprobante de pago final',role:'compras',docs:[{icon:'📤',name:'Pago-final-proveedor.pdf',meta:'Al proveedor'}]}]},
  {key:'artes',label:'Artes',icon:'ti-palette',color:'#7F77DD',resp:'Diseño / Gerencia',alertRole:'diseno',hasArte:true,steps:[{name:'HUB de diseño',role:'diseno',docs:[{icon:'🎨',name:'Brief.pdf',meta:'Specs'}]},{name:'Artes terminados',role:'diseno',docs:[{icon:'🎨',name:'Arte-final.pdf',meta:'PDF'}]},{name:'Artes aprobados por gerencia',role:'gerencia',docs:[{icon:'🎨',name:'Arte-APROBADO.pdf',meta:'Sello'}]},{name:'Artes enviados al proveedor',role:'compras',docs:[{icon:'📧',name:'Email-confirmado.pdf',meta:'Recepción'}]}]},
  {key:'produccion',label:'Producción',icon:'ti-tool',color:'#BA7517',resp:'Compras / Gerencia',alertRole:'compras',steps:[{name:'Producción terminada — Inspección de producción finalizada',role:'compras',docs:[{icon:'📸',name:'Inspeccion.jpg',meta:'Fotos'}]}]},
  {key:'logistica',label:'Logística',icon:'ti-ship',color:'#1D9E75',resp:'Importación',alertRole:'importacion',steps:[{name:'Booking',role:'importacion',docs:[{icon:'🚢',name:'Booking.pdf',meta:'Naviera'}]},{name:'Bill of Lading (B/L)',role:'importacion',docs:[{icon:'📄',name:'BL.pdf',meta:'B/L'}]},{name:'Aviso de llegada',role:'importacion',docs:[{icon:'🏴',name:'Arrival-notice.pdf',meta:'Puerto'}]}]},
  {key:'costeo',label:'Aduanización & Costeo',icon:'ti-table',color:'#7C3D12',resp:'Importación / Gerencia',alertRole:'importacion',steps:[{name:'DMCE y SIGA',role:'importacion',docs:[{icon:'📋',name:'DMCE.pdf',meta:'Aduana'}]},{name:'DMCE de salida',role:'importacion',docs:[{icon:'📤',name:'DMCE-salida.pdf',meta:'Salida'}]},{name:'Costeo de importación',role:'importacion',docs:[{icon:'📊',name:'Costeo.xlsx',meta:'Excel'}]},{name:'Precios de venta por gerencia',role:'gerencia',docs:[{icon:'📊',name:'Costeo-precios.xlsx',meta:'PVP'}]}]},
  {key:'bodega',label:'Bodega & Venta',icon:'ti-building-warehouse',color:'#3B6D11',resp:'Bodega / Ventas',alertRole:'bodega',steps:[{name:'Recibido en bodega',role:'bodega',docs:[{icon:'📋',name:'Recibo-bodega.pdf',meta:'Firmado'}]},{name:'Disponible en SAP',role:'contabilidad',docs:[{icon:'📊',name:'SAP-disponible.pdf',meta:'Inventario'}]},{name:'En sala de venta',role:'bodega',docs:[{icon:'📸',name:'Foto-sala.jpg',meta:'Sala'}]}]},
];
function fmt(v){return'$'+Number(v).toLocaleString();}
function fmtS(v){
  var n=Math.abs(v);
  if(n>=1000000)return'$'+(v/1000000).toFixed(1)+'M';
  if(n>=100000)return'$'+(v/1000).toFixed(0)+'k';
  if(n>=10000)return'$'+(v/1000).toFixed(1)+'k';
  return'$'+Number(v).toLocaleString();
}
function fmtK(v){return v>=1000?'$'+(v/1000).toFixed(0)+'k':'$'+v.toLocaleString();}
function now2(){const d=new Date();return d.toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'})+' · '+d.toLocaleTimeString('es-PA',{hour:'2-digit',minute:'2-digit'});}
function dateOnly(){return new Date().toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'});}
function pct(a,b){return b>0?Math.round((a/b)*100):0;}
function parseDateStr(s){if(!s)return null;const mo={ene:0,feb:1,mar:2,abr:3,may:4,jun:5,jul:6,ago:7,sep:8,oct:9,nov:10,dic:11};const p=(s+'').replace(/·.*/,'').trim().split(' ');if(p.length<3)return null;return new Date(parseInt(p[2]),mo[p[1]?.toLowerCase()],parseInt(p[0]));}
function daysBetween(from,to){const f=parseDateStr(from),t=to?parseDateStr(to):new Date();if(!f)return 0;return Math.max(0,Math.round((t-f)/86400000));}
function diasBadge(days){if(days>14)return`<span class="dias-badge dias-late"><i class="ti ti-alert-triangle" style="font-size:10px"></i>${days}d</span>`;if(days>5)return`<span class="dias-badge dias-warn"><i class="ti ti-clock" style="font-size:10px"></i>${days}d</span>`;return`<span class="dias-badge dias-ok"><i class="ti ti-clock" style="font-size:10px"></i>${days}d</span>`;}
function sapChip(desc){const s=SAP_STOCK[desc];if(!s)return'';if(s.status==='high')return`<span class="sap-chip sap-ok"><i class="ti ti-package" style="font-size:10px"></i>SAP: ${s.stock}</span>`;if(s.status==='low')return`<span class="sap-chip sap-warn"><i class="ti ti-alert-triangle" style="font-size:10px"></i>SAP: ${s.stock} bajo</span>`;return`<span class="sap-chip sap-low"><i class="ti ti-circle-x" style="font-size:10px"></i>SAP: agotado</span>`;}
function pills2(active,fn,id,depts,showCount){var lista=depts||['todos',..._deptsVisibles()];
  // Si el usuario tiene un solo departamento, no tiene sentido ofrecerle
  // los demás: se le quitan de cualquier lista que le llegue.
  try{ if(_deptAcotado()) lista=lista.filter(function(x){ return x==='todos' || _deptPermitido(x); }); }catch(e){}return`<div class="filters" id="${id}">${lista.map(d=>{var cnt='';if(showCount){var n=vO().filter(o=>!o.completada&&!o.pend&&(d==='todos'||o.dept===d)).length;cnt=` <span style="background:rgba(0,0,0,.08);border-radius:8px;padding:0 5px;font-size:9px;font-weight:600">${n}</span>`;}return`<span class="pill ${d===active?'active':''}" onclick="${fn}(this,'${d}')">${dL(d)}${cnt}</span>`;}).join('')}</div>`;}
function canSeeStage(k){if(!CU)return false;if(CU.role==='diseno')return k==='pedido'||k==='artes';if(CU.role==='bodega')return k==='bodega';// Contabilidad no trabaja artes ni producción: se le ocultan
if(CU.role==='contabilidad')return k!=='artes'&&k!=='produccion';return true;}
function stagesForUser(){return STAGES.filter(s=>canSeeStage(s.key));}
let CU=null,PG='dashboard',NID=130,activeDashStage=null,dashStageDept='todos',_deptoAutoAbrir=null;
let dO='todos',dC='todos',dA='todos',dAdept='todos',dAuser='todos',dP='todos',dMT='todos',dComp='todos',searchQuery='';
let contabFilter='all',dashKpiFilter=null,_dSQ='',_dSort='nuevo',_dEst='todos',_dMF=null,_dMD=null;
let firmas={},notifications=[],costeoData={},stageProgress={},recordatorios={};
// Los avisos internos ahora también se guardan en base: antes vivían solo en
// memoria y se perdían al recargar la página. Los dos sistemas quedan unidos.
function addNotif(to,msg,oid,icon='ti-bell',yaPersistido){
  notifications.push({to,msg,oid,icon,time:now2(),read:false,id:Date.now()});
  // El respaldo persistente. Se omite donde ya se manda un aviso propio,
  // para no avisar dos veces de lo mismo.
  if(!yaPersistido){ try{ _notifPersistir(to,msg,oid); }catch(e){} }
}

// Guarda el aviso en la tabla de menciones, para que sobreviva a la recarga
function _notifPersistir(to,msg,oid){
  if(!to || !msg) return;
  // Los destinatarios pueden ser un rol o un usuario concreto
  var destinos=(USERS||[]).filter(function(u){
    if(!u.id) return false;
    if(u.id===to) return true;
    if((u.role||'')===to) return true;
    return false;
  }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
  if(!destinos.length) return;

  // Sin await: es un respaldo, no debe frenar la acción del usuario
  _menNotificar(destinos, {
    docnum:oid||'', contexto:'aviso',
    texto:String(msg).replace(/^[^\w\d]+\s*/,'').slice(0,300),
    etiqueta:'Aviso del portal'
  }).catch(function(e){ console.warn('[aviso] no se pudo guardar:', e); });
}
function unreadN(){return notifications.filter(n=>!n.read&&(n.to===CU?.role||n.to===CU?.id)).length;}
function initP(oid){if(!stageProgress[oid]){stageProgress[oid]={};STAGES.forEach(s=>{stageProgress[oid][s.key]={stepIdx:0,comments:[],startDate:'',stepDates:Array(s.steps.length).fill('')};});}}
function getStageIdx(o){initP(o.id);const sp=stageProgress[o.id];for(let i=0;i<STAGES.length;i++){
  // Si la etapa tiene noBloquea (ej: depósito) y ya se hizo al menos 1 paso, sigue avanzando
  var noBloquea=STAGES[i].noBloquea&&sp[STAGES[i].key].stepIdx>=1;
  if(!noBloquea&&sp[STAGES[i].key].stepIdx<STAGES[i].steps.length)return i;
}return STAGES.length-1;}
function getStageName(o){if(o.pend)return'Sin firmar';if(o.completada)return'Completada';return STAGES[getStageIdx(o)]?.label||'';}
function getPct(o){if(o.completada)return 100;initP(o.id);const sp=stageProgress[o.id];let total=0,done=0;STAGES.forEach(s=>{total+=s.steps.length;done+=Math.min(sp[s.key].stepIdx,s.steps.length);});return Math.round((done/total)*100);}
function getSem(o){
  if(o.pend)return'sem-y';if(o.completada)return'sem-g';
  // Si depósito tiene pasos pero falta pago final → amarillo
  initP(o.id);var sp=stageProgress[o.id];
  var dep=sp&&sp.deposito;
  if(dep&&dep.stepIdx>=1&&dep.stepIdx<STAGES.find(function(s){return s.key==='deposito';}).steps.length)return'sem-y';
  return'sem-y';
}
function getStageColor(o){if(o.completada)return'#534AB7';if(o.pend)return'#eda100';return STAGES[getStageIdx(o)]?.color||'#2a78d6';}
function getStageStartEnd(o,k){initP(o.id);const sp=stageProgress[o.id][k];if(!sp)return{start:'',end:'',days:0,active:false,done:false};const start=sp.startDate||'';const steps=STAGES.find(s=>s.key===k)?.steps||[];const done=sp.stepIdx>=steps.length;const end=done?(sp.stepDates?.[sp.stepIdx-1]||''):'';return{start,end,days:start?daysBetween(start,end||null):0,active:!done&&!!start,done};}
let orders=[
  // Órdenes demo de prueba eliminadas — los datos reales vienen de Supabase (SAP)
];
function setupDemo(){
  initP('OC-2024-0115');const p1=stageProgress['OC-2024-0115'];p1.pedido={stepIdx:2,comments:[{autor:'Lorena (Compras)',ini:'LO',texto:'Pedido creado.',time:'02 jun 2024'}],startDate:'02 jun 2024',stepDates:['02 jun 2024','03 jun 2024']};p1.deposito={stepIdx:2,comments:[],startDate:'05 jun 2024',stepDates:['05 jun 2024','06 jun 2024']};p1.artes={stepIdx:0,comments:[],startDate:'07 jun 2024',stepDates:['','','','']};
  initP('OC-2024-0112');const p2=stageProgress['OC-2024-0112'];p2.pedido={stepIdx:2,comments:[],startDate:'08 jun 2024',stepDates:['08 jun 2024','09 jun 2024']};p2.deposito={stepIdx:2,comments:[],startDate:'10 jun 2024',stepDates:['10 jun 2024','11 jun 2024']};p2.artes={stepIdx:2,comments:[{autor:'Franco (Diseño)',ini:'FR',texto:'V2 lista.',time:'14 jun 2024'}],startDate:'12 jun 2024',stepDates:['12 jun 2024','14 jun 2024','','']};
  initP('OC-2024-0089');const p89=stageProgress['OC-2024-0089'];p89.pedido={stepIdx:2,comments:[],startDate:'18 may 2024',stepDates:['18 may 2024','19 may 2024']};p89.deposito={stepIdx:2,comments:[],startDate:'20 may 2024',stepDates:['20 may 2024','21 may 2024']};p89.artes={stepIdx:4,comments:[],startDate:'23 may 2024',stepDates:['23 may','24 may','25 may','26 may']};p89.produccion={stepIdx:2,comments:[],startDate:'01 jun 2024',stepDates:['01 jun 2024','10 jun 2024']};p89.logistica={stepIdx:6,comments:[],startDate:'12 jun 2024',stepDates:['12 jun','14 jun','16 jun','18 jun','19 jun','20 jun']};p89.costeo={stepIdx:1,comments:[{autor:'Jamileth',ini:'JA',texto:'Costeo subido.',time:'23 jun 2024'}],startDate:'22 jun 2024',stepDates:['22 jun 2024','23 jun 2024','','']};
  costeoData['OC-2024-0089']={status:'uploaded',uploadedBy:'Jamileth',uploadDate:'23 jun 2024',pricedBy:'',items:[{sku:'ALF-001',desc:'Alfombra persa 3x4 — Floral',costo:180,precioVenta:0,unidades:60},{sku:'ALF-002',desc:'Alfombra persa 3x4 — Geométrico',costo:195,precioVenta:0,unidades:50},{sku:'ALF-003',desc:'Alfombra persa 3x4 — Tradicional',costo:210,precioVenta:0,unidades:40}]};
  notifications.push({to:'gerencia',msg:'OC-2024-0089 — Costeo de Alfombras listo. Asignar precios.',oid:'OC-2024-0089',icon:'ti-table',time:'23 jun 2024 · 9:05am',read:false,id:1001});
  initP('OC-2024-0071');STAGES.forEach((s,i)=>{if(i<6)stageProgress['OC-2024-0071'][s.key]={stepIdx:s.steps.length,comments:[],startDate:`0${i+1} may 2024`,stepDates:s.steps.map((_,j)=>`${j+1} jun 2024`)};});stageProgress['OC-2024-0071'].bodega={stepIdx:0,comments:[],startDate:'22 jun 2024',stepDates:['','','']};
  initP('OC-2024-0107');stageProgress['OC-2024-0107'].pedido={stepIdx:2,comments:[],startDate:'10 jun 2024',stepDates:['10 jun','11 jun']};stageProgress['OC-2024-0107'].deposito={stepIdx:0,comments:[],startDate:'12 jun 2024',stepDates:['','']};
  initP('OC-2024-0040');stageProgress['OC-2024-0040'].pedido={stepIdx:2,comments:[],startDate:'01 abr 2024',stepDates:['01 abr','02 abr']};stageProgress['OC-2024-0040'].deposito={stepIdx:0,comments:[],startDate:'03 abr 2024',stepDates:['','']};
  initP('OC-2024-0109');const p09=stageProgress['OC-2024-0109'];p09.pedido={stepIdx:2,comments:[],startDate:'01 jun 2024',stepDates:['01 jun','02 jun']};p09.deposito={stepIdx:2,comments:[],startDate:'03 jun 2024',stepDates:['03 jun','04 jun']};p09.artes={stepIdx:4,comments:[],startDate:'06 jun 2024',stepDates:['06 jun','07 jun','08 jun','09 jun']};p09.produccion={stepIdx:1,comments:[],startDate:'10 jun 2024',stepDates:['10 jun 2024','']};
  initP('OC-2024-0055');STAGES.forEach(s=>{stageProgress['OC-2024-0055'][s.key]={stepIdx:s.steps.length,comments:[],startDate:'01 abr 2024',stepDates:s.steps.map((_,j)=>`0${j+1} may 2024`)};});
  initP('OC-2024-0048');STAGES.forEach(s=>{stageProgress['OC-2024-0048'][s.key]={stepIdx:s.steps.length,comments:[],startDate:'01 mar 2024',stepDates:s.steps.map((_,j)=>`0${j+1} abr 2024`)};});
}
// setupDemo();  // DESACTIVADO: los datos ahora vienen de Supabase
function vO(){if(!CU)return[];
  // Las NO SAP viven en su propio listado: se excluyen de las vistas de SAP
  var base=(orders||[]).filter(function(o){return !o._noSap;});
  return _deptAcotado()?base.filter(function(o){return _deptPermitido(o.dept);}):base;}
function pCnt(){return vO().filter(o=>o.pend).length;}
// ── Logo corporativo incrustado (PNG optimizado, sin dependencias externas) ──
var KCC_LOGO='data:image/png;base64,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';
var KCC_GLOBO='data:image/png;base64,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';

// Logo de la pantalla de entrada (K-Flow). El de Kennedy Center sigue
// usándose en la barra de arriba y en los catálogos en PDF.
var KFLOW_LOGO='data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAQDAwQDAwQEBAQFBQQFBwsHBwYGBw4KCggLEA4RERAOEA8SFBoWEhMYEw8QFh8XGBsbHR0dERYgIh8cIhocHRz/2wBDAQUFBQcGBw0HBw0cEhASHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBz/wAARCAG6AjADASIAAhEBAxEB/8QAHQABAAICAwEBAAAAAAAAAAAAAAcIAQYEBQkDAv/EAGgQAAEDAwIDBQQEBwkKBg8GBwECAwQABREGBxIhMQgTQVFhFCJxgTJCkaEVI1JicoKxFhczkqKjs8HRJENTY3WDssLS0yUmNGVzwxgnN0RFRkdVZGZ0k5XU8DVUhZSk4TZ2hLTE4vH/xAAaAQEAAwEBAQAAAAAAAAAAAAAAAQIDBQQG/8QALBEBAQACAQQBBAICAgIDAAAAAAECEQMEEiExQQUTMlEiM2FxFCNSkRViof/aAAwDAQACEQMRAD8Av5SlBQKUpQKUFKBSlKBSlMUClMUoFKUoFKUoFKUoFKUoFKUoFKUoFKUFApTrX5WtLaVKUoBKRkknkB50H7FYJ51B2v8AtN6X0u77BZXG73dVkoSGngmOFDljvPrnPggH4ioRvO5ms9wy6mbdVx4RUUqhQD3TY/NVg8Sv1j8q1w4csmWXLMVqdTbu6N0mtTNxvkYy0/8Ae0bLzufIpRnHzxUfTe0g1LUtFh05KkDwdmuhlPx4U8R/ZUK6f0I2tSVFAxnOMVKtk0cy2lPC2Bj0recOGPvyxvLnl6fqTvhuFLa7m06MtKpAAzIlXEoaJPkjBVy9a/WjNx909Rz3I+oLLFsDSOL32B34cA5BSF8JTzP1VEKxzxW627S6U8PuDHwrZ4tjbQBhIyPSq2YRaXOqnbyXW4i/w3bDqrW0+43F0CZAtzEpXs6CCnv+6UzwJZSQCUoHEs8gRkmtRmyLtoLV1ps91v6nG773DtmvkvvERJzTnJTj6DxllaTyS2UHJIzwjnV6brc7fpmzyblebi1BtsVPG6/Ic4UIHqT+zqaqpr3tbaI1dfLTpy12xybb2pqZL19uNtMhqEps5Q8yxkFxYOSCojhHPhV9Gsrb8NJP24mvNJbl6getlv2/1posiBJUHYNtnhqdICTy7wuAkKPPibzgH05DvjunrbT1/hWm67b3+2ROAJkz49y5oUPpLQgkpcR4+6fSq33K4S7tu9M1RFv8m8XPUKzb3jG0y0mSAeBDQTHfV3XErgbwvjyDk4zVqtC7r2ODt5btNbgP6psN3RxJYumt4q4okvJWVJUH0HgASrA4SoHhGOfjHdYtcZW5aM3Qj6tuNwtmm9Xt3K420BUmFMjcLraTjmQQkkc8EgnBrc/3dT7crhudnUsD++Ql8X8lWP21Snc/eiZpHVxYdv0OyXn2dxhnUNmtzFwQoKOHE96hSFKRyQoBTfEk9CoczKOynantN/bj2HWU2LcLg0j/AO3IDSkNyB+U4yUhSCB1IB6E4A51beN9xXVnqrLaW3J0vrF1+PaLzFkTI6y29EKwl9lYOClTZ5gg1tQIzyqnO4u01hlaxk7m6TtcTV8G9gCU8zeOcRwcIBbIPAEkJxzWgpPLiAIxrWid5dztI7iq0zcrnbYtlkFxcaFqhuQw8xge613i1KXwnp3iVOoB9DgU7d+YvLflew1ioy0tvZY71Lett0WzarvHUEPNe1NyGAT0w8g8OCMY4wgnPSpMQtKwCnmCM5FV1Yttms+FYNKgKUpQKUpQKUpQKUpQKUpQKUpQKUpQKUpQKUpigUpSgUpSgUrOKxQKzjlWKUClKUDGayaxSgUpSgUoKUClKUAUpSgUpSgUpSgUpSgUpSgUpWetA6UHWg9a6bU2qbVpK1quN2lpjxwoISMFS3Vn6KEIHNayeQSkEmg59zfkRrfKehxfapbbSltR+MI75YBKUcR5JycDJ6ZqlW4upNxdwXZlpuF9gR+6STJsOmx7Q3DTj/vuatSGEEePEojyHhX23n7TqW5Um1yTIab5oFggSAh5X/tslOe6H+JayrwUpNVP1XqvWe5MyLZWWlC1JVxRrHaWe5htevdp5KP56ypR861xxs8s7ZfBNt2jtO3tl3UOqp2qbyXQhMHTS1JjM5OOFUxQy4cHGGUHPQKGat5ovSES1W6LDhRFRojacoZXkqTk5PESSSrnzySahvQXZjm2a72O7arfbiyWpLL6LYnJdPVSeM9E/RBA6nwq21ntfARkZz1NbcXjdZcnnUcmx2JKAnCfurf7baUpAOOdcW0QgnHKtuisgfCozyTji/DEIAdMCuahpKK+nSlee5WtpjpD3aE2fmbu6dtkSBOSzItsv2pMZ9wpjv5QU++AkklIOU+GSc1UHVm1t/29lNRL5D7gPJy062vjZcHiEqHLI8jg+lej4rjzIEa4MKYlx2pDCvpNuoC0n5EYpjlouO3mYxYH4f8AdcNyRGksYcaciEIdSpJ4k8CvA5HLPKvQLQOs7FvFoSLeYsRbltnhxmRCuDKSptxCihxpxBykkKBHiDUPdorQMPTFhY1Bp60sxGY5cRKEWOtwAqx3S1ISCAgKBClcgArnU5bdC3uaJsMi12lNohy4bUpMAM9z3JcSFqSUdQrKjnPPNWyss2jGWILk9irRa9VSJbTbCNPzEP8AfwQzwuNLWctllSSEpCD0BSeXI5zmqu7xdmZG2N4jsrfVFi3B0s2+7Af3O4vqG3Ck8TS8eYIPgfL0/wDSuq1Bpy1aqtj1svNvjXCA8MLjyWwtJ9cHofUcxVZkm47eRK9ObkaPaLbEyU1EbWVodjKCkg+Pvp5j4E1NOkO1NJh2u32HcjSts1HaIobS24hpKH2+AAJVwqyhSgAPe91X51Wl1zsLEgQ13DS4lJdb4QYHEXOJPQlCieLkOeCTnFVh1ptpGuMhxu52zgWM/j44DTg88/VV8xn1rSavpS7jcndr9ot+5Dl52z1OrTesCniLDKyw6D5LZJyR4ZTxD1raEbh6i7Mtis0bV4u02LxpjSHu77+E55utrHNkn8jJB8E5yaqxN2olWNw3O1FyazG/Gd8xxJdj8+SlJHNPP6wJHrUiaD7VN+tAOn9cwUaq0s6nunUykhchCOhGVcnRjwXz/OFO02vroHcvTm5FrRPsFxalIx77YV76D5EdR/8AXIVt45mqWs2TTdq0RcdUbGNJff78ymY8N0pfiPkJCmFpWc92oD+CXjBGUK51MWxu/aNxbNCZ1DCVZtROd4gx3vdDym1cKykHmMHqCAefzNLj8xeZfCcPGsYrI86xVFilOtKBSlKBSlKBSlKBSlKBSlKBSlKBSlKBSlKBSlKBSlKBSlKBTFKUClKUClKUClKUClOlKBSlKBSlKBSlKBTFKUClKYoArPwpitP3M1irQ+kLndWBHcnMsqWw0+vhSojmonmOSU5UeY6YyMik8lfTXuvLdoKyrnTCHZCgruIwcSgulIySVK5IQkc1LVySPUgHzv3T37vesbw85DnuJeIU2Lg0FNlptXVqKk82UEci4fxrniUJ9ys7lbtz90kIkWy6C7NKIKo8taYrqwDxAcA9zCT9FsK5EZPErmNTnWx9Ey2WuzwfadU3QJU0lTZW3EB+sRjC3PTmE9Tk8q2xx15ZXLbi6f27VcmY8iY04hlZy0ygpStweZKuSEfnK6+APWrc7b6l2l2ctCVypLMm+8HeOKjx8hCsfQQSckjpxqOT4YHKt92V7Oto0VpVA1Iwm7X2aEuynJRK+FXl168zmvxqrbvSOn7+zHsWn7fEedPtstxtBUsuZw2MkkAclHA8h80syui/xm2vKtx1bqVGoJbMlpJmG4RI7yuFbRUjhT3gBwVJBOBzA5eI5SbbYvAlIxXBtdr5BRBzWzRo/dgcq1tkmmUnzXaW9rhArv2eQro4yuGu2YeGOtZZtcfDmUr8pWDX6zWOmpSlKDHCDyr9AYrFZzQYUQMmoWuuqtzNaX24I0C1YrXpi2LWwLve2HZBuchJwpLDTakkNJVlPeEniUDwggc5pPnWl7hbn6U2ts/4Q1JcG4jXCe5YQON57hHMIbHM48+QHiRQVkmao3H3f09qiz3bUEODaIkdxtT9jt0mIuRJCFfiFqfwtKUKA4wAM5AzjNS4rRidSaNtF6jMvKTOgx3jFeWlx9tRZT0WkkOEgZOCc5J51pgnaD3Qh/u8Qxc0u3uRiBHsbvfzZDTQQlbr8fmEKSQpJAzgcPMqNRteNB3qNcI0KNIuVth2ta1WmBMklxy1NqVxJS04noU55EEkdMkCtZP0zt06+8XdzbvUypUaYiJJaWpCmn/cz5pWhXgR1BHjW53XazR29lge1BpBqND1C2jjlQY+Clw+KkDPPn4dfXoDrk06u4CiXKtlzcyVLeuMJp91xXmpS2iSfn4V1C9Qa4tkR5NsbsMB/JH9z21ptRyOuUJT1xir6qm0PQIOsdpdTqvlllKhPDKQtr32JbYOFIWg8lpyMFKhkH8k1MsW5WTfd6BfLM4/p/cez5dftLb6u7mNj6a45PMnHP8AKT48aa/dmsMi8WVdwuWoYEhQSt6fYn7emGXQerzToPvODrxdcZBChUIa00rLsVxj6j09dXXIYf44U+Me7cYdQc8Csc23E+Xj1GRRK7Wx3aPh3+7y9FaolCNqCCrgaXIR3KpCB4lJ5ZHjgkeI93pZTrXnrpLWEXdFcO8GLGhbpWRhwud2gNousYoKXFpAHJWDlSR0PvgcPEBO/Z47QD2rp03SOpbdIt13gZLDjnNt1riCQOLwIJAxz+kBkjFUzw+Ytjl8LJ0rIxisHrWTQpSlApSlApWfCsUClKUClKUClKcqBTNKUClKUClKUClZxWKBSlBQKUpQKUpQKUpQKUpQKUrNBilKUClKUCgpSgeNKUoM4pg061+VrDSFLWoBKRkknAFB119vcTT1sfuE1wpZZGcDHEs+CRnxP/8A3lk15sb+b6S91by5ChvYsDLmMNk8Mog5HPxaSeY/LPvn6gTInaq30Oo7m5pGzSlexIHDJUg49xQ+j+ksHn5NkDq4oDRdn9sYiLXcNxNUs50vZE941HVy9uf6NtD0KiAfT5VpjNeWeV34RtJ0fA0rZHEO2VcjUN3YQuIyXFJbhpWoYeWAclRAPCnkOYJz0qzWgey9q246LtV5iarcst1dAdbjkLUhPkoKzxIJ/wD3rqNjdBzd09w371ewXoiXTMlqxhKjn3Wx5DokDwA9Kvm22lpAQhISlIwAkYAHkKnLPXomO/aslu/f128jlNwiSNVxGvrwpbLjhA/MdTxE/rCt+sSH9RxmLvLaWiXPQiQ4hQAKCpIwg4JxwjA6npUrXB0NQZLhSTwNKVyGScAmtf0Xb2Rpy1KQpDiDFZKVoOUqHAOYPiKY5e7TLH4hDtQbbHKvo8yGq2EtpQk4ArW7vKS3nn0qZluos0+IkBB61ymJnrWqruGVda+zE/P1qvpTbcm5fTnXITK9a1dqd61yUzfWq9q3c2ESR51+hJHnXRCWPOv17Z61Hanud6JAOOdfVKwa19Mvn1rmsy8+NRcEzJ8tV6usuh7FJvd/uDUC1xikOPugkAqUEpAABJJUQAAMkmoD1hp7T+9WmNdXyPpy8x7n7GwGZF6gLjrUloLWEMpX9RSTxe7jJWOLmMDsN+rBudrLUGnYWgZ8aBEtI9vlOLcSFreUVIbASrlhISog+Z8xXXRY/aEtcdDDrFmuSUpwpbrznGv44dx91Vk0tvbTOz/bbfoW26PctpWGNRx3WJaHFcRRLZX74SccknksJ/PNWRl2mJeGkiQwlwZ90kc0nzB8KqpYbxcWYetrDL041Zbvoi5Qrq1GjyXFBxC0hp9SVrKykcKmycZHLOKtnZ0SnorRRGRwEAgmXnI+yrfG1f8ACGtRabdttxcZdbISokoX4KHxrXtQ6OusSGmabbJEYJ4i4G+WP/rxqx95sjU2KhuZES4gKCgA+oEEeoxXJfV3iAe7ZPLGDk/KpmaOxXzbjcW1xJqNJarXGkWx9sezmbwrSwok8hxcwg5Hw+FaBvbtZK0driPctJ2WTeNMagHdTrVBQp4hQ+sAnOCMgpV4fKpE1JBTbLnMXa7ZAj92ooCWorSVAD8/gKj9tdzotuDq59duu92uLT7qcRwzIKUk45p555+IHIVNmvKN/Cpatj9a2XWMO+NXG16etkF1uSzMus8RpKR1x3SApaVgcjkYz5g1IUC6p1BLOqtIXC0Srta3HIN0RGCgzIK0YHAFAcLa8EpJGOIKRkYBroNb6WRZdb3rReoJbk5+7PCPDeknIbVjKOE/VB4hkeo8qhbTtxum0mtzwR3A2wtUWfAWSnvms++2fIggFJ8FJB8KmIsejHZ43si7raddjSSqPqO0/iJ0R3k4kg44sHmeY6/bzzUz5zVbdnXLLEmSLxbGovFf0NSUXFCQlcjhBSkL/lJI8FBQqxMCa3PYDrZ8SlSfFKh1FZZ46rTC7jk0xQ0qi5WfCsU6GgUrPjWKBSlKBjlSs+FYoFKUoFKUoFKUoFKUoFKUoFKYpQKUpQKUxSgUpSgUpSgUFKUClKUAUpSgUpSgUpSgzmq/9p3eFrQGmHrbEcQq6TEhIbUcg8WeFBHkcKUr8xBH1xU4Xq7R7Faplxlq4Y8VsuLx1IHgPUnkPUivLHd/Vs/cjXE65qd75lLqkMhByknICin0PClI/NbRV8Md1XK6fLafbS67sbgMQip1xEhxUidLc5kJJytaj5nnVg+0lqOFap+ndrtPJS3bbK227IaT9eQsYaSrzISSs/pelb92epOjdrNCxU3C5xV6ouaA9JjsZedSDzS3hAPCenI+magSxRp8XeSdqbcW3uoYlS/bu7jLRJUsuKVhHuKITwpSEYOCAc1fzap4XZ2V0S1ojQ0CPwYlykJffJHPJHIH4D7yakM+lQ5K7QdkjsJcYjlziGQhTpCh8QlCsVq1x7Ts2Ihx5vR0h6MgZ42nVKP8XhBNUuNX7osZgY51pFkt1q0Rer+zHeRBtcru7ippxwIYZdcUpDhTnAQFqSkkdOIkjGTUX2rtI3C8Qm5DGiL+AvolUIJP2KdB+6oz7RGorhuNtbrAytPXC2sW+3sTX/aeFsPpaltlKBhajz4nPsB8MVXVTuLi3CWGGlc/Co2v17AURxVx4WpYr2jLG/FbfjtKhNJEeU5xvMlKQkoWr6yklJBPjjPjUZX/AFIVOqAV4+db8ePhjnk2hd7HEcKrlxLqVEc/vqLmrwXFDJruol34cAEVrpntKbFxHLmK5rc7PjUexLtxAEqrtW7sCBzI+PKo0nbdROA8az7bnxrSZmpYFpYMi4To8SOCB3sh0NpyegyT1r42rXNhvLoagXy2ynSeFKGpSFKUcZwE5yeQJ5eVRYnbfUTueM19ZOooNkhvTrnMYhwY6eN2RIWENtp8yTyFaoqd76UpVhSiAPnVdLP2gdFXXVcibruy6kuSoUtxu3wVxmhbIiULKUucKljvXSBxFaxgZwkDGTXLwnHzVudvdSTtYyLhdnLBNtNqKG2Yjk4BLs0ArV3oR9VspUnGcE5Oelb6QFDFQxaO0/t5c0jN4ixifB+bGSf6WtmZ3v0LISO61Halk+CbhGJ/pK89lbzSNtf2GNa98Yb7iQmLq62m2SD4FRSpoE/Pua3DaO/SLnpS3IeSoSYqVRXwrqFtKKFZ+aa0/e7UMLVNps1y0y63cLta5feIZjvNKXwkcWR7/gpCPtrmab1GxpnUmomXYkw265S03SE601xJ4JDaHFDryIWVfbWk8xTeqnV1rvWAFc1AV0rgLLqkk+7XQr3FtrSU5lsoB5EOPIQR8QVCtaf3Ij/hJxtVxszkI80um6Rm1I9CkuZPxFRIm5RwtYwTAmOLA/FPkqQoDxPUVE2olyrS4l6Dxd66oBPAeEpcz7pB8OdTBK1tp+chTD12tjqV8uFEkOn4/iwqtCvOmoF9GHNRJjRuLiStqE8pWM56rCBn51pKpZ5V43jt9xsN4Z0/fX3ZF6YYEti5O9ZS/p8lZPFgFSQrPMAdMYrt9T2uLudt/B17GShy+QQiFeEp+k6cYafx4lQHCfUZ8anbWdr0xr60OqnNz73FsTWXVQloZUlGeJIUpJUrAOehHImqtat1xbbbfoejrFp9nTdmStqQp+EcvPJyFfTWVKJx6/KoNu52M3Idh6ge0S86rifKpNtJOOB8DLjPwcSnIH5aB+UatFstKu2mLjqK53G8pk6evF0R3UVwqW5AW4kAKKz/AHtSylIH1Qr0qhmp7E9pbWS5sWQvvWnxLiyU8iQTxIUPUf1VbLRetmdUWhqW4lKLdqKOqJMZSeTT30VhPkQs5T6OJq1ndNI/G7XPzkClaZtdqV/UulI6pywu7QFqgziPrPN8uP4LTwuD0XW5nrXns1W0uylKVCTFKUoFKUoFKUoFKUoFKUoFKzkVigUpSgUrPhWKBSlKBSlKBmlKUClKUClKUChpSgUpSgyelYFKUClKUGetfh1xLKFLWoJSkEkk4AAr9CvlJQhxpaXAC2oEKCumPHPyoKJ7vdoi77kNXK1WZTdv0s4e7aXj8dISD/CqUeSRjmEjxKMk9K0fZ7a+frfUoiWxLCkxmu9LjqsNNjkASR1xnkB44rsbDdNsbVL1BoS9Wi2zYIlOG2XiS2S42hSiW2nyeWACAFDl86nTs4XPSW38m62Fbiocie8lcZ2S4C13YGAwlR6YOSMnnnGeVeizU3iwl3dZNH3z0EdntDQZVuuzbuoZ8oR47Yip7ltKUFbiuE54sAADOOas1InZk0SnU+37F61hHauU+Qv3PaGkpCOWTwpSAPEDp4Vovaxuxvu5VgsLa8ot8MKKfJx9fP8AkNj7atZt5ZE6e0VY7clISWYyCsfnKHEfvNZ5W63V8ZNuxjaXssMBMe0QGsdCiOgf1V2LcdpkYbbQj9FIH7K+uDWKzaAHLqftqH+0bpe36i24vCJK1tS34rsFlxBPv96k8LRHRQU4lsgH6wTjn1mCutv9lj6gs8y3Sh+JlNlskDJSfBQ9UnCh6gUFO3dxbW5F0xEgyyqVc9MwLu9H4eTKlNhpXMcuIlAJHXqfGtdm3UvryVffUKahm3LSG4KNLRosh26t3sh5RVluQwE9wy00f8GFLkEeA4x5GpBnPPwpkiLIaW0/HcU042sYUhaSQQR5gg16uO+Hn5J5bEi5FB5GuxiXnBGTWiid61+/wilCSVL4UgZJz0q+2aa9Fad1PuJIkNWNbUCzR3fZ5N3f94pUMcaWUfWWAep90E+lS8ns76bZQ17LdtSxnR/CutXVfE+PHiyCB8UgEeFc7s/W2TbNrLKmVDERckvS0t5yoodcUtKleRUFBWPDOKk+vLlnbXpxxmkGo2AuAvtplv6vM+12yaiQ3DuFpYfWppIIKVOnmVkEp48fRPTi51IWqts9NatgLYl2uK1LwCxPjsNokxlpIUlbbnDlJBAP3HkTW4Ch5VW5WrSRXC/6J/eruMBMW8z7lBuiHFPIuT5ddbkowouoPglYVgtgBKSElIAJqRNvrZp3UmnkByzW5T0ZRbcKo6cnxBzjxB+6uXu7ot3V+l1OQW2jfLWv2yApwlIKwCFNkjoFoKkeQJB8KiPbfWftO3mtr3Z74zbmILTD5uBje1pZASpawWwoZVwcsZGCQa133Yf5Z61mnNe3GknAQrT9uOf8SK6qTspoKaSX9L25RPjwV1uz+rZF2buNnvGoEXe9Q1JkJcMP2Va4rgHdq4OJWfeC0qIOAoEDoKlLwrK7nhpPKve7vZ70N+9xqddssMaJPbhOLZeZSApKhz5cvLI+daRtLoXTe59p0XI1NbxMkxrCqA2SrBCor2CDy5+48j7Ks3rWP7TpK/NflwXh/INVy2AmNwFw4qsj2e5ZR6IkNLbI+HGhr7qvjfFVy9pdj7BaDijMaxx2l/lhtskfak1+Htk7a2sqhXWbEJ6d20yAPsSKlFJGBQ86r3X9rdsQPedrNUWSO9Is15/DTiSFKhSUICinzHHxA/Dlmot1LrWNbr2bPq7RbbU4tBwusgx14Pn3ax+w1te4Sb5pLcOZc25z7Uh1z2hh4KyFtHokjoUjHCUnlyqMd3ta3PXUW3zpUWI2/awpCnGGylTgV4nry5dOg5+dazfyyunIQxodaJI07q286VuEtAQoPKTLYPjgpWEKx18T1qH9a7Pa21lekXXTVvhTW7WSwhAmNoflJBJC22lHJTggDnnlWHHBJQFdQedcDXGoLpZ9G26bZbhIhTIS3GlFlXuuJGFAKScg9fEVNRK++o4b8rR4ZvMSRbNTWZfAqFMaLbrjCsklIP0gk+WeRrjbO6gdkIv+lHCR7Y0Z8JWeaX2k5UB+k2Cfi2mt02d1ZqTemK1pa7z4ch2Qwv2VcxPLvAM8KSQeBRGcFOPLxqIZK5eh9WsyorZEy0zAoJIxkoV9E+hAIPxqZUVdXs76mmWjUVshXRwhOqIS+7Uo8lvxlEJPxLain/Npq1oINeb1nVq+DqKRqOOpb+jrC/Hn2x4up/ElagvgCc8RCkLOSBjOM16L22ezc7fFmx1BTElpDzah4pUAR9xrPlnyvx34co1ilKyalZ8KxSgUpSgUpSgUpSgUpSgUpSgUpSgUpSgUpSgYpSlApSlApTFKDNYpSgUrJrFApSlApSlArIrFZ6UDFRpv3rAaK2r1DcAvhecZ9laOcHic93l6hJUflUlZqpnbY1ADbtL6ZS5/yp52e8kHqhsBKfvUr7KtjN1GV1FN9EaTk601rBiKSXH50kIKf0lcx8OdW61r2U7/AKfPtOg7qi5W1AyqyXZeFJ8wy/4D81XTzrSeyZo5Nx3GZuKk8TdtZXI/W6J+9Q+yr6490A/Cr3O43wpMZlPLzsZMVepmHL029A1DbnAyuJdX+64lIHCGw6SW1YHIDiSR5Vbmzb/adIba1BGm6ekKAx7Y0Syry4XEjBHriq17Zwomvd9bmmfHblwZsqQt5h5PEhaFOOKwR48gKn259mayNNufuTvd300F5KojDokQ1H1juhSPuq2WUv5K442fimS1Xy3X2MmTbJ0aZHP98jupcH3GufkGqnq2T11pS5N3GFbLDd1sK4g9apL1qkOeikJKm1fxBWzW3fz8BTnbZqeyaqtUxgArQW2p4APQkIUXMfqjNZXGfDSW/KxeK6rUd0/A1iuNwGCqKwt1KT9ZQB4R8zgfOo3t3aO29nuJYZ1VbVyFchHkFUN7PlwPcPOtM3j3tYk6KuEOz2O/rnO4LKlW9amXyn3wlDiOJJUpSUADqc0mNTtXDajTC9xe0/GuD7nfwbdJLiSeYLcQcCT+s4gq/Xrd+09AjWLdB5UVTebjFblvNp6pcOUEny4ggH7a7HscWRentQake1C07abjCiswkMXJBjur4iFLWErwcHhHP1rau0js3K1M+/rrTK/wg+llKJ8NlXeKUlAwHW8ZyQORT5DI8RV8brJTKbiromnPWubamEXi5woLqgGpL7baz5IKhxfyc1qq5HCrrWWrk7HebdYXwOtKC0K8iDkVsxes7LbbTSG2kpS2gBKUpGAAOmPlX0FR1s/uZa9xNHwZsaS37ay2hmWwVDibdA5gj1xyreplxjW+M7JlPtsx2Ula1rVgJSOZNeXT0yuUVDw6+lOIV5tal3v1lqG5znHtTXFMN55am2GHi02lBJ4QAnHLGKuN2bLXNibX26dPuUqa9dlKmJEh1SwwgnhShPEfJPEfVRq2WHbN1XHPuuo/Wpe0Ppe2TJlvszNw1JcIZUl9qzx1PIZUM5C3ACARg8vStEg716A1tpS+acgOL0nJvLL6C80whKUPOpILhKRgqJxkqHPxqaNT7ZaY1e7FXd7Yl0xnVPIDTzjAK1YypQbUnjPujmrOMcq4+r9pNIazgvsXKzxhIdGBNjNpaktq8FJcAzkHzyD0ORUS4/MTZl+0Wbf2PUoiNQblYbenXdgQqVaL6tDq7ZIbcwHUpdbweE8az3SuYJBweEGppTfpMO9uwbk2y1GeR3sN9kOqSUoSO9DqingbIUfdyr3h6g1WGy6Z3j291JcIGmId0ulphuFDbk3uWY8lGeRSkukdPFPD+iOlWQ0nqG6S9Li46ws7WnpYUUuR3ZSHU8PLCiQSBk593JNTlJ7lRjfiu81CQdPXX/2R7/QNU62+vgtN9jtLHCpUT2gZ8Sy408P5LS/tNTi9rqz21vU9vc1u7dVzozy4MKW0gLZyF5CFpSFLTlSUjI5YAyar3dQi06w2+LgDf4RtTDa88sF0PsHPzWmrYRGVi9aenLpWR1rrdPTPwjYrZMyD7RGadyPHiQD/AF12OR5j7ayaIw3t0w9ebBHnxI6npNuWVLSgZV3Sh7xx44IB+2qxN2tc4To/DlDiMD1q9hwc1Gly2v0zb1Xu5y1OhD5VIS2hwNBgBOSlOOuTk8/hWmOfjTPLHflQF6Oq3vvxFggtqIrizLWbtp26sKBKW1oc+AUlSD+1P2Vu8/Rt+v8AdlqtVmnzHHnCfxbRwB4ZPIVt9o2X1JaWZC76bZZ2JDQQfb5aEEe8D9Ennyz0rRRWraK8P2Vph2M4tqXGcCm3UHCkKSeRHwIrcNb2q9691Q/erPbQ67Oy/IUFBtlDucK5nkCTzwPOpRsWy+3W2EUSb5eZ98eWSsIUkRI6j1wkuFHEPhx/CvvrfeaRZrATpe0W63sxcIY4M8aQc8+PhHDzA+glJ5/SpIWtLtu0eop9wtES7sXK2XuDEU8i3xnG1mUwklzhV1ASBxDKsYyOXMVdPs16i/dBtPaELVxPW0rgqyeeEHKM/qKTXn1tZu/qu03686lSlifqCNmQ00+lRaWjhKFt4BzgpVnrknmSTVqexNqaTcI2poUqMqIqQpuc2wcgDmpCuHPPGOCmfnEw8ZLcdKVmsV525SlKBSlKBSlKBSlKBSlKBSlKBSlKBSlZ8KDFKzWKBSlKBSlKBWetYoKBSlKBSlKBSlKBSlKBSlBQK8/e1xcnrpvLLjpOUWm2RowHkpwrdP3KTXoCrkk/CvMvfy+rd3s14rmsi4oZHoG2G04+41fj9qZ+ljOxbZ1s6fv10eB43HUR0k+QyT/VVo5b6GYzrqlBKUJKionAGB51SHbHeC4aS0S3ZLHHjsPvLMl2a+OMp4kjASjpkY6nPwrdLZo3cTX6kzZyn1xHPeEi7ulKCPNDQ5Y+CfnVrh81WZ/ERd2aNS2207jzrlcXHIzLSD9NlZWriQvBSgDiIJJwQKs/ee0fpSzyUMLjXdfH0WYvdp+xR4v5NVs2OvNx3a3GesepWzHt0NpxMdER0pWEp48jjwMAlI5ACre2jaDRdkWl2Pp+It5JB7yQC8o+vvE0y7flM7vhHuoe0nYosFSoz6mHCAoKXDU5gZ5541NJ6etVq1Zd9I7ubke329i7ydQ3NaA3BgTWWg4tCeoCUuKzwpyfeA5VJt77LZj6Z3AnSYS7le5Lzn4MZjkErbLgUXOHP0iCoBOeQB5cxW4bOdmGFpEWjUFxlPNX2M61KZRGHB3Ce7IWwvOQrPEQSMdOXjUbk9GrfaMbinWmrdZT9PTtK2yQ/GhplvW72FvvG28e6pbyUgFSsck4yfCow3n0ncdurZBuMWzs6cu0tKHozFukOMqcGVFXepSoFPuoPIEHKvTFehl+vdg0fbpV+ucmNCiLUhLsoN5Lh+igEpBKj4DriqHdpzXtu15ulZ2rJMan25uEO6dazwqUrCfHnyK1/ZUy7RZpJ2zu2u52rdBWfU6dwbhan7i2pfsb7ypiUoCilPvPpcJBAzjwrsdS9nrcS6o437pYbhIB4g+iGYT/AMe8jOMkfYasht7ahY9EaetwSAY0FlB5Y58AJ+8mtlAzVLk0083L72b9d6akd/d5EBEKZIDTTjz7rjhdVkgcWFlWfzjn1rQtcaE1Nt5LSxf7RJhocJDb62z3TmPJWMfLrXoPvEgzb5oC2D6Mi8IcUPROP7TUmXC0wbzEXFuMRiXEd+ky+2FoV8QeVXmeopcJXkbbb1cbPIMi3zHoy1gBSmz7qx4BQPI/OuVcdWXe45TLuUt5JGChTygnHlwjl91eqv7h9NptrluFhtggLSUKYEVHAR5YxXnDvnti3pLcnUkDS8eRJs8MpeLLaS4qIFJSSDjnwAqwD4dDVsc5fhTLCz5Rk7MDLLrzrnA02kqUo+AqyGiu0izZ9O220RNzrDBZhMojsxlW6TIKUgcgVBgZNVqg3GRBd76O84w8kFPG2opUM8iK5adR3gr4vwvPHwkLH7DVrLUY2RbmH2nZRAKdzdLSQfFVlnj/AEW67xjtStRgDK1ppN4jwTa7onP8ya1Xsc36Rqa7XqwXW2Qrlb4kf2tM2QwhTzLhWEhBWRlQVzPMkjhq4Z0rZFAZtEHH/QJ/srLLxdNcfM2ppprtF6lY1rKem65ssvTLrrjie8gzXFoSclKAhMUHAJABz0HPxrZtbb/aa1fZF2qebVemQ4l1DKrVd2cOJzwqStDGUkZPMVahGmrO2MItcMfBlP8AZX7/AHP2of8Ag2Hk/wCIT/ZUdye1S+yam0DM0lLs980884+/ktyUWG4XGQ0rh4QtLr7bfCoA8sDHx511esr7tdNh2JSpGr7U/YIqI0HurQ2wyCh4PBS23FgrJUDnChniPjVod7oNvtu2V9W3BituLQhtKkspB5rHiB6VXntUaFhK2724eEdpL1uhuqCg2AeIMtr6gehqZdq2abrpTeG5NWODbrPa9bzEx2EtJdXCgMpHCMcuJZIAxj3snlzpK3P1sFLU83c2Uj6sy5xWPuZjrV9lS5sNMVcNrrFIKiSoO+P+NUf66kdTaVjCgFDyVzqO6S+iY7ntV617maguau7S/p9t0HH933GY6fsX3CT8q7VN1vN1uT8JestNxJ8drvlxYNtaDgRjIIU53vXzzU7XDSljuqSmZaIL+evGwkn7cVqMnY/RypAlwoDtsljo9b31NKFTM4dtVE1Jv/Pg+xtrmy3lSXChaZ090JQB+Yz3SftFdJH3CuN5nrREnNsKUji/uNtDR5KTn3kji6Z+tW1bhblR4c66Qb1p6FqazxZa47JnMNvPqbCiniKlJBB5eChWrQLDt3cJSbhpmLI0xdXElLntD7jkNppQwpfdqzzBxgBYrRXSvOmZL9y1ld3ZDzj7vtTn411ZWsjiOPePOpXvcYTNOzWc8wyVD4pwf6q6y5dnfW2iJL12skmDqm3OfjVv20kOAdeItq94fLI9a3rRWhrvrDRF7v7aoyGrWhxMqI46EyEJDZKl8HXh6D18OlRLovtC2g5ibdqZkpGVOBScHxOMj7wKtd2add29/dm22OHZ0Wl42uQHENthCZKFqDqHeXUkoPP19KqPY0CNqmIsD3Q6P21fvYjQxmTrDqtNtgktQURhOJSH2+6cfSpAHXCkrR6cqZfiYzys3WfCsClYNilKUClKUClKUClKUClKUClKUClKUClKUClMUoFKUoFKUoArNYpQKUpigUpSgUpSgUpSgVnpWKUHBvV0jWS0T7nMWURITDkh5Q+qhCSpR+wGvMC7X2DqbVlz1TcG0RHNST3ZLEda88AURhOfPoK9Pb9aWL9ZbjapWfZp0dyM7jrwLSUn7ia8+rdtxodQuel9QQEzNeaWkLjOd++tTEyKlRw8wjkBgkcY5kE9cdNeObZ8l0sF2ctrLbItDOqLiy1IcS4puEwpIKGuA8JcUPFWRgZ6AeZ5WRx0BFQx2cLjBjaPe06y+TItkp9SW1n3u5WsqQQfEDPD8hnrU0HmnNUz3vytjrXhS7ZO3taa3xci8kuCRKjkehLmKukDkZqkl7ed0r2qwlY4Iz0wPjwGFLSv9izV2xgDHlU5fFMWobl6q/cdo25XZCXC60kJQW0cRSpRwDjyHn4da03a3Ul815tBLccll2+BEqG2+eSi4EHuyT5+8nnWh9qe43dq66etrchxuyzo7xU2nkHXkLQcE+iSDj41Fmn9UX/SttkQLPdJERiUeN1DZ5FWMZHkccuXlUzHcVuWq1KFJu72nmbHIuM4woyOH2Nb6i02sE5wnOOuajywR2Xt0HCrBbtzYGP0UuL/AG8NTdYLF7SXVqySSMk/GoZ2hi/uh3E1A4rJbdMhII9ShH7M1ozXj2h3zg3ixwLdqKSpq8pcTGS93J7t8HkhRIGEnwPQZ+NTt8KpvbrYi0Ox+5bSS24lYBHLIII/ZVprTrO0XSM04JjTLq8Asuq4VJUfDn1rPPHXprjl+2m634ZG7GgI55lBfex8En+ypTHQD0qJr9xSN+tJpP8ABsWqQ581FQ/qqWU1S/C0+WFDII8+VV12aaVdN8t17sv3koe9lSfTj6fYirFLISkqJ5DnUA9mIi4s63vPX2+8LwrzA4j/AK1TPVL7jedWbE7faydkP3XS0Bcp9PCqSyjunfjlOOfrXnrvrtDP2X1V+D3FLkWeZxOW+YR/CIHVKvJacgHz5Hxr1RzgVEu+uxlv3tskCLKuD9vnW11b0WQ2njSCpICkqR4g4HqMVOGWqrljuIV7BMds2LWko8Peqlx2z5hIQoj7zVwxzrzh0Dq3UnZT3SulmvdudlWiRhuUGkEB5tJyh9onkcZPL1IqzcntXWW8ux7foKwXjVt6eaLqokVkthlI6lalchU5Y23cMbJNLB9DWt6r17pzRcVUm+3iJBbSOjrg41fBPU1FOlu1Xo696ZutzuwdstxtPuybfKUCsryRwoI+lzBHmKoVqrUT2rdR3O8yHXHHJkl19JdUSUhayoAZ6AZ6Ux49+0ZZ6nhabcftIWvXiLrY4jbKbCju3GH1cQkSFg8wEHlw+ZJGMjrXC333Jtu5O1Vke0/GkOXKK+5Hk2xCS4+wlTCk8fCnmUch7wGOeOtVdhzC213Xdtk8XEHOH3xyxgHyPl6V3EWQCQSefnW044yvJV7uytclI2asjNxzFmNFwLZkAtrQM5BKVYIqXImqLNOk+zRrrCdkElIaQ8krJ8gOteblsu7rCsh5zJ6njNbjY9RuwJ0WdHWlEqM4HW1lIPCodDzp9iX5Jz68aehCTWhbra8l6EssWVBityJEiQGh32eBIAKjnHPPLlWn7X71uakubdqvKECTLViO60kJQCEc0nnnmQSD5nFN+jNkm0xuFItZ4nMj6ReHLB9Ak/eax7LjlrJt3y47irF9ccvtyuUmcEqkS3lvLKU4HEo55CtLuS3ItounDy/Fpaz6FWT9yTUk3eCW5g4BkEc6jTciYi0aXuihgOKQtQ+JwhP+kr7K0rONH2RvV7sveSYF0lx2w4VJZS4S2OfXhPIfEYNWXZtF53D0pc9Vt2xIfgqcjvzYKuB5xIRxK7xA+mjB5nmfPIqu22NvUzYmSRgqHWrK7M3yVaI+srUZATb5lllvd2roXkNHBHkeEq+PyqPUTfNVKZcSzeUFvBCXDgj51djsvKmydY3Cd7UVwld9CQyUEFvukpJ97PMFaicYGCT1zVJbZGLF7jsKBJcWUj51fDYi4W62P2Ew20IFwlPoW2lZUeNRUFLOemSkHHQZwKtreNV3qxaalM5xSvM9BSlKBSlKBilKUClKUClKUClKUClKUClKUClKUClKUClKUClKUClKUGaxSlApSlApSlApSsigwrmk/CvOHfmA7bN69XhK3WnG56JrDzKuF1lTjDauNCvA9QQeShyPp6PkVRPtZWhdt3eampSe7utqZcJ81tLW2r7iir8d8qZ+mh6U3GvOnJ0KdeO9tq3HCIl6jpKIzrmOaVeCFEYyg5HPyq3+gd+oF9LUG/JRClkAJloH9zu/H8g/Hl6io77McW0ao07qbTF5gxp8B4NPLjSUBaFD3kk4P6vPrXY3rssv6alLuG3V5MVjmo2S6KU5GPo259JHzyK0yyxvjKKTHKecWqdqiAiy6701qlggolNpRxjmCUnhyD8CmrYaduqb3p+2XJKgpMqM29kHxKRn781TTVsdi4Rk6a3AgXXTi2yVMreUfZkqPVbUhIU3zwPpBPrU6aH1e5pTRUK2MRlXpuOkpiyW320oeQTkArGU8snmnNVyx8eFscvPlDu++8Tt91Mxp9KPZbbAle/xEEvH6pyOgwQfnz6Vpa7hEhglbiQPMmtJ1dtlE0ykSdX3252+IFFXuxSgHJJADisg9fAmuRYLvom5KbRbdPzL3lPuSLnKcLascvop4Afvq8kk0pfPlI2ntTQG48xz2hoJShR5qHgDUT9nRxMGPMu3cuvL95XA02VrVxOnoACT0rebjMvse3S2rPYbBb2BHcU4Y8NAUlPAc4JSTnGfGtH2YtVyGmhAts52BcJLCHEPt/SSnvnCcfEcqCcjeb1IWhcbTF4WnOeJUVSB9qsV3zEu6ymwH7O6yMdHX2UftXUZRtpdTTn8y9W3NSVHmMpGfuraoey6WI6g9drg6vHMl4j9lBL72q7PA3F09cZFxYXDiWn2Z+UXkYS4eP3T73U1vit49EJxnUluSfIyED+utLc0lZ4muNGQVWeF7LJgkvMqYTwuOJQr3lDoVetSWNAaWI//AIctOf8A2RH9lZXTWbdBP3d0hIt8tuLqK2uSVNLDaRKbHErhOBzV51HuwF4sWgdDC23e726LcXJCnnGjMZUeYHPKVEHnmpB1toLScfR+oJH7nLQlbVvkLCxEQCkhtRBzitH2B2809ctsbU9d7Db5czK0l6THStwgEAZURmnjR8pbY1xpuSnibvdvUPSSg/11yW9UWZ73W7nEUfzXQf2V0rm1OinOStMWvHTkwB+yuG7sloF45OmIKT5oCk/sNV8J8tnfXaJ3CXxFkFKSkFxAXgHqOY6Go/0TsfonQGsbhqqwqlR5s5txpxhUrMcJWtKyEoI5AFIxz5ZNct/YTQbwITaFsnzZkuJx99cMbAacjkmJc9RRD/ibq5gfI1Pg8qg9rzb+x6F1vZJOnoDEKFdojrrrLPNPfpdPEsZzjIWOQ8qgJC8Yqxnay03b9O3fT9tjX+5XaYyh5byJz3emMFcBSnPgVdceWD4iq6hg55ZrbG+GOc8uSyvpXYx3zyxXXNsnI61zmWinwq+1NO6iySMV3MecpPjWuMgj4V2LAOedWmStxbdBuq0FJC1JIOQQcEGpDe3Pvd2gxok+d7Y3GBDftCAtSc8utQ+woiu3jOEYq25faurPSQmrkzOVh1pKHFDGUE49OR6fbVfd5lPTJlttjWVfhCScAf4NokE/ArUr+LUrMOu8SC2TxA8sefhVk9i9I6P1DoNIuca2XKVMWpwNSEJW420n8WjGfeGeFSsjxVWXLqeY14vNVKs1oTbLfEjpHgMipL05Ze50ZrnUrq3EM2m2LS2EfWddygA+YCSeXqK3TcnaBdn1WI+moqpbU3iW1HYBKYqRwjhUtRwMnJySOVbhZdHxtL6GkWXVi4Ajz3kyHmCskOcGChJPVYBTkhIIPicVT3FvVUR0N7Pf74yl9p6PKUQ8wh5BR3qeIc056/Krz7MaMcOrEy0ICYVqytavN1SSEp+PMqPwHnUOTdwdLPXe42bSrEW6TgD388tpWiMkZIS1yICspAyCSPNPSrL9nO2y7fop0XB5T85x/ifeUMca+AFXLwGTjHpU29uNRJvKJg6UoetPCvO9BSlKBSnWlApTFKBSlKBSnXypQKUpQKUpQKUpQKUpQBSlKDNYpSgVnNYpQKVmsUClKUClZrFAxSlKBSlKAarX2vtPGVYNPX5tvicgS1RHDj+9vJ5fymx9tWVzitQ3Q02NWaDvlrCAp1xguNDH98R76fvTj51MuqizcVN7MtyXZdxWWVqwxcWVxVAn6x95P3pA+dWX3L3itG3pagge336SjiYt7SsEJ/LcV9RP3nw86o9ZtQydPart8hjhQ4y+lxJXnhCgQRn0zjPpUm7WaCuW7utJ9xvz7nCpftd0eBIUviUeBlB+qDw/JI+Fa3GXzWfdZ4jZ0w9b71zRIJbfiML4m1uktW+Kvw4UjJcUPM8R+FRtsfbJmodZXCxXqfK01qFbr6EO2Vfc8DrascC0/RdHI/SB5mr5wLdEtUFiDCjtx4rCAhtptOEoA8AKqN2gtOy9u9yoOtrSkttTHUylFA+i8jAcHzGFfbVZlvwm468uVdd3dR7faovGkLhKtmoW7cpDTi50Ex++C20rHvNcSScKwctdfGjOotp76pLty0DNsss81SrAlLyAfElMc8X8Zqtw3C2ii7pxm9f2GYGLhKtoU7EKOJEpaE5QAoc0qHNGeYPu8uVViiOBwtuKHTChxDmP7DVpNot0me6O6Dat10GndWtzHHIjyTDmFDT6fxavqrKF/wAmoj2jcuNv1vY1S7TLZ09ItyI7E9beEOOAKJUgHmtOVYynxqRPbIM6yKLwbeT3SiEvgOJCgk+CsjrUb7HTLlqu+SYL8wwWFKw0u2FyGsHiX17laUqHIdU1PlE0tPLgx46kyYN0YltcuJhxtTDo9Rxcj8M1+o0xp25xYjaSqStaSlsj6Qz9mK+Uba3XrsTvYGuZPD1Q1dI7EoH5ra4sfrV8W9P7v2VwEQdHXhtJ6rhuMKV/EdIz+rUd2k9qRNVxVo1jpCekcm3ltKPorA/1q38KASKq7qvVetre3GcvG3keH3b6SiTbbupoFXgEh1kAHl4GsNbq6jjrAfsG4EMA/RQYcsEfEug/dVLNxfek87mKH73mq8H/AMFyv6JVcPaxj2bSMVoDASeQHqhJqGNQ73Q59pk2qZF1iyzNYXHfTJ08pZKFpKThTXFg4PrXDh9oSJpyG3Gh3FttlOMJuNjuLa+SQnqGsfVprxo2tURTwqr47VLaW8quemVcv74JjP8ApN1xj2tUhRHtOjT8bq6n7i3UdtO6LUDrUQb/AG8je1Wnkohd27qK4hSYbSuYbA+k6oeQzgDxV6A1F0rtgJioK1q0otCRk91c3VH7OCq6a+3PY3f1jPvzb7K0FDbDTTS1KS2htIBxxAHBUpR+JqZj58ly/TUbvOm3+4v3C4PuSJkhZW464cqUSck1xUwvHFdymGBzxX7EYnwrRR0yYpB6VyW4+T0rskxMnpXIbic+lTKrY4TbHCByrlstHyrmohnlyrltQyPCrIcdhnzFdiyyTjAr7sW9RxyNdtEtxyPdNWitj4twBMZDDi3EsqP4xCDwl1P5HEOaQfEjmRkAjOR2ditEq3umS440ZJc40GOjhQwkckIbyPdCR5AcyeXSu0g2lSse7W1QLOVYHDV9RTy7C1ax1IzaJFtalltbgIROSkGS3n84+A8PGtP3hsN71LohECwWaROuchSm5b4kFb0pJSMd4VkDAIUeXLmOVSXbrJjA4a2iDaQlSQoBKM8yfAeNRccUzLJTDY62Q9J2y93q+pVDRFmIivJdbIU0UfSSU9cjBGK9Gdu4Yh6WiHGC+pTx+Z5fcBXnHbdQ/u31PLsqoiTbLhf3nk8C1ccpbrxUCo/kpaT0HXJz1r08t0ZMOBFjpGA02lGPgMV5+S+NN8J525J60pSsWpSgpQKUpQKUpQKUpigUpSgUpSgUpSgUrPhWKAOXWsmsVnPKgxSlKBSlKBSlKBSlKBSlKBSlKBSlKBSlKBWFYCSfLnX6rHWg82d+7vZNM3/VMiIgoEO6OwAyvqHUkKwMeBSoEelWP7HeqLVf9LXh2K8TcH3mpD7S0lKkDuw3488cSCfL3q6Tevb1rQu5Mncp2xsXfSV3ZSxe09wHHrW8AEpmtD4BIVjngEeIr4WLX1v0jqHSl0bcQ7aUl6G5IjnKVR3ilQUMdUhSUq+RraS5Y+GNsxy8rc+Oa0jdfRKdd6Mn25KAZiB30UkdHE+HzGR863Nh9uSy260tLjS0hSVoOQoHoQfKvoax9NlbuzNqh2LFm6OuKymTBc4mEuHmU+A+4j4o/OrSd49lJ2jDctR291EmwOyC6psDhchhxXQjopAUcAjmARkeNbLvjpudoHWMDXdiaWW1OlUhpoYKj1WkepwFp/OTUwzGbdvHtlIiIkp7i7xAA83khCyAtCwPLISrHlyrTevMU1vwrp2e3ojmp37XNbadbnRHmW+8AOFEA4APicGtO2MgR7DuBa4biRwOSUpUD44dKf667Sft3qzazVljN0S240842WpVuKloLocHugFIPERzAP31yrvb0aT1/bpaUq4WrhJQeXM8DoX088JNX8VX0u8kjAwKyRyzWs6E1vaNf6fi3qzPl2FJSFtqUMEpPTI8DyII8CCPCthkE90sJc7tRSQlZH0TjrzrFo1XciCJekpise8wpt4enCoZ+4mtjtj6ZtsiP54g6yhfPn1ArrbnIhybJIgS7jEL70dTS194lIUopxkDPLnzroNvNTRXdMRGJMhLciMpTCkqBBODyxy9cfKnnR8u71jaYs3S18bMZorcgvpSruxkEtq5g461rG1tqtdx0fAcdhRnVFiOviW2CfejtHr8c1vMmdBfiuNrfTwOJKCSD0IxUb7Nz/wdpS3Rp7bsN1ENlvgkNqQrLanGjyI8m0n4KBqfg+Ugq0vZ18jbY+P0K+CtE6fJybTGJ/RP9tdqm4xlAEPpIr6CWwocnUH51HkdE/ofTklstu2aG4hXIpWjIIrzz1Hp5606ju0V+GmIWpj/AARkMpaQyguqIShCQAE4Ixjr1r0qS60T/CIP6wqJN9tt4+rbA7d4bI/DNtbK0lA5vNDmpB8yBzHz86nG+UWKQmIemK/SIZ8q2H2Hi6Cvom3+la6ZtfTDPlXKZgnyru0W/n0rnNW48sCrRDpmbdxHmK7KPawT0rvYtryByruodoyckVKroYtpKsDhrv4diJx7tbFAsvMEpra7dZQSPd+6p2hrls0+Tj3K2632DhIyk1sttsgTghP3VsbFpAx7tLkmYtcjWUIIOKjbf/XTWjdOoscF0C/3tBaSEnnHjn3VunyJ5pT65PhU1ajuEHSmnp96uLgbhQWi44fE+SR6k4Hzrzfteq5O8G7jzrr/AH0ibO4iQriCWweQT+alIwPQVS5bWmKwewmydtg6utM93jdfhqVKQ2fotApA5jxOBgeXFV0elRvtFpty22qTd5Q/ui6uFxpGMd0wOTafmlIV8xUkVlnd3w1wngpSmKosUpSgUrPhTHKgxSlKBSlKBSnWlApSlApSlApSlAoKUxQDQUpQKUpQKzkVimKB40pmlApShoFKUoFKUoFKUoFKUoPm+w3IZcZdbQ404kpUhYylQPUEeIqhW7e3a9p9WSIlqQtWnbktUhmApQCGyVE4ZUThChzHAohKsciDgG/NR5vDt1H3F0q9ELYMxjLjBxkq80/PAx6gVbDLtqueO4gvZXeKXBY9gDhlwY6u7cjO5Q4yfEYVzQr81Qwfvq0Nj1JbtRMd7Bf41J+m0ocK2/in+vpXnI9bpmn7kT7RJTLi/i25Da+F5pIP0Aog8SPzFhSR4AVO2l9V3uwWmFebra3p9leHuXyyIUstHxDzAJW2oePAVD0xWuWMy8s8bZ4Wl1HYoepbPLtk1HExITgkdUHwUPUHnVT9vNxF7Lbs3DbrUK3ERHkmTEISeDhUok8P5pOVJ8iVJ8eU1I1fddaaVX+4zUlrekFQC5nCHVtJ8RgfQX5caRjxFQtdtidcamsWoXnr4xar5MaUhvvHjJlTcHouQcJSCM4CeQJ5gVSTXte39Jju+/8Ap1pRENpb6RzQ7IUGkr8ilGC4f4oqB9zLk9qC3Rb8ww7EcF67wpU2UEJcSUk4VzwSQc+NbDsHra0Wa+O2LVFogxdRZwZ644St5SeRUcj3VAj30jofe6E43TtFRENWe7Tg2VZgolAjn7zK8n7impmpdIu9Ic2+uOorDqKRoS1Q2tHsSY7V0tz/AH7zrE1p1RLqyeMkZGVgJIwUrBAzU7J2S1Jc1cdz127xf+ixAf5TijWpW+wq3H2WsV5spxqfTJcTEcSMqWlCuLu/XKSkgemPGpd2k11G1jpuK6k8EhCeBbROS2pOOJB9U5HxSUnxNRbfhMkdBH2AiKbUmdq/VEsE8wJSWgPQBCRXLi9nvSUYqy9enkq6JeuK1YqVqz1FU7qt2xE87s96IlsKbci3DhPXgnupP2g1Ge2m0VivBk6fvvtsoaduN0gx1mWtKyjv23UcRByr3HR18jVoyMgg1FFrQLNuxqRgjgRMeh3FA8w6ythf8tpH21MtNMJ7O2ikfQbujf6FxdGPvons/adZOY131NGP+KurlSuDkA1+gKjupqIoXsu8zzha81ax5ccwOj+UK+P712sYeVRNx5bo/JnW9lwfPHOpdxXEuUxFugvyljIaTxBI6qPgkepOB86bpqKc6n0NM0vdnYcx5mQvJPfx2yhtZ5EgJPTGQCPOum/B2D0qXH9Lztf3fVV3iuF02Ut2yMkH3ZLqSXZZHrxrSB+jjxrThblNrKHkKbcBwULSUqB+B51tKzvhrTdtyRyrsGLZnHKu9RFZDrbSnEB13JQgkAqx1wPHHjXZRrfhXSrRV1US1k45VsMG1DlkVzokEAjIrv4cMZHKpRp8bfaQSBitsttpAI5UgRAMHFbPBYAxVbdLSP3DgBKQMV2iIyUjBr9tICRXQ631lbNB6cmXu7SWGI0cAAvOpbC1k4SniV5/M8jgGsblbdNJJpH29kSJqKDGsL7apDLTgmPMAnhWpKSG0rA+kMkqx05DNRJsh2crHE1kjVfs5Q5HLgWGlcLTiVpKQ3wjrzyoqGOmBnJNdNK3Ju29eqE2DRyXWIkhzimXTBC1Izg8AIGPAAqAxy93lmre6T07G0rYodqipCW46Anl4nHmeZ+J51fK6x0pjju7dylISlIAAAGMCs0pWTUpSlApSlApTHKlApSlApSlApTpSgUpSgUpSgYpSlApSlApSlApSlApSlApSlApSlApSlApWfCsUClKUClKUChwRilKCu2+m06H3XdRW1kcKzmU2kfRUfr/AAPj5H48oKtGtrzoW3X20wJXcxrvGXGPGcBpw8gsfknBIz68/S/bzKH2ltOoSttYKVJUMhQPUEeVUY7Ue1Uu2Xew26xzI8GFqCWttMyeSlhhQTkNKcAI4ieSQccWcZyCa0xy34qmWPzG57MbYQtdRJ1xkS5sKXbkNRY8+C8WZaHeHjUS6nCiACBwkkelSk9Yd1dLRVtxLva9YQAMdxdGvZpRT5d82OFR/SQfjUWbLSZ+xseHbr7dlXKHPIakrUwGyy4nkgjnk4Hu+8eYwPAVa+FPj3CM1JjOoeYdGUrSeR/+vKme5TDVmlT9VRNOXuUHtYaIvunboh0Oiay2pxKXAOSw9HPEDy6qbr73PWcTUdnRpxq5xLnFdjyIrT6ZLanU8bRwlSRgjmkdUj4Va56O2+gocbQtB6pWAR9hqKdzNnYuokIulkajMXiIQ4lhxlCmZODnhIUk8Cj0Ck468/MJmXFAnYr3Hdt1iu9kvrDrLbjiJMFzGS6jh4VK4M8QHJODjn4VIWtHmtstWp1tp0qfsFxcSLpDYQSuO5zw+lvGcczkDqCpPiMQbcpx0fuxbrJFKrHZ7ohn2SXGUoLj8SuBaFIXxNngOOXCOQx4VYz9we6lmV/ct+0/eGUn6M6B3SyP0mlN/sqdTZ8Jg01qKFqe2MT4LzbrTiQrLauIcxkEHxBHMH+vIruSfWqzal1bqTb6OidqjTMC3xnnEspnW+8KZQpZyQn8Y2QCeeMr5n1rpX92dRkIkQndXRmFpStKkw2Lg0pJGUqCm3SSCOhxzqvbtO1tORqH9y1uWfcXStxaB4bnDlW0nw71vhlMj5lpY+dRez2gdRQgPaL1GIHX2+wTGPtKWsffX1uO89n1sxa27vqXTcB+2XBi4sPtPlshbaicFLuPdUkqSfQ0mJclpo7yJDLbzZCm3EhaT5g8x+2vqagi37/abtsOPDZ1FpaShlPAhRvLKTwjoPpeAwPlXNV2hLRwlSZenHeX1L9H5/fUdtO5NXhUW7w6zXpu2OKjJ71+MlLjbQ6uyXCURm/mvK/82POtPk9p6EwspEaxlP5Rv8cD9tRret3bJdtS2a9T7zp5xFtmO3D2E3dgoefKeFpSilZOGkhICQOZGT1qZjUXKLRbdaUTo3R9rs6lBySw3xynf8K+s8Tq/mon5YrvLjbINyZU3MiMSEKGCHUBVVTuPa5nsO8MNiwutnoWHHZB/k1rt07Yl3tsdyXPt11TDQMqXHtvdox+k4KdtT3RIs2GIGuNT2eMAIFtXGDGVcSx3rIcUknxwSMeODzz1rs2Y4B6c61HbqBI/Bs3UFyeedvGqJRu0kvEFTYWkBpvlyHC2ED45re0J6VrPTOvtHYGRXdw2wMV1jBAxXaMOip2h30XCfGu5iugY51rrDmeladuNvHpfbOyS5l5nR3ZrZKGLZ3gCnXMdV+SB5+PMAE4FVqY2Lc/eWz7W22PJmNOzX5HEWmGFpTlKcZUSfq5OMgHJ5VR/crdrU/aC1Bb7cuGmNb2XT7HbY5KgFq5d4tR+kvHLOAAM4HMmo/1Bupd94NYqLrrkmVLcw2hIIB8EhKfBIzgJ8PUkmrwdnvYGNo+Exeryyhy6OpCkpUM8IP9X7fh1r4nlbzW2bA7PR9sNMtF4JcuksBx5zHQkdB6Ach8/OpiPOnQUrO3a8milKVCSlKUCnWlKBSlKDPhWKUoFKUoFKUoM+FYpSgUpSgz4VilKBWaxSgVkVigoBpSlApWeVYzjpQKUpQKUpQKUp1oFKUoFKUoFM8qUFApSlAPOuvvlhtupLXItl1hMTYElPA6w+gKQseoP7a7GsEgUFV9ydrbroq1SWY7cu+aOUCEkAuzbUPDPi+yP46R+UOVRxtlvFqDbCa1DmKVdLBJOWXG1cYKfNCuigOnCcKTjHLpV7VKSetQ/rnYm0Xx+VdbEWLXdXzxPMqa44ctXm414K/PThQ860mfxVLj8xvOkdfWjWMRt+C/hSx/Br5K+Hx9OvpWzEg9apjKu03QNxVZ7tBdsVy4eJlxai9EeT+Uh1IJCfRSSB4qqS9G7x3O22+P+6RtD8R0fi5jBC0KHopJIV8ifhUXD5hMv2j7tUaIZc7ya0nhciO+1oUPBt04Xj9FwZ/WrsNuO0/CeEGwamfMCcGUJZkvrAZkEDB/GH6Cs9QvlzGFDOK3nXlzh6rtImEIftyG1oKkYUlbSxhYJ8CMBWDg+70qm0uT+AbhdtPXK2w7lBcUkFuSk4IH0HW3EkKQrB+kk9CQQRV9ePKN6q5eudRxb5aptkukNE22Tmih6O+OTiDzB/YQodCAQarXoreOdsBq57Tkt+XdNFKVxMLX778JKjkpx9dIPUcs9RwqzmO42vNT7Y5ZtL0iZYgcmx3pPftNg9Sy6nBR+rweua5k7XW324rQbuz0nTF2UPdM4F+MD+a+2ONI/TQfjUJ2vSjcKw360w7haI1vuMOYnialIQlba/MA4zxDxScEeIFa1f50R2E+23a4LTjrak940jhUgkEcQI6EdaotZm9zNobrIvWlkfh3TkghTztsUmfBkAf4VLRPCR+UQhQ8xU16G7RWldeFMWfMb07e1e6YVxdww4rp+LfOAP0XOE/nGoS3LZybD1BpCKq/WuPc7tAfetM9cnPH7QyoqSs8/wC+NKB9S2a31dr0yvP/ABMtOR0JSTVf7ZfZegt6ZdjmsuwbbrRlsxnpCSln29snuVpX9Ehf8GSCeTlS7K1GxFgvzpUpECDDaL8yVIHuxGwcKKh4qCvdCeqlYSKlV0e6GodMaK0pOu509a40homPDaaaHHKlqT7qP0UAhav1E/WNfHYxiarRkJ7VKGZl1eUp7vHmwFJSTkI5Y5AVArN4uO/25bFyh22cdK2Q93BipbU4EIySVuKAxxqJKlE45nyAqWtUbu6Q2+a4J96afltDAttqUmS/keClA92381E/m02aWIiXa3M4QqyWt8k4CVs5J9B1qPN293LTerLN0Dpe3wVaquiREdZioQsxWlEBxTiwAlvCOLIJKhnmB41I1F2iNS7hS12+1vL01YnPxbjcJRcmyE/kqeODzHgkJT6GpY2PsVptFqn3C3RFsrfe7jvXslbiUgE+8eoK1HJHLKfSpk2W6WDZcQyhttBBCEhI8OgxXOaleZrUGZ+cc67Bqf61dRtbcoedc9l/ABzWi3HUcSzxe/krXgnCUNpKlLOM4A+HngetR5qvfCQptNo0lb5Uu6SE4U73RJZz4JSnqr87OB5miLW77h7yfgVmfatOSGPwsz+Kk3OQMxLYo+f+Ff8AyWUZOcFWAKinTth0hqzTNwiJVMl3mUrK5s5HePvuHoeWSFEknA6faaaL2F1LrabHkXZ1bkZs8KYkVYCGc8yFOAcDfPqEcSj55q3ugNpbDodllbEZlctA91QT7jf6IPPP5x5mq3KRbHG1Emw3ZWs2h7qjVV2hhy8d0G2Uuc+HJJKynoCQQPgOfXnZ8DArIxj1pWNu2smilBSoSUpSgUpSgU9aU8KBSlKBSlKBSlKBWf21ilAzmlKUClKUClKUCnSlKDPKsUpQKUpQKUpQKUpQKUpQKUpigUpSgUoaUClKUClKUH5UrFcdbuK+rgJriPA0H4XKxXFcm+tfN/Iz1rrX1KAPWg4WrdP2XWtpctd9gtzIazxAKyFtq8FoWMKQoeYINV/vexd70m1KlaL1I9JKskRJqktOLT+SpwDu3f8AOI5+JqeJMpSQRzrpZExWTVpdIslVz0lvbdNEXhVl1FpYsTXDzYLRiqd9UABTa/1QkGo93cetGoy/cNPQp7SWE82CgFbIUfoBSFKBCFc/MJPMcqtXfGbddoq4lzhRpsVXVmS2Fo+OD0PqKhLUu19vjzzOsLrbLqR7seelT7Y/QdBDrePDClD0q8zlUuNc7bPauJq3QsS1vXe03y/N5JcW6pscJAw3+LUVcI8FKQTz5joBomueyTc4Ti1uaD1E8yPe7zT92iTR8m3W2nPuNaLrS36ttylT3WWm3mOfE6huXGdA6ELKeJpX8UH0r86K3wvHfJhXi+aisSkHHeWue8pojz7pbih/F+yl8+iXXtrsjRFi0FML0sbtacloPJ02Vtlf8cPJ/bXbL3p0imOGLjc9WanCORTfbVanSf13Q44PtqdLLutqRKFLtW+7LicY9nvcdhSj/wC8bQf5Vane+0rPhX0W+6ydA6ilpwQtzTBdBUTyHG04r3vgKrcat3RxrXudb9F6a/CMzTUPSVnko7+HbHnFSZl0VnIKbecR22leLq0DHVHEemYXaOu+6Om7ncLhpHS90esRVMm6eYhd24/HAA9tbcX3gWpkqVxJKPdCgvmOLG7XBOpdZyF3edsTt/fJMzDjkruJDbzpI6qJSVZx51+bTbLvo+7Rb3C7N2noFwhr7xqVGnykFBxj/B9CCQR0IJBpqo3ENTt1Nv8AWsUx7jP1Cy3wjEC93GT7Gj0SIY4QP80K6L2GwgY09ZNqH8/RXLvspSv4sp1sfya3G47rbbW2c+3I2b27ZlNrIdadmyipKs8xw9xy+FdjH3ktc6HNgaf2i2+sjjsRRTcjGWtbfGClKmwpoEq6kZ5DGTSSpta3oyNqp6e4zdmtPwdOqStDkWxR4qUPqSQAFOtAlSc5+uc4qZYd1Qw0htBCW0AJSkcgkeQHgKiSFeWbfEYhs8KGY6A2geg/rrlHVrDaFpMlhLiRyS45w5+41pPDK3dTGxdwpXuqFdrb7xEbeZfuSpDdrHEXHmu7GQOgC3FJQk5xzOeQPKog0zbntVJlut31EmGSG1NMhLSW+vmVuc+uSlOccqlTTehbDBSh19r2l5PicjH6xJV9hA9KXJMxtfS76ntmp5zFk0/pb2uU57wcckLfcKfNZ9xttHqCQfWt/wBN7RocQ1+G5rcaMfeXbrQnukr9Fu4BI8+EA/nVybGYltaLUKMzGaUclLKAkE+Zx1Pqa2aLcCSBmqXJeYftvlq9ltUNmFBZajxGUhLbTSeFKB6Cu0RJB6GtOiSVKx1ru4q1cutZrtgber7pXmutZUT51zW80HIpQdKUClKUGfCsUpQKYpSgUpSgUpSgUpilApSlApSlApSlApSlApSlApSlApSlApSs45UGKzWKUClKUCmaUxQKUpQKUxWQRQPjWKyaxQKUpQCM18XGeKvtSg69yLmuC/ACga70jNfgtg+FBp0q0FXhXRTLKvngGpKXGSquK5bkK8BQQxcbC8okgGtNvNikpyeAmrGv2ZCwfdH2V1UnTTboIKAflU7FR7xZ5Kir8Wv7KjDUGh4MkLLlqRxnqttPAfuq97+hYy8ktJPyrpJ228R8EBlIB9KbRp5ral0U24lTLLUgDwSocQH7K6i0RJWk7fITGsTa7spYXHuveuB6Pj6oR9BQPqM+Rr0ekbMwXVFQYTk/m11crYyA7zMdP8Wp2aUWte9m5cQuIfuk7KE/ig2wlQJ8lZIwPUZr5zu0NuqoBtyc6B6t5q7TmwduzkRE5/RrjOdn+2vclQkZ/Rp3VHbFBbzcf3ZQRNu0WcvUReHE8zHaQx3XjxY99SvsFdjBmyQ03HjR3ENoASOMEcvUnrV52+z7BayBDTg/m1+k9neCVgiME/KpmWi47U4tlonS5TTjym1sJOVNp4sq9PDFSDZNNQm1BYssLJOSTHSSftFWmtmxECLj8QMfCtlj7TQ2hgMJx8Ki5bJjIr/ZLcttHDGiNMpUQSGmgjPxwOdb3arRKUE5Qrn6VMEHbiLH+i191d9G0oyzgBA+yo2sji22N4pGUkVtNusK04JBzW6sWNtsD3R9ldi1b0oHICmxr0O18AGRXcMw+HFdkiME19g2BUDitR8YrlJRiv0Bis0DlilKUClKUCgpSgUpSgUpSgUpSgZpSlApSlApSlApSlApSlApSlApWcVBm7No3fOqhO0Su0zbEuM2kwZU9cV5t5JXxlJCcEKBT1P1fCpk2ipzrFVNh7l6zs11j2rWNhvdluchXBHS7cAI0tX5LUjhW0pfkhSkE+FSbaNXO3iOhyO5cwOItrS44gLbWOSkqBRkKHiD+w1bt/yjuTNyoTyqNDDlSQCZt1SD14H0D/Ur5rs/s/vfhC9KPkqYMf6NR2m0nCnL1qLFXExBw5nrx4mUP9mo/wBUbuR9PrnrWib7JAPDKlqm8LbbhxhpICCXHOY91I5ZAJBOKntNrJ5Hr9lM+VU9U1vHuQ0ZFj0tOscR5JDMrUF8XFUMjkv2dvK+XI4UBnyq1elIFwtWmLNAusz226RYbLMqVknv3UoAWvnz5qBPPzqtmky13GKchTPKsVCQEZND8/sqBdybXvGxq64zdLNWW66cfQ0pmLJnqiyGFJRwrSk8PCQVDi5nqa0E7k3yztzG9Xae1JaJkNBeeQm4Dh7kfSdbIC0upT1PAriA+rVpjL8q2rcA/H7KHHkfsqv8RCLpHakIuF+LLyEuNrau2QtJGQQQjoQc18JNmQ8rCrlqkD8y8lP+pU9n+Udyw/F55+ymR5H7DVUL23ZIMlqAq7a4kXR5JU1Ch31a33B+VwhPup/OUQn1rQ5epbUZ67NaJ+vL1qAcl2uxX165OMH/ABrqQhlv+MrFO3/Ke6/perI9fsr9CqZ6a2u3iud0gy2Wp+nIokMuLdvGq3Zb6Gw4lS8MNgo4ikEYKvGrlgVWzSYUpSoSVkVgetM4oFKE/GscafMUDA8qcINY40+dCtI8aDBbSfAV+fZmz9UZr9hxJP8A+1Z4wPA/YaD4mI35D7K/BgtH6tcjvB6/ZTjT5n7KDim3NeQ+ygtzI+qK5QdR50LqOmedNDjewNfkiv0ITQ+qK5CSFYNZJFB8PZWvKgjIz0H2V+3ZDTDZcdcS22kZK1nCR8zWl3rdzS1obdLdwE9xr6SIH40J/SX9BP6yhV8OPLPxjNq5Z44/ldN17tKR0FZCB1wKp1uF2wJDUqJB007bWpD86PG4UH2tYQpwBSlLA7oYGfdBUcnqMVcZJzn4mr83Bnw6mfyrx8uPJ5xMDyrNKVi0KUpQKUpQKUpQKUpQKz4VilApSlApSlApSlApSlApSlApSlApSlApSs+FBilKUDJr8qTxDrg1+hSg1nUml41+t8mHMYalQpCeF1h5PEhY8iP2HqOoxVWdpn7ro3tRau2/u9wkT7bd4Sbhb3JCuJae7QngyfE93xIJ8e7Bq5ZGQRVeZ9hgr7Wmn7kpjMpiwOcDmcY95xPz5KNWxVqefYUNNkJAxiujuDSUgitlcdASR6VrN2dAJPKkEe67vadL6Yvd6wD+DYb0oA9CUIKgPtAqCOybBm7oREaivn49NjeU1CQvmPanMrdfI8VgKwD4FaiOeKl3dvu5mgNUR1p4kuwXEKHmDXB7H9satGi7hEZbCEpuTij8S23Vr6RPawkC3CIgDiJPjXYgUHSlZrsmnhTlWM0HzeZDqCD41EW8e30XWdgTpuRIWwbtIbZadaOHGueVrT8GwsHzBwetSLqXVEbTcZvjQ5JnSVFuLCYwXZC/JI8AOpUeSRzNaTBVIbuTl3vjzL1+UgoQhpX4i3tHmUIJ6nllSzzVjwAAq2M+VbX5gWCHYoEO0wsliAw3GQT1whISPnyqJ9wd0oVkTcmLdOjx2oBLdwvLqQ4zCV/gm09HpHgEDIST72T7p6jcfd1E+P7PZ5MtmwSHPZkTYCSZ17eJx7PASOfCeYU/8eDl79d3tTsXKmS7dqDWMKK1JggG1WCPhcSzJ8D5Ov8Ams8gScc+dWtRI0vQu1OotzS7Iu4uOndHTFd45A7xSbrec/3yY/8ASQkj+9jnjl7oxVodJ7c2nSltZt1nt8a229ke7HithCPicdT6nJrbYFsZhNhKUgnzNc6qWrafBiKllIAJOPOvvTrSoSUrNYoHWo23j0BqHXtnt7Om9ZSdL3CFIL3tDTPeofSUFJbWniGRzB8elSVX5UkLGDU45XG7iLJZqqTa1sW6+2liflXi7xLww3jhuDciQho+AS4lLiC0T0CiFJycEjNQtE351FJaDgjRlJUM85Uv/fV6Oap0vGv9tkwpLaXYkptTLzShkLQoYUCPUE15YxdLL0/+GLevKkW67SrelR8e6UP6iK7v0/nvPbjlPTmdXxTjkyxbXI3nv7qsmFD+ciX/AL6usl7p3d/JXBh58T38r/fVr7zATnlXCdTyPLNdO4Seni3t3KtyHpTSVmDAVxDIPtEjn/PiuEvVz8j/AMEwlf8A9TI/+YqyvY229tGq9p35E6z22W8m7SUB2TEbdXgJb5ZUknHPpVkGtktMoGDpuxn/APDmf9iuPn9S7crj2ulj0U1vbzX/AHSPISVLs0EAcyTJfP8A/kVwka6hPKKBCtvEOuXZP++r05VstpdQwNM2L/4ax/sV0lz7Omirnyl6SsLqTy/5C2g/akA1X/5Sf+Kf+H/9nnQNQ8R4k2y3qSehDskj+mr8u34pPGm0wQfPjkf76rZbj9iywux3Zmjn37DckjiS0VqeiuHyKVZUn4gn4VU2dabnp6+zNP6ggKhXqEcOsnmlxJ6OIPRSSOeRXt4Oq4ufxPFefl4OTjm97i7PZ73BvOmuylab5BsU/UtxiTpDBgxeJbykGUoFQGCSEhWceQrS9Q9s67LcXFNuuNlmg8KoXsaG3kHwBU6okfxKkjsVqUnaBUDJHs12mJB9CUKH+lWe1zthE1Ntfebw80ld3sTKp8SUB+MQEYK0cXUpUnPLpkA+FcrDkw4+a454y+XtzwufHLjdeFWNVb76g1GSVR21rPRy5PLmqHqEK4Wh/EqOb1qO9ah4fwrc5UttP0GnF4aR+i2MIT8hWTHWpiO4tOFOtIc+Skgg/fXGcbxX0HZJPEcjf7cFg8F4saj4XCP/AEia9mIrgdbKvzj+2vGhScXOy+f4Rj/0gr2RtnOMM+Z/bXE+qfnHU6L8K5tYrJxWK5b2FKUoFKUoFKUoFKUoFOlKUClKGgUpSgUpSgUpSgUpSgUpTFApSlApSs+FBilM0oFKUoFQlcAlHaPtase9+594/wA4am2oOvCw32i7conrpyRj/wB4atirklWRL4Uk1q90m8eedcmVO90itUuc3CutW0Vqm4jyTpO/A+MVQ/ZXcdmlsNWO7gDGLgr+iarUtcyC9pq7p/KYI+8VvXZ9ZDNpu4HjPUf5pupy9IntNlZrGafGslytf1DqcWtbcCCyJt6kJKmYoVgJT07xxX1GwfHqegBNcPUOqHUSnbTZQ27c0JCpD7vNiAgj6bh8VEc0oHM+OBzqLNRaxtOmrVOdRPWmOpQVMuT5y/Nc6ADHM56JQkegGKtMf2ra7m53iLptU26T7i09cC0fbbs+Q22w2OZQ3k4bbH39SSagXWOvZerZ0S3MW6XJt9xJ/B+n0ZblXvHPvZBP8BDHUhWCofS5YSeHd7lf9b32JbGbamTdxiRBsD6vxFvRn3ZtwUOWR1Q0M8+QBOSLF7VbPxNINPz5bzly1DcOFVwu0lIDshQ5hIH1Gk/VbHIeOTzq1ukSOi2s2VctdyGqdTSGrnqx9vu++bRwx7e1j+Aio+ogDkVfSV44HKp4jRkRmwlIAA8q/bTSWkhKQABX7qlu1ylKVAUpSgVnFYrOaDFKyKwaD5SOTRNeYWo2ybhqwk/+N12/6qvT2RyaNeX2rXi3ctVpHL/jbdT/AEVdb6R/bXh6/wDrjU5mB0rq3CBmuVIdycmuvW5k4rvVy4uz2BSf3oZY8PwzK/0WqtnVTewQnG0cv/LMr9jdWyr5Dn/syfQYfjChwRSmKyWfJ2Oh5JSpIINVW7Xe0CLzo9WsLbHH4c0wkyQpKfeei5y62fMAZWPLCvOrXfGuHdLezdIT0R9tLjLyFNrQoZCkkYIPoQSKvx53jymU+FcsZlNVW7sWyW5ehb2WebSbpxpV6LjsqqV9+m+92e1yk/8AmaX/AESq7Lbja/TO1VqkWvS9rTboUh72hxtLq3OJzhCc5WSeiQMdOVcDfQ/9qDXPn+BZn9EqtMs/uc3fPmq449mHb+nmnORwsW0f83Qz/MIrpXhmu6uC8sW3/JsP/wDt266N5XOvq56jhfLguD/hKy/5Sj/0gr2Ntf8AyYfE/trx0yFXKzDx/CMb+kFexdtGIw/SP7a4P1X846vRfg5tYpmlct7AUNKz8aDFBSs8vnQYpSlApTrSgUpWfCgxSlZxQYpWccqx40ClZPSsUClZ/bWMUCs+FYpQKz4VjHKs0GKVnFCKDFKzjlWKBSlKBSlZoMVAGrXiz2h7Njx07L+5Rqf6rpr1wNdoKyKz107M/rq2HtXJtsqcOA8+datcZZKjzr9vzCQTmuhnywc860VdRq18OWC4pB5lrH3ipT2EQUW27JPX20/0bdQrf5ObdKSTyKcfeKnPZlbYhXhaVDu0zTk9B/BNmoy9JntLpIFaJqXWJeEuJa5aI0WKSmddlDKI5HVtvwW79yfHJ5V0GptxYt2iPqjzlw9MNqLbtxaOHbgsdWYvjw+Bd/i+dQxfdWvX9xlhppEK0RRwxYLPJDSfM+avWq44/tNv6bHqncOFa7Y3BhMPs21x3hZit5clXF9XPn4rWo8+fIdScDlGcGzaj1lqwMRe4dv0Y4W9jvYGm0KHh4PS1D7PzU9dttNvsd1ls/haFHU+gFMacpJ7yKT15gg8Cuih8/CpV2ljwdKFOj5URiI6yVvQ1IAAkpJKl5P1nBnJP1k4PgatfSI73bXam06EtpjwkOrceX38qVIVxvy3SObjq/rKP2AcgAKkpKAhIAGAKykAJAFKyXKVnlTFA+NYrPx6V0c7WOnrY+6xNvltjPtHC23pSEKScA4IJ5ciPtqZjcvEiLZPbu+tZ6CtPf3W0NFz32sLC3j8q4ND+uuArfLbVBwrXumRjzubX9tX+1n/AON/9I78f236lR7+/wAbYZx++Bpf/wCKNf20O/G2OP8AugaY/wDibX9tR9vP9U78f2kKlafYN1tDaquLdtsmrrJcZ7gJRHiTW3HFADJwkHJwOdbhVbLPFTLL6fKT/Aqryv1y9wX7ViPLVV0P3tV6oSP4I15PbhyOHV+r0/8ArLcj/KR/ZXU+k/2ZPH134RrL72a4gc94fGvm67mvgXfeA9a7Vyc2RfTsHDg2nmp/56l/sbq11VT7C/LbK4JA5C8yv9FqrWjGK+W6j+3L/bucf4QArjXGc1bIMmbIXwR4zanXFeSUpKifsBrkFWPGoL7UG48XSugZ1jQ/i5XthTSgg82Ip5OunyyDwJ81LGOhqvFx3kzmE+TkzmGNyrb9pt4LTu7Fu0q0RpDTNuebZUt0pIc42kuAjHkFAEHoQakWqndh4qGnNYOYCe+uTC+EdADHTyq2NW6jCcfLljj6iOHK5YS0qPd8h/2otcf5Fmf0SqkKo93yONodcf5Fmf0Sqzw/KLZfjXmHcH8ot/Ppb4g//TorqXXMmvrNd4hCP/oUYfzKK69blfW78OFry+jBzdLP/lGN/SCvZC3f8n/WP7a8bIiuK6Wn0uEb+kFeyluH9z/rH9tcT6pf54/6dPovwrlUxWSPWuk1Vqy0aLsr92vUxEWEzgcR5qWo/RQhI5qUTyCRzNcyS26j12yTdd1nBrWb9uDp7T7yo8q4oXNSM+yRkl97+IgEj54qoe6Pasnz5L8GEh2Ixkp/B8Z7gdA/9JfTzSfNprmOilg8qr1qTcq8vwXlSZjiIij7sGH+JaWo9Bwp5rPqriV6mupw/TLZ3ct1Hh5Os89vHNrx6q7U9ssS3G49pbSpH1rpc2IuPigFSx8wKjqT2y70lZcZtOk1R88lG7PkfxgzitL2Y7NF8ucVjUGrpAtsh8Bxi3RGEKfYSenEpwKS2r0CSoeKgeVWNTtBalQvZ3ZOpl+7jiN8k/6PFw/Lhx6VXLk6TC9uOG//AGvjhz5eblpGts7a76lJTN0ZGlIJ5rs99ZdVj0bcSgn5GpV0h2n9vNVSmYMi5vWG6vEBEK+smIpZ8krPuK+SqrPvN2YLpBhSL5pFwXB9gFxyBJZSh91I6hK2wlLivRSQo+CieRrjB1G9Iidy2Q5GzwuQ5SA42D4goVyHywfhW2HTdN1Mt4/FZ583Nw3+XmPYlDiVpCkqBSoZBHQium1fqmForTF11DckvKgWxhUh4MI418CeuB4mvPTaPfTUW3j0eNaJapFsCgF6duL5VHWPKK+rKmF+SFEoPn4VffQW4dk3L0/+ErStY4SWpUOSjgfiu+LbiD0P3Hwrw8/SZ8F3l5j08XPjy+J7R9be1Roa+NLcs65NwS39Is8Ix8eIivjI7UFpaJDenLs78HGBn7V1qXaS2Ht2rrBcrlYrNGi6jZbLza47QQJakjPAsAYKvyVYznkcg4qh9saamw2nlMIS5jC0lAHCociK9vSdP0/UTxPP+3l5+Tm4vnw9Cne1YyhRDeg764PMSYo/a5XAf7XncHnt1fj8Z0P/AHlUOXFaSP4NH8UV1N2b4YEhTLaC6hBI90cvM16svpvDJvTHHrOXftey7dui02J1DVz0ReYa3BxJ76XH94enCTn5ZqxkzXEK36Ac1lKjy0W9q3C5uMJb4nkt92HCnh/KAPTzFRRsHs3YtC6dtryLbFl3x6M25Ku0htLj7qykEhKlD3EDOAlOBgedT2UfiuDl08a4fNlx92sMdSOphMtfyqAIHa+0VfErNlh3O5cHJXcpbTj+OoV+ZHaqhtHDeir658H4w/a5Xz7QOydr1np64PwLPEY1AGy41JYaCC+pIyELwOZPQK6g454yD59WoJn29DzrCEPJJQ4koAIWOR5V0+k6fp+onjHVjw8/JzcV3vwvy/2tu7GUbd31Y9ZsQf69cI9sYgkfvc3nPrcYn+3VFnI7Y/vaP4orpbw2tmFIcjto7xCCoYSOXma9N+m8Em9Mser5b4Xuu3bmt1hktR7roS7wnHRlAenR/eHmME5+WatDpi+t6o05ab2yw9HauUVqUll8YcbC0hQSoeBGah3YDaCwaJ0tbH2bZGkXx6M2uVdpDYckOrKQSAtWSlAzgJTgAAePOp1SOEY61w+a8e9cc06WEy1vKsrXwIKuZwM8qrc32zNIzZaotutN0lSU5BaVwMrTjqCFkYqyKhkEVoGv9CWrVcQpulsjSSnmh8tAPsn8pDgHEk/P45pw5ceN/wCzHcOTHOz+F0ieV2vWmVlLOh57vxu0JP8Ar1wXe2Q60QP3vJpJ8Beof+1VKtQWeRZNR3yDN7tbkW4vsJcQ2EhYSojp9/zrcNj9p3N59YvR5Bda0pZlJM5xn3VSnTzSwlXh0JUfADzIrr8nS9Lx8f3LP/14OPm58s+yVa7Q/bHiaz11adKJ0ZcY8mfJTGU63MakBgnPvKDYI4RjmcirOg5TmtX0VpW3aRtbdvtNrh26GgYDUZoIHzPVR9SSa2iuNy5YW/wmo6OEsn8rspSlZrM8qxSlAIqsu57/AHfaDsSfAacm/wCtVms5qrG77nc7/WVXj+5qb+xVWw9q5en6lTgkEA1rs6fknnXHkTyQRmuimSzk860Ufq7y+KBKOejZP2c67/Rwv+kdGKh7gOexQ5shcwWthwe1XXiSngQpQJ7tgADiPIqJKfCtOYvQtkpmapLCkRVh0iQniaPDz94HqOXMV8Lmi56su7FyvTU253G7KJg2cHhk3LH13M4DEZOcnOOXXAISpUx2V31g9rCaJ6pDK47WWWGYxHcx0J5d2gDoBikeRgjnUPzP3RbY7n3e0akZaS3cnDLHsmSwUq6LayAeEfRIwD7uPKpKiTEOJQtCgpCgCFA5BHmKGm5wZGMc6kKyyk6iis2595bVxikLgSkHC0qScpSD+UPq+YynpUTRXs4IPrWyW6dzQQrhKSCCDgg+dBZ3ROqV3yIuLcEpZvMMASG08kuA9HUfmqwfgcjyztZqDbNenL2hq4QnG29R20FR4vovoPXix9VXIK8jhQqW9PX+PqG2olMgtrBLbzC/psuD6SFeo+8EEcjWdml5XbVnPKsUqqX5cOEKJ8Aa86d47/Jt+9e5SoxaQVTogy4w25yEbw40nHQdOuBXos5gtq88V5p7+W2+r3t157NYbm5FflsLRIER4trCWQPdUlCgevhXR+mZ44ctufrTx9bjcuPWLT5mt7xk8MpkD0hRx/1ddHK1zfBnE5A+EVj/AHdcgaUvDwy4wpknwciy+X2MGvx+9xdJJyZkVsfnRZ39Uau1n1HF8VzseDP5jopOtL2vOZw+Udkf6ldQ/q67rOFTMg/4lv8A2a257aq5EYF0gk+Qh3D/AOWrrJW1N6bHEl1D3/Rwpv8AWwKxvUYfFazhy16SD2UrrLe3+0g9IdLgSJiB7oAGYy/ICvUxB4kg+YrzF7Lek7xbt7tNe02ucIzftS1yTDeQ2gGOsDKloSBzx9tenDQw2kelcfr8plybl+HQ6aWYar8yP4JVeRu47uNcayH/AKxXD/TTXrlI/gVV5A7kO/8AHvWQz/4w3D+kFbfTPzyZ9Z+Ma2pzNfBSyDxeXOvwpz1r4lzPLzrr2ufpZTaztEwNpLBItFidlORnpK5SvaralagtYSFcw8OXujAxW4u9uO5HCW1ISfM2pJ/6+tM7OOw0LdDRDl7nTpLL7U56IENRYy0lKAjB99tRJ97zqY19kez8+G4Ss+f4Ohf7muZn1HTzK92Hl7ceHl14yaFJ7al74FEzJS8jkiNbWGD/AB1OLx/FqA9f7mXXcGY4/Lyyy4vvVoLqnFvLAwFOOK5rIGcDASnJwkZJqy157E0C45eZ1FcozyeaR7HHDZ+IQlBqse622V+2nvzUC6sBdvl59kntElt7HVPmlQ/JPP49a34Oo4MstYTVZcvBySbyu1zOw64TpbUCT1MqMf8A9Mmra1VLsVshrSt1Wnqt2Ko//lk1a0Vyeq/uye/h/rhUeb6nG0GuT/zLM/olVImOVRzvwcbPa6P/ADLM/olVjh+UXy9V5TSnfdijyixx/NJrhqcz0r8yHPdj8/8Avdkfzaa+BXX1Nri6c+3K4rtaR/6fG/pBXs1A5Mcvyj+2vGKzniu9r9J0b+lTXs5b+cf9Y/trj/U/OWLodH+NfK+XuDp20Trtc5KI0CC0p995w4ShCRkmvNjejfO67gahXM43IyEZEGNxY/B7ChyOP8OtPNS+qAQlODkicu2tugYX4L0PEcy2psXS5JB5LSFcMdo+inAVEeIQKo448t1xbriytxaipSj1USck16Pp/TzHH7uXu+mPV8lyy7J6jltrA6DAHgKmzsmbft7jblzb1cWQ9adMhAYbUMoXLVnhV68AClfHhqBy/wB2lSvyQTXoD2GNKotOzsS5qRh+8zJExaiOZTxd2n7m/vq31DluPH2z5R0nHLlbfhZi3WlmCylKUg8q5/An8kV+vCsCuE6bhTrc1LZWkpGSK83O1XtqjbzcyNfYLQbteqAvvkIGEty0YKj6cQIV8eKvTA9arD24NLou2zku5pQPaLJMjzkKxzA4+7X9zn3V6Ol5Lx8srPlxmWFihAcHU/YamvZDdK6WTUcdLLxN2SgNx+JWE3Fsc/ZHT4qI/glnmlQCehFQOp3PMHl1r9sTHGHW3GnFtuIUFJWg4KVA5BB8wedfS5yZy4304stl3Hr5YL7bNeaYgXq0vB6DOaDrSyPeHgUqHgpJBBHgQRXm5vloz97nd/UFtQ3wW66AXSFywAFk94gfBYV8sVZHsn7jJlXifYHXEhi+xje4rY5JalJUG5raR4Ar4HgB07xVcPtzaFcmaStesYzXFI09J/HEDmYzuEr+QVwH5muJwW9J1PbfTp8knPw7U0cfBzX1tT8Zu5RzMTxQnCWZA/xSwUL+wKJ+Irqu/CkhQOQeYPpX5U6MHPSu93OXp6fdmzUytQ7YW2PLcC7tZVLtE4+JdYPAFfrI4F/rVMNUS7Hu4Jh6xXaH3MtaiiY5n/v2IkD7Vx1JPqWzV7AcgeVfMdXx/b5bJ6dngz7+OV8ZTCXmVAjJAyPQ15fb76RXt7vPqCA033drveLtDAGAOMnvEj4LCvlivUg4xVF+2xItNy1NYYnCfwjZYb0x15tQBSl1QQyyf0lpKvgk+da/TsspzSRTqpLx3arT7vOvra3oyJ7Pto4obhLUgf4pYKVfYCT8q6su56mvmp3PLrX0VycjT097NOqF6i2wtseUsKullK7TNPm6wQgK/WRwK/WqY8VRfsda9EDVa7NIe/FaiiY95XSbESAfmuOpB9S2avQDnmOlfMdXxfb5bHa4M+/CVjFdJq69RtO6euF0lqCY8NlTyyfQdPmeVd5mq3dq7cBiz2Biwhee9SZ0xIPVps4Q3+u4Up+Gap0/FeXkmC3NyfbwuSku7d9Vcr2sR2yqapZPdoGVLkvqCuH4gFA+Oa9COzvtY1tftzZ7M4hJuCUGRNcH98kr5rPy5JHokVSvsr6Bkbk7vm/XBJetmmle2uqUMpdmuE92Pl7y/wBUV6Yx2gy0lAHICvX9R5u/Psnww6Ti7ce6/L6gYpSlc56wVk4pWKBSlKBVS97nO735s6vD9zU3/Wq2lVC38c7vfG0H/wBW5n+tVsPauXppsmXnIBrqZEjJ5mvi7JJJ51wH38+NabVfm6j2i2TWknCnGlJBHgTU39lHTsmTp+5XS8KVLvbs1UZ2c/7zq2UJR3aCo/VGSceZycmoDclEhSB9blVt+zcju9O3NP8Azgs/zbdVy9Jx9v3vhsfG3G08hUQsx9QW1RkW6Use6lzxbX/i1gcKvLkocxVQre+baXGHmHIhbfVGkRXuS4MkHCmlehPMHpzBHJQr0qcbDqClQ5GqtdozaMMuSNcWeEqQ4hnur1BaTkzIqRydSPF1oc/NSMjqE1XGrWIfiTTjrXZRrjwHGa0aHO9nUhkPpkMuIDsaSk5TIaPRWfMePyPjXaIme8DWiiRrNqCTbJjMyK6USGjlKuo9QR4gjkRU4WLUjfdo1TaW1KaVhq6QEHKhjxA8VJ5lJ+snKevSr8SbkDnW4aT1jJ0xdESWgXWFDgfj5wHW/Eeh8QfA1CVzYM2PcYjMqM6h6O8gLbcQchST0Ir71FGk9RR7G4y+xKDulroe8adPIRXVHnkfVSVclD6qufRRqVwQRms7NLSlcGVA9oGA4pI8go1zqVCWvK0u2s5U6sn9I1g6VaxjvF/xjWxUoNbGkmc/wiv4xr9jS7QGO8Xj0Ua2GlB1sO0ohjAUojyJJrsqUoPlI/glV477luf8fdZc/wDxguB/na9iJH8EqvG3c5XDuBrEf8/z/wClro/Tvzy/08nV/jGsldfkOYUPjXxK6/HHz511dvDp6N9hNrO1E0EcheZX+i3Vqw2gdEiqxdiJrudsJqcY/wCF5Bx+o1Vn6+f6j+3L/brcX4R81MtqGCkVEm/+1UTcTbO/2tDCFTu4VJhKI5okNgqQR8cFPwUal8V+XEBxJSehrLG9tli1m5pVPsOyGJ+grg+y8hwodjNOcBzwLTHSCk+RFWurrbTY4FkQtECFGiIcUVqTHZS0FK8yEgZPrXZ8sVflz+5ncv2jDHtmmM1HO/X/AHG9d/5Fmf0Sqkao437/AO41rz/Ikz+iVVcPyicvVeR77n8D/wBC0P5Ar495XzeXzb/6JsfyBXy46+ltcbTvNPq4rxbh5TI5/nU17OwSfZTjrk4+2vGHSY769wx5SGD/ADqa9noRxGT+n/rVyvqPvF7uk9V5T9oHVLmqN3tbzisqR+FVw2ufRqMkNJHwzxH51GPHXO1XMcf1Rf1uZ7xV0mqVnrkvqJrqe9rp8fjDGT9PHy+c7X1eWe5dx+Sa9U+y/AFv2P0O0B1tbK/mrKz/AKVeVbA75wo65Sr9hr1p7PoA2e0SE9BaIv8ARJrn/UvWL1dH8pOrPhWKVynuKijtI21N02T10wRkm0SFj4pTxD701K9R9veQNp9aE/8AmaZ/Qrq2H5RF9PI5hwqYaV5oSfur995iuDGcIjMg/kJ/ZX0K819Pvw4tia9gdRLsu4ehZIdIDF9RGVz/AL3KbLSh8MhJ+VelGs9ORNW6VuNmuLYchz4zkZ4Hn7qkkE/EZz8q8kNBy3mtY6ZbaJ4l3iAQB5h9NexzP4+OQodSa5H1L+zHKfp0Oj/Gz/Lxmulql6Yu1zsE8FM+0SnIbwPiUEgH5jB+dcMu+tWJ7bmgTpXcuBqiM3wwtSMd0+QOQksgDP6zZSf1TVZ+9z410un5vuccyePm4+zOxvW3+q5Olr3HuEMFUy3Pt3SMkfWcYJK0frtF1P2V63abvMbUFkgXSE4HIU1hEhhYP0m1pCkn7CK8X7fcXLZPjTWubsZxLqR54OcfPp869JeyDrlm86Dk6bS7xr07I7qOSeaobw72OfklSkfqV4/qPH3YTknw36TPVuKwd2uMW0W6XPmvJYhxWlvPOqOAhCQSon4AGvJrdbX8vXGpLhdQha7hf5gktRxzUlKsNxWf1WsHHm4aun209wE2HQUXSjL5blajcKZHCcKRCawp4/rHgR+sarH2UduzuRus9qCc0F23TYEkgjKVy15DSf1QFK/VTWXS/wDRw5c/zfEac/8A2ck4/j2g92FcLHOn2e6tFq5WyQuLIQTnC0nB5+Px8a+Zd9edT720NBq0huPbtRRmiiDqFjun1AchJaAGfipBSfkart3njXR6fm+5xzJ5Obj7M9N5291RL03fY1wiEmXbX2rpGSD9JxglS0frtF1Pryr1vsV3iX6zwblBdS7CmMokMuDoptaQpJ+wivF2JcXLdLYltc3WFpcSPPB6fPp869I+xxrNF828fsCnuNzTr/cs5OSqG6O9jn5BSkfqV4/qWHdhM58PR0eWrcVi5UhqKw686sNtNpKlLJ5JAGST8BXlf2ityHdW6puM5C1KRNfDraB1THRlEdGPX3lkfnJq7fas18jSm3xtTMnup19UqOVJOC3GSOJ9f8XCfiqqVdm/Qzu8G9EebMZ47PZFJuctChlGQQI7P8YA48kGsukk4eLLmy+fEW5/+zknHPj2vB2X9r/3s9sLVClNBN3mD2+4KI59+4AeE/oJ4UfI1N9fGIyGWEp8ccz5mvtXNyyuVtr2SamilKVCSlKUClKUCqc9olfBvbZ//wCXJf7VVcaqY9pRfDvXZ8+GnpP+kqrY+0ZekYuvYBrrH5HrWXnzg117i+KrqPvHX3sthP5SwPvq6PZ/aDNkuSR/99Uf5tuqUQFgXGIM9XU/tq7mxYxa7jj/AO+H+jRUZekz2mGuPMiplMqQQM45VyKVmuotvFtS3t3qDvIqAzpS9SCqI4ke7apyiT3fo06c8I6BRKfEVGpfdadcYfQWpDR4HEHwPp6HqDXodrfSFu1pp+4We6xkSYE5pTLzSuXEk+R8CDgg+BAPhVEtU6Lummb1K03dFLfvVub72DMVy/C8HOAry71B5KHnz6Kq8qtjqYswtkc67pmcFpBB51pyH8gEHkfGuVFmlDnCT7pqyEv7fa4bskxy3XM95Yp54XkkcQYURjvAPEY5KHiPUCrMaNvi7bIb0/Oe7xBTxW+SVcQebxkIKvEgc0n6yfUGqNpk8HjUu7Wa3auKGdKXmR3aFKH4LmFWFR3c5S3xeAJwUnwPLoeUWbJdLi8sUrV9IalcuYettx4UXiEAHUgcIdTnAcSPI9CPA8umK2is1ylKUClKUClKUHyk/wACflXjTumrG4esR/z7PP8APGvZWT/BH5V407sgt7jat/OvU4/zyq6H0/8ALJ5eq/GNOK6/JVX5zX4Wrka6e3j09Quxwnu9u5acYP4TeJ+bbVWSqu3ZEQU7fP5GCZ7h/m2qsTXC6j+3L/bpcX4Q5UrIrB61i0KYpWR1oMYqON/MfvM69z/5kmf0Sqkg1Gu/3/ca13/kWX/RKq2H5RGXqvH91XvJHkhH+iK+fFWHj7+PJKR9wr8Z5V9Fa5Om3bfoDuoY48nGj/Oor2UhqIhcQGSCT99eOG16O91Q2PIIP86ivZG3DMRPxNcz6h7xezpfVeP28NoOnN2tc2paeHuLxIWgH8hxZcSfsWK0kqq0Hbr0K5YNyLbq1lkiFfowjvLA5CQzyGfVTZSf1TVWSqvd0/J38crz82HbnXbWL8ZeIbfg45wfaCK9WuzVJ9r2V0U4PC2NIPxTlJ/0a8l7fMEKfFknow6hw/AKBr1D7I11RK2wNtSoFVnuMuH8E953iP5LorDr8d8cv6rTpbrOxYD9tYp1rPjXHe9ios7R04W7ZLXkgkDhs8lIz5qRwD71CpU6Gq49tm/otOxlzh8YD14lxoCE55kFwLV/JbNX4pvORXK6lrzNJCAEfkgD7q/JXXxW5xLUfAmsd5gV9Ha5Gkndn2znUe92h7fwKU23cEzXceCGQXDn5pH2167R08LKBjwqgXYK25cnXa+a9ltEMIT+DIBUOSjkKeWPsQn5qr0BSOFIHlXD6zk7+Tx8OnwYduCA+1tt0rX20V5RGZ47lawLlEAGSVtAlSR+kgrH2V5aoeDiErB5KGRXt7cGBJirQpIVy6Eda8eN6dDK213R1Jp1KCmG1IMmHnxju++jHwyU/q16Og5dW4Vl1WG53RpRXmrJ9kTcJOl9x7LFddAYu6VWR0KOBxkl2Ko/rhxv9cVWTiNdnp6bGg3eK7OMn2FLiFu+yL4HvdUFAoVywrIHPwya6OeP3Mbhfl5ML2ZTJKXaV3V/fI3Qv9xjOqctkZf4OgcPMFhkkFQ/Tc4lfDFXw7K+1SttdsbZGmNBF4nj2+fkcw84AeA/oJ4U/I1Q7s0bep3K3etjLkcuWazkXGYFDIKUH8U2T48S+HPoFV6xRGu5ZSnx8a5XWZya4sb4j3cE3vO/KC+1ttsNfbQXlMZnjulrAuUPAyStoEqSP0kFY+OK8tkSQ62haTyWM17dz2BIjLQUhWR0PQ149b2aFO2m6upNPJbKISXzKhcusd33kAfDJT+rWnQcurcFOqw3O5pJXnxqyHZF3D/ctuPZ4brvDEvCTZXgTy4lEuRVH4OBxv4OCq0FVdhYbi1b7xDelLkphpebW8YquF0BKwrKDkYUMcj4V0eTGZ43C/LyYXtymUTj2pd1BrvX16XEkldrhq/BcMg+73LSsvOD9N3x8kCre9j7a06A2whSpjHd3i+kXKXxD3khQ/FNn9FvBx5qNUT2G2+O7O8FqtfcrXY4ajOmpVzxGbVkIUfNailJ8+I164QI4jR0IwBy6AVy+s5JJjw4/D29PhfPJflycUrNYrwPSUpSgUpQUGaxWcVgnGaAeQ61TrtGW9Fz3MduLSyPwXZvZ1eXE4c4+Pvpqx+qd0dP6cmsWhM5iXqCWsNR7awouOFROOJzhB7tAzkqVgAA1WXefVNsnvJtVndbmyEuF66XRtJxKfyfdR+YnJx8EjnjNWxVyqFXiU+6a4bi+GuVIUR9U5+FdeviJ5g/ZV0OTaUqfvEFCeqnkgDzOavJsa42bZcADhXtQUR6FtGP2GqIIkOw3W32SUvNKC0HHRQOQftFWy2e17p6Hb37+9eWozTzgRNhPAgxOWUknyCisBXRSSPrAiovontZyldfZr9a9QQ0TLVcIs+KsZDsV1LiftSa7DrWa5UVbzbWN7gWNPsryYd8t6/abbO4c9w9jGFDxbWPdWnxBz1AqVawtIWkpUORp6HmpqCC5xyJhhKgzI75jXW3q5mHJHX4oVkEK6EEHxNdKkkH1q3e++2Kw8rWdmgqlTmGe5ucBpOTcIYz0T4ut5JT5p4k+VVTu9oNrDcyO4JNklJDkWYg8SeE/VX5EeZ5H0ORWku1NPk3JynhJ5jpX0Q8rpk8661pfe+8g8SfMc65ClkJ6HPwqRZnbbcb908SM1NmhjVlpTxMSljPtjIHPiH1iByWPEYV1BxY/TWo4+o7el9ohDyMJeZ4sltXx8QeoPiPnXmvHmSY0hmRGedYkMrDjbrZKVIUOhB8DU1aO3ilwZDElh+NDu6RwuxpJ7uLMGfqL6NKJ5lCsIzzSpPSos2b0uzisVGmld7dO3woiXR1VgvGBxQrp+JKvVtZ91YPgQakht5t5tK21BaFcwpJyD86prS+37pWRzrFQM0FKwSB8aD4TMhlWBk5FeN28KVI3E1IVdHbpMcSfNJeVivV7cjcO36MtUhAfadvTjSlRoXGONRx9Nf5DaeqlqwABXkjuRfo+oNWzZENYditnukPJHJ4gkqWPRSiSPTFdPocLJc78vH1GUtmM+GqE1+DzzWSD5GsKPCDyPOvbt59PVbspBDehHUAgqExRI8stNVYHr8aoh2UN5bPYYobv16jRYd0caZ/HZQIUptsIw4rolt1IBSs4HECk1etl9t9pDra0rbWAUrScpUD4gjka5HV4XHlt+K93BlLhJ+n7NKUrzNjFZApzp+2gGo03/WE7O63B6KtElP2oIH7akonkfOq69pfdTT9u0dcrI7MQ40tP93OMqCg2B7yWQehdWoABI5gZJwK24OO8nJJGfLnMcba8upaSzIcQr6SDwn5V8grNfqS47LkvPqThTqysgdBk5xXzIKfAiu3XO0kPZ1sOat944CWgon0DiDXsNa1JMNBHma8WNC3RFr1C0qRKVEiym1xXZQQV9wFjAc4fEJVgkDngGvV/Znc+z6wscS3OXWArUsRlCJkNp8KKlBIHet+K2144goeeDgivD12Fyxmc+Hp6bKS3G/L6b7bWQ92tBXKwSeFt51IdiySMmPITzQv4ZyCPEKNeSd/sN00te59jvUVcS6290syGVeCh4jzBGCD4gg17dkJWkpx18DVa+0f2bYO7LCblEU3B1NEb4WJhSSl1HXunQOZTnoRzTnlkZFebpeo+1dX1W3Nxd88PMNSh08PGrs9izcdqDqT8CyneFjUsdKG1KPJNwio4VI+LjBQoeZQaq5qbabUmmbuu0y7e61dU5IhOEcbwH1mFfRfT+ieIeKa63TGpJejri42TJjqDiHDwDgfiPtnLbyAejiDnkeoKknry6eUx5sLjv28mMvHlt7XggjI8axVVNou2bp69WqNF126i03NCQg3RptSoEo/lEgEsKPilYAHgcVP9v3Q0Vdo4fh6usEhojPE1cWlf61cfPg5MLqx7pyY2b22wkAZ8q8+O3buA1edU23S8R4Kj6fbL8opOR7W+nCEfFLQKj5cdWN3h7SFk0dYZH4CnxH5zgKEzX8mMwfMAc31+TaM5PUgZNeZupLrP1xqF32FidMedcW7hSe9kPuLOVvOcP1lHmfBIAA5DJ9vSdPlhfuZzX6efm5Zl/DHy13jradudvrxupq2HpqyoIW8QuTKKcoisg+84r+oeJwK2PbzYfVG5FyTDtbbYZQvhlT1HiixPMFwcnHPzEZ9SK9Itktj7DtFp5NvtTJW+7hcua8B30pwD6SiOgHgkck/HJOnU9VMZ24+1eHg87ybhttoi26B0na7DamAzAt7IZaT9Y45lSj4qUSVE+ZNbhWAABgdKzXJe0xVFe39t4TE09riKz70Nw22YpI/vbmVNE/BYUP1xV6/21ou7uh4+4m31/02+E4uUVbKFEfQc6tq+Swk/KtOLPszmSuWPdLHjTmvypXCCScAda+0qFIt0l+JLbLUqM4pl5sjBQtJKVD5EGt12X28c3U3OsOmuBRguue0TlJ+pGb95f28kj1UK7mecxw765uOHdl2r6dijaz9xW2bN7nMcF31IpM93iHNDOMMo/ikq/Xq0fKuDa4TcCG0y0hLaEJCUoSMBIAwAPQDlXNrg5Zd1trpyamg1Rjt+7eFVusGuIrXvwXfwfMUkdWnMqbUfgsKH64q9A61ou7uho+4ugb9pqQBw3KKtlCiPoOdUK+Swk/KrcWfZnMkZY90seNHFWCQfGvtNhSLZLfhzGy1LjOKZebVyKFpJSofIg1tW1GgZG5+4lg0uwFdzNeCpa0/3uMj3nVfxQQPUiu5nnMce6ubjhbl2r3dh3as6U2+Vqaczw3TUyhJHEMKRFTkMp+eVL/WT5VbOuvstvYtlujxo7KWWGW0tttJGAhCRhKR6AACuwrg55d2VtdOTU0UpSqpKdaUHKgCs9KxWc8qB86gneLbDcjWWoPadMa5ttpsy4yG1QZ1vMjhcSVcS0noOIFOR+bU61hSAsYNJ4FIJvZp3SCHWHtx7C9HdOVsps6m21n1CMZ+ea6dXZq3AjKJTqDSj36VncI/bV8VQ2VdUDNfn2Bg/UH2VO6jSiCOz7r9ByqZolw/nWRz/arkp2I18B9PQXzsTv8AtVeb2Bj/AAY+ynsEf/Bj7KbNKLfvBa+dUCXdBjn4WN3/AGq7i2bEa5ivtuty9EMyEH3XWrQ+2ofMK6elXS9gYx/Bj7KCCwD9AfZU91NKtWrYPWaJBlpuulWZSzkuRYbrKs+fJIqz1hhv26y2+JLkmTJjx22nXzklxSUgFXPnzIzzrlJjtp6JAr6jpUW7JCs8qxWfCoS+MmOmS2UKqvu4vZ1gaglPzLRPm2GY6surXA4S04s9VKZV7uT4lPCT45qxGK/JSCMEAikuhReR2ddeRXFJTe9Izkno9MsBQ6fjwKwa+A7Puvk8/bdDkf5Fd/2qvUqK0rqgfZX4EFjxbT9lTtGlGVbBa/UQBM0Qn4WR3/arP/Y5a7knDt30a2PzbG4f9arzewsf4NOPhT2Fj8gVPdTSnVv7PO4UeAqGzryzMxVjHs7VpV3Q/UXxJHyFbftz2f8AW2k9SW25u65hOw2JCHH2I8PuS4gKBKBwhI5gYOQRgmrLiGyOiBX0S0lHQVHdTUfsE4pSmM1CWedRZvXobWet7bamdH6wTpx2M+tyUXGluIkoKMBJCSDyPOpTNflSQoc6nHK43cRZLNVSO59l3Wz7LjVx1Ppe6odILqZFtlgOkdOPheTxfPNdErssXgdLbt4o/wCSZv8Av6voYrR+qKx7Ex+QPsrW9RyZebVZx4zxIoV/2L96SOVp27PxtEz/AH9fkdly9LOTadu//hMz/f1ff2Jj/BisGCwf72Psqv3ck9sUWi9mK+tK/ERdvojhHD3jVpmg48j+PwR6HlUg7b9nzcHS+pbLORr+2xLJDltvybZa4b7KH20nKm8KcKQFdDy6VagQWBz7sfZX0Qw2j6KQKt/yOTWtovHjbux9AMAZpSlYrs0rFAc5oIB3o2p3G1vqMzNO7gx7PYTGbbNskRXHE94kq4lZQofSBHL0qEbl2W9UXMt/hO46OuamchHtNsmEJz1wkPgDPjgc6vUttK+Shmvl7Gz+QK1nPnMe2Xwp9vHfdryob/2Ld4YHCLXt4v42iZ/8xWB2X7yo87Pt187PM/39XzEJjH0B9lPY2P8ABj7Kfez/AGntiiaey5dgMfgrbgf/AIPM/wDmK5sbsrakktpaizNDW4oyW1R7XMCmj5py+eE/CrvGEx/gx9lZTDaSeSBUzn5MfMqLhjfaMNidAas2+sVyg6q1YNRPPyQ7GUlLiURmggJ4E8ZJ5kE/OpTcbS4kpUMg1+kpCOgxWayyyuV3VpJJqNG1ltvZdX25yFdbZFnxF8+5kthQB8x4pPqMGq+au7LceTkRJaZMdIwiJfI3t6ED8lD3Eh9A9A4QPKreV+FNIWOaQflVseTLH1S4y+3nu/2U5MeQXmbAWHB/fbJqRxj+RJYXj4cZrmtbGahhtluMxrdsnl7l8tSf5Qbz91X0Xbo6+rafsr5fgeLnPdp+ytZ1XJPG1LxYX3FGrb2XXJ8oS7hYmpMk9X9Q6hkT1f8Au47bQI9CvFSrprsz2rCG7t/dcIY/4NiR0wYJx+Uy17zv+dWurLIgMN9G0/ZX3ShKRyAqmXNnl8pmGMa9YNJwrJFZjx47TDDKQltlpAQhA8kpHID4VsSQEjAGBWeeKVkuUpSgV+HUBxspPjX7rPh60FFN7+xpd9abkXrUdhvttt8G6uiQuM+w4pSHikBwgpGMFQ4vmak/su9m1ey7l7uN2uEW53i5BtlD0dpSEssJySkcXPKlEE/oirMKZQs+8kGsoQlHIACtLy52dtvhWYyXb9YxSlKzWK/LqA40oHxFfqlBRfe/sbXXWm4151JYr7brfDuriX1xpDDilJeKQHCCnlgkcXxJqRey92Y3dmLlebxdrnFul2ntIjsuR2VISwyDxKHvcyVKCc+iR51Z9bKHPpJB+VfpDaUDCRgVpeXOztt8KzCS7kfoDA5dKUzSs1ilKUChpSgcqVkUJHnQYrIr88Q86cQ86D9HFYrAUnzFOMZ6igzWT0rHEk+NCoY60DNZrAIpQKdKyCKiftHXu86f2h1BcLDOkQboyWO6kR1cK05dSDg+oJFBK3EnH0h9tfrIx1qvFr2U3BlQIsle92qQX2kOFPszZCeJIOPpetSPqNq66V2fvDSb1Km3q3WZ/F0cAS846hpWHSBkBWcGp0N/40/lD7aZz06VVnbnbXcXXGhbFqKRvLqeG/coqZCo6GULDZJPLJIz0qQdh9R6mlv6z0zqi5/heXpm4iI1ci2ELkNqSSOIDxHD8eeOeM00JlJA8axkedV91dcdZbi7v3HQ1h1NI0vZbHb2pcuXDaSqRJddxwpBPRIBHQjoeuRjodc6W3I2ZsjutIO592v8e2ONqlWy7NJU280pYSQCCcHmOmD4g8qC0NYBCuhBrWdRXd5/QF0ukFbjDy7U7JYUDhTaiyVJOfMHH2VBPZV3D1Tel3Gx6wucm4S5MKPeLfIlKClLYXltaQcDotI+BJqBZ3iA6nFZxVRt/dwtZJ3GbhaYvU23WaxKgx5/srgSHn5DueE8ueEJx6c6twk9c+dNDPTrX54x+UPtr5T1KTCkKQopUG1EEeBwaqdtHoncfcbQ0LUEvd/U0B+Q482WG2kOBPAspB4iR1xmgtvkHxFAQTjPSoN2ZvOrLZrvWWgtTX1zUCLM3HkxLk+2EPKS6MlCgOuMjzxz54PLn2K/3tztHansztxkrsTFhjPswlKHdNulaQpYHmQTQTGSB1OKZA69Kh7tIahvWnNAxJljuEmBMVdojSnY6sKLalkKT8DW07vXC4WvbDVs21ynYlwj295bD7JwttYHIg+dBu/EnPUfbWRg1WrSm1O4eptLWa8K3o1LGcuMRqSWhGQsNlaQcZKhnGa3fs/ao1JftPXyFqmYmfc7FdHrd7clAQZKEAYUoDlnrz+GedBLxIBwTWMjzqtkhOud5dyda26Bre46T05peSiA03bG099JdKSVLUo45cj4+QA6mt/2/wBstXaP1AZdz3LvGorQphSFQbiwjPeEjhWFgkjHPl45oJUz0B6msk4GTUMbhahvtu3z2vtkK4SmbNPRM9tjNqAbe4U+7xD08K3jcy4TIG3Gq5lukOR58e1yHGHmjhaHA2SlQPmDQbeMGhKU+OK0PZe5XK77VaRnXaW7LuUi3tOPvvHK3FkHJJ86jffrU+rrnqa2aK0JcpMG6MwJN4mvxjhQbQghtrODzUrPLzKaCwnWhIA5mtN2p1oNwNAWK/dH5McCQnxQ+n3XBj9IE/Aioy3nvuqLtudpbb+y6pXpW33GE7Ok3NhCS84pJIS0gqwAfd8CM59MEJ+yPOs8gMk8qhfSu0etdOX22z1buahutvZdCpMG4x23ESG/FIVnKc+Yrt+0Nebrp7aDUdyss5+Dc46GlNSI5wtH41AOD6gkfOgk8rTn6Q+2v1nxFV2t+zG4Nzt0OX+/dqdpT7SHSkRmyBxJCsfS9cVN+kLPOsGm7bbbld5F4nRWg27cJKQlyQrJ95QHIH+yg7vljJr88Sfyh9tcW5RXZ1umRmJK4rzzK20SG+amlFJAWPUE5+VVR3A0TuPoadpNhveHUs1N8ujdtWVNoR3KVD+EHM8R9OVBbgKB6EGmR51G+3W32pdG3GdLve4F31Mw+yG2405pKEsqCs8YwTzI5VGspnXW9Ov9YwrZri4aR05piWLe03bG0l6S7jKlrUSDjl0z5cupoLJAg9CKz0qsl5h692IummLtJ3AuWrLDc7m1bZsK6Mp40BzOFtqBJBGD4joOoNWaBz8qDNMgDrWn7q6pmaJ271HfoDSXZsCIt1lKhlPHyAJHiATnHpUO6T2t1xq/T9vvrm9uofap7KJCkQUNlhpSwFcASCOmcdB06UFkgcjl0rGQTjNdJpa3XKz6egQbtd13e5R2+B+etoNqfVk+8UjkORA+VRdsNqG+3u/7oNXm5ypjMDULseGl9QIYZAOEJ5ck1Im0kDlmmRjrUNbrakvFq3P2ngW24yI9vuVxfbmstKwh9AbSQFDxGaz2lb/fNPbVS59guEm33FMuKhL8dXCsJU5hQz6imhMfGnpxD7azkYz4VADGyevnmm3TvbqgcSQrHszeOY/SqTb0zcdPbX3Fn8LSZd1gWh1P4SWAl1x1DKsOnHIKJGfjUDcgc9KdBnwqOtibtcr3tJpO4XiW9MuUmGFvyHzlbiuJQyT54Ars92Z862bZ6sm2yS7Fnx7c84w+ycLbWE8iD50G48Yx9IfbQEHoc1WbSG1G4mqtMWa+Ob06oiquMVuSphMdtQbK054QSoZx51O+h7BcdM6biWy636XfpzJWV3GYkJddyokZAyOQIHyoNjrIxWM0zQDSmRmmR58qBShI86wFDzoM0rHEnPUU4h5igzSmfWlBwZNudkZ4bjMZz/gij+tJrp5GlJb/AE1Tfmv+jWwP2tVtAr8mg0l7QE90Hh1xqpB/Nej/AO5rr3dsLq59HcXVyf8APMf7oVI4oOtNiLHdpb2s+7ubq9P+dZ/2K4rmzd/X03R1ePi6j+oVL3jSp2jSF17I6hUeW6uqx8Vj+2vgrYvUZ6bran+aj/t1NppTdNRB52G1Gf8Ayqaj+ZV/vKwdhdSHl++pqHH63+9qcxSm6adJpayP6d0/b7XJuL9yfit92uY/njeOSeI5J58/M1onaMVwbQagIGSO4wP86mpUNavuFDjT9JXCPLjtSGF8HE28gLSfeHUHlUJR7A7POkbjbIbrzt8CnmEKUE3R0DJSCcDw61v+vI6I23eomU5KEWt9A4jk4DRFbJCQlEKMlKQlKW0gADAAwK4epGm37BdGnUJcaXGcSpCxkKBScgjxFTsQDo7a6Ze9p7ZcrRqnUMS6P2/vY0ZuaUxkuc8ICQAQkkY6+Nbt2eUWlegm5ECM4xcnX1i698srdVLTyUVE8+mCB4Z+NbvoaMxE0laGI7LbLDbACG20hKUjJ5ADpXWaNgxYWpdVGNGZYL0lLjhaQE8asq5nHU+tLRpdtuEDT/aB1OLnIZhqudriqjLfWEJe4cAgE8s8j9lcjtAaltK9rb1CanxJEud3TEeO08la3FlxJwADnwrtN7LPbrjplD0yBFkutO4bW8ylakAjmASOVaJtHpqyjU7TotFvDrSONC/ZkcSFAHBBxyNShLl1aXD22nMvI4XGbOtK0nwIjkEfdUD2bGldutqtwYrKlJtLSoU5DY5riurWMfJXT1VVl700h6yT23EJW2uO4lSVDIUCk5BFajabRb1bXs25UCKbf7Nw+yllPdY4yccGMYzz6VEShC6Wh1G08HUFybzc9Talj3N4nqEKUoNp+ASMj41awDr8a0bWtthP6XtUZ2HHcjtSYxbaW2kpRwj3cDGBjw8q3pNKPhNOIcgnwbV+w1W7ZvbQas0DAuKdUajtoW68n2aBL7tpPCsjITjqepqykkAsOAjIKT+ytQ2thxoGkIzESO1HZS44Q20gISMqOeQpsfrRO29p0J7e9Ccly7hcFBUmdNd7x53h6AnyGTWiR5cWx9ou8vXJ9uKi4WNhEdbyghLhSsZAJ5Z5H7Kms1G+81ot1x0ylyZAiyXGnQEKeZSsoBHPBI5dKQa5v5drXeNMWq0xZsaVPl3WL3Mdh1Li1YVzOAT5j7a3Ld/3tsNWpH/m979lRtsjp60M31+Q3aoKJDTZUh1MdAUg4HMHGR1qZtXx2ZWmLsw+026y5HUlTbiQpKh5EHrQQlbNp7g9thCudm1TqNN0ctrb7EP20iPxcAPdpSMYHUDny5Vv+yJsju3ludsbCmEPFapaFrK3BJ6OcZPMnIHyxW5acZbj6dtTTLaG2m4zaUoQMBIA5AAdK1zbyDFt83UzcSMzHQuepaksthAUo5ySB4+tKNR22uVvsG4u5sC4SWIcyTckym0PrCC42Un3hnr9IfbUrx9Q2qbLTDjXOG9LUkrSy2+hSyB1OAc4GRUU7+WS2TYUCTJt0N6TlSO9dYSpfCMYGSM45muHsRYbVDlS5Ua2QmZQQUh5thCVgE8xxAZwcUo/G71hhaq3V2+s9yQ6qHKZlhfdOFCuQBGFDmOYFfHWuwWj7Fo+/wB0iIuftMSC8+2Fz3FJ4koJGQeoz4VJWoIMV/XOmJLsZlyQwHu7dUgFbeRzweoz6V3upGW5GnLo082hxpcZxKkLAKVAp5gg9RREaxtK81E2m0u86sNstWxta1nkEpCSSfsqJtvn9dXq96h19ZLFaZbWoH+7YduEtTa0R2lFKEpAHTkPiRUwNw4ze2AiIjtJiiB3fcpQAjhxjh4emPSu60fFYhaYtUeMy2ww3HSENtJCUpHoByFEol2ffuGi9aX3R15hR4Dly4rxDjxneNlHErDiEKPMjkD+qa3rcLR2h9bKiw9VtwVymkqXHLkgMvoSTglJBBxkDzGRX21BAiu660zLXGZVLaDiW3lNgrQD1AV1ANa/vbZLZcbVFkTLdDkSGypCHXmErUlPXAJGQM0QjbVemrftXK0/N0Lqy5KmyLkzGVal3ASW3m1H3hweQ6c/PwNSf2gm0r2j1EFdOFrH/vkVpGymnbO1qV6Q3aYCJDTXE26mOgKQcdQcZBqW9x4rE3R9wYkstvsLCOJt1IUlXvp6g8qCJ7btFtW7bIy3rwoOOsoLg/DxTglIyMcXLnU72cRE2uGmA8h6EhpKGXEOBwKQBgHiHXp1quDej9OltJ/AFqz/AOxt/wBlT5oaKxC0laY8ZlthhtkJQ20kJSkZPIAchSkbBUP73j/hTbo4yBqBk/DlUwVp+uYUaZI08qRGZeLM9DjZcQFcCvyhnofWoS28jLZxUKbX3KDp7Xu5ltuUliHMfu3tjaH3AjvW1JOFDOM9R9tTUPCoa36sdrmxLbJk22G/I4yjvXWEqXwjoMkZxzqR8t7rjb9QI0fZ4UuNLnv32M6hhhxLiglGcqIB5DnU2DkDjqTUD7EWC0xZtwksWuE1JbRhLrcdCVpzgHBAyKngUo4N4RBctktF09n/AActtSZAkkBooIwoKzyxjzqEJ+yG2KEOSbRe37Eo5WHbdeQhCPXBURipwvESPOtcuNKYafjutKStp1AUhYx0IPIiqiv6asovCmxZ7eG+9xwiMjHXyxSCb+z3fbnfdvi5dJ7twXGmyIrMx3mt5pChwknx6kZ9KjrQG2Vg1/qfcWTd2pnexb660j2eUtkYJJOQnrzqxVhhRrfY4EaJHZjx22UcLTKAhCcjPIDkOda5oGBFhz9UKjRmWVP3BTjpbbCS4rB95WOp9TQRPe9rdPaE3M23ds7cpLkm4Od4ZElTv0UcscXTrW39pEpO1cziTlPtUbl/nBW2aohRpOqNKvPR2XHWJDimlrQCpskDJST0+VY3QhRbhpF5iXGZkMl5slt5AWkkK5cjQR03tPtY6wj/AIZV7yRnF9x4fpVKGq1M/uAvK47iHY5tj/drQoKCk90rBBHXlUHw9H6dwP8AgC1f/k2/7KnCNDjt7ftxER2kxRbi2GQgBAT3ZHDw9MY8KlDVdm9SWSFtlpmM/dbew83ECVNOSUJUk8SuRBORXdbnS2Ju12qH47rb8dy2vKS42oKSocPgRyNQ6zpLT5AJsVrJ8/ZG/wCypiYt0NG1y4SYjCYfsTiO4DYDfDk8uHGMelQloGitjdLX7R1juEly8JfmQmnVhu4uISFKTk4A5AelTXZ7WzZLVDtsbvDHiNJZbLiypXCkYGSep9a4ulmW4+m7U0y2htpEdtKUIACUjh6ADpXb1FGk7jaFuGuIsBm36ouFgVFcU4tyHnLoKccJwpPIda0BOwWpE/8AlW1F/L/3tTrSp2jSDhsLqMHnuvqX5FQ/6yvqnYrUKeZ3V1Sfgv8A/wBqmys+FN01ENNbJ6gb/wDKpq0/B1P9tctvZ6/I67o6vP8AnW/6xUtDrWT0ps0jBnau9Nn39ytXK/zjH9bZrtY+31wZxxa61S5+k7H/ANzW8VkdabS1ljSktjHFqm+ufprYP/VV28a3ux8cVwlvY/wpR/UkVzz1rFQP/9k=';

// ── Plantillas de shipping mark que se le mandan al proveedor ──────────

function renderLogin(){const grupos=[{l:'Gerencia / Sin restricciones',u:USERS.filter(u=>u.role==='gerencia'&&!u.dept)},{l:'Encargados por departamento',u:USERS.filter(u=>u.role==='gerencia'&&u.dept)},{l:'Compras — Hogar',u:USERS.filter(u=>u.role==='compras'&&u.dept==='hogar')},{l:'Compras — Muebles',u:USERS.filter(u=>u.role==='compras'&&u.dept==='muebles')},{l:'Compras — Electrónica',u:USERS.filter(u=>u.role==='compras'&&u.dept==='electronica')},{l:'Compras — Ropa',u:USERS.filter(u=>u.role==='compras'&&u.dept==='ropa')},{l:'Compras — Alfombras',u:USERS.filter(u=>u.role==='compras'&&u.dept==='alfombras')},{l:'Diseño',u:USERS.filter(u=>u.role==='diseno')},{l:'Importación',u:USERS.filter(u=>u.role==='importacion')},{l:'Contabilidad',u:USERS.filter(u=>u.role==='contabilidad')},{l:'Bodega',u:USERS.filter(u=>u.role==='bodega')},].filter(g=>g.u.length);const colores={gerencia:'#EAF3DE',compras:'#e6f1fb',diseno:'#EEEDFE',importacion:'#E1F5EE',contabilidad:'#FBEAF0',bodega:'#FEF3E8'};const tcs={gerencia:'#27500A',compras:'#0c447c',diseno:'#3C3489',importacion:'#085041',contabilidad:'#72243E',bodega:'#7C3D12'};document.getElementById('root').innerHTML=`<div class="lw"><div class="lc"><div class="ll"><img src="${KFLOW_LOGO}" alt="K-Flow" class="kflow-logo-login" style="max-width:280px;margin-bottom:8px"><p style="font-weight:600;color:var(--text-accent);font-size:14px;margin-top:2px">Kennedy · SAP B1</p></div><div id="lerr" class="le">Usuario o contraseña incorrectos</div><div class="lf"><label class="llb">Email o usuario</label><input id="lu" class="li" placeholder="Ej: lorena@kennedyzl.com" onkeydown="if(event.key==='Enter')doLogin()"></div><div class="lf"><label class="llb">Contraseña</label><div style="position:relative"><input id="lp" class="li" type="password" value="" placeholder="Tu contraseña" style="padding-right:40px" onkeydown="if(event.key==='Enter')doLogin()"><button type="button" onclick="_togglePass()" style="position:absolute;right:8px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:var(--text-muted);padding:4px;display:flex;align-items:center" title="Mostrar/ocultar contraseña"><i class="ti ti-eye" id="lp-eye" style="font-size:18px"></i></button></div></div><label style="display:flex;align-items:center;gap:7px;margin:2px 0 12px;cursor:pointer;font-size:12px;color:var(--text-secondary);user-select:none"><input type="checkbox" id="lremember" style="width:15px;height:15px;cursor:pointer;accent-color:var(--text-accent)"><span>Recordar mi contraseña en esta computadora</span></label><div style="display:flex;gap:8px;align-items:stretch"><button class="lb" onclick="doLogin()" style="flex:1"><i class="ti ti-login" style="font-size:13px"></i> Iniciar sesión</button><button type="button" id="bio-login-btn" onclick="_bioLoginDesdeInput()" title="Entrar o activar Face / Touch ID" style="width:52px;flex-shrink:0;padding:10px;background:var(--surface-1);border:1px solid var(--border-accent);border-radius:10px;cursor:pointer;color:var(--text-accent);display:flex;align-items:center;justify-content:center"><i class="ti ti-fingerprint" style="font-size:22px"></i></button></div><div class="ul"><p>Pulsa tu nombre y escribe tu contraseña:</p>${grupos.map(g=>`<div class="ug"><div class="ug-title">${g.l}</div>${g.u.map(u=>`<span class="uc" onclick="qL('${u.email}')"><span style="background:${colores[u.role]||'#eee'};color:${tcs[u.role]||'#333'};padding:1px 6px;border-radius:8px;font-size:10px;font-weight:600">${u.ini}</span><span style="font-size:11px">${u.name}</span></span>`).join('')}</div>`).join('')}</div></div></div>`;
  // Rellenar credenciales recordadas
  try{
    var saved=JSON.parse(localStorage.getItem('kcc_login_recordado')||'null');
    if(saved&&saved.u){
      var lu=document.getElementById('lu'), lp=document.getElementById('lp'), lr=document.getElementById('lremember');
      if(lu)lu.value=saved.u;
      if(lp&&saved.p)lp.value=saved.p;
      if(lr)lr.checked=true;
    }
  }catch(e){}
  try{ _bioChequearBotonLogin(); }catch(e){}
}
// Al pulsar un nombre solo se rellena el usuario. La contrasena la tiene
// que escribir cada uno: antes se metia sola y se entraba sin teclear nada,
// con lo cual cualquiera podia entrar como cualquiera.
function qL(email){
  var lu=document.getElementById('lu'), lp=document.getElementById('lp');
  if(lu) lu.value=email;
  if(lp){ lp.value=''; lp.focus(); }
  var err=document.getElementById('lerr'); if(err) err.style.display='none';
}
let DATOS_CARGADOS=false;

// ═══════════ CAMBIO 7: LOGIN BIOMÉTRICO (Face ID / Touch ID) ═══════════
// Usa WebAuthn del dispositivo. Guarda una credencial ligada al usuario y su
// clave cifrada en localStorage; al validar la huella/cara, entra directo.
function _bioDisponible(){
  return !!(window.PublicKeyCredential && navigator.credentials && navigator.credentials.create);
}
// Face/Touch ID (WebAuthn) SOLO funciona en HTTPS o localhost. En file:// o http falla.
function _bioContextoSeguro(){
  try{ return window.isSecureContext===true || location.protocol==='https:' || location.hostname==='localhost' || location.hostname==='127.0.0.1'; }catch(e){ return false; }
}
function _bioKey(email){ return 'kcc_bio_'+email; }

// Registrar la biometría para el usuario que ya está logueado con clave
async function _bioRegistrar(email, pass){
  if(!_bioDisponible()){ showT('Este navegador no soporta Face/Touch ID'); return false; }
  if(!_bioContextoSeguro()){
    showT('Face/Touch ID necesita HTTPS. Abre la app desde su enlace web (https://), no como archivo local.', 6000);
    return false;
  }
  try{
    var uidBuf=new TextEncoder().encode(email);
    var challenge=new Uint8Array(32); crypto.getRandomValues(challenge);
    var cred=await navigator.credentials.create({ publicKey:{
      challenge:challenge,
      rp:{ name:'Kennedy Compras', id: location.hostname||undefined },
      user:{ id:uidBuf, name:email, displayName:email },
      pubKeyCredParams:[{type:'public-key',alg:-7},{type:'public-key',alg:-257}],
      authenticatorSelection:{ userVerification:'required', authenticatorAttachment:'platform', residentKey:'preferred' },
      timeout:60000, attestation:'none'
    }});
    if(!cred){ showT('No se completó el registro de Face/Touch ID'); return false; }
    var idB64=btoa(String.fromCharCode.apply(null,new Uint8Array(cred.rawId)));
    localStorage.setItem(_bioKey(email), JSON.stringify({ id:idB64, p:pass }));
    return true;
  }catch(e){
    console.warn('bio registrar:',e);
    var msg='No se pudo activar Face/Touch ID';
    if(e && e.name==='NotAllowedError') msg='Cancelaste o no se reconoció la huella/cara. Intenta de nuevo.';
    else if(e && e.name==='InvalidStateError') msg='Este dispositivo ya está registrado para este usuario.';
    else if(e && e.name==='NotSupportedError') msg='Este dispositivo no tiene Face/Touch ID configurado.';
    else if(e && e.name==='SecurityError') msg='Face/Touch ID necesita HTTPS. Abre la app desde su enlace web.';
    showT(msg, 5000);
    return false;
  }
}

// Botón de huella en el login: entra con biometría si ya está registrada,
// o la activa si el usuario ya escribió email + clave correctos.
async function _bioLoginDesdeInput(){
  if(!_bioDisponible()){ showT('Este dispositivo o navegador no soporta Face/Touch ID'); return; }
  var lu=document.getElementById('lu'), lp=document.getElementById('lp');
  var email=(lu&&lu.value.trim())||'';
  if(!email){
    try{ var s=JSON.parse(localStorage.getItem('kcc_login_recordado')||'null'); if(s&&s.u) email=s.u; }catch(e){}
  }
  var emailN=email.toLowerCase();
  // ¿Ya hay biometría registrada para este usuario? -> entrar directo
  if(email && localStorage.getItem(_bioKey(emailN))){
    _bioLogin(emailN);
    return;
  }
  // No registrada: para activarla necesita email + clave correctos
  var pass=(lp&&lp.value.trim())||'';
  if(!email || !pass){
    showT('Para activar Face/Touch ID: escribe tu email y clave, luego toca la huella');
    return;
  }
  // Validar credenciales antes de registrar
  var u=USERS.find(function(x){ return (x.email.toLowerCase()===emailN||x.id===emailN||x.name.toLowerCase()===emailN)&&x.pass===pass; });
  if(!u){ showT('Email o clave incorrectos. Verifícalos para activar Face/Touch ID'); return; }
  // Registrar la biometría
  var ok=await _bioRegistrar(u.email.toLowerCase(), pass);
  if(ok){ showT('✓ Face/Touch ID activado. La próxima vez entra con tu huella'); }
}
// Al renderizar el login, mostrar el botón bio si hay credencial guardada
function _bioChequearBotonLogin(){
  try{
    var btn=document.getElementById('bio-login-btn');
    if(!btn)return;
    // Si el dispositivo no soporta biometría, ocultar el botón
    if(!_bioDisponible()){ btn.style.display='none'; return; }
    btn.style.display='flex';
  }catch(e){}
}

async function _bioLogin(email){
  if(!_bioDisponible()){ showT('Este navegador no soporta Face/Touch ID'); return; }
  if(!_bioContextoSeguro()){ showT('Face/Touch ID necesita HTTPS. Abre la app desde su enlace web.', 5000); return; }
  var raw=localStorage.getItem(_bioKey(email));
  if(!raw){ showT('Primero inicia sesión con tu clave y activa Face/Touch ID'); return; }
  try{
    var saved=JSON.parse(raw);
    var idBuf=Uint8Array.from(atob(saved.id), function(c){ return c.charCodeAt(0); });
    var challenge=new Uint8Array(32); crypto.getRandomValues(challenge);
    var assertion=await navigator.credentials.get({ publicKey:{
      challenge:challenge,
      allowCredentials:[{ type:'public-key', id:idBuf }],
      userVerification:'required',
      timeout:60000
    }});
    if(!assertion){ showT('No se validó la biometría'); return; }
    // Validó: entrar con el usuario y su clave guardada
    var lu=document.getElementById('lu'), lp=document.getElementById('lp');
    if(lu) lu.value=email;
    if(lp) lp.value=saved.p;
    doLogin();
  }catch(e){ console.warn('bio login:',e); showT('No se pudo validar Face/Touch ID'); }
}

// Botón para activar biometría desde la barra del usuario
function _bioActivarDesdeApp(){
  if(!CU){ return; }
  var raw=localStorage.getItem('kcc_login_recordado');
  var pass='';
  try{ var s=JSON.parse(raw||'null'); if(s&&s.u&&s.u.toLowerCase()===(CU.email||'').toLowerCase()) pass=s.p; }catch(e){}
  if(!pass){ pass=CU.pass||''; }
  if(!pass){ showT('Marca "Recordar contraseña" al iniciar sesión para activar la biometría'); return; }
  _bioRegistrar(CU.email, pass);
}


function _togglePass(){
  var inp=document.getElementById('lp'), eye=document.getElementById('lp-eye');
  if(!inp)return;
  if(inp.type==='password'){ inp.type='text'; if(eye)eye.className='ti ti-eye-off'; }
  else { inp.type='password'; if(eye)eye.className='ti ti-eye'; }
}

async function doLogin(){const uid=document.getElementById('lu').value.trim().toLowerCase(),p=document.getElementById('lp').value.trim();const u=USERS.find(x=>(x.email.toLowerCase()===uid||x.id===uid||x.name.toLowerCase()===uid)&&x.pass===p);if(!u){document.getElementById('lerr').style.display='block';return;}
  // Recordar o borrar credenciales según el checkbox
  try{
    var lr=document.getElementById('lremember');
    if(lr&&lr.checked){
      localStorage.setItem('kcc_login_recordado', JSON.stringify({u:document.getElementById('lu').value.trim(), p:p}));
    } else {
      localStorage.removeItem('kcc_login_recordado');
    }
  }catch(e){}CU=u;try{ _accRegistrar('entrada','Inició sesión'); }catch(e){}dO=_deptPrimero()||'todos';dP=_deptPrimero()||'todos';dComp=_deptPrimero()||'todos';activeDashStage=null;dashStageDept='todos';dashKpiFilter=null;searchQuery='';
  if(!DATOS_CARGADOS){
    document.getElementById('root').innerHTML='<div class="lw"><div style="text-align:center"><div style="font-size:34px">📦</div><div style="margin-top:12px;font-size:14px;color:var(--text-secondary)">Cargando órdenes de SAP...</div></div></div>';
    const ok=await cargarDatosReales();
    DATOS_CARGADOS=ok;
    if(!ok){document.getElementById('root').innerHTML='<div class="lw"><div style="text-align:center;max-width:340px"><div style="font-size:34px">⚠️</div><div style="margin-top:12px;font-size:14px;color:var(--text-danger)">No se pudieron cargar los datos.</div><div style="margin-top:6px;font-size:12px;color:var(--text-muted)">Revisa que las tablas compras_* existan en Supabase.</div><button class="lb" style="margin-top:16px;max-width:200px" onclick="renderLogin()">Volver</button></div></div>';return;}
  }
  renderApp();
  // Antes se lanzaba un Sync 300 ms despues de entrar, y como cargarDatosReales
  // acababa de terminar, se descargaba TODO dos veces: 17 segundos y otros 15.
  // La fecha y hora se ponen sin volver a pedir nada.
  try{
    window._ultimoSync=new Date().toLocaleString('es',
      {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'});
    localStorage.setItem('kcc_ultimoSync', window._ultimoSync);
    var _st=document.getElementById('syncTime');
    if(_st) _st.textContent=window._ultimoSync;
  }catch(e){}
}
// ══════════════════════════════════════════════════════════════════════
//  REGISTRO DE ACCESOS Y ACTIVIDAD
//  Quién entra, cuándo y qué hace. Lo consulta la gerencia general en
//  Reportes → Registro de accesos.
//  No se guardan contraseñas ni el contenido de lo que la gente escribe.
// ══════════════════════════════════════════════════════════════════════
function _accRegistrar(tipo, detalle, referencia){
  try{
    if(!CU) return;
    var fila={
      usuario_id:CU.id||'', usuario:CU.name||'', rol:CU.role||'',
      dept:(CU.dept||(CU.depts||[]).join(',')||''),
      tipo:tipo||'accion', detalle:String(detalle||'').slice(0,200),
      referencia:String(referencia||'').slice(0,80),
      navegador:String((navigator&&navigator.userAgent)||'').slice(0,160),
      creado_en:new Date().toISOString()
    };
    // Sin await: si falla, no debe estorbar lo que la persona esté haciendo
    fetch(SB+'/rest/v1/accesos',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)
    }).then(function(r){
      if(!r.ok && !window._accAvisado){
        window._accAvisado=1;
        console.warn('[accesos] no se pudo registrar ('+r.status
          +'). ¿Falta la tabla "accesos"? Está en crear_tabla_accesos.sql');
      }
    }).catch(function(){});
  }catch(e){}
}

// Las pantallas se registran con retardo: si alguien pasa rápido por
// cuatro, no tiene sentido guardar las cuatro.
function _accPantalla(id){
  try{
    clearTimeout(window._accT);
    window._accT=setTimeout(function(){
      if(window._accUltPantalla===id) return;   // ya se anotó
      window._accUltPantalla=id;
      _accRegistrar('pantalla', id);
    }, 1200);
  }catch(e){}
}

function logout(){
  try{ _accRegistrar('salida','Cerró sesión'); }catch(e){}
  CU=null;PG='dashboard';renderLogin();
}

document.addEventListener('click',function(e){
  var rr=e.target.closest('.ra-row');
  if(rr){openDetail(rr.getAttribute('data-oid'));return;}
  var ab=e.target.closest('.nsap-abrir-btn');
  if(ab){e.stopPropagation();abrirPendSAP(ab.getAttribute('data-abrir'));return;}
  var ib=e.target.closest('.nsap-ia-btn');
  if(ib){e.stopPropagation();revisarPendSAPIA(ib.getAttribute('data-ia'));return;}
});
document.addEventListener('click',function(e){
  var r=e.target.closest('.kp-row');
  if(r){openDetail(r.getAttribute('data-oid'));return;}
  var okb=e.target.closest('.ord-kpi-btn');
  if(okb){_oKpiFilter=okb.getAttribute('data-okf');_oKpiDept=dO;rOrdenes();return;}
});
document.addEventListener('click',function(e){
  var btn=e.target.closest('.ctn-track-mini');
  if(btn){openTrackingCtn(btn.getAttribute('data-oid'),parseInt(btn.getAttribute('data-ci')));return;}
  var tb=e.target.closest('.ctn-track-btn');
  if(tb){openTrackingCtn(tb.getAttribute('data-oid'),parseInt(tb.getAttribute('data-ci')));return;}
  var db=e.target.closest('.ctn-del-btn');
  if(db){removeContainer(db.getAttribute('data-oid'),parseInt(db.getAttribute('data-ci')));return;}
  var ab=e.target.closest('.ctn-add-btn');
  if(ab){addContainer(ab.getAttribute('data-oid'));return;}
});
document.addEventListener('change',function(e){
  var bs=e.target.closest('.bk-sel');
  if(bs){setBKField(bs.getAttribute('data-bk-oid'),bs.getAttribute('data-bk-field'),bs.value);return;}
});
document.addEventListener('input',function(e){
  var bi=e.target.closest('.bk-inp');
  if(bi){setBKField(bi.getAttribute('data-bk-oid'),bi.getAttribute('data-bk-field'),bi.value);return;}
  var ci2=e.target.closest('.ctn-inp');
  if(ci2){setContainerField(ci2.getAttribute('data-ctn-oid'),parseInt(ci2.getAttribute('data-ctn-i')),ci2.getAttribute('data-ctn-field'),ci2.value);return;}
});
renderLogin();

// Event delegation para adjuntos (registrado a nivel global, se activa siempre)
document.addEventListener('click', function(e){
  var tgt=e.target;
  // Eliminar adjunto (closest capta el clic aunque caiga en un hijo del botón)
  var delBtn=tgt.closest?tgt.closest('.att-del'):null;
  if(delBtn){
    e.preventDefault(); e.stopPropagation();
    var ai=parseInt(delBtn.getAttribute('data-ai'));
    var oid=delBtn.getAttribute('data-oid');
    var sk=delBtn.getAttribute('data-sk');
    delAtt(oid,sk,ai);
    return;
  }
  // Zoom en imagen adjunta
  var imgEl=tgt.closest?tgt.closest('.att-img'):null;
  if(imgEl){
    zoomImg(imgEl.getAttribute('data-src'));
    return;
  }
});
document.addEventListener('change', function(e){
  var tgt=e.target;
  if(tgt.classList&&tgt.classList.contains('att-input')){
    var oid=tgt.getAttribute('data-oid');
    var sk=tgt.getAttribute('data-sk');
    handleAttach(oid,sk,tgt);
  }
});
// ═══════════════════════════════════════════════════════════════════════════
//  AYUDA POR PANTALLA
//  Cada opción del menú lleva un "?" que explica para qué sirve, quién la usa
//  y qué se hace ahí. El texto se adapta al rol de quien está mirando.
// ═══════════════════════════════════════════════════════════════════════════
var AYUDA={
  dashboard:{
    t:'Inicio',
    para:'Todos',
    q:'El resumen del día: cuántas órdenes hay activas, cuánto se ha abonado y qué está por llegar.',
    pasos:[
      'Pulsa cualquier recuadro de arriba (Activas, Abonado, Saldo, Por llegar) para ver el listado de esas órdenes.',
      'Desde ese listado puedes entrar a cualquier orden para trabajarla.',
      'Los avisos en rojo son cosas que necesitan tu atención.'
    ],
    tip:'Los recuadros son filtros: pulsa uno y abajo aparece solo lo que corresponde.'
  },
  ordenes:{
    t:'Buscar órdenes',
    para:'Todos',
    q:'El buscador de todas las órdenes de compra, las de SAP y las NO SAP.',
    pasos:[
      'Escribe el proveedor, el código, la referencia o parte de la descripción.',
      'Con el desplegable de la derecha eliges si ves las de SAP, las NO SAP o todas.',
      'Pulsa cualquier orden para abrirla y trabajar sus etapas.'
    ],
    tip:'Las órdenes NO SAP se reconocen por su etiqueta naranja y se abren igual que las demás.'
  },
  completadas:{
    t:'Completadas',
    para:'Todos',
    q:'El historial de las órdenes que ya terminaron todo su recorrido, desde el pedido hasta la venta.',
    pasos:[
      'Sirve para consultar cómo se trabajó una compra anterior.',
      'Puedes abrirlas para ver sus etapas, documentos y comentarios.'
    ]
  },
  pendientes:{
    t:'Por aprobar',
    para:'Gerencia',
    q:'Las órdenes que esperan tu aprobación para poder seguir avanzando.',
    pasos:[
      'Revisa la orden y sus documentos.',
      'Apruébala para que compras pueda continuar con el proceso.'
    ],
    tip:'El punto rojo indica que hay órdenes esperando.'
  },
  deptos:{
    t:'Departamentos',
    para:'Gerencia y contabilidad',
    q:'El resumen de todas las compras agrupadas por departamento y proveedor.',
    pasos:[
      'Cada fila es un proveedor, con sus órdenes al lado.',
      'De cada orden ves el número, el DKC, el total, lo abonado y el saldo.',
      'Pulsa una orden para abrirla.'
    ]
  },
  mistarea:{
    t:'Mis artes / Embarques / Bodega',
    para:'Diseño, importación y bodega',
    q:'Tu bandeja de trabajo: solo las órdenes que están esperando algo de tu parte.',
    pasos:[
      'Entra a cada orden y completa lo que te toca en tu etapa.',
      'Marca los pasos como hechos para que la orden avance.'
    ]
  },
  alertas:{
    t:'Alertas',
    para:'Todos',
    q:'Lo que está atrasado o necesita atención: órdenes detenidas, artes pendientes, mercancía sin llegar.',
    pasos:[
      'Revisa cada aviso y entra a la orden para resolverlo.',
      'Puedes filtrar por responsable con los botones de arriba.'
    ]
  },
  alertas_contab:{
    t:'Solicitudes de abonos o cancelaciones',
    para:'Contabilidad',
    q:'Las solicitudes de pago que manda compras: abonos para arrancar una orden y cancelaciones del saldo final.',
    pasos:[
      'Revisa cada solicitud con su monto, proveedor y orden.',
      'Están agrupadas por departamento solicitante.',
      'Pulsa el icono de comentarios para hablar con quien la pidió.',
      'Cuando la trabajes, márcala como hecha para que salga del listado.'
    ],
    tip:'Con el botón Reporte sacas la lista para imprimir, con los totales al final.'
  },
  reposiciones:{
    t:'Reposiciones',
    para:'Compras',
    q:'Para volver a pedirle mercancía a un proveedor que ya trabajas.',
    pasos:[
      'Busca el proveedor por código o por nombre.',
      'Se abre su listado de artículos con stock, disponible y última compra.',
      'Escribe las cantidades que quieres pedir, en piezas o en bultos.',
      'Genera el PDF y el Excel, y envíalos al proveedor por correo.'
    ],
    tip:'Con los filtros de stock ves solo lo que se está acabando: sin disponible, o por debajo del 50% de la última llegada.'
  },
  reppedidos:{
    t:'Pedidos guardados',
    para:'Compras',
    q:'Las reposiciones que dejaste a medias para seguirlas después.',
    pasos:['Ábrelas para continuar donde las dejaste.']
  },
  nueva:{
    t:'Nueva compra para firma',
    para:'Compras',
    q:'Para mandarle a gerencia una compra nueva y que la firme.',
    pasos:[
      'Adjunta los dos documentos: la PI del proveedor y nuestra orden de compra.',
      'Pulsa AI para que lea los datos y compare los dos documentos.',
      'Revisa las incidencias que reporte y corrige lo que haga falta.',
      'Completa los campos y envíala a gerencia.'
    ],
    tip:'Mientras gerencia no la firme, la puedes editar o borrar.'
  },
  nueva_ger:{
    t:'Compras para firmar',
    para:'Gerencia',
    q:'Las compras que compras te mandó para que las firmes.',
    pasos:[
      'Revisa el archivo y la revisión de la AI, que te avisa si los dos documentos no coinciden.',
      'Dibuja tu firma y fírmala.',
      'Se firman los dos documentos por separado y le llegan al comprador.'
    ]
  },
  livechat:{
    t:'Live Chat',
    para:'Todos',
    q:'Chat interno del equipo para consultas rápidas sobre las órdenes.',
    pasos:['Escribe tu mensaje y el equipo lo ve al instante.']
  },
  reportes:{
    t:'Reportes',
    para:'Todos menos diseño',
    q:'Vistas de conjunto para seguir el trabajo sin entrar orden por orden.',
    pasos:[
      'Estado de las entradas: dónde está cada embarque, de puerto a inventario.',
      'Los botones de arriba filtran por etapa y por departamento.',
      'Se ordenan por tiempo detenido: arriba lo que lleva más días sin moverse.',
      'Pulsa una fila para abrir esa orden en su etapa de logística.'
    ],
    tip:'Si una entrada lleva más de 15 días en la misma etapa, el número sale en rojo.'
  },
  inventario:{
    t:'Consulta inventario',
    para:'Todos menos contabilidad',
    q:'Para consultar cualquier artículo: existencia, reservado, disponible, por llegar y precio.',
    pasos:[
      'Busca por SKU, descripción, código de barras o proveedor.',
      'Filtra por departamento con los botones de arriba.',
      'Pasa el mouse por la foto para verla grande.',
      'Pulsa cualquier fila para abrir la ficha técnica completa.'
    ],
    tip:'En la ficha, el número de reservado es clickeable: te dice qué cliente tiene esa mercancía separada.'
  },
  catnosap:{
    t:'Proveedores y SKU NO SAP',
    para:'Compras y gerencia',
    q:'Los proveedores y artículos nuevos que todavía no existen en SAP, creados desde una orden NO SAP.',
    pasos:[
      'Están agrupados por proveedor; pulsa uno para ver sus artículos.',
      'Cuando el proveedor o el SKU se crean en SAP, su ficha desaparece sola de aquí.',
      'Con Revisar contra SAP fuerzas esa comprobación en el momento.'
    ],
    tip:'El número rojo del menú te dice cuántas fichas faltan por crearse en SAP.'
  },
  ordennosap:{
    t:'Agregar nueva orden NO SAP',
    para:'Compras y gerencia',
    q:'Para registrar una compra que todavía no está cargada en SAP y poder trabajarla igual.',
    pasos:[
      'Adjunta la PI del proveedor y nuestra orden de compra.',
      'Pulsa Revisar y comparar con IA: llena los datos y te avisa de diferencias entre los dos documentos.',
      'Verifica el proveedor y los artículos, y crea la orden.',
      'La orden nace con la etapa Pedido ya aprobada y queda pendiente de abono.'
    ],
    tip:'Puedes guardarla como borrador y seguir más tarde.'
  },
  reporteabonos:{
    t:'Reporte abonos y cancelaciones',
    para:'Contabilidad y gerencia',
    q:'Saca la lista imprimible de todas las solicitudes de pago pendientes.',
    pasos:[
      'Trae proveedor, orden con su DKC, monto, departamento, concepto y fecha de llegada.',
      'Al final los totales de abonos, de cancelaciones y el gran total.'
    ]
  }
};

// Botón "?" que abre la ayuda
function _ayudaBtn(clave, color){
  return '<span class="ayuda-i" onclick="event.stopPropagation();_ayudaVer(\'' + clave + '\')" '
    +'title="¿Cómo funciona esta pantalla?"'+(color?(' style="color:'+color+'"'):'')+'>?</span>';
}

// La clave cambia según el rol en un par de pantallas
function _ayudaClave(id){
  if(id==='alertas' && CU && CU.role==='contabilidad') return 'alertas_contab';
  if(id==='nueva'   && CU && CU.role==='gerencia')     return 'nueva_ger';
  return id;
}

function _ayudaVer(clave){
  var a=AYUDA[clave];
  if(!a){ showT('Sin ayuda para esta pantalla'); return; }
  var prev=document.getElementById('ayudaOv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='ayudaOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2200;display:flex;align-items:center;justify-content:center;padding:18px';
  var h='<div style="background:var(--surface-0);border-radius:13px;max-width:480px;width:100%;max-height:88vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;padding:15px 18px;border-bottom:0.5px solid var(--border)">'
    +'<div><div style="font-size:15px;font-weight:700"><i class="ti ti-help-circle" style="color:var(--fill-accent)"></i> '+_esc(a.t)+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-top:3px"><i class="ti ti-users" style="font-size:11px"></i> Para: '+_esc(a.para)+'</div></div>'
    +'<button onclick="document.getElementById(\'ayudaOv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';
  h+='<div style="padding:15px 18px">';
  h+='<div style="font-size:13px;line-height:1.55;margin-bottom:13px">'+_esc(a.q)+'</div>';
  if(a.pasos&&a.pasos.length){
    h+='<div style="font-size:11px;text-transform:uppercase;letter-spacing:.04em;color:var(--text-muted);font-weight:700;margin-bottom:6px">Cómo se usa</div>';
    h+='<ol style="margin:0 0 13px 0;padding-left:20px;font-size:12.5px;line-height:1.7">'
      +a.pasos.map(function(p){ return '<li>'+_esc(p)+'</li>'; }).join('')+'</ol>';
  }
  if(a.tip){
    h+='<div style="background:#FEF9E7;border-left:4px solid #E0A82E;border-radius:8px;padding:10px 12px">'
      +'<div style="font-size:10px;text-transform:uppercase;color:var(--t-oro);font-weight:700;margin-bottom:3px">Consejo</div>'
      +'<div style="font-size:12.5px;color:#5A4A1F;line-height:1.5">'+_esc(a.tip)+'</div></div>';
  }
  h+='</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
}

// Índice con todas las pantallas, para quien quiera verlo de corrido
function _ayudaIndice(){
  var prev=document.getElementById('ayudaOv'); if(prev) prev.remove();
  var vistos={}, lista=[];
  (CU&&CU.nav?CU.nav:[]).forEach(function(id){
    var k=_ayudaClave(id);
    if(AYUDA[k] && !vistos[k]){ vistos[k]=1; lista.push(k); }
  });
  ['inventario','ordennosap','catnosap','reporteabonos'].forEach(function(k){
    if(AYUDA[k] && !vistos[k]){ vistos[k]=1; lista.push(k); }
  });
  var ov=document.createElement('div');
  ov.id='ayudaOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2200;display:flex;align-items:center;justify-content:center;padding:18px';
  var h='<div style="background:var(--surface-0);border-radius:13px;max-width:520px;width:100%;max-height:88vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;padding:15px 18px;border-bottom:0.5px solid var(--border)">'
    +'<div style="font-size:15px;font-weight:700"><i class="ti ti-help-circle" style="color:var(--fill-accent)"></i> Guía del portal</div>'
    +'<button onclick="document.getElementById(\'ayudaOv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
  h+='<div style="padding:10px 0">';
  lista.forEach(function(k){
    var a=AYUDA[k];
    h+='<div onclick="_ayudaVer(\''+k+'\')" style="padding:10px 18px;border-bottom:0.5px solid var(--border);cursor:pointer;display:flex;gap:10px;align-items:flex-start">'
      +'<i class="ti ti-chevron-right" style="color:var(--text-muted);margin-top:2px"></i>'
      +'<div style="flex:1;min-width:0"><div style="font-size:12.5px;font-weight:600">'+_esc(a.t)+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:1px">'+_esc(a.q)+'</div></div></div>';
  });
  h+='</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
}

// ═══════════════════════════════════════════════════════════════════════════
//  BORRADO PARA GERENCIA
//  Gerencia puede eliminar del sistema órdenes NO SAP, proveedores y SKU no
//  registrados, reposiciones y los archivos que cuelgan de ellos. Todo pasa
//  por una confirmación que dice exactamente qué se va a borrar y qué se
//  lleva por delante. Nada se borra de SAP: solo de este portal.
// ═══════════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════════
//  NOMBRE PARA FIRMAR LOS CORREOS
//  Todos los correos van firmados con nombre y apellido. Si el usuario está
//  cargado solo con el nombre, puede completarlo desde su perfil y queda
//  guardado para los envíos siguientes.
// ═══════════════════════════════════════════════════════════════════════════
function _firmaNombreKey(){ return 'firma_nombre_'+((CU&&CU.id)||'x'); }

function _firmaNombre(){
  if(!CU) return '';
  // 1) Lo que el propio usuario haya completado
  try{
    var v=localStorage.getItem(_firmaNombreKey());
    if(v && v.trim()) return v.trim();
  }catch(e){}
  if(CU.firma && String(CU.firma).trim()) return String(CU.firma).trim();
  return String(CU.name||'').trim();
}

// ¿Tiene apellido? (al menos dos palabras)
function _firmaTieneApellido(){
  return String(_firmaNombre()).trim().split(/\s+/).filter(Boolean).length>=2;
}

// Pide el nombre completo y lo guarda
function _firmaPedirNombre(cb){
  var actual=_firmaNombre();
  var txt=prompt('¿Con qué nombre quieres firmar los correos?\n\n'
    +'Poné nombre y apellido, por ejemplo: Sherene Muor\n'
    +'Queda guardado para los próximos envíos.', actual);
  if(txt===null) return false;
  txt=String(txt).trim();
  if(!txt){ showT('El nombre no puede quedar vacío'); return false; }
  try{ localStorage.setItem(_firmaNombreKey(), txt); }catch(e){}
  if(CU) CU.firma=txt;
  showT('Los correos se firmarán como "'+txt+'"');
  if(typeof cb==='function') cb();
  return true;
}

// Aviso para completar el apellido, si falta
function _firmaAvisoNombre(){
  if(_firmaTieneApellido()) return '';
  return '<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:8px 10px;margin-bottom:10px;font-size:11px;color:var(--t-marron)">'
    +'<i class="ti ti-alert-circle"></i> Vas a firmar como <b>'+_esc(_firmaNombre())+'</b>, sin apellido. '
    +'<span onclick="_firmaPedirNombre(function(){ showT(\'Volvé a abrir el correo para verlo actualizado\'); })" '
    +'style="text-decoration:underline;cursor:pointer;font-weight:600">Completar mi nombre</span></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  MENCIONES CON @ EN LOS COMENTARIOS
//  Al escribir @ aparece la lista de usuarios para elegir. El mencionado
//  recibe un aviso en Alertas que lo lleva directo al comentario.
// ═══════════════════════════════════════════════════════════════════════════

// Usuarios que se pueden mencionar, filtrados por lo que se lleva escrito
function _menCandidatos(q){
  q=String(q||'').toLowerCase().trim();
  var yo=(CU&&CU.id)||'';
  return (USERS||[]).filter(function(u){
    if(u.id===yo) return false;
    if(!q) return true;
    return String(u.name||'').toLowerCase().indexOf(q)>=0
        || String(u.role||'').toLowerCase().indexOf(q)>=0
        || String(u.dept||'').toLowerCase().indexOf(q)>=0;
  }).slice(0,8);
}

// El texto que se inserta: @Nombre (sin espacios, para poder detectarlo luego)
function _menToken(u){ return '@'+String(u.name||'').replace(/\s+/g,'_'); }

// Detecta la mención que se está escribiendo justo antes del cursor
function _menEnCurso(input){
  if(!input) return null;
  var pos=input.selectionStart||0;
  var antes=String(input.value||'').slice(0,pos);
  var m=antes.match(/(^|\s)@([\wÁÉÍÓÚÑáéíóúñ_]*)$/);
  if(!m) return null;
  return {q:m[2]||'', inicio:pos-(m[2]||'').length-1, fin:pos};
}

// Muestra u oculta el desplegable de menciones
function _menRefrescar(inputId, listaId){
  var inp=document.getElementById(inputId);
  var box=document.getElementById(listaId);
  if(!inp||!box) return;
  var men=_menEnCurso(inp);
  if(!men){ box.style.display='none'; box.innerHTML=''; return; }
  var cands=_menCandidatos(men.q);
  if(!cands.length){ box.style.display='none'; box.innerHTML=''; return; }
  window._menCtx={inputId:inputId, listaId:listaId, inicio:men.inicio, fin:men.fin};
  box.innerHTML=cands.map(function(u,i){
    return '<div onmousedown="event.preventDefault();_menElegir(\''+u.id+'\')" '
      +'style="display:flex;align-items:center;gap:7px;padding:6px 9px;cursor:pointer;border-bottom:0.5px solid var(--border);font-size:11.5px"'
      +' onmouseover="this.style.background=\'var(--surface-1)\'" onmouseout="this.style.background=\'transparent\'">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(u.color||'#eee')+';color:'+(u.tc||'#333')
      +';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;flex-shrink:0">'
      +_esc(String(u.name||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join(''))+'</span>'
      +'<span style="font-weight:600">'+_esc(u.name)+'</span>'
      +'<span style="color:var(--text-muted);font-size:10px">'+_esc(u.role||'')+(u.dept?(' · '+dL(u.dept)):'')+'</span>'
      +'</div>';
  }).join('');
  box.style.display='block';
}

// Inserta la mención elegida
function _menElegir(uid){
  var ctx=window._menCtx; if(!ctx) return;
  var u=(USERS||[]).find(function(x){ return x.id===uid; });
  var inp=document.getElementById(ctx.inputId);
  if(!u||!inp) return;
  var v=String(inp.value||'');
  inp.value=v.slice(0,ctx.inicio)+_menToken(u)+' '+v.slice(ctx.fin);
  var box=document.getElementById(ctx.listaId);
  if(box){ box.style.display='none'; box.innerHTML=''; }
  window._menCtx=null;
  inp.focus();
  var p=ctx.inicio+_menToken(u).length+1;
  try{ inp.setSelectionRange(p,p); }catch(e){}
}

function _menCerrar(listaId){
  var box=document.getElementById(listaId);
  if(box){ box.style.display='none'; box.innerHTML=''; }
}

// Usuarios mencionados en un texto
function _menExtraer(texto){
  var out=[], vistos={};
  String(texto||'').replace(/@([\wÁÉÍÓÚÑáéíóúñ_]+)/g, function(_, nom){
    var busca=nom.replace(/_/g,' ').toLowerCase();
    var u=(USERS||[]).find(function(x){ return String(x.name||'').toLowerCase()===busca; });
    if(u && !vistos[u.id]){ vistos[u.id]=1; out.push(u); }
    return _;
  });
  return out;
}

// Resalta las menciones al mostrar el comentario
function _menResaltar(textoEsc){
  return String(textoEsc||'').replace(/@([\wÁÉÍÓÚÑáéíóúñ_]+)/g, function(tok, nom){
    var busca=nom.replace(/_/g,' ').toLowerCase();
    var u=(USERS||[]).find(function(x){ return String(x.name||'').toLowerCase()===busca; });
    if(!u) return tok;
    var mio=(CU && u.id===CU.id);
    return '<span style="background:'+(mio?'#FEF08A':'var(--bg-accent)')+';color:'+(mio?'#713F12':'var(--text-accent)')
      +';border-radius:5px;padding:0 5px;font-weight:700">@'+_esc(u.name)+'</span>';
  });
}

// ── Avisos de mención ──
// Se guardan en la propia solicitud/etapa para que sobrevivan a la recarga
// ═══════════════════════════════════════════════════════════════════════════
//  AVISOS DEL CIRCUITO DE PAGOS
//  Estos avisos usaban addNotif, que vive solo en memoria: al recargar la
//  página se perdían. Ahora van al sistema persistente, el mismo del globo
//  rojo, así que quedan guardados hasta que la persona los lee.
// ═══════════════════════════════════════════════════════════════════════════
function _avUsuariosPorRol(rol, dept){
  return (USERS||[]).filter(function(u){
    if(u.role!==rol || !u.id) return false;
    if(dept && rol==='compras' && String(u.dept||'')!==String(dept)) return false;
    return u.id!==((CU&&CU.id)||'');
  });
}

function _avSolicitante(x){
  var u=(USERS||[]).find(function(us){ return us.name===x.solicitado_por; });
  return u ? [u] : [];
}

// Aviso persistente sobre una solicitud de pago
async function _avSolicitud(destinos, x, texto, etiqueta){
  if(!destinos || !destinos.length) return;
  try{
    await _menNotificar(destinos, {
      docnum:x.docnum, contexto:'solicitud', solId:x.id,
      texto:texto, etiqueta:etiqueta||'Solicitud de pago'
    });
  }catch(e){ console.warn('[aviso pagos]', e); }
}

async function _menNotificar(usuarios, datos){
  if(!usuarios||!usuarios.length) return;
  var ok=0, err='';
  for(var i=0;i<usuarios.length;i++){
    var u=usuarios[i];
    try{
      var _r=await fetch(SB+'/rest/v1/menciones',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({
          para_id:u.id, para_nombre:u.name,
          de_nombre:(CU&&CU.name)||'',
          docnum:String(datos.docnum||''),
          contexto:datos.contexto||'',      // 'solicitud' | 'etapa'
          etapa:datos.etapa||'',
          paso:datos.paso||'',
          sol_id:datos.solId||null,
          texto:String(datos.texto||'').slice(0,400),
          leido:false,
          creado_en:new Date().toISOString()
        })});
      if(_r.ok) ok++;
      else {
        var _t=await _r.text();
        console.error('[mencion] no se guardó:', _r.status, _t);
        // Un fallo aquí es silencioso para el usuario y la mención se pierde:
        // hay que decirlo claro.
        err=/does not exist|Could not find the table|relation .* does not exist/i.test(_t)
          ? 'Falta la tabla menciones en Supabase (script menciones.sql).'
          : ('Error '+_r.status+' al guardar la mención.');
      }
    }catch(e){ console.warn('mencion:',e); err='No hay conexión para avisar la mención.'; }
    // OJO: no se agrega addNotif aquí. El panel "Notificación de lectura de
    // comentario" ya muestra la mención, y hacer las dos cosas la mostraba
    // dos veces al usuario mencionado.
  }
  if(err) showT('⚠ El comentario se guardó, pero no llegó el aviso. '+err);
  else if(ok) showT('✓ Se avisó a '+ok+' persona(s) mencionada(s)');
  // El mencionado ve el aviso en cuanto recargue sus menciones
  try{ if(usuarios.some(function(u){ return CU && u.id===CU.id; })) _menCargar(true).then(_menBadge); }catch(e){}
}

// Diagnóstico: dice si la tabla de menciones está lista
async function _menDiag(){
  showT('Probando la tabla menciones…');
  try{
    var r=await fetch(SB+'/rest/v1/menciones?select=id&limit=1',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      alert('La tabla "menciones" no está disponible.\n\n'
        +(/does not exist|Could not find/i.test(t)
          ? 'Todavía no se creó. Hay que correr el script menciones.sql en Supabase.'
          : ('Error '+r.status+': '+t.slice(0,200)))
        +'\n\nSin esa tabla, los @ se escriben pero el aviso no le llega a nadie.');
      return;
    }
    var p=await fetch(SB+'/rest/v1/menciones',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify({para_id:'__test__', para_nombre:'prueba', de_nombre:'diagnostico',
                           docnum:'TEST', contexto:'etapa', texto:'prueba de conexion',
                           leido:false, creado_en:new Date().toISOString()})});
    if(!p.ok){
      var t2=await p.text();
      alert('La tabla existe pero no acepta escritura.\n\n'+t2.slice(0,240)
        +'\n\nRevisa los permisos (RLS) en el script menciones.sql.');
      return;
    }
    var cr=null; try{ cr=await p.json(); }catch(e){}
    if(cr&&cr[0]&&cr[0].id){ try{ await fetch(SB+'/rest/v1/menciones?id=eq.'+cr[0].id,{method:'DELETE',headers:SBH}); }catch(e){} }
    alert('Todo bien: la tabla "menciones" acepta lectura y escritura.\n\nLos @ deberían avisar sin problema.');
  }catch(e){ alert('Error de conexión: '+(e.message||e)); }
}

// Carga las menciones sin leer del usuario
async function _menCargar(silencioso){
  if(!CU) return [];
  try{
    var r=await fetch(SB+'/rest/v1/menciones?select=*&para_id=eq.'+encodeURIComponent(CU.id)
      +'&leido=is.false&order=creado_en.desc&limit=100',{headers:SBH});
    if(!r.ok){ if(!silencioso) console.warn('menciones:', r.status); window._menciones=[]; return []; }
    var rows=await r.json();
    window._menciones=Array.isArray(rows)?rows:[];
  }catch(e){ console.warn('cargar menciones:',e); window._menciones=[]; }
  return window._menciones;
}

// Panel de "Notificación de lectura de comentario" en Alertas
function _menPanel(){
  var ms=window._menciones||[];
  if(!ms.length) return '';
  var h='<div style="border:1px solid #E0A82E;background:#FEF9E7;border-radius:10px;margin-bottom:12px;overflow:hidden">'
    +'<div style="padding:9px 13px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<i class="ti ti-at" style="color:var(--t-oro)"></i>'
      +'<span style="font-size:12.5px;font-weight:700;color:var(--t-oro)">Notificación de lectura de comentario</span>'
      +'<span style="font-size:11px;color:var(--t-oro);opacity:.85">'+ms.length+' sin leer</span>'
      +'<button class="btn bg2" style="margin-left:auto;padding:3px 10px;font-size:10.5px" onclick="_menMarcarTodas()">Marcar todas como leídas</button>'
      +'<button class="btn bg2" style="padding:3px 10px;font-size:10.5px" onclick="_menDiag()" title="Probar que los @ funcionan"><i class="ti ti-stethoscope"></i></button>'
    +'</div>';
  ms.forEach(function(m){
    var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String(m.de_nombre||''); });
    var ini=String(m.de_nombre||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join('');
    var donde=(m.paso||m.etapa||'');
    h+='<div class="men-fila" onclick="_menAbrir('+m.id+')" style="border-top:0.5px solid #E0A82E;padding:10px 13px;background:var(--surface-0);cursor:pointer;display:flex;gap:10px;align-items:flex-start">'
      +'<span style="width:28px;height:28px;border-radius:50%;flex-shrink:0;background:'+((quien&&quien.color)||'#E0A82E')
      +';color:'+((quien&&quien.tc)||'#fff')+';display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700">'
      +_esc(ini)+'</span>'
      +'<div style="flex:1;min-width:0">'
        // Los avisos del sistema (escalamiento por demora) no son menciones de
        // nadie: decir "Fulano te mencionó" confundía, porque esa persona no
        // había escrito nada, solo tenía el portal abierto.
        +'<div style="font-size:12px;font-weight:700;color:var(--t-oro)">'
        // "etiqueta" se pasa a _menNotificar pero NO se guarda en la tabla, así
        // que no sirve para distinguir. Se mira el texto, que sí está.
        +(/^(MUY )?ATRASADA?S?:/i.test(String(m.texto||''))
            ? 'Aviso del sistema'
            : (_esc(m.de_nombre||'')+' te mencionó'))+'</div>'
        +'<div style="font-size:11px;color:var(--t-oro);opacity:.9;margin-top:1px">'
          +(m.docnum?('<i class="ti ti-file-invoice" style="font-size:11px"></i> Orden '+_esc(m.docnum)):'')
          +(donde?(' <i class="ti ti-arrow-right" style="font-size:10px"></i> '+_esc(donde)):'')
        +'</div>'
        +'<div style="font-size:12px;color:var(--text-secondary);margin-top:4px;background:var(--surface-1);border-radius:7px;padding:6px 9px">'
          +_menResaltar(_esc(m.texto||''))+'</div>'
        +'<div style="font-size:10px;color:var(--text-muted);margin-top:4px">'+_esc(_fechaHora(m.creado_en))+'</div>'
      +'</div>'
      +'<div style="display:flex;flex-direction:column;gap:4px;flex-shrink:0">'
        +'<button class="btn bp" style="padding:5px 11px;font-size:10.5px;white-space:nowrap" onclick="event.stopPropagation();_menAbrir('+m.id+')">'
          +'<i class="ti ti-arrow-right"></i> Ir</button>'
        +'<button class="btn bg2" style="padding:4px 11px;font-size:10px;white-space:nowrap" onclick="event.stopPropagation();_menMarcarUna('+m.id+')" title="Quitarla sin abrirla">'
          +'Leída</button>'
      +'</div>'
    +'</div>';
  });
  return h+'</div>';
}

// Quita una mención sin abrir la orden
async function _menMarcarUna(id){
  try{ await fetch(SB+'/rest/v1/menciones?id=eq.'+id,{method:'PATCH',
    headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
    body:JSON.stringify({leido:true, leido_en:new Date().toISOString()})}); }catch(e){}
  window._menciones=(window._menciones||[]).filter(function(x){ return String(x.id)!==String(id); });
  _menBadge();
  showT('Marcada como leída');
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

// Abre la orden donde ocurrió la mención y la marca como leída
async function _menAbrir(id){
  var m=(window._menciones||[]).find(function(x){ return String(x.id)===String(id); });
  if(!m) return;
  try{ await fetch(SB+'/rest/v1/menciones?id=eq.'+id,{method:'PATCH',
    headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
    body:JSON.stringify({leido:true, leido_en:new Date().toISOString()})}); }catch(e){}
  window._menciones=(window._menciones||[]).filter(function(x){ return String(x.id)!==String(id); });
  _menBadge();

  // Si la mención vino de una ETAPA, se abre la orden en esa etapa y se deja
  // ahí, con el chat del paso listo para seguir la conversación. La ventana
  // aparte solo se usa cuando no hay etapa a la que ir.
  if(m.contexto==='etapa' && m.docnum){
    _menIrAEtapa(m);
    return;
  }
  // Las alertas de solicitud de pago llevan a la solicitud concreta, no a una
  // etapa: contabilidad quiere ver esa solicitud, no buscarla en la lista.
  if(m.contexto==='solicitud' && m.docnum){
    _menIrASolicitud(m);
    return;
  }
  _menVerHilo(m);
}

// Lleva a la solicitud de pago concreta y la resalta
function _menIrASolicitud(m){
  go('alertas');
  window._solResaltar={docnum:String(m.docnum), id:m.solId||null, hasta:Date.now()+9000};
  showT('Abriendo la solicitud de la orden '+m.docnum);
  _solResaltarIr(0);
}

function _solResaltarIr(intento){
  var r=window._solResaltar;
  if(!r || Date.now()>r.hasta){ window._solResaltar=null; return; }
  // La tarjeta de esa solicitud
  var el=(r.id!=null) ? document.getElementById('solcard-'+r.id) : null;
  if(!el){
    var cands=document.querySelectorAll('[data-soldoc="'+r.docnum+'"]');
    if(cands && cands.length) el=cands[0];
  }
  if(!el){
    if(intento>40){ window._solResaltar=null; return; }
    return setTimeout(function(){ _solResaltarIr(intento+1); }, 160);
  }
  window._solResaltar=null;
  try{ el.scrollIntoView({behavior:'smooth', block:'center'}); }catch(e){}
  el.style.transition='box-shadow .3s';
  el.style.boxShadow='0 0 0 3px var(--fill-accent)';
  setTimeout(function(){ el.style.boxShadow='none'; }, 2400);
}

// Abre la orden en la etapa exacta del comentario y prepara la respuesta
function _menIrAEtapa(m){
  var idx=STAGES.findIndex(function(s){ return s.label===m.etapa || s.key===m.etapa; });
  if(idx<0){ _menVerHilo(m); return; }
  // El paso concreto: el que tenga ese comentario en su chat
  var paso=_menPasoDelComentario(m, idx);
  window._menDestino={oid:String(m.docnum), idx:idx, paso:paso, de:m.de_nombre||'', texto:m.texto||''};
  window._abrirEtapa={oid:String(m.docnum), key:STAGES[idx].key, paso:paso};
  showT('Abriendo '+STAGES[idx].label+' — orden '+m.docnum);
  try{ _solPagoAbrir(m.docnum); }catch(e){ try{ openDetail(m.docnum); }catch(e2){} }
  _abrirEtapaPedida(0);
  _menPrepararRespuesta(0);
}

// Busca en qué subpaso está el comentario que me mencionó
function _menPasoDelComentario(m, idx){
  var st=STAGES[idx];
  if(!st) return 0;
  // Si la alerta ya dice a qué paso lleva, se usa ese
  if(m.paso){
    var ip=st.steps.findIndex(function(p){ return p.name===m.paso; });
    if(ip>=0) return ip;
  }
  for(var i=0;i<st.steps.length;i++){
    var ck='sub_'+m.docnum+'_'+st.key+'_step'+i;
    var coms=(window._subComs&&window._subComs[ck])?window._subComs[ck]:[];
    if(coms.some(function(c){ return String(c.texto||'')===String(m.texto||''); })) return i;
  }
  // Si los comentarios aún no están en memoria, se pregunta a la base y se
  // corrige el destino cuando llegue la respuesta.
  _menPasoDesdeBase(m, idx);
  return 0;
}

// Consulta en qué etapa quedó guardado el comentario
async function _menPasoDesdeBase(m, idx){
  try{
    var r=await fetch(SB+'/rest/v1/compras_comentarios?select=etapa,texto&docnum=eq.'
      +encodeURIComponent(m.docnum)+'&limit=200',{headers:SBH});
    if(!r.ok) return;
    var rows=await r.json()||[];
    var st=STAGES[idx];
    var hit=rows.find(function(c){ return String(c.texto||'')===String(m.texto||''); });
    if(!hit || !hit.etapa) return;
    var mm=String(hit.etapa).match(/_step(\d+)$/);
    if(!mm) return;
    var paso=parseInt(mm[1],10);
    if(isNaN(paso) || paso<0 || paso>=st.steps.length) return;
    if(window._menDestino && String(window._menDestino.oid)===String(m.docnum)){
      window._menDestino.paso=paso;   // se corrige antes de enfocar
    }
  }catch(e){ console.warn('paso del comentario:',e); }
}

// Deja el cursor en el chat del paso, con la persona ya etiquetada
function _menPrepararRespuesta(intento){
  var d=window._menDestino; if(!d) return;
  intento=intento||0;
  var inp=document.getElementById('subcin-'+d.oid+'-'+d.idx+'-'+d.paso);
  if(!inp){
    if(intento>50){ window._menDestino=null; return; }   // ~8 s y se rinde
    return setTimeout(function(){ _menPrepararRespuesta(intento+1); }, 160);
  }
  window._menDestino=null;
  // Responder a quien me mencionó, ya etiquetado
  var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String(d.de||''); });
  if(quien && !inp.value) inp.value=_menToken(quien)+' ';
  var caja=document.getElementById('subcms-'+d.oid+'-'+d.idx+'-'+d.paso);
  if(caja && caja.scrollIntoView) caja.scrollIntoView({behavior:'smooth', block:'center'});
  setTimeout(function(){
    try{ inp.focus(); inp.setSelectionRange(inp.value.length, inp.value.length); }catch(e){}
    // Realce breve del chat, para ubicarlo
    var cont=inp.closest?inp.closest('.cir'):null;
    if(cont){
      cont.style.transition='box-shadow .3s';
      cont.style.boxShadow='0 0 0 3px #E0A82E';
      setTimeout(function(){ cont.style.boxShadow='none'; }, 1800);
    }
  }, 220);
}

// Ventana con el hilo de comentarios donde ocurrió la mención
async function _menVerHilo(m){
  var prev=document.getElementById('menHiloOv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='menHiloOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2300;display:flex;align-items:center;justify-content:center;padding:18px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:13px;padding:22px;max-width:440px;width:100%">'
    +'<div style="font-size:12.5px;color:var(--text-muted)"><span class="ai-ring g" style="vertical-align:-2px"></span> Abriendo el comentario…</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);

  // Comentarios del hilo, según de dónde venga la mención
  var coms=[], titulo='', sub='', x=null;
  if(m.contexto==='solicitud'){
    x=_solPagoPorId(m.sol_id);
    if(!x){
      // La solicitud puede no estar cargada: se pide a la base
      try{
        var r=await fetch(SB+'/rest/v1/solicitudes_pago?select=*&id=eq.'+m.sol_id+'&limit=1',{headers:SBH});
        if(r.ok){ var f=await r.json(); if(Array.isArray(f)&&f.length){ x=f[0];
          window._solPago=(window._solPago||[]); 
          if(!window._solPago.some(function(z){return String(z.id)===String(x.id);})) window._solPago.push(x); } }
      }catch(e){}
    }
    if(x){
      coms=_solComents(x);
      titulo=(x.tipo==='abono'?'Solicitud de abono':'Solicitud de cancelación');
      sub=(x.proveedor||'')+' · orden '+(x.docnum||'')+' · '+fmt(x.monto);
    }
  } else {
    // Comentario de una etapa: se leen los del subpaso
    titulo=m.etapa||'Comentario de etapa';
    sub='Orden '+(m.docnum||'');
    try{
      var rc=await fetch(SB+'/rest/v1/compras_comentarios?select=*&docnum=eq.'+encodeURIComponent(m.docnum||'')
        +'&order=creado_en.asc&limit=200',{headers:SBH});
      if(rc.ok){
        var todos=await rc.json()||[];
        coms=todos.filter(function(c){ return String(c.texto||'').indexOf('@')>=0 || true; })
                  .map(function(c){ return {autor:c.usuario||c.autor||'', texto:c.texto||'', en:c.creado_en}; });
      }
    }catch(e){}
  }

  if(!coms.length && m.texto) coms=[{autor:m.de_nombre||'', texto:m.texto, en:m.creado_en}];

  var h='<div style="background:var(--surface-0);border-radius:13px;max-width:520px;width:100%;max-height:88vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;padding:15px 18px;border-bottom:0.5px solid var(--border)">'
    +'<div style="min-width:0"><div style="font-size:14.5px;font-weight:700"><i class="ti ti-at" style="color:var(--t-oro)"></i> '+_esc(titulo)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-top:2px">'+_esc(sub)+'</div>'
    +'<div style="font-size:11px;color:var(--t-oro);margin-top:3px"><b>'+_esc(m.de_nombre||'')+'</b> te mencionó · '+_esc(_fechaHora(m.creado_en))+'</div></div>'
    +'<button onclick="document.getElementById(\'menHiloOv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';

  h+='<div style="padding:13px 18px">';
  coms.forEach(function(c){
    var mio=(String(c.autor||'')===String((CU&&CU.name)||''));
    var esElMio=(String(c.texto||'')===String(m.texto||''));
    h+='<div style="font-size:12px;padding:7px 10px;background:'+(esElMio?'#FEF9E7':(mio?'#eef5fd':'var(--surface-1)'))+';'
      +'border-radius:8px;margin-bottom:6px'+(esElMio?';border:1px solid #E0A82E':'')+'">'
      +'<div style="font-weight:600;font-size:11px;color:var(--text-secondary)">'+_esc(c.autor||'')
      +(c.en?(' <span style="font-weight:400;color:var(--text-muted);font-size:10px">'+_esc(_fechaHora(c.en))+'</span>'):'')+'</div>'
      +'<div style="margin-top:2px">'+_menResaltar(_esc(c.texto||''))+'</div></div>';
  });

  // Responder, con la persona ya mencionada
  var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String(m.de_nombre||''); });
  var pre=quien?(_menToken(quien)+' '):'';
  h+='<div style="margin-top:10px;position:relative">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:4px">Responder'
      +(quien?(' a <b>'+_esc(quien.name)+'</b>'):'')+'</div>'
    +'<div id="menhilo-drop" style="display:none;position:absolute;bottom:100%;left:0;right:0;margin-bottom:4px;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.18);max-height:200px;overflow-y:auto;z-index:60"></div>'
    +'<div style="display:flex;gap:6px">'
      +'<input id="menhilo-in" value="'+_esc(pre)+'" placeholder="Escribe tu respuesta… usa @ para mencionar" autocomplete="off" '
      +'style="flex:1;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12px;background:var(--surface-0);color:var(--text-primary)" '
      +'oninput="_menRefrescar(\'menhilo-in\',\'menhilo-drop\')" onblur="setTimeout(function(){_menCerrar(\'menhilo-drop\');},150)" '
      +'onkeydown="if(event.key===\'Enter\'){event.preventDefault();_menResponder();}">'
      +'<button class="btn bp" style="padding:7px 12px" onclick="_menResponder()"><i class="ti ti-send"></i></button>'
    +'</div></div>';

  if(m.docnum){
    h+='<div style="margin-top:12px;display:flex;justify-content:flex-end">'
      +'<button class="btn bg2" style="padding:6px 12px;font-size:11.5px" onclick="document.getElementById(\'menHiloOv\').remove();_menIrAlContexto('+m.id+')">'
      +'<i class="ti ti-external-link"></i> Abrir la orden</button></div>';
  }
  h+='</div></div>';
  ov.innerHTML=h;
  window._menHilo=m;
  setTimeout(function(){
    var i=document.getElementById('menhilo-in');
    if(i){ i.focus(); try{ i.setSelectionRange(i.value.length,i.value.length); }catch(e){} }
  },80);
}

// Envía la respuesta desde la ventana del hilo
async function _menResponder(){
  var m=window._menHilo; if(!m) return;
  var inp=document.getElementById('menhilo-in');
  var txt=(inp&&inp.value||'').trim();
  if(!txt){ showT('Escribe una respuesta'); return; }
  if(inp){ inp.disabled=true; }

  if(m.contexto==='solicitud'){
    var x=_solPagoPorId(m.sol_id);
    if(!x){ showT('No se encontró la solicitud'); if(inp) inp.disabled=false; return; }
    var cs=_solComents(x);
    cs.push({autor:(CU&&CU.name)||'', rol:(CU&&CU.role)||'', texto:txt, en:new Date().toISOString()});
    x.comentarios=cs;
    var ok=await _solPagoPatch(m.sol_id,{comentarios:cs});
    if(!ok) showT('⚠ No se pudo guardar la respuesta');
    try{
      var men=_menExtraer(txt);
      if(men.length) await _menNotificar(men, {docnum:x.docnum, contexto:'solicitud', solId:x.id, texto:txt,
        etiqueta:'una solicitud de '+(x.tipo==='abono'?'abono':'cancelación')});
    }catch(e){}
  } else {
    try{ await guardarComentario(m.docnum, m.etapa||'', txt); }catch(e){}
    try{
      var men2=_menExtraer(txt);
      if(men2.length) await _menNotificar(men2, {docnum:m.docnum, contexto:'etapa', etapa:m.etapa, texto:txt,
        etiqueta:m.etapa||('la orden '+m.docnum)});
    }catch(e){}
  }
  var ov=document.getElementById('menHiloOv'); if(ov) ov.remove();
  showT('✓ Respuesta enviada');
  try{ _solPagoRefrescar(); }catch(e){}
}

// Abre la orden donde ocurrió la mención
function _menIrAlContexto(id){
  var m=window._menHilo;
  if(!m || String(m.id)!==String(id)) return;
  if(m.contexto==='solicitud'){
    window._solComentOpen=m.sol_id;
    go('alertas');
    setTimeout(function(){
      var el=document.getElementById('solcom-box-'+m.sol_id);
      if(el && el.scrollIntoView) el.scrollIntoView({behavior:'smooth', block:'center'});
    }, 500);
    return;
  }
  if(m.docnum){
    var idx=STAGES.findIndex(function(s){ return s.label===m.etapa || s.key===m.etapa; });
    if(idx>=0) window._abrirEtapa={oid:m.docnum, key:STAGES[idx].key};
    try{ _solPagoAbrir(m.docnum); }catch(e){}
    if(idx>=0) _abrirEtapaPedida(0);
  }
}

async function _menMarcarTodas(){
  var ms=(window._menciones||[]).slice();
  for(var i=0;i<ms.length;i++){
    try{ await fetch(SB+'/rest/v1/menciones?id=eq.'+ms[i].id,{method:'PATCH',
      headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({leido:true, leido_en:new Date().toISOString()})}); }catch(e){}
  }
  window._menciones=[];
  _menBadge();
  showT('Menciones marcadas como leídas');
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

function _menBadge(){
  var n=(window._menciones||[]).length;
  var el=document.getElementById('nbNumMen');
  if(el){
    if(n>0){
      el.textContent=(n>99?'99+':String(n));
      el.style.display='block';
      el.title=n+' comentario(s) donde te mencionaron. Pulsa Alertas para verlos.';
      el.style.cursor='pointer';
      // El globo también entra a Alertas
      el.onclick=function(ev){ ev.stopPropagation(); go('alertas'); };
    } else {
      el.textContent=''; el.style.display='none'; el.title=''; el.onclick=null;
    }
  }
}

function _menIniciar(){
  // El escalamiento por demora arranca junto con las alertas
  try{ _escIniciar(); }catch(e){ console.warn('escalamiento:',e); }
  // Y los reclamos, para que se vean sin tener que abrir cada orden
  try{ setTimeout(function(){ _reclPrecargar(); }, 2500); }catch(e){}
  _menCargar(true).then(function(){
    _menBadge();
    try{ if(PG==='alertas') rAlertas(); }catch(e){}
  }).catch(function(){});
  if(!window._menPoller){
    window._menPoller=true;
    setInterval(function(){
      _menCargar(true).then(function(){
        _menBadge();
        var escribiendo=false;
        try{
          var act=document.activeElement;
          if(act && /^(solcom-in-|subcin-|cin-)/.test(act.id||'')) escribiendo=true;
        }catch(e){}
        if(!escribiendo && PG==='alertas'){ try{ rAlertas(); }catch(e){} }
      });
    }, 45000);
  }
}

function _esGerencia(){ return !!(CU && CU.role==='gerencia'); }

// Confirmación con el detalle de lo que se elimina
function _confirmarBorrado(titulo, detalle, arrastra){
  var msg='¿Está seguro de que desea borrar '+titulo+'?';
  if(detalle) msg+='\n\n'+detalle;
  if(arrastra && arrastra.length){
    msg+='\n\nSe eliminará también:';
    arrastra.forEach(function(x){ msg+='\n  · '+x; });
  }
  msg+='\n\nEsta acción NO se puede deshacer.';
  return confirm(msg);
}

// Borra un archivo del Storage y su registro
async function _borrarArchivoStorage(path, docId){
  var ok=true;
  if(docId){
    try{ await fetch(SB+'/rest/v1/compras_documentos?id=eq.'+docId,{method:'DELETE',headers:SBH}); }
    catch(e){ ok=false; console.warn('borrar registro doc:',e); }
  }
  if(path){
    try{
      await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+String(path).split('/').map(encodeURIComponent).join('/'),
        {method:'DELETE', headers:{'apikey':KEY,'Authorization':'Bearer '+KEY}});
    }catch(e){ ok=false; console.warn('borrar archivo:',e); }
  }
  return ok;
}

// Todos los documentos colgados de una referencia
async function _docsDeOrden(ref){
  try{
    var r=await fetch(SB+'/rest/v1/compras_documentos?select=id,archivo_path,nombre&docnum=eq.'+encodeURIComponent(ref)+'&limit=500',{headers:SBH});
    if(r.ok){ var f=await r.json(); return Array.isArray(f)?f:[]; }
  }catch(e){ console.warn('docs de orden:',e); }
  return [];
}

// ── Limpiar archivos duplicados de una orden ──
// Las versiones anteriores del portal subean el mismo archivo varias veces.
// Esto deja UNA copia de cada documento y borra las demás, del registro y
// del almacenamiento.
async function _limpiarDocsDuplicados(ref, silencioso){
  var docs=[];
  try{
    var r=await fetch(SB+'/rest/v1/compras_documentos?select=id,nombre_archivo,url,etapa,subido_en&docnum=eq.'
      +encodeURIComponent(ref)+'&order=subido_en.asc&limit=500',{headers:SBH});
    if(r.ok) docs=await r.json()||[];
  }catch(e){ console.warn('leer docs:',e); return 0; }
  if(!docs.length) return 0;

  // Se agrupa por nombre + etapa: la primera copia se queda, el resto se va
  var vistos={}, sobran=[];
  docs.forEach(function(d){
    var k=String(d.etapa||'')+'|'+_docClave({name:d.nombre_archivo});
    if(vistos[k]) sobran.push(d); else vistos[k]=d;
  });
  if(!sobran.length){ if(!silencioso) showT('No hay archivos duplicados en esta orden'); return 0; }

  if(!silencioso){
    if(!confirm('Esta orden tiene '+sobran.length+' archivo(s) duplicado(s).\n\n'
      +'Se conservará una copia de cada documento y se borrarán las repetidas.\n\n¿Continuar?')) return 0;
  }
  // Las rutas que siguen en uso no se borran del almacenamiento
  var enUso={};
  Object.keys(vistos).forEach(function(k){ if(vistos[k].url) enUso[vistos[k].url]=1; });

  for(var i=0;i<sobran.length;i++){
    try{ await fetch(SB+'/rest/v1/compras_documentos?id=eq.'+sobran[i].id,{method:'DELETE',headers:SBH}); }catch(e){}
    if(sobran[i].url && !enUso[sobran[i].url]){
      try{
        await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+String(sobran[i].url).split('/').map(encodeURIComponent).join('/'),
          {method:'DELETE', headers:{'apikey':KEY,'Authorization':'Bearer '+KEY}});
      }catch(e){}
    }
  }
  // Y se limpia lo que hay en memoria
  Object.keys(window._atts||{}).forEach(function(k){
    if(k.indexOf(String(ref))===0) window._atts[k]=_dedupDocs(window._atts[k]);
  });
  if(!silencioso) showT('✓ '+sobran.length+' archivo(s) duplicado(s) eliminados');
  return sobran.length;
}

// ── Orden NO SAP: se lleva documentos, etapas, comentarios y solicitudes ──
async function _gerBorrarOrdenNoSap(ref){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar la orden completa'); return; }
  var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref); });
  var nombre=(p?(p.proveedor+' — '):'')+ref;

  showT('Revisando qué cuelga de esta orden…');
  var docs=await _docsDeOrden(ref);
  var sols=[], etapas=0, coments=0;
  try{
    var rs=await fetch(SB+'/rest/v1/solicitudes_pago?select=id,tipo,monto&docnum=eq.'+encodeURIComponent(ref)+'&limit=100',{headers:SBH});
    if(rs.ok) sols=await rs.json()||[];
  }catch(e){}
  try{
    var re=await fetch(SB+'/rest/v1/compras_seguimiento?select=etapa&docnum=eq.'+encodeURIComponent(ref)+'&limit=50',{headers:SBH});
    if(re.ok) etapas=(await re.json()||[]).length;
  }catch(e){}
  try{
    var rc=await fetch(SB+'/rest/v1/compras_comentarios?select=id&docnum=eq.'+encodeURIComponent(ref)+'&limit=200',{headers:SBH});
    if(rc.ok) coments=(await rc.json()||[]).length;
  }catch(e){}

  var arrastra=[];
  if(docs.length)   arrastra.push(docs.length+' archivo(s) adjunto(s)');
  if(etapas)        arrastra.push('el avance de '+etapas+' etapa(s)');
  if(coments)       arrastra.push(coments+' comentario(s)');
  if(sols.length)   arrastra.push(sols.length+' solicitud(es) de pago');

  if(!_confirmarBorrado('la orden NO SAP "'+nombre+'"',
      'Se borra solo de este portal. SAP no se toca.', arrastra)) return;

  showT('Borrando…');
  // Archivos primero: si algo falla, se ve antes de perder el registro
  for(var i=0;i<docs.length;i++){ await _borrarArchivoStorage(docs[i].archivo_path, docs[i].id); }
  var tablas=[
    ['compras_seguimiento','docnum'],
    ['compras_comentarios','docnum'],
    ['compras_com_pend','docnum'],
    ['solicitudes_pago','docnum'],
    ['compras_pend_sap','dkc']
  ];
  for(var t=0;t<tablas.length;t++){
    try{ await fetch(SB+'/rest/v1/'+tablas[t][0]+'?'+tablas[t][1]+'=eq.'+encodeURIComponent(ref),{method:'DELETE',headers:SBH}); }
    catch(e){ console.warn('borrar '+tablas[t][0]+':',e); }
  }
  try{ await fetch(SB+'/rest/v1/compras_pend_sap?num_orden=eq.'+encodeURIComponent(ref),{method:'DELETE',headers:SBH}); }catch(e){}

  // Limpieza en memoria
  window._pendSAP=(window._pendSAP||[]).filter(function(x){ return String(x.dkc)!==String(ref)&&String(x.num_orden)!==String(ref); });
  if(typeof orders!=='undefined') orders=orders.filter(function(o){ return !(o._noSap && String(o.id)===String(ref)); });
  if(stageProgress) delete stageProgress[ref];
  if(window._atts) delete window._atts[ref+'__pendsap'];
  window._solPago=(window._solPago||[]).filter(function(x){ return String(x.docnum)!==String(ref); });

  showT('✓ Orden '+ref+' eliminada por completo');
  _refrescarPantalla();
  try{ _solPagoBadgeIniciar&&_solPagoBadgeIniciar(); }catch(e){}
}

// ── Proveedor NO SAP: con todos sus SKU ──
async function _gerBorrarProveedorNoSap(cardcode){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar el proveedor completo'); return; }
  var k=_catKeyProv(cardcode);
  var prov=(window._catNoSap||[]).find(function(f){ return f.tipo==='proveedor' && _catKeyProv(f.cardcode)===k; });
  var items=_catItemsDeProveedor(cardcode);
  var nombre=(prov?prov.cardname:'')||cardcode;

  var arrastra=[];
  if(items.length) arrastra.push(items.length+' SKU nuevo(s) de este proveedor');
  if(!_confirmarBorrado('el proveedor NO SAP "'+cardcode+' — '+nombre+'"',
      'Se quita solo de este portal. Las órdenes que lo usan no se tocan.', arrastra)) return;

  showT('Borrando…');
  var ids=[]; if(prov) ids.push(prov.id);
  items.forEach(function(it){ if(it.id) ids.push(it.id); });
  for(var i=0;i<ids.length;i++){
    try{ await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+ids[i],{method:'DELETE',headers:SBH}); }catch(e){}
  }
  window._catNoSap=(window._catNoSap||[]).filter(function(f){ return ids.indexOf(f.id)<0; });
  _catNoSapBadge();
  showT('✓ Proveedor y '+items.length+' SKU eliminados');
  rCatNoSap();
}

// ── Solo los SKU de un proveedor, dejando la ficha del proveedor ──
// Hace falta cuando el proveedor YA existe en SAP y lo único pendiente son
// sus artículos: antes había que borrarlos de uno en uno.
async function _gerBorrarSkuDeProveedor(cardcode){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar los SKU'); return; }
  var items=_catItemsDeProveedor(cardcode);
  if(!items.length){ showT('Ese proveedor no tiene SKU'); return; }
  var k=_catKeyProv(cardcode);
  var prov=(window._catNoSap||[]).find(function(f){ return f.tipo==='proveedor' && _catKeyProv(f.cardcode)===k; });
  var nombre=(prov?prov.cardname:'')||(items[0]&&items[0].cardname)||cardcode;

  if(!_confirmarBorrado('los '+items.length+' SKU de "'+cardcode+' — '+nombre+'"',
      'Se quitan solo de este portal. Las órdenes que los usan no se tocan.',
      [items.length+' SKU nuevo(s)'])) return;

  showT('Borrando '+items.length+' SKU…');
  var n=0;
  for(var i=0;i<items.length;i++){
    if(!items[i].id) continue;
    try{
      await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+items[i].id,{method:'DELETE',headers:SBH});
      n++;
    }catch(e){}
  }
  var ids={};
  items.forEach(function(it){ ids[it.id]=1; });
  window._catNoSap=(window._catNoSap||[]).filter(function(f){ return !ids[f.id]; });
  _catNoSapBadge();
  showT('✓ '+n+' SKU eliminados');
  rCatNoSap();
}

// ── Todas las fichas de una vez ──

// ═══════ LIMPIEZA DE DATOS DE PRUEBA (solo gerencia) ═══════
async function _gerLimpiarPruebas(){
  if(!_esGerencia()){ showT('Solo gerencia puede limpiar los datos de prueba'); return; }
  if(!confirm('Esto borra TODOS los reclamos, reposiciones y los montos/logs de prueba guardados.\n\nNO toca proveedores, órdenes, SKU, fotos ni cuentas.\n\n¿Continuar?')) return;
  showT('Limpiando datos de prueba…');
  var borrados={reclamos:0, repos:0, envios:0, logs:0};

  // 1. Reclamos (tabla reclamos)
  try{
    await fetch(SB+'/rest/v1/reclamos?id=gt.0',{method:'DELETE',headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    borrados.reclamos=1;
  }catch(e){ console.warn('reclamos:',e); }

  // 2. Reposiciones (pedidos + envíos)
  try{
    await fetch(SB+'/rest/v1/reposiciones_envios?id=gt.0',{method:'DELETE',headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    borrados.envios=1;
  }catch(e){ console.warn('rep envios:',e); }
  try{
    await fetch(SB+'/rest/v1/reposiciones_pedidos?id=gt.0',{method:'DELETE',headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    borrados.repos=1;
  }catch(e){ console.warn('rep pedidos:',e); }

  // 3. Logs de localStorage (montos de reclamo, logística de prueba)
  try{
    var quitar=[];
    for(var i=0;i<localStorage.length;i++){
      var k=localStorage.key(i);
      if(k && (k.indexOf('log_')===0 || k.indexOf('iarev_')===0 || k.indexOf('recepcion_')===0 || k.indexOf('muestras_')===0)) quitar.push(k);
    }
    quitar.forEach(function(k){ localStorage.removeItem(k); });
    borrados.logs=quitar.length;
  }catch(e){}

  // 4. Limpiar memoria
  try{ window._reclEstados={}; window._reclCargado=false; }catch(e){}
  try{ window._repPedidos=[]; window._repEnvios=[]; }catch(e){}
  try{ (window._pendSAP||[]).forEach(function(p){ if(p.logistica&&p.logistica.reclamo) delete p.logistica.reclamo; }); }catch(e){}

  showT('✓ Datos de prueba eliminados. Recarga la página.');
  setTimeout(function(){ location.reload(); }, 1500);
}

async function _gerVaciarCatalogoNoSap(){
  if(!_esGerencia()){ showT('Solo gerencia puede vaciar el catálogo'); return; }
  var filas=window._catNoSap||[];
  if(!filas.length){ showT('No hay nada que borrar'); return; }
  var provs=filas.filter(function(f){return f.tipo==='proveedor';}).length;
  var items=filas.filter(function(f){return f.tipo==='item';}).length;
  if(!_confirmarBorrado('TODO el catálogo NO SAP',
      'Se eliminan todas las fichas temporales de este portal. SAP no se toca.',
      [provs+' proveedor(es) nuevo(s)', items+' SKU nuevo(s)'])) return;
  if(!confirm('Última confirmación.\n\nSe van a borrar '+filas.length+' fichas. ¿Continuar?')) return;
  showT('Borrando '+filas.length+' fichas…');
  for(var i=0;i<filas.length;i++){
    try{ await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+filas[i].id,{method:'DELETE',headers:SBH}); }catch(e){}
  }
  window._catNoSap=[];
  _catNoSapBadge();
  showT('✓ Catálogo NO SAP vaciado');
  rCatNoSap();
}

// ── Reposición enviada: con su archivo ──
async function _gerBorrarReposicion(id, archivoPath){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar la reposición'); return; }
  var env=(window._repEnvios||[]).find(function(x){ return String(x.id)===String(id); });
  var nombre=env?((env.cardcode||'')+' — '+(env.cardname||'')):('#'+id);
  var arrastra=[];
  if(archivoPath||(env&&env.archivo_path)) arrastra.push('el archivo adjunto de la reposición');
  if(!_confirmarBorrado('la reposición de "'+nombre+'"',
      'Se elimina del seguimiento de reposiciones.', arrastra)) return;
  showT('Borrando…');
  var path=archivoPath||(env&&env.archivo_path);
  if(path) await _borrarArchivoStorage(path, null);
  try{ await fetch(SB+'/rest/v1/reposiciones_envios?id=eq.'+id,{method:'DELETE',headers:SBH}); }catch(e){}
  window._repEnvios=(window._repEnvios||[]).filter(function(x){ return String(x.id)!==String(id); });
  showT('✓ Reposición eliminada');
  try{ _repEnviosCargar(); }catch(e){}
  try{ _repBadgeActualizar(); }catch(e){}
}

// ── Solicitud de pago ──
async function _gerBorrarSolicitud(id){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar solicitudes'); return; }
  var x=_solPagoPorId(id);
  if(!x){ showT('Solicitud no encontrada'); return; }
  var nombre=(x.tipo==='abono'?'solicitud de abono':'solicitud de cancelación')
    +' de '+(x.proveedor||'')+' por '+fmt(x.monto);
  var cs=_solComents(x);
  var arrastra=[];
  if(cs.length) arrastra.push(cs.length+' comentario(s)');
  if(!_confirmarBorrado('la '+nombre, 'Dejará de aparecer en alertas y en el reporte.', arrastra)) return;
  try{ await fetch(SB+'/rest/v1/solicitudes_pago?id=eq.'+id,{method:'DELETE',headers:SBH}); }catch(e){}
  window._solPago=(window._solPago||[]).filter(function(s){ return String(s.id)!==String(id); });
  showT('✓ Solicitud eliminada');
  _solPagoRefrescar();
}

// ── Archivo suelto de cualquier etapa ──
async function _gerBorrarArchivo(oid, stageKey, i){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar archivos de las etapas'); return; }
  var k=oid+stageKey;
  var a=(window._atts&&window._atts[k])?window._atts[k][i]:null;
  if(!a){ showT('Archivo no encontrado'); return; }
  if(!_confirmarBorrado('el archivo "'+(a.name||'sin nombre')+'"',
      'Se elimina del portal y del almacenamiento.')) return;
  await _borrarArchivoStorage(a.url, a.id);
  window._atts[k].splice(i,1);
  showT('✓ Archivo eliminado');
  try{ openDetail(oid); }catch(e){}
}

// ══════════════════════════════════════════════════════════════════════
//  MODO CLARO Y MODO OSCURO
//  Por defecto se sigue lo que tenga puesto el sistema operativo, que es lo
//  que la mayoría espera. Quien quiera otra cosa lo elige aquí y se le
//  recuerda en su equipo.
//    'auto'  → lo que diga el sistema
//    'claro' → siempre claro
//    'oscuro'→ siempre oscuro
// ══════════════════════════════════════════════════════════════════════
function _temaGuardado(){
  // Por defecto CLARO: los colores de siempre. El modo oscuro solo si la
  // persona lo elige, no por lo que tenga puesto el sistema. Así nadie se
  // encuentra el portal cambiado sin haberlo pedido.
  try{ return localStorage.getItem('kcc_tema') || 'claro'; }catch(e){ return 'claro'; }
}

function _temaEfectivo(){ return _temaGuardado()==='oscuro' ? 'oscuro' : 'claro'; }

function _temaAplicar(){
  try{
    var el=document.documentElement;
    el.setAttribute('data-tema', _temaEfectivo());
    // Para que el navegador pinte del color correcto los campos nativos:
    // desplegables, calendarios y barras de desplazamiento
    el.style.colorScheme = (_temaEfectivo()==='oscuro') ? 'dark' : 'light';
  }catch(e){}
}

function _temaCambiar(){
  var nuevo = (_temaGuardado()==='oscuro') ? 'claro' : 'oscuro';
  try{ localStorage.setItem('kcc_tema', nuevo); }catch(e){}
  _temaAplicar();
  try{ if(CU) renderApp(); else renderLogin(); }catch(e){}
  showT(nuevo==='oscuro' ? 'Modo nocturno' : 'Modo diurno');
}

function _temaBoton(){
  var osc = _temaEfectivo()==='oscuro';
  return '<button onclick="_temaCambiar()" '
    +'title="'+(osc?'Modo nocturno. Pulsa para el diurno.':'Modo diurno. Pulsa para el nocturno.')+'" '
    +'style="background:transparent;border:0.5px solid var(--border);border-radius:8px;'
    +'width:32px;height:32px;cursor:pointer;font-size:15px;line-height:1;'
    +'color:'+(osc?'#F0B366':'#B45309')+';display:flex;align-items:center;'
    +'justify-content:center;padding:0">'
    +'<i class="ti '+(osc?'ti-moon':'ti-sun')+'"></i></button>';
}

// Al arrancar
_temaAplicar();

function renderApp(){const rl={gerencia:(_deptAcotado()?('Encargado · '+_deptEtiqueta()):'Gerencia'),compras:'Compras · '+(_deptEtiqueta()||''),diseno:'Diseño',importacion:'Importación',contabilidad:'Contabilidad',bodega:'Bodega'};const ndefs={dashboard:{i:'ti-layout-dashboard',l:'Inicio'},ordenes:{i:'ti-search',l:'Buscar órdenes'},completadas:{i:'ti-circle-check',l:'Completadas'},pendientes:{i:'ti-writing',l:'Por aprobar',dot:true},contab:{i:'ti-coin',l:'Contabilidad'},deptos:{i:'ti-chart-bar',l:'Departamentos'},mistarea:{i:CU.role==='importacion'?'ti-ship':CU.role==='bodega'?'ti-building-warehouse':'ti-palette',l:CU.role==='importacion'?'Embarques':CU.role==='bodega'?'Bodega':'Mis artes'},alertas:{i:'ti-bell',l:(CU.role==='contabilidad'?'Solicitudes de abonos o cancelaciones':'Alertas')},reposiciones:{i:'ti-package',l:'Reposiciones'},reppedidos:{i:'ti-clipboard-list',l:'Pedidos guardados'},nueva:{i:'ti-writing',l:(CU.role==='gerencia'?'Compras para firmar':'Nueva compra para firma')},livechat:{i:'ti-messages',l:'Live Chat'},reportes:{i:'ti-report',l:'Reportes'}};const colores={gerencia:'#EAF3DE',compras:'#e6f1fb',diseno:'#EEEDFE',importacion:'#E1F5EE',contabilidad:'#FBEAF0',bodega:'#FEF3E8'};const tcs={gerencia:'#27500A',compras:'#0c447c',diseno:'#3C3489',importacion:'#085041',contabilidad:'#72243E',bodega:'#7C3D12'};const p=pCnt(),unr=unreadN();document.getElementById('root').innerHTML=`<div class="topbar"><h1><img src="${KCC_GLOBO}" alt="Kennedy Center" class="kcc-logo-top">Control de compras<span title="Versión del portal. Si no coincide con la última que te pasaron, tu navegador tiene una copia vieja: recarga con Ctrl+F5." style="font-size:10px;font-weight:600;color:var(--text-muted);background:var(--surface-1);border-radius:20px;padding:2px 9px;margin-left:9px;vertical-align:middle">${APP_VERSION}</span></h1><div style="display:flex;gap:5px;align-items:center">${_temaBoton()}<div style="display:flex;flex-direction:column;align-items:center;gap:1px"><button id="btnSync" onclick="hacerSyncGlobal()" style="background:var(--fill-accent);color:white;border:none;border-radius:9px;padding:9px 18px;cursor:pointer;font-size:14px;font-weight:700;display:flex;align-items:center;gap:7px"><i class="ti ti-refresh" id="syncIcon" style="font-size:16px"></i> Sync</button><div id="syncTime" style="font-size:11px;color:var(--text-secondary);white-space:nowrap;font-weight:500;margin-top:2px">${window._ultimoSync||'—'}</div></div>${unr>0?`<span class="badge" style="background:var(--pastel-naranja);color:var(--t-marron);cursor:pointer" onclick="renderNP()"><i class="ti ti-bell" style="font-size:10px"></i> ${unr}</span>`:''}<span class="badge b-al"><i class="ti ti-alert-triangle" style="font-size:10px"></i> <span id="ac">${vO().filter(o=>o.alerta).length}</span></span><span class="badge b-sap">SAP B1</span></div></div><div class="ub"><div style="position:relative;flex-shrink:0"><div id="topAvatar" class="uav" style="background:${colores[CU.role]||'#eee'};color:${tcs[CU.role]||'#333'};background-size:cover;background-position:center">${CU.ini}</div><button onclick="_perfilCambiar()" title="Cambiar foto de perfil" style="position:absolute;bottom:-2px;right:-2px;width:17px;height:17px;border-radius:50%;border:1.5px solid var(--surface-0);background:#075E54;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0"><i class="ti ti-camera" style="font-size:9px"></i></button></div><div style="flex:1"><div style="font-size:12px;font-weight:600">${CU.name}</div><div style="font-size:10px;color:var(--text-muted);margin-top:1px">${CU.email}</div>${window._ultimoLoginPrevio?`<div style="font-size:9.5px;color:var(--text-accent);margin-top:2px;display:flex;align-items:center;gap:3px"><i class="ti ti-clock" style="font-size:10px"></i>Último acceso: ${window._ultimoLoginPrevio}</div>`:''}<div style="display:flex;align-items:center;gap:5px;margin-top:2px"><span class="urb" style="background:${colores[CU.role]};color:${tcs[CU.role]}">${rl[CU.role]||CU.role}</span>${_deptAcotado()?`<span style="font-size:10px;color:var(--text-muted)">${_deptEmojis()} Solo ${_deptEtiqueta()}</span>`:''}${CU.role==='diseno'?'<span style="font-size:10px;color:#7F77DD;background:#EEEDFE;padding:1px 6px;border-radius:8px">Solo pedido y artes</span>':''}${CU.role==='bodega'?'<span style="font-size:10px;color:var(--t-marron);background:var(--pastel-naranja);padding:1px 6px;border-radius:8px">Solo bodega</span>':''}</div></div><button class="xb" onclick="_ayudaIndice()" title="Guía del portal: qué hace cada pantalla" style="margin-right:6px"><i class="ti ti-help-circle" style="font-size:11px"></i> Ayuda</button><button class="xb" onclick="logout()"><i class="ti ti-logout" style="font-size:11px"></i> Salir</button></div><div id="notif-area"></div><div class="nav">${CU.nav.map(nid=>{const n=ndefs[nid];if(!n)return'';return`<button class="nb" onclick="go('${nid}',this)"><i class="ti ${n.i}"></i>${n.l}${nid==='pendientes'&&p>0?'<span class="nb-dot"></span>':''}${nid==='reposiciones'?'<span class="nb-num" id="nbNumRep" style="display:none"></span>':''}${nid==='alertas'?'<span class="nb-num" id="nbNumMen" style="display:none"></span>':''}${nid==='alertas'?'<span class="nb-num" id="nbNumSol" style="display:none"></span>':''}${AYUDA[_ayudaClave(nid)]?_ayudaBtn(_ayudaClave(nid)):''}</button>`;}).join('')}${CU.role!=='contabilidad'?`<button class="nb" onclick="go('inventario',this)"><i class="ti ti-package"></i>Consulta inventario${_ayudaBtn('inventario')}</button>`:''}${(CU.role==='gerencia'||CU.role==='compras'||CU.role==='importacion')?`<button class="nb" style="color:var(--t-ambar)" onclick="go('ocpend',this)"><i class="ti ti-package-off"></i>Órdenes de Compra Abiertas</button>`:''}${(CU.role==='gerencia'&&!_deptAcotado())?`<button class="nb" onclick="go('accesos',this)"><i class="ti ti-history"></i>Registro de accesos</button>`:''}${(CU.role==='contabilidad'||(CU.role==='gerencia'&& !_deptAcotado()))?`<button class="nb" style="color:var(--t-vino)" onclick="_solPagoReporteMenu()"><i class="ti ti-printer"></i>Reporte abonos y cancelaciones${_ayudaBtn('reporteabonos')}</button><button class="nb" style="color:var(--t-vino)" onclick="go('concil',this)"><i class="ti ti-scale"></i>Conciliación bancaria</button>`:''}${(CU.role==='gerencia'||CU.role==='compras')?`<button class="nb" style="color:var(--t-ambar)" onclick="abrirNuevaOrdenSinSAP('${_deptPrimero()}')"><i class="ti ti-plus"></i>Agregar nueva orden NO SAP${_ayudaBtn('ordennosap')}</button><button class="nb" style="color:var(--t-lila)" onclick="go('catnosap',this)"><i class="ti ti-tags"></i>Proveedores y SKU NO SAP<span class="nb-num" id="nbNumCat" style="display:none"></span>${_ayudaBtn('catnosap')}</button>`:''}</div>${['dashboard','ordenes','completadas','pendientes','deptos','mistarea','alertas','reposiciones','nueva','livechat','catnosap','inventario','ocpend','accesos','reportes','concil'].map(id=>`<div id="page-${id}" class="page"></div>`).join('')}`;renderNP();go('dashboard');setTimeout(_firmaBadgeIniciar,600);setTimeout(_dmInit,900);setTimeout(_repBadgeIniciar,800);setTimeout(_catNoSapIniciar,1100);setTimeout(_solPagoBadgeIniciar,1000);setTimeout(function(){ try{ _repCargarProveedores(); }catch(e){} },1500);setTimeout(_menIniciar,1200);}
function renderNP(){const area=document.getElementById('notif-area');if(!area)return;const mine=notifications.filter(n=>!n.read&&(n.to===CU?.role||n.to===CU?.id));if(!mine.length){area.innerHTML='';return;}area.innerHTML=`<div class="notif-panel"><div class="notif-hdr"><span style="font-size:12px;font-weight:500;color:var(--t-marron);display:flex;align-items:center;gap:5px"><i class="ti ti-bell"></i>${mine.length} notificación${mine.length>1?'es':''}</span><span style="font-size:11px;color:var(--t-marron);cursor:pointer;font-weight:500" onclick="markAllR()">Marcar leídas</span></div>${mine.map(n=>`<div class="ni" onclick="rdN(${n.id},'${n.oid||''}')"><div class="ndot" style="background:${n.icon==='ti-writing-sign'?'#16a34a':n.icon==='ti-x'?'#dc2626':n.icon==='ti-table'?'#eda100':'#2a78d6'}"></div><div style="flex:1"><div style="font-size:12px;font-weight:500">${n.msg}</div><div style="font-size:10px;color:var(--text-muted);margin-top:2px">${n.time}</div></div><i class="ti ti-eye" style="font-size:12px;color:var(--text-accent)"></i></div>`).join('')}</div>`;}
function rdN(id,oid){const n=notifications.find(x=>x.id===id);if(n)n.read=true;renderNP();if(oid)setTimeout(()=>openDetail(oid),100);}
function markAllR(){notifications.forEach(n=>{if(n.to===CU?.role||n.to===CU?.id)n.read=true;});renderNP();renderApp();}
function oCard(o){initP(o.id);const sc=CU.verCostos&&CU.role!=='diseno'&&CU.role!=='bodega';const comp=o.completada,pPct=getPct(o),stageName=getStageName(o),stageColor=getStageColor(o);const borderCls=o.alerta?'al':comp?'comp':o.pend?'pend':'ok';const si=getStageIdx(o),stg=STAGES[si],sd=stg?getStageStartEnd(o,stg.key):{start:'',end:'',days:0,active:false,done:false};const depAbn=stageProgress[o.id]?.deposito?.stepDates?.[1]||'';const diasDesdeAbn=depAbn?daysBetween(depAbn,null):0;return`<div class="ocard ${borderCls}" onclick="openDetail('${o.id}')"><div class="oh"><div class="oi">${o.emoji}</div><div class="om"><div class="oc">${o.prov} — ${o.id}${o.num_proveedor?` - <span style="font-weight:700;color:var(--t-ambar)">${o.num_proveedor}</span>`:''}</div><div class="od">${dL(o.dept)} · ${o.desc} · ${o.uni?.toLocaleString()||0} und</div><div style="font-size:11px;color:var(--text-muted);margin-top:1px">Cod proveedor: ${o.resp?`<span onclick="event.stopPropagation();abrirInvProveedor('${String(o.resp).replace(/'/g,'')}')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline;font-weight:600">${o.resp}</span>`:'—'}${sc&&!o.completada?` &nbsp;·&nbsp; <span style="color:var(--text-danger);font-weight:500">Saldo prov: ${fmt(saldoProv(o.prov))}</span>`:''}</div><div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:3px"><span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>${o.fechaCreacion}</span>${o.fechaEst?`<span class="fecha-badge"><i class="ti ti-calendar-due" style="font-size:10px"></i>ETA: ${o.fechaEst}</span>`:''}${_arteBadge(o)}${o.num_proveedor?`<span class="fecha-badge" style="background:#EEF2FF;color:var(--t-indigo2)"><i class="ti ti-file-invoice" style="font-size:10px"></i>Ref: ${o.num_proveedor}</span>`:''}</div>${!o.pend&&!comp&&sd.start?`<div class="estado-dates"><span class="ed ed-start"><i class="ti ti-player-play" style="font-size:9px"></i>${stg?.label}: ${sd.start}</span>${sd.done&&sd.end?`<span class="ed ed-end"><i class="ti ti-circle-check" style="font-size:9px"></i>Fin: ${sd.end}</span><span class="ed ed-dur"><i class="ti ti-clock" style="font-size:9px"></i>${sd.days}d</span>`:sd.active?`<span class="ed ed-act"><i class="ti ti-clock" style="font-size:9px"></i>${sd.days}d en progreso</span>`:''}</div>`:''}${sc&&depAbn&&!comp?`<div style="font-size:10px;color:var(--text-muted);margin-top:3px"><i class="ti ti-coin" style="font-size:9px"></i> Abono: ${depAbn} · hace ${diasDesdeAbn}d</div>`:''}${o.pend?`<div class="pchip"><i class="ti ti-clock" style="font-size:10px"></i>Pendiente firma</div>`:''}${comp?`<div style="font-size:10px;background:#F0EEFF;color:var(--t-indigo);padding:2px 7px;border-radius:8px;display:inline-flex;align-items:center;gap:3px;margin-top:3px"><i class="ti ti-circle-check" style="font-size:10px"></i>Proceso completo</div>`:''}${o.alerta?`<div class="achip"><i class="ti ti-alert-triangle" style="font-size:10px"></i>${o.alertaMsg}</div>`:''}${badge6m(o)}</div><div style="display:flex;flex-direction:column;align-items:flex-end;gap:5px"><span class="sem ${getSem(o)}"></span><span style="font-size:10px;padding:2px 7px;border-radius:10px;background:${stageColor}22;color:${stageColor};border:0.5px solid ${stageColor}44;white-space:nowrap;max-width:85px;text-align:right">${stageName}</span><span style="font-size:10px;color:var(--text-muted)">${pPct}%</span></div></div><div class="pb"><div class="pf" style="width:${pPct}%;background:${stageColor}"></div></div><div class="om2">${(sc||CU.role==='compras')?`<span><i class="ti ti-currency-dollar" style="font-size:11px"></i>Total ${fmt(o.valor)}</span><span style="color:var(--text-success)">Abonado ${fmt(o.abono)} · ${pct(o.abono,o.valor)}%</span><span style="color:var(--text-danger)">Saldo ${fmt(o.valor-o.abono)}</span>`:''}<span style="color:var(--text-accent)"><i class="ti ti-eye" style="font-size:11px"></i>Ver detalle</span></div></div>`;}

// ── Helper: ¿orden tiene +6 meses y aún no embarcada? ──
function alerta6meses(o){
  if(o.completada||o.pend)return false;
  var dias=daysBetween(o.fechaCreacion,null);
  if(dias<182)return false;
  initP(o.id);
  var logIdx=stageProgress[o.id]&&stageProgress[o.id].logistica?stageProgress[o.id].logistica.stepIdx:0;
  var stageI=getStageIdx(o);
  return stageI<=4&&logIdx<3;
}
function badge6m(o){
  if(!alerta6meses(o))return'';
  var dias=daysBetween(o.fechaCreacion,null);
  return'<div style="display:inline-flex;align-items:center;gap:4px;margin-top:3px;padding:3px 8px;border-radius:8px;background:var(--pastel-naranja);border:0.5px solid #f5c9a0;color:var(--t-marron);font-size:10px;font-weight:500"><i class="ti ti-alarm" style="font-size:10px"></i>'+dias+'d sin embarcar — +6 meses</div>';
}
function saldoProv(prov){
  return orders.filter(function(o){return o.prov===prov&&!o.completada;}).reduce(function(s,o){return s+(o.valor-o.abono);},0);
}
let _oSort='nuevo', _oKpiFilter=null, _oKpiDept=null, _oSapFilter='todas';
function _setSapFilter(v){ _oSapFilter=v; rOrdenes(); }
function rDash(){
  // Si el contenedor no está dibujado, no hay nada que pintar. Esto pasa
  // cuando una carga termina ANTES de que la pantalla exista: reventaba con
  // "Cannot set properties of null" y cortaba el repintado a la mitad.
  // Al volver la pantalla, se pinta con normalidad.
  if(!document.getElementById('page-dashboard')) return;
  /* Las tarjetas y las pastillas de abajo leían "orders" y DEPTS_ALL, o sea
     TODOS los departamentos. Con gerencia acotada por área (Gady en
     alfombras, Henry en ropa) eso les enseñaba lo que no les toca.
     vO() y _deptsVisibles() aplican ese límite y no cambian nada para quien
     no tiene departamento asignado. */
  const vo=vO(),al=vo.filter(o=>o.alerta).length;const activas=vo.filter(o=>!o.completada),comp=vo.filter(o=>o.completada),pend=vo.filter(o=>o.pend);const porLlegar=activas.filter(o=>!o.pend&&(getStageIdx(o)===4||getStageIdx(o)===5));const costeoEst=activas.filter(o=>!o.pend&&getStageIdx(o)===5);const tv=activas.reduce((s,o)=>s+o.valor,0),ta=activas.reduce((s,o)=>s+o.abono,0);(function(){var _ac=document.getElementById('ac'); if(_ac) _ac.textContent=al;})();/* Se comprueba que exista: rDash puede llamarse cuando una carga
     termina ANTES de que la barra esté dibujada, y entonces reventaba
     con "Cannot set properties of null" y cortaba el repintado. */const visStages=stagesForUser();const gByStage=STAGES.map((_,i)=>activas.filter(o=>!o.pend&&getStageIdx(o)===i).length);const porLlegarByDept={};_deptsVisibles().forEach(d=>{porLlegarByDept[d]=porLlegar.filter(o=>o.dept===d).length;});let html='';try{html+=_solPagoDashBanner();}catch(e){}if(pend.length&&(CU.role==='gerencia'||CU.role==='compras')){const byDept={};pend.forEach(o=>{byDept[o.dept]=(byDept[o.dept]||[]);byDept[o.dept].push(o);});html+=`<div class="ab"><i class="ti ti-writing" style="font-size:18px;color:var(--text-warning)"></i><div style="flex:1"><div style="font-size:12px;color:var(--text-warning);font-weight:500">${pend.length} orden${pend.length>1?'es':''} pendiente${pend.length>1?'s':''} de firma</div><div style="display:flex;gap:5px;flex-wrap:wrap;margin-top:5px">${Object.entries(byDept).map(([d,list])=>`<span style="font-size:10px;background:var(--bg-warning);border:0.5px solid var(--border-warning);border-radius:8px;padding:2px 8px;color:var(--text-warning)">${EMOJIS2[d]||''} ${dL(d)}: ${list.length}</span>`).join('')}</div></div><button class="btn bw" onclick="go('pendientes')"><i class="ti ti-eye"></i>Ver</button></div>`;}if(costeoEst.length&&CU.role==='gerencia'){const byDept={};costeoEst.forEach(o=>{byDept[o.dept]=(byDept[o.dept]||[]);byDept[o.dept].push(o);});html+=`<div style="background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:var(--radius);padding:10px 12px;margin-bottom:10px"><div style="display:flex;align-items:center;gap:10px"><i class="ti ti-table" style="font-size:18px;color:var(--t-marron)"></i><div style="flex:1"><div style="font-size:12px;color:var(--t-marron);font-weight:500">${costeoEst.length} costeo${costeoEst.length>1?'s':''} pendiente${costeoEst.length>1?'s':''} de precios</div><div style="display:flex;gap:5px;flex-wrap:wrap;margin-top:5px">${Object.entries(byDept).map(([d,list])=>`<span style="font-size:10px;background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:8px;padding:2px 8px;color:var(--t-marron);cursor:pointer" onclick="openDetail('${list[0].id}')">${EMOJIS2[d]||''} ${dL(d)}: ${list.length}</span>`).join('')}</div></div></div></div>`;}html+=`<div class="kpi-grid"><div class="kpi ${dashKpiFilter==='activas'?'kpi-active':''}" onclick="toggleKpiFilter('activas')"><div class="kpi-l"><i class="ti ti-shopping-cart"></i>Activas</div><div class="kpi-v kva">${activas.length}</div></div><div class="kpi ${dashKpiFilter==='completadas'?'kpi-active':''}" onclick="toggleKpiFilter('completadas')"><div class="kpi-l"><i class="ti ti-circle-check"></i>Completadas</div><div class="kpi-v kvs">${comp.length}</div></div>${(CU.role==='gerencia'||CU.role==='compras')?`<div class="kpi ${dashKpiFilter==='pend'?'kpi-active':''}" onclick="toggleKpiFilter('pend')"><div class="kpi-l"><i class="ti ti-writing"></i>Sin firmar</div><div class="kpi-v kvw">${pend.length}</div></div>`:''}${CU.verCostos?`<div class="kpi ${dashKpiFilter==='tot'?'kpi-active':''}" onclick="toggleKpiFilter('tot')"><div class="kpi-l"><i class="ti ti-currency-dollar"></i>Total SAP</div><div class="kpi-v">${fmt(tv)}</div></div><div class="kpi ${dashKpiFilter==='abn'?'kpi-active':''}" onclick="toggleKpiFilter('abn')"><div class="kpi-l"><i class="ti ti-coin"></i>Abonado SAP ${pct(ta,tv)}%</div><div class="kpi-v kvs">${fmt(ta)}</div></div><div class="kpi ${dashKpiFilter==='sal'?'kpi-active':''}" onclick="toggleKpiFilter('sal')"><div class="kpi-l"><i class="ti ti-receipt"></i>Saldo SAP ${pct(tv-ta,tv)}%</div><div class="kpi-v kvd">${fmt(tv-ta)}</div></div>
<div class="kpi ${dashKpiFilter==='ns_tot'?'kpi-active':''}" style="border-color:#C4B5FD;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);cursor:pointer" onclick="toggleKpiFilter('ns_tot')"><div class="kpi-l" style="color:var(--t-lila2)"><i class="ti ti-file-invoice"></i>Total No SAP</div><div class="kpi-v" style="color:var(--t-lila2)">${_nsapKpi(totalPendSAP())}</div></div>
<div class="kpi ${dashKpiFilter==='ns_abn'?'kpi-active':''}" style="border-color:#C4B5FD;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);cursor:pointer" onclick="toggleKpiFilter('ns_abn')"><div class="kpi-l" style="color:var(--t-lila2)"><i class="ti ti-coin"></i>Abonado No SAP</div><div class="kpi-v kvs" style="color:#059669">${_nsapKpi(totalAbonPendSAP())}</div></div>
<div class="kpi ${dashKpiFilter==='ns_sal'?'kpi-active':''}" style="border-color:#C4B5FD;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);cursor:pointer" onclick="toggleKpiFilter('ns_sal')"><div class="kpi-l" style="color:var(--t-lila2)"><i class="ti ti-receipt"></i>Saldo No SAP</div><div class="kpi-v kvd">${_nsapKpi(totalPendSAP()-totalAbonPendSAP())}</div></div>
<div class="kpi" style="border-color:#185FA5;background:linear-gradient(135deg,#EFF6FF,#DBEAFE);grid-column:span 2"><div class="kpi-l" style="color:#185FA5;font-weight:700"><i class="ti ti-sigma"></i>GRAN TOTAL (SAP + No SAP)</div><div class="kpi-v" style="color:#185FA5;font-size:18px;font-weight:800">${fmt(tv+totalPendSAP())}</div></div>
<div class="kpi" style="border-color:#059669;background:linear-gradient(135deg,#ECFDF5,#D1FAE5)"><div class="kpi-l" style="color:#059669;font-weight:600"><i class="ti ti-coin"></i>Gran Total Abonado</div><div class="kpi-v kvs" style="font-size:15px">${fmt(ta+totalAbonPendSAP())}</div></div>
<div class="kpi" style="border-color:var(--t-rojo2);background:linear-gradient(135deg,#FEF2F2,#FEE2E2)"><div class="kpi-l" style="color:var(--t-rojo2);font-weight:600"><i class="ti ti-receipt"></i>Gran Total Saldo</div><div class="kpi-v kvd" style="font-size:15px">${fmt((tv-ta)+(totalPendSAP()-totalAbonPendSAP()))}</div></div>
`:''}
<div class="kpi ${dashKpiFilter==='llegar'?'kpi-active':''}" onclick="toggleKpiFilter('llegar')"><div class="kpi-l"><i class="ti ti-ship"></i>Por llegar</div><div class="kpi-v" style="color:#1D9E75">${porLlegar.length}</div></div><div class="kpi ${dashKpiFilter==='sap'?'kpi-active':''}" onclick="toggleKpiFilter('sap')"><div class="kpi-l"><i class="ti ti-clock-pause"></i>Orden No SAP</div><div class="kpi-v" style="color:var(--t-ambar)">${pendientesSAPVisibles().length}${CU.verCostos?` <span style="font-size:12px;font-weight:500">· ${fmt(totalPendSAP())}</span>`:''}</div></div><div class="kpi ${dashKpiFilter==='alertas'?'kpi-active':''}" onclick="toggleKpiFilter('alertas')"><div class="kpi-l"><i class="ti ti-alert-triangle"></i>Alertas</div><div class="kpi-v kvd">${al}</div></div></div>`;if(dashKpiFilter){let panelOrdenes=[],panelTitle='',panelColor='#2a78d6';let esNoSAP=false;if(dashKpiFilter==='activas'){panelOrdenes=activas.filter(o=>!o.pend);panelTitle=`Órdenes activas (${panelOrdenes.length})`;panelColor='var(--text-accent)';}else if(dashKpiFilter==='completadas'){panelOrdenes=comp;panelTitle=`Completadas (${comp.length})`;panelColor='var(--text-success)';}else if(dashKpiFilter==='pend'){panelOrdenes=pend;panelTitle=`Sin firmar (${pend.length})`;panelColor='#BA7517';}else if(dashKpiFilter==='llegar'){panelOrdenes=porLlegar;panelTitle=`Por llegar (${porLlegar.length})`;panelColor='#1D9E75';}else if(dashKpiFilter==='alertas'){panelOrdenes=vo.filter(o=>o.alerta);panelTitle=`Con alertas (${panelOrdenes.length})`;panelColor='var(--text-danger)';}else if(dashKpiFilter==='tot'){panelOrdenes=activas.filter(o=>!o.pend);panelTitle=`Total SAP (${panelOrdenes.length})`;panelColor='var(--text-accent)';}else if(dashKpiFilter==='abn'){panelOrdenes=activas.filter(o=>o.abono>0);panelTitle=`Abonado SAP (${panelOrdenes.length})`;panelColor='var(--text-success)';}else if(dashKpiFilter==='sal'){panelOrdenes=activas.filter(o=>(o.valor-o.abono)>0);panelTitle=`Saldo SAP (${panelOrdenes.length})`;panelColor='var(--text-danger)';}else if(dashKpiFilter==='sap'){esNoSAP=true;panelOrdenes=pendientesSAPVisibles();panelTitle=`Orden No SAP (${panelOrdenes.length})`;panelColor='#B45309';}else if(dashKpiFilter==='ns_tot'){esNoSAP=true;panelOrdenes=pendientesSAPVisibles();panelTitle=`Total No SAP (${panelOrdenes.length})`;panelColor='#6D28D9';}else if(dashKpiFilter==='ns_abn'){esNoSAP=true;panelOrdenes=pendientesSAPVisibles().filter(p=>(Number(p.abonado)||0)>0);panelTitle=`Abonado No SAP (${panelOrdenes.length})`;panelColor='#6D28D9';}else if(dashKpiFilter==='ns_sal'){esNoSAP=true;panelOrdenes=pendientesSAPVisibles().filter(p=>((p.saldo!=null?p.saldo:(Number(p.total)||0)-(Number(p.abonado)||0)))>0);panelTitle=`Saldo No SAP (${panelOrdenes.length})`;panelColor='#6D28D9';}
html+=`<div class="kpi-panel"><div class="kpi-panel-hdr"><span style="font-size:12px;font-weight:600;color:${panelColor};display:flex;align-items:center;gap:5px"><i class="ti ti-list"></i>${panelTitle}</span><button class="btn bg2" style="padding:2px 8px;font-size:11px" onclick="toggleKpiFilter(null)"><i class="ti ti-x" style="font-size:11px"></i></button></div>`
  +`<div style="padding:8px 10px;border-bottom:0.5px solid var(--border)"><div style="position:relative"><i class="ti ti-search" style="position:absolute;left:9px;top:50%;transform:translateY(-50%);color:var(--text-muted);font-size:13px"></i><input id="dashKpiSearch" placeholder="Buscar por proveedor o número de orden..." value="${_dashKpiQ||''}" oninput="_dashKpiFiltrar(this.value)" style="width:100%;padding:7px 10px 7px 30px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;background:var(--surface-2);color:var(--text-primary)"></div></div>`
  +`<div id="dashKpiList">${_dashKpiRenderList(panelOrdenes, esNoSAP)}</div></div>`;}
  else { html += _dashExtraPanel(activas); }if((CU.role==='gerencia'||CU.role==='contabilidad')&&porLlegar.length){const deptConL=_deptsVisibles().filter(d=>porLlegarByDept[d]>0);html+=`<div style="background:var(--pastel-verde2);border:0.5px solid #0F6E56;border-radius:var(--radius);padding:10px 12px;margin-bottom:12px"><div style="font-size:12px;font-weight:500;color:var(--t-verde2);margin-bottom:7px;display:flex;align-items:center;gap:5px"><i class="ti ti-ship"></i>Por llegar por departamento</div><div style="display:flex;gap:7px;flex-wrap:wrap">${deptConL.map(d=>`<span style="background:var(--surface-2);border:0.5px solid #0F6E56;border-radius:10px;padding:3px 10px;font-size:11px;cursor:pointer;color:var(--t-verde2)" onclick="go('deptos')"><strong>${porLlegarByDept[d]}</strong> ${EMOJIS2[d]} ${dL(d)}</span>`).join('')}</div></div>`;}html+=`<div class="slbl"><i class="ti ti-map"></i>Estado por etapa — clic para ver</div>`;if(CU.role==='gerencia')html+=`<div class="dept-filter-row">${(_deptAcotado()?['todos'].concat(_deptsVisibles()):['todos',...DEPTS_ALL]).map(d=>`<span class="dept-chip ${dashStageDept===d?'active':''}" onclick="setDashDept('${d}')">${dL(d)}</span>`).join('')}</div>`;html+=`<div class="etapa-grid">${visStages.map(s=>{const ri=STAGES.indexOf(s);let cnt=dashStageDept==='todos'||CU.role!=='gerencia'?gByStage[ri]:activas.filter(o=>!o.pend&&getStageIdx(o)===ri&&o.dept===dashStageDept).length;const isA=activeDashStage===s.key;return`<div class="etapa-card ${isA?'active-stage':''}" onclick="toggleDashStage('${s.key}')"><div class="etapa-n" style="color:${s.color}">${cnt}</div><div class="etapa-l">${s.label}</div></div>`;}).join('')}</div>`;if(activeDashStage){const st=STAGES.find(s=>s.key===activeDashStage);const stIdx=STAGES.indexOf(st);let list=activas.filter(o=>!o.pend&&getStageIdx(o)===stIdx);if(dashStageDept!=='todos'&&CU.role==='gerencia')list=list.filter(o=>o.dept===dashStageDept);html+=`<div class="etapa-list"><div class="etapa-list-hdr"><div style="display:flex;align-items:center;gap:7px"><i class="ti ${st.icon}" style="font-size:14px;color:${st.color}"></i><span style="font-size:12px;font-weight:500">${st.label} — ${list.length} orden${list.length!==1?'es':''}${dashStageDept!=='todos'?' · '+dL(dashStageDept):''}</span></div><button class="btn bg2" style="padding:3px 8px;font-size:11px" onclick="activeDashStage=null;rDash()"><i class="ti ti-x" style="font-size:11px"></i></button></div>${list.length?list.map(o=>{const sp=stageProgress[o.id]||{};const sS=sp[activeDashStage]||{};const dias=sS.startDate?daysBetween(sS.startDate,null):0;return`<div class="etapa-list-item" onclick="openDetail('${o.id}')"><div style="font-size:20px;flex-shrink:0">${o.emoji}</div><div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">${o.prov} — ${o.id}${o.num_proveedor?` - <span style="font-weight:700;color:var(--t-ambar)">${o.num_proveedor}</span>`:''}</div><div style="font-size:11px;color:var(--text-secondary)">${dL(o.dept)} · ${o.desc}</div><div style="display:flex;gap:5px;margin-top:3px;flex-wrap:wrap"><span class="fecha-badge"><i class="ti ti-calendar" style="font-size:9px"></i>${sS.startDate||o.fechaCreacion}</span>${diasBadge(dias)}</div></div><span class="sem sem-y"></span></div>`;}).join(''):'<div class="empty">No hay órdenes en esta etapa</div>'}</div>`;}if(CU.role==='gerencia'||CU.role==='contabilidad'){html+=`<div class="slbl"><i class="ti ti-chart-bar"></i>Por departamento</div><div class="dept-sem-grid">${_deptsVisibles().map(d=>{const list=vO().filter(o=>o.dept===d);if(!list.length)return'';const tot=list.reduce((s,o)=>s+o.valor,0),abn=list.reduce((s,o)=>s+o.abono,0);const pctAbn=pct(abn,tot),pctSal=100-pctAbn;const actCnt=list.filter(o=>!o.completada).length,compCnt=list.filter(o=>o.completada).length;const diasProm=Math.round(list.filter(o=>!o.completada&&!o.pend).reduce((s,o)=>s+daysBetween(o.fechaCreacion,null),0)/Math.max(1,actCnt));const semColor=pctSal>70?'#e24b4a':pctSal>40?'#eda100':'#639922';const porLleg=porLlegarByDept[d]||0;return`<div class="dept-sem-card"><div class="dept-sem-hdr" onclick="go('deptos')" style="cursor:pointer;display:flex;align-items:center;gap:11px">${_deptIconHTML(d,52)}<div style="flex:1;min-width:0"><div class="dept-sem-name" style="font-size:15px;font-weight:700">${dL(d)}</div><div class="dept-sem-count">${list.length} total · ${compCnt} comp · ${actCnt} activas${porLleg>0?` · <span style="color:var(--t-verde2);font-weight:500">${porLleg} por llegar</span>`:''}${_ocPendResumenDept(d)}</div></div></div><div class="dept-sem-body"><div class="sem-row"><span class="sem-label">Total</span><span onclick="_dMF='total';_dMD='${d}';go('deptos')" class="sem-val" style="cursor:pointer;text-decoration:underline;font-weight:600">${fmt(tot)}</span></div><div class="sem-row"><span class="sem-label" style="color:#639922">Abonado</span><div class="sem-bar-bg"><div class="sem-bar-fill" style="width:${pctAbn}%;background:#639922"></div></div><span onclick="_dMF='abonado';_dMD='${d}';go('deptos')" class="sem-val" style="color:#639922;cursor:pointer;text-decoration:underline">${fmt(abn)} · ${pctAbn}%</span></div><div class="sem-row"><span class="sem-label" style="color:${semColor}">Saldo</span><div class="sem-bar-bg"><div class="sem-bar-fill" style="width:${pctSal}%;background:${semColor}"></div></div><span onclick="_dMF='saldo';_dMD='${d}';go('deptos')" class="sem-val" style="color:${semColor};cursor:pointer;text-decoration:underline">${fmt(abn>0?tot-abn:0)} · ${pctSal}%</span></div><div class="sem-dias"><span class="sem" style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${semColor};margin-right:4px"></span>Promedio: ${diasProm} días</div>${_ocPendFilaDept(d)}${_dashDeptSinSAP(d,tot,abn)}</div></div>`;}).join('')}</div>`;html+=_invValPanel();html+=_vtaDepPanel();}if(pend.length&&(CU.role==='gerencia'||CU.role==='compras'))html+=`<div class="slbl" style="color:var(--text-warning)"><i class="ti ti-writing"></i>Pendientes de firma</div>${pend.slice(0,2).map(o=>oCard(o)).join('')}`;if(CU.role==='diseno'){
    var _enArtes=activas.filter(function(o){return !o.pend;});
    var _artActivos=_enArtes.filter(function(o){return tieneAdjuntoArte(o.id);});
    // Pendiente = ni terminado ni empezado. Antes bastaba con no tener un
    // arte adjunto, así que una orden con la etapa cerrada y el semáforo en
    // verde seguía contando como pendiente.
    var _artPend=_enArtes.filter(function(o){
      return !_arteCompleta(o) && !_arteEnProceso(o); });
    var _artHechos=_enArtes.filter(_arteCompleta);
    html+='<div class="slbl"><i class="ti ti-palette"></i>Artes activos ('+_artActivos.length+')</div>';
    html+=(_artActivos.length?_artActivos.slice(0,4).map(function(o){return oCard(o);}).join(''):'<div class="empty">Sin artes en trabajo</div>');
    html+='<div class="slbl" style="color:#BA7517"><i class="ti ti-clock"></i>Artes pendientes ('
      +_artPend.length+') de '+_enArtes.length+' totales'
      +(_artHechos.length?(' <span style="font-weight:400;color:var(--t-verde)">· '
        +_artHechos.length+' ya terminados</span>'):'')+'</div>';
    html+=(_artPend.length?_artPend.slice(0,4).map(function(o){return oCard(o);}).join(''):'<div class="empty">No hay artes pendientes</div>');
    document.getElementById('page-dashboard').innerHTML=html;return;
  }
  // Actividad reciente agrupada por departamento
// Si el usuario tiene un departamento asignado (no gerencia), solo ve la actividad de SU depto.
var _raExcl=(CU&&CU.deptExcl)||[];
var _raOrdenes=_recentActivity.map(function(a){return orders.find(function(o){return String(o.id)===String(a.docnum)&&!o.completada;});}).filter(Boolean).filter(function(o){
  if(CU&& _deptAcotado()) return _deptPermitido(o.dept);         // usuario de un solo depto
  if(_raExcl.length) return _raExcl.indexOf(o.dept)<0;  // usuario con deptos excluidos
  return true;                                       // gerencia: ve todo
});
// Deduplicar por id de orden, mantener orden
var _raVistas={}, _raList=[];
_raOrdenes.forEach(function(o){if(!_raVistas[o.id]){_raVistas[o.id]=true;_raList.push(o);}});
if(_raList.length){
  // Agrupar por departamento
  var _raDepts={};
  _raList.forEach(function(o){
    if(!_raDepts[o.dept])_raDepts[o.dept]=[];
    _raDepts[o.dept].push(o);
  });
  html+='<div class="slbl"><i class="ti ti-activity"></i>Actividad reciente por departamento <span style="font-size:10px;font-weight:400;color:var(--text-muted)">(últimas 48h)</span></div>';
  html+='<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(320px,1fr));gap:10px;margin-bottom:14px">';
  Object.keys(_raDepts).forEach(function(d){
    var list=_raDepts[d];
    html+='<div style="background:var(--surface-1);border:0.5px solid var(--border);border-radius:10px;overflow:hidden">';
    html+='<div style="display:flex;align-items:center;gap:7px;padding:8px 12px;background:var(--surface-2);border-bottom:0.5px solid var(--border)">';
    html+='<span style="font-size:16px">'+(EMOJIS2[d]||'📦')+'</span>';
    html+='<span style="font-size:12px;font-weight:600">'+dL(d)+'</span>';
    html+='<span style="margin-left:auto;font-size:10px;background:var(--bg-accent);color:var(--text-accent);padding:1px 7px;border-radius:8px;font-weight:600">'+list.length+' activa'+(list.length>1?'s':'')+'</span>';
    html+='</div>';
    list.forEach(function(o){
      var act=_recentActivity.find(function(a){return String(a.docnum)===String(o.id);});
      var tsLabel='';
      if(act&&act.ts){
        var mins=Math.round((Date.now()-new Date(act.ts).getTime())/60000);
        if(mins<60)tsLabel='hace '+mins+'m';
        else if(mins<1440)tsLabel='hace '+Math.round(mins/60)+'h';
        else tsLabel='hace '+Math.round(mins/1440)+'d';
      }
      var etapaLabel=act?({pedido:'Pedido',deposito:'Depósito',artes:'Artes',produccion:'Producción',logistica:'Logística',costeo:'Costeo',bodega:'Bodega'}[act.etapa]||act.etapa):'';
      var tipoIcon=act&&act.tipo==='comentario'?'<i class="ti ti-message" style="font-size:9px;color:var(--text-muted)"></i>':'<i class="ti ti-edit" style="font-size:9px;color:var(--text-muted)"></i>';
      html+='<div data-oid="'+o.id+'" class="ra-row" style="display:flex;align-items:center;gap:9px;padding:8px 12px;border-bottom:0.5px solid var(--border);cursor:pointer;transition:background .15s">';
      html+='<span class="sem '+(o.completada?'sem-g':o.pend?'sem-y':'sem-y')+'" style="width:8px;height:8px;flex-shrink:0"></span>';
      html+='<div style="flex:1;min-width:0">';
      html+='<div style="font-size:12px;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+o.prov+' <span style="color:var(--text-muted);font-weight:400">#'+o.id+'</span></div>';
      html+='<div style="display:flex;gap:6px;align-items:center;margin-top:2px;flex-wrap:wrap">';
      if(etapaLabel)html+='<span style="font-size:10px;background:var(--surface-2);border:0.5px solid var(--border);border-radius:5px;padding:0 5px">'+etapaLabel+'</span>';
      if(act&&act.autor)html+=tipoIcon+'<span style="font-size:10px;color:var(--text-muted)">'+act.autor+'</span>';
      html+='</div></div>';
      if(tsLabel)html+='<span style="font-size:10px;color:var(--text-accent);white-space:nowrap;flex-shrink:0">'+tsLabel+'</span>';
      if(CU.verCostos&&o.abono)html+='<span style="font-size:10px;color:var(--text-success);white-space:nowrap;flex-shrink:0">'+fmt(o.abono)+'</span>';
      html+='</div>';
    });
    html+='</div>';
  });
  html+='</div>';
} else {
  html+='<div class="slbl"><i class="ti ti-activity"></i>Actividad reciente</div>';
  html+='<div class="empty" style="margin-bottom:14px"><i class="ti ti-moon" style="font-size:20px;color:var(--text-muted)"></i><br>Sin actividad en las últimas 48 horas</div>';
}document.getElementById('page-dashboard').innerHTML=html;}
function toggleKpiFilter(f){dashKpiFilter=dashKpiFilter===f?null:f;_dashKpiQ='';rDash();}
var _dashKpiQ='';
// Filtra la lista del panel KPI en vivo (por proveedor o número de orden), sin redibujar todo
function _dashKpiFiltrar(q){
  _dashKpiQ=q||'';
  var cont=document.getElementById('dashKpiList');
  if(!cont)return;
  // Recalcular la lista según el filtro activo
  var info=_dashKpiObtenerLista();
  cont.innerHTML=_dashKpiRenderList(info.lista, info.esNoSAP);
  // Mantener foco en el input
  var inp=document.getElementById('dashKpiSearch');
  if(inp){ inp.focus(); try{inp.setSelectionRange(inp.value.length,inp.value.length);}catch(e){} }
}
// Devuelve la lista base según el filtro KPI activo (para el filtrado en vivo)
function _dashKpiObtenerLista(){
  var vo=vO();
  var activas=vo.filter(function(o){return !o.completada;});
  var comp=vo.filter(function(o){return o.completada;});
  var pend=vo.filter(function(o){return o.pend;});
  var porLlegar=activas.filter(function(o){return !o.pend&&(getStageIdx(o)===4||getStageIdx(o)===5);});
  var f=dashKpiFilter, esNoSAP=false, lista=[];
  if(f==='activas'||f==='tot')lista=activas.filter(function(o){return !o.pend;});
  else if(f==='completadas')lista=comp;
  else if(f==='pend')lista=pend;
  else if(f==='llegar')lista=porLlegar;
  else if(f==='alertas')lista=vo.filter(function(o){return o.alerta;});
  else if(f==='abn')lista=activas.filter(function(o){return o.abono>0;});
  else if(f==='sal')lista=activas.filter(function(o){return (o.valor-o.abono)>0;});
  else if(f==='sap'||f==='ns_tot'){esNoSAP=true;lista=pendientesSAPVisibles();}
  else if(f==='ns_abn'){esNoSAP=true;lista=pendientesSAPVisibles().filter(function(p){return (Number(p.abonado)||0)>0;});}
  else if(f==='ns_sal'){esNoSAP=true;lista=pendientesSAPVisibles().filter(function(p){return ((p.saldo!=null?p.saldo:(Number(p.total)||0)-(Number(p.abonado)||0)))>0;});}
  return {lista:lista, esNoSAP:esNoSAP};
}
// Renderiza la lista del panel (SAP o No SAP), aplicando el filtro de búsqueda
function _dashKpiRenderList(lista, esNoSAP){
  var q=(_dashKpiQ||'').toLowerCase().trim();
  if(esNoSAP){
    var arr=lista.filter(function(p){
      if(!q)return true;
      return String(p.proveedor||'').toLowerCase().includes(q)||String(p.num_orden||p.dkc||'').toLowerCase().includes(q)||String(p.po||'').toLowerCase().includes(q);
    });
    if(!arr.length)return '<div class="empty">Sin órdenes'+(q?' para "'+_esc(q)+'"':'')+'</div>';
    return arr.map(function(p){
      var saldo=(p.saldo!=null?p.saldo:(Number(p.total)||0)-(Number(p.abonado)||0));
      var _refPend=String(p.dkc||p.num_orden||'').replace(/\x27/g,'');
      return '<div class="kpi-panel-item" style="cursor:pointer" onclick="abrirDetalleNoSap(\''+_refPend+'\')">'
        +'<div style="font-size:18px;flex-shrink:0">📄</div>'
        +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+_esc(p.proveedor||'?')+' — '
          // El número de orden es un enlace explícito para abrir la orden
          +'<span onclick="event.stopPropagation();abrirPendSAP(\''+_refPend+'\')" title="Abrir la orden '+_esc(p.num_orden||p.dkc||'')+'" style="color:var(--text-accent);text-decoration:underline;cursor:pointer;font-weight:700">'+_esc(p.num_orden||p.dkc||'')+'</span>'
          +' <span style="font-size:9px;background:var(--pastel-naranja);color:var(--t-ambar);border-radius:4px;padding:0 5px;font-weight:700">NO SAP</span>'+_pendSAPBadgeEditada(p)+'</div>'
        +'<div style="font-size:11px;color:var(--text-secondary)">'+dL(p.dept||'')+(p.po?(' · PO: '+_esc(p.po)):'')
          +((Number(p.abonado)>0)?(' · <span style="color:var(--t-verde);font-weight:600"><i class="ti ti-coin" style="font-size:9px"></i> Abono: '+_esc(p.fecha_abono||'sin fecha')+'</span>'):'')+'</div></div>'
        +(CU.verCostos?'<div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">'+fmt(Number(p.total)||0)+'</div><div style="font-size:10px;color:var(--text-success)">'+fmt(Number(p.abonado)||0)+'</div><div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(saldo)+'</div></div>':'')
      +'</div>';
    }).join('');
  } else {
    var arr2=lista.filter(function(o){
      if(!q)return true;
      return String(o.prov||'').toLowerCase().includes(q)||String(o.id||'').toLowerCase().includes(q)||String(o.num_proveedor||'').toLowerCase().includes(q)||String(o.desc||'').toLowerCase().includes(q);
    });
    if(!arr2.length)return '<div class="empty">Sin órdenes'+(q?' para "'+_esc(q)+'"':'')+'</div>';
    return arr2.map(function(o){
      return '<div class="kpi-panel-item" onclick="openDetail(\''+o.id+'\')"><div style="font-size:18px;flex-shrink:0">'+o.emoji+'</div>'
        +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+_esc(o.prov)+' — '+_esc(o.id)+(o.num_proveedor?' - <span style="font-weight:700;color:var(--t-ambar)">'+_esc(o.num_proveedor)+'</span>':'')+'</div>'
        +'<div style="font-size:11px;color:var(--text-secondary)">'+dL(o.dept)+' · '+_esc(o.desc)+'</div>'
        +'<div style="display:flex;gap:5px;margin-top:2px;flex-wrap:wrap"><span class="fecha-badge" style="margin-top:0"><i class="ti ti-calendar" style="font-size:9px"></i>'+o.fechaCreacion+'</span>'
        +((Number(o.abono)>0)?('<span class="fecha-badge" style="margin-top:0;background:var(--pastel-ok);color:var(--t-verde);border-color:var(--t-verde3)"><i class="ti ti-coin" style="font-size:9px"></i>Abono: '+_esc(o.fechaAbono||'sin fecha')+'</span>'):'')
        +(o.alerta?'<span style="font-size:10px;background:var(--bg-danger);color:var(--text-danger);padding:1px 7px;border-radius:8px">'+o.alertaMsg+'</span>':'')+'</div></div>'
        +(CU.verCostos?'<div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">'+fmt(o.valor)+'</div><div style="font-size:10px;color:var(--text-success)">'+fmt(o.abono)+'</div><div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</div></div>':'')
      +'</div>';
    }).join('');
  }
}
function _dashExtraPanel(activas){
  if(!dashKpiFilter||!['tot','abn','sal'].includes(dashKpiFilter))return'';
  var lst=dashKpiFilter==='tot'?activas:dashKpiFilter==='abn'?activas.filter(function(o){return o.abono>0;}):activas.filter(function(o){return(o.valor-o.abono)>0;});
  var lbl={tot:'Total en órdenes',abn:'Abonadas',sal:'Con saldo'}[dashKpiFilter];
  var col=dashKpiFilter==='abn'?'var(--text-success)':dashKpiFilter==='sal'?'var(--text-danger)':'var(--text-accent)';
  return'<div class="kpi-panel"><div class="kpi-panel-hdr"><span style="font-size:12px;font-weight:600;color:'+col+';display:flex;align-items:center;gap:5px"><i class="ti ti-list"></i>'+lbl+' ('+lst.length+')</span><button class="btn bg2" style="padding:2px 8px;font-size:11px" onclick="toggleKpiFilter(null)"><i class="ti ti-x" style="font-size:11px"></i></button></div>'
    +lst.map(function(o){return'<div class="kp-row" data-oid="'+o.id+'" style="cursor:pointer;display:flex;align-items:center;gap:10px;padding:9px 14px;border-bottom:0.5px solid var(--border)">'
      +'<span style="font-size:18px">'+o.emoji+'</span>'
      +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+o.prov+' — '+o.id+'</div>'
      +'<div style="font-size:11px;color:var(--text-secondary)">'+dL(o.dept)+' · '+o.fechaCreacion+'</div></div>'
      +'<div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">'+fmt(o.valor)+'</div>'
      +'<div style="font-size:10px;color:var(--text-success)">'+fmt(o.abono)+'</div>'
      +'<div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</div></div>'
      +'</div>';}).join('')
    +'</div>';
}
function toggleDashStage(key){
  // Si hay un departamento seleccionado en el dashboard, al hacer clic en una
  // etapa se muestra el listado COMPLETO del departamento (igual que la sección
  // Departamentos), en vez del listado simple por etapa.
  if(dashStageDept && dashStageDept!=='todos' && CU.role==='gerencia'){
    _deptoAutoAbrir=dashStageDept;
    go('deptos');
    return;
  }
  activeDashStage=activeDashStage===key?null:key;rDash();
}
function setDashDept(d){dashStageDept=d;rDash();}
function rOrdenes(d){
  if(!document.getElementById('page-ordenes')) return;dO=d||dO;const avD=_deptAcotado()?['todos'].concat(_deptsVisibles()):['todos',...DEPTS_ALL];let base=vO();if(dO!=='todos'&& !_deptAcotado())base=base.filter(o=>o.dept===dO);const q=searchQuery.toLowerCase().trim();if(q)base=base.filter(o=>o.prov.toLowerCase().includes(q)||o.id.toLowerCase().includes(q)||o.desc.toLowerCase().includes(q)||dL(o.dept).toLowerCase().includes(q)||o.resp.toLowerCase().includes(q)||String(o.num_proveedor||'').toLowerCase().includes(q));
  // FIX 1: sort
  // Filtros por lo que falta llegar. Se cruzan con las órdenes por su
  // referencia (el DKC/SKC) o por el número de pedido de SAP.
  if(_oSapFilter==='abiertas' || _oSapFilter==='sinrecibir'){
    var _pend=_ocPendIndice();
    base=base.filter(function(o){
      var p=_pend[_ocPendClave(o)];
      if(!p) return false;
      return _oSapFilter==='sinrecibir' ? p.completa : !p.completa;
    });
  }
  base=base.slice().sort(function(a,b){var da=parseDateStr(a.fechaCreacion)||new Date(0),db=parseDateStr(b.fechaCreacion)||new Date(0);return _oSort==='nuevo'?db-da:da-db;});
  const activas=base.filter(o=>!o.completada),completadas=base.filter(o=>o.completada);
  const list=[...activas,...completadas];
  const t=activas.reduce((s,o)=>s+o.valor,0),a=activas.reduce((s,o)=>s+o.abono,0),sal=t-a;
  // FIX 2: panel KPI clickeado
  var oKpiPanel='';
  if(_oKpiFilter){
    var _okl=_oKpiFilter==='total'?activas:_oKpiFilter==='abonado'?activas.filter(o=>o.abono>0):activas.filter(o=>(o.valor-o.abono)>0);
    if(_oKpiDept&&_oKpiDept!=='todos')_okl=_okl.filter(o=>o.dept===_oKpiDept);
    var _okc=_oKpiFilter==='abonado'?'var(--text-success)':_oKpiFilter==='saldo'?'var(--text-danger)':'var(--text-accent)';
    var _oklbl={total:'Total en órdenes',abonado:'Abonadas',saldo:'Con saldo pendiente'}[_oKpiFilter];
    oKpiPanel='<div style="background:var(--surface-2);border:0.5px solid var(--border-accent);border-radius:var(--radius);margin-bottom:12px;overflow:hidden">'
      +'<div style="display:flex;align-items:center;padding:10px 14px;background:var(--bg-accent)">'
      +'<span style="font-size:13px;font-weight:600;color:'+_okc+'">'+_oklbl+(_oKpiDept&&_oKpiDept!=='todos'?' — '+dL(_oKpiDept):'')+' ('+_okl.length+')</span>'
      +'<button onclick="_oKpiFilter=null;_oKpiDept=null;rOrdenes()" style="margin-left:auto;background:none;border:none;font-size:20px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
      +_okl.map(function(o){return'<div data-oid="'+o.id+'" class="kp-row" style="display:flex;align-items:center;gap:10px;padding:9px 14px;border-bottom:0.5px solid var(--border);cursor:pointer">'
        +'<span style="font-size:18px">'+o.emoji+'</span>'
        +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+o.prov+' — #'+o.id+'</div>'
        +'<div style="font-size:10px;color:var(--text-muted)">'+dL(o.dept)+' · '+o.fechaCreacion+'</div></div>'
        +(CU.verCostos?'<div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">'+fmt(o.valor)+'</div><div style="font-size:10px;color:var(--text-success)">'+fmt(o.abono)+' · '+pct(o.abono,o.valor)+'%</div><div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</div></div>':'')
        +'</div>';}).join('')
      +'</div>';
  }
  // FIX 1: sort selector; FIX 2: stats con Total+Abonado+Saldo clickeables
  // El origen de la orden va en pastillas a la vista, no escondido en un
  // desplegable: se ve de un vistazo cuál está activo y es un clic menos.
  // Se añaden las dos situaciones de mercancía pendiente. No son un origen
  // como las otras, pero se filtran igual y así están todas a la vista.
  var _sapOpts=[['todas','Todas (SAP + No SAP)'],['sap','Órdenes en SAP'],['nosap','Órdenes No SAP'],
                ['abiertas','Abiertas · falta mercancía'],['sinrecibir','Sin recibir nada']];
  var sapPills='<div class="filters" id="pf-sap" style="margin:0">'
    +_sapOpts.map(function(op){
      return '<span class="pill '+(_oSapFilter===op[0]?'active':'')+'" onclick="_setSapFilter(\''+op[0]+'\')">'+op[1]+'</span>';
    }).join('')+'</div>';
  var sortBar='<div style="display:flex;gap:8px;margin-bottom:10px;align-items:center;flex-wrap:wrap"><select onchange="_oSort=this.value;rOrdenes()" style="padding:6px 10px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)"><option value="nuevo"'+(_oSort==='nuevo'?' selected':'')+'>Más reciente primero</option><option value="antiguo"'+(_oSort==='antiguo'?' selected':'')+'>Más antiguo primero</option></select>'+sapPills+'</div>';
  var statsHtml=CU.verCostos?'<div style="display:flex;gap:7px;margin-bottom:10px;flex-wrap:wrap;align-items:center">'
    +'<span style="font-size:12px;background:var(--surface-1);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border)">'+activas.length+' activas</span>'
    +'<span style="font-size:12px;background:var(--surface-1);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border)">'+completadas.length+' completadas</span>'
    +'<span data-okf="total" class="ord-kpi-btn" style="font-size:12px;background:var(--surface-1);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border);cursor:pointer;text-decoration:underline"><i class="ti ti-currency-dollar" style="font-size:11px"></i> Total: '+fmt(t)+'</span>'
    +'<span data-okf="abonado" class="ord-kpi-btn" style="font-size:12px;background:var(--bg-success);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border-success);color:var(--text-success);cursor:pointer;text-decoration:underline">Abonado: '+fmt(a)+' ('+pct(a,t)+'%)</span>'
    +'<span data-okf="saldo" class="ord-kpi-btn" style="font-size:12px;background:var(--bg-danger);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border-danger);color:var(--text-danger);cursor:pointer;text-decoration:underline">Saldo: '+fmt(sal)+' ('+pct(sal,t)+'%)</span>'
    +'</div>':'';
  var resultsHtml=(_oSapFilter==='nosap')?'':(list.length?list.map(o=>oCard(o)).join(''):'<div class="empty"><i class="ti ti-search" style="font-size:22px;color:var(--text-muted)"></i><br>'+(q?'Sin resultados':'')+'</div>');
  document.getElementById('page-ordenes').innerHTML='<div style="font-size:13px;font-weight:500;margin-bottom:6px">Buscar órdenes</div><div class="search-wrap"><i class="ti ti-search search-icon"></i><input class="search-input" id="search-q" placeholder="Proveedor, código, referencia (SKC), descripción, responsable..." value="'+searchQuery+'" oninput="doSearch(this.value)"><button id="sc-btn" class="search-clear" onclick="clearSearch()" style="display:'+(searchQuery?'flex':'none')+';align-items:center"><i class="ti ti-x"></i></button></div>'+(avD?pills2(dO,'setDO','pf-ord',avD,true):'')+sortBar+statsHtml+oKpiPanel+'<div id="ord-results">'+resultsHtml+'</div>'
    +'<div id="nosap-results"></div>'; setTimeout(function(){refreshSearchResults();try{_renderNoSap();}catch(e){}},0);}
function doSearch(val){
  searchQuery=val;
  var btn=document.getElementById('sc-btn');if(btn)btn.style.display=val?'flex':'none';
  refreshSearchResults();
}
function refreshSearchResults(){
  var base=vO();
  if(dO!=='todos'&& !_deptAcotado())base=base.filter(o=>o.dept===dO);
  var q=searchQuery.toLowerCase().trim();
  if(q)base=base.filter(o=>o.prov.toLowerCase().includes(q)||o.id.toLowerCase().includes(q)||o.desc.toLowerCase().includes(q)||dL(o.dept).toLowerCase().includes(q)||o.resp.toLowerCase().includes(q)||String(o.num_proveedor||'').toLowerCase().includes(q));
  base=base.slice().sort(function(a,b){var da=parseDateStr(a.fechaCreacion)||new Date(0),db=parseDateStr(b.fechaCreacion)||new Date(0);return _oSort==='nuevo'?db-da:da-db;});
  var activas=base.filter(o=>!o.completada),completadas=base.filter(o=>o.completada);
  var list=[...activas,...completadas];
  var res=document.getElementById('ord-results');
  if(res)res.innerHTML=(_oSapFilter==='nosap')?'':(list.length?list.map(o=>oCard(o)).join(''):'<div class="empty"><i class="ti ti-search" style="font-size:22px;color:var(--text-muted)"></i><br>'+(q?'Sin resultados':'Busca por proveedor, orden, descripción...')+'</div>');
  try{ _renderNoSap(); }catch(e){}
}
function _renderNoSap(){
  var cont=document.getElementById('nosap-results'); if(!cont) return;
  if(_oSapFilter==='sap'){ cont.innerHTML=''; return; }
  var q=searchQuery.toLowerCase().trim();
  var _nsb=pendientesSAPVisibles();
  if(dO!=='todos' && !_deptAcotado())_nsb=_nsb.filter(function(p){return p.dept===dO;});
  if(q)_nsb=_nsb.filter(function(p){return(p.proveedor||'').toLowerCase().includes(q)||(p.num_orden||'').toLowerCase().includes(q)||(p.po||'').toLowerCase().includes(q)||dL(p.dept||'').toLowerCase().includes(q);});
  var show=(_oSapFilter==='nosap')||(q||dO!=='todos');
  if(!show){ cont.innerHTML=''; return; }
  if(!_nsb.length){
    // "No hay ninguna" y "no se pudieron cargar" son cosas distintas. Antes
    // las dos decían lo mismo, y desde una red lenta parecía que la empresa
    // no tenía órdenes NO SAP.
    if(_oSapFilter!=='nosap'){ cont.innerHTML=''; return; }
    var _hay=(window._pendSAP||[]).length;
    cont.innerHTML='<div class="empty" style="padding:14px;color:var(--text-muted)">'
      +(window._pendSAPError
        ? ('<b style="color:var(--t-ambar)"><i class="ti ti-wifi-off"></i> '
           +'No se pudo cargar la lista</b><br>'
           +'<span style="font-size:11px">'+_esc(window._pendSAPError)+'. '
           +'Se reintenta solo; si sigue, pulsa Sync.</span><br>'
           +'<button class="btn bg2" style="font-size:11px;padding:4px 11px;margin-top:7px" '
           +'onclick="cargarPendSAP().then(function(){_refrescarPantalla();})">'
           +'<i class="ti ti-refresh"></i> Reintentar</button>')
        : (_hay
            ? 'Ninguna orden No SAP coincide con este filtro.'
            : 'Sin órdenes No SAP'))
      +'</div>';
    return;
  }
  cont.innerHTML='<div style="font-size:11px;font-weight:600;color:var(--t-ambar);margin:12px 0 6px;display:flex;align-items:center;gap:5px"><i class="ti ti-file-invoice"></i>Órdenes No SAP ('+_nsb.length+')</div>'+_nsb.map(function(p){return _pendSAPFila(p,true);}).join('');
}
function clearSearch(){
  searchQuery='';
  var inp=document.getElementById('search-q');
  if(inp){inp.value='';inp.focus();}
  var btn=document.getElementById('sc-btn');if(btn)btn.style.display='none';
  refreshSearchResults();
}
function setDO(el,d){dO=d;document.querySelectorAll('#pf-ord .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');refreshSearchResults();}
// ── Abonos y cancelaciones realizados (para contabilidad) ──
// Van en Completadas: son las solicitudes cuyo comprobante ya se le envió a
// compras. Se listan de la más nueva a la más vieja y se pueden acotar por
// fecha y por departamento, con el usuario que hizo cada una.
window._solHechasDesde=''; window._solHechasHasta=''; window._solHechasDept='todos';
function _solEnvioComprobante(x){
  var e=x&&x.envio_comprobante;
  if(typeof e==='string'){ try{ e=JSON.parse(e); }catch(err){ e=null; } }
  return (e&&typeof e==='object')?e:null;
}
function _solHechaQuien(x){
  var e=_solEnvioComprobante(x);
  return (e&&e.por) || x.procesado_por || x.recibido_por || '';
}
function _solHechaFecha(x){
  var e=_solEnvioComprobante(x);
  return (e&&e.fecha) || x.finalizado_en || x.procesado_en || x.recibido_en || '';
}
function _solHechas(){
  var cerradas=['abono_enviado','cancelacion_realizada'];
  var lista=(window._solPago||[]).filter(function(x){ return cerradas.indexOf(x.estado)>=0; });
  // Filtros
  var d1=window._solHechasDesde, d2=window._solHechasHasta, dp=window._solHechasDept;
  lista=lista.filter(function(x){
    if(dp && dp!=='todos' && String(x.dept||'otros')!==dp) return false;
    var f=String(_solHechaFecha(x)||'').slice(0,10);
    if(d1 && (!f || f<d1)) return false;
    if(d2 && (!f || f>d2)) return false;
    return true;
  });
  // De la más nueva a la más vieja
  lista.sort(function(a,b){ return String(_solHechaFecha(b)||'').localeCompare(String(_solHechaFecha(a)||'')); });
  return lista;
}
function _solHechasSetDept(v){ window._solHechasDept=v; rCompletadas(); }
function _solHechasSetFecha(cual, v){
  if(cual==='desde') window._solHechasDesde=v; else window._solHechasHasta=v;
  rCompletadas();
}
function _solHechasLimpiar(){
  window._solHechasDesde=''; window._solHechasHasta=''; window._solHechasDept='todos';
  rCompletadas();
}
function _solHechasSeccion(){
  if(!CU || (CU.role!=='contabilidad' && CU.role!=='gerencia')) return '';
  var todas=(window._solPago||[]).filter(function(x){
    return ['abono_enviado','cancelacion_realizada'].indexOf(x.estado)>=0; });
  var lista=_solHechas();
  var totAb=lista.filter(function(x){return x.tipo==='abono';}).reduce(function(a,x){return a+(Number(x.monto)||0);},0);
  var totCa=lista.filter(function(x){return x.tipo==='cancelacion';}).reduce(function(a,x){return a+(Number(x.monto)||0);},0);

  // Departamentos que realmente aparecen
  var deps={}; todas.forEach(function(x){ deps[x.dept||'otros']=1; });
  var pills='<span class="pill '+(window._solHechasDept==='todos'?'active':'')+'" onclick="_solHechasSetDept(\'todos\')">Todos</span>'
    +Object.keys(deps).sort().map(function(d){
      return '<span class="pill '+(window._solHechasDept===d?'active':'')+'" onclick="_solHechasSetDept(\''+d+'\')">'
        +(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</span>';
    }).join('');

  var inp='padding:5px 8px;border:0.5px solid var(--border);border-radius:7px;font-size:11.5px;'
    +'background:var(--surface-0);color:var(--text-primary)';
  var h='<div style="border:1px solid #A9DFD0;background:var(--pastel-verde2);border-radius:10px;margin-bottom:14px;overflow:hidden">'
    +'<div style="padding:9px 13px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<i class="ti ti-receipt" style="color:var(--t-verde2)"></i>'
      +'<span style="font-size:12.5px;font-weight:700;color:var(--t-verde2)">Abonos y cancelaciones realizados</span>'
      +'<span style="font-size:11px;color:var(--t-verde2);opacity:.85">'+lista.length+' de '+todas.length
        +' · abonos '+fmt(totAb)+' · cancelaciones '+fmt(totCa)+'</span>'
    +'</div>'
    +'<div style="padding:0 13px 9px;display:flex;gap:7px;align-items:center;flex-wrap:wrap">'
      +'<span style="font-size:10.5px;color:var(--t-verde2);font-weight:600">Desde</span>'
      +'<input type="date" value="'+_esc(window._solHechasDesde||'')+'" style="'+inp+'" '
        +'onchange="_solHechasSetFecha(\'desde\',this.value)">'
      +'<span style="font-size:10.5px;color:var(--t-verde2);font-weight:600">Hasta</span>'
      +'<input type="date" value="'+_esc(window._solHechasHasta||'')+'" style="'+inp+'" '
        +'onchange="_solHechasSetFecha(\'hasta\',this.value)">'
      +((window._solHechasDesde||window._solHechasHasta||window._solHechasDept!=='todos')
        ? '<button class="btn bg2" style="padding:4px 10px;font-size:10.5px" onclick="_solHechasLimpiar()">'
          +'<i class="ti ti-x"></i> Quitar filtros</button>' : '')
    +'</div>'
    +'<div class="filters" style="padding:0 13px 9px;margin:0">'+pills+'</div>';

  if(!lista.length){
    h+='<div style="padding:11px 13px;font-size:11.5px;color:var(--text-muted);border-top:0.5px solid #A9DFD0;background:var(--surface-0)">'
      +(todas.length?'Ningún abono o cancelación con esos filtros.':'Todavía no se envió ningún comprobante a compras.')+'</div>';
    return h+'</div>';
  }

  lista.forEach(function(x){
    var esAb=(x.tipo==='abono');
    var col=esAb?'#166534':'#B45309';
    var quien=_solHechaQuien(x), f=_solHechaFecha(x);
    h+='<div style="border-top:0.5px solid #A9DFD0;padding:9px 13px;background:var(--surface-0);cursor:pointer" '
      +'onclick="_solPagoAbrir(\''+_esc(String(x.docnum||''))+'\')">'
      +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
        +'<div style="flex:1;min-width:150px">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')
            +' <span style="font-weight:400;color:'+col+';font-size:10.5px">'+(esAb?'Abono':'Cancelación')+'</span></div>'
          +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">'+_solRefLinks(x)
            +' · '+_esc(dL(x.dept||''))+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted);margin-top:1px">'
            +(quien?('Realizó '+_esc(quien)):'')+(f?(' · '+_esc(_fechaHora(f))):'')
            +(x.solicitado_por?(' · solicitó '+_esc(x.solicitado_por)):'')+'</div>'
        +'</div>'
        +'<div style="text-align:right;flex-shrink:0"><div style="font-size:13px;font-weight:700;color:'+col+'">'
          +fmt(x.monto)+'</div>'
          +'<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(_solEstadoLabel(x).t)+'</div></div>'
      +'</div></div>';
  });
  return h+'</div>';
}

function rCompletadas(d){
  if(!document.getElementById('page-completadas')) return;dComp=d||dComp;const base=vO().filter(o=>o.completada);const list=dComp==='todos'?base:base.filter(o=>o.dept===dComp);const t=list.reduce((s,o)=>s+o.valor,0);const avD=_deptAcotado()?['todos'].concat(_deptsVisibles()):['todos',...DEPTS_ALL];var _hechas='';try{_hechas=_solHechasSeccion();}catch(e){console.warn('abonos realizados:',e);}document.getElementById('page-completadas').innerHTML=_hechas+`${avD?pills2(dComp,'setDComp','pf-comp',avD):''}${CU.verCostos?`<div style="display:flex;gap:7px;margin-bottom:10px;flex-wrap:wrap"><span style="font-size:12px;background:var(--surface-1);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border)">${list.length} completadas</span><span style="font-size:12px;background:#F0EEFF;color:var(--t-indigo);padding:4px 10px;border-radius:var(--radius);border:0.5px solid var(--border)">${fmt(t)} facturado</span></div>`:''}${list.length?list.map(o=>oCard(o)).join(''):'<div class="empty"><i class="ti ti-circle-check" style="font-size:22px;color:#534AB7"></i><br>No hay completadas</div>'}`;}
function setDComp(el,d){document.querySelectorAll('#pf-comp .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');rCompletadas(d);}
function rPendientes(d){
  if(!document.getElementById('page-pendientes')) return;dP=d||dP;const allP=vO().filter(o=>o.pend);const fil=dP==='todos'?allP:allP.filter(o=>o.dept===dP);const avD=_deptAcotado()?_deptsVisibles():DEPTS_ALL;document.getElementById('page-pendientes').innerHTML=`<div style="font-size:13px;font-weight:500;margin-bottom:4px">${CU.role==='gerencia'?'Para revisar, firmar y aprobar':'Enviadas a gerencia'}</div><div style="font-size:12px;color:var(--text-muted);margin-bottom:10px">${allP.length} pendiente${allP.length!==1?'s':''}</div>${avD?`<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:12px"><span style="padding:4px 10px;background:${dP==='todos'?'var(--bg-accent)':'var(--surface-1)'};border:0.5px solid ${dP==='todos'?'var(--border-accent)':'var(--border)'};border-radius:14px;font-size:11px;cursor:pointer" onclick="setDP(this,'todos')">Todos <span style="background:var(--bg-danger);color:var(--text-danger);border-radius:10px;padding:1px 6px;font-size:10px;font-weight:500">${allP.length}</span></span>${avD.map(d=>{const c=allP.filter(o=>o.dept===d).length;if(!c)return'';return`<span style="display:inline-flex;align-items:center;gap:4px;padding:4px 10px;background:${dP===d?'var(--bg-accent)':'var(--surface-1)'};border:0.5px solid ${dP===d?'var(--border-accent)':'var(--border)'};border-radius:14px;font-size:11px;cursor:pointer" onclick="setDP(this,'${d}')">${EMOJIS2[d]||''} ${dL(d)} <span style="background:var(--bg-danger);color:var(--text-danger);border-radius:10px;padding:1px 6px;font-size:10px;font-weight:500">${c}</span></span>`;}).join('')}</div>`:''}${fil.length?fil.map(o=>oCard(o)).join(''):'<div class="empty"><i class="ti ti-circle-check" style="font-size:24px;color:var(--text-success)"></i><br>Sin pendientes</div>'}`;}
function setDP(el,d){dP=d;rPendientes(d);}
function rContab(d){dC=d||dC;const base=dC==='todos'?orders:orders.filter(o=>o.dept===dC);const depPend=base.filter(o=>{initP(o.id);const sp=stageProgress[o.id];return !o.pend&&!o.completada&&sp.pedido?.stepIdx>=2&&sp.deposito?.stepIdx===0;});const saldoPend=base.filter(o=>{initP(o.id);const sp=stageProgress[o.id];return !o.pend&&!o.completada&&sp.deposito?.stepIdx>=2&&(o.valor-o.abono)>0;});const totDep=depPend.reduce((s,o)=>s+o.valor,0),totSaldo=saldoPend.reduce((s,o)=>s+(o.valor-o.abono),0);const totAbn=base.reduce((s,o)=>s+o.abono,0),totComp=base.reduce((s,o)=>s+o.valor,0);function depRow(o){const p=stageProgress[o.id];const sd=p?.pedido?.stepDates?.[1]||o.fechaCreacion;const dias=daysBetween(sd,null);return`<div class="ocard al" onclick="openDetail('${o.id}')"><div class="oh"><div class="oi">${o.emoji}</div><div class="om"><div class="oc">${o.prov} — ${o.id}</div><div class="od">${dL(o.dept)} · ${o.desc}</div><div style="font-size:11px;color:var(--text-muted);margin-top:1px">Cod proveedor: ${o.resp?`<span onclick="event.stopPropagation();abrirInvProveedor('${String(o.resp).replace(/'/g,'')}')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline;font-weight:600">${o.resp}</span>`:'—'}${sc&&!o.completada?` &nbsp;·&nbsp; <span style="color:var(--text-danger);font-weight:500">Saldo prov: ${fmt(saldoProv(o.prov))}</span>`:''}</div><div style="display:flex;gap:5px;margin-top:3px;flex-wrap:wrap"><span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>Aprobada: ${sd}</span>${diasBadge(dias)}</div><div class="achip"><i class="ti ti-alert-triangle" style="font-size:10px"></i>${dias} días sin enviar depósito</div></div><div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px"><span style="font-size:10px;padding:2px 8px;border-radius:10px;background:#FBEAF0;color:var(--t-vino)">Dep. pendiente</span><span style="font-size:10px;color:var(--text-muted)">${dL(o.dept)}</span></div></div><div class="cr-row"><div><div class="crl">Total orden</div><div class="crv">${fmt(o.valor)}</div></div><div><div class="crl">A depositar (50%)</div><div class="crv kvd">${fmt(Math.round(o.valor*0.5))}</div></div><div><div class="crl">Responsable</div><div class="crv" style="font-size:11px">${o.resp}</div></div></div><div style="padding:0 12px 9px"><div class="pct-bar"><div class="pct-fill" style="width:0%;background:#e24b4a"></div></div></div></div>`;}function saldoRow(o){const saldo=o.valor-o.abono,p=stageProgress[o.id];const dd=p?.deposito?.stepDates?.[1]||'';const dias=dd?daysBetween(dd,null):0;const pp=pct(o.abono,o.valor);return`<div class="ocard ok" onclick="openDetail('${o.id}')"><div class="oh"><div class="oi">${o.emoji}</div><div class="om"><div class="oc">${o.prov} — ${o.id}</div><div class="od">${dL(o.dept)} · ${o.desc}</div><div style="font-size:11px;color:var(--text-muted);margin-top:1px">Cod proveedor: ${o.resp?`<span onclick="event.stopPropagation();abrirInvProveedor('${String(o.resp).replace(/'/g,'')}')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline;font-weight:600">${o.resp}</span>`:'—'}${sc&&!o.completada?` &nbsp;·&nbsp; <span style="color:var(--text-danger);font-weight:500">Saldo prov: ${fmt(saldoProv(o.prov))}</span>`:''}</div><div style="display:flex;gap:5px;margin-top:3px;flex-wrap:wrap">${dd?`<span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>Dep.: ${dd}</span>`:''}<span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>${o.fechaCreacion}</span></div>${dd?`<div style="font-size:10px;color:var(--text-muted);margin-top:2px">Hace ${dias} días del abono</div>`:''}</div><div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px"><span style="font-size:10px;padding:2px 8px;border-radius:10px;background:var(--pastel-azul);color:var(--t-azul)">Saldo pend.</span><span style="font-size:10px;color:var(--text-muted)">${dL(o.dept)}</span></div></div><div style="padding:0 12px 4px;display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;font-size:12px"><div><div class="crl">Total</div><div class="crv">${fmt(o.valor)}</div></div><div><div class="crl">Abonado · ${pp}%</div><div class="crv kvs">${fmt(o.abono)}</div></div><div><div class="crl">Saldo · ${100-pp}%</div><div class="crv kvd">${fmt(saldo)}</div></div></div><div style="padding:0 12px 9px"><div class="pct-bar"><div class="pct-fill" style="width:${pp}%;background:#639922"></div></div></div></div>`;}let mainContent='';if(contabFilter==='all'||contabFilter==='dep'){if(depPend.length)mainContent+=`<div class="slbl" style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i>Depósitos pendientes (${depPend.length}) · ${fmt(totDep)}</div>${depPend.map(depRow).join('')}`;else mainContent+=`<div style="font-size:12px;color:var(--text-muted);padding:8px 0;margin-bottom:8px"><i class="ti ti-circle-check" style="color:var(--text-success)"></i> Sin depósitos pendientes</div>`;}if(contabFilter==='all'||contabFilter==='sal'){if(saldoPend.length)mainContent+=`<div class="slbl" style="color:#BA7517"><i class="ti ti-receipt"></i>Saldos pendientes (${saldoPend.length}) · ${fmt(totSaldo)}</div>${saldoPend.map(saldoRow).join('')}`;else mainContent+=`<div style="font-size:12px;color:var(--text-muted);padding:8px 0"><i class="ti ti-circle-check" style="color:var(--text-success)"></i> Sin saldos pendientes</div>`;}// FIX 6: alerta abonados +6m sin embarcar
  const abnSinEmbarcar=saldoPend.filter(o=>alerta6meses(o));
  let ctKpiPanel='';
  const ctKpiKey=window._ctKpi;
  if(ctKpiKey){
    let ctList=ctKpiKey==='dep'?depPend:ctKpiKey==='sal'?saldoPend:ctKpiKey==='tot'?base:base.filter(o=>o.abono>0);
    const ctColor=ctKpiKey==='dep'?'var(--text-danger)':ctKpiKey==='sal'?'#BA7517':ctKpiKey==='tot'?'var(--text-accent)':'var(--text-success)';
    const ctLabel={dep:'Depósitos pendientes',sal:'Saldos pendientes',tot:'Total en órdenes',abn:'Abonadas'}[ctKpiKey]||'';
    ctKpiPanel=`<div style="background:var(--surface-2);border:0.5px solid var(--border-accent);border-radius:var(--radius);margin-bottom:12px;overflow:hidden"><div style="display:flex;align-items:center;padding:10px 14px;background:var(--bg-accent)"><span style="font-size:13px;font-weight:600;color:${ctColor}">${ctLabel} (${ctList.length})</span><button onclick="window._ctKpi=null;rContab()" style="margin-left:auto;background:none;border:none;font-size:20px;cursor:pointer;color:var(--text-muted)">&times;</button></div>${ctList.map(o=>`<div onclick="openDetail('${o.id}')" style="display:flex;align-items:center;gap:10px;padding:9px 14px;border-bottom:0.5px solid var(--border);cursor:pointer"><span style="font-size:18px">${o.emoji}</span><div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">${o.prov} — #${o.id}${o.num_proveedor?` - <span style="font-weight:700;color:var(--t-ambar)">${o.num_proveedor}</span>`:''}</div><div style="font-size:10px;color:var(--text-muted)">${dL(o.dept)} · ${o.fechaCreacion}</div>${alerta6meses(o)?'<div style="font-size:10px;color:var(--t-marron);background:var(--pastel-naranja);border-radius:6px;padding:1px 6px;display:inline-block;margin-top:2px"><i class="ti ti-alarm" style="font-size:9px"></i> +6 meses sin embarcar</div>':''}</div><div style="text-align:right;flex-shrink:0"><div style="font-size:11px;font-weight:500">${fmt(o.valor)}</div><div style="font-size:10px;color:var(--text-success)">${fmt(o.abono)} (${pct(o.abono,o.valor)}%)</div><div style="font-size:10px;color:var(--text-danger)">Saldo: ${fmt(o.valor-o.abono)}</div></div></div>`).join('')}</div>`;
  }
  document.getElementById('page-contab').innerHTML=`${pills2(dC,'setDC','pf-ct',['todos',...DEPTS_ALL])}<div class="ctab"><button class="ctab-btn ${contabFilter==='all'?'active-all':''}" onclick="setContabFilter('all')"><i class="ti ti-list"></i>Todo (${depPend.length+saldoPend.length})</button><button class="ctab-btn ${contabFilter==='dep'?'active':''}" onclick="setContabFilter('dep')"><i class="ti ti-alert-triangle"></i>Depósitos pendientes <span style="background:#e24b4a;color:white;border-radius:10px;padding:1px 7px;font-size:10px;margin-left:4px">${depPend.length}</span></button><button class="ctab-btn ${contabFilter==='sal'?'active-warn':''}" onclick="setContabFilter('sal')"><i class="ti ti-receipt"></i>Saldos pendientes <span style="background:#eda100;color:white;border-radius:10px;padding:1px 7px;font-size:10px;margin-left:4px">${saldoPend.length}</span></button></div>
  ${abnSinEmbarcar.length?`<div style="background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:var(--radius);padding:10px 14px;margin-bottom:12px;display:flex;align-items:center;gap:10px"><i class="ti ti-alarm" style="font-size:18px;color:var(--t-marron)"></i><div style="flex:1"><div style="font-size:12px;font-weight:600;color:var(--t-marron)">${abnSinEmbarcar.length} orden${abnSinEmbarcar.length>1?'es':''} abonada${abnSinEmbarcar.length>1?'s':''} con +6 meses sin embarcar</div><div style="font-size:11px;color:var(--t-marron);margin-top:2px">${abnSinEmbarcar.map(o=>`<span onclick="openDetail('${o.id}')" style="cursor:pointer;text-decoration:underline;margin-right:8px">${o.prov} #${o.id}</span>`).join('')}</div></div></div>`:''}
  <div class="kpi-grid">
    <div class="kpi" onclick="window._ctKpi=window._ctKpi==='dep'?null:'dep';rContab()" style="cursor:pointer"><div class="kpi-l" style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i>Dep. pendientes</div><div class="kpi-v kvd">${depPend.length}</div><div style="font-size:10px;color:var(--text-danger);margin-top:1px">${fmt(totDep)}</div></div>
    <div class="kpi" onclick="window._ctKpi=window._ctKpi==='sal'?null:'sal';rContab()" style="cursor:pointer"><div class="kpi-l" style="color:#BA7517"><i class="ti ti-receipt"></i>Saldos pendientes</div><div class="kpi-v kvw">${saldoPend.length}</div><div style="font-size:10px;color:#BA7517;margin-top:1px">${fmt(totSaldo)}</div></div>
    <div class="kpi" onclick="window._ctKpi=window._ctKpi==='tot'?null:'tot';rContab()" style="cursor:pointer"><div class="kpi-l"><i class="ti ti-currency-dollar"></i>Total en órdenes</div><div class="kpi-v">${fmt(totComp)}</div></div>
    <div class="kpi" onclick="window._ctKpi=window._ctKpi==='abn'?null:'abn';rContab()" style="cursor:pointer"><div class="kpi-l"><i class="ti ti-coin"></i>Abonado ${pct(totAbn,totComp)}%</div><div class="kpi-v kvs">${fmt(totAbn)}</div></div>
  </div>
  <div style="margin-bottom:12px"><div style="display:flex;justify-content:space-between;font-size:11px;color:var(--text-muted);margin-bottom:3px"><span>Porcentaje pagado total</span><span>${pct(totAbn,totComp)}%</span></div><div class="pct-bar" style="height:7px"><div class="pct-fill" style="width:${pct(totAbn,totComp)}%;background:#639922"></div></div></div>
  ${ctKpiPanel}${mainContent}`;}
function setDC(el,d){document.querySelectorAll('#pf-ct .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');rContab(d);}
function setContabFilter(f){contabFilter=f;rContab(dC);}
function rDeptos(){
  if(!document.getElementById('page-deptos')) return;
  // Esta pantalla leía "orders" directamente, o sea TODOS los departamentos.
  // Con gerencia acotada por departamento (Gady en alfombras, Henry en ropa)
  // eso les mostraba áreas que no les tocan. vO() ya aplica ese filtro y no
  // cambia nada para quien no tiene departamento asignado.
  var orders=vO();
  var gT=orders.reduce(function(s,o){return s+o.valor;},0),gA=orders.reduce(function(s,o){return s+o.abono;},0);

  /* ── PANEL MONTO CLICKEADO ── */
  var montoPanel='';
  if(_dMF&&_dMD){
    var _ml=orders.filter(function(o){return o.dept===_dMD&&(_dMF==='abonado'?o.abono>0:(o.valor-o.abono)>0);});
    var _mc=_dMF==='abonado'?'var(--text-success)':'var(--text-danger)';
    var _mlbl=_dMF==='abonado'?'Abonadas':'Con saldo pendiente';
    montoPanel='<div style="background:var(--surface-2);border:0.5px solid var(--border-accent);border-radius:var(--radius);margin-bottom:14px;overflow:hidden">'
      +'<div style="display:flex;align-items:center;padding:10px 14px;background:var(--bg-accent)">'
      +'<span style="font-size:13px;font-weight:600;color:'+_mc+'">'+dL(_dMD)+' \u2014 '+_mlbl+' ('+_ml.length+')</span>'
      +'<button onclick="_dMF=null;_dMD=null;rDeptos()" style="margin-left:auto;background:none;border:none;font-size:20px;cursor:pointer;color:var(--text-muted)">&times;</button>'
      +'</div>'
      +_ml.map(function(o){
        return '<div onclick="openDetail(\''+o.id+'\')" style="display:flex;align-items:center;gap:10px;padding:9px 14px;border-bottom:0.5px solid var(--border);cursor:pointer">'
          +'<span style="font-size:18px">'+o.emoji+'</span>'
          +'<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500">'+o.prov+' \u2014 #'+o.id+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted)">'+o.fechaCreacion+(o._estadoSap?' \u00b7 '+o._estadoSap:'')+'</div></div>'
          +(CU.verCostos?'<div style="text-align:right;flex-shrink:0">'
            +'<div style="font-size:11px;color:var(--text-success)">'+fmt(o.abono)+'</div>'
            +'<div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</div></div>':'')
          +'</div>';
      }).join('')
      +'</div>';
  }

  /* ── KPIs ── */
  var kpiHtml=CU.verCostos
    ?'<div class="kpi-grid"><div class="kpi"><div class="kpi-l">Total en \u00f3rdenes</div><div class="kpi-v">'+fmt(gT)+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Abonado</div><div class="kpi-v kvs">'+fmt(gA)+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Saldo</div><div class="kpi-v kvd">'+fmt(gT-gA)+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Completadas</div><div class="kpi-v kvs">'+orders.filter(function(o){return o.completada;}).length+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Activas</div><div class="kpi-v kva">'+orders.filter(function(o){return!o.completada;}).length+'</div></div></div>'
    :'<div class="kpi-grid"><div class="kpi"><div class="kpi-l">Total</div><div class="kpi-v kva">'+orders.length+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Activas</div><div class="kpi-v kva">'+orders.filter(function(o){return!o.completada;}).length+'</div></div>'
      +'<div class="kpi"><div class="kpi-l">Completadas</div><div class="kpi-v kvs">'+orders.filter(function(o){return o.completada;}).length+'</div></div></div>';

  /* ── TOOLBAR ── */
  var toolbar='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px;align-items:center">'
    +'<div class="search-wrap" style="flex:1;min-width:200px;margin-bottom:0"><i class="ti ti-search search-icon"></i>'
    +'<input class="search-input" id="dSQ-inp" placeholder="Buscar proveedor o n\u00famero de orden..." value="'+_dSQ+'">'
    +(_dSQ?'<button class="search-clear" id="dSQ-clr"><i class="ti ti-x"></i></button>':'')
    +'</div>'
    +'<select id="dSort-sel" style="padding:7px 10px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)">'
    +'<option value="nuevo"'+(_dSort==='nuevo'?' selected':'')+'>M\u00e1s reciente</option>'
    +'<option value="antiguo"'+(_dSort==='antiguo'?' selected':'')+'>M\u00e1s antiguo</option>'
    +'</select>'
    +'<select id="dEst-sel" style="padding:7px 10px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)">'
    +'<option value="todos"'+(_dEst==='todos'?' selected':'')+'>Todos los estados</option>'
    +'<option value="confirm"'+(_dEst==='confirm'?' selected':'')+'>Confirmado</option>'
    +'<option value="despach"'+(_dEst==='despach'?' selected':'')+'>Despachado</option>'
    +'<option value="embarcad"'+(_dEst==='embarcad'?' selected':'')+'>Embarcado</option>'
    +'<option value="pendiente"'+(_dEst==='pendiente'?' selected':'')+'>Pendiente</option>'
    +'</select></div>';

  /* ── FILAS POR DEPTO ── */
  var rows=_deptsVisibles().map(function(d){
    var allList=orders.filter(function(o){return o.dept===d;});
    if(!allList.length)return'<div class="dc"><div class="dh" onclick="this.nextElementSibling.classList.toggle(\'open\')" style="display:flex;align-items:center;gap:11px">'
      +_deptIconHTML(d,46)+'<div style="flex:1"><div style="font-size:14px;font-weight:700">'+dL(d)+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">Sin \u00f3rdenes</div></div></div>'
      +'<div class="dbody"></div></div>';

    // Filtrar y ordenar
    var fl=allList;
    if(_dSQ.trim()){var q=_dSQ.trim().toLowerCase();fl=fl.filter(function(o){return o.prov.toLowerCase().includes(q)||String(o.id).toLowerCase().includes(q)||(o.desc||'').toLowerCase().includes(q);});}
    if(_dEst!=='todos'){fl=fl.filter(function(o){return(o._estadoSap||'').toLowerCase().includes(_dEst);});}
    fl=fl.slice().sort(function(a,b){var da=parseDateStr(a.fechaCreacion)||new Date(0),db=parseDateStr(b.fechaCreacion)||new Date(0);return _dSort==='nuevo'?db-da:da-db;});

    var tot=allList.reduce(function(s,o){return s+o.valor;},0),abn=allList.reduce(function(s,o){return s+o.abono;},0),sal=tot-abn;
    var act=allList.filter(function(o){return!o.completada;}),comp=allList.filter(function(o){return o.completada;}),pend2=act.filter(function(o){return o.pend;});
    var pp=pct(abn,tot);
    // CAMBIO 5: sumar No SAP
    var _nsL=pendSAPporDept(d);
    var _nsCnt=_nsL.length;
    var _nsTot=_nsL.reduce(function(s,p){return s+(Number(p.total)||0);},0);
    var _nsAbn=_nsL.reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
    tot+=_nsTot; abn+=_nsAbn; sal=tot-abn;
    var ordsConAbn=allList.filter(function(o){initP(o.id);return stageProgress[o.id]&&stageProgress[o.id].deposito&&stageProgress[o.id].deposito.stepDates&&stageProgress[o.id].deposito.stepDates[1];});
    var ultimoAbn=ordsConAbn.length?stageProgress[ordsConAbn[ordsConAbn.length-1].id].deposito.stepDates[1]:'';
    var diasAbn=ultimoAbn?daysBetween(ultimoAbn,null):0;

    // Agrupar proveedores
    var pvMap={};
    fl.forEach(function(o){if(!pvMap[o.prov])pvMap[o.prov]=[];pvMap[o.prov].push(o);});
    var pvKeys=Object.keys(pvMap).sort(function(a,b){return pvMap[b].length-pvMap[a].length;});

    // Tabla de proveedores
    var thCols=CU.verCostos
      ?'<tr style="background:var(--surface-1)"><th style="padding:7px 12px;font-size:10px;font-weight:600;color:var(--text-muted);text-align:left;border-bottom:0.5px solid var(--border)">Proveedor</th><th style="padding:7px 12px;font-size:10px;color:var(--text-muted);text-align:left;border-bottom:0.5px solid var(--border)">\u00d3rdenes</th><th style="padding:7px 12px;font-size:10px;color:var(--text-muted);text-align:right;border-bottom:0.5px solid var(--border)">Total</th><th style="padding:7px 12px;font-size:10px;color:var(--text-success);text-align:right;border-bottom:0.5px solid var(--border)">Abonado</th><th style="padding:7px 12px;font-size:10px;color:var(--text-danger);text-align:right;border-bottom:0.5px solid var(--border)">Saldo</th></tr>'
      :'<tr style="background:var(--surface-1)"><th style="padding:7px 12px;font-size:10px;font-weight:600;color:var(--text-muted);text-align:left;border-bottom:0.5px solid var(--border)">Proveedor</th><th style="padding:7px 12px;font-size:10px;color:var(--text-muted);text-align:left;border-bottom:0.5px solid var(--border)">\u00d3rdenes</th></tr>';

    var pvRows=pvKeys.map(function(pv){
      var pos=pvMap[pv];
      var pvT=pos.reduce(function(s,o){return s+o.valor;},0),pvA=pos.reduce(function(s,o){return s+o.abono;},0);
      var pvNameCell=pos.length>1
        ?'<span onclick="showProvPanel(\''+encodeURIComponent(pv)+'\')" style="cursor:pointer;display:inline-flex;align-items:center;gap:5px;color:var(--text-accent)">'+pv+'<span style="background:var(--fill-accent);color:white;border-radius:10px;padding:0 7px;font-size:10px;font-weight:700">'+pos.length+'</span></span>'
        :pv;
      var ordCells=pos.map(function(o){
        var ec={confirmado:'#185FA5',despachado:'#1D9E75',embarcado:'#7F77DD',pendiente:'#BA7517'}[(o._estadoSap||'').toLowerCase()]||'var(--text-muted)';
        return'<span onclick="openDetail(\''+o.id+'\')" style="display:inline-flex;align-items:center;gap:4px;margin:2px;padding:3px 8px;border-radius:6px;background:var(--surface-0);border:0.5px solid var(--border);cursor:pointer;font-size:10px;white-space:nowrap">'
          +o.emoji+' #'+o.id
          // DKC del proveedor (Vendor Ref No de SAP)
          +(o.num_proveedor?'<span style="color:var(--t-ambar);font-weight:700"> - '+_esc(o.num_proveedor)+'</span>':'')
          +(o._estadoSap?'<span style="color:'+ec+'"> \u00b7 '+o._estadoSap+'</span>':'')
          +(CU.verCostos?(
              '<span style="color:var(--text-muted)">Total </span><span style="font-weight:700">'+fmt(o.valor)+'</span>'
             +'<span style="color:var(--text-muted)"> · Abonado </span><span style="font-weight:700;color:var(--text-success)">'+fmt(o.abono)+'</span>'
             +'<span style="color:var(--text-muted)"> · Saldo </span><span style="font-weight:700;color:var(--text-danger)">'+fmt(o.valor-o.abono)+'</span>'
            ):'')
          +'<span style="color:var(--text-muted)"> '+o.fechaCreacion+'</span>'
          +'</span>';
      }).join('');
      return'<tr style="border-bottom:0.5px solid var(--border)">'
        +'<td style="padding:8px 12px;font-size:12px;font-weight:500;white-space:nowrap;vertical-align:middle">'+pvNameCell+'</td>'
        +'<td style="padding:8px 12px;vertical-align:middle">'+ordCells+'</td>'
        +(CU.verCostos
          ?'<td style="padding:8px 12px;font-size:11px;text-align:right;white-space:nowrap;vertical-align:middle;font-weight:500">'+fmt(pvT)+'</td>'
           +'<td style="padding:8px 12px;font-size:11px;text-align:right;white-space:nowrap;vertical-align:middle;color:var(--text-success)">'+fmt(pvA)+'</td>'
           +'<td style="padding:8px 12px;font-size:11px;text-align:right;white-space:nowrap;vertical-align:middle;color:var(--text-danger)">'+fmt(pvT-pvA)+'</td>'
          :'')
        +'</tr>';
    }).join('');

    // Stats en línea
    var statsLine='<div style="display:flex;gap:16px;flex-wrap:wrap;padding:8px 0 10px;border-bottom:0.5px solid var(--border);margin-bottom:10px">'
      +'<span style="font-size:11px"><strong style="color:var(--text-accent)">'+act.length+'</strong> activas</span>'
      +'<span style="font-size:11px"><strong style="color:var(--text-success)">'+comp.length+'</strong> completadas</span>'
      +(pend2.length?'<span style="font-size:11px"><strong style="color:#BA7517">'+pend2.length+'</strong> sin firmar</span>':'')
      +(CU.verCostos
        ?'<span onclick="_dMF=\'abonado\';_dMD=\''+d+'\';rDeptos()" style="font-size:11px;cursor:pointer;color:var(--text-success);text-decoration:underline"><strong>'+fmt(abn)+'</strong> abonado ('+pp+'%)</span>'
         +'<span onclick="_dMF=\'saldo\';_dMD=\''+d+'\';rDeptos()" style="font-size:11px;cursor:pointer;color:var(--text-danger);text-decoration:underline"><strong>'+fmt(sal)+'</strong> saldo</span>'
         +(ultimoAbn?'<span style="font-size:11px;color:var(--text-muted)">Último abono: '+ultimoAbn+' ('+diasAbn+'d)</span>':'')
        :'')
      +'</div>';

    return'<div class="dc" data-dept="'+d+'">'
      +'<div class="dh" onclick="this.nextElementSibling.classList.toggle(\'open\')" style="display:flex;align-items:center;gap:11px">'
      +_deptIconHTML(d,50)+'<div style="flex:1"><div style="font-size:15px;font-weight:700">'+dL(d)+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+(allList.length+_nsCnt)+' total \u00b7 '+comp.length+' comp. \u00b7 '+act.length+' activas'+(_nsCnt?' \u00b7 <span style="color:var(--t-ambar);font-weight:600">+'+_nsCnt+' No SAP</span>':'')+(fl.length!==allList.length?' \u00b7 <strong>'+fl.length+' con filtro</strong>':'')+'</div></div>'
      +(CU.verCostos
        ?'<div style="text-align:right">'
          +'<div style="font-size:14px;font-weight:500;color:var(--text-accent)">'+fmt(tot)+'</div>'
          +'<div style="display:flex;gap:10px;margin-top:2px;justify-content:flex-end">'
          +'<span onclick="event.stopPropagation();_dMF=\'abonado\';_dMD=\''+d+'\';rDeptos()" style="font-size:11px;color:var(--text-success);cursor:pointer;text-decoration:underline">'+fmt(abn)+'</span>'
          +'<span onclick="event.stopPropagation();_dMF=\'saldo\';_dMD=\''+d+'\';rDeptos()" style="font-size:11px;color:var(--text-danger);cursor:pointer;text-decoration:underline">Saldo: '+fmt(sal)+'</span>'
          +'</div></div>'
        :'<div style="font-size:14px;font-weight:500;color:var(--text-accent)">'+allList.length+' \u00f3rdenes</div>')
      +'</div>'
      +'<div class="dbody">'
      +statsLine
            +(fl.length||_nsCnt
        ?'<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse"><thead>'+thCols+'</thead><tbody>'+pvRows+_nsapDeptoRows(d)+'</tbody></table></div>'
        :'<div style="font-size:12px;color:var(--text-muted);padding:10px 0">Sin resultados para este filtro.</div>')
      +'</div></div>';
  }).join('');

  document.getElementById('page-deptos').innerHTML=kpiHtml+montoPanel+toolbar
    
    +'<div class="slbl">Toca un departamento para ver el desglose</div>'+rows;

  // Si se llegó desde el dashboard con un departamento elegido, abrirlo y
  // desplazarse hasta él automáticamente (muestra el listado completo del depto).
  if(_deptoAutoAbrir){
    var _da=_deptoAutoAbrir; _deptoAutoAbrir=null;
    setTimeout(function(){
      var card=document.querySelector('#page-deptos .dc[data-dept="'+_da+'"]');
      if(card){
        var body=card.querySelector('.dbody');
        if(body) body.classList.add('open');
        card.scrollIntoView({behavior:'smooth',block:'start'});
      }
    },50);
  }

  // Eventos del toolbar — se adjuntan DESPUÉS de renderizar
  var _inp=document.getElementById('dSQ-inp');
  var _clr=document.getElementById('dSQ-clr');
  var _ss=document.getElementById('dSort-sel');
  var _es=document.getElementById('dEst-sel');
  if(_inp){_inp.addEventListener('input',function(){_dSQ=this.value;rDeptos();var me=document.getElementById('dSQ-inp');if(me){me.focus();me.setSelectionRange(me.value.length,me.value.length);}});}
  if(_clr){_clr.addEventListener('click',function(){_dSQ='';rDeptos();});}
  if(_ss){_ss.addEventListener('change',function(){_dSort=this.value;rDeptos();});}
  if(_es){_es.addEventListener('change',function(){_dEst=this.value;rDeptos();});}
}

// Panel lateral proveedor
function showProvPanel(provEnc){
  var prov=decodeURIComponent(provEnc);
  var ex=document.getElementById('prov-panel');
  if(ex&&ex.dataset.prov===prov){ex.remove();return;}
  if(ex)ex.remove();
  var lista=orders.filter(function(o){return o.prov===prov;}).sort(function(a,b){var da=parseDateStr(a.fechaCreacion)||new Date(0),db=parseDateStr(b.fechaCreacion)||new Date(0);return db-da;});
  var panel=document.createElement('div');panel.id='prov-panel';panel.dataset.prov=prov;
  panel.style.cssText='position:fixed;top:0;right:0;width:min(480px,40vw);height:100vh;background:var(--surface-2);border-left:1px solid var(--border);z-index:250;overflow-y:auto;box-shadow:-6px 0 24px rgba(0,0,0,.18)';
  var ptot=lista.reduce(function(s,o){return s+o.valor;},0),pabn=lista.reduce(function(s,o){return s+o.abono;},0);
  var hdr=document.createElement('div');hdr.style.cssText='position:sticky;top:0;z-index:2;padding:14px 16px;border-bottom:0.5px solid var(--border);background:var(--surface-1);display:flex;align-items:center;gap:10px';
  hdr.innerHTML='<i class="ti ti-building-store" style="color:var(--text-accent);font-size:16px"></i><div style="flex:1;min-width:0"><div style="font-size:14px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+prov+'</div><div style="font-size:11px;color:var(--text-muted)">'+lista.length+' orden'+(lista.length!==1?'es':'')+'</div></div>';
  var cb=document.createElement('button');cb.innerHTML='&times;';cb.style.cssText='background:none;border:none;font-size:24px;cursor:pointer;color:var(--text-muted);line-height:1';cb.onclick=function(){panel.remove();};hdr.appendChild(cb);panel.appendChild(hdr);
  var body=document.createElement('div');body.style.cssText='padding:14px';
  if(CU.verCostos){var kg=document.createElement('div');kg.style.cssText='display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:14px';kg.innerHTML='<div style="background:var(--surface-1);border-radius:var(--radius);padding:10px;text-align:center"><div style="font-size:9px;color:var(--text-muted);margin-bottom:3px">TOTAL</div><div style="font-size:13px;font-weight:600">'+fmt(ptot)+'</div></div><div style="background:var(--bg-success);border-radius:var(--radius);padding:10px;text-align:center"><div style="font-size:9px;color:var(--text-success);margin-bottom:3px">ABONADO</div><div style="font-size:13px;font-weight:600;color:var(--text-success)">'+fmt(pabn)+'</div></div><div style="background:var(--bg-danger);border-radius:var(--radius);padding:10px;text-align:center"><div style="font-size:9px;color:var(--text-danger);margin-bottom:3px">SALDO</div><div style="font-size:13px;font-weight:600;color:var(--text-danger)">'+fmt(ptot-pabn)+'</div></div>';body.appendChild(kg);}
  lista.forEach(function(o){
    var card=document.createElement('div');card.style.cssText='background:var(--surface-1);border:0.5px solid var(--border);border-radius:9px;margin-bottom:9px;padding:12px 14px;cursor:pointer';
    card.onmouseenter=function(){this.style.borderColor='var(--border-accent)';};card.onmouseleave=function(){this.style.borderColor='var(--border)';};
    card.onclick=function(){panel.remove();openDetail(o.id);};
    var ec={confirmado:'#185FA5',despachado:'#1D9E75',embarcado:'#7F77DD',pendiente:'#BA7517'}[(o._estadoSap||'').toLowerCase()]||'var(--text-muted)';
    card.innerHTML='<div style="display:flex;align-items:flex-start;gap:10px"><span style="font-size:22px;line-height:1">'+o.emoji+'</span>'
      +'<div style="flex:1;min-width:0"><div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap"><span style="font-size:13px;font-weight:600">#'+o.id+'</span><span style="font-size:11px;color:var(--text-muted)">'+dL(o.dept)+'</span>'
      +(o._estadoSap?'<span style="font-size:10px;padding:2px 8px;border-radius:8px;background:'+ec+'22;color:'+ec+'">'+o._estadoSap+'</span>':'')+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:3px">'+(o.desc||'')+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+o.fechaCreacion+(o.fechaEst?' \u00b7 ETA: '+o.fechaEst:'')+'</div>'
      +(CU.verCostos?'<div style="display:flex;gap:12px;margin-top:7px;font-size:12px"><span>'+fmt(o.valor)+'</span><span style="color:var(--text-success)">'+fmt(o.abono)+' \u00b7 '+pct(o.abono,o.valor)+'%</span><span style="color:var(--text-danger)">Saldo: '+fmt(o.valor-o.abono)+'</span></div>':'')
      +'</div><i class="ti ti-chevron-right" style="font-size:14px;color:var(--text-muted);margin-top:4px"></i></div>';
    body.appendChild(card);
  });
  panel.appendChild(body);document.body.appendChild(panel);
}


// Detecta si una orden tiene actividad de arte (adjuntos o pasos hechos en la etapa artes)
function tieneAdjuntoArte(oid){
  // ¿Hay algún adjunto en la etapa de artes (general o en cualquier sub-paso)?
  if(window._atts){
    for(var k in window._atts){
      if(k.indexOf(oid+'artes')===0 && window._atts[k] && window._atts[k].length) return true;
    }
  }
  return false;
}
function tieneActividadArte(oid){ return tieneAdjuntoArte(oid); }
// La marca del estado del arte en la tarjeta. Solo para diseño y gerencia:
// al resto no le aporta y ensucia la ficha.
function _arteBadge(o){
  if(!CU || (CU.role!=='diseno' && CU.role!=='gerencia')) return '';
  if(o.pend || o.completada) return '';
  if(_arteCompleta(o))
    return '<span class="fecha-badge" style="background:var(--pastel-ok);'
      +'color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check" style="font-size:10px"></i>Arte terminado</span>';
  if(_arteEnProceso(o))
    return '<span class="fecha-badge" style="background:var(--pastel-azul);'
      +'color:var(--t-azul);font-weight:600">'
      +'<i class="ti ti-palette" style="font-size:10px"></i>Arte en proceso</span>';
  return '<span class="fecha-badge" style="background:var(--pastel-aviso);'
    +'color:var(--t-ambar);font-weight:600">'
    +'<i class="ti ti-clock" style="font-size:10px"></i>Arte pendiente</span>';
}

// ── ¿Está terminada la etapa de artes de esta orden? ──
// Antes se miraba solo si había un arte adjunto, y eso no dice si la etapa
// se cerró: una orden podía tener el semáforo en verde y seguir contando
// como pendiente para diseño. Ahora manda el avance de la etapa.
function _arteCompleta(o){
  try{
    initP(o.id);
    var sp=stageProgress[o.id];
    var et=STAGES.find(function(x){ return x.key==='artes'; });
    if(!sp || !sp.artes || !et) return false;
    return sp.artes.stepIdx >= et.steps.length;
  }catch(e){ return false; }
}

// Empezada pero sin cerrar: algún paso hecho, o algún arte adjunto
function _arteEnProceso(o){
  if(_arteCompleta(o)) return false;
  try{
    initP(o.id);
    var sp=stageProgress[o.id];
    if(sp && sp.artes && sp.artes.stepIdx>0) return true;
  }catch(e){}
  return tieneAdjuntoArte(o.id);
}

window._mtEstado = window._mtEstado || 'pendientes';
window._mtOrden  = window._mtOrden  || 'nuevo';
window._mtQ      = window._mtQ      || '';

function _mtSetEstado(v){ window._mtEstado=v; rMiTarea(); }
function _mtSetOrden(v){ window._mtOrden=v; rMiTarea(); }
function _mtBuscar(v){ window._mtQ=String(v||''); rMiTarea(); }

function rMiTarea(d){dMT=d||dMT;
  if(CU.role==='diseno'){
    var enArtes=vO().filter(function(o){return !o.pend&&!o.completada;});
    if(dMT!=='todos')enArtes=enArtes.filter(function(o){return o.dept===dMT;});

    var completas =enArtes.filter(_arteCompleta);
    var enProceso =enArtes.filter(_arteEnProceso);
    var pendientes=enArtes.filter(function(o){
      return !_arteCompleta(o) && !_arteEnProceso(o); });

    // Lo que se muestra según la pastilla elegida
    var est=window._mtEstado||'pendientes';
    var lista = est==='todas'      ? enArtes
              : est==='proceso'    ? enProceso
              : est==='completas'  ? completas
              : pendientes;

    // Buscador: proveedor, orden, referencia o descripción
    var q=String(window._mtQ||'').toLowerCase().trim();
    if(q){
      lista=lista.filter(function(o){
        return String(o.prov||'').toLowerCase().indexOf(q)>=0
            || String(o.id||'').toLowerCase().indexOf(q)>=0
            || String(o.ref||'').toLowerCase().indexOf(q)>=0
            || String(o.desc||'').toLowerCase().indexOf(q)>=0
            || String(dL(o.dept||'')).toLowerCase().indexOf(q)>=0;
      });
    }

    lista=lista.slice().sort(function(a,b){
      var da=parseDateStr(a.fechaCreacion)||new Date(0);
      var db=parseDateStr(b.fechaCreacion)||new Date(0);
      return window._mtOrden==='viejo' ? da-db : db-da;
    });

    var pastilla=function(k,t,n,col){
      var on=(est===k);
      return '<span onclick="_mtSetEstado(\''+k+'\')" style="cursor:pointer;'
        +'border:1px solid '+(on?col:'var(--border)')+';background:'+(on?col:'var(--surface-0)')
        +';color:'+(on?'#fff':col)+';border-radius:20px;padding:4px 12px;font-size:11px;'
        +'font-weight:600;white-space:nowrap">'+t+' <span style="opacity:.85">'+n+'</span></span>';
    };

    document.getElementById('page-mistarea').innerHTML=
      pills2(dMT,'setDMT','pf-mt',['todos',...DEPTS_ALL])

      +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin:8px 0">'
        +'<input id="mt-q" value="'+_esc(window._mtQ||'')+'" '
        +'placeholder="Buscar proveedor, orden, DKC o descripción…" '
        +'oninput="clearTimeout(window._mtT);window._mtT=setTimeout(function(){_mtBuscar(document.getElementById(\'mt-q\').value)},300)" '
        +'style="flex:1;min-width:230px;padding:7px 11px;border:1px solid var(--border);'
        +'border-radius:8px;font-size:12px;font-family:var(--font-sans);'
        +'background:var(--surface-2);color:var(--text-primary)">'
        +'<select onchange="_mtSetOrden(this.value)" style="padding:7px 9px;border-radius:8px;'
        +'border:1px solid var(--border);font-size:11.5px;background:var(--surface-2);'
        +'color:var(--text-primary);cursor:pointer">'
          +'<option value="nuevo"'+(window._mtOrden==='nuevo'?' selected':'')+'>Más reciente primero</option>'
          +'<option value="viejo"'+(window._mtOrden==='viejo'?' selected':'')+'>Más antigua primero</option>'
        +'</select>'
      +'</div>'

      +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:10px">'
        + pastilla('pendientes','Pendientes', pendientes.length, '#B45309')
        + pastilla('proceso','En proceso',    enProceso.length,  '#0c447c')
        + pastilla('completas','Terminados',  completas.length,  '#166534')
        + pastilla('todas','Todas',           enArtes.length,    '#5B21B6')
      +'</div>'

      +'<div class="slbl">'+
        (est==='completas' ? '<i class="ti ti-circle-check" style="color:var(--t-verde)"></i>Artes terminados'
        : est==='proceso'  ? '<i class="ti ti-palette"></i>Artes en proceso'
        : est==='todas'    ? '<i class="ti ti-list"></i>Todas las órdenes en artes'
        : '<i class="ti ti-clock" style="color:var(--t-ambar)"></i>Artes pendientes')
        +' ('+lista.length+')'
        +(q?(' <span style="font-weight:400;color:var(--text-muted)">· filtrado por "'+_esc(q)+'"</span>'):'')
      +'</div>'
      +(lista.length
        ? lista.map(function(o){ return oCard(o); }).join('')
        : '<div class="empty">'+(q?'Sin resultados para esa búsqueda'
            : est==='completas' ? 'Todavía no hay artes terminados'
            : est==='proceso'   ? 'No hay artes empezados'
            : 'No hay artes pendientes')+'</div>');
    return;
  }
  let targetS=[];if(CU.role==='importacion')targetS=[4,5];else if(CU.role==='bodega')targetS=[6];const my=vO().filter(o=>!o.pend&&!o.completada&&targetS.includes(getStageIdx(o)));const fil=dMT==='todos'?my:my.filter(o=>o.dept===dMT);const lbl=CU.role==='importacion'?'Embarques y Nacionalización':CU.role==='bodega'?'Órdenes en Bodega':'Mis artes';const ico=CU.role==='importacion'?'ti-ship':CU.role==='bodega'?'ti-building-warehouse':'ti-palette';document.getElementById('page-mistarea').innerHTML=`${pills2(dMT,'setDMT','pf-mt',['todos',...DEPTS_ALL])}<div class="slbl"><i class="ti ${ico}"></i>${lbl} (${fil.length})</div>${fil.length?fil.map(o=>oCard(o)).join(''):'<div class="empty">Sin órdenes en tu área</div>'}`;}
function setDMT(el,d){document.querySelectorAll('#pf-mt .pill').forEach(p=>p.classList.remove('active'));el.classList.add('active');rMiTarea(d);}
function buildAlerts(){const vo=vO();let alerts=[];vo.filter(o=>o.alerta).forEach(o=>{alerts.push({type:'orden',o,msg:o.alertaMsg,color:'#e24b4a',responsable:o.resp,dept:o.dept,oid:o.id,role:STAGES[getStageIdx(o)]?.alertRole||'compras'});});vo.filter(o=>{initP(o.id);const sp=stageProgress[o.id];return !o.pend&&!o.completada&&sp.pedido?.stepIdx>=2&&sp.deposito?.stepIdx===0;}).filter(o=>!o.alerta).forEach(o=>{alerts.push({type:'deposito',o,msg:`Depósito pendiente — ${daysBetween(stageProgress[o.id]?.pedido?.stepDates?.[1]||o.fechaCreacion,null)} días sin enviar`,color:'#e24b4a',responsable:USERS.find(u=>u.role==='contabilidad')?.name||'Contabilidad',dept:o.dept,oid:o.id,role:'contabilidad'});});vo.filter(o=>{initP(o.id);return !o.pend&&getStageIdx(o)===2&&stageProgress[o.id]?.artes?.stepIdx===2;}).forEach(o=>{alerts.push({type:'artes',o,msg:`Artes esperando aprobación — ${daysBetween(stageProgress[o.id]?.artes?.stepDates?.[1]||'',null)} días`,color:'#eda100',responsable:'Gerencia',dept:o.dept,oid:o.id,role:'gerencia'});});vo.filter(o=>!o.pend&&!o.completada&&costeoData[o.id]?.status==='uploaded').forEach(o=>{alerts.push({type:'costeo',o,msg:'📊 Costeo subido — abrir para poner precios de venta',color:'#7C3D12',responsable:'Gerencia',dept:o.dept,oid:o.id,role:'gerencia'});});
  // Diseño: órdenes aprobadas/firmadas con +30 días sin tener los artes aprobados
  vo.filter(o=>{initP(o.id);const sp=stageProgress[o.id];if(o.pend||o.completada)return false;var firmada=sp.pedido&&sp.pedido.stepIdx>=2;if(!firmada)return false;var artesAprob=sp.artes&&sp.artes.stepIdx>=3;if(artesAprob)return false;var fechaFirma=(sp.pedido&&sp.pedido.stepDates&&sp.pedido.stepDates[1])||o.fechaCreacion;var dias=daysBetween(fechaFirma,null);return dias>30;}).forEach(o=>{initP(o.id);var sp=stageProgress[o.id];var fechaFirma=(sp.pedido&&sp.pedido.stepDates&&sp.pedido.stepDates[1])||o.fechaCreacion;var dias=daysBetween(fechaFirma,null);alerts.push({type:'artes_atrasado',o,msg:`Firmada hace ${dias} días sin artes aprobados`,color:'#e24b4a',responsable:'Diseño',dept:o.dept,oid:o.id,role:'diseno'});});
  // Punto 5: comentarios de gerencia pendientes de leer para el usuario actual
  if(window._comPend&&CU){var _vistos={};vo.forEach(function(o){var k=o.id;if(_vistos[k])return;if(tieneComPendiente(o.id)){_vistos[k]=1;alerts.push({type:'comentario',o:o,msg:'Tienes un comentario de gerencia por leer',color:'#7F77DD',responsable:CU.name,dept:o.dept,oid:o.id,role:CU.role});}});}
  // Punto 3: contenedores atrasados (ETA de llegada cumplida pero sin confirmar arribo)
  vo.filter(function(o){
    if(o.pend||o.completada) return false;
    if(typeof getBK!=='function') return false;
    var bk=getBK(o.id);
    if(!bk||!bk.containers||!bk.containers.length) return false;
    var lg=(typeof getLlegada==='function')?getLlegada(o.id):{confirmado:false};
    if(lg.confirmado) return false;
    var hoy=new Date(); hoy.setHours(0,0,0,0);
    var fechas=bk.containers.map(function(c){return c.etaLlegada?new Date(c.etaLlegada):null;}).filter(Boolean);
    if(!fechas.length) return false;
    var etaMax=new Date(Math.max.apply(null,fechas));
    return hoy>new Date(etaMax.getFullYear(),etaMax.getMonth(),etaMax.getDate());
  }).forEach(function(o){
    var bk=getBK(o.id);
    var fechas=bk.containers.map(function(c){return c.etaLlegada?new Date(c.etaLlegada):null;}).filter(Boolean);
    var etaMax=new Date(Math.max.apply(null,fechas));
    var dias=daysBetween(etaMax.toISOString().slice(0,10),null);
    alerts.push({type:'atraso_llegada',o:o,msg:'Contenedor atrasado — '+dias+' días desde la ETA sin confirmar arribo',color:'#e24b4a',responsable:'Importación',dept:o.dept,oid:o.id,role:'importacion'});
  });
  return alerts;}
function rAlertas(){
  if(!document.getElementById('page-alertas')) return;
  // Contabilidad ve arriba las solicitudes que le mandó compras
  if(CU && (CU.role==='contabilidad'||CU.role==='gerencia'||CU.role==='compras')){
    if(!window._solPagoListo){
      window._solPagoListo=true;
      _solPagoCargar(true).then(function(){ try{ rAlertas(); }catch(e){} });
    }
    // El refresco se dispara al ENTRAR a la pantalla (desde go), no aquí:
    // llamarlo en cada render creaba un bucle que repintaba sin parar y no
    // dejaba escribir en los comentarios.
  }
  const allAlerts=buildAlerts();let visible=(CU.role==='gerencia'||CU.role==='contabilidad')?allAlerts:allAlerts.filter(a=>a.role===CU.role||(_deptAcotado()&&_deptPermitido(a.dept)));if(dAdept!=='todos')visible=visible.filter(a=>a.dept===dAdept);if(dAuser!=='todos')visible=visible.filter(a=>a.responsable===dAuser||a.role===dAuser);const uniqueRoles=[...new Set(allAlerts.map(a=>a.role))];const uniqueDepts=[...new Set(allAlerts.map(a=>a.dept))].filter(Boolean);let _solHTML='';
  // El panel de menciones va PRIMERO y aparte: antes se armaba aquí y las
  // líneas de abajo lo pisaban con "=", así que nunca se llegaba a ver.
  var _menHTML='';
  try{ _menHTML=_menPanel(); }catch(e){ console.warn('panel menciones:',e); }

  if(CU && (CU.role==='contabilidad'||CU.role==='gerencia')){
    try{
      _solHTML=_solPagoBarraDept()
              +_solPagoSeccion('abono','Solicitudes de depósito (abono)','ti ti-coin','#166534','#dcfce7','#16a34a')
              +_solPagoSeccion('cancelacion','Solicitud de cancelación','ti ti-file-invoice','#B45309','#FEF9F3','#E9C08A')
              ;
    }catch(e){ console.warn('solicitudes:',e); }
  } else if(CU && CU.role==='compras'){
    try{ _solHTML=_solPagoMisSeccion(); }catch(e){ console.warn('mis solicitudes:',e); }
  }
  // Seguimiento de abonos: para gerencia y compras, arriba de todo
  var _segHTML='';
  try{ _segHTML=_segPanel(); }catch(e){ console.warn('seguimiento:',e); }

  // Gerencia: el listado de lo que espera una acción, por departamento
  var _pgHTML='';
  try{ _pgHTML=_pgPanel(); }catch(e){ console.warn('pendientes gerencia:',e); }

  // Reclamos a proveedores, por departamento
  var _reclHTML='';
  try{ _reclHTML=_reclPanel(); }catch(e){ console.warn('reclamos:',e); }

  _solHTML=_menHTML+_pgHTML+_reclHTML+_segHTML+_solHTML;
  document.getElementById('page-alertas').innerHTML=_solHTML+`<div style="font-size:13px;font-weight:500;margin-bottom:8px">${CU.role==='contabilidad'?'Otras alertas operativas':'Alertas'} — ${visible.length} activas</div><div style="margin-bottom:8px"><div style="font-size:11px;color:var(--text-muted);margin-bottom:5px;font-weight:500">Filtrar por departamento:</div><div style="display:flex;gap:5px;flex-wrap:wrap">${['todos',...uniqueDepts].map(d=>`<span class="pill ${dAdept===d?'active':''}" onclick="setAlDept('${d}')">${dL(d)}</span>`).join('')}</div></div>${CU.role==='contabilidad'?'':`<div style="margin-bottom:12px"><div style="font-size:11px;color:var(--text-muted);margin-bottom:5px;font-weight:500">Filtrar por responsable:</div><div style="display:flex;gap:5px;flex-wrap:wrap"><span class="pill ${dAuser==='todos'?'active':''}" onclick="setAlUser('todos')">Todos</span>${uniqueRoles.map(r=>{const label={compras:'Compras',contabilidad:'Contabilidad',diseno:'Diseño',gerencia:'Gerencia',importacion:'Importación',bodega:'Bodega'}[r]||r;return`<span class="pill ${dAuser===r?'active':''}" onclick="setAlUser('${r}')">${label}</span>`;}).join('')}</div></div>`}${visible.length?visible.map(a=>alCard(a)).join(''):'<div class="empty"><i class="ti ti-circle-check" style="font-size:22px;color:var(--text-success)"></i><br>Sin alertas para los filtros seleccionados</div>'}`;}
// ═══════════════════════════════════════════════════════════════════════════
//  REPOSICIONES  (restock por proveedor -> PDF con formato SAP)
// ═══════════════════════════════════════════════════════════════════════════
function _esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
var _repProv=[];          // catálogo de proveedores {cardcode,cardname,n_items}
var _repData=null;        // datos del último proveedor consultado
var _repCard='';          // cardcode consultado
var _repCarrito={};       // {itemcode: cantidad} — items seleccionados para restock
var _repImgCache={};      // {itemcode: dataURL} — fotos precargadas para PDF/Excel
var _repMailFiles=[];     // [File] — PDF y Excel generados, para compartir/adjuntar
var _repRutaCompras={ edy:['lorena','sherene'], jimmy:['edgardo'], itay:['yagizel'], henry:['yagizel'], samuel:['lorena','sherene','edy'], gady:['eimy'], ariel:['zeida'], eli:['ariel','zeida'] };
// ═══════════════════════════════════════════════════════════════════════════
//  EQUIPO POR DEPARTAMENTO
//  Las personas del mismo rol y departamento comparten todo: órdenes, pedidos
//  guardados, compras para firma, reposiciones. Sherene ve exactamente lo mismo
//  que Lorena (ambas Compras · Hogar), pero con su propio usuario y su firma.
//  Gerencia no tiene equipo: ve todo.
// ═══════════════════════════════════════════════════════════════════════════
function _equipo(){
  if(!CU) return [];
  // Gerencia SIN departamento ve todo y no tiene equipo.
  // Gerencia CON departamento (Gady en alfombras, Henry en ropa) tiene los
  // mismos permisos que gerencia, pero solo sobre su área: su equipo son
  // todos los que trabajan ese departamento, sea cual sea su rol.
  if(CU.role==='gerencia'){
    if(!_deptAcotado()) return [];             // vacío = sin restricción
    return (USERS||[]).filter(function(u){
      return (_deptPermitido(u.dept)||(!u.dept&&!_deptAcotado()));
    });
  }
  return (USERS||[]).filter(function(u){
    return u.role===CU.role && (_deptPermitido(u.dept)||(!u.dept&&!_deptAcotado()));
  });
}
function _equipoIds(){ return _equipo().map(function(u){ return u.id; }); }
function _equipoEmails(){ return _equipo().map(function(u){ return (u.email||'').toLowerCase(); }).filter(Boolean); }
// ¿Este registro es de alguien de mi equipo? (para permisos de editar/borrar)
function _esDeMiEquipo(id){
  var ids=_equipoIds();
  if(!ids.length) return true;               // gerencia
  return ids.indexOf(String(id||''))>=0;
}
// Filtro PostgREST: usuario dentro del equipo
function _filtroEquipo(campo){
  var ids=_equipoIds();
  if(!ids.length) return '';                 // gerencia ve todo
  return '&'+campo+'=in.('+ids.map(encodeURIComponent).join(',')+')';
}

function _repRutaEmails(){ var ids=_repRutaCompras[(CU&&CU.id)]; if(!ids) return []; return ids.map(function(id){ var u=(USERS||[]).find(function(x){return x.id===id;}); return u?u.email:''; }).filter(Boolean); }

// Arma la URL de la foto. El bucket guarda los nombres con la EXTENSIÓN en minúscula
// (ej: 2317920.jpg) aunque SAP la reporte en mayúscula (2317920.JPG). Normalizamos
// la extensión a minúscula para que coincida con el archivo real del bucket.
function _repFotoUrl(picturname){
  var pn=(picturname||'').toString().trim();
  if(!pn) return '';
  // pasar solo la extensión a minúscula: "2317920.JPG" -> "2317920.jpg"
  pn=pn.replace(/\.([A-Za-z0-9]+)$/, function(m,ext){ return '.'+ext.toLowerCase(); });
  return FOTO_BASE+encodeURIComponent(pn);
}

// Muestra la foto en grande (lightbox) al hacer clic
function _repZoomFoto(urlEnc, itemcode){
  var url=decodeURIComponent(urlEnc||'');
  if(!url) return;
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.85);z-index:3000;display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
  ov.innerHTML='<div style="position:relative;max-width:92vw;max-height:92vh;text-align:center">'
    +'<img src="'+url+'" style="max-width:92vw;max-height:86vh;object-fit:contain;border-radius:8px;background:var(--surface-2)">'
    +'<div style="color:white;font-size:13px;margin-top:8px;font-weight:600">'+_esc(itemcode||'')+'</div>'
    +'<button style="position:absolute;top:-6px;right:-6px;background:var(--surface-2);border:none;border-radius:50%;width:32px;height:32px;font-size:20px;cursor:pointer;line-height:32px">&times;</button>'
  +'</div>';
  ov.addEventListener('click',function(){ ov.remove(); });
  document.body.appendChild(ov);
}
// Preview flotante al pasar el mouse por encima de una foto (hover)
var _repHoverBox=null;
function _repHoverShow(ev, urlEnc){
  var url=decodeURIComponent(urlEnc||'');
  if(!url) return;
  if(!_repHoverBox){
    _repHoverBox=document.createElement('div');
    _repHoverBox.style.cssText='position:fixed;z-index:3500;pointer-events:none;border:2px solid white;border-radius:8px;box-shadow:0 8px 30px rgba(0,0,0,.4);background:var(--surface-2);overflow:hidden;display:none';
    _repHoverBox.innerHTML='<img style="display:block;width:260px;height:260px;object-fit:contain;background:var(--surface-2)">';
    document.body.appendChild(_repHoverBox);
  }
  var img=_repHoverBox.querySelector('img');
  if(img.getAttribute('src')!==url) img.src=url;
  _repHoverBox.style.display='block';
  _repHoverMove(ev);
}
function _repHoverMove(ev){
  if(!_repHoverBox||_repHoverBox.style.display==='none')return;
  var pad=16, w=264, h=264;
  var x=ev.clientX+pad, y=ev.clientY+pad;
  if(x+w>window.innerWidth) x=ev.clientX-w-pad;
  if(y+h>window.innerHeight) y=window.innerHeight-h-8;
  if(y<8) y=8;
  _repHoverBox.style.left=x+'px';
  _repHoverBox.style.top=y+'px';
}
function _repHoverHide(){
  if(_repHoverBox) _repHoverBox.style.display='none';
}

// Busca un itemcode en las órdenes No SAP. Devuelve [{orden, cantidad, dept, proveedor}, ...]
function _repEnOrdenesNoSAP(itemcode){
  var ic=String(itemcode||'').trim();
  if(!ic) return [];
  var res=[];
  (window._pendSAP||[]).forEach(function(p){
    var items=p.items; if(typeof items==='string'){ try{items=JSON.parse(items);}catch(e){items=[];} }
    (items||[]).forEach(function(it){
      if(String(it.itemcode||'').trim()===ic){
        res.push({orden:p.num_orden||p.dkc, dkc:p.dkc, cantidad:Number(it.cantidad)||0, precio_unit:Number(it.precio_unit)||0, total_linea:Number(it.total_linea)||0, dept:p.dept, proveedor:p.proveedor, fecha:p.fecha||p.creado_en||''});
      }
    });
  });
  return res;
}

function _fmtN2(v){ v=Number(v)||0; return v.toLocaleString('es',{minimumFractionDigits:2,maximumFractionDigits:2}); }
// Formatea una fecha (ISO o dd/mm/yyyy) a un formato corto dd/mm/yy
function _fmtFechaCorta(f){
  if(!f) return '';
  var s=String(f);
  var d=null;
  // Una fecha suelta "2026-08-01" la interpreta como UTC, y en Panamá
  // (UTC-5) eso la corría un día para atrás. Se arma a mano en hora local.
  var m=s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if(m){
    return ('0'+m[3]).slice(-2)+'/'+('0'+m[2]).slice(-2)+'/'+m[1].slice(2);
  }
  if(/^\d{4}-\d{2}-\d{2}/.test(s)){ d=new Date(s); }
  else if(/^\d{1,2}\/\d{1,2}\/\d{2,4}/.test(s)){ return s.slice(0,10); }
  else { d=new Date(s); }
  if(d && !isNaN(d.getTime())){
    return d.toLocaleDateString('es',{day:'2-digit',month:'2-digit',year:'2-digit'});
  }
  return s.slice(0,10);
}

async function _repCargarProveedores(){
  if(_repProv.length) return _repProv;
  if(window._repProvCargando) return window._repProvCargando;
  // Se pagina el inventario completo. Antes se pedía limit=50000 de un tirón y
  // los proveedores que quedaban después de esa fila nunca aparecían en la lista.
  window._repProvCargando=(async function(){
    try{
      // OJO: Supabase corta las respuestas en su tope de filas (por defecto 1000)
      // aunque se pida limit=10000. Antes se cortaba el bucle al recibir menos
      // filas de las pedidas, así que solo se leía la PRIMERA página y quedaban
      // fuera casi todos los proveedores. Ahora se avanza por lo REALMENTE
      // recibido y solo se para cuando una página vuelve vacía.
      var mp={}, offset=0, tanda=1000, vueltas=0, leidas=0;
      while(vueltas<400){
        vueltas++;
        var url=SB+'/rest/v1/inventario?select=cardcode,nombre_proveedor,grupo'
              +'&cardcode=not.is.null&order=cardcode&limit='+tanda+'&offset='+offset;
        var r=await fetch(url,{headers:SBH});
        if(!r.ok) break;
        var rows=await r.json();
        if(!Array.isArray(rows)||!rows.length) break;   // se acabó el inventario
        rows.forEach(function(x){
          var cc=(x.cardcode||'').trim(); if(!cc)return;
          // Si el usuario tiene departamento, solo cuentan los items de su área
          if(_deptAcotado() && !_deptPermitido(normDept(x.grupo))) return;
          if(!mp[cc])mp[cc]={cardcode:cc, cardname:x.nombre_proveedor||'', n_items:0};
          mp[cc].n_items++;
          if(!mp[cc].cardname && x.nombre_proveedor) mp[cc].cardname=x.nombre_proveedor;
        });
        leidas+=rows.length;
        offset+=rows.length;                            // se avanza por lo recibido
        // Se va mostrando lo que ya se tiene, sin esperar a terminar
        _repProv=Object.values(mp).sort(function(a,b){return a.cardcode.localeCompare(b.cardcode);});
        window._repProvParcial=true;
        if(vueltas%5===0){
          try{
            var dd=document.getElementById('rep-provdrop');
            var ii=document.getElementById('rep-code');
            if(dd && dd.style.display!=='none') _repProvFiltrar(ii?ii.value:'');
          }catch(e){}
        }
      }
      window._repProvParcial=false;
      _repProv=Object.values(mp).sort(function(a,b){return a.cardcode.localeCompare(b.cardcode);});
      console.info('[proveedores] '+_repProv.length+' proveedores desde '+leidas+' filas de inventario');
    }catch(e){ _repProv=_repProv||[]; }
    window._repProvCargando=null;
    // Si el desplegable estaba abierto mientras terminaba de cargar, se repinta
    try{
      var d=document.getElementById('rep-provdrop');
      var inp=document.getElementById('rep-code');
      if(d && d.style.display!=='none') _repProvFiltrar(inp?inp.value:'');
    }catch(e){}
    return _repProv;
  })();
  return window._repProvCargando;
}

// ══ DESPLEGABLE DE PROVEEDORES CON SCROLL INFINITO ══
// Antes era un <datalist> nativo: los navegadores limitan cuantas opciones
// muestran (Chrome corta la lista) y no dejan seguir bajando. Este lo
// reemplaza por una lista propia que va cargando de a tandas al hacer scroll.
var _repProvFiltrados=[], _repProvVistos=0, _repProvTanda=40, _repProvSel=-1;

// Abrir la lista al recibir el foco es cómodo, salvo justo después de elegir
function _repProvFoco(txt){
  if(window._repProvRecien && (Date.now()-window._repProvRecien)<600) return;
  _repProvFiltrar(txt);
}

function _repProvCerrar(){
  var d=document.getElementById('rep-provdrop');
  if(d){ d.style.display='none'; }
  _repProvSel=-1;
}

function _repProvFiltrar(txt){
  var d=document.getElementById('rep-provdrop'); if(!d) return;
  var base=_repProv||[];
  var q=_repNorm(txt||'');
  if(!q){ _repProvFiltrados=base.slice(); }
  else {
    // Busca por palabras sueltas y en cualquier orden: "light china" también
    // encuentra "CHINA LIGHT (GUANGZHOU) HOMETREND".
    var pals=q.split(' ').filter(Boolean);
    var exactos=[], parciales=[];
    base.forEach(function(p){
      var cc=_repNorm(p.cardcode), cn=_repNorm(p.cardname);
      var todo=cc+' '+cn;
      if(cc===q || cc.indexOf(q)===0){ exactos.push(p); return; }
      if(pals.every(function(w){ return todo.indexOf(w)>=0; })) parciales.push(p);
    });
    _repProvFiltrados=exactos.concat(parciales);
  }
  _repProvVistos=0; _repProvSel=-1;
  d.innerHTML=''; d.scrollTop=0;
  d.style.display='block';
  // Scroll infinito enganchado al propio desplegable (más fiable que el listener global)
  d.onscroll=function(){
    if(d.scrollTop + d.clientHeight >= d.scrollHeight - 80) _repProvSiguiente();
  };
  // Cabecera fija con el conteo y el aviso de carga
  d.insertAdjacentHTML('beforeend','<div style="position:sticky;top:0;z-index:2;background:var(--surface-2);border-bottom:0.5px solid var(--border);padding:6px 12px;font-size:10.5px;color:var(--text-muted);font-weight:600">'
    +_repProvFiltrados.length+' proveedor(es)'+(q?(' con "'+_esc(String(txt||''))+'"'):'')
    +(window._repProvParcial?' <span style="color:var(--t-ambar)">\u00b7 cargando el resto…</span>':'')
    +'</div>');
  _repProvMas();
  if(!_repProvFiltrados.length){
    d.innerHTML='<div style="padding:10px 12px;font-size:12px;color:var(--text-muted)">'
      +(window._repProvCargando?'Cargando proveedores…':'Sin proveedores que coincidan. Puedes buscar igual por SKU, referencia o descripción.')
      +'</div>';
  }
}

// Carga la siguiente tanda si todavía queda lista por mostrar
function _repProvSiguiente(){
  if(_repProvVistos >= _repProvFiltrados.length) return;
  var mas=document.getElementById('rep-provmas'); if(mas) mas.remove();
  _repProvMas();
}

// Agrega la siguiente tanda al final de la lista (esto es el "bajar infinito").
function _repProvMas(){
  var d=document.getElementById('rep-provdrop'); if(!d) return;
  var hasta=Math.min(_repProvVistos+_repProvTanda, _repProvFiltrados.length);
  var h='';
  for(var i=_repProvVistos;i<hasta;i++){
    var p=_repProvFiltrados[i];
    h+='<div class="rep-provit" data-i="'+i+'" onclick="_repProvElegir('+i+')"'
      +' style="padding:8px 12px;cursor:pointer;font-size:12.5px;border-bottom:0.5px solid var(--border);display:flex;align-items:center;gap:8px;-webkit-tap-highlight-color:transparent">'
      +'<b style="color:var(--text-accent);flex:0 0 auto">'+_esc(p.cardcode)+'</b>'
      +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(p.cardname||'')+'</span>'
      +'<span style="flex:0 0 auto;color:var(--text-muted);font-size:11px">'+(p.n_items||0)+' items</span>'
      +'</div>';
  }
  d.insertAdjacentHTML('beforeend', h);
  _repProvVistos=hasta;
  if(_repProvVistos<_repProvFiltrados.length){
    d.insertAdjacentHTML('beforeend','<div id="rep-provmas" style="padding:7px 12px;font-size:11px;color:var(--text-muted);text-align:center">Baja para ver más… ('+_repProvVistos+' de '+_repProvFiltrados.length+')</div>');
    // Si la tanda no alcanzó a llenar el alto visible no habría scroll y la lista
    // se quedaría trabada: se sigue cargando hasta que sí se pueda desplazar.
    if(d.scrollHeight <= d.clientHeight + 8){
      setTimeout(_repProvSiguiente, 0);
    }
  }
}

function _repProvElegir(i){
  var p=_repProvFiltrados[i]; if(!p) return;
  _repProvElegido(p.cardcode);
}

// Deja el proveedor puesto y cierra el desplegable. Como el campo vuelve a
// abrir la lista al recibir el foco, se le quita el foco y se ignora la
// reapertura durante un instante.
function _repProvElegido(code){
  var inp=document.getElementById('rep-code');
  if(inp) inp.value=code;
  window._repProvRecien=Date.now();
  _repProvCerrar();
  try{ if(inp) inp.blur(); }catch(e){}
  repGenerar();
}

// Flechas para moverse sin ratón; Enter busca; Escape cierra.
function _repProvTecla(ev){
  var d=document.getElementById('rep-provdrop');
  var abierto=d && d.style.display!=='none';
  if(ev.key==='Escape'){ _repProvCerrar(); return; }
  if(ev.key==='Enter'){
    if(abierto && _repProvSel>=0){ ev.preventDefault(); _repProvElegir(_repProvSel); return; }
    _repProvCerrar(); repBuscarUnificado(); return;
  }
  if(!abierto) return;
  if(ev.key==='ArrowDown'||ev.key==='ArrowUp'){
    ev.preventDefault();
    var max=_repProvVistos-1; if(max<0) return;
    _repProvSel += (ev.key==='ArrowDown'?1:-1);
    if(_repProvSel<0) _repProvSel=0;
    if(_repProvSel>max){ _repProvSel=max; _repProvMas(); }
    Array.prototype.forEach.call(d.querySelectorAll('.rep-provit'),function(el){
      var on=Number(el.getAttribute('data-i'))===_repProvSel;
      el.style.background=on?'var(--bg-accent)':'transparent';
      if(on && el.scrollIntoView) el.scrollIntoView({block:'nearest'});
    });
  }
}

// Scroll infinito + cerrar al hacer clic fuera. Se registran una sola vez.
if(!window._repProvInit){
  window._repProvInit=true;
  document.addEventListener('scroll', function(ev){
    var d=ev.target;
    if(!d || d.id!=='rep-provdrop') return;
    if(d.scrollTop + d.clientHeight >= d.scrollHeight - 80){
      _repProvSiguiente();
    }
  }, true);
  // En fase de captura: se evalúa antes de que el re-render borre el nodo.
  document.addEventListener('click', function(ev){
    var t=ev.target;
    if(t && t.closest && (t.closest('#rep-provdrop') || t.closest('#rep-code'))) return;
    _repProvCerrar();
  }, true);
}

// ══════════════════════════════════════════════════════════════════════
//  TOP SELLING ITEMS
//  Los artículos que más se movieron en los últimos 3 años y que hoy
//  están por debajo de la mitad de lo que se compró la última vez, sin
//  nada en camino. Es decir: lo que se vende y se está acabando.
// ══════════════════════════════════════════════════════════════════════

window._topDept = window._topDept || 'todos';
window._topRows = window._topRows || null;

// Cuánto urge reponer cada uno. Manda la cobertura: cuántos meses aguanta
// el stock al ritmo al que se ha vendido. Cuanto menos aguanta y más se
// vende, más arriba sale.
function _topUrgencia(x){
  var disp   = _repDisp(x);
  var vendido= Number(x.vendido_3a)||0;
  var meses  = 36;
  try{
    var m=_repMesesDe(x.primera_venta);
    if(m && m>0 && m<36) meses=m;
  }catch(e){}
  var rot = vendido/Math.max(meses,1);          // piezas por mes
  if(rot<=0) return null;
  var cobertura = disp/rot;                      // meses que aguanta
  // Nota: la puntuación mezcla las dos cosas a propósito. Un artículo que
  // vende mucho y aguanta poco tiene que ir antes que uno que vende poco
  // aunque esté a cero: reponer el primero evita más venta perdida.
  return { rot:rot, cobertura:cobertura, vendido:vendido,
           score: rot / (1 + cobertura) };
}

function _topCalcular(){
  var base=(window._topItems||[]);
  var out=[];
  base.forEach(function(x){
    var ult=Number(x.u_cant_ult_ent)||0;
    if(!(ult>0)) return;                                  // sin compra previa
    var disp=_repDisp(x);
    if(disp > ult*0.5) return;                            // todavía queda medio pedido
    if((Number(x.onorder)||0) > 0) return;                // ya viene en camino
    var u=_topUrgencia(x);
    if(!u) return;                                        // no se ha vendido nunca
    x._topRot=u.rot; x._topCob=u.cobertura; x._topScore=u.score;
    out.push(x);
  });
  out.sort(function(a,b){ return b._topScore-a._topScore; });
  return out;
}

function _topSetDept(d){ window._topDept=d; _topRender(); }

// La pantalla de reposiciones trabaja con UN proveedor por vez, así que sus
// artículos no sirven aquí: hace falta el inventario entero. Se acota en el
// servidor a lo que puede cumplir las condiciones —que se haya vendido, que
// no venga nada en camino y que haya una compra anterior— y el resto se
// filtra aquí. Sin ese acote serían más de cien mil filas.
async function _topCargar(){
  // OJO con los nombres: la tabla usa onhand/iscommited/codebars. Pedir una
  // columna que no existe hace que PostgREST rechace la consulta ENTERA y
  // devuelva vacío, que es justo lo que pasaba: "stock", "comprometido" y
  // "barcode" no existen y tumbaban toda la pantalla.
  var url=SB+'/rest/v1/inventario?select=itemcode,itemname,grupo,grupo_cod,cardcode,'
    +'nombre_proveedor,disponible,onhand,iscommited,onorder,u_cant_ult_ent,fechaentrada,'
    +'vendido_3a,primera_venta,hist_comprado,unidadesbulto,precioventa,lastpurprc,'
    +'picturname,u_color,u_tamano,codebars,subg,salpackun,fob,cif,prox_llegada,ultima_llegada'
    +'&vendido_3a=gt.0&u_cant_ult_ent=gt.0'
    // 8.963 artículos pasan el filtro del servidor. Con 6.000 se dejaban
    // fuera los 2.963 de menos venta; se sube para no perder ninguno.
    +'&order=vendido_3a.desc&limit=12000';
  try{
    var r=await fetch(url,{headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      console.error('[top] inventario '+r.status+': '+t.slice(0,300));
      showT('No se pudo leer el inventario ('+r.status+'). Mira la consola.');
      return [];
    }
    var f=await r.json()||[];
    return f.map(function(x){
      return Object.assign({}, x, {
        grupo_nom: x.grupo||'',
        grupo_cod: x.grupo_cod||'',
        // "precio1" no existe en la tabla: es el precio de venta con otro
        // nombre. La pantalla de reposiciones lo arma así, y las columnas
        // se pintan con él, de modo que hay que armarlo igual aquí.
        precio1:   Number(x.precioventa)||0,
        u_fentrada: x.fechaentrada||''
      });
    });
  }catch(e){ console.warn('[top]',e); return []; }
}

async function _topAbrir(){
  window._topRows=null;
  PG='topselling';
  var cont=document.getElementById('page-reposiciones');
  if(cont){
    cont.innerHTML='<div class="empty" style="padding:26px;color:var(--text-muted)">'
      +'<i class="ti ti-flame" style="font-size:24px;color:#EA580C"></i><br>'
      +'Buscando los artículos más vendidos…</div>';
  }
  var todos=await _topCargar();
  // El control de acceso por departamento, igual que en reposiciones
  if(_deptAcotado()){
    todos=todos.filter(function(x){ return _deptPermitido(normDept(x.grupo_nom)); });
  }
  window._topItems=todos;
  _topRender();
}

// ── El informe de top selling, a Excel ──
// Lleva lo mismo que la pantalla y además el proveedor, con su código y su
// nombre, que en el listado no se ve porque cada fila es un artículo.
async function _topExportar(){
  var lista=_topCalcular();
  if(!lista.length){ showT('No hay artículos que exportar'); return; }
  if(window._topDept && window._topDept!=='todos'){
    lista=lista.filter(function(x){ return normDept(x.grupo)===window._topDept; });
  }
  showT('Generando el informe…');
  try{
    await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Top selling');
    ws.columns=[
      {header:'#',                 key:'n',    width:5},
      // La foto va en su columna. Se incrusta a 120 px y calidad 0,55: en la
      // celda se ve a 48 px, así que más resolución solo engordaría el
      // archivo sin verse mejor.
      {header:'Foto',              key:'foto', width:9},
      {header:'SKU',               key:'sku',  width:16},
      {header:'Descripción',       key:'desc', width:44},
      {header:'Departamento',      key:'dep',  width:14},
      // Lo que pediste: el proveedor con código y nombre
      {header:'Código proveedor',  key:'cc',   width:14},
      {header:'Proveedor',         key:'prov', width:34},
      {header:'Existencia',        key:'onh',  width:12},
      {header:'Comprometido',      key:'com',  width:13},
      {header:'Disponible',        key:'disp', width:12},
      {header:'En camino',         key:'ord',  width:11},
      {header:'Meses de stock',    key:'cob',  width:14},
      {header:'Vende al mes',      key:'rot',  width:13},
      {header:'Vendidas 3 años',   key:'v3a',  width:15},
      {header:'Última compra',     key:'ult',  width:14},
      {header:'Fecha última entrada', key:'fe', width:16},
      {header:'Pzs por bulto',     key:'blt',  width:13},
      {header:'Color',             key:'col',  width:14},
      {header:'Medida',            key:'tam',  width:14},
      {header:'Código barras',     key:'bar',  width:16},
      {header:'FOB',               key:'fob',  width:11},
      {header:'CIF',               key:'cif',  width:11},
      {header:'Precio venta',      key:'pv',   width:12}
    ];
    ws.getRow(1).font={bold:true};
    ws.getRow(1).fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEDE9FE'}};
    ws.views=[{state:'frozen', ySplit:1}];

    // Las fotos se bajan ANTES y a la vez, no una a una: con 200 artículos
    // en fila india se hacía eterno.
    var fotos={};
    var conFoto=lista.filter(function(x){ return _repFotoUrl(x.picturname); });
    showT('Bajando '+conFoto.length+' foto(s)…');
    for(var b=0; b<conFoto.length; b+=12){
      var tanda=conFoto.slice(b,b+12);
      await Promise.all(tanda.map(async function(x){
        var u=_repFotoUrl(x.picturname);
        if(!u || fotos[u]) return;
        try{ fotos[u]=await _repImgToB64(u, 120, 0.55); }catch(e){ fotos[u]=null; }
      }));
    }

    lista.forEach(function(x,i){
      var cob=x._topCob;
      ws.addRow({
        n:i+1, foto:'',
        sku:x.itemcode||'', desc:x.itemname||'',
        dep:dL(normDept(x.grupo)||''),
        cc:x.cardcode||'', prov:x.nombre_proveedor||'',
        onh:Number(x.onhand)||0, com:Number(x.iscommited)||0,
        disp:_repDisp(x), ord:Number(x.onorder)||0,
        cob:(cob!=null?Number(cob.toFixed(1)):''),
        rot:Math.round(Number(x._topRot)||0),
        v3a:Number(x.vendido_3a)||0,
        ult:Number(x.u_cant_ult_ent)||0,
        fe:(x.fechaentrada?String(x.fechaentrada).slice(0,10):''),
        blt:Number(x.unidadesbulto||x.salpackun)||'',
        col:x.u_color||'', tam:x.u_tamano||'', bar:x.codebars||'',
        fob:Number(x.fob)||0, cif:Number(x.cif)||0, pv:Number(x.precioventa)||0
      });
    });

    // Y ahora se pegan las fotos en su celda
    var puestas=0;
    lista.forEach(function(x,i){
      var u=_repFotoUrl(x.picturname);
      var im=u?fotos[u]:null;
      if(!im || !im.b64) return;
      try{
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id, {tl:{col:1.12, row:(i+1)+0.10},
                         ext:{width:46, height:46}, editAs:'oneCell'});
        ws.getRow(i+2).height=38;
        puestas++;
      }catch(e){}
    });
    console.log('[top selling] '+puestas+' foto(s) incrustadas de '+lista.length);

    // Los que quedan sin stock, en rojo: es lo primero que hay que reponer
    for(var f=2; f<=ws.rowCount; f++){
      var c=ws.getRow(f).getCell('cob').value;
      if(c!=='' && Number(c)<1){
        ws.getRow(f).getCell('cob').font={bold:true, color:{argb:'FFB91C1C'}};
      }
    }
    ['onh','com','disp','ord','rot','v3a','ult','blt'].forEach(function(k){
      ws.getColumn(k).numFmt='#,##0';
    });
    ['fob','cif','pv'].forEach(function(k){ ws.getColumn(k).numFmt='#,##0.00'; });

    var buf=await wb.xlsx.writeBuffer();
    var url=URL.createObjectURL(new Blob([buf],
      {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
    var a=document.createElement('a');
    a.href=url;
    a.download='top-selling-'
      +((window._topDept&&window._topDept!=='todos')?(window._topDept+'-'):'')
      +new Date().toISOString().slice(0,10)+'.xlsx';
    a.click();
    showT('✓ '+lista.length+' artículo(s) exportados');
  }catch(e){
    console.warn('[top selling] exportar:', e);
    showT('No se pudo generar el informe');
  }
}

function _topRender(){
  var cont=document.getElementById('page-reposiciones');
  if(!cont) return;
  if(!window._topRows) window._topRows=_topCalcular();

  var todos=window._topRows;
  var deps={};
  todos.forEach(function(x){ var d=normDept(x.grupo_nom||x.grupo||'')||'otros'; deps[d]=(deps[d]||0)+1; });

  var lista = (window._topDept==='todos')
    ? todos
    : todos.filter(function(x){ return (normDept(x.grupo_nom||x.grupo||'')||'otros')===window._topDept; });
  // Si el departamento seleccionado quedó en un valor que ya no existe entre
  // los resultados, la pantalla salía vacía teniendo artículos de sobra.
  // Antes que mostrar nada, se vuelve a "Todos".
  if(!lista.length && todos.length && window._topDept!=='todos'){
    console.warn('[top] el departamento "'+window._topDept+'" no tiene artículos; se muestran todos');
    window._topDept='todos';
    lista=todos;
  }
  var top = lista.slice(0,200);
  console.log('[top] '+todos.length+' artículo(s) · departamento '+window._topDept
    +' · se muestran '+top.length);

  var pills='<span class="pill '+(window._topDept==='todos'?'active':'')+'" onclick="_topSetDept(\'todos\')">'
      +'Todos <span style="opacity:.7">'+todos.length+'</span></span>'
    +Object.keys(deps).sort().map(function(d){
      return '<span class="pill '+(window._topDept===d?'active':'')+'" onclick="_topSetDept(\''+d+'\')">'
        +(EMOJIS2[d]||'')+' '+_esc(dL(d))+' <span style="opacity:.7">'+deps[d]+'</span></span>';
    }).join('');

  var h='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin-bottom:4px">'
    +'<button onclick="_topVolver()" class="btn bg2" style="padding:5px 12px;font-size:12px">'
      +'<i class="ti ti-arrow-left"></i> Volver a reposiciones</button>'
    +'<span style="font-size:15px;font-weight:700"><i class="ti ti-flame" style="color:#EA580C"></i> '
      +'Top selling items</span>'
    +'<button onclick="_topExportar()" class="btn bg2" '
    +'style="margin-left:auto;padding:5px 12px;font-size:12px">'
    +'<i class="ti ti-file-spreadsheet"></i> Informe Excel</button></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px;max-width:820px;line-height:1.5">'
      +'Lo que más se vendió en los últimos 3 años y hoy está por debajo de la mitad de la última '
      +'compra, sin nada en camino. Arriba, lo que antes se va a quedar sin existencias al ritmo '
      +'al que se vende. Pulsa un artículo para ir a la reposición de su proveedor.</div>'
    +'<div class="filters" style="margin-bottom:10px">'+pills+'</div>';

  if(!top.length){
    return void (cont.innerHTML = h
      +'<div class="empty" style="padding:22px;color:var(--text-muted)">'
      +'<i class="ti ti-mood-check" style="font-size:22px;color:var(--t-verde)"></i><br>'
      +'Ningún artículo cumple las condiciones'
      +(window._topDept!=='todos'?' en este departamento':'')+'.<br>'
      +'<span style="font-size:11px">Se piden tres cosas a la vez: que tenga ventas, que quede '
      +'la mitad o menos de la última compra y que no venga nada en camino.</span></div>');
  }

  h+='<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px">'
    +'Mostrando '+top.length+' de '+lista.length+' artículo(s)'
    +(lista.length>200?' · los 200 más urgentes':'')+'</div>';

  // Las mismas columnas que el listado de reposiciones
  h+=top.map(function(x, i){
    var fila=_repFilaItem(x);
    var cob=x._topCob;
    var col=(cob<1)?'#b91c1c':(cob<3?'#B45309':'#166534');
    var etiqueta='<div style="display:flex;align-items:center;gap:7px;padding:2px 0 0 6px">'
      +'<span style="font-size:10px;font-weight:800;color:var(--text-muted);min-width:26px">#'+(i+1)+'</span>'
      +'<span title="Al ritmo al que se vende, el stock aguanta esto" '
        +'style="font-size:10px;font-weight:700;color:'+col+'">'
        +(cob<0.05?'sin stock':(cob.toFixed(1)+' meses de stock'))+'</span>'
      +'<span style="font-size:10px;color:var(--text-muted)">vende ~'+_fmtN2(Math.round(x._topRot))+'/mes'
        +' · '+_fmtN2(x.vendido_3a||0)+' vendidas en 3 años</span>'
      +'<button class="btn bg2" style="margin-left:auto;padding:3px 10px;font-size:10.5px;font-weight:600"'
        +' onclick="event.stopPropagation();_topIrAProveedor(\''+_esc(String(x.itemcode||''))+'\')">'
        +'Reponer con su proveedor <i class="ti ti-arrow-right"></i></button>'
      +'</div>';
    return '<div style="border:0.5px solid var(--border);border-radius:9px;margin-bottom:7px;'
      +'overflow:hidden;background:var(--surface-0);cursor:pointer" '
      +'onclick="_topIrAProveedor(\''+_esc(String(x.itemcode||''))+'\')">'
      +etiqueta+fila+'</div>';
  }).join('');

  cont.innerHTML=h;
}

function _topVolver(){
  PG='reposiciones';
  window._topRows=null;
  rReposiciones();
}

// Lleva a la reposición del proveedor de ese artículo, con el artículo ya
// buscado para no tener que encontrarlo entre cientos.
function _topIrAProveedor(itemcode){
  var cod=String(itemcode||'').trim().toUpperCase();
  var x=(window._topItems||[]).find(function(it){
    return String(it.itemcode||'').trim().toUpperCase()===cod;
  });
  if(!x){ showT('No se encontró el artículo'); return; }
  var prov=String(x.cardcode||'').trim();
  if(!prov){ showT('Ese artículo no tiene proveedor en SAP'); return; }
  PG='reposiciones';
  window._topRows=null;
  window._repFiltroItem=cod;          // deja el artículo filtrado al llegar
  try{ _repProvElegido(prov); }catch(e){ showT('No se pudo abrir el proveedor'); }
}

async function rReposiciones(){
  var cont=document.getElementById('page-reposiciones');
  if(!cont) return;
  // La pantalla se dibuja YA. El catálogo de proveedores se carga en segundo
  // plano: al recorrer todo el inventario tarda varios segundos y, si se
  // esperaba aquí, la primera entrada a Reposiciones quedaba en blanco.
  if(!_repProv.length){
    _repCargarProveedores().then(function(){
      var av=document.getElementById('rep-prov-carga');
      if(av) av.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> '+_repProv.length+' proveedores listos</span>';
      setTimeout(function(){ var a2=document.getElementById('rep-prov-carga'); if(a2) a2.remove(); }, 2500);
    }).catch(function(){});
  }
  // El datalist incluye código Y nombre para que el navegador filtre por ambos.
  // El value es el código (lo que se usa al consultar), el texto muestra el nombre.
  // (El <datalist> se reemplazo por #rep-provdrop, que carga por tandas al
  //  hacer scroll; la lista completa vive en _repProv.)
  cont.innerHTML=''
    +'<div style="font-size:13px;font-weight:500;margin-bottom:6px"><i class="ti ti-package"></i> Reposiciones — Restock por proveedor'
      +((CU&& _deptAcotado())?' <span style="font-size:11px;font-weight:600;color:var(--t-azul);background:var(--pastel-azul);padding:2px 8px;border-radius:8px">'+_deptEmojis()+' Solo '+_deptEtiqueta()+'</span>':'')
    +'</div>'
    +'<div style="font-size:12px;color:var(--text-muted);background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:var(--radius);padding:8px 10px;margin-bottom:12px">'
      +'<i class="ti ti-info-circle" style="font-size:12px"></i> Busca por <b>proveedor</b> (código P2232 o nombre Luoyang…), por <b>referencia del ítem</b> (SKU 2317920 o referencia GF-P1124-1171) o por <b>nombre del producto</b> (ej: tenedor, olla). Al buscar por referencia verás todo el proveedor de ese ítem.'
      +((CU&& _deptAcotado())?' Solo verás productos de <b>'+_deptEtiqueta()+'</b>.':'')
    +'</div>'
    // Atajo a los artículos que urge reponer, sin tener que ir proveedor
    // por proveedor buscandolos.
    +'<div style="margin-bottom:12px">'
      +'<button onclick="_topAbrir()" '
      +'title="Los artículos más vendidos de los últimos 3 años que ya están por debajo de la mitad de la última compra y no tienen nada en camino." '
      +'style="border:1px solid #EA580C;background:#FFF7ED;color:#EA580C;border-radius:20px;'
      +'padding:6px 14px;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap">'
      +'<i class="ti ti-flame"></i> Top selling items</button>'
      +'<span style="font-size:11px;color:var(--text-muted);margin-left:9px">'
      +'Lo que más se vende y se está acabando, ordenado por urgencia</span>'
    +'</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:flex-end;margin-bottom:14px">'
      +'<div style="flex:1;min-width:260px;display:flex;flex-direction:column;gap:3px">'
        +'<label style="font-size:11px;color:var(--text-secondary);font-weight:500">Buscar</label>'
        +'<div style="position:relative">'
          +'<input id="rep-code" class="fi2" autocomplete="off" placeholder="Escribe cualquier texto: proveedor, SKU, referencia o descripción (ej: ba-)" value="'+_esc(_repCard)+'" onkeydown="_repProvTecla(event)" oninput="_repProvFiltrar(this.value)" onfocus="_repProvFoco(this.value)" style="background:var(--surface-2);color:var(--text-primary);width:100%">'
          +'<div id="rep-prov-carga" style="font-size:10.5px;color:var(--t-ambar);margin-top:4px">'
            +(_repProv.length?'':'<span class="ai-ring g" style="width:10px;height:10px;border-width:2px;vertical-align:-1px"></span> Cargando el catálogo de proveedores… puedes escribir mientras tanto')
          +'</div>'
          +'<div id="rep-provdrop" style="display:none;position:absolute;top:calc(100% + 4px);left:0;right:0;z-index:9999;background:var(--surface-2);border:0.5px solid var(--border);border-radius:9px;box-shadow:0 10px 34px rgba(0,0,0,.16);max-height:60vh;min-height:180px;overflow-y:auto;-webkit-overflow-scrolling:touch"></div>'
        +'</div>'
      +'</div>'
      +'<button class="btn bp" onclick="repBuscarUnificado()"><i class="ti ti-search"></i> Buscar</button>'
      +'<button class="btn bg2" onclick="_repToggleAlertas()"><i class="ti ti-bell"></i> Alertas de reposición</button>'
    +'</div>'
    +'<div id="rep-alertas" style="margin-bottom:14px"></div>'
    +'<div id="rep-envios" style="margin-bottom:14px"></div>'
    +'<div id="rep-encurso" style="margin-bottom:14px"></div>'
    +'<div id="rep-result"></div>';
  // Cargar las reposiciones en curso (antes "Pedidos guardados")
  _repCargarEnCurso();
  _repEnviosCargar();
  // Proveedor que quedó pendiente al llegar desde otra pantalla (por ejemplo
  // la ficha del inventario). Se consume AQUÍ, cuando el campo ya existe:
  // esta función es asíncrona y antes el salto se hacía con un tiempo fijo,
  // así que si el catálogo tardaba en cargar el código se perdía.
  if(window._repPrefill){
    var _pf=window._repPrefill; window._repPrefill=null;
    var _in=document.getElementById('rep-code');
    if(_in){
      _in.value=_pf;
      var _d=document.getElementById('rep-provdrop'); if(_d) _d.style.display='none';
      try{ repGenerar(); }catch(e){ console.warn('prefill repGenerar:',e); }
    }
  }
}

// Deduce el departamento de un pedido de reposición a partir de sus items
function _repDeptDePedido(p){
  var items=p&&p.items; if(typeof items==='string'){ try{items=JSON.parse(items);}catch(e){items=[];} }
  if(!Array.isArray(items)||!items.length) return '';
  var cuenta={};
  items.forEach(function(it){ var d=normDept(it.grupo_nom||it.grupo||''); cuenta[d]=(cuenta[d]||0)+1; });
  var best='', bn=-1;
  Object.keys(cuenta).forEach(function(d){ if(cuenta[d]>bn){ bn=cuenta[d]; best=d; } });
  return best;
}
function _repEstadoPedidoBadge(e){
  if(e==='finalizado') return '<span style="font-size:9px;background:var(--pastel-ok);color:var(--t-verde);padding:1px 7px;border-radius:7px;font-weight:600">Enviada a proveedor</span>';
  if(e==='enviado_compras') return '<span style="font-size:9px;background:#dbeafe;color:#1e40af;padding:1px 7px;border-radius:7px;font-weight:600">Enviado a compras</span>';
  return '<span style="font-size:9px;background:var(--pastel-naranja);color:var(--t-ambar);padding:1px 7px;border-radius:7px;font-weight:600">En proceso</span>';
}
// Muestra los pedidos de reposición en curso/guardados como sección dentro de Reposiciones
async function _repCargarEnCurso(){
  var box=document.getElementById('rep-encurso');
  if(!box) return;
  try{
    var filtro=_filtroEquipo('usuario');   // todo el equipo del departamento
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=*'+filtro+'&order=actualizado_en.desc&limit=100',{headers:SBH});
    var peds=r.ok?(await r.json()):[];
    if(!Array.isArray(peds)||!peds.length){ box.innerHTML=''; return; }
    var h='<div style="border:0.5px solid #C4B5FD;border-radius:10px;overflow:hidden">'
      +'<div style="background:var(--pastel-lila);padding:8px 12px;font-size:12px;font-weight:600;color:var(--t-lila2);display:flex;align-items:center;gap:6px"><i class="ti ti-clipboard-list"></i> Reposiciones en curso <span style="font-size:10px;font-weight:400;background:#6D28D9;color:white;padding:1px 7px;border-radius:8px">'+peds.length+'</span></div>'
      +'<div style="max-height:220px;overflow-y:auto">';
    peds.forEach(function(p){
      var fecha=p.actualizado_en?new Date(p.actualizado_en).toLocaleString('es'):'';
      var estBadge=_repEstadoPedidoBadge(p.estado);
      // Departamento de la reposición (según los items del pedido)
      var deptP=_repDeptDePedido(p);
      var deptBadge=deptP?('<span style="font-size:9px;background:var(--pastel-azul);color:var(--t-azul);padding:1px 7px;border-radius:7px;font-weight:600">'+(EMOJIS2[deptP]||'')+' '+_esc(dL(deptP))+'</span>'):'';
      h+='<div style="display:flex;align-items:center;gap:10px;padding:8px 12px;border-top:0.5px solid var(--border)">'
        +'<div style="flex:1;min-width:0">'
          +'<div style="font-size:12px;font-weight:600;display:flex;align-items:center;gap:6px;flex-wrap:wrap">'+_esc(p.cardcode)+(p.cardname?(' — '+_esc(p.cardname)):'')+' '+estBadge+deptBadge+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted);margin-top:1px">'+(p.n_items||0)+' items · '+(p.n_unidades||0)+' und · '+_esc(p.usuario_nom||p.usuario||'?')+' · '+_esc(fecha)+'</div>'
          +(p.enviado_compras_en?('<div style="font-size:9.5px;color:#2563eb;margin-top:1px"><i class="ti ti-send"></i> Enviada a compras: '+new Date(p.enviado_compras_en).toLocaleString('es')+'</div>'):'')
          +(p.terminado_en?('<div style="font-size:9.5px;color:var(--t-verde);margin-top:1px"><i class="ti ti-checks"></i> Enviada a proveedor: '+new Date(p.terminado_en).toLocaleString('es')+'</div>'):'')
        +'</div>'
        +'<button class="btn bp" style="padding:4px 9px;font-size:11px" onclick="repContinuarPedido('+p.id+')"><i class="ti ti-edit"></i> Continuar</button>'
        +'<button class="btn bg2" style="padding:4px 9px;font-size:11px" onclick="repVerPedido('+p.id+')"><i class="ti ti-eye"></i></button>'
        +'<button class="btn bg2" style="padding:4px 9px;font-size:11px;color:var(--text-danger)" onclick="repBorrarPedido('+p.id+')"><i class="ti ti-trash"></i></button>'
      +'</div>';
    });
    h+='</div></div>';
    box.innerHTML=h;
  }catch(e){ box.innerHTML=''; }
}

// ═══════════════════════════════════════════════════════════════════════════
//  ALERTAS DE REPOSICIÓN
//  1) Stock bajo: disponible ≤ 50% de la última llegada (≤ 1.5 años) y SIN orden
//     de compra por llegar  → hay que reponer.
//  2) Separado recién llegado: mercancía que ya está separada y llegó hace poco.
//  3) Alta rotación: vendió ≥ 60% de su última llegada (≤ 1.5 años) y le queda
//     menos del 50% disponible.
//  Click en el ítem → abre el proveedor para pedir. Click en "Sep" → ver quién
//  lo tiene separado (pedido de venta).
// ═══════════════════════════════════════════════════════════════════════════
var _repAlertasVisible=false;
var _repAlertasCache=null;
// Departamento seleccionado para las alertas. Las compradoras quedan fijas a su
// departamento; gerencia puede elegir cualquiera con el selector.
// OJO: esta línea corre al cargar el archivo, cuando todavía no hay nadie
// dentro (CU es null), así que el departamento quedaba SIEMPRE en 'hogar'.
// Gady, que es de alfombras, veía las alertas de hogar y por eso cero.
// Ahora se decide al abrir las alertas, con el usuario ya identificado.
var _repAlertaDept=null;
function _repDeptAlerta(){
  if(_deptAcotado()) return _deptPrimero();
  if(_repAlertaDept) return _repAlertaDept;
  return (DEPTS_ALL && DEPTS_ALL[0]) || 'hogar';
}
// Parseo robusto de fecha (ISO, DD/MM/YYYY, DD/MM/YY)
function _repParseFecha(s){
  if(!s) return null;
  if(s instanceof Date) return isNaN(s)?null:s;
  s=String(s).trim(); if(!s) return null;
  var m=s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})$/);
  if(m){
    var dd=+m[1], mm=+m[2], yy=+m[3]; if(yy<100) yy+=2000;
    // Heurística: si el primer número >12, es día; si no, asumimos DD/MM
    var d=new Date(yy, (mm<=12?mm:dd)-1, (mm<=12?dd:mm));
    return isNaN(d)?null:d;
  }
  var d2=new Date(s); return isNaN(d2)?null:d2;
}
// Meses entre una fecha y hoy
function _repMesesDesde(fecha){
  if(!fecha) return Infinity;
  return (Date.now()-fecha.getTime())/(1000*60*60*24*30.44);
}
// Detecta un campo de rotación si existe en la fila (nombres comunes)
function _repRotacionVal(row){
  var claves=['rotacion','rotation','rot','ventas12m','vendido12m','venta12m','salidas12m','consumo','consumomensual','venta_mensual','ventamensual','ventas_ano','ventasanuales'];
  for(var i=0;i<claves.length;i++){ if(row[claves[i]]!=null && row[claves[i]]!==''){ var n=Number(row[claves[i]]); if(!isNaN(n)) return n; } }
  return null;
}
function _repToggleAlertas(){
  var box=document.getElementById('rep-alertas'); if(!box) return;
  _repAlertasVisible=!_repAlertasVisible;
  var enc=document.getElementById('rep-encurso');
  if(!_repAlertasVisible){
    box.innerHTML='';
    if(enc) enc.style.display='';   // volver a mostrar las reposiciones en curso
    return;
  }
  if(enc) enc.style.display='none'; // ocultar reposiciones en curso mientras se ven alertas
  // El caché guarda de qué departamento es. Si se cambia de departamento —o
  // si lo guardado quedó vacío por un fallo—, se vuelve a calcular en vez de
  // repintar un cero que no significa nada.
  if(_repAlertasCache && _repAlertasCache.dept===_repDeptAlerta()
     && (_repAlertasCache.total||0)>0){
    _repRenderAlertas(_repAlertasCache); return;
  }
  _repCargarAlertas();
}
var _repAlertasCargando=false;
async function _repCargarAlertas(force){
  var box=document.getElementById('rep-alertas'); if(!box) return;
  if(_repAlertasCargando) return;   // evitar cargas concurrentes
  _repAlertasCargando=true;
  box.innerHTML='<div class="empty" style="padding:18px"><i class="ti ti-loader-2 spin"></i><br>Analizando inventario para detectar alertas…</div>';
  try{
    // Asegurar datos de pedidos No SAP (para excluir items ya pedidos)
    if(typeof cargarPendSAP==='function' && (!window._pendSAP)){ try{ await cargarPendSAP(); }catch(e){} }
    // Departamento (compradora: su depto; gerencia: el elegido en el selector)
    var deptSel=_repDeptAlerta();
    // Pista para filtrar el grupo en el servidor y reducir datos (normDept confirma después)
    var hint={hogar:'hogar',ropa:'ropa',muebles:'mueble',alfombras:'alfombra',campamento:'campamento',electronica:'electr',ferreteria:'ferret',otros:'art'}[deptSel];
    var deptFilter=hint?('&grupo=ilike.*'+encodeURIComponent(hint)+'*'):'';
    var campos='itemcode,itemname,cardcode,nombre_proveedor,grupo,onhand,iscommited,onorder,'
      +'prox_llegada,ultima_llegada,ordenes_abiertas,fob,cif,precioventa,'
      +'u_cant_ult_ent,hist_comprado,fechaentrada,picturname,unidadesbulto,salpackun';
    // Paginar (el servidor limita ~1000 por página) hasta traer TODO el departamento
    var pageSize=1000, offset=0, maxPages=40, rows=[];
    for(var pg=0; pg<maxPages; pg++){
      // El filtro pedía onhand>0 o comprometido>0, o sea que solo miraba
      // artículos que TODAVÍA tienen algo. Justo los agotados —los más
      // urgentes de reponer— quedaban fuera, y por eso las tres alertas
      // salían en cero. Ahora se piden los que tienen una compra anterior,
      // que es lo que las tres reglas necesitan de verdad.
      var url=SB+'/rest/v1/inventario?select='+campos+'&cardcode=not.is.null'
        +'&u_cant_ult_ent=gt.0'+deptFilter+'&order=itemcode&limit='+pageSize+'&offset='+offset;
      var chunk=[];
      try{
        var r=await fetch(url,{headers:SBH});
        if(!r.ok){
          // Antes se cortaba en silencio y la pantalla decía "sin alertas",
          // que es indistinguible de "no hay nada que reponer".
          var _t=''; try{ _t=await r.text(); }catch(e){}
          console.error('[alertas] inventario '+r.status+': '+_t.slice(0,300));
          try{ showT('No se pudo leer el inventario ('+r.status+'). Mira la consola.'); }catch(e){}
          break;
        }
        chunk=await r.json();
        if(pg===0) console.log('[alertas] '+deptSel+': primera tanda '+((chunk||[]).length)+' artículo(s)');
      }catch(ferr){ console.warn('alertas fetch page '+pg, ferr); break; }
      if(!Array.isArray(chunk)||!chunk.length) break;
      for(var ci=0; ci<chunk.length; ci++){ if(normDept(chunk[ci].grupo)===deptSel) rows.push(chunk[ci]); }
      offset+=pageSize;
      if(chunk.length<pageSize) break;
    }
    var A=[], B=[], C=[];   // A=reponer, B=separado recién llegado, C=alta rotación
    // Cuenta por qué se descarta cada uno. Sin esto, "sin alertas" puede
    // significar cosas muy distintas y no hay forma de saber cuál.
    var _dx={total:0, yaEnNoSap:0, sinUltCompra:0, sinFecha:0, masDe18Meses:0,
             conOrden:0, quedaMasDel50:0};
    rows.forEach(function(x){
      _dx.total++;
      // Excluir si ese item YA tiene reposición en un pedido No SAP
      if(_repEnOrdenesNoSAP(x.itemcode).length){ _dx.yaEnNoSap++; return; }
      var onhand=Number(x.onhand)||0, sep=Number(x.iscommited)||0, onorder=Number(x.onorder)||0;
      var ult=Number(x.u_cant_ult_ent)||0;
      var disp=onhand-sep;
      var fecha=_repParseFecha(x.fechaentrada);
      var meses=_repMesesDesde(fecha);
      var reciente18=(fecha && meses<=18);
      var recienLlego=(fecha && meses<=1.2);      // ~ últimos ~35 días
      var it={
        itemcode:x.itemcode, itemname:x.itemname, cardcode:x.cardcode,
        nombre_proveedor:x.nombre_proveedor||'', grupo:x.grupo||'',
        onhand:onhand, iscommited:sep, onorder:onorder, disp:disp,
        u_cant_ult_ent:ult, fechaentrada:x.fechaentrada, picturname:x.picturname||'',
        unidadesbulto:Number(x.unidadesbulto)||Number(x.salpackun)||0,
        // Costos y fecha de llegada, para verlos también en el tablero
        fob:Number(x.fob)||0, cif:Number(x.cif)||0, precio1:Number(x.precioventa)||0,
        prox_llegada:x.prox_llegada||'', ultima_llegada:x.ultima_llegada||'',
        ordenes_abiertas:Number(x.ordenes_abiertas)||0
      };
      // 1) Reponer: disponible ≤ 50% de última llegada, ≤1.5 años, sin OC por llegar
      if(reciente18 && ult>0 && onorder<=0 && disp<=0.5*ult){
        it._motivo='Disponible '+_fmtN2(disp)+' (≤50% de última llegada '+_fmtN2(ult)+') y sin orden por llegar';
        A.push(it);
      } else {
        if(!ult) _dx.sinUltCompra++;
        else if(!fecha) _dx.sinFecha++;
        else if(!reciente18) _dx.masDe18Meses++;
        else if(onorder>0) _dx.conOrden++;
        else if(disp>0.5*ult) _dx.quedaMasDel50++;
      }
      // 2) Separado y recién llegado
      if(recienLlego && sep>0){
        it._motivoB='Separado '+_fmtN2(sep)+' und y llegó hace '+Math.round(meses*30)+' días';
        B.push(it);
      }
      // 3) Alta rotación con <50% disponible
      var rotVal=_repRotacionVal(x);
      var sellThrough=(ult>0)?((ult-disp)/ult):0;
      var altaRot=(rotVal!=null)?(rotVal>0 && sellThrough>=0.5):(reciente18 && sellThrough>=0.6);
      if(altaRot && ult>0 && disp<0.5*ult){
        it._motivoC='Alta rotación: vendió '+Math.round(sellThrough*100)+'% de su última llegada; quedan '+_fmtN2(disp)+' disponibles';
        C.push(it);
      }
    });
    // Ordenar cada lista por urgencia (menor disponible primero)
    var byDisp=function(a,b){return a.disp-b.disp;};
    A.sort(byDisp); B.sort(function(a,b){return b.iscommited-a.iscommited;}); C.sort(byDisp);
    console.log('[alertas] '+deptSel+': de '+_dx.total+' artículo(s) → A='+A.length
      +' B='+B.length+' C='+C.length);
    console.log('[alertas] descartes: ya en orden NO SAP '+_dx.yaEnNoSap
      +' · sin última compra '+_dx.sinUltCompra
      +' · sin fecha de entrada '+_dx.sinFecha
      +' · entrada de hace más de 18 meses '+_dx.masDe18Meses
      +' · con orden en camino '+_dx.conOrden
      +' · les queda más del 50% '+_dx.quedaMasDel50);
    _repAlertasCache={A:A, B:B, C:C, total:rows.length, dept:deptSel};
    _repRenderAlertas(_repAlertasCache);
  }catch(e){
    console.error('alertas reposicion:', e);
    if(box) box.innerHTML='<div class="empty" style="padding:18px;color:var(--text-danger)">Error al cargar alertas: '+(e.message||e)+'</div>';
  }finally{
    _repAlertasCargando=false;
  }
}
// Cambia el departamento de las alertas (diferido para no destruir el <select> en pleno evento)
function _repSelDeptAlerta(v){
  try{
    _repAlertaDept=v;
    _repAlertasCache=null;
    setTimeout(function(){ try{ _repCargarAlertas(); }catch(e){ console.error(e); } }, 0);
  }catch(e){ console.error('cambiar dept alerta:', e); }
}
function _repRenderAlertas(data){
  var box=document.getElementById('rep-alertas'); if(!box) return;
  var grupos=[
    {key:'A', titulo:'Reponer — stock bajo sin orden', icono:'ti-alert-triangle', color:'#B45309', bg:'#FEF3E8', bd:'#f5c9a0', motivo:'_motivo', items:data.A},
    {key:'B', titulo:'Separado recién llegado', icono:'ti-package-import', color:'#0c447c', bg:'#e6f1fb', bd:'#a9cdf0', motivo:'_motivoB', items:data.B},
    {key:'C', titulo:'Alta rotación — queda menos del 50%', icono:'ti-flame', color:'#9D174D', bg:'#FBEAF0', bd:'#f0b6cd', motivo:'_motivoC', items:data.C}
  ];
  // Selector de departamento (gerencia elige; compradora ve fijo el suyo)
  var deptActual=_repDeptAlerta();
  var deptCtrl;
  if(CU&& _deptAcotado()){
    deptCtrl='<span style="font-size:11px;font-weight:600;background:var(--surface-2);border:0.5px solid #C4B5FD;color:var(--t-lila2);padding:3px 9px;border-radius:8px">'+_deptEmojis()+' '+_esc(_deptEtiqueta())+'</span>';
  } else {
    deptCtrl='<select onchange="_repSelDeptAlerta(this.value)" style="font-size:11px;font-weight:600;padding:3px 8px;border:0.5px solid #C4B5FD;border-radius:8px;background:var(--surface-2);color:var(--t-lila2);cursor:pointer">'
      +_deptsVisibles().map(function(d){ return '<option value="'+d+'"'+(d===deptActual?' selected':'')+'>'+(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</option>'; }).join('')
      +'</select>';
  }
  var h='<div style="border:0.5px solid #C4B5FD;border-radius:10px;overflow:hidden">'
    +'<div style="background:var(--pastel-lila);padding:9px 12px;font-size:12px;font-weight:700;color:var(--t-lila2);display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<i class="ti ti-bell"></i> Alertas de reposición'
      +'<span style="font-size:10px;font-weight:400;background:#6D28D9;color:#fff;padding:1px 7px;border-radius:8px">'+(data.A.length+data.B.length+data.C.length)+'</span>'
      +'<span style="font-size:11px;font-weight:500;color:var(--t-lila2)">Departamento:</span>'+deptCtrl
      +'<button class="btn bg2" style="margin-left:auto;padding:3px 9px;font-size:11px" onclick="_repAlertasCache=null;_repCargarAlertas()"><i class="ti ti-refresh"></i> Actualizar</button>'
      +'<button class="btn bg2" style="padding:3px 9px;font-size:11px" onclick="_repToggleAlertas()"><i class="ti ti-x"></i></button>'
    +'</div>';
  grupos.forEach(function(g){
    h+='<div style="border-top:0.5px solid var(--border)">'
      +'<div style="background:'+g.bg+';border-bottom:0.5px solid '+g.bd+';padding:7px 12px;font-size:12px;font-weight:600;color:'+g.color+';display:flex;align-items:center;gap:7px"><i class="ti '+g.icono+'"></i> '+g.titulo+' <span style="font-size:10px;font-weight:700;background:'+g.color+';color:#fff;padding:1px 7px;border-radius:8px">'+g.items.length+'</span></div>';
    if(!g.items.length){
      h+='<div style="padding:10px 14px;font-size:11px;color:var(--text-muted)">Sin alertas de este tipo.</div>';
    } else {
      // Contenedor con scroll infinito (se van agregando items al hacer scroll)
      h+='<div class="rep-alert-scroll" id="rep-alert-list-'+g.key+'" data-g="'+g.key+'" data-n="0" style="max-height:60vh;overflow-y:auto"></div>';
    }
    h+='</div>';
  });
  h+='</div>';
  box.innerHTML=h;
  // Poblar cada grupo con el primer lote y enganchar el scroll infinito
  grupos.forEach(function(g){
    if(!g.items.length) return;
    var el=document.getElementById('rep-alert-list-'+g.key);
    if(!el) return;
    _repAlertMore(g.key);
    el.onscroll=function(){
      if(el.scrollTop+el.clientHeight >= el.scrollHeight-100) _repAlertMore(g.key);
    };
  });
}
// Agrega el siguiente lote de items al grupo (scroll infinito)
function _repAlertMore(key){
  var el=document.getElementById('rep-alert-list-'+key); if(!el) return;
  if(!_repAlertasCache) return;
  var arr=_repAlertasCache[key]||[];
  var motivoKey={A:'_motivo',B:'_motivoB',C:'_motivoC'}[key];
  // Cargar lotes hasta llenar el contenedor visible (o agotar la lista). Iterativo,
  // con tope de seguridad para no bloquear el hilo.
  var vueltas=0;
  do{
    var n=Number(el.getAttribute('data-n'))||0;
    if(n>=arr.length) break;
    var batch=arr.slice(n, n+40);
    var frag=batch.map(function(x){ return _repAlertaItemHTML(x, x[motivoKey]||''); }).join('');
    el.insertAdjacentHTML('beforeend', frag);
    el.setAttribute('data-n', n+batch.length);
    vueltas++;
  } while(el.scrollHeight<=el.clientHeight && vueltas<8 && (Number(el.getAttribute('data-n'))||0)<arr.length);
}
function _repAlertaItemHTML(x, motivo){
  var ic=_esc(String(x.itemcode));
  var foto=_repFotoUrl(x.picturname);
  var bulto=Math.max(1, Number(x.unidadesbulto)||1);
  var fechaLleg=x.fechaentrada?_esc(String(x.fechaentrada)):'';
  return '<div style="display:flex;align-items:center;gap:10px;padding:8px 12px;border-top:0.5px solid var(--border)">'
    +'<div style="width:46px;height:46px;flex-shrink:0;border:0.5px solid var(--border);border-radius:6px;overflow:hidden;background:var(--surface-2);display:flex;align-items:center;justify-content:center'+(foto?';cursor:zoom-in':'')+'"'+(foto?' onclick="_repZoomFoto(\''+encodeURIComponent(foto)+'\',\''+ic+'\')" onmouseenter="_repHoverShow(event,\''+encodeURIComponent(foto)+'\')" onmousemove="_repHoverMove(event)" onmouseleave="_repHoverHide()"':'')+'>'
      +(foto?'<img src="'+foto+'" style="width:100%;height:100%;object-fit:cover" onerror="this.style.display=\'none\';this.parentNode.innerHTML=\'<i class=&quot;ti ti-photo-off&quot; style=&quot;color:var(--text-muted)&quot;></i>\'">':'<i class="ti ti-photo-off" style="color:var(--text-muted)"></i>')
    +'</div>'
    +'<div style="flex:1;min-width:0">'
      +'<div style="font-size:12.5px;font-weight:600"><span onclick="repBuscarPorItem(\''+ic+'\')" title="Abrir el proveedor para hacer pedido" style="color:var(--text-accent);cursor:pointer;text-decoration:underline">'+ic+'</span> <span style="font-weight:400;color:var(--text-secondary)">'+_esc(x.itemname||'')+'</span></div>'
      +'<div style="display:flex;gap:6px 14px;flex-wrap:wrap;font-size:11.5px;color:var(--text-secondary);margin-top:3px">'
        +'<span>Stock: <b>'+_fmtN2(x.onhand)+'</b></span>'
        +'<span onclick="verSeparado(\''+ic+'\')" title="Ver quién lo tiene separado (pedido de venta)" style="cursor:pointer">Sep: <b style="color:var(--t-rojo2);text-decoration:underline">'+_fmtN2(x.iscommited)+'</b></span>'
        +(function(){
            var _ub=Math.max(1, Number(x.u_cxblt)||Number(x.unidadesbulto)||Number(x.salpackun)||1);
            var _d=Number(x.disp)||0;
            return '<span>Disp: <b style="color:var(--text-success)">'+_fmtN2(_d)+'</b>'
              +(_ub>1?(' <span style="color:var(--t-lila2);font-size:11.5px">(bultos: <b>'
                +_fmtN2(Math.floor(_d/_ub))
                +((_d%_ub)?('<span style="font-weight:400"> + '+_fmtN2(_d%_ub)+' pz</span>'):'')
                +'</b>)</span>'):'')
              +'</span>';
          })()
        +'<span>Por lleg: <b style="color:#C9A800">'+_fmtN2(x.onorder)+'</b>'
          +((Number(x.onorder)>0 && _invLlegadaTxt(x))
            ? (' <span style="font-size:10.5px;color:'+_invLlegadaColor(x)+'">('+_esc(_invLlegadaTxt(x))+')</span>')
            : '')
          +'</span>'
        +'<span>Últ. llegada: <b>'+_fmtN2(x.u_cant_ult_ent)+'</b></span>'
        +(fechaLleg?'<span>Fecha llegada: <b>'+fechaLleg+'</b></span>':'')
      +'</div>'
      +(motivo?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px"><i class="ti ti-info-circle" style="font-size:11px"></i> '+_esc(motivo)+'</div>'):'')
    +'</div>'
    +'<button class="btn bp" style="padding:5px 10px;font-size:11px;flex-shrink:0" onclick="repBuscarPorItem(\''+ic+'\')"><i class="ti ti-shopping-cart"></i> Pedir</button>'
  +'</div>';
}
async function repBuscarUnificado(){
  var q=(document.getElementById('rep-code').value||'').trim();
  if(!q){ showT('Escribe algo para buscar'); return; }

  // 1) ¿Es una opción del datalist "CODIGO — nombre (N items)"? -> proveedor directo
  if(q.indexOf(' — ')>=0){ return repGenerar(); }

  // 2) ¿Coincide exactamente con un código de proveedor del catálogo? -> proveedor
  var up=q.toUpperCase();
  var esProv=(_repProv||[]).some(function(p){ return (p.cardcode||'').toUpperCase()===up; });
  if(esProv){ return repGenerar(); }

  // 3) Coincide EXACTO con una referencia de ítem (itemcode o suppcatnum) -> su proveedor
  try{
    var enc=encodeURIComponent(q);
    var r1=await fetch(SB+'/rest/v1/inventario?itemcode=ilike.'+enc+'&select=itemcode&limit=1',{headers:SBH});
    var d1=r1.ok?(await r1.json()):[];
    if(Array.isArray(d1)&&d1.length){ return repBuscarPorItemDirecto(d1[0].itemcode||q); }
    var r2=await fetch(SB+'/rest/v1/inventario?suppcatnum=ilike.'+enc+'&select=itemcode&limit=1',{headers:SBH});
    var d2=r2.ok?(await r2.json()):[];
    if(Array.isArray(d2)&&d2.length){ return repBuscarPorItemDirecto(d2[0].itemcode||q); }
  }catch(e){}

  // 4) Búsqueda AMPLIA: cualquier proveedor o ítem que CONTENGA el texto
  //    (código o nombre de proveedor, SKU, referencia o descripción).
  return repBuscarPorNombreDirecto(q);
}
// Alias que pasan el valor directo (el buscador unificado ya no tiene campos separados)
function repBuscarPorItemDirecto(v){ return repBuscarPorItem(v); }
function repBuscarPorNombreDirecto(v){ return repBuscarPorNombre(v); }

// Busca el proveedor a partir de una referencia (itemcode) y carga su reporte
async function repBuscarPorItem(itemArg){
  var item=(itemArg!=null?String(itemArg):(document.getElementById('rep-item')?document.getElementById('rep-item').value:'')||'').trim();
  if(!item){ showT('Ingresa el código de un producto'); return; }
  var res=document.getElementById('rep-result');
  res.innerHTML='<div class="empty"><i class="ti ti-loader-2 spin"></i><br>Buscando el proveedor de '+_esc(item)+'...</div>';
  try{
    var r=await fetch(SB+'/rest/v1/inventario?itemcode=eq.'+encodeURIComponent(item)+'&select=itemcode,itemname,cardcode,nombre_proveedor,grupo&limit=1',{headers:SBH});
    var d=r.ok?(await r.json()):[];
    var row=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!row){ res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-search-off" style="font-size:22px;color:var(--text-muted)"></i><br>No se encontró el producto <b>'+_esc(item)+'</b> en el inventario.</div>'; return; }
    // Control de acceso: verificar que el producto sea del departamento del usuario
    if(CU && _deptAcotado() && !_deptPermitido(normDept(row.grupo))){
      res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-lock" style="font-size:22px;color:var(--text-warning)"></i><br>El producto <b>'+_esc(item)+'</b> pertenece a otro departamento.<br><span style="font-size:11px;color:var(--text-muted)">Solo puedes ver reposiciones de '+_deptEtiqueta()+'.</span></div>';
      return;
    }
    if(!row.cardcode){ res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-alert-triangle" style="font-size:22px;color:var(--text-warning)"></i><br>El producto <b>'+_esc(item)+'</b> ('+_esc(row.itemname||'')+') no tiene proveedor asignado.</div>'; return; }
    // Cargar el reporte del proveedor de ese producto
    document.getElementById('rep-code').value=row.cardcode;
    showT('Proveedor: '+row.cardcode+(row.nombre_proveedor?(' — '+row.nombre_proveedor):''));
    await repGenerar();
    // Resaltar visualmente el item buscado
    setTimeout(function(){
      var el=document.querySelector('.rep-item-row[data-ic="'+item.replace(/"/g,'')+'"]');
      if(el){ el.scrollIntoView({behavior:'smooth',block:'center'}); el.style.outline='2px solid var(--text-accent)'; setTimeout(function(){el.style.outline='';},2500); }
    },400);
  }catch(e){ res.innerHTML='<div class="empty">Error al buscar. Revisa tu conexión.</div>'; }
}

var _repSearchProvs=[];
// Busca (contiene) en proveedores e ítems con SCROLL INFINITO (sin límite fijo).
async function repBuscarPorNombre(qArg){
  var q=(qArg!=null?String(qArg):(document.getElementById('rep-prodname')?document.getElementById('rep-prodname').value:'')||'').trim();
  if(!q){ showT('Escribe algo para buscar'); return; }
  if(q.length<2){ showT('Escribe al menos 2 caracteres'); return; }
  var res=document.getElementById('rep-result');
  res.innerHTML='<div class="empty"><i class="ti ti-loader-2 spin"></i><br>Buscando "'+_esc(q)+'" en proveedores e ítems...</div>';
  try{
    var qs=q.replace(/[(),"*%\\]/g,' ').replace(/\s+/g,' ').trim();
    var pat='*'+qs+'*';
    var cols=['itemname','itemcode','suppcatnum','nombre_proveedor','cardcode'];
    var orExpr='or=('+cols.map(function(c){return c+'.ilike.'+pat;}).join(',')+')';
    var base=SB+'/rest/v1/inventario?'+orExpr+'&cardcode=not.is.null&select=itemcode,itemname,cardcode,nombre_proveedor,picturname,grupo,suppcatnum&order=cardcode';
    // Paginar sin límite artificial hasta traer TODO
    var pageSize=1000, offset=0, maxPages=60, rows=[];
    for(var pg=0; pg<maxPages; pg++){
      var url=(base+'&limit='+pageSize+'&offset='+offset).replace(/ /g,'%20');
      var chunk=[];
      try{ var r=await fetch(url,{headers:SBH}); if(!r.ok) break; chunk=await r.json(); }catch(e){ break; }
      if(!Array.isArray(chunk)||!chunk.length) break;
      for(var i=0;i<chunk.length;i++){ if(!CU||!_deptAcotado()||_deptPermitido(normDept(chunk[i].grupo))) rows.push(chunk[i]); }
      offset+=pageSize;
      if(chunk.length<pageSize) break;
    }
    if(!rows.length){
      res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-search-off" style="font-size:22px;color:var(--text-muted)"></i><br>No se encontró ningún proveedor ni ítem que contenga "<b>'+_esc(q)+'</b>"'+((CU&& _deptAcotado())?(' en '+_deptEtiqueta()):'')+'.</div>';
      return;
    }
    var porProv={};
    rows.forEach(function(x){ var cc=(x.cardcode||'').trim(); if(!cc)return; if(!porProv[cc])porProv[cc]={cardcode:cc, cardname:x.nombre_proveedor||'', items:[]}; porProv[cc].items.push(x); });
    _repSearchProvs=Object.values(porProv).sort(function(a,b){return b.items.length-a.items.length;});
    var h='<div style="font-size:12px;color:var(--text-muted);margin-bottom:10px">'+rows.length+' coincidencia(s) con "<b>'+_esc(q)+'</b>" en '+_repSearchProvs.length+' proveedor(es). Haz clic en un proveedor para ver su reposición completa.</div>'
      +'<div id="rep-search-scroll" data-n="0" style="max-height:68vh;overflow-y:auto;padding-right:4px"></div>';
    res.innerHTML=h;
    var sc=document.getElementById('rep-search-scroll');
    _repSearchMore();
    if(sc) sc.onscroll=function(){ if(sc.scrollTop+sc.clientHeight>=sc.scrollHeight-120) _repSearchMore(); };
  }catch(e){ res.innerHTML='<div class="empty">Error al buscar. Revisa tu conexión.</div>'; }
}
function _repSearchGrupoHTML(p){
  var h='<div style="border:0.5px solid var(--border);border-radius:10px;margin-bottom:12px;overflow:hidden">'
    +'<div onclick="_repProvElegido(\''+_esc(p.cardcode)+'\')" style="background:var(--surface-2);padding:9px 12px;cursor:pointer;display:flex;align-items:center;gap:8px;border-bottom:0.5px solid var(--border)">'
      +'<i class="ti ti-building-store" style="color:var(--text-accent)"></i>'
      +'<span style="font-size:13px;font-weight:700;color:var(--text-accent)">'+_esc(p.cardcode)+'</span>'
      +(p.cardname?'<span style="font-size:12px;color:var(--text-secondary)">'+_esc(p.cardname)+'</span>':'')
      +'<span style="margin-left:auto;font-size:11px;color:var(--text-muted)">'+p.items.length+' coincidencia(s) · ver todo <i class="ti ti-chevron-right"></i></span>'
    +'</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;padding:10px 12px">';
  p.items.slice(0,8).forEach(function(x){
    var foto=_repFotoUrl(x.picturname);
    h+='<div style="width:92px;text-align:center" title="'+_esc(x.itemname||'')+'">'
      +'<div style="width:92px;height:92px;border:0.5px solid var(--border);border-radius:8px;overflow:hidden;background:var(--surface-2);display:flex;align-items:center;justify-content:center'+(foto?';cursor:zoom-in':'')+'"'+(foto?' onclick="event.stopPropagation();_repZoomFoto(\''+encodeURIComponent(foto)+'\',\''+_esc(String(x.itemcode))+'\')"':'')+'>'
        +(foto?'<img src="'+foto+'" style="width:100%;height:100%;object-fit:cover" onerror="this.style.display=\'none\';this.parentNode.innerHTML=\'<i class=&quot;ti ti-photo-off&quot; style=&quot;color:var(--text-muted)&quot;></i>\'">':'<i class="ti ti-photo-off" style="color:var(--text-muted)"></i>')
      +'</div>'
      +'<div style="font-size:9px;font-weight:600;margin-top:3px">'+_esc(x.itemcode)+'</div>'
      +'<div style="font-size:9px;color:var(--text-muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(x.itemname||'')+'</div>'
    +'</div>';
  });
  if(p.items.length>8) h+='<div style="align-self:center;font-size:11px;color:var(--text-muted)">+'+(p.items.length-8)+' más</div>';
  h+='</div></div>';
  return h;
}
function _repSearchMore(){
  var sc=document.getElementById('rep-search-scroll'); if(!sc) return;
  var n=Number(sc.getAttribute('data-n'))||0;
  var vueltas=0;
  do{
    if(n>=_repSearchProvs.length) break;
    var batch=_repSearchProvs.slice(n, n+15);
    sc.insertAdjacentHTML('beforeend', batch.map(function(p){return _repSearchGrupoHTML(p);}).join(''));
    n+=batch.length; sc.setAttribute('data-n', n);
    vueltas++;
  } while(sc.scrollHeight<=sc.clientHeight && vueltas<6 && n<_repSearchProvs.length);
}
// - "P2232 — LUOYANG... (18 items)" (opción del datalist) -> P2232
// - "luoyang" (nombre parcial) -> busca en el catálogo por nombre
function _repResolverCodigo(entrada){
  var t=(entrada||'').trim();
  if(!t) return '';
  // Caso datalist: "CODIGO — nombre (N items)" -> tomar lo antes del " — "
  if(t.indexOf(' — ')>=0){ return t.split(' — ')[0].trim().toUpperCase(); }
  // Caso código exacto: si coincide con algún cardcode del catálogo
  var up=t.toUpperCase();
  var exacto=(_repProv||[]).find(function(p){ return (p.cardcode||'').toUpperCase()===up; });
  if(exacto) return exacto.cardcode;
  // Caso nombre parcial: buscar en los nombres de proveedor
  var low=t.toLowerCase();
  var porNombre=(_repProv||[]).filter(function(p){ return (p.cardname||'').toLowerCase().indexOf(low)>=0; });
  if(porNombre.length===1) return porNombre[0].cardcode;
  if(porNombre.length>1){
    // Varios coinciden: mostrar opciones para elegir
    var res=document.getElementById('rep-result');
    if(res){
      // Lista completa con scroll infinito: antes se cortaba en 15 y el resto
      // no había forma de verlo.
      window._repCoinc=porNombre; window._repCoincVistos=0;
      res.innerHTML='<div style="padding:14px;border:0.5px solid var(--border);border-radius:10px">'
        +'<div style="font-size:12px;font-weight:600;margin-bottom:8px">'+porNombre.length+' proveedores coinciden con "'+_esc(t)+'":</div>'
        +'<div id="rep-coinc" style="max-height:340px;overflow-y:auto;-webkit-overflow-scrolling:touch"></div>'
        +'</div>';
      _repCoincMas();
      var _cd=document.getElementById('rep-coinc');
      if(_cd) _cd.onscroll=function(){
        if(_cd.scrollTop+_cd.clientHeight >= _cd.scrollHeight-70) _repCoincMas();
      };
    }
    return '';  // que el usuario elija
  }
  // Si no coincide con nada del catálogo, asumir que escribió un código directo
  return up;
}

// Muestra los proveedores coincidentes por tandas, con scroll infinito
function _repCoincMas(){
  var d=document.getElementById('rep-coinc'); if(!d) return;
  var todos=window._repCoinc||[];
  var desde=window._repCoincVistos||0;
  if(desde>=todos.length) return;
  var hasta=Math.min(desde+40, todos.length);
  var h='';
  for(var i=desde;i<hasta;i++){
    var p=todos[i];
    h+='<div onclick="_repProvElegido(\''+_esc(p.cardcode)+'\')"'
      +' style="cursor:pointer;padding:6px 8px;border-bottom:0.5px solid var(--border);font-size:12px">'
      +'<b style="color:var(--text-accent)">'+_esc(p.cardcode)+'</b> — '+_esc(p.cardname||'')
      +' <span style="color:var(--text-muted)">('+(p.n_items||0)+' items)</span></div>';
  }
  var viejo=document.getElementById('rep-coincmas'); if(viejo) viejo.remove();
  d.insertAdjacentHTML('beforeend', h);
  window._repCoincVistos=hasta;
  if(hasta<todos.length){
    d.insertAdjacentHTML('beforeend','<div id="rep-coincmas" style="padding:7px 8px;font-size:11px;color:var(--text-muted);text-align:center">Baja para ver más… ('+hasta+' de '+todos.length+')</div>');
    if(d.scrollHeight<=d.clientHeight+8) setTimeout(_repCoincMas,0);
  }
}

async function repGenerar(){
  // Se cierra el desplegable pase lo que pase. Elegir un proveedor siempre
  // termina llamando aquí, así que este es el único lugar donde hace falta
  // acordarse, en vez de en cada sitio desde donde se puede elegir.
  try{ _repProvCerrar(); }catch(e){}
  try{
    var _d=document.getElementById('rep-provdrop'); if(_d) _d.style.display='none';
    var _i=document.getElementById('rep-code'); if(_i) _i.blur();
    window._repProvRecien=Date.now();
  }catch(e){}
  var entrada=(document.getElementById('rep-code').value||'').trim();
  if(!entrada){ showT('Ingresa el código o nombre del proveedor'); return; }
  // El usuario pudo escribir/seleccionar "P2232 — LUOYANG... (18 items)" del datalist,
  // o solo "P2232", o incluso un nombre. Resolvemos el código real:
  var code=_repResolverCodigo(entrada);
  if(!code){ showT('No se encontró ese proveedor. Prueba con el código exacto.'); return; }
  document.getElementById('rep-code').value=code;
  // Si se cambia de proveedor manualmente (no viene de "continuar"), reiniciar carrito y pedido
  if(code!==_repCard){ _repCarrito={}; _repPedidoId=null; }
  _repCard=code;
  var res=document.getElementById('rep-result');
  res.innerHTML='<div class="empty"><i class="ti ti-loader-2 spin"></i><br>Consultando '+_esc(code)+'...</div>';
  try{
    // Leer directo del inventario del portal, filtrando por proveedor (cardcode).
    // Se ordena solo por itemcode (siempre presente); el agrupado por grupo se hace en el cliente.
    var r=await fetch(SB+'/rest/v1/inventario?cardcode=eq.'+encodeURIComponent(code)+'&select=*&order=itemcode&limit=100000',{headers:SBH});
    var raw=r.ok?(await r.json()):[];
    // Normalizar los nombres de campos de 'inventario' al formato que usa el reporte
    var rows=raw.map(function(x){
      return {
        cardcode:      x.cardcode,
        cardname:      x.nombre_proveedor||'',
        marca:         x.marca||'',
        itemcode:      x.itemcode,
        itemname:      x.itemname,
        grupo_cod:     x.grupo_cod||'',
        grupo_nom:     x.grupo||'',
        salunitmsr:    x.salunitmsr||'',
        salpackun:     Number(x.salpackun)||0,
        u_bulunie:     '',
        u_cxblt:       Number(x.unidadesbulto)||0,
        onhand:        Number(x.onhand)||0,
        iscommited:    Number(x.iscommited)||0,
        onorder:       Number(x.onorder)||0,
        // Cuándo llega lo que está por llegar
        prox_llegada:     x.prox_llegada||'',
        ultima_llegada:   x.ultima_llegada||'',
        ordenes_abiertas: Number(x.ordenes_abiertas)||0,
        fob:           Number(x.fob)||0,
        cif:           Number(x.cif)||0,
        precio1:       Number(x.precioventa)||0,
        kilos:         Number(x.peso)||0,
        picturname:    x.picturname||'',
        cant_comprada: 0,
        total_fob:     0,
        total_cif:     0,
        u_fentrada:    x.fechaentrada||'',
        u_nentrada:    x.u_nentrada||'',
        u_cant_ult_ent:Number(x.u_cant_ult_ent)||0,
        hist_comprado: Number(x.hist_comprado)||0,   // total comprado histórico
        suppcatnum:    x.suppcatnum||'',
        u_color:       x.u_color||'',
        u_tamano:      x.u_tamano||'',
        // Descripción en INGLÉS (Foreign Name de SAP) para el PDF/Excel de reposición
        frgnname:      x.frgnname||x.foreign_name||x.foreignname||'',
        // Campo definido por usuario "Colores" (según cómo lo haya sincronizado el ETL)
        colores:       x.u_colores||x.colores||x.u_colors||x.u_color||'',
        // Ficha técnica y datos que usa el detalle del producto
        caracteristicas: x.caracteristicas||null,
        codebars:      x.codebars||'',
        usertext:      x.usertext||'',
        marca:         x.marca||'',
        peso:          x.peso||0,
        volumen:       x.volumen||0,
        unidadesbulto: x.unidadesbulto||0,
        precioventa:   Number(x.precioventa)||0,
        lastpurprc:    Number(x.lastpurprc)||0,
        disponible:    x.disponible,
        subg:          x.subg||''
      };
    });
    // ── Control de acceso por departamento ──
    // Si el usuario tiene un departamento asignado (compradora), solo ve los items
    // de su departamento. Gerencia (dept null) ve todo.
    var todosLosRows=rows;
    if(_deptAcotado()){
      rows=rows.filter(function(x){ return _deptPermitido(normDept(x.grupo_nom)); });
    }
    _repData=rows;
    if(!rows.length){
      // Si el proveedor tiene items pero NINGUNO es del departamento del usuario,
      // avisar que ese proveedor no corresponde a su departamento.
      if(CU && _deptAcotado() && todosLosRows.length){
        res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-lock" style="font-size:22px;color:var(--text-warning)"></i><br>El proveedor <b>'+_esc(code)+'</b> no tiene productos de tu departamento (<b>'+_deptEtiqueta()+'</b>).<br><span style="font-size:11px;color:var(--text-muted)">Solo puedes ver reposiciones de '+_deptEtiqueta()+'.</span></div>';
        return;
      }
      // Sugerir proveedores que SÍ tienen datos (del catálogo cargado)
      var conDatos=(_repProv||[]).filter(function(p){return p.n_items>0;})
        .sort(function(a,b){return b.n_items-a.n_items;}).slice(0,8);
      var sug=conDatos.length
        ? '<div style="margin-top:10px;font-size:11px;color:var(--text-muted)">Proveedores con datos disponibles: '
          +conDatos.map(function(p){return '<span onclick="_repProvElegido(\''+_esc(p.cardcode)+'\')" style="cursor:pointer;color:var(--text-accent);text-decoration:underline;margin:0 4px">'+_esc(p.cardcode)+' ('+p.n_items+')</span>';}).join('')+'</div>'
        : '';
      res.innerHTML='<div class="empty" style="padding:20px"><i class="ti ti-database-off" style="font-size:22px;color:var(--text-muted)"></i><br>No hay ítems para el proveedor <b>'+_esc(code)+'</b>.<br><span style="font-size:11px;color:var(--text-muted)">Puede que el sync del inventario aún no haya poblado este proveedor. Si el resync completo terminó y sigue vacío, verifica el código.</span>'+sug+'</div>';
      return;
    }
    repRenderResumen(rows, code);
  }catch(e){
    res.innerHTML='<div class="empty">Error al consultar. Revisa tu conexión.</div>';
  }
}

// Fila de un item en el listado de reposición (se reusa agrupado y en lista plana)
// ═══════════════════════════════════════════════════════════════════════════
//  SUGERENCIA DE REPOSICIÓN
//  El cálculo se hace aquí con los datos del artículo: rotación estimada,
//  disponible, lo que ya viene en camino y cuándo llegó la última compra.
//  La AI se usa después para afinar los casos dudosos, pero si falla o tarda,
//  la sugerencia igual sale: antes todo dependía de la AI y quedaba en cero.
// ═══════════════════════════════════════════════════════════════════════════
window._repSugIA=window._repSugIA||{};

function _repBultos(x){
  return Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);
}

// Meses transcurridos desde una fecha
function _repMesesDe(f){
  var d=_repParseFecha(f);
  if(!d) return null;
  var m=(Date.now()-d.getTime())/(1000*60*60*24*30.44);
  return m>0?m:0.1;
}

// El cálculo por artículo. Devuelve bultos sugeridos y el porqué.
// ── Margen de ganancia del artículo, con lo que se compró y se vendió ──
// El costo es el de la última compra (lastpurprc) y el precio, el de venta
// del inventario. Se devuelve null cuando falta alguno de los dos: no es lo
// mismo "gana poco" que "no sabemos cuánto gana", y marcar en rojo por falta
// de datos sería peor que no marcar nada.
var REP_MARGEN_MIN = 15;   // por debajo de esto, se avisa
window._margenHist = window._margenHist || {};

// Trae de la base el margen histórico de cada artículo: lo que SAP muestra
// en el Sales Analysis Report, o sea TODAS las ventas del artículo desde
// siempre. Es un dato mucho más fiable que comparar el último costo con el
// precio de lista, porque recoge lo que de verdad se cobró.
async function _margenHistCargar(force){
  if(!force && Object.keys(window._margenHist).length) return window._margenHist;
  try{
    var out={}, desde=0;
    while(true){
      var r=await fetch(SB+'/rest/v1/margen_items?select=itemcode,ventas,ganancia,'
        +'margen_pct,unidades,facturas,ultima_venta&offset='+desde+'&limit=1000',{headers:SBH});
      if(!r.ok){
        if(desde===0) console.warn('[margen] no se pudo leer margen_items: '+r.status
          +' (¿falta correr crear_tabla_margen_items.sql?)');
        break;
      }
      var lote=await r.json()||[];
      lote.forEach(function(m){ out[String(m.itemcode||'').trim().toUpperCase()]=m; });
      if(lote.length<1000) break;
      desde+=1000;
    }
    if(Object.keys(out).length) window._margenHist=out;
    console.log('[margen] '+Object.keys(window._margenHist).length+' artículo(s) con margen histórico');
  }catch(e){ console.warn('[margen]',e); }
  return window._margenHist;
}

// El margen histórico de un artículo, o null si no hay ventas registradas
function _margenHistDe(itemcode){
  var k=String(itemcode||'').trim().toUpperCase();
  var m=(window._margenHist||{})[k];
  if(!m || m.margen_pct===null || m.margen_pct===undefined) return null;
  return m;
}

// El margen que se usa para avisar. Manda el histórico —son ventas reales—
// y solo si no hay se estima con el último costo contra el precio de lista.
function _repMargenItem(x){
  if(!x) return null;
  var h=_margenHistDe(x.itemcode);
  if(h) return Number(h.margen_pct);
  var pv=Number(x.precioventa)||Number(x.precio_venta)||Number(x.precio1)||0;
  var costo=Number(x.lastpurprc)||Number(x.u_precio_ult_ent)||Number(x.costo)||0;
  if(!(pv>0) || !(costo>0)) return null;
  return Number((((pv-costo)/pv)*100).toFixed(2));
}

// El margen histórico como un campo más de la fila, al lado del precio.
// Es lo que SAP llama Gross Profit %: la ganancia de TODAS las ventas del
// artículo dividida entre lo que se facturó por él.
function _repMargenCampo(x){
  var h=_margenHistDe(x&&x.itemcode);
  if(!h){
    return '<span title="Este artículo todavía no registra ventas, así que no hay '
      +'margen histórico que calcular." style="color:var(--text-muted)">Margen hist.: <b>—</b></span>';
  }
  var m=Number(h.margen_pct);
  var col = (m<0) ? '#b91c1c' : (m<REP_MARGEN_MIN ? '#B45309' : '#166534');
  var t='Margen histórico sobre todas las ventas del artículo: '
    +fmt(h.ventas)+' facturados, '+fmt(h.ganancia)+' de ganancia'
    +(h.unidades?(', '+_fmtN2(h.unidades)+' unidades'):'')
    +(h.facturas?(' en '+h.facturas+' factura(s)'):'')+'.'
    +(m<REP_MARGEN_MIN?(' Está por debajo del '+REP_MARGEN_MIN+'%.'):'');
  return '<span title="'+_esc(t)+'">Margen hist.: <b style="color:'+col+'">'
    +m.toFixed(1)+'%</b>'
    +(m<REP_MARGEN_MIN?' <i class="ti ti-arrow-down" style="color:var(--t-rojo3);font-size:11px"></i>':'')
    +'</span>';
}

// La marca que se ve junto a la sugerencia
function _repMargenBadge(x){
  var m=_repMargenItem(x);
  if(m===null || m>=REP_MARGEN_MIN) return '';
  var pv=Number(x.precioventa)||Number(x.precio_venta)||Number(x.precio1)||0;
  var costo=Number(x.lastpurprc)||Number(x.u_precio_ult_ent)||Number(x.costo)||0;
  var h=_margenHistDe(x.itemcode);
  var titulo = h
    ? ('Margen histórico: '+m.toFixed(1)+'% sobre todas las ventas del artículo'
       +' ('+fmt(h.ventas)+' vendidos, '+fmt(h.ganancia)+' de ganancia'
       +(h.facturas?(', '+h.facturas+' factura(s)'):'')+').'
       +' Por debajo del '+REP_MARGEN_MIN+'% que se considera aceptable.'
       +(m<0?' El artículo dejó pérdida.':''))
    : ('Margen estimado: '+m.toFixed(1)+'% (costo '+fmt(costo)+' → venta '+fmt(pv)+').'
       +' No hay ventas registradas de este artículo, así que sale de comparar'
       +' la última compra con el precio de lista.'
       +(m<0?' Se vendería por debajo del costo.':''));
  return '<span title="'+_esc(titulo)+'" style="display:inline-flex;align-items:center;gap:1px;'
    +'background:var(--pastel-error);color:var(--t-rojo3);border:0.5px solid #f0b4b4;border-radius:6px;'
    +'padding:1px 5px;font-size:9.5px;font-weight:800;margin-left:5px;white-space:nowrap;cursor:help">'
    +'<i class="ti ti-arrow-down" style="font-size:10px"></i>'+m.toFixed(0)+'%</span>';
}

function _repCalcularSug(x, mesesObjetivo){
  // El objetivo es tener 6 meses de inventario
  mesesObjetivo=mesesObjetivo||6;
  var ub=_repBultos(x);
  var disp=_repDisp(x);
  var porLlegar=Number(x.onorder)||0;
  var ultEnt=Number(x.u_cant_ult_ent)||0;
  var hist=Number(x.hist_comprado)||0;
  // Ventas reales de los últimos 3 años, que es el dato más fiable
  var vendido=Number(x.vendido_3a)||Number(x.vendido)||Number(x.u_vendido)||0;
  var mesesVenta=null;
  if(x.primera_venta){
    var mv=_repMesesDe(x.primera_venta);
    if(mv) mesesVenta=Math.min(mv, 36);      // como mucho, 3 años
  }
  var mesesEnt=_repMesesDe(_repFechaEnt(x));

  // 1) Rotación mensual estimada.
  //    OJO: "mesesEnt" son los meses desde la ÚLTIMA entrada, no la vida del
  //    artículo. Dividir todo el histórico por ese número inflaba la rotación
  //    de forma absurda (un artículo con 8 compras parecía vender 8 veces más).
  var rot=0, base='';

  // a) Lo consumido desde que llegó la última compra.
  //    Solo vale si quedó MENOS de lo que llegó: ahí se sabe que esa
  //    mercancía se movió. Si quedó más, había stock previo y la cuenta
  //    mezclaría cosas distintas.
  var consumo=null;
  if(ultEnt>0 && mesesEnt!=null && mesesEnt>=0.5 && disp<ultEnt){
    var consumido=ultEnt-disp;
    consumo=consumido/mesesEnt;
  }

  // b) El histórico repartido en el PERÍODO DEL DATO.
  //    El histórico que llega es el de los últimos 3 años, así que se reparte
  //    en esos 36 meses. Estimar una "vida" a partir del número de compras
  //    daba disparates: un artículo con 3 compras parecía vivir 8 meses y su
  //    rotación salía 4 veces más alta de lo real.
  var VENTANA_MESES = 36;
  var porHistorico=null;
  if(hist>0){
    // Si el artículo es más nuevo que la ventana, se usa su edad real
    var periodo=VENTANA_MESES;
    if(x.primera_venta){
      var pv=_repMesesDe(x.primera_venta);
      if(pv && pv<VENTANA_MESES) periodo=Math.max(pv, 1);
    } else if(mesesEnt!=null && mesesEnt<VENTANA_MESES && (hist<=ultEnt*1.2)){
      // Una sola compra y reciente: el período es desde esa compra
      periodo=Math.max(mesesEnt, 1);
    }
    porHistorico=hist/periodo;
  }

  if(vendido>0){
    // Lo vendido de verdad, repartido en el período en que se vendió
    var perVenta=mesesVenta || Math.min(_repMesesDe(x.u_fentrada)||36, 36) || 36;
    rot=vendido/Math.max(1, perVenta);
    base='ventas reales ('+Math.round(perVenta)+' meses)';
  } else if(porHistorico!=null && consumo!=null){
    // Se toma la señal más alta SOLO cuando la ventana reciente es corta y no
    // alcanza para concluir nada. Si la ventana ya es larga, más abajo manda
    // lo que está pasando ahora (ver "freno de realidad").
    if(consumo>porHistorico){
      rot=consumo;
      base='consumo reciente ('+_fmtN2(Math.round(ultEnt-disp))+' pz en '
           +mesesEnt.toFixed(1)+' meses)';
    } else {
      rot=porHistorico;
      base='compras de los últimos 3 años';
    }
  } else if(porHistorico!=null){
    rot=porHistorico;
    base='compras de los últimos 3 años';
  } else if(consumo!=null){
    rot=consumo;
    base='consumo desde la última compra';
  }

  // ── FRENO DE REALIDAD ────────────────────────────────────────────────
  // La rotación estimada mira hasta 3 años atrás. Si en los últimos meses el
  // artículo NO se movió, ese promedio ya no describe lo que pasa hoy y hay
  // que hacerle caso a lo reciente, que es evidencia directa.
  //
  // Sin esto, un artículo con 1.436 piezas paradas desde marzo pedía otras
  // 2.616 porque "históricamente rotaba 675 al mes", cuando en 5 meses solo
  // habían salido 4 piezas.
  var frenado=null, consumido=null;
  // El ritmo real manda en cuanto haya un mes de ventana. Antes se exigían 3
  // meses, y en ese hueco la rotación salía de las COMPRAS: comprar 52 piezas
  // hace un mes se leía como "vende 45 al mes" aunque siguieran 48 en bodega.
  if(consumo!=null && mesesEnt!=null && mesesEnt>=1){
    consumido=Math.round(ultEnt-disp);
    if(consumo<rot){
      rot=consumo;
      base='consumo real desde la última compra ('+_fmtN2(consumido)+' pz en '
           +mesesEnt.toFixed(1)+' meses)';
    }
  }
  if(consumo!=null && mesesEnt!=null && mesesEnt>=3){
    consumido=Math.round(ultEnt-disp);
    // Y si a ese ritmo hay para mucho más del objetivo, no se repone
    var cobRec=(disp+porLlegar)/Math.max(consumo, 0.01);
    if(cobRec>mesesObjetivo*2){
      frenado='Desde la última compra (hace '+mesesEnt.toFixed(1)+' meses) solo salieron '
        +_fmtN2(consumido)+' pieza(s). Con '+_fmtN2(disp)+' disponible(s) hay para '
        +(cobRec>240?'años':(Math.round(cobRec)+' meses'))+' a ese ritmo: no hace falta reponer.'
        +' Si esperás que se mueva (temporada, promoción), cárgalo a mano.';
    }
  }
  if(frenado) return {bultos:0, razon:frenado, rot:rot, base:base, enCamino:porLlegar};

  // ── TODAVÍA QUEDA MEDIA COMPRA EN CASA ───────────────────────────────
  // Si de la última compra sobra la mitad o más, no se repone: aún no se
  // sabe a qué ritmo se vende de verdad, y cualquier proyección hecha sobre
  // tan poco movimiento se dispara. Con 48 de 52, o con 80 de 120, lo
  // sensato es esperar.
  if(ultEnt>0 && (disp+porLlegar) >= ultEnt*0.5){
    var _vend=Math.max(0, Math.round(ultEnt-disp));
    return {bultos:0, rot:rot, base:base, enCamino:porLlegar,
      razon:'De la última compra de '+_fmtN2(ultEnt)+' pz todavía quedan '+_fmtN2(disp)
        +(porLlegar>0?(' y vienen '+_fmtN2(porLlegar)):'')+', o sea la mitad o más. '
        +'Solo salieron '+_fmtN2(_vend)+' pieza(s)'
        +((mesesEnt!=null)?(' en '+mesesEnt.toFixed(1)+' meses'):'')+'. '
        +'No se repone hasta que baje del 50%. Si lo necesitás igual, cárgalo a mano.'};
  }

  // 2) Cuánto haría falta para cubrir el objetivo
  var objetivo=rot*mesesObjetivo;
  var faltan=objetivo-disp-porLlegar;

  // 3) Reglas de decisión
  var razon='', bultos=0;

  if(rot<=0){
    // Sin datos de movimiento: solo se repone si está en cero y hubo compras
    if(disp<=0 && ultEnt>0 && porLlegar<=0){
      bultos=Math.max(1, Math.round((ultEnt/ub)/2));
      razon='Sin datos de rotación, pero está agotado. Media última compra.';
    } else {
      razon='Sin movimiento registrado: no se sugiere reponer.';
    }
    return {bultos:bultos, razon:razon, rot:rot, base:base};
  }

  var mesesCobertura=(disp+porLlegar)/rot;

  // ── COMPRA VIEJA CON MERCANCÍA TODAVÍA EN CASA ───────────────────────
  // Si la última compra tiene más de dos años y AÚN quedan piezas, el
  // artículo es lento por definición: se tardó años en vender lo anterior y
  // todavía sobra. No se repone solo.
  //
  // El promedio disimula esto: 1.200 piezas compradas en 2022 de las que
  // quedan 104 dan "22 al mes", pero ese número reparte por igual lo que se
  // vendió el primer año y lo que se vende ahora.
  // Más de dos años sin recomprar es una decisión, no un olvido: si el
  // artículo siguiera vendiéndose se habría repuesto en todo ese tiempo.
  // Vale tanto si sobra mercancía como si está agotado.
  //
  // Con agotados el promedio engaña especialmente: 6.012 piezas compradas en
  // 2021 dan "107 al mes", pero ese número reparte por igual lo que se vendió
  // el primer año y los últimos tres, en los que puede no haberse movido nada.
  var MESES_VIEJO=24;
  if(mesesEnt!=null && mesesEnt>MESES_VIEJO){
    var _anios=(mesesEnt/12).toFixed(1);
    razon=(disp+porLlegar)>0
      ? ('Última compra hace '+_anios+' años y todavía quedan '+_fmtN2(disp)
         +' disponible(s)'+(porLlegar>0?(' más '+_fmtN2(porLlegar)+' por llegar'):'')
         +'. Rota demasiado lento para reponer solo.')
      : ('Agotado, pero la última compra fue hace '+_anios+' años y no se volvió '
         +'a comprar desde entonces: parece descontinuado.');
    razon+=' Si lo quieres igual, cárgalo a mano.';
    return {bultos:0, razon:razon, rot:rot, base:base, enCamino:porLlegar};
  }

  if(faltan<=0){
    if(porLlegar>0){
      razon='Ya vienen '+_fmtN2(porLlegar)+' en camino: cubre '
        +mesesCobertura.toFixed(1)+' meses. No hace falta pedir más.';
    } else {
      razon='Con '+_fmtN2(disp)+' disponibles cubre '+mesesCobertura.toFixed(1)
        +' meses. Todavía no hace falta.';
    }
    return {bultos:0, razon:razon, rot:rot, base:base, enCamino:porLlegar};
  }

  // Si ya viene mercancía en camino, solo se pide más cuando de verdad falta:
  // con 2 meses o más cubiertos se espera a que llegue.
  if(porLlegar>0 && mesesCobertura>=2){
    razon='Vienen '+_fmtN2(porLlegar)+' en camino y cubren '+mesesCobertura.toFixed(1)
      +' meses. Conviene esperar a que lleguen.';
    return {bultos:0, razon:razon, rot:rot, base:base, enCamino:porLlegar};
  }

  bultos=Math.ceil(faltan/ub);

  // ── TOPE DE CRECIMIENTO SOBRE LA ÚLTIMA COMPRA ───────────────────────
  // Una cosa es que la rotación diga que faltan piezas y otra saltar de 120
  // a 672 de golpe. El salto se limita según la EVIDENCIA que hay detrás:
  // con ventas reales medidas durante meses se puede confiar más; con una
  // sola compra en el historial, la proyección se apoya en muy poco.
  //
  // El tope anterior (6 veces la última compra) era tan alto que casi nunca
  // frenaba nada: por eso EK5035-MB pedía 672 piezas habiendo comprado 120
  // en toda su historia.
  var topeInfo=null;
  if(ultEnt>0){
    var factor, motivo;
    var comprasVarias=(hist > ultEnt*1.5);          // hay más de una compra
    var ventaLarga=(vendido>0 && mesesVenta!=null && mesesVenta>=6);
    if(ventaLarga && comprasVarias){ factor=3;   motivo='ventas reales de varios meses y varias compras'; }
    else if(ventaLarga){            factor=2.5; motivo='ventas reales de varios meses'; }
    else if(comprasVarias){         factor=2.5; motivo='varias compras en el historial'; }
    else {                          factor=2;   motivo='una sola compra en el historial'; }

    var topePz=Math.round(ultEnt*factor);
    var topeBultos=Math.max(1, Math.floor(topePz/ub));
    if(bultos>topeBultos){
      topeInfo={pedidoSinTope:bultos*ub, factor:factor, motivo:motivo};
      bultos=topeBultos;
    }
  }

  // Y el tope viejo se mantiene como red de seguridad ante datos absurdos
  if(ultEnt>0){
    var razonable=(rot*mesesObjetivo*1.5)/ub;
    var tope=Math.ceil(Math.max(razonable, (ultEnt*6)/ub));
    if(bultos>tope) bultos=tope;
  }

  razon=(porLlegar>0?'AUNQUE YA VIENEN '+_fmtN2(porLlegar)+', ':'')
    +(consumido!=null?('Desde la última compra salieron '+_fmtN2(consumido)+' pz en '
       +mesesEnt.toFixed(1)+' meses. '):'')
    +'vende ~'+_fmtN2(Math.round(rot))+'/mes ('+base+'), quedan '+_fmtN2(disp)
    +(porLlegar>0?(' y vienen '+_fmtN2(porLlegar)):'')
    +' = '+mesesCobertura.toFixed(1)+' meses. Para '+mesesObjetivo+' meses faltan '
    +_fmtN2(Math.round(faltan))+' piezas.'
    +(topeInfo
      ? (' Harían falta '+_fmtN2(Math.round(topeInfo.pedidoSinTope))+' pz, pero la última '
         +'compra fue de '+_fmtN2(ultEnt)+': se limita a '+topeInfo.factor+' veces esa '
         +'cantidad porque solo hay '+topeInfo.motivo+'. Si quieres más, cárgalo a mano.')
      : ((bultos*ub < faltan-ub) ? ' Se topó la sugerencia para no pedir de más.' : ''));
  return {bultos:bultos, razon:razon, rot:rot, base:base, enCamino:porLlegar};
}

async function _repSugerirIA(){
  if(!_repData || !_repData.length){ showT('Primero abrí un proveedor'); return; }
  var items=_repFiltrarItems(_repData);
  if(!items.length){ showT('No hay artículos que analizar'); return; }

  var btn=document.getElementById('rep-ia-btn');
  function estado(t){ if(btn) btn.innerHTML=t; }
  if(btn) btn.disabled=true;
  estado('<span class="ai-ring"></span> Calculando…');

  // 1) El cálculo local, que siempre funciona
  var conSug=0, sinDatos=0;
  items.forEach(function(x){
    var r=_repCalcularSug(x, window._repMesesObjetivo||6);
    window._repSugIA[String(x.itemcode||'').trim().toUpperCase()]={
      bultos:r.bultos, razon:r.razon, rot:r.rot, base:r.base,
      enCamino:r.enCamino||0, fuente:'cálculo'
    };
    if(r.bultos>0) conSug++;
    if(!r.rot) sinDatos++;
  });

  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
  showT('✓ '+conSug+' artículo(s) con sugerencia de reposición');

  // 2) La AI revisa los que tienen movimiento, para afinar
  var paraIA=items.filter(function(x){
    var s=window._repSugIA[String(x.itemcode||'').trim().toUpperCase()];
    return s && s.rot>0;
  }).slice(0, 120);      // un tope, para no eternizar el análisis

  if(!paraIA.length){
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-sparkles"></i> Sugerencia IA'; }
    return;
  }

  var TANDA=25, total=Math.ceil(paraIA.length/TANDA), hechas=0, ajustados=0;
  for(var i=0;i<paraIA.length;i+=TANDA){
    estado('<span class="ai-ring"></span> Revisando con AI… '+(hechas+1)+'/'+total);
    try{
      var res=await _repSugLote(paraIA.slice(i,i+TANDA));
      (res||[]).forEach(function(r){
        if(!r || !r.sku) return;
        var k=String(r.sku).trim().toUpperCase();
        var prev=window._repSugIA[k];
        if(!prev) return;
        var nb=Number(r.bultos);
        if(!isNaN(nb) && nb>=0 && nb!==prev.bultos){
          prev.bultos=nb;
          prev.razon=String(r.razon||prev.razon).slice(0,200);
          prev.fuente='AI';
          ajustados++;
        }
      });
    }catch(e){ console.warn('[reposición] la AI no pudo revisar esta tanda:', e.message||e); }
    hechas++;
  }

  if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-sparkles"></i> Sugerencia IA'; }
  if(ajustados) showT('✓ La AI ajustó '+ajustados+' sugerencia(s)');
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
}

async function _repSugLote(lote){
  var filas=lote.map(function(x){
    var k=String(x.itemcode||'').trim().toUpperCase();
    var s=window._repSugIA[k]||{};
    return {
      sku:x.itemcode,
      desc:String(x.itemname||'').slice(0,50),
      disponible:_repDisp(x),
      por_llegar:Number(x.onorder)||0,
      ultima_compra_piezas:Number(x.u_cant_ult_ent)||0,
      meses_desde_ultima_entrada:(function(){ var m=_repMesesDe(_repFechaEnt(x)); return m?Math.round(m*10)/10:null; })(),
      historico_comprado:Number(x.hist_comprado)||0,
      piezas_por_bulto:_repBultos(x),
      rotacion_mensual_estimada:Math.round(s.rot||0),
      sugerencia_calculada_bultos:s.bultos||0
    };
  });

  var prompt='Sos el analista de compras de KENNEDY CENTER CORP, mayorista en Panama.\n'
    +'Ya hay una sugerencia calculada para cada articulo. Tu trabajo es REVISARLA '
    +'y corregirla solo si esta claramente mal.\n\n'
    +'CRITERIOS:\n'
    +'- Objetivo: tener 6 meses de inventario.\n'
    +'- Lo que esta en "por_llegar" YA viene en camino: no hay que volver a pedirlo. '
    +'Solo se pide mas si aun con eso no alcanza para el periodo.\n'
    +'- Si "meses_desde_ultima_entrada" es mayor a 30 y el historico es bajo, el articulo '
    +'rota poco: sugerir 0 o muy poco.\n'
    +'- Si el disponible esta en cero y el articulo rota, priorizar la reposicion.\n'
    +'- La respuesta va en BULTOS ENTEROS, nunca en piezas.\n\n'
    +'ARTICULOS:\n'+JSON.stringify(filas)+'\n\n'
    +'Devuelve SOLO un array JSON, sin texto antes ni despues:\n'
    +'[{"sku":"","bultos":0,"razon":""}]\n\n'
    +'Incluí TODOS los articulos, aunque no cambies su cantidad. '
    +'La "razon" en una frase corta en espanol.';

  var obj=await _iaJSON([{type:'text', text:prompt}], 4000);
  if(Array.isArray(obj)) return obj;
  if(obj && Array.isArray(obj.articulos)) return obj.articulos;
  if(obj && Array.isArray(obj.items)) return obj.items;
  if(obj && Array.isArray(obj.resultado)) return obj.resultado;
  console.warn('[reposición] la AI devolvió algo inesperado:', obj);
  return [];
}

// Pasa la sugerencia al campo de reposición
// El motivo de la sugerencia, al pasar el mouse por el signo de pregunta
function _sugMotivoOcultar(){
  var p=document.getElementById('sugMotivo');
  if(p) p.remove();
}

function _sugMotivo(ev, itemcode){
  _sugMotivoOcultar();
  var k=String(itemcode||'').trim().toUpperCase();
  var s=window._repSugIA[k];
  if(!s) return;
  var x=(_repData||[]).find(function(r){ return String(r.itemcode).toUpperCase()===k; });
  var ub=x?_repBultos(x):1;
  var b=Number(s.bultos)||0;

  var caja=document.createElement('div');
  caja.id='sugMotivo';
  caja.style.cssText='position:fixed;z-index:13500;background:var(--surface-0);'
    +'border:1px solid #5B21B6;border-radius:10px;box-shadow:0 10px 34px rgba(0,0,0,.3);'
    +'padding:11px 13px;max-width:380px;pointer-events:none';

  var h='<div style="font-size:11px;font-weight:800;color:var(--t-lila);text-transform:uppercase;margin-bottom:5px">'
    +'<i class="ti ti-sparkles"></i> Por qué esta sugerencia</div>'
    +'<div style="font-size:12px;font-weight:700;margin-bottom:6px">'
    +(b>0?(b+' bulto(s) · '+(b*ub)+' piezas'):'No hace falta reponer')
    +(b>0&&x?_repMargenBadge(x):'')+'</div>'
    +(function(){
        if(!x || !(b>0)) return '';
        var m=_repMargenItem(x);
        if(m===null || m>=REP_MARGEN_MIN) return '';
        var pv=Number(x.precioventa)||Number(x.precio_venta)||Number(x.precio1)||0;
        var co=Number(x.lastpurprc)||Number(x.u_precio_ult_ent)||Number(x.costo)||0;
        return '<div style="background:var(--pastel-error);border:0.5px solid #f0b4b4;border-radius:8px;'
          +'padding:7px 9px;margin-bottom:7px;font-size:11px;color:var(--t-rojo3);line-height:1.45">'
          +'<b><i class="ti ti-arrow-down"></i> Ganancia baja: '+m.toFixed(1)+'%</b><br>'
          +'La última vez se compró a '+fmt(co)+' y se vende a '+fmt(pv)+'. '
          +(m<0?'Se está vendiendo por debajo del costo. ':'')
          +'Antes de reponer, conviene revisar el precio con el proveedor.</div>';
      })()
    +'<div style="font-size:11.5px;color:var(--text-secondary);line-height:1.5">'+_esc(s.razon||'')+'</div>';

  // El detalle que se usó para el cálculo
  if(x){
    h+='<div style="margin-top:8px;padding-top:7px;border-top:0.5px solid var(--border);'
      +'font-size:10.5px;color:var(--text-muted);line-height:1.6">'
      +'<div>Disponible: <b>'+_fmtN2(_repDisp(x))+'</b>'
        +((Number(x.onorder)||0)>0?(' · Por llegar: <b style="color:#C9A800">'+_fmtN2(x.onorder)+'</b>'):'')+'</div>'
      +'<div>Última compra: <b>'+_fmtN2(x.u_cant_ult_ent)+'</b>'
        +(_repFechaEnt(x)?(' el '+_esc(_fmtFechaCorta(_repFechaEnt(x)))):'')+'</div>'
      +'<div>Histórico comprado: <b>'+_fmtN2(x.hist_comprado)+'</b></div>'
      +(s.rot?('<div>Rotación estimada: <b>'+_fmtN2(Math.round(s.rot))+'/mes</b>'
        +(s.base?(' (según '+_esc(s.base)+')'):'')+'</div>'):'')
      +'<div style="margin-top:4px;font-size:9.5px;font-style:italic">'
        +'La rotación sale de repartir lo comprado (o vendido) en los últimos '
        +'3 años entre esos 36 meses.</div>'
      +'<div>Piezas por bulto: <b>'+ub+'</b></div>'
      +'</div>';
  }
  h+='<div style="margin-top:6px;font-size:9.5px;color:var(--text-muted);font-style:italic">'
    +(s.fuente==='AI'?'Ajustado por la AI':'Calculado con los datos del artículo')+'</div>';
  caja.innerHTML=h;
  document.body.appendChild(caja);

  // Se ubica junto al cursor, sin salirse de la pantalla
  var x0=(ev&&ev.clientX)||100, y0=(ev&&ev.clientY)||100;
  var an=caja.offsetWidth||380, al=caja.offsetHeight||200;
  var izq=x0+14;
  if(izq+an > window.innerWidth-10) izq=Math.max(10, x0-an-14);
  var arr=y0+14;
  if(arr+al > window.innerHeight-10) arr=Math.max(10, window.innerHeight-al-10);
  caja.style.left=izq+'px';
  caja.style.top=arr+'px';
}

function _repUsarSugIA(itemcode){
  var s=window._repSugIA[String(itemcode||'').trim().toUpperCase()];
  if(!s || !(Number(s.bultos)>0)){ showT('No hay sugerencia para ese artículo'); return; }
  var x=(_repData||[]).find(function(r){ return String(r.itemcode)===String(itemcode); });
  if(!x) return;
  var piezas=(Number(s.bultos)||0)*_repBultos(x);
  try{ repCantSet(itemcode, piezas); }catch(e){ console.warn('cargar sugerencia:',e); }
  showT('✓ '+s.bultos+' bulto(s) = '+piezas+' piezas');
}

function _repUsarTodasSugIA(){
  var n=Object.keys(window._repSugIA||{}).filter(function(k){
    return Number(window._repSugIA[k].bultos)>0; }).length;
  if(!n){ showT('Todavía no hay sugerencias. Pulsa "Sugerencia IA".'); return; }
  if(!confirm('¿Cargar las '+n+' sugerencias en la reposición?\n\n'
    +'Se pisan las cantidades que hayas puesto a mano.')) return;
  var puestas=0;
  (_repData||[]).forEach(function(x){
    var s=window._repSugIA[String(x.itemcode||'').trim().toUpperCase()];
    if(!s || !(Number(s.bultos)>0)) return;
    var piezas=(Number(s.bultos)||0)*_repBultos(x);
    try{ repCantSet(x.itemcode, piezas); puestas++; }catch(e){}
  });
  showT('✓ '+puestas+' cantidad(es) cargada(s)');
}

// Cambia el horizonte de cobertura y recalcula
function _repMesesSug(){
  var v=prompt('¿Para cuántos meses de inventario quieres reponer?\n\n'
    +'Por defecto son 6 meses.', String(window._repMesesObjetivo||6));
  if(v===null) return;
  var n=parseFloat(v);
  if(isNaN(n) || n<=0 || n>24){ showT('Poné un número de meses entre 1 y 24'); return; }
  window._repMesesObjetivo=n;
  _repSugerirIA();
}

function _repFilaItem(x){
  var h='';
        var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
        var bulto=Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);   // piezas por bulto
        var foto=_repFotoUrl(x.picturname);
        var ic=_esc(String(x.itemcode));
        h+='<div class="rep-item-row" data-ic="'+ic+'" data-bulto="'+bulto+'" style="display:flex;align-items:center;gap:10px;padding:8px 12px;border-bottom:0.5px solid var(--border)">'
          // Foto
          +'<div style="width:52px;height:52px;flex-shrink:0;border:0.5px solid var(--border);border-radius:6px;overflow:hidden;background:var(--surface-2);display:flex;align-items:center;justify-content:center'+(foto?';cursor:zoom-in':'')+'"'+(foto?' onclick="_repZoomFoto(\''+encodeURIComponent(foto)+'\',\''+_esc(String(x.itemcode))+'\')" onmouseenter="_repHoverShow(event,\''+encodeURIComponent(foto)+'\')" onmousemove="_repHoverMove(event)" onmouseleave="_repHoverHide()"':'')+'>'
            +(foto?'<img src="'+foto+'" style="width:100%;height:100%;object-fit:cover" onerror="this.style.display=\'none\';this.parentNode.innerHTML=\'<i class=&quot;ti ti-photo-off&quot; style=&quot;color:var(--text-muted);font-size:16px&quot;></i>\'">':'<i class="ti ti-photo-off" style="color:var(--text-muted);font-size:16px"></i>')
          +'</div>'
          // Info
          +'<div style="flex:1;min-width:0">'
            +'<div style="font-size:12px;font-weight:600"><span onclick="event.stopPropagation();_invFicha(\''+ic+'\')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline">'+ic+'</span> <span style="font-weight:400;color:var(--text-secondary)">'+_esc(x.itemname||'')+'</span></div>'
            +'<div style="display:flex;gap:6px 14px;flex-wrap:wrap;font-size:12.5px;color:var(--text-secondary);margin-top:4px;line-height:1.5">'
              +'<span>Stock: <b>'+_fmtN2(x.onhand)+'</b></span>'
              +'<span onclick="event.stopPropagation();verSeparado(\''+ic+'\')" title="Ver quién lo tiene separado" style="cursor:pointer">Sep: <b style="color:var(--t-rojo2);text-decoration:underline">'+_fmtN2(x.iscommited)+'</b></span>'
              +'<span>Disp: <b style="color:var(--text-success)">'+_fmtN2(disp)+'</b>'
                +(bulto>1?(' <span style="color:var(--t-lila2);font-size:11.5px">(bultos: <b>'
                  +_fmtN2(Math.floor(disp/bulto))
                  +((disp%bulto)?('<span style="font-weight:400"> + '+_fmtN2(disp%bulto)+' pz</span>'):'')
                  +'</b>)</span>'):'')
                +'</span>'
              +'<span>Por lleg: <b style="color:#C9A800">'+_fmtN2(x.onorder)+'</b>'
          +((Number(x.onorder)>0 && _invLlegadaTxt(x))
            ? (' <span style="font-size:10.5px;color:'+_invLlegadaColor(x)+'">('+_esc(_invLlegadaTxt(x))+')</span>')
            : '')
          +'</span>'
              +'<span>Bulto: <b>'+bulto+' pz</b></span>'
              +'<span title="Cantidad de la última compra">Últ. compra: <b>'+_fmtN2(x.u_cant_ult_ent)+'</b>'
                +((bulto>1 && (Number(x.u_cant_ult_ent)||0)>0)
                  ?(' <span style="color:var(--t-lila2);font-size:11.5px">(bultos: <b>'
                    +_fmtN2(Math.floor((Number(x.u_cant_ult_ent)||0)/bulto))
                    +(((Number(x.u_cant_ult_ent)||0)%bulto)?('<span style="font-weight:400"> + '+_fmtN2((Number(x.u_cant_ult_ent)||0)%bulto)+' pz</span>'):'')
                    +'</b>)</span>'):'')+(x.u_nentrada?(' ('+_esc(x.u_nentrada)+')'):'')+'</span>'
              +'<span title="Total histórico comprado: facturas de compra menos notas de crédito. Mismo criterio que el reporte Purchase Analysis by Item de SAP.">Hist. comprado: <b style="color:var(--t-lila)">'+(Number(x.hist_comprado)?_fmtN2(x.hist_comprado):'—')+'</b></span>'
              +(x.u_fentrada?('<span title="Fecha de entrada al inventario">Fecha entrada: <b>'+_esc(_fmtFechaCorta(x.u_fentrada))+'</b></span>'):'')
              +(CU.verCostos
                ? ('<span>FOB: <b>'+_fmtN2(x.fob)+'</b></span>'
                   +'<span title="Costo puesto en bodega: FOB más flete y gastos">CIF: <b style="color:var(--t-marron)">'
                     +_fmtN2(x.cif)+'</b></span>'
                   +'<span>Precio: <b>'+_fmtN2(x.precio1)+'</b></span>'
                   +_repMargenCampo(x))
                : '')
            +'</div>'
            +(function(){
              // Mostrar si esta referencia está en órdenes No SAP (ya pedida)
              var enNoSAP=_repEnOrdenesNoSAP(x.itemcode);
              if(!enNoSAP.length) return '';
              var totNoSAP=enNoSAP.reduce(function(s,o){return s+o.cantidad;},0);
              return '<div style="margin-top:4px;font-size:10px;background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:6px;padding:4px 8px;color:var(--t-ambar)">'
                +'<i class="ti ti-file-invoice"></i> Ya pedido en No SAP: <b>'+totNoSAP+' und</b> · '
                +enNoSAP.map(function(o){
                  var precioTxt=(CU.verCostos&&o.precio_unit)?(' @'+_fmtN2(o.precio_unit)):'';
                  var fechaTxt=o.fecha?(' · '+_esc(_fmtFechaCorta(o.fecha))):'';
                  return '<span onclick="event.stopPropagation();abrirPendSAP(\''+_esc(String(o.dkc).replace(/\x27/g,''))+'\')" style="cursor:pointer;text-decoration:underline;font-weight:600">'+_esc(o.orden)+' ('+o.cantidad+precioTxt+fechaTxt+')</span>';
                }).join(' · ')
              +'</div>';
            })()
          +'</div>'
          // Sugerencia de la AI, si ya se calculó
          +(function(){
            var sg=window._repSugIA[String(x.itemcode||'').trim().toUpperCase()];
            if(!sg) return '';
            var b=Number(sg.bultos)||0;
            var pz=b*bulto;
            var enCam=Number(sg.enCamino)||0;
            return '<div style="flex-shrink:0;text-align:center;border:1px solid '+(b>0?'#5B21B6':'var(--border)')+';'
              +'border-radius:8px;padding:4px 9px;background:'+(b>0?'#F7F5FF':'var(--surface-1)')+';cursor:'+(b>0?'pointer':'default')+'" '
              +(b>0?('onclick="event.stopPropagation();_repUsarSugIA(\''+ic+'\')" '):'')
              +'title="'+_esc(sg.razon||'Sin sugerencia')+'">'
              +'<div style="font-size:8px;color:var(--t-lila);font-weight:700;text-transform:uppercase;'
                +'display:flex;align-items:center;justify-content:center;gap:3px">Sugerencia IA'
                +'<span class="sug-ayuda" onmouseenter="_sugMotivo(event,\''+ic+'\')" onmouseleave="_sugMotivoOcultar()" '
                +'onclick="event.stopPropagation();_sugMotivo(event,\''+ic+'\')" '
                +'style="display:inline-flex;align-items:center;justify-content:center;width:13px;height:13px;'
                +'border-radius:50%;background:#5B21B6;color:#fff;font-size:9px;font-weight:800;cursor:help;'
                +'flex-shrink:0">?</span></div>'
              +'<div style="font-size:13px;font-weight:800;color:'+(b>0?'#5B21B6':'var(--text-muted)')+'">'+b+' <span style="font-size:9px">blt</span>'
                +(b>0?_repMargenBadge(x):'')+'</div>'
              +(b>0?('<div style="font-size:8.5px;color:var(--text-muted)">'+pz+' pz · usar</div>'):'')
              +(enCam>0?('<div style="font-size:8px;color:#C9A800;font-weight:700">ya viene '+_fmtN2(enCam)+'</div>'):'')
              +'</div>';
          })()
          // Controles: piezas y bultos EN LÍNEA (lado a lado) + conversión bidireccional
          +'<div style="display:flex;flex-direction:row;align-items:center;gap:14px;flex-shrink:0;flex-wrap:wrap;justify-content:flex-end">'
            // Grupo piezas
            +'<div style="display:flex;align-items:center;gap:4px">'
              +'<button onclick="repCantAjustar(\''+ic+'\',-1)" title="Quitar 1 pieza" style="width:24px;height:26px;border:0.5px solid var(--border);background:var(--surface-1);border-radius:6px;cursor:pointer;font-size:14px;font-weight:700;color:var(--text-danger)">−</button>'
              +'<div style="display:flex;flex-direction:column;align-items:center">'
                +'<input id="rep-qty-'+ic+'" type="number" min="0" value="'+(_repCarrito[x.itemcode]||0)+'" onchange="repCantSet(\''+ic+'\',this.value)" style="width:70px;text-align:center;padding:4px;border:0.5px solid var(--border);border-radius:6px;font-size:13px;font-weight:600" title="Piezas">'
                +'<span style="font-size:8px;color:var(--text-muted)">piezas</span>'
              +'</div>'
              +'<button onclick="repCantAjustar(\''+ic+'\',1)" title="Agregar 1 pieza" style="width:24px;height:26px;border:0.5px solid var(--border);background:var(--surface-1);border-radius:6px;cursor:pointer;font-size:14px;font-weight:700;color:var(--text-success)">+</button>'
            +'</div>'
            // Fila bultos
            +'<div style="display:flex;align-items:center;gap:4px">'
              +'<button onclick="repAjustarBulto(\''+ic+'\',-1,'+bulto+')" title="Quitar 1 bulto ('+bulto+' pz)" style="width:24px;height:24px;border:0.5px solid #C4B5FD;background:var(--pastel-lila);border-radius:6px;cursor:pointer;font-size:14px;font-weight:700;color:var(--t-lila2)">−</button>'
              +'<div style="display:flex;flex-direction:column;align-items:center">'
                +'<input id="rep-blt-'+ic+'" type="number" min="0" step="0.01" value="'+(_repCarrito[x.itemcode]?(Math.round((_repCarrito[x.itemcode]/bulto)*100)/100):0)+'" onchange="repBultoSet(\''+ic+'\',this.value,'+bulto+')" style="width:70px;text-align:center;padding:4px;border:0.5px solid #C4B5FD;border-radius:6px;font-size:13px;font-weight:600;color:var(--t-lila2)" title="Bultos">'
                +'<span style="font-size:8px;color:var(--t-lila2)">bultos ×'+bulto+'</span>'
              +'</div>'
              +'<button onclick="repAjustarBulto(\''+ic+'\',1,'+bulto+')" title="Agregar 1 bulto ('+bulto+' pz)" style="width:24px;height:24px;border:0.5px solid #C4B5FD;background:var(--pastel-lila);border-radius:6px;cursor:pointer;font-size:14px;font-weight:700;color:var(--t-lila2)">+</button>'
            +'</div>'
          +'</div>'
        +'</div>';
  return h;
}

// ═══════════════════════════════════════════════════════════════════════════
//  ORDEN Y FILTRO DEL LISTADO DE REPOSICIÓN
//  Se guardan en memoria para que el listado se repinte sin volver a consultar.
// ═══════════════════════════════════════════════════════════════════════════
// Por defecto, la entrada más reciente primero
window._repOrden='entrada';    // entrada | entrada_v | grupo | sku | desc | stock | disp | hist
window._repAgrupar=true;       // agrupar por grupo de artículo
window._repFiltroItem='';      // texto para filtrar dentro del proveedor

var _REP_ORDENES={
  entrada:'Entrada  más reciente primero (por defecto)',
  entrada_v:'Entrada  más vieja primero',
  grupo:  'Grupo de artículo',
  sku:    'SKU  A → Z',
  sku_z:  'SKU  Z → A',
  desc:   'Descripción  A → Z',
  desc_z: 'Descripción  Z → A',
  stock:  'Stock  menor primero',
  disp:   'Disponible  menor primero',
  hist:   'Hist. comprado  mayor primero'
};

function _repCmpTexto(a,b){ return String(a||'').localeCompare(String(b||''),'es',{numeric:true,sensitivity:'base'}); }
function _repDisp(x){ return (Number(x.onhand)||0)-(Number(x.iscommited)||0); }

// Compara por fecha de entrada. Los que no tienen fecha van siempre al final,
// para que no ensucien el orden.
// La fecha de entrada viaja con dos nombres distintos: "fechaentrada" en el
// tablero de reposiciones y "u_fentrada" en el catálogo del proveedor. Se
// miran los dos: buscar solo uno hacía que el orden no se aplicara.
function _repFechaEnt(x){
  return (x && (x.u_fentrada || x.fechaentrada || x.fecha_entrada)) || '';
}

function _repCmpEntrada(viejaPrimero){
  return function(a,b){
    var da=_repParseFecha(_repFechaEnt(a)), db=_repParseFecha(_repFechaEnt(b));
    if(!da && !db) return _repCmpTexto(a.itemcode,b.itemcode);
    if(!da) return 1;
    if(!db) return -1;
    var dif=viejaPrimero ? (da-db) : (db-da);
    return dif!==0 ? dif : _repCmpTexto(a.itemcode,b.itemcode);
  };
}

function _repOrdenar(list){
  var l=list.slice();
  switch(window._repOrden){
    case 'sku':    l.sort(function(a,b){ return _repCmpTexto(a.itemcode,b.itemcode); }); break;
    case 'sku_z':  l.sort(function(a,b){ return _repCmpTexto(b.itemcode,a.itemcode); }); break;
    case 'desc':   l.sort(function(a,b){ return _repCmpTexto(a.itemname,b.itemname); }); break;
    case 'desc_z': l.sort(function(a,b){ return _repCmpTexto(b.itemname,a.itemname); }); break;
    case 'stock':  l.sort(function(a,b){ return (Number(a.onhand)||0)-(Number(b.onhand)||0); }); break;
    case 'disp':   l.sort(function(a,b){ return _repDisp(a)-_repDisp(b); }); break;
    case 'hist':   l.sort(function(a,b){ return (Number(b.hist_comprado)||0)-(Number(a.hist_comprado)||0); }); break;
    case 'entrada':   l.sort(_repCmpEntrada(false)); break;
    case 'entrada_v': l.sort(_repCmpEntrada(true));  break;
    case 'grupo':  l.sort(function(a,b){ return _repCmpTexto(a.itemcode,b.itemcode); }); break;
    // Por defecto: la entrada más reciente primero
    default:       l.sort(_repCmpEntrada(false));
  }
  return l;
}

// Filtro por situación de stock
//  · sin      -> disponible en cero
//  · bajo50   -> tiene disponible, pero cayó por debajo de la mitad de lo que
//                entró en la última compra
window._repFiltroStock='todos';

function _repCumpleStock(x){
  var f=window._repFiltroStock||'todos';
  if(f==='todos') return true;
  var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
  if(f==='sin') return disp<=0;
  if(f==='bajo50'){
    var ult=Number(x.u_cant_ult_ent)||0;
    if(ult<=0) return false;          // sin última entrada no hay con qué comparar
    return disp>0 && disp < (ult/2);
  }
  return true;
}

function _repFiltrarItems(list){
  list=(list||[]).filter(_repCumpleStock);
  var q=String(window._repFiltroItem||'').trim().toLowerCase();
  if(!q) return list;
  return list.filter(function(x){
    return String(x.itemcode||'').toLowerCase().indexOf(q)>=0
        || String(x.itemname||'').toLowerCase().indexOf(q)>=0
        || String(x.frgnname||'').toLowerCase().indexOf(q)>=0
        || String(x.codebars||'').toLowerCase().indexOf(q)>=0;
  });
}

// Repinta el listado con el orden y filtro actuales, sin volver a consultar
function _repReordenar(v){
  if(v!=null) window._repOrden=v;
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
}
function _repToggleAgrupar(chk){
  window._repAgrupar=!!chk;
  _repReordenar();
}
function _repFiltrarAhora(v){
  window._repFiltroItem=v;
  if(!_repData || !_repData.length) return;
  // Se repinta solo la lista, para no perder el foco del cuadro de búsqueda
  var cont=document.getElementById('rep-lista');
  if(!cont){ repRenderResumen(_repData, _repCard); return; }
  cont.innerHTML=_repListaHTML(_repData);
  var cnt=document.getElementById('rep-cnt-filtro');
  if(cnt){
    var n=_repFiltrarItems(_repData).length;
    cnt.textContent=(n===_repData.length)?(_repData.length+' referencias'):(n+' de '+_repData.length+' referencias');
  }
  repActualizarCarrito();
}

// HTML del listado, agrupado o en lista única según la preferencia
function _repListaHTML(rows){
  var vis=_repFiltrarItems(rows);
  if(!vis.length){
    return '<div class="empty" style="padding:18px;color:var(--text-muted)">'
      +'<i class="ti ti-search-off" style="font-size:20px"></i><br>Ningún ítem coincide con "'+_esc(window._repFiltroItem)+'".</div>';
  }
  var h='';
  // Al ordenar por fecha de entrada, el agrupamiento por grupo se deja de
  // lado: si no, el orden se aplica solo dentro de cada grupo y en pantalla
  // se ven fechas viejas arriba.
  var _porFecha=(window._repOrden==='entrada'||window._repOrden==='entrada_v');
  if(window._repAgrupar && !_porFecha){
    var porGrupo={};
    vis.forEach(function(x){ var g=(x.grupo_cod||'')+' '+(x.grupo_nom||'Sin grupo'); (porGrupo[g]=porGrupo[g]||[]).push(x); });
    Object.keys(porGrupo).sort(_repCmpTexto).forEach(function(g){
      var list=_repOrdenar(porGrupo[g]);
      h+='<div style="margin-bottom:12px;border:0.5px solid var(--border);border-radius:8px;overflow:hidden">'
        +'<div style="background:var(--surface-2);padding:7px 12px;font-size:12px;font-weight:600;border-bottom:0.5px solid var(--border)">'+_esc(g)+' <span style="color:var(--text-muted);font-weight:400">· '+list.length+' items</span></div>';
      list.forEach(function(x){ h+=_repFilaItem(x); });
      h+='</div>';
    });
  } else {
    var list=_repOrdenar(vis);
    h+='<div style="margin-bottom:12px;border:0.5px solid var(--border);border-radius:8px;overflow:hidden">'
      +'<div style="background:var(--surface-2);padding:7px 12px;font-size:12px;font-weight:600;border-bottom:0.5px solid var(--border)">'+_esc(_porFecha ? ('Por fecha de entrada · '+(window._repOrden==='entrada_v'?'más antigua primero':'más reciente primero')) : 'Todos los ítems')+'<span style="color:var(--text-muted);font-weight:400"> · '+list.length+' items</span></div>';
    list.forEach(function(x){ h+=_repFilaItem(x); });
    h+='</div>';
  }
  return h;
}

// Barra de orden y filtro
// Botones para filtrar por situación de stock
function _repBarraStock(rows){
  var defs=[
    {k:'todos',  l:'Todos',                    c:'var(--text-secondary)', t:'Todas las referencias del proveedor'},
    {k:'sin',    l:'Sin disponible',           c:'#DC2626', t:'Disponible en cero: stock menos separado'},
    {k:'bajo50', l:'Bajó del 50% de la última llegada', c:'#EA580C', t:'Tienen disponible, pero quedan menos de la mitad de las piezas que entraron en la última compra'}
  ];
  var act=window._repFiltroStock||'todos';
  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:12px">'
    +'<span style="font-size:11.5px;color:var(--text-secondary);font-weight:600"><i class="ti ti-filter"></i> Stock</span>';
  defs.forEach(function(d){
    var cont=(rows||[]).filter(function(x){
      var g=window._repFiltroStock; window._repFiltroStock=d.k;
      var ok=_repCumpleStock(x); window._repFiltroStock=g; return ok;
    }).length;
    var on=(act===d.k);
    h+='<button onclick="_repSetStock(\''+d.k+'\')" title="'+_esc(d.t)+'" style="border:1px solid '+(on?d.c:'var(--border)')+';'
      +'background:'+(on?d.c:'var(--surface-1)')+';color:'+(on?'#fff':d.c)+';'
      +'border-radius:20px;padding:4px 11px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
      +d.l+' <span style="opacity:.8;font-weight:400">'+cont+'</span></button>';
  });
  // Botón para ordenar por fecha de entrada. No filtra: siempre se ven todos
  // los SKU, solo cambia el orden en que aparecen.
  var porEntrada=(window._repOrden==='entrada'||window._repOrden==='entrada_v');
  var vieja=(window._repOrden==='entrada_v');
  // Si se está corrigiendo una reposición ya enviada, se avisa
  try{ h+=_repModificandoAviso(); }catch(e){}

  // Sugerencia de la AI: propone bultos a reponer por artículo
  var haySug=Object.keys(window._repSugIA||{}).length>0;
  h+='<span style="width:1px;height:20px;background:var(--border);margin:0 4px"></span>'
    +'<button id="rep-ia-btn" onclick="_repSugerirIA()" '
    +'title="La AI revisa disponibilidad, última entrada y el histórico de cada artículo y sugiere cuántos bultos reponer." '
    +'style="border:1px solid #5B21B6;background:'+(haySug?'#F7F5FF':'#5B21B6')+';color:'+(haySug?'#5B21B6':'#fff')+';'
    +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
    +'<i class="ti ti-sparkles"></i> Sugerencia IA'+(haySug?' · recalcular':'')+'</button>'
    +(haySug?('<button onclick="_repMesesSug()" title="Cambiar para cuántos meses reponer" '
      +'style="border:1px solid var(--border);background:var(--surface-1);color:var(--text-secondary);'
      +'border-radius:20px;padding:4px 10px;font-size:10.5px;cursor:pointer">'
      +(window._repMesesObjetivo||6)+' meses</button>'):'')
    +(haySug?('<button onclick="_repUsarTodasSugIA()" title="Cargar todas las sugerencias en la reposición" '
      +'style="border:1px solid #5B21B6;background:var(--surface-1);color:var(--t-lila);border-radius:20px;'
      +'padding:4px 11px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
      +'<i class="ti ti-checks"></i> Usar todas</button>'):'')
    +'<span style="width:1px;height:20px;background:var(--border);margin:0 4px"></span>'
    +'<button onclick="_topAbrir()" '
    +'title="Los artículos más vendidos de los últimos 3 años que ya están por debajo de la mitad de la última compra y no tienen nada en camino." '
    +'style="border:1px solid #EA580C;background:var(--surface-1);color:#EA580C;'
    +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
    +'<i class="ti ti-flame"></i> Top selling items</button>'
    +'<span style="width:1px;height:20px;background:var(--border);margin:0 4px"></span>'
    +'<button onclick="_repToggleEntrada()" '
    +'title="Ordena la lista por fecha de llegada. No oculta ningún artículo." '
    +'style="border:1px solid '+(porEntrada?'#1D4ED8':'var(--border)')+';'
    +'background:'+(porEntrada?'#1D4ED8':'var(--surface-1)')+';color:'+(porEntrada?'#fff':'#1D4ED8')+';'
    +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
    +'<i class="ti ti-calendar"></i> Fecha de entrada · '
    +(vieja?'más antigua primero':'más reciente primero')+'</button>';
  return h+'</div>';
}

// Alterna entre reciente primero y antigua primero
function _repToggleEntrada(){
  window._repOrden = (window._repOrden==='entrada') ? 'entrada_v' : 'entrada';
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
}

function _repSetStock(k){
  window._repFiltroStock=k;
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
}

function _repBarraOrden(rows){
  var n=_repFiltrarItems(rows).length;
  var opts=Object.keys(_REP_ORDENES).map(function(k){
    return '<option value="'+k+'"'+((window._repOrden===k)?' selected':'')+'>'+_REP_ORDENES[k]+'</option>';
  }).join('');
  return '<div style="display:flex;gap:9px;align-items:center;flex-wrap:wrap;background:var(--surface-1);border:0.5px solid var(--border);border-radius:10px;padding:9px 12px;margin-bottom:12px">'
    +'<span style="font-size:11.5px;color:var(--text-secondary);font-weight:600"><i class="ti ti-arrows-sort"></i> Ordenar</span>'
    +'<select onchange="_repReordenar(this.value)" style="padding:5px 9px;border:0.5px solid var(--border);border-radius:7px;background:var(--surface-0);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)">'+opts+'</select>'
    +'<label style="display:flex;align-items:center;gap:5px;font-size:11.5px;color:var(--text-secondary);cursor:pointer">'
      +'<input type="checkbox" onchange="_repToggleAgrupar(this.checked)"'+(window._repAgrupar?' checked':'')
      +((window._repOrden==='entrada'||window._repOrden==='entrada_v')?' disabled title="Al ordenar por fecha de entrada no se agrupa: la lista va toda seguida por fecha."':'')
      +' style="cursor:pointer"> Agrupar por grupo</label>'
    +'<div style="flex:1;min-width:150px;display:flex;align-items:center;gap:6px">'
      +'<i class="ti ti-search" style="color:var(--text-muted);font-size:13px"></i>'
      +'<input id="rep-filtro-item" value="'+_esc(window._repFiltroItem||'')+'" oninput="_repFiltrarAhora(this.value)" placeholder="Filtrar por SKU, descripción o código de barras" style="flex:1;padding:5px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;background:var(--surface-0);color:var(--text-primary)">'
      +(window._repFiltroItem?'<span onclick="document.getElementById(\'rep-filtro-item\').value=\'\';_repFiltrarAhora(\'\')" style="cursor:pointer;color:var(--text-muted);font-size:15px" title="Limpiar">&times;</span>':'')
    +'</div>'
    +'<span id="rep-cnt-filtro" style="font-size:11px;color:var(--text-muted);white-space:nowrap">'+((n===rows.length)?(rows.length+' referencias'):(n+' de '+rows.length+' referencias'))+'</span>'
    +'</div>'
    +_repBarraStock(rows);
}

// Trabajar la reposición a pantalla completa: la lista se hace incómoda
// dentro del ancho normal cuando hay cientos de artículos.
function _repPantallaCompleta(){
  window._repFull=!window._repFull;
  var b=document.body;
  if(window._repFull){
    b.classList.add('rep-full');
    // Un botón fijo arriba a la derecha, para salir desde cualquier punto
    if(!document.getElementById('repFullSalir')){
      var btn=document.createElement('button');
      btn.id='repFullSalir';
      btn.className='rep-full-salir';
      btn.innerHTML='<i class="ti ti-arrows-minimize"></i> Salir de pantalla completa';
      btn.onclick=_repPantallaCompleta;
      document.body.appendChild(btn);
    }
    // Se recuerda dónde estaba para volver al mismo punto
    window._repScrollPrev=window.scrollY;
    showT('Pantalla completa · Esc para salir');
    if(!window._repEscHandler){
      window._repEscHandler=function(ev){
        if(ev.key==='Escape' && window._repFull) _repPantallaCompleta();
      };
      document.addEventListener('keydown', window._repEscHandler);
    }
  } else {
    b.classList.remove('rep-full');
    var vb=document.getElementById('repFullSalir');
    if(vb) vb.remove();
  }
  if(_repData && _repData.length) repRenderResumen(_repData, _repCard);
  if(!window._repFull && window._repScrollPrev!=null){
    setTimeout(function(){ window.scrollTo(0, window._repScrollPrev); }, 30);
  }
}

function repRenderResumen(rows, code){
  var res=document.getElementById('rep-result');
  var cardname=(rows[0]&&rows[0].cardname)||'';
  // Agrupar por grupo (solo para el conteo del encabezado)
  var porGrupo={};
  rows.forEach(function(x){ var g=(x.grupo_cod||'')+' '+(x.grupo_nom||'Sin grupo'); (porGrupo[g]=porGrupo[g]||[]).push(x); });
  var h=''
    +'<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;background:var(--surface-1);border:0.5px solid var(--border);border-radius:10px;padding:12px 14px;margin-bottom:14px">'
      +'<div style="flex:1;min-width:0"><div style="font-size:15px;font-weight:700">'+_esc(code)+(cardname?(' — '+_esc(cardname)):'')+'</div>'
      +'<div style="font-size:12px;color:var(--text-muted);margin-top:2px">'+rows.length+' referencias · '+Object.keys(porGrupo).length+' grupo(s)</div></div>'
      +'<button class="btn bg2" onclick="repPDF()"><i class="ti ti-file-type-pdf"></i> PDF completo</button>'
      +'<button class="btn bg2" onclick="repExcel()"><i class="ti ti-file-spreadsheet"></i> Excel completo</button>'
      +'<button class="btn bp" id="rep-full-btn" onclick="_repPantallaCompleta()" '
        +'title="Trabajar la reposición a pantalla completa" style="background:#5B21B6">'
        +'<i class="ti ti-'+(window._repFull?'arrows-minimize':'arrows-maximize')+'"></i> '
        +(window._repFull?'Salir de pantalla completa':'Pantalla completa')+'</button>'
    +'</div>';
  // SKUs de este proveedor que todavía no existen en SAP (creados desde una
  // orden NO SAP). Se muestran aparte y en morado para que se note.
  h+=_catBloqueProveedor(code);
  // Barra de carrito (fija arriba del listado)
  h+='<div id="rep-cart-bar" style="position:sticky;top:0;z-index:5;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);border:1px solid #C4B5FD;border-radius:10px;padding:10px 14px;margin-bottom:14px;display:flex;align-items:center;gap:10px;flex-wrap:wrap"></div>';

  // Barra de orden / filtro y listado
  h+=_repBarraOrden(rows);
  h+='<div id="rep-lista">'+_repListaHTML(rows)+'</div>';
  res.innerHTML=h;
  repActualizarCarrito();
}

// Ajusta la cantidad de un item en +1 o -1 (unidad)
function repCantAjustar(ic, delta){
  var actual=Number(_repCarrito[ic]||0);
  var nuevo=Math.max(0, actual+delta);
  repCantSet(ic, nuevo);
}
// Ajusta la cantidad por BULTOS: suma o resta 'signo' bultos (cada bulto = N piezas)
function repAjustarBulto(ic, signo, bulto){
  var b=Math.max(1, Number(bulto)||1);
  var actual=Number(_repCarrito[ic]||0);
  var nuevo=Math.max(0, actual + (signo*b));
  repCantSet(ic, nuevo);
}
// Suma un bulto completo (N piezas) — compatibilidad
function repAddBulto(ic, bulto){
  var actual=Number(_repCarrito[ic]||0);
  repCantSet(ic, actual+(Number(bulto)||1));
}
// Fija la cantidad exacta en PIEZAS (manual)
function repCantSet(ic, val){
  var n=Math.max(0, Math.round(Number(val)||0));
  if(n<=0){ delete _repCarrito[ic]; } else { _repCarrito[ic]=n; }
  var inp=document.getElementById('rep-qty-'+ic);
  if(inp)inp.value=n;
  // Sincronizar el input de bultos (piezas → bultos)
  _repSyncBultoInput(ic, n);
  // Resaltar la fila si está seleccionada
  var row=document.querySelector('.rep-item-row[data-ic="'+ic+'"]');
  if(row)row.style.background=n>0?'#F0FDF4':'';
  repActualizarCarrito();
  repAutoguardar();   // guardar en segundo plano
}
// Fija la cantidad a partir de BULTOS (bultos × piezasPorBulto = piezas)
function repBultoSet(ic, val, bulto){
  var b=Math.max(1, Number(bulto)||1);
  var bultos=Math.max(0, Number(val)||0);
  var piezas=Math.round(bultos*b);
  // repCantSet actualizará el input de piezas y re-sincronizará bultos
  repCantSet(ic, piezas);
}
// Actualiza el input de bultos según las piezas actuales
function _repSyncBultoInput(ic, piezas){
  var bInp=document.getElementById('rep-blt-'+ic);
  if(!bInp) return;
  // Obtener el bulto de la fila (está en el título del botón o lo recalculamos del data)
  var row=document.querySelector('.rep-item-row[data-ic="'+ic+'"]');
  var bulto=1;
  if(row){
    var m=(row.getAttribute('data-bulto'));
    if(m) bulto=Math.max(1, Number(m)||1);
  }
  bInp.value = piezas>0 ? (Math.round((piezas/bulto)*100)/100) : 0;
}
// Actualiza la barra de carrito
function repActualizarCarrito(){
  var bar=document.getElementById('rep-cart-bar');
  if(!bar)return;
  var items=Object.keys(_repCarrito).filter(function(k){return _repCarrito[k]>0;});
  var totalUnid=items.reduce(function(s,k){return s+_repCarrito[k];},0);
  if(!items.length){
    bar.innerHTML='<span style="font-size:12px;color:var(--t-lila2)"><i class="ti ti-shopping-cart"></i> Selecciona items con + / − o escribe cantidades para armar tu pedido de reposición.</span>';
    return;
  }
  bar.innerHTML=''
    +'<span id="repNumRepo"></span>'
    +'<span style="font-size:13px;font-weight:700;color:var(--t-lila2)"><i class="ti ti-shopping-cart"></i> '+items.length+' item(s) · '+totalUnid+' unidades</span>'
    +'<div style="flex:1"></div>'
    +'<button class="btn bp" onclick="repGenerarYEnviar()"><i class="ti ti-mail"></i> Generar Excel y PDF</button>'
    +'<button class="btn bg2" onclick="repLimpiarCarrito()" style="color:var(--text-danger)"><i class="ti ti-trash"></i></button>';
  try{ _repPintarNumero(); }catch(e){}
}
function repLimpiarCarrito(){
  _repCarrito={};
  document.querySelectorAll('.rep-item-row').forEach(function(r){
    r.style.background='';
    var inp=r.querySelector('input[type=number]'); if(inp)inp.value=0;
  });
  repActualizarCarrito();
  repAutoguardar();
}

// ═══════════════════════════════════════════════════════════════════════════
//  AUTOGUARDADO DE PEDIDOS DE REPOSICIÓN
// ═══════════════════════════════════════════════════════════════════════════
var _repPedidoId=null;      // id del pedido actual en Supabase (para actualizar)
var _repNumRepo='';         // número consecutivo de esta reposición (R-01, R-02…)

// ═══════════════════════════════════════════════════════════════════════════
//  NÚMERO DE REPOSICIÓN
//  Consecutivo simple: R-01, R-02… Se pide el mayor que haya y se suma uno.
//  Se compara el número, no el texto, para que después de R-09 venga R-10.
// ═══════════════════════════════════════════════════════════════════════════
function _repNumFmt(n){ return 'R-'+(n<10?('0'+n):String(n)); }
function _repNumVal(txt){
  var m=String(txt||'').toUpperCase().match(/R\s*-?\s*(\d+)/);
  return m?parseInt(m[1],10):0;
}
// El siguiente número mira LAS DOS tablas. Un número puede haber quedado
// guardado solo en el envío y no en el pedido; mirando únicamente los pedidos
// ese número parecía libre y se repartía dos veces (así salieron dos R-09).
async function _repSiguienteNumero(){
  var max=0, leyoAlguna=false;

  async function mirar(tabla){
    try{
      var r=await fetch(SB+'/rest/v1/'+tabla+'?select=num_reposicion'
        +'&num_reposicion=not.is.null&order=id.desc&limit=1000',{headers:SBH});
      if(!r.ok){
        var t=''; try{ t=await r.text(); }catch(e){}
        window._repNumError='HTTP '+r.status+' '+String(t).slice(0,180);
        console.warn('[reposición] no se pudo leer el consecutivo en '+tabla+':', window._repNumError);
        return;
      }
      leyoAlguna=true;
      (await r.json()||[]).forEach(function(x){
        var n=_repNumVal(x.num_reposicion);
        if(n>max) max=n;
      });
    }catch(e){
      window._repNumError=String(e && e.message || e);
      console.warn('[reposición] consecutivo en '+tabla+':', e);
    }
  }

  await mirar('reposiciones_pedidos');
  await mirar('reposiciones_envios');

  if(!leyoAlguna) return '';          // no se pudo consultar ninguna: sin número
  window._repNumError='';
  return _repNumFmt(max+1);
}
var _repSaveTimer=null;     // debounce del autoguardado

function repAutoguardar(){
  // Debounce: espera 800ms tras el último cambio para no saturar la BD
  if(_repSaveTimer) clearTimeout(_repSaveTimer);
  _repSaveTimer=setTimeout(_repGuardarAhora, 800);
}

// Fuerza el guardado que estuviera esperando y espera a que termine. Se usa
// antes de generar o enviar, para que el pedido exista de verdad en la base.
async function _repGuardarPendiente(){
  if(_repSaveTimer){ clearTimeout(_repSaveTimer); _repSaveTimer=null; }
  await _repGuardarAhora();
}

async function _repGuardarAhora(){
  if(!_repData||!_repCard) return;
  var items=Object.keys(_repCarrito).filter(function(k){return _repCarrito[k]>0;});
  // Armar el detalle del pedido (con datos para poder continuar/ver luego)
  var detalle=items.map(function(ic){
    var x=_repData.find(function(r){return String(r.itemcode)===String(ic);})||{};
    return {
      itemcode:ic, itemname:x.itemname||'', cant:_repCarrito[ic],
      picturname:x.picturname||'', grupo_nom:x.grupo_nom||'',
      onhand:x.onhand||0, disponible:(Number(x.onhand)||0)-(Number(x.iscommited)||0),
      u_cxblt:x.u_cxblt||0, salpackun:x.salpackun||0, fob:x.fob||0, precio1:x.precio1||0
    };
  });
  var nUnid=items.reduce(function(s,k){return s+_repCarrito[k];},0);
  var cardname=(_repData[0]&&_repData[0].cardname)||'';
  var payload={
    cardcode:_repCard, cardname:cardname,
    usuario:(CU&&CU.id)||'', usuario_nom:(CU&&CU.name)||'',
    estado:'en_proceso', items:detalle,
    n_items:items.length, n_unidades:nUnid,
    actualizado_en:new Date().toISOString()
  };
  try{
    if(_repPedidoId){
      // Actualizar el pedido existente. Si viene de antes del consecutivo,
      // aprovecha y le asigna número.
      if(!_repNumRepo && !window._repSinColumna){
        // Se pregunta primero si el pedido ya tiene número
        try{
          var _rp=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=num_reposicion&id=eq.'
            +encodeURIComponent(_repPedidoId)+'&limit=1',{headers:SBH});
          if(_rp.ok){
            var _dp=await _rp.json()||[];
            if(_dp.length && _dp[0].num_reposicion) _repNumRepo=String(_dp[0].num_reposicion).trim();
          }
        }catch(e){}
        if(!_repNumRepo){
          try{ _repNumRepo=await _repSiguienteNumero(); }catch(e){}
          if(!_repNumRepo) window._repSinColumna=true;
        }
      }
      var _cuerpo=_repNumRepo?Object.assign({}, payload, {num_reposicion:_repNumRepo}):payload;
      var _rp=await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify(_cuerpo)
      });
      if(!_rp.ok && _repNumRepo){
        _repNumRepo=''; window._repSinColumna=true;
        await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
          method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify(payload)
        });
      }
      try{ _repPintarNumero(); }catch(e){}
    } else if(items.length){
      // Crear un pedido nuevo (solo si ya hay al menos 1 item).
      // Aquí es donde nace el número de reposición.
      if(!_repNumRepo){ try{ _repNumRepo=await _repSiguienteNumero(); }catch(e){} }
      var conNum=_repNumRepo?Object.assign({}, payload, {num_reposicion:_repNumRepo}):payload;
      var r=await fetch(SB+'/rest/v1/reposiciones_pedidos',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(conNum)
      });
      if(!r.ok && _repNumRepo){
        // La columna no está: se guarda igual, sin número
        var _t=''; try{ _t=await r.text(); }catch(e){}
        window._repNumError='HTTP '+r.status+' '+String(_t).slice(0,180);
        console.warn('[reposición] sin columna num_reposicion:', window._repNumError);
        _repNumRepo=''; window._repSinColumna=true;
        r=await fetch(SB+'/rest/v1/reposiciones_pedidos',{
          method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
          body:JSON.stringify(payload)
        });
      }
      if(r.ok){
        var d=await r.json();
        if(Array.isArray(d)&&d[0]){
          _repPedidoId=d[0].id;
          if(d[0].num_reposicion) _repNumRepo=d[0].num_reposicion;
        }
      }
      try{ _repPintarNumero(); }catch(e){}
    }
  }catch(e){ /* si falla el guardado, no interrumpir la edición */ }
}

// ── Vista de pedidos guardados ──
async function rRepPedidos(){
  var cont=document.getElementById('page-reppedidos');
  if(!cont) return;
  cont.innerHTML='<div style="font-size:13px;font-weight:500;margin-bottom:6px"><i class="ti ti-clipboard-list"></i> Pedidos de reposición guardados</div>'
    +'<div class="empty"><i class="ti ti-loader-2 spin"></i><br>Cargando...</div>';
  try{
    // Gerencia ve todos; el resto ve los de su equipo (mismo depto)
    var filtro=_filtroEquipo('usuario');
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=*'+filtro+'&order=actualizado_en.desc&limit=200',{headers:SBH});
    var peds=r.ok?(await r.json()):[];
    if(!Array.isArray(peds)||!peds.length){
      cont.innerHTML='<div style="font-size:13px;font-weight:500;margin-bottom:6px"><i class="ti ti-clipboard-list"></i> Pedidos de reposición guardados</div>'
        +'<div class="empty" style="padding:24px"><i class="ti ti-clipboard-off" style="font-size:22px;color:var(--text-muted)"></i><br>No hay pedidos guardados todavía.<br><span style="font-size:11px;color:var(--text-muted)">Cuando armes un pedido en Reposiciones, se guarda automáticamente aquí.</span></div>';
      return;
    }
    var h='<div style="font-size:13px;font-weight:500;margin-bottom:6px"><i class="ti ti-clipboard-list"></i> Pedidos de reposición guardados <span style="font-size:11px;color:var(--text-muted);font-weight:400">('+peds.length+')</span></div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:12px">Se guardan automáticamente mientras armas cada pedido. Puedes continuar uno o revisarlo.</div>';
    peds.forEach(function(p){
      var fecha=p.actualizado_en?new Date(p.actualizado_en).toLocaleString('es'):'';
      var estBadge=p.estado==='finalizado'
        ?'<span style="font-size:10px;background:var(--bg-success);color:var(--text-success);padding:1px 7px;border-radius:8px;font-weight:600">Finalizado</span>'
        :'<span style="font-size:10px;background:var(--pastel-lila);color:var(--t-lila2);padding:1px 7px;border-radius:8px;font-weight:600">En proceso</span>';
      h+='<div style="border:0.5px solid var(--border);border-radius:10px;padding:12px 14px;margin-bottom:10px;display:flex;align-items:center;gap:12px;flex-wrap:wrap">'
        +'<div style="flex:1;min-width:0">'
          +'<div style="font-size:13px;font-weight:700">'+_esc(p.cardcode)+' — '+_esc(p.cardname||'')+' '+estBadge+'</div>'
          +'<div style="font-size:11px;color:var(--text-muted);margin-top:3px">'
            +(p.n_items||0)+' items · '+(p.n_unidades||0)+' unidades · por '+_esc(p.usuario_nom||p.usuario||'?')+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted);margin-top:2px">Actualizado: '+_esc(fecha)+'</div>'
        +'</div>'
        +'<button class="btn bp" onclick="repContinuarPedido('+p.id+')"><i class="ti ti-edit"></i> Continuar</button>'
        +'<button class="btn bg2" onclick="repVerPedido('+p.id+')"><i class="ti ti-eye"></i> Ver</button>'
        +'<button class="btn bg2" style="color:var(--text-danger)" onclick="repBorrarPedido('+p.id+')"><i class="ti ti-trash"></i></button>'
      +'</div>';
    });
    cont.innerHTML=h;
  }catch(e){
    cont.innerHTML='<div class="empty">Error al cargar los pedidos guardados.</div>';
  }
}

// Continuar un pedido: carga el proveedor y restaura las cantidades
async function repContinuarPedido(id){
  try{
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+id+'&select=*&limit=1',{headers:SBH});
    var d=r.ok?(await r.json()):[];
    var p=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!p){ showT('No se encontró el pedido'); return; }
    // Ir a reposiciones, cargar el proveedor y restaurar el carrito
    go('reposiciones');
    document.getElementById('rep-code').value=p.cardcode;
    _repPedidoId=p.id;   // seguir guardando sobre el mismo pedido
    _repNumRepo=p.num_reposicion||'';   // y su número de reposición
    await repGenerar();
    // Restaurar cantidades
    var items=(typeof p.items==='string')?JSON.parse(p.items):(p.items||[]);
    _repCarrito={};
    items.forEach(function(it){ if(it.cant>0)_repCarrito[it.itemcode]=it.cant; });
    // Refrescar inputs y resaltado
    Object.keys(_repCarrito).forEach(function(ic){
      var inp=document.getElementById('rep-qty-'+ic);
      if(inp)inp.value=_repCarrito[ic];
      var row=document.querySelector('.rep-item-row[data-ic="'+ic+'"]');
      if(row)row.style.background='#F0FDF4';
    });
    repActualizarCarrito();
    showT('✓ Pedido cargado, puedes continuar');
  }catch(e){ showT('Error al cargar el pedido'); }
}

// Ver un pedido (solo lectura, genera la vista imprimible)
async function repVerPedido(id){
  try{
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+id+'&select=*&limit=1',{headers:SBH});
    var d=r.ok?(await r.json()):[];
    var p=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!p){ showT('No se encontró el pedido'); return; }
    var items=(typeof p.items==='string')?JSON.parse(p.items):(p.items||[]);
    // Precargar fotos
    var imgs={};
    await Promise.all(items.map(function(it){
      return _repCargarImg(_repFotoUrl(it.picturname)).then(function(im){ imgs[it.itemcode]=im?im.data:null; });
    }));
    // Reusar la vista HTML imprimible
    var sel=items.map(function(it){ return {
      itemcode:it.itemcode, itemname:it.itemname, _cant:it.cant,
      picturname:it.picturname, u_color:it.u_color, u_tamano:it.u_tamano,
      onhand:it.onhand, iscommited:0, u_cxblt:it.u_cxblt, salpackun:it.salpackun
    };});
    _repCard=p.cardcode; _repData=[{cardname:p.cardname}];
    repPedidoHTML(sel, imgs);
  }catch(e){ showT('Error al abrir el pedido'); }
}

async function repBorrarPedido(id){
  if(!confirm('¿Está seguro de que desea borrar esta reposición en curso?\n\nSe perderán las cantidades que llevabas cargadas.\n\nEsta acción no se puede deshacer.')) return;
  try{
    await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+id,{method:'DELETE',headers:SBH});
    if(_repPedidoId===id)_repPedidoId=null;
    showT('Reposición borrada');
    if(document.getElementById('rep-encurso')) _repCargarEnCurso();
    else if(typeof rRepPedidos==='function') rRepPedidos();
  }catch(e){ showT('Error al borrar'); }
}

// ── Generar PDF con formato tipo SAP ──
// Precarga una imagen y la devuelve como dataURL (para incrustarla en el PDF)
// Carga una foto para el PDF, redimensionada al tamaño en que se va a ver.
// Antes se guardaba a resolución completa aunque en el papel midiera 110
// puntos: el archivo pesaba diez veces más de lo necesario.
function _repCargarImg(url, ladoMax, calidad){
  ladoMax=ladoMax||300;                 // ~2.7x el tamaño impreso, se ve nítida
  calidad=(calidad==null?0.62:calidad);
  return new Promise(function(resolve){
    if(!url){ resolve(null); return; }
    var img=new Image();
    img.crossOrigin='anonymous';
    img.onload=function(){
      try{
        var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
        if(!w || !h){ resolve(null); return; }
        var esc=Math.min(1, ladoMax/Math.max(w,h));
        var cw=Math.max(1,Math.round(w*esc)), ch=Math.max(1,Math.round(h*esc));
        var cv=document.createElement('canvas');
        cv.width=cw; cv.height=ch;
        var cx=cv.getContext('2d');
        cx.fillStyle='#ffffff';         // fondo blanco para los PNG con transparencia
        cx.fillRect(0,0,cw,ch);
        cx.drawImage(img,0,0,cw,ch);
        resolve({data:cv.toDataURL('image/jpeg',calidad), w:cw, h:ch});
      }catch(e){ resolve(null); }
    };
    img.onerror=function(){ resolve(null); };
    img.src=url;
    // Margen amplio: con muchas fotos el navegador las pone en cola y un
    // límite corto las descartaba, dejando el PDF sin imágenes.
    setTimeout(function(){ resolve(null); }, 30000);
  });
}

// Carga fotos por tandas, para no saturar al navegador. Cargarlas todas de
// golpe hacía que las últimas quedaran en cola y se perdieran.
async function _repCargarImgs(items, urlDe, porTanda, aviso){
  porTanda=porTanda||10;
  var mapa={}, hechas=0;
  for(var i=0;i<items.length;i+=porTanda){
    var lote=items.slice(i,i+porTanda);
    await Promise.all(lote.map(function(x){
      var u=urlDe(x);
      if(!u){ mapa[x.itemcode]=null; return Promise.resolve(); }
      return _repCargarImg(u).then(function(im){ mapa[x.itemcode]=im; });
    }));
    hechas+=lote.length;
    if(aviso && (i%40===0)) aviso(hechas, items.length);
  }
  var con=Object.keys(mapa).filter(function(k){ return !!mapa[k]; }).length;
  console.log('[fotos] '+con+' de '+items.length+' cargadas');
  return mapa;
}

async function repPDF(returnBlob){
  if(!_repData||!_repData.length){ showT('Primero consulta un proveedor'); return; }
  if(!window.jspdf||!window.jspdf.jsPDF){ showT('No se pudo cargar el generador de PDF'); return; }
  if(!returnBlob) showT('Generando PDF con fotos…');
  // compress:true reduce bastante el peso del archivo
  var doc=new window.jspdf.jsPDF({unit:'pt',format:'letter',compress:true}); // 612 x 792
  var rows=_repData;
  var code=_repCard, cardname=(rows[0]&&rows[0].cardname)||'';
  var W=612, M=40, y=0;
  var azul=[30,80,165];
  var fecha=new Date().toLocaleDateString('es',{weekday:'long',day:'2-digit',month:'long',year:'numeric'});

  // Las fotos, por tandas: todas a la vez saturaban al navegador
  var imgs=await _repCargarImgs(rows,
    function(x){ return _repFotoUrl(x.picturname); }, 10,
    function(n,t){ if(!returnBlob) showT('Cargando fotos… '+n+'/'+t); });

  // Agrupar por grupo
  var porGrupo={};
  rows.forEach(function(x){ var g=(x.grupo_cod||'')+' '+(x.grupo_nom||'Sin grupo'); (porGrupo[g]=porGrupo[g]||[]).push(x); });
  var totalProv=0;

  function header(pageNum){
    doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(0);
    doc.text(fecha, M, 38);
    doc.text('Página '+pageNum, W-M, 38, {align:'right'});
    doc.setFontSize(15); doc.setTextColor(azul[0],azul[1],azul[2]); doc.setFont('helvetica','bold');
    doc.text('KENNEDY CENTER CORP.', W/2, 56, {align:'center'});
    doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.8); doc.line(M,62,W-M,62);
    doc.setFontSize(11); doc.setTextColor(0);
    doc.text(code+'   '+cardname, W/2, 78, {align:'center'});
    doc.setLineWidth(1.2); doc.line(M,84,W-M,84);
    doc.setFont('helvetica','normal');
    return 100;
  }

  var FICHA_H=118;   // alto aproximado de cada ficha
  var page=1;
  y=header(page);

  Object.keys(porGrupo).sort().forEach(function(g){
    var list=porGrupo[g];
    // Encabezado de grupo
    if(y>760){ doc.addPage(); page++; y=header(page); }
    doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(0);
    doc.text(g, M+10, y);
    doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.2); y+=4; doc.line(M,y,W-M,y); y+=14;
    doc.setFont('helvetica','normal');

    list.forEach(function(x){
      if(y+FICHA_H>770){ doc.addPage(); page++; y=header(page); }
      var y0=y;
      var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
      var pctv=(Number(x.precio1)&&Number(x.cif))?((1-(Number(x.cif)/Number(x.precio1)))*100):0;
      var col2=M+300;   // columna derecha de datos
      var col2b=M+230;  // etiqueta col derecha

      // ── Código (azul) + Nombre (negro) ──
      doc.setFont('helvetica','bold'); doc.setFontSize(9.5);
      doc.setTextColor(azul[0],azul[1],azul[2]); doc.text(String(x.itemcode||''), M, y);
      doc.setTextColor(0); doc.text(String(x.itemname||'').toUpperCase(), M+90, y);
      y+=15;

      // ── Bloque de datos (3 líneas, etiqueta en negrita + valor) ──
      doc.setFontSize(8);
      function par(lbl,val,lx,vx,vy,valColor){
        doc.setFont('helvetica','bold'); doc.setTextColor(0); doc.text(lbl,lx,vy);
        doc.setFont('helvetica','normal');
        if(valColor)doc.setTextColor(valColor[0],valColor[1],valColor[2]); else doc.setTextColor(0);
        doc.text(String(val),vx,vy);
        doc.setTextColor(0);
      }
      // Línea 1
      var emp=_fmtN2(x.salpackun)+' '+(x.salunitmsr||'PZAS')+' X C/ '+( (Number(x.u_cxblt)||1) )+' '+(x.u_bulunie||'BTO')+'(S)';
      par('Empaque:', emp, M, M+52, y);
      par('Kilos:', _fmtN2(x.kilos), col2b, col2b+34, y);
      par('P3:', _fmtN2(x.p3), col2b+90, col2b+108, y);
      y+=12;
      // Línea 2
      par('Existencia:', _fmtN2(x.onhand), M, M+56, y);
      par('Separado:', _fmtN2(x.iscommited), M+150, M+205, y);
      par('Disponible:', _fmtN2(disp), col2b, col2b+56, y, azul);
      y+=12;
      // Línea 3 (costos, solo si ve costos)
      if(CU.verCostos){
        par('FOB:', _fmtN2(x.fob), M, M+30, y);
        par('CIF:', _fmtN2(x.cif), M+150, M+180, y);
        par('Precio:', _fmtN2(x.precio1), col2b, col2b+40, y, azul);
        if(pctv){ doc.setFont('helvetica','normal'); doc.setTextColor(90); doc.text(_fmtN2(pctv)+'%', col2b+120, y); doc.setTextColor(0); }
        y+=14;
      } else { y+=2; }

      // ── Recuadro Ult. Compra / Total Comprado ──
      if(CU.verCostos){
        var bx=M, bw=340, bh=30, by=y-2;
        doc.setDrawColor(150); doc.setLineWidth(0.5);
        doc.rect(bx,by,bw,bh);
        doc.line(bx+bw/2,by,bx+bw/2,by+bh); // divisoria vertical
        doc.line(bx,by+12,bx+bw,by+12);      // divisoria horizontal (encabezados)
        doc.setFontSize(6.5); doc.setFont('helvetica','bold'); doc.setTextColor(0);
        doc.text('Ult. Compra:', bx+3, by+8);
        doc.text('Total Comprado:', bx+bw/2+3, by+8);
        doc.setFont('helvetica','normal'); doc.setFontSize(6);
        doc.text('# Entrada    Fecha              Cantidad', bx+3, by+18);
        doc.text('Cantidad     Tot. FOB       Tot. CIF', bx+bw/2+3, by+18);
        doc.setFontSize(6.5);
        doc.text((x.u_nentrada||'-')+'   '+(x.u_fentrada||'')+'   '+_fmtN2(x.u_cant_ult_ent), bx+3, by+27);
        doc.text(_fmtN2(x.cant_comprada)+'   '+_fmtN2(x.total_fob)+'   '+_fmtN2(x.total_cif), bx+bw/2+3, by+27);
        y=by+bh+11;
      }

      // ── Por llegar + Tot. CIF ──
      doc.setFontSize(8);
      par('Por llegar:', _fmtN2(x.onorder), M, M+56, y, azul);
      if(CU.verCostos) par('Tot. CIF.:', _fmtN2(x.total_cif), col2b, col2b+50, y, azul);
      totalProv+=(Number(x.total_cif)||0);
      y+=13;

      // ── Comp / Color / Tamaño ──
      doc.setFontSize(7.5); doc.setTextColor(60);
      var linea3=[];
      if(x.u_color) linea3.push('Color: '+x.u_color);
      if(x.u_tamano) linea3.push('Tamaño: '+x.u_tamano);
      if(linea3.length){ doc.text(linea3.join('     '), M, y); }
      doc.setTextColor(0);

      // ── Foto del producto (a la derecha) ──
      var im=imgs[x.itemcode];
      if(im){
        try{
          var maxW=110, maxH=80;
          var r=Math.min(maxW/im.w, maxH/im.h);
          var iw=im.w*r, ih=im.h*r;
          var ix=W-M-maxW+(maxW-iw)/2, iy=y0+6;
          doc.addImage(im.data,'JPEG',ix,iy,iw,ih);
        }catch(e){}
      }

      // ── Separador entre productos ──
      y=Math.max(y, y0+FICHA_H-10);
      doc.setDrawColor(120); doc.setLineWidth(0.7); doc.line(M,y,W-M,y);
      y+=14;
    });
  });

  // ── Total proveedor ──
  if(CU.verCostos){
    if(y>740){ doc.addPage(); page++; y=header(page); }
    doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.8); doc.line(M,y,W-M,y); y+=18;
    doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(azul[0],azul[1],azul[2]);
    doc.text('TOTAL PROVEEDOR --->', W-220, y);
    doc.text(_fmtN2(totalProv), W-M, y, {align:'right'});
    doc.setTextColor(0); doc.setFont('helvetica','normal');
  }

  var nombrePDF='Reposicion_'+code+'_'+new Date().toISOString().slice(0,10)+'.pdf';
  if(returnBlob){ return new File([doc.output('blob')], nombrePDF, {type:'application/pdf'}); }
  doc.save(nombrePDF);
  showT('✓ PDF generado');
}

// ── Exportar a Excel ──
function repExcel(returnBlob){
  if(!_repData||!_repData.length){ showT('Primero consulta un proveedor'); return; }
  if(typeof XLSX==='undefined'){ showT('No se pudo cargar Excel'); return; }
  var rows=_repData.map(function(x){
    var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
    var o={
      'Código':x.itemcode, 'Descripción':x.itemname, 'Grupo':x.grupo_nom,
      'Existencia':Number(x.onhand)||0, 'Separado':Number(x.iscommited)||0,
      'Disponible':disp, 'Por llegar':Number(x.onorder)||0,
      'Empaque':Number(x.salpackun)||0, 'Unidad':x.salunitmsr,
      'Últ. entrada #':x.u_nentrada, 'Últ. entrada fecha':x.u_fentrada,
      'Cant. últ. entrada':Number(x.u_cant_ult_ent)||0,
      'Color':x.u_color, 'Tamaño':x.u_tamano
    };
    if(CU.verCostos){
      o['FOB']=Number(x.fob||x.cif)||0; o['CIF']=Number(x.cif)||0;
      o['Precio']=Number(x.precio1)||0;
      o['Cant. comprada']=Number(x.cant_comprada)||0;
      o['Total FOB']=Number(x.total_fob)||0; o['Total CIF']=Number(x.total_cif)||0;
    }
    return o;
  });
  var ws=XLSX.utils.json_to_sheet(rows);
  var wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Reposicion');
  var nombreXLS='Reposicion_'+_repCard+'_'+new Date().toISOString().slice(0,10)+'.xlsx';
  if(returnBlob){
    var wbout=XLSX.write(wb,{bookType:'xlsx',type:'array'});
    return new File([wbout], nombreXLS, {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  }
  XLSX.writeFile(wb, nombreXLS);
  showT('✓ Excel generado');
}

// ── Enviar el REPORTE COMPLETO del proveedor (PDF + Excel) por correo ──
async function repEnviarReporte(){
  if(!_repData||!_repData.length){ showT('Primero consulta un proveedor'); return; }
  showT('Generando PDF y Excel…');
  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var fecha=new Date().toLocaleDateString('es');
  var asunto='Reposición '+code+(cardname?(' - '+cardname):'');
  var cuerpo='Estimados,\n\n'
    +'Adjunto el reporte de reposición del proveedor '+code+(cardname?(' ('+cardname+')'):'')+'.\n\n'
    +'Resumen: '+_repData.length+' referencias · '+fecha+'\n\n'
    +'Saludos,\n'+(CU?CU.name:'')+'\nKennedy Center';
  var filePDF=null, fileXLS=null;
  try{ filePDF=await repPDF(true); }catch(e){}
  try{ fileXLS=await repExcel(true); }catch(e){}
  var nombrePDF=filePDF?filePDF.name:('Reposicion_'+code+'.pdf');
  var nombreXLS=fileXLS?fileXLS.name:('Reposicion_'+code+'.xlsx');
  return _repEnviarConAdjuntos([filePDF,fileXLS].filter(Boolean), asunto, cuerpo, nombrePDF, nombreXLS);
}

// ═══════════════════════════════════════════════════════════════════════════
//  PEDIDO DE REPOSICIÓN — solo los items seleccionados (con cantidades y fotos)
// ═══════════════════════════════════════════════════════════════════════════
function _repItemsSeleccionados(){
  if(!_repData) return [];
  return _repData.filter(function(x){ return (_repCarrito[x.itemcode]||0)>0; })
    .map(function(x){ var c=Object.assign({}, x); c._cant=_repCarrito[x.itemcode]; return c; });
}

async function repGenerarPedido(tipo){
  var sel=_repItemsSeleccionados();
  if(!sel.length){ showT('No hay items seleccionados'); return; }
  try{ await _repGuardarPendiente(); }catch(e){}
  try{ await _repAsegurarNumero(); }catch(e){}
  // Marcar el pedido guardado como finalizado (si existe)
  if(_repPedidoId){
    try{
      await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({actualizado_en:new Date().toISOString()})
      });
    }catch(e){}
  }
  if(tipo==='excel'){ return repPedidoExcel(sel); }
  return repPedidoPDF(sel);
}

// A quién va dirigido el "Dear". Si el proveedor tiene contacto guardado se
// usa su nombre; si no, queda "Vendor" y se cambia a mano en el correo, que
// es editable antes de enviar.
function _repContacto(){
  var c='';
  try{
    c=(window._repProvContacto||'')
      || ((_repData&&_repData[0]&&(_repData[0].contacto||_repData[0].contact))||'');
  }catch(e){}
  c=String(c||'').trim();
  if(!c) return 'Vendor';
  return c.split(/\s+/)[0];        // solo el nombre de pila, como se acostumbra
}

// La firma. Cuando compras manda una reposición que originó gerencia, se
// firma en su nombre: "On behalf of <gerencia>".
function _repFirmaCorreo(){
  var yo=(CU&&CU.name)||'';
  var de='';
  try{ de=String(window._repOrigenNombre||'').trim(); }catch(e){}
  var enNombreDe=(de && de!==yo) ? ('On behalf of '+de+'\n') : '';
  return 'Best regards,\n\n'+enNombreDe+yo+'\nKENNEDY CENTER CORP.';
}

// Genera PDF + Excel del pedido e intenta compartirlos (adjuntar) vía Web Share API
async function repGenerarYEnviar(){
  var sel=_repItemsSeleccionados();
  if(!sel.length){ showT('No hay items seleccionados'); return; }
  // Primero se guarda el pedido. Si el autoguardado quedó pendiente, el envío
  // salía sin pedido_id y las líneas de esa reposición no quedaban en ningún
  // lado: después no había contra qué comparar la orden NO SAP.
  try{ await _repGuardarPendiente(); }catch(e){ console.warn('[reposición] guardar antes de enviar:', e); }
  // El número va en el PDF, el Excel, el asunto y el cuerpo: se resuelve antes
  try{ await _repAsegurarNumero(); }catch(e){}
  if(!_repNumRepo) showT('Ojo: esta reposición sale sin número (falta correr reposiciones_numero.sql)', 6000);
  // Marcar pedido como finalizado
  if(_repPedidoId){
    try{
      await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({actualizado_en:new Date().toISOString()})
      });
    }catch(e){}
  }
  showT('Generando PDF y Excel…');

  var ahora=new Date();
  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var totUnid=sel.reduce(function(s,x){return s+(Number(x._cant)||0);},0);
  var totBultos=Math.round(sel.reduce(function(s,x){var b=Math.max(1,Number(x.u_cxblt)||Number(x.salpackun)||1);return s+(x._cant/b);},0)*100)/100;

  // ── Asunto y cuerpo del correo, en INGLÉS y con el formato acordado ──
  var asunto='RE-ORDER '+(_repNumRepo?(_repNumRepo+' '):'')+code+(cardname?(' - '+cardname):'');
  var cuerpo=''
    +'Attention:                    '+(cardname||('Supplier '+code))+'\n'
    +'Vendor Code:            '+code+'\n'
    +(_repNumRepo?('Re-order No.:           '+_repNumRepo+'\n'):'')
    +'\n'
    +'Dear '+_repContacto()+'\n'
    +'\n'
    +'I hope you are doing well.\n'
    +'\n'
    +'Please find attached our repeat order\n'
    +'\n'
    +'Order Summary:\n'
    +'\u2022 '+_repNum(sel.length)+' '+(sel.length===1?'item':'items')+'\n'
    +'\u2022 '+_repNum(totUnid)+' '+(totUnid===1?'unit':'units')+'\n'
    +'\u2022 '+_repNum(totBultos)+' '+(totBultos===1?'carton':'cartons')+'\n'
    +'\u2022 Date: '+_repFechaEN(ahora)+'\n'
    +'\n'
    +'Kindly check and send us your company\u2019s PI as well as our KCC RE-ORDER format for final confirmation.\n'
    +'\n'
    +'Thank you for your cooperation.\n'
    +'\n'
    +_repFirmaCorreo();

  // Generar los archivos como objetos File (para compartir/adjuntar)
  var filePDF=null, fileXLS=null;
  try{ filePDF=await repPedidoPDF(sel, true); }catch(e){}
  try{ fileXLS=await repPedidoExcel(sel, true); }catch(e){}
  var nombrePDF=filePDF?filePDF.name:_repNombreArchivo('pdf', ahora);
  var nombreXLS=fileXLS?fileXLS.name:_repNombreArchivo('xlsx', ahora);
  return _repEnviarConAdjuntos([filePDF, fileXLS].filter(Boolean), asunto, cuerpo, nombrePDF, nombreXLS);
}

// ═══════════════════════════════════════════════════════════════════════════
//  ENVÍO POR CORREO CON ADJUNTOS (PDF + Excel) — Apple y Windows
//  · "Compartir con adjuntos" usa la hoja nativa (Web Share) que SÍ adjunta los
//    archivos de verdad: funciona en iPhone/iPad/Mac y en Windows compatible.
//  · "Abrir correo" usa mailto con destinatarios/CC/asunto/mensaje ya escritos y
//    descarga los 2 archivos para que los adjuntes (los navegadores no permiten
//    adjuntar archivos automáticamente por mailto).
// ═══════════════════════════════════════════════════════════════════════════
function _repEnviarConAdjuntos(files, asunto, cuerpo, nombrePDF, nombreXLS){
  _repMailFiles = files||[];
  _repAbrirModalCorreo(asunto, cuerpo, nombrePDF, nombreXLS);
}
// Abre/descarga un adjunto (PDF o Excel) del correo en preparación
function _repAbrirAdjunto(i){
  var f=(_repMailFiles||[])[i]; if(!f){ showT('Adjunto no disponible'); return; }
  var url=URL.createObjectURL(f);
  var a=document.createElement('a'); a.href=url; a.download=f.name; a.target='_blank';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(function(){URL.revokeObjectURL(url);},4000);
}
// Correos existentes del equipo (definidos en USERS) para elegir con un clic
function _repCorreosEquipo(){
  try{
    return (USERS||[]).filter(function(u){return u&&u.email;})
      .map(function(u){return {email:u.email, name:u.name||u.email};});
  }catch(e){ return []; }
}
// Agrega/quita (toggle) un correo del equipo en el campo "Para"
function _repAddCorreo(email){
  var inp=document.getElementById('repMailPara'); if(!inp)return;
  var actuales=(inp.value||'').split(/[;,\n]/).map(function(s){return s.trim();}).filter(Boolean);
  var i=actuales.indexOf(email);
  if(i>=0){ actuales.splice(i,1); } else { actuales.push(email); }
  inp.value=actuales.join(', ');
  document.querySelectorAll('.rep-mail-chip').forEach(function(c){
    var on=actuales.indexOf(c.getAttribute('data-email'))>=0;
    c.style.background=on?'var(--text-accent)':'var(--surface-2)';
    c.style.color=on?'#fff':'var(--text-secondary)';
    c.style.borderColor=on?'var(--text-accent)':'var(--border)';
  });
}
// Copia los destinatarios (Para + CC) al portapapeles
function _repCopiarCorreos(){
  var para=(document.getElementById('repMailPara').value||'').trim();
  var cc=(document.getElementById('repMailCC').value||'').trim();
  var todos=[para,cc].filter(Boolean).join(', ');
  if(!todos){ showT('No hay correos para copiar'); return; }
  var done=function(){ showT('✓ Correos copiados'); };
  if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(todos).then(done,done); }
  else { var t=document.createElement('textarea'); t.value=todos; document.body.appendChild(t); t.select(); try{document.execCommand('copy');}catch(e){} t.remove(); done(); }
}
// Comparte los archivos ADJUNTOS con la hoja nativa (Web Share)
async function _repCompartirAdjuntos(){
  var files=_repMailFiles||[];
  if(!files.length){ showT('No hay archivos para compartir'); return; }
  var asunto=(document.getElementById('repMailAsunto')?document.getElementById('repMailAsunto').value:'')||'';
  var cuerpo=(document.getElementById('repMailCuerpo')?document.getElementById('repMailCuerpo').value:'')||'';
  var para=(document.getElementById('repMailPara')?document.getElementById('repMailPara').value:'')||'';
  var cc=(document.getElementById('repMailCC')?document.getElementById('repMailCC').value:'')||'';
  // Copiamos los destinatarios al portapapeles para pegarlos rápido en el correo
  var dest=[para,cc].filter(function(s){return (s||'').trim();}).join(', ');
  if(dest){ try{ if(navigator.clipboard&&navigator.clipboard.writeText) await navigator.clipboard.writeText(dest); }catch(e){} }
  if(navigator.canShare && navigator.canShare({files:files})){
    try{
      await navigator.share({ files:files, title:asunto, text:(dest?('Para: '+dest+'\n\n'):'')+cuerpo });
      showT('✓ Compartido — pega los correos (ya copiados) en Para');
      var m=document.querySelector('#repMailPara'); if(m){var mm=m.closest('div[style*=fixed]'); if(mm)mm.remove();}
      return;
    }catch(err){ if(err&&err.name==='AbortError'){ return; } }
  }
  showT('Tu dispositivo no permite adjuntar al compartir. Usa "Abrir correo".');
}
// Modal para componer el correo (elige destinatarios del equipo o escríbelos)
function _repAbrirModalCorreo(asunto, cuerpo, nombrePDF, nombreXLS){
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2000;display:flex;align-items:center;justify-content:center;padding:16px';
  var puedeCompartir=false;
  try{ puedeCompartir=!!(navigator.canShare && _repMailFiles && _repMailFiles.length && navigator.canShare({files:_repMailFiles})); }catch(e){}
  var equipo=_repCorreosEquipo();
  var chips=equipo.map(function(u){
    return '<span class="rep-mail-chip" data-email="'+_esc(u.email)+'" onclick="_repAddCorreo(\''+_esc(u.email)+'\')" title="'+_esc(u.email)+'" style="cursor:pointer;font-size:11px;padding:4px 9px;border:0.5px solid var(--border);background:var(--surface-2);color:var(--text-secondary);border-radius:20px;white-space:nowrap">'+_esc(u.name)+'</span>';
  }).join('');
  var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:540px;width:100%;max-height:90vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px"><div style="font-size:15px;font-weight:700"><i class="ti ti-mail" style="color:var(--text-accent)"></i> Enviar por correo</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
  h+='<div style="background:#EAF3DE;border:0.5px solid #B7D89A;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11px;color:#3B5323"><i class="ti ti-paperclip"></i> El PDF y el Excel se adjuntan automáticamente. Elige los destinatarios y pulsa <b>Enviar</b> para mandarlo desde el app, ya con los archivos adjuntos.</div>';
  // Adjuntos clicables (PDF y Excel)
  var adjHTML=(_repMailFiles||[]).map(function(f,i){
    var esPdf=/\.pdf$/i.test(f.name);
    var icon=esPdf?'ti-file-type-pdf':'ti-file-spreadsheet';
    var col=esPdf?'#B91C1C':'#15803D';
    return '<div onclick="_repAbrirAdjunto('+i+')" title="Abrir / descargar el archivo" style="display:flex;align-items:center;gap:8px;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;background:var(--surface-1);cursor:pointer;margin-bottom:6px">'
      +'<i class="ti '+icon+'" style="font-size:18px;color:'+col+'"></i>'
      +'<span style="flex:1;min-width:0;font-size:12px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(f.name)+'</span>'
      +'<span style="font-size:10px;color:var(--text-accent);font-weight:600"><i class="ti ti-eye" style="font-size:12px"></i> ver</span>'
    +'</div>';
  }).join('');
  h+='<div style="margin-bottom:12px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500"><i class="ti ti-paperclip" style="font-size:12px"></i> Adjuntos (clic para abrir)</label><div style="margin-top:5px">'+(adjHTML||'<span style="font-size:11px;color:var(--text-muted)">Generando archivos…</span>')+'</div></div>';
  if(equipo.length){
    h+='<div style="margin-bottom:10px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Correos del equipo (clic para agregar)</label><div style="display:flex;flex-wrap:wrap;gap:5px;margin-top:5px;max-height:104px;overflow-y:auto">'+chips+'</div></div>';
  }
  h+='<div style="margin-bottom:10px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Para (uno o varios, separados por coma)</label><textarea id="repMailPara" rows="2" placeholder="destinatario@ejemplo.com, otro@ejemplo.com" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-2);color:var(--text-primary);resize:vertical"></textarea></div>';
  h+='<div style="margin-bottom:10px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">CC (opcional)</label><input id="repMailCC" placeholder="copia@ejemplo.com" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-2);color:var(--text-primary)"></div>';
  h+='<div style="margin-bottom:10px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Asunto</label><input id="repMailAsunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-2);color:var(--text-primary)"></div>';
  h+='<div style="margin-bottom:14px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Mensaje</label><textarea id="repMailCuerpo" rows="8" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;margin-top:3px;background:var(--surface-2);color:var(--text-primary);resize:vertical">'+_esc(cuerpo)+'</textarea></div>';
  h+='<div style="display:flex;gap:8px;justify-content:flex-end;flex-wrap:wrap">';
  h+='<button onclick="this.closest(\'div[style*=fixed]\').remove()" class="btn bg2">Cancelar</button>';
  h+='<button onclick="_repEnviarAutomatico()" class="btn bp"><i class="ti ti-send"></i> Enviar</button>';
  h+='</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ var ems=_repRutaEmails(); var pi=document.getElementById('repMailPara'); if(pi && !pi.value && ems.length){ pi.value=ems.join(', '); document.querySelectorAll('.rep-mail-chip').forEach(function(c){ if(ems.indexOf(c.getAttribute('data-email'))>=0){ c.style.background='var(--text-accent)'; c.style.color='#fff'; c.style.borderColor='var(--text-accent)'; } }); } }catch(e){}
}
// Descarga los archivos generados (para adjuntarlos manualmente)
function _repDescargarAdjuntos(){
  (_repMailFiles||[]).forEach(function(f){
    if(!f)return;
    var a=document.createElement('a'); a.href=URL.createObjectURL(f); a.download=f.name;
    document.body.appendChild(a); a.click(); a.remove(); setTimeout(function(){URL.revokeObjectURL(a.href);},1500);
  });
}
// Lee los campos del modal y devuelve {para,cc,asunto,cuerpo} normalizados
function _repDatosCorreo(){
  var para=(document.getElementById('repMailPara').value||'').trim();
  var cc=(document.getElementById('repMailCC').value||'').trim();
  var norm=function(s){ return s.split(/[,;\n]/).map(function(x){return x.trim();}).filter(Boolean).join(','); };
  return {
    para: norm(para),
    cc: norm(cc),
    asunto: (document.getElementById('repMailAsunto').value||'').trim(),
    cuerpo: (document.getElementById('repMailCuerpo').value||'')
  };
}
function _repCerrarModalCorreo(){
  var modal=document.querySelector('#repMailPara'); if(modal){ var m=modal.closest('div[style*=fixed]'); if(m)m.remove(); }
}
// Abre el correo PREDETERMINADO del equipo (mailto)
function _repEnviarCorreo(){
  _repDescargarAdjuntos();
  var d=_repDatosCorreo();
  var url='mailto:'+d.para+'?';
  if(d.cc) url+='cc='+d.cc+'&';
  url+='subject='+encodeURIComponent(d.asunto)+'&body='+encodeURIComponent(d.cuerpo);
  window.location.href=url;
  showT('Abriendo tu correo… adjunta los 2 archivos descargados');
  _repCerrarModalCorreo();
}
// ENVIAR AHORA: lleva al Mail/Outlook del usuario con TODO adjunto.
//  · Apple/móvil: usa la hoja de compartir (Web Share) que adjunta los archivos.
//  · Windows/otros: abre Outlook (web) con los archivos ya descargados para pegar.
async function _repEnviarAhora(){
  var files=_repMailFiles||[];
  if(files.length && navigator.canShare && navigator.canShare({files:files})){
    return _repCompartirAdjuntos();
  }
  return _repEnviarOutlook();
}
// Abre la redacción directamente en OUTLOOK (web) — Apple y Windows
function _repEnviarOutlook(){
  var d=_repDatosCorreo();
  // Deeplink de Outlook 365 (empresa). Si el usuario tuviera Outlook personal,
  // el mismo enlace lo redirige al login correcto.
  var url='https://outlook.office.com/mail/deeplink/compose?to='+encodeURIComponent(d.para)
    +'&subject='+encodeURIComponent(d.asunto)+'&body='+encodeURIComponent(d.cuerpo);
  if(d.cc) url+='&cc='+encodeURIComponent(d.cc);
  window.open(url,'_blank');
  showT('Abriendo Outlook… adjunta los 2 archivos descargados');
  _repCerrarModalCorreo();
}
// Carga JSZip (para empaquetar PDF+Excel en un solo adjunto)
var _jszipLoad=null;
function _ensureJSZip(){
  if(window.JSZip) return Promise.resolve(window.JSZip);
  if(_jszipLoad) return _jszipLoad;
  _jszipLoad=new Promise(function(res,rej){
    var s=document.createElement('script');
    s.src='https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
    s.onload=function(){res(window.JSZip);}; s.onerror=rej;
    document.head.appendChild(s);
  });
  return _jszipLoad;
}
// ═══════════════════════════════════════════════════════════════════════════
//  ENVÍO AUTOMÁTICO DE LA REPOSICIÓN — por la MISMA ruta de Azure que las etapas
//  Escribe en correos_queue con el formato que ya usa mailEnviar():
//    para_lista[] · adjuntos[{nombre, contenido(base64), mime}] · de_nombre · de_email
//  Así el worker (Microsoft Graph) lo manda igual que los demás correos del
//  portal, con el PDF y el Excel adjuntos de verdad y saliendo desde el correo
//  del usuario que lo genera.
// ═══════════════════════════════════════════════════════════════════════════

// Convierte un File a base64 puro (sin el prefijo "data:...;base64,")
function _repFileABase64(file){
  return new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
    fr.onerror=function(){ rej(new Error('No se pudo leer '+((file&&file.name)||'el archivo'))); };
    fr.readAsDataURL(file);
  });
}

function _repMimeDe(f){
  if(f && f.type) return f.type;
  var n=String((f&&f.name)||'').toLowerCase();
  if(n.slice(-4)==='.pdf')  return 'application/pdf';
  if(n.slice(-5)==='.xlsx') return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  if(n.slice(-4)==='.zip')  return 'application/zip';
  return 'application/octet-stream';
}

// Arma el arreglo `adjuntos` tal como lo espera el worker de Graph
async function _repAdjuntosInline(files){
  var out=[];
  for(var i=0;i<files.length;i++){
    var f=files[i]; if(!f) continue;
    out.push({ nombre:f.name, mime:_repMimeDe(f),
               contenido:await _repFileABase64(f), _kb:Math.round(f.size/1024) });
  }
  return out;
}
function _repAdjKb(adj){ return (adj||[]).reduce(function(a,x){ return a+(x._kb||0); },0); }

// Espera a que el worker lo marque como enviado (mismo criterio que _mailSeguir)
function _repSeguirCorreo(id, nDest){
  if(!id){ showT('✓ Correo en cola — saldrá en unos segundos'); return; }
  var intentos=0;
  var timer=setInterval(async function(){
    if(++intentos>20){
      clearInterval(timer);
      showT('El correo sigue en cola; saldrá en cuanto el sync lo procese');
      return;
    }
    try{
      var r=await fetch(SB+'/rest/v1/correos_queue?select=estado,error_msg&id=eq.'+id+'&limit=1',{headers:SBH});
      var f=r.ok?(await r.json()):[];
      var row=(f&&f[0])||null; if(!row) return;
      if(row.estado==='enviado'){
        clearInterval(timer);
        showT('✅ Enviado a '+nDest+' destinatario(s) con el PDF y el Excel');
      }else if(row.estado==='error'){
        clearInterval(timer);
        showT('⚠ No se pudo enviar: '+(row.error_msg||'sin detalle'));
      }
    }catch(e){}
  },2500);
}

async function _repEnviarAutomatico(){
  var files=(_repMailFiles||[]).filter(Boolean);
  if(!files.length){ showT('No hay archivos para enviar'); return; }
  var d=_repDatosCorreo();
  if(!d.para){ showT('Escribe o elige al menos un destinatario'); return; }
  if(!(d.asunto||'').trim()){ showT('Escribe un asunto'); return; }

  var listaPara=d.para.split(',').map(function(s){return s.trim();}).filter(Boolean);
  var listaCC  =(d.cc||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
  var todos=listaPara.concat(listaCC);
  var destinatarios=todos.join(',');
  var code=_repCard||'reposicion';

  showT('Preparando envío con adjuntos…');
  try{
    // 1) PDF + Excel como adjuntos en línea (base64), igual que en las etapas
    var adjuntos=await _repAdjuntosInline(files);
    var enviados=files.slice();

    // 2) Si pasan del límite de Graph, se empaquetan en un solo ZIP
    if(_repAdjKb(adjuntos)/1024 > MAIL_MAX_MB && files.length>1){
      try{
        var JSZ=await _ensureJSZip();
        var zip=new JSZ();
        files.forEach(function(f){ zip.file(f.name, f); });
        var blob=await zip.generateAsync({type:'blob', compression:'DEFLATE'});
        var nombreZip='Reposicion_'+code+'_'+new Date().toISOString().slice(0,10)+'.zip';
        var zipFile=new File([blob], nombreZip, {type:'application/zip'});
        var zipAdj=await _repAdjuntosInline([zipFile]);
        if(_repAdjKb(zipAdj)/1024 <= MAIL_MAX_MB){ adjuntos=zipAdj; enviados=[zipFile]; }
      }catch(e){ console.warn('ZIP reposición:', e); }
    }

    // 3) Si ni comprimido cabe, mejor avisar que mandar el correo sin los archivos
    if(_repAdjKb(adjuntos)/1024 > MAIL_MAX_MB){
      showT('⚠ Los adjuntos pesan '+(_repAdjKb(adjuntos)/1024).toFixed(1)+' MB y el límite son '
            +MAIL_MAX_MB+' MB. Quita algún archivo o mándalos por separado.');
      return;
    }

    // 4) Copia en el storage, solo para el seguimiento de reposiciones (no bloquea)
    // Se guardan TODOS los archivos, no solo el primero: compras necesita
    // reenviar el PDF y el Excel al proveedor, y antes solo quedaba uno.
    var adjPath=null, adjNombre=enviados[0]?enviados[0].name:null;
    var adjTodos=[];
    try{
      for(var _a=0;_a<enviados.length;_a++){
        var _p=await _subirDocStorage('reposicion', code, enviados[_a]);
        if(!_p) continue;
        adjTodos.push({path:_p, nombre:enviados[_a].name});
        if(!adjPath){ adjPath=_p; adjNombre=enviados[_a].name; }
      }
    }catch(e){ console.warn('subir adjuntos de la reposición:',e); }
    try{ if(!adjPath) adjPath=await _subirDocStorage('reposicion', code, enviados[0]); }
    catch(e){ console.warn('storage reposición:', e); }

    // 5) Misma fila que los correos de las etapas → mismo envío por Azure
    var bodyBase={
      docnum: 'REP-'+code,
      para_lista: todos,
      para_email: todos[0],              // compatibilidad con lo anterior
      asunto: d.asunto,
      cuerpo: _repCuerpoTexto(d.cuerpo),
      adjuntos: adjuntos.map(function(a){
        return {nombre:a.nombre, contenido:a.contenido, mime:a.mime};
      }),
      de_nombre: (CU&&CU.name)||'',
      de_email:  (CU&&CU.email)||'',
      origen: 'Reposición · '+code,
      estado: 'pendiente'
    };
    // Columnas extra propias de reposiciones; si la tabla no las tiene, se reintenta sin ellas
    // OJO: NO se mandan aquí adjunto_path / adjunto_nombre. El worker adjuntaba
    // ese archivo ADEMÁS de los de `adjuntos`, y por eso el PDF llegaba 2 veces.
    // La copia en el storage se sigue guardando, pero solo para el seguimiento.
    var bodyFull=Object.assign({}, bodyBase, {
      proveedor: code,
      creado_por: (CU&&CU.name)||''
    });

    function _postCola(bodyObj){
      return fetch(SB+'/rest/v1/correos_queue',{
        method:'POST',
        headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(bodyObj)
      });
    }

    var r=await _postCola(bodyFull);
    if(!r.ok){
      var t0=await r.text();
      console.warn('correos_queue (columnas extra) falló, reintento sin ellas:', r.status, t0);
      r=await _postCola(bodyBase);
    }

    if(r.ok){
      var creado=null; try{ creado=await r.json(); }catch(e){}
      var filaId=(creado&&creado[0]&&creado[0].id)||null;
      // Si se está corrigiendo una reposición ya enviada, se actualiza esa
      // misma en vez de crear otra: si no, quedaban dos en el seguimiento.
      var _mod=window._repModificando;
      if(_mod && String(_mod.cardcode)===String(code)){
        try{
          await _firmaWrite(SB+'/rest/v1/reposiciones_envios?id=eq.'+_mod.id,'PATCH',{
            archivo_path:adjPath||null, archivo_nombre:adjNombre||null,
            archivos:(adjTodos&&adjTodos.length)?JSON.stringify(adjTodos):null,
            mail_asunto:(d&&d.asunto)||'', mail_cuerpo:(d&&d.cuerpo)||'',
            modificado_en:new Date().toISOString(),
            modificado_por:(CU&&CU.name)||''
          },['modificado_en']);
          showT('✓ Reposición corregida · ya puedes enviarla al proveedor');
          _repModificandoFin();
        }catch(e){ console.warn('actualizar reposición:',e); }
      } else {
        try{ await _repRegistrarEnvio(code, adjPath, adjNombre, d, destinatarios, adjTodos); }
        catch(e){ console.warn('registro envio rep:',e); }
      }
      showT('Enviando…');
      _repCerrarModalCorreo();
      _repSeguirCorreo(filaId, todos.length);
      setTimeout(function(){ try{ _repBadgeActualizar(); }catch(e){} }, 1500);
    } else {
      var t=await r.text(); console.error('correos_queue reposicion:', r.status, t);
      showT('⚠ No se pudo encolar. Revisa correos_queue.');
    }
  }catch(e){
    console.error('envío automático:', e);
    showT('⚠ Error al enviar: '+(e.message||e));
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  HELPERS DE LA REPOSICIÓN EN INGLÉS (RE-ORDER)
//  · Descripción: se usa el Foreign Name de SAP (frgnname). Si el item no lo
//    tiene, cae al itemname para no dejar la línea vacía.
//  · Colores: campo definido por usuario.
//  · Nombre de archivo: RE-ORDER P1276 270726 15-28
//    (se usa "-" en la hora porque Windows no permite ":" en nombres de archivo)
// ═══════════════════════════════════════════════════════════════════════════
function _repDescEN(x){
  return String((x && (x.frgnname || x.itemname)) || '').trim();
}
// ── Traducción de la columna Colors al inglés ──
// El campo de usuario viene cargado en español desde SAP. Lo que no esté en el
// diccionario se deja tal cual (puede ser un código o un color ya en inglés).
var _REP_COLOR_EN={
  // básicos
  'negro':'Black','negra':'Black','blanco':'White','blanca':'White',
  'gris':'Grey','plomo':'Grey','rojo':'Red','roja':'Red','azul':'Blue',
  'verde':'Green','amarillo':'Yellow','amarilla':'Yellow',
  'naranja':'Orange','anaranjado':'Orange','naranjado':'Orange',
  'morado':'Purple','purpura':'Purple','violeta':'Violet','lila':'Lilac',
  'rosa':'Pink','rosado':'Pink','rosada':'Pink','fucsia':'Fuchsia',
  'cafe':'Brown','marron':'Brown','carmelita':'Brown','chocolate':'Chocolate',
  'beige':'Beige','crema':'Cream','hueso':'Ivory','marfil':'Ivory',
  'dorado':'Gold','oro':'Gold','plateado':'Silver','plata':'Silver',
  'bronce':'Bronze','cobre':'Copper','niquel':'Nickel','cromo':'Chrome','cromado':'Chrome',
  'turquesa':'Turquoise','celeste':'Light Blue','aqua':'Aqua','agua':'Aqua',
  'vino':'Burgundy','borgona':'Burgundy','granate':'Maroon',
  'mostaza':'Mustard','coral':'Coral','menta':'Mint','salmon':'Salmon',
  'durazno':'Peach','ocre':'Ochre','arena':'Sand','terracota':'Terracotta',
  'transparente':'Clear','translucido':'Translucent','natural':'Natural',
  'madera':'Wood','bambu':'Bamboo','acero':'Steel','inoxidable':'Stainless',
  'multicolor':'Multicolor','surtido':'Assorted','surtidos':'Assorted',
  'surtida':'Assorted','surtidas':'Assorted','varios':'Assorted','colores':'Colors',
  // compuestos frecuentes
  'azul marino':'Navy Blue','azul rey':'Royal Blue','azul cielo':'Sky Blue',
  'azul claro':'Light Blue','azul oscuro':'Dark Blue',
  'verde oliva':'Olive Green','verde limon':'Lime Green','verde agua':'Aqua Green',
  'verde claro':'Light Green','verde oscuro':'Dark Green',
  'gris claro':'Light Grey','gris oscuro':'Dark Grey','gris perla':'Pearl Grey',
  'blanco mate':'Matt White','negro mate':'Matt Black','acero inoxidable':'Stainless Steel',
  'colores surtidos':'Assorted Colors','color natural':'Natural'
};
var _REP_MODIF_EN={ 'claro':'Light','clara':'Light','oscuro':'Dark','oscura':'Dark',
                    'mate':'Matt','brillante':'Glossy','metalico':'Metallic','pastel':'Pastel' };

function _repNorm(s){
  return String(s||'').toLowerCase().trim()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')   // quitar acentos
    .replace(/\s+/g,' ');
}
function _repCapitalizar(s){
  return String(s||'').replace(/\S+/g,function(w){ return w.charAt(0).toUpperCase()+w.slice(1); });
}
// Traduce un color suelto (puede venir con modificador: "gris claro")
function _repColorUno(txt){
  var n=_repNorm(txt); if(!n) return '';
  if(_REP_COLOR_EN[n]) return _REP_COLOR_EN[n];
  var pal=n.split(' ');
  var base=[], mods=[], reconocidos=0;
  pal.forEach(function(w){
    if(w==='y'||w==='con'||w==='de'||w==='color') return;
    if(_REP_MODIF_EN[w]){ mods.push(_REP_MODIF_EN[w]); reconocidos++; }
    else if(_REP_COLOR_EN[w]){ base.push(_REP_COLOR_EN[w]); reconocidos++; }
    else base.push(w);
  });
  // Si no se reconoció nada es un código o un texto propio: se deja tal cual
  if(!reconocidos) return String(txt).trim();
  var out=mods.concat(base).join(' ').trim();
  return out || String(txt).trim();
}
// Traduce el valor completo, respetando separadores: "negro / blanco y gris"
function _repColorEN(txt){
  var s=String(txt||'').trim(); if(!s) return '';
  var partes=s.split(/\s*[\/,;+|]\s*|\s+y\s+|\s+con\s+|\s+&\s+/i).filter(function(x){ return String(x).trim(); });
  if(partes.length<=1) return _repColorUno(s);
  return partes.map(_repColorUno).filter(Boolean).join(' / ');
}

function _repColores(x){
  return _repColorEN(String((x && x.colores) || '').trim());
}
function _repNum(n){ return Number(n||0).toLocaleString('en-US'); }
// Fecha larga en inglés: July 27, 2026
function _repFechaEN(d){
  return (d||new Date()).toLocaleDateString('en-US',{month:'long', day:'numeric', year:'numeric'});
}
// Sello DDMMYY HH-MM usado en el nombre de archivo
function _repSelloArchivo(d){
  d = d || new Date();
  var p=function(n){ return String(n).padStart(2,'0'); };
  return p(d.getDate())+p(d.getMonth()+1)+String(d.getFullYear()).slice(-2)
       + ' ' + p(d.getHours())+'-'+p(d.getMinutes());
}
function _repNombreArchivo(ext, d){
  return 'RE-ORDER '+(_repNumRepo?(_repNumRepo+' '):'')+(_repCard||'')+' '+_repSelloArchivo(d)+'.'+ext;
}

// Pinta el número de reposición en la pantalla, si hay dónde
function _repPintarNumero(){
  var el=document.getElementById('repNumRepo');
  if(!el) return;
  if(_repNumRepo){
    el.innerHTML='<span title="Número de esta reposición. Va en el PDF, el Excel, '
      +'el asunto y el cuerpo del correo." style="background:var(--pastel-lila);border:1px solid #C4B5FD;'
      +'color:var(--t-lila);border-radius:12px;padding:3px 11px;font-size:13px;font-weight:800;'
      +'margin-right:9px">'+_esc(_repNumRepo)+'</span>';
  } else if(window._repSinColumna){
    // Se muestra el motivo real y se puede reintentar sin recargar
    el.innerHTML='<span onclick="_repReintentarNumero()" title="'
      +_esc(window._repNumError||'No se pudo asignar el número')
      +' — clic para reintentar" style="cursor:pointer;background:var(--pastel-aviso);'
      +'border:1px solid #E9C08A;color:var(--t-marron);border-radius:12px;padding:3px 11px;'
      +'font-size:11.5px;font-weight:700;margin-right:9px">'
      +'<i class="ti ti-refresh"></i> sin número · reintentar</span>';
  } else {
    el.innerHTML='';
  }
}

// Reintenta a mano, sin recargar la página
async function _repReintentarNumero(){
  window._repSinColumna=false;
  showT('Buscando número de reposición…');
  var n=await _repAsegurarNumero();
  showT(n ? ('✓ Esta reposición es la '+n)
          : ('No se pudo: '+(window._repNumError||'revisa la columna num_reposicion')), 6000);
}

// Se asegura de que esta reposición tenga número, aunque el pedido se haya
// creado antes de que existiera el consecutivo.
async function _repAsegurarNumero(){
  if(_repNumRepo) return _repNumRepo;

  // Antes de sacar uno nuevo hay que preguntarle al pedido si YA tiene el
  // suyo. Si no, una reposición podía quedarse con dos números distintos:
  // el pedido con el que se le asignó al guardarlo y el envío con otro
  // sacado más tarde, cuando la página ya no lo recordaba.
  if(_repPedidoId){
    try{
      var rp=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=num_reposicion&id=eq.'
        +encodeURIComponent(_repPedidoId)+'&limit=1',{headers:SBH});
      if(rp.ok){
        var dp=await rp.json()||[];
        var ya=dp.length?String(dp[0].num_reposicion||'').trim():'';
        if(ya){
          _repNumRepo=ya;
          try{ _repPintarNumero(); }catch(e){}
          return _repNumRepo;
        }
      }
    }catch(e){ console.warn('[reposición] leer el número del pedido:', e); }
  }

  var n='';
  try{ n=await _repSiguienteNumero(); }catch(e){}
  if(!n){ window._repSinColumna=true; try{ _repPintarNumero(); }catch(e){} return ''; }
  _repNumRepo=n;
  if(!_repPedidoId){
    // Sin pedido no hay dónde guardarlo ni líneas que comparar después
    try{ await _repGuardarPendiente(); }catch(e){}
  }
  if(_repPedidoId){
    try{
      var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+_repPedidoId,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({num_reposicion:_repNumRepo, actualizado_en:new Date().toISOString()})});
      if(!r.ok){
        console.warn('[reposición] no se pudo guardar el número:', r.status);
        _repNumRepo=''; window._repSinColumna=true;
      }
    }catch(e){ _repNumRepo=''; window._repSinColumna=true; }
  }
  try{ _repPintarNumero(); }catch(e){}
  return _repNumRepo;
}

// El cuerpo va en TEXTO PLANO. El worker (kennedy_live.py) lo escapa y lo
// convierte a HTML poniendo <br> en cada salto de línea, así que aquí solo hay
// que normalizar los saltos y quitar espacios sobrantes al final de cada línea.
function _repCuerpoTexto(txt){
  var t=String(txt==null?'':txt).replace(/\r\n/g,'\n').replace(/\r/g,'\n');
  return t.split('\n').map(function(l){ return l.replace(/\s+$/,''); }).join('\n');
}

// ── PDF del pedido de reposición (con foto y cantidad por línea) ──
async function repPedidoPDF(sel, returnBlob){
  if(!window.jspdf||!window.jspdf.jsPDF){ showT('No se pudo cargar el generador de PDF'); return; }
  showT('Generando pedido PDF con fotos…');
  var doc=new window.jspdf.jsPDF({unit:'pt',format:'letter',compress:true});
  var W=612, M=40, y=0, azul=[30,80,165];
  var COL_COLOR=M+300, COL_BULTO=M+410;   // posiciones de las columnas Colors y Carton
  var ahora=new Date();
  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var fecha=_repFechaEN(ahora);

  // Las fotos, por tandas
  var imgs=await _repCargarImgs(sel,
    function(x){ return _repFotoUrl(x.picturname); }, 10,
    function(n,t){ showT('Cargando fotos… '+n+'/'+t); });

  function header(pg){
    doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(0);
    doc.text(fecha, M, 38);
    doc.text('Page '+pg, W-M, 38, {align:'right'});
    doc.setFontSize(15); doc.setTextColor(azul[0],azul[1],azul[2]); doc.setFont('helvetica','bold');
    doc.text('KENNEDY CENTER CORP.', W/2, 56, {align:'center'});
    doc.setFontSize(12); doc.setTextColor(0);
    doc.text('RE-ORDER'+(_repNumRepo?('   '+_repNumRepo):''), W/2, 72, {align:'center'});
    doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.8); doc.line(M,78,W-M,78);
    doc.setFontSize(11);
    doc.text(code+'   '+cardname, W/2, 94, {align:'center'});
    doc.setLineWidth(1); doc.line(M,100,W-M,100);
    // Cabecera de columnas (en inglés)
    doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(80);
    doc.text('Photo', M, 116);
    doc.text('Code / Description', M+70, 116);
    doc.text('Colors', COL_COLOR, 116);
    doc.text('Carton', COL_BULTO, 116);
    doc.text('Quantity', W-M, 116, {align:'right'});
    doc.setDrawColor(180); doc.setLineWidth(0.5); doc.line(M,120,W-M,120);
    doc.setFont('helvetica','normal'); doc.setTextColor(0);
    return 130;
  }

  var page=1; y=header(page);
  var totalUnid=0, totalItems=0, totalBultos=0;

  sel.forEach(function(x){
    if(y+60>770){ doc.addPage(); page++; y=header(page); }
    var bulto=Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);
    var cant=x._cant;
    totalUnid+=cant; totalItems++;
    totalBultos+=cant/bulto;

    var rowY=y;
    // Foto
    var im=imgs[x.itemcode];
    if(im){
      try{
        var mw=46, mh=46, r=Math.min(mw/im.w, mh/im.h);
        doc.addImage(im.data,'JPEG', M, rowY-2, im.w*r, im.h*r);
      }catch(e){}
    } else {
      doc.setDrawColor(210); doc.rect(M, rowY-2, 46, 46);
    }
    // Código + descripción
    doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(azul[0],azul[1],azul[2]);
    doc.text(String(x.itemcode||''), M+70, rowY+8);
    doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(0);
    // Descripción en inglés (Foreign Name)
    var nombre=_repDescEN(x);
    doc.text(nombre.length>46?nombre.slice(0,46)+'...':nombre, M+70, rowY+20);
    // Colores
    var col=_repColores(x);
    if(col){
      doc.setFontSize(8); doc.setTextColor(60);
      doc.text(col.length>18?col.slice(0,18)+'...':col, COL_COLOR, rowY+12);
      doc.setTextColor(0);
    }
    // Bulto / carton
    doc.setFontSize(8);
    doc.text(String(bulto)+' pcs', COL_BULTO, rowY+12);
    // Cantidad (grande, azul)
    doc.setFont('helvetica','bold'); doc.setFontSize(13); doc.setTextColor(azul[0],azul[1],azul[2]);
    doc.text(String(cant), W-M, rowY+14, {align:'right'});
    doc.setFont('helvetica','normal'); doc.setTextColor(0);
    // Separador
    y=rowY+52;
    doc.setDrawColor(220); doc.setLineWidth(0.4); doc.line(M,y-4,W-M,y-4);
  });

  // Totales
  if(y+40>770){ doc.addPage(); page++; y=header(page); }
  totalBultos=Math.round(totalBultos*100)/100;
  doc.setDrawColor(azul[0],azul[1],azul[2]); doc.setLineWidth(1.5); doc.line(M,y,W-M,y); y+=18;
  doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(azul[0],azul[1],azul[2]);
  doc.text(_repNum(totalItems)+' references  -  '+_repNum(totalUnid)+' units  -  '+_repNum(totalBultos)+' cartons', M, y);
  doc.setFont('helvetica','normal'); doc.setTextColor(0);

  var nombrePDF=_repNombreArchivo('pdf', ahora);
  if(returnBlob){
    var blobPDF=doc.output('blob');
    return new File([blobPDF], nombrePDF, {type:'application/pdf'});
  }
  doc.save(nombrePDF);
  showT('✓ Pedido PDF generado');
}

// ── Excel del pedido de reposición (con fotos embebidas y cantidades) ──
// ── Cargar ExcelJS (para incrustar fotos, igual que el portal de ventas) ──
var _exceljsLoad=null;
function _ensureExcelJS(){
  if(window.ExcelJS) return Promise.resolve(window.ExcelJS);
  if(_exceljsLoad) return _exceljsLoad;
  _exceljsLoad=new Promise(function(res,rej){
    var sc=document.createElement('script');
    sc.src='https://cdnjs.cloudflare.com/ajax/libs/exceljs/4.4.0/exceljs.min.js';
    sc.onload=function(){ if(window.ExcelJS) res(window.ExcelJS); else rej(new Error('ExcelJS no disponible')); };
    sc.onerror=function(){ rej(new Error('No se pudo cargar la librería de Excel (revisa la conexión)')); };
    document.head.appendChild(sc);
  });
  return _exceljsLoad;
}
// Descarga una imagen y la devuelve como {b64, ext} para incrustarla en Excel
// Baja una imagen y la COMPRIME antes de meterla en el archivo.
// Las fotos del bucket pesan 150-400 KB cada una; en un PDF o Excel de 200
// artículos eso son decenas de MB. Reducidas a 340 px pesan ~15 KB y en el
// papel o la celda se ven igual.
async function _repImgToB64(url, lado, calidad){
  lado=lado||340; calidad=(calidad==null?0.62:calidad);
  try{
    var img=await new Promise(function(res,rej){
      var im=new Image();
      im.crossOrigin='anonymous';
      im.onload=function(){ res(im); };
      im.onerror=function(){ rej(new Error('no carga')); };
      im.src=url;
      setTimeout(function(){ rej(new Error('tardó demasiado')); }, 30000);
    });
    var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
    if(!w || !h) return null;
    // Si ya es chica, no se agranda
    var esc=Math.min(1, lado/Math.max(w,h));
    var cw=Math.max(1,Math.round(w*esc)), ch=Math.max(1,Math.round(h*esc));
    var cv=document.createElement('canvas');
    cv.width=cw; cv.height=ch;
    var cx=cv.getContext('2d');
    cx.fillStyle='#ffffff';       // los PNG transparentes saldrían negros en JPEG
    cx.fillRect(0,0,cw,ch);
    cx.drawImage(img,0,0,cw,ch);
    var b64=cv.toDataURL('image/jpeg', calidad).split(',')[1]||null;
    return b64?{b64:b64, ext:'jpeg', kb:Math.round(b64.length*0.75/1024)}:null;
  }catch(e){
    // Si el canvas falla (por ejemplo por CORS), se usa el original
    try{
      var _ac=new AbortController(); var _to=setTimeout(function(){try{_ac.abort();}catch(_){}} ,7000);
      var r; try{ r=await fetch(url,{mode:'cors',signal:_ac.signal}); } finally { clearTimeout(_to); }
      if(!r.ok) return null;
      var blob=await r.blob();
      var ty=(blob.type||'').toLowerCase();
      var ext = ty.indexOf('png')>=0?'png' : (ty.indexOf('gif')>=0?'gif' : 'jpeg');
      var b2=await new Promise(function(res){
        var fr=new FileReader();
        fr.onload=function(){ res(String(fr.result).split(',')[1]||null); };
        fr.onerror=function(){ res(null); };
        fr.readAsDataURL(blob);
      });
      return b2?{b64:b2, ext:ext, kb:Math.round(b2.length*0.75/1024)}:null;
    }catch(e2){ return null; }
  }
}


async function repPedidoExcel(sel, returnBlob){
  showT('Generando Excel con fotos…');
  var ExcelJS;
  try{ ExcelJS=await _ensureExcelJS(); }
  catch(e){ showT('No se pudo cargar Excel'); return; }

  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var verC=CU.verCostos;
  var _repXlsAhora=new Date();

  // Definir columnas (la primera es la foto)
  var cols=[
    {label:'Photo', width:9, foto:true},
    {label:'Code', width:14},
    {label:'Description', width:44},
    {label:'Colors', width:18},
    {label:'Quantity', width:12, numFmt:'#,##0'},
    {label:'Carton (pcs)', width:13, numFmt:'#,##0'},
    {label:'Cartons', width:10, numFmt:'#,##0.00'}
  ];
  var nc=cols.length;

  // Precargar fotos (base64) en paralelo
  var urls=sel.map(function(x){ return _repFotoUrl(x.picturname); });
  var imgMap={};
  // Por tandas, para no saturar al navegador con cientos de descargas
  for(var _i=0;_i<urls.length;_i+=10){
    var _lote=urls.slice(_i,_i+10);
    await Promise.all(_lote.map(function(u){
      if(!u) return Promise.resolve();
      return _repImgToB64(u).then(function(im){ imgMap[u]=im; });
    }));
    if(_i%40===0) showT('Cargando fotos… '+Math.min(_i+10,urls.length)+'/'+urls.length);
  }

  var wb=new ExcelJS.Workbook();
  var ws=wb.addWorksheet('Re-order', {views:[{state:'frozen', ySplit:4}]});

  // ── Título (fila 1) ──
  ws.mergeCells(1,1,1,nc);
  var c1=ws.getCell(1,1);
  c1.value='RE-ORDER '+(_repNumRepo?(_repNumRepo+' '):'')+'— KENNEDY CENTER CORP.';
  c1.font={bold:true, size:15, color:{argb:'FFFFFFFF'}};
  c1.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FF1E50A5'}};
  c1.alignment={vertical:'middle', horizontal:'center'};
  ws.getRow(1).height=26;

  // ── Subtítulo (fila 2) ──
  ws.mergeCells(2,1,2,nc);
  var c2=ws.getCell(2,1);
  c2.value=code+(cardname?('  —  '+cardname):'')+'     ·     '+_repFechaEN(_repXlsAhora)+'     ·     '+_repNum(sel.length)+' references';
  c2.font={size:10, bold:true, color:{argb:'FF1E50A5'}};
  c2.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEFF4FB'}};
  c2.alignment={vertical:'middle', horizontal:'center'};
  ws.getRow(2).height=18;
  // Fila 3 vacía de separación
  ws.getRow(3).height=4;

  // ── Cabecera de columnas (fila 4) con color distinto ──
  cols.forEach(function(c,ci){
    var h=ws.getCell(4,ci+1);
    h.value=c.label;
    h.font={bold:true, size:11, color:{argb:'FFFFFFFF'}};
    h.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFB45309'}}; // naranja Kennedy
    h.alignment={vertical:'middle', horizontal:'center'};
    h.border={bottom:{style:'thin',color:{argb:'FF9A4A08'}}};
    var col=ws.getColumn(ci+1); col.width=c.width||14; if(c.numFmt) col.numFmt=c.numFmt;
  });
  ws.getRow(4).height=20;

  // ── Filas de items ──
  sel.forEach(function(x, ri){
    var rowNum=5+ri;
    var bulto=Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);
    var vals=[
      '', // foto (columna 1) — se incrusta como imagen
      x.itemcode||'',
      _repDescEN(x),          // descripción en inglés (Foreign Name)
      _repColores(x),         // campo definido por usuario "Colores"
      Number(x._cant)||0,
      bulto,
      Math.round((x._cant/bulto)*100)/100
    ];
    vals.forEach(function(v,ci){
      var cell=ws.getCell(rowNum,ci+1);
      if(ci>0) cell.value=v;   // la col 0 es la foto
      cell.alignment={vertical:'middle', horizontal:(ci>=4?'center':'left'), wrapText:(ci===2||ci===3)};
      // Zebra: filas alternas con fondo suave
      if(ri%2===1) cell.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFF7F7F7'}};
      cell.border={bottom:{style:'hair',color:{argb:'FFDDDDDD'}}};
    });
    // Incrustar foto
    ws.getRow(rowNum).height=48;
    var u=_repFotoUrl(x.picturname); var im=u?imgMap[u]:null;
    if(im && im.b64){
      var id=wb.addImage({base64:im.b64, extension:im.ext});
      ws.addImage(id, { tl:{col:0.12, row:(rowNum-1)+0.10}, ext:{width:56,height:56}, editAs:'oneCell' });
    }
  });

  // ── Fila de totales ──
  var totRow=5+sel.length;
  var totUnid=sel.reduce(function(s,x){return s+(Number(x._cant)||0);},0);
  var totBultos=sel.reduce(function(s,x){var b=Math.max(1,Number(x.u_cxblt)||Number(x.salpackun)||1);return s+(x._cant/b);},0);
  totBultos=Math.round(totBultos*100)/100;
  ws.mergeCells(totRow,1,totRow,4);
  var tc=ws.getCell(totRow,1);
  tc.value='TOTAL: '+_repNum(sel.length)+' references';
  tc.font={bold:true, color:{argb:'FF1E50A5'}};
  tc.alignment={vertical:'middle', horizontal:'right'};
  var tCant=ws.getCell(totRow,5); tCant.value=totUnid; tCant.font={bold:true}; tCant.numFmt='#,##0'; tCant.alignment={horizontal:'center'};
  var tBlt=ws.getCell(totRow,7); tBlt.value=totBultos; tBlt.font={bold:true,color:{argb:'FF6D28D9'}}; tBlt.numFmt='#,##0.00'; tBlt.alignment={horizontal:'center'};
  ws.getRow(totRow).height=20;

  var buf=await wb.xlsx.writeBuffer();
  var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  var nombreXLS=_repNombreArchivo('xlsx', _repXlsAhora);
  if(returnBlob){
    return new File([blob], nombreXLS, {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  }
  var a=document.createElement('a');
  a.href=URL.createObjectURL(blob);
  a.download=nombreXLS;
  document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
  showT('✓ Pedido Excel generado con fotos');
}

// ── HTML imprimible del pedido, con fotos embebidas (se abre para imprimir/guardar) ──
function repPedidoHTML(sel, imgs){
  var code=_repCard, cardname=(_repData[0]&&_repData[0].cardname)||'';
  var fecha=new Date().toLocaleDateString('es');
  var filas=sel.map(function(x){
    var disp=(Number(x.onhand)||0)-(Number(x.iscommited)||0);
    var bulto=Math.max(1, Number(x.u_cxblt)||Number(x.salpackun)||1);
    var img=imgs[x.itemcode];
    return '<tr>'
      +'<td style="text-align:center">'+(img?'<img src="'+img+'" style="width:60px;height:60px;object-fit:cover;border:1px solid #ccc">':'—')+'</td>'
      +'<td><b>'+_esc(x.itemcode)+'</b><br><span style="font-size:11px">'+_esc(x.itemname||'')+'</span>'
        +((x.u_color||x.u_tamano)?'<br><span style="font-size:10px;color:#666">'+[x.u_color,x.u_tamano].filter(Boolean).join(' · ')+'</span>':'')+'</td>'
      +'<td style="text-align:right">'+_fmtN2(disp)+'</td>'
      +'<td style="text-align:center">'+bulto+' pz</td>'
      +'<td style="text-align:right;font-size:16px;font-weight:bold;color:#1e50a5">'+x._cant+'</td>'
      +'</tr>';
  }).join('');
  var totalUnid=sel.reduce(function(s,x){return s+x._cant;},0);
  var html='<!DOCTYPE html><html><head><meta charset="utf-8"><title>Pedido '+_esc(code)+'</title>'
    +'<style>body{font-family:Arial,sans-serif;margin:24px;color:var(--text-primary)}h1{color:#1e50a5;text-align:center;margin:0}h2{text-align:center;font-weight:normal;margin:4px 0}'
    +'table{width:100%;border-collapse:collapse;margin-top:16px}th{background:#1e50a5;color:#fff;padding:8px;font-size:12px}td{border-bottom:1px solid #ddd;padding:8px;font-size:12px}'
    +'.tot{margin-top:16px;text-align:right;font-size:14px;font-weight:bold;color:#1e50a5}</style></head><body>'
    +'<h1>KENNEDY CENTER CORP.</h1><h2>PEDIDO DE REPOSICIÓN</h2>'
    +'<p style="text-align:center">'+_esc(code)+' — '+_esc(cardname)+' · '+fecha+'</p>'
    +'<table><thead><tr><th>Foto</th><th>Código / Descripción</th><th>Disp.</th><th>Bulto</th><th>Cantidad</th></tr></thead>'
    +'<tbody>'+filas+'</tbody></table>'
    +'<div class="tot">'+sel.length+' items · '+totalUnid+' unidades</div>'
    +'<div style="margin-top:20px;text-align:center"><button onclick="window.print()" style="padding:8px 16px;background:#1e50a5;color:#fff;border:none;border-radius:6px;cursor:pointer">Imprimir / Guardar PDF</button></div>'
    +'</body></html>';
  var w=window.open('','_blank');
  if(w){ w.document.write(html); w.document.close(); }
}


function setAlDept(d){dAdept=d;rAlertas();}
function setAlUser(u){dAuser=u;rAlertas();}
function alCard(a){const key=`${a.oid}_${a.role}`;const recs=recordatorios[key]||[];const labelRole={compras:'Compras',contabilidad:'Contabilidad',diseno:'Diseño',gerencia:'Gerencia',importacion:'Importación',bodega:'Bodega'}[a.role]||a.role;return`<div class="al-card"><div class="al-hdr"><div class="al-dot" style="background:${a.color}"></div><div class="al-body"><div style="font-size:12px;font-weight:500">${a.o.prov} — ${a.oid}</div><div style="font-size:11px;color:var(--text-secondary);margin-top:2px">${dL(a.dept)} · ${a.o.desc}</div><div style="font-size:11px;color:var(--text-muted);margin-top:2px">${a.msg}</div><div style="display:flex;gap:5px;margin-top:4px;flex-wrap:wrap"><span style="font-size:10px;background:${a.color}22;color:${a.color};padding:1px 7px;border-radius:8px;border:0.5px solid ${a.color}55">Responsable: ${labelRole}</span><span style="font-size:10px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:1px 7px;color:var(--text-muted)">${EMOJIS2[a.dept]||''} ${dL(a.dept)}</span></div>${recs.length?`<div style="font-size:10px;color:var(--text-success);margin-top:4px;display:flex;align-items:center;gap:4px"><i class="ti ti-send" style="font-size:10px"></i>${recs.length} recordatorio${recs.length>1?'s':''} enviado${recs.length>1?'s':''} · Último: ${recs[recs.length-1].date}</div>`:''}</div></div><div class="al-actions"><button class="btn bg2" style="font-size:11px;padding:4px 10px" onclick="openDetail('${a.oid}')"><i class="ti ti-eye"></i>Ver orden</button>${CU.role==='gerencia'?`<button class="btn brem" onclick="sendRecordatorio('${a.oid}','${a.role}','${labelRole}')"><i class="ti ti-bell"></i>Enviar recordatorio</button>`:''}</div></div>`;}
function sendRecordatorio(oid,role,labelRole){const o=orders.find(x=>x.id===oid);if(!o)return;document.getElementById('qmc').innerHTML=`<div style="font-size:14px;font-weight:500;margin-bottom:4px">Enviar recordatorio</div><div style="font-size:12px;color:var(--text-muted);margin-bottom:12px">Para: <strong>${labelRole}</strong> · ${o.prov} — ${oid}</div><textarea id="rem-msg" class="cin" rows="3" style="width:100%;font-size:12px;margin-bottom:10px" placeholder="Escribe el mensaje del recordatorio...">Por favor atender urgentemente la alerta en la orden ${oid} de ${dL(o.dept)}.</textarea><div style="display:flex;gap:8px;justify-content:flex-end"><button class="btn bg2" onclick="CQM()">Cancelar</button><button class="btn bp" onclick="confirmarRecordatorio('${oid}','${role}')"><i class="ti ti-send"></i>Enviar</button></div>`;document.getElementById('qmodal').style.display='flex';}
function confirmarRecordatorio(oid,role){const msg=document.getElementById('rem-msg')?.value.trim();if(!msg)return;const key=`${oid}_${role}`;if(!recordatorios[key])recordatorios[key]=[];recordatorios[key].push({by:CU.name,date:dateOnly(),msg});addNotif(role,`📣 Recordatorio de ${CU.name}: ${msg}`,oid,'ti-bell');CQM();showT(`✓ Recordatorio enviado a ${role}`);rAlertas();renderNP();}
function CQM(){document.getElementById('qmodal').style.display='none';}
// ═══════════════════════════════════════════════════════════════════════════
//  COMPRAS PARA FIRMA — subir PDF/Excel, autollenar con AI, firma de gerencia
//  dibujada que queda estampada en el PDF, y notificación al comprador.
//  Requiere la tabla Supabase: ordenes_firma (ver SQL entregado).
// ═══════════════════════════════════════════════════════════════════════════
var _firmaArchivo=null, _firmaPendCount=0;
function _fv(id){ var el=document.getElementById(id); return el?String(el.value||'').trim():''; }
function _sv(id,v){ var el=document.getElementById(id); if(el) el.value=v; }
function _fileToBase64(f){ return new Promise(function(res,rej){ var r=new FileReader(); r.onload=function(){ var t=String(r.result||''); res(t.slice(t.indexOf(',')+1)); }; r.onerror=rej; r.readAsDataURL(f); }); }
function _dataURLtoUint8(d){ var b=atob(d.split(',')[1]); var a=new Uint8Array(b.length); for(var i=0;i<b.length;i++)a[i]=b.charCodeAt(i); return a; }
function _firmaCorreoDe(uid){ var u=(USERS||[]).find(function(x){return x.id===uid;}); return u?u.email:''; }
function _ensurePdfLib(){
  if(window.PDFLib) return Promise.resolve(window.PDFLib);
  if(window._pdflibLoad) return window._pdflibLoad;
  window._pdflibLoad=new Promise(function(res,rej){ var s=document.createElement('script'); s.src='https://cdnjs.cloudflare.com/ajax/libs/pdf-lib/1.17.1/pdf-lib.min.js'; s.onload=function(){res(window.PDFLib);}; s.onerror=rej; document.head.appendChild(s); });
  return window._pdflibLoad;
}
function _ffld(id,label,type,ph){ return '<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">'+label+'</label><input id="'+id+'" type="'+type+'" class="fi2" placeholder="'+ph+'"></div>'; }

function rNueva(){ var cont=document.getElementById('page-nueva'); if(!cont) return; if(CU.role==='gerencia') _firmaRenderGerencia(cont); else _firmaRenderCompras(cont); }

function _firmaRenderCompras(cont){
  var deptOpts=_deptAcotado()
    ? _deptsVisibles().map(function(d,i){
        return '<option value="'+d+'"'+(i===0?' selected':'')+'>'+dL(d)+'</option>'; }).join('')
    : DEPTS_ALL.map(function(d){return '<option value="'+d+'">'+dL(d)+'</option>';}).join('');
  cont.innerHTML=''
    +'<div style="font-size:13px;font-weight:600;margin-bottom:6px"><i class="ti ti-writing"></i> Nueva compra para firma</div>'
    +'<div style="font-size:12px;color:var(--text-muted);background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:var(--radius);padding:8px 10px;margin-bottom:12px"><i class="ti ti-info-circle"></i> Sube el PDF con <b>las dos órdenes</b> (la nuestra y la del proveedor) y usa <b>AI</b> para rellenar los datos. La AI identifica cuál es cuál por el logo de Kennedy Center, las compara línea por línea y te avisa de cualquier diferencia. Al enviar, gerencia firma ambas y te llega el archivo firmado.</div>'
    +'<div style="display:flex;flex-direction:column;gap:7px;margin-bottom:8px">'
      +_nsapCajaArchivo('fprov','PI PROVEEDOR','Proforma Invoice del proveedor','#B45309','#FEF9F3','#E9C08A')
      +_nsapCajaArchivo('fkcc','KCC ORDEN DE COMPRA','Nuestra orden de compra','#0c447c','#e6f1fb','#85B7EB')
    +'</div>'
    +'<div style="margin-bottom:8px">'
      +'<button class="btn bp" onclick="_firmaAI()" style="background:#6D28D9"><i class="ti ti-sparkles"></i> AI rellenar y revisar</button>'
    +'</div>'
    +'<div id="firma-ai-status" style="font-size:11px;color:var(--text-muted);margin-bottom:6px"></div>'
    +'<div id="firma-ai-errores" style="margin-bottom:10px"></div>'
    +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:10px">'
      +_ffld('firma-orden','No. de orden (DKC / SKC) *','text','Ej: DKC-25090 o SKC-25090')
      +_ffld('firma-prov','Proveedor *','text','Nombre del proveedor')
      +'<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Departamento *</label><select id="firma-dept" class="fi2" '+((_deptAcotado()&&_deptsVisibles().length===1)?'disabled':'')+'>'+deptOpts+'</select></div>'
      +_ffld('firma-desc','Descripción *','text','Ej: Sofás esquineros')
      +_ffld('firma-monto','Monto total (USD) *','number','0.00')
      +_ffld('firma-uni','Unidades','number','0')
      +_ffld('firma-fecha','Fecha estimada (campo Date del archivo)','date','')
    +'</div>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-bottom:16px"><button class="btn bp" onclick="_firmaEnviar()"><i class="ti ti-send"></i> Enviar a firma de gerencia</button></div>'
    +'<div id="firma-lista"></div>';
  _firmaArchivo=null; window._firmaDocs={prov:null,kcc:null};
  _firmaCargarLista('compras');
}
function _firmaRenderGerencia(cont){
  cont.innerHTML=''
    +'<div style="font-size:13px;font-weight:600;margin-bottom:6px"><i class="ti ti-signature"></i> Compras para firmar</div>'
    +'<div style="font-size:12px;color:var(--text-muted);background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:var(--radius);padding:8px 10px;margin-bottom:12px"><i class="ti ti-info-circle"></i> Revisa el archivo, dibuja tu firma y fírmala. <b>Se firman las dos órdenes: la nuestra y la del proveedor.</b> Si la compra trae revisión AI, mírala antes de firmar. La orden firmada le llega al comprador con el adjunto.</div>'
    +'<div id="firma-lista"></div>';
  _firmaCargarLista('gerencia');
}
function _firmaSetArchivo(input){ var f=input.files&&input.files[0]; if(!f) return; _firmaArchivo=f; window._firmaRevisionIA=null; var el=document.getElementById('firma-file-name'); if(el) el.textContent=f.name; var eb=document.getElementById('firma-ai-errores'); if(eb) eb.innerHTML=''; var st=document.getElementById('firma-ai-status'); if(st) st.innerHTML=''; }

// ── Normaliza el N° de orden extraído: DKC-25090 / SKC-25090 ──
// Acepta "dkc 25090", "DKC25090", "Order No. SKC-25090", etc.
// ═══════════════════════════════════════════════════════════════════════════
//  LLAMADAS A LA IA QUE DEVUELVEN JSON
//  Los documentos con muchas líneas (50+) hacen que la respuesta se corte por
//  el límite de tokens y el JSON quede a medias ("Unexpected end of JSON
//  input"). Aquí se resuelve de dos formas:
//   1. Si la respuesta se cortó, se pide que CONTINÚE donde quedó y se pega.
//   2. Si aun así quedó incompleta, se repara cerrando lo que quedó abierto y
//      se avisa que la lista puede venir recortada.
// ═══════════════════════════════════════════════════════════════════════════
window._iaJSONReparado=false;

function _iaRepararJSON(s){
  var enStr=false, esc=false, ultimoCierre=-1;
  for(var i=0;i<s.length;i++){
    var c=s.charAt(i);
    if(enStr){
      if(esc) esc=false;
      else if(c==='\\') esc=true;
      else if(c==='"') enStr=false;
      continue;
    }
    if(c==='"'){ enStr=true; continue; }
    if(c==='}'||c===']') ultimoCierre=i;
  }
  if(ultimoCierre<0) throw new Error('La AI devolvió una respuesta incompleta');
  var base=s.slice(0, ultimoCierre+1);
  // Recalcular qué corchetes quedaron abiertos y cerrarlos
  var pila=[], inS=false, es=false;
  for(var k=0;k<base.length;k++){
    var ch=base.charAt(k);
    if(inS){
      if(es) es=false;
      else if(ch==='\\') es=true;
      else if(ch==='"') inS=false;
      continue;
    }
    if(ch==='"'){ inS=true; continue; }
    if(ch==='{') pila.push('}');
    else if(ch==='[') pila.push(']');
    else if(ch==='}'||ch===']') pila.pop();
  }
  base=base.replace(/,\s*$/,'');
  while(pila.length) base+=pila.pop();
  return base;
}

function _iaParseJSON(txt){
  window._iaJSONReparado=false;
  var s=String(txt||'').replace(/```json/gi,'').replace(/```/g,'').trim();
  var i=s.indexOf('{');
  if(i<0) throw new Error('La AI no devolvió datos en formato JSON');
  s=s.slice(i);
  var fin=s.lastIndexOf('}');
  if(fin>0){ try{ return JSON.parse(s.slice(0,fin+1)); }catch(e){} }
  try{ return JSON.parse(s); }catch(e){}
  window._iaJSONReparado=true;
  return JSON.parse(_iaRepararJSON(s));
}

// Llama a la IA y devuelve el JSON ya parseado, continuando si se cortó
async function _iaJSON(content, maxTokens, onProgreso){
  var acumulado='', stop='', vueltas=0;
  var max=maxTokens||8000;
  do{
    var msgs=[{role:'user', content:content}];
    if(acumulado) msgs.push({role:'assistant', content:acumulado.replace(/\s+$/,'')});
    var r=await fetch('https://api.anthropic.com/v1/messages',{
      method:'POST',
      headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
      body:JSON.stringify({model:IA_MODELO, max_tokens:max, messages:msgs})
    });
    // Si la respuesta no viene en JSON, r.json() lanza un error con los bytes
    // crudos dentro ("Unexpected token '\uFFFD'..."), que no dice nada. Se lee
    // como texto y se informa del código y de lo que llegó.
    var j, crudo='';
    try{
      crudo=await r.text();          // texto primero: json() consume el cuerpo
      j=JSON.parse(crudo);
    }catch(errJ){
      var pista=String(crudo||'').replace(/[^\x20-\x7E]/g,'·').slice(0,200);
      console.error('[IA] respuesta no válida · estado '+r.status+' · '+pista);
      throw new Error(
        r.status===401 ? 'La clave de la IA no es válida o caducó.'
      : r.status===429 ? 'La IA está saturada ahora mismo. Prueba en un minuto.'
      : r.status===413 ? 'El documento es demasiado grande para la IA. '
                        +'Divídelo o súbelo en Excel o CSV.'
      : (r.status>=500 ? 'La IA no respondió bien (error '+r.status+'). Prueba de nuevo.'
                       : 'La IA devolvió algo que no se pudo interpretar (estado '
                         +r.status+'). Mira la consola para el detalle.'));
    }
    if(j&&j.error) throw new Error(j.error.message||'Error de IA');
    acumulado+=(j.content||[]).map(function(c){return c.text||'';}).join('');
    stop=j.stop_reason||'';
    vueltas++;
    if(stop==='max_tokens' && typeof onProgreso==='function'){
      onProgreso(vueltas);
    }
  } while(stop==='max_tokens' && vueltas<6);
  return _iaParseJSON(acumulado);
}

// ── Normaliza el N° de orden extraído: DKC-25090 / SKC-25090 ──
function _firmaNormRef(v){
  var t=String(v||'').toUpperCase().replace(/[_\s]+/g,' ');
  var m=t.match(/\b(DKC|SKC)\s*-?\s*([A-Z0-9]{2,})/);
  if(m) return m[1]+'-'+m[2];
  return '';
}

// ── Normaliza el N° de orden de una orden NO SAP ──
// Nuestra orden escribe "DKC No.  26084" (el número solo, sin prefijo) y la PI
// del proveedor escribe "PO No: DKC-26084". La IA copia lo que ve, así que
// según qué documento mire devolvía 26084 pelado. Aquí se le devuelve el
// prefijo: primero se busca en las otras referencias del mismo análisis
// (el PO del proveedor, el número que citó el otro documento) y, si en
// ninguna aparece, se asume DKC- que es lo habitual.
// Saca el par prefijo+número de un texto. Entre los dos puede haber palabras
// de relleno ("DKC No. 26084", "DKC N° 26084"), y el número siempre lleva
// algún dígito: así "No" no se confunde con el número de orden.
function _nsapRefPartes(txt){
  var t=String(txt||'').toUpperCase();
  var re=/\b(DKC|SKC)\s*(?:NO\.?|N[º°]\.?|NUM(?:ERO)?\.?|#|:)?\s*-?\s*([A-Z0-9\-]{2,})/g, m;
  while((m=re.exec(t))){
    var tok=m[2].replace(/^-+|-+$/g,'');
    if(/\d/.test(tok)) return {pre:m[1], num:tok};
  }
  return null;
}
function _nsapNormRef(valor, alternativas){
  var t=String(valor||'').toUpperCase().replace(/[_\s]+/g,' ').trim();
  if(!t) return '';
  // Ya viene con prefijo: solo se le da forma DKC-26084
  var p=_nsapRefPartes(t);
  if(p) return p.pre+'-'+p.num;
  // Viene el número pelado: se busca el prefijo en las otras referencias
  var num=t.match(/([A-Z0-9]*\d[A-Z0-9]*)/);
  if(!num) return t;
  num=num[1];
  var alts=(alternativas||[]);
  for(var i=0;i<alts.length;i++){
    var a=_nsapRefPartes(alts[i]);
    if(a && a.num===num) return a.pre+'-'+a.num;
  }
  // Ningún documento trae el prefijo: se usa el de la casa
  return 'DKC-'+num;
}

// ── Normaliza la fecha del documento a YYYY-MM-DD (lo que pide <input type=date>) ──
function _firmaNormFecha(v){
  var s=String(v||'').trim();
  if(!s) return '';
  // Ya viene en el formato correcto
  var m=s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if(m) return m[1]+'-'+m[2]+'-'+m[3];
  var p2=function(n){ return String(n).padStart(2,'0'); };
  var MESES={jan:1,ene:1,feb:2,mar:3,apr:4,abr:4,may:5,jun:6,jul:7,aug:8,ago:8,sep:9,sept:9,oct:10,nov:11,dec:12,dic:12,
             january:1,enero:1,february:2,febrero:2,march:3,marzo:3,april:4,abril:4,mayo:5,june:6,junio:6,
             july:7,julio:7,august:8,agosto:8,september:9,septiembre:9,october:10,octubre:10,
             november:11,noviembre:11,december:12,diciembre:12};
  // "July 27, 2026" / "27 de julio de 2026" / "27-Jul-2026"
  var mm=s.toLowerCase().match(/([a-záéíóú]{3,12})\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(\d{4})/);
  if(mm && MESES[mm[1]]) return mm[3]+'-'+p2(MESES[mm[1]])+'-'+p2(mm[2]);
  var md=s.toLowerCase().match(/(\d{1,2})[\s\-\/.]*(?:de\s+)?([a-záéíóú]{3,12})\.?[\s\-\/.]*(?:de\s+)?(\d{4})/);
  if(md && MESES[md[2]]) return md[3]+'-'+p2(MESES[md[2]])+'-'+p2(md[1]);
  // Numéricas: DD/MM/YYYY o MM/DD/YYYY. Si un bloque pasa de 12 ese es el día.
  var mn=s.match(/(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})/);
  if(mn){
    var a=Number(mn[1]), b=Number(mn[2]), y=Number(mn[3]);
    if(y<100) y+=2000;
    var dia, mes;
    if(a>12){ dia=a; mes=b; }        // sin ambigüedad: DD/MM
    else if(b>12){ dia=b; mes=a; }   // sin ambigüedad: MM/DD
    else { dia=a; mes=b; }           // ambiguo: se asume DD/MM
    if(mes>=1&&mes<=12&&dia>=1&&dia<=31) return y+'-'+p2(mes)+'-'+p2(dia);
  }
  return '';
}

// ═══════════════════════════════════════════════════════════════════════════
//  REVISIÓN CON IA DE LA COMPRA PARA FIRMA
//  El adjunto puede traer UNA o DOS órdenes en el mismo PDF:
//   · La NUESTRA: la que lleva el logo/membrete de KENNEDY CENTER CORP.
//     Su número empieza con DKC- o SKC-. Es la que se firma.
//   · La DEL PROVEEDOR: la otra (PO, Proforma Invoice, Sales Contract).
//  Cuando vienen las dos, la IA las compara línea por línea y reporta cualquier
//  diferencia entre ellas, además de los errores internos de cada una.
// ═══════════════════════════════════════════════════════════════════════════
function _firmaPromptRevision(){
  return 'Eres el auditor de compras de KENNEDY CENTER CORP. Analizas el archivo adjunto de una compra.\n\n'
  +'LOS DOCUMENTOS PUEDEN VENIR DE DOS FORMAS: (a) como dos archivos separados, rotulados DOCUMENTO A (nuestra orden de compra) y DOCUMENTO B (la PI del proveedor); o (b) como un unico PDF que contiene las dos ordenes en paginas distintas. En cualquiera de los dos casos revisa TODO el contenido, todas las paginas, antes de responder.\n'
  +'COMO IDENTIFICAR CADA DOCUMENTO:\n'
  +'- La orden NUESTRA es SIEMPRE la que lleva el LOGO o el membrete de KENNEDY CENTER CORP (tambien puede decir Kennedy Center, KCC o Kennedy). Su numero de orden normalmente empieza con DKC- o SKC-.\n'
  +'- La orden DEL PROVEEDOR es la otra: lleva el logo o membrete de la empresa proveedora y suele titularse Purchase Order, Proforma Invoice, Sales Contract, Order Confirmation o similar, con su propio numero.\n'
  +'- Regla estricta: si un documento NO tiene el logo ni el membrete de Kennedy Center, es del proveedor. No lo asumas por el contenido.\n'
  +'- Si solo hay un documento, devuelve un solo elemento en "documentos" con su tipo correcto.\n\n'
  +'TU TRABAJO:\n'
  +'1) EXTRAER los datos de cada documento.\n'
  +'2) REVISAR los errores internos de cada documento (aritmetica).\n'
  +'3) Si hay DOS documentos, COMPARARLOS campo por campo y linea por linea, y reportar TODA diferencia.\n\n'
  +'REGLA DE CANTIDADES, MUY IMPORTANTE:\n'
  +'- La cantidad SIEMPRE se toma en PIEZAS (unidades sueltas), NUNCA en cartones ni en cajas.\n'
  +'- La columna correcta es la de la cantidad pedida en piezas: suele rotularse ORDER QTY / Pcs, ORDER QTY, QTY, Qty, Quantity, CANTIDAD, PCS o Order Quantity. En el total del documento suele aparecer como "TOTAL ... PCS".\n'
  +'- NO uses nunca estas columnas como cantidad porque son cartones o empaque: QTY X CTN, QTY/CTN, PCS/CTN, pcs/ctn, No.Ctn, TTL CTNS, CTNS, CARTONS, cartones, inner, INNER, No. de cajas. Esas indican cuantas piezas entran por carton o cuantos cartones hay, no lo que se compra.\n'
  +'- Ejemplo: si una linea dice ORDER QTY/Pcs = 300, QTY X CTN = 6 y TTL CTNS = 50, la cantidad de esa linea es 300 (piezas), no 6 ni 50.\n'
  +'- Verificacion: cantidad_en_piezas x precio_unitario debe dar el total de la linea. Si al usar un numero el total no cuadra, es que tomaste la columna equivocada.\n'
  +'- "unidades" del documento es el TOTAL DE PIEZAS. "cartones" es el total de cartones, y va aparte.\n\n'
  +'QUE COMPARAR entre la orden nuestra y la del proveedor: nombre del proveedor; numero de orden que cada una referencia; fecha; moneda; incoterm; terminos y condiciones de pago; puerto o destino; plazo de entrega; cantidad de lineas; y por cada linea el codigo del item, la descripcion, la cantidad EN PIEZAS, el precio unitario y el total de linea; subtotal, descuentos, impuestos, flete, total general, total de piezas y total de cartones.\n'
  +'Empareja las lineas por codigo de item y, si no hay codigo, por descripcion. Reporta tambien las lineas que aparecen en un documento y NO en el otro.\n\n'
  +'ERRORES INTERNOS a revisar en cada documento: cantidad x precio unitario que no cuadra con el total de la linea; suma de lineas que no cuadra con el subtotal o el total general; subtotal + impuestos + flete - descuentos que no da el total; cantidades o precios en cero o negativos; totales repetidos que no coinciden entre si.\n\n'
  +'Devuelve SOLO un JSON valido, sin texto antes ni despues, con esta forma exacta:\n'
  +'{\n'
  +' "documentos":[{"tipo":"kennedy","titulo":"","identificado_por":"","orden":"","orden_referenciada":"","proveedor":"","fecha":"YYYY-MM-DD","moneda":"","monto":0,"unidades":0,"cartones":0,"n_lineas":0,"pagina_inicial":0,"pagina_final":0}],\n'
  +' "descripcion":"",\n'
  +' "errores":[{"doc":"kennedy","detalle":""}],\n'
  +' "diferencias":[{"campo":"","kennedy":"","proveedor":"","gravedad":"alta","detalle":""}],\n'
  +' "coinciden":true\n'
  +'}\n\n'
  +'REGLAS DEL JSON:\n'
  +'- "tipo" solo puede ser "kennedy" o "proveedor".\n'
  +'- "identificado_por": explica en pocas palabras como supiste de quien es el documento (por ejemplo: logo de Kennedy Center Corp en el encabezado).\n'  +'- Cuando cites codigos de item usa SIEMPRE el codigo interno de KENNEDY CENTER (columnas "KCC ITEM No", "KCC ITEM", "Codigo KCC", o "Code" en la PI del proveedor; suele ser numerico de 6-7 digitos o empezar con BA-), NUNCA el del proveedor ("Factory Code", "Item No.", "Supplier Code", que mezclan letras y numeros como B0040MP5L o BBQ4004).\n'
  +'- "orden": el numero de orden propio de ese documento, exactamente como aparece. En el documento nuestro prioriza el que empiece con DKC o SKC.\n'
  +'- "orden_referenciada": el numero de la OTRA orden que ese documento menciona, si aparece.\n'
  +'- "pagina_inicial" y "pagina_final": numero de pagina del ARCHIVO COMPLETO (empezando en 1) donde arranca y donde termina ese documento. La pagina_final es aquella donde aparece el TOTAL GENERAL de ese documento. Cuenta las paginas del PDF entero, no la numeracion impresa dentro de cada documento. Si solo hay un documento, pagina_final es la ultima pagina del archivo.\n'
  +'- "fecha": el campo Date/Fecha del documento, SIEMPRE en formato YYYY-MM-DD. Interpreta bien el formato original antes de convertir. Si no aparece, "".\n'
  +'- "descripcion": resumen breve de los productos de la compra.\n'
  +'- "unidades": total de PIEZAS del documento (no cartones). "cartones": total de cartones/cajas.\n'
  +'- "doc" en errores: "kennedy", "proveedor" o "ambos".\n'
  +'- "gravedad" en diferencias: "alta" si afecta dinero, cantidades o el item comprado; "media" si afecta fechas, terminos o condiciones; "baja" si es solo de forma o redaccion.\n'
  +'- "detalle": explicalo claro y CON LOS NUMEROS involucrados.\n'
  +'- "coinciden": true solo si NO hay ninguna diferencia de gravedad alta o media.\n'
  +'- Si no hay errores devuelve "errores":[]. Si no hay diferencias o solo hay un documento, devuelve "diferencias":[].\n'
  +'- Si un dato no aparece usa "" o 0. Nunca inventes datos.\n'
  +'- Se breve: cada "detalle" en una sola frase. En documentos largos reporta como maximo 40 diferencias, priorizando las de gravedad alta, y en ese caso agrega una ultima diferencia con campo "Nota" indicando cuantas quedaron fuera.';
}

// Tarjeta resumen de cada documento detectado
function _firmaCardDoc(d){
  var esK=(d.tipo==='kennedy');
  var col=esK?'#0c447c':'#B45309', bg=esK?'#e6f1fb':'#FEF9F3', bd=esK?'#85B7EB':'#E9C08A';
  return '<div style="flex:1;min-width:210px;background:'+bg+';border:0.5px solid '+bd+';border-radius:8px;padding:9px 11px">'
    +'<div style="font-size:11px;font-weight:800;color:'+col+';margin-bottom:4px">'
      +'<i class="ti '+(esK?'ti-building-store':'ti-truck-delivery')+'"></i> '
      +(esK?'NUESTRA — Kennedy Center':'PROVEEDOR')+'</div>'
    +(d.titulo?'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:3px">'+_esc(String(d.titulo))+'</div>':'')
    +'<div style="font-size:11.5px;line-height:1.5">'
      +(d.orden?('<div>Orden: <b>'+_esc(String(d.orden))+'</b></div>'):'')
      +(d.proveedor?('<div>Proveedor: <b>'+_esc(String(d.proveedor))+'</b></div>'):'')
      +(d.fecha?('<div>Fecha: <b>'+_esc(String(d.fecha))+'</b></div>'):'')
      +(Number(d.monto)?('<div>Total: <b>'+(d.moneda?_esc(String(d.moneda))+' ':'')+Number(d.monto).toLocaleString('en-US',{minimumFractionDigits:2})+'</b></div>'):'')
      +(Number(d.unidades)?('<div>Piezas: <b>'+Number(d.unidades).toLocaleString('en-US')+'</b></div>'):'')
      +(Number(d.cartones)?('<div>Cartones: <b>'+Number(d.cartones).toLocaleString('en-US')+'</b></div>'):'')
      +(Number(d.n_lineas)?('<div>Líneas: <b>'+Number(d.n_lineas)+'</b></div>'):'')
    +'</div>'
    +(d.identificado_por?('<div style="font-size:9.5px;color:var(--text-muted);margin-top:4px;font-style:italic">'+_esc(String(d.identificado_por))+'</div>'):'')
  +'</div>';
}

// Pinta el resultado completo: documentos, diferencias y errores
function _firmaRenderRevision(data, elId){
  var eb=document.getElementById(elId||'firma-ai-errores'); if(!eb) return {nErr:0,nDif:0,nAlta:0};
  var docs=Array.isArray(data.documentos)?data.documentos:[];
  var kenn=docs.filter(function(d){return d.tipo==='kennedy';});
  var prov=docs.filter(function(d){return d.tipo==='proveedor';});

  // Normalizar errores y diferencias (aceptan texto suelto u objeto)
  var errs=(Array.isArray(data.errores)?data.errores:[]).map(function(x){
    if(typeof x==='string') return {doc:'', detalle:x};
    return {doc:x.doc||'', detalle:x.detalle||x.error||''};
  }).filter(function(x){ return String(x.detalle||'').trim(); });

  var difs=(Array.isArray(data.diferencias)?data.diferencias:[]).map(function(x){
    if(typeof x==='string') return {campo:'', kennedy:'', proveedor:'', gravedad:'media', detalle:x};
    return {campo:x.campo||'', kennedy:x.kennedy!=null?x.kennedy:'', proveedor:x.proveedor!=null?x.proveedor:'',
            gravedad:String(x.gravedad||'media').toLowerCase(), detalle:x.detalle||''};
  }).filter(function(x){ return String(x.detalle||x.campo||'').trim(); });

  var nAlta=difs.filter(function(d){return d.gravedad==='alta';}).length;
  var h='';

  // ── Documentos detectados ──
  if(docs.length){
    h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:9px">'+docs.map(_firmaCardDoc).join('')+'</div>';
  }

  // ── Aviso si falta uno de los dos ──
  if(docs.length===1){
    h+='<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-marron);margin-bottom:9px">'
      +'<i class="ti ti-info-circle"></i> Solo se detectó <b>'+(kenn.length?'la orden de Kennedy Center':'la orden del proveedor')+'</b> en este archivo. '
      +'Si el PDF debía traer las dos, revísalo: sin las dos no se puede comparar.</div>';
  } else if(!docs.length){
    h+='<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-marron);margin-bottom:9px">'
      +'<i class="ti ti-info-circle"></i> La AI no logró identificar las órdenes en el archivo. Verifica que el PDF esté legible.</div>';
  }

  // ── Diferencias entre ambas ──
  if(docs.length>1){
    if(difs.length){
      h+='<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden;margin-bottom:9px">'
        +'<div style="background:var(--pastel-error);padding:8px 11px;font-size:11.5px;font-weight:800;color:var(--t-rojo)">'
          +'<i class="ti ti-git-compare"></i> '+difs.length+' diferencia(s) entre nuestra orden y la del proveedor'
          +(nAlta?(' &middot; <span style="color:var(--t-rojo2)">'+nAlta+' grave(s)</span>'):'')
        +'</div>';
      difs.forEach(function(d){
        var c=d.gravedad==='alta'?'#dc2626':(d.gravedad==='baja'?'#6b7280':'#B45309');
        var bgg=d.gravedad==='alta'?'#FEF2F2':(d.gravedad==='baja'?'var(--surface-1)':'#FEF9F3');
        h+='<div style="padding:8px 11px;border-top:0.5px solid var(--border);background:'+bgg+'">'
          +'<div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap">'
            +'<span style="font-size:9px;font-weight:800;color:#fff;background:'+c+';border-radius:6px;padding:1px 6px;text-transform:uppercase">'+_esc(d.gravedad)+'</span>'
            +(d.campo?('<b style="font-size:11.5px">'+_esc(String(d.campo))+'</b>'):'')
          +'</div>';
        if(String(d.kennedy)!==''||String(d.proveedor)!==''){
          h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:4px;font-size:11px">'
            +'<span style="flex:1;min-width:150px;background:var(--pastel-azul);border-radius:6px;padding:3px 7px"><b style="color:var(--t-azul)">Nuestra:</b> '+_esc(String(d.kennedy||'—'))+'</span>'
            +'<span style="flex:1;min-width:150px;background:var(--pastel-aviso);border-radius:6px;padding:3px 7px"><b style="color:var(--t-ambar)">Proveedor:</b> '+_esc(String(d.proveedor||'—'))+'</span>'
          +'</div>';
        }
        if(d.detalle) h+='<div style="font-size:11px;color:var(--text-secondary);margin-top:3px">'+_esc(String(d.detalle))+'</div>';
        h+='</div>';
      });
      h+='</div>';
    } else {
      h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600;margin-bottom:9px">'
        +'<i class="ti ti-git-compare"></i> Las dos órdenes coinciden: mismos items, cantidades, precios y totales.</div>';
    }
  }

  // ── Errores internos ──
  if(errs.length){
    var etq={kennedy:'Nuestra orden', proveedor:'Orden del proveedor', ambos:'Ambas'};
    h+='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-rojo)">'
      +'<div style="font-weight:800;margin-bottom:4px"><i class="ti ti-alert-triangle"></i> '+errs.length+' error(es) dentro de los documentos. Corrígelos antes de enviar a firma:</div>'
      +'<ul style="margin:4px 0 0 16px;padding:0">'
      +errs.map(function(x){
        var et=etq[x.doc]||'';
        return '<li style="margin-bottom:2px">'+(et?('<b>'+et+':</b> '):'')+_esc(String(x.detalle))+'</li>';
      }).join('')
      +'</ul></div>';
  } else if(docs.length){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Sin errores de montos, cantidades ni totales dentro de los documentos.</div>';
  }

  eb.innerHTML=h;
  return {nErr:errs.length, nDif:difs.length, nAlta:nAlta, nDocs:docs.length, kenn:kenn[0]||null, prov:prov[0]||null};
}

async function _firmaAI(){
  var fd=window._firmaDocs||{};
  if(!fd.kcc && !fd.prov && !_firmaArchivo){ showT('Primero sube los documentos'); return; }
  var st=document.getElementById('firma-ai-status');
  if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo los documentos y comparándolos con AI…</span>';
  var eb0=document.getElementById('firma-ai-errores'); if(eb0) eb0.innerHTML='';
  try{
    // Los dos documentos van etiquetados para que la AI sepa cuál es cuál
    var content=[];
    if(fd.kcc){
      content.push({type:'text', text:'DOCUMENTO A — NUESTRA ORDEN DE COMPRA (KENNEDY CENTER CORP.):'});
      content.push(await _nsapContenido(fd.kcc));
    }
    if(fd.prov){
      content.push({type:'text', text:'DOCUMENTO B — PI DEL PROVEEDOR (Proforma Invoice):'});
      content.push(await _nsapContenido(fd.prov));
    }
    if(!fd.kcc && !fd.prov && _firmaArchivo){
      content.push(await _nsapContenido(_firmaArchivo));
    }
    content.push({type:'text', text:_firmaPromptRevision()});
    var data=await _iaJSON(content, 8000, function(n){
      if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Documento largo: la AI sigue leyendo las líneas ('+n+')…</span>';
    });
    if(window._iaJSONReparado && st){
      console.warn('JSON de la revisión reparado (respuesta muy larga)');
    }

    var res=_firmaRenderRevision(data);
    var dK=res.kenn||{}, dP=res.prov||{};

    // ── Rellenar el formulario. Manda SIEMPRE nuestra orden (la que se firma);
    //    solo se usa la del proveedor para lo que a la nuestra le falte. ──
    var refIA=_firmaNormRef(dK.orden||'');
    if(!refIA) refIA=_firmaNormRef(dK.orden_referenciada||dP.orden_referenciada||'');
    if(!refIA) refIA=_firmaNormRef(dP.orden||'');
    if(!refIA) refIA=_firmaNormRef(_firmaArchivo.name||'');
    if(refIA) _sv('firma-orden', refIA);

    var provNom=dK.proveedor||dP.proveedor||'';
    if(provNom) _sv('firma-prov', provNom);
    if(data.descripcion) _sv('firma-desc', data.descripcion);

    var monto=Number(dK.monto)||Number(dP.monto)||0;
    if(monto) _sv('firma-monto', monto);
    var uni=Number(dK.unidades)||Number(dP.unidades)||0;
    if(uni) _sv('firma-uni', uni);

    // Fecha estimada = campo Date del documento (prioriza el nuestro)
    var fIA=_firmaNormFecha(dK.fecha||'')||_firmaNormFecha(dP.fecha||'');
    if(fIA) _sv('firma-fecha', fIA);

    var faltan=[];
    if(!refIA) faltan.push('el N° de orden (DKC/SKC)');
    if(!fIA)   faltan.push('la fecha');
    var avisoFalta=faltan.length?(' <span style="color:var(--t-ambar)">No se encontró '+faltan.join(' ni ')+': complétalo a mano.</span>'):'';

    if(st){
      if(res.nAlta){
        st.innerHTML='<span style="color:var(--t-rojo2)"><i class="ti ti-alert-triangle"></i> <b>No envíes a firma todavía:</b> hay '+res.nAlta+' diferencia(s) grave(s) entre las dos órdenes.</span>'+avisoFalta;
      } else if(res.nErr || res.nDif){
        st.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Datos rellenados. Revisa lo que la AI encontró abajo.</span>'+avisoFalta;
      } else if(res.nDocs>1){
        st.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Las dos órdenes coinciden y no hay errores.</span>'+avisoFalta;
      } else {
        st.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Datos rellenados y revisados.</span>'+avisoFalta;
      }
    }
    // Se guarda para adjuntar el resultado al enviar a firma
    window._firmaRevisionIA={ fecha:new Date().toISOString(), archivo:_firmaArchivo.name,
                              n_docs:res.nDocs, n_errores:res.nErr, n_diferencias:res.nDif, n_graves:res.nAlta,
                              data:data };
  }catch(e){
    console.error('firma AI:',e);
    if(st) st.innerHTML='<span style="color:var(--text-danger)">No se pudo leer con AI: '+(e.message||e)+'</span>';
  }
}

async function _firmaEnviar(){
  var num=_fv('firma-orden'), prov=_fv('firma-prov'), dept=(_fv('firma-dept')||_deptPrimero()), desc=_fv('firma-desc');
  var monto=parseFloat(_fv('firma-monto'))||0, uni=parseInt(_fv('firma-uni'))||0;
  if(!num||!prov||!dept||!desc||!monto){ showT('Completa No. de orden, proveedor, departamento, descripcion y monto'); return; }
  showT('Enviando a firma...');
  try{
    // Se suben los dos: nuestra orden y la PI del proveedor
    var fd=window._firmaDocs||{};
    var docKcc=fd.kcc||_firmaArchivo||null;
    var docProv=fd.prov||null;
    var path=null, nombre=null, path2=null, nombre2=null;
    if(docKcc){ path=await _subirDocStorage('firma', dept, docKcc); nombre=docKcc.name; }
    if(docProv){ path2=await _subirDocStorage('firma', dept, docProv); nombre2=docProv.name; }
    var fEst=_fv('firma-fecha')||null;
    var revIA=window._firmaRevisionIA||null;
    var payload={ num_orden:num, proveedor:prov, dept:dept, descripcion:desc, monto:monto, unidades:uni, fecha_estimada:fEst, revision_ia:revIA, archivo_path2:path2, archivo_nombre2:nombre2, creado_por:(CU&&CU.id)||'', creado_por_nom:(CU&&CU.name)||'', creado_por_email:(CU&&CU.email)||'', estado:'pendiente', archivo_path:path, archivo_nombre:nombre, creado_en:new Date().toISOString() };
    var r=await _firmaWrite(SB+'/rest/v1/ordenes_firma','POST',payload,['fecha_estimada','revision_ia','archivo_path2','archivo_nombre2']);
    if(r.ok){ showT('Enviada a gerencia para firma'); ['firma-orden','firma-prov','firma-desc','firma-monto','firma-uni','firma-fecha'].forEach(function(id){_sv(id,'');}); _firmaArchivo=null; window._firmaDocs={prov:null,kcc:null}; window._firmaRevisionIA=null; var el=document.getElementById('firma-file-name'); if(el) el.textContent='Subir PDF o Excel de la compra'; var stx=document.getElementById('firma-ai-status'); if(stx) stx.innerHTML=''; var eb1=document.getElementById('firma-ai-errores'); if(eb1) eb1.innerHTML=''; _firmaCargarLista('compras'); }
    else { var t=await r.text(); console.error('ordenes_firma insert',r.status,t); showT('No se pudo enviar (revisa que exista la tabla ordenes_firma)'); }
  }catch(e){ console.error(e); showT('Error: '+(e.message||e)); }
}

async function _firmaCargarLista(rol){
  var box=document.getElementById('firma-lista'); if(!box) return;
  box.innerHTML='<div class="empty" style="padding:14px"><i class="ti ti-loader-2 spin"></i> Cargando...</div>';
  try{
    var filtro='';
    // Todo el equipo del departamento ve las mismas compras para firma
    if(rol==='compras'){ filtro=(CU&& _deptAcotado())?_deptFiltroURL():_filtroEquipo('creado_por'); }
    else if(CU&& _deptAcotado()){ filtro=_deptFiltroURL(); }
    var r=await fetch(SB+'/rest/v1/ordenes_firma?select=*'+filtro+'&order=creado_en.desc&limit=100',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    await _firmaCargarAmarres(rows);
    window._firmaRows=rows; window._firmaRol=rol;   // cache para el filtro de estado
    _firmaRenderLista(box, rows, rol);
  }catch(e){ box.innerHTML='<div class="empty" style="color:var(--text-danger);padding:14px">Error al cargar: '+(e.message||e)+'</div>'; }
}
// ══ AMARRE POR DKC: orden firmada  <->  orden de compra No-SAP ══
// Flujo: el proveedor manda la orden, gerencia la firma, y compras escribe
// aqui el N° DKC. Cuando existe una orden No-SAP con ese mismo DKC, las dos
// quedan amarradas y se ve que ya esta en proceso con el proveedor.
window._firmaAmarres = window._firmaAmarres || {};

function _firmaNormDKC(v){ return String(v||'').trim().toUpperCase(); }

// Busca en compras_pend_sap las ordenes cuyo dkc/num_orden coincida.
async function _firmaCargarAmarres(rows){
  window._firmaAmarres={};
  var dkcs=(rows||[]).map(function(o){ return _firmaNormDKC(o.dkc); }).filter(Boolean);
  if(!dkcs.length) return;
  var unicos=[]; var vistos={};
  dkcs.forEach(function(d){ if(!vistos[d]){ vistos[d]=1; unicos.push(d); } });
  try{
    var inList=unicos.map(function(d){ return '"'+d.replace(/"/g,'')+'"'; }).join(',');
    var r=await fetch(SB+'/rest/v1/compras_pend_sap?select=dkc,num_orden,proveedor,total,saldo,dept&or=(dkc.in.('+inList+'),num_orden.in.('+inList+'))',{headers:SBH});
    var ord=r.ok?(await r.json()):[];
    (Array.isArray(ord)?ord:[]).forEach(function(p){
      var k1=_firmaNormDKC(p.dkc), k2=_firmaNormDKC(p.num_orden);
      if(k1) window._firmaAmarres[k1]=p;
      if(k2 && !window._firmaAmarres[k2]) window._firmaAmarres[k2]=p;
    });
  }catch(e){}
}

// Bloque visual del DKC dentro de cada orden firmada.
function _firmaBloqueDKC(o, rol){
  if(o.estado!=='firmada' && o.estado!=='enviada_proveedor') return '';
  var dkc=_firmaNormDKC(o.dkc);
  var puedeEditar = (rol==='compras') || (CU && CU.role==='compras');
  var h='<div style="margin-top:7px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:8px 10px">';
  h+='<div style="font-size:10.5px;color:var(--text-muted);font-weight:600;margin-bottom:5px"><i class="ti ti-link"></i> N° DKC de la orden de compra</div>';

  if(!dkc){
    if(puedeEditar){
      h+='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center">'
        +'<input id="firma-dkc-'+o.id+'" placeholder="Ej: DKC-25090" value="" style="flex:1;min-width:150px;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)">'
        +'<button class="btn bp" style="padding:5px 11px;font-size:11px" onclick="_firmaGuardarDKC('+o.id+')"><i class="ti ti-device-floppy"></i> Guardar DKC</button>'
        +'</div>'
        +'<div style="font-size:10px;color:var(--text-muted);margin-top:4px">Al guardarlo se amarra con la orden No-SAP que tenga ese mismo número.</div>';
    }else{
      h+='<div style="font-size:11.5px;color:var(--text-muted)">Compras aún no ha registrado el N° DKC.</div>';
    }
    h+='</div>'; return h;
  }

  var p=window._firmaAmarres[dkc];
  h+='<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">'
    +'<span style="font-size:13px;font-weight:700;color:var(--text-accent)">'+_esc(dkc)+'</span>';
  if(puedeEditar) h+='<button class="btn bg2" style="padding:3px 8px;font-size:10.5px" onclick="_firmaEditarDKC('+o.id+',\''+_esc(dkc)+'\')"><i class="ti ti-pencil"></i> Cambiar</button>';
  h+='</div>';

  if(p){
    h+='<div style="margin-top:6px;background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px;font-size:12px;font-weight:700;color:var(--t-verde);display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<span><i class="ti ti-link"></i> Amarrada a la orden No-SAP '+_esc(p.num_orden||p.dkc)+' &middot; firmada y en proceso con el proveedor</span>'
      +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px" onclick="abrirPendSAP(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-eye"></i> Ver orden</button>'
      +(puedeEditar?'<button class="btn bp" style="padding:3px 9px;font-size:10.5px;background:#166534" onclick="marcarEnSAP(\''+_esc(dkc)+'\')"><i class="ti ti-database-import"></i> Ya está en SAP</button>':'')
      +'</div>';
  }else{
    h+='<div style="margin-top:6px;background:var(--pastel-naranja);border:1px solid #F5B971;border-radius:8px;padding:7px 10px;font-size:11.5px;color:var(--t-ambar);display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +'<span><i class="ti ti-alert-triangle"></i> Falta crear la orden No-SAP con este DKC.</span>';
    if(puedeEditar) h+='<button class="btn bp" style="padding:3px 9px;font-size:10.5px;background:#B45309" onclick="_firmaCrearNoSAP('+o.id+')"><i class="ti ti-plus"></i> Crear orden No-SAP</button>';
    h+='</div>';
  }
  h+='</div>';
  return h;
}

async function _firmaGuardarDKC(id){
  var inp=document.getElementById('firma-dkc-'+id);
  var val=_firmaNormDKC(inp?inp.value:'');
  if(!val){ showT('Escribe el N° DKC'); return; }
  try{
    await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',{dkc:val},[]);
    showT('DKC '+val+' guardado');
    _firmaCargarLista((CU&&CU.role==='gerencia')?'gerencia':'compras');
  }catch(e){ showT('Error al guardar el DKC: '+(e.message||e)); }
}

function _firmaEditarDKC(id, actual){
  var v=prompt('N° DKC de la orden de compra:', actual||'');
  if(v===null) return;
  var val=_firmaNormDKC(v);
  if(!val){ showT('DKC vacío, no se cambió'); return; }
  _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',{dkc:val},[])
    .then(function(){ showT('DKC actualizado'); _firmaCargarLista((CU&&CU.role==='gerencia')?'gerencia':'compras'); })
    .catch(function(e){ showT('Error: '+(e.message||e)); });
}

// Abre el formulario de orden No-SAP ya con el DKC y el proveedor puestos.
async function _firmaCrearNoSAP(id){
  try{
    var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=dkc,proveedor,dept,monto&limit=1',{headers:SBH}).then(function(r){return r.json();});
    var o=(d&&d[0])||{};
    abrirNuevaOrdenSinSAP(o.dept||null, { ref:_firmaNormDKC(o.dkc), prov:o.proveedor||'', total:o.monto||0 });
  }catch(e){ showT('Error: '+(e.message||e)); }
}

function _firmaEstadoColor(e){ return (e==='firmada'||e==='enviada_proveedor')?'#16a34a':(e==='rechazada')?'#9ca3af':'#dc2626'; }
function _firmaBadgeEstado(e){
  var map={firmada:['Firmada','#dcfce7','#166534'],enviada_proveedor:['Enviada a proveedor','#dcfce7','#166534'],rechazada:['Rechazada','#f3f4f6','#6b7280'],pendiente:['Pendiente de firma','#fee2e2','#b91c1c']};
  var m=map[e]||map.pendiente;
  // "Enviada a proveedor" se destaca: es el estado final y antes se perdia
  if(e==='enviada_proveedor'){
    return '<span style="display:inline-flex;align-items:center;gap:4px;font-size:11.5px;background:var(--pastel-ok);'
      +'color:var(--t-verde);border:1px solid #16a34a;padding:3px 10px;border-radius:9px;font-weight:700;white-space:nowrap">'
      +'<i class="ti ti-circle-check" style="font-size:12px"></i>ENVIADA AL PROVEEDOR</span>';
  }
  return '<span style="font-size:9px;background:'+m[1]+';color:'+m[2]+';padding:1px 7px;border-radius:7px;font-weight:600">'+m[0]+'</span>';
}
// ── Resumen de la revisión con IA dentro de la tarjeta de firma ──
window._firmaRevCache={};
function _firmaRevDe(o){
  var rv=o&&o.revision_ia;
  if(typeof rv==='string'){ try{ rv=JSON.parse(rv); }catch(e){ rv=null; } }
  return rv&&rv.data?rv:null;
}
function _firmaResumenIA(o){
  var rv=_firmaRevDe(o); if(!rv) return '';
  window._firmaRevCache[String(o.id)]=rv;
  var g=Number(rv.n_graves)||0, d=Number(rv.n_diferencias)||0, e=Number(rv.n_errores)||0, nd=Number(rv.n_docs)||0;
  var col, bg, bd, txt;
  if(g){ col='#991b1b'; bg='#FEF2F2'; bd='#dc2626'; txt='<b>'+g+' diferencia(s) grave(s)</b> entre nuestra orden y la del proveedor'; }
  else if(d||e){ col='#7C3D12'; bg='#FEF9F3'; bd='#E9C08A'; txt=(d?(d+' diferencia(s)'):'')+((d&&e)?' · ':'')+(e?(e+' error(es)'):''); }
  else if(nd>1){ col='#166534'; bg='#dcfce7'; bd='#16a34a'; txt='Las dos órdenes coinciden'; }
  else { col='#166534'; bg='#dcfce7'; bd='#16a34a'; txt='Revisada por AI, sin observaciones'; }
  return '<div onclick="event.stopPropagation();_firmaVerRevisionIA(\''+o.id+'\')" title="Ver el detalle de la revisión"'
    +' style="margin-top:5px;display:inline-flex;align-items:center;gap:5px;background:'+bg+';border:1px solid '+bd+';color:'+col
    +';border-radius:8px;padding:3px 9px;font-size:10.5px;font-weight:600;cursor:pointer">'
    +'<i class="ti ti-sparkles"></i> AI: '+txt
    +(nd>1?' <span style="font-weight:400;opacity:.75">('+nd+' documentos)</span>':(nd===1?' <span style="font-weight:400;opacity:.75">(1 documento)</span>':''))
    +' <i class="ti ti-chevron-right"></i></div>';
}
function _firmaVerRevisionIA(id){
  var rv=window._firmaRevCache[String(id)]; if(!rv){ showT('Sin revisión guardada'); return; }
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1004;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;max-width:640px;width:100%;max-height:90vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;padding:14px 16px;border-bottom:0.5px solid var(--border)">'
      +'<div style="font-size:14px;font-weight:700"><i class="ti ti-sparkles" style="color:var(--t-lila2)"></i> Revisión AI de la compra</div>'
      +'<button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="padding:14px 16px">'
      +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:9px">'+_esc(rv.archivo||'')+(rv.fecha?(' · '+new Date(rv.fecha).toLocaleString('es')):'')+'</div>'
      +'<div id="firma-rev-modal-body"></div>'
    +'</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ _firmaRenderRevision(rv.data,'firma-rev-modal-body'); }catch(e){}
}

// ── Filtro por estado de la orden de compra ──
window._firmaFiltro='todas';
// Una orden "enviada a proveedor sin orden No SAP" es la que ya salió al
// proveedor pero todavía no tiene una orden No-SAP amarrada por su N° DKC.
function _firmaSinNoSAP(o){
  if(o.estado!=='enviada_proveedor') return false;
  var dkc=_firmaNormDKC(o.dkc);
  if(!dkc) return true;
  return !(window._firmaAmarres && window._firmaAmarres[dkc]);
}
function _firmaCoincide(o, f){
  if(f==='todas') return true;
  if(f==='pendiente') return o.estado==='pendiente';
  if(f==='firmada') return o.estado==='firmada';
  if(f==='enviada_proveedor') return o.estado==='enviada_proveedor';
  if(f==='sin_nosap') return _firmaSinNoSAP(o);
  return true;
}
function _firmaSetFiltro(f){
  window._firmaFiltro=f;
  var box=document.getElementById('firma-lista');
  if(box) _firmaRenderLista(box, window._firmaRows||[], window._firmaRol||(CU&&CU.role));
}
function _firmaBarraFiltro(rows){
  var defs=[
    {k:'todas',              l:'Todas',                          c:'var(--text-secondary)'},
    {k:'pendiente',          l:'Pendiente de firma',             c:'#b91c1c'},
    {k:'firmada',            l:'Firmada',                        c:'#166534'},
    {k:'enviada_proveedor',  l:'Enviada a proveedor',            c:'#0c447c'},
    {k:'sin_nosap',          l:'Enviada sin orden No SAP',       c:'#B45309'}
  ];
  var act=window._firmaFiltro||'todas';
  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;margin:4px 0 10px">';
  defs.forEach(function(d){
    var n=rows.filter(function(o){ return _firmaCoincide(o,d.k); }).length;
    var on=(act===d.k);
    h+='<button onclick="_firmaSetFiltro(\''+d.k+'\')" style="border:1px solid '+(on?d.c:'var(--border)')+';'
      +'background:'+(on?d.c:'var(--surface-1)')+';color:'+(on?'#fff':d.c)+';'
      +'border-radius:20px;padding:4px 11px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
      +d.l+' <span style="opacity:.8;font-weight:400">'+n+'</span></button>';
  });
  return h+'</div>';
}

function _firmaRenderLista(box, rows, rol){
  var todas=rows||[];
  var titulo=rol==='compras'?'Mis compras para firma':'Compras para firmar';
  var barra=_firmaBarraFiltro(todas);
  rows=todas.filter(function(o){ return _firmaCoincide(o, window._firmaFiltro||'todas'); });
  if(!todas.length){ box.innerHTML='<div class="empty" style="padding:16px;color:var(--text-muted)">'+(rol==='compras'?'Aun no has enviado compras para firma.':'No hay compras pendientes de firma.')+'</div>'; return; }
  var h='<div style="font-size:12px;font-weight:600;margin:6px 0 4px">'+titulo+' <span style="color:var(--text-muted);font-weight:400">('+rows.length+(rows.length!==todas.length?(' de '+todas.length):'')+')</span></div>'+barra;
  if(!rows.length){
    box.innerHTML=h+'<div class="empty" style="padding:16px;color:var(--text-muted)">No hay compras en ese estado.</div>';
    return;
  }
  rows.forEach(function(o){
    var col=_firmaEstadoColor(o.estado);
    var fecha=o.creado_en?new Date(o.creado_en).toLocaleDateString('es'):'';
    var fFirm=o.firmado_en?new Date(o.firmado_en).toLocaleString('es'):'';
    var fRec=o.recibido_en?new Date(o.recibido_en).toLocaleString('es'):'';
    var fEnv=o.enviado_proveedor_en?new Date(o.enviado_proveedor_en).toLocaleString('es'):'';
    var title=(o.num_orden?('<b>'+_esc(o.num_orden)+'</b> &middot; '):'')+_esc(o.proveedor||'');
    h+='<div style="border:0.5px solid var(--border);border-left:4px solid '+col+';border-radius:9px;padding:10px 12px;margin-bottom:8px;display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:170px">'
        +'<div style="font-size:12.5px;font-weight:600">'+title+' '+_firmaBadgeEstado(o.estado)
          +((rol==='compras'&&o.estado==='firmada'&&!o.recibido_en)?'<span class="rep-nuevo"><i class="ti ti-writing-sign"></i> sin abrir</span>':'')
        +'</div>'
        +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+_esc(o.descripcion||'')+' &middot; '+fmt(o.monto||0)+' &middot; '+(EMOJIS2[o.dept]||'')+' '+_esc(dL(o.dept||''))+' &middot; '+_esc(o.creado_por_nom||'')+' &middot; '+fecha+'</div>'
        +(fFirm?('<div style="font-size:10.5px;color:var(--t-verde3);margin-top:2px"><i class="ti ti-writing-sign"></i> Firmada por '+_esc(o.firmado_por||'')+' &middot; '+fFirm+'</div>'):'')
        +(fRec?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px"><i class="ti ti-inbox"></i> Recibida firmada por compras: '+fRec+'</div>'):'')
        +(fEnv?('<div style="margin-top:5px;background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px;font-size:13px;font-weight:700;color:var(--t-verde)"><i class="ti ti-send"></i> Enviada a proveedor &middot; '+fEnv+'</div>'):'')
        +((o.estado==='rechazada'&&o.motivo_rechazo)?('<div style="font-size:10.5px;color:var(--text-danger);margin-top:2px">Motivo: '+_esc(o.motivo_rechazo)+'</div>'):'')
        +_firmaResumenIA(o)
        +_firmaBloqueDKC(o, rol)
      +'</div>';
    if(o.archivo_path) h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px" onclick="_firmaVer(\''+_esc(o.archivo_path)+'\',\''+_esc(o.archivo_nombre||'archivo')+'\')"><i class="ti ti-file"></i> Original</button>';
    if((o.estado==='firmada'||o.estado==='enviada_proveedor')&&o.archivo_firmado_path){
      if(rol==='compras') h+='<button class="btn bp" style="padding:5px 9px;font-size:11px;background:#16a34a" onclick="_firmaVerFirmadaCompras('+o.id+',\''+_esc(o.archivo_firmado_path)+'\',\''+_esc(o.archivo_firmado_nombre||'firmada')+'\','+(o.recibido_en?'true':'false')+')"><i class="ti ti-writing-sign"></i> Ver orden firmada</button>';
      else h+='<button class="btn bp" style="padding:5px 9px;font-size:11px;background:#16a34a" onclick="_firmaVer(\''+_esc(o.archivo_firmado_path)+'\',\''+_esc(o.archivo_firmado_nombre||'firmada')+'\')"><i class="ti ti-writing-sign"></i> Ver orden firmada</button>';
      if(o.archivo_firmado_path2) h+='<button class="btn bp" style="padding:5px 9px;font-size:11px;background:#B45309" onclick="_firmaVer(\''+_esc(o.archivo_firmado_path2)+'\',\''+_esc(o.archivo_firmado_nombre2||'PI firmada')+'\')"><i class="ti ti-writing-sign"></i> Ver PI firmada</button>';
    }
    if(rol==='compras'&&o.estado==='firmada') h+='<button class="btn bp" style="padding:5px 9px;font-size:11px" onclick="_firmaEnviadaProveedor('+o.id+')"><i class="ti ti-send"></i> Enviada a proveedor</button>';
    // Editar: solo mientras gerencia no la haya firmado
    if(rol==='compras' && o.estado!=='firmada' && o.estado!=='enviada_proveedor'){
      h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px;color:var(--t-ambar)" onclick="_firmaEditar('+o.id+')"><i class="ti ti-pencil"></i> Editar</button>';
    }
    // Borrar: disponible para cualquier usuario y en cualquier estado, siempre
    // con confirmación previa.
    h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px;color:var(--text-danger)" onclick="_firmaBorrar('+o.id+')"><i class="ti ti-trash"></i> Borrar</button>';
    if(rol==='gerencia'&&o.estado==='pendiente') h+='<button class="btn bp" style="padding:5px 9px;font-size:11px" onclick="_firmaAbrir('+o.id+')"><i class="ti ti-signature"></i> Firmar</button>';
    h+=_chatBtn('firma', o.id, (o.num_orden?o.num_orden+' ':'')+(o.proveedor||''));
    h+='</div>';
  });
  box.innerHTML=h;
  try{ _chatBadges('firma', rows.map(function(o){return o.id;})); }catch(e){}
}
// Escritura resiliente: intenta con todas las columnas; si la tabla no tiene alguna
// columna nueva, reintenta sin ellas (para no romper si falta el ALTER).
async function _firmaWrite(url, method, bodyFull, dropKeys){
  var r=await fetch(url,{method:method,headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(bodyFull)});
  if(!r.ok && dropKeys && dropKeys.length){ var min=Object.assign({},bodyFull); dropKeys.forEach(function(k){delete min[k];}); r=await fetch(url,{method:method,headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(min)}); }
  return r;
}
function _firmaVerFirmadaCompras(id, path, nombre, yaRecibida){ _firmaVer(path, nombre); if(!yaRecibida) _firmaMarcarRecibida(id); }
async function _firmaRefOrden(id){ try{ var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=num_orden,proveedor&limit=1',{headers:SBH}).then(function(r){return r.json();}); var o=d&&d[0]; return o?((o.num_orden?o.num_orden+' ':'')+(o.proveedor||'')):('#'+id); }catch(e){ return '#'+id; } }
async function _firmaMarcarRecibida(id){
  try{
    await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',{ recibido_en:new Date().toISOString() },['recibido_en']);
    var ref=await _firmaRefOrden(id);
    try{ addNotif('gerencia','Orden '+ref+' recibida (firmada) por compras','','ti-writing-sign'); }catch(e){}
    _firmaCargarLista('compras');
    try{ _firmaActualizarBadge(); }catch(e){}
  }catch(e){ console.warn('marcar recibida:',e); }
}
// ═══════════════════════════════════════════════════════════════════════════
//  ENVIAR LA ORDEN FIRMADA AL PROVEEDOR
//  Abre una pantalla con el correo del proveedor ya cargado (si está en SAP),
//  la orden firmada adjunta y el asunto armado. El cuerpo queda editable.
// ═══════════════════════════════════════════════════════════════════════════
// Busca el correo del proveedor en las órdenes de SAP por nombre
function _firmaCorreoProveedor(nombre){
  var n=_repNorm(nombre);
  if(!n) return '';
  var lista=(typeof orders!=='undefined' && orders)?orders:[];
  var exacto=lista.find(function(o){ return o.vendorEmail && _repNorm(o.prov)===n; });
  if(exacto) return exacto.vendorEmail;
  var parcial=lista.find(function(o){
    if(!o.vendorEmail) return false;
    var p=_repNorm(o.prov);
    return p && (p.indexOf(n)>=0 || n.indexOf(p)>=0);
  });
  return parcial?parcial.vendorEmail:'';
}

// ── Chips de CC: compañeros del departamento + gerencia ──
// Se marcan con un clic y se van escribiendo en el campo CC.
function _firmaCandidatosCC(){
  var yo=((CU&&CU.email)||'').toLowerCase();
  var mios=[], gerencia=[];
  (USERS||[]).forEach(function(u){
    if(!u.email) return;
    if(u.email.toLowerCase()===yo) return;                 // uno mismo no
    if(u.role==='gerencia'){ gerencia.push(u); return; }
    if(CU && u.role===CU.role && (_deptPermitido(u.dept)||(!u.dept&&!_deptAcotado()))) mios.push(u);
  });
  return {equipo:mios, gerencia:gerencia};
}
function _firmaChipsCC(){
  var c=_firmaCandidatosCC();
  if(!c.equipo.length && !c.gerencia.length) return '';
  function chip(u, color, bg, bd){
    return '<span class="cc-chip" data-mail="'+_esc(u.email)+'" onclick="_firmaToggleCC(this)"'
      +' style="border:1px solid '+bd+';background:var(--surface-1);color:'+color+'">'
      +'<i class="ti ti-plus" style="font-size:10px"></i>'+_esc(u.name||u.email)+'</span>';
  }
  var h='<div style="display:flex;gap:5px;flex-wrap:wrap;margin-top:5px">';
  c.equipo.forEach(function(u){ h+=chip(u,'#0c447c','#e6f1fb','#85B7EB'); });
  c.gerencia.forEach(function(u){ h+=chip(u,'#27500A','#EAF3DE','#A9C98A'); });
  h+='</div>';
  h+='<div style="display:flex;gap:8px;margin-top:5px">'
    +'<span onclick="_firmaCCTodos()" style="font-size:10.5px;color:var(--text-accent);cursor:pointer;text-decoration:underline">Marcar todos</span>'
    +'<span onclick="_firmaCCNinguno()" style="font-size:10.5px;color:var(--text-muted);cursor:pointer;text-decoration:underline">Quitar todos</span>'
    +'</div>';
  return h;
}
function _firmaCCSync(){
  var inp=document.getElementById('ep-cc'); if(!inp) return;
  // Respeta los correos escritos a mano que no correspondan a ningún chip
  var chips=Array.prototype.slice.call(document.querySelectorAll('.cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); })
                   .map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}
function _firmaToggleCC(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i) i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus');
  if(i) i.style.fontSize='10px';
  _firmaCCSync();
}
function _firmaCCTodos(){
  document.querySelectorAll('.cc-chip').forEach(function(c){ if(!c.classList.contains('on')) _firmaToggleCC(c); });
}
function _firmaCCNinguno(){
  document.querySelectorAll('.cc-chip').forEach(function(c){ if(c.classList.contains('on')) _firmaToggleCC(c); });
}

async function _firmaEnviadaProveedor(id){
  try{
    var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*&limit=1',{headers:SBH}).then(function(r){return r.json();});
    var o=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!o){ showT('No se encontró la orden'); return; }
    window._firmaEnvProv=o;

    var correo=_firmaCorreoProveedor(o.proveedor||'');
    // El asunto lleva el N° DKC de la orden: CONFIRMATION DKC-26118
    var dkc=_firmaNormDKC(o.dkc)||_firmaNormRef(o.num_orden||'')||String(o.num_orden||'').trim();
    var asunto='CONFIRMATION'+(dkc?(' '+dkc):'');
    var tieneAdj=!!o.archivo_firmado_path;

    var ov=document.createElement('div');
    ov.id='modalEnvProv';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2002;display:flex;align-items:center;justify-content:center;padding:16px';
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:540px;width:100%;max-height:92vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700"><i class="ti ti-send" style="color:var(--t-azul)"></i> Enviar orden al proveedor</div>'
      +'<button onclick="document.getElementById(\'modalEnvProv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';

    h+='<div style="background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px">'
      +'<b>'+_esc(o.num_orden||'')+'</b> &middot; '+_esc(o.proveedor||'')
      +(o.descripcion?(' &middot; '+_esc(o.descripcion)):'')+'</div>';

    // Adjunto: la orden firmada por gerencia
    h+='<div style="font-size:11px;color:var(--text-secondary);font-weight:600;margin-bottom:4px"><i class="ti ti-paperclip"></i> Adjunto</div>';
    if(tieneAdj){
      h+='<div style="display:flex;align-items:center;gap:7px;background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:7px;padding:8px 10px;margin-bottom:12px;font-size:11.5px;color:var(--t-verde)">'
        +'<i class="ti ti-writing-sign"></i><span style="flex:1">'+_esc(o.archivo_firmado_nombre||'orden firmada')+'</span>'
        +'<button class="btn bg2" style="padding:3px 8px;font-size:10.5px" onclick="_firmaVer(\''+_esc(o.archivo_firmado_path)+'\',\''+_esc(o.archivo_firmado_nombre||'firmada')+'\')">ver</button></div>';
    } else {
      h+='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:7px;padding:8px 10px;margin-bottom:12px;font-size:11.5px;color:var(--t-rojo)">'
        +'<i class="ti ti-alert-triangle"></i> Esta compra no tiene la orden firmada guardada. El correo saldría sin adjunto.</div>';
    }

    h+='<div style="display:flex;flex-direction:column;gap:9px">';
    h+='<div><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Para *</label>'
      +'<input id="ep-para" value="'+_esc(correo)+'" placeholder="correo@proveedor.com (uno o varios, separados por coma)" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;margin-top:3px;background:var(--surface-2);color:var(--text-primary)">'
      +(correo?'<div style="font-size:10px;color:var(--text-success);margin-top:3px"><i class="ti ti-circle-check"></i> Correo tomado de SAP</div>'
              :'<div style="font-size:10px;color:var(--t-ambar);margin-top:3px"><i class="ti ti-alert-circle"></i> Este proveedor no tiene correo en SAP: escríbelo a mano</div>')
      +'</div>';
    // CC: el equipo del departamento y gerencia, para marcar con un clic
    h+='<div><label style="font-size:11px;color:var(--text-secondary);font-weight:500">CC — copia interna</label>'
      +_firmaChipsCC()
      +'<input id="ep-cc" placeholder="Marca arriba o escribe: copia@ejemplo.com" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;margin-top:5px;background:var(--surface-2);color:var(--text-primary)"></div>';
    h+='<div><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Asunto *</label>'
      +'<input id="ep-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;margin-top:3px;background:var(--surface-2);color:var(--text-primary)"></div>';
    h+='<div><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Mensaje</label>'
      +'<textarea id="ep-cuerpo" rows="16" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;margin-top:3px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical;line-height:1.45">'
      +_esc(_firmaCuerpoProveedor(o))+'</textarea>'
      +'<div style="font-size:10px;color:var(--text-muted);margin-top:3px">Puedes editarlo antes de enviar. El N° DKC ya viene puesto.</div></div>';
    h+='</div>';

    h+='<div style="display:flex;gap:8px;margin-top:16px">';
    h+='<button class="btn bg2" style="flex:1;padding:10px" onclick="document.getElementById(\'modalEnvProv\').remove()">Cancelar</button>';
    h+='<button class="btn bp" style="flex:2;padding:10px" onclick="_firmaEnviarAlProveedor('+id+')"><i class="ti ti-send"></i> Enviar al proveedor</button>';
    h+='</div></div>';

    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ e.stopPropagation(); });   // no se cierra al hacer clic fuera: hay datos escritos
    document.body.appendChild(ov);
  }catch(e){ showT('Error: '+(e.message||e)); }
}

// Cuerpo por defecto del correo de confirmación al proveedor.
// Queda editable en la pantalla antes de enviar.
function _firmaCuerpoProveedor(o){
  var dkc=_firmaNormDKC(o&&o.dkc)||_firmaNormRef((o&&o.num_orden)||'')||'DKC-';
  return 'Dear Vendor,\n'
+'Kindly find attached your company\u2019s PI and our Purchase Order '+dkc+' duly signed as final confirmation for this order.  Also we included the DKC excel sheet format for your convenience.\n'
+'\n'
+'As you may see, we added the following:\n'
+'   * We included our new '+dkc+' number\n'
+'   * We also included our NEW item and barcode numbers FOR THIS NEW ORDER\n'
+'   * We also included the Spanish name that must be used in the shipping marks only.   Spanish package description for artworks is usually kind of different than shipping marks.\n'
+'\n'
+'Also please follow the instructions below:\n'
+'-            Our '+dkc+' number must be used in all our e-mail communications from now on please.\n'
+'-            Shipping marks will be sent right after confirmation of this order\n'
+'-            Please check if bank details are ok to arrange deposit.  ON a separate email you will be asked for special banking documents\n'
+'\n'
+'Ref. ARTWORKS:  In order to make package design we need the following:\n'
+'\u00b7       Diecuts for all packages, boxes, sleeves cards, hang tags, etc.\n'
+'\u00b7       Photos for each product in HD resolution\n'
+'\u00b7       Any QC certification you carry\n'
+'\n'
+'IMPORTANT:\n'
+'   1. Nominated carrier information will be sent once you are ready for shipment\n'
+'   2. Booking must be arranged 2 weeks before shipment\n'
+'   3. Mass production Inspection photos must be sent before shipment when booked for approval\n'
+'   4. Few Samples might be requested before final shipment\n'
+'\n'
+'Hope all is clear and fine, if any question, please feel free to let me know.\n'
+'Thanks for your great sense of business, we appreciate.\n'
+'\n'
+'Best regards,\n'
+_firmaNombre();
}

async function _firmaEnviarAlProveedor(id){
  var o=window._firmaEnvProv;
  if(!o){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var para=(document.getElementById('ep-para').value||'').split(/[,;]/).map(function(s){return s.trim();}).filter(Boolean);
  var cc=(document.getElementById('ep-cc').value||'').split(/[,;]/).map(function(s){return s.trim();}).filter(Boolean);
  var asunto=(document.getElementById('ep-asunto').value||'').trim();
  var cuerpo=(document.getElementById('ep-cuerpo').value||'');
  if(!para.length){ showT('Escribe al menos un destinatario'); return; }
  if(!asunto){ showT('Falta el asunto'); return; }

  showT('Enviando al proveedor…');
  try{
    var todos=para.concat(cc);
    var fila={
      docnum:'PROV-'+id,
      para_lista: todos,
      para_email: todos[0],
      proveedor: o.proveedor||'',
      asunto: asunto,
      cuerpo: _repCuerpoTexto(cuerpo),
      adjunto_path: o.archivo_firmado_path||null,
      adjunto_nombre: o.archivo_firmado_nombre||null,
      de_nombre: (CU&&CU.name)||'',
      de_email: (CU&&CU.email)||'',
      estado:'pendiente',
      creado_por:(CU&&CU.name)||'',
      creado_en:new Date().toISOString()
    };
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)
    });
    if(!r.ok){ var t=await r.text(); console.error('correo proveedor',r.status,t); showT('⚠ No se pudo encolar el correo'); return; }

    // Recién ahora se marca como enviada a proveedor
    var body={ estado:'enviada_proveedor', enviado_proveedor_en:new Date().toISOString(),
               enviado_por:(CU&&CU.name)||'', enviado_proveedor_email:todos.join(','),
               recibido_en:new Date().toISOString() };
    await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',body,
                      ['enviado_proveedor_en','enviado_por','recibido_en','enviado_proveedor_email']);
    var ref=await _firmaRefOrden(id);
    try{ addNotif('gerencia','Orden '+ref+' enviada al proveedor por '+((CU&&CU.name)||''),'','ti-send'); }catch(e){}

    var m=document.getElementById('modalEnvProv'); if(m) m.remove();
    showT('✓ Correo en cola para '+todos.length+' destinatario(s)');
    _firmaCargarLista('compras'); _firmaActualizarBadge();
  }catch(e){ console.error('enviar proveedor:',e); showT('Error: '+(e.message||e)); }
}
function _firmaVer(path,nombre){ if(!path)return; var url=DOCS_BASE+path.split('/').map(encodeURIComponent).join('/'); verArchivo(url,nombre); }

function _firmaAbrir(id){
  fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*&limit=1',{headers:SBH}).then(function(r){return r.json();}).then(function(d){
    var o=(Array.isArray(d)&&d[0])?d[0]:null; if(!o){ showT('No se encontro la orden'); return; }
    window._firmaOrden=o;
    var ov=document.createElement('div');
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2000;display:flex;align-items:center;justify-content:center;padding:16px';
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:560px;width:100%;max-height:92vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px"><div style="font-size:15px;font-weight:700"><i class="ti ti-signature" style="color:var(--text-accent)"></i> Firmar compra</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
    h+='<div style="font-size:13px;font-weight:600">'+(o.num_orden?('<b>'+_esc(o.num_orden)+'</b> &middot; '):'')+_esc(o.proveedor||'')+'</div><div style="font-size:11px;color:var(--text-muted);margin-bottom:10px">'+_esc(o.descripcion||'')+' &middot; '+fmt(o.monto||0)+' &middot; '+(EMOJIS2[o.dept]||'')+' '+_esc(dL(o.dept||''))+' &middot; '+_esc(o.creado_por_nom||'')+'</div>';
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:12px">';
    if(o.archivo_path) h+='<button class="btn bg2" style="color:var(--t-azul)" onclick="_firmaVer(\''+_esc(o.archivo_path)+'\',\''+_esc(o.archivo_nombre||'archivo')+'\')"><i class="ti ti-file"></i> Ver KCC orden de compra</button>';
    if(o.archivo_path2) h+='<button class="btn bg2" style="color:var(--t-ambar)" onclick="_firmaVer(\''+_esc(o.archivo_path2)+'\',\''+_esc(o.archivo_nombre2||'PI proveedor')+'\')"><i class="ti ti-file"></i> Ver PI proveedor</button>';
    h+='</div>';
    if(o.archivo_path2) h+='<div style="font-size:11px;color:var(--t-marron);background:var(--pastel-aviso);border:0.5px solid #E9C08A;border-radius:8px;padding:8px 10px;margin-bottom:12px"><i class="ti ti-writing-sign"></i> Al firmar se firmarán <b>los dos documentos por separado</b>.</div>';
    // Páginas donde se estampará la firma (última de cada proforma)
    var sug=[];
    try{
      var rv0=o.revision_ia; if(typeof rv0==='string') rv0=JSON.parse(rv0);
      ((rv0&&rv0.data&&rv0.data.documentos)||[]).forEach(function(d){
        var n=Number(d.pagina_final||0);
        if(n>=1 && sug.indexOf(n)<0) sug.push(n);
      });
    }catch(e){}
    sug.sort(function(a,b){return a-b;});
    window._firmaPaginasManual=null;
    h+='<div style="background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:12px">'
      +'<div style="font-size:11px;font-weight:600;margin-bottom:4px"><i class="ti ti-writing-sign"></i> Páginas donde va la firma</div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:5px">La firma va abajo a la derecha, debajo del total de cada proforma. Si el archivo trae las dos órdenes, escribe las dos páginas separadas por coma.</div>'
      +'<input id="firma-paginas" value="'+(sug.join(', '))+'" placeholder="Ej: 9, 18 (vacío = última página)" oninput="_firmaSetPaginas(this.value)" style="width:100%;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)">'
      +(sug.length?('<div style="font-size:10px;color:var(--text-success);margin-top:3px"><i class="ti ti-sparkles"></i> Detectado por la AI: fin de cada orden en la(s) página(s) '+sug.join(' y ')+'</div>')
                  :'<div style="font-size:10px;color:var(--t-ambar);margin-top:3px">Sin revisión AI: se firmará solo la última página. Escribe las páginas si el archivo trae dos órdenes.</div>')
      +'</div>';
    _firmaSetPaginas(sug.join(','));
    h+='<div style="font-size:11px;color:var(--text-secondary);font-weight:600;margin-bottom:4px"><i class="ti ti-pencil"></i> Dibuja tu firma</div>';
    h+='<canvas id="firma-canvas" width="520" height="140" style="border:1px solid var(--border);border-radius:8px;background:var(--surface-2);width:100%;touch-action:none;cursor:crosshair"></canvas>';
    h+='<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:12px;flex-wrap:wrap">';
    h+='<button class="btn bg2" onclick="_firmaLimpiarCanvas()"><i class="ti ti-eraser"></i> Limpiar</button>';
    h+='<button class="btn bg2" style="color:var(--text-danger)" onclick="_firmaRechazar('+o.id+')"><i class="ti ti-x"></i> Rechazar</button>';
    h+='<button class="btn bp" onclick="_firmaFirmar('+o.id+')"><i class="ti ti-check"></i> Firmar y enviar</button>';
    h+='</div></div>';
    ov.innerHTML=h; document.body.appendChild(ov);
    _firmaInitCanvas();
  }).catch(function(e){ showT('Error: '+(e.message||e)); });
}
// ═══════════════════════════════════════════════════════════════════════════
//  EDITAR / BORRAR UNA COMPRA PARA FIRMA
//  Solo mientras gerencia NO la haya firmado, y solo para quien la creó.
//  Se pueden corregir los datos y reemplazar el PDF adjunto.
// ═══════════════════════════════════════════════════════════════════════════
window._firmaEditArchivo=null;

async function _firmaEditar(id){
  try{
    var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*&limit=1',{headers:SBH}).then(function(r){return r.json();});
    var o=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!o){ showT('No se encontró la orden'); return; }
    if(o.estado==='firmada'||o.estado==='enviada_proveedor'){ showT('Ya fue firmada: no se puede editar'); _firmaCargarLista('compras'); return; }
    if(!_esDeMiEquipo(o.creado_por)){ showT('Solo el equipo que creó la compra puede editarla'); return; }

    window._firmaEditArchivo=null;
    var deptOpts=DEPTS_ALL.map(function(x){ return '<option value="'+x+'"'+((o.dept===x)?' selected':'')+'>'+dL(x)+'</option>'; }).join('');
    var ov=document.createElement('div');
    ov.id='modalEditarFirma';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2001;display:flex;align-items:center;justify-content:center;padding:16px';
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:520px;width:100%;max-height:92vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700"><i class="ti ti-pencil" style="color:var(--t-ambar)"></i> Editar compra para firma</div>'
      +'<button onclick="document.getElementById(\'modalEditarFirma\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
    h+='<div style="background:var(--pastel-aviso);border:0.5px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
      +'<i class="ti ti-info-circle"></i> Puedes corregirla mientras gerencia no la firme. También puedes reemplazar el PDF adjunto.</div>';
    h+='<div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:10px">';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">N° de orden (DKC / SKC) *</label><input id="fe-orden" class="fi2" value="'+_esc(o.num_orden||'')+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Proveedor *</label><input id="fe-prov" class="fi2" value="'+_esc(o.proveedor||'')+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Departamento *</label><select id="fe-dept" class="fi2">'+deptOpts+'</select></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Descripción *</label><input id="fe-desc" class="fi2" value="'+_esc(o.descripcion||'')+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Monto total (USD) *</label><input id="fe-monto" type="number" step="0.01" class="fi2" value="'+(Number(o.monto)||0)+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Unidades</label><input id="fe-uni" type="number" class="fi2" value="'+(Number(o.unidades)||0)+'"></div>';
    h+='<div style="display:flex;flex-direction:column;gap:3px"><label style="font-size:11px;color:var(--text-secondary);font-weight:500">Fecha estimada</label><input id="fe-fecha" type="date" class="fi2" value="'+_esc(o.fecha_estimada||'')+'"></div>';
    h+='</div>';
    h+='<div style="font-size:11px;color:var(--text-secondary);font-weight:600;margin-bottom:4px">Archivo adjunto</div>';
    h+='<div style="font-size:11.5px;background:var(--surface-1);border-radius:7px;padding:7px 10px;margin-bottom:6px"><i class="ti ti-file"></i> '+_esc(o.archivo_nombre||'sin archivo')+'</div>';
    h+='<label style="display:flex;align-items:center;gap:7px;padding:9px 11px;border:1.5px dashed var(--border-accent);border-radius:8px;cursor:pointer;font-size:12px;color:var(--text-accent);background:var(--bg-accent);margin-bottom:14px">'
      +'<i class="ti ti-upload"></i><span id="fe-file-name">Reemplazar el PDF o Excel (opcional)</span>'
      +'<input type="file" accept=".pdf,.xlsx,.xls,.png,.jpg,.jpeg" style="display:none" onchange="_firmaEditSetArchivo(this)"></label>';
    h+='<div style="display:flex;gap:8px">';
    h+='<button class="btn bg2" style="flex:1;padding:10px" onclick="document.getElementById(\'modalEditarFirma\').remove()">Cancelar</button>';
    h+='<button class="btn bp" style="flex:2;padding:10px" onclick="_firmaGuardarEdicion('+o.id+')"><i class="ti ti-device-floppy"></i> Guardar cambios</button>';
    h+='</div></div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ e.stopPropagation(); });   // no se cierra al hacer clic fuera: hay datos escritos
    document.body.appendChild(ov);
  }catch(e){ showT('Error: '+(e.message||e)); }
}

function _firmaEditSetArchivo(input){
  var f=input.files&&input.files[0]; if(!f) return;
  window._firmaEditArchivo=f;
  var el=document.getElementById('fe-file-name'); if(el) el.textContent=f.name;
}

async function _firmaGuardarEdicion(id){
  var num=(document.getElementById('fe-orden').value||'').trim();
  var prov=(document.getElementById('fe-prov').value||'').trim();
  var dept=document.getElementById('fe-dept').value;
  var desc=(document.getElementById('fe-desc').value||'').trim();
  var monto=parseFloat(document.getElementById('fe-monto').value)||0;
  var uni=parseInt(document.getElementById('fe-uni').value)||0;
  var fEst=document.getElementById('fe-fecha').value||null;
  if(!num||!prov||!dept||!desc||!monto){ showT('Completa N° de orden, proveedor, departamento, descripción y monto'); return; }
  showT('Guardando cambios...');
  try{
    var patch={ num_orden:num, proveedor:prov, dept:dept, descripcion:desc, monto:monto, unidades:uni,
                fecha_estimada:fEst, actualizado_en:new Date().toISOString() };
    if(window._firmaEditArchivo){
      var path=await _subirDocStorage('firma', dept, window._firmaEditArchivo);
      if(path){
        patch.archivo_path=path;
        patch.archivo_nombre=window._firmaEditArchivo.name;
        patch.revision_ia=null;   // el archivo cambió: la revisión anterior ya no aplica
      } else { showT('No se pudo subir el archivo nuevo'); return; }
    }
    var r=await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',patch,['fecha_estimada','revision_ia','actualizado_en']);
    if(!r.ok){ var t=await r.text(); console.error('editar firma',r.status,t); showT('No se pudo guardar'); return; }
    window._firmaEditArchivo=null;
    var m=document.getElementById('modalEditarFirma'); if(m) m.remove();
    showT('✓ Compra actualizada'+(patch.archivo_path?' con el archivo nuevo':''));
    _firmaCargarLista('compras');
  }catch(e){ console.error('guardar edicion firma:',e); showT('Error: '+(e.message||e)); }
}

async function _firmaBorrar(id){
  try{
    var d=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id+'&select=*&limit=1',{headers:SBH}).then(function(r){return r.json();});
    var o=(Array.isArray(d)&&d[0])?d[0]:null;
    if(!o){ showT('No se encontró la orden'); return; }
    // Cualquier usuario puede borrarla, en cualquier estado, pero siempre
    // confirmando. El aviso avisa si ya estaba firmada o enviada al proveedor.
    var ref=(o.num_orden?o.num_orden+' — ':'')+(o.proveedor||'');
    var extra='';
    if(o.estado==='firmada') extra='\n\nOJO: esta orden YA FUE FIRMADA por gerencia.';
    else if(o.estado==='enviada_proveedor') extra='\n\nOJO: esta orden YA FUE ENVIADA AL PROVEEDOR.';
    if(!confirm('¿Seguro que desea eliminar la orden "'+ref+'"?'+extra+'\n\nEsta acción no se puede deshacer.')) return;
    var r=await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id,{method:'DELETE',headers:SBH});
    if(!r.ok){ var t=await r.text(); console.error('borrar firma',r.status,t); showT('No se pudo borrar'); return; }
    showT('Compra para firma borrada');
    _firmaCargarLista('compras'); _firmaActualizarBadge();
  }catch(e){ showT('Error: '+(e.message||e)); }
}

function _firmaSetPaginas(v){
  var ns=String(v||'').split(/[,;\s]+/).map(function(x){ return parseInt(x,10); })
    .filter(function(n){ return !isNaN(n) && n>=1; });
  var out=[]; ns.forEach(function(n){ if(out.indexOf(n)<0) out.push(n); });
  window._firmaPaginasManual = out.length?out:null;
}

var _firmaCtx=null, _firmaDibujando=false, _firmaHayTrazo=false;
function _firmaInitCanvas(){
  var c=document.getElementById('firma-canvas'); if(!c) return;
  _firmaCtx=c.getContext('2d'); _firmaCtx.lineWidth=2.2; _firmaCtx.lineCap='round'; _firmaCtx.lineJoin='round'; _firmaCtx.strokeStyle='#0b2e5e'; _firmaHayTrazo=false;
  function pos(e){ var r=c.getBoundingClientRect(); var t=e.touches&&e.touches[0]; var cx=(t?t.clientX:e.clientX)-r.left; var cy=(t?t.clientY:e.clientY)-r.top; return {x:cx*(c.width/r.width), y:cy*(c.height/r.height)}; }
  function down(e){ e.preventDefault(); _firmaDibujando=true; var p=pos(e); _firmaCtx.beginPath(); _firmaCtx.moveTo(p.x,p.y); }
  function move(e){ if(!_firmaDibujando)return; e.preventDefault(); var p=pos(e); _firmaCtx.lineTo(p.x,p.y); _firmaCtx.stroke(); _firmaHayTrazo=true; }
  function up(){ _firmaDibujando=false; }
  c.onmousedown=down; c.onmousemove=move; window.addEventListener('mouseup',up);
  c.ontouchstart=down; c.ontouchmove=move; c.ontouchend=up;
}
function _firmaLimpiarCanvas(){ var c=document.getElementById('firma-canvas'); if(c&&_firmaCtx){ _firmaCtx.clearRect(0,0,c.width,c.height); _firmaHayTrazo=false; } }

// ═══════════════════════════════════════════════════════════════════════════
//  ESTAMPADO DE LA FIRMA
//  · Va en la ÚLTIMA página de cada proforma (la nuestra y la del proveedor),
//    abajo a la derecha, debajo del total.
//  · Siempre HORIZONTAL: si la página trae rotación (/Rotate 90, 180 o 270),
//    se compensa para que la firma se vea derecha y no de lado.
// ═══════════════════════════════════════════════════════════════════════════

// Convierte una posición "como se ve en pantalla" a coordenadas del PDF,
// devolviendo también el giro que hay que aplicar para que salga horizontal.
function _firmaPosEnPagina(page, Xd, Yd){
  var rot=0;
  try{ rot=((page.getRotation&&page.getRotation().angle)||0)%360; }catch(e){ rot=0; }
  if(rot<0) rot+=360;
  var w=page.getWidth(), h=page.getHeight();
  if(rot===90)  return {x:w-Yd, y:Xd,   ang:90,  Wd:h, Hd:w};
  if(rot===180) return {x:w-Xd, y:h-Yd, ang:180, Wd:w, Hd:h};
  if(rot===270) return {x:Yd,   y:h-Xd, ang:270, Wd:h, Hd:w};
  return {x:Xd, y:Yd, ang:0, Wd:w, Hd:h};
}

// Estampa firma + pie en una página concreta
function _firmaEstampar(PDFLib, page, png, texto, font){
  var med=_firmaPosEnPagina(page, 0, 0);
  var m=34;
  var sw=170, sh=sw*(png.height/png.width);
  if(sh>70){ sh=70; sw=sh*(png.width/png.height); }
  // Abajo a la derecha, dejando lugar para el pie de texto
  var Xd=med.Wd-sw-m, Yd=m+13;
  if(Xd<m) Xd=m;
  var p=_firmaPosEnPagina(page, Xd, Yd);
  page.drawImage(png,{ x:p.x, y:p.y, width:sw, height:sh, rotate:PDFLib.degrees(p.ang) });
  var t=_firmaPosEnPagina(page, Xd, m+2);
  var op={ x:t.x, y:t.y, size:7.5, rotate:PDFLib.degrees(t.ang) };
  if(font) op.font=font;
  try{ page.drawText(texto,op); }catch(e){}
}

// Páginas donde termina cada orden. Usa lo que detectó la revisión AI y,
// si no hay nada, firma solo la última página del archivo.
function _firmaPaginasDeFirma(o, totalPaginas){
  var pgs=[];
  try{
    var rv=o.revision_ia;
    if(typeof rv==='string') rv=JSON.parse(rv);
    var docs=(rv&&rv.data&&rv.data.documentos)||[];
    docs.forEach(function(d){
      var n=Number(d.pagina_final||0);
      if(n>=1 && n<=totalPaginas && pgs.indexOf(n)<0) pgs.push(n);
    });
  }catch(e){}
  // Override manual desde el modal de firma
  try{
    var manual=window._firmaPaginasManual;
    if(manual && manual.length) pgs=manual.filter(function(n){ return n>=1&&n<=totalPaginas; });
  }catch(e){}
  if(!pgs.length) pgs=[totalPaginas];
  return pgs.sort(function(a,b){return a-b;});
}

async function _firmaGenerarPDFFirmado(o, firmaPng){
  var esPdf=o.archivo_path && /\.pdf$/i.test(o.archivo_nombre||o.archivo_path||'');
  var nombre=(o._sufijo?('PI_Proveedor_Firmada_'):'Orden_Firmada_')
    +String(o.proveedor||'compra').replace(/[^\w]+/g,'_')+'_'+new Date().toISOString().slice(0,10)+'.pdf';
  if(esPdf){
    try{
      var PDFLib=await _ensurePdfLib();
      var url=DOCS_BASE+o.archivo_path.split('/').map(encodeURIComponent).join('/');
      var bytes=await fetch(url).then(function(r){return r.arrayBuffer();});
      var pdfDoc=await PDFLib.PDFDocument.load(bytes);
      var png=await pdfDoc.embedPng(_dataURLtoUint8(firmaPng));
      var font=null;
      try{ font=await pdfDoc.embedFont(PDFLib.StandardFonts.Helvetica); }catch(e){}
      var pages=pdfDoc.getPages();
      var texto='Firmado por '+((CU&&CU.name)||'')+' - '+new Date().toLocaleDateString('es');
      var cuales=_firmaPaginasDeFirma(o, pages.length);
      cuales.forEach(function(n){
        var pg=pages[n-1];
        if(pg) _firmaEstampar(PDFLib, pg, png, texto, font);
      });
      window._firmaPaginasUsadas=cuales;
      var out=await pdfDoc.save();
      return new File([out], nombre, {type:'application/pdf'});
    }catch(e){ console.warn('pdf-lib estampar fallo, genero PDF resumen:',e); }
  }
  var doc=new window.jspdf.jsPDF({unit:'pt',format:'letter',compress:true});
  var W=612,M=48,y=70;
  doc.setFont('helvetica','bold'); doc.setFontSize(15); doc.setTextColor(30,80,165);
  doc.text('KENNEDY CENTER CORP.',W/2,y,{align:'center'}); y+=22;
  doc.setFontSize(13); doc.setTextColor(0); doc.text('ORDEN DE COMPRA - APROBADA Y FIRMADA',W/2,y,{align:'center'}); y+=30;
  doc.setFontSize(10); doc.setFont('helvetica','normal');
  function line(l,v){ doc.setFont('helvetica','bold'); doc.text(String(l),M,y); doc.setFont('helvetica','normal'); doc.text(String(v==null?'':v),M+130,y); y+=20; }
  line('Proveedor:',o.proveedor); line('Descripcion:',o.descripcion); line('Departamento:',dL(o.dept||''));
  line('Monto total:',fmt(o.monto||0)); line('Unidades:',o.unidades||0); line('Solicitado por:',o.creado_por_nom);
  line('Fecha:',new Date().toLocaleDateString('es'));
  y+=16; doc.setFont('helvetica','bold'); doc.text('Firma de gerencia:',M,y); y+=8;
  try{ doc.addImage(firmaPng,'PNG',M,y,200,66); }catch(e){}
  y+=78; doc.setFont('helvetica','normal'); doc.setFontSize(9);
  doc.text('Firmado por '+((CU&&CU.name)||'')+' - '+new Date().toLocaleString('es'),M,y);
  if(o.archivo_nombre){ y+=16; doc.setTextColor(90); doc.text('Archivo original de la compra: '+o.archivo_nombre,M,y); }
  return new File([doc.output('blob')], nombre, {type:'application/pdf'});
}

async function _firmaFirmar(id){
  if(!_firmaHayTrazo){ showT('Dibuja tu firma primero'); return; }
  var o=window._firmaOrden||{}; var canvas=document.getElementById('firma-canvas'); if(!canvas) return;
  var firmaPng=canvas.toDataURL('image/png');
  showT('Generando orden firmada...');
  try{
    // Se firma NUESTRA orden y, si existe, también la PI del proveedor.
    // Cada una queda como archivo firmado aparte.
    var signedFile=await _firmaGenerarPDFFirmado(o, firmaPng);
    var path=await _subirDocStorage('firma_signed', o.dept||'gen', signedFile);
    if(!path){ showT('No se pudo subir la orden firmada'); return; }

    var path2=null, nombre2=null;
    if(o.archivo_path2){
      try{
        showT('Firmando también la PI del proveedor…');
        var o2=Object.assign({}, o, {
          archivo_path:o.archivo_path2,
          archivo_nombre:o.archivo_nombre2,
          _sufijo:'PI_PROVEEDOR',
          revision_ia:null            // las páginas de firma se recalculan para este archivo
        });
        var signed2=await _firmaGenerarPDFFirmado(o2, firmaPng);
        path2=await _subirDocStorage('firma_signed', o.dept||'gen', signed2);
        nombre2=signed2.name;
        if(!path2) showT('⚠ La orden se firmó, pero no se pudo subir la PI firmada');
      }catch(e){ console.warn('firmar PI proveedor:',e); showT('⚠ No se pudo firmar la PI del proveedor'); }
    }

    var patch={ estado:'firmada', firmado_por:(CU&&CU.name)||'', firmado_en:new Date().toISOString(),
                archivo_firmado_path:path, archivo_firmado_nombre:signedFile.name,
                archivo_firmado_path2:path2, archivo_firmado_nombre2:nombre2 };
    var r=await _firmaWrite(SB+'/rest/v1/ordenes_firma?id=eq.'+id,'PATCH',patch,['archivo_firmado_path2','archivo_firmado_nombre2']);
    if(!r.ok){ var t=await r.text(); console.error('firma patch',r.status,t); showT('No se pudo guardar la firma'); return; }
    try{
      var para=o.creado_por_email||_firmaCorreoDe(o.creado_por);
      if(para){
        await fetch(SB+'/rest/v1/correos_queue',{method:'POST',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify({
          docnum:'FIRMA-'+id, para_email:para, proveedor:o.proveedor||'',
          asunto:'Orden firmada - '+(o.num_orden?o.num_orden+' - ':'')+(o.proveedor||''),
          cuerpo:'Hola '+((o.creado_por_nom||'').split(' ')[0]||'')+',\n\n'
            +'Tu compra ya fue revisada y firmada por '+((CU&&CU.name)||'gerencia')+'.\n\n'
            +'Detalle:\n'
            +(o.num_orden?('  - Orden: '+o.num_orden+'\n'):'')
            +'  - Proveedor: '+(o.proveedor||'')+'\n'
            +(o.descripcion?('  - Descripcion: '+o.descripcion+'\n'):'')
            +(o.monto?('  - Monto: '+fmt(o.monto)+'\n'):'')
            +(o.unidades?('  - Unidades: '+o.unidades+'\n'):'')
            +'  - Firmada el: '+new Date().toLocaleDateString('es')+'\n\n'
            +'Adjuntamos la orden firmada. Ya puedes enviarsela al proveedor.\n\n'
            +'Saludos,\n'
            +((CU&&CU.name)||'Gerencia')+'\n'
            +'Kennedy Center Corp.',
          adjunto_path:path, adjunto_nombre:signedFile.name,
          estado:'pendiente', creado_por:(CU&&CU.name)||'', creado_en:new Date().toISOString()
        })});
      }
    }catch(e){ console.warn('correo firma:',e); }
    try{ addNotif(o.creado_por,'Tu compra '+(o.proveedor||'')+' fue firmada por '+((CU&&CU.name)||'gerencia'),'','ti-writing-sign'); }catch(e){}
    try{ _accRegistrar('accion','Firmó una compra', o.id||''); }catch(e){}
    showT('Firmada en la(s) página(s) '+((window._firmaPaginasUsadas||[]).join(', ')||'final')+'. Se notificó al comprador.');
    var mm=canvas.closest('div[style*=fixed]'); if(mm) mm.remove();
    _firmaCargarLista('gerencia'); _firmaActualizarBadge();
  }catch(e){ console.error('firmar:',e); showT('Error al firmar: '+(e.message||e)); }
}
async function _firmaRechazar(id){
  var motivo=prompt('Motivo del rechazo (opcional):')||'';
  try{
    var o=window._firmaOrden||{};
    await fetch(SB+'/rest/v1/ordenes_firma?id=eq.'+id,{method:'PATCH',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify({estado:'rechazada',motivo_rechazo:motivo,firmado_por:(CU&&CU.name)||'',firmado_en:new Date().toISOString()})});
    try{ addNotif(o.creado_por,'Tu compra '+(o.proveedor||'')+' fue rechazada'+(motivo?': '+motivo:''),'','ti-x'); }catch(e){}
    showT('Orden rechazada');
    var c=document.getElementById('firma-canvas'); if(c){ var mm=c.closest('div[style*=fixed]'); if(mm) mm.remove(); }
    _firmaCargarLista('gerencia'); _firmaActualizarBadge();
  }catch(e){ showT('Error: '+(e.message||e)); }
}

// ═══════════════════════════════════════════════════════════════════════════
//  AVISO DE ÓRDENES FIRMADAS
//  Al comprador le queda un círculo ROJO sobre "Nueva compra para firma" con
//  cuántas órdenes suyas firmó gerencia y él todavía no ha abierto. Se apaga
//  cuando abre la orden firmada (ahí se marca como recibida).
//  A gerencia le sigue saliendo el conteo naranja de lo que le falta firmar.
// ═══════════════════════════════════════════════════════════════════════════
var _firmaBadgeTimer=null;
window._firmaFirmadasVistas=null;

async function _firmaActualizarBadge(){
  try{
    if(!(CU&&(CU.role==='gerencia'||CU.role==='compras'))) return;
    var esGer=(CU.role==='gerencia');
    var filtro=esGer
      ? (_deptFiltroURL()+'&estado=eq.pendiente')
      : (((CU&& _deptAcotado())?_deptFiltroURL():_filtroEquipo('creado_por'))+'&estado=eq.firmada&recibido_en=is.null');
    var r=await fetch(SB+'/rest/v1/ordenes_firma?select=id,proveedor,num_orden'+filtro+'&limit=300',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    _firmaPendCount=rows.length;

    // Aviso al comprador cuando aparecen órdenes firmadas nuevas
    if(!esGer){
      var ids=rows.map(function(x){return String(x.id);});
      if(window._firmaFirmadasVistas===null){
        window._firmaFirmadasVistas=ids;   // primera carga: solo pintar
      } else {
        var nuevas=rows.filter(function(x){ return window._firmaFirmadasVistas.indexOf(String(x.id))<0; });
        nuevas.forEach(function(x){
          var ref=(x.num_orden?x.num_orden+' ':'')+(x.proveedor||'');
          try{ addNotif(CU.id, '✍️ Tu compra '+ref+' fue FIRMADA por gerencia', '', 'ti-writing-sign'); }catch(e){}
        });
        if(nuevas.length){
          showT('✍️ '+(nuevas.length===1?'Tu compra fue firmada por gerencia':nuevas.length+' compras tuyas fueron firmadas'));
          try{ renderNP(); }catch(e){}
        }
        window._firmaFirmadasVistas=ids;
      }
    }

    _firmaPintarBadge(esGer);
  }catch(e){}
}

function _firmaPintarBadge(esGer){
  document.querySelectorAll('.nb').forEach(function(b){
    if((b.getAttribute('onclick')||'').indexOf("'nueva'")>=0){
      var ex=b.querySelector('.firma-badge'); if(ex) ex.remove();
      if(_firmaPendCount>0){
        var sp=document.createElement('span');
        sp.className='firma-badge '+(esGer?'':'nb-num');
        sp.textContent=(_firmaPendCount>99?'99+':_firmaPendCount);
        sp.title=esGer?(_firmaPendCount+' compra(s) por firmar')
                      :(_firmaPendCount+' orden(es) firmada(s) sin abrir');
        if(esGer){
          sp.style.cssText='background:#B45309;color:#fff;border-radius:10px;font-size:9px;padding:1px 6px;margin-left:5px;font-weight:700';
        }
        b.appendChild(sp);
      }
    }
  });
}

function _firmaBadgeIniciar(){
  window._firmaFirmadasVistas=null;
  _firmaActualizarBadge();
  if(_firmaBadgeTimer) clearInterval(_firmaBadgeTimer);
  _firmaBadgeTimer=setInterval(_firmaActualizarBadge, 45000);
}

function chkSAP(){const desc=document.getElementById('f-desc')?.value.trim();const box=document.getElementById('sap-alert');if(!box||!desc)return;const s=SAP_STOCK[desc];if(!s){box.style.display='none';return;}let h='',color='',bg='';if(s.status==='high'){color='#27500A';bg='#EAF3DE';h=`<strong>SAP: Stock alto — ${s.stock} und.</strong>`;}else if(s.status==='low'){color='#92400e';bg='#fef3c7';h=`<strong>SAP: Stock bajo — ${s.stock} und.</strong>`;}else{color='#993C1D';bg='#FAECE7';h=`<strong>SAP: Agotado.</strong>`;}box.innerHTML=`<div style="background:${bg};border-radius:var(--radius);padding:10px 12px;font-size:12px;color:${color}">${h}</div>`;box.style.display='block';}
function uploadF(id,msg){const z=document.getElementById(id);if(z){z.classList.add('uok');z.innerHTML=`<i class="ti ti-circle-check" style="font-size:18px;display:block;margin-bottom:3px"></i><div>${msg}</div>`;}}
function crearOrden(){const prov=document.getElementById('f-prov').value.trim();const dept=document.getElementById('f-dept').value||_deptPrimero();const valor=parseFloat(document.getElementById('f-valor').value)||0;const resp=document.getElementById('f-resp').value.trim();const desc=document.getElementById('f-desc').value.trim();if(!prov||!dept||!valor||!resp||!desc){showT('Completa los campos obligatorios (*)');return;}const id=`OC-2024-0${NID++}`;const uni=parseInt(document.getElementById('f-uni').value)||0;const fechaE=document.getElementById('f-fecha').value;let fechaEst='';if(fechaE){const dd=new Date(fechaE);fechaEst=dd.toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'});}orders.unshift({id,dept,prov,valor,abono:0,desc,alerta:false,resp,fechaCreacion:dateOnly(),fechaEst,uni,emoji:EMOJIS2[dept]||'📦',pend:true,completada:false});initP(id);stageProgress[id].pedido.startDate=dateOnly();addNotif('gerencia',`Nueva orden ${prov} — ${id} · ${dL(dept)}`,id,'ti-writing');showT(`Orden ${id} enviada`);go('ordenes');renderNP();}
// ═══════════════════════════════════════════════════════════════════════════
//  ÓRDENES NO SAP CON EL FLUJO COMPLETO
//  Una orden NO SAP se trabaja igual que una de SAP: mismas etapas, comentarios,
//  adjuntos, solicitudes de abono, artes, etc. Cuando entra a SAP lo único que
//  cambia es dónde aparece; el avance de las etapas se conserva porque se
//  migra de la clave del DKC a la del número de orden de SAP.
// ═══════════════════════════════════════════════════════════════════════════

// La orden NO SAP nace ya firmada por gerencia: la etapa "Pedido" queda
// completa con sus dos pasos y el proceso arranca en Depósito & Pago.
// Sin abono: los tres primeros pasos del depósito quedan hechos (solicitud,
// envío y comprobante) y la etapa se queda esperando en "Solicitud de final
// del balance", que es donde se paga el 100%.
async function _nsapMarcarSinAbono(ref){
  var stage=STAGES.find(function(s){ return s.key==='deposito'; });
  if(!stage) return;
  initP(ref);
  var sp=stageProgress[ref].deposito;
  var hoyIso=new Date().toISOString().slice(0,10);
  var hoyTxt=(typeof isoADisplay==='function')?isoADisplay(hoyIso):hoyIso;
  var HASTA=3;                       // 0,1,2 hechos; el 3 es el balance final
  sp.stepIdx=Math.max(sp.stepIdx||0, HASTA);
  if(!sp.stepDates) sp.stepDates=stage.steps.map(function(){ return ''; });
  if(!sp._isoPasos) sp._isoPasos=stage.steps.map(function(){ return ''; });
  for(var i=0;i<HASTA;i++){
    if(!sp.stepDates[i]) sp.stepDates[i]=hoyTxt;
    if(!sp._isoPasos[i]) sp._isoPasos[i]=hoyIso;
  }
  if(!sp.startDate){ sp.startDate=hoyTxt; sp._isoInicio=hoyIso; }
  try{ await guardarEtapa(ref,'deposito'); }catch(e){ console.warn('sin abono:',e); }
}

async function _nsapMarcarPedidoHecho(ref){
  var stage=STAGES.find(function(s){ return s.key==='pedido'; });
  if(!stage) return;
  initP(ref);
  var sp=stageProgress[ref].pedido;
  var hoyIso=new Date().toISOString().slice(0,10);
  var hoyTxt=(typeof isoADisplay==='function')?isoADisplay(hoyIso):hoyIso;
  sp.stepIdx=stage.steps.length;
  sp.startDate=hoyTxt;
  sp.stepDates=stage.steps.map(function(){ return hoyTxt; });
  sp._isoInicio=hoyIso;
  sp._isoPasos=stage.steps.map(function(){ return hoyIso; });
  try{ await guardarEtapa(ref,'pedido'); }catch(e){ console.warn('marcar pedido:',e); }
  // La siguiente etapa arranca hoy, para que se vea como pendiente de abono
  var dep=stageProgress[ref].deposito;
  if(dep && !dep._isoInicio){
    dep.startDate=hoyTxt; dep._isoInicio=hoyIso;
    try{ await guardarEtapa(ref,'deposito'); }catch(e){}
  }
}

// Convierte un registro de compras_pend_sap al formato que usa el detalle
function _ordenDesdePendSAP(p){
  if(!p) return null;
  var id=String(p.dkc||p.num_orden||'').trim();
  var total=Number(p.total)||0, abon=Number(p.abonado)||0;
  var items=p.items;
  if(typeof items==='string'){ try{ items=JSON.parse(items); }catch(e){ items=[]; } }
  items=Array.isArray(items)?items:[];
  var uni=items.reduce(function(a,it){ return a+(Number(it.cantidad)||0); },0);
  var desc=items.length
    ? (String(items[0].itemname||'').slice(0,60)+(items.length>1?(' +'+(items.length-1)+' más'):''))
    : ('Orden '+id);
  return {
    id:id,
    dept:p.dept||'otros',
    prov:p.proveedor||'-',
    valor:total,
    abono:abon,
    desc:desc,
    alerta:false,
    resp:p.cardcode||'',
    fechaCreacion:p.fecha||p.creado_en||'',
    fechaEst:p.eta||'',
    uni:uni,
    emoji:deptEmoji(p.dept||'otros'),
    pend:false,
    completada:false,
    _estadoSap:'',
    _docstatus:'',
    vendorEmail:'',
    fechaAbono:p.fecha_abono||'',
    num_proveedor:p.dkc||p.num_orden||'',
    _noSap:true,          // marca para el resto del portal
    _pend:p               // registro original, por si hace falta
  };
}

// Busca una orden por id, primero en SAP y después en las NO SAP
function _ordenPorId(id){
  var o=(typeof orders!=='undefined'&&orders)?orders.find(function(x){return String(x.id)===String(id);}):null;
  if(o) return o;
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===String(id) || String(x.num_orden)===String(id);
  });
  return p?_ordenDesdePendSAP(p):null;
}

// Abre el detalle completo (con todas las etapas) de una orden NO SAP
function abrirDetalleNoSap(ref){
  var o=_ordenPorId(ref);
  if(!o){ showT('Orden no encontrada'); return; }
  // El detalle trabaja sobre `orders`: se agrega temporalmente si no está
  if(!orders.some(function(x){ return String(x.id)===String(o.id); })) orders.push(o);
  openDetail(o.id);
}

// ── Continuidad al pasar a SAP ──
// El avance vive en stageProgress[id]. Mientras la orden es NO SAP la clave es
// el DKC; en SAP pasa a ser el docnum. Esta función mueve el avance de una a
// otra para que no se pierda nada de lo ya trabajado.
async function _migrarEtapasNoSap(silencioso){
  if(typeof orders==='undefined' || !orders.length) return 0;
  var movidas=0;
  for(var i=0;i<orders.length;i++){
    var o=orders[i];
    if(o._noSap) continue;
    var dkc=String(o.num_proveedor||'').trim();
    if(!dkc) continue;
    var viejo=stageProgress[dkc];
    if(!viejo){
      // La referencia de SAP puede llevar prefijo ("DKC-26088") y el avance
      // haberse guardado con la clave de la orden NO SAP ("26088").
      var pend=(window._pendSAP||[]).find(function(p){
        var s=_ordenSapDeNoSap(p);
        return s && String(s.id)===String(o.id);
      });
      if(pend){
        var otra=String(pend.num_orden||pend.dkc||'').trim();
        if(otra && stageProgress[otra]){ dkc=otra; viejo=stageProgress[otra]; }
      }
    }
    if(!viejo) continue;
    if(String(dkc)===String(o.id)) continue;
    initP(o.id);
    var nuevo=stageProgress[o.id];
    var hubo=false;
    STAGES.forEach(function(st){
      var v=viejo[st.key]||{}, n=nuevo[st.key]||{};
      // Se conserva lo más avanzado de las dos claves
      if((Number(v.stepIdx)||0) > (Number(n.stepIdx)||0)){
        n.stepIdx=v.stepIdx; hubo=true;
        if(v.stepDates) n.stepDates=v.stepDates;
        if(v.startDate && !n.startDate) n.startDate=v.startDate;
      }
      if((v.comments||[]).length > (n.comments||[]).length){ n.comments=v.comments; hubo=true; }
      nuevo[st.key]=n;
    });
    if(hubo){
      movidas++;
      // Se reescriben las etapas con la clave nueva para que quede en la base
      for(var s=0;s<STAGES.length;s++){
        var k=STAGES[s].key;
        if((Number(nuevo[k].stepIdx)||0)>0){
          try{ await guardarEtapa(o.id, k); }catch(e){}
        }
      }
      // ── Los adjuntos ──────────────────────────────────────────────────
      // Se movían SOLO en memoria y solo la llave '__pendsap': al recargar,
      // la orden de SAP aparecía sin ningún documento porque en la base
      // seguían guardados con el número de la orden NO SAP.
      try{
        if(window._atts){
          // Todas las llaves de esa orden (cada etapa y cada subpaso tiene
          // la suya), conservando el sufijo
          Object.keys(window._atts).forEach(function(k){
            if(k.indexOf(dkc)!==0) return;
            var suf=k.slice(dkc.length);
            var nueva=o.id+suf;
            if(!window._atts[k] || !window._atts[k].length) return;
            window._atts[nueva]=_dedupDocs((window._atts[nueva]||[]).concat(window._atts[k]));
          });
        }
      }catch(e){ console.warn('[etapas] adjuntos en memoria:', e); }

      // Y en la base, que es lo que sobrevive a recargar la página
      try{
        var rd=await fetch(SB+'/rest/v1/compras_documentos?docnum=eq.'+encodeURIComponent(dkc),{
          method:'PATCH',
          headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify({docnum:String(o.id)})
        });
        if(!rd.ok) console.warn('[etapas] no se pudieron mover los documentos de '+dkc+':', rd.status);
      }catch(e){ console.warn('[etapas] documentos:', e); }
      console.info('[etapas] avance migrado de '+dkc+' a la orden SAP '+o.id);
    }
  }
  if(movidas && !silencioso) showT('Se conservó el avance de '+movidas+' orden(es) que entraron a SAP');
  return movidas;
}

// Alterna el detalle de la orden entre modal normal y pantalla completa
function _ordenPantallaCompleta(){
  window._ordenFull=!window._ordenFull;
  document.body.classList.toggle('orden-full', !!window._ordenFull);
  try{ localStorage.setItem('ordenFull', window._ordenFull?'1':'0'); }catch(e){}
  var b=document.getElementById('ordenFullBtn');
  if(b){
    b.innerHTML='<i class="ti ti-'+(window._ordenFull?'arrows-minimize':'arrows-maximize')+'"></i>';
    b.title=window._ordenFull?'Volver al tamaño normal':'Pantalla completa';
  }
}

// Se recuerda la preferencia entre sesiones
try{
  if(localStorage.getItem('ordenFull')==='1'){
    window._ordenFull=true;
    document.addEventListener('DOMContentLoaded', function(){
      document.body.classList.add('orden-full');
    });
  }
}catch(e){}

function openDetail(id){
  // El icono del botón refleja el estado guardado
  setTimeout(function(){
    var b=document.getElementById('ordenFullBtn');
    if(b) b.innerHTML='<i class="ti ti-'+(window._ordenFull?'arrows-minimize':'arrows-maximize')+'"></i>';
  }, 0);
  // Si el usuario está mirando el costeo, no se reconstruye la pantalla:
  // reconstruirla cerraba esa ventana en medio de la descarga.
  if(document.getElementById('modalCostPrev')){
    console.log('[detalle] hay un costeo abierto: no se repinta');
    return;
  }
  const o=_ordenPorId(id);if(!o)return;initP(id);if(!firmas[id])firmas[id]={};const fd=firmas[id],sap=sapChip(o.desc),pPct=getPct(o),signed=fd['gerencia']?.signed;const sc=CU.verCostos&&CU.role!=='diseno'&&CU.role!=='bodega';let firmaHtml='';if(o.pend){firmaHtml=`<div class="firma-box"><div style="font-size:13px;font-weight:500;margin-bottom:10px;display:flex;align-items:center;gap:6px"><span class="sem sem-y"></span>Revisión y firma</div><div class="po-card"><div style="font-size:26px;color:#e24b4a"><i class="ti ti-file-text"></i></div><div style="flex:1"><div style="font-size:13px;font-weight:500">PO-${id}.pdf</div><div style="font-size:11px;color:var(--text-muted);margin-top:2px">${o.prov} · ${o.desc}</div>${sc?`<div style="font-size:11px;color:var(--text-muted);margin-top:2px">${fmt(o.valor)} total</div>`:''}</div><span class="po-btn"><i class="ti ti-eye" style="font-size:11px"></i> Ver</span></div>${CU.role==='gerencia'&&!signed?`<div class="lbl2"><i class="ti ti-pencil"></i>Firma digital</div><canvas id="fc" width="570" height="90"></canvas><div class="br"><button class="btn bg2" onclick="CC()"><i class="ti ti-eraser"></i>Limpiar</button><button class="btn bd" onclick="rejOrden('${id}')"><i class="ti ti-x"></i>Rechazar</button><button class="btn bs" onclick="signOrden('${id}')"><i class="ti ti-check"></i>Aprobar y firmar</button></div>`:CU.role==='gerencia'&&signed?`<div class="aps" style="margin-top:8px;display:inline-flex"><i class="ti ti-circle-check"></i>Firmada por ${fd['gerencia'].by}</div>`:`<div style="font-size:12px;color:var(--text-muted);padding:8px;background:var(--surface-2);border-radius:var(--radius);margin-top:8px">Pendiente firma de gerencia.</div>`}</div>`;}else{firmaHtml=`<div style="padding:8px 12px;background:var(--bg-success);border-radius:var(--radius);margin-bottom:12px;font-size:12px;color:var(--text-success);font-weight:500;display:flex;align-items:center;gap:6px"><span class="sem sem-g"></span>${o.completada?'Proceso completado':'Orden aprobada — activa'}${fd['gerencia']?.signed?' · Firmada por '+fd['gerencia'].by:''}</div>`;}const visibleSts=stagesForUser();const sp=stageProgress[id];const si=getStageIdx(o);const stagesHtml=visibleSts.map(stage=>{const idx=STAGES.indexOf(stage);const stepsDone=sp[stage.key].stepIdx,stepsTotal=stage.steps.length,isDone=stepsDone>=stepsTotal;const isCurr=!o.completada&&!o.pend&&idx===si;const semClass=isDone?'sem-g':isCurr?'sem-y':'sem-r';const groupClass=isDone?'done':isCurr?'active':'';const startDate=sp[stage.key].startDate||'';const endDate=isDone?(sp[stage.key].stepDates?.[stepsTotal-1]||''):'';const daysIn=startDate?daysBetween(startDate,endDate||null):0;const nc=sp[stage.key].comments?.length||0;return`<div class="eg ${groupClass}" id="eg-${id}-${idx}"><div class="eg-hdr" onclick="toggleEG('${id}',${idx})"><span class="sem ${semClass}"></span><i class="ti ${stage.icon}" style="font-size:13px;color:${stage.color}"></i><div style="flex:1"><div style="font-size:12px;font-weight:500">${stage.label}</div><div style="font-size:10px;color:var(--text-muted);display:flex;gap:5px;flex-wrap:wrap;margin-top:1px">${startDate?`<span style="background:var(--bg-accent);color:var(--text-accent);padding:1px 6px;border-radius:6px;font-size:9px">Inicio: ${startDate}</span>`:''}${endDate&&isDone?`<span style="background:var(--bg-success);color:var(--text-success);padding:1px 6px;border-radius:6px;font-size:9px">Fin: ${endDate} · ${daysIn}d</span>`:!isDone&&isCurr&&startDate?`<span style="background:var(--bg-danger);color:var(--text-danger);padding:1px 6px;border-radius:6px;font-size:9px">${daysIn}d en progreso</span>`:''}<span>${stage.resp}</span>${nc>0?`<span style="color:var(--text-accent)">${nc} com.</span>`:''}<span id="egnl-${id}-${idx}">${_comBadgeNoLeido(id,stage.key)}</span></div></div><div style="display:flex;align-items:center;gap:5px"><button class="btn" title="Enviar correo sobre esta etapa" onclick="event.stopPropagation();mailAbrir('${id}','${stage.key}',null)" style="padding:3px 7px;font-size:10px;background:transparent;border:0.5px solid var(--border)"><i class="ti ti-mail" style="font-size:12px;color:var(--text-accent)"></i></button><span style="font-size:10px;color:var(--text-muted)">${stepsDone}/${stepsTotal}</span>${isDone?'<span style="font-size:10px;background:var(--bg-success);color:var(--text-success);padding:1px 6px;border-radius:8px;font-weight:500">✓</span>':''}<i class="ti ti-chevron-down eg-chev" id="egch-${id}-${idx}"></i></div></div><div class="eg-body" id="egb-${id}-${idx}"></div></div>`;}).join('');// Otras ordenes del proveedor
  const otrasAct=orders.filter(x=>x.prov===o.prov&&x.id!==o.id&&!x.completada);
  const otrasComp=orders.filter(x=>x.prov===o.prov&&x.id!==o.id&&x.completada);
  const otrasHtml=(otrasAct.length||otrasComp.length)?`<div style="margin-top:7px;padding:7px 10px;background:var(--bg-accent);border:0.5px solid var(--border-accent);border-radius:var(--radius)"><div style="font-size:10px;font-weight:600;color:var(--text-accent);margin-bottom:5px;display:flex;align-items:center;gap:5px"><i class="ti ti-packages" style="font-size:10px"></i> Otras órdenes de este proveedor <span style="background:var(--fill-accent);color:white;border-radius:8px;padding:0 7px;font-size:9px;font-weight:700">${otrasAct.length+otrasComp.length+1} en total</span></div><div style="display:flex;gap:5px;flex-wrap:wrap">${otrasAct.map(x=>`<span onclick="CM();setTimeout(()=>openDetail('`+x.id+`'),80)" style="font-size:10px;padding:2px 9px;background:var(--fill-accent);color:white;border-radius:8px;cursor:pointer">#`+x.id+` `+dL(x.dept)+`</span>`).join('')}${otrasComp.map(x=>`<span onclick="CM();setTimeout(()=>openDetail('`+x.id+`'),80)" style="font-size:10px;padding:2px 9px;background:#534AB7;color:white;border-radius:8px;cursor:pointer">✓ #`+x.id+`</span>`).join('')}</div></div>`:'';
  document.getElementById('mc').innerHTML=`<div class="mt"><div style="font-size:30px">${o.emoji}</div><div style="flex:1"><div style="font-size:14px;font-weight:500">${o.prov} — <span onclick="openPoLines('${o.id}')" title="Ver líneas detalle" style="cursor:pointer;color:var(--text-accent);text-decoration:underline;text-underline-offset:2px">${o.id}</span></div>
${o.vendorEmail?`<div style="font-size:11px;margin-top:3px;display:flex;align-items:center;gap:6px;flex-wrap:wrap">
  <i class="ti ti-mail" style="font-size:11px;color:var(--text-muted)"></i>
  <a href="mailto:${o.vendorEmail}?subject=OC ${o.id} - ${o.prov}&body=Estimados ${o.prov},%0D%0A%0D%0AHacemos referencia a la orden de compra ${o.id}.%0D%0A%0D%0ASaludos,%0D%0A${CU?CU.name:''}" style="color:var(--text-accent);font-size:11px;text-decoration:underline;cursor:pointer">${o.vendorEmail}</a>
</div>`:''}<div style="font-size:11px;color:var(--text-muted);margin-top:2px">${dL(o.dept)} · ${o.desc} · ${o.uni?.toLocaleString()||0} und · ${o.resp}</div><div style="display:flex;gap:6px;margin-top:4px;flex-wrap:wrap"><span class="fecha-badge"><i class="ti ti-calendar" style="font-size:10px"></i>Creado: ${o.fechaCreacion}</span>${o.fechaEst?`<span class="fecha-badge"><i class="ti ti-calendar-due" style="font-size:10px"></i>ETA: ${o.fechaEst}</span>`:''}${o.completada?`<span class="fecha-badge ok"><i class="ti ti-circle-check" style="font-size:10px"></i>Completada</span>`:''}</div>${sap?`<div style="margin-top:5px">${sap}</div>`:''}${sc?`<div style="display:flex;gap:8px;margin-top:8px;flex-wrap:wrap">
  <div style="background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:7px 12px;min-width:110px">
    <div style="font-size:9px;color:var(--text-muted);font-weight:600;text-transform:uppercase;letter-spacing:.5px">Total Orden</div>
    <div style="font-size:15px;font-weight:700;color:var(--text-primary);margin-top:2px">${fmt(o.valor)}</div>
  </div>
  <div onclick="_verCompPago('${id}','abono')" title="${_hayCompPago(id,'abono')?'Ver el comprobante del abono':'Todavía no hay comprobante del abono'}"
       style="background:var(--bg-success);border:0.5px solid var(--border-success);border-radius:8px;padding:7px 12px;min-width:110px;cursor:pointer">
    <div style="font-size:9px;color:var(--text-success);font-weight:600;text-transform:uppercase;letter-spacing:.5px">Abonado · ${pct(o.abono,o.valor)}% ${_hayCompPago(id,'abono')?'<i class="ti ti-paperclip" style="font-size:10px"></i>':''}</div>
    <div style="font-size:15px;font-weight:700;color:var(--text-success);margin-top:2px">${fmt(o.abono)}</div>
  </div>
  <div onclick="_verCompPago('${id}','cancelacion')" title="${_hayCompPago(id,'cancelacion')?'Ver el comprobante del pago final':'Todavía no hay comprobante del pago final'}"
       style="background:var(--bg-danger);border:0.5px solid var(--border-danger);border-radius:8px;padding:7px 12px;min-width:110px;cursor:pointer">
    <div style="font-size:9px;color:var(--text-danger);font-weight:600;text-transform:uppercase;letter-spacing:.5px">Saldo · ${pct(o.valor-o.abono,o.valor)}% ${_hayCompPago(id,'cancelacion')?'<i class="ti ti-paperclip" style="font-size:10px"></i>':''}</div>
    <div style="font-size:15px;font-weight:700;color:var(--text-danger);margin-top:2px">${fmt(o.valor-o.abono)}</div>
  </div>
</div>`:''}${otrasHtml}</div><button id="ordenFullBtn" class="orden-full-btn" onclick="_ordenPantallaCompleta()" title="Pantalla completa"><i class="ti ti-arrows-maximize"></i></button><button class="cb" onclick="CM()">×</button></div><div class="mb">${_ocPendPanelOrden(o)}${_entResumenSeguro(o.id)}<div style="margin-bottom:12px"><div style="display:flex;justify-content:space-between;font-size:11px;color:var(--text-muted);margin-bottom:4px"><span>Progreso general</span><span>${pPct}%</span></div><div style="height:6px;background:var(--border);border-radius:3px;overflow:hidden"><div style="height:100%;border-radius:3px;background:${o.completada?'#534AB7':'#1D9E75'};width:${pPct}%"></div></div></div>${firmaHtml}<div style="font-size:11px;color:var(--text-muted);margin-bottom:8px"><i class="ti ti-info-circle" style="font-size:11px"></i> Clic en cualquier etapa — puedes revertir pasos con el botón ↩</div><div>${stagesHtml}</div>${!o.completada&&!o.pend&&getPct(o)>=85?`<div style="margin-top:12px"><button class="btn bs" onclick="markComplete('${id}')"><i class="ti ti-circle-check"></i>Marcar proceso completo</button></div>`:''}</div>`;document.getElementById('modal').style.display='flex';if(o.pend)initC();setTimeout(()=>toggleEG(id,si,true),80);
  // La cabecera cambia de alto según el proveedor y los recuadros: se mide de
  // verdad para que el cuerpo sepa cuánto espacio le queda y la última etapa
  // no se corte.
  setTimeout(function(){
    try{
      var md=document.querySelector('#modal .md');
      var hd=md&&md.querySelector('.mh, .mhd, .md > div');
      if(hd) document.documentElement.style.setProperty('--orden-hdr', (hd.offsetHeight+18)+'px');
    }catch(e){}
  }, 120);
  // Carga los documentos ya guardados de esta orden (todas sus etapas) y refresca
  cargarDocsOrden(id).then(function(){
    var abierta=document.querySelector('#modal .eg-body.open');
    if(abierta){ var m=abierta.id.match(/egb-(.+)-(\d+)$/); if(m) buildEGB(m[1], parseInt(m[2]), abierta); }
  });
}
// ═══════════════════════════════════════════════════════════════════════════
//  COMENTARIOS EN VIVO
//  Mientras una etapa está abierta se relee `compras_comentarios` cada pocos
//  segundos, así lo que escribe otra persona aparece solo, sin tener que salir
//  y volver a entrar a la orden.
// ═══════════════════════════════════════════════════════════════════════════
var _comPollTimer=null;

function _comIniciarPoll(){
  if(_comPollTimer) return;
  _comPollTimer=setInterval(_comPollTick, 6000);
}
function _comDetenerPoll(){
  if(_comPollTimer){ clearInterval(_comPollTimer); _comPollTimer=null; }
}
function _comPollTick(){
  var abiertos=document.querySelectorAll('.eg-body.open');
  if(!abiertos.length){ _comDetenerPoll(); return; }
  Array.prototype.forEach.call(abiertos, function(el){
    var m=String(el.id||'').match(/^egb-(.+)-(\d+)$/);
    if(!m) return;
    var st=STAGES[Number(m[2])];
    if(st) _comRefrescar(m[1], st.key);
  });
}

// Relee los comentarios de una etapa y repinta solo si algo cambió
async function _comRefrescar(oid, stageKey, forzar){
  try{
    var url=SB+'/rest/v1/compras_comentarios?select=autor,autor_rol,texto,creado_en'
      +'&docnum=eq.'+encodeURIComponent(oid)
      +'&etapa=eq.'+encodeURIComponent(stageKey)
      +'&order=creado_en.asc&limit=300';
    var r=await fetch(url,{headers:SBH});
    if(!r.ok) return;
    var rows=await r.json();
    if(!Array.isArray(rows)) return;

    initP(oid);
    var lista=rows.map(function(c){
      return {
        autor:(c.autor||'')+(c.autor_rol?(' ('+c.autor_rol+')'):''),
        ini:String(c.autor||'--').slice(0,2).toUpperCase(),
        texto:c.texto,
        time:(typeof isoADisplay==='function'?isoADisplay(c.creado_en):(c.creado_en||''))
      };
    });

    var actual=stageProgress[oid][stageKey].comments||[];
    var firma=function(a){ return a.map(function(x){return (x.autor||'')+'|'+(x.texto||'');}).join('\u0001'); };
    if(!forzar && firma(lista)===firma(actual)) return;
    // Si el servidor trae menos que lo que ya se ve, es que el comentario recién
    // escrito todavía no llegó: no se pisa lo local para que no parpadee.
    if(!forzar && lista.length<actual.length) return;

    var hayNuevos=lista.length>actual.length;
    stageProgress[oid][stageKey].comments=lista;
    _comRepintar(oid, stageKey);

    if(hayNuevos){
      // Estoy viendo la etapa, así que lo que llegó ya cuenta como leído
      if(_comNoLeidoEtapa(oid, stageKey)){
        marcarComLeido(oid, stageKey);
        _comPintarBadgesEtapas(oid);
        renderNP();
      }
      var box=document.getElementById('cms-'+oid+'-'+stageKey);
      if(box) box.scrollTop=box.scrollHeight;
      // Aviso discreto si el último no es mío
      var ult=lista[lista.length-1];
      var mio=(CU&&CU.name)||'\u0000';
      if(ult && String(ult.autor||'').indexOf(mio)!==0) showT('💬 '+ult.autor+' comentó');
    }
  }catch(e){}
}

function toggleEG(oid,idx,forceOpen=false){const body=document.getElementById(`egb-${oid}-${idx}`);const chev=document.getElementById(`egch-${oid}-${idx}`);if(!body)return;if(!forceOpen&&body.classList.contains('open')){body.classList.remove('open');chev&&chev.classList.remove('open');return;}body.classList.add('open');chev&&chev.classList.add('open');buildEGB(oid,idx,body);const _st=STAGES[idx];if(_st){_comRefrescar(oid,_st.key);_comIniciarPoll();}if(_st&&_comNoLeidoEtapa(oid,_st.key)){marcarComLeido(oid,_st.key);setTimeout(function(){_comRepintar(oid,_st.key);if(typeof rAlertas==='function'&&PG==='alertas')rAlertas();renderNP();_comPintarBadgesEtapas(oid);},150);}}

// ─── FIX 4: Panel lateral líneas de OC ───
var _poCache={};
// Para las órdenes NO SAP: trae foto y descripción del inventario. Los SKU que
// todavía no existen en SAP se completan desde el catálogo NO SAP, que es
// donde vive su descripción mientras SAP no los da de alta.
async function _poCompletarDesdeInventario(lineas){
  var codes=(lineas||[]).map(function(l){return String(l.itemcode||'').trim();}).filter(Boolean);
  if(!codes.length) return;
  var mp={};
  try{
    var inList=Array.from(new Set(codes)).map(function(c){return '"'+c.replace(/"/g,'')+'"';}).join(',');
    var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,picturname,onhand,iscommited&itemcode=in.('+encodeURIComponent(inList)+')&limit=500',{headers:SBH});
    if(r.ok) (await r.json()||[]).forEach(function(x){ mp[String(x.itemcode).toUpperCase()]=x; });
  }catch(e){ console.warn('completar lineas NO SAP:',e); }
  // Los que no están en SAP: su descripción vive en el catálogo NO SAP
  var faltan=(lineas||[]).filter(function(l){ return !mp[String(l.itemcode||'').toUpperCase()]; });
  var cat={};
  if(faltan.length){
    // Primero lo que ya está en memoria. Se incluyen las fichas degradadas
    // (tipo 'foto'): ya no son artículos del catálogo, pero guardan la única
    // imagen que existe de un SKU que en SAP todavía no tiene la suya.
    (window._catNoSap||[]).forEach(function(c){
      if(c.itemcode && c.tipo!=='proveedor') cat[String(c.itemcode).toUpperCase()]=c;
    });
    // Y si falta alguno, se consulta la tabla
    var sinDato=faltan.filter(function(l){ return !cat[String(l.itemcode||'').toUpperCase()]; });
    if(sinDato.length){
      try{
        var lst=Array.from(new Set(sinDato.map(function(l){return String(l.itemcode||'').trim();}).filter(Boolean)))
                 .map(function(c){ return '"'+c.replace(/"/g,'')+'"'; }).join(',');
        if(lst){
          var rc=await fetch(SB+'/rest/v1/catalogo_nosap?select=itemcode,itemname,foto,colores,tipo&tipo=in.(item,foto)&itemcode=in.('
            +encodeURIComponent(lst)+')&limit=500',{headers:SBH});
          if(rc.ok) (await rc.json()||[]).forEach(function(c){ cat[String(c.itemcode).toUpperCase()]=c; });
        }
      }catch(e){ console.warn('catalogo NO SAP para lineas:',e); }
    }
  }

  lineas.forEach(function(l){
    var cod=String(l.itemcode||'').toUpperCase();
    var inv=mp[cod];
    if(inv){
      l.picturname=inv.picturname||'';
      if(!l.dscription) l.dscription=inv.itemname||'';
      l._enSap=true;
      // Está en SAP pero sin foto propia: se usa la del proveedor, que para
      // eso se conservó. Antes se salía aquí y la línea quedaba con el
      // cuadrito gris aunque la imagen existiera del otro lado.
      if(!l.picturname){
        var cs=cat[cod];
        var _u=cs && (cs.foto || cs.foto_url || cs.imagen_url);
        if(_u) l._fotoUrl=_fotoNoSapUrl(_u);
      }
      return;
    }
    l._enSap=false;   // SKU nuevo, todavía no está en SAP
    var c=cat[cod];
    if(c){
      if(!l.dscription) l.dscription=c.itemname||'';
      var _uc=c.foto || c.foto_url || c.imagen_url;
      if(_uc) l._fotoUrl=_fotoNoSapUrl(_uc);
      if(c.colores) l.colores=c.colores;
    }
    // Si aun así no hay descripción, al menos no queda la celda vacía
    if(!l.dscription) l.dscription='(sin descripción)';
  });
}
async function openPoLines(docnum){
  var _verPrecio=CU&&CU.verCostos&&CU.role!=='diseno'&&CU.role!=='bodega';
  var ex=document.getElementById('po-panel');
  if(ex){ex.remove();return;}
  var panel=document.createElement('div');
  panel.id='po-panel';
  panel.style.cssText='position:fixed;top:0;right:0;width:min(420px,96vw);height:100vh;background:var(--surface-2);border-left:1px solid var(--border);z-index:250;overflow-y:auto;box-shadow:-6px 0 24px rgba(0,0,0,.18)';
  var hdr=document.createElement('div');
  hdr.style.cssText='position:sticky;top:0;z-index:2;padding:13px 15px;border-bottom:0.5px solid var(--border);background:var(--surface-1);display:flex;align-items:center;gap:8px';
  hdr.innerHTML='<i class="ti ti-file-invoice" style="color:var(--text-accent);font-size:15px"></i>'
    +'<span style="font-size:13px;font-weight:600">OC #'+docnum+'</span>'
    +_catBtnOrdenSAP(docnum)
    +_smBtn(docnum);
  var closeBtn=document.createElement('button');
  closeBtn.innerHTML='&times;';
  closeBtn.style.cssText='margin-left:auto;background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1';
  closeBtn.onclick=function(){panel.remove();};
  hdr.appendChild(closeBtn);
  panel.appendChild(hdr);
  // Los shipping marks enviados quedan guardados con el número de ESTA orden.
  // Se muestran aquí, que es donde está el botón que los mandó.
  var smBox=document.createElement('div');
  smBox.id='po-sm';
  smBox.style.cssText='padding:0 14px';
  panel.appendChild(smBox);
  (async function(){
    try{
      await cargarDocsOrden(String(docnum));
      if(!document.body.contains(panel)) return;
      smBox.innerHTML=_smGuardadosHTML(docnum);
    }catch(e){ console.warn('[orden] shipping marks:', e); }
  })();

  var body=document.createElement('div');
  body.id='po-body';
  body.style.cssText='padding:14px';
  body.innerHTML='<div style="text-align:center;padding:30px;color:var(--text-muted)"><i class="ti ti-loader-2 spin" style="font-size:24px"></i><br><br>Cargando líneas SAP...</div>';
  panel.appendChild(body);
  document.body.appendChild(panel);
  try{
    if(!_poCache[docnum]){
      // Las órdenes NO SAP no viven en opor_lineas: sus artículos están en el
      // registro de compras_pend_sap que se creó al darlas de alta.
      var pNoSap=(window._pendSAP||[]).find(function(x){
        return String(x.dkc)===String(docnum) || String(x.num_orden)===String(docnum);
      });
      if(pNoSap){
        var its=pNoSap.items;
        if(typeof its==='string'){ try{ its=JSON.parse(its); }catch(e){ its=[]; } }
        its=Array.isArray(its)?its:[];
        _poCache[docnum]=its.map(function(it,i){
          var cant=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
          return {
            linenum:i, itemcode:it.itemcode||'', dscription:it.itemname||'',
            cantidad:cant, quantity:cant, precio_unit:pu, price:pu,
            total_linea:Number(it.total_linea)||(cant*pu),
            _noSap:true
          };
        });
        // Se completa con las fotos y descripciones que haya en el inventario
        try{ await _poCompletarDesdeInventario(_poCache[docnum]); }catch(e){}
      } else {
        var r=await fetch(SB+'/rest/v1/opor_lineas?select=*&docnum=eq.'+docnum+'&order=linenum.asc',{headers:SBH});
        _poCache[docnum]=r.ok?(await r.json()):[];
        if(!Array.isArray(_poCache[docnum]))_poCache[docnum]=[];
      }
    }
    var lines=_poCache[docnum];
    if(!lines.length){
      var esNoSap=(window._pendSAP||[]).some(function(x){ return String(x.dkc)===String(docnum)||String(x.num_orden)===String(docnum); });
      body.innerHTML='<div class="empty" style="padding:24px"><i class="ti ti-inbox" style="font-size:28px"></i><br>'
        +(esNoSap
          ?'Esta orden NO SAP se guardó sin productos.<br><span style="font-size:11px">Puedes agregárselos con <b>Editar orden</b>.</span>'
          :'Sin líneas para esta orden')
        +'</div>';
      return;
    }
    var total=lines.reduce(function(s,l){return s+(parseFloat(l.total_linea)||parseFloat(l.precio_linea)||0);},0);
    // Si la orden salió de una reposición, arriba de los artículos va el
    // registro de en qué se apartó de lo que se había pedido.
    // Las diferencias con la reposición NO van aquí: se abren desde la etiqueta
    // de la orden en el listado, que es donde se buscan.
    body.innerHTML='<div style="font-size:11px;color:var(--text-muted);margin-bottom:10px">'+lines.length+' artículos'+(_verPrecio?' &middot; Total: <strong style="color:var(--text-primary)">'+fmt(total)+'</strong>':'')+'</div>';
    lines.forEach(function(l,i){
      var card=document.createElement('div');
      card.style.cssText='background:var(--surface-1);border:0.5px solid var(--border);border-radius:9px;margin-bottom:9px;overflow:hidden';
      var variantes=fotoVariantes(l);
      var pu=parseFloat(l.precio)||parseFloat(l.precio_unitario)||parseFloat(l.precio_unit)||0;
      var qty=parseFloat(l.cantidad)||0;
      var tot=parseFloat(l.total_linea)||parseFloat(l.precio_linea)||(pu*qty);
      var row=document.createElement('div');
      row.style.cssText='display:flex;gap:10px;padding:10px 11px;align-items:flex-start';
      // imagen
      var imgEl;
      if(variantes.length){
        imgEl=document.createElement('img');
        var _vi=0;
        imgEl.src=variantes[0];
        imgEl.style.cssText='width:62px;height:62px;object-fit:cover;border-radius:6px;cursor:zoom-in;flex-shrink:0;border:0.5px solid var(--border)';
        imgEl.title='Click para zoom';
        imgEl.onclick=function(){ if(imgEl.src) zoomImg(imgEl.src); };
        // Prueba cada variante (nombre tal cual, minúscula, mayúscula, foto_url).
        // Si todas fallan, muestra 📦.
        imgEl.onerror=function(){
          _vi++;
          if(_vi < variantes.length){ imgEl.src=variantes[_vi]; return; }
          var ph=document.createElement('div');
          ph.style.cssText='width:62px;height:62px;background:var(--surface-0);border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:28px;flex-shrink:0;border:0.5px solid var(--border)';
          ph.textContent='📦';
          if(imgEl.parentNode) imgEl.parentNode.replaceChild(ph, imgEl);
        };
      } else {
        imgEl=document.createElement('div');
        imgEl.style.cssText='width:62px;height:62px;background:var(--surface-0);border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:28px;flex-shrink:0;border:0.5px solid var(--border)';
        imgEl.textContent='📦';
      }
      row.appendChild(imgEl);
      var info=document.createElement('div');
      info.style.cssText='flex:1;min-width:0';
      info.innerHTML='<div style="font-size:12px;font-weight:500;line-height:1.35;margin-bottom:2px">'+(l.itemname||'Artículo '+(i+1))+'</div>'
        +'<div style="font-size:10px;margin-bottom:6px">'+(l._noSap&&l._enSap===false?'<span class="cat-nuevo" style="margin-right:5px">SKU nuevo</span>':'')+'SKU: <span onclick="_invFicha(\''+(l.itemcode||l.item_code||'')+'\')" style="color:var(--text-accent);cursor:pointer;text-decoration:underline;font-weight:600">'+(l.itemcode||l.item_code||'-')+'</span></div>'
        +'<div style="display:grid;grid-template-columns:'+(_verPrecio?'1fr 1fr 1fr':'1fr')+';gap:5px">'
        +'<div style="background:var(--surface-2);border-radius:5px;padding:4px 7px"><div style="font-size:9px;color:var(--text-muted)">Cant.</div><div style="font-size:12px;font-weight:600">'+qty.toLocaleString()+'</div></div>'
        +(_verPrecio?('<div style="background:var(--surface-2);border-radius:5px;padding:4px 7px"><div style="font-size:9px;color:var(--text-muted)">P.Unit</div><div style="font-size:12px;font-weight:600">'+fmt(pu)+'</div></div>'
        +'<div style="background:var(--bg-accent);border-radius:5px;padding:4px 7px"><div style="font-size:9px;color:var(--text-accent)">Total</div><div style="font-size:12px;font-weight:600;color:var(--text-accent)">'+fmt(tot)+'</div></div>'):'')
        +'</div>';
      row.appendChild(info);
      card.appendChild(row);
      body.appendChild(card);
    });
    var footer=document.createElement('div');
    footer.style.cssText='margin-top:6px;padding:10px 12px;background:var(--surface-1);border-radius:8px;display:flex;justify-content:space-between;font-size:13px;font-weight:700;border:0.5px solid var(--border)';
    footer.innerHTML='<span>Total OC #'+docnum+'</span><span style="color:var(--text-accent)">'+fmt(total)+'</span>';
    body.appendChild(footer);
  }catch(e){body.innerHTML='<div class="empty">Error: '+e.message+'</div>';}
}

function zoomImg(src){
  verArchivo(src, '');
}
// Visor universal: vista previa (imágenes y PDF inline) + botón de descargar.
// Reemplaza la descarga directa. Funciona para todos los archivos y usuarios.
// Ficha de producto (consulta el inventario en Supabase y la muestra en un modal)
// Extrae un valor de las caracteristicas por palabras clave (como en el portal)
function _caracVal(carac, claves){
  if(!carac) return '';
  var keys=Object.keys(carac);
  for(var i=0;i<claves.length;i++){
    for(var j=0;j<keys.length;j++){
      if(keys[j].toLowerCase().indexOf(claves[i].toLowerCase())>=0){
        var v=carac[keys[j]];
        if(v!=null && String(v).trim()!=='') return String(v).trim();
      }
    }
  }
  return '';
}
// Ficha de producto completa (replica la del portal de ventas)
// Muestra qué clientes tienen separada (comprometida) la mercancía de un item,
// consultando los pedidos de venta abiertos. Permite abrir el pedido de cada cliente.
async function verSeparado(itemcode){
  if(!itemcode){ showT('Sin código de producto'); return; }
  var ov=document.createElement('div');
  // z-index alto: se puede abrir desde la ficha del inventario, que ya usa 2010
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2030;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:460px;width:100%"><div style="font-size:12px;color:var(--text-muted)"><i class="ti ti-loader-2 spin"></i> Buscando quién tiene separado '+itemcode+'...</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{
    // Pedidos de venta ABIERTOS con este item y cantidad pendiente (separada)
    var r=await fetch(SB+'/rest/v1/pedidos?select=docnum,cardcode,cardname,openqty,quantity,delivrdqty,docdate,docstatus,nombrevendedor&itemcode=eq.'+encodeURIComponent(itemcode)+'&docstatus=eq.O&openqty=gt.0&order=openqty.desc', {headers:SBH});
    var rows=await r.json();
    if(!Array.isArray(rows)) rows=[];
    var totalSep=rows.reduce(function(s,x){return s+(Number(x.openqty)||0);},0);
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:20px;max-width:480px;width:100%;max-height:88vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px"><div><div style="font-size:14px;font-weight:600">Mercancía separada</div><div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+itemcode+' · '+rows.length+' pedido(s) · '+totalSep.toLocaleString()+' und separadas</div></div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';
    if(!rows.length){
      h+='<div style="font-size:12px;color:var(--text-muted);padding:10px 0">No hay pedidos de venta abiertos con este producto separado.</div>';
    } else {
      h+='<div style="display:flex;flex-direction:column;gap:7px">';
      rows.forEach(function(p){
        var cliente=p.cardname||p.cardcode||'(sin cliente)';
        var sep=Number(p.openqty)||0;
        var vendNom=p.nombrevendedor||'(sin vendedor)';
        h+='<div style="border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;background:var(--surface-1)">';
        h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px">';
        h+='<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:600">'+cliente+'</div>';
        h+='<div style="font-size:11px;color:var(--text-accent);font-weight:600;margin-top:2px"><i class="ti ti-user" style="font-size:11px"></i> Vendedor: '+_esc(vendNom)+'</div>';
        h+='<div style="font-size:10px;color:var(--text-muted);margin-top:1px">Pedido #'+(p.docnum||'?')+' · '+(p.docdate||'')+'</div></div>';
        h+='<div style="text-align:right;flex-shrink:0"><div style="font-size:15px;font-weight:700;color:rgb(255,0,0)">'+sep.toLocaleString()+'</div><div style="font-size:9px;color:var(--text-muted)">separadas</div></div>';
        h+='</div>';
        // Botón para abrir el pedido de venta dentro del portal
        h+='<div style="margin-top:8px;display:flex;gap:6px">';
        h+='<button onclick="abrirPedidoVenta(\''+(p.docnum||'')+'\')" style="flex:1;background:var(--fill-accent);color:white;border:none;border-radius:6px;padding:6px 10px;cursor:pointer;font-size:11px;font-weight:600"><i class="ti ti-external-link" style="font-size:11px"></i> Abrir pedido de venta</button>';
        h+='</div>';
        h+='</div>';
      });
      h+='</div>';
    }
    h+='</div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }catch(e){
    ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:420px"><div style="font-size:13px;color:var(--text-danger)">Error al buscar: '+(e.message||e)+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }
}
// ═══════════════════════════════════════════════════════════════════════════
//  PEDIDO DE VENTA
//  Abre el pedido completo dentro del portal, leyendo la tabla `pedidos` de
//  Supabase (una fila por línea). Todo se ve dentro del portal de compras.
// ═══════════════════════════════════════════════════════════════════════════
function _pvNum(v){ return Number(v)||0; }
function _pvEstado(e){
  var m={O:['Abierto','#fee2e2','#b91c1c'], C:['Cerrado','#dcfce7','#166534']};
  var x=m[String(e||'').toUpperCase()]||['—','var(--surface-1)','var(--text-muted)'];
  return '<span style="font-size:9.5px;background:'+x[1]+';color:'+x[2]+';padding:1px 8px;border-radius:7px;font-weight:700">'+x[0]+'</span>';
}

async function abrirPedidoVenta(docnum){
  if(!docnum){ showT('Sin número de pedido'); return; }
  var prev=document.getElementById('pvOv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='pvOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2040;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:460px;width:100%">'
    +'<div style="font-size:12px;color:var(--text-muted)"><span class="ai-ring g" style="vertical-align:-2px"></span> Abriendo pedido #'+_esc(String(docnum))+'…</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);

  try{
    var campos='docnum,docdate,docduedate,cardcode,cardname,doctotal,doccur,docstatus,comments,'
      +'nombrevendedor,linenum,itemcode,dscription,quantity,price,linetotal,delivrdqty,openqty,'
      +'linestatus,unitmsr,whscode';
    var r=await fetch(SB+'/rest/v1/pedidos?select='+campos+'&docnum=eq.'+encodeURIComponent(docnum)+'&order=linenum&limit=500',{headers:SBH});
    if(!r.ok) throw new Error('HTTP '+r.status);
    var lin=await r.json();
    if(!Array.isArray(lin)) lin=[];
    if(!lin.length){
      ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:440px;width:100%">'
        +'<div style="font-size:13px">No se encontró el pedido #'+_esc(String(docnum))+' en el sistema.</div>'
        +'<button onclick="document.getElementById(\'pvOv\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
      return;
    }
    var h0=lin[0];

    // Fotos de los items, para reconocerlos de un vistazo
    var fotos={};
    try{
      var codes=lin.map(function(l){return String(l.itemcode||'');}).filter(Boolean);
      if(codes.length){
        var inList=Array.from(new Set(codes)).map(function(c){return '"'+c.replace(/"/g,'')+'"';}).join(',');
        var rf=await fetch(SB+'/rest/v1/inventario?select=itemcode,picturname&itemcode=in.('+encodeURIComponent(inList)+')&limit=500',{headers:SBH});
        if(rf.ok) (await rf.json()||[]).forEach(function(x){ fotos[x.itemcode]=x.picturname||''; });
      }
    }catch(e){}

    var totPz=lin.reduce(function(a,l){return a+_pvNum(l.quantity);},0);
    var totEnt=lin.reduce(function(a,l){return a+_pvNum(l.delivrdqty);},0);
    var totAb=lin.reduce(function(a,l){return a+_pvNum(l.openqty);},0);
    var moneda=h0.doccur||h0.currency||'';

    var maxSku=lin.reduce(function(m,l){ return Math.max(m, String(l.itemcode||'').length); },0);
    var skuW=Math.min(280, Math.max(116, Math.round(maxSku*7.2)+22));
    var h='<div style="--pv-sku-w:'+skuW+'px;background:var(--surface-0);border-radius:12px;max-width:800px;width:100%;max-height:92vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;padding:15px 18px;border-bottom:0.5px solid var(--border)">'
      +'<div style="min-width:0">'
        +'<div style="font-size:15px;font-weight:700">Pedido de venta #'+_esc(String(h0.docnum||docnum))+' '+_pvEstado(h0.docstatus)+'</div>'
        +'<div style="font-size:12.5px;color:var(--text-secondary);margin-top:2px">'+_esc(h0.cardname||h0.cardcode||'(sin cliente)')+'</div>'
        +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'
          +(h0.docdate?('Fecha: '+_esc(String(h0.docdate).slice(0,10))):'')
          +(h0.docduedate?(' · Entrega: '+_esc(String(h0.docduedate).slice(0,10))):'')
          +(h0.nombrevendedor?(' · Vendedor: '+_esc(h0.nombrevendedor)):'')
        +'</div>'
      +'</div>'
      +'<button onclick="document.getElementById(\'pvOv\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';

    h+='<div style="padding:14px 18px">';
    // Totales
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:12px">'
      +_invCaja('Piezas pedidas', totPz.toLocaleString('en-US'), '#1D4ED8')
      +_invCaja('Entregadas',     totEnt.toLocaleString('en-US'), '#15803D')
      +_invCaja('Abiertas',       totAb.toLocaleString('en-US'), '#DC2626')
      +(CU.verCostos&&_pvNum(h0.doctotal)?_invCaja('Total '+_esc(moneda), fmt(h0.doctotal), '#5B21B6'):'')
      +'</div>';

    // Líneas
    h+='<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden">';
    h+='<div class="pv-hdr"><div style="flex:0 0 40px"></div><div class="pv-sku">SKU</div>'
      +'<div class="pv-desc">Descripción</div>'
      +'<div class="pv-n">Pedidas</div><div class="pv-n">Entreg.</div><div class="pv-n">Abiertas</div>'
      +(CU.verCostos?'<div class="pv-n" style="flex:0 0 84px">Total</div>':'')+'</div>';
    lin.forEach(function(l){
      var f=_repFotoUrl(fotos[l.itemcode]||'');
      var ab=_pvNum(l.openqty);
      h+='<div class="pv-row">'
        +'<div style="flex:0 0 40px">'+(f
            ?'<img src="'+_esc(f)+'" loading="lazy" style="width:34px;height:34px;object-fit:contain;border:0.5px solid var(--border);border-radius:5px;background:var(--surface-2)">'
            :'<div style="width:34px;height:34px;border:0.5px solid var(--border);border-radius:5px;display:flex;align-items:center;justify-content:center;color:var(--text-muted)"><i class="ti ti-photo-off" style="font-size:13px"></i></div>')+'</div>'
        +'<div class="pv-sku" title="'+_esc(l.itemcode||'')+'">'+_esc(l.itemcode||'')+'</div>'
        +'<div class="pv-desc" title="'+_esc(l.dscription||'')+'">'+_esc(l.dscription||'')+'</div>'
        +'<div class="pv-n">'+_pvNum(l.quantity).toLocaleString('en-US')+'</div>'
        +'<div class="pv-n" style="color:#15803D">'+_pvNum(l.delivrdqty).toLocaleString('en-US')+'</div>'
        +'<div class="pv-n" style="color:'+(ab>0?'#DC2626':'var(--text-muted)')+';font-weight:700">'+ab.toLocaleString('en-US')+'</div>'
        +(CU.verCostos?('<div class="pv-n" style="flex:0 0 84px">'+fmt(l.linetotal)+'</div>'):'')
      +'</div>';
    });
    h+='</div>';

    if(h0.comments && String(h0.comments).trim()){
      h+='<div style="margin-top:12px;padding:10px 12px;background:#FEF9E7;border-left:4px solid #E0A82E;border-radius:8px">'
        +'<div style="font-size:10px;text-transform:uppercase;color:var(--t-oro);font-weight:700;margin-bottom:3px">Comentarios</div>'
        +'<div style="font-size:12.5px;color:#5A4A1F;white-space:pre-wrap">'+_esc(String(h0.comments))+'</div></div>';
    }

    h+='<div style="margin-top:13px;display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end">'
      +'<button class="btn bg2" style="padding:7px 14px;font-size:11.5px" onclick="document.getElementById(\'pvOv\').remove()">Cerrar</button>'
      +'</div>';

    h+='</div></div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }catch(e){
    console.error('pedido venta:',e);
    ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:440px;width:100%">'
      +'<div style="font-size:13px;color:var(--text-danger)">No se pudo abrir el pedido: '+_esc(e.message||String(e))+'</div>'
      +'<button onclick="document.getElementById(\'pvOv\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
  }
}

async function verFichaProducto(itemcode){
  if(!itemcode){ showT('Sin código de producto'); return; }
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1000;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:460px;width:100%"><div style="font-size:12px;color:var(--text-muted)"><i class="ti ti-loader-2 spin"></i> Cargando ficha de '+itemcode+'...</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{
    // Traer de vista_inventario (datos) + inventario (frgnname, usertext/nota) + fotos
    var results=await Promise.all([
      fetch(SB+'/rest/v1/vista_inventario?select=*&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=1',{headers:SBH}).then(function(r){return r.json();}),
      fetch(SB+'/rest/v1/inventario?select=frgnname,usertext&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=1',{headers:SBH}).then(function(r){return r.json();}).catch(function(){return[];}),
      fetch(SB+'/rest/v1/fotos?select=url&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=1',{headers:SBH}).then(function(r){return r.json();}).catch(function(){return[];})
    ]);
    var b=(Array.isArray(results[0])&&results[0][0])?results[0][0]:null;
    var invRow=(Array.isArray(results[1])&&results[1][0])?results[1][0]:{};
    var fotoRow=(Array.isArray(results[2])&&results[2][0])?results[2][0]:{};
    if(!b){ ov.querySelector('div>div').innerHTML='<div style="font-size:13px">No se encontró <strong>'+itemcode+'</strong> en el inventario.</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button>'; return; }
    var carac=b.caracteristicas; if(typeof carac==='string'){try{carac=JSON.parse(carac);}catch(e){carac=null;}}
    var nombre=b.itemname||itemcode;
    var frgn=invRow.frgnname||'';
    var nota=invRow.usertext||_caracVal(carac,['nota','note','observ','comentario']);
    var foto=(fotoRow.url)||b.foto_url||'';
    var _verP=CU&&CU.verCostos&&CU.role!=='diseno'&&CU.role!=='bodega';
    var pventa=Number(b.precioventa)||0;
    var dispo=Number(b.disponiblebodega!=null?b.disponiblebodega:b.disponible)||0;
    // Valores GLOBALES (todas las bodegas), como en SAP
    var stockGlobal=Number(b.onhand)||0;
    var enPedidos=Number(b.iscommited)||0;
    var porLlegar=Number(b.onorder)||0;
    var bulto=Math.max(1,Number(b.unidadesbulto)||Number(b.numinbuy)||1);
    // Ficha técnica (campos como en el portal)
    var cub=b.volumen?(Math.round(b.volumen*100000)/100000)+' Pies':_caracVal(carac,['cubicaje','volumen']);
    var pesoP=b.peso?(Math.round(b.peso*100)/100)+' kg':_caracVal(carac,['peso','weight']);
    var ficha=[
      ['Tamaño', _caracVal(carac,['tamano','tama','medida','size','dimens'])],
      ['Cubicaje', cub],
      ['Peso', pesoP],
      ['Marca', b.marca||_caracVal(carac,['marca','brand'])],
      ['Origen', _caracVal(carac,['porigen','origen','origin','pais','country'])],
      ['Piezas por bulto', b.unidadesbulto?String(b.unidadesbulto):''],
      ['Color', _caracVal(carac,['color','colour','tono'])],
      ['Composición', _caracVal(carac,['composic','compo','material','tela','fabric','content','fibra','composition'])]
    ].filter(function(x){ return x[1] && String(x[1]).trim()!==''; });
    function row(lbl,val){ return val?('<div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:0.5px solid var(--border);font-size:12px;gap:12px"><span style="color:var(--text-muted);flex-shrink:0">'+lbl+'</span><span style="font-weight:500;text-align:right">'+String(val)+'</span></div>'):''; }
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:460px;width:100%;max-height:90vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px;gap:10px"><div><div style="font-size:15px;font-weight:600;line-height:1.3">'+nombre+'</div><div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+itemcode+(frgn?' · '+frgn:'')+'</div></div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1;flex-shrink:0">&times;</button></div>';
    if(foto) h+='<img src="'+foto+'" style="width:100%;max-height:210px;object-fit:contain;border-radius:8px;background:var(--surface-1);margin-bottom:14px;padding:6px" onerror="this.style.display=\'none\'">';
    // KPIs
    h+='<div style="background:var(--surface-1);border-radius:8px;padding:12px;margin-bottom:12px;display:flex;justify-content:space-around;text-align:center">';
    if(_verP) h+='<div><div style="font-size:9px;color:var(--text-muted);text-transform:uppercase">Precio venta</div><div style="font-size:18px;font-weight:700;color:var(--text-accent)">'+(pventa?fmt(pventa):'—')+'</div></div>';
    h+='<div><div style="font-size:9px;color:var(--text-muted);text-transform:uppercase">Stock</div><div style="font-size:18px;font-weight:700;color:rgb(21,206,43)">'+stockGlobal.toLocaleString()+' <span onclick="verSeparado(\''+itemcode+'\')" style="font-size:11px;font-weight:500;color:rgb(255,0,0);cursor:pointer;text-decoration:underline" title="Ver qué clientes lo tienen separado">('+enPedidos.toLocaleString()+')</span> <span style="font-size:11px;font-weight:500;color:#C9A800">('+porLlegar.toLocaleString()+')</span></div><div style="font-size:9px;color:var(--text-muted)">stock · <span style="color:rgb(255,0,0)">separado</span> · <span style="color:#C9A800">por llegar</span></div></div>';
    h+='</div>';
    // Info del producto
    h+='<div style="margin-bottom:12px">';
    h+=row('Código', '<b>'+itemcode+'</b>');
    h+=row('Código de barras', b.codebars);
    h+=row('Unidades por bulto', bulto);
    h+=row('Unidad compra', b.buyunitmsr);
    h+=row('Unidad venta', b.salunitmsr);
    h+='</div>';
    // Ficha técnica
    if(ficha.length){
      h+='<div style="font-size:10px;font-weight:700;text-transform:uppercase;color:var(--text-muted);margin-bottom:4px">Ficha técnica</div><div style="margin-bottom:12px">';
      ficha.forEach(function(x){ h+=row(x[0],x[1]); });
      h+='</div>';
    }
    // Nota
    if(nota && String(nota).trim()){
      h+='<div style="background:#FEF9E7;border-left:3px solid #E0A82E;border-radius:8px;padding:10px 12px;font-size:11px;color:#5A4A1F;line-height:1.5;white-space:pre-wrap"><strong style="text-transform:uppercase;font-size:9px;color:var(--t-oro)">Nota</strong><br>'+String(nota).replace(/</g,'&lt;')+'</div>';
    }
    // Stock detalle
    h+='<div style="margin-top:12px;display:flex;justify-content:space-around;text-align:center;background:var(--surface-1);border-radius:8px;padding:10px;font-size:11px">';
    h+='<div><div style="color:var(--text-muted);font-size:9px;text-transform:uppercase">En stock</div><div style="font-weight:600;color:rgb(21,206,43)">'+stockGlobal.toLocaleString()+'</div></div>';
    h+='<div onclick="verSeparado(\''+itemcode+'\')" style="cursor:pointer"><div style="color:var(--text-muted);font-size:9px;text-transform:uppercase">Separado</div><div style="font-weight:600;color:rgb(255,0,0);text-decoration:underline">'+enPedidos.toLocaleString()+'</div></div>';
    h+='<div><div style="color:var(--text-muted);font-size:9px;text-transform:uppercase">Por llegar</div><div style="font-weight:600;color:#C9A800">'+porLlegar.toLocaleString()+'</div></div>';
    h+='<div><div style="color:var(--text-muted);font-size:9px;text-transform:uppercase">Disponible</div><div style="font-weight:600">'+(stockGlobal-enPedidos).toLocaleString()+'</div></div>';
    h+='</div>';
    h+='</div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }catch(e){
    ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:24px;max-width:420px"><div style="font-size:13px;color:var(--text-danger)">Error al cargar la ficha: '+(e.message||e)+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }
}

// URL que fuerza la descarga en vez de abrir el archivo en el navegador.
// Supabase ignora el Content-Disposition que se manda al subir, pero sí
// respeta ?download= en la URL pública. Sirve incluso para los archivos que
// quedaron guardados con el tipo equivocado.
function _urlDescarga(url, nombre){
  if(!url) return url;
  var u=String(url);
  if(u.indexOf('download=')>=0) return u;
  var nom=String(nombre||u.split('/').pop()||'archivo').split('?')[0];
  return u + (u.indexOf('?')>=0?'&':'?') + 'download=' + encodeURIComponent(nom);
}

// Estos se pueden ver dentro del portal; el resto se descarga
var _VER_EN_PORTAL=['jpg','jpeg','png','gif','webp','bmp','svg','pdf','xlsx','xls','csv','doc','docx','ppt','pptx','txt'];

function verArchivo(url, nombre){
  if(!url) return;
  nombre = nombre || (url.split('/').pop()||'archivo').split('?')[0];
  try{ nombre=decodeURIComponent(nombre); }catch(e){}
  var ext=(nombre.split('.').pop()||'').toLowerCase();

  // Comprimidos y formatos de diseño: se descargan directo, no hay nada que
  // previsualizar y abrirlos en el navegador mostraba una pantalla de letras.
  if(_VER_EN_PORTAL.indexOf(ext)<0){
    var a=document.createElement('a');
    a.href=_urlDescarga(url, nombre);
    a.download=nombre;
    a.style.display='none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function(){ a.remove(); }, 1500);
    showT('Descargando '+nombre+'…');
    return;
  }
  var esImg=['jpg','jpeg','png','gif','webp','bmp','svg'].includes(ext);
  var esPdf=ext==='pdf';
  var esOffice=['xlsx','xls','doc','docx','ppt','pptx'].includes(ext);
  var esExcel=['xlsx','xls','csv'].includes(ext);

  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.85);z-index:1000;display:flex;flex-direction:column;padding:0';
  // Barra superior con nombre + descargar + cerrar
  var bar=document.createElement('div');
  bar.style.cssText='display:flex;align-items:center;gap:10px;padding:11px 16px;background:#1e1e24;color:#fff;flex-shrink:0';
  bar.innerHTML='<i class="ti ti-file" style="font-size:15px;color:#c9c9d6"></i><span style="font-size:13px;font-weight:500;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+nombre.replace(/</g,'&lt;')+'</span>';
  var dl=document.createElement('a');
  dl.href=_urlDescarga(url,nombre); dl.download=nombre;
  dl.style.cssText='display:inline-flex;align-items:center;gap:5px;background:#534AB7;color:#fff;text-decoration:none;padding:6px 13px;border-radius:7px;font-size:12px;font-weight:600;cursor:pointer';
  dl.innerHTML='<i class="ti ti-download" style="font-size:13px"></i> Descargar';
  bar.appendChild(dl);
  var cl=document.createElement('button');
  cl.innerHTML='&times;';
  cl.style.cssText='background:none;border:none;color:#fff;font-size:26px;cursor:pointer;line-height:1;padding:0 4px';
  cl.onclick=function(){ov.remove();};
  bar.appendChild(cl);
  ov.appendChild(bar);
  // Cuerpo con la vista previa
  var body=document.createElement('div');
  body.style.cssText='flex:1;display:flex;align-items:center;justify-content:center;overflow:auto;padding:16px';
  if(esImg){
    var img=document.createElement('img');
    img.src=url;
    img.style.cssText='max-width:96%;max-height:96%;object-fit:contain;border-radius:8px;box-shadow:0 8px 40px rgba(0,0,0,.5)';
    body.appendChild(img);
  } else if(esPdf){
    var fr=document.createElement('iframe');
    fr.src=url;
    fr.style.cssText='width:100%;height:100%;border:none;background:var(--surface-2);border-radius:6px';
    body.appendChild(fr);
  } else if(esExcel){
    var xw=document.createElement('div'); xw.style.cssText='width:100%;height:100%;overflow:auto;background:var(--surface-2);border-radius:6px;padding:10px'; xw.innerHTML='<div style="color:#555;font-size:13px;padding:12px"><i class="ti ti-loader-2 spin"></i> Cargando vista previa…</div>'; body.appendChild(xw); _previewExcel(url, xw, nombre);
  } else if(esOffice){
    // Visor de Microsoft Office Online (renderiza Excel/Word/PowerPoint con formato).
    // Requiere que la URL del archivo sea pública (el bucket compras-docs lo es).
    var frO=document.createElement('iframe');
    frO.src='https://view.officeapps.live.com/op/embed.aspx?src='+encodeURIComponent(url);
    frO.style.cssText='width:100%;height:100%;border:none;background:var(--surface-2);border-radius:6px';
    // Si el visor de Office no carga (ej. archivo no accesible), avisar con opción de descargar
    var avisoTimer=setTimeout(function(){
      if(!frO._cargó){
        // No forzamos cierre; el usuario siempre tiene el botón Descargar arriba.
      }
    },8000);
    frO.onload=function(){ frO._cargó=true; clearTimeout(avisoTimer); };
    body.appendChild(frO);
  } else {
    // Otros tipos (Word, Excel): no se pueden previsualizar en el navegador
    var box=document.createElement('div');
    box.style.cssText='text-align:center;color:#fff;max-width:340px';
    box.innerHTML='<div style="font-size:46px;margin-bottom:10px">'+(ext==='xlsx'||ext==='xls'?'📊':ext==='doc'||ext==='docx'?'📝':'📎')+'</div>'
      +'<div style="font-size:14px;font-weight:500;margin-bottom:6px">'+nombre.replace(/</g,'&lt;')+'</div>'
      +'<div style="font-size:12px;color:#b8b8c8;margin-bottom:16px">Este tipo de archivo no se puede previsualizar en el navegador.</div>';
    var dl2=document.createElement('a');
    dl2.href=_urlDescarga(url,nombre); dl2.download=nombre;
    dl2.style.cssText='display:inline-flex;align-items:center;gap:6px;background:#534AB7;color:#fff;text-decoration:none;padding:9px 18px;border-radius:8px;font-size:13px;font-weight:600';
    dl2.innerHTML='<i class="ti ti-download"></i> Descargar archivo';
    box.appendChild(dl2);
    body.appendChild(box);
  }
  ov.appendChild(body);
  // Cerrar al hacer clic en el fondo oscuro (no en el contenido)
  ov.addEventListener('click',function(e){ if(e.target===ov||e.target===body) ov.remove(); });
  document.body.appendChild(ov);
}
async function _previewExcel(url, wrap, nombre){
  try{
    if(typeof XLSX==='undefined') throw new Error('sin XLSX');
    var buf=await fetch(url).then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.arrayBuffer(); });
    var wb=XLSX.read(buf,{type:'array'});
    var html='';
    wb.SheetNames.forEach(function(sn){ var ws=wb.Sheets[sn]; html+='<div style="font-size:12px;font-weight:700;color:#075E54;margin:8px 0 4px">'+_esc(sn)+'</div>'+XLSX.utils.sheet_to_html(ws); });
    wrap.innerHTML='<style>#xlsxprev table{border-collapse:collapse;font-size:12px;color:var(--text-primary)}#xlsxprev td,#xlsxprev th{border:0.5px solid #ccc;padding:3px 7px}</style><div id="xlsxprev">'+html+'</div>';
  }catch(e){
    wrap.innerHTML='<div style="text-align:center;color:#555;padding:24px"><div style="font-size:40px">📊</div><div style="margin:8px 0;font-size:13px">No se pudo generar la vista previa aquí.</div><a href="'+url+'" download style="display:inline-flex;gap:6px;align-items:center;background:#534AB7;color:#fff;text-decoration:none;padding:9px 16px;border-radius:8px;font-size:13px;font-weight:600"><i class="ti ti-download"></i> Descargar</a></div>';
  }
}

// ─── FIX 5: Adjuntos por etapa ───
// Encola un correo al proveedor en Supabase. El script Python lo detecta,
// adjunta el comprobante automáticamente y lo envía por Office 365. Sin abrir
// ningún programa de correo y sin adjuntar nada a mano.
async function enviarCorreoProveedor(oid){
  var o = orders.find(function(x){return x.id===oid;});
  if(!o){ showT('Orden no encontrada'); return; }
  var email = (o.vendorEmail||'').trim();
  if(!email){
    showT('⚠ Este proveedor no tiene correo en SAP');
    return;
  }

  // Comprobante de abono adjunto en la etapa de depósito (si existe)
  var docsDep = (window._atts && window._atts[oid+'deposito']) ? window._atts[oid+'deposito'] : [];
  var adj = docsDep.length ? docsDep[docsDep.length-1] : null;   // el último adjuntado

  var fechaAbono = o.fechaAbono || dateOnly();
  var montoAbono = (typeof fmt==='function') ? fmt(o.abono) : ('$'+o.abono);
  var asunto = 'Payment advice - Order '+oid+' - Kennedy Center';
  var cuerpo =
    'Dear '+o.prov+',\n\n'+
    'We are pleased to inform you that we have issued the payment for purchase order '+oid+'.\n\n'+
    'Details:\n'+
    '  - Order: '+oid+'\n'+
    (o.num_proveedor?('  - Reference: '+o.num_proveedor+'\n'):'')+
    '  - Payment amount: '+montoAbono+'\n'+
    '  - Payment date: '+fechaAbono+'\n'+
    '  - Description: '+(o.desc||'')+'\n\n'+
    (adj ? 'Please find the payment receipt attached.\n\n' : '')+
    'We look forward to your confirmation of receipt.\n\n'+
    'Best regards,\n'+
    (CU?CU.name:'')+'\n'+
    'Kennedy Center Corp.';

  if(!confirm('¿Enviar correo del abono a '+o.prov+' ('+email+')'+(adj?' con el comprobante adjunto':'')+'?')) return;

  showT('Encolando correo...');
  try{
    var body = {
      docnum:String(oid), para_email:email, proveedor:o.prov,
      asunto:asunto, cuerpo:cuerpo,
      adjunto_path: adj?adj.url:null,
      adjunto_nombre: adj?adj.name:null,
      estado:'pendiente', creado_por:(CU?CU.name:''), creado_en:new Date().toISOString()
    };
    var r = await fetch(SB+'/rest/v1/correos_queue', {
      method:'POST',
      headers:Object.assign({}, SBH, {'Prefer':'return=minimal'}),
      body:JSON.stringify(body)
    });
    if(r.ok){
      showT('✅ Correo en cola — se enviará al proveedor'+(adj?' con el comprobante':''));
    } else {
      var t = await r.text();
      console.error('encolar correo:', r.status, t);
      showT('⚠ No se pudo encolar (revisa la tabla correos_queue)');
    }
  }catch(e){
    console.error('encolar correo:', e);
    showT('⚠ Error: '+e.message);
  }
}

if(!window._atts)window._atts={};

// Bucket de Supabase Storage para documentos de compras (crear una vez en el panel)
const DOCS_BUCKET = 'compras-docs';
const DOCS_BASE = SB + '/storage/v1/object/public/' + DOCS_BUCKET + '/';

// Sube un archivo al bucket y devuelve la ruta pública (o null si falla)
async function _subirDocStorage(oid, stageKey, file){
  // Ruta única: oid/etapa/timestamp_nombre  (sin espacios ni caracteres raros)
  var limpio = file.name.replace(/[^\w.\-]+/g,'_');
  var path = oid + '/' + stageKey + '/' + Date.now() + '_' + limpio;
  var url = SB + '/storage/v1/object/' + DOCS_BUCKET + '/' + path.split('/').map(encodeURIComponent).join('/');
  try{
    var resp = await fetch(url, {
      method:'POST',
      headers:{ 'apikey':KEY, 'Authorization':'Bearer '+KEY, 'Content-Type': file.type||'application/octet-stream', 'x-upsert':'true' },
      body: file
    });
    if(resp.ok) return path;
    console.error('subir doc:', resp.status, await resp.text());
    return null;
  }catch(e){ console.error('subir doc error:', e); return null; }
}

// Registra el documento en la tabla compras_documentos
async function _registrarDoc(oid, stageKey, file, path){
  try{
    var body = {
      docnum:String(oid), etapa:stageKey, paso:null,
      nombre_archivo:file.name, url:path,
      tipo:(file.name.split('.').pop()||'').toLowerCase(),
      subido_por: CU?CU.name:'', subido_en:new Date().toISOString()
    };
    var r = await fetch(SB+'/rest/v1/compras_documentos', {
      method:'POST',
      headers:Object.assign({}, SBH, {'Prefer':'return=representation'}),
      body:JSON.stringify(body)
    });
    if(r.ok){ var arr=await r.json(); return Array.isArray(arr)?arr[0]:null; }
  }catch(e){ console.error('registrar doc:', e); }
  return null;
}

// Carga los documentos guardados de una orden (todas sus etapas) a window._atts
async function cargarDocsOrden(oid){
  try{
    var r = await fetch(SB+'/rest/v1/compras_documentos?select=*&docnum=eq.'+encodeURIComponent(oid)+'&order=subido_en.asc', {headers:SBH});
    if(!r.ok) return;
    var docs = await r.json();
    if(!Array.isArray(docs)) return;
    docs.forEach(function(d){
      var k = oid + d.etapa;
      if(!window._atts[k]) window._atts[k]=[];
      // No repetir: ni por id ni por nombre. Las versiones anteriores del
      // portal subean el mismo archivo varias veces y quedaron duplicados.
      if(window._atts[k].some(function(a){return a.id===d.id;})) return;
      var _cl=_docClave({name:d.nombre_archivo});
      if(_cl && window._atts[k].some(function(a){ return _docClave(a)===_cl; })) return;
      window._atts[k].push({
        id:d.id, name:d.nombre_archivo,
        data: DOCS_BASE + d.url.split('/').map(encodeURIComponent).join('/'),
        url:d.url, date:(d.subido_en||'').slice(0,10),
        by:d.subido_por, remoto:true
      });
    });
  }catch(e){ console.error('cargarDocsOrden:', e); }
}

function handleAttach(oid,stageKey,inp){
  var k=oid+stageKey;
  if(!window._atts[k])window._atts[k]=[];
  var files=Array.from(inp.files);
  if(!files.length) return;
  inp.value='';
  showT('Subiendo '+files.length+' archivo'+(files.length>1?'s':'')+'...');
  var pend=files.length;
  files.forEach(function(f){
    _subirDocStorage(oid, stageKey, f).then(function(path){
      if(path){
        _registrarDoc(oid, stageKey, f, path).then(function(reg){
          window._atts[k].push({
            id: reg?reg.id:undefined,
            name:f.name,
            data: DOCS_BASE + path.split('/').map(encodeURIComponent).join('/'),
            url:path, date:now2(), by:(CU?CU.name:''), remoto:true
          });
          try{ _solPagoDepositoAdjunto(oid, stageKey, path, f.name); }catch(e){}
          _finAttach(oid, stageKey, files.length, --pend);
        });
      } else {
        showT('⚠ No se pudo subir '+f.name);
        _finAttach(oid, stageKey, files.length, --pend);
      }
    });
  });
}
function _finAttach(oid, stageKey, totalFiles, pend){
  if(pend<=0){
    showT('✓ '+totalFiles+' archivo'+(totalFiles>1?'s':'')+' guardado'+(totalFiles>1?'s':''));
    _redibujarPaso(oid, stageKey);
  }
}
// Redibuja el paso y REABRE la sub-etapa donde se subió/eliminó el archivo,
// para que el adjunto se vea al instante (sin salir de la pantalla).
// stageKey puede venir como 'artes_step3' (con sub-paso) o 'artes' (etapa).
function _redibujarPaso(oid, stageKey){
  // Caso especial: adjuntos de "Pendientes de SAP" (no es una etapa normal)
  if(stageKey==='__pendsap'){ if(PG==='dashboard'&&dashKpiFilter==='sap')rDash(); return; }
  // Separar la etapa base del índice de sub-paso, si viene como 'etapa_stepN'
  var baseKey=stageKey, subIdx=null;
  var m=String(stageKey).match(/^(.*)_step(\d+)$/);
  if(m){ baseKey=m[1]; subIdx=parseInt(m[2]); }
  var si=STAGES.findIndex(function(s){return s.key===baseKey;});
  if(si<0) return;
  var b=document.getElementById('egb-'+oid+'-'+si);
  if(!b) return;
  buildEGB(oid,si,b);
  // Reabrir la sub-etapa donde estaba el usuario
  if(subIdx!==null){
    setTimeout(function(){
      var sb=document.getElementById('ssb-'+oid+'-'+si+'-'+subIdx);
      var chev=document.getElementById('ssch-'+oid+'-'+si+'-'+subIdx);
      if(sb){ sb.style.display='block'; if(chev)chev.style.transform='rotate(180deg)'; }
    },0);
  }
}
async function delAtt(oid,sk,i){
  var k=oid+sk;
  var a = window._atts&&window._atts[k]?window._atts[k][i]:null;
  // Confirmación antes de borrar: el archivo se va también del almacenamiento
  if(!confirm('¿Está seguro de que desea borrar el archivo "'+((a&&a.name)||'sin nombre')+'"?\n\nSe elimina del portal y del almacenamiento.\n\nEsta acción no se puede deshacer.')) return;
  if(a && a.id){
    // Borra el registro y el archivo del Storage
    try{
      await fetch(SB+'/rest/v1/compras_documentos?id=eq.'+a.id, {method:'DELETE', headers:SBH});
      if(a.url) await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+a.url.split('/').map(encodeURIComponent).join('/'), {method:'DELETE', headers:{'apikey':KEY,'Authorization':'Bearer '+KEY}});
    }catch(e){ console.error('borrar doc:', e); }
  }
  if(window._atts&&window._atts[k])window._atts[k].splice(i,1);
  _redibujarPaso(oid, sk);
  showT('Archivo eliminado');
}


function buildEGB(oid,idx,container){
  const o=orders.find(x=>x.id===oid);if(!o)return;
  const stage=STAGES[idx];if(!stage)return;
  initP(oid);
  const sp2=stageProgress[oid][stage.key];
  const si=getStageIdx(o);
  const isCurr=!o.completada&&!o.pend&&idx===si;
  const isDone=sp2.stepIdx>=stage.steps.length;
  // Gerencia puede editar cualquier etapa
  // Diseño ve la etapa de Pedido para consultar la orden y las fotos, pero
  // no la trabaja: ahí solo mira, descarga y comenta en el chat.
  const soloMira = CU && CU.role==='diseno' && stage.key==='pedido';
  const canEdit=!soloMira && CU
    && (CU.role==='gerencia'||(isCurr&&canSeeStage(stage.key)));

  let html='<div class="sub-steps">';
  stage.steps.forEach(function(step,i){
    const done=i<sp2.stepIdx, active=i===sp2.stepIdx&&(isCurr||canEdit);
    // El color del semáforo refleja el ESTADO real del paso (no los permisos):
    // verde=completado, amarillo=paso en curso, rojo=pendiente.
    const esPasoActivo=i===sp2.stepIdx;
    // Punto 1: el "Registro de Booking" queda AMARILLO hasta que se registre al menos
    // un contenedor con su número (aunque el paso se haya marcado como hecho).
    var _bookingIncompleto=false;
    if(stage.key==='logistica' && step.name==='Registro de Booking'){
      var _bk=getBK(oid);
      var _tieneCtn=_bk && _bk.containers && _bk.containers.some(function(c){return c && c.id && String(c.id).trim();});
      if(!_tieneCtn) _bookingIncompleto=true;
    }
    const cls=done?'ss-done':active?'ss-active':'ss-future';
    var sem=done?'sem-g':esPasoActivo?'sem-y':'sem-r';
    if(_bookingIncompleto) sem='sem-y';
    const stepDate=sp2.stepDates&&sp2.stepDates[i]?sp2.stepDates[i]:'';
    const dur=done&&stepDate?daysBetween(stepDate,null):0;
    // Sub-key para adjuntos individuales por sub-etapa
    const subKey=stage.key+'_step'+i;
    // A los adjuntos propios del subpaso se suman los documentos base de la
    // orden (la orden de KCC y la del proveedor). Se muestran en Pedido y en
    // Depósito & Pago, que es donde se necesitan, SIN duplicar el archivo:
    // es la misma URL, solo se referencia.
    const subAtts=_attsDelSubpaso(oid, stage.key, i, subKey);

    html+='<div class="ss '+cls+'" style="border-radius:8px;margin-bottom:8px;border:0.5px solid var(--border);overflow:hidden">';
    // Header de sub-etapa
    html+='<div style="display:flex;align-items:center;gap:8px;padding:9px 12px;background:var(--surface-1);cursor:pointer" onclick="toggleSubStep(\''+oid+'\','+idx+','+i+')">';
    html+='<span class="sem '+sem+'" style="width:10px;height:10px;flex-shrink:0"></span>';
    html+='<div style="flex:1"><div class="ss-name">'+step.name+'</div>';
    var stepBy=(sp2.stepBy&&sp2.stepBy[i])?sp2.stepBy[i]:'';
    if(stepDate)html+='<div class="ss-dates"><i class="ti ti-calendar" style="font-size:9px"></i> '+(done?'Completado':'Iniciado')+': '+stepDate+(done&&dur>0?' ('+dur+'d)':'')+(stepBy?' <span style="color:var(--text-accent)">· por '+stepBy+'</span>':'')+'</div>';
    html+='</div>';
    html+='<div style="display:flex;gap:5px;align-items:center">';
    html+='<button class="btn" title="Enviar correo sobre este paso" onclick="event.stopPropagation();mailAbrir(\''+oid+'\',\''+stage.key+'\','+i+')" style="padding:3px 7px;font-size:10px;background:transparent;border:0.5px solid var(--border)"><i class="ti ti-mail" style="font-size:12px;color:var(--text-accent)"></i></button>';
    if(subAtts.length)html+='<span style="font-size:10px;background:var(--bg-accent);color:var(--text-accent);padding:1px 6px;border-radius:8px"><i class="ti ti-paperclip" style="font-size:9px"></i> '+subAtts.length+'</span>';
    // Los pasos que ejecuta compras (solicitud de abono y pago final) no los
    // puede marcar contabilidad: se completan solos al enviar el correo.
    var _deCompras = stage.key==='deposito' && [_PASO_SOL_ABONO,_PASO_PAGO_FINAL,_PASO_COMP_PROV,_PASO_COMP_FINAL].indexOf(step.name)>=0;
    var _deContab  = stage.key==='deposito' && step.name===_PASO_DEP_PROV;
    var _puedeMarcar = _deCompras
      ? (CU.role==='compras'||CU.role==='gerencia')
      : _deContab
        ? (CU.role==='contabilidad'||CU.role==='gerencia')
        : (CU.role===step.role||CU.role==='gerencia');
    // El botón sale en el paso activo y también en los anteriores sin cerrar:
    // así ningún paso queda sin forma de ponerse en verde.
    var _pendiente = !done && (i <= (sp2.stepIdx||0));
    if((active||_pendiente) && _puedeMarcar)
      html+='<button class="btn" title="Dejar este paso en verde" style="padding:3px 8px;font-size:10px;background:#639922;color:white;white-space:nowrap" onclick="event.stopPropagation();advSS(\''+oid+'\',\''+stage.key+'\','+i+')">✓ Marcar hecho</button>';
    if(done&&(CU.role===step.role||CU.role==='gerencia'))html+='<button class="btn bundo" onclick="event.stopPropagation();undoSS(\''+oid+'\',\''+stage.key+'\','+i+')"><i class="ti ti-arrow-back-up" style="font-size:10px"></i></button>';
    html+='<i class="ti ti-chevron-down" id="ssch-'+oid+'-'+idx+'-'+i+'"></i>';
    html+='</div></div>';
    // Body de sub-etapa (oculto por defecto)
    html+='<div id="ssb-'+oid+'-'+idx+'-'+i+'" style="display:none;padding:10px 12px;border-top:0.5px solid var(--border)">';

    // LOGÍSTICA — Tracker multi-contenedor en todos los pasos
    if(stage.key==='logistica'){
      // Punto 3: en "Llegó a destino", panel de confirmación de arribo
      if(step.name==='Llegó a destino'){
        html+=buildLlegadaDestino(oid);
      }
      var bk=getBK(oid);
      // El editor viejo de booking ya no se usa: los paneles nuevos de
      // Booking, B/L y Aviso de llegada traen esos campos y duplicarlos
      // confundía. Solo queda el resumen visual de los contenedores.
      if(false){
        html+='<div id="log-tracker-'+oid+'"></div>';
      } else {
        // Pasos 2-5: resumen de contenedores (solo lectura) + mini barquitos
        if(bk.naviera||bk.containers.length){
          html+='<div style="background:var(--bg-accent);border-radius:8px;padding:8px 12px;margin-bottom:8px">';
          if(bk.naviera||bk.booking)html+='<div style="font-size:11px;font-weight:600;margin-bottom:6px"><span style="color:var(--text-accent)">'+(NAVIERA_EMOJI[bk.naviera]||'🚢')+' '+bk.naviera+'</span>'+(bk.booking?' · BL/Booking: <code style="font-size:10px;background:var(--surface-1);padding:1px 5px;border-radius:4px">'+bk.booking+'</code>':'')+'</div>';
          bk.containers.forEach(function(ctn,ci){
            var hoy=new Date();
            var sal=ctn.etaSalida?new Date(ctn.etaSalida):null;
            var lle=ctn.etaLlegada?new Date(ctn.etaLlegada):null;
            var pct2=0,enRuta2=false,llegado2=false,diasFalta2=0,diasTrans2=0;
            if(sal&&lle){
              if(hoy<sal){pct2=0;}
              else if(hoy>=lle){pct2=100;llegado2=true;}
              else{diasTrans2=Math.round((hoy-sal)/(1000*60*60*24));diasFalta2=Math.round((lle-hoy)/(1000*60*60*24));var tot=Math.max(1,Math.round((lle-sal)/(1000*60*60*24)));pct2=Math.min(95,Math.round((diasTrans2/tot)*100));enRuta2=true;}
            }
            var sc2=llegado2?'#27500A':enRuta2?'#185FA5':'#888';
            var leftP=Math.max(2,Math.min(92,pct2));
            html+='<div style="margin-bottom:6px;background:linear-gradient(180deg,#E8F4FD,#C8E6F8);border-radius:7px;padding:7px 10px">';
            html+='<div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">';
            html+='<span style="font-size:13px">'+(NAVIERA_EMOJI[bk.naviera]||'🚢')+'</span>';
            html+='<code style="font-size:11px;font-weight:700;letter-spacing:.5px">'+(ctn.id||'Sin número')+'</code>';
            html+='<button data-oid="'+oid+'" data-ci="'+ci+'" class="ctn-track-mini" style="padding:2px 8px;background:'+(NAVIERA_COLOR[bk.naviera]||'#185FA5')+';color:white;border:none;border-radius:5px;font-size:9px;cursor:pointer;margin-left:auto"><i class="ti ti-current-location" style="font-size:9px"></i> Track</button>';
            html+='</div>';
            // Mini barquito
            html+='<div style="position:relative;height:20px">';
            html+='<div style="position:absolute;top:50%;left:14px;right:14px;height:1.5px;background:rgba(255,255,255,.6);transform:translateY(-50%)"></div>';
            if(pct2>0)html+='<div style="position:absolute;top:50%;left:14px;width:calc('+leftP+'% - 14px);height:1.5px;background:'+sc2+';transform:translateY(-50%)"></div>';
            html+='<div style="position:absolute;left:calc('+leftP+'% - 10px);top:0;font-size:16px;line-height:1;filter:drop-shadow(0 1px 2px rgba(0,0,0,.2))">'+(NAVIERA_EMOJI[bk.naviera]||'🚢')+'</div>';
            html+='</div>';
            if(enRuta2)html+='<div style="font-size:9px;color:var(--text-muted);margin-top:2px">'+diasTrans2+'d en ruta · '+diasFalta2+'d restantes</div>';
            else if(llegado2)html+='<div style="font-size:9px;color:var(--t-oliva);font-weight:600;margin-top:2px">✓ Llegó a Panamá</div>';
            html+='</div>';
          });
          if(!bk.containers.length)html+='<div style="font-size:11px;color:var(--text-muted)">Sin contenedores registrados. Agrégalos en el paso Booking.</div>';
          html+='</div>';
        }
      }
    }

    // ARTES ENVIADOS AL PROVEEDOR — panel de WeTransfer + correos
    // ARTES APROBADOS POR GERENCIA — ganchito de aprobación + comentario
    // PEDIDO — revisar orden de compra (Excel/PDF) con IA
    if(stage.key==='pedido' && step.name==='Pedido creado por compras'){
      html+=buildRevisionIAGenerica(oid, subKey, 'excel');
    }
    // DEPÓSITO — verificar datos bancarios con IA
    if(stage.key==='deposito'){
      html+=buildRevisionIAGenerica(oid, subKey, 'deposito');
    }
    // ARTES TERMINADOS — botón de revisión con IA (aparece si hay artes adjuntos)
    if(stage.key==='artes' && step.name==='Artes terminados'){
      html+=buildRevisionIA(oid, subKey);
    }

    if(stage.key==='artes' && step.name===_PASO_ARTES_FIN){
      try{ html+=_artesBotonEnviar(oid); }catch(e){ html+=_panelErrLog('Artes', e); }
    }
    if(stage.key==='artes' && step.name===_PASO_ARTES_APROB){
      try{ html+=_artesRevisionPanel(oid); }catch(e){ html+=_panelErrLog('Revisión de artes', e); }
      html+=buildArtesAprobacion(oid);
    }

    // BODEGA & VENTA
    if(stage.key==='bodega'){
      if(step.name===_PASO_BOD_REC){
        html+='<div id="bodrec-'+oid+'">';
        try{ html+=_bodRecibidoPanel(oid); }catch(e){ html+=_panelErrLog('Recibido en bodega', e); }
        html+='</div>';
      } else if(step.name===_PASO_BOD_SAP){
        html+='<div id="bodsap-'+oid+'">';
        try{ html+=_bodFaltantesPanel(oid); }catch(e){ html+=_panelErrLog('Disponible en SAP', e); }
        html+='</div>';
      } else if(step.name===_PASO_BOD_SALA){
        html+='<div id="bodsala-'+oid+'">';
        try{ html+=_bodSalaPanel(oid); }catch(e){ html+=_panelErrLog('En sala de venta', e); }
        html+='</div>';
      }
    }

    // ADUANIZACIÓN & COSTEO
    // Si un panel falla, se muestra el error en pantalla en vez de tragarlo:
    // un try/catch mudo hacía desaparecer el panel entero sin dejar rastro.
    if(stage.key==='costeo'){
      function _panelErr(nombre, e){
        console.error('['+nombre+']', e);
        return '<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;margin-bottom:8px;font-size:11.5px;color:var(--t-rojo)">'
          +'<b><i class="ti ti-alert-triangle"></i> No se pudo mostrar el panel de '+nombre+'</b>'
          +'<div style="margin-top:3px;font-family:monospace;font-size:10.5px">'+_esc(e&&(e.message||String(e)))+'</div>'
          +'<div style="margin-top:3px">Pasale este mensaje a soporte.</div></div>';
      }
      if(step.name===_PASO_DMCE){
        html+='<div id="adupanel-'+oid+'">';
        try{ html+=_aduPanel(oid); }catch(e){ html+=_panelErr('DMCE y SIGA', e); }
        html+='</div>';
      } else if(step.name===_PASO_DMCE_SAL){
        html+='<div id="dmcesal-'+oid+'">';
        try{ html+=_dmceSalidaPanel(oid); }catch(e){ html+=_panelErr('DMCE de salida', e); }
        html+='</div>';
        try{ _dmceSalidaCheck(oid); }catch(e){}
      } else if(step.name===_PASO_PRECIOS){
        html+='<div id="pvpanel-'+oid+'">';
        try{ html+=_pvPanel(oid); }catch(e){ html+=_panelErr('Precios de venta', e); }
        html+='</div>';
      } else if(step.name===_PASO_COSTEO){
        html+='<div id="costeopanel-'+oid+'">';
        try{ html+=_costPanel(oid); }catch(e){ html+=_panelErr('Costeo de importación', e); }
        html+='</div>';
      }
    }

    // LOGÍSTICA — booking, B/L y aviso de llegada
    if(stage.key==='logistica'){
      var _kLog = step.name===_PASO_BOOKING ? 'booking'
                : step.name===_PASO_BL      ? 'bl'
                : step.name===_PASO_ARRIVAL ? 'arrival' : '';
      if(_kLog){
        html+='<div id="logpanel-'+_kLog+'-'+oid+'">';
        try{
          html+= _kLog==='booking' ? _logPanelBooking(oid)
               : _kLog==='bl'      ? _logPanelBL(oid)
                                   : _logPanelArrival(oid);
        }catch(e){ html+=_panelErrLog('Logística', e); }
        html+='</div>';
      }
    }

    // PRODUCCIÓN — inspección y aprobación del encargado
    if(stage.key==='produccion' && step.name===_PASO_INSPECCION){
      html+='<div id="insppanel-'+oid+'">';
      try{ html+=_inspPanel(oid); }catch(e){ html+=_panelErrLog('Inspección', e); }
      html+='</div>';
      if(!window._hubDesc['insp_'+oid]){
        _inspDescargasCargar(oid).then(function(ds){ if(ds&&ds.length) _inspRepintar(oid); });
      }
    }

    // ARTES — HUB de diseño: la orden firmada de KCC va sola, más dos zonas
    // para que se suban el Excel de la orden y los archivos del proveedor.
    if(stage.key==='artes' && step.name==='HUB de diseño'){
      html+='<div class="hub-2col">';
      html+='<div class="hub-col-docs">';
      try{ html+=_hubDisenoPanel(oid); }catch(e){ html+=_panelErrLog('HUB de diseño', e); }
      // Vigilancia de las descargas: mientras haya alguna en curso se
      // consulta seguido y, apenas termina, se traen los archivos y se
      // repinta el HUB sin que haya que recargar nada a mano.
      try{ _hubVigilar(oid); }catch(e){ console.warn('vigilar descargas:',e); }
    }

    // DEPÓSITO — envío de correos
    // Compras: en "Solicitud de depósito enviada" puede mandar la solicitud + OC a contabilidad
    if(stage.key==='deposito' && step.name==='Solicitud de depósito enviada'){
      try{ html+=_solEnvioPanel(oid,'abono'); }catch(e){}
      // Solo compras y gerencia pueden enviar la solicitud
      if(CU && (CU.role==='compras'||CU.role==='gerencia')){
        try{ html+=_solPagoBotonAbono(oid); }catch(e){}
      } else if(CU && CU.role==='contabilidad'){
        html+='<div style="font-size:11px;color:var(--text-muted);background:var(--surface-1);border-radius:7px;padding:7px 10px;margin-bottom:8px">'
          +'<i class="ti ti-lock"></i> Este paso lo completa compras. Aquí solo puedes consultar los documentos.</div>';
      }
    }
    // Compras: pedir a contabilidad la cancelación del saldo final,
    // eligiendo el destinatario entre los usuarios de contabilidad
    // Pago final: mismo circuito que la solicitud de abono, por Azure
    if(stage.key==='deposito' && step.name==='Solicitud de final del balance'){
      try{ html+=_solEnvioPanel(oid,'cancelacion'); }catch(e){}
      if(CU && (CU.role==='compras'||CU.role==='gerencia')){
        try{ html+=_solPagoBotonCancelacion(oid); }catch(e){}
      }
    }
    // Contabilidad: en "Depósito enviado al proveedor" puede mandarlo por correo con copias
    if(stage.key==='deposito' && step.name==='Depósito enviado al proveedor'){
      // Lo que contabilidad ya envió, visible para todos
      try{ html+=_solEnvioPanel(oid,'comprobante_abono'); }catch(e){}
      if(CU && (CU.role==='contabilidad'||CU.role==='gerencia')){
        html+='<div style="background:var(--pastel-verde2);border:1px solid #A9DFD0;border-radius:9px;padding:10px 12px;margin-bottom:10px">'
          +'<div style="font-size:11.5px;font-weight:600;color:var(--t-verde2);margin-bottom:6px"><i class="ti ti-receipt"></i> Enviar el comprobante del depósito a compras</div>'
          +'<button class="btn bp" style="background:#085041;font-size:11px;padding:6px 12px" onclick="_compAbrirModal(\''+oid+'\',\'abono\')">'
          +'<i class="ti ti-send"></i> Redactar comprobante</button></div>';
      }
    }
    // Compras: reenvía al proveedor el comprobante que dejó contabilidad
    if(stage.key==='deposito' && (step.name===_PASO_COMP_PROV || step.name===_PASO_COMP_FINAL)){
      var _esComp=(step.name===_PASO_COMP_PROV);
      try{ html+=_solEnvioPanel(oid, 'proveedor_'+(_esComp?'abono':'cancelacion')); }catch(e){}
      if(CU && (CU.role==='compras'||CU.role==='gerencia')){
        html+='<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:10px 12px;margin-bottom:10px">'
          +'<div style="font-size:11.5px;font-weight:600;color:var(--t-azul);margin-bottom:6px"><i class="ti ti-send"></i> Enviar el comprobante al proveedor</div>'
          +'<button class="btn bp" style="font-size:11px;padding:6px 12px" onclick="_provAbrirModal(\''+oid+'\',\''+(_esComp?'abono':'cancelacion')+'\')">'
          +'<i class="ti ti-mail"></i> Redactar correo al proveedor</button></div>';
      } else if(CU && CU.role==='contabilidad'){
        html+='<div style="font-size:11px;color:var(--text-muted);background:var(--surface-1);border-radius:7px;padding:7px 10px;margin-bottom:8px">'
          +'<i class="ti ti-lock"></i> Este paso lo completa compras. Aquí solo puedes consultar.</div>';
      }
    }
    // Contabilidad: en "Solicitud de final del balance" envía el comprobante de la cancelación
    if(stage.key==='deposito' && step.name==='Solicitud de final del balance'){
      try{ html+=_solEnvioPanel(oid,'comprobante_cancelacion'); }catch(e){}
      if(CU && (CU.role==='contabilidad'||CU.role==='gerencia')){
        html+='<div style="background:var(--pastel-verde2);border:1px solid #A9DFD0;border-radius:9px;padding:10px 12px;margin-bottom:10px">'
          +'<div style="font-size:11.5px;font-weight:600;color:var(--t-verde2);margin-bottom:6px"><i class="ti ti-receipt"></i> Enviar el comprobante de la cancelación a compras</div>'
          +'<button class="btn bp" style="background:#085041;font-size:11px;padding:6px 12px" onclick="_compAbrirModal(\''+oid+'\',\'cancelacion\')">'
          +'<i class="ti ti-send"></i> Redactar comprobante</button></div>';
      }
    }

    if(stage.key==='artes' && step.name===_PASO_ARTES_PROV){
      try{ html+=_artesPanelProveedor(oid); }catch(e){ html+=_panelErrLog('Artes al proveedor', e); }
      html+=buildArtesEnvio(oid);
    }

    // Adjuntos de esta sub-etapa
    var _nBase=subAtts.filter(function(a){return a&&a._base;}).length;
    html+='<div style="font-size:10px;color:var(--text-muted);font-weight:500;margin-bottom:5px"><i class="ti ti-paperclip"></i> Archivos de este paso ('+subAtts.length+')'
      +(_nBase?(' <span style="color:var(--t-lila);font-weight:600">· '+_nBase+' de la orden</span>'):'')+'</div>';
    // Punto 1: el usuario de diseño NO puede eliminar archivos en el pedido ni en
    // "artes aprobados por gerencia" (solo ver y descargar). En sus propios pasos sí.
    var _bloqueDiseno = (CU&&CU.role==='diseno') && (stage.key==='pedido' || (stage.key==='artes' && step.name==='Artes aprobados por gerencia'));
    // En la etapa de Depósito cada rol solo trabaja SUS pasos; en los del otro
    // puede consultar los archivos y usar el chat, pero no modificar nada.
    var _pasosDeCompras = [_PASO_SOL_ABONO, _PASO_PAGO_FINAL, _PASO_COMP_PROV, _PASO_COMP_FINAL];
    var _pasosDeContab  = [_PASO_DEP_PROV];
    var _bloqueContab = (CU&&CU.role==='contabilidad') && stage.key==='deposito'
      && _pasosDeCompras.indexOf(step.name)>=0;
    var _bloqueCompras = (CU&&CU.role==='compras') && stage.key==='deposito'
      && _pasosDeContab.indexOf(step.name)>=0;
    // Diseño en la etapa de Pedido: solo consulta. Podía subir archivos aunque
    // no pudiera borrarlos, y esa etapa no la trabaja: solo mira, descarga y
    // escribe en el chat.
    var _soloConsulta = _bloqueContab || _bloqueCompras
      || ((CU&&CU.role==='diseno') && stage.key==='pedido');
    var _puedeEliminar = !_bloqueDiseno && !_soloConsulta;
    // Los documentos base de la orden se muestran aquí pero no se borran desde
    // el subpaso: pertenecen a la orden, no a este paso.
    var _esBase=function(a){ return !!(a&&a._base); };
    if(subAtts.length){
      html+='<div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:7px">';
      subAtts.forEach(function(a,ai){
        var ext=(String(a.name||'').split('.').pop()||'').toLowerCase();
        var extImg=['jpg','jpeg','png','gif','webp'];
        var _info=(a.by?('Subido por '+a.by):'')+(a.date?(a.by?' · ':'')+a.date:'');
        if(extImg.includes(ext)){
          html+='<div style="position:relative;display:inline-block;margin:2px">'
            +'<img src="'+a.data+'" data-src="'+a.data+'" data-ai="'+ai+'" data-oid="'+oid+'" data-sk="'+subKey+'" class="att-img" style="width:58px;height:58px;object-fit:cover;border-radius:5px;cursor:zoom-in;border:0.5px solid var(--border)" title="'+a.name+(_info?' — '+_info:'')+'">'
            +((_puedeEliminar&&!_esBase(a))?'<button data-ai="'+ai+'" data-oid="'+oid+'" data-sk="'+subKey+'" class="att-del" style="position:absolute;top:-5px;right:-5px;background:#e24b4a;color:white;border:none;border-radius:50%;width:17px;height:17px;font-size:10px;cursor:pointer;line-height:17px;padding:0;text-align:center">\xd7</button>':'')+'</div>';
        } else {
          var ic=ext==='pdf'?'📄':ext==='xlsx'||ext==='xls'?'📊':ext==='doc'||ext==='docx'?'📝':'📎';
          var abrir=a.data?(' onclick="verArchivo(\''+a.data+'\',\''+(a.name||'').replace(/'/g,"\\\\'")+'\')" '+_prevAttrs(a.data,a.name)):'';
          html+='<div style="display:inline-flex;align-items:center;gap:5px;padding:3px 8px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:var(--radius);font-size:11px;margin:2px;cursor:pointer" title="'+(_info||a.name)+'"'+abrir+'>'
            +ic+' <span style="max-width:80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+a.name+'</span>'
            +((_puedeEliminar&&!_esBase(a))?'<button data-ai="'+ai+'" data-oid="'+oid+'" data-sk="'+subKey+'" class="att-del" style="background:none;border:none;color:var(--text-danger);cursor:pointer;padding:0;font-size:13px;line-height:1">\xd7</button>':'')+'</div>';
        }
      });
      html+='</div>';
    }
    // Contabilidad no adjunta nada en los pasos que ejecuta compras: ahí solo consulta
    if(_soloConsulta){
      html+='<div style="display:flex;align-items:center;gap:7px;padding:6px 10px;background:var(--surface-1);border-radius:var(--radius);font-size:11px;color:var(--text-muted);margin-bottom:7px">'
        +'<i class="ti ti-lock"></i> Solo lectura: '
        +((CU&&CU.role==='diseno')
            ? 'la etapa de Pedido la trabaja compras'
            : ('este paso lo completa '+(_bloqueCompras?'contabilidad':'compras')))
        +'. Puedes abrir los archivos y escribir en el chat.</div>';
    }
    if(!_soloConsulta) html+='<label style="display:flex;align-items:center;gap:7px;padding:6px 10px;border:1.5px dashed var(--border);border-radius:var(--radius);cursor:pointer;font-size:11px;color:var(--text-secondary);margin-bottom:8px;background:var(--surface-1)"><i class="ti ti-upload" style="font-size:12px;color:var(--text-accent)"></i>Adjuntar a este paso<input type="file" multiple accept="image/*,.pdf,.xlsx,.xls,.doc,.docx" style="display:none" data-oid="'+oid+'" data-sk="'+subKey+'" class="att-input"></label>';
    // Live chat de sub-etapa
    var subComKey='sub_'+oid+'_'+subKey;
    // En el HUB de diseño la conversación es lo principal: se pone a la
    // izquierda y en grande, con los documentos al costado.
    var _dosCol=(stage.key==='artes' && step.name==='HUB de diseño');
    if(_dosCol){
      html+='</div>';   // cierra la columna de documentos
      html+='<div class="hub-col-chat">';
      html+='<div style="font-size:11.5px;color:var(--text-secondary);font-weight:700;margin-bottom:6px"><i class="ti ti-message"></i> Live chat de este paso</div>';
      html+='<div id="subcms-'+oid+'-'+idx+'-'+i+'" data-ck="'+subComKey+'" class="hub-chat-lista">'+renderSubComs(subComKey)+'</div>';
      try{ _chatAlAbrir(subComKey); }catch(e){}
      html+='<div id="submen-'+oid+'-'+idx+'-'+i+'" style="display:none;position:relative;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.18);max-height:200px;overflow-y:auto;z-index:60;margin-bottom:4px"></div>';
      html+='<div class="cir"><textarea class="cin" id="subcin-'+oid+'-'+idx+'-'+i+'" rows="2" placeholder="Escribe en el chat de este paso... usa @ para mencionar" oninput="_menRefrescar(\'subcin-'+oid+'-'+idx+'-'+i+'\',\'submen-'+oid+'-'+idx+'-'+i+'\')" onblur="setTimeout(function(){_menCerrar(\'submen-'+oid+'-'+idx+'-'+i+'\');},150)" style="font-size:12px"></textarea>'
        +'<button class="btn bp" onclick="addSubCom(\''+oid+'\','+idx+','+i+')" style="align-self:flex-end;padding:6px 10px"><i class="ti ti-send"></i></button></div>';
      html+='</div>';       // cierra la columna del chat
      html+='</div>';       // cierra el contenedor de dos columnas
      html+='</div></div>'; // cierra body + div ss (los DOS, como el flujo normal)
      return;
    }
    html+='<div style="font-size:10px;color:var(--text-muted);font-weight:500;margin-bottom:4px"><i class="ti ti-message"></i> Live chat de este paso</div>';
    html+='<div id="subcms-'+oid+'-'+idx+'-'+i+'" data-ck="'+subComKey+'" style="margin-bottom:6px">'+renderSubComs(subComKey)+'</div>';
    try{ _chatAlAbrir(subComKey); }catch(e){}
    html+='<div id="submen-'+oid+'-'+idx+'-'+i+'" style="display:none;position:relative;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.18);max-height:200px;overflow-y:auto;z-index:60;margin-bottom:4px"></div>';
    html+='<div class="cir"><textarea class="cin" id="subcin-'+oid+'-'+idx+'-'+i+'" rows="1" placeholder="Escribe en el chat de este paso... usa @ para mencionar" oninput="_menRefrescar(\'subcin-'+oid+'-'+idx+'-'+i+'\',\'submen-'+oid+'-'+idx+'-'+i+'\')" onblur="setTimeout(function(){_menCerrar(\'submen-'+oid+'-'+idx+'-'+i+'\');},150)" style="font-size:11px"></textarea>'
      +'<button class="btn bp" onclick="addSubCom(\''+oid+'\','+idx+','+i+')" style="align-self:flex-end;padding:5px 8px"><i class="ti ti-send"></i></button></div>';
    html+='</div></div>'; // cierra body + div ss
  });
  html+='</div>'; // cierra sub-steps

  // ── Adjuntos globales de la etapa (nivel etapa, no sub-paso) ──
  var attKey=oid+stage.key;
  var atts=window._atts&&window._atts[attKey]?window._atts[attKey]:[];
  html+='<div class="lbl2" style="margin-top:12px"><i class="ti ti-paperclip"></i>Documentos generales de la etapa <span style="font-weight:400;color:var(--text-muted)">('+atts.length+')</span></div>';
  // Punto 1: diseño no elimina docs generales en pedido ni artes aprobados
  var _bloqueDisGen = (CU&&CU.role==='diseno') && (stage.key==='pedido' || stage.key==='artes');
  var _puedeElimGen = !_bloqueDisGen;
  if(atts.length){
    html+='<div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:7px">';
    atts.forEach(function(a,ai){
      var ext=(String(a.name||'').split('.').pop()||'').toLowerCase();
      var extImg=['jpg','jpeg','png','gif','webp'];
      var _infoG=(a.by?('Subido por '+a.by):'')+(a.date?(a.by?' · ':'')+a.date:'');
      if(extImg.includes(ext)){
        html+='<div style="position:relative;display:inline-block;margin:2px">'
          +'<img src="'+a.data+'" data-src="'+a.data+'" data-ai="'+ai+'" data-oid="'+oid+'" data-sk="'+stage.key+'" class="att-img" style="width:58px;height:58px;object-fit:cover;border-radius:5px;cursor:zoom-in;border:0.5px solid var(--border)" title="'+a.name+(_infoG?' — '+_infoG:'')+'">'
          +(_puedeElimGen?'<button data-ai="'+ai+'" data-oid="'+oid+'" data-sk="'+stage.key+'" class="att-del" style="position:absolute;top:-5px;right:-5px;background:#e24b4a;color:white;border:none;border-radius:50%;width:17px;height:17px;font-size:10px;cursor:pointer;line-height:17px;padding:0;text-align:center">\xd7</button>':'')+'</div>';
      } else {
        var ic=ext==='pdf'?'📄':ext==='xlsx'||ext==='xls'?'📊':ext==='doc'||ext==='docx'?'📝':'📎';
        var abrir=a.data?(' onclick="verArchivo(\''+a.data+'\',\''+(a.name||'').replace(/'/g,"\\\\'")+'\')" '):'';
        html+='<div style="display:inline-flex;align-items:center;gap:5px;padding:3px 8px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:var(--radius);font-size:11px;margin:2px;cursor:pointer" title="'+(_infoG||a.name)+'"'+abrir+'>'
          +ic+' <span style="max-width:90px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+a.name+'</span>'
          +(_puedeElimGen?'<button data-ai="'+ai+'" data-oid="'+oid+'" data-sk="'+stage.key+'" class="att-del" style="background:none;border:none;color:var(--text-danger);cursor:pointer;padding:0;font-size:13px;line-height:1">\xd7</button>':'')+'</div>';
      }
    });
    html+='</div>';
  }
  // El adjunto general de la etapa no tenía ningún control: diseño podía
  // subir aquí aunque los pasos estuvieran en solo consulta.
  var _etapaSoloConsulta = (CU&&CU.role==='diseno') && stage.key==='pedido';
  if(!_etapaSoloConsulta)
  html+='<label style="display:flex;align-items:center;gap:7px;padding:7px 11px;border:1.5px dashed var(--border);border-radius:var(--radius);cursor:pointer;font-size:11px;color:var(--text-secondary);margin-bottom:8px;background:var(--surface-1)"><i class="ti ti-upload" style="font-size:13px;color:var(--text-accent)"></i>Adjuntar archivo general de etapa<input type="file" multiple accept="image/*,.pdf,.xlsx,.xls,.doc,.docx" style="display:none" data-oid="'+oid+'" data-sk="'+stage.key+'" class="att-input"></label>';

  if(stage.hasArte)html+=`<div class="arte-box">🎨<br><div style="font-size:12px;font-weight:500;margin-top:6px">${o.desc}</div><p>Vista previa simulada</p></div>`;
  // El resumen viejo "Costeo de mercancía" quedaba duplicado con los paneles
  // nuevos de la etapa, y sus tres líneas ya no coinciden con los subpasos.
  // if(stage.key==='costeo'&&CU.role!=='diseno'&&CU.role!=='bodega')html+=buildCosteoSection(oid);

  // ── Comentarios generales de la etapa ──
  const comments=sp2.comments||[];
  html+=`<div class="lbl2" style="margin-top:10px"><i class="ti ti-message"></i>Comentarios generales de la etapa ${_comBadgeNoLeido(oid,stage.key)}</div><div class="cms" id="cms-${oid}-${stage.key}">${_comRenderLista(oid,stage.key,comments)}</div><div class="cir"><textarea class="cin" id="cin-${oid}-${stage.key}" rows="2" placeholder="Escribe un comentario..."></textarea><button class="btn bp" onclick="addComS('${oid}','${stage.key}')" style="align-self:flex-end"><i class="ti ti-send"></i></button></div>`;
  if(isDone)html+=`<div style="margin-top:10px"><div class="aps"><i class="ti ti-circle-check"></i>Etapa completada · ${sp2.stepDates?.[sp2.stepDates.length-1]||''}</div></div>`;
  container.innerHTML=html;
  // Inicializar tracker de logística
  var trackerEl=container.querySelector('[id^="log-tracker-"]');
  if(trackerEl){
    var tOid=trackerEl.id.replace('log-tracker-','');
    trackerEl.innerHTML=buildLogTracker(tOid);
  }
}

// Toggle para mostrar/ocultar body de una sub-etapa
function toggleSubStep(oid,idx,i){
  var b=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
  var chev=document.getElementById('ssch-'+oid+'-'+idx+'-'+i);
  if(!b)return;
  var open=b.style.display!=='none';
  b.style.display=open?'none':'block';
  if(chev)chev.style.transform=open?'':'rotate(180deg)';
}

// Agregar comentario a una sub-etapa
// Documentos base de la orden: la orden de KCC y la PI del proveedor
// Nombre normalizado de un archivo, para reconocer el mismo documento aunque
// se haya subido varias veces con rutas distintas.
// Solo el nombre, normalizado. Sirve para reconocer el MISMO documento
// subido dos veces (dos rutas distintas, un solo archivo).
function _docNombreClave(a){
  if(!a) return '';
  var n=String(a.name||a.nombre_archivo||a.nombre||'').trim().toLowerCase();
  n=n.replace(/\s*\(\d+\)\s*(?=\.[a-z0-9]+$)/,'');   // "factura (1).pdf" = "factura.pdf"
  return n.replace(/[_\s-]+/g,' ');
}

function _docClave(a){
  if(!a) return '';
  // La ruta en el almacenamiento es única y manda sobre el nombre: dos
  // documentos DISTINTOS pueden llamarse igual (pasa siempre que compras
  // guarda la orden de Kennedy y la PI del proveedor como "Copia de
  // DKC-26109.xlsx"), y comparando por nombre se perdía uno de los dos.
  var u=String(a.url||a.path||'').trim().toLowerCase();
  if(u) return 'u:'+u;
  var n=String(a.name||a.nombre_archivo||'').trim().toLowerCase();
  // "DKC 26111 (1).pdf" y "DKC 26111.pdf" son el mismo documento
  n=n.replace(/\s*\(\d+\)\s*(?=\.[a-z0-9]+$)/,'');
  n=n.replace(/[_\s-]+/g,' ');
  return n;
}
// Quita repetidos por nombre. Se queda con el primero, que es el más antiguo
// y el que suele tener el id correcto en la base.
function _dedupDocs(lista){
  var out=[], vistos={};
  (lista||[]).forEach(function(a){
    var k=_docClave(a);
    if(!k){ out.push(a); return; }
    if(vistos[k]) return;
    vistos[k]=1; out.push(a);
  });
  return out;
}

function _docsBaseOrden(oid){
  var todos=[];
  [oid+'pedido', oid+'__pendsap'].forEach(function(k){
    ((window._atts&&window._atts[k])||[]).forEach(function(a){ todos.push(a); });
  });
  return _dedupDocs(todos);
}
// Adjuntos que se ven en un subpaso: los suyos más los documentos base
function _attsDelSubpaso(oid, stageKey, i, subKey){
  var propios=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];

  // El comprobante que contabilidad deja en "Depósito enviado al proveedor"
  // es EL MISMO que compras reenvía en el paso siguiente. Aparece solo, para
  // no tener que subirlo dos veces ni ir a buscarlo al paso anterior.
  // Lo mismo con el pago final y su comprobante.
  if(stageKey==='deposito' && (i===2 || i===4)){
    var previos=(window._atts&&window._atts[oid+'deposito_step'+(i-1)])||[];
    if(previos.length){
      // Se compara por NOMBRE, no por ruta. Es el mismo comprobante: si
      // compras ya lo había subido a mano en este paso, son dos copias con
      // rutas distintas y por ruta no se reconocían como el mismo archivo,
      // así que salía duplicado.
      var res=_dedupDocs(propios), yaEstan={};
      res.forEach(function(a){ yaEstan[_docNombreClave(a)]=1; });
      previos.forEach(function(a){
        var k=_docNombreClave(a);
        if(k && !yaEstan[k]){ yaEstan[k]=1; res.push(Object.assign({}, a, {_delPasoAnterior:true})); }
      });
      propios=res;
    }
  }

  if(stageKey!=='pedido' && stageKey!=='deposito') return propios;
  var base=_docsBaseOrden(oid);
  if(!base.length) return propios;
  var out=_dedupDocs(propios), vistos={};
  out.forEach(function(a){ vistos[_docClave(a)]=1; });
  base.forEach(function(a){
    var k=_docClave(a);
    if(k && !vistos[k]){ vistos[k]=1; out.push(Object.assign({}, a, {_base:true})); }
  });
  return out;
}

if(!window._subComs)window._subComs={};
function addSubCom(oid,idx,i){
  var stage=STAGES[idx];if(!stage)return;
  var subKey=stage.key+'_step'+i;
  var comKey='sub_'+oid+'_'+subKey;
  var inp=document.getElementById('subcin-'+oid+'-'+idx+'-'+i);
  var txt=inp?inp.value.trim():'';
  if(!txt)return;
  if(!window._subComs[comKey])window._subComs[comKey]=[];
  window._subComs[comKey].push({autor:CU.name+' ('+CU.role+')',ini:CU.ini,texto:txt,time:now2(),role:CU.role,by:CU.name});
  guardarComentario(oid, subKey, txt);
  // A quién avisar: los mencionados con @ y, además, quien participó antes en
  // este hilo. Si Lorena etiquetó a Franco y Franco responde, Lorena tiene que
  // enterarse aunque él no la haya etiquetado.
  try{
    var avisar=_menExtraer(txt);
    var yaEsta={};
    avisar.forEach(function(u){ yaEsta[u.id]=1; });
    _menDelHilo(comKey).forEach(function(u){
      if(!yaEsta[u.id] && (!CU || u.id!==CU.id)){ yaEsta[u.id]=1; avisar.push(u); }
    });
    if(avisar.length) _menNotificar(avisar, {
      docnum:oid, contexto:'etapa', etapa:stage.label, texto:txt,
      etiqueta:stage.label+' · '+(stage.steps[i]?stage.steps[i].name:'')
    });
  }catch(e){ console.warn('menciones:',e); }
  // Quien escribe ya leyó todo lo anterior
  try{ _chatMarcarLeido(comKey); }catch(e){}
  // Punto 5: si comenta gerencia, avisar al responsable de la etapa
  if(CU.role==='gerencia') _notificarComentarioEtapa(oid, stage);
  if(inp)inp.value='';
  // Actualizar SOLO la lista de comentarios (no reconstruir la etapa = no cierra el paso)
  var lista=document.getElementById('subcms-'+oid+'-'+idx+'-'+i);
  if(lista) lista.innerHTML=renderSubComs(comKey);
  if(inp) inp.focus();
}
// Render de los comentarios de una sub-etapa (con botones editar/borrar del propio autor)
function renderSubComs(comKey){
  var coms=window._subComs&&window._subComs[comKey]?window._subComs[comKey]:[];
  if(!coms.length) return '';
  return coms.map(function(cm,ci){
    var mio=(cm.by===(CU?CU.name:''))||(cm.autor&&cm.autor.indexOf(CU?CU.name:'###')===0);
    var acciones=mio?('<div style="display:flex;gap:6px;margin-top:3px">'
      +'<span onclick="editSubCom(\''+comKey+'\','+ci+')" style="font-size:9px;color:var(--text-accent);cursor:pointer"><i class="ti ti-pencil" style="font-size:9px"></i> Editar</span>'
      +'<span onclick="delSubCom(\''+comKey+'\','+ci+')" style="font-size:9px;color:var(--text-danger);cursor:pointer"><i class="ti ti-trash" style="font-size:9px"></i> Borrar</span></div>'):'';
    return '<div class="ci"><div class="cav2">'+cm.ini+'</div><div class="cbub"><div class="cau">'+cm.autor+'</div><div class="ctx2" id="subctx-'+comKey+'-'+ci+'">'+_menResaltar((cm.texto||'').replace(/</g,'&lt;'))+'</div><div class="ctm">'+(cm.time||'')+(mio?_chatLeidoPor(comKey,ci):'')+'</div>'+acciones+'</div></div>';
  }).join('');
}
// Repinta SOLO el contenedor de este hilo. Antes se repintaban todos los
// contenedores con el mismo contenido, y los comentarios de un paso aparecían
// repetidos en los demás.
// Quiénes vienen conversando en este hilo: autores y mencionados
function _menDelHilo(comKey){
  var coms=(window._subComs&&window._subComs[comKey])?window._subComs[comKey]:[];
  var out=[], vistos={};
  coms.forEach(function(c){
    var u=(USERS||[]).find(function(x){ return String(x.name||'')===String(c.by||c.autor||'').replace(/\s*\([^)]*\)\s*$/,''); });
    if(u && !vistos[u.id]){ vistos[u.id]=1; out.push(u); }
    _menExtraer(c.texto||'').forEach(function(m){
      if(!vistos[m.id]){ vistos[m.id]=1; out.push(m); }
    });
  });
  return out;
}

// ── Leído de cada hilo de chat ──
// Se guarda quién leyó hasta cuántos mensajes, con la fecha.
function _chatLeidoKey(comKey){ return 'chatleido_'+comKey; }
function _chatLeidoGet(comKey){
  if(window._chatLeido && window._chatLeido[comKey]) return window._chatLeido[comKey];
  try{
    var v=localStorage.getItem(_chatLeidoKey(comKey));
    if(v) return JSON.parse(v);
  }catch(e){}
  return {};
}
async function _chatMarcarLeido(comKey){
  if(!CU) return;
  var coms=(window._subComs&&window._subComs[comKey])?window._subComs[comKey]:[];
  var m=_chatLeidoGet(comKey);
  if(Number((m[CU.id]||{}).n||0)>=coms.length) return;
  m[CU.id]={n:coms.length, nombre:CU.name, en:new Date().toISOString()};
  window._chatLeido=window._chatLeido||{};
  window._chatLeido[comKey]=m;
  try{ localStorage.setItem(_chatLeidoKey(comKey), JSON.stringify(m)); }catch(e){}
  // Y en la base, para que lo vean los demás. Si la tabla todavía no está
  // lista, el portal sigue funcionando con el registro local.
  if(window._chatLeidosOff) return;
  try{
    var r=await fetch(SB+'/rest/v1/chat_leidos?on_conflict=com_key,usuario_id',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify({com_key:comKey, usuario_id:CU.id, usuario_nombre:CU.name,
                           leidos:coms.length, leido_en:new Date().toISOString()})});
    if(!r.ok){
      var t=await r.text();
      console.warn('[chat_leidos]', r.status, t);
      // Falta la tabla o el índice: se avisa una vez y se sigue en local
      if(/does not exist|Could not find|no unique|constraint matching/i.test(t)){
        window._chatLeidosOff=true;
        showT('El "leído" queda solo en este equipo: falta preparar la tabla chat_leidos (script chat_leidos.sql).');
      }
    }
  }catch(e){ console.warn('chat_leidos:',e); }
}
async function _chatLeidosCargar(comKey){
  if(window._chatLeidosOff) return;
  try{
    var r=await fetch(SB+'/rest/v1/chat_leidos?select=*&com_key=eq.'+encodeURIComponent(comKey)+'&limit=40',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      if(/does not exist|Could not find/i.test(t)) window._chatLeidosOff=true;
      return;
    }
    var rows=await r.json()||[];
    var m=_chatLeidoGet(comKey);
    rows.forEach(function(x){
      m[x.usuario_id]={n:x.leidos||0, nombre:x.usuario_nombre||x.usuario_id, en:x.leido_en};
    });
    window._chatLeido=window._chatLeido||{};
    window._chatLeido[comKey]=m;
  }catch(e){}
}

// Quién leyó hasta este mensaje
function _chatLeidoPor(comKey, ci){
  var m=_chatLeidoGet(comKey);
  var yo=(CU&&CU.id)||'';
  var out=[];
  Object.keys(m).forEach(function(uid){
    if(uid===yo) return;
    var d=m[uid]||{};
    if(Number(d.n||0) >= (ci+1)) out.push(d);
  });
  if(!out.length) return '';
  return '<span class="chat-leido" title="'+_esc(out.map(function(d){
      return d.nombre+' · '+_fechaHora(d.en); }).join('\n'))+'">'
    +'<i class="ti ti-checks"></i> Leído por '+_esc(out.map(function(d){return d.nombre;}).join(', '))
    +' · '+_esc(_fechaHora(out[0].en))+'</span>';
}

// Al abrir un paso: se marca lo leído y se traen los leídos de los demás
function _chatAlAbrir(comKey){
  var coms=(window._subComs&&window._subComs[comKey])?window._subComs[comKey]:[];
  if(!coms.length) return;
  _chatLeidosCargar(comKey).then(function(){ _subComRepintar(comKey); });
  setTimeout(function(){ _chatMarcarLeido(comKey); }, 1200);
}

function _subComRepintar(comKey){
  var cont=document.getElementById('subcms-'+comKey);
  if(cont){ cont.innerHTML=renderSubComs(comKey); return; }
  // La clave del contenedor puede diferir: se busca el que ya muestre este hilo
  document.querySelectorAll('[id^="subcms-"]').forEach(function(el){
    if(el.getAttribute('data-ck')===comKey) el.innerHTML=renderSubComs(comKey);
  });
}

async function delSubCom(comKey,ci){
  if(!window._subComs||!window._subComs[comKey]||!window._subComs[comKey][ci])return;
  var c=window._subComs[comKey][ci];
  if(!confirm('¿Está seguro de que desea borrar este comentario?\n\n"'+String(c.texto||'').slice(0,120)+'"\n\nEsta acción no se puede deshacer.')) return;
  // Se borra también de la base: antes solo se quitaba de la pantalla y
  // volvía a aparecer en cuanto se recargaba.
  var ok=true;
  if(c.id){
    try{
      var r=await fetch(SB+'/rest/v1/compras_comentarios?id=eq.'+c.id,{method:'DELETE',headers:SBH});
      ok=r.ok;
    }catch(e){ ok=false; }
  } else {
    // Sin id (recién escrito): se borra por su contenido
    try{
      var q=SB+'/rest/v1/compras_comentarios?texto=eq.'+encodeURIComponent(c.texto||'')
        +'&autor=eq.'+encodeURIComponent(c.by||'');
      var r2=await fetch(q,{method:'DELETE',headers:SBH});
      ok=r2.ok;
    }catch(e){ ok=false; }
  }
  window._subComs[comKey].splice(ci,1);
  _subComRepintar(comKey);
  showT(ok?'Comentario borrado':'⚠ Se quitó de la pantalla, pero no se pudo borrar de la base');
}

async function editSubCom(comKey,ci){
  if(!window._subComs||!window._subComs[comKey]||!window._subComs[comKey][ci])return;
  var c=window._subComs[comKey][ci];
  var actual=c.texto||'';
  var nuevo=prompt('Editar comentario:', actual);
  if(nuevo===null)return;
  nuevo=String(nuevo).trim();
  if(!nuevo){ showT('El comentario no puede quedar vacío'); return; }
  if(nuevo===actual) return;
  c.texto=nuevo;
  c.time=now2()+' (editado)';
  _subComRepintar(comKey);
  var ok=false;
  if(c.id){
    try{
      var r=await fetch(SB+'/rest/v1/compras_comentarios?id=eq.'+c.id,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({texto:nuevo})});
      ok=r.ok;
    }catch(e){}
  }
  showT(ok?'Comentario editado':'⚠ Se cambió en la pantalla, pero no se pudo guardar');
}
// Punto 5: notificar comentario de gerencia al responsable de la etapa
async function guardarComPend(oid, stageKey, rolDestino){
  try{
    await fetch(SB+'/rest/v1/compras_com_pend?on_conflict=docnum,stage,rol', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), stage:String(stageKey), rol:String(rolDestino), leido:false, actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarComPend:', e); }
}
async function cargarComPend(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_com_pend?select=*&leido=eq.false', {headers:SBH});
    var rows=await r.json();
    if(!window._comPend) window._comPend={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      window._comPend[String(row.docnum)+'_'+String(row.stage)+'_'+String(row.rol)]={ role:row.rol, oid:row.docnum, stage:row.stage, read:false };
    });
  }catch(e){ console.error('cargarComPend:', e); }
}
// Marca como leído el comentario pendiente de una etapa para el usuario actual
async function marcarComLeido(oid, stageKey){
  var rol=(CU&&CU.role)||'';
  var key=oid+'_'+stageKey+'_'+rol;
  if(window._comPend && window._comPend[key]) delete window._comPend[key];
  // Compatibilidad con la clave vieja de 2 partes
  if(window._comPend && window._comPend[oid+'_'+stageKey]) delete window._comPend[oid+'_'+stageKey];
  try{
    await fetch(SB+'/rest/v1/compras_com_pend?docnum=eq.'+encodeURIComponent(oid)+'&stage=eq.'+encodeURIComponent(stageKey)+'&rol=eq.'+encodeURIComponent(rol), {
      method:'PATCH', headers: Object.assign({}, SBH, {'Prefer':'return=minimal'}),
      body: JSON.stringify({ leido:true })
    });
  }catch(e){}
}
// ¿El usuario actual tiene comentarios de gerencia pendientes en esta orden?
function tieneComPendiente(oid){
  if(!window._comPend||!CU) return false;
  for(var k in window._comPend){
    var c=window._comPend[k];
    if(c && c.oid===oid && c.role===CU.role && !c.read) return true;
  }
  return false;
}
// ═══════════════════════════════════════════════════════════════════════════
//  ESTADO DE LECTURA DE COMENTARIOS (tipo WhatsApp)
//  Cuando alguien escribe en una etapa, queda "no leído" para todos los roles
//  que participan en esa etapa (menos quien escribió). El indicador desaparece
//  cuando el destinatario abre la etapa.
//  · ✓  = enviado, todavía nadie lo abrió
//  · ✓✓ = ya lo leyeron todos los destinatarios
// ═══════════════════════════════════════════════════════════════════════════
function _comRolesEtapa(stage){
  var roles=[];
  if(stage && stage.alertRole) roles.push(stage.alertRole);
  ((stage&&stage.steps)||[]).forEach(function(s){ if(s&&s.role) roles.push(s.role); });
  roles.push('gerencia');
  var out=[];
  roles.forEach(function(r){ if(r && out.indexOf(r)<0) out.push(r); });
  return out;
}
// Destinatarios de un comentario: todos los de la etapa menos quien escribe
function _comDestinos(stage){
  var mio=(CU&&CU.role)||'';
  return _comRolesEtapa(stage).filter(function(r){ return r!==mio; });
}
// ¿Esta etapa tiene comentarios sin leer PARA MÍ?
function _comNoLeidoEtapa(oid, stageKey){
  if(!window._comPend||!CU) return false;
  for(var k in window._comPend){
    var c=window._comPend[k];
    if(c && String(c.oid)===String(oid) && String(c.stage)===String(stageKey)
       && c.role===CU.role && !c.read) return true;
  }
  return false;
}
// ¿Ya leyeron TODOS los destinatarios lo que escribe en esta etapa?
function _comLeidoPorTodos(oid, stageKey){
  if(!window._comPend||!CU) return true;
  for(var k in window._comPend){
    var c=window._comPend[k];
    if(c && String(c.oid)===String(oid) && String(c.stage)===String(stageKey)
       && c.role!==CU.role && !c.read) return false;
  }
  return true;
}
// Palomitas de estado para un comentario propio
function _comChecks(oid, stageKey){
  var leido=_comLeidoPorTodos(oid, stageKey);
  return '<span class="com-chk'+(leido?' leido':'')+'" title="'+(leido?'Leído':'Enviado, sin leer')+'">'
       + '<i class="ti '+(leido?'ti-checks':'ti-check')+'"></i></span>';
}
// Badge de "sin leer" para la cabecera de la etapa
function _comBadgeNoLeido(oid, stageKey){
  if(!_comNoLeidoEtapa(oid, stageKey)) return '';
  return '<span class="com-nuevo" title="Tienes comentarios sin leer"><i class="ti ti-message-circle"></i> nuevo</span>';
}

// Repinta los avisos "nuevo" de todas las etapas de una orden abierta
function _comPintarBadgesEtapas(oid){
  try{
    STAGES.forEach(function(st, idx){
      var el=document.getElementById('egnl-'+oid+'-'+idx);
      if(el) el.innerHTML=_comBadgeNoLeido(oid, st.key);
    });
  }catch(e){}
}

function _notificarComentarioEtapa(oid, stage){
  if(!stage) return;
  var destinos=_comDestinos(stage);
  if(!window._comPend) window._comPend={};
  var quien=(CU?CU.name:'');
  destinos.forEach(function(rol){
    window._comPend[oid+'_'+stage.key+'_'+rol]={
      role:rol, oid:oid, stage:stage.key, stageLabel:stage.label,
      by:quien, time:now2(), read:false
    };
    addNotif(rol, '💬 '+quien+' comentó en "'+stage.label+'" — '+oid, oid, 'ti-message');
    guardarComPend(oid, stage.key, rol);
  });
}

// Actualizar botón de tracking



function undoSS(oid,stageKey,stepIdx){initP(oid);const sp2=stageProgress[oid];if(sp2[stageKey].stepIdx>stepIdx){sp2[stageKey].stepIdx=stepIdx;sp2[stageKey].stepDates[stepIdx]='';if(sp2[stageKey]._isoPasos)sp2[stageKey]._isoPasos[stepIdx]='';showT('↩ Paso revertido');guardarEtapa(oid,stageKey);const stage=STAGES.find(s=>s.key===stageKey);const stageidx=STAGES.indexOf(stage);const body=document.getElementById(`egb-${oid}-${stageidx}`);if(body){buildEGB(oid,stageidx,body);_reabrirSub(oid,stageidx,stepIdx);}}}
function advSS(oid,stageKey,stepIdx){initP(oid);const sp2=stageProgress[oid];const stage=STAGES.find(s=>s.key===stageKey);if(!stage)return;sp2[stageKey].stepIdx=stepIdx+1;if(!sp2[stageKey].stepDates)sp2[stageKey].stepDates=Array(stage.steps.length).fill('');sp2[stageKey].stepDates[stepIdx]=now2();if(!sp2[stageKey].stepBy)sp2[stageKey].stepBy=Array(stage.steps.length).fill('');sp2[stageKey].stepBy[stepIdx]=(CU?CU.name:'');if(!sp2[stageKey].startDate)sp2[stageKey].startDate=now2();
  // Registrar fechas en ISO para guardar en Supabase
  var hoyIso=new Date().toISOString().slice(0,10);
  if(!sp2[stageKey]._isoPasos)sp2[stageKey]._isoPasos=Array(stage.steps.length).fill('');
  sp2[stageKey]._isoPasos[stepIdx]=hoyIso;
  if(!sp2[stageKey]._isoInicio)sp2[stageKey]._isoInicio=hoyIso;
  const o=orders.find(x=>x.id===oid);const isDoneNow=sp2[stageKey].stepIdx>=stage.steps.length;if(isDoneNow){const idx=STAGES.indexOf(stage);showT(`✓ "${stage.label}" completado`);if(idx+1<STAGES.length){sp2[STAGES[idx+1].key].startDate=dateOnly();sp2[STAGES[idx+1].key]._isoInicio=hoyIso;addNotif(STAGES[idx+1].alertRole,`${oid} — "${stage.label}" completado.`,oid,'ti-bell');}else{if(o)o.completada=true;}}else{showT('Sub-paso marcado ✓');}
  guardarEtapa(oid,stageKey);
  // Aviso a la gerencia del departamento: alguien completó un paso y hay que
  // revisarlo. Antes ningún paso avisaba y la gerencia no se enteraba.
  try{ _avisarGerenciaPaso(oid, stage, stepIdx); }catch(e){ console.warn('aviso gerencia:',e); }
  // Cuando contabilidad paga, el solicitante tiene que enterarse: antes no
  // recibía nada hasta que le mandaban el comprobante.
  try{ _avisarPagoHecho(oid, stage, stepIdx); }catch(e){ console.warn('aviso de pago:',e); }
  const body=document.getElementById(`egb-${oid}-${STAGES.indexOf(stage)}`);if(body){buildEGB(oid,STAGES.indexOf(stage),body);_reabrirSub(oid,STAGES.indexOf(stage),stepIdx);}renderNP();_actualizarContadores();}
// Reabre una sub-etapa tras reconstruir la etapa (para no cerrar el proceso)
// Avisa a la gerencia del departamento cuando se completa un paso.
// La alerta lleva directo a ese paso para que pueda revisarlo.
// Avisa a quien pidió el pago cuando contabilidad lo ejecuta
async function _avisarPagoHecho(oid, stage, stepIdx){
  if(!stage || stage.key!=='deposito') return;
  var paso=(stage.steps[stepIdx]||{}).name||'';
  var esDeposito=(paso===_PASO_DEP_PROV);
  var esFinal=(paso===_PASO_PAGO_FINAL);
  if(!esDeposito && !esFinal) return;

  // La solicitud correspondiente, para saber a quién avisar
  var tipo=esDeposito?'abono':'cancelacion';
  var sols=(window._solPago||[]).filter(function(x){
    return String(x.docnum)===String(oid) && String(x.tipo||'')===tipo;
  });

  var destinos=[];
  sols.forEach(function(x){
    _avSolicitante(x).forEach(function(u){
      if(!destinos.some(function(z){ return z.id===u.id; })) destinos.push(u);
    });
  });
  // Si no hay solicitud registrada, se avisa a las compradoras del departamento
  if(!destinos.length){
    var d=_solPagoDatosOrden(oid);
    destinos=_avUsuariosPorRol('compras', d.dept);
  }
  destinos=destinos.filter(function(u){ return u.id!==((CU&&CU.id)||''); });
  if(!destinos.length) return;

  var dat=_solPagoDatosOrden(oid);
  var monto=sols.length?sols[0].monto:null;
  await _menNotificar(destinos, {
    docnum:oid, contexto:'etapa', etapa:'Depósito & Pago', paso:paso,
    texto:(esDeposito?'Contabilidad envió el depósito al proveedor'
                     :'Contabilidad realizó el pago final')
      +(dat.proveedor?(' · '+dat.proveedor):'')
      +(monto?(' · '+fmt(monto)):''),
    etiqueta:(esDeposito?'Depósito pagado':'Pago final realizado')
  });
}

async function _avisarGerenciaPaso(oid, stage, stepIdx){
  if(!CU || CU.role==='gerencia') return;      // gerencia no se avisa a sí misma
  var paso=stage.steps[stepIdx];
  if(!paso) return;

  // El departamento de la orden
  var dept='';
  var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
  if(o) dept=o.dept||'';
  if(!dept){
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p) dept=p.dept||'';
  }

  // Gerencia del departamento; si no hay, toda la gerencia
  var gers=(USERS||[]).filter(function(u){ return u.role==='gerencia'; });
  var delDept=gers.filter(function(u){ return dept && String(u.dept||'')===String(dept); });
  var destinos=delDept.length?delDept:gers;
  if(!destinos.length) return;

  var completa=(stageProgress[oid] && stageProgress[oid][stage.key]
                && stageProgress[oid][stage.key].stepIdx>=stage.steps.length);
  var texto=(completa?'Etapa completada: ':'Paso completado: ')+paso.name
    +' — por '+((CU&&CU.name)||'');

  await _menNotificar(destinos, {
    docnum:oid, contexto:'etapa', etapa:stage.label, texto:texto,
    etiqueta:stage.label+' \u00b7 '+paso.name,
    paso:paso.name
  });
}

function _reabrirSub(oid,stageidx,subIdx){
  setTimeout(function(){
    var sb=document.getElementById('ssb-'+oid+'-'+stageidx+'-'+subIdx);
    var chev=document.getElementById('ssch-'+oid+'-'+stageidx+'-'+subIdx);
    if(sb){ sb.style.display='block'; if(chev)chev.style.transform='rotate(180deg)'; }
  },0);
}
// Actualiza solo los contadores de fondo (alertas) sin cerrar el modal
function _actualizarContadores(){
  try{ var ac=document.getElementById('ac'); if(ac)ac.textContent=vO().filter(function(o){return o.alerta;}).length; }catch(e){}
}
function buildCosteoSection(oid){const o=orders.find(x=>x.id===oid);if(!o)return'';if(!costeoData[oid])costeoData[oid]={status:'pending',items:[],uploadedBy:'',pricedBy:''};const cd=costeoData[oid];let html=`<div style="background:var(--pastel-naranja);border:0.5px solid #f5c9a0;border-radius:var(--radius);padding:12px 14px;margin:10px 0"><div style="font-size:13px;font-weight:500;color:var(--t-marron);margin-bottom:8px"><i class="ti ti-table"></i> Costeo de mercancía</div>${[{s:'pending',l:'Importación sube Excel',done:cd.status!=='pending'},{s:'uploaded',l:'Gerencia asigna precios',done:['pricing','done'].includes(cd.status)},{s:'pricing',l:'Importación sube al SAP',done:cd.status==='done'}].map(st=>`<div style="display:flex;align-items:center;gap:8px;font-size:12px;margin-bottom:5px"><span class="sem ${st.done?'sem-g':cd.status===st.s?'sem-y':'sem-r'}" style="width:10px;height:10px"></span><span>${st.l}</span></div>`).join('')}</div>`;if(cd.status==='pending'&&CU.role==='importacion')html+=`<div class="uz" onclick="subirCosteo('${oid}')"><i class="ti ti-table" style="font-size:20px;display:block;margin-bottom:4px;color:#1D6F42"></i><div style="font-weight:500;color:#1D6F42">Subir Excel de costeo</div></div>`;if(['uploaded','pricing','done'].includes(cd.status)){const canEdit=cd.status==='uploaded'&&CU.role==='gerencia';const tC=cd.items.reduce((s,i)=>s+(i.costo*i.unidades),0),tV=cd.items.reduce((s,i)=>s+(i.precioVenta*i.unidades),0);html+=`<div class="excel-viewer"><div class="excel-hdr"><i class="ti ti-table" style="font-size:14px;color:white"></i><span>Costeo-${oid}.xlsx</span></div><div style="overflow-x:auto"><table class="excel-table"><thead><tr><th>SKU</th><th>Desc.</th><th>Und.</th><th>Costo</th><th>Tot. costo</th><th style="background:#1a5c38;color:white">P. venta</th><th>Tot. venta</th></tr></thead><tbody>${cd.items.map((item,i2)=>`<tr><td style="font-family:monospace;font-size:10px">${item.sku}</td><td>${item.desc}</td><td style="text-align:right">${item.unidades}</td><td style="text-align:right">$${item.costo}</td><td style="text-align:right">$${(item.costo*item.unidades).toLocaleString()}</td><td style="background:${canEdit?'#f0fff4':'var(--surface-1)'};text-align:center">${canEdit?`<input class="excel-input" type="number" id="pv-${oid}-${i2}" value="${item.precioVenta||''}" placeholder="0">`:`<span>${item.precioVenta>0?'$'+item.precioVenta:'—'}</span>`}</td><td style="text-align:right">${item.precioVenta>0?'$'+(item.precioVenta*item.unidades).toLocaleString():'—'}</td></tr>`).join('')}<tr class="etotal"><td colspan="4"><strong>Total</strong></td><td style="text-align:right"><strong>$${tC.toLocaleString()}</strong></td><td style="text-align:center"><strong>${tV>0?'$'+tV.toLocaleString():'Pendiente'}</strong></td><td style="text-align:right"><strong>${tV>0?'$'+tV.toLocaleString():'—'}</strong></td></tr></tbody></table></div></div>`;if(canEdit)html+=`<div class="br"><button class="btn" style="background:#1D6F42;color:white" onclick="guardarPrecios('${oid}')"><i class="ti ti-check"></i>Guardar precios</button></div>`;if(cd.status==='pricing'&&CU.role==='importacion')html+=`<div class="br" style="margin-top:8px"><button class="btn bsap" onclick="subirSAP('${oid}')"><i class="ti ti-upload"></i>Subir al SAP</button></div>`;if(cd.status==='done')html+=`<div style="background:#EAF3DE;border-radius:var(--radius);padding:10px 12px;margin-top:10px;font-size:12px;color:var(--t-oliva)">✓ Subido al SAP por ${cd.pricedBy}</div>`;}return html;}
function subirCosteo(oid){const o=orders.find(x=>x.id===oid);if(!o)return;const cd=costeoData[oid];cd.status='uploaded';cd.uploadedBy=CU.name;cd.items=[{sku:'ITEM-001',desc:o.desc+' — A',costo:180,precioVenta:0,unidades:Math.ceil((o.uni||150)/2)},{sku:'ITEM-002',desc:o.desc+' — B',costo:195,precioVenta:0,unidades:(o.uni||150)-Math.ceil((o.uni||150)/2)}];initP(oid);stageProgress[oid].costeo.stepIdx=1;stageProgress[oid].costeo.stepDates[0]=dateOnly();addNotif('gerencia',`${oid} — Costeo listo. Asignar precios.`,oid,'ti-table');showT('✓ Costeo subido.');const b=document.getElementById(`egb-${oid}-5`);if(b&&b.classList.contains('open'))buildEGB(oid,5,b);renderNP();}
function guardarPrecios(oid){const cd=costeoData[oid];let all=true;cd.items.forEach((item,i2)=>{const inp=document.getElementById(`pv-${oid}-${i2}`);const val=inp?parseFloat(inp.value):0;if(!val||val<=0)all=false;else item.precioVenta=val;});if(!all){showT('Ingresa todos los precios');return;}cd.status='pricing';cd.pricedBy=CU.name;initP(oid);stageProgress[oid].costeo.stepIdx=2;stageProgress[oid].costeo.stepDates[1]=dateOnly();addNotif('importacion',`${oid} — Precios asignados.`,oid,'ti-circle-check');showT('✓ Precios guardados.');const b=document.getElementById(`egb-${oid}-5`);if(b&&b.classList.contains('open'))buildEGB(oid,5,b);renderNP();}
function subirSAP(oid){const cd=costeoData[oid];cd.status='done';cd.pricedBy=CU.name;initP(oid);stageProgress[oid].costeo.stepIdx=4;stageProgress[oid].costeo.stepDates[2]=dateOnly();stageProgress[oid].costeo.stepDates[3]=dateOnly();addNotif('gerencia',`${oid} — Costeo subido al SAP.`,oid,'ti-circle-check');showT('✅ Costeo subido.');setTimeout(()=>{advSS(oid,'costeo',3);},800);}
// Dibuja la lista de comentarios de una etapa, con palomitas en los propios
function _comRenderLista(oid, stageKey, comments){
  comments=comments||[];
  if(!comments.length) return '<div style="font-size:12px;color:var(--text-muted);margin-bottom:6px">Sin comentarios.</div>';
  var mio=(CU&&CU.name)||'\u0000';
  return comments.map(function(cm){
    var esMio=String(cm.autor||'').indexOf(mio)===0;
    return '<div class="ci"><div class="cav2">'+(cm.ini||'')+'</div>'
      +'<div class="cbub'+(esMio?' cbub-mio':'')+'">'
      +'<div class="cau">'+(cm.autor||'')+'</div>'
      +'<div class="ctx2">'+String(cm.texto||'').replace(/</g,'&lt;')+'</div>'
      +'<div class="ctm">'+(cm.time||'')+(esMio?(' '+_comChecks(oid, stageKey)):'')+'</div>'
      +'</div></div>';
  }).join('');
}
function _comRepintar(oid, stageKey){
  var c=document.getElementById('cms-'+oid+'-'+stageKey);
  if(c) c.innerHTML=_comRenderLista(oid, stageKey, (stageProgress[oid]&&stageProgress[oid][stageKey]&&stageProgress[oid][stageKey].comments)||[]);
}
function addComS(oid,stageKey){
  initP(oid);
  const inp=document.getElementById(`cin-${oid}-${stageKey}`);
  const txt=inp?.value.trim();
  if(!txt)return;
  if(!stageProgress[oid][stageKey].comments)stageProgress[oid][stageKey].comments=[];
  stageProgress[oid][stageKey].comments.push({autor:`${CU.name} (${CU.role})`,ini:CU.ini,texto:txt,time:now2()});
  guardarComentario(oid,stageKey,txt);
  // Antes solo avisaba si escribea gerencia. Ahora cualquier comentario queda
  // como "no leído" para los demás participantes de la etapa.
  const _st=STAGES.find(s=>s.key===stageKey);
  if(_st)_notificarComentarioEtapa(oid,_st);
  inp.value='';
  _comRepintar(oid, stageKey);
  var _box=document.getElementById('cms-'+oid+'-'+stageKey);
  if(_box) _box.scrollTop=_box.scrollHeight;
  renderNP();
  _comIniciarPoll();
  setTimeout(function(){ _comRefrescar(oid, stageKey); }, 1800);
  if(inp)inp.focus();
}
// ── SISTEMA MULTI-CONTENEDOR ──
if(!window._bookingData)window._bookingData={};

// Estructura: _bookingData[oid] = { naviera:'MAERSK', booking:'MAEU123', containers:[{id:'MSCU001',etaSalida:'2024-06-10',etaLlegada:'2024-07-15',origen:'Shanghai',destino:'Panamá'}] }
// ═══ ARTES ENVIADOS AL PROVEEDOR: WeTransfer + correos ═══
if(!window._artesData) window._artesData={};
// ═══ ARTES APROBADOS POR GERENCIA: ganchito + comentario ═══
if(!window._artesAprob) window._artesAprob={};
function getAprob(oid){
  if(!window._artesAprob[oid]) window._artesAprob[oid]={aprobado:false,por:'',fecha:'',comentario:''};
  return window._artesAprob[oid];
}
// ═══ REVISIÓN DE ARTES CON IA ═══
// ⚠️ SEGURIDAD: la API key queda expuesta en el frontend. Ver nota al usuario.
var ANTHROPIC_KEY_ARTES = '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';
var IA_MODELO = 'claude-haiku-4-5-20251001';
if(!window._revIA) window._revIA={};
// Revisión IA genérica de un documento (imagen o PDF) con un prompt específico.
// Devuelve {errores:[...], ok:bool}
// Lee un archivo Excel/CSV y lo convierte a texto tabular (para pasarlo a la IA)
async function _excelATexto(url){
  try{
    if(typeof XLSX==='undefined'){ console.error('SheetJS no cargó'); return ''; }
    var resp=await fetch(url);
    var buf=await resp.arrayBuffer();
    var wb=XLSX.read(buf,{type:'array'});
    var out='';
    wb.SheetNames.forEach(function(sn){
      var ws=wb.Sheets[sn];
      var csv=XLSX.utils.sheet_to_csv(ws,{FS:'\t'});
      if(csv && csv.trim()){
        out+='=== Hoja: '+sn+' ===\n'+csv+'\n\n';
      }
    });
    // Limitar tamaño para no exceder el contexto
    if(out.length>12000) out=out.slice(0,12000)+'\n...(contenido truncado)';
    return out;
  }catch(e){ console.error('_excelATexto:', e); return ''; }
}
async function _revisarDocIA(url, nombre, promptTexto){
  var ext=(nombre.split('.').pop()||'').toLowerCase();
  var esImg=['jpg','jpeg','png','gif','webp'].includes(ext);
  var esPdf=ext==='pdf';
  var content=[];
  if(esImg){
    var b64=await _imgUrlABase64(url);
    content.push({type:'image',source:{type:'base64',media_type:b64.mime,data:b64.data}});
  } else if(esPdf){
    var pb=await _fileUrlABase64(url);
    content.push({type:'document',source:{type:'base64',media_type:'application/pdf',data:pb.data}});
  } else if(['xlsx','xls','csv'].includes(ext)){
    // Excel/CSV: leer el contenido con SheetJS y pasarlo como texto a la IA
    var texto=await _excelATexto(url);
    if(!texto){ return {errores:['No se pudo leer el contenido del Excel.'], ok:false}; }
    content.push({type:'text',text:promptTexto+'\n\nContenido del archivo (hoja de cálculo, filas separadas por saltos de línea y columnas por tabulación):\n\n'+texto});
    var body0={ model:IA_MODELO, max_tokens:1500, messages:[{role:'user',content:content}] };
    var r0=await fetch('https://api.anthropic.com/v1/messages',{method:'POST',headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},body:JSON.stringify(body0)});
    var d0=await r0.json();
    var txt0=(d0.content&&d0.content[0]&&d0.content[0].text)?d0.content[0].text:'{"errores":[]}';
    txt0=txt0.replace(/```json|```/g,'').trim();
    var p0; try{ p0=JSON.parse(txt0); }catch(e){ p0={errores:['No se pudo interpretar la respuesta de la IA.']}; }
    return {errores:p0.errores||[], ok:(p0.errores||[]).length===0};
  } else {
    return {errores:['Este tipo de archivo ('+ext+') no se puede revisar con IA.'], ok:false, noLeible:true};
  }
  content.push({type:'text',text:promptTexto});
  var body={ model:IA_MODELO, max_tokens:1500, messages:[{role:'user',content:content}] };
  var r=await fetch('https://api.anthropic.com/v1/messages',{
    method:'POST',
    headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
    body:JSON.stringify(body)
  });
  var d=await r.json();
  var txt=(d.content&&d.content[0]&&d.content[0].text)?d.content[0].text:'{"errores":[]}';
  txt=txt.replace(/```json|```/g,'').trim();
  var parsed; try{ parsed=JSON.parse(txt); }catch(e){ parsed={errores:['No se pudo interpretar la respuesta de la IA.']}; }
  return {errores:parsed.errores||[], ok:(parsed.errores||[]).length===0};
}
async function _fileUrlABase64(url){
  var resp=await fetch(url);
  var blob=await resp.blob();
  var data=await new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onloadend=function(){ res(fr.result.split(',')[1]); };
    fr.onerror=rej; fr.readAsDataURL(blob);
  });
  return {data:data};
}
// Badge visual de "AI revisado con éxito" (sin errores)
function _badgeIAok(){
  return '<div style="display:inline-flex;align-items:center;gap:6px;background:#F0FDF4;border:1px solid #86EFAC;border-radius:20px;padding:5px 12px;font-size:11px;font-weight:600;color:var(--t-verde);margin-top:8px"><i class="ti ti-sparkles" style="font-size:13px"></i><i class="ti ti-circle-check" style="font-size:13px"></i> AI: revisado con éxito, sin errores</div>';
}
// Panel de revisión IA genérico para un paso (Excel de pedido, depósito, etc.)
function buildRevisionIAGenerica(oid, subKey, tipo){
  var atts=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  // Cualquier archivo adjunto, no una lista cerrada de extensiones
  var revisables=_dedupDocs(atts);
  var titulo=tipo==='excel'?'Revisar orden de compra con IA':tipo==='deposito'?'Verificar datos bancarios con IA':'Revisar con IA';
  var h='';
  h+='<div style="background:#F5F3FF;border:1px solid #DDD6FE;border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:var(--t-lila);margin-bottom:8px;display:flex;align-items:center;gap:6px"><i class="ti ti-sparkles"></i>'+titulo+'</div>';
  if(!revisables.length){
    h+='<div style="font-size:11px;color:var(--text-muted)">Adjunta el documento (PDF, imagen o Excel) para poder revisarlo con IA.</div>';
  } else {
    var desc=tipo==='excel'?'La IA revisará las órdenes de compra buscando errores en fórmulas, totales, sumatorias y montos.':tipo==='deposito'?'La IA comparará los datos bancarios del comprobante con los de la orden de compra y avisará si hay diferencias.':'La IA revisará el documento.';
    h+='<div style="font-size:11px;color:var(--text-secondary);margin-bottom:9px">'+desc+'</div>';
    h+='<button onclick="revisarGenericaIA(\''+oid+'\',\''+subKey+'\',\''+tipo+'\')" id="btn-reviag-'+oid+'-'+subKey+'" style="background:#5B21B6;color:white;border:none;border-radius:7px;padding:8px 14px;cursor:pointer;font-size:12px;font-weight:600;display:inline-flex;align-items:center;gap:6px"><i class="ti ti-sparkles"></i>Revisar con IA</button>';
    var res=window._revIA[oid+subKey+'_'+tipo];
    h+='<div id="reviag-res-'+oid+'-'+subKey+'" style="margin-top:10px">'+(res?_renderRevIAGen(res):'')+'</div>';
  }
  h+='</div>';
  return h;
}
function _renderRevIAGen(res){
  if(!res||!res.items) return '';
  var hayError=res.items.some(function(it){return it.errores&&it.errores.length;});
  var h=res.items.map(function(it){
    // Un archivo que no se pudo leer no es "sin errores": se marca aparte
    var color=it.nota?'#B45309':(it.errores&&it.errores.length?'#DC2626':'#16A34A');
    var icon=it.nota?'ti-alert-circle':(it.errores&&it.errores.length?'ti-alert-triangle':'ti-circle-check');
    var x='<div style="background:var(--surface-2);border:0.5px solid var(--border);border-left:3px solid '+color+';border-radius:6px;padding:9px 11px;margin-bottom:7px">';
    x+='<div style="font-size:11px;font-weight:600;color:'+color+';display:flex;align-items:center;gap:5px;margin-bottom:'+((it.errores&&it.errores.length)?'6px':'0')+'"><i class="ti '+icon+'" style="font-size:12px"></i>'+it.nombre+'</div>';
    if(it.errores&&it.errores.length){
      x+='<ul style="margin:0;padding-left:16px;font-size:11px;color:var(--text-secondary);line-height:1.5">';
      it.errores.forEach(function(e){ x+='<li>'+String(e).replace(/</g,'&lt;')+'</li>'; });
      x+='</ul>';
    } else if(it.nota){
      x+='<span style="font-size:11px;color:var(--t-ambar)">'+String(it.nota).replace(/</g,'&lt;')+'</span>';
    } else { x+='<span style="font-size:11px;color:var(--t-verde3)">Sin errores.</span>'; }
    x+='</div>';
    return x;
  }).join('');
  if(!hayError) h+=_badgeIAok();
  return h;
}
async function revisarGenericaIA(oid, subKey, tipo){
  var atts=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  // Cualquier archivo adjunto, no una lista cerrada de extensiones
  var revisables=_dedupDocs(atts);
  if(!revisables.length){ showT('No hay documentos revisables'); return; }
  var btn=document.getElementById('btn-reviag-'+oid+'-'+subKey);
  var resDiv=document.getElementById('reviag-res-'+oid+'-'+subKey);
  if(btn){ btn.disabled=true; btn.style.opacity=".7"; btn.innerHTML='<span class="ai-ring" style="width:11px;height:11px;border-width:2px;vertical-align:-1px"></span> Revisando…'; }
  var prompt;
  if(tipo==='excel'){
    prompt='Eres un auditor de órdenes de compra. Revisa este documento (una orden de compra con productos, cantidades, precios y totales). Verifica EXCLUSIVAMENTE errores objetivos de cálculo: que cantidad × precio unitario = total de cada línea, que la suma de los totales de línea = total general, que no haya montos inconsistentes o sumatorias incorrectas. Responde SOLO en JSON válido sin texto adicional: {"errores": ["descripción del error con los números involucrados"]}. Si todos los cálculos están correctos, responde {"errores": []}. Responde en español.';
  } else if(tipo==='deposito'){
    prompt='Eres un auditor financiero. Este documento es un comprobante de depósito/pago o una orden de compra. Revisa los DATOS BANCARIOS visibles (número de cuenta, beneficiario, banco, monto) y verifica que sean consistentes y estén completos. Si detectas datos bancarios incompletos, montos que no coinciden, o inconsistencias, infórmalo. Responde SOLO en JSON válido sin texto adicional: {"errores": ["descripción de la diferencia o error"]}. Si todo está correcto y consistente, responde {"errores": []}. Responde en español.';
  } else {
    prompt='Revisa este documento y detecta errores objetivos. Responde SOLO en JSON: {"errores": []}. En español.';
  }
  var resultado={items:[]};
  for(var idx=0; idx<revisables.length; idx++){
    var a=revisables[idx];
    if(resDiv) resDiv.innerHTML='<div style="font-size:11px;color:var(--text-muted)"><i class="ti ti-loader-2 spin"></i> Revisando '+(idx+1)+' de '+revisables.length+'...</div>';
    try{
      var res=await _revisarDocIA(a.data, a.name, prompt);
      resultado.items.push({nombre:a.name, errores:res.errores||[]});
    }catch(e){
      resultado.items.push({nombre:a.name, errores:['Error al revisar: '+(e.message||e)]});
    }
  }
  window._revIA[oid+subKey+'_'+tipo]=resultado;
  if(resDiv) resDiv.innerHTML=_renderRevIAGen(resultado);
  if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-refresh"></i> Volver a revisar'; }
  var conErr=resultado.items.filter(function(it){return it.errores&&it.errores.length;}).length;
  var sinLeer=resultado.items.filter(function(it){return it.nota;}).length;
  showT(conErr?('⚠ '+conErr+' documento(s) con posibles errores'+(sinLeer?(' · '+sinLeer+' sin poder leer'):''))
              :(sinLeer?('✓ Sin errores · '+sinLeer+' archivo(s) no se pudieron leer'):'✓ AI: sin errores'));
}

function buildRevisionIA(oid, subKey){
  // Junta los artes adjuntos de este paso
  var atts=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  // Cualquier archivo, no solo imágenes: PDF, Excel, Word, texto…
  var imgs=_dedupDocs(atts);
  var h='';
  h+='<div style="background:#F5F3FF;border:1px solid #DDD6FE;border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:var(--t-lila);margin-bottom:8px;display:flex;align-items:center;gap:6px"><i class="ti ti-sparkles"></i>Revisión con inteligencia artificial</div>';
  if(!imgs.length){
    h+='<div style="font-size:11px;color:var(--text-muted)">Adjunta los artes para poder revisarlos. Se aceptan PDF, imágenes, Excel y Word.</div>';
  } else {
    h+='<div style="font-size:11px;color:var(--text-secondary);margin-bottom:9px">La IA revisará los '+imgs.length+' arte(s) adjunto(s) buscando errores de ortografía, gramática y otros problemas visibles en el texto.</div>';
    h+='<button onclick="revisarArtesIA(\''+oid+'\',\''+subKey+'\')" id="btn-revia-'+oid+'" style="background:#5B21B6;color:white;border:none;border-radius:7px;padding:8px 14px;cursor:pointer;font-size:12px;font-weight:600;display:inline-flex;align-items:center;gap:6px"><i class="ti ti-sparkles"></i>Revisar artes con IA</button>';
    // Resultados previos
    var res=window._revIA[oid+subKey];
    if(res) h+='<div id="revia-res-'+oid+'" style="margin-top:10px">'+_renderRevIA(res)+'</div>';
    else h+='<div id="revia-res-'+oid+'" style="margin-top:10px"></div>';
  }
  h+='</div>';
  return h;
}
function _renderRevIA(res){
  if(!res||!res.items) return '';
  var hayError=res.items.some(function(it){return it.errores&&it.errores.length;});
  var out=res.items.map(function(it){
    // Un archivo que no se pudo leer no es "sin errores": se marca aparte
    var color=it.nota?'#B45309':(it.errores&&it.errores.length?'#DC2626':'#16A34A');
    var icon=it.nota?'ti-alert-circle':(it.errores&&it.errores.length?'ti-alert-triangle':'ti-circle-check');
    var h='<div style="background:var(--surface-2);border:0.5px solid var(--border);border-left:3px solid '+color+';border-radius:6px;padding:9px 11px;margin-bottom:7px">';
    h+='<div style="font-size:11px;font-weight:600;color:'+color+';display:flex;align-items:center;gap:5px;margin-bottom:'+((it.errores&&it.errores.length)?'6px':'0')+'"><i class="ti '+icon+'" style="font-size:12px"></i>'+it.nombre+'</div>';
    if(it.errores&&it.errores.length){
      h+='<ul style="margin:0;padding-left:16px;font-size:11px;color:var(--text-secondary);line-height:1.5">';
      it.errores.forEach(function(e){ h+='<li>'+String(e).replace(/</g,'&lt;')+'</li>'; });
      h+='</ul>';
    } else if(it.nota){
      h+='<span style="font-size:11px;color:var(--t-ambar)">'+String(it.nota).replace(/</g,'&lt;')+'</span>';
    } else {
      h+='<span style="font-size:11px;color:var(--t-verde3)">Sin errores detectados.</span>';
    }
    h+='</div>';
    return h;
  }).join('');
  if(!hayError) out+=_badgeIAok();
  return out;
}
async function revisarArtesIA(oid, subKey){
  var atts=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  var imgs=_dedupDocs(atts);
  if(!imgs.length){ showT('No hay archivos para revisar'); return; }
  if(ANTHROPIC_KEY_ARTES==='PEGA_TU_API_KEY_AQUI'){ showT('Falta configurar la API key de Anthropic'); return; }
  var btn=document.getElementById('btn-revia-'+oid);
  var resDiv=document.getElementById('revia-res-'+oid);
  if(btn){ btn.disabled=true; btn.style.opacity=".7"; btn.innerHTML='<span class="ai-ring" style="width:11px;height:11px;border-width:2px;vertical-align:-1px"></span> Revisando… (puede tardar)'; }
  var resultado={items:[]};
  for(var idx=0; idx<imgs.length; idx++){
    var a=imgs[idx];
    if(resDiv) resDiv.innerHTML='<div style="font-size:11px;color:var(--text-muted)"><i class="ti ti-loader-2 spin"></i> Revisando '+(idx+1)+' de '+imgs.length+': '+a.name+'...</div>';
    try{
      // Cualquier formato: PDF, imagen, Excel, Word o texto
      var prep=await _iaDesdeStorage(a.url||a.data, a.name||('arte_'+(idx+1)), 7);
      if(!prep || !prep.bloques || !prep.bloques.length){
        resultado.items.push({nombre:a.name||'', errores:[], nota:'No se pudo leer el archivo.'});
        continue;
      }
      if(prep.nota){
        resultado.items.push({nombre:a.name||'', errores:[], nota:prep.nota});
        continue;
      }
      var body={
        model:IA_MODELO,
        max_tokens:1024,
        messages:[{role:'user',content:prep.bloques.concat([
          {type:'text',text:'Eres un revisor de artes gráficos para impresión. Revisa este arte/diseño de producto (puede venir como imagen, PDF o texto extraído) y detecta EXCLUSIVAMENTE errores objetivos en el TEXTO visible: errores de ortografía, de gramática, palabras cortadas, texto duplicado, números o unidades inconsistentes. NO comentes sobre gustos de diseño, colores ni composición. Responde SOLO en JSON válido, sin texto adicional, con este formato: {"errores": ["descripción breve del error 1", "error 2"]}. Si no hay errores, responde {"errores": []}. Responde en español.'}
        ])}]
      };
      var r=await fetch('https://api.anthropic.com/v1/messages',{
        method:'POST',
        headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
        body:JSON.stringify(body)
      });
      var d=await r.json();
      var txt=(d.content&&d.content[0]&&d.content[0].text)?d.content[0].text:'{"errores":[]}';
      txt=txt.replace(/```json|```/g,'').trim();
      var parsed; try{ parsed=JSON.parse(txt); }catch(e){ parsed={errores:['No se pudo interpretar la respuesta de la IA.']}; }
      resultado.items.push({nombre:a.name, errores:parsed.errores||[]});
    }catch(e){
      resultado.items.push({nombre:a.name, errores:['Error al revisar: '+(e.message||e)]});
    }
  }
  window._revIA[oid+subKey]=resultado;
  if(resDiv) resDiv.innerHTML=_renderRevIA(resultado);
  if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-refresh"></i> Volver a revisar'; }
  var conErr=resultado.items.filter(function(it){return it.errores&&it.errores.length;}).length;
  showT(conErr?('⚠ '+conErr+' arte(s) con posibles errores'):'✓ Sin errores detectados');
}
// Convierte una URL de imagen a base64 (para enviarla a la API)
async function _imgUrlABase64(url){
  var resp=await fetch(url);
  var blob=await resp.blob();
  var mime=blob.type||'image/jpeg';
  var data=await new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onloadend=function(){ res(fr.result.split(',')[1]); };
    fr.onerror=rej;
    fr.readAsDataURL(blob);
  });
  return {mime:mime, data:data};
}

function buildArtesAprobacion(oid){
  var ap=getAprob(oid);
  var esGerencia=CU && CU.role==='gerencia';
  var h='';
  if(esGerencia){
    // Gerencia: puede aprobar y comentar
    h+='<div style="background:#F0FDF4;border:1px solid #BBF7D0;border-radius:9px;padding:12px;margin-bottom:10px">';
    h+='<div style="font-size:12px;font-weight:600;color:var(--t-verde);margin-bottom:10px;display:flex;align-items:center;gap:6px"><i class="ti ti-stamp"></i>Aprobación de gerencia</div>';
    // Checkbox de aprobado
    h+='<label style="display:flex;align-items:center;gap:9px;cursor:pointer;margin-bottom:10px;font-size:13px;font-weight:500">';
    h+='<input type="checkbox" '+(ap.aprobado?'checked':'')+' onchange="toggleAprobArte(\''+oid+'\',this.checked)" style="width:18px;height:18px;cursor:pointer;accent-color:var(--t-verde3)">';
    h+='<span style="color:'+(ap.aprobado?'#166534':'var(--text-secondary)')+'">'+(ap.aprobado?'✓ Artes aprobados':'Marcar artes como aprobados')+'</span></label>';
    // Comentario opcional
    h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">COMENTARIO (opcional)</label>';
    h+='<textarea placeholder="Agregar un comentario sobre la aprobación..." oninput="setAprobComentario(\''+oid+'\',this.value)" rows="2" style="width:100%;padding:7px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;font-family:var(--font-sans);resize:vertical">'+(ap.comentario||'')+'</textarea>';
    if(ap.aprobado && ap.por)h+='<div style="font-size:10px;color:var(--t-verde);margin-top:7px"><i class="ti ti-circle-check" style="font-size:10px"></i> Aprobado por '+ap.por+(ap.fecha?' el '+ap.fecha:'')+'</div>';
    h+='</div>';
  } else {
    // Diseño y demás: solo ven el estado, sin modificar
    if(ap.aprobado){
      h+='<div style="background:#F0FDF4;border:1px solid #86EFAC;border-radius:9px;padding:12px;margin-bottom:10px">';
      h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:'+(ap.comentario?'8px':'0')+'">';
      h+='<div style="width:26px;height:26px;background:#16A34A;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0"><i class="ti ti-check" style="color:white;font-size:15px"></i></div>';
      h+='<div><div style="font-size:12px;font-weight:600;color:var(--t-verde)">Aprobado por gerencia</div>';
      h+='<div style="font-size:10px;color:#15803D">'+(ap.por||'Gerencia')+(ap.fecha?' · '+ap.fecha:'')+'</div></div></div>';
      if(ap.comentario){
        h+='<div style="background:var(--surface-2);border-radius:6px;padding:8px 10px;font-size:12px;color:var(--text-secondary);border-left:3px solid #16A34A"><i class="ti ti-message" style="font-size:11px;color:var(--t-verde3)"></i> '+ap.comentario.replace(/</g,'&lt;')+'</div>';
      }
      h+='</div>';
    } else {
      h+='<div style="background:var(--surface-2);border:0.5px dashed var(--border);border-radius:9px;padding:12px;margin-bottom:10px;font-size:12px;color:var(--text-muted);display:flex;align-items:center;gap:7px"><i class="ti ti-clock"></i>Pendiente de aprobación por gerencia</div>';
    }
  }
  return h;
}
function toggleAprobArte(oid,checked){
  var ap=getAprob(oid);
  ap.aprobado=checked;
  if(checked){ ap.por=CU?CU.name:''; ap.fecha=(typeof dateOnly==='function'?dateOnly():new Date().toLocaleDateString()); }
  else { ap.por=''; ap.fecha=''; }
  guardarAprob(oid);
  // Redibujar el panel para reflejar el estado
  var st=STAGES.find(function(s){return s.key==='artes';});
  var si=STAGES.indexOf(st);
  var body=document.getElementById('egb-'+oid+'-'+si);
  if(body){ buildEGB(oid,si,body); _reabrirSub(oid,si,2); }
  showT(checked?'✓ Artes aprobados':'Aprobación quitada');
}
function setAprobComentario(oid,val){ getAprob(oid).comentario=val; _guardarAprobDebounced(oid); }
var _aprobTimers={};
function _guardarAprobDebounced(oid){
  if(_aprobTimers[oid]) clearTimeout(_aprobTimers[oid]);
  _aprobTimers[oid]=setTimeout(function(){ guardarAprob(oid); }, 600);
}
async function guardarAprob(oid){
  try{
    var ap=getAprob(oid);
    await fetch(SB+'/rest/v1/compras_artes_aprob?on_conflict=docnum', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), aprobado:ap.aprobado, aprobado_por:ap.por||'', aprobado_fecha:ap.fecha||'', comentario:ap.comentario||'', actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarAprob:', e); }
}
async function cargarAprob(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_artes_aprob?select=*', {headers:SBH});
    var rows=await r.json();
    if(!window._artesAprob) window._artesAprob={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      window._artesAprob[String(row.docnum)]={ aprobado:!!row.aprobado, por:row.aprobado_por||'', fecha:row.aprobado_fecha||'', comentario:row.comentario||'' };
    });
  }catch(e){ console.error('cargarAprob:', e); }
}

// ═══ EMAIL DE DEPÓSITO/PAGO (compras y contabilidad) ═══
if(!window._depMail) window._depMail={};
function getDepMail(oid,paso){
  var k=oid+'_'+paso;
  if(!window._depMail[k]) window._depMail[k]={para:'',copias:[]};
  return window._depMail[k];
}
// Construye un panel de envío por correo. tipo: 'solicitud' (compras->contabilidad) o 'proveedor' (contabilidad->proveedor)
// Fija el destinatario del correo de depósito desde los atajos
function setDepMailPara(oid, paso, email){
  setDepMailField(oid, paso, 'para', email);
  var det=document.getElementById('modal');
  if(det) { try{ openDetail(oid); }catch(e){} }
  showT('Destinatario: '+email);
}
// Pone en copia a todos los de contabilidad que no sean el destinatario
function addDepMailCopiaTodos(oid, paso){
  var m=getDepMail(oid, paso);
  var para=(m.para||'').toLowerCase();
  var cop=Array.isArray(m.copias)?m.copias.slice():[];
  (USERS||[]).forEach(function(u){
    if(u.role!=='contabilidad'||!u.email) return;
    if(u.email.toLowerCase()===para) return;
    if(cop.map(function(c){return String(c||'').toLowerCase();}).indexOf(u.email.toLowerCase())<0) cop.push(u.email);
  });
  m.copias=cop;
  if(!window._depMail) window._depMail={};
  window._depMail[String(oid)+'_'+String(paso)]=m;
  guardarDepMail(oid, paso);
  try{ openDetail(oid); }catch(e){}
  showT(cop.length+' correo(s) en copia');
}

function buildEmailPanel(oid,paso,tipo){
  var m=getDepMail(oid,paso);
  var o=orders.find(function(x){return x.id===oid;});
  var esSolicitud=(tipo==='solicitud');
  var titulo=esSolicitud?'Enviar solicitud de depósito a Contabilidad':'Enviar comprobante por correo';
  var colorBg=esSolicitud?'#FBEAF0':'#E1F5EE';
  var colorBd=esSolicitud?'#F0C4D5':'#A9DFD0';
  var colorTx=esSolicitud?'#72243E':'#085041';
  var placeholderPara=esSolicitud?'contabilidad@kennedyzl.com':'proveedor@empresa.com';
  var h='';
  h+='<div style="background:'+colorBg+';border:1px solid '+colorBd+';border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:'+colorTx+';margin-bottom:10px;display:flex;align-items:center;gap:6px"><i class="ti ti-mail"></i>'+titulo+'</div>';
  // Para (destinatario)
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">CORREO DESTINATARIO</label>';
  // Atajo: los usuarios de contabilidad, para no escribir el correo a mano
  var _cts=(USERS||[]).filter(function(u){ return u.role==='contabilidad' && u.email; });
  if(esSolicitud && _cts.length){
    h+='<div style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:6px">';
    _cts.forEach(function(u){
      var act=((m.para||'').toLowerCase()===u.email.toLowerCase());
      h+='<span onclick="setDepMailPara(\''+oid+'\',\''+paso+'\',\''+u.email+'\')" title="'+_esc(u.email)+'"'
        +' style="cursor:pointer;font-size:10.5px;font-weight:600;padding:3px 9px;border-radius:13px;'
        +'border:1px solid '+(act?colorTx:'var(--border)')+';background:'+(act?colorTx:'var(--surface-0)')+';color:'+(act?'#fff':colorTx)+'">'
        +(act?'<i class="ti ti-check" style="font-size:10px"></i> ':'')+_esc(u.name)+'</span>';
    });
    h+='<span onclick="addDepMailCopiaTodos(\''+oid+'\',\''+paso+'\')" title="Poner al resto en copia"'
      +' style="cursor:pointer;font-size:10.5px;font-weight:600;padding:3px 9px;border-radius:13px;border:1px dashed '+colorTx+';color:'+colorTx+'">'
      +'<i class="ti ti-users" style="font-size:10px"></i> Todos en copia</span>';
    h+='</div>';
  }
  h+='<input type="email" value="'+(m.para||'').replace(/"/g,'&quot;')+'" placeholder="'+placeholderPara+'" oninput="setDepMailField(\''+oid+'\',\''+paso+'\',\'para\',this.value)" style="width:100%;padding:7px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;margin-bottom:10px;font-family:var(--font-sans)">';
  // Copias
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">CORREOS EN COPIA (CC)</label>';
  h+='<div id="depcc-'+oid+'-'+paso+'">';
  (m.copias||[]).forEach(function(c,ci){
    h+='<div style="display:flex;gap:5px;margin-bottom:5px"><input type="email" value="'+(c||'').replace(/"/g,'&quot;')+'" placeholder="correo@empresa.com" oninput="setDepMailCopia(\''+oid+'\',\''+paso+'\','+ci+',this.value)" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;font-family:var(--font-sans)"><button onclick="delDepMailCopia(\''+oid+'\',\''+paso+'\','+ci+')" style="background:none;border:0.5px solid var(--border-danger);color:var(--text-danger);border-radius:6px;padding:0 9px;cursor:pointer;font-size:14px">&times;</button></div>';
  });
  h+='</div>';
  h+='<button onclick="addDepMailCopia(\''+oid+'\',\''+paso+'\')" style="background:none;border:1px dashed var(--border);color:var(--text-accent);border-radius:6px;padding:5px 10px;cursor:pointer;font-size:11px;margin-bottom:10px"><i class="ti ti-plus" style="font-size:11px"></i> Agregar correo en copia</button>';
  h+='<div><button onclick="enviarDepMail(\''+oid+'\',\''+paso+'\',\''+tipo+'\')" style="width:100%;background:'+colorTx+';color:white;border:none;border-radius:6px;padding:8px 12px;cursor:pointer;font-size:12px;font-weight:600;display:flex;align-items:center;justify-content:center;gap:6px"><i class="ti ti-mail"></i>Abrir en Outlook para enviar</button></div>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-top:7px;line-height:1.4"><i class="ti ti-info-circle" style="font-size:10px"></i> Se abrirá tu Outlook con el correo ya armado. Adjunta los archivos manualmente antes de enviar.</div>';
  h+='</div>';
  return h;
}
function setDepMailField(oid,paso,field,val){ getDepMail(oid,paso)[field]=val; _guardarDepMailDebounced(oid,paso); }
function setDepMailCopia(oid,paso,ci,val){ var m=getDepMail(oid,paso); if(m.copias[ci]!==undefined){m.copias[ci]=val; _guardarDepMailDebounced(oid,paso);} }
function addDepMailCopia(oid,paso){ getDepMail(oid,paso).copias.push(''); _redibujarDepCC(oid,paso); guardarDepMail(oid,paso); }
function delDepMailCopia(oid,paso,ci){ getDepMail(oid,paso).copias.splice(ci,1); _redibujarDepCC(oid,paso); guardarDepMail(oid,paso); }
function _redibujarDepCC(oid,paso){
  var cont=document.getElementById('depcc-'+oid+'-'+paso);
  if(cont && cont.parentNode){ cont.parentNode.outerHTML=buildEmailPanel(oid,paso,cont.parentNode.getAttribute('data-tipo')||'solicitud'); }
}
var _depMailTimers={};
function _guardarDepMailDebounced(oid,paso){
  var k=oid+'_'+paso;
  if(_depMailTimers[k]) clearTimeout(_depMailTimers[k]);
  _depMailTimers[k]=setTimeout(function(){ guardarDepMail(oid,paso); }, 600);
}
// Junta los links de descarga de los archivos adjuntos de una etapa (para incluir en el correo)
function _linksArchivosEtapa(oid, stageKey){
  var links=[];
  if(window._atts){
    for(var k in window._atts){
      // archivos de la etapa (general) y de sus sub-pasos
      if(k.indexOf(oid+stageKey)===0 && window._atts[k]){
        window._atts[k].forEach(function(a){
          if(a.data && a.data.indexOf('http')===0){ links.push('- '+(a.name||'archivo')+': '+a.data); }
        });
      }
    }
  }
  return links;
}
function enviarDepMail(oid,paso,tipo){
  var m=getDepMail(oid,paso);
  var o=orders.find(function(x){return x.id===oid;});
  if(!m.para){ showT('Falta el correo destinatario'); return; }
  var esSolicitud=(tipo==='solicitud');
  var asunto,cuerpo;
  if(esSolicitud){
    asunto='Solicitud de depósito - Orden '+oid+(o?(' - '+o.prov):'');

    var _lk1=_linksArchivosEtapa(oid,'deposito');cuerpo='Estimados Contabilidad,\n\nSolicito el envío del depósito para la siguiente orden de compra:\n\nOrden: '+oid+'\nProveedor: '+(o?o.prov:'')+'\nDescripción: '+(o?o.desc:'')+'\n\n'+(_lk1.length?('Archivos adjuntos (descargar):\n'+_lk1.join('\n')+'\n\n'):'Adjunto la orden de compra para su gestión.\n\n')+'Saludos,\n'+(CU?CU.name:'')+'\nKennedy';
  } else {
    asunto='Deposit / Payment - Order '+oid+(o?(' - '+o.prov):'');
    var _lk2=_linksArchivosEtapa(oid,'deposito');cuerpo='Dear Supplier,\n\nPlease find the payment confirmation for order '+oid+(o?(' ('+o.desc+')'):'')+'.\n\n'+(_lk2.length?('Files (download):\n'+_lk2.join('\n')+'\n\n'):'')+'Best regards,\n'+(CU?CU.name:'')+'\nKennedy';
  }
  var cc=(m.copias||[]).filter(function(c){return c && c.trim();}).join(';');
  var url='mailto:'+encodeURIComponent(m.para)+'?';
  if(cc) url+='cc='+encodeURIComponent(cc)+'&';
  url+='subject='+encodeURIComponent(asunto)+'&body='+encodeURIComponent(cuerpo);
  window.location.href=url;
  showT('Abriendo Outlook...');
}
async function guardarDepMail(oid,paso){
  try{
    var m=getDepMail(oid,paso);
    await fetch(SB+'/rest/v1/compras_dep_mail?on_conflict=docnum,paso', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), paso:String(paso), para:m.para||'', copias:m.copias||[], actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarDepMail:', e); }
}
async function cargarDepMail(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_dep_mail?select=*', {headers:SBH});
    var rows=await r.json();
    if(!window._depMail) window._depMail={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      var cop=row.copias; if(typeof cop==='string'){try{cop=JSON.parse(cop);}catch(e){cop=[];}}
      window._depMail[String(row.docnum)+'_'+String(row.paso)]={ para:row.para||'', copias:Array.isArray(cop)?cop:[] };
    });
  }catch(e){ console.error('cargarDepMail:', e); }
}

function getArtes(oid){
  if(!window._artesData[oid]) window._artesData[oid]={wetransfer:'',correoProv:'',copias:[]};
  return window._artesData[oid];
}
function buildArtesEnvio(oid){
  var a=getArtes(oid);
  var o=orders.find(function(x){return x.id===oid;});
  var provNombre=o?o.prov:'';
  var h='';
  h+='<div style="background:#F5F3FF;border:1px solid #DDD6FE;border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:var(--t-lila);margin-bottom:10px;display:flex;align-items:center;gap:6px"><i class="ti ti-send"></i>Enviar artes al proveedor</div>';
  // Link WeTransfer
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">LINK DE WETRANSFER (todos los artes)</label>';
  h+='<input type="text" value="'+(a.wetransfer||'').replace(/"/g,'&quot;')+'" placeholder="https://we.tl/t-xxxxxxxx" oninput="setArteField(\''+oid+'\',\'wetransfer\',this.value)" style="width:100%;padding:7px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;margin-bottom:10px;font-family:var(--font-sans)">';
  // Correo proveedor
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">CORREO DEL PROVEEDOR</label>';
  h+='<input type="email" value="'+(a.correoProv||'').replace(/"/g,'&quot;')+'" placeholder="proveedor@empresa.com" oninput="setArteField(\''+oid+'\',\'correoProv\',this.value)" style="width:100%;padding:7px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;margin-bottom:10px;font-family:var(--font-sans)">';
  // Correos en copia
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">CORREOS EN COPIA (CC)</label>';
  h+='<div id="artes-cc-'+oid+'">';
  (a.copias||[]).forEach(function(c,ci){
    h+='<div style="display:flex;gap:5px;margin-bottom:5px"><input type="email" value="'+(c||'').replace(/"/g,'&quot;')+'" placeholder="correo@empresa.com" oninput="setArteCopia(\''+oid+'\','+ci+',this.value)" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;font-family:var(--font-sans)"><button onclick="delArteCopia(\''+oid+'\','+ci+')" style="background:none;border:0.5px solid var(--border-danger);color:var(--text-danger);border-radius:6px;padding:0 9px;cursor:pointer;font-size:14px">&times;</button></div>';
  });
  h+='</div>';
  h+='<button onclick="addArteCopia(\''+oid+'\')" style="background:none;border:1px dashed var(--border);color:var(--text-accent);border-radius:6px;padding:5px 10px;cursor:pointer;font-size:11px;margin-bottom:10px"><i class="ti ti-plus" style="font-size:11px"></i> Agregar correo en copia</button>';
  // Botón enviar por Outlook
  h+='<div style="display:flex;gap:6px"><button onclick="mailAbrir(\''+oid+'\',\'artes\',null)" style="flex:1;background:#5B21B6;color:white;border:none;border-radius:6px;padding:8px 12px;cursor:pointer;font-size:12px;font-weight:600"><i class="ti ti-send"></i> Redactar correo</button></div>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-top:7px;line-height:1.4"><i class="ti ti-info-circle" style="font-size:10px"></i> Se abrirá tu Outlook con el correo ya armado (proveedor, copias, link de WeTransfer). Solo revisa y dale enviar.</div>';
  h+='</div>';
  return h;
}
function setArteField(oid,field,val){ getArtes(oid)[field]=val; _guardarArtesDebounced(oid); }
function setArteCopia(oid,ci,val){ var a=getArtes(oid); if(a.copias[ci]!==undefined){a.copias[ci]=val; _guardarArtesDebounced(oid);} }
function addArteCopia(oid){ getArtes(oid).copias.push(''); _redibujarArtesCC(oid); guardarArtes(oid); }
function delArteCopia(oid,ci){ getArtes(oid).copias.splice(ci,1); _redibujarArtesCC(oid); guardarArtes(oid); }
function _redibujarArtesCC(oid){
  // Redibujar todo el panel de artes (para reflejar los correos en copia)
  var cont=document.getElementById('artes-cc-'+oid);
  if(cont && cont.parentNode){ cont.parentNode.outerHTML=buildArtesEnvio(oid); }
}
var _artesSaveTimers={};
function _guardarArtesDebounced(oid){
  if(_artesSaveTimers[oid]) clearTimeout(_artesSaveTimers[oid]);
  _artesSaveTimers[oid]=setTimeout(function(){ guardarArtes(oid); }, 600);
}
function enviarArtesOutlook(oid){
  var a=getArtes(oid);
  var o=orders.find(function(x){return x.id===oid;});
  if(!a.correoProv){ showT('Falta el correo del proveedor'); return; }
  var asunto='Artwork for Order '+oid+(o?(' - '+o.prov):'');
  var _lkA=_linksArchivosEtapa(oid,'artes');var cuerpo='Dear Supplier,\n\nPlease find below the WeTransfer link with the artwork files for order '+oid+(o?(' ('+o.desc+')'):'')+':\n\n'+(a.wetransfer||'[paste the WeTransfer link here]')+'\n\n'+(_lkA.length?('Additional files (download):\n'+_lkA.join('\n')+'\n\n'):'')+'We look forward to your confirmation.\n\nBest regards,\n'+(CU?CU.name:'')+'\nKennedy';
  var cc=(a.copias||[]).filter(function(c){return c && c.trim();}).join(';');
  var url='mailto:'+encodeURIComponent(a.correoProv)+'?';
  if(cc) url+='cc='+encodeURIComponent(cc)+'&';
  url+='subject='+encodeURIComponent(asunto)+'&body='+encodeURIComponent(cuerpo);
  window.location.href=url;
  showT('Abriendo Outlook...');
}
async function guardarArtes(oid){
  try{
    var a=getArtes(oid);
    await fetch(SB+'/rest/v1/compras_artes_envio?on_conflict=docnum', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), wetransfer:a.wetransfer||'', correo_prov:a.correoProv||'', copias:a.copias||[], actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarArtes:', e); }
}
async function cargarArtes(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_artes_envio?select=*', {headers:SBH});
    var rows=await r.json();
    if(!window._artesData) window._artesData={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      var cop=row.copias; if(typeof cop==='string'){try{cop=JSON.parse(cop);}catch(e){cop=[];}}
      window._artesData[String(row.docnum)]={ wetransfer:row.wetransfer||'', correoProv:row.correo_prov||'', copias:Array.isArray(cop)?cop:[] };
    });
  }catch(e){ console.error('cargarArtes:', e); }
}

// ═══ LLEGÓ A DESTINO: confirmación de arribo + edición de fecha si hay atraso ═══
if(!window._llegada) window._llegada={};
function getLlegada(oid){
  if(!window._llegada[oid]) window._llegada[oid]={confirmado:false, fechaReal:'', por:''};
  return window._llegada[oid];
}
function buildLlegadaDestino(oid){
  var bk=getBK(oid);
  var lg=getLlegada(oid);
  var hoy=new Date(); hoy.setHours(0,0,0,0);
  // ¿Algún contenedor ya debería haber llegado según su ETA?
  var fechasLleg=(bk.containers||[]).map(function(c){return c.etaLlegada?new Date(c.etaLlegada):null;}).filter(Boolean);
  var etaMax=fechasLleg.length?new Date(Math.max.apply(null,fechasLleg)):null;
  var yaLlego=etaMax && hoy>=new Date(etaMax.getFullYear(),etaMax.getMonth(),etaMax.getDate());
  var atrasado=etaMax && hoy>new Date(etaMax.getFullYear(),etaMax.getMonth(),etaMax.getDate()) && !lg.confirmado;
  var h='';
  h+='<div style="background:'+(lg.confirmado?'#F0FDF4':atrasado?'#FEF2F2':'#EFF6FF')+';border:1px solid '+(lg.confirmado?'#86EFAC':atrasado?'#FCA5A5':'#BFDBFE')+';border-radius:9px;padding:12px;margin-bottom:10px">';
  h+='<div style="font-size:12px;font-weight:600;color:'+(lg.confirmado?'#166534':atrasado?'#991B1B':'#1E40AF')+';margin-bottom:9px;display:flex;align-items:center;gap:6px"><i class="ti ti-map-pin"></i>Llegada a destino</div>';
  // Estado según ETA
  if(etaMax){
    var etaStr=etaMax.toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'});
    h+='<div style="font-size:11px;color:var(--text-secondary);margin-bottom:8px">ETA de llegada: <strong>'+etaStr+'</strong>';
    if(yaLlego && !lg.confirmado) h+=' <span style="color:#059669">· la fecha ya se cumplió, el contenedor debería estar en puerto</span>';
    if(atrasado) h+=' <span style="color:var(--t-rojo2);font-weight:600">· ATRASADO</span>';
    h+='</div>';
  } else {
    h+='<div style="font-size:11px;color:var(--text-muted);margin-bottom:8px">Registrá la fecha de llegada (ETA) en los contenedores del paso de Booking.</div>';
  }
  // Confirmación (ganchito)
  h+='<label style="display:flex;align-items:center;gap:9px;cursor:pointer;font-size:13px;font-weight:500;margin-bottom:8px">';
  h+='<input type="checkbox" '+(lg.confirmado?'checked':'')+' onchange="toggleLlegada(\''+oid+'\',this.checked)" style="width:18px;height:18px;cursor:pointer;accent-color:var(--t-verde3)">';
  h+='<span style="color:'+(lg.confirmado?'#166534':'var(--text-secondary)')+'">'+(lg.confirmado?'✓ Contenedor en puerto (confirmado)':'Confirmar que el contenedor llegó a puerto')+'</span></label>';
  if(lg.confirmado && lg.por) h+='<div style="font-size:10px;color:var(--t-verde);margin-bottom:8px"><i class="ti ti-circle-check" style="font-size:10px"></i> Confirmado por '+lg.por+(lg.fechaConfirm?' el '+lg.fechaConfirm:'')+'</div>';
  // Editar fecha de llegada nueva (atraso)
  h+='<label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px">FECHA DE LLEGADA REAL (editá si hubo atraso)</label>';
  h+='<input type="date" value="'+(lg.fechaReal||'')+'" onchange="setLlegadaFecha(\''+oid+'\',this.value)" style="padding:6px 9px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;font-family:var(--font-sans)">';
  if(atrasado) h+='<div style="font-size:11px;color:var(--t-rojo);margin-top:8px;background:#FEE2E2;border-radius:6px;padding:7px 9px"><i class="ti ti-alert-triangle" style="font-size:11px"></i> Este contenedor está atrasado. Se notificó al equipo de Importación. Actualizá la fecha de llegada real arriba.</div>';
  h+='</div>';
  return h;
}
function toggleLlegada(oid,checked){
  var lg=getLlegada(oid);
  lg.confirmado=checked;
  if(checked){ lg.por=CU?CU.name:''; lg.fechaConfirm=(typeof dateOnly==='function'?dateOnly():new Date().toLocaleDateString()); }
  else { lg.por=''; lg.fechaConfirm=''; }
  guardarLlegada(oid);
  var st=STAGES.find(function(s){return s.key==='logistica';});
  var si=STAGES.indexOf(st);
  var body=document.getElementById('egb-'+oid+'-'+si);
  if(body){ buildEGB(oid,si,body); _reabrirSub(oid,si,2); }
  showT(checked?'✓ Llegada confirmada':'Confirmación quitada');
}
function setLlegadaFecha(oid,val){
  getLlegada(oid).fechaReal=val;
  guardarLlegada(oid);
  showT('Fecha de llegada actualizada');
}
async function guardarLlegada(oid){
  try{
    var lg=getLlegada(oid);
    await fetch(SB+'/rest/v1/compras_llegada?on_conflict=docnum', {
      method:'POST',
      headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body: JSON.stringify({ docnum:String(oid), confirmado:lg.confirmado, confirmado_por:lg.por||'', fecha_real:lg.fechaReal||'', actualizado_en:new Date().toISOString() })
    });
  }catch(e){ console.error('guardarLlegada:', e); }
}
// ═══ ÓRDENES MANUALES SIN SAP (creadas por compradoras, se trabajan antes de existir en SAP) ═══
if(!window._pendSAP) window._pendSAP=[];
// Días transcurridos desde la fecha de creación (YYYY-MM-DD)
function _diasPendSAP(p){
  var f=p.creado_en||p.fecha||'';
  if(!f) return 0;
  try{ return daysBetween(f, null)||0; }catch(e){ return 0; }
}
// Órdenes que TODAVÍA no existen como orden real en SAP.
// Si aparece una orden real (del sync) con el mismo num_orden (num_proveedor), se oculta.
// ═══════════════════════════════════════════════════════════════════════════
//  ¿QUÉ ORDEN DE SAP CORRESPONDE A UNA ORDEN NO SAP?
//  La referencia se escribe a mano en SAP, así que no siempre coincide letra
//  por letra: la orden NO SAP puede llamarse "26088" y en SAP quedar como
//  "DKC-26088".
//
//  Comparar solo los dígitos sería peligroso: en la misma base conviven
//  DKC-26088 (ZHEJIANG) y HIKC-26088 (LONWA), que son órdenes distintas de
//  proveedores distintos. Por eso, cuando la coincidencia no es exacta, hace
//  falta que ADEMÁS coincida el proveedor.
// ═══════════════════════════════════════════════════════════════════════════
function _refNorm(v){ return String(v==null?'':v).toUpperCase().replace(/[^A-Z0-9]/g,''); }
function _refDigitos(v){ return String(v==null?'':v).replace(/\D/g,''); }

function _provParecido(a, b){
  a=String(a||'').toUpperCase().replace(/[^A-Z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
  b=String(b||'').toUpperCase().replace(/[^A-Z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
  if(!a || !b) return false;
  if(a===b) return true;
  if(a.indexOf(b)>=0 || b.indexOf(a)>=0) return true;
  // Las dos primeras palabras suelen bastar: "ZHEJIANG SUNFLOW ..."
  var pa=a.split(' ').slice(0,2).join(' '), pb=b.split(' ').slice(0,2).join(' ');
  return !!pa && pa===pb;
}

// Devuelve la orden de SAP que corresponde a este pendiente, o null
function _ordenSapDeNoSap(p){
  var ref=String(p.num_orden||p.dkc||'').trim();
  if(!ref) return null;
  var refN=_refNorm(ref), refD=_refDigitos(ref);
  var reales=(typeof orders!=='undefined'?orders:[]).filter(function(o){ return !o._noSap; });

  // 1) Coincidencia exacta de la referencia
  var exacta=reales.find(function(o){ return _refNorm(o.num_proveedor)===refN && refN; });
  if(exacta) return exacta;

  // 2) Misma numeración con otro prefijo: hace falta que el proveedor coincida
  if(refD.length>=4){
    var candidatas=reales.filter(function(o){
      var d=_refDigitos(o.num_proveedor);
      return d && d===refD;
    });
    if(candidatas.length===1 && _provParecido(candidatas[0].prov, p.proveedor)) return candidatas[0];
    if(candidatas.length>1){
      var conProv=candidatas.filter(function(o){ return _provParecido(o.prov, p.proveedor); });
      if(conProv.length===1) return conProv[0];
      console.warn('[NO SAP] '+ref+' coincide con '+candidatas.length
        +' órdenes de SAP y no se puede decidir: '
        +candidatas.map(function(o){ return o.num_proveedor+' ('+o.prov+')'; }).join(', '));
    }
  }
  return null;
}

function pendientesSAPVisibles(){
  var vis=(window._pendSAP||[]).filter(function(p){
    return !_ordenSapDeNoSap(p);          // se oculta si ya existe en SAP
  });
  // El departamento del usuario acota aquí, en el origen. Estaba filtrado
  // solo en la pantalla de búsqueda, así que el tablero, los paneles de
  // KPI y los totales seguían enseñando las órdenes de otros departamentos:
  // Sherene, de Hogar, veía las de Alfombras.
  if(_deptAcotado()){
    vis=vis.filter(function(p){ return _deptPermitido(normDept(p.dept||'')); });
  }
  // De la más nueva a la más vieja. Si no hay fecha se usa el número de orden,
  // que es correlativo, para que igual queden en orden.
  return vis.slice().sort(function(a,b){
    var fa=String(a.creado_en||a.fecha||''), fb=String(b.creado_en||b.fecha||'');
    if(fa && fb && fa!==fb) return fb.localeCompare(fa);
    if(fa && !fb) return -1;
    if(!fa && fb) return 1;
    var na=parseInt(String(a.num_orden||a.dkc||'').replace(/\D/g,''),10)||0;
    var nb=parseInt(String(b.num_orden||b.dkc||'').replace(/\D/g,''),10)||0;
    return nb-na;
  });
}
// Totales (monto = total de la orden)
// El importe de un total NO SAP. Si la lista no se pudo cargar, un $0 hace
// creer que no hay nada; conviene decir que falta el dato.
function _nsapKpi(v){
  if(window._pendSAPError && !(window._pendSAP||[]).length){
    return '<span title="No se pudo cargar la lista de órdenes NO SAP. '
      +'Pulsa Sync o recarga la página." style="color:var(--t-ambar)">'
      +'<i class="ti ti-alert-triangle" style="font-size:12px"></i> sin cargar</span>';
  }
  return fmt(v);
}

function totalPendSAP(){
  return pendientesSAPVisibles().reduce(function(s,p){return s+(Number(p.total)||0);},0);
}
function totalAbonPendSAP(){
  return pendientesSAPVisibles().reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
}
function pendSAPporDept(dept){
  return pendientesSAPVisibles().filter(function(p){return String(p.dept||'')===String(dept);});
}
function totalPendSAPporDept(dept){
  return pendSAPporDept(dept).reduce(function(s,p){return s+(Number(p.total)||0);},0);
}
function totalAbonPendSAPporDept(dept){
  return pendSAPporDept(dept).reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
}
// Badge con los días sin subir a SAP (color según antigüedad)
function _badgeDiasSAP(dias){
  var col = dias>=30?'#e24b4a' : dias>=15?'#BA7517' : '#639922';
  var bg  = dias>=30?'#FBE9E9' : dias>=15?'#FEF3E8' : '#EAF3DE';
  return '<span style="font-size:10px;background:'+bg+';color:'+col+';padding:1px 7px;border-radius:8px;white-space:nowrap"><i class="ti ti-clock" style="font-size:9px"></i> '+dias+'d sin SAP</span>';
}

// Bloque de "órdenes sin SAP" que se muestra dentro de cada departamento
// (total del depto + listado). El botón para CREAR está en la etapa Bodega & Venta.
function _deptoPendSAPBloque(dept, totSap, abnSap){
  var lista=pendSAPporDept(dept);
  var total=totalPendSAPporDept(dept), abon=totalAbonPendSAPporDept(dept), saldo=total-abon;
  var h='<div style="background:linear-gradient(135deg,#F5F3FF,#EDE9FE);border:0.5px solid #C4B5FD;border-radius:8px;padding:9px 11px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:'+(lista.length?'8px':'0')+'">';
  h+='<i class="ti ti-clock-pause" style="color:var(--t-lila2);font-size:15px"></i>';
  h+='<span style="font-size:12px;font-weight:600;color:var(--t-lila2)">Órdenes sin SAP</span>';
  h+='<span style="font-size:11px;color:#7C3AED">'+lista.length+' orden'+(lista.length!==1?'es':'')+(CU.verCostos?' · <strong>'+fmt(total)+'</strong> total · <strong style="color:var(--text-success)">'+fmt(abon)+'</strong> abonado · <strong style="color:var(--text-danger)">'+fmt(saldo)+'</strong> saldo':'')+'</span>';
  h+='</div>';
  lista.forEach(function(p){ h+=_pendSAPFila(p, false); });
  // Gran total del departamento (SAP + sin SAP)
  if(CU.verCostos && (totSap!=null)){
    var granTot=(Number(totSap)||0)+total;
    var granAbn=(Number(abnSap)||0)+abon;
    h+='<div style="margin-top:8px;padding-top:8px;border-top:0.5px dashed #C4B5FD;display:flex;gap:16px;flex-wrap:wrap">';
    h+='<span style="font-size:12px;font-weight:700">GRAN TOTAL: <span style="color:var(--text-accent)">'+fmt(granTot)+'</span></span>';
    h+='<span style="font-size:11px;color:var(--text-success)">Abonado total: '+fmt(granAbn)+'</span>';
    h+='<span style="font-size:11px;color:var(--text-danger)">Saldo total: '+fmt(granTot-granAbn)+'</span>';
    h+='<span style="font-size:9px;color:var(--text-muted);width:100%">Suma de órdenes en SAP + sin SAP</span>';
    h+='</div>';
  }
  h+='</div>';
  return h;
}

// Una fila/tarjeta de orden sin SAP (compacta para listados)
function _pendSAPFila(p, mostrarDept){
  var dias=_diasPendSAP(p);
  // Clave segura: si la orden no tiene dkc, p.dkc.replace() reventaba y
  // tumbaba el render completo de "Buscar ordenes" con el filtro No SAP.
  var _k=String(p.dkc||p.num_orden||'').replace(/'/g,'');
  var ref=p.num_orden||p.dkc||'(sin número)';
  var total=Number(p.total)||0, abon=Number(p.abonado)||0, saldo=(p.saldo!=null?Number(p.saldo):total-abon);
  // La fila abre la orden, salvo que el clic caiga en la etiqueta de la
  // reposición. Con stopPropagation bastaría, pero si algo lo deja pasar el
  // detalle se abre encima y se lleva por delante el panel de diferencias.
  var h='<div class="nosap-card" onclick="if(!(event.target.closest&&event.target.closest(\'.nsap-dif-chip\'))) abrirDetalleNoSap(\''+_k+'\')" title="Abrir las etapas de esta orden" style="border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;background:var(--surface-0);margin-bottom:7px;cursor:pointer">';
  h+='<div style="display:flex;align-items:flex-start;gap:8px">';
  h+='<div style="width:30px;height:30px;background:var(--pastel-naranja);border-radius:7px;display:flex;align-items:center;justify-content:center;flex-shrink:0"><i class="ti ti-file-invoice" style="color:var(--t-ambar);font-size:15px"></i></div>';
  h+='<div style="flex:1;min-width:0">';
  h+='<div style="font-size:13px;font-weight:600">'+(p.proveedor||'(sin proveedor)')+' <span onclick="event.stopPropagation();abrirAdjuntoPendSAP(\''+_k+'\')" style="font-weight:400;color:var(--text-accent);font-size:11px;cursor:pointer;text-decoration:underline" title="Ver adjunto de esta orden">— '+ref+'</span></div>';
  // De qué reposición viene. Se muestra aunque no haya registro de
  // diferencias: el origen de la orden es un dato por sí solo.
  // De qué reposición viene. Si hay registro de diferencias, la etiqueta es
  // el acceso: un clic aquí lo abre, sin tener que entrar a la orden.
  if(p.num_reposicion){
    var _dif=_nsapDifDe(p);
    var _nd=_dif?((_dif.faltan||[]).length+(_dif.agregados||[]).length+(_dif.distintos||[]).length):0;
    var _clic=_dif
      ? ' onclick="event.stopPropagation();event.stopImmediatePropagation();_nsapVerDif(\''+_esc(_k)+'\')" '
        +'title="Ver las diferencias contra la reposición '+_esc(p.num_reposicion)+'" '
      : ' title="Esta orden salió de la reposición '+_esc(p.num_reposicion)+'" ';
    h+='<div class="nsap-dif-chip" style="margin-top:3px;display:inline-flex;align-items:center;gap:5px'
      +(_dif?';cursor:pointer':'')+'"'+_clic+'>'
      +'<span style="font-size:10px;background:var(--pastel-lila);border:1px solid #C4B5FD;color:var(--t-lila);'
      +'border-radius:8px;padding:1px 7px;font-weight:700">'
      +'<i class="ti ti-repeat" style="font-size:9px"></i> '+_esc(p.num_reposicion)+'</span>'
      +(_dif?('<span style="font-size:10px;font-weight:600;color:'
        +(_dif.cuadra?'#166534':'#B45309')+';text-decoration:underline;text-underline-offset:2px">'
        +(_dif.cuadra?'sin cambios':(_nd+' diferencia(s)'))+'</span>')
        : '<span title="La comparación no quedó guardada con esta orden" '
          +'style="font-size:10px;color:var(--text-muted)">sin registro</span>')
      +'</div>';
  }
  h+=(p.po?'<div style="font-size:10px;color:var(--text-muted);margin-top:1px">PO: '+p.po+'</div>':'');
  h+='<div style="font-size:10px;color:var(--text-muted);margin-top:1px">'+(mostrarDept&&p.dept?(EMOJIS2[p.dept]||'')+' '+dL(p.dept)+' · ':'')+(p.creado_en||p.fecha||'')+(p.by?' · '+p.by:'')+'</div>';
  h+='<div style="display:flex;gap:5px;margin-top:4px;flex-wrap:wrap">'+_badgeDiasSAP(dias);
  if(window._atts&&window._atts[_k+'__pendsap']&&window._atts[_k+'__pendsap'].length){
    h+='<span style="font-size:10px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:1px 7px;color:var(--text-muted)"><i class="ti ti-paperclip" style="font-size:9px"></i> '+window._atts[_k+'__pendsap'].length+'</span>';
  }
  h+='</div>';
  h+='</div>';
  if(CU.verCostos){
    h+='<div style="text-align:right;flex-shrink:0">';
    h+='<div style="font-size:13px;font-weight:700;color:var(--t-ambar)">'+fmt(total)+'</div>';
    h+='<div style="font-size:10px;color:var(--text-success)">Ab: '+fmt(abon)+'</div>';
    h+='<div style="font-size:10px;color:var(--text-danger)">Saldo: '+fmt(saldo)+'</div>';
    h+='</div>';
  }
  h+='</div>';
  // Acciones: revisar con IA, ver/editar, eliminar
    // Vista previa adjunto (C1b)
  var _ak2=_k+'__pendsap';
  var _al2=window._atts&&window._atts[_ak2]?window._atts[_ak2]:[];
  if(!_al2.length&&p.adjunto_url)_al2=[{name:p.adjunto_name||'adjunto',data:p.adjunto_url}];
  if(_al2.length){
    h+='<div style="margin-top:8px;display:flex;flex-wrap:wrap;gap:6px">';
    _al2.forEach(function(a){
      var ext2=(a.name||'').split('.').pop().toLowerCase();
      var url2=a.data||a.url||'';
      if(['jpg','jpeg','png','gif','webp'].includes(ext2)){
        h+='<img src="'+url2+'" data-src="'+url2+'" class="att-img" onclick="event.stopPropagation()" style="height:60px;border-radius:6px;border:0.5px solid var(--border);cursor:zoom-in;object-fit:cover" title="'+a.name+'">';
      } else if(ext2==='pdf'){
        h+='<a href="'+url2+'" target="_blank" onclick="event.stopPropagation()" style="display:inline-flex;align-items:center;gap:5px;padding:5px 10px;background:#FEF0F0;border:0.5px solid #f5c9a0;border-radius:7px;font-size:11px;color:var(--t-ambar);text-decoration:none"><i class="ti ti-file-type-pdf" style="font-size:14px"></i>'+a.name+'</a>';
      } else {
        h+='<a href="'+url2+'" target="_blank" onclick="event.stopPropagation()" style="display:inline-flex;align-items:center;gap:5px;padding:5px 10px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:7px;font-size:11px;color:var(--text-accent);text-decoration:none"><i class="ti ti-file-spreadsheet" style="font-size:14px"></i>'+a.name+'</a>';
      }
    });
    h+='</div>';
  }
  h+='<div style="display:flex;gap:6px;margin-top:8px;flex-wrap:wrap">';
  h+='<button onclick="event.stopPropagation();revisarPendSAPIA(\''+_k+'\')" style="background:var(--pastel-lila);color:var(--t-lila);border:none;border-radius:6px;padding:5px 10px;cursor:pointer;font-size:11px;font-weight:600"><i class="ti ti-sparkles" style="font-size:11px"></i> AI revisar</button>';
  h+='<button onclick="event.stopPropagation();abrirPendSAP(\''+_k+'\')" style="background:var(--surface-2);border:0.5px solid var(--border);border-radius:6px;padding:5px 10px;cursor:pointer;font-size:11px"><i class="ti ti-eye" style="font-size:11px"></i> Ver / adjuntos</button>';
  h+='<button onclick="event.stopPropagation();eliminarPendSAP(\''+_k+'\')" style="background:none;border:0.5px solid var(--border-danger);color:var(--text-danger);border-radius:6px;padding:5px 8px;cursor:pointer;font-size:11px"><i class="ti ti-trash" style="font-size:11px"></i></button>';
  h+=_catBtnOrden(_k);
  h+=_smBtn(_k);
  h+='</div>';
  h+='</div>';
  return h;
}

// Lee el registro guardado de un pendiente (venga como objeto o como texto)
function _nsapDifDe(p){
  if(!p || !p.dif_reposicion) return null;
  var d=p.dif_reposicion;
  if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(e){ return null; } }
  return (d && d.num) ? d : null;
}

// La ventana con el registro completo
// Los documentos de las dos partes: el PDF/Excel de la reposición que se le
// mandó a la compradora, y lo que se adjuntó al crear la orden NO SAP.
function _nsapDocsHTML(titulo, lista, color){
  lista=(lista||[]).filter(function(a){ return a && _docHref(a); });
  if(!lista.length) return '';
  var h='<div style="margin-top:10px"><div style="font-size:10px;font-weight:700;'
    +'text-transform:uppercase;letter-spacing:.4px;color:'+color+';margin-bottom:4px">'
    +_esc(titulo)+'</div><div style="display:flex;gap:6px;flex-wrap:wrap">';
  lista.forEach(function(a){
    var nom=String(a.name||a.nombre_archivo||'archivo');
    var ext=nom.split('.').pop().toLowerCase();
    var ico=(ext==='pdf')?'ti-file-type-pdf'
           :(['xlsx','xls','csv'].indexOf(ext)>=0)?'ti-file-spreadsheet'
           :(['jpg','jpeg','png','gif','webp'].indexOf(ext)>=0)?'ti-photo':'ti-file';
    h+='<a href="'+_esc(_docHref(a))+'" target="_blank" rel="noopener" '
      +'style="display:inline-flex;align-items:center;gap:6px;padding:6px 11px;'
      +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:11px;color:var(--text-accent);text-decoration:none;max-width:280px">'
      +'<i class="ti '+ico+'" style="font-size:14px"></i>'
      +'<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(nom)+'</span></a>';
  });
  return h+'</div></div>';
}

// Los archivos que viajaron en el correo de la reposición.
// Ojo con el formato: el envío los guarda como {path, nombre} — no como
// {url, name} —, y por eso antes no aparecía ninguno en el panel.
function _repArchivoNormal(a){
  if(!a) return null;
  var nom=a.nombre||a.name||a.nombre_archivo||'';
  var url=_docHref(a);
  if(!url && a.path){
    url=DOCS_BASE + String(a.path).split('/').map(encodeURIComponent).join('/');
    if(!nom) nom=String(a.path).split('/').pop();
  }
  if(!url) return null;
  return {name:nom||'archivo', url:url};
}

function _repArchivosDe(fila){
  var a=fila && fila.archivos;
  if(!a) return [];
  if(typeof a==='string'){ try{ a=JSON.parse(a); }catch(e){ return []; } }
  if(!Array.isArray(a)) return [];
  return a.map(_repArchivoNormal).filter(Boolean);
}

async function _nsapArchivosRepo(num){
  var n=String(num||'').trim().toUpperCase(), val=_repNumVal(n);
  try{
    var r=await fetch(SB+'/rest/v1/reposiciones_envios'
      +'?select=id,num_reposicion,pedido_id,archivos&order=id.desc&limit=500',{headers:SBH});
    if(!r.ok) return [];
    var envs=await r.json()||[];

    // 1) Por número de reposición
    var e=envs.find(function(x){
      var t=String(x.num_reposicion||'').trim().toUpperCase();
      return (t===n || (val && _repNumVal(t)===val)) && _repArchivosDe(x).length; });
    if(e) return _repArchivosDe(e);

    // 2) Si el número no llegó al envío, se busca el pedido y se va por su id
    var ped=null;
    try{ ped=await _repBuscarPedidoPorNum(n); }catch(err){}
    if(ped && ped.id){
      var e2=envs.find(function(x){
        return String(x.pedido_id)===String(ped.id) && _repArchivosDe(x).length; });
      if(e2) return _repArchivosDe(e2);
    }
    return [];
  }catch(err){ console.warn('[reposición] archivos:', err); return []; }
}

async function _nsapVerDif(ref){
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===String(ref) || String(x.num_orden)===String(ref); });
  var d=_nsapDifDe(p);
  if(!d){ showT('Esta orden no tiene registro de reposición'); return; }

  var prev=document.getElementById('modalDifRepo'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalDifRepo';
  // Por encima de cualquier otro panel del portal
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13600;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:14px;padding:18px;'
      +'max-width:760px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px">'
      +'<div><div style="font-size:14px;font-weight:700">'
        +'<i class="ti ti-git-compare"></i> Orden '+_esc(ref)+' contra la reposición '+_esc(d.num||'')+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'
        +'Comparación hecha al crear la orden'+(d.fecha?(' · '+_esc(d.fecha)):'')
        +(d.por?(' · '+_esc(d.por)):'')+'</div></div>'
      +'<button onclick="document.getElementById(\'modalDifRepo\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'
    + _nsapDifPanelHTML(d)
    +'<div id="difDocs"><div style="font-size:11px;color:var(--text-muted);margin-top:10px">'
      +'<i class="ti ti-loader-2 spin"></i> Buscando los documentos…</div></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px;margin-top:12px">'
      +'<button class="btn" onclick="_nsapCopiarDif(\''+_esc(ref)+'\')">'
        +'<i class="ti ti-copy"></i> Copiar el detalle</button>'
      +'<button class="btn bg2" onclick="document.getElementById(\'modalDifRepo\').remove()">Cerrar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}

  // Los documentos se cargan después, para que el panel aparezca ya
  var docs=document.getElementById('difDocs');
  var arch=[];
  try{ arch=await _nsapArchivosRepo(d.num); }catch(e){}
  // Los documentos de la orden viven en dos llaves distintas según por dónde
  // se subieron ('__pendsap' al crearla, 'pedido' desde la etapa). Mirar una
  // sola dejaba fuera los de la otra. _docsBaseOrden junta las dos y quita
  // repetidos, que es lo mismo que usa la solicitud de abono.
  var deOrden=[];
  try{ deOrden=_docsBaseOrden(String(ref))||[]; }
  catch(e){ deOrden=(window._atts&&window._atts[String(ref)+'__pendsap'])||[]; }
  // Si todavía no se cargaron, se piden ahora
  if(!deOrden.length){
    try{
      await cargarDocsOrden(String(ref));
      deOrden=_docsBaseOrden(String(ref))||[];
    }catch(e){}
  }
  if(!docs || !document.body.contains(ov)) return;
  var h2=_nsapDocsHTML('Reposición '+(d.num||'')+' — PDF y Excel que se enviaron', arch, '#5B21B6');
  if(!h2){
    // Se dice que no están, en vez de no mostrar el bloque: así se sabe que
    // se buscó y que esa reposición no dejó archivos guardados.
    h2='<div style="margin-top:10px"><div style="font-size:10px;font-weight:700;'
      +'text-transform:uppercase;letter-spacing:.4px;color:var(--t-lila);margin-bottom:4px">'
      +'Reposición '+_esc(d.num||'')+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted)"><i class="ti ti-paperclip"></i> '
      +'No quedaron archivos guardados de esta reposición.</div></div>';
  }
  var h3=_nsapDocsHTML('Orden '+ref+' — lo que se adjuntó al crearla', deOrden, '#B45309');
  if(!h3){
    h3='<div style="margin-top:10px"><div style="font-size:10px;font-weight:700;'
      +'text-transform:uppercase;letter-spacing:.4px;color:var(--t-ambar);margin-bottom:4px">'
      +'Orden '+_esc(String(ref))+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted)"><i class="ti ti-paperclip"></i> '
      +'Esta orden no tiene documentos adjuntos.</div></div>';
  }
  docs.innerHTML=h2+h3;
}

function _nsapCopiarDif(ref){
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===String(ref) || String(x.num_orden)===String(ref); });
  var d=_nsapDifDe(p); if(!d) return;
  var txt=d.texto||_nsapDifTexto(d);
  try{
    navigator.clipboard.writeText(txt);
    showT('✓ Detalle copiado');
  }catch(e){ showT('No se pudo copiar'); }
}

// Panel del dashboard: lista TODAS las órdenes sin SAP agrupadas por departamento
function buildPendientesSAP(filtroDept, mostrarForm){
  var todas=filtroDept?pendSAPporDept(filtroDept):pendientesSAPVisibles();
  var h='';
  if(!todas.length){ h+='<div class="empty">No hay órdenes sin SAP'+(filtroDept?' en este departamento':'')+'.</div>'; return h; }
  if(filtroDept){
    todas.forEach(function(p){ h+=_pendSAPFila(p, false); });
    return h;
  }
  // Agrupar por departamento
  var porDept={};
  todas.forEach(function(p){ var d=p.dept||'otros'; (porDept[d]=porDept[d]||[]).push(p); });
  DEPTS_ALL.forEach(function(d){
    var lista=porDept[d]; if(!lista||!lista.length) return;
    var total=lista.reduce(function(s,p){return s+(Number(p.total)||0);},0);
    var abon=lista.reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
    h+='<div style="padding:8px 12px;background:var(--surface-1);border-bottom:0.5px solid var(--border);display:flex;align-items:center;gap:8px;flex-wrap:wrap">';
    h+='<span style="font-size:12px;font-weight:600">'+(EMOJIS2[d]||'')+' '+dL(d)+'</span>';
    h+='<span style="font-size:11px;color:var(--text-muted)">'+lista.length+' orden'+(lista.length!==1?'es':'')+(CU.verCostos?' · <strong style="color:var(--t-ambar)">'+fmt(total)+'</strong> · Ab: <strong style="color:var(--text-success)">'+fmt(abon)+'</strong> · Saldo: <strong style="color:var(--text-danger)">'+fmt(total-abon)+'</strong>':'')+'</span>';
    h+='</div>';
    h+='<div style="padding:8px 12px">';
    lista.forEach(function(p){ h+=_pendSAPFila(p, false); });
    h+='</div>';
  });
  return h;
}

// Modal para AGREGAR una orden manual sin SAP (se abre desde la etapa Bodega & Venta)
function abrirNuevaOrdenSinSAP(deptPre, prefill){
  window._nsapCardcode=''; window._nsapProvNuevoOK=false; window._nsapProvUltimo='';
  window._nsapDocs={prov:null, kcc:null}; window._nsapArchivo=null;
  window._nsapItems=[];   // reiniciar productos al abrir
  var ov=document.createElement('div');
  ov.id='modalNuevaSAP';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1002;display:flex;align-items:center;justify-content:center;padding:16px';
  window._nsapFull=false;
  var opts='<option value="">Departamento…</option>'+DEPTS_ALL.map(function(d){return '<option value="'+d+'"'+(deptPre===d?' selected':'')+'>'+(EMOJIS2[d]||'')+' '+dL(d)+'</option>';}).join('');
  var h='<div id="nsapPanel" style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:980px;width:100%;max-height:90vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">'
    +'<div style="font-size:15px;font-weight:600"><i class="ti ti-plus" style="color:var(--t-ambar)"></i> Nueva orden sin SAP</div>'
    +'<div style="display:flex;align-items:center;gap:4px">'
      +'<button onclick="_nsapPantallaCompleta()" id="nsapFullBtn" title="Pantalla completa"'
        +' style="background:none;border:none;cursor:pointer;color:var(--text-muted);padding:2px 6px">'
        +'<i class="ti ti-arrows-maximize" id="nsapFullIco" style="font-size:17px"></i></button>'
      +'<button onclick="_nsapCerrarModal()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div></div>';
  try{ h+=_nsapAvisoDraft(); }catch(e){}
  // Paso 1: adjuntar documento para que la IA extraiga
  h+='<div style="background:var(--pastel-lila);border:0.5px solid #C4B5FD;border-radius:8px;padding:11px;margin-bottom:12px">';
  h+='<div style="font-size:12px;font-weight:600;color:var(--t-lila);margin-bottom:6px"><i class="ti ti-sparkles"></i> Extraer datos con AI</div>';
  h+='<div style="font-size:11px;color:var(--t-lila);margin-bottom:8px">Adjunta los dos documentos. La IA extrae los datos y compara uno contra otro para avisarte de cualquier diferencia.</div>';
  h+='<div style="display:flex;flex-direction:column;gap:7px">';
  // Dos adjuntos: la PI del proveedor y nuestra orden de compra
  h+=_nsapCajaArchivo('prov','PI PROVEEDOR','Proforma Invoice del proveedor','#B45309','#FEF9F3','#E9C08A');
  h+=_nsapCajaArchivo('kcc','KCC ORDEN DE COMPRA','Nuestra orden de compra','#0c447c','#e6f1fb','#85B7EB');
  h+='</div>';
  h+='<button id="nsapBtnIA" class="btn bp" style="background:#5B21B6;width:100%;margin-top:9px;padding:9px;font-size:12.5px" onclick="_nsapRevisarConIA()"><i class="ti ti-sparkles"></i> Revisar y comparar con IA</button>';
  h+='<button class="btn bg2" style="width:100%;margin-top:6px;padding:7px;font-size:11.5px" '
    +'onclick="_nsapSacarFotos()" title="Extrae las fotos incrustadas en el Excel del proveedor">'
    +'<i class="ti ti-photo-search"></i> Sacar las fotos del Excel</button>';
  h+='<div id="nsapIAstatus" style="font-size:11px;margin-top:7px"></div>';
  h+='<div id="nsapIAerrores" style="margin-top:7px"></div>';
  h+='</div>';
  // Paso 2: campos (los llena la IA, editables)
  h+='<div style="display:flex;flex-direction:column;gap:9px">';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Departamento *</label><select id="nsapDept" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1)">'+opts+'</select></div>';
  h+='<div><div style="display:flex;gap:8px">'
    +'<div style="flex:1;min-width:0"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Proveedor *</label>'
      +'<input id="nsapProv" placeholder="Nombre del proveedor" onblur="_nsapBuscarProvSAP()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>'
    +'<div style="flex:0 0 120px"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Código SAP</label>'
      +'<input id="nsapProvCod" placeholder="Ej: P1276" onblur="_nsapCodigoManual(this.value)" onkeydown="if(event.key===\'Enter\'){event.preventDefault();_nsapCodigoManual(this.value);}" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;font-weight:700;text-transform:uppercase"></div>'
    +'</div>'
    +'<div id="nsapProvSAP" style="margin-top:4px"></div></div>';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de orden (DKC / SKC) *</label><input id="nsapRef" placeholder="Ej: DKC-25090 o SKC-25090" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="display:flex;gap:8px">'
    +'<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de PO del proveedor</label>'
      +'<input id="nsapPO" placeholder="PO del proveedor" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>'
    +'<div style="flex:0 0 200px"><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de reposición</label>'
      +'<input id="nsapNumRepo" placeholder="Ej: R-01" oninput="_nsapRepoCambio()" '
      +'title="Si el documento viene de una reposición, la IA lo completa solo. Si no, dejalo vacío." '
      +'style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;font-weight:700;text-transform:uppercase"></div>'
    +'</div>';
  h+='<div id="nsapRepoBox" style="display:none"></div>';
  h+='<div style="display:flex;gap:8px">';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Total *</label><input id="nsapTotal" type="number" step="0.01" placeholder="0.00" oninput="_nsapCalcSaldo()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Por Abonar</label><input id="nsapAbon" type="number" step="0.01" placeholder="0.00" oninput="_nsapCalcSaldo()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:0 0 92px"><label style="font-size:11px;color:var(--text-muted);font-weight:500">% Abono</label>'
    +'<input id="nsapAbonPct" type="number" step="0.01" min="0" max="100" placeholder="0" oninput="_nsapAbonoDesdePct()" '
    +'title="Escribe el porcentaje y se calcula el monto sobre el total" '
    +'style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;font-weight:700"></div>';
  h+='<div style="flex:0 0 168px;display:flex;align-items:flex-end;padding-bottom:1px">'
    +'<label id="nsapContraBLBox" style="display:flex;align-items:center;gap:7px;cursor:pointer;'
    +'border:1px solid var(--border);border-radius:7px;padding:8px 9px;background:var(--surface-1);width:100%">'
      +'<input type="checkbox" id="nsapContraBL" onchange="_nsapContraBLCambio()" style="cursor:pointer">'
      +'<span style="font-size:11px;font-weight:600;line-height:1.25">100% contra<br>copia de B/L</span>'
    +'</label></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Fecha abono</label><input id="nsapFechaAbono" type="date" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Saldo</label><input id="nsapSaldo" type="number" step="0.01" placeholder="0.00" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1)" readonly></div>';
  h+='</div>';
  h+='</div>';
  // Sección de productos (obligatoria) — se llena con IA o a mano
  h+='<div style="margin-top:14px;border-top:0.5px solid var(--border);padding-top:12px">';
  h+='<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px">'
    +'<label style="font-size:12px;font-weight:600;color:var(--t-ambar)"><i class="ti ti-list-details"></i> Productos de la orden *</label>'
    +'<button onclick="_nsapAddItemManual()" style="font-size:11px;padding:3px 8px;border:0.5px solid #B45309;background:var(--pastel-aviso);color:var(--t-ambar);border-radius:6px;cursor:pointer"><i class="ti ti-plus"></i> Agregar producto</button>'
  +'</div>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-bottom:6px">Se extraen automáticamente del documento con IA. Puedes editarlos o agregarlos a mano. (Obligatorio: al menos 1)</div>';
  h+='<div id="nsapItemsBox"></div>';
  h+='</div>';
  h+='<div style="display:flex;gap:8px;margin-top:16px">'
    +'<button onclick="_nsapGuardarDraft()" style="flex:1;background:var(--surface-1);color:var(--text-secondary);border:0.5px solid var(--border);border-radius:8px;padding:11px;cursor:pointer;font-size:12.5px;font-weight:600"><i class="ti ti-device-floppy"></i> Guardar borrador</button>'
    +'<button onclick="guardarNuevaOrdenSinSAP()" style="flex:2;background:#B45309;color:white;border:none;border-radius:8px;padding:11px;cursor:pointer;font-size:13px;font-weight:600"><i class="ti ti-check"></i> Crear orden sin SAP</button>'
  +'</div>';
  h+='</div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ e.stopPropagation(); });   // no se cierra al hacer clic fuera: hay datos escritos
  document.body.appendChild(ov);
  window._nsapItems=window._nsapItems||[];
  _nsapRenderItems();
  // Prellenado al venir desde una orden firmada (amarre por DKC).
  if(prefill){
    try{
      var _r=document.getElementById('nsapRef');   if(_r && prefill.ref)  _r.value=prefill.ref;
      var _p=document.getElementById('nsapProv');  if(_p && prefill.prov) _p.value=prefill.prov;
      var _t=document.getElementById('nsapTotal'); if(_t && prefill.total){ _t.value=prefill.total; if(typeof _nsapCalcSaldo==='function') _nsapCalcSaldo(); }
    }catch(_e){}
  }
}
// Renderiza la lista editable de productos de la orden No SAP
function _nsapRenderItems(){
  var box=document.getElementById('nsapItemsBox');
  if(!box) return;
  var items=window._nsapItems||[];
  if(!items.length){
    box.innerHTML='<div style="font-size:11px;color:var(--text-muted);padding:8px;text-align:center;border:1px dashed var(--border);border-radius:6px">Aún no hay productos. Sube un documento (se leen con IA) o agrégalos a mano.</div>';
    return;
  }
  box.innerHTML=items.map(function(it,i){
    var tl=(it.total_linea!=null?it.total_linea:((it.cantidad||0)*(it.precio_unit||0)));
    return '<div style="display:flex;gap:6px;align-items:center;margin-bottom:5px">'
      // La foto que se sacó del Excel, para confirmar que se leyó bien
      +(it._foto
        ? ('<img src="'+_esc(it._foto)+'" class="nsap-foto-mini" onclick="_nsapVerFoto('+i+')" '
           +'title="Pasá el mouse para verla grande · pulsa para abrirla">')
        : ('<span title="Sin foto en el Excel" style="width:34px;height:34px;border-radius:5px;'
           +'border:0.5px dashed var(--border);display:flex;align-items:center;justify-content:center;'
           +'color:var(--text-muted);flex-shrink:0"><i class="ti ti-photo-off" style="font-size:13px"></i></span>'))
      +'<input value="'+_esc(it.itemcode||'')+'" onchange="_nsapItemEdit('+i+',\'itemcode\',this.value)" placeholder="Cód. KCC" '
      +'title="'+(it._enSAP?'Ya existe en SAP: no se crea ficha NO SAP y la foto sale del inventario':'Todavía no está en SAP')+'" '
      +'style="width:95px;padding:5px 7px;border:0.5px solid '+(it._enSAP?'#16a34a':'var(--border)')+';'
      +'border-radius:6px;font-size:12px'+(it._enSAP?';background:#f0fdf4':'')+'">'
      +(it._enSAP?'<span title="Ya está en SAP" style="font-size:9px;font-weight:700;color:var(--t-verde);background:var(--pastel-ok);border-radius:8px;padding:1px 6px;flex-shrink:0">SAP</span>':'')
      +'<input value="'+_esc(it.itemname||'')+'" onchange="_nsapItemEdit('+i+',\'itemname\',this.value)" placeholder="Descripción" style="flex:1;padding:5px 7px;border:0.5px solid var(--border);border-radius:6px;font-size:12px">'
      +'<input type="number" value="'+(it.cantidad||0)+'" onchange="_nsapItemEdit('+i+',\'cantidad\',this.value)" placeholder="Cant" title="Cantidad" style="width:56px;padding:5px 7px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;text-align:center">'
      +'<input type="number" step="0.01" value="'+(it.precio_unit||0)+'" onchange="_nsapItemEdit('+i+',\'precio_unit\',this.value)" placeholder="P.Unit" title="Precio unitario" style="width:66px;padding:5px 7px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;text-align:right">'
      +'<span title="Total línea" style="width:74px;text-align:right;font-size:12px;font-weight:600;color:var(--t-ambar)">'+(typeof _fmtN2==='function'?_fmtN2(tl):Number(tl).toFixed(2))+'</span>'
      +'<button onclick="_nsapItemDel('+i+')" style="width:26px;height:26px;border:0.5px solid var(--border);background:var(--surface-1);color:var(--text-danger);border-radius:6px;cursor:pointer">×</button>'
    +'</div>';
  }).join('');
}
// Vuelve a revisar los números cuando se editan los productos a mano
function _nsapRevisarAhora(){
  if(!document.getElementById('nsapIAerrores')) return;
  if(!(window._nsapItems||[]).length) return;
  var el=document.getElementById('nsapTotal');
  var total=el?(parseFloat(el.value)||0):0;
  window._nsapProblemas=_nsapPintarRevision(null, _nsapRevisarNumeros(window._nsapItems, total));
}

function _nsapAddItemManual(){
  window._nsapItems=window._nsapItems||[];
  window._nsapItems.push({itemcode:'',itemname:'',cantidad:0});
  _nsapRenderItems();
}
function _nsapItemEdit(i,campo,val){
  if(!window._nsapItems||!window._nsapItems[i])return;
  var it=window._nsapItems[i];
  if(campo==='cantidad'||campo==='precio_unit'){
    it[campo]=Number(val)||0;
    it.total_linea=(it.cantidad||0)*(it.precio_unit||0);
    _nsapRenderItems();  // refrescar para mostrar el nuevo total
  } else {
    it[campo]=val;
  }
  _nsapRevisarAhora();
}
function _nsapItemDel(i){
  if(!window._nsapItems)return;
  window._nsapItems.splice(i,1);
  _nsapRenderItems();
  _nsapRevisarAhora();
}
// desdePct = lo llamó el campo de porcentaje; no se recalcula el % para no
// pisar lo que se está escribiendo.
function _nsapCalcSaldo(desdePct){
  var elT=document.getElementById('nsapTotal'), elA=document.getElementById('nsapAbon');
  var t=elT?(parseFloat(elT.value)||0):0;
  var a=elA?(parseFloat(elA.value)||0):0;
  var s=document.getElementById('nsapSaldo'); if(s) s.value=(t-a).toFixed(2);
  if(!desdePct){
    var p=document.getElementById('nsapAbonPct');
    if(p) p.value = (t>0 && a) ? (Math.round(a/t*10000)/100) : '';
  }
  try{ _nsapRevisarAhora(); }catch(e){}
}

// El porcentaje manda sobre el monto: 30 sobre un total de 1.000 pone 300
function _nsapAbonoDesdePct(){
  var elT=document.getElementById('nsapTotal');
  var elP=document.getElementById('nsapAbonPct');
  var elA=document.getElementById('nsapAbon');
  if(!elP || !elA) return;
  var t=elT?(parseFloat(elT.value)||0):0;
  var p=parseFloat(elP.value);
  if(isNaN(p)){ _nsapCalcSaldo(true); return; }
  elA.value=(Math.round(t*p)/100).toFixed(2);
  _nsapCalcSaldo(true);
}

// ═══════════════════════════════════════════════════════════════════════════
//  REPOSICIÓN ↔ ORDEN NO SAP
//  Si la orden viene de una reposición, se puede cotejar línea por línea lo
//  que se pidió contra lo que el proveedor está facturando.
// ═══════════════════════════════════════════════════════════════════════════
function _nsapRepoCambio(){
  var el=document.getElementById('nsapNumRepo');
  var box=document.getElementById('nsapRepoBox');
  if(!el || !box) return;
  var v=String(el.value||'').trim().toUpperCase();
  if(!v){ box.style.display='none'; box.innerHTML=''; return; }
  box.style.display='block';
  box.innerHTML='<button class="btn bg2" style="padding:6px 12px;font-size:11.5px;'
    +'border-color:#C4B5FD;color:var(--t-lila);font-weight:600" onclick="_nsapCompararRepo()">'
    +'<i class="ti ti-git-compare"></i> Comparar reposición '+_esc(v)+' contra esta orden</button>'
    +'<div id="nsapRepoDif" style="margin-top:8px"></div>';
}

// Compara lo que se pidió en la reposición contra lo que se está cargando en
// la orden. Función pura: la usan el botón de comparar y el guardado, para
// que el log que queda archivado sea exactamente lo que se vio en pantalla.
function _nsapCalcularDif(lineasRepo, items){
  var enRepo={}, enOrden={};
  (lineasRepo||[]).forEach(function(it){
    var k=String(it.itemcode||'').trim().toUpperCase();
    if(k) enRepo[k]={code:it.itemcode, name:it.itemname||'', cant:Number(it.cant)||0};
  });
  (items||[]).forEach(function(it){
    var k=String(it.itemcode||'').trim().toUpperCase();
    if(k) enOrden[k]={code:it.itemcode, name:it.itemname||'', cant:Number(it.cantidad)||0};
  });

  var faltan=[], agregados=[], distintos=[], iguales=0;
  Object.keys(enRepo).forEach(function(k){
    if(!enOrden[k]){ faltan.push(enRepo[k]); return; }
    if(enRepo[k].cant!==enOrden[k].cant)
      distintos.push({code:enRepo[k].code, name:enRepo[k].name,
                      pedido:enRepo[k].cant, orden:enOrden[k].cant});
    else iguales++;
  });
  Object.keys(enOrden).forEach(function(k){ if(!enRepo[k]) agregados.push(enOrden[k]); });

  var totRepo=Object.keys(enRepo).reduce(function(a,k){ return a+enRepo[k].cant; },0);
  var totOrden=Object.keys(enOrden).reduce(function(a,k){ return a+enOrden[k].cant; },0);

  return { faltan:faltan, agregados:agregados, distintos:distintos, iguales:iguales,
           skuRepo:Object.keys(enRepo).length, skuOrden:Object.keys(enOrden).length,
           totRepo:totRepo, totOrden:totOrden,
           cuadra:(!faltan.length && !agregados.length && !distintos.length) };
}

// El mismo detalle en texto, para el registro que queda guardado
function _nsapDifTexto(d){
  if(!d) return '';
  var L=[];
  L.push('Reposición '+(d.num||'')+' → orden '+(d.dkc||''));
  L.push('Reposición: '+d.skuRepo+' SKU · '+_repNum(d.totRepo)+' pzs');
  L.push('Orden:      '+d.skuOrden+' SKU · '+_repNum(d.totOrden)+' pzs');
  L.push('Coinciden exactos: '+d.iguales);
  if(d.cuadra){ L.push(''); L.push('Todo coincide: mismos artículos y mismas cantidades.'); return L.join('\n'); }
  if(d.faltan.length){
    L.push(''); L.push('NO SE PIDIERON (estaban en la reposición):');
    d.faltan.forEach(function(f){ L.push('  · '+f.code+'  '+f.name+'  — faltan '+_repNum(f.cant)+' pzs'); });
  }
  if(d.agregados.length){
    L.push(''); L.push('AGREGADOS (no estaban en la reposición):');
    d.agregados.forEach(function(f){ L.push('  · '+f.code+'  '+f.name+'  — '+_repNum(f.cant)+' pzs'); });
  }
  if(d.distintos.length){
    L.push(''); L.push('DISTINTA CANTIDAD:');
    d.distintos.forEach(function(f){
      var dif=f.orden-f.pedido;
      L.push('  · '+f.code+'  '+f.name+'  — pedido '+_repNum(f.pedido)+' → orden '
        +_repNum(f.orden)+' ('+(dif>0?'+':'')+_repNum(dif)+')');
    });
  }
  return L.join('\n');
}

// El panel que se ve, tanto al comparar como después en la orden
function _nsapDifPanelHTML(d, compacto){
  if(!d) return '';
  function tabla(titulo, color, filas, cols){
    if(!filas.length) return '';
    var t='<div style="margin-top:8px"><div style="font-size:11px;font-weight:700;color:'+color+';margin-bottom:3px">'
      +titulo+' ('+filas.length+')</div>'
      +'<table style="width:100%;border-collapse:collapse;font-size:11px">';
    filas.forEach(function(f){
      t+='<tr style="border-top:0.5px solid var(--border)">'
        +'<td style="padding:3px 5px;font-family:monospace;white-space:nowrap">'+_esc(f.code||'')+'</td>'
        +'<td style="padding:3px 5px;color:var(--text-secondary)">'+_esc(String(f.name||'').slice(0,44))+'</td>'
        +cols(f)+'</tr>';
    });
    return t+'</table></div>';
  }

  var h='<div style="border:1px solid '+(d.cuadra?'#16a34a':'#E9C08A')+';border-radius:9px;overflow:hidden'
    +(compacto?';margin-bottom:12px':'')+'">'
    +'<div style="background:'+(d.cuadra?'#dcfce7':'#FEF9F3')+';padding:8px 11px;font-size:12px;'
      +'font-weight:700;color:'+(d.cuadra?'#166534':'#7C3D12')+'">'
      +'<i class="ti '+(d.cuadra?'ti-circle-check':'ti-git-compare')+'"></i> '
      +'Diferencias contra la reposición '+_esc(d.num||'')
      +(d.fecha?('<span style="float:right;font-weight:500;font-size:10.5px">'+_esc(d.fecha)+'</span>'):'')
      +'</div>'
    +'<div style="padding:9px 11px;font-size:11.5px">'
    +'<div style="display:flex;gap:14px;flex-wrap:wrap;margin-bottom:8px;color:var(--text-secondary)">'
      +'<span>Reposición: <b>'+d.skuRepo+'</b> SKU · <b>'+_repNum(d.totRepo)+'</b> pzs</span>'
      +'<span>Orden: <b>'+d.skuOrden+'</b> SKU · <b>'+_repNum(d.totOrden)+'</b> pzs</span>'
      +'<span style="color:var(--t-verde)">Coinciden: <b>'+d.iguales+'</b></span>'
    +'</div>';

  if(d.cuadra){
    h+='<div style="color:var(--t-verde)"><i class="ti ti-circle-check"></i> '
      +'Todo coincide: mismos artículos y mismas cantidades.</div>';
  }
  h+=tabla('No se pidieron (estaban en la reposición)', '#991b1b', d.faltan, function(f){
    return '<td style="padding:3px 5px;text-align:right;white-space:nowrap;color:var(--t-rojo)">'
      +_repNum(f.cant)+' pzs pedidas</td>'; });
  h+=tabla('Agregados (no estaban en la reposición)', '#B45309', d.agregados, function(f){
    return '<td style="padding:3px 5px;text-align:right;white-space:nowrap;color:var(--t-ambar)">'
      +_repNum(f.cant)+' pzs agregadas</td>'; });
  h+=tabla('Mismo SKU con distinta cantidad', '#5B21B6', d.distintos, function(f){
    var dd=f.orden-f.pedido;
    return '<td style="padding:3px 5px;text-align:right;white-space:nowrap">'
      +'<span style="color:var(--text-muted)">pedido '+_repNum(f.pedido)+'</span> → '
      +'<b>'+_repNum(f.orden)+'</b> '
      +'<span style="color:'+(dd>0?'#B45309':'#991b1b')+';font-weight:700">('
      +(dd>0?'+':'')+_repNum(dd)+')</span></td>'; });
  return h+'</div></div>';
}

// Busca una reposición por su número.
// Compara por el NÚMERO, no por el texto: así da igual que esté guardada
// como R-4, R-04, "r 04" o con un espacio de más. Buscar con un "=" exacto
// hacía que una reposición que sí existía apareciera como inexistente.
async function _repBuscarPedidoPorNum(num){
  var n=String(num||'').trim().toUpperCase();
  if(!n) return null;
  var val=_repNumVal(n);
  try{
    var r=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=*'
      +'&num_reposicion=not.is.null&order=id.desc&limit=500',{headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      window._repNumError='HTTP '+r.status+' '+String(t).slice(0,180);
      console.warn('[reposición] buscar por número:', window._repNumError);
      return null;
    }
    var filas=await r.json()||[];
    // Se deja a mano la lista de números que sí existen, para poder decirlo
    window._repNumsDisponibles=filas
      .map(function(x){ return String(x.num_reposicion||'').trim(); })
      .filter(Boolean);
    var exacto=filas.find(function(x){
      return String(x.num_reposicion||'').trim().toUpperCase()===n; });
    if(exacto) return exacto;
    var porNum=val?filas.find(function(x){ return _repNumVal(x.num_reposicion)===val; }):null;
    if(porNum) return porNum;

    // Puede que el número haya quedado guardado en el ENVÍO y no en el
    // pedido (pasa cuando la reposición se envió desde una pantalla que no
    // tenía el pedido cargado). El envío guarda pedido_id, así que se llega
    // igual, y de paso se le pone el número al pedido para que no vuelva a
    // faltar.
    var re=await fetch(SB+'/rest/v1/reposiciones_envios?select=pedido_id,num_reposicion'
      +'&num_reposicion=not.is.null&order=id.desc&limit=500',{headers:SBH});
    if(re.ok){
      var envs=await re.json()||[];
      (envs||[]).forEach(function(x){
        var t=String(x.num_reposicion||'').trim();
        if(t && window._repNumsDisponibles.indexOf(t)<0) window._repNumsDisponibles.push(t);
      });
      var env=envs.find(function(x){
        var t=String(x.num_reposicion||'').trim().toUpperCase();
        return t===n || (val && _repNumVal(t)===val); });
      if(env && !env.pedido_id){
        // El envío existe pero nunca se guardó su pedido: no hay líneas
        window._repNumError='La reposición '+n+' se envió sin guardar su detalle '
          +'(el envío no quedó ligado a ningún pedido), así que no hay artículos que comparar.';
      }
      if(env && env.pedido_id){
        var rp=await fetch(SB+'/rest/v1/reposiciones_pedidos?select=*&id=eq.'
          +encodeURIComponent(env.pedido_id)+'&limit=1',{headers:SBH});
        if(rp.ok){
          var dp=await rp.json()||[];
          if(dp.length){
            if(!dp[0].num_reposicion){
              try{
                await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+dp[0].id,{
                  method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
                  body:JSON.stringify({num_reposicion:String(env.num_reposicion).trim()})});
                dp[0].num_reposicion=String(env.num_reposicion).trim();
              }catch(e){}
            }
            return dp[0];
          }
        }
      }
    }
    return null;
  }catch(e){
    window._repNumError=String(e&&e.message||e);
    console.warn('[reposición] buscar por número:', e);
    return null;
  }
}

// Trae las líneas de una reposición por su número
async function _nsapLineasRepo(num){
  var p=await _repBuscarPedidoPorNum(num);
  if(!p) return null;
  var lineas=p.items;
  if(typeof lineas==='string'){ try{ lineas=JSON.parse(lineas); }catch(e){ lineas=[]; } }
  return Array.isArray(lineas)?lineas:[];
}

// Poner uno de los números sugeridos y comparar
function _nsapUsarRepo(num){
  var el=document.getElementById('nsapNumRepo');
  if(!el) return;
  el.value=num;
  try{ _nsapRepoCambio(); }catch(e){}
  _nsapCompararRepo();
}

// Busca la reposición de este proveedor que todavía no tiene orden y la deja
// puesta en el campo. Se usa cuando el documento del proveedor no menciona el
// número: el vínculo no puede depender de que alguien se acuerde de escribirlo.
async function _nsapRepoAuto(){
  var el=document.getElementById('nsapNumRepo');
  if(!el || String(el.value||'').trim()) return;      // ya vino en el documento
  var prov=String(((document.getElementById('nsapProv')||{}).value)||'').trim();
  var code=String(window._nsapCardcode||'').trim();
  if(!prov && !code) return;

  var r=await fetch(SB+'/rest/v1/reposiciones_pedidos'
    +'?select=id,num_reposicion,cardcode,cardname,estado'
    +'&num_reposicion=not.is.null&order=id.desc&limit=200',{headers:SBH});
  if(!r.ok) return;
  var filas=await r.json()||[];
  var nprov=_invNorm(prov), ncode=_invNorm(code);

  var m=filas.find(function(x){
    if(x.estado==='orden_creada') return false;       // esa ya tiene su orden
    var c=_invNorm(x.cardcode), n=_invNorm(x.cardname);
    if(ncode && c && c===ncode) return true;
    if(!nprov || !n) return false;
    return n===nprov || n.indexOf(nprov)>=0 || nprov.indexOf(n)>=0;
  });
  if(!m) return;

  el.value=m.num_reposicion;
  try{ _nsapRepoCambio(); }catch(e){}
  showT('Ligada automáticamente a la reposición '+m.num_reposicion
    +' de este proveedor. Si no es esa, cambiá el número.', 8000);
  try{ await _nsapCompararRepo(); }catch(e){}
}

async function _nsapCompararRepo(){
  var el=document.getElementById('nsapNumRepo');
  var out=document.getElementById('nsapRepoDif');
  if(!el || !out) return;
  var num=String(el.value||'').trim().toUpperCase();
  if(!num){ showT('Escribe el número de reposición'); return; }
  var items=(window._nsapItems||[]);
  if(!items.length){ showT('Primero leé el documento con IA'); return; }

  out.innerHTML='<span class="ai-ring g" style="vertical-align:-2px"></span> Buscando la reposición '+_esc(num)+'…';
  var lineas=null;
  try{ lineas=await _nsapLineasRepo(num); }
  catch(e){ console.warn('[reposición] buscar:', e); }

  if(!lineas){
    // Sin la lista de lo que sí hay, este mensaje no deja avanzar a nadie
    var disp=(window._repNumsDisponibles||[]);
    var err=window._repNumError||'';
    out.innerHTML='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;'
      +'padding:9px 11px;font-size:11.5px;color:var(--t-marron)"><i class="ti ti-alert-circle"></i> '
      +'No encontré ninguna reposición con el número '+_esc(num)+'.'
      +(err?('<br><span style="font-size:10.5px">Error al consultar: '+_esc(err)+'</span>'):'')
      +(disp.length
        ? ('<br><span style="font-size:10.5px">Números que sí existen: '
           +disp.slice(0,25).map(function(x){
               return '<span onclick="_nsapUsarRepo(\''+_esc(String(x).replace(/\\/g,''))+'\')" '
                 +'style="cursor:pointer;background:var(--pastel-lila);border:1px solid #C4B5FD;color:var(--t-lila);'
                 +'border-radius:8px;padding:1px 7px;margin:2px 3px 0 0;display:inline-block;'
                 +'font-weight:700">'+_esc(x)+'</span>'; }).join('')
           +(disp.length>25?' …':'')+'</span>')
        : '<br><span style="font-size:10.5px">Todavía no hay ninguna reposición numerada.</span>')
      +'</div>';
    return;
  }

  var dif=_nsapCalcularDif(lineas, items);
  dif.num=num;
  window._nsapRepoDif=dif;
  out.innerHTML=_nsapDifPanelHTML(dif);
}

// 100% contra copia de B/L: no hay abono. El monto queda en cero, el saldo es
// el total, y al crear la orden se dan por hechos los pasos del depósito para
// que el seguimiento arranque directo en la solicitud del balance final.
function _nsapContraBLCambio(){
  var ck=document.getElementById('nsapContraBL');
  var elA=document.getElementById('nsapAbon');
  var elP=document.getElementById('nsapAbonPct');
  var elF=document.getElementById('nsapFechaAbono');
  var caja=document.getElementById('nsapContraBLBox');
  var on=!!(ck&&ck.checked);
  [elA, elP, elF].forEach(function(el){
    if(!el) return;
    el.disabled=on;
    el.style.opacity=on?0.45:1;
    if(on) el.value='';
  });
  if(caja){
    caja.style.background=on?'#dcfce7':'var(--surface-1)';
    caja.style.borderColor=on?'#16a34a':'var(--border)';
    caja.style.color=on?'#166534':'';
  }
  _nsapCalcSaldo(true);
}

// Pantalla completa del panel de la orden
function _nsapPantallaCompleta(){
  var p=document.getElementById('nsapPanel');
  var ov=document.getElementById('modalNuevaSAP');
  if(!p) return;
  window._nsapFull=!window._nsapFull;
  if(window._nsapFull){
    p.style.maxWidth='100%'; p.style.maxHeight='100vh'; p.style.borderRadius='0';
    if(ov) ov.style.padding='0';
  } else {
    p.style.maxWidth='980px'; p.style.maxHeight='90vh'; p.style.borderRadius='12px';
    if(ov) ov.style.padding='16px';
  }
  var ic=document.getElementById('nsapFullIco');
  if(ic) ic.className='ti '+(window._nsapFull?'ti-arrows-minimize':'ti-arrows-maximize');
  var b=document.getElementById('nsapFullBtn');
  if(b) b.title=window._nsapFull?'Salir de pantalla completa':'Pantalla completa';
}

// Ver en grande la foto que se sacó del Excel
function _nsapVerFoto(i){
  var it=(window._nsapItems||[])[i];
  if(!it || !it._foto) return;
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.82);z-index:10050;'
    +'display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
  ov.innerHTML='<div style="max-width:92vw;max-height:92vh;text-align:center">'
    +'<img src="'+_esc(it._foto)+'" style="max-width:92vw;max-height:84vh;object-fit:contain;'
    +'border-radius:10px;background:var(--surface-2);box-shadow:0 20px 60px rgba(0,0,0,.5)">'
    +'<div style="color:#fff;font-size:12.5px;margin-top:10px">'
    +_esc(it.itemcode||'')+(it.itemname?(' — '+_esc(it.itemname)):'')+'</div></div>';
  ov.addEventListener('click', function(){ ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}
}
// ═══════════════════════════════════════════════════════════════════════════
//  IDENTIFICAR EL PROVEEDOR CONTRA SAP (orden NO SAP)
//  El nombre viene de la proforma y puede traer una letra distinta, un punto
//  de más o el "CO., LTD" escrito de otra forma. Antes de dar por nuevo a un
//  proveedor se buscan los parecidos, para no duplicar en SAP por un typo.
// ═══════════════════════════════════════════════════════════════════════════
window._nsapCardcode='';        // código elegido/confirmado
window._nsapProvNuevoOK=false;  // ya se confirmó que es nuevo

// Distancia de edición (Levenshtein) con dos filas, suficiente para nombres
function _nsapLev(a,b){
  a=String(a||''); b=String(b||'');
  if(a===b) return 0;
  if(!a.length) return b.length;
  if(!b.length) return a.length;
  var prev=new Array(b.length+1), cur=new Array(b.length+1), i, j;
  for(j=0;j<=b.length;j++) prev[j]=j;
  for(i=1;i<=a.length;i++){
    cur[0]=i;
    for(j=1;j<=b.length;j++){
      var cost=(a.charAt(i-1)===b.charAt(j-1))?0:1;
      cur[j]=Math.min(cur[j-1]+1, prev[j]+1, prev[j-1]+cost);
    }
    for(j=0;j<=b.length;j++) prev[j]=cur[j];
  }
  return prev[b.length];
}

// Limpia el nombre: sin acentos, sin sufijos societarios ni puntuación
var _NSAP_RUIDO=/\b(co|company|companies|ltd|limited|inc|corp|corporation|sa|s a|sas|srl|gmbh|bv|llc|plc|pte|pty|group|trading|import|export|imports|exports|international|intl)\b/g;
function _nsapNormProv(s){
  var t=String(s||'').toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-z0-9\s]/g,' ')
    .replace(/\s+/g,' ').trim();
  return t;
}
function _nsapNucleo(s){
  return _nsapNormProv(s).replace(_NSAP_RUIDO,' ').replace(/\s+/g,' ').trim();
}

// Parecido 0..1 combinando edición y palabras en común
function _nsapParecido(a,b){
  var na=_nsapNormProv(a), nb=_nsapNormProv(b);
  if(!na||!nb) return 0;
  if(na===nb) return 1;
  var ka=_nsapNucleo(a), kb=_nsapNucleo(b);
  if(ka && kb && ka===kb) return 0.98;
  // Uno contenido en el otro (nombre recortado)
  if(ka && kb && (ka.indexOf(kb)>=0 || kb.indexOf(ka)>=0)) return 0.93;
  // Por edición sobre el núcleo
  var A=ka||na, B=kb||nb;
  var lev=1-(_nsapLev(A,B)/Math.max(A.length,B.length));
  // Por palabras compartidas (nombres largos con orden distinto)
  var pa=A.split(' ').filter(function(w){return w.length>2;});
  var pb=B.split(' ').filter(function(w){return w.length>2;});
  var comunes=pa.filter(function(w){ return pb.indexOf(w)>=0; }).length;
  var tok=(pa.length&&pb.length)?(comunes/Math.max(pa.length,pb.length)):0;
  return Math.max(lev, tok);
}

// Palabras significativas del nombre, para buscar en la base
function _nsapTokens(nombre){
  var t=_nsapNucleo(nombre).split(' ').filter(function(w){ return w.length>=3; });
  if(!t.length) t=_nsapNormProv(nombre).split(' ').filter(function(w){ return w.length>=3; });
  // Las palabras más largas son las más distintivas
  t.sort(function(a,b){ return b.length-a.length; });
  return t.slice(0,5);
}

// Busca proveedores parecidos DIRECTO en la base.
// El catálogo local (_repProv) solo trae proveedores con items del
// departamento del usuario, así que un proveedor de otro departamento —o sin
// items todavía— nunca aparecía. Por eso se consulta también el inventario.
async function _nsapBuscarProvRemoto(nombre){
  var toks=_nsapTokens(nombre);
  if(!toks.length) return [];
  var out={};
  // 1) Proveedores que tienen artículos en el inventario
  try{
    var ors=toks.map(function(w){ return 'nombre_proveedor.ilike.*'+encodeURIComponent(w)+'*'; }).join(',');
    var url=SB+'/rest/v1/inventario?select=cardcode,nombre_proveedor&cardcode=not.is.null'
      +'&nombre_proveedor=not.is.null&or=('+ors+')&limit=4000';
    var r=await fetch(url,{headers:SBH});
    if(r.ok){
      (await r.json()||[]).forEach(function(x){
        var cc=String(x.cardcode||'').trim(); if(!cc) return;
        if(!out[cc]) out[cc]={cardcode:cc, cardname:x.nombre_proveedor||''};
      });
    }
  }catch(e){ console.warn('buscar prov remoto (inventario):',e); }
  // 2) Y el maestro de proveedores. Un proveedor recién dado de alta en SAP
  //    todavía no tiene artículos en el inventario, así que buscandolo solo
  //    ahí salía como nuevo aunque existiera. Es lo que pasó con
  //    "Zhejiang Longstar Manufacture & Trade Co.,Ltd".
  try{
    var ors2=toks.map(function(w){ return 'cardname.ilike.*'+encodeURIComponent(w)+'*'; }).join(',');
    var url2=SB+'/rest/v1/proveedores?select=cardcode,cardname&cardcode=not.is.null'
      +'&or=('+ors2+')&limit=2000';
    var r2=await fetch(url2,{headers:SBH});
    if(r2.ok){
      (await r2.json()||[]).forEach(function(x){
        var cc=String(x.cardcode||'').trim(); if(!cc) return;
        // El maestro manda sobre el inventario para el nombre
        out[cc]={cardcode:cc, cardname:x.cardname||(out[cc]&&out[cc].cardname)||''};
      });
    } else {
      console.warn('[proveedor] la tabla proveedores devolvió '+r2.status);
    }
  }catch(e){ console.warn('buscar prov remoto (proveedores):',e); }
  return Object.keys(out).map(function(k){ return out[k]; });
}

// Devuelve {exacto, candidatos:[{cardcode,cardname,score}]}
function _nsapCandidatos(nombre, extra){
  var base=extra&&extra.length?extra:(_repProv||[]);
  var nn=_nsapNormProv(nombre);
  var exacto=null, todos=[];
  base.forEach(function(pr){
    // Solo se da por exacto si el nombre normalizado es idéntico. Cualquier
    // otra cosa se ofrece para elegir: aceptar automáticamente un 98% podía
    // confundir "MEGA EXPORT" con "MEGA EXPORTS", que pueden ser distintos.
    if(!exacto && nn && _nsapNormProv(pr.cardname)===nn) exacto=pr;
    todos.push({cardcode:pr.cardcode, cardname:pr.cardname,
                score:_nsapParecido(nombre, pr.cardname), n_items:pr.n_items});
  });
  todos.sort(function(a,b){ return b.score-a.score; });
  var lista=todos.filter(function(c){ return c.score>=0.34; });
  // Si quedaron muy pocos, se baja el listón: es mejor mostrar alguno de más
  // que dejar que se duplique un proveedor que sí existe.
  if(lista.length<3) lista=todos.filter(function(c){ return c.score>=0.28; }).slice(0,5);
  return {exacto:exacto, candidatos:lista.slice(0,8)};
}

function _nsapProvMsg(html){
  var d=document.getElementById('nsapProvSAP'); if(d) d.innerHTML=html;
}

// Busca el proveedor en SAP y pinta el resultado debajo del campo
async function _nsapBuscarProvSAP(forzar){
  var inp=document.getElementById('nsapProv'); if(!inp) return null;
  // Si ya hay un código escrito a mano, ese manda: no se busca por nombre
  var ci=document.getElementById('nsapProvCod');
  var codManual=ci?String(ci.value||'').trim():'';
  if(codManual && window._nsapCardcode===codManual.toUpperCase()) return window._nsapCardcode;
  var nombre=(inp.value||'').trim();
  if(!nombre){ _nsapProvMsg(''); window._nsapCardcode=''; window._nsapProvNuevoOK=false; return null; }
  if(!forzar && nombre===window._nsapProvUltimo) return window._nsapCardcode||null;
  window._nsapProvUltimo=nombre;
  window._nsapCardcode=''; window._nsapProvNuevoOK=false;

  _nsapProvMsg('<span style="font-size:10.5px;color:var(--text-muted)"><span class="ai-ring g" style="width:11px;height:11px;border-width:2px;vertical-align:-1px"></span> Buscando el código en SAP…</span>');
  try{ await _repCargarProveedores(); }catch(e){}

  // Se juntan el catálogo local y la búsqueda directa en el inventario, para
  // no perder proveedores de otros departamentos.
  var universo={};
  (_repProv||[]).forEach(function(pr){ if(pr.cardcode) universo[pr.cardcode]={cardcode:pr.cardcode, cardname:pr.cardname, n_items:pr.n_items}; });
  var remotos=await _nsapBuscarProvRemoto(nombre);
  remotos.forEach(function(pr){ if(!universo[pr.cardcode]) universo[pr.cardcode]=pr; });
  var lista=Object.keys(universo).map(function(k){ return universo[k]; });

  var r=_nsapCandidatos(nombre, lista);
  if(r.exacto){
    window._nsapCardcode=r.exacto.cardcode;
    var _ce=document.getElementById('nsapProvCod'); if(_ce) _ce.value=r.exacto.cardcode;
    _nsapProvMsg('<div style="font-size:11px;color:var(--t-verde);background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:7px;padding:5px 9px">'
      +'<i class="ti ti-circle-check"></i> En SAP como <b>'+_esc(r.exacto.cardcode)+'</b> — '+_esc(r.exacto.cardname||'')+'</div>');
    return r.exacto.cardcode;
  }
  if(r.candidatos.length){
    var h='<div style="font-size:11px;background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;padding:9px 10px;color:var(--t-marron)">'
      +'<div style="margin-bottom:8px"><button onclick="_nsapConfirmarNuevo()" style="width:100%;background:#B45309;border:none;color:#fff;border-radius:8px;padding:9px 12px;font-size:12.5px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:7px"><i class="ti ti-building-plus" style="font-size:15px"></i> No hay coincidencia, Crear Proveedor NO SAP</button></div>'
      +'<div style="font-size:10.5px;margin-bottom:5px"><i class="ti ti-alert-circle"></i> Si en realidad ya existe escrito de otra forma, elegilo de la lista:</div>'
      +'<div style="display:flex;flex-direction:column;gap:4px">';

    r.candidatos.forEach(function(c){
      h+='<div onclick="_nsapUsarProv(\''+_esc(c.cardcode)+'\',\''+_esc(String(c.cardname||'').replace(/\'/g,''))+'\')"'
        +' style="display:flex;align-items:center;gap:7px;background:var(--surface-0);border:0.5px solid var(--border);border-radius:6px;padding:5px 8px;cursor:pointer">'
        +'<b style="color:var(--text-accent);flex-shrink:0">'+_esc(c.cardcode)+'</b>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--text-primary)">'+_esc(c.cardname||'')+'</span>'
        +'<span style="flex-shrink:0;font-size:10px;color:var(--text-muted)">'+Math.round(c.score*100)+'%</span>'
        +'</div>';
    });
    h+='</div></div>';



    _nsapProvMsg(h);
    return null;
  }
  // Nada parecido: probablemente sí es nuevo, pero se confirma
  _nsapProvMsg('<div style="font-size:11px;background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:9px 10px;color:var(--t-marron)">'
    +'<div style="margin-bottom:7px"><button onclick="_nsapConfirmarNuevo()" style="width:100%;background:#B45309;border:none;color:#fff;border-radius:8px;padding:9px 12px;font-size:12.5px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:7px"><i class="ti ti-building-plus" style="font-size:15px"></i> No hay coincidencia, Crear Proveedor NO SAP</button></div>'
    +'<div style="font-size:10.5px"><i class="ti ti-info-circle"></i> No existe en SAP ningún proveedor con ese nombre ni parecido.</div>'
    +'</div>');

  return null;
}

// El usuario escribió el código a mano: ese manda.
// Se intenta traer su nombre desde SAP para confirmar que es el correcto.
async function _nsapCodigoManual(v){
  var cod=String(v||'').trim().toUpperCase();
  var ci=document.getElementById('nsapProvCod');
  if(ci) ci.value=cod;
  if(!cod){
    // Se borró el código: se vuelve a resolver por nombre
    window._nsapCardcode=''; window._nsapProvNuevoOK=false; window._nsapProvUltimo='';
    return _nsapBuscarProvSAP(true);
  }
  window._nsapCardcode=cod;
  window._nsapProvNuevoOK=false;
  _nsapProvMsg('<span style="font-size:10.5px;color:var(--text-muted)"><span class="ai-ring g" style="width:11px;height:11px;border-width:2px;vertical-align:-1px"></span> Verificando '+_esc(cod)+' en SAP…</span>');

  var nombre=null;
  try{ await _repCargarProveedores(); }catch(e){}
  var local=(_repProv||[]).find(function(p){ return String(p.cardcode||'').toUpperCase()===cod; });
  if(local) nombre=local.cardname;
  if(!nombre){
    try{
      var r=await fetch(SB+'/rest/v1/inventario?select=nombre_proveedor&cardcode=eq.'+encodeURIComponent(cod)+'&limit=1',{headers:SBH});
      if(r.ok){ var f=await r.json(); if(Array.isArray(f)&&f.length) nombre=f[0].nombre_proveedor||''; }
    }catch(e){}
  }
  var inp=document.getElementById('nsapProv');
  if(nombre){
    if(inp) inp.value=nombre;                 // se alinea el nombre con el código
    window._nsapProvUltimo=nombre;
    _nsapProvMsg('<div style="font-size:11px;color:var(--t-verde);background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:7px;padding:5px 9px">'
      +'<i class="ti ti-circle-check"></i> Código escrito a mano: <b>'+_esc(cod)+'</b> — '+_esc(nombre)+'</div>');
  } else {
    _nsapProvMsg('<div style="font-size:11px;color:var(--t-marron);background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:7px;padding:5px 9px">'
      +'<i class="ti ti-alert-circle"></i> Se usará el código <b>'+_esc(cod)+'</b> tal como lo escribiste. '
      +'No aparece en el inventario todavía, así que se guardará como proveedor NO SAP.</div>');
    window._nsapProvNuevoOK=true;             // código propio: no hace falta más confirmación
  }
  return cod;
}

// El usuario eligió uno de los parecidos
function _nsapUsarProv(cardcode, cardname){
  var inp=document.getElementById('nsapProv');
  if(inp && cardname) inp.value=cardname;
  var ci=document.getElementById('nsapProvCod'); if(ci) ci.value=cardcode;
  window._nsapProvUltimo=cardname||'';
  window._nsapCardcode=cardcode;
  window._nsapProvNuevoOK=false;
  _nsapProvMsg('<div style="font-size:11px;color:var(--t-verde);background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:7px;padding:5px 9px">'
    +'<i class="ti ti-circle-check"></i> Se usará <b>'+_esc(cardcode)+'</b> — '+_esc(cardname||'')
    +' <span style="color:var(--text-muted)">(no se creará un proveedor nuevo)</span></div>');
}

// Confirmación explícita de crear proveedor nuevo
function _nsapConfirmarNuevo(){
  var inp=document.getElementById('nsapProv');
  var nombre=(inp&&inp.value||'').trim();
  if(!confirm('¿Deseas crear un nuevo proveedor?\n\n"'+nombre+'"\n\nSe registrará como proveedor NO SAP hasta que exista en SAP. Si en realidad ya existe con el nombre escrito de otra forma, cancela y elige el correcto de la lista.')) return;
  window._nsapCardcode='';
  window._nsapProvNuevoOK=true;
  var _cn=document.getElementById('nsapProvCod'); if(_cn) _cn.value='';
  _nsapProvMsg('<div style="font-size:11px;color:var(--t-lila);background:var(--pastel-lila);border:0.5px solid #C4B5FD;border-radius:7px;padding:5px 9px">'
    +'<i class="ti ti-plus"></i> Confirmado: <b>'+_esc(nombre)+'</b> se creará como proveedor nuevo (NO SAP).</div>');
}

// ── Revisión aritmética propia de la orden NO SAP ──
// No depende de la AI: recalcula las líneas y los totales con los números que
// quedaron en el formulario, así se detectan descuadres aunque la AI no avise.
function _nsapRevisarNumeros(items, total, unidadesDoc, cartonesDoc){
  var errs=[];
  var suma=0, piezas=0;
  (items||[]).forEach(function(it, i){
    var n=i+1;
    var c=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
    var tl=Number(it.total_linea)||0;
    var calc=Math.round(c*pu*100)/100;
    suma+=(tl||calc); piezas+=c;
    if(c<=0) errs.push('Línea '+n+' ('+(it.itemcode||it.itemname||'')+'): cantidad en '+c+'.');
    if(pu<0) errs.push('Línea '+n+' ('+(it.itemcode||it.itemname||'')+'): precio unitario negativo.');
    if(tl && Math.abs(tl-calc)>0.02){
      errs.push('Línea '+n+' ('+(it.itemcode||it.itemname||'')+'): '+c+' x '+_fmtN2(pu)+' = '+_fmtN2(calc)+', pero la línea dice '+_fmtN2(tl)+'.');
    }
  });
  suma=Math.round(suma*100)/100;
  var t=Number(total)||0;
  if(t && Math.abs(suma-t)>0.05){
    var nL=(items||[]).length;
    errs.push('La suma de '+(nL===1?'la línea':'las '+nL+' líneas')+' da '+_fmtN2(suma)+' y el total general dice '+_fmtN2(t)+' (diferencia '+_fmtN2(Math.abs(suma-t))+').');
  }
  var ud=Number(unidadesDoc)||0;
  if(ud && piezas && Math.abs(ud-piezas)>0){
    errs.push('El total de piezas declarado es '+ud.toLocaleString('en-US')+' pero la suma de las líneas da '+piezas.toLocaleString('en-US')+'.');
  }
  return {errores:errs, suma:suma, piezas:piezas, cartones:Number(cartonesDoc)||0};
}

function _nsapPintarRevision(errsIA, calc){
  var box=document.getElementById('nsapIAerrores'); if(!box) return 0;
  var todos=[];
  (errsIA||[]).forEach(function(x){ var s=String(x&&x.detalle?x.detalle:x||'').trim(); if(s) todos.push({o:'AI', t:s}); });
  (calc&&calc.errores||[]).forEach(function(s){ todos.push({o:'Cálculo', t:s}); });
  // Quitar repetidos por texto
  var vistos={}, lista=[];
  todos.forEach(function(x){ var k=x.t.toLowerCase().replace(/\s+/g,' '); if(!vistos[k]){ vistos[k]=1; lista.push(x); } });

  if(!lista.length){
    box.innerHTML='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Revisado: las líneas, los totales y las cantidades cuadran.'
      +(calc?('<div style="font-weight:400;margin-top:2px">Suma de líneas '+_fmtN2(calc.suma)+' · '+calc.piezas.toLocaleString('en-US')+' piezas'+(calc.cartones?(' · '+calc.cartones.toLocaleString('en-US')+' cartones'):'')+'</div>'):'')
      +'</div>';
    return 0;
  }
  box.innerHTML='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-rojo)">'
    +'<div style="font-weight:800;margin-bottom:4px"><i class="ti ti-alert-triangle"></i> '+lista.length+' problema(s) en los números. Revisa antes de crear la orden:</div>'
    +'<ul style="margin:4px 0 0 16px;padding:0">'
    +lista.map(function(x){ return '<li style="margin-bottom:2px"><b style="opacity:.7">'+x.o+':</b> '+_esc(x.t)+'</li>'; }).join('')
    +'</ul></div>';
  return lista.length;
}

// ═══════════════════════════════════════════════════════════════════════════
//  ORDEN NO SAP — DOS DOCUMENTOS Y COMPARACIÓN
//  Se adjunta la PI del proveedor y nuestra orden de compra. La IA extrae los
//  datos de cada una, llena el formulario con la NUESTRA (que es la que manda)
//  y reporta cualquier diferencia entre las dos.
// ═══════════════════════════════════════════════════════════════════════════
window._nsapDocs = window._nsapDocs || {prov:null, kcc:null};

function _nsapCajaArchivo(clave, titulo, sub, color, bg, bd){
  return '<label id="nsapBox-'+clave+'" style="display:flex;align-items:center;gap:9px;padding:9px 11px;'
    +'border:1.5px dashed '+bd+';border-radius:8px;cursor:pointer;background:'+bg+'">'
    +'<i class="ti ti-upload" style="color:'+color+';font-size:16px"></i>'
    +'<div style="flex:1;min-width:0">'
      +'<div style="font-size:11.5px;font-weight:700;color:'+color+'">'+titulo+'</div>'
      +'<div id="nsapLbl-'+clave+'" style="font-size:10.5px;color:'+color+';opacity:.8;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+sub+'</div>'
    +'</div>'
    +'<i id="nsapChk-'+clave+'" class="ti ti-circle-check" style="color:'+color+';font-size:16px;display:none"></i>'
    +'<input type="file" accept=".pdf,.xlsx,.xls,.csv,.doc,.docx,.txt,image/*" style="display:none" onchange="_nsapDocElegido(\''+clave+'\',this)">'
  +'</label>';
}

window._firmaDocs = window._firmaDocs || {prov:null, kcc:null};
// Sirve para los dos formularios: orden NO SAP (prov/kcc) y compra para firma (fprov/fkcc)
function _nsapDocElegido(clave, input){
  var f=input.files&&input.files[0]; if(!f) return;
  var esFirma=(clave.charAt(0)==='f');
  var k=esFirma?clave.slice(1):clave;
  var store=esFirma?(window._firmaDocs=window._firmaDocs||{prov:null,kcc:null})
                   :(window._nsapDocs=window._nsapDocs||{prov:null,kcc:null});
  store[k]=f;

  var lbl=document.getElementById('nsapLbl-'+clave);
  if(lbl) lbl.textContent=f.name;
  var chk=document.getElementById('nsapChk-'+clave);
  if(chk) chk.style.display='block';

  var faltan=[];
  if(!store.prov) faltan.push('la PI del proveedor');
  if(!store.kcc)  faltan.push('nuestra orden de compra');

  if(esFirma){
    _firmaArchivo = store.kcc || store.prov;      // compatibilidad
    window._firmaRevisionIA=null;
    var eb=document.getElementById('firma-ai-errores'); if(eb) eb.innerHTML='';
    var sf=document.getElementById('firma-ai-status');
    if(sf) sf.innerHTML=faltan.length
      ? '<span style="color:var(--t-ambar)"><i class="ti ti-info-circle"></i> Falta '+faltan.join(' y ')+'. Puedes revisar igual con lo que ya subiste.</span>'
      : '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Los dos documentos listos. Pulsa <b>AI rellenar y revisar</b>.</span>';
    return;
  }

  window._nsapArchivo = store.kcc || store.prov;
  var st=document.getElementById('nsapIAstatus');
  if(st) st.innerHTML=faltan.length
    ? '<span style="color:var(--t-marron)"><i class="ti ti-info-circle"></i> Falta '+faltan.join(' y ')+'. Puedes revisar igual con lo que ya subiste.</span>'
    : '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Los dos documentos listos. Pulsa <b>Revisar y comparar con IA</b>.</span>';
}

// Pasa un libro de Excel a texto para la IA.
// El corte es por el MEDIO, nunca por el final: en una proforma los totales,
// el depósito y el saldo están siempre en las últimas filas, así que cortar
// por el final dejaba la orden sin total (era exactamente lo que pasaba con
// las proformas largas: se enviaban las primeras 12.000 letras y la fila
// TOTAL quedaba fuera).
function _iaLibroTexto(wb, tope){
  tope=tope||60000;
  var txt='';
  wb.SheetNames.forEach(function(n){
    txt+='=== HOJA: '+n+' ===\n'+XLSX.utils.sheet_to_csv(wb.Sheets[n],{FS:'\t'})+'\n\n';
  });
  return _iaRecorteMedio(txt, tope);
}

function _iaRecorteMedio(txt, tope){
  txt=String(txt||'');
  if(txt.length<=tope) return txt;
  var cola=Math.floor(tope*0.35), cabeza=tope-cola;
  return txt.slice(0, cabeza)
    +'\n\n[… se omitieron '+(txt.length-tope)+' caracteres del medio del documento. '
    +'Lo que sigue son las ÚLTIMAS filas de la hoja, donde están los totales …]\n\n'
    +txt.slice(txt.length-cola);
}

// Convierte un archivo al bloque de contenido que entiende la IA
async function _nsapContenido(file){
  var ext=(file.name.split('.').pop()||'').toLowerCase();
  if(ext==='xlsx'||ext==='xls'||ext==='csv'){
    var buf=await file.arrayBuffer();
    var wb=XLSX.read(buf,{type:'array'});
    return {type:'text', text:_iaLibroTexto(wb, 60000)};
  }
  if(ext==='pdf'){
    return {type:'document', source:{type:'base64', media_type:'application/pdf', data:await _fileB64(file)}};
  }
  return {type:'image', source:{type:'base64', media_type:(file.type||'image/jpeg'), data:await _fileB64(file)}};
}

// Revisa y compara los dos documentos
// Saca las fotos del Excel a pedido. Sirve cuando la revisión con AI ya
// pasó o cuando el archivo se adjuntó después.
// auto = viene enganchado a la revisión con IA. En ese caso no pisa el
// resumen de la revisión (lo continúa en una segunda línea) y se calla si no
// hay nada que sacar, para no interrumpir con avisos que nadie pidió.
async function _nsapSacarFotos(auto){
  var items=window._nsapItems||[];
  if(!items.length){ if(auto) return; showT('Primero revisa el documento con AI'); return; }

  var cands=[];
  [window._nsapDocs, window._firmaDocs].forEach(function(st){
    if(!st) return;
    if(st.prov) cands.push(st.prov);
    if(st.kcc)  cands.push(st.kcc);
  });
  try{
    document.querySelectorAll('#modalNuevaSAP input[type=file]').forEach(function(inp){
      if(inp.files && inp.files[0]) cands.push(inp.files[0]);
    });
  }catch(e){}
  var xls=cands.filter(function(f){ return f && /\.xlsx$/i.test(f.name||''); });

  var st2=document.getElementById('nsapIAstatus');
  // En automático, debajo de lo que dijo la revisión
  var _pre=(auto && window._nsapEstadoIA) ? (window._nsapEstadoIA+'<br>') : '';
  if(!xls.length){
    if(auto) return;
    var msg='No hay ningún archivo .xlsx adjunto. '
      +(cands.length?('Se ve: '+cands.map(function(f){return f.name;}).join(', ')+'. ')
                    :'No se detectó ningún archivo. ')
      +'Solo los .xlsx llevan fotos incrustadas.';
    if(st2) st2.innerHTML=_pre+'<span style="color:var(--t-ambar)"><i class="ti ti-photo-off"></i> '+_esc(msg)+'</span>';
    showT('No hay un .xlsx del que sacar fotos');
    return;
  }

  if(st2) st2.innerHTML=_pre+'<span class="ai-wrap" style="color:var(--t-lila)">'
    +'<span class="ai-ring"></span> Sacando las fotos del Excel…</span>';
  try{ await _cargarJSZip(); }catch(e){}

  // Antes de emparejar las fotos, se corrigen los códigos de KCC leyéndolos
  // de la propia hoja. Si la IA se equivocó de columna, las fotos se
  // buscarían por un código que no existe y no encontrarían nada.
  for(var c=0;c<xls.length;c++){
    try{ await _nsapCorregirKcc(xls[c], items); }
    catch(e){ console.warn('[kcc] '+xls[c].name+':', e); }
  }

  var mapa={};
  for(var i=0;i<xls.length;i++){
    try{
      var m=await _nsapFotosPorSku(xls[i], items);
      Object.keys(m||{}).forEach(function(k){ if(!mapa[k]) mapa[k]=m[k]; });
    }catch(e){ console.warn('[nosap] '+xls[i].name+':', e); }
  }
  window._nsapFotosPend=mapa;
  var n=Object.keys(mapa).length;
  if(n){
    items.forEach(function(it){
      var k=String(it.itemcode||'').trim().toUpperCase();
      // Los que ya están en SAP conservan la foto del inventario: es la que
      // usa el resto del portal y la que ya está subida al bucket.
      if(mapa[k] && !it._fotoDeSAP) it._foto='data:'+mapa[k].mime+';base64,'+mapa[k].b64;
    });
    _nsapRenderItems();
  }
  var d=window._nsapFotosDiag||{};
  if(st2) st2.innerHTML = _pre + (n
    ? ('<span style="color:var(--text-success)"><i class="ti ti-photo-check"></i> '
       +n+' de '+items.length+' artículo(s) con foto</span>')
    : ('<span style="color:var(--t-ambar)"><i class="ti ti-photo-off"></i> Sin fotos · '
       +(!d.jszip ? 'no se pudo abrir el archivo'
        : (d.imagenes===0 ? 'el Excel no trae imágenes'
        : (d.ubicados===0 ? 'no se encontraron los códigos en la hoja'
        : 'las imágenes están fuera de la tabla')))
       +'</span>'));
  if(!auto) showT(n?('✓ '+n+' foto(s)'):'No se encontraron fotos');
}

async function _nsapRevisarConIA(){
  var prov=window._nsapDocs.prov, kcc=window._nsapDocs.kcc;
  if(!prov && !kcc){ showT('Adjunta al menos un documento'); return; }
  window._nsapEstadoIA='';   // resumen de esta revisión, aún sin escribir
  var st=document.getElementById('nsapIAstatus');
  var btn=document.getElementById('nsapBtnIA');
  if(btn){ btn.disabled=true; btn.style.opacity='.7';
    btn.innerHTML='<span class="ai-ring" style="width:12px;height:12px;border-width:2px;vertical-align:-1px"></span> Analizando…'; }
  if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo los documentos…</span>';

  try{
    var contenido=[];
    if(kcc){
      contenido.push({type:'text', text:'DOCUMENTO A — NUESTRA ORDEN DE COMPRA (KENNEDY CENTER CORP.):'});
      contenido.push(await _nsapContenido(kcc));
    }
    if(prov){
      contenido.push({type:'text', text:'DOCUMENTO B — PI DEL PROVEEDOR (Proforma Invoice):'});
      contenido.push(await _nsapContenido(prov));
    }
    contenido.push({type:'text', text:_nsapPromptComparar(!!kcc, !!prov)});

    var obj=await _iaJSON(contenido, 8000, function(n){
      if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Documentos largos: la AI sigue leyendo ('+n+')…</span>';
    });

    // El formulario se llena con NUESTRA orden; si no vino, con la del proveedor
    var base=obj.kcc||obj.proveedor||obj;
    if(base.proveedor) document.getElementById('nsapProv').value=base.proveedor;
    // El número va SIEMPRE con su prefijo. Nuestra orden lo escribe suelto
    // ("DKC No. 26084") y la PI del proveedor con prefijo ("PO No: DKC-26084"):
    // se cruzan las dos para no perderlo.
    if(base.num_orden){
      document.getElementById('nsapRef').value=_nsapNormRef(base.num_orden, [
        base.po,
        (obj.proveedor&&obj.proveedor.po), (obj.proveedor&&obj.proveedor.num_orden),
        (obj.kcc&&obj.kcc.po), (obj.kcc&&obj.kcc.num_orden)
      ]);
    }
    if(base.po){ var poEl=document.getElementById('nsapPO'); if(poEl) poEl.value=base.po; }
    // Número de reposición: si el documento lo trae, se completa solo
    var _nr=String(base.num_reposicion||'').trim().toUpperCase();
    if(_nr){
      var nrEl=document.getElementById('nsapNumRepo');
      if(nrEl){ nrEl.value=_nr; try{ _nsapRepoCambio(); }catch(e){} }
    }
    // Si el documento no traía el número, se busca la reposición abierta de
    // ese mismo proveedor: la orden tiene que quedar ligada sola.
    try{ await _nsapRepoAuto(); }catch(e){ console.warn('[reposición] liga automática:', e); }
    if(base.total!=null) document.getElementById('nsapTotal').value=base.total;
    if(base.abonado!=null) document.getElementById('nsapAbon').value=base.abonado;
    _nsapCalcSaldo();
    // El abono casi nunca viene en dólares: los términos dicen "20% Deposit".
    // Si la IA leyó el porcentaje y no hay monto, se escribe el monto calculado
    // y se deja anotado de dónde salió, para que se pueda corregir a mano.
    window._nsapAbonoDePct=0;
    var _pct=Number(base.deposito_pct||(obj.kcc&&obj.kcc.deposito_pct)||(obj.proveedor&&obj.proveedor.deposito_pct))||0;
    var _elA=document.getElementById('nsapAbon');
    var _elP=document.getElementById('nsapAbonPct');
    if(_pct>0 && _pct<=100 && _elA && !(parseFloat(_elA.value)||0)){
      if(_elP){ _elP.value=_pct; _nsapAbonoDesdePct(); }
      else { _elA.value=(Math.round((Number(base.total)||0)*_pct)/100).toFixed(2); _nsapCalcSaldo(); }
      window._nsapAbonoDePct=_pct;
    }
    var fa=document.getElementById('nsapFechaAbono');
    if(fa && base.fecha_abono) fa.value=base.fecha_abono;

    var crudos=(Array.isArray(base.items)?base.items:[]).map(function(it){
      var cant=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
      var tl=Number(it.total_linea)||(cant*pu);
      return {itemcode:String(it.itemcode||it.itemcode_kcc||'').trim(),
              itemcode_kcc:String(it.itemcode_kcc||'').trim(),
              itemcode_proveedor:String(it.itemcode_proveedor||'').trim(),
              itemname:String(it.itemname||'').trim(),
              cantidad:cant, precio_unit:pu, total_linea:tl};
    });
    // Se comprueban los códigos contra el inventario de SAP: los KCC existen
    // ahí, los del proveedor no. Si vinieron cruzados, se corrigen solos.
    var rc={items:crudos, verificados:0, corregidos:0};
    try{ rc=await _nsapResolverCodigos(crudos); }catch(e){ console.warn('resolver codigos:',e); }
    window._nsapItems=rc.items;
    window._nsapCodigosInfo=rc;
    _nsapRenderItems();

    // Si el documento no traía el total (o la IA no lo encontró), se suma el
    // de las líneas en vez de dejar la orden en cero. Queda avisado abajo,
    // porque un total sumado puede no incluir flete ni descuentos.
    window._nsapTotalSumado=0;
    var _elT=document.getElementById('nsapTotal');
    var _suma=(window._nsapItems||[]).reduce(function(a,it){
      return a+(Number(it.total_linea)||0); }, 0);
    if(_elT && !(Number(base.total)||0) && _suma>0){
      _elT.value=Math.round(_suma*100)/100;
      window._nsapTotalSumado=Math.round(_suma*100)/100;
      _nsapCalcSaldo();
    }

    // Identificar el proveedor contra SAP
    try{ await _nsapBuscarProvSAP(true); }catch(e){}

    // Revisión propia de la aritmética
    var calc=_nsapRevisarNumeros(window._nsapItems, base.total, base.unidades, base.cartones);
    var nProb=_nsapPintarComparacion(obj, calc, !!kcc, !!prov);
    window._nsapProblemas=nProb;

    var nIt=window._nsapItems.length;
    if(st){
      var dif=((obj.diferencias||[]).length);
      var rcI=window._nsapCodigosInfo||{verificados:0,corregidos:0,sinKcc:0};
      var partes=[];
      if(rcI.verificados) partes.push(rcI.verificados+'/'+nIt+' códigos verificados contra SAP');
      if(rcI.corregidos)  partes.push(rcI.corregidos+' código(s) corregido(s) al de Kennedy');
      if(rcI.sinKcc)      partes.push('<b style="color:var(--t-ambar)">'+rcI.sinKcc+' línea(s) sin código KCC reconocible: revisalas</b>');
      if(window._nsapTotalSumado) partes.push('<b style="color:var(--t-ambar)">el total no venía en el documento: '
        +'se sumaron las líneas ('+fmt(window._nsapTotalSumado)+'), verifícalo</b>');
      if(window._nsapAbonoDePct) partes.push('abono calculado con el '+window._nsapAbonoDePct
        +'% de depósito de los términos de pago, edítalo si hace falta');
      var extra=partes.length?(' · '+partes.join(' · ')):'';
      st.innerHTML=nProb
        ? '<span style="color:var(--t-rojo2)"><i class="ti ti-alert-triangle"></i> '+nIt+' productos extraídos'+extra+' · '+nProb+' incidencia(s) para revisar.</span>'
        : '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> '+nIt+' productos extraídos'+extra
          +((kcc&&prov)?' · los dos documentos coinciden':'')+'.</span>';
      window._nsapEstadoIA=st.innerHTML;   // las fotos escriben debajo de esto
    }

    // Las fotos del Excel salen solas: son parte de leer el documento, no un
    // segundo paso que haya que acordarse de pulsar. Si algo falla, la
    // revisión ya está hecha y el botón de mano sigue estando.
    try{ await _nsapSacarFotos(true); }
    catch(e){ console.warn('[nosap] fotos automáticas:', e); }
  }catch(e){
    console.error('comparar NO SAP:',e);
    if(st) st.innerHTML='<span style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i> No se pudo analizar ('+_esc(e.message||String(e))+'). Completá los campos a mano.</span>';
  }
  if(btn){ btn.disabled=false; btn.style.opacity='1';
    btn.innerHTML='<i class="ti ti-sparkles"></i> Revisar y comparar con IA'; }
}

function _nsapPromptComparar(hayKcc, hayProv){
  var p='Sos el auditor de compras de KENNEDY CENTER CORP. Analiza ';
  p+= (hayKcc&&hayProv) ? 'los DOS documentos adjuntos.\n\n'
     : 'el documento adjunto.\n\n';
  if(hayKcc&&hayProv){
    p+='DOCUMENTO A es NUESTRA orden de compra (Kennedy Center). Su numero suele empezar con DKC- o SKC-.\n'
      +'DOCUMENTO B es la PI (Proforma Invoice) del PROVEEDOR, con su propio numero.\n'
      +'Los dos deberian describir la MISMA compra. Tu trabajo es extraer los datos de cada uno y COMPARARLOS.\n\n';
  }
  p+='REGLA DE CANTIDADES, MUY IMPORTANTE: la cantidad va SIEMPRE en PIEZAS, nunca en cartones. '
    +'Usa la columna de cantidad pedida en piezas (ORDER QTY / Pcs, ORDER QTY, QTY, Quantity, CANTIDAD, PCS). '
    +'NO uses QTY X CTN, QTY/CTN, PCS/CTN, No.Ctn, TTL CTNS, CTNS, CARTONS ni inner: esas son piezas por carton o cantidad de cartones. '
    +'Ejemplo: si dice ORDER QTY/Pcs = 300, QTY X CTN = 6 y TTL CTNS = 50, la cantidad es 300. '
    +'Verifica siempre que cantidad x precio_unitario de el total de la linea.\n\n'
    +'QUE COMPARAR entre los dos documentos: nombre del proveedor; numero de orden que cada uno referencia; fecha; moneda; '
    +'incoterm; terminos de pago; puerto o destino; plazo de entrega; cantidad de lineas; y por cada linea el codigo del item, '
    +'la descripcion, la cantidad en piezas, el precio unitario y el total de linea; subtotal, descuentos, impuestos, flete, '
    +'total general, total de piezas y total de cartones. Empareja las lineas por codigo y, si no hay codigo, por descripcion. '
    +'Reporta tambien las lineas que estan en un documento y NO en el otro.\n\n'
    +'ERRORES INTERNOS a revisar en cada documento: cantidad x precio unitario que no cuadre con el total de la linea; '
    +'suma de lineas que no cuadre con el total general; subtotal + impuestos + flete - descuentos que no de el total; '
    +'cantidades o precios en cero o negativos; totales repetidos que no coincidan entre si.\n\n'
    +'FICHA DE CADA ARTICULO (sirve para armar catalogos para el cliente):\n'
    +'La tabla de productos tiene una columna por dato. Lee la CABECERA de cada\n'
    +'columna y lleva su valor al campo que corresponde. Los encabezados varian\n'
    +'entre proveedores, asi que guiate por el significado, no por el texto exacto.\n\n'
    +'EQUIVALENCIAS HABITUALES:\n'
    +'  "KCC ITEM No." / "KCC ITEM CODE" / "KCC CODE" / "Item No." /\n'
    +'  "Codigo KCC" / "COD KCC" / cualquier encabezado que lleve KCC -> itemcode_kcc\n'
    +'  "Factory Code" / "Vendor Code" / "Supplier Item" / "Ref. fabrica" -> itemcode_proveedor\n'
    +'  "BARCODE No." / "Barcode" / "UPC" / "EAN"          -> barcode\n'
    +'  "PRODUCT Description & Package" / "Description"    -> descripcion\n'
    +'  "SPANISH NAME" / "Descripcion en espanol"          -> itemname\n'
    +'  "ITEM SIZE Dimension / Ounces / Capacity"          -> tamano\n'
    +'  "COLOR Finishing" / "Color"                        -> color\n'
    +'  "MATERIAL, Construction Composition %"             -> material\n'
    +'  "ORDER QTY / Pcs" / "Quantity" / "QTY"             -> cantidad\n'
    +'  "QTY X CTN Packing" / "Pcs per carton"             -> unidades_x_caja\n'
    +'  "CARTON SIZE" / "Medida de caja"                   -> carton_size\n'
    +'  "TTL CTNS" / "Total cartons"                       -> cartones_item\n'
    +'  "CBM X CTN" / "CBM"                                -> cbm\n'
    +'  "N.W." / "G.W." / "Weight" / "Peso"                -> peso\n'
    +'  "UNIT PRICE" / "Precio unitario"                   -> precio_unit\n'
    +'  "TOTAL AMOUNT" / "Amount"                          -> total_linea\n'
    +'  "Brand" / "Marca"                                  -> marca\n\n'
    +'NUMERO DE REPOSICION (campo num_reposicion, a nivel de la orden):\n'
    +'Si el documento menciona un numero de reposicion o re-order con la forma\n'
    +'R-01, R-1, R 01, "RE-ORDER R-05", "Re-order No.: R-12" o "Reposicion R-03",\n'
    +'devolvelo en num_reposicion con el formato R-NN (por ejemplo R-05).\n'
    +'Si no aparece en ninguna parte, devolve num_reposicion vacio. NO lo inventes\n'
    +'ni lo confundas con el DKC, el PO del proveedor ni el codigo de un articulo.\n\n'
    +'REGLAS:\n'
    +'1. Si hay nombre en espanol y descripcion en ingles, el espanol va en\n'
    +'   "itemname" y el ingles en "descripcion". Si solo hay uno, ponelo en ambos.\n'
    +'2. Copia el valor COMPLETO de la celda, con sus saltos de linea y unidades\n'
    +'   (por ejemplo "95% Acrylic\\n3% Iron\\n2% Paper" o "39.5x34x23.5cm").\n'
    +'3. Si una columna no existe en ese documento, deja el campo vacio.\n'
    +'   NUNCA inventes un valor ni lo deduzcas de otra columna.\n'
    +'4. Si una columna tiene un encabezado que no reconoces pero su contenido\n'
    +'   claramente corresponde a uno de los campos, usalo igual.\n'
    +'5. "empaque" se arma con "unidades_x_caja" y "carton_size" si ambos estan:\n'
    +'   por ejemplo "24 pzs x caja · 39.5x34x23.5cm".\n\n'
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues, con esta forma:\n'
    +'{\n'
    +' "kcc":{"proveedor":"","num_orden":"","po":"","fecha":"","moneda":"","total":0,"abonado":0,"deposito_pct":0,"saldo":0,"unidades":0,"cartones":0,'
    +'"items":[{"itemcode_kcc":"","itemcode_proveedor":"","itemname":"","cantidad":0,"precio_unit":0,"total_linea":0,"descripcion":"","material":"","color":"","tamano":"","empaque":"","barcode":"","unidades_x_caja":0,"carton_size":"","cartones_item":0,"cbm":0,"peso":"","marca":""}]},\n'
    // La ficha completa (material, color, empaque, cbm…) solo se usa para armar
    // el catálogo, y eso sale de NUESTRA orden. Cuando están los dos documentos,
    // del proveedor basta con lo que se compara: pedirle la ficha otra vez
    // duplicaba la respuesta y por eso el análisis tardaba tanto.
    +' "proveedor":{"proveedor":"","num_orden":"","po":"","fecha":"","moneda":"","total":0,"deposito_pct":0,"unidades":0,"cartones":0,'
    +(hayKcc
      ? '"items":[{"itemcode_kcc":"","itemcode_proveedor":"","itemname":"","cantidad":0,"precio_unit":0,"total_linea":0}]},\n'
      : '"items":[{"itemcode_kcc":"","itemcode_proveedor":"","itemname":"","cantidad":0,"precio_unit":0,"total_linea":0,"descripcion":"","material":"","color":"","tamano":"","empaque":"","barcode":"","unidades_x_caja":0,"carton_size":"","cartones_item":0,"cbm":0,"peso":"","marca":""}]},\n')
    +' "errores":[{"doc":"kcc","detalle":""}],\n'
    +' "diferencias":[{"campo":"","kcc":"","proveedor":"","gravedad":"alta","detalle":""}],\n'
    +' "coinciden":true\n'
    +'}\n\n'
    +'REGLAS DEL JSON:\n'
    +'- "num_orden" del bloque kcc es el codigo DKC- o SKC-. "po" es el numero del proveedor.\n'
    +'- "num_orden" SIEMPRE lleva su prefijo: DKC-26084, nunca 26084 a secas. Nuestra orden a veces\n'
    +'  lo escribe partido ("DKC No." en una celda y "26084" en la de al lado) y la PI del proveedor\n'
    +'  lo escribe entero ("PO No: DKC-26084"). Juntalo y devolvelo completo. Si un documento lo trae\n'
    +'  sin prefijo y el otro con prefijo, usa el que tiene prefijo.\n'
    +'- "deposito_pct": si los terminos de pago indican un porcentaje de deposito o anticipo\n'
    +'  ("20% Deposit / 80% Balance", "20% DEPOSIT, BALANCE T/T AGAINST COPY OF B/L", "30% anticipo"),\n'
    +'  devuelve solo el numero del deposito (20, 30). Si no hay porcentaje, 0.\n'
    +'- "abonado": solo si el documento dice un MONTO ya abonado en dinero. Si unicamente hay\n'
    +'  porcentaje, deja abonado en 0 y usa deposito_pct: el monto lo calcula el sistema.\n'
    +'- POR CADA LINEA devuelve LOS DOS codigos por separado: "itemcode_kcc" (el nuestro, de Kennedy) e "itemcode_proveedor" (el del proveedor). '
    +'NUNCA los mezcles ni repitas el mismo valor en los dos. Si en esa linea solo aparece uno, deja el otro en "".\n'
    +'- REGLA QUE MANDA SOBRE TODO LO DEMAS: si el encabezado de una columna contiene "KCC" '
    +'(KCC ITEM No., KCC ITEM CODE, KCC CODE, COD KCC, KCC REF...), esa columna es NUESTRA y su valor '
    +'va SIEMPRE en "itemcode_kcc", nunca en "itemcode_proveedor". La palabra "Item Code" sola, SIN KCC '
    +'delante, si es del proveedor. No te dejes llevar por el parecido de los textos.\n'
    +'- CUIDADO: en NUESTRA orden las columnas "Factory Code" y "KCC ITEM No." estan PEGADAS, una al lado de la otra. '
    +'La PRIMERA (Factory Code) es la del proveedor y NO se usa. La SEGUNDA (KCC ITEM No.) es la nuestra y es la que va en "itemcode_kcc".\n'
    +'- COMO RECONOCERLOS POR SU FORMA: el codigo de Kennedy es numerico de 5 a 8 digitos (ej: 2313496, 26274) o empieza con BA- seguido de digitos '
    +'(ej: BA-2324041, BA-2317969). El de fabrica mezcla letras y numeros (ej: V-S12Q, V-S20Q, V-A13-SS, V-M96210-SS, B0040MP5L, BBQ4004, W4068). '
    +'Si el valor que ibas a poner en "itemcode_kcc" tiene letras mezcladas como V-S12Q, ESTA MAL: ese es el de fabrica, busca el que empieza con BA- o el numerico.\n'
    +'- Ejemplo real de una linea nuestra: Factory Code "V-S12Q", KCC ITEM No. "BA-2324041", BARCODE "7450123240419". '
    +'Entonces itemcode_kcc = "BA-2324041", itemcode_proveedor = "V-S12Q". El barcode NO es un codigo de item, no lo uses nunca.\n'
    +'- El codigo de Kennedy ES EL PUNTO MAS IMPORTANTE. Tiene que ser SIEMPRE el codigo interno de KENNEDY CENTER, NUNCA el del proveedor.\n'
    +'  Como distinguirlos: el codigo de Kennedy aparece en columnas rotuladas "KCC ITEM No", "KCC ITEM", "KCC Item No.", "Codigo KCC", '
    +'"Item Kennedy", o simplemente "Code" en la PI del proveedor. Suele ser numerico de 6 a 7 digitos (ej: 2313496, 26274) o empezar con BA- (ej: BA-2317969).\n'
    +'  El codigo del PROVEEDOR aparece como "Factory Code", "Item No.", "Supplier Code", "Ref proveedor", "Vendor Item" y suele tener letras y numeros '
    +'mezclados (ej: B0040MP5L, BBQ4004, KT251008, W4068). ESOS NO SE USAN.\n'
    +'  Si una linea muestra los dos codigos, elige SIEMPRE el de Kennedy. Ejemplo real: si la fila dice Factory Code "BBQ4004" y KCC ITEM "BA-2317969", '
    +'el itemcode correcto es "BA-2317969". Si dice Factory Code "B0040MP5L" y KCC ITEM "2313496", el itemcode correcto es "2313496".\n'
    +'  Toma el codigo de NUESTRA orden (documento A) cuando exista; solo si falta, usa el de la PI del proveedor.\n'
    +'- En "itemname" usa una descripcion CORTA de maximo 60 caracteres.\n'
    +'- "doc" en errores: "kcc", "proveedor" o "ambos".\n'
    +'- "gravedad": "alta" si afecta dinero, cantidades o el item comprado; "media" en fechas, terminos o condiciones; "baja" si es de forma.\n'
    +'- "detalle": una sola frase, CON LOS NUMEROS involucrados.\n'
    +'- "coinciden": true solo si NO hay diferencias de gravedad alta ni media.\n'
    +'- Si solo hay un documento, deja el otro bloque vacio y "diferencias":[].\n'
    +'- En documentos largos reporta como maximo 40 diferencias, priorizando las de gravedad alta.\n'
    +'- Si un dato no aparece usa "" o 0. Nunca inventes datos.';
  return p;
}

// Pinta el reporte de incidencias
function _nsapPintarComparacion(obj, calc, hayKcc, hayProv){
  var box=document.getElementById('nsapIAerrores'); if(!box) return 0;
  var difs=(Array.isArray(obj.diferencias)?obj.diferencias:[]).map(function(d){
    if(typeof d==='string') return {campo:'', kcc:'', proveedor:'', gravedad:'media', detalle:d};
    return {campo:d.campo||'', kcc:(d.kcc!=null?d.kcc:''), proveedor:(d.proveedor!=null?d.proveedor:''),
            gravedad:String(d.gravedad||'media').toLowerCase(), detalle:d.detalle||''};
  }).filter(function(d){ return String(d.detalle||d.campo||'').trim(); });

  var errs=(Array.isArray(obj.errores)?obj.errores:[]).map(function(e){
    if(typeof e==='string') return {doc:'', detalle:e};
    return {doc:e.doc||'', detalle:e.detalle||''};
  }).filter(function(e){ return String(e.detalle||'').trim(); });

  var nAlta=difs.filter(function(d){return d.gravedad==='alta';}).length;
  var h='';

  // Resumen de cada documento
  var k=obj.kcc||{}, pv=obj.proveedor||{};
  if(hayKcc||hayProv){
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:9px">';
    if(hayKcc)  h+=_nsapTarjetaDoc('KCC ORDEN DE COMPRA', k, '#0c447c','#e6f1fb','#85B7EB');
    if(hayProv) h+=_nsapTarjetaDoc('PI PROVEEDOR', pv, '#B45309','#FEF9F3','#E9C08A');
    h+='</div>';
  }

  if(hayKcc && hayProv){
    if(difs.length){
      h+='<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden;margin-bottom:9px">'
        +'<div style="background:var(--pastel-error);padding:8px 11px;font-size:11.5px;font-weight:800;color:var(--t-rojo)">'
        +'<i class="ti ti-git-compare"></i> '+difs.length+' incidencia(s) entre la PI del proveedor y nuestra orden'
        +(nAlta?(' &middot; <span style="color:var(--t-rojo2)">'+nAlta+' grave(s)</span>'):'')+'</div>';
      difs.forEach(function(d){
        var c=d.gravedad==='alta'?'#dc2626':(d.gravedad==='baja'?'#6b7280':'#B45309');
        var bgg=d.gravedad==='alta'?'#FEF2F2':(d.gravedad==='baja'?'var(--surface-1)':'#FEF9F3');
        h+='<div style="padding:8px 11px;border-top:0.5px solid var(--border);background:'+bgg+'">'
          +'<div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap">'
            +'<span style="font-size:9px;font-weight:800;color:#fff;background:'+c+';border-radius:6px;padding:1px 6px;text-transform:uppercase">'+_esc(d.gravedad)+'</span>'
            +(d.campo?('<b style="font-size:11.5px">'+_esc(String(d.campo))+'</b>'):'')
          +'</div>';
        if(String(d.kcc)!==''||String(d.proveedor)!==''){
          h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-top:4px;font-size:11px">'
            +'<span style="flex:1;min-width:140px;background:var(--pastel-azul);border-radius:6px;padding:3px 7px"><b style="color:var(--t-azul)">KCC:</b> '+_esc(String(d.kcc||'—'))+'</span>'
            +'<span style="flex:1;min-width:140px;background:var(--pastel-aviso);border-radius:6px;padding:3px 7px"><b style="color:var(--t-ambar)">PI proveedor:</b> '+_esc(String(d.proveedor||'—'))+'</span>'
          +'</div>';
        }
        if(d.detalle) h+='<div style="font-size:11px;color:var(--text-secondary);margin-top:3px">'+_esc(String(d.detalle))+'</div>';
        h+='</div>';
      });
      h+='</div>';
    } else {
      h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600;margin-bottom:9px">'
        +'<i class="ti ti-git-compare"></i> Los dos documentos coinciden: mismos items, cantidades, precios y totales.</div>';
    }
  } else if(hayKcc||hayProv){
    h+='<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-marron);margin-bottom:9px">'
      +'<i class="ti ti-info-circle"></i> Solo se analizó <b>'+(hayKcc?'nuestra orden de compra':'la PI del proveedor')+'</b>. '
      +'Adjunta el otro documento para poder compararlos.</div>';
  }

  // Errores internos + recálculo propio
  var todos=[];
  var etq={kcc:'Nuestra orden', proveedor:'PI proveedor', ambos:'Ambos'};
  errs.forEach(function(e){ todos.push({o:(etq[e.doc]||'AI'), t:e.detalle}); });
  (calc&&calc.errores||[]).forEach(function(t){ todos.push({o:'Cálculo', t:t}); });
  var vistos={}, lista=[];
  todos.forEach(function(x){ var kk=String(x.t).toLowerCase().replace(/\s+/g,' '); if(!vistos[kk]){ vistos[kk]=1; lista.push(x); } });

  if(lista.length){
    h+='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-rojo)">'
      +'<div style="font-weight:800;margin-bottom:4px"><i class="ti ti-alert-triangle"></i> '+lista.length+' problema(s) en los números:</div>'
      +'<ul style="margin:4px 0 0 16px;padding:0">'
      +lista.map(function(x){ return '<li style="margin-bottom:2px"><b style="opacity:.7">'+_esc(x.o)+':</b> '+_esc(x.t)+'</li>'; }).join('')
      +'</ul></div>';
  } else if(hayKcc||hayProv){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Las líneas y los totales cuadran.</div>';
  }

  box.innerHTML=h;
  return difs.length+lista.length;
}

function _nsapTarjetaDoc(titulo, d, color, bg, bd){
  return '<div style="flex:1;min-width:180px;background:'+bg+';border:0.5px solid '+bd+';border-radius:8px;padding:8px 10px">'
    +'<div style="font-size:10.5px;font-weight:800;color:'+color+';margin-bottom:3px">'+titulo+'</div>'
    +'<div style="font-size:11px;line-height:1.5">'
      +(d.num_orden?('<div>Orden: <b>'+_esc(String(d.num_orden))+'</b></div>'):'')
      +(d.po?('<div>PO: <b>'+_esc(String(d.po))+'</b></div>'):'')
      +(d.proveedor?('<div>'+_esc(String(d.proveedor))+'</div>'):'')
      +(Number(d.total)?('<div>Total: <b>'+fmt(d.total)+'</b></div>'):'')
      +(Number(d.unidades)?('<div>Piezas: <b>'+Number(d.unidades).toLocaleString('en-US')+'</b></div>'):'')
      +(Array.isArray(d.items)&&d.items.length?('<div>Líneas: <b>'+d.items.length+'</b></div>'):'')
    +'</div></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  BORRADOR DE LA ORDEN NO SAP
//  Guarda lo que se lleva escrito para seguir más tarde. Se guarda en el
//  navegador de la persona, así que no ocupa nada en la base ni ensucia la
//  lista de órdenes hasta que se cree de verdad.
// ═══════════════════════════════════════════════════════════════════════════
// Cerrar guarda el borrador solo si hay algo escrito
function _nsapCerrarModal(){
  var guardado=false;
  try{ guardado=_nsapGuardarDraft(true); }catch(e){}
  var m=document.getElementById('modalNuevaSAP'); if(m) m.remove();
  if(guardado) showT('Se guardó un borrador con lo que llevabas');
}

// Cortina con rueda mientras se crea la orden: toca varias tablas y sube
// archivos, así que puede tardar unos segundos.
function _nsapCreando(txt){
  // Red de seguridad: si algo se cuelga, la rueda se quita sola
  if(window._nsapCreandoTimer) clearTimeout(window._nsapCreandoTimer);
  window._nsapCreandoTimer=setTimeout(function(){
    if(document.getElementById('nsapCreandoOv')){
      _nsapCreandoFin();
      showT('La creación está tardando más de lo normal. Revisa si la orden quedó guardada.');
      try{ _refrescarPantalla(); }catch(e){}
    }
  }, 45000);
  var ov=document.getElementById('nsapCreandoOv');
  if(!ov){
    ov=document.createElement('div');
    ov.id='nsapCreandoOv';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:3000;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px';
    ov.innerHTML='<div class="ai-ring" style="width:44px;height:44px;border-width:4px"></div>'
      +'<div id="nsapCreandoTxt" style="color:#fff;font-size:14px;font-weight:600;text-align:center;padding:0 20px"></div>'
      +'<div style="color:#ccc;font-size:11.5px">No cierres esta ventana</div>';
    document.body.appendChild(ov);
  }
  var t=document.getElementById('nsapCreandoTxt');
  if(t) t.textContent=txt||'Creando la orden…';
}
function _nsapCreandoFin(){
  if(window._nsapCreandoTimer){ clearTimeout(window._nsapCreandoTimer); window._nsapCreandoTimer=null; }
  var ov=document.getElementById('nsapCreandoOv'); if(ov) ov.remove();
}

function _nsapDraftKey(){ return 'nsap_draft_'+((CU&&CU.id)||'x'); }

function _nsapLeerForm(){
  function v(id){ var e=document.getElementById(id); return e?e.value:''; }
  return {
    dept:v('nsapDept'), prov:v('nsapProv'), cardcode:v('nsapProvCod'),
    ref:v('nsapRef'), po:v('nsapPO'),
    total:v('nsapTotal'), abon:v('nsapAbon'), saldo:v('nsapSaldo'),
    fechaAbono:v('nsapFechaAbono'),
    items:(window._nsapItems||[]),
    guardado_en:new Date().toISOString(),
    guardado_por:(CU&&CU.name)||''
  };
}

function _nsapGuardarDraft(silencioso){
  var d=_nsapLeerForm();
  var vacio=!d.prov && !d.ref && !d.total && !(d.items||[]).length;
  if(vacio){ if(!silencioso) showT('No hay nada que guardar todavía'); return false; }
  window._nsapDraftMem=d;
  try{ localStorage.setItem(_nsapDraftKey(), JSON.stringify(d)); }catch(e){}
  if(!silencioso){
    showT('✓ Borrador guardado. Puedes cerrar y seguir más tarde.');
    var m=document.getElementById('modalNuevaSAP'); if(m) m.remove();
    try{ _refrescarPantalla(); }catch(e){}
  }
  return true;
}

function _nsapLeerDraft(){
  if(window._nsapDraftMem) return window._nsapDraftMem;
  try{
    var s=localStorage.getItem(_nsapDraftKey());
    if(s) return JSON.parse(s);
  }catch(e){}
  return null;
}

function _nsapBorrarDraft(){
  window._nsapDraftMem=null;
  try{ localStorage.removeItem(_nsapDraftKey()); }catch(e){}
}

function _nsapDescartarDraft(){
  if(!confirm('¿Descartar el borrador guardado?\n\nSe perderá lo que tenías escrito.')) return;
  _nsapBorrarDraft();
  var b=document.getElementById('nsapDraftAviso'); if(b) b.remove();
  showT('Borrador descartado');
}

// Vuelca el borrador en el formulario ya dibujado
function _nsapAplicarDraft(d){
  if(!d) return;
  function s(id,val){ var e=document.getElementById(id); if(e && val!=null && val!=='') e.value=val; }
  s('nsapDept',d.dept); s('nsapProv',d.prov); s('nsapProvCod',d.cardcode);
  s('nsapRef',d.ref); s('nsapPO',d.po);
  s('nsapTotal',d.total); s('nsapAbon',d.abon); s('nsapFechaAbono',d.fechaAbono);
  window._nsapItems=(d.items||[]).slice();
  try{ _nsapCalcSaldo(); }catch(e){}
  try{ _nsapRenderItems(); }catch(e){}
  if(d.cardcode) window._nsapCardcode=d.cardcode;
  var st=document.getElementById('nsapIAstatus');
  if(st) st.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-device-floppy"></i> Borrador recuperado del '
    +_esc(_fechaHora(d.guardado_en))+'. Los documentos hay que volver a adjuntarlos.</span>';
}

// Aviso arriba del formulario cuando hay un borrador
function _nsapAvisoDraft(){
  var d=_nsapLeerDraft(); if(!d) return '';
  var n=(d.items||[]).length;
  return '<div id="nsapDraftAviso" style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:12px">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);margin-bottom:3px"><i class="ti ti-device-floppy"></i> Tienes un borrador sin terminar</div>'
    +'<div style="font-size:10.5px;color:var(--t-marron);margin-bottom:7px">'
      +_esc(d.prov||'(sin proveedor)')+(d.ref?(' · '+_esc(d.ref)):'')+(n?(' · '+n+' producto(s)'):'')
      +' · guardado el '+_esc(_fechaHora(d.guardado_en))+'</div>'
    +'<div style="display:flex;gap:6px">'
      +'<button class="btn bp" style="background:#B45309;padding:5px 11px;font-size:11px" onclick="_nsapAplicarDraft(_nsapLeerDraft())"><i class="ti ti-restore"></i> Continuar</button>'
      +'<button class="btn bg2" style="padding:5px 11px;font-size:11px;color:var(--text-danger)" onclick="_nsapDescartarDraft()"><i class="ti ti-trash"></i> Descartar</button>'
    +'</div></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  CÓDIGOS DE ITEM: SIEMPRE EL DE KENNEDY
//  La IA a veces confunde las columnas porque en la PI del proveedor el código
//  de Kennedy viene rotulado "Code" y el del proveedor "Item No.". Por eso no
//  alcanza con pedírselo: aquí se verifica contra el inventario de SAP, que es
//  la única fuente donde viven los códigos KCC de verdad.
// ═══════════════════════════════════════════════════════════════════════════
// ¿Tiene forma de código de Kennedy?
// Los nuestros son numéricos de 5 a 8 dígitos (2313496, 26274) o BA- seguido
// de dígitos (BA-2324041). Los de fábrica mezclan letras y números
// (V-S12Q, V-M96210-SS, B0040MP5L, BBQ4004, W4068) y nunca calzan.
// Los códigos de barra son de 13 dígitos, así que tampoco entran.
function _esCodigoKCC(c){
  var t=String(c||'').trim().toUpperCase().replace(/\s+/g,'');
  if(!t) return false;
  return /^\d{5,8}$/.test(t) || /^BA-?\d{5,8}$/.test(t);
}

async function _nsapResolverCodigos(items){
  items=items||[];
  if(!items.length) return {items:items, verificados:0, corregidos:0, sinKcc:0};

  // Todos los candidatos que trajo la IA
  var cand={};
  items.forEach(function(it){
    [it.itemcode, it.itemcode_kcc, it.itemcode_proveedor].forEach(function(c){
      c=String(c||'').trim(); if(c) cand[c.toUpperCase()]=c;
    });
  });
  var lista=Object.keys(cand);
  if(!lista.length) return {items:items, verificados:0, corregidos:0, sinKcc:0};

  // ¿Cuáles existen en el inventario? Esos son códigos KCC reales.
  // Se pide también la foto: si el artículo ya está en SAP, su foto sale de
  // ahí y no hay que sacarla del Excel del proveedor.
  var enSap={}, infoSap={};
  try{
    for(var i=0;i<lista.length;i+=200){
      var chunk=lista.slice(i,i+200);
      var inList=chunk.map(function(c){ return '"'+cand[c].replace(/"/g,'')+'"'; }).join(',');
      var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,picturname&itemcode=in.('+encodeURIComponent(inList)+')&limit=400',{headers:SBH});
      if(r.ok) (await r.json()||[]).forEach(function(x){
        var k=String(x.itemcode||'').toUpperCase();
        enSap[k]=x.itemcode; infoSap[k]=x;
      });
    }
  }catch(e){ console.warn('verificar codigos KCC:',e); }

  var verificados=0, corregidos=0, sinKcc=0;
  var out=items.map(function(it){
    var kcc=String(it.itemcode_kcc||'').trim();
    var prov=String(it.itemcode_proveedor||'').trim();
    var actual=String(it.itemcode||'').trim();
    var elegido=kcc||actual;

    var kccOk=kcc && enSap[kcc.toUpperCase()];
    var provOk=prov && enSap[prov.toUpperCase()];
    var actualOk=actual && enSap[actual.toUpperCase()];

    // 1) Existe en el inventario: es un código KCC comprobado
    if(kccOk){ elegido=enSap[kcc.toUpperCase()]; verificados++; }
    else if(actualOk && (!kcc || actual.toUpperCase()===kcc.toUpperCase())){ elegido=enSap[actual.toUpperCase()]; verificados++; }
    else if(provOk){
      // El que la IA marcó como del proveedor sí existe en SAP: venían cruzados
      elegido=enSap[prov.toUpperCase()]; verificados++; corregidos++;
    }
    // 2) SKU nuevo que todavía no está en SAP: manda la FORMA del código.
    //    Esto es lo que evita que se cuele un V-S12Q en lugar de BA-2324041.
    else {
      var cands=[kcc, actual, prov].filter(Boolean);
      var conForma=cands.filter(_esCodigoKCC);
      if(conForma.length){
        var nuevoCod=conForma[0];
        if(elegido && nuevoCod.toUpperCase()!==String(elegido).toUpperCase()) corregidos++;
        elegido=nuevoCod;
      } else if(elegido && !_esCodigoKCC(elegido)){
        sinKcc++;   // ninguna columna tiene forma de código nuestro
      }
    }
    var res=Object.assign({}, it, {itemcode:elegido});
    delete res.itemcode_kcc; delete res.itemcode_proveedor;
    // Si el artículo ya existe en SAP se marca. Su foto sale del inventario,
    // PERO solo si esa foto existe de verdad: SAP rellena picturname aunque la
    // imagen no haya llegado al bucket, y entonces el artículo se quedaba sin
    // nada porque además se descartaba la del Excel del proveedor.
    // La comprobación real se hace después, fuera de este map, porque es async.
    var inf=infoSap[String(elegido||'').toUpperCase()];
    if(inf){
      res._enSAP=true;
      if(!res.itemname && inf.itemname) res.itemname=inf.itemname;
      res._picturnameSAP=String(inf.picturname||'').trim();
    }
    return res;
  });

  // Ahora sí: se comprueba cuáles de esas fotos de SAP se pueden ver. Las que
  // no, se dejan sin marcar para que el Excel del proveedor las cubra.
  var _sinFotoReal=0;
  for(var q=0;q<out.length;q++){
    var _pn=out[q]._picturnameSAP;
    delete out[q]._picturnameSAP;
    if(!_pn) continue;
    var _ok=false;
    try{ _ok=await _fotoSapExiste(_pn); }catch(e){ _ok=false; }
    if(_ok){
      var _u=''; try{ _u=_repFotoUrl(_pn)||''; }catch(e){}
      if(_u){ out[q]._foto=_u; out[q]._fotoDeSAP=true; }
    } else {
      _sinFotoReal++;
      console.warn('[nosap] '+out[q].itemcode+': SAP declara "'+_pn
        +'" pero la imagen no está en el bucket. Se usará la del Excel del proveedor.');
    }
  }
  if(_sinFotoReal){
    console.info('[nosap] '+_sinFotoReal+' artículo(s) en SAP sin foto usable: '
      +'las fotos saldrán del Excel del proveedor.');
  }
  return {items:out, verificados:verificados, corregidos:corregidos, sinKcc:sinKcc};
}

// Guarda temporalmente el archivo elegido y dispara la extracción por IA
window._nsapArchivo=null;
function _nsapArchivoElegido(input){
  var f=input.files&&input.files[0]; if(!f) return;
  document.getElementById('nsapFileLbl').textContent=f.name;
  window._nsapArchivo=f;
  _extraerOrdenIA(f);
}
// Extrae los datos de la orden con la IA (Claude) desde el PDF/Excel/imagen
async function _extraerOrdenIA(file){
  var st=document.getElementById('nsapIAstatus');
  if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Analizando documento con AI…</span>';
  try{
    var contenido, tipo;
    // Cualquier formato: PDF, imagen, Excel, Word o texto
    var _prep=await _iaDesdeBlob(file, file.name);
    contenido=(_prep && _prep.bloques && _prep.bloques.length)
      ? (_prep.bloques.length===1 ? _prep.bloques[0] : _prep.bloques)
      : {type:'text', text:'ARCHIVO '+file.name+': no se pudo leer.'};
    var prompt='Analizá este documento de una orden de compra a proveedor y devolvé SOLO un JSON (sin explicación, sin backticks) con estos campos exactos: {"proveedor": "nombre del proveedor", "num_orden": "número de referencia interno que empieza con DKC- o SKC- (ej DKC-25090)", "po": "número de PO del proveedor (Purchase Order), distinto del DKC/SKC", "total": número, "abonado": número, "saldo": número, "unidades": número, "cartones": número, "items": [{"itemcode": "código de Kennedy Center", "itemname": "descripción", "cantidad": número, "precio_unit": número, "total_linea": número}], "errores": ["..."]}. El num_orden es el código DKC- o SKC-. El po es el número de orden de compra del proveedor. IMPORTANTE sobre itemcode: usá SIEMPRE el CÓDIGO INTERNO DE KENNEDY CENTER, nunca el del proveedor. El de Kennedy aparece en columnas como "KCC ITEM No", "KCC ITEM", "Código KCC", "Item Kennedy", o "Code" en las PI de proveedor, y suele ser numérico de 6-7 dígitos (2313496, 26274) o empezar con BA- (BA-2317969). El del proveedor aparece como "Factory Code", "Item No.", "Supplier Code" o "Vendor Item" y mezcla letras y números (B0040MP5L, BBQ4004, KT251008, W4068): ESOS NO se usan. Si la fila trae los dos, elige siempre el de Kennedy. En "items" incluí TODAS las líneas de producto.\n'
      +'REGLA DE CANTIDADES, MUY IMPORTANTE: la "cantidad" de cada línea va SIEMPRE en PIEZAS, nunca en cartones. Usá la columna de cantidad pedida en piezas (ORDER QTY / Pcs, ORDER QTY, QTY, Qty, Quantity, CANTIDAD, PCS). NO uses nunca QTY X CTN, QTY/CTN, PCS/CTN, No.Ctn, TTL CTNS, CTNS, CARTONS, inner ni similares: esas son piezas por cartón o cantidad de cartones. Ejemplo: si la línea dice ORDER QTY/Pcs = 300, QTY X CTN = 6 y TTL CTNS = 50, la cantidad es 300. Verificá siempre que cantidad x precio_unit dé el total de la línea; si no cuadra, tomaste la columna equivocada. "unidades" es el total de PIEZAS del documento y "cartones" el total de cartones.\n'
      +'REVISIÓN OBLIGATORIA: además de extraer, revisa la aritmética del documento y poné en "errores" CUALQUIER inconsistencia, con los números involucrados: cantidad x precio unitario que no cuadre con el total de la línea; suma de las líneas que no cuadre con el total general; subtotal + impuestos + flete - descuentos que no dé el total; cantidades o precios en cero o negativos; totales repetidos en el documento que no coincidan entre sí; total de piezas o de cartones declarado que no coincida con la suma de las líneas. Describe cada error en una sola frase clara. Si no encontrás errores, devolvé "errores": [].\n'
      +'NUMERO DE ORDEN: "num_orden" va SIEMPRE con su prefijo (DKC-26084), nunca el número solo (26084). El documento a veces lo escribe partido, con "DKC No." en una celda y el número en la de al lado: juntalo.\\n'
      +'DEPOSITO: agregá el campo "deposito_pct". Si los términos de pago indican un porcentaje de depósito o anticipo ("20% Deposit / 80% Balance", "30% anticipo"), devolvé solo ese número (20, 30); si no hay porcentaje, 0. En "abonado" poné un monto solo si el documento dice cuánto se abonó en dinero; si únicamente hay porcentaje, dejá abonado en 0.\\n'
      +'Si un dato no aparece, poné null (para textos) o 0 (para números). Los montos y cantidades como número sin símbolos ni comas de miles. IMPORTANTE: en "itemname" usá una descripción CORTA de máximo 60 caracteres (el nombre del producto, sin medidas ni materiales ni detalles de empaque), para que la respuesta no se corte en documentos con muchas líneas.';
    var msgContent=[contenido, {type:'text', text:prompt}];
    var obj=await _iaJSON(msgContent, 8000, function(n){
      if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Documento largo: la AI sigue leyendo las líneas ('+n+')…</span>';
    });
    if(obj.proveedor) document.getElementById('nsapProv').value=obj.proveedor;
    if(obj.num_orden) document.getElementById('nsapRef').value=_nsapNormRef(obj.num_orden, [obj.po]);
    if(obj.po){ var poEl=document.getElementById('nsapPO'); if(poEl) poEl.value=obj.po; }
    if(obj.total!=null) document.getElementById('nsapTotal').value=obj.total;
    if(obj.abonado!=null) document.getElementById('nsapAbon').value=obj.abonado;
    _nsapCalcSaldo();
    // Igual que en la comparación: si solo hay porcentaje de depósito, se
    // escribe el monto para no dejar el campo en cero.
    window._nsapAbonoDePct=0;
    var _p1=Number(obj.deposito_pct)||0;
    var _a1=document.getElementById('nsapAbon'), _pp1=document.getElementById('nsapAbonPct');
    if(_p1>0 && _p1<=100 && _a1 && !(parseFloat(_a1.value)||0)){
      if(_pp1){ _pp1.value=_p1; _nsapAbonoDesdePct(); }
      else { _a1.value=(Math.round((Number(obj.total)||0)*_p1)/100).toFixed(2); _nsapCalcSaldo(); }
      window._nsapAbonoDePct=_p1;
    }
    if(obj.saldo!=null && !document.getElementById('nsapAbon').value) document.getElementById('nsapSaldo').value=obj.saldo;
    // Guardar los items extraídos y mostrarlos
    window._nsapItems=(Array.isArray(obj.items)?obj.items:[]).map(function(it){
      var cant=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
      var tl=Number(it.total_linea)|| (cant*pu);
      return {itemcode:String(it.itemcode||'').trim(), itemname:String(it.itemname||'').trim(), cantidad:cant, precio_unit:pu,
        // La ficha técnica, para el catálogo
        descripcion:String(it.descripcion||'').trim(),
        material:String(it.material||'').trim(),
        color:String(it.color||'').trim(),
        tamano:String(it.tamano||'').trim(),
        // El empaque se arma con las piezas por caja y la medida de la caja
        empaque:String(it.empaque||'').trim()
          || [(Number(it.unidades_x_caja)?(_fmtN2(it.unidades_x_caja)+' pzs x caja'):''),
              String(it.carton_size||'').trim()].filter(Boolean).join(' · '),
        carton_size:String(it.carton_size||'').trim(),
        barcode:String(it.barcode||'').trim(),
        marca:String(it.marca||'').trim(),
        unidades_x_caja:Number(it.unidades_x_caja)||0,
        cartones_item:Number(it.cartones_item)||0,
        cbm:Number(it.cbm)||0,
        peso:String(it.peso||'').trim(), total_linea:tl};
    }).filter(function(it){ return it.itemcode||it.itemname; });
    _nsapRenderItems();
    var nIt=window._nsapItems.length;

    // Las fotos incrustadas en el Excel del proveedor: se usan después para
    // armar catálogos de mercancía que todavía no está en SAP.
    // Las fotos incrustadas en el Excel: se buscan en TODOS los archivos
    // adjuntos, no solo en uno, y se avisa en pantalla cómo fue.
    console.log('[nosap] buscando fotos en los adjuntos…');
    try{
      var _cands=[];
      // El archivo puede estar en varios sitios según cómo se abrió el modal
      [window._nsapDocs, window._firmaDocs].forEach(function(st2){
        if(!st2) return;
        if(st2.prov) _cands.push(st2.prov);
        if(st2.kcc)  _cands.push(st2.kcc);
      });
      if(window._nsapArchivo) _cands.push(window._nsapArchivo);
      if(window._firmaArchivo) _cands.push(window._firmaArchivo);
      // Y como último recurso, lo que haya en los campos de archivo
      try{
        document.querySelectorAll('#modalNuevaSAP input[type=file]').forEach(function(inp){
          if(inp.files && inp.files[0]) _cands.push(inp.files[0]);
        });
      }catch(e){}
      // Sin repetidos
      var _vistos={};
      _cands=_cands.filter(function(f){
        if(!f || !f.name) return false;
        var k=f.name+'|'+(f.size||0);
        if(_vistos[k]) return false;
        _vistos[k]=1; return true;
      });
      var _xls=_cands.filter(function(f){ return /\.xlsx$/i.test(f.name||''); });
      console.log('[nosap] archivos adjuntos:', _cands.map(function(f){return f.name;}),
                  '· con fotos posibles:', _xls.length);
      // JSZip es lo que abre el .xlsx: sin él no hay fotos
      if(_xls.length && typeof JSZip==='undefined'){
        console.log('[nosap] JSZip no estaba cargado: se carga ahora');
        try{ await _cargarJSZip(); }catch(e){ console.warn('[nosap] JSZip:', e); }
      }

      if(!_xls.length){
        window._nsapFotosPend={};
        if(_cands.length){
          console.log('[nosap] ningún .xlsx: los .xls, .csv y .pdf no llevan fotos incrustadas');
        }
      } else {
        if(st) st.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)">'
          +'<span class="ai-ring"></span> Sacando las fotos del Excel…</span>';
        var _mapa={};
        for(var _q=0;_q<_xls.length;_q++){
          try{
            var _m=await _nsapFotosPorSku(_xls[_q], window._nsapItems);
            Object.keys(_m||{}).forEach(function(k){ if(!_mapa[k]) _mapa[k]=_m[k]; });
          }catch(e){ console.warn('[nosap] '+_xls[_q].name+':', e); }
        }
        window._nsapFotosPend=_mapa;
        var _nf=Object.keys(_mapa).length;
        if(_nf){
          window._nsapItems.forEach(function(it){
            var k=String(it.itemcode||'').trim().toUpperCase();
            if(_mapa[k]) it._foto='data:'+_mapa[k].mime+';base64,'+_mapa[k].b64;
          });
          _nsapRenderItems();
        }
        // El detalle de por qué salió así, para no quedarse a ciegas
        var _diag=window._nsapFotosDiag||{};
        window._nsapFotosMsg = _nf
          ? ('<span style="color:var(--text-success)"><i class="ti ti-photo-check"></i> '
             +_nf+' de '+window._nsapItems.length+' artículo(s) con foto</span>')
          : ('<span style="color:var(--t-ambar)"><i class="ti ti-photo-off"></i> '
             +'No se pudo sacar ninguna foto · '
             +(_diag.imagenes===0 ? 'el Excel no trae imágenes'
              : (!_diag.jszip ? 'no se pudo abrir el archivo (JSZip)'
              : (_diag.ubicados===0 ? 'no se encontraron los códigos en la hoja'
              : 'las imágenes están fuera de la tabla de artículos')))
             +'</span>');
        console.log('[nosap] fotos:', _nf+'/'+window._nsapItems.length, _diag);
      }
    }catch(e){
      console.warn('[nosap] fotos del Excel:', e);
      window._nsapFotosMsg='<span style="color:var(--t-ambar)">No se pudieron leer las fotos: '
        +String(e.message||e).slice(0,60)+'</span>';
    }
    // Identificar el proveedor contra SAP con lo que extrajo la AI
    try{ await _nsapBuscarProvSAP(true); }catch(e){}
    // Revisión de cantidades y montos (AI + recálculo propio)
    var calc=_nsapRevisarNumeros(window._nsapItems, obj.total, obj.unidades, obj.cartones);
    var nProb=_nsapPintarRevision(obj.errores, calc);
    window._nsapProblemas=nProb;
    var col=nProb?'#dc2626':(window._iaJSONReparado?'#B45309':'var(--text-success)');
    var ico=nProb?'alert-triangle':(window._iaJSONReparado?'alert-circle':'circle-check');
    // El resultado de las fotos, junto al de la revisión
    var _fmsg=window._nsapFotosMsg||'';
    var msg=nProb
      ? ('Datos extraídos ('+nIt+' productos), pero hay '+nProb+' problema(s) en los números.')
      : ('Datos extraídos'+(nIt?(' ('+nIt+' productos)'):'')+'. '+(window._iaJSONReparado?'El documento es muy largo y la lista pudo quedar incompleta: verificá que estén todas las líneas.':'Revisa y ajustá si hace falta.'));
    if(st) st.innerHTML='<span style="color:'+col+'"><i class="ti ti-'+ico+'"></i> '+msg+'</span>'
      +(_fmsg?('<div style="margin-top:4px;font-size:11px">'+_fmsg+'</div>'):'');
  }catch(e){
    if(st) st.innerHTML='<span style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i> No se pudo extraer automáticamente ('+(e.message||e)+'). Completá los campos a mano.</span>';
  }
}
function _fileB64(file){
  return new Promise(function(res,rej){
    var r=new FileReader();
    r.onload=function(){ res(String(r.result).split(',')[1]); };
    r.onerror=rej;
    r.readAsDataURL(file);
  });
}
// ═══════════════════════════════════════════════════════════════════════════
//  EDITAR UNA ORDEN NO SAP
//  El N° DKC NO cambia nunca: es la llave con la que la orden queda amarrada a
//  la orden firmada. Sí se pueden cambiar proveedor, PO, departamento, montos y
//  productos (si el proveedor no puede fabricar algo o se decide no comprarlo).
//  El motivo del cambio es obligatorio y queda en el historial de la orden.
// ═══════════════════════════════════════════════════════════════════════════
function _pendSAPBuscar(ref){
  return (window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref); });
}
function _pendSAPItems(p){
  var items=p&&p.items;
  if(typeof items==='string'){ try{ items=JSON.parse(items); }catch(e){ items=[]; } }
  return Array.isArray(items)?items:[];
}
function _pendSAPEdiciones(p){
  var e=p&&p.ediciones;
  if(typeof e==='string'){ try{ e=JSON.parse(e); }catch(_){ e=[]; } }
  return Array.isArray(e)?e:[];
}
// Sello visual de "orden editada"
function _pendSAPBadgeEditada(p){
  if(!p||!p.editada) return '';
  var n=_pendSAPEdiciones(p).length;
  return '<span class="ord-editada" title="Orden editada'+(n?(' \u00b7 '+n+' cambio(s)'):'')+'">'
       + '<i class="ti ti-pencil"></i> editada'+(n>1?(' \u00d7'+n):'')+'</span>';
}

function abrirEditarOrdenSinSAP(ref){
  var p=_pendSAPBuscar(ref);
  if(!p){ showT('Orden no encontrada'); return; }
  var itemsAct=_pendSAPItems(p);
  // Copia de trabajo: si cancela, la orden original queda intacta
  window._nsapItems=itemsAct.map(function(it){ return Object.assign({}, it); });
  window._nsapEditRef=String(p.dkc||p.num_orden);
  window._nsapEditAntes={
    proveedor:p.proveedor||'', po:p.po||'', dept:p.dept||'',
    total:Number(p.total)||0, abonado:Number(p.abonado)||0,
    saldo:Number(p.saldo!=null?p.saldo:((p.total||0)-(p.abonado||0))),
    n_items:itemsAct.length
  };

  var ov=document.createElement('div');
  ov.id='modalEditarSAP';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1003;display:flex;align-items:center;justify-content:center;padding:16px';
  var opts='<option value="">Departamento…</option>'+DEPTS_ALL.map(function(d){
    return '<option value="'+d+'"'+((p.dept===d)?' selected':'')+'>'+(EMOJIS2[d]||'')+' '+dL(d)+'</option>';
  }).join('');

  var h='<div style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:480px;width:100%;max-height:90vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">'
    +'<div style="font-size:15px;font-weight:600"><i class="ti ti-pencil" style="color:var(--t-ambar)"></i> Editar orden sin SAP</div>'
    +'<button onclick="document.getElementById(\'modalEditarSAP\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';

  h+='<div style="background:var(--pastel-aviso);border:0.5px solid #E9C08A;border-radius:8px;padding:10px 12px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
    +'<i class="ti ti-info-circle"></i> El <b>N° DKC no cambia</b>. Puedes ajustar proveedor, montos y productos: quita los items que el proveedor no puede fabricar o los que se decidió no comprar.</div>';

  h+='<div style="display:flex;flex-direction:column;gap:9px">';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de orden (DKC) — no editable</label>'
    +'<input id="nsapRef" value="'+_esc(p.dkc||p.num_orden||'')+'" readonly style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1);color:var(--text-muted);font-weight:700"></div>';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Departamento *</label><select id="nsapDept" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1)">'+opts+'</select></div>';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Proveedor *</label><input id="nsapProv" value="'+_esc(p.proveedor||'')+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">N° de PO del proveedor</label><input id="nsapPO" value="'+_esc(p.po||'')+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="display:flex;gap:8px">';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Total *</label><input id="nsapTotal" type="number" step="0.01" value="'+(Number(p.total)||0)+'" oninput="_nsapCalcSaldo()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Por Abonar</label><input id="nsapAbon" type="number" step="0.01" value="'+(Number(p.abonado)||0)+'" oninput="_nsapCalcSaldo()" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Fecha abono</label><input id="nsapFechaAbono" type="date" value="'+_esc(p.fecha_abono||'')+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px"></div>';
  h+='<div style="flex:1"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Saldo</label><input id="nsapSaldo" type="number" step="0.01" value="'+((Number(p.total)||0)-(Number(p.abonado)||0)).toFixed(2)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:13px;margin-top:3px;background:var(--surface-1)" readonly></div>';
  h+='</div></div>';

  // Productos (mismos ids que el alta, para reusar _nsapRenderItems y compañía)
  h+='<div style="margin-top:14px;border-top:0.5px solid var(--border);padding-top:12px">';
  h+='<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px">'
    +'<label style="font-size:12px;font-weight:600;color:var(--t-ambar)"><i class="ti ti-list-details"></i> Productos de la orden *</label>'
    +'<button onclick="_nsapAddItemManual()" style="font-size:11px;padding:3px 8px;border:0.5px solid #B45309;background:var(--pastel-aviso);color:var(--t-ambar);border-radius:6px;cursor:pointer"><i class="ti ti-plus"></i> Agregar producto</button>'
  +'</div>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-bottom:6px">Usa la × para quitar un producto que ya no se va a comprar.</div>';
  h+='<div id="nsapItemsBox"></div>';
  h+='</div>';

  // Motivo obligatorio
  h+='<div style="margin-top:14px;border-top:0.5px solid var(--border);padding-top:12px">';
  h+='<label style="font-size:12px;font-weight:600;color:var(--text-danger)"><i class="ti ti-alert-circle"></i> Motivo del cambio *</label>';
  h+='<textarea id="nsapMotivo" rows="3" placeholder="Ej: el proveedor no puede fabricar el item KCC-1024; se retira de la orden." style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;font-size:12.5px;margin-top:5px;background:var(--surface-2);color:var(--text-primary);resize:vertical"></textarea>';
  h+='<div style="font-size:10px;color:var(--text-muted);margin-top:3px">Obligatorio. Queda guardado en el historial de la orden.</div>';
  h+='</div>';

  // Historial de cambios anteriores
  var eds=_pendSAPEdiciones(p);
  if(eds.length){
    h+='<div style="margin-top:12px;border:0.5px solid var(--border);border-radius:8px;overflow:hidden">';
    h+='<div style="background:var(--surface-2);padding:6px 11px;font-size:11px;font-weight:600"><i class="ti ti-history"></i> Cambios anteriores ('+eds.length+')</div>';
    eds.slice().reverse().forEach(function(e){
      h+='<div style="padding:7px 11px;border-top:0.5px solid var(--border);font-size:11px">'
        +'<div style="color:var(--text-muted)">'+_esc(e.fecha||'')+' · '+_esc(e.por||'')+'</div>'
        +'<div style="margin-top:2px">'+_esc(e.motivo||'')+'</div></div>';
    });
    h+='</div>';
  }

  h+='<div style="display:flex;gap:8px;margin-top:16px">';
  h+='<button onclick="document.getElementById(\'modalEditarSAP\').remove()" class="btn bg2" style="flex:1;padding:11px">Cancelar</button>';
  h+='<button onclick="guardarEdicionOrdenSinSAP()" style="flex:2;background:#B45309;color:white;border:none;border-radius:8px;padding:11px;cursor:pointer;font-size:13px;font-weight:600"><i class="ti ti-device-floppy"></i> Guardar cambios</button>';
  h+='</div>';
  h+='</div>';

  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ e.stopPropagation(); });   // no se cierra al hacer clic fuera: hay datos escritos
  document.body.appendChild(ov);
  _nsapRenderItems();
}

async function guardarEdicionOrdenSinSAP(){
  var ref=window._nsapEditRef;
  var p=_pendSAPBuscar(ref);
  if(!p){ showT('Orden no encontrada'); return; }

  var motivo=(document.getElementById('nsapMotivo').value||'').trim();
  if(motivo.length<5){ showT('Escribe el motivo del cambio (obligatorio)'); 
    var mt=document.getElementById('nsapMotivo'); if(mt) mt.focus(); return; }

  var dept=document.getElementById('nsapDept').value;
  var prov=document.getElementById('nsapProv').value.trim();
  var po=(document.getElementById('nsapPO')?document.getElementById('nsapPO').value.trim():'');
  var total=parseFloat(document.getElementById('nsapTotal').value)||0;
  var abon=parseFloat(document.getElementById('nsapAbon').value)||0;
  var saldo=parseFloat(document.getElementById('nsapSaldo').value);
  if(isNaN(saldo)) saldo=total-abon;
  if(!dept){ showT('Seleccioná el departamento'); return; }
  if(!prov){ showT('Falta el proveedor'); return; }
  if(!total||total<=0){ showT('Falta el total'); return; }
  var itemsOrden=(window._nsapItems||[]).filter(function(it){ return (it.itemcode||it.itemname)&&Number(it.cantidad)>0; });
  if(!itemsOrden.length){ showT('La orden debe quedar con al menos 1 producto'); return; }

  var antes=window._nsapEditAntes||{};
  var registro={
    fecha:(typeof now2==='function'?now2():new Date().toLocaleString('es')),
    por:(CU?CU.name:''), rol:(CU?CU.role:''),
    motivo:motivo,
    antes:antes,
    despues:{ proveedor:prov, po:po, dept:dept, total:total, abonado:abon, saldo:saldo, n_items:itemsOrden.length }
  };
  var eds=_pendSAPEdiciones(p); eds.push(registro);

  // El DKC se conserva tal cual: es la llave del amarre
  p.dept=dept; p.proveedor=prov; p.po=po;
  p.total=total; p.abonado=abon; p.saldo=saldo;
  p.fecha_abono=(document.getElementById('nsapFechaAbono')||{}).value||null;
  p.items=itemsOrden;
  p.ediciones=eds;
  p.editada=true;
  p.editado_en=new Date().toISOString();
  p.editado_por=(CU?CU.name:'');
  p.motivo_edicion=motivo;

  await guardarPendSAP(ref);
  try{ addNotif('gerencia','✏️ Orden '+ref+' editada por '+(CU?CU.name:'')+' — '+motivo, '', 'ti-pencil'); }catch(e){}

  var m=document.getElementById('modalEditarSAP'); if(m) m.remove();
  // Refrescar el detalle si estaba abierto detrás
  document.querySelectorAll('div[style*="fixed"]').forEach(function(el){
    if(el.querySelector && el.querySelector('#pendsap-items-'+ref)) el.remove();
  });
  showT('✓ Orden actualizada — cambio registrado');
  renderNP();
  _refrescarPantalla();
  setTimeout(function(){ abrirPendSAP(ref); }, 250);
}

async function guardarNuevaOrdenSinSAP(){
  var dept=document.getElementById('nsapDept').value;
  var prov=document.getElementById('nsapProv').value.trim();
  var ref=document.getElementById('nsapRef').value.trim();
  var po=(document.getElementById('nsapPO')?document.getElementById('nsapPO').value.trim():'');
  var total=parseFloat(document.getElementById('nsapTotal').value)||0;
  // 100% contra copia de B/L: no hay abono, el saldo es el total
  var contraBL=!!((document.getElementById('nsapContraBL')||{}).checked);
  var numRepo=String(((document.getElementById('nsapNumRepo')||{}).value)||'').trim().toUpperCase();
  var abon=contraBL?0:(parseFloat(document.getElementById('nsapAbon').value)||0);
  var saldo=contraBL?total:(parseFloat(document.getElementById('nsapSaldo').value)||(total-abon));
  if(!dept){ showT('Seleccioná el departamento'); return; }
  if(!prov){ showT('Falta el proveedor'); return; }
  // El proveedor tiene que estar resuelto: o es uno de SAP, o se confirmó que
  // es nuevo. Así no se duplica un proveedor por un error de escritura.
  if(!window._nsapCardcode && !window._nsapProvNuevoOK){
    var _cod=await _nsapBuscarProvSAP(true);
    if(!_cod && !window._nsapProvNuevoOK){
      showT('Revisa el proveedor: elige el de SAP o confirmá que es nuevo');
      var _pi=document.getElementById('nsapProv'); if(_pi) _pi.focus();
      return;
    }
  }
  if(!ref){ showT('Falta el número de orden'); return; }
  if(!total||total<=0){ showT('Falta el total'); return; }
  var itemsOrden=(window._nsapItems||[]).filter(function(it){return (it.itemcode||it.itemname)&&it.cantidad>0;});
  if(!itemsOrden.length){ showT('Agrega al menos 1 producto con cantidad'); return; }
  if((window._pendSAP||[]).some(function(p){return String(p.num_orden||p.dkc).toUpperCase()===ref.toUpperCase();})){ showT('Ya existe una orden con esa referencia'); return; }
  if((orders||[]).some(function(o){return String(o.num_proveedor||'').toUpperCase()===ref.toUpperCase();})){ showT('Esa orden ya existe en SAP'); return; }
  // Revisión final de números antes de crear
  var _rev=_nsapRevisarNumeros(itemsOrden, total);
  if(_rev.errores.length){
    if(!confirm('La revisión encontró '+_rev.errores.length+' problema(s) en los números:\n\n· '
        +_rev.errores.slice(0,6).join('\n· ')
        +(_rev.errores.length>6?('\n· … y '+(_rev.errores.length-6)+' más'):'')
        +'\n\n¿Crear la orden de todas formas?')) return;
  }
  var fecha=(typeof dateOnly==='function'?dateOnly():new Date().toISOString().slice(0,10));
  var fAbono=(document.getElementById('nsapFechaAbono')||{}).value||null;
  // Aviso de progreso: crear la orden toca varias tablas y sube archivos
  _nsapCreando('Creando la orden…');
  // Registro de diferencias contra la reposición. Se calcula SIEMPRE que la
  // orden venga de una reposición, se haya pulsado el botón de comparar o no:
  // es lo que después ve gerencia para saber en qué se apartó la orden de lo
  // que se había pedido.
  var difRepo=null;
  if(numRepo){
    try{
      var _lineas=await _nsapLineasRepo(numRepo);
      if(_lineas){
        difRepo=_nsapCalcularDif(_lineas, itemsOrden);
        difRepo.num=numRepo;
        difRepo.dkc=ref;
        difRepo.fecha=new Date().toLocaleString('es');
        difRepo.por=(CU&&CU.name)||'';
        difRepo.texto=_nsapDifTexto(difRepo);
      } else {
        console.warn('[orden NO SAP] no se encontró la reposición '+numRepo);
      }
    }catch(e){ console.warn('[orden NO SAP] diferencias:', e); }
  }

  if(contraBL) fAbono=null;
  var reg={dkc:ref, num_orden:ref, po:po, dept:dept, proveedor:prov, cardcode:(window._nsapCardcode||''), total:total, fecha_abono:fAbono, abonado:abon, saldo:saldo, by:(CU?CU.name:''), fecha:fecha, creado_en:fecha, items:itemsOrden, pago_contra_bl:contraBL, num_reposicion:numRepo||null,
    dif_reposicion:difRepo?JSON.stringify(difRepo):null};
  window._pendSAP.push(reg);
  // Se adjuntan los DOS documentos: nuestra orden y la PI del proveedor
  var _docs=[];
  if(window._nsapDocs && window._nsapDocs.kcc)  _docs.push(window._nsapDocs.kcc);
  if(window._nsapDocs && window._nsapDocs.prov) _docs.push(window._nsapDocs.prov);
  if(!_docs.length && window._nsapArchivo) _docs.push(window._nsapArchivo);
  // Cada archivo se sube UNA SOLA VEZ al almacenamiento. Después se referencia
  // en las etapas que lo necesitan, sin volver a subirlo ni volver a
  // registrarlo: antes se subea dos veces y se veía duplicado.
  window._nsapDocsSubidos=[];
  for(var _di=0; _di<_docs.length; _di++){
    _nsapCreando('Subiendo documento '+(_di+1)+' de '+_docs.length+'…');
    try{
      var _pth=await _subirDocStorage(ref, 'pedido', _docs[_di]);
      if(_pth){
        var _reg=await _registrarDoc(ref, 'pedido', _docs[_di], _pth);
        var _doc={ id:_reg?_reg.id:undefined, name:_docs[_di].name,
                   data: DOCS_BASE + _pth.split('/').map(encodeURIComponent).join('/'),
                   url:_pth, date:now2(), by:(CU?CU.name:''), remoto:true };
        window._nsapDocsSubidos.push(_doc);
        if(!window._atts) window._atts={};
        // La ficha de adjuntos de la orden y la etapa Pedido apuntan al MISMO archivo
        [ref+'__pendsap', ref+'pedido'].forEach(function(kk){
          if(!window._atts[kk]) window._atts[kk]=[];
          if(!window._atts[kk].some(function(a){ return a.url===_doc.url; })) window._atts[kk].push(_doc);
        });
      }
    }catch(e){ console.warn('subir doc:',e); }
  }
  if(_docs.length){
    try{
      var _attsK=window._atts&&window._atts[ref+'__pendsap'];
      if(_attsK&&_attsK.length){reg.adjunto_url=_attsK[0].data||_attsK[0].url||null;reg.adjunto_name=_attsK[0].name||null;}
    }catch(e){}
  }
  window._nsapArchivo=null;
  window._nsapDocs={prov:null, kcc:null};
  _nsapCreando('Guardando la orden…');
  await guardarPendSAP(ref);
  var modal=document.getElementById('modalNuevaSAP'); if(modal) modal.remove();
  _nsapCreando('Preparando las etapas…');
  try{ _nsapBorrarDraft(); }catch(e){}
  // Ya viene firmada por gerencia: la etapa Pedido queda completa
  try{ await _nsapMarcarPedidoHecho(ref); }catch(e){ console.warn('pedido hecho:',e); }
  // Sin abono: los pasos del depósito quedan hechos y el seguimiento espera
  // en la solicitud del balance final
  // Si viene de una reposición, esa reposición queda como orden aprobada y
  // firmada: en el seguimiento pasa a verde y se sabe que ya está cerrada.
  if(numRepo){
    try{
      var _ok=await _repMarcarOrdenCreada(numRepo, ref);
      if(_ok) showT('Reposición '+numRepo+' marcada como orden aprobada y firmada');
      else console.warn('[reposición] no se encontró '+numRepo+' para marcarla');
    }catch(e){ console.warn('[reposición] marcar:', e); }
    var _drop=(window._pendSapDrop||[]);
    if(difRepo && _drop.indexOf('dif_reposicion')>=0){
      // Se calculó y se mostró, pero no se pudo guardar. Se muestra la
      // respuesta literal del servidor, que es lo único que dice la causa.
      alert('La orden SÍ se guardó, pero el detalle de diferencias no.\n\n'
        +'Le faltan estas columnas a compras_pend_sap:\n  '
        +(window._pendSapDrop||[]).join(', ')
        +'\n\nCorré el script compras_pend_sap_columnas.sql en Supabase.\n\n'
        +'Respuesta del servidor:\n'+(window._pendSapError||'(sin detalle)'));
    } else if(difRepo && !difRepo.cuadra){
      showT('Ojo: la orden se apartó de la reposición '+numRepo+' · '
        +difRepo.faltan.length+' sin pedir, '+difRepo.agregados.length+' agregados, '
        +difRepo.distintos.length+' con otra cantidad. Queda registrado en la orden.', 8000);
    }
  }
  if(contraBL){
    try{
      await _nsapMarcarSinAbono(ref);
      showT('Sin abono · 100% contra copia de B/L: el depósito queda cerrado y '
        +'la orden espera en la solicitud del balance final', 6500);
    }catch(e){ console.warn('sin abono:',e); }
  }
  // Proveedor y SKUs que todavía no existen en SAP: se guardan como fichas
  // temporales para poder trabajarlos mientras SAP los da de alta.
  // OJO: esto va ANTES de cerrar la rueda. Antes se cerraba aquí y este bloque
  // la volvía a abrir sin cerrarla nunca, así que se quedaba girando.
  try{
    _nsapCreando('Registrando proveedor y SKU nuevos…');
    if(!(window._catNoSap||[]).length) await _catNoSapCargar(true);
    var nuevo=await _catNoSapRegistrarDeOrden(reg);
    _catNoSapBadge();   // el numerito se actualiza de inmediato
    if(nuevo.error){
      showT('⚠ No se registró en Proveedores y SKU NO SAP: '+nuevo.error);
    } else if(nuevo.proveedor || nuevo.items){
      var partes=[];
      if(nuevo.proveedor) partes.push('proveedor nuevo');
      if(nuevo.items) partes.push(nuevo.items+' SKU nuevo(s)');
      showT('Registrado en NO SAP: '+partes.join(' y '));
      _catNoSapBadge();
      // La pantalla se refresca en el momento: antes había que salir y
      // volver a entrar para ver el proveedor recién creado.
      try{ if(PG==='catnosap') rCatNoSap(); }catch(e){ console.warn('refrescar NO SAP:',e); }
      // Si se registró el proveedor pero ningún artículo, se explica por qué:
      // quedarse con un proveedor vacío sin motivo desconcierta.
      if(nuevo.proveedor && !nuevo.items && nuevo.omitidos){
        setTimeout(function(){
          showT('Ningún SKU se agregó · '+(nuevo.motivo||''), 7000);
        }, 2600);
      }
    } else if(nuevo.omitidos){
      showT('No se registró ningún SKU · '+(nuevo.motivo||''), 7000);
    }
  }catch(e){ console.warn('catalogo no sap:',e); }
  finally{
    // Pase lo que pase, la rueda se cierra y la pantalla se refresca
    _nsapCreandoFin();
    showT('✓ Orden sin SAP creada — pendiente de abono');
    try{ _refrescarPantalla(); }catch(e){ console.warn('refrescar:',e); }
  }
}
// Adjunta un archivo a la orden usando el sistema real de documentos
// (sube a Storage + registra en compras_documentos) para que PERSISTA.
async function _adjuntarArchivoPendSAP(ref, file){
  var k=ref+'__pendsap';
  if(!window._atts) window._atts={};
  if(!window._atts[k]) window._atts[k]=[];
  try{
    var path=await _subirDocStorage(ref, '__pendsap', file);
    if(path){
      var reg=await _registrarDoc(ref, '__pendsap', file, path);
      window._atts[k].push({
        id: reg?reg.id:undefined,
        name:file.name,
        data: DOCS_BASE + path.split('/').map(encodeURIComponent).join('/'),
        url:path, date:now2(), by:(CU?CU.name:''), remoto:true
      });
    }
  }catch(e){ console.error('_adjuntarArchivoPendSAP:', e); }
}
// Revisar una orden ya creada con IA (busca errores/detalles en sus adjuntos)
async function revisarPendSAPIA(ref){
  var p=(window._pendSAP||[]).find(function(x){return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref);});
  var atts=(window._atts&&window._atts[ref+'__pendsap'])?window._atts[ref+'__pendsap']:[];
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1003;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:26px;max-width:460px;width:100%;text-align:center">'
    +'<div class="ai-ring" style="width:34px;height:34px;border-width:4px;margin:0 auto 12px"></div>'
    +'<div style="font-size:13px;font-weight:600;color:var(--t-lila)">AI revisando la orden '+ref+'…</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-top:4px">Puede tardar unos segundos según el tamaño del documento.</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{
    if(!atts.length){ throw new Error('Esta orden no tiene documento adjunto para revisar.'); }
    var a=atts[0];
    var ext=(String(a.name||'').split('.').pop()||'').toLowerCase();
    var contenido;
    // Obtener base64 del adjunto: si es remoto (URL), descargarlo; si es local, ya viene en data:...
    var b64, arrBuf;
    if(a.remoto || /^https?:/.test(a.data)){
      var rf=await fetch(a.data);
      arrBuf=await rf.arrayBuffer();
      var bytes=new Uint8Array(arrBuf), bin=''; for(var bi=0;bi<bytes.length;bi++)bin+=String.fromCharCode(bytes[bi]);
      b64=btoa(bin);
    } else {
      b64=a.data.split(',')[1];
    }
    // Cualquier formato, con el mismo criterio que el resto del portal
    var _bin=atob(b64), _u8=new Uint8Array(_bin.length);
    for(var _i=0;_i<_bin.length;_i++) _u8[_i]=_bin.charCodeAt(_i);
    var _blob=new Blob([_u8], {type:(a.mime||'')});
    var _prep=await _iaDesdeBlob(_blob, a.name||('archivo.'+ext));
    if(!_prep || !_prep.bloques || !_prep.bloques.length) throw new Error('No se pudo leer el archivo para revisar.');
    contenido=(_prep.bloques.length===1)?_prep.bloques[0]:_prep.bloques;
    var datosActuales='Datos cargados: proveedor='+(p&&p.proveedor||'?')+', num_orden='+(p&&(p.num_orden||p.dkc)||'?')+', total='+(p&&p.total||0)+', abonado='+(p&&p.abonado||0)+', saldo='+(p&&p.saldo||0)+'.';
    var prompt='Sos un revisor de órdenes de compra. '+datosActuales+' Revisa el documento adjunto y decime en español, en pocas líneas: 1) si los datos cargados coinciden con el documento, 2) cualquier error, inconsistencia o dato faltante que veas (montos que no cuadran, saldo mal calculado, etc). Sé breve y claro.';
    var msgContent=[contenido, {type:'text', text:prompt}];
    var resp=await fetch('https://api.anthropic.com/v1/messages',{
      method:'POST',
      headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
      body:JSON.stringify({model:IA_MODELO, max_tokens:600, messages:[{role:'user', content:msgContent}]})
    });
    // Se lee como TEXTO y luego se interpreta. Al revés no funciona: json()
  // consume el cuerpo, y si falla, el text() posterior devuelve vacío y no
  // hay forma de ver qué llegó. Por eso el aviso no decía nada útil.
  var data, crudoTxt='';
  try{
    crudoTxt=await resp.text();
    data=JSON.parse(crudoTxt);
  }catch(errJ){
    // Sin esto, una respuesta que no sea JSON hace saltar el error con los
    // bytes crudos dentro y en pantalla sale "Unexpected token '\uFFFD'".
    var crudo=crudoTxt;
    console.error('[IA] estado '+resp.status
      +' · tipo: '+((resp.headers&&resp.headers.get&&resp.headers.get('content-type'))||'?')
      +' · '+String(crudo||'').length+' caracteres recibidos');
    console.error('[IA] primeros 300: '
      +String(crudo||'').replace(/[^\x20-\x7E]/g,'·').slice(0,300));
    console.error('[IA] error original: '+((errJ&&errJ.message)||errJ));
    throw new Error(
      resp.status===413 ? 'El documento es demasiado grande para la IA. '
                         +'Súbelo en Excel o CSV, o divídelo.'
    : resp.status===401 ? 'La clave de la IA no es válida o caducó.'
    : resp.status===429 ? 'La IA está saturada. Prueba dentro de un minuto.'
    : resp.status>=500  ? 'La IA no respondió bien (error '+resp.status+').'
    : (resp.status===200
        ? ('La IA respondió, pero el navegador no pudo leer la respuesta. '
           +'Suele ser una extensión del navegador o un antivirus que se '
           +'interponen. Prueba en una ventana de incógnito. En la consola '
           +'queda el detalle de lo que llegó.')
        : 'La IA devolvió una respuesta ilegible (estado '+resp.status+').'));
  }
    if(data.error){ throw new Error(data.error.message||'Error de IA'); }
    var txt=(data.content||[]).map(function(c){return c.text||'';}).join('').trim();
    var h='<div style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:480px;width:100%;max-height:88vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px"><div style="font-size:14px;font-weight:600;color:var(--t-lila)"><i class="ti ti-sparkles"></i> Revisión AI — '+ref+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
    h+='<div style="font-size:13px;line-height:1.6;color:var(--text-primary);white-space:pre-wrap">'+txt.replace(/</g,'&lt;')+'</div>';
    h+='</div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }catch(e){
    ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;padding:22px;max-width:420px"><div style="font-size:13px;color:var(--text-danger)"><i class="ti ti-alert-triangle"></i> '+(e.message||e)+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="margin-top:14px;background:var(--surface-2);border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }
}
// Ver/editar una orden sin SAP con sus adjuntos y chat (modal reutilizando buildPendItem)
function abrirPendSAP(ref){
  window._pendSAPDeptAbierto=null;
  var p=(window._pendSAP||[]).find(function(x){return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref);});
  if(!p){ showT('Orden no encontrada'); return; }
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1002;display:flex;align-items:center;justify-content:center;padding:16px';
  var h='<div style="background:var(--surface-0);border-radius:12px;padding:0;max-width:520px;width:100%;max-height:90vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:center;padding:16px 18px;border-bottom:0.5px solid var(--border)"><div style="font-size:15px;font-weight:600">'+(p.proveedor||'')+' — '+(p.num_orden||p.dkc)+' '+_pendSAPBadgeEditada(p)+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>';
  h+='<div class="pend-detalle">'+buildPendItemDetalle(p)+'</div>';
  h+='</div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  // Cargar las fotos de los items desde el inventario (por itemcode)
  _pendSAPCargarFotos(p);
  // Y traer de la base los documentos de la orden: los shipping marks y todo
  // lo enviado por correo se guardan ahí, y sin esto no aparecen hasta que
  // algo más los cargue.
  (async function(){
    try{
      await cargarDocsOrden(String(p.dkc||p.num_orden));
      if(!document.body.contains(ov)) return;
      var cont=ov.querySelector('.pend-detalle');
      if(cont) cont.innerHTML=buildPendItemDetalle(p);
    }catch(e){ console.warn('[orden] documentos:', e); }
  })();
}
// Busca en inventario las fotos de los items de la orden y las coloca en cada línea
async function _pendSAPCargarFotos(p){
  var items=p.items; if(typeof items==='string'){ try{items=JSON.parse(items);}catch(e){items=[];} }
  items=(items||[]).filter(function(it){return it.itemcode;});
  if(!items.length) return;
  var codes=items.map(function(it){return String(it.itemcode);});
  try{
    // Consultar el inventario por esos itemcodes (in.())
    var inList=codes.map(function(c){return '"'+c.replace(/"/g,'')+'"';}).join(',');
    var r=await fetch(SB+'/rest/v1/inventario?itemcode=in.('+encodeURIComponent(inList)+')&select=itemcode,picturname&limit=1000',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    var mp={};
    (Array.isArray(rows)?rows:[]).forEach(function(x){ mp[String(x.itemcode)]=x.picturname||''; });
    // Colocar cada foto en su línea
    var cont=document.getElementById('pendsap-items-'+p.dkc);
    if(!cont) return;
    cont.querySelectorAll('.pendsap-item-linea').forEach(function(linea){
      var ic=linea.getAttribute('data-ic');
      var pn=mp[ic];
      var cont2=linea.querySelector('.pendsap-item-foto');
      if(pn&&cont2){
        var url=_repFotoUrl(pn);
        cont2.style.cursor='zoom-in';
        cont2.onclick=function(){ _repZoomFoto(encodeURIComponent(url), ic); };
        cont2.innerHTML='<img src="'+url+'" style="width:100%;height:100%;object-fit:cover" onerror="this.style.display=\'none\';this.parentNode.innerHTML=\'<i class=&quot;ti ti-photo-off&quot; style=&quot;color:var(--text-muted);font-size:14px&quot;></i>\'">';
      }
    });
  }catch(e){}
}
// Junta los adjuntos de una orden estén en la clave que estén (documentos de
// la orden, de cada etapa, shipping marks…), poniéndole a cada uno de dónde
// viene para no perder el contexto.
function _attsTodosDeOrden(ref){
  ref=String(ref||''); if(!ref) return [];
  // Si esta orden NO SAP ya tiene su gemela en SAP, lo que se guardó allí
  // (los shipping marks, por ejemplo) también le pertenece.
  var refs=[ref];
  try{
    var p=(window._pendSAP||[]).find(function(x){
      return String(x.dkc)===ref || String(x.num_orden)===ref; });
    if(p){
      var o=_ordenSapDeNoSap(p);
      if(o && String(o.id)!==ref) refs.push(String(o.id));
    }
  }catch(e){}
  var etiquetas={ '__pendsap':'', 'pedido':'Pedido', 'shipping_mark':'Shipping marks',
                  'artes':'Artes', 'produccion':'Producción', 'logistica':'Logística',
                  'aduanizacion':'Aduanización', 'bodega':'Bodega' };
  var out=[];
  Object.keys(window._atts||{}).forEach(function(k){
    var base=refs.find(function(r){ return k.indexOf(r)===0; });
    if(!base) return;
    var suf=k.slice(base.length);
    var et=etiquetas[suf];
    if(et===undefined){                       // deposito_step1, artes_step2…
      et=suf.replace(/_step(\d+)/, ' · paso ').replace(/^_+/,'');
      et=et.charAt(0).toUpperCase()+et.slice(1);
    }
    ((window._atts[k])||[]).forEach(function(a){
      if(a && _docHref(a)) out.push(Object.assign({}, a, {_de:et}));
    });
  });
  try{ return _dedupDocs(out); }catch(e){ return out; }
}

function buildPendItemDetalle(p){
  // Clave segura de la orden (sin dkc no debe reventar el render)
  var _k=String(p.dkc||p.num_orden||'').replace(/'/g,'');
  // TODOS los adjuntos de la orden, no solo los de la clave '__pendsap'.
  // Los shipping marks y lo que se mande por correo se guardan en su propia
  // clave, y mirando una sola quedaban invisibles.
  var atts=_attsTodosDeOrden(p.dkc||p.num_orden);
  var h='<div style="padding:14px 18px">';
  // Datos de cabecera
  h+='<div style="display:flex;gap:14px;flex-wrap:wrap;margin-bottom:12px;font-size:12px">';
  h+='<span>Proveedor: <strong>'+_esc(p.proveedor||'-')+'</strong></span>';
  h+='<span>Orden: <strong>'+_esc(p.num_orden||p.dkc)+'</strong></span>';
  if(p.po)h+='<span>PO: <strong>'+_esc(p.po)+'</strong></span>';
  if(p.dept)h+='<span>Depto: <strong>'+dL(p.dept)+'</strong></span>';
  h+='</div>';
  h+='<div style="margin-bottom:12px;display:flex;gap:7px;flex-wrap:wrap">'
    +((CU&&(CU.role==='gerencia'||CU.role==='compras'))?('<button class="btn bg2" style="font-size:11px;padding:6px 12px" title="Deja una sola copia de cada documento" onclick="_limpiarDocsDuplicados(\''+_esc(String(p.dkc||p.num_orden))+'\').then(function(){ abrirPendSAP(\''+_esc(String(p.dkc||p.num_orden))+'\'); })"><i class="ti ti-copy-off"></i> Quitar archivos duplicados</button>'):'')
    +'<button class="btn bp" style="font-size:11px;padding:6px 12px" onclick="this.closest(\'div[style*=fixed]\').remove();abrirDetalleNoSap(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-list-check"></i> Abrir etapas de la orden</button>'
    +((CU&&CU.role==='contabilidad')?'':('<button class="btn bp" style="background:#B45309;font-size:11px;padding:6px 12px" onclick="abrirEditarOrdenSinSAP(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-pencil"></i> Editar orden</button>'))
    +(_esGerencia()?('<button class="btn bp" style="background:var(--text-danger);font-size:11px;padding:6px 12px" onclick="this.closest(\'div[style*=fixed]\').remove();_gerBorrarOrdenNoSap(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-trash"></i> Borrar orden completa</button>'):'')
    +((CU&&CU.role==='contabilidad')?'':('<button class="btn bp" style="background:#166534;font-size:11px;padding:6px 12px" onclick="marcarEnSAP(\''+_esc(String(p.dkc||p.num_orden))+'\')"><i class="ti ti-database-import"></i> Ya está en SAP (quitar de No SAP y Firma)</button>'))
  +'</div>';
  // Historial de ediciones
  var _eds=_pendSAPEdiciones(p);
  if(_eds.length){
    h+='<div style="border:0.5px solid #E9C08A;background:var(--pastel-aviso);border-radius:8px;overflow:hidden;margin-bottom:12px">';
    h+='<div style="padding:7px 12px;font-size:11.5px;font-weight:700;color:var(--t-marron)"><i class="ti ti-history"></i> Historial de cambios ('+_eds.length+')</div>';
    _eds.slice().reverse().forEach(function(e){
      var a=e.antes||{}, d=e.despues||{};
      var cambios=[];
      if(a.proveedor!==d.proveedor) cambios.push('proveedor: '+_esc(a.proveedor||'-')+' → '+_esc(d.proveedor||'-'));
      if(Number(a.total)!==Number(d.total)) cambios.push('total: '+fmt(a.total||0)+' → '+fmt(d.total||0));
      if(Number(a.abonado)!==Number(d.abonado)) cambios.push('abonado: '+fmt(a.abonado||0)+' → '+fmt(d.abonado||0));
      if(Number(a.n_items)!==Number(d.n_items)) cambios.push('productos: '+(a.n_items||0)+' → '+(d.n_items||0));
      h+='<div style="padding:8px 12px;border-top:0.5px solid #E9C08A;font-size:11.5px">'
        +'<div style="color:var(--text-muted);font-size:10.5px">'+_esc(e.fecha||'')+' &middot; '+_esc(e.por||'')+'</div>'
        +'<div style="margin-top:2px;font-weight:600">'+_esc(e.motivo||'')+'</div>'
        +(cambios.length?('<div style="margin-top:3px;color:var(--text-secondary);font-size:10.5px">'+cambios.join(' &middot; ')+'</div>'):'')
      +'</div>';
    });
    h+='</div>';
  }
  if(CU.verCostos){
    h+='<div style="display:flex;gap:14px;flex-wrap:wrap;margin-bottom:12px;font-size:12px">';
    h+='<span>Total: <strong style="color:var(--t-ambar)">'+fmt(p.total||0)+'</strong></span>';
    h+='<span>Abonado: <strong style="color:var(--text-success)">'+fmt(p.abonado||0)+'</strong></span>';
    h+='<span>Saldo: <strong style="color:var(--text-danger)">'+fmt((p.saldo!=null?p.saldo:(p.total||0)-(p.abonado||0)))+'</strong></span>';
    h+='</div>';
  }
  // ── Detalle de items (con fotos, cantidades y precios) ──
  var items=p.items; if(typeof items==='string'){ try{items=JSON.parse(items);}catch(e){items=[];} }
  items=items||[];
  if(items.length){
    h+='<div style="border:0.5px solid var(--border);border-radius:8px;overflow:hidden;margin-bottom:12px">';
    h+='<div style="background:var(--surface-2);padding:7px 12px;font-size:12px;font-weight:600;border-bottom:0.5px solid var(--border)"><i class="ti ti-list-details"></i> Productos ('+items.length+')</div>';
    h+='<div id="pendsap-items-'+p.dkc+'">';
    items.forEach(function(it){
      var cant=Number(it.cantidad)||0, pu=Number(it.precio_unit)||0;
      var tl=Number(it.total_linea)||(cant*pu);
      h+='<div class="pendsap-item-linea" data-ic="'+_esc(String(it.itemcode||''))+'" style="display:flex;align-items:center;gap:10px;padding:8px 12px;border-bottom:0.5px solid var(--border)">'
        +'<div class="pendsap-item-foto" style="width:44px;height:44px;flex-shrink:0;border:0.5px solid var(--border);border-radius:6px;overflow:hidden;background:var(--surface-2);display:flex;align-items:center;justify-content:center"><i class="ti ti-photo" style="color:var(--text-muted);font-size:14px"></i></div>'
        +'<div style="flex:1;min-width:0">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(it.itemcode||'-')+'</div>'
          +'<div style="font-size:11px;color:var(--text-secondary);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(it.itemname||'')+'</div>'
        +'</div>'
        +'<div style="text-align:right;flex-shrink:0">'
          +'<div style="font-size:13px;font-weight:700">'+cant+' <span style="font-size:10px;color:var(--text-muted);font-weight:400">und</span></div>'
          +(CU.verCostos&&pu?'<div style="font-size:10px;color:var(--text-muted)">@'+_fmtN2(pu)+' = '+_fmtN2(tl)+'</div>':'')
        +'</div>'
      +'</div>';
    });
    h+='</div></div>';
  } else {
    h+='<div style="font-size:11px;color:var(--text-muted);background:var(--surface-1);border:0.5px solid var(--border);border-radius:6px;padding:8px;margin-bottom:12px"><i class="ti ti-info-circle"></i> Esta orden no tiene detalle de productos guardado.</div>';
  }
  if(atts.length){
    h+='<div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:9px">';
    atts.forEach(function(a,ai){
      var ext=(String(a.name||'').split('.').pop()||'').toLowerCase();
      if(['jpg','jpeg','png','gif','webp'].indexOf(ext)>=0){
        // Los guardados en el almacenamiento traen url; los subidos a mano, data
        var _src=a.data||a.url||'';
        h+='<div style="position:relative;display:inline-block;margin:2px" title="'+_esc(a.name||'')+(a._de?(' \u00b7 '+a._de):'')+'"><img src="'+_src+'" data-src="'+_src+'" data-ai="'+ai+'" data-oid="'+p.dkc+'" data-sk="__pendsap" class="att-img" style="width:52px;height:52px;object-fit:cover;border-radius:5px;cursor:zoom-in;border:0.5px solid var(--border)">'
          +(a._de?'':'<button data-ai="'+ai+'" data-oid="'+p.dkc+'" data-sk="__pendsap" class="att-del" style="position:absolute;top:-5px;right:-5px;background:#e24b4a;color:white;border:none;border-radius:50%;width:17px;height:17px;font-size:10px;cursor:pointer;line-height:17px;padding:0;text-align:center">\u00d7</button>')
          +'</div>';
      } else {
        var ic=ext==='pdf'?'\ud83d\udcc4':ext==='xlsx'||ext==='xls'?'\ud83d\udcca':'\ud83d\udcce';
        var _u=a.data||a.url||'';
        var abrir=_u?(' onclick="verArchivo(\''+_u+'\',\''+(a.name||'').replace(/\'/g,"\\'")+'\')" '):'';
        h+='<div title="'+_esc(a.name||'')+'" style="display:inline-flex;align-items:center;gap:5px;padding:3px 8px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:var(--radius);font-size:11px;margin:2px;cursor:pointer"'+abrir+'>'+ic
          +' <span style="max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+a.name+'</span>'
          +(a._de?('<span style="font-size:9px;background:#EEF2FF;color:var(--t-indigo2);border-radius:6px;padding:0 5px;font-weight:700">'+_esc(a._de)+'</span>')
                 :('<button data-ai="'+ai+'" data-oid="'+p.dkc+'" data-sk="__pendsap" class="att-del" style="background:none;border:none;color:var(--text-danger);cursor:pointer;padding:0;font-size:13px;line-height:1">\u00d7</button>'))
          +'</div>';
      }
    });
    h+='</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:7px;padding:6px 10px;border:1.5px dashed var(--border);border-radius:var(--radius);cursor:pointer;font-size:11px;color:var(--text-secondary);background:var(--surface-1);margin-bottom:6px"><i class="ti ti-upload" style="font-size:12px;color:var(--t-ambar)"></i>Adjuntar documento<input type="file" multiple accept="image/*,.pdf,.xlsx,.xls,.doc,.docx" style="display:none" data-oid="'+p.dkc+'" data-sk="__pendsap" class="att-input"></label>';
  h+='<button onclick="event.stopPropagation();revisarPendSAPIA(\''+_k+'\')" style="background:var(--pastel-lila);color:var(--t-lila);border:none;border-radius:6px;padding:6px 11px;cursor:pointer;font-size:11px;font-weight:600;margin-bottom:10px"><i class="ti ti-sparkles"></i> AI revisar detalles y errores</button>';
  // Live chat
  var chatKey='pendsap_'+p.dkc;
  h+='<div style="margin-top:6px"><div style="font-size:10px;color:var(--text-muted);font-weight:500;margin-bottom:4px"><i class="ti ti-message"></i> Live chat de esta orden</div>';
  h+='<div id="pendsap-cms-'+p.dkc+'" style="margin-bottom:6px">'+renderSubComs(chatKey)+'</div>';
  h+='<div class="cir"><textarea class="cin" id="pendsap-cin-'+p.dkc+'" rows="1" placeholder="Escribe en el chat..." style="font-size:11px"></textarea>';
  h+='<button class="btn bp" onclick="addPendSAPCom(\''+_k+'\')" style="align-self:flex-end;padding:5px 8px"><i class="ti ti-send"></i></button></div></div>';
  h+='</div>';
  return h;
}

function agregarPendSAP(){ abrirNuevaOrdenSinSAP(); }  // compatibilidad
// Resumen GENERAL de órdenes sin SAP (todas) para la cabecera de la sección Departamentos.
// Muestra total, abonado, saldo de las sin SAP, y el GRAN TOTAL (SAP + sin SAP).

// Genera filas <tr> de No SAP para integrar en la tabla de departamentos
function _nsapDeptoRows(dept){
  var lista=pendSAPporDept(dept);
  if(!lista.length)return'';
  var rows='';
  lista.forEach(function(p){
    // Clave segura de la orden (sin dkc no debe reventar el render)
    var _k=String(p.dkc||p.num_orden||'').replace(/'/g,'');
    var ref=p.num_orden||p.dkc||'?';
    var tot=Number(p.total)||0,abn=Number(p.abonado)||0,sal=Number(p.saldo!=null?p.saldo:tot-abn);
    var _ak=p.dkc+'__pendsap';
    var _al=window._atts&&window._atts[_ak]?window._atts[_ak]:[];
    if(!_al.length&&p.adjunto_url)_al=[{name:p.adjunto_name||'adj',data:p.adjunto_url}];
    var adjCell='';
    if(_al.length){var a=_al[0];var url=a.data||a.url||'';var ext=(a.name||'').split('.').pop().toLowerCase();
      if(['jpg','jpeg','png','webp'].includes(ext))adjCell='<img src="'+url+'" data-src="'+url+'" class="att-img" style="height:24px;width:24px;object-fit:cover;border-radius:4px;cursor:zoom-in;border:0.5px solid var(--border);vertical-align:middle;margin-left:4px" title="'+a.name+'">';
      else adjCell='<a href="'+url+'" target="_blank" onclick="event.stopPropagation()" style="font-size:9px;margin-left:4px;color:var(--text-accent)"><i class="ti ti-paperclip" style="font-size:10px"></i>'+a.name+'</a>';}
    rows+='<tr style="border-bottom:0.5px solid var(--border);background:var(--pastel-aviso)">'
      +'<td style="padding:7px 12px;font-size:12px;font-weight:500;white-space:nowrap;vertical-align:middle">'
      +'<span style="font-size:9px;background:var(--pastel-naranja);color:var(--t-ambar);border-radius:4px;padding:1px 5px;margin-right:4px;font-weight:700">NO SAP</span>'
      +(p.proveedor||'?')+_pendSAPBadgeEditada(p)+adjCell+'</td>'
      +'<td style="padding:7px 12px;vertical-align:middle">'
      +'<span data-abrir="'+_k+'" class="nsap-abrir-btn" style="display:inline-flex;align-items:center;gap:3px;padding:2px 7px;border-radius:6px;background:var(--pastel-naranja);border:0.5px solid #f5c9a0;cursor:pointer;font-size:10px;color:var(--t-ambar)">'
      +'<i class="ti ti-file-invoice" style="font-size:10px"></i> '+ref+'</span>'
      +'<span data-ia="'+_k+'" class="nsap-ia-btn" style="display:inline-flex;align-items:center;gap:3px;padding:2px 6px;border-radius:6px;background:var(--pastel-lila);border:0.5px solid #c4b5fd;cursor:pointer;font-size:10px;margin-left:4px;color:var(--t-lila)">'
      +'<i class="ti ti-sparkles" style="font-size:9px"></i> IA</span>'
      +'</td>'
      +(CU.verCostos
        ?'<td style="padding:7px 12px;font-size:11px;text-align:right;white-space:nowrap;color:var(--t-ambar);font-weight:600">'+fmt(tot)+'</td>'
         +'<td style="padding:7px 12px;font-size:11px;text-align:right;white-space:nowrap;color:var(--text-success)">'+fmt(abn)+'</td>'
         +'<td style="padding:7px 12px;font-size:11px;text-align:right;white-space:nowrap;color:var(--text-danger)">'+fmt(sal)+'</td>'
        :'')
      +'</tr>';
  });
  return rows;
}
function _resumenGeneralSinSAP(gTotSap, gAbnSap){
  if(!CU.verCostos) return '';
  var lista=pendientesSAPVisibles();
  if(!lista.length && !(Number(gTotSap)>0)) return '';
  var nsapTot=totalPendSAP(), nsapAbn=totalAbonPendSAP(), nsapSaldo=nsapTot-nsapAbn;
  var granTot=(Number(gTotSap)||0)+nsapTot;
  var granAbn=(Number(gAbnSap)||0)+nsapAbn;
  var h='<div style="background:linear-gradient(135deg,#F5F3FF,#EDE9FE);border:0.5px solid #C4B5FD;border-radius:10px;padding:12px 14px;margin-bottom:14px">';
  h+='<div style="display:flex;align-items:center;gap:6px;margin-bottom:8px"><i class="ti ti-clock-pause" style="color:var(--t-lila2);font-size:16px"></i><span style="font-size:13px;font-weight:600;color:var(--t-lila2)">Órdenes sin SAP — resumen general</span><span style="font-size:11px;color:#7C3AED;margin-left:auto">'+lista.length+' orden'+(lista.length!==1?'es':'')+'</span></div>';
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(90px,1fr));gap:8px">';
  h+='<div style="background:var(--surface-2);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#7C3AED;text-transform:uppercase">Total sin SAP</div><div style="font-size:15px;font-weight:700;color:var(--t-lila2)">'+fmt(nsapTot)+'</div></div>';
  h+='<div style="background:var(--surface-2);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#639922;text-transform:uppercase">Abonado</div><div style="font-size:15px;font-weight:700;color:#639922">'+fmt(nsapAbn)+'</div></div>';
  h+='<div style="background:var(--surface-2);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#e24b4a;text-transform:uppercase">Saldo</div><div style="font-size:15px;font-weight:700;color:#e24b4a">'+fmt(nsapSaldo)+'</div></div>';
  h+='</div>';
  // Gran total
  h+='<div style="margin-top:10px;padding-top:10px;border-top:0.5px dashed #C4B5FD;display:grid;grid-template-columns:repeat(auto-fit,minmax(90px,1fr));gap:8px">';
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:var(--text-muted);text-transform:uppercase">Gran total</div><div style="font-size:16px;font-weight:800;color:var(--text-accent)">'+fmt(granTot)+'</div></div>';
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#639922;text-transform:uppercase">Abonado total</div><div style="font-size:15px;font-weight:700;color:#639922">'+fmt(granAbn)+'</div></div>';
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:7px;padding:8px 10px;text-align:center"><div style="font-size:9px;color:#e24b4a;text-transform:uppercase">Saldo total</div><div style="font-size:15px;font-weight:700;color:#e24b4a">'+fmt(granTot-granAbn)+'</div></div>';
  h+='</div>';
  h+='<div style="font-size:9px;color:var(--text-muted);margin-top:6px;text-align:center">Gran total = órdenes en SAP + órdenes sin SAP</div>';
  h+='</div>';
  return h;
}
// Casilla "Órdenes sin SAP" para la tarjeta de departamento en el dashboard.
// Muestra cantidad, total, abonado, saldo, promedio de días, y el gran total (SAP + sin SAP).
// Color elegante distinto (violeta suave).
function _dashDeptSinSAP(dept, totSap, abnSap){
  var lista=pendSAPporDept(dept);
  var nsapTot=lista.reduce(function(s,p){return s+(Number(p.total)||0);},0);
  var nsapAbn=lista.reduce(function(s,p){return s+(Number(p.abonado)||0);},0);
  var nsapSaldo=nsapTot-nsapAbn;
  var diasProm=lista.length?Math.round(lista.reduce(function(s,p){return s+_diasPendSAP(p);},0)/lista.length):0;
  var granTot=(Number(totSap)||0)+nsapTot;
  var granAbn=(Number(abnSap)||0)+nsapAbn;
  var h='<div style="margin-top:9px;padding:8px 10px;background:linear-gradient(135deg,#F5F3FF,#EDE9FE);border:0.5px solid #C4B5FD;border-radius:8px">';
  h+='<div style="display:flex;align-items:center;gap:5px;margin-bottom:5px"><i class="ti ti-clock-pause" style="font-size:12px;color:var(--t-lila2)"></i><span style="font-size:11px;font-weight:600;color:var(--t-lila2)">Órdenes sin SAP</span><span style="font-size:10px;color:#7C3AED;margin-left:auto">'+lista.length+' orden'+(lista.length!==1?'es':'')+'</span></div>';
  if(CU.verCostos){
    h+='<div class="sem-row"><span class="sem-label" style="color:var(--t-lila2)">Total</span><span class="sem-val" style="color:var(--t-lila2);font-weight:600">'+fmt(nsapTot)+'</span></div>';
    h+='<div class="sem-row"><span class="sem-label" style="color:#639922">Abonado</span><span class="sem-val" style="color:#639922">'+fmt(nsapAbn)+'</span></div>';
    h+='<div class="sem-row"><span class="sem-label" style="color:#e24b4a">Saldo</span><span class="sem-val" style="color:#e24b4a">'+fmt(nsapSaldo)+'</span></div>';
  }
  h+='<div style="font-size:10px;color:#7C3AED;margin-top:2px"><i class="ti ti-clock" style="font-size:9px"></i> Promedio: '+diasProm+' días sin SAP</div>';
  // Gran total (SAP + sin SAP)
  if(CU.verCostos){
    h+='<div style="margin-top:7px;padding-top:6px;border-top:0.5px dashed #C4B5FD">';
    h+='<div class="sem-row"><span class="sem-label" style="font-weight:700">GRAN TOTAL</span><span class="sem-val" style="font-weight:700;color:var(--text-accent)">'+fmt(granTot)+'</span></div>';
    h+='<div class="sem-row"><span class="sem-label" style="color:#639922;font-size:10px">Abonado total</span><span class="sem-val" style="color:#639922;font-size:11px">'+fmt(granAbn)+'</span></div>';
    h+='<div style="font-size:9px;color:var(--text-muted);margin-top:1px">SAP + sin SAP</div>';
    h+='</div>';
  }
  h+='</div>';
  return h;
}
// Abre el adjunto (PDF/imagen/Excel) de una orden sin SAP en vista previa.
function abrirAdjuntoPendSAP(ref){
  var atts=(window._atts&&window._atts[ref+'__pendsap'])?window._atts[ref+'__pendsap']:[];
  if(!atts.length){ showT('Esta orden no tiene adjunto. Abrí "Ver / adjuntos" para agregar uno.'); abrirPendSAP(ref); return; }
  var a=atts[0]; // el primero (el documento de la orden)
  if(typeof verArchivo==='function'){ verArchivo(a.data, a.name); }
  else { window.open(a.data, '_blank'); }
}
// Sync global: recarga todos los datos desde Supabase y redibuja la pantalla actual.
async function hacerSyncGlobal(){
  var icon=document.getElementById('syncIcon');
  var btn=document.getElementById('btnSync');
  if(icon) icon.style.animation='spin 1s linear infinite';
  if(btn){ btn.style.opacity='.7'; btn.disabled=true; }
  try{
    await cargarDatosReales();
    var ahora=new Date();
    var f=ahora.toLocaleDateString('es',{day:'2-digit',month:'2-digit',year:'numeric'});
    var h=ahora.toLocaleTimeString('es',{hour:'2-digit',minute:'2-digit'});
    window._ultimoSync=f+' '+h;
    try{ localStorage.setItem('kcc_ultimoSync', window._ultimoSync); }catch(e){}
    var st=document.getElementById('syncTime'); if(st) st.textContent=window._ultimoSync;
    // Redibujar la pantalla actual
    if(PG==='dashboard') rDash();
    else if(PG==='deptos') rDeptos();
    else if(PG==='ordenes') rOrdenes(dO);
    else if(PG==='completadas') rCompletadas(dComp);
    else if(PG==='pendientes') rPendientes(dP);
    else if(PG==='contab') rContab(dC);
    else if(PG==='mistarea') rMiTarea(dMT);
    else if(PG==='alertas') rAlertas();
    showT('✓ Actualizado');
  }catch(e){
    showT('Error al sincronizar');
    console.error('sync global:', e);
  }finally{
    if(icon) icon.style.animation='';
    if(btn){ btn.style.opacity='1'; btn.disabled=false; }
  }
}
// ═══════════════════════════════════════════════════════════════════════════
//  REFRESCO AUTOMÁTICO DE LA PANTALLA
//  Se llama después de crear, editar o borrar cualquier orden No SAP para que
//  el cambio se vea al instante, sin tener que pulsar Sync. Repinta la página
//  activa y, además, las secciones de No SAP que viven fuera de ella.
// ═══════════════════════════════════════════════════════════════════════════
function _refrescarPantalla(){
  try{
    if(PG==='ordenes' && typeof refreshSearchResults==='function') refreshSearchResults();
    else if(PG==='deptos' && typeof rDeptos==='function') rDeptos();
    else if(PG==='contab' && typeof rContab==='function') rContab();
    else if(PG==='completadas' && typeof rCompletadas==='function') rCompletadas();
    else if(PG==='pendientes' && typeof rPendientes==='function') rPendientes();
    else if(PG==='alertas' && typeof rAlertas==='function') rAlertas();
    else if(typeof rDash==='function') rDash();
  }catch(e){ console.warn('refrescar pagina:',e); }
  try{ if(typeof _renderNoSap==='function') _renderNoSap(); }catch(e){}
  try{ if(typeof renderNP==='function') renderNP(); }catch(e){}
  try{ if(typeof _firmaActualizarBadge==='function') _firmaActualizarBadge(); }catch(e){}
}

function eliminarPendSAP(ref){
  // Gerencia borra la orden con todo lo que cuelga de ella
  if(_esGerencia()) return _gerBorrarOrdenNoSap(ref);
  if(!confirm('¿Está seguro de que desea borrar esta orden NO SAP?\n\nEsta acción no se puede deshacer.')) return;
  window._pendSAP=(window._pendSAP||[]).filter(function(p){return String(p.dkc)!==String(ref)&&String(p.num_orden)!==String(ref);});
  borrarPendSAP(ref);
  _refrescarPantalla();
  showT('Orden eliminada');
}
async function marcarEnSAP(ref){
  if(!confirm('¿Confirmas que esta orden YA está registrada en SAP?\n\nSe eliminará de "Órdenes No SAP" y de "Compras para firmar". Quedará solo como una orden normal de SAP.')) return;
  var refN=String(ref||'').trim().toUpperCase();
  try{
    try{ await fetch(SB+'/rest/v1/compras_pend_sap?dkc=eq.'+encodeURIComponent(ref),{method:'DELETE',headers:SBH}); }catch(e){}
    try{ await fetch(SB+'/rest/v1/compras_pend_sap?num_orden=eq.'+encodeURIComponent(ref),{method:'DELETE',headers:SBH}); }catch(e){}
    try{ await fetch(SB+'/rest/v1/ordenes_firma?dkc=eq.'+encodeURIComponent(refN),{method:'DELETE',headers:SBH}); }catch(e){}
    window._pendSAP=(window._pendSAP||[]).filter(function(pp){return String(pp.dkc||'').trim().toUpperCase()!==refN && String(pp.num_orden||'').trim().toUpperCase()!==refN;});
    var mm=document.querySelector('div[style*=fixed]'); if(mm && mm.querySelector && mm.querySelector('.ti-database-import')) mm.remove();
    // El avance de las etapas se conserva bajo el número de orden de SAP
    try{ await _migrarEtapasNoSap(); }catch(e){ console.warn('migrar etapas:',e); }
    showT('✓ Orden marcada como registrada en SAP — se conservó el avance de las etapas');
    if(PG==='ordenes') rOrdenes(); else _refrescarPantalla();
    if(typeof _firmaCargarLista==='function'){ try{ _firmaCargarLista((CU&&CU.role==='gerencia')?'gerencia':'compras'); }catch(e){} }
  }catch(e){ showT('Error: '+(e.message||e)); }
}
// Live chat de una orden sin SAP
function addPendSAPCom(ref){
  var comKey='pendsap_'+ref;
  var inp=document.getElementById('pendsap-cin-'+ref);
  var txt=inp?inp.value.trim():'';
  if(!txt)return;
  if(!window._subComs) window._subComs={};
  if(!window._subComs[comKey])window._subComs[comKey]=[];
  window._subComs[comKey].push({autor:CU.name+' ('+CU.role+')',ini:CU.ini,texto:txt,time:now2(),role:CU.role,by:CU.name});
  guardarComentario(ref, comKey, txt);
  if(inp)inp.value='';
  var lista=document.getElementById('pendsap-cms-'+ref);
  if(lista) lista.innerHTML=renderSubComs(comKey);
  if(inp) inp.focus();
}
async function guardarPendSAP(ref){
  try{
    var p=(window._pendSAP||[]).find(function(x){return String(x.dkc)===String(ref)||String(x.num_orden)===String(ref);});
    if(!p)return;
    var base={ dkc:String(p.dkc), num_orden:p.num_orden||p.dkc, po:p.po||null, dept:p.dept||null, proveedor:p.proveedor||null, total:p.total||0, abonado:p.abonado||0, saldo:p.saldo||0, agregado_por:p.by||'', fecha:p.fecha||'', creado_en:p.creado_en||p.fecha||'', actualizado_en:new Date().toISOString(), items:p.items||[] };
    // Columnas del control de ediciones. Si la tabla todavía no las tiene, se
    // reintenta sin ellas para no perder el guardado.
    var full=Object.assign({}, base, {
      fecha_abono: p.fecha_abono||null,
      editada: !!p.editada,
      editado_en: p.editado_en||null,
      editado_por: p.editado_por||null,
      motivo_edicion: p.motivo_edicion||null,
      ediciones: p.ediciones||[]
    });
    async function _post(body){
      return fetch(SB+'/rest/v1/compras_pend_sap?on_conflict=dkc', {
        method:'POST',
        headers: Object.assign({}, SBH, {'Prefer':'resolution=merge-duplicates,return=minimal'}),
        body: JSON.stringify(body)
      });
    }
    // Se intenta guardar con todo. Si alguna columna nueva no existe todavía
    // en la tabla, se va soltando de a UNA para no perder las demás: antes un
    // solo campo que faltara tiraba abajo los otros dos sin decir nada, y el
    // registro de diferencias se perdía en silencio.
    window._pendSapDrop=[];
    window._pendSapError='';
    // El registro va como objeto, no como texto: la columna es jsonb.
    var _dif=p.dif_reposicion||null;
    if(typeof _dif==='string'){ try{ _dif=JSON.parse(_dif); }catch(e){} }

    // Se intenta guardar TODO. Si la tabla no tiene alguna columna, PostgREST
    // dice cuál: se quita ESA y se reintenta. Antes se iban soltando campos a
    // ciegas y una columna que faltaba (ediciones) hacía perder otras que sí
    // existían, como el registro de diferencias.
    var cuerpo=Object.assign({}, full, {
      pago_contra_bl: !!p.pago_contra_bl,
      num_reposicion: p.num_reposicion||null,
      dif_reposicion: _dif
    });
    var OBLIGATORIAS=['dkc','num_orden','items','total'];   // sin esto no hay orden
    var r=null;
    for(var intento=0; intento<8; intento++){
      r=await _post(cuerpo);
      if(r.ok) break;
      var txt='';
      try{ txt=await r.clone().text(); }catch(e){}
      window._pendSapError='HTTP '+r.status+' — '+String(txt).slice(0,400);
      // "Could not find the 'X' column of 'tabla' in the schema cache"
      var m=String(txt).match(/find the '([^']+)' column/i)
         || String(txt).match(/column "?([a-z0-9_]+)"? of relation/i);
      var col=m?m[1]:null;
      if(!col || OBLIGATORIAS.indexOf(col)>=0 || !(col in cuerpo)){
        console.warn('[orden NO SAP] no se pudo guardar y no puedo identificar la columna:',
                     window._pendSapError);
        break;
      }
      console.warn('[orden NO SAP] la tabla no tiene la columna "'+col+'": se guarda sin ella');
      window._pendSapDrop.push(col);
      delete cuerpo[col];
    }

    if(window._pendSapDrop.length){
      console.warn('[orden NO SAP] columnas que no existen en compras_pend_sap:',
                   window._pendSapDrop.join(', '));
      // Lo que no se pudo guardar tampoco se deja en memoria: si no,
      // "desaparece" en el siguiente Sync y nadie entiende por qué.
      window._pendSapDrop.forEach(function(c){ if(c in p) p[c]=null; });
    }
  }catch(e){ console.error('guardarPendSAP:', e); }
}
async function borrarPendSAP(ref){
  try{
    await fetch(SB+'/rest/v1/compras_pend_sap?dkc=eq.'+encodeURIComponent(ref), {method:'DELETE', headers:SBH});
  }catch(e){ console.error('borrarPendSAP:', e); }
}
// Todas las columnas MENOS "items". Esa lleva dentro todas las líneas de
// la orden y es la que pesa: con ella, 16 órdenes tardaban 17 segundos y la
// respuesta llegaba a 6 MB. Para LISTAR las órdenes no hace falta ninguna
// línea, así que se piden aparte y en segundo plano.
var _NSAP_COLS = ['dkc','num_orden','po','dept','proveedor','cardcode',
  'total','abonado','saldo','agregado_por','fecha','creado_en','fecha_abono',
  'editada','editado_en','editado_por','motivo_edicion','num_reposicion',
  'dif_reposicion','pago_contra_bl'].join(',');

// Las líneas de cada orden, después y sin bloquear. Se piden solo cuando
// hacen falta de verdad.
async function _nsapCargarItems(){
  var pend=(window._pendSAP||[]).filter(function(o){ return !o.__items; });
  if(!pend.length) return 0;
  var puestos=0;
  for(var i=0;i<pend.length;i+=10){
    var grupo=pend.slice(i,i+10);
    var lista=grupo.map(function(o){ return '"'+String(o.dkc).replace(/"/g,'')+'"'; }).join(',');
    try{
      var r=await fetch(SB+'/rest/v1/compras_pend_sap?select=dkc,items'
        +'&dkc=in.('+encodeURIComponent(lista)+')', {headers:SBH});
      if(!r.ok) continue;
      var filas=await r.json()||[];
      filas.forEach(function(f){
        var o=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(f.dkc); });
        if(o){ o.items=f.items||[]; o.__items=1; puestos++; }
      });
    }catch(e){ console.warn('[NO SAP] líneas:', e); }
  }
  if(puestos){
    console.log('[NO SAP] líneas de '+puestos+' orden(es) cargadas');
    try{ _refrescarPantalla(); }catch(e){}
  }
  return puestos;
}

async function cargarPendSAP(){
  try{
    // POR TANDAS. Pedirlo todo de un golpe daba una respuesta de casi 6 MB
    // —cada orden lleva dentro TODAS sus líneas en la columna items— que
    // llegaba cortada: "Unterminated string in JSON", 100 segundos, y la
    // lista vacía. En tandas de 25 cada respuesta es manejable.
    var rows=[], desde=0, tanda=25, vueltas=0;
    while(vueltas<200){
      vueltas++;
      // Sin la columna items. Es la que pesa: lleva TODAS las líneas de la
      // orden y hacía que 16 órdenes tardaran 17 segundos. Para listarlas no
      // hace falta ninguna, así que se piden aparte y en segundo plano.
      var r=await fetch(SB+'/rest/v1/compras_pend_sap?select='+_NSAP_COLS
        +'&order=creado_en.desc&limit='+tanda+'&offset='+desde, {headers:SBH});
      if(!r.ok){
        var _t=''; try{ _t=await r.text(); }catch(e){}
        console.error('[NO SAP] no se pudieron cargar: '+r.status+' · '+_t.slice(0,160));
        // Si ya se leyó algo, se usa lo que hay en vez de perderlo todo
        if(rows.length){ console.warn('[NO SAP] se usan las '+rows.length+' ya leídas'); break; }
        window._pendSAPError='No se pudo cargar la lista (error '+r.status+')';
        throw new Error('http '+r.status);
      }
      var lote;
      try{
        lote=await r.json();
      }catch(errJ){
        console.error('[NO SAP] respuesta cortada en la tanda '+vueltas+':', errJ.message);
        if(rows.length){ console.warn('[NO SAP] se usan las '+rows.length+' ya leídas'); break; }
        window._pendSAPError='La respuesta llegó cortada';
        throw errJ;
      }
      if(!Array.isArray(lote)) break;
      rows=rows.concat(lote);
      if(lote.length<tanda) break;      // última tanda
      desde+=lote.length;
    }
    console.log('[NO SAP] '+rows.length+' orden(es) en '+vueltas+' tanda(s)');
    window._pendSAPError=null;
    // La fila se rearma campo por campo. Todo lo que no se copie aquí SE PIERDE
    // en cada Sync, aunque esté guardado en la base: era lo que hacía
    // desaparecer la línea de diferencias al sincronizar.
    if(Array.isArray(rows)) window._pendSAP=rows.map(function(row){return {
      dkc:row.dkc, num_orden:row.num_orden||row.dkc, po:row.po||'',
      dept:row.dept||'', proveedor:row.proveedor||'', cardcode:row.cardcode||'',
      total:Number(row.total)||0, abonado:Number(row.abonado)||0, saldo:Number(row.saldo)||0,
      by:row.agregado_por||'', fecha:row.fecha||'', creado_en:row.creado_en||row.fecha||'',
      items:(row.items||[]), fecha_abono:row.fecha_abono||'',
      editada:!!row.editada, editado_en:row.editado_en||'', editado_por:row.editado_por||'',
      motivo_edicion:row.motivo_edicion||'', ediciones:(row.ediciones||[]),
      // De dónde viene la orden y en qué se apartó de la reposición
      num_reposicion:row.num_reposicion||'',
      dif_reposicion:(row.dif_reposicion!=null?row.dif_reposicion:null),
      pago_contra_bl:!!row.pago_contra_bl
    };});
    // La pantalla se repinta AQUÍ, en cuanto están las órdenes. Antes solo se
    // repintaba si la carga fallaba y entraba el reintento: en un equipo
    // lento (el iPad) la pantalla ya se había dibujado con la lista vacía y
    // se quedaba diciendo "Sin órdenes No SAP" hasta que se cambiaba de
    // pestaña. En el escritorio la carga terminaba antes de dibujar y por eso
    // ahí sí se veían.
    try{ _refrescarPantalla(); }catch(e){}
    try{ if(typeof rDash==='function' && PG==='dashboard') rDash(); }catch(e){}

    // Las líneas, por detrás. La pantalla ya está pintada.
    setTimeout(function(){ _nsapCargarItems().catch(function(){}); }, 400);

    // Los adjuntos van DESPUÉS y sin bloquear: son para cuando se abre una
    // orden, no para verlas listadas. Esperarlos uno a uno retrasaba todo.
    if(Array.isArray(window._pendSAP)){
      // Se copia la lista: si mientras tanto alguien recarga y la deja en
      // nulo, este bucle seguía apuntando a la de antes y reventaba.
      var _paraDocs=window._pendSAP.slice();
      (async function(){
        for(var i=0;i<_paraDocs.length;i++){
          try{ await cargarDocsOrden(_paraDocs[i].dkc); }catch(e){}
        }
      })();
    }
  }catch(e){
    console.error('cargarPendSAP:', e);
    // Un reintento a los cinco segundos. Casi todos estos fallos son de red
    // momentánea y con una segunda oportunidad se resuelven.
    if(!window._pendSAPReintento){
      window._pendSAPReintento=1;
      setTimeout(function(){
        console.log('[NO SAP] reintentando la carga…');
        cargarPendSAP().then(function(){
          try{ _refrescarPantalla(); }catch(e2){}
        });
      }, 5000);
    }
  }
}

async function cargarLlegadas(){
  try{
    var r=await fetch(SB+'/rest/v1/compras_llegada?select=*', {headers:SBH});
    var rows=await r.json();
    if(!window._llegada) window._llegada={};
    if(Array.isArray(rows)) rows.forEach(function(row){
      window._llegada[String(row.docnum)]={ confirmado:!!row.confirmado, por:row.confirmado_por||'', fechaReal:row.fecha_real||'', fechaConfirm:'' };
    });
  }catch(e){ console.error('cargarLlegadas:', e); }
}

function getBK(oid){
  if(!window._bookingData[oid]) window._bookingData[oid]={naviera:'',booking:'',containers:[]};
  return window._bookingData[oid];
}
function setBKField(oid,field,val){
  getBK(oid)[field]=val;
  // Al escribir el booking (texto) NO redibujamos nada: eso recreaba el input
  // y perdía el foco (solo dejaba 1 tecla). Solo guardamos.
  // Al cambiar la naviera (un select, no pierde foco) sí redibujamos para
  // actualizar los colores/íconos del barquito.
  if(field==='naviera'){
    var trackerEl=document.getElementById('log-tracker-'+oid);
    if(trackerEl) trackerEl.innerHTML=buildLogTracker(oid);
  }
  _guardarBookingDebounced(oid);
}
// Guarda tras 600ms sin cambios (evita guardar en cada tecla)
var _bkSaveTimers={};
function _guardarBookingDebounced(oid){
  if(_bkSaveTimers[oid]) clearTimeout(_bkSaveTimers[oid]);
  _bkSaveTimers[oid]=setTimeout(function(){ guardarBooking(oid); }, 600);
}
function addContainer(oid){
  _syncLogFromDOM(oid);
  getBK(oid).containers.push({id:'',etaSalida:'',etaLlegada:'',origen:'Shanghai, China',destino:'Colón, Panamá'});
  _redibujarTracker(oid);
  guardarBooking(oid);
}
function removeContainer(oid,i){
  _syncLogFromDOM(oid);
  getBK(oid).containers.splice(i,1);
  _redibujarTracker(oid);
  guardarBooking(oid);
}
function _syncLogFromDOM(oid){
  var trackerEl=document.getElementById('log-tracker-'+oid);
  if(!trackerEl)return;
  var bk=getBK(oid);
  var selNav=trackerEl.querySelector('.bk-sel');
  if(selNav&&selNav.value)bk.naviera=selNav.value;
  var inpBk=trackerEl.querySelector('.bk-inp');
  if(inpBk)bk.booking=inpBk.value;
  trackerEl.querySelectorAll('.ctn-inp').forEach(function(inp){
    var i=parseInt(inp.getAttribute('data-ctn-i'));
    var field=inp.getAttribute('data-ctn-field');
    if(!isNaN(i)&&field&&bk.containers[i])bk.containers[i][field]=inp.value;
  });
}
function _redibujarTracker(oid){
  var trackerEl=document.getElementById('log-tracker-'+oid);
  if(trackerEl){ trackerEl.innerHTML=buildLogTracker(oid); return; }
  _rebuildLogStep(oid);
}
function setContainerField(oid,i,field,val){
  var bk=getBK(oid);
  if(!bk.containers[i])return;
  bk.containers[i][field]=val;
  // NO rerenderizar — solo guardar el valor, el barquito se actualiza al abrir
  _guardarBookingDebounced(oid);
}
function _rebuildLogStep(oid){
  // Guardar valores actuales del DOM al tracker antes de reconstruir
  var trackerEl=document.getElementById('log-tracker-'+oid);
  if(trackerEl){
    var bk=getBK(oid);
    var selNav=trackerEl.querySelector('.bk-sel');
    if(selNav&&selNav.value)bk.naviera=selNav.value;
    var inpBk=trackerEl.querySelector('.bk-inp');
    if(inpBk)bk.booking=inpBk.value;
    trackerEl.querySelectorAll('.ctn-inp').forEach(function(inp){
      var i=parseInt(inp.getAttribute('data-ctn-i'));
      var field=inp.getAttribute('data-ctn-field');
      if(!isNaN(i)&&field&&bk.containers[i])bk.containers[i][field]=inp.value;
    });
  }
  var logIdx=STAGES.findIndex(function(s){return s.key==='logistica';});
  if(logIdx<0)return;
  var body=document.getElementById('egb-'+oid+'-'+logIdx);
  if(body&&body.classList.contains('open'))buildEGB(oid,logIdx,body);
}
function rerenderLogTracker(oid){
  _rebuildLogStep(oid);
}
function attachTrackerListeners(root,oid){
  // no-op: listeners manejados por event delegation
}

const TRACKING_URLS={
  'MAERSK':'https://www.maersk.com/tracking/',
  'CMA':'https://www.cma-cgm.com/ebusiness/tracing/search?SearchBy=Container&Reference=',
  'EVERGREEN':'https://www.shipmentlink.com/servlet/TDB1_CargoTracking.do?container_id=',
  'COSCO':'https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=CONTAINER&number=',
  'PANAMA CARRIER':'https://www.pancarrier.com/track/?ctn=',
  'MSC':'https://www.msc.com/en/track-a-shipment?agencyPath=msc&trackingNumber=',
  'AIR SEA WORLDWIDE':'',
  'CAPITAL PACIFICO':'',
  'ETERNITY':'',
};

// Tracking por tipo de referencia. Cada naviera usa una URL distinta segun
// se busque por contenedor, por B/L o por booking; algunas aceptan cualquiera
// en el mismo buscador.
const TRACKING_POR_TIPO={
  'MAERSK':{
    contenedor:'https://www.maersk.com/tracking/',
    bl:'https://www.maersk.com/tracking/',
    booking:'https://www.maersk.com/tracking/'
  },
  'CMA':{
    contenedor:'https://monitor.cma-cgm.com/ebusiness/tracking/search?SearchBy=Container&Reference=',
    bl:'https://monitor.cma-cgm.com/ebusiness/tracking/search?SearchBy=BL&Reference=',
    booking:'https://monitor.cma-cgm.com/ebusiness/tracking/search?SearchBy=Booking&Reference=',
    base:'https://monitor.cma-cgm.com/ebusiness/tracking'
  },
  'MSC':{
    contenedor:'https://www.msc.com/en/track-a-shipment?agencyPath=msc&trackingNumber=',
    bl:'https://www.msc.com/en/track-a-shipment?agencyPath=msc&trackingNumber=',
    booking:'https://www.msc.com/en/track-a-shipment?agencyPath=msc&trackingNumber='
  },
  'EVERGREEN':{
    contenedor:'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do?container_id=',
    bl:'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do?bl_no=',
    booking:'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do?bkg_no=',
    base:'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do'
  },
  'COSCO':{
    contenedor:'https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=CONTAINER&number=',
    bl:'https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=BILLOFLADING&number=',
    booking:'https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=BOOKING&number='
  },
  'PANAMA CARRIER':{
    contenedor:'https://www.pancarrier.com/track/?ctn=',
    bl:'https://www.pancarrier.com/track/?bl=',
    booking:'https://www.pancarrier.com/track/?bkg='
  }
};

// Devuelve la URL de tracking, o '' si esa naviera no tiene buscador propio
function _trackURL(naviera, tipo, valor){
  var nav=String(naviera||'').toUpperCase().trim();
  var v=String(valor||'').trim();
  if(!nav || !v) return '';
  var m=TRACKING_POR_TIPO[nav];
  if(m && m[tipo]) return m[tipo]+encodeURIComponent(v);
  // Sin buscador propio (Air Sea Worldwide, Capital Pacífico, Eternity):
  // se ofrece un rastreador general que cubre muchas navieras
  return 'https://www.trackingmore.com/es/container-tracking.html?number='+encodeURIComponent(v);
}

// Página de rastreo de la naviera, para abrirla y buscar a mano
function _trackBase(naviera){
  var nav=String(naviera||'').toUpperCase().trim();
  var m=TRACKING_POR_TIPO[nav];
  if(m && m.base) return m.base;
  if(m && m.contenedor) return String(m.contenedor).split('?')[0];
  return '';
}

// Chip clickeable con la referencia y su enlace de rastreo
function _trackChip(naviera, tipo, valor, etiqueta){
  var v=String(valor||'').trim();
  if(!v) return '';
  var url=_trackURL(naviera, tipo, v);
  var propio=!!(TRACKING_POR_TIPO[String(naviera||'').toUpperCase().trim()]||{})[tipo];
  if(!url) return '';
  return '<a href="'+_esc(url)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" '
    +'title="Rastrear '+_esc(etiqueta||tipo)+' '+_esc(v)+(propio?(' en '+_esc(naviera)):' (rastreador general)')+'" '
    +'style="display:inline-flex;align-items:center;gap:5px;background:var(--surface-1);border:0.5px solid var(--border);'
    +'border-radius:20px;padding:3px 11px;font-size:11px;text-decoration:none;color:var(--text-accent);font-weight:600">'
    +'<i class="ti ti-radar" style="font-size:12px"></i>'+_esc(etiqueta||tipo)
    +(propio?'':' <span style="font-size:9px;color:var(--text-muted)">general</span>')
    +'</a>';
}

// Barra de rastreo de una subetapa
function _trackBarra(oid, tipoPaso){
  var d=_logLeer(oid);
  var nav=(d.booking&&d.booking.naviera)||'';
  var chips=[];
  var bk=(d.booking&&d.booking.numero)||'';
  var bl=(d.bl&&d.bl.numero)||(d.arrival&&d.arrival.bl)||'';
  if(bk) chips.push(_trackChip(nav,'booking',bk,'Booking '+bk));
  if(bl) chips.push(_trackChip(nav,'bl',bl,'B/L '+bl));
  chips=chips.filter(Boolean);
  // El buscador de la naviera, para entrar aunque falte la referencia
  var base=_trackBase(nav);
  if(base){
    chips.push('<a href="'+_esc(base)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" '
      +'title="Abrir el rastreador de '+_esc(nav)+'" '
      +'style="display:inline-flex;align-items:center;gap:4px;font-size:10.5px;text-decoration:none;color:var(--text-muted)">'
      +'<i class="ti ti-external-link" style="font-size:11px"></i>abrir '+_esc(nav)+'</a>');
  }
  if(!chips.length) return '';
  return '<div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;background:var(--surface-0);'
    +'border:0.5px solid var(--border);border-radius:8px;padding:7px 10px;margin-bottom:8px">'
    +'<span style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase">Rastrear'
    +(nav?(' en '+_esc(nav)):'')+'</span>'
    +chips.join('')
    +'</div>';
}

// Emojis/logos por naviera (texto fallback)
const NAVIERA_EMOJI={'MAERSK':'🔷','CMA':'🔴','EVERGREEN':'🟢','COSCO':'⭐','PANAMA CARRIER':'🇵🇦','MSC':'🟡','AIR SEA WORLDWIDE':'✈️','CAPITAL PACIFICO':'🔵','ETERNITY':'⚫'};
const NAVIERA_COLOR={'MAERSK':'#42B0D5','CMA':'#E30613','EVERGREEN':'#009E60','COSCO':'#1C4FA0','PANAMA CARRIER':'#003580','MSC':'#0A2B6B','AIR SEA WORLDWIDE':'#0F766E','CAPITAL PACIFICO':'#1D4ED8','ETERNITY':'#374151'};
// Iniciales para el ícono de cada naviera
const NAVIERA_INI={'MAERSK':'MSK','CMA':'CMA','EVERGREEN':'EMC','COSCO':'COS','PANAMA CARRIER':'PCL','MSC':'MSC','AIR SEA WORLDWIDE':'ASW','CAPITAL PACIFICO':'CAP','ETERNITY':'ETN'};

// Ícono de naviera: cuadro con el color oficial y las iniciales (identifica la marca sin usar el logo con copyright)
function navieraIcono(nav, size){
  size=size||18;
  if(!nav) return '<span style="font-size:'+size+'px;line-height:1">🚢</span>';
  var color=NAVIERA_COLOR[nav]||'#185FA5';
  var ini=NAVIERA_INI[nav]||nav.slice(0,3).toUpperCase();
  var fs=Math.round(size*0.42);
  return '<span style="display:inline-flex;align-items:center;justify-content:center;width:'+size+'px;height:'+size+'px;background:'+color+';color:#fff;border-radius:4px;font-size:'+fs+'px;font-weight:800;letter-spacing:.3px;font-family:var(--font-sans);box-shadow:0 1px 2px rgba(0,0,0,.2);flex-shrink:0" title="'+nav+'">'+ini+'</span>';
}

function openTrackingCtn(oid, i){
  var bk=getBK(oid);
  var ctn=(bk.containers[i]||{}).id||'';
  var nav=bk.naviera;
  if(!ctn.trim()){showT('Ingresa el número de contenedor');return;}
  var url=TRACKING_URLS[nav];
  if(url) window.open(url+encodeURIComponent(ctn.trim()),'_blank');
  else window.open('https://www.google.com/search?q=track+container+'+encodeURIComponent(ctn.trim()),'_blank');
}

function buildLogTracker(oid){
  var bk=getBK(oid);
  var navieras=['MAERSK','CMA','MSC','EVERGREEN','COSCO','PANAMA CARRIER','AIR SEA WORLDWIDE','CAPITAL PACIFICO','ETERNITY'];
  var navColor=NAVIERA_COLOR[bk.naviera]||'#185FA5';
  var navEmoji=NAVIERA_EMOJI[bk.naviera]||'🚢';
  var html='';
  // Campos globales
  html+='<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:10px">'
    +'<div><label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px;text-transform:uppercase;letter-spacing:.4px">Naviera</label>'
    +'<select data-bk-oid="'+oid+'" data-bk-field="naviera" class="bk-sel" style="width:100%;padding:7px 8px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);font-size:12px;font-family:var(--font-sans)">'
    +'<option value="">-- Seleccionar --</option>'
    +navieras.map(function(n){return'<option value="'+n+'"'+(bk.naviera===n?' selected':'')+'>'+NAVIERA_EMOJI[n]+' '+n+'</option>';}).join('')
    +'</select></div>'
    +'<div><label style="font-size:10px;color:var(--text-muted);font-weight:600;display:block;margin-bottom:3px;text-transform:uppercase;letter-spacing:.4px">N° Booking / BL</label>'
    +'<input type="text" value="'+bk.booking+'" placeholder="Ej: MAEU12345678" data-bk-oid="'+oid+'" data-bk-field="booking" class="bk-inp" style="width:100%;padding:7px 8px;border:0.5px solid var(--border);border-radius:var(--radius);background:var(--surface-1);font-size:12px;font-family:var(--font-sans)"></div>'
    +'</div>';

  if(!bk.containers.length){
    html+='<div style="font-size:11px;color:var(--text-muted);padding:8px 0;margin-bottom:4px">Sin contenedores. Agrega uno abajo.</div>';
  } else {
    html+='<div style="font-size:10px;color:var(--text-muted);font-weight:600;text-transform:uppercase;letter-spacing:.4px;margin-bottom:6px">Contenedores ('+bk.containers.length+')</div>';
    bk.containers.forEach(function(ctn,i){
      var hoy=new Date();
      var sal=ctn.etaSalida?new Date(ctn.etaSalida):null;
      var lle=ctn.etaLlegada?new Date(ctn.etaLlegada):null;
      var pct=0,diasRuta=0,diasTrans=0,diasFalta=0,enRuta=false,llegado=false;
      if(sal&&lle){
        diasRuta=Math.max(1,Math.round((lle-sal)/(1000*60*60*24)));
        if(hoy<sal){pct=0;diasFalta=Math.round((lle-hoy)/(1000*60*60*24));}
        else if(hoy>=lle){pct=100;llegado=true;}
        else{diasTrans=Math.round((hoy-sal)/(1000*60*60*24));diasFalta=Math.round((lle-hoy)/(1000*60*60*24));pct=Math.min(95,Math.round((diasTrans/diasRuta)*100));enRuta=true;}
      }
      var leftPct=Math.max(2,Math.min(92,pct));
      var statusColor=llegado?'#27500A':enRuta?'#185FA5':'#888780';
      var statusLabel=llegado?'Llegó a Panamá':enRuta?'En tránsito':'Pendiente salida';

      html+='<div class="ctn-card">';
      html+='<div style="display:flex;align-items:flex-start;gap:8px;margin-bottom:8px">';
      html+='<div style="padding-top:2px">'+navieraIcono(bk.naviera,20)+'</div>';
      html+='<div style="flex:1;min-width:0">';
      html+='<input type="text" value="'+(ctn.id||'')+'" placeholder="N° Contenedor (Ej: MSCU1234567)" data-ctn-oid="'+oid+'" data-ctn-i="'+i+'" data-ctn-field="id" class="ctn-inp" style="width:100%;padding:5px 8px;border:0.5px solid var(--border);border-radius:6px;background:var(--surface-1);font-size:12px;font-weight:600;font-family:monospace;letter-spacing:.5px;margin-bottom:4px">';
      html+='<div style="display:flex;gap:6px;flex-wrap:wrap">';
      html+='<div style="flex:1;min-width:100px"><label style="font-size:9px;color:var(--text-muted);display:block">Salida estimada</label><input type="date" value="'+(ctn.etaSalida||'')+'" data-ctn-oid="'+oid+'" data-ctn-i="'+i+'" data-ctn-field="etaSalida" class="ctn-inp" style="width:100%;padding:4px 6px;border:0.5px solid var(--border);border-radius:5px;background:var(--surface-1);font-size:11px;font-family:var(--font-sans)"></div>';
      html+='<div style="flex:1;min-width:100px"><label style="font-size:9px;color:var(--text-muted);display:block">ETA llegada</label><input type="date" value="'+(ctn.etaLlegada||'')+'" data-ctn-oid="'+oid+'" data-ctn-i="'+i+'" data-ctn-field="etaLlegada" class="ctn-inp" style="width:100%;padding:4px 6px;border:0.5px solid var(--border);border-radius:5px;background:var(--surface-1);font-size:11px;font-family:var(--font-sans)"></div>';
      html+='<div style="flex:1;min-width:80px"><label style="font-size:9px;color:var(--text-muted);display:block">Origen</label><input type="text" value="'+(ctn.origen||'Shanghai, China')+'" data-ctn-oid="'+oid+'" data-ctn-i="'+i+'" data-ctn-field="origen" class="ctn-inp" style="width:100%;padding:4px 6px;border:0.5px solid var(--border);border-radius:5px;background:var(--surface-1);font-size:11px;font-family:var(--font-sans)"></div>';
      html+='</div></div>';
      html+='<div style="display:flex;flex-direction:column;gap:4px;flex-shrink:0">';
      html+='<button data-oid="'+oid+'" data-ci="'+i+'" class="ctn-track-btn" style="padding:5px 10px;background:'+(bk.naviera&&ctn.id?navColor:'#aaa')+';color:white;border:none;border-radius:6px;font-size:10px;cursor:pointer;display:flex;align-items:center;gap:4px;white-space:nowrap"><i class="ti ti-current-location" style="font-size:11px"></i>Live Track</button>';
      html+='<button data-oid="'+oid+'" data-ci="'+i+'" class="ctn-del-btn" style="padding:4px 8px;background:none;border:0.5px solid var(--border-danger);border-radius:6px;font-size:10px;cursor:pointer;color:var(--text-danger)"><i class="ti ti-trash" style="font-size:10px"></i></button>';
      html+='</div></div>';

      // Barquito animado
      html+='<div style="margin-top:6px;padding:8px 10px;background:linear-gradient(180deg,#E8F4FD 0%,#C8E6F8 60%,#A8D4F0 100%);border-radius:8px;position:relative;overflow:hidden">';
      html+='<div style="position:absolute;bottom:0;left:0;right:0;height:18px;opacity:.3"><svg viewBox="0 0 400 20" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="width:100%;height:100%"><path d="M0,10 C50,0 100,20 150,10 C200,0 250,20 300,10 C350,0 400,20 400,10 L400,20 L0,20 Z" fill="#185FA5" opacity="0.4"/><path d="M0,14 C60,6 120,18 180,12 C240,6 300,18 360,12 L400,14 L400,20 L0,20 Z" fill="#185FA5" opacity="0.3"/></svg></div>';
      html+='<div style="position:relative;height:44px">';
      html+='<div style="position:absolute;top:50%;left:14px;right:14px;height:2px;background:rgba(255,255,255,.5);border-radius:1px;transform:translateY(-50%)"></div>';
      if(pct>0)html+='<div style="position:absolute;top:50%;left:14px;width:calc('+leftPct+'% - 14px);height:2px;background:'+statusColor+';border-radius:1px;transform:translateY(-50%)"></div>';
      html+='<div style="position:absolute;left:4px;top:50%;transform:translateY(-50%)"><div style="width:10px;height:16px;background:#185FA5;border-radius:2px 2px 0 0"></div><div style="font-size:8px;color:#185FA5;white-space:nowrap;margin-top:2px;max-width:60px;overflow:hidden;text-overflow:ellipsis">'+(ctn.origen||'Origen')+'</div></div>';
      html+='<div style="position:absolute;right:4px;top:50%;transform:translateY(-50%);text-align:right"><div style="width:10px;height:16px;background:#27500A;border-radius:2px 2px 0 0;margin-left:auto"></div><div style="font-size:8px;color:var(--t-oliva);white-space:nowrap;margin-top:2px">'+(ctn.destino||'Colón, Panamá')+'</div></div>';
      html+='<div style="position:absolute;left:calc('+leftPct+'% - 12px);top:4px;font-size:20px;line-height:1;filter:drop-shadow(0 2px 4px rgba(0,0,0,.25));transition:left .8s ease">'+navEmoji+'</div>';
      if(bk.naviera)html+='<div style="position:absolute;left:calc('+leftPct+'% - 10px);top:-6px;font-size:8px;font-weight:700;color:'+navColor+';white-space:nowrap;background:var(--surface-2);border-radius:3px;padding:0 3px;line-height:14px">'+bk.naviera+'</div>';
      html+='</div>';
      html+='<div style="display:flex;justify-content:space-between;align-items:center;margin-top:6px">';
      html+='<div style="font-size:10px;font-weight:600;color:'+statusColor+';display:flex;align-items:center;gap:4px"><span style="display:inline-block;width:6px;height:6px;border-radius:50%;background:'+statusColor+'"></span>'+statusLabel+'</div>';
      if(enRuta)html+='<div style="font-size:10px;color:var(--text-muted)"><span style="color:#185FA5;font-weight:600">'+diasTrans+'d</span> en ruta · <span style="color:var(--t-oliva);font-weight:600">'+diasFalta+'d</span> para llegar</div>';
      else if(!llegado&&sal)html+='<div style="font-size:10px;color:var(--text-muted)">Sale '+formatDateDisplay(ctn.etaSalida)+' · Llega '+formatDateDisplay(ctn.etaLlegada)+'</div>';
      else if(llegado)html+='<div style="font-size:10px;color:var(--t-oliva);font-weight:600">\u2713 '+diasRuta+'d de tr\u00e1nsito total</div>';
      html+='</div>';
      html+='<div style="height:4px;background:rgba(0,0,0,.1);border-radius:2px;margin-top:5px;overflow:hidden"><div style="height:100%;background:'+statusColor+';border-radius:2px;width:'+pct+'%;transition:width .8s ease"></div></div>';
      html+='</div>'; // cierra ocean box
      html+='</div>'; // cierra ctn-card
    });
  }
  html+='<button data-oid="'+oid+'" class="ctn-add-btn"><i class="ti ti-plus" style="font-size:12px"></i> Agregar contenedor</button>';
  return html;
}

function formatDateDisplay(iso){
  if(!iso)return'—';
  var d=new Date(iso+'T00:00:00');
  return d.toLocaleDateString('es-PA',{day:'2-digit',month:'short'});
}

let DRW=false,CTX=null;
var _recentActivity=[]; // {docnum, etapa, autor, ts} ordenado desc
function initC(){const c=document.getElementById('fc');if(!c)return;CTX=c.getContext('2d');CTX.strokeStyle='#185FA5';CTX.lineWidth=2.5;CTX.lineCap='round';CTX.lineJoin='round';function gxy(e){const r=c.getBoundingClientRect();return{x:(e.clientX-r.left)*(c.width/r.width),y:(e.clientY-r.top)*(c.height/r.height)};}function gxyt(e){const r=c.getBoundingClientRect(),t=e.touches[0];return{x:(t.clientX-r.left)*(c.width/r.width),y:(t.clientY-r.top)*(c.height/r.height)};}c.addEventListener('mousedown',e=>{DRW=true;CTX.beginPath();const p=gxy(e);CTX.moveTo(p.x,p.y);});c.addEventListener('mousemove',e=>{if(!DRW)return;const p=gxy(e);CTX.lineTo(p.x,p.y);CTX.stroke();});c.addEventListener('mouseup',()=>DRW=false);c.addEventListener('mouseleave',()=>DRW=false);c.addEventListener('touchstart',e=>{e.preventDefault();DRW=true;CTX.beginPath();const p=gxyt(e);CTX.moveTo(p.x,p.y);},{passive:false});c.addEventListener('touchmove',e=>{e.preventDefault();if(!DRW)return;const p=gxyt(e);CTX.lineTo(p.x,p.y);CTX.stroke();},{passive:false});c.addEventListener('touchend',()=>DRW=false);}
function CC(){const c=document.getElementById('fc');if(c&&CTX)CTX.clearRect(0,0,c.width,c.height);}
function isBlank2(c){const d=c.getContext('2d').getImageData(0,0,c.width,c.height).data;for(let i=3;i<d.length;i+=4)if(d[i]>0)return false;return true;}
function signOrden(id){const c=document.getElementById('fc');if(!c||isBlank2(c)){showT('Dibuja tu firma primero');return;}if(!firmas[id])firmas[id]={};firmas[id]['gerencia']={signed:true,by:CU.name,date:now2()};const o=orders.find(x=>x.id===id);if(o){o.pend=false;initP(id);stageProgress[id].pedido.stepIdx=2;stageProgress[id].pedido.stepDates=[o.fechaCreacion,dateOnly()];stageProgress[id].deposito.startDate=dateOnly();}showT('✓ Orden firmada');CM();setTimeout(()=>{go(PG,null,true);openDetail(id);},80);}
function rejOrden(id){showT('Orden rechazada.');CM();setTimeout(()=>go(PG,null,true),80);}
function markComplete(id){const o=orders.find(x=>x.id===id);if(o){o.completada=true;STAGES.forEach(s=>{if(stageProgress[id])stageProgress[id][s.key].stepIdx=s.steps.length;});}showT('✓ Proceso completo');CM();setTimeout(()=>go(PG,null,true),80);}
function CM(){document.getElementById('modal').style.display='none';try{document.getElementById('mc').classList.remove('md-ancho');}catch(e){}try{_comDetenerPoll();}catch(e){}}

// ── El comprobante detrás de "Abonado" y "Saldo" ──────────────────────
// El del abono está en los pasos del depósito (el que dejó contabilidad o el
// que compras reenvió al proveedor); el del pago final, en los dos últimos.
function _compsPago(oid, tipo){
  var pasos=(tipo==='cancelacion') ? [4,3] : [2,1];
  var out=[];
  pasos.forEach(function(i){
    ((window._atts&&window._atts[String(oid)+'deposito_step'+i])||[]).forEach(function(a){
      if(a && _docHref(a)) out.push(a);
    });
  });
  return _dedupDocs(out);
}
function _hayCompPago(oid, tipo){ return _compsPago(oid, tipo).length>0; }

function _verCompPago(oid, tipo){
  var lista=_compsPago(oid, tipo);
  var qué=(tipo==='cancelacion')?'del pago final':'del abono';
  if(!lista.length){ showT('Todavía no hay comprobante '+qué+' adjunto'); return; }
  // Uno solo: se abre directo, que es lo que se espera al hacer clic
  if(lista.length===1){ window.open(lista[0].url||lista[0].data, '_blank', 'noopener'); return; }

  var prev=document.getElementById('modalCompPago'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCompPago';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13600;'
    +'display:flex;align-items:center;justify-content:center;padding:22px';
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:14px;padding:18px;'
      +'max-width:520px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">'
      +'<div style="font-size:13.5px;font-weight:700">Comprobantes '+qué+' &middot; orden '+_esc(String(oid))+'</div>'
      +'<button onclick="document.getElementById(\'modalCompPago\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'
    +_nsapDocsHTML('', lista, 'var(--text-muted)')
    +'</div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}
}
// ═══════════════════════════════════════════════════════════════════════════
//  SEGUIMIENTO DE REPOSICIONES ENVIADAS (gerencia -> compras -> proveedor)
//  Requiere la tabla Supabase: reposiciones_envios (ver SQL entregado).
// ═══════════════════════════════════════════════════════════════════════════
function _repDeptDeData(){ try{ if(!_repData||!_repData.length) return null; var c={}; _repData.forEach(function(x){ var dd=normDept(x.grupo_nom||''); c[dd]=(c[dd]||0)+1; }); var b='',n=-1; Object.keys(c).forEach(function(k){ if(c[k]>n){n=c[k];b=k;} }); return b; }catch(e){ return null; } }
async function _repRegistrarEnvio(code, adjPath, adjNombre, d, destinatarios, adjTodos){
  var dept=(CU&& _deptAcotado())||_repDeptDeData()||null;
  var pedidoId=_repPedidoId||null;
  var payload={ cardcode:code, cardname:(_repData&&_repData[0]&&_repData[0].cardname)||'', dept:dept, resumen:(d&&d.asunto)||('Reposicion '+code),
    // El asunto y el cuerpo completos, para que compras pueda reenviarlos
    // al proveedor tal cual los escribió gerencia.
    mail_asunto:(d&&d.asunto)||'', mail_cuerpo:(d&&d.cuerpo)||'',
    para_email:destinatarios||'', enviado_por:(CU&&CU.name)||'', enviado_por_email:(CU&&CU.email)||'', enviado_en:new Date().toISOString(), estado:'enviada', archivo_path:adjPath||null, archivo_nombre:adjNombre||null,
    archivos:(adjTodos&&adjTodos.length)?JSON.stringify(adjTodos):null, pedido_id:pedidoId,
    num_reposicion:_repNumRepo||null, creado_en:new Date().toISOString() };
  await _firmaWrite(SB+'/rest/v1/reposiciones_envios','POST',payload,['pedido_id','num_reposicion']);
  // El número tiene que quedar TAMBIÉN en el pedido: es donde lo busca la
  // orden NO SAP para comparar. Si solo queda en el envío, la comparación
  // dice que la reposición no existe.
  if(_repNumRepo && pedidoId){
    try{
      await fetch(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+encodeURIComponent(pedidoId)
        +'&num_reposicion=is.null',{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({num_reposicion:_repNumRepo})});
    }catch(e){ console.warn('[reposición] número en el pedido:', e); }
  }
  if(pedidoId){ try{ await _firmaWrite(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+pedidoId,'PATCH',{estado:'enviado_compras', enviado_compras_en:new Date().toISOString(), actualizado_en:new Date().toISOString()},['enviado_compras_en']); }catch(e){} }
}
// ═══════════════════════════════════════════════════════════════════════════
//  CONTADOR DE REPOSICIONES NUEVAS
//  Muestra un número rojo sobre el botón "Reposiciones" del inicio con las
//  reposiciones que le llegaron a esta persona y todavía no ha abierto.
//  El número baja solo cuando la abre (ahí se marca como recibida).
// ═══════════════════════════════════════════════════════════════════════════
var _repBadgeTimer=null;
window._repNuevas=0;

function _repBadgePintar(n){
  var el=document.getElementById('nbNumRep');
  if(!el) return;
  if(n>0){ el.textContent=(n>99?'99+':String(n)); el.style.display='block'; el.title=n+' reposición(es) sin abrir'; }
  else { el.textContent=''; el.style.display='none'; el.title=''; }
}

async function _repBadgeActualizar(){
  try{
    var email=(CU&&CU.email)||'';
    if(!email){ _repBadgePintar(0); return; }
    // Cuenta las que le llegaron a cualquiera del equipo del departamento
    var correos=_equipoEmails(); if(!correos.length) correos=[email];
    var orRep=correos.map(function(e){ return 'para_email.ilike.*'+e+'*'; }).join(',');
    var url=SB+'/rest/v1/reposiciones_envios?select=id&recibido_en=is.null'
      +'&or=('+orRep+')&limit=200';
    var r=await fetch(url,{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    window._repNuevas=Array.isArray(rows)?rows.length:0;
    _repBadgePintar(window._repNuevas);
  }catch(e){ /* sin conexión: se deja el número anterior */ }
}

function _repBadgeIniciar(){
  _repBadgeActualizar();
  if(_repBadgeTimer) clearInterval(_repBadgeTimer);
  _repBadgeTimer=setInterval(_repBadgeActualizar, 60000);
}

async function _repEnviosCargar(){
  var box=document.getElementById('rep-envios'); if(!box) return;
  try{
    var esGer=(CU&&CU.role==='gerencia');
    var email=(CU&&CU.email)||'';
    // El equipo del departamento ve los mismos envíos
    var _cs=_equipoEmails(); if(!_cs.length) _cs=[email];
    var _or=_cs.map(function(e){ return 'enviado_por_email.eq.'+e+',para_email.ilike.*'+e+'*'; }).join(',');
    var filtro='&or=('+_or+')';
    var r=await fetch(SB+'/rest/v1/reposiciones_envios?select=*'+filtro+'&order=enviado_en.desc&limit=100',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)||!rows.length){ window._repEnvios=[]; box.innerHTML=''; return; }
    window._repEnvios=rows;
    _repEnviosRender(box, rows, esGer);
  }catch(e){ box.innerHTML=''; }
}
// La comparación contra la orden NO SAP que salió de esta reposición. Se ve
// aquí también, para no tener que ir a buscarla al listado de órdenes.
function _repDifLinea(o){
  var dkc=String(o.orden_dkc||'').trim();
  if(!dkc) return '';
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===dkc || String(x.num_orden)===dkc; });
  var d=p?_nsapDifDe(p):null;
  if(!d){
    return '<div style="margin-top:4px;font-size:11px;color:var(--text-muted)">'
      +'<i class="ti ti-git-compare"></i> Sin registro de diferencias con esta reposición.</div>';
  }
  var n=(d.faltan||[]).length+(d.agregados||[]).length+(d.distintos||[]).length;
  return '<div onclick="event.stopPropagation();_nsapVerDif(\''+_esc(dkc.replace(/\\/g,''))+'\')" '
    +'title="Ver el detalle de las diferencias" '
    +'style="margin-top:4px;display:inline-flex;align-items:center;gap:6px;cursor:pointer;'
    +'background:'+(d.cuadra?'#dcfce7':'#FEF9F3')+';border:1px solid '+(d.cuadra?'#16a34a':'#E9C08A')+';'
    +'border-radius:8px;padding:5px 10px;font-size:11.5px;font-weight:600;'
    +'color:'+(d.cuadra?'#166534':'#7C3D12')+'">'
    +'<i class="ti '+(d.cuadra?'ti-circle-check':'ti-git-compare')+'"></i> '
    +(d.cuadra?'La orden respetó la reposición':(n+' diferencia(s) con la reposición'))
    +'<span style="text-decoration:underline;text-underline-offset:2px;font-weight:500">ver</span></div>';
}

// ¿Ya salió al proveedor? Comparar solo contra 'enviada_proveedor' dejaba
// fuera el estado siguiente ('orden_creada'), y al crearse la orden volvían a
// aparecer los botones de modificar y enviar sobre algo ya cerrado.
function _repYaEnviada(o){
  if(!o) return false;
  if(o.enviado_proveedor_en) return true;
  return o.estado==='enviada_proveedor' || o.estado==='orden_creada';
}

function _repEnvioColor(e){
  return (e==='orden_creada')?'#15803d'
       : (e==='enviada_proveedor')?'#16a34a'
       : (e==='recibida')?'#2563eb':'#dc2626';
}
function _repEnvioBadge(e){
  var map={enviada:['Enviada por gerencia','#fee2e2','#b91c1c'],
           recibida:['Recibida por compras','#dbeafe','#1e40af'],
           enviada_proveedor:['Enviada a proveedor','#dcfce7','#166534'],
           orden_creada:['Orden aprobada y firmada','#bbf7d0','#14532d']};
  var m=map[e]||map.enviada; return '<span style="font-size:9px;background:'+m[1]+';color:'+m[2]+';padding:1px 7px;border-radius:7px;font-weight:600">'+m[0]+'</span>';
}

// La reposición se convirtió en orden NO SAP: queda cerrada y en verde
async function _repMarcarOrdenCreada(numRepo, dkc){
  numRepo=String(numRepo||'').trim();
  if(!numRepo) return false;
  try{
    // Se busca con la misma tolerancia que el resto: por número, no por texto
    var ped=await _repBuscarPedidoPorNum(numRepo);
    if(!ped) return false;
    var peds=[ped];
    var cambios={ estado:'orden_creada', orden_dkc:String(dkc||''),
                  orden_creada_en:new Date().toISOString() };
    for(var i=0;i<peds.length;i++){
      try{
        await _firmaWrite(SB+'/rest/v1/reposiciones_envios?pedido_id=eq.'+peds[i].id,
          'PATCH', cambios, ['orden_dkc','orden_creada_en']);
      }catch(e){ console.warn('[reposición] marcar envío:', e); }
      try{
        await _firmaWrite(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+peds[i].id,
          'PATCH', {estado:'orden_creada', actualizado_en:new Date().toISOString()}, []);
      }catch(e){}
    }
    return true;
  }catch(e){ console.warn('[reposición] orden creada:', e); return false; }
}
function _repEnviosRender(box, rows, esGer){
  var email=((CU&&CU.email)||'').toLowerCase();
  var h='<div style="border:0.5px solid #C4B5FD;border-radius:10px;overflow:hidden">'
    +'<div style="background:var(--pastel-lila);padding:9px 12px;font-size:12px;font-weight:700;color:var(--t-lila2);display:flex;align-items:center;gap:8px"><i class="ti ti-send"></i> Seguimiento de reposiciones <span style="font-size:10px;font-weight:400;background:#6D28D9;color:#fff;padding:1px 7px;border-radius:8px">'+rows.length+'</span></div>'
    +'<div style="max-height:360px;overflow-y:auto">';
  rows.forEach(function(o){
    // Destinatario = cualquiera del equipo del departamento
    var _pe=(o.para_email||'').toLowerCase();
    var _mios=_equipoEmails(); if(!_mios.length) _mios=[email];
    var soyDestino=_mios.some(function(e){ return e && _pe.indexOf(e)>=0; });
    var col=_repEnvioColor(o.estado);
    var fEnv=o.enviado_en?new Date(o.enviado_en).toLocaleString('es'):'';
    var fRec=o.recibido_en?new Date(o.recibido_en).toLocaleString('es'):'';
    var fProv=o.enviado_proveedor_en?new Date(o.enviado_proveedor_en).toLocaleString('es'):'';
    h+='<div style="border-top:0.5px solid var(--border);border-left:4px solid '+col+';padding:10px 12px;display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:180px">'
        +'<div style="font-size:12.5px;font-weight:600">'
          +(o.num_reposicion?('<span style="background:var(--pastel-lila);border:1px solid #C4B5FD;color:var(--t-lila);'
            +'border-radius:10px;padding:1px 8px;font-size:11px;margin-right:6px">'+_esc(o.num_reposicion)+'</span>'):'')
          +_esc(o.cardcode||'')+(o.cardname?(' — '+_esc(o.cardname)):'')+' '+_repEnvioBadge(o.estado)
          // Para el destinatario: aviso rojo mientras no la abra
          +((soyDestino && !o.recibido_en)?'<span class="rep-nuevo"><i class="ti ti-mail"></i> sin abrir</span>':'')
          // Para quien la envió: palomitas de entregado / leído
          +((!soyDestino)?('<span class="com-chk'+(o.recibido_en?' leido':'')+'" title="'+(o.recibido_en?'Abierta por compras':'Enviada, sin abrir')+'"><i class="ti '+(o.recibido_en?'ti-checks':'ti-check')+'"></i></span>'):'')
        +'</div>'
        +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'+(o.dept?((EMOJIS2[o.dept]||'')+' '+_esc(dL(o.dept))+' &middot; '):'')+'Enviada por '+_esc(o.enviado_por||'')+(o.para_email?(' &middot; para '+_esc(o.para_email)):'')+'</div>'
        +(fEnv?('<div style="font-size:11px;color:var(--text-muted);margin-top:2px"><i class="ti ti-send"></i> Reposición enviada a compras: <b>'+fEnv+'</b></div>'):'')
        +(fRec?('<div style="font-size:11px;color:#2563eb;margin-top:1px"><i class="ti ti-inbox"></i> Recibida por compras: <b>'+fRec+'</b>'+(o.recibido_por?(' ('+_esc(o.recibido_por)+')'):'')+'</div>'):'')
        +(fProv?('<div style="margin-top:5px;background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px;font-size:13px;font-weight:700;color:var(--t-verde)"><i class="ti ti-send"></i> Enviada a proveedor &middot; '+fProv+(o.enviado_proveedor_por?(' ('+_esc(o.enviado_proveedor_por)+')'):'')+'</div>'):'')
        +(o.estado==='orden_creada'?('<div style="margin-top:5px;background:#bbf7d0;border:1px solid #15803d;border-radius:8px;padding:7px 10px;font-size:13px;font-weight:700;color:#14532d"><i class="ti ti-circle-check"></i> Orden aprobada y firmada'+(o.orden_dkc?(' &middot; '+_esc(o.orden_dkc)):'')+'</div>'
            +_repDifLinea(o)):'')
      +'</div>';
    if(o.archivo_path){
      if(soyDestino) h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px" onclick="_repEnvioVer('+o.id+',\''+_esc(o.archivo_path)+'\',\''+_esc(o.archivo_nombre||'reposicion')+'\','+(o.recibido_en?'true':'false')+')"><i class="ti ti-file"></i> Ver</button>';
      else h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px" onclick="_repEnvioVerGer(\''+_esc(o.archivo_path)+'\',\''+_esc(o.archivo_nombre||'reposicion')+'\')"><i class="ti ti-file"></i> Ver</button>';
    }
    // La compradora puede corregir la reposición antes de mandarla: a veces
    // gerencia se equivoca en una cantidad y no hay que rehacer todo.
    if(soyDestino && !_repYaEnviada(o) && o.cardcode)
      h+='<button class="btn bg2" style="padding:5px 9px;font-size:11px" title="Abrir la reposición para corregir cantidades" onclick="_repEnvioModificar('+o.id+',\''+_esc(o.cardcode)+'\','+(o.pedido_id||'null')+')"><i class="ti ti-edit"></i> Modificar</button>';
    if(soyDestino && !_repYaEnviada(o)) h+='<button class="btn bp" style="padding:5px 9px;font-size:11px" onclick="_repEnvioProveedor('+o.id+','+(o.pedido_id||'null')+')"><i class="ti ti-send"></i> Enviar a proveedor</button>';
    // Gerencia puede borrar cualquier reposición, con su archivo
    if(_esGerencia()) h+='<button class="btn bg2" title="Borrar esta reposición y su archivo" style="padding:5px 9px;font-size:11px;color:var(--text-danger);font-weight:600" onclick="_gerBorrarReposicion('+o.id+',\''+_esc(o.archivo_path||'')+'\')"><i class="ti ti-trash"></i></button>';
    else if(email && (o.enviado_por_email||'').toLowerCase()===email) h+='<button class="btn bg2" title="Eliminar esta reposición" style="padding:5px 9px;font-size:11px;color:var(--text-danger)" onclick="_repEnvioBorrar('+o.id+')"><i class="ti ti-trash"></i></button>';
    h+=_chatBtn('reposicion', o.id, (o.cardcode||'')+' '+(o.cardname||''));
    h+='</div>';
  });
  h+='</div></div>';
  box.innerHTML=h;
  try{ _chatBadges('reposicion', rows.map(function(o){return o.id;})); }catch(e){}
}
function _repEnvioVerGer(path,nombre){ if(!path)return; verArchivo(DOCS_BASE+path.split('/').map(encodeURIComponent).join('/'),nombre); }
function _repEnvioVer(id,path,nombre,yaRec){ _repEnvioVerGer(path,nombre); if(!yaRec) _repEnvioRecibir(id); }
async function _repEnvioRecibir(id){
  try{
    await _firmaWrite(SB+'/rest/v1/reposiciones_envios?id=eq.'+id,'PATCH',{estado:'recibida',recibido_en:new Date().toISOString(),recibido_por:(CU&&CU.name)||''},['recibido_por']);
    try{ addNotif('gerencia','Reposición recibida por compras ('+((CU&&CU.name)||'')+')','','ti-inbox'); }catch(e){}
    _repEnviosCargar();
    try{ _repBadgeActualizar(); }catch(e){}
  }catch(e){ console.warn('rep recibir:',e); }
}
// La compradora reenvía la reposición al proveedor con el mismo correo que
// le mandó gerencia. Antes solo se marcaba el estado, sin enviar nada.
// Abre la reposición del proveedor para corregirla. Lo que se guarde
// reemplaza al archivo original cuando se mande al proveedor.
async function _repEnvioModificar(id, cardcode, pedidoId){
  var o=(window._repEnvios||[]).find(function(x){ return String(x.id)===String(id); });
  if(!o){ showT('No se encontró la reposición'); return; }
  if(!confirm('¿Abrir la reposición de '+(o.cardname||cardcode)+' para modificarla?\n\n'
    +'Vas a poder cambiar las cantidades. Cuando termines, generá el archivo de nuevo '
    +'y usá "Enviar a proveedor" desde aquí.')) return;

  // Queda anotado para poder volver y saber qué se está corrigiendo
  window._repModificando={id:id, cardcode:cardcode, pedidoId:pedidoId,
                          cardname:o.cardname||'', desde:Date.now()};
  // Quién la mandó desde gerencia: va en el "On behalf of" del correo
  window._repOrigenNombre=o.enviado_por||'';
  try{ localStorage.setItem('repModificando', JSON.stringify(window._repModificando)); }catch(e){}

  go('reposiciones');
  setTimeout(function(){
    var inp=document.getElementById('rep-code');
    if(inp){ inp.value=cardcode; }
    _repPedidoId=pedidoId||null;
    try{ repGenerar(); }catch(e){ console.warn('abrir reposición:',e); }
    showT('Corregí las cantidades y volvé a generar el archivo');
  }, 260);
}

// Aviso mientras se está corrigiendo una reposición ya enviada
function _repModificandoAviso(){
  var m=window._repModificando;
  if(!m){
    try{
      var v=localStorage.getItem('repModificando');
      if(v){ m=JSON.parse(v); window._repModificando=m; }
    }catch(e){}
  }
  if(!m || !m.cardcode) return '';
  // A las dos horas se olvida solo, para no quedar pegado
  if(m.desde && (Date.now()-m.desde)>2*60*60*1000){ _repModificandoFin(); return ''; }
  if(String(_repCard||'')!==String(m.cardcode)) return '';
  return '<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;'
    +'padding:9px 12px;margin-bottom:10px;display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
    +'<i class="ti ti-edit" style="color:var(--t-marron)"></i>'
    +'<span style="font-size:11.5px;color:var(--t-marron);flex:1">'
      +'Estás <b>corrigiendo</b> la reposición que te envió gerencia'
      +(m.cardname?(' para '+_esc(m.cardname)):'')+'. '
      +'Cuando termines, generá el archivo y enviá al proveedor desde el seguimiento.</span>'
    +'<button class="btn bg2" style="padding:4px 10px;font-size:10.5px" onclick="_repModificandoFin()">'
      +'Ya no la estoy corrigiendo</button>'
    +'</div>';
}

function _repModificandoFin(){
  window._repModificando=null;
  try{ localStorage.removeItem('repModificando'); }catch(e){}
  try{ if(_repData && _repData.length) repRenderResumen(_repData, _repCard); }catch(e){}
}

async function _repEnvioProveedor(id, pedidoId){
  var o=(window._repEnvios||[]).find(function(x){ return String(x.id)===String(id); });
  if(!o){ showT('No se encontró la reposición'); return; }
  window._repProvCtx={id:id, pedidoId:pedidoId, envio:o};
  window._repOrigenNombre=o.enviado_por||'';
  window._mailAdj=[];

  // El proveedor, con su correo si lo tenemos
  var prov=null;
  try{
    var r=await fetch(SB+'/rest/v1/proveedores?select=cardcode,cardname,email&cardcode=eq.'
      +encodeURIComponent(o.cardcode||'')+'&limit=1',{headers:SBH});
    if(r.ok){ var a=await r.json(); prov=(Array.isArray(a)&&a[0])?a[0]:null; }
  }catch(e){}
  var correoProv=(prov&&prov.email)||'';

  var asunto=o.mail_asunto || o.resumen || ('Reposicion '+(o.cardcode||''));
  var cuerpo=o.mail_cuerpo || ('Estimados,\n\n'
    +'Adjunto el pedido de reposición.\n\n'
    +'Proveedor: '+(o.cardname||o.cardcode||'')+'\n\n'
    +'Quedamos atentos a su confirmación.\n\n'
    +'Saludos cordiales,\n'+_firmaNombre()+'\nKennedy Center Corp.');

  var prev=document.getElementById('modalRepProv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalRepProv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:660px;max-height:92vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)">'
        +'<i class="ti ti-send"></i> Enviar la reposición al proveedor</div>'
      +'<button onclick="_repProvModalCerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:9px 11px;'
      +'margin-bottom:12px;font-size:11.5px;color:var(--t-azul)">'
      +'<b>'+_esc(o.cardcode||'')+'</b> '+_esc(o.cardname||'')
      +'<div style="margin-top:2px">Es el mismo correo que te envió '
      +_esc(o.enviado_por||'gerencia')+'. Puedes ajustarlo antes de mandarlo.</div></div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">PARA · el proveedor</div>'
    +'<input id="repprov-para" value="'+_esc(correoProv)+'" '
      +'placeholder="correo@proveedor.com — separá varios con coma" '
      +'style="width:100%;padding:8px 10px;border:0.5px solid '+(correoProv?'var(--border)':'#E9C08A')
      +';border-radius:8px;font-size:13px;margin-bottom:4px;background:var(--surface-2);color:var(--text-primary)">'
    +(correoProv?'':'<div style="font-size:10.5px;color:var(--t-marron);margin-bottom:8px">'
      +'<i class="ti ti-alert-circle"></i> Este proveedor no tiene correo guardado. Escribilo aquí.</div>')
    +'<div style="font-size:11px;color:var(--text-muted);margin:8px 0 5px">CON COPIA · marcá a quien quieras</div>'
    +'<div id="repprov-users" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'
      +(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); })
        .map(function(u){
          var marcado=(String(u.email||'').toLowerCase()===String(o.enviado_por_email||'').toLowerCase());
          return '<label style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
            +(marcado?'#0c447c':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;'
            +'background:'+(marcado?'#e6f1fb':'var(--surface-0)')+'">'
            +'<input type="checkbox" value="'+_esc(u.email)+'"'+(marcado?' checked':'')
            +' style="margin:0;cursor:pointer">'
            +'<span>'+_esc(u.name)+'</span>'
            +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)
            +(u.dept?(' · '+_esc(dL(u.dept))):'')+'</span></label>';
        }).join('')
    +'</div>'
    +'<input id="repprov-cc" placeholder="Otros correos, separados por coma" '
      +'style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="repprov-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;'
      +'border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;'
      +'background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="repprov-cuerpo" rows="14" style="width:100%;padding:8px 10px;'
      +'border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;'
      +'background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTO</div>'
    +'<div id="repprov-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px">'
      +'<span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando la reposición…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_repProvModalCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="repprov-btn" style="background:#0c447c" onclick="_repProvEnviar()">'
        +'<i class="ti ti-send"></i> Enviar al proveedor</button>'
    +'</div></div>';
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  document.body.appendChild(ov);
  _modalEsc(ov);

  // El archivo de la reposición, el mismo que mandó gerencia
  var aviso=document.getElementById('repprov-auto');

  // El PDF y el Excel: los dos archivos que mandó gerencia
  var lista=[];
  try{
    var arch=o.archivos;
    if(typeof arch==='string'){ try{ arch=JSON.parse(arch); }catch(e){ arch=null; } }
    if(Array.isArray(arch) && arch.length) lista=arch;
  }catch(e){}
  if(!lista.length && o.archivo_path){
    lista=[{path:o.archivo_path, nombre:o.archivo_nombre||('Reposicion_'+(o.cardcode||'')+'.xlsx')}];
  }

  if(lista.length){
    var puestos=[], fallos=[];
    for(var i=0;i<lista.length;i++){
      try{
        var motivo={};
        var adj=await _solPagoAdjuntarDeStorage(lista[i].path, lista[i].nombre, motivo);
        if(adj){ window._mailAdj.push(adj); puestos.push(adj.nombre); }
        else fallos.push(lista[i].nombre+(motivo.txt?(' ('+motivo.txt+')'):''));
      }catch(e){ fallos.push(lista[i].nombre); }
    }
    mailPintarAdjuntos();
    if(aviso){
      aviso.innerHTML=(puestos.length
        ? '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> '
          +_esc(puestos.join(' · '))+'</span>'
        : '')
        +(fallos.length
          ? ('<div style="color:var(--t-ambar);margin-top:3px"><i class="ti ti-alert-circle"></i> '
             +'No se pudo adjuntar: '+_esc(fallos.join(', '))+'. Adjuntalo a mano.</div>')
          : '');
    }
  } else {
    if(aviso) aviso.innerHTML='<span style="color:var(--t-ambar)">'
      +'<i class="ti ti-alert-circle"></i> Esta reposición no tiene archivos guardados. Adjuntalos a mano.</span>';
  }
}

// Cierra el modal de "enviar al proveedor". Antes se llamaba igual que el
// del desplegable de proveedores y, al estar definida después, lo pisaba:
// elegir un proveedor ejecutaba ESTA y el desplegable nunca se cerraba.
function _repProvModalCerrar(){
  var m=document.getElementById('modalRepProv'); if(m) m.remove();
  window._mailAdj=[]; window._repProvCtx=null;
}

async function _repProvEnviar(){
  var ctx=window._repProvCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var o=ctx.envio;

  var para=((document.getElementById('repprov-para')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var cc=((document.getElementById('repprov-cc')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  // Los usuarios del portal que se marcaron
  var box=document.getElementById('repprov-users');
  if(box){
    Array.prototype.slice.call(box.querySelectorAll('input:checked')).forEach(function(c){
      if(cc.indexOf(c.value)<0) cc.push(c.value);
    });
  }
  if(!para.length){ _mailMsg('Escribe el correo del proveedor.','err'); return; }

  var asunto=(document.getElementById('repprov-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('repprov-cuerpo')||{}).value||'';
  if(!(window._mailAdj||[]).length){
    if(!confirm('No hay ningún archivo adjunto.\n\n¿Enviar igual?')) return;
  }

  var btn=document.getElementById('repprov-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var todos=para.concat(cc), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:'', para_lista:todos, para_email:para[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Reposición al proveedor · '+(o.cardcode||''), estado:'pendiente'
      })});
    if(!r.ok){
      _mailMsg('No se pudo encolar el correo.','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
    return;
  }

  // Recién con el correo enviado se marca el estado
  try{
    await _firmaWrite(SB+'/rest/v1/reposiciones_envios?id=eq.'+ctx.id,'PATCH',
      {estado:'enviada_proveedor', enviado_proveedor_en:new Date().toISOString(),
       enviado_proveedor_por:(CU&&CU.name)||'', enviado_proveedor_a:para.join(', ')},
      ['enviado_proveedor_en']);
    if(ctx.pedidoId){
      try{
        await _firmaWrite(SB+'/rest/v1/reposiciones_pedidos?id=eq.'+ctx.pedidoId,'PATCH',
          {estado:'finalizado', terminado_en:new Date().toISOString(),
           actualizado_en:new Date().toISOString()},['terminado_en']);
      }catch(e){}
    }
  }catch(e){ console.warn('marcar enviada:',e); }

  // Y se avisa a quien la mandó, más la gerencia del departamento
  try{
    var destinos=[];
    var quien=(USERS||[]).find(function(u){
      return String(u.email||'').toLowerCase()===String(o.enviado_por_email||'').toLowerCase()
          || u.name===o.enviado_por;
    });
    if(quien) destinos.push(quien);
    (USERS||[]).forEach(function(u){
      if(u.role!=='gerencia' || !u.id) return;
      if(o.dept && u.dept && String(u.dept)!==String(o.dept)) return;
      if(destinos.some(function(z){ return z.id===u.id; })) return;
      destinos.push(u);
    });
    destinos=destinos.filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length){
      await _menNotificar(destinos, {
        docnum:'', contexto:'reposicion',
        texto:'Reposición enviada al proveedor '+(o.cardname||o.cardcode||'')
          +' por '+((CU&&CU.name)||'')+' · a '+para.join(', '),
        etiqueta:'Reposición enviada al proveedor'
      });
    }
    addNotif('gerencia','Reposición enviada al proveedor por '+((CU&&CU.name)||''),'','ti-send', true);
  }catch(e){ console.warn('aviso a gerencia:',e); }

  _repProvModalCerrar();
  showT('✓ Reposición enviada al proveedor');
  _repEnviosCargar();
}

async function _repEnvioBorrar(id){
  if(!confirm('¿Seguro que deseas eliminar esta reposición? Esta acción no se puede deshacer.')) return;
  try{ await fetch(SB+'/rest/v1/reposiciones_envios?id=eq.'+id,{method:'DELETE',headers:SBH}); showT('Reposición eliminada'); _repEnviosCargar(); }catch(e){ showT('Error al eliminar: '+(e.message||e)); }
}

// ═══════════════════════════════════════════════════════════════════════════
//  CHAT DE COMENTARIOS (live) con acuse tipo WhatsApp
//  Doble check gris = entregado · Doble check verde = leído
//  Requiere la tabla Supabase: comentarios_chat (ver SQL entregado).
// ═══════════════════════════════════════════════════════════════════════════
var _chatCtx=null, _chatRef=null, _chatTitulo='', _chatTimer=null;
function _chatIdActual(){ return (CU&&CU.id)||''; }
async function _chatAbrir(contexto, refId, titulo){
  _chatCtx=contexto; _chatRef=refId; _chatTitulo=titulo||'';
  var ov=document.createElement('div');
  ov.id='chat-overlay';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2100;display:flex;align-items:center;justify-content:center;padding:14px';
  var h='<div style="background:var(--surface-0);border-radius:12px;width:100%;max-width:480px;height:80vh;max-height:640px;display:flex;flex-direction:column;overflow:hidden">';
  h+='<div style="background:#075E54;color:#fff;padding:11px 14px;display:flex;align-items:center;gap:8px"><i class="ti ti-message-circle"></i><div style="flex:1;min-width:0"><div style="font-size:13px;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">Comentarios</div><div style="font-size:10px;opacity:.85;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(_chatTitulo)+'</div></div><button onclick="_chatCerrar()" style="background:none;border:none;color:#fff;font-size:22px;cursor:pointer;line-height:1">&times;</button></div>';
  h+='<div id="chat-body" style="flex:1;overflow-y:auto;padding:12px;background:#ECE5DD;display:flex;flex-direction:column;gap:6px"><div style="text-align:center;color:#667;font-size:11px;margin:auto"><i class="ti ti-loader-2 spin"></i> Cargando...</div></div>';
  h+='<div style="display:flex;gap:6px;padding:9px;background:var(--surface-1);border-top:0.5px solid var(--border)"><input id="chat-input" placeholder="Escribe un comentario..." onkeydown="if(event.key===\'Enter\')_chatEnviar()" style="flex:1;padding:9px 12px;border:0.5px solid var(--border);border-radius:20px;font-size:13px;background:var(--surface-2);color:var(--text-primary)"><button onclick="_chatEnviar()" class="btn bp" style="border-radius:50%;width:40px;height:40px;padding:0"><i class="ti ti-send"></i></button></div>';
  h+='</div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) _chatCerrar(); });
  document.body.appendChild(ov);
  await _chatCargar();
  _chatTimer=setInterval(_chatCargar, 4000);
}
function _chatCerrar(){
  if(_chatTimer){ clearInterval(_chatTimer); _chatTimer=null; }
  var ov=document.getElementById('chat-overlay'); if(ov) ov.remove();
  try{ if(_chatCtx!=null && _chatRef!=null) _chatBadges(_chatCtx,[_chatRef]); }catch(e){}
}
function _chatChecks(m){
  if(m.autor!==_chatIdActual()) return '';
  var otros=(m.leido_por||'').split(',').map(function(s){return s.trim();}).filter(function(x){return x && x!==_chatIdActual();});
  var leido=otros.length>0;
  return '<i class="ti ti-checks" style="font-size:13px;margin-left:5px;vertical-align:-1px;color:'+(leido?'#34B7F1':'#9aa4a0')+'" title="'+(leido?'Leído':'Entregado')+'"></i>';
}
async function _chatCargar(){
  var body=document.getElementById('chat-body'); if(!body || _chatRef==null) return;
  try{
    var r=await fetch(SB+'/rest/v1/comentarios_chat?contexto=eq.'+encodeURIComponent(_chatCtx)+'&ref_id=eq.'+encodeURIComponent(_chatRef)+'&select=*&order=creado_en.asc&limit=500',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    var yo=_chatIdActual();
    var h='';
    if(!rows.length){ h='<div style="text-align:center;color:#667;font-size:11px;margin:auto">Sin comentarios todavía. Escribe el primero.</div>'; }
    rows.forEach(function(m){
      var mio=(m.autor===yo);
      var hora=m.creado_en?new Date(m.creado_en).toLocaleString('es',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}):'';
      h+='<div style="align-self:'+(mio?'flex-end':'flex-start')+';max-width:82%;background:'+(mio?'#DCF8C6':'#fff')+';border-radius:9px;padding:6px 9px;box-shadow:0 1px 1px rgba(0,0,0,.08)">'
        +(mio?'':'<div style="font-size:10px;font-weight:700;color:#075E54;margin-bottom:1px">'+_esc(m.autor_nom||m.autor||'')+(m.autor_rol?(' · '+_esc(m.autor_rol)):'')+'</div>')
        +'<div style="font-size:12.5px;color:var(--text-primary);white-space:pre-wrap;word-break:break-word">'+_esc(m.mensaje||'')+'</div>'
        +'<div style="font-size:9px;color:#8a938f;text-align:right;margin-top:2px">'+hora+_chatChecks(m)+'</div>'
      +'</div>';
    });
    var nearBottom=(body.scrollTop+body.clientHeight >= body.scrollHeight-60);
    body.innerHTML=h;
    if(nearBottom) body.scrollTop=body.scrollHeight;
    // Marcar como leídos los que no son míos
    _chatMarcarLeidos(rows);
  }catch(e){ /* silencioso */ }
}
async function _chatMarcarLeidos(rows){
  var yo=_chatIdActual(); if(!yo) return;
  var pend=rows.filter(function(m){ var l=(m.leido_por||''); return m.autor!==yo && l.split(',').map(function(s){return s.trim();}).indexOf(yo)<0; });
  for(var i=0;i<pend.length;i++){
    var m=pend[i];
    var nuevo=((m.leido_por||'').trim()? (m.leido_por.trim()+','+yo) : yo);
    try{ await fetch(SB+'/rest/v1/comentarios_chat?id=eq.'+m.id,{method:'PATCH',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify({leido_por:nuevo})}); }catch(e){}
  }
}
async function _chatEnviar(){
  var inp=document.getElementById('chat-input'); if(!inp) return;
  var txt=(inp.value||'').trim(); if(!txt) return;
  inp.value='';
  var payload={ contexto:_chatCtx, ref_id:_chatRef, autor:(CU&&CU.id)||'', autor_nom:(CU&&CU.name)||'', autor_rol:(CU&&CU.role)||'', mensaje:txt, leido_por:'', creado_en:new Date().toISOString() };
  try{
    var r=await fetch(SB+'/rest/v1/comentarios_chat',{method:'POST',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(payload)});
    if(!r.ok){ var t=await r.text(); console.error('chat insert',r.status,t); showT('No se pudo enviar (¿existe la tabla comentarios_chat?)'); inp.value=txt; return; }
    await _chatCargar();
  }catch(e){ console.error(e); showT('Error: '+(e.message||e)); inp.value=txt; }
}
// Actualiza el badge de no-leídos en los botones "Comentarios" de una lista
async function _chatBadges(contexto, ids){
  try{
    ids=(ids||[]).filter(function(x){return x!=null;});
    if(!ids.length) return;
    var yo=_chatIdActual();
    var inList='('+ids.join(',')+')';
    var r=await fetch(SB+'/rest/v1/comentarios_chat?contexto=eq.'+encodeURIComponent(contexto)+'&ref_id=in.'+inList+'&select=ref_id,autor,leido_por&limit=2000',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    var cnt={};
    rows.forEach(function(m){
      var l=(m.leido_por||'').split(',').map(function(s){return s.trim();});
      if(m.autor!==yo && l.indexOf(yo)<0){ cnt[m.ref_id]=(cnt[m.ref_id]||0)+1; }
    });
    ids.forEach(function(id){
      var b=document.getElementById('chatbtn-'+contexto+'-'+id); if(!b) return;
      var badge=b.querySelector('.chat-badge'); if(!badge) return;
      var n=cnt[id]||0;
      badge.textContent=n>0?n:'';
      badge.style.display=n>0?'inline-flex':'none';
    });
  }catch(e){}
}
// HTML del botón de comentarios (con badge de no leídos)
function _chatBtn(contexto, id, titulo){
  var t=String(titulo||'').replace(/['"\\]/g,'').slice(0,60);
  return '<button id="chatbtn-'+contexto+'-'+id+'" class="btn bg2" style="padding:5px 9px;font-size:11px" onclick="_chatAbrir(\''+contexto+'\','+id+',\''+_esc(t)+'\')"><i class="ti ti-message"></i> Comentarios<span class="chat-badge" style="display:none;align-items:center;justify-content:center;min-width:16px;height:16px;padding:0 4px;margin-left:5px;background:#dc2626;color:#fff;border-radius:9px;font-size:9px;font-weight:700"></span></button>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  LIVE CHAT entre usuarios (estilo WhatsApp) — mensajes directos + adjuntos
//  Doble check gris = entregado · Doble check verde = leído
//  Requiere la tabla Supabase: mensajes_dm (ver SQL entregado).
// ═══════════════════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════════════════
//  LIVE CHAT entre usuarios (estilo WhatsApp) — texto, voz, stickers, adjuntos,
//  fotos de perfil, editar/borrar/reenviar, marcar no leído, vaciar chat.
//  Tablas: mensajes_dm, perfiles, dm_marcas (ver SQL).
// ═══════════════════════════════════════════════════════════════════════════
var _dmPartner=null, _dmTimer=null, _dmArchivo=null, _dmMsgs={}, _dmLimpiadoEn=null, _dmFwd=null;
var _dmRec=null, _dmRecChunks=[];
window._perfiles=window._perfiles||{};
window._dmMarcas=window._dmMarcas||{};
var _dmColores={gerencia:'#EAF3DE',compras:'#e6f1fb',diseno:'#EEEDFE',importacion:'#E1F5EE',contabilidad:'#FBEAF0',bodega:'#FEF3E8'};
var _dmTc={gerencia:'#27500A',compras:'#0c447c',diseno:'#3C3489',importacion:'#085041',contabilidad:'#72243E',bodega:'#7C3D12'};
var _DM_STICKERS=['👍','🔥','🎉','💪','✅','🚀','☕','😎','🙌','🤝','💯','🧠'];
function _dmYo(){ return (CU&&CU.id)||''; }
function _dmUser(id){ return (USERS||[]).find(function(u){return u.id===id;})||{id:id,name:id,role:''}; }
async function _dmWrite(url,method,body,dropKeys){
  var r=await fetch(url,{method:method,headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(body)});
  if(!r.ok && dropKeys && dropKeys.length){ var b=Object.assign({},body); dropKeys.forEach(function(k){delete b[k];}); r=await fetch(url,{method:method,headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify(b)}); }
  return r;
}

// ── Perfiles (foto) ──
async function _perfilesCargar(){
  try{ var r=await fetch(SB+'/rest/v1/perfiles?select=id,foto_path&limit=500',{headers:SBH}); var rows=r.ok?(await r.json()):[]; var mp={}; (rows||[]).forEach(function(x){ if(x&&x.foto_path) mp[x.id]=x.foto_path; }); window._perfiles=mp; _perfilRefrescarTop(); }catch(e){}
}
function _fotoPerfil(uid){ var p=window._perfiles&&window._perfiles[uid]; return p?(DOCS_BASE+p.split('/').map(encodeURIComponent).join('/')):null; }
function _avatarHTML(uid,name,role,size){
  var url=_fotoPerfil(uid); var s=size||38;
  if(url) return '<div style="width:'+s+'px;height:'+s+'px;border-radius:50%;flex-shrink:0;background:#ddd;background-image:url('+url+');background-size:cover;background-position:center"></div>';
  var u=_dmUser(uid);
  return '<div style="width:'+s+'px;height:'+s+'px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:'+Math.round(s*0.34)+'px;font-weight:700;background:'+(_dmColores[role||u.role]||'#eee')+';color:'+(_dmTc[role||u.role]||'#333')+'">'+_esc(u.ini||ini(name||uid||'?'))+'</div>';
}
function _perfilRefrescarTop(){ var el=document.getElementById('topAvatar'); if(el){ var url=_fotoPerfil(_dmYo()); if(url){ el.style.backgroundImage='url('+url+')'; el.style.backgroundSize='cover'; el.style.backgroundPosition='center'; el.textContent=''; } } }
function _perfilCambiar(){
  var inp=document.createElement('input'); inp.type='file'; inp.accept='image/*';
  inp.onchange=async function(){ var f=inp.files&&inp.files[0]; if(!f)return; showT('Subiendo foto...'); try{ var path=await _subirDocStorage('perfil', _dmYo(), f); await fetch(SB+'/rest/v1/perfiles?on_conflict=id',{method:'POST',headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),body:JSON.stringify({id:_dmYo(),foto_path:path,actualizado_en:new Date().toISOString()})}); await _perfilesCargar(); showT('✓ Foto actualizada'); if(PG==='livechat'){ if(_dmPartner) _dmAbrir(_dmPartner); else rLiveChat(); } }catch(e){ showT('Error: '+(e.message||e)); } };
  inp.click();
}

// ── Marcas (no leído / vaciado) ──
async function _dmMarca(con, obj){ try{ await fetch(SB+'/rest/v1/dm_marcas?on_conflict=usuario,con',{method:'POST',headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),body:JSON.stringify(Object.assign({usuario:_dmYo(),con:con},obj))}); }catch(e){} }
async function _dmMarcasCargar(){
  try{ var r=await fetch(SB+'/rest/v1/dm_marcas?usuario=eq.'+encodeURIComponent(_dmYo())+'&select=con,no_leido,limpiado_en&limit=500',{headers:SBH}); var rows=r.ok?(await r.json()):[]; var mp={}; (rows||[]).forEach(function(x){ mp[x.con]=x; }); window._dmMarcas=mp; }catch(e){ window._dmMarcas={}; }
}

// ── Lista de contactos ──
async function rLiveChat(){
  if(_dmTimer){ clearInterval(_dmTimer); _dmTimer=null; }
  _dmPartner=null;
  var cont=document.getElementById('page-livechat'); if(!cont) return;
  cont.innerHTML='<div style="font-size:14px;font-weight:700;margin-bottom:4px"><i class="ti ti-messages"></i> Live Chat</div><div id="dm-contactos"><div class="empty" style="padding:16px"><i class="ti ti-loader-2 spin"></i> Cargando...</div></div>';
  try{
    await _perfilesCargar(); await _dmMarcasCargar();
    var yo=_dmYo();
    var r=await fetch(SB+'/rest/v1/mensajes_dm?or=(de.eq.'+encodeURIComponent(yo)+',para.eq.'+encodeURIComponent(yo)+')&select=de,para,mensaje,adjunto_nombre,tipo,borrado,leido_en,creado_en&order=creado_en.desc&limit=1500',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    var last={}, unread={};
    rows.forEach(function(m){
      var other=(m.de===yo)?m.para:m.de;
      if(!last[other]) last[other]=m;
      if(m.para===yo && m.de===other && !m.leido_en) unread[other]=(unread[other]||0)+1;
    });
    var otros=(USERS||[]).filter(function(u){ return u.id!==yo; });
    otros.sort(function(a,b){ var ta=last[a.id]?new Date(last[a.id].creado_en).getTime():0; var tb=last[b.id]?new Date(last[b.id].creado_en).getTime():0; return tb-ta; });
    var h='<div style="font-size:11px;color:var(--text-muted);margin-bottom:8px">Elige a quién escribirle. Cualquier usuario puede escribirte.</div><div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden">';
    otros.forEach(function(u){
      var lm=last[u.id]; var n=unread[u.id]||0; var marca=window._dmMarcas[u.id]||{};
      var prevTxt = lm ? (lm.borrado?'Mensaje eliminado':(lm.tipo==='voz'?'🎤 Mensaje de voz':(lm.tipo==='sticker'?(lm.mensaje||'Sticker'):(lm.adjunto_nombre?('📎 '+lm.adjunto_nombre):(lm.mensaje||''))))) : 'Sin mensajes aún';
      var prev=(lm&&lm.de===yo?'Tú: ':'')+prevTxt;
      var hora=lm?new Date(lm.creado_en).toLocaleString('es',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}):'';
      h+='<div style="display:flex;align-items:center;gap:10px;padding:9px 12px;border-top:0.5px solid var(--border)">'
        +'<div onclick="_dmAbrir(\''+u.id+'\')" style="display:flex;align-items:center;gap:10px;flex:1;min-width:0;cursor:pointer">'
          +_avatarHTML(u.id,u.name,u.role,40)
          +'<div style="flex:1;min-width:0"><div style="font-size:13px;font-weight:600;display:flex;justify-content:space-between;gap:8px"><span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(u.name)+'</span><span style="font-size:9px;color:var(--text-muted);font-weight:400;flex-shrink:0">'+hora+'</span></div>'
            +'<div style="font-size:11px;color:var(--text-muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(prev)+'</div></div>'
        +'</div>'
        +(n>0?'<span style="background:#16a34a;color:#fff;border-radius:999px;min-width:18px;height:18px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;padding:0 5px;flex-shrink:0">'+n+'</span>':'')
        +((marca.no_leido&&!n)?'<span title="Marcado como no leído" style="width:11px;height:11px;border-radius:50%;background:#16a34a;flex-shrink:0"></span>':'')
        +'<span onclick="event.stopPropagation();_dmContactoMenu(\''+u.id+'\')" style="cursor:pointer;color:var(--text-muted);padding:2px 4px;flex-shrink:0"><i class="ti ti-dots-vertical"></i></span>'
      +'</div>';
    });
    h+='</div>';
    document.getElementById('dm-contactos').innerHTML=h;
    _dmActualizarBadge();
  }catch(e){ document.getElementById('dm-contactos').innerHTML='<div class="empty" style="color:var(--text-danger);padding:14px">Error al cargar: '+(e.message||e)+'</div>'; }
}
function _dmContactoMenu(uid){
  var ov=document.createElement('div'); ov.className='dm-menu-ov'; ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:2300;display:flex;align-items:center;justify-content:center;padding:20px';
  function it(icon,txt,fn,col){ return '<div onclick="'+fn+'" style="padding:12px 16px;font-size:13px;cursor:pointer;display:flex;align-items:center;gap:10px;border-bottom:0.5px solid var(--border);color:'+(col||'var(--text)')+'"><i class="ti '+icon+'"></i> '+txt+'</div>'; }
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;overflow:hidden;min-width:220px">'+it('ti-mail-off','Marcar como no leído','_dmCerrarMenu();_dmMarcarNoLeido(\''+uid+'\')')+it('ti-eraser','Vaciar chat (solo para mí)','_dmCerrarMenu();_dmVaciarCon(\''+uid+'\')','#dc2626')+it('ti-x','Cancelar','_dmCerrarMenu()')+'</div>';
  ov.addEventListener('click',function(e){ if(e.target===ov)_dmCerrarMenu(); }); document.body.appendChild(ov);
}
async function _dmMarcarNoLeido(uid){ await _dmMarca(uid,{no_leido:true}); rLiveChat(); }
async function _dmVaciarCon(uid){ if(!confirm('¿Vaciar el chat con este usuario? (solo se oculta para ti)'))return; await _dmMarca(uid,{limpiado_en:new Date().toISOString(),no_leido:false}); rLiveChat(); }

// ── Conversación ──
function _dmAbrir(uid){
  if(_dmTimer){ clearInterval(_dmTimer); _dmTimer=null; }
  _dmPartner=uid; _dmArchivo=null;
  var marca=(window._dmMarcas&&window._dmMarcas[uid])||{}; _dmLimpiadoEn=marca.limpiado_en?new Date(marca.limpiado_en).getTime():null;
  _dmMarca(uid,{no_leido:false});
  var u=_dmUser(uid);
  var cont=document.getElementById('page-livechat'); if(!cont) return;
  var h='<div style="display:flex;flex-direction:column;height:78vh;border:0.5px solid var(--border);border-radius:12px;overflow:hidden">';
  h+='<div style="background:#075E54;color:#fff;padding:9px 12px;display:flex;align-items:center;gap:10px"><button onclick="rLiveChat()" style="background:none;border:none;color:#fff;font-size:18px;cursor:pointer"><i class="ti ti-arrow-left"></i></button>'
    +_avatarHTML(uid,u.name,u.role,34)
    +'<div style="flex:1;min-width:0"><div style="font-size:13px;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(u.name)+'</div><div style="font-size:10px;opacity:.85">'+_esc((u.role||'')+(u.dept?(' · '+dL(u.dept)):''))+'</div></div>'
    +'<button onclick="_dmConvMenu()" style="background:none;border:none;color:#fff;font-size:18px;cursor:pointer"><i class="ti ti-dots-vertical"></i></button></div>';
  h+='<div id="dm-conv" style="flex:1;overflow-y:auto;padding:12px;background:#ECE5DD;display:flex;flex-direction:column;gap:6px"><div style="text-align:center;color:#667;font-size:11px;margin:auto"><i class="ti ti-loader-2 spin"></i></div></div>';
  h+='<div id="dm-file-hint" style="display:none;font-size:11px;color:#075E54;background:#e7f3f0;padding:5px 12px"></div>';
  h+='<div id="dm-stickerbar" style="display:none;flex-wrap:wrap;gap:6px;padding:8px;background:var(--surface-1);border-top:0.5px solid var(--border);max-height:120px;overflow-y:auto"></div>';
  h+='<div style="display:flex;gap:4px;padding:8px;background:var(--surface-1);border-top:0.5px solid var(--border);align-items:center">'
    +'<button onclick="_dmToggleStickers()" title="Stickers" style="background:none;border:none;color:var(--text-muted);cursor:pointer;padding:5px"><i class="ti ti-mood-smile" style="font-size:19px"></i></button>'
    +'<label style="cursor:pointer;color:var(--text-muted);padding:5px"><i class="ti ti-paperclip" style="font-size:18px"></i><input type="file" onchange="_dmSetArchivo(this)" style="display:none"></label>'
    +'<button id="dm-mic" onclick="_dmGrabarToggle()" title="Mensaje de voz" style="background:none;border:none;color:var(--text-muted);cursor:pointer;padding:5px"><i class="ti ti-microphone" style="font-size:19px"></i></button>'
    +'<input id="dm-input" placeholder="Escribe un mensaje..." onkeydown="if(event.key===\'Enter\')_dmEnviar()" style="flex:1;padding:9px 12px;border:0.5px solid var(--border);border-radius:20px;font-size:13px;background:var(--surface-2);color:var(--text-primary)">'
    +'<button onclick="_dmEnviar()" class="btn bp" style="border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0"><i class="ti ti-send"></i></button></div>';
  h+='</div>';
  cont.innerHTML=h;
  _dmCargarConv();
  _dmTimer=setInterval(_dmCargarConv, 3500);
}
function _dmConvMenu(){
  var ov=document.createElement('div'); ov.className='dm-menu-ov'; ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:2300;display:flex;align-items:center;justify-content:center;padding:20px';
  function it(icon,txt,fn,col){ return '<div onclick="'+fn+'" style="padding:12px 16px;font-size:13px;cursor:pointer;display:flex;align-items:center;gap:10px;border-bottom:0.5px solid var(--border);color:'+(col||'var(--text)')+'"><i class="ti '+icon+'"></i> '+txt+'</div>'; }
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;overflow:hidden;min-width:220px">'+it('ti-mail-off','Marcar como no leído','_dmCerrarMenu();_dmMarcarNoLeidoDesdeConv()')+it('ti-eraser','Vaciar chat (solo para mí)','_dmCerrarMenu();_dmVaciarConv()','#dc2626')+it('ti-x','Cancelar','_dmCerrarMenu()')+'</div>';
  ov.addEventListener('click',function(e){ if(e.target===ov)_dmCerrarMenu(); }); document.body.appendChild(ov);
}
async function _dmMarcarNoLeidoDesdeConv(){ if(_dmPartner){ await _dmMarca(_dmPartner,{no_leido:true}); rLiveChat(); } }
async function _dmVaciarConv(){ if(!_dmPartner)return; if(!confirm('¿Vaciar este chat? (solo para ti)'))return; await _dmMarca(_dmPartner,{limpiado_en:new Date().toISOString(),no_leido:false}); _dmLimpiadoEn=Date.now(); _dmCargarConv(); }
function _dmToggleStickers(){
  var bar=document.getElementById('dm-stickerbar'); if(!bar)return;
  if(bar.style.display==='flex'){ bar.style.display='none'; return; }
  bar.innerHTML=_DM_STICKERS.map(function(s){ return '<div onclick="_dmSticker(\''+s+'\')" style="font-size:30px;cursor:pointer;padding:4px 6px;border-radius:8px">'+s+'</div>'; }).join('');
  bar.style.display='flex';
}
async function _dmSticker(emoji){ var b=document.getElementById('dm-stickerbar'); if(b)b.style.display='none'; await _dmInsertar({tipo:'sticker',mensaje:emoji}); _dmCargarConv(); }
function _dmSetArchivo(input){ var f=input.files&&input.files[0]; _dmArchivo=f||null; var hint=document.getElementById('dm-file-hint'); if(hint){ if(f){ hint.style.display='block'; hint.innerHTML='<i class="ti ti-paperclip"></i> Adjunto listo: '+_esc(f.name)+' — escribe (opcional) y envía'; } else hint.style.display='none'; } }
function _dmChecks(m){ if(m.de!==_dmYo()) return ''; var leido=!!m.leido_en; return '<i class="ti ti-checks" style="font-size:13px;margin-left:5px;vertical-align:-1px;color:'+(leido?'#34B7F1':'#9aa4a0')+'" title="'+(leido?'Leído':'Entregado')+'"></i>'; }
async function _dmInsertar(extra){
  var payload=Object.assign({ de:_dmYo(), de_nom:(CU&&CU.name)||'', para:_dmPartner, mensaje:'', adjunto_path:null, adjunto_nombre:null, tipo:'texto', leido_en:null, creado_en:new Date().toISOString() }, extra||{});
  return _dmWrite(SB+'/rest/v1/mensajes_dm','POST',payload,['tipo','borrado','borrado_para','editado_en']);
}
async function _dmCargarConv(){
  var conv=document.getElementById('dm-conv'); if(!conv || !_dmPartner || PG!=='livechat'){ if(_dmTimer){clearInterval(_dmTimer);_dmTimer=null;} return; }
  try{
    var yo=_dmYo(), ot=_dmPartner;
    var flt='or=(and(de.eq.'+encodeURIComponent(yo)+',para.eq.'+encodeURIComponent(ot)+'),and(de.eq.'+encodeURIComponent(ot)+',para.eq.'+encodeURIComponent(yo)+'))';
    var r=await fetch(SB+'/rest/v1/mensajes_dm?'+flt+'&select=*&order=creado_en.asc&limit=1000',{headers:SBH});
    var rows=r.ok?(await r.json()):[];
    if(!Array.isArray(rows)) rows=[];
    _dmMsgs={}; var h='', vis=0;
    rows.forEach(function(m){
      _dmMsgs[m.id]=m;
      if(_dmLimpiadoEn && new Date(m.creado_en).getTime()<=_dmLimpiadoEn) return;
      var bp=(m.borrado_para||'').split(',').map(function(s){return s.trim();});
      if(bp.indexOf(yo)>=0) return;
      vis++;
      var mio=(m.de===yo);
      var hora=m.creado_en?new Date(m.creado_en).toLocaleString('es',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}):'';
      if(m.borrado){
        h+='<div style="align-self:'+(mio?'flex-end':'flex-start')+';max-width:82%;background:'+(mio?'#DCF8C6':'#fff')+';border-radius:9px;padding:6px 9px;font-style:italic;color:#8a938f;font-size:12px"><i class="ti ti-ban"></i> Mensaje eliminado</div>';
        return;
      }
      if(m.tipo==='sticker'){
        h+='<div style="align-self:'+(mio?'flex-end':'flex-start')+';display:flex;flex-direction:column;align-items:'+(mio?'flex-end':'flex-start')+'"><div style="font-size:54px;line-height:1" onclick="_dmMenu('+m.id+')">'+_esc(m.mensaje||'')+'</div><div style="font-size:9px;color:#8a938f">'+hora+_dmChecks(m)+'</div></div>';
        return;
      }
      var adj='';
      if(m.adjunto_path){
        var url=DOCS_BASE+m.adjunto_path.split('/').map(encodeURIComponent).join('/');
        var nm=(m.adjunto_nombre||m.adjunto_path||'');
        var esImg=/\.(png|jpe?g|gif|webp)$/i.test(nm);
        var esAudio=(m.tipo==='voz')||/\.(webm|ogg|mp3|m4a|wav)$/i.test(nm);
        if(esAudio) adj='<audio controls src="'+url+'" style="max-width:210px;display:block;margin-bottom:3px"></audio>';
        else if(esImg) adj='<img src="'+url+'" onclick="verArchivo(\''+url+'\',\''+_esc(nm)+'\')" style="max-width:180px;max-height:180px;border-radius:8px;cursor:zoom-in;display:block;margin-bottom:3px">';
        else adj='<div onclick="verArchivo(\''+url+'\',\''+_esc(nm)+'\')" style="display:flex;align-items:center;gap:6px;background:rgba(0,0,0,.05);border-radius:7px;padding:6px 8px;cursor:pointer;margin-bottom:3px"><i class="ti ti-file"></i><span style="font-size:11px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:150px">'+_esc(nm)+'</span></div>';
      }
      h+='<div style="align-self:'+(mio?'flex-end':'flex-start')+';max-width:82%;background:'+(mio?'#DCF8C6':'#fff')+';border-radius:9px;padding:6px 9px 5px;box-shadow:0 1px 1px rgba(0,0,0,.08);position:relative">'
        +'<span onclick="_dmMenu('+m.id+')" style="position:absolute;top:2px;right:3px;cursor:pointer;color:#9aa4a0;font-size:13px"><i class="ti ti-chevron-down"></i></span>'
        +adj
        +(m.mensaje?('<div style="font-size:12.5px;color:var(--text-primary);white-space:pre-wrap;word-break:break-word;padding-right:12px">'+_esc(m.mensaje)+'</div>'):'')
        +'<div style="font-size:9px;color:#8a938f;text-align:right;margin-top:2px">'+(m.editado_en?'<span style="font-style:italic;margin-right:4px">editado</span>':'')+hora+_dmChecks(m)+'</div>'
      +'</div>';
    });
    if(!vis) h='<div style="text-align:center;color:#667;font-size:11px;margin:auto">Sin mensajes. Escribe el primero.</div>';
    var nb=(conv.scrollTop+conv.clientHeight >= conv.scrollHeight-60);
    conv.innerHTML=h;
    if(nb) conv.scrollTop=conv.scrollHeight;
    if(rows.some(function(m){return m.para===yo && m.de===ot && !m.leido_en;})){
      try{ await fetch(SB+'/rest/v1/mensajes_dm?para=eq.'+encodeURIComponent(yo)+'&de=eq.'+encodeURIComponent(ot)+'&leido_en=is.null',{method:'PATCH',headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),body:JSON.stringify({leido_en:new Date().toISOString()})}); _dmActualizarBadge(); }catch(e){}
    }
  }catch(e){}
}
async function _dmEnviar(){
  var inp=document.getElementById('dm-input'); if(!inp||!_dmPartner) return;
  var txt=(inp.value||'').trim();
  if(!txt && !_dmArchivo) return;
  inp.value='';
  var path=null, nombre=null, tipo='texto';
  try{ if(_dmArchivo){ path=await _subirDocStorage('dm', _dmYo()+'_'+_dmPartner, _dmArchivo); nombre=_dmArchivo.name; tipo='archivo'; } }catch(e){}
  await _dmInsertar({mensaje:txt, adjunto_path:path, adjunto_nombre:nombre, tipo:tipo});
  _dmArchivo=null; var hint=document.getElementById('dm-file-hint'); if(hint) hint.style.display='none';
  await _dmCargarConv();
}
// ── Mensaje de voz ──
async function _dmGrabarToggle(){
  var mic=document.getElementById('dm-mic');
  if(_dmRec && _dmRec.state==='recording'){ _dmRec.stop(); return; }
  if(!navigator.mediaDevices || !window.MediaRecorder){ showT('Tu navegador no soporta grabar audio'); return; }
  try{
    var stream=await navigator.mediaDevices.getUserMedia({audio:true});
    _dmRecChunks=[]; _dmRec=new MediaRecorder(stream);
    _dmRec.ondataavailable=function(e){ if(e.data && e.data.size) _dmRecChunks.push(e.data); };
    _dmRec.onstop=async function(){
      stream.getTracks().forEach(function(t){t.stop();});
      if(mic){ mic.style.color='var(--text-muted)'; mic.querySelector('i').className='ti ti-microphone'; }
      var blob=new Blob(_dmRecChunks,{type:(_dmRec.mimeType||'audio/webm')});
      if(!blob.size) return;
      var ext=(blob.type.indexOf('ogg')>=0)?'ogg':'webm';
      var file=new File([blob],'voz_'+Date.now()+'.'+ext,{type:blob.type});
      showT('Enviando voz...');
      try{ var p=await _subirDocStorage('dm', _dmYo()+'_'+_dmPartner, file); await _dmInsertar({tipo:'voz', adjunto_path:p, adjunto_nombre:file.name}); _dmCargarConv(); }catch(e){ showT('Error al enviar voz'); }
    };
    _dmRec.start();
    if(mic){ mic.style.color='#dc2626'; mic.querySelector('i').className='ti ti-player-stop-filled'; }
    showT('Grabando... toca de nuevo para enviar');
  }catch(e){ showT('No se pudo acceder al micrófono'); }
}
// ── Menú de mensaje: editar / borrar / reenviar ──
function _dmMenu(id){
  var m=_dmMsgs[id]; if(!m||m.borrado) return;
  var mio=(m.de===_dmYo());
  var ov=document.createElement('div'); ov.className='dm-menu-ov'; ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:2300;display:flex;align-items:center;justify-content:center;padding:20px';
  function it(icon,txt,fn,col){ return '<div onclick="'+fn+'" style="padding:12px 16px;font-size:13px;cursor:pointer;display:flex;align-items:center;gap:10px;border-bottom:0.5px solid var(--border);color:'+(col||'var(--text)')+'"><i class="ti '+icon+'"></i> '+txt+'</div>'; }
  var h='<div style="background:var(--surface-0);border-radius:12px;overflow:hidden;min-width:230px">';
  if(mio && (m.tipo==='texto'||!m.tipo) && m.mensaje) h+=it('ti-edit','Editar','_dmCerrarMenu();_dmEditar('+id+')');
  h+=it('ti-arrow-forward-up','Reenviar','_dmCerrarMenu();_dmReenviar('+id+')');
  h+=it('ti-trash','Borrar para mí','_dmCerrarMenu();_dmBorrarMi('+id+')');
  if(mio) h+=it('ti-trash-x','Borrar para todos','_dmCerrarMenu();_dmBorrarTodos('+id+')','#dc2626');
  h+=it('ti-x','Cancelar','_dmCerrarMenu()');
  h+='</div>'; ov.innerHTML=h; ov.addEventListener('click',function(e){ if(e.target===ov)_dmCerrarMenu(); }); document.body.appendChild(ov);
}
function _dmCerrarMenu(){ document.querySelectorAll('.dm-menu-ov').forEach(function(o){o.remove();}); }
async function _dmEditar(id){ var m=_dmMsgs[id]; if(!m)return; var nv=prompt('Editar mensaje:', m.mensaje||''); if(nv==null)return; nv=nv.trim(); if(!nv)return; await _dmWrite(SB+'/rest/v1/mensajes_dm?id=eq.'+id,'PATCH',{mensaje:nv, editado_en:new Date().toISOString()},['editado_en']); _dmCargarConv(); }
async function _dmBorrarMi(id){ var m=_dmMsgs[id]; if(!m)return; var yo=_dmYo(); var l=(m.borrado_para||'').split(',').map(function(s){return s.trim();}).filter(Boolean); if(l.indexOf(yo)<0)l.push(yo); await _dmWrite(SB+'/rest/v1/mensajes_dm?id=eq.'+id,'PATCH',{borrado_para:l.join(',')},['borrado_para']); _dmCargarConv(); }
async function _dmBorrarTodos(id){ if(!confirm('¿Borrar este mensaje para todos?'))return; await _dmWrite(SB+'/rest/v1/mensajes_dm?id=eq.'+id,'PATCH',{borrado:true, mensaje:'', adjunto_path:null, adjunto_nombre:null, tipo:'texto'},['borrado']); _dmCargarConv(); }
function _dmReenviar(id){
  var m=_dmMsgs[id]; if(!m)return; _dmFwd=id;
  var ov=document.createElement('div'); ov.className='dm-menu-ov'; ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:2300;display:flex;align-items:center;justify-content:center;padding:20px';
  var yo=_dmYo();
  var lista=(USERS||[]).filter(function(u){return u.id!==yo;}).map(function(u){ return '<div onclick="_dmReenviarA(\''+u.id+'\')" style="display:flex;align-items:center;gap:9px;padding:9px 14px;cursor:pointer;border-bottom:0.5px solid var(--border)">'+_avatarHTML(u.id,u.name,u.role,30)+'<span style="font-size:13px;font-weight:600">'+_esc(u.name)+'</span></div>'; }).join('');
  ov.innerHTML='<div style="background:var(--surface-0);border-radius:12px;overflow:hidden;width:100%;max-width:340px;max-height:70vh;display:flex;flex-direction:column"><div style="padding:11px 14px;font-weight:700;font-size:13px;border-bottom:0.5px solid var(--border)"><i class="ti ti-arrow-forward-up"></i> Reenviar a…</div><div style="overflow-y:auto">'+lista+'</div><div onclick="_dmCerrarMenu()" style="padding:11px 14px;text-align:center;font-size:13px;cursor:pointer;color:var(--text-muted)">Cancelar</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov)_dmCerrarMenu(); }); document.body.appendChild(ov);
}
async function _dmReenviarA(dest){
  var m=_dmMsgs[_dmFwd]; _dmCerrarMenu(); if(!m)return;
  var payload={ de:_dmYo(), de_nom:(CU&&CU.name)||'', para:dest, mensaje:m.mensaje||'', adjunto_path:m.adjunto_path||null, adjunto_nombre:m.adjunto_nombre||null, tipo:m.tipo||'texto', leido_en:null, creado_en:new Date().toISOString() };
  await _dmWrite(SB+'/rest/v1/mensajes_dm','POST',payload,['tipo']);
  showT('✓ Reenviado a '+(_dmUser(dest).name||dest));
}
// ── Badge del menú (verde) ──
// El número de mensajes sin leer, en la pestaña del navegador. Con varias
// pestañas abiertas, así se ve que hay algo nuevo sin tener que entrar.
window._dmTituloBase = window._dmTituloBase || null;

function _dmTituloPestana(n){
  try{
    if(window._dmTituloBase===null){
      // El título tal cual, sin el contador de una vuelta anterior
      window._dmTituloBase=String(document.title||'').replace(/^\(\d+\)\s*/,'');
    }
    var base=window._dmTituloBase;
    document.title = (n>0) ? ('('+(n>99?'99+':n)+') '+base) : base;
  }catch(e){}
}

async function _dmActualizarBadge(){
  try{
    var yo=_dmYo(); if(!yo) return;
    var r=await fetch(SB+'/rest/v1/mensajes_dm?para=eq.'+encodeURIComponent(yo)+'&leido_en=is.null&borrado=is.false&select=id&limit=500',{headers:SBH});
    if(!r.ok){ r=await fetch(SB+'/rest/v1/mensajes_dm?para=eq.'+encodeURIComponent(yo)+'&leido_en=is.null&select=id&limit=500',{headers:SBH}); }
    var rows=r.ok?(await r.json()):[];
    var n=Array.isArray(rows)?rows.length:0;
    _dmTituloPestana(n);
    document.querySelectorAll('.nb').forEach(function(b){
      if((b.getAttribute('onclick')||'').indexOf("'livechat'")>=0){
        var ex=b.querySelector('.dm-badge'); if(ex) ex.remove();
        if(n>0){ var sp=document.createElement('span'); sp.className='dm-badge'; sp.textContent=n; sp.style.cssText='display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;margin-left:6px;background:#16a34a;color:#fff;border-radius:999px;font-size:10px;font-weight:700;box-shadow:0 0 0 2px rgba(22,163,74,.18)'; b.appendChild(sp); }
      }
    });
  }catch(e){}
}
function _dmInit(){ _perfilesCargar(); _dmActualizarBadge(); if(!window._dmPollerOn){ window._dmPollerOn=true; setInterval(_dmActualizarBadge, 20000); } }
function abrirInvProveedor(code){
  code=String(code||'').trim(); if(!code){ showT('Sin código de proveedor'); return; }
  go('reposiciones');
  var tries=0;
  (function attempt(){ var el=document.getElementById('rep-code'); if(el){ el.value=code; if(typeof repGenerar==='function'){ try{ repGenerar(); }catch(e){} } return; } if(tries++<25) setTimeout(attempt,150); })();
}
// ═══════════════════════════════════════════════════════════════════════════
//  CATÁLOGO TEMPORAL: PROVEEDORES Y SKU QUE TODAVÍA NO ESTÁN EN SAP
//  Cuando se crea una orden NO SAP con un proveedor nuevo o con SKUs nuevos,
//  se guardan aquí para poder trabajarlos mientras SAP los da de alta.
//  En cuanto el mismo cardcode / itemcode aparece en `inventario`, la ficha
//  temporal se borra sola: SAP manda.
//  Tabla Supabase: catalogo_nosap
// ═══════════════════════════════════════════════════════════════════════════
window._catNoSap = window._catNoSap || [];

// ── ¿Esta ficha sigue siendo un artículo NO SAP de verdad? ──
// No lo es si ya se degradó a solo-foto, ni si su código apareció en SAP.
// Todas las pantallas que listan o cuentan fichas pasan por aquí, para que
// no vuelva a haber un sitio que enseñe lo que otro ya oculta.
function _catFichaViva(f){
  if(!f || f.tipo==='proveedor' || f.tipo==='foto') return false;
  try{ if((window._catEnSap||{})[_catKeyItem(f.itemcode)]) return false; }catch(e){}
  return true;
}

function _catKeyProv(c){ return String(c||'').trim().toUpperCase(); }
function _catKeyItem(c){ return String(c||'').trim().toUpperCase(); }

// ── Carga desde Supabase y depura lo que ya existe en SAP ──
async function _catNoSapCargar(silencioso){
  try{
    var r=await fetch(SB+'/rest/v1/catalogo_nosap?select=*&order=creado_en.desc&limit=1000',{headers:SBH});
    if(!r.ok){ if(!silencioso) console.warn('catalogo_nosap:', r.status); window._catNoSap=[]; return []; }
    var rows=await r.json();
    window._catNoSap=Array.isArray(rows)?rows:[];
    await _catNoSapDepurar();
    return window._catNoSap;
  }catch(e){ console.warn('cargar catalogo_nosap:',e); return window._catNoSap||[]; }
}

// ── ¿La foto que SAP declara existe de verdad en el bucket? ──
// SAP rellena picturname cuando alguien asigna la imagen en el ERP, pero eso
// no garantiza que el archivo haya llegado al bucket. Fiarse del nombre costó
// las 33 fichas de la DKC-26084: se borraron por "ya tienen foto en SAP" y las
// imágenes buenas del proveedor quedaron sin nada que las apuntara.
// Se comprueba de verdad, probando las mismas variantes que usa el portal al
// pintar. Ante la duda (sin red, error raro) se responde false: no borrar.
async function _fotoSapExiste(picturname){
  var pn=String(picturname||'').trim();
  if(!pn) return false;
  var variantes=[pn];
  if(pn.toLowerCase()!==pn) variantes.push(pn.toLowerCase());
  if(pn.toUpperCase()!==pn) variantes.push(pn.toUpperCase());
  for(var i=0;i<variantes.length;i++){
    try{
      var r=await fetch(FOTO_BASE+encodeURIComponent(variantes[i]));
      if(r.ok) return true;
    }catch(e){ return false; }   // sin conexión: no se borra nada
  }
  return false;
}

// ── ¿Este artículo tiene en SAP una foto que se pueda ver? ──
// Consulta el picturname del inventario y comprueba que el archivo exista.
// Un nombre sin archivo detrás cuenta como SIN foto.
async function _sapTieneFotoReal(itemcode){
  var c=String(itemcode||'').trim();
  if(!c) return false;
  try{
    var r=await fetch(SB+'/rest/v1/inventario?select=picturname&itemcode=eq.'
      +encodeURIComponent(c)+'&limit=1',{headers:SBH});
    if(!r.ok) return false;
    var f=await r.json();
    if(!Array.isArray(f)||!f.length) return false;
    return await _fotoSapExiste(f[0].picturname);
  }catch(e){ return false; }
}

// ── Borra las fichas temporales cuyo código ya existe en SAP ──
async function _catNoSapDepurar(){
  var filas=window._catNoSap||[];
  if(!filas.length) return 0;
  var provs=[], items=[];
  filas.forEach(function(f){
    if(f.tipo==='proveedor' && f.cardcode) provs.push(_catKeyProv(f.cardcode));
    if(f.tipo==='item' && f.itemcode) items.push(_catKeyItem(f.itemcode));
  });
  var enSapProv={}, enSapItem={};
  try{
    if(provs.length){
      var lp=provs.map(function(x){return '"'+x.replace(/"/g,'')+'"';}).join(',');
      var rp=await fetch(SB+'/rest/v1/inventario?select=cardcode&cardcode=in.('+encodeURIComponent(lp)+')&limit=2000',{headers:SBH});
      if(rp.ok){ (await rp.json()||[]).forEach(function(x){ enSapProv[_catKeyProv(x.cardcode)]=true; }); }
    }
    if(items.length){
      // Se pide también la foto: un SKU que ya existe en SAP pero todavía sin
      // foto necesita que su ficha temporal siga viva, porque ahí está la
      // única imagen que hay (la que se sacó del Excel del proveedor).
      var li=items.map(function(x){return '"'+x.replace(/"/g,'')+'"';}).join(',');
      var ri=await fetch(SB+'/rest/v1/inventario?select=itemcode,picturname&itemcode=in.('+encodeURIComponent(li)+')&limit=2000',{headers:SBH});
      if(ri.ok){
        var _filas=await ri.json()||[];
        // No basta con que SAP declare un nombre: se comprueba que la imagen
        // esté realmente en el bucket. Si el nombre no tiene archivo detrás,
        // el SKU cuenta como SIN foto y su ficha se conserva.
        for(var _f=0;_f<_filas.length;_f++){
          var _x=_filas[_f];
          var _pn=String(_x.picturname||'').trim();
          var _real=_pn ? await _fotoSapExiste(_pn) : false;
          enSapItem[_catKeyItem(_x.itemcode)]=_real?'con_foto':'sin_foto';
          if(_pn && !_real){
            console.warn('[catalogo_nosap] '+_x.itemcode+': SAP declara "'+_pn
              +'" pero esa imagen no está en el bucket. Se conserva solo la foto.');
          }
        }
      }
    }
  }catch(e){ console.warn('depurar catalogo:',e); return 0; }

  // En cuanto un SKU existe en SAP deja de ser un artículo NO SAP y sale del
  // catálogo. Lo ÚNICO que se conserva es la foto, y solo mientras SAP no
  // tenga la suya: la ficha se degrada a tipo 'foto', que no aparece en
  // ninguna pantalla pero sigue alimentando la imagen del artículo de SAP.
  // Cuando SAP ya trae foto, se borra del todo.
  var soloFoto=[];      // se degradan: siguen dando la imagen
  var aBorrar=filas.filter(function(f){
    if(f.tipo==='proveedor'){
      // El proveedor se va con sus artículos: si ya no le queda ninguno
      // como artículo NO SAP, no pinta nada en el catálogo.
      var suyos=_catItemsDeProveedor(f.cardcode);
      var algunoSigue=suyos.some(function(it){
        return !enSapItem[_catKeyItem(it.itemcode)];
      });
      if(algunoSigue) return false;
      return true;
    }
    if(f.tipo==='item'){
      var st=enSapItem[_catKeyItem(f.itemcode)];
      if(!st) return false;                 // no está en SAP: sigue igual
      if(st==='con_foto') return true;      // SAP ya tiene foto: fuera del todo
      // Está en SAP y sin foto: solo se guarda la imagen, si la hay
      if(f.foto){ soloFoto.push(f); return false; }
      return true;                          // sin foto que guardar: fuera
    }
    return false;
  });

  // Degradar las que solo aportan la foto
  var degradadas=0;
  for(var d=0; d<soloFoto.length; d++){
    try{
      var rd=await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+soloFoto[d].id,
        {method:'PATCH', headers:Object.assign({}, SBH, {'Content-Type':'application/json'}),
         body:JSON.stringify({tipo:'foto'})});
      if(rd.ok){ soloFoto[d].tipo='foto'; degradadas++; }
      else if(rd.status===400){
        // La columna 'tipo' de la tabla solo admite 'item' y 'proveedor'.
        // No es grave: el portal ya los oculta usando _catEnSap. Pero hasta
        // que se amplíe la restricción, la marca no queda guardada y hay que
        // recalcularla en cada carga.
        if(!window._catAvisoTipo){
          window._catAvisoTipo=1;
          console.warn('[catalogo_nosap] la tabla no acepta tipo="foto" (400). '
            +'Se ocultan igual, pero conviene ampliar la restricción de la columna '
            +'"tipo" para que la marca quede guardada. Ver catalogo_nosap_tipo_foto.sql');
        }
      }
      else console.warn('[catalogo_nosap] no se pudo degradar '+soloFoto[d].itemcode+': '+rd.status);
    }catch(e){ console.warn('degradar ficha:',e); }
  }
  if(degradadas){
    console.info('[catalogo_nosap] '+degradadas+' ficha(s) salen del catálogo pero conservan '
      +'la foto porque SAP todavía no tiene imagen → '
      +soloFoto.slice(0,10).map(function(f){return f.itemcode;}).join(', '));
  }
  window._catEsperandoFoto=soloFoto.map(function(f){ return f.itemcode; });
  // Qué códigos se sabe que YA están en SAP. La consulta de inventario lo usa
  // para no mostrar la fila NO SAP de un artículo que ya existe, sin depender
  // de que ese artículo haya entrado en la página que se cargó.
  window._catEnSap=enSapItem;

  if(!aBorrar.length && !degradadas) return 0;
  for(var i=0;i<aBorrar.length;i++){
    try{ await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+aBorrar[i].id,{method:'DELETE',headers:SBH}); }catch(e){}
  }
  var ids=aBorrar.map(function(f){ return f.id; });
  window._catNoSap=filas.filter(function(f){ return ids.indexOf(f.id)<0; });
  if(aBorrar.length) console.info('[catalogo_nosap] '+aBorrar.length+' ficha(s) ya están en SAP y se eliminaron');
  try{ _catNoSapBadge(); }catch(e){}
  return aBorrar.length+degradadas;
}

// ── ¿Existe ya en SAP? (consulta directa a inventario) ──
async function _catExisteEnSAP(campo, valor){
  var v=String(valor||'').trim();
  if(!v) return true;   // sin código, no se registra nada
  try{
    var r=await fetch(SB+'/rest/v1/inventario?select='+campo+'&'+campo+'=eq.'+encodeURIComponent(v)+'&limit=1',{headers:SBH});
    if(!r.ok) return false;
    var f=await r.json();
    return Array.isArray(f)&&f.length>0;
  }catch(e){ return false; }
}

// ── Busca un proveedor por NOMBRE (la orden NO SAP no guarda el código) ──
async function _catBuscarProvPorNombre(nombre){
  var n=String(nombre||'').trim();
  if(n.length<3) return null;
  // Primero en el catálogo que ya está en memoria
  var nn=_repNorm(n);
  var local=(_repProv||[]).find(function(p){ return _repNorm(p.cardname)===nn; })
         || (_repProv||[]).find(function(p){
              var pn=_repNorm(p.cardname);
              return pn && (pn.indexOf(nn)>=0 || nn.indexOf(pn)>=0);
            });
  if(local) return {cardcode:local.cardcode, cardname:local.cardname};
  // Si no, se consulta el inventario y el maestro de proveedores
  try{
    var url=SB+'/rest/v1/inventario?select=cardcode,nombre_proveedor'
      +'&nombre_proveedor=ilike.*'+encodeURIComponent(n)+'*&cardcode=not.is.null&limit=1';
    var r=await fetch(url,{headers:SBH});
    if(r.ok){
      var f=await r.json();
      if(Array.isArray(f)&&f.length) return {cardcode:f[0].cardcode, cardname:f[0].nombre_proveedor};
    }
  }catch(e){}
  // El maestro: un proveedor dado de alta en SAP sin artículos todavía no
  // aparece en el inventario, y se estaba creando ficha temporal por nada.
  try{
    var url2=SB+'/rest/v1/proveedores?select=cardcode,cardname'
      +'&cardname=ilike.*'+encodeURIComponent(n)+'*&cardcode=not.is.null&limit=1';
    var r2=await fetch(url2,{headers:SBH});
    if(r2.ok){
      var f2=await r2.json();
      if(Array.isArray(f2)&&f2.length) return {cardcode:f2[0].cardcode, cardname:f2[0].cardname};
    }
  }catch(e){}
  return null;
}

// ── Registra proveedor e items nuevos a partir de una orden NO SAP ──
// Devuelve {proveedor:0|1, items:N} con lo que se creó.
async function _catNoSapRegistrarDeOrden(o){
  var res={proveedor:0, items:0};
  if(!o) return res;
  var cardcode=String(o.cardcode||o.proveedor_codigo||'').trim();
  var cardname=String(o.proveedor||'').trim();
  var ref=String(o.dkc||o.num_orden||'').trim();
  var yaCat=window._catNoSap||[];

  // ── Proveedor ──
  // La orden NO SAP solo guarda el NOMBRE del proveedor, no su código. Así que
  // primero se busca por nombre en el inventario: si ya está en SAP se toma su
  // cardcode real y no se crea ficha temporal, solo se revisan sus SKUs.
  var provEnSAP=false;
  if(cardcode){
    provEnSAP=await _catExisteEnSAP('cardcode', cardcode);
  } else {
    var hallado=await _catBuscarProvPorNombre(cardname);
    if(hallado){ cardcode=hallado.cardcode; provEnSAP=true; }
    else { cardcode='TMP-'+cardname.toUpperCase().replace(/[^A-Z0-9]+/g,'').slice(0,12); }
  }
  if(!provEnSAP && cardname){
    var dupP=yaCat.some(function(f){ return f.tipo==='proveedor' && _catKeyProv(f.cardcode)===_catKeyProv(cardcode); });
    if(!dupP){
      var filaP={ tipo:'proveedor', cardcode:cardcode, cardname:cardname,
                  dept:o.dept||null, dkc_origen:ref||null,
                  creado_por:(CU&&CU.name)||'', creado_en:new Date().toISOString() };
      // Se pinta ya y después se confirma contra la base
      window._catNoSap.push(filaP); res.proveedor=1;
      try{ _catNoSapBadge(); }catch(e){}
      var rp=await fetch(SB+'/rest/v1/catalogo_nosap',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(filaP)});
      if(rp.ok){
        var cr=null; try{ cr=await rp.json(); }catch(e){}
        if(cr&&cr[0]){ var ix=window._catNoSap.indexOf(filaP); if(ix>=0) window._catNoSap[ix]=cr[0]; }
      } else {
        var ixe=window._catNoSap.indexOf(filaP); if(ixe>=0) window._catNoSap.splice(ixe,1);
        res.proveedor=0;
        var tp=await rp.text();
        console.warn('cat prov', rp.status, tp);
        res.error=_catNoSapExplicar(rp.status, tp);
      }
    }
  }

  // ── Items ──
  var items=(o.items||[]).filter(function(it){ return it && (it.itemcode||it.itemname); });
  // Se anota por qué se descarta cada artículo: antes se saltaban en
  // silencio y el proveedor quedaba sin ningún SKU sin explicación.
  var _descartes={sinCodigo:[], enSAP:[], repetidos:[]};
  var _soloFoto={};   // SKU que ya están en SAP y solo aportan la foto
  console.log('[nosap] artículos a registrar:', items.length,
              items.map(function(x){ return x.itemcode; }));

  for(var i=0;i<items.length;i++){
    var it=items[i];
    var code=String(it.itemcode||'').trim();
    if(!code){ _descartes.sinCodigo.push(it.itemname||'(sin nombre)'); continue; }
    // Estar en SAP NO basta para descartarlo. Si SAP no tiene la foto —o la
    // tiene declarada pero el archivo no está en el bucket— la única imagen
    // del artículo es la del Excel del proveedor, y hay que guardarla igual.
    // Así fue como se perdieron las 33 de la DKC-26084.
    var _enSap = it._enSAP || await _catExisteEnSAP('itemcode', code);
    if(_enSap){
      var _tieneFoto=false;
      try{ _tieneFoto=await _sapTieneFotoReal(code); }catch(e){ _tieneFoto=false; }
      if(_tieneFoto){ _descartes.enSAP.push(code); continue; }
      // Está en SAP pero sin foto usable: no entra al catálogo NO SAP, solo
      // se guarda la imagen (tipo 'foto') para que el artículo de SAP tenga
      // algo que mostrar hasta que le carguen la suya.
      _soloFoto[_catKeyItem(code)]=1;
      console.info('[catalogo_nosap] '+code+' ya está en SAP pero sin foto: '
        +'se guarda solo la imagen, no la ficha.');
    }
    var dupI=(window._catNoSap||[]).some(function(f){ return f.tipo==='item' && _catKeyItem(f.itemcode)===_catKeyItem(code); });
    if(dupI){ _descartes.repetidos.push(code); continue; }
    var filaI={ tipo:(_soloFoto[_catKeyItem(code)]?'foto':'item'), itemcode:code, itemname:it.itemname||'',
                cardcode:cardcode, cardname:cardname,
                cantidad:Number(it.cantidad)||0, precio:Number(it.precio_unit)||0,
                total_linea:Number(it.total_linea)||0, moneda:'USD',
                colores:it.colores||it.color||null,
                // La ficha técnica que leyó la AI, para armar el catálogo
                descripcion:it.descripcion||null, material:it.material||null,
                color:it.color||null, tamano:it.tamano||null,
                empaque:it.empaque||null, barcode:it.barcode||null,
                carton_size:it.carton_size||null, marca:it.marca||null,
                unidades_x_caja:Number(it.unidades_x_caja)||null,
                cartones_item:Number(it.cartones_item)||null,
                cbm:Number(it.cbm)||null,
                peso:(it.peso!=null&&it.peso!=='')?String(it.peso):null,
                // La foto que se sacó del Excel del proveedor
                foto:(await _catSubirFotoSku(code, cardcode, it)) || it.foto || null,
                dept:o.dept||null, dkc_origen:ref||null,
                creado_por:(CU&&CU.name)||'', creado_en:new Date().toISOString() };
    try{
      window._catNoSap.push(filaI); res.items++;
      try{ _catNoSapBadge(); }catch(e){}
      var ri=await fetch(SB+'/rest/v1/catalogo_nosap',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
        body:JSON.stringify(filaI)});
      if(ri.ok){
        var ci=null; try{ ci=await ri.json(); }catch(e){}
        if(ci&&ci[0]){ var ii=window._catNoSap.indexOf(filaI); if(ii>=0) window._catNoSap[ii]=ci[0]; }
      } else {
        var iie=window._catNoSap.indexOf(filaI); if(iie>=0) window._catNoSap.splice(iie,1);
        res.items--;
        var ti=await ri.text();
        console.warn('cat item', ri.status, ti);
        if(/foto/i.test(ti)){
          console.warn('[nosap] la columna "foto" rechazó el valor. '
            +'Si es varchar corto, cambiala a text en Supabase.');
        }
        res.error=_catNoSapExplicar(ri.status, ti);
      }
    }catch(e){ console.warn('cat item:',e); }
  }
  // El detalle de lo que no entró, para saber qué pasó
  try{
    var _d=_descartes||{sinCodigo:[],enSAP:[],repetidos:[]};
    var _tot=_d.sinCodigo.length+_d.enSAP.length+_d.repetidos.length;
    if(_tot){
      console.log('[nosap] artículos NO registrados: '+_tot, _d);
      var _partes=[];
      if(_d.enSAP.length)     _partes.push(_d.enSAP.length+' ya existen en SAP ('+_d.enSAP.slice(0,4).join(', ')+')');
      if(_d.repetidos.length) _partes.push(_d.repetidos.length+' ya estaban en la lista');
      if(_d.sinCodigo.length) _partes.push(_d.sinCodigo.length+' sin código');
      res.omitidos=_tot;
      res.motivo=_partes.join(' · ');
    }
  }catch(e){}
  try{ _catResumenFotos(); }catch(e){}
  return res;
}

// Cuántas fichas quedaron con foto, para saber si el catálogo va a servir
function _catResumenFotos(){
  var items=(window._catNoSap||[]).filter(_catFichaViva);
  var con=items.filter(function(f){ return !!(f.foto||f.foto_url); }).length;
  console.log('[nosap] catálogo: '+con+' de '+items.length+' artículo(s) con foto');
  if(con<items.length){
    console.log('[nosap] los que no tienen:',
      items.filter(function(f){ return !f.foto; }).map(function(f){ return f.itemcode; }));
  }
  return {con:con, total:items.length};
}

// Traduce el error de Supabase a algo entendible
function _catNoSapExplicar(status, texto){
  var t=String(texto||'');
  if(status===404 || /does not exist|Could not find the table/i.test(t))
    return 'La tabla catalogo_nosap no existe todavía en Supabase. Hay que crearla (script catalogo_nosap.sql).';
  if(status===401 || status===403 || /row-level security|permission denied/i.test(t))
    return 'La tabla existe pero no da permiso de escritura (RLS). Hay que habilitar el acceso.';
  if(status===400 && /column .* does not exist/i.test(t))
    return 'A la tabla le falta alguna columna. Volver a correr el script completo.';
  return 'Error '+status+' al escribir en catalogo_nosap: '+t.slice(0,140);
}

// Diagnóstico: dice exactamente qué pasa con la tabla
async function _catNoSapDiag(){
  var box=document.getElementById('cat-diag');
  function pinta(color, borde, fondo, msg){
    if(box) box.innerHTML='<div style="border:1px solid '+borde+';background:'+fondo+';color:'+color
      +';border-radius:8px;padding:9px 11px;font-size:11.5px;margin-bottom:10px">'+msg+'</div>';
  }
  pinta('var(--text-muted)','var(--border)','var(--surface-1)','<span class="ai-ring g" style="vertical-align:-2px"></span> Probando la tabla catalogo_nosap…');
  try{
    // Lectura
    var r=await fetch(SB+'/rest/v1/catalogo_nosap?select=id&limit=1',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      pinta('#991b1b','#dc2626','#FEF2F2','<b>No se puede leer.</b><br>'+_esc(_catNoSapExplicar(r.status,t)));
      return;
    }
    // Escritura: se inserta una fila de prueba y se borra
    var prueba={ tipo:'item', itemcode:'__TEST__'+Date.now(), itemname:'prueba de conexion',
                 cardcode:'__TEST__', cardname:'prueba', creado_por:'diagnostico',
                 creado_en:new Date().toISOString() };
    var w=await fetch(SB+'/rest/v1/catalogo_nosap',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(prueba)});
    if(!w.ok){
      var tw=await w.text();
      pinta('#991b1b','#dc2626','#FEF2F2','<b>Lee pero no puede escribir.</b><br>'+_esc(_catNoSapExplicar(w.status,tw)));
      return;
    }
    var creada=null; try{ creada=await w.json(); }catch(e){}
    var idp=(creada&&creada[0]&&creada[0].id)||null;
    if(idp){ try{ await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+idp,{method:'DELETE',headers:SBH}); }catch(e){} }
    pinta('#166534','#16a34a','#dcfce7','<b>Todo bien:</b> la tabla existe y acepta lectura y escritura. Si no se llenó, usa "Revisar órdenes existentes".');
  }catch(e){
    pinta('#991b1b','#dc2626','#FEF2F2','<b>Error de conexión:</b> '+_esc(e.message||String(e)));
  }
}

// Relleno retroactivo: recorre las órdenes NO SAP ya creadas y registra
// los proveedores y SKUs que falten. Sirve para las órdenes hechas antes
// de que existiera esta pantalla.
async function _catNoSapRellenar(){
  var ordenes=(window._pendSAP||[]);
  if(!ordenes.length){ showT('No hay órdenes NO SAP para revisar'); return; }
  var box=document.getElementById('cat-diag');
  if(box) box.innerHTML='<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
    +'<span class="ai-ring g" style="vertical-align:-2px"></span> Revisando '+ordenes.length+' orden(es) NO SAP…</div>';
  await _catNoSapCargar(true);
  var tp=0, ti=0, err='';
  for(var i=0;i<ordenes.length;i++){
    var o=ordenes[i];
    if(typeof o.items==='string'){ try{ o=Object.assign({},o,{items:JSON.parse(o.items)}); }catch(e){} }
    try{
      var r=await _catNoSapRegistrarDeOrden(o);
      tp+=r.proveedor; ti+=r.items;
      if(r.error) err=r.error;
    }catch(e){ console.warn('rellenar:',e); }
  }
  if(err){
    if(box) box.innerHTML='<div style="border:1px solid #dc2626;background:var(--pastel-error);color:var(--t-rojo);border-radius:8px;padding:9px 11px;font-size:11.5px;margin-bottom:10px"><b>No se pudo guardar.</b><br>'+_esc(err)+'</div>';
    return;
  }
  showT(tp||ti ? ('Agregados: '+tp+' proveedor(es) y '+ti+' SKU(s)') : 'Todo estaba ya registrado o ya existe en SAP');
  rCatNoSap();
}

// ── Items temporales de un proveedor (para pintarlos dentro de su ficha) ──
// Cuántas piezas de este SKU vienen en camino, sumando todas las órdenes NO
// SAP que lo llevan. Es el dato que le interesa al cliente en el catálogo de
// mercancía por llegar: no cuánto hay, sino cuánto va a haber.
function _catPorLlegar(sku){
  sku=String(sku||'').trim().toUpperCase();
  if(!sku) return 0;
  var t=0;
  (window._pendSAP||[]).forEach(function(p){
    var its=p.items;
    if(typeof its==='string'){ try{ its=JSON.parse(its); }catch(e){ its=[]; } }
    (Array.isArray(its)?its:[]).forEach(function(it){
      if(String(it.itemcode||'').trim().toUpperCase()===sku) t+=Number(it.cantidad)||0;
    });
  });
  return t;
}

// De dónde salen las fichas del catálogo. Normalmente del catálogo NO SAP,
// pero una orden de SAP arma las suyas al vuelo desde el inventario y las
// deja aquí, para poder usar la misma pantalla de revisión.
function _catFuenteFilas(){
  return (window._catFuente && window._catFuente.length)
    ? window._catFuente
    : (window._catNoSap||[]);
}

function _catItemsDeProveedor(cardcode){
  var k=_catKeyProv(cardcode);
  return (window._catNoSap||[]).filter(function(f){
    return f.tipo==='item' && _catKeyProv(f.cardcode)===k;
  });
}
function _catEsProveedorNuevo(cardcode){
  var k=_catKeyProv(cardcode);
  return (window._catNoSap||[]).some(function(f){
    return f.tipo==='proveedor' && _catKeyProv(f.cardcode)===k;
  });
}

// Completa el departamento de cada ficha del catálogo NO SAP
function _catCompletarDept(filas){
  // 1) El que ya trae la ficha
  filas.forEach(function(f){ f._dept=f.dept||f.departamento||''; });

  // 2) Si no lo trae, el de la orden NO SAP donde se usó ese código
  var porProv={}, porItem={};
  (window._pendSAP||[]).forEach(function(o){
    var d=o.dept||o.departamento||'';
    if(!d) return;
    var cc=String(o.cardcode||o.proveedor_codigo||'').trim().toUpperCase();
    if(cc && !porProv[cc]) porProv[cc]=d;
    var lns=o.lineas||o.items||[];
    if(Array.isArray(lns)) lns.forEach(function(l){
      var ic=String(l.itemcode||'').trim().toUpperCase();
      if(ic && !porItem[ic]) porItem[ic]=d;
    });
  });

  filas.forEach(function(f){
    if(f._dept) return;
    if(f.tipo==='proveedor'){
      var cc=String(f.cardcode||'').trim().toUpperCase();
      if(porProv[cc]) f._dept=porProv[cc];
    } else {
      var ic=String(f.itemcode||'').trim().toUpperCase();
      if(porItem[ic]) f._dept=porItem[ic];
    }
  });

  // 3) Los artículos heredan el departamento de su proveedor
  var deptProv={};
  filas.forEach(function(f){
    if(f.tipo==='proveedor' && f._dept) deptProv[_catKeyProv(f.cardcode)]=f._dept;
  });
  filas.forEach(function(f){
    if(!f._dept && f.tipo!=='proveedor' && f.cardcode){
      var k=_catKeyProv(f.cardcode);
      if(deptProv[k]) f._dept=deptProv[k];
    }
  });
}

// ═══════════════════════════════════════════════════════════════════════════
//  FOTOS DE LOS SKU NO SAP
//  Los Excel de los proveedores traen las fotos incrustadas. Un .xlsx es un
//  ZIP: las imágenes están en xl/media/ y la relación con cada fila en los
//  dibujos de la hoja. Se extraen para armar catálogos de mercancía que
//  todavía no existe en SAP.
// ═══════════════════════════════════════════════════════════════════════════
window._nsapFotos = window._nsapFotos || {};   // itemcode -> {b64, mime}

// Lee un .xlsx y devuelve las imágenes con la fila donde están ancladas
// Carga JSZip bajo demanda. El <script> de la cabecera puede no haber
// terminado, o fallar si no hay internet en ese momento.
function _cargarJSZip(){
  if(typeof JSZip!=='undefined') return Promise.resolve(true);
  if(window._jszipCargando) return window._jszipCargando;
  window._jszipCargando=new Promise(function(res,rej){
    var sc=document.createElement('script');
    sc.src='https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
    sc.onload=function(){ res(true); };
    sc.onerror=function(){ rej(new Error('no se pudo cargar JSZip')); };
    document.head.appendChild(sc);
    setTimeout(function(){ rej(new Error('JSZip tardó demasiado')); }, 15000);
  });
  return window._jszipCargando;
}

async function _nsapExtraerFotos(file){
  var ext=(file.name.split('.').pop()||'').toLowerCase();
  if(ext!=='xlsx'){
    console.log('[fotos] solo los .xlsx traen imágenes incrustadas');
    return [];
  }
  if(typeof JSZip==='undefined'){
    try{ await _cargarJSZip(); }catch(e){}
  }
  if(typeof JSZip==='undefined'){
    console.warn('[fotos] falta JSZip: no se pueden extraer las imágenes');
    return [];
  }
  try{
    var zip=await JSZip.loadAsync(await file.arrayBuffer());

    // 1) Las imágenes del archivo
    var medios={};
    var tareas=[];
    zip.forEach(function(ruta, f){
      if(!/^xl\/media\//i.test(ruta) || f.dir) return;
      tareas.push(f.async('base64').then(function(b64){
        var e=(ruta.split('.').pop()||'png').toLowerCase();
        medios[ruta.split('/').pop().toLowerCase()]={
          b64:b64,
          mime:(e==='jpg'||e==='jpeg')?'image/jpeg':(e==='gif'?'image/gif':'image/png')
        };
      }));
    });
    await Promise.all(tareas);
    if(!Object.keys(medios).length){
      console.log('[fotos] el Excel no trae imágenes');
      return [];
    }

    // 2) En qué fila está anclada cada una
    var dibujos=[];
    zip.forEach(function(ruta, f){
      if(/^xl\/drawings\/drawing\d+\.xml$/i.test(ruta) && !f.dir) dibujos.push(ruta);
    });

    var out=[];
    for(var i=0;i<dibujos.length;i++){
      var xml=await zip.file(dibujos[i]).async('string');
      // La relación de ese dibujo, para saber qué archivo es cada r:embed
      var relRuta=dibujos[i].replace(/drawings\/(drawing\d+\.xml)/i,'drawings/_rels/$1.rels');
      var rels={};
      var relFile=zip.file(relRuta);
      if(relFile){
        var relXml=await relFile.async('string');
        var re=/Id="([^"]+)"[^>]*Target="([^"]+)"/g, m;
        while((m=re.exec(relXml))) rels[m[1]]=m[2].split('/').pop().toLowerCase();
      }
      // Cada anclaje: la fila y la imagen
      var anclas=xml.split(/<xdr:(?:twoCellAnchor|oneCellAnchor)/);
      anclas.forEach(function(a){
        var mf=a.match(/<xdr:from>[\s\S]*?<xdr:col>(\d+)<\/xdr:col>[\s\S]*?<xdr:row>(\d+)<\/xdr:row>/);
        var mt=a.match(/<xdr:to>[\s\S]*?<xdr:row>(\d+)<\/xdr:row>/);
        var mi=a.match(/r:embed="([^"]+)"/);
        if(!mf || !mi) return;
        var arch=rels[mi[1]];
        if(!arch || !medios[arch]) return;
        var col=parseInt(mf[1],10);
        var desde=parseInt(mf[2],10);
        // Una foto puede abarcar varias filas: en ese caso vale para todos
        // los artículos que quedan debajo de ella.
        var hasta=mt?parseInt(mt[1],10):desde;
        out.push({fila:desde, hasta:Math.max(hasta,desde), col:col,
                  b64:medios[arch].b64, mime:medios[arch].mime});
      });
    }

    // Sin anclajes se devuelven en orden, que suele coincidir con las filas
    if(!out.length){
      Object.keys(medios).sort().forEach(function(k,i){
        out.push({fila:i+1, hasta:i+1, b64:medios[k].b64, mime:medios[k].mime});
      });
    }
    console.log('[fotos] '+out.length+' imagen(es) extraídas del Excel');
    return out;
  }catch(e){
    console.warn('[fotos] no se pudo leer el Excel:', e);
    return [];
  }
}

// Une cada foto con su SKU. Las fotos se anclan a una fila y una columna;
// los SKU están en su propia columna. Se empareja por FILA, que es lo que
// de verdad los relaciona: antes se buscaba el texto del SKU en la fila y
// fallaba porque la hoja tiene tres códigos distintos por artículo.
// ── Rescatar el código de KCC leyendo la hoja ──
// La IA se equivoca de columna con facilidad: en la PI de Delite tomó
// "Style no." —vacía en 15 de 18 filas— en vez de "KCC ITEM CODE". Esto no
// se arregla insistiendo en el prompt: se busca la columna cuyo encabezado
// lleva KCC y se leen los códigos de ahí, que es un dato exacto.
// Las filas se emparejan por código de barras, y si no lo hay, por importe
// y cantidad.
async function _nsapCorregirKcc(file, items){
  if(!items || !items.length) return 0;
  var filas=[];
  try{
    var wb=XLSX.read(await file.arrayBuffer(),{type:'array'});
    filas=XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]],
      {header:1, defval:'', blankrows:true});
  }catch(e){ console.warn('[kcc] no se pudo leer la hoja:', e); return 0; }

  // La fila de encabezados es la que tenga una celda con KCC
  var filaH=-1, colKcc=-1, colBar=-1, colCant=-1, colImp=-1;
  for(var r=0; r<Math.min(filas.length, 60); r++){
    var c=(filas[r]||[]).map(function(x){ return String(x==null?'':x).toUpperCase().replace(/\s+/g,' ').trim(); });
    var k=c.findIndex(function(t){ return t.indexOf('KCC')>=0; });
    if(k>=0){
      filaH=r; colKcc=k;
      colBar =c.findIndex(function(t){ return t.indexOf('BARCODE')>=0 || t.indexOf('UPC')>=0 || t.indexOf('EAN')>=0; });
      colCant=c.findIndex(function(t){ return t==='QTY' || t.indexOf('QTY')>=0 || t.indexOf('CANT')>=0; });
      colImp =c.findIndex(function(t){ return t.indexOf('AMOUNT')>=0 || t.indexOf('TOTAL AMOUNT')>=0 || t.indexOf('IMPORTE')>=0; });
      break;
    }
  }
  if(filaH<0){ console.log('[kcc] la hoja no tiene ninguna columna con KCC'); return 0; }
  console.log('[kcc] encabezado en la fila '+(filaH+1)+' · columna KCC: "'
    +String((filas[filaH]||[])[colKcc]||'').trim()+'"');

  // Las filas con código, en orden
  var datos=[];
  for(var r2=filaH+1; r2<filas.length; r2++){
    var f=filas[r2]||[];
    var cod=String(f[colKcc]==null?'':f[colKcc]).trim();
    if(!cod || cod.length<3) continue;
    if(/^(TOTAL|GRAND TOTAL|SUBTOTAL)/i.test(cod)) continue;
    datos.push({
      cod:cod,
      bar:colBar>=0?String(f[colBar]==null?'':f[colBar]).replace(/\D/g,''):'',
      cant:colCant>=0?(parseFloat(String(f[colCant]).replace(/[^0-9.\-]/g,''))||0):0,
      imp: colImp>=0?(parseFloat(String(f[colImp]).replace(/[^0-9.\-]/g,''))||0):0
    });
  }
  if(!datos.length){ console.log('[kcc] la columna KCC no tiene valores'); return 0; }

  var usados={}, arreglados=0;
  function tomar(i){ usados[i]=1; return datos[i].cod; }

  items.forEach(function(it, n){
    var barIt=String(it.barcode||'').replace(/\D/g,'');
    var cantIt=Number(it.cantidad)||0;
    var impIt=Number(it.total_linea)||0;
    var idx=-1;
    // 1) por código de barras, que es único
    if(barIt) idx=datos.findIndex(function(d,i){ return !usados[i] && d.bar && d.bar===barIt; });
    // 2) por importe y cantidad
    if(idx<0 && impIt) idx=datos.findIndex(function(d,i){
      return !usados[i] && Math.abs(d.imp-impIt)<0.02 && (!cantIt || d.cant===cantIt); });
    // 3) por posición, si la cuenta de líneas coincide
    if(idx<0 && datos.length===items.length && !usados[n]) idx=n;
    if(idx<0) return;
    var bueno=tomar(idx);
    var antes=String(it.itemcode||it.itemcode_kcc||'').trim();
    if(antes.toUpperCase()!==bueno.toUpperCase()){
      it.itemcode=bueno;
      it.itemcode_kcc=bueno;
      arreglados++;
      if(arreglados<=6) console.log('[kcc] línea '+(n+1)+': "'+(antes||'(vacío)')+'" → "'+bueno+'"');
    }
  });
  if(arreglados) console.log('[kcc] '+arreglados+' de '+items.length+' código(s) corregidos desde la hoja');
  else console.log('[kcc] los códigos de la IA ya coincidían con la hoja');
  return arreglados;
}

// El parámetro "estricto" es para el catálogo: ahí una foto equivocada se
// ve al momento y va al cliente. En ese modo NO se empareja por descripción
// (dos alfombras "ALFOMBRA DE ENTRADA" caerían en la misma fila), NO se
// rellena por cercanía y NO se reparte una imagen entre varios SKU salvo
// que de verdad ocupe varias filas.
async function _nsapFotosPorSku(file, items, opciones){
  var estricto = !!(opciones && opciones.estricto);
  var fotos=await _nsapExtraerFotos(file);
  window._nsapFotosDiag={jszip:(typeof JSZip!=='undefined'), imagenes:fotos.length,
                         articulos:(items||[]).length, ubicados:0};
  if(!fotos.length){ console.log('[fotos] el Excel no trae imágenes'); return {}; }
  if(!items || !items.length){ console.log('[fotos] no hay artículos que emparejar'); return {}; }

  var filas=[], merges=[];
  try{
    var wb=XLSX.read(await file.arrayBuffer(),{type:'array'});
    var hoja=wb.Sheets[wb.SheetNames[0]];
    filas=XLSX.utils.sheet_to_json(hoja,{header:1, defval:'', blankrows:true});
    merges=hoja['!merges']||[];
  }catch(e){ console.warn('[fotos] no se pudo leer la hoja:', e); return {}; }

  // Cuando varias referencias comparten foto, el proveedor suele COMBINAR las
  // celdas de esa columna. El dibujo entonces se ancla a una sola fila y el
  // rango del propio dibujo no dice nada. Se mira la celda combinada: si la
  // foto cae dentro de una, su alcance son todas las filas de esa combinación.
  var ampliadas=0;
  fotos.forEach(function(f){
    for(var m=0;m<merges.length;m++){
      var mg=merges[m];
      var dentroFila = f.fila>=mg.s.r && f.fila<=mg.e.r;
      var dentroCol  = (f.col==null) || (f.col>=mg.s.c && f.col<=mg.e.c);
      if(dentroFila && dentroCol && mg.e.r>mg.s.r){
        if(mg.s.r<f.fila) f.fila=mg.s.r;
        if(mg.e.r>(f.hasta||f.fila)){ f.hasta=mg.e.r; ampliadas++; }
        break;
      }
    }
  });
  if(ampliadas){
    console.log('[fotos] '+ampliadas+' imagen(es) están en celdas combinadas: '
      +'se reparten entre todos los artículos de esas filas');
  }

  // La fila donde está cada artículo: se busca su código en CUALQUIER celda,
  // porque la AI puede haber tomado el código de fábrica, el de KCC o el
  // código de barras.
  var filaDe={};
  items.forEach(function(it){
    var sku=String(it.itemcode||'').trim().toUpperCase();
    if(!sku) return;
    var nom=String(it.itemname||'').trim().toUpperCase().slice(0,18);
    for(var r=0;r<filas.length;r++){
      var celdas=(filas[r]||[]).map(function(c){ return String(c==null?'':c).trim().toUpperCase(); });
      var hay=celdas.some(function(c){
        if(!c) return false;
        if(c===sku) return true;
        // El código puede venir con espacios o saltos, como "P55762\n  4x6"
        return c.replace(/\s+/g,'')===sku.replace(/\s+/g,'');
      });
      // Si no aparece el código, se intenta por la descripción. En modo
      // estricto no: descripciones repetidas dan filas equivocadas.
      if(!hay && !estricto && nom.length>8){
        hay=celdas.some(function(c){ return c.length>8 && c.indexOf(nom)>=0; });
      }
      if(hay){ filaDe[sku]=r; break; }
    }
  });

  var ubicados=Object.keys(filaDe).length;
  window._nsapFotosDiag={
    jszip:(typeof JSZip!=='undefined'),
    imagenes:fotos.length,
    articulos:items.length,
    ubicados:ubicados
  };
  console.log('[fotos] '+fotos.length+' imagen(es) · '+ubicados+' de '+items.length
    +' artículo(s) ubicados en la hoja');
  console.log('[fotos] filas de las imágenes:', fotos.map(function(f){ return f.fila; }));
  console.log('[fotos] filas de los artículos:', filaDe);

  var mapa={}, usadas={};

  // 1) Emparejado por rango: una foto puede abarcar varias filas y entonces
  //    vale para todos los artículos que quedan dentro. Es lo que pasa cuando
  //    varias referencias comparten la misma imagen.
  Object.keys(filaDe).forEach(function(sku){
    var fila=filaDe[sku];
    // La foto cuyo rango CONTIENE esta fila
    for(var k=0;k<fotos.length;k++){
      var f=fotos[k];
      if(fila>=f.fila && fila<=(f.hasta||f.fila)){
        // En estricto, una imagen anclada a UNA fila vale para UN artículo:
        // si ya se usó, no se repite. Así no salen fotos duplicadas.
        if(estricto && usadas[k] && (f.hasta||f.fila)===f.fila) continue;
        mapa[sku]=f;
        usadas[k]=1;                       // usada, pero puede repetirse
        if((f.hasta||f.fila)>f.fila){
          console.log('[fotos] '+sku+' comparte la foto de las filas '
            +f.fila+'-'+f.hasta);
        }
        return;
      }
    }
  });

  // 1c) Si un artículo sigue sin foto y el de la fila anterior sí tiene una
  //     que abarca varias filas, la comparte. Cubre el caso de la combinación
  //     que XLSX no llegó a leer.
  var ordenados=Object.keys(filaDe).sort(function(a,b){ return filaDe[a]-filaDe[b]; });
  for(var q=1;q<ordenados.length;q++){
    var actual=ordenados[q], previo=ordenados[q-1];
    if(mapa[actual] || !mapa[previo]) continue;
    var fp=mapa[previo];
    // Solo si la del anterior llega hasta esta fila o justo antes
    if((fp.hasta||fp.fila) >= filaDe[actual]-1 && (fp.hasta||fp.fila) > fp.fila){
      mapa[actual]=fp;
      console.log('[fotos] '+actual+' comparte la foto de '+previo);
    }
  }

  // 1b) Los que quedaron sin foto: la más cercana, a lo sumo una fila
  if(!estricto) Object.keys(filaDe).forEach(function(sku){
    if(mapa[sku]) return;
    var fila=filaDe[sku], mejor=null, dist=99, idx=-1;
    fotos.forEach(function(f,k){
      if(usadas[k]) return;
      var d=Math.min(Math.abs(f.fila-fila), Math.abs((f.hasta||f.fila)-fila));
      if(d<dist){ dist=d; mejor=f; idx=k; }
    });
    if(mejor && dist<=1){ mapa[sku]=mejor; usadas[idx]=1; }
  });

  // 2) Lo que quedó sin foto, solo si las imágenes libres caen DENTRO del
  //    rango de filas de los artículos. Fuera de ese rango están el logo
  //    del proveedor y las firmas, que no son fotos de producto.
  var filasArt=Object.keys(filaDe).map(function(k){ return filaDe[k]; });
  if(filasArt.length && !estricto){
    var minF=Math.min.apply(null, filasArt)-1;
    var maxF=Math.max.apply(null, filasArt)+1;
    var sinFoto=items.filter(function(it){
      var k=String(it.itemcode||'').trim().toUpperCase();
      return k && !mapa[k];
    });
    var libres=[];
    fotos.forEach(function(f,k){
      if(usadas[k]) return;
      if((f.hasta||f.fila)<minF || f.fila>maxF) return;    // logo o firma
      libres.push(f);
    });
    if(sinFoto.length && libres.length){
      libres.sort(function(a,b){ return a.fila-b.fila; });
      var n=Math.min(sinFoto.length, libres.length);
      for(var q=0;q<n;q++){
        var sku=String(sinFoto[q].itemcode||'').trim().toUpperCase();
        mapa[sku]=libres[q];
      }
      console.log('[fotos] '+n+' emparejada(s) por cercanía');
    }
    var descartadas=fotos.filter(function(f,k){
      return !usadas[k] && ((f.hasta||f.fila)<minF || f.fila>maxF);
    }).length;
    if(descartadas){
      console.log('[fotos] '+descartadas+' imagen(es) descartadas: están fuera de la tabla '
        +'(logo del proveedor, firmas, etc.)');
    }
  }

  console.log('[fotos] resultado: '+Object.keys(mapa).length+' SKU con foto');
  return mapa;
}

// Sube las fotos al storage y las deja guardadas en el catálogo NO SAP
async function _nsapGuardarFotos(mapa, cardcode){
  var skus=Object.keys(mapa||{});
  if(!skus.length) return 0;
  var n=0;
  for(var i=0;i<skus.length;i++){
    var sku=skus[i], f=mapa[sku];
    try{
      var ext=(f.mime==='image/jpeg')?'jpg':(f.mime==='image/gif'?'gif':'png');
      var nombre='nosap/'+String(cardcode||'sin-prov').replace(/[^\w-]/g,'')+'/'
        +sku.replace(/[^\w.-]/g,'_')+'.'+ext;
      // El base64 pasa a binario para subirlo
      var bin=atob(f.b64), arr=new Uint8Array(bin.length);
      for(var j=0;j<bin.length;j++) arr[j]=bin.charCodeAt(j);
      var r=await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+nombre,{
        method:'POST',
        headers:{'apikey':KEY,'Authorization':'Bearer '+KEY,'Content-Type':f.mime,'x-upsert':'true'},
        body:arr});
      if(!r.ok && r.status!==409){ console.warn('[fotos] no se subió '+sku, r.status); continue; }
      var url=DOCS_BASE+nombre.split('/').map(encodeURIComponent).join('/');
      window._nsapFotos[sku]={url:url, mime:f.mime};
      // Y en la ficha del catálogo, para que quede después de recargar
      try{
        await fetch(SB+'/rest/v1/catalogo_nosap?itemcode=eq.'+encodeURIComponent(sku),{
          method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify({foto_url:url})});
      }catch(e){}
      n++;
    }catch(e){ console.warn('[fotos] '+sku+':', e); }
  }
  console.log('[fotos] '+n+' foto(s) guardadas');
  return n;
}

// ═══════════════════════════════════════════════════════════════════════════
//  CATÁLOGO DE MERCANCÍA POR LLEGAR
//  Arma un catálogo con los SKU que todavía no están en SAP, usando las
//  fotos que la AI extrajo del Excel del proveedor.
// ═══════════════════════════════════════════════════════════════════════════
window._catSel = window._catSel || {};     // itemcode -> true si está elegido

// Botón para armar el catálogo de un solo proveedor
// ═══════════════════════════════════════════════════════════════════════════
//  EDITOR DEL CATÁLOGO
//  Antes de generar se revisa cada artículo: precio de venta y los datos de
//  la ficha que falten. El catálogo va al cliente, así que conviene que
//  esté completo.
// ═══════════════════════════════════════════════════════════════════════════
window._catEdit = window._catEdit || {};     // itemcode -> {precio, material, ...}

var _CAT_CAMPOS = [
  {k:'descripcion',     t:'Descripción'},
  {k:'material',        t:'Composición'},
  {k:'color',           t:'Color'},
  {k:'tamano',          t:'Medida'},
  {k:'unidades_x_caja', t:'Pzs/caja'},
  {k:'carton_size',     t:'Medida caja'},
  {k:'peso',            t:'Peso'},
  {k:'barcode',         t:'Código barras'},
  {k:'marca',           t:'Marca'},
  // Lo que viene en camino de esa referencia: al cliente le importa saber
  // si hay reposición y cuándo. Se puede editar antes de generar.
  {k:'por_llegar',      t:'Por llegar'},
  // Cuándo llega: junto a la cantidad, al cliente le dice si esperar
  {k:'eta',             t:'ETA'}
];

// Lo que se va a usar: lo editado manda sobre lo guardado
function _catValor(f, campo){
  // Las fichas armadas desde el inventario traen sus datos ya resueltos y no
  // deben mezclarse con lo que se editó a mano en el catálogo NO SAP.
  if(f && f.__sinEdit) return f[campo]||'';
  var sku=String(f.itemcode||'').toUpperCase();
  var e=window._catEdit[sku]||{};
  if(e[campo]!=null && String(e[campo]).trim()!=='') return e[campo];
  return f[campo]||'';
}

// ═══════════════════════════════════════════════════════════════════════════
//  LEER LA FICHA DEL EXCEL
//  Los SKU creados antes de que la AI leyera la ficha quedaron sin datos.
//  Con esto se vuelve a leer el Excel original y se completan, emparejando
//  por código. No depende de la AI: se leen las columnas directamente.
// ═══════════════════════════════════════════════════════════════════════════

// Cómo se llama cada columna en los documentos de los proveedores.
// Se compara sin acentos ni signos, así que "MATERIAL, Construction
// Composition %" encuentra "material".
var _CAT_COLS = [
  {campo:'barcode',         claves:['barcode','codigo de barras','upc','ean','cod barras']},
  {campo:'descripcion',     claves:['product description','description','descripcion & package','product desc']},
  {campo:'itemname',        claves:['spanish name','nombre en espanol','descripcion en espanol','nombre']},
  {campo:'tamano',          claves:['item size','size','dimension','medida del producto','capacity']},
  {campo:'color',           claves:['color','colour','finishing']},
  {campo:'material',        claves:['material','composition','composicion','construction']},
  {campo:'unidades_x_caja', claves:['qty x ctn','pcs per carton','pcs x ctn','packing','unidades por caja','pzs x caja']},
  {campo:'carton_size',     claves:['carton size','medida de caja','box size','ctn size']},
  {campo:'cartones_item',   claves:['ttl ctns','total ctns','cartones','ctns']},
  {campo:'cbm',             claves:['cbm x ctn','cbm']},
  {campo:'peso',            claves:['n.w','g.w','weight','peso','kgs']},
  {campo:'marca',           claves:['brand','marca']}
];

function _catNorm(t){
  return String(t||'').toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
}

// Encuentra la fila de cabecera y a qué campo va cada columna
function _catMapearColumnas(filas){
  var mejor={fila:-1, mapa:{}, aciertos:0};
  for(var r=0; r<Math.min(filas.length, 40); r++){
    var mapa={}, aciertos=0;
    (filas[r]||[]).forEach(function(celda, c){
      var t=_catNorm(celda);
      if(t.length<2) return;
      for(var i=0;i<_CAT_COLS.length;i++){
        var def=_CAT_COLS[i];
        if(mapa[def.campo]!=null) continue;
        for(var j=0;j<def.claves.length;j++){
          if(t.indexOf(def.claves[j])>=0){ mapa[def.campo]=c; aciertos++; return; }
        }
      }
    });
    if(aciertos>mejor.aciertos) mejor={fila:r, mapa:mapa, aciertos:aciertos};
  }
  return mejor;
}

// Lee el Excel y devuelve la ficha de cada código encontrado
async function _catFichaDelExcel(file){
  var filas=[];
  try{
    var wb=XLSX.read(await file.arrayBuffer(),{type:'array'});
    var hoja=wb.Sheets[wb.SheetNames[0]];
    filas=XLSX.utils.sheet_to_json(hoja,{header:1, defval:'', blankrows:true});
  }catch(e){
    console.warn('[ficha] no se pudo leer el Excel:', e);
    return {};
  }

  var det=_catMapearColumnas(filas);
  console.log('[ficha] cabecera en la fila '+det.fila+' · '+det.aciertos+' columna(s) reconocidas:', det.mapa);
  if(det.aciertos<2){
    console.warn('[ficha] no se reconocieron suficientes columnas');
    return {};
  }

  // Los códigos posibles de cada fila, para emparejar con los SKU
  var out={};
  for(var r=det.fila+1; r<filas.length; r++){
    var fila=filas[r]||[];
    var ficha={};
    Object.keys(det.mapa).forEach(function(campo){
      var v=fila[det.mapa[campo]];
      if(v==null || String(v).trim()==='') return;
      var t=String(v).trim();
      // Las fórmulas del Excel no sirven
      if(t.charAt(0)==='=') return;
      if(campo==='unidades_x_caja' || campo==='cartones_item' || campo==='cbm'){
        var n=parseFloat(String(t).replace(/,/g,''));
        if(!isNaN(n)) ficha[campo]=n;
      } else {
        ficha[campo]=t;
      }
    });
    if(!Object.keys(ficha).length) continue;

    // Se guarda bajo TODOS los códigos de esa fila: no se sabe cuál usó la orden
    fila.forEach(function(celda){
      var t=String(celda==null?'':celda).trim().toUpperCase();
      if(t.length<4 || t.length>24) return;
      if(!/[0-9]/.test(t)) return;
      var k=t.replace(/\s+/g,'');
      if(!out[k]) out[k]=ficha;
    });
  }
  console.log('[ficha] '+Object.keys(out).length+' código(s) con datos');
  return out;
}

// Pide el Excel y completa la ficha de los artículos elegidos
// Completa la ficha desde el Excel que YA está guardado con la orden.
// No hay que volver a subirlo: el documento quedó en la orden al crearla.
// ── Las fotos que faltan, del Excel adjunto a la orden ──
// Cuando SAP no tiene imagen, casi siempre sí la tiene el Excel que se
// adjuntó en la etapa de Pedido: la PI del proveedor o nuestra orden
// llevan la foto pegada al lado del SKU. Se busca sola, sin pedirle nada
// al usuario; solo si tampoco está ahí se ofrece adjuntarla a mano.
async function _catAutoFotos(filas){
  var sinFoto=(filas||[]).filter(function(f){ return !String(f.foto||'').trim(); });
  if(!sinFoto.length) return 0;

  var ordenes={};
  sinFoto.forEach(function(f){ if(f.dkc_origen) ordenes[f.dkc_origen]=1; });
  var refs=Object.keys(ordenes);
  if(!refs.length){
    console.log('[fotos] los artículos sin imagen no tienen orden de origen');
    return 0;
  }

  try{ await _cargarJSZip(); }catch(e){}
  var puestas=0;

  for(var i=0;i<refs.length;i++){
    var ref=refs[i];
    var docs=[];
    try{
      var r=await fetch(SB+'/rest/v1/compras_documentos?select=url,nombre_archivo,tipo'
        +'&docnum=eq.'+encodeURIComponent(ref)+'&limit=60',{headers:SBH});
      if(r.ok) docs=await r.json()||[];
    }catch(e){ console.warn('[fotos] documentos de '+ref+':', e); }

    var xls=docs.filter(function(d){
      var n=String(d.nombre_archivo||d.url||'');
      return /\.(xlsx|xls|xlsm)$/i.test(n) || /^xlsx?$/i.test(String(d.tipo||''));
    });
    // Y lo que esté en la sesión, si la orden se acaba de crear
    try{
      var enMem=(window._atts&&window._atts[ref+'pedido'])||[];
      enMem.forEach(function(a){
        if(/\.(xlsx|xls|xlsm)$/i.test(String(a.name||'')) && a.url){
          xls.push({url:a.url, nombre_archivo:a.name});
        }
      });
    }catch(e){}

    if(!xls.length){
      console.log('[fotos] la orden '+ref+' no tiene Excel adjunto');
      continue;
    }

    for(var k=0;k<xls.length && sinFoto.some(function(f){ return !f.foto; });k++){
      try{
        var url=DOCS_BASE+String(xls[k].url).split('/').map(encodeURIComponent).join('/');
        var resp=await fetch(url);
        if(!resp.ok){ console.warn('[fotos] no se pudo bajar '+xls[k].nombre_archivo); continue; }
        var blob=await resp.blob();
        var file=new File([blob], xls[k].nombre_archivo||'orden.xlsx');

        var delaOrden=sinFoto.filter(function(f){ return String(f.dkc_origen||'')===ref; });
        var mapa=await _nsapFotosPorSku(file, delaOrden.map(function(x){
          return {itemcode:x.itemcode, itemname:x.itemname,
                  barcode:x.barcode, cantidad:x.por_llegar||0}; }),
          {estricto:true});

        Object.keys(mapa||{}).forEach(function(sku){
          var d=mapa[sku];
          if(!d || !d.b64) return;
          var ficha=delaOrden.find(function(x){
            return String(x.itemcode||'').toUpperCase()===String(sku).toUpperCase(); });
          if(ficha && !String(ficha.foto||'').trim()){
            ficha.foto='data:'+(d.mime||'image/jpeg')+';base64,'+d.b64;
            ficha.__fotoOk=1;
            puestas++;
          }
        });
        console.log('[fotos] '+xls[k].nombre_archivo+': '
          +Object.keys(mapa||{}).length+' SKU con imagen');
      }catch(e){ console.warn('[fotos] '+ref+':', e); }
    }
  }

  var quedan=sinFoto.filter(function(f){ return !String(f.foto||'').trim(); }).length;
  if(puestas) console.log('[fotos] '+puestas+' imagen(es) sacadas del Excel de la orden');
  if(quedan)  console.log('[fotos] '+quedan+' artículo(s) siguen sin imagen');
  return puestas;
}

async function _catAutoFicha(filas){
  // Los artículos a los que les falta algo
  var faltos=filas.filter(function(f){
    return !f.material && !f.color && !f.tamano && !f.barcode;
  });
  if(!faltos.length) return 0;

  // Las órdenes de donde vinieron esos artículos
  var ordenes={};
  faltos.forEach(function(f){ if(f.dkc_origen) ordenes[f.dkc_origen]=1; });
  var refs=Object.keys(ordenes);
  if(!refs.length){
    console.log('[ficha] los artículos sin datos no tienen orden de origen');
    return 0;
  }

  var puestos=0;
  for(var i=0;i<refs.length;i++){
    var ref=refs[i];
    // El Excel adjunto de esa orden
    var docs=[];
    try{
      // La columna es nombre_archivo, no nombre: por eso no encontraba nada
      var r=await fetch(SB+'/rest/v1/compras_documentos?select=url,nombre_archivo,tipo'
        +'&docnum=eq.'+encodeURIComponent(ref)+'&limit=60',{headers:SBH});
      if(r.ok) docs=await r.json()||[];
      console.log('[ficha] orden '+ref+': '+docs.length+' documento(s)',
        docs.map(function(d){ return d.nombre_archivo; }));
    }catch(e){ console.warn('[ficha] documentos de '+ref+':', e); }

    var xls=docs.filter(function(d){
      var n=String(d.nombre_archivo||d.url||'');
      return /\.(xlsx|xls)$/i.test(n) || /^xlsx?$/i.test(String(d.tipo||''));
    });
    if(!xls.length){
      console.log('[ficha] la orden '+ref+' no tiene Excel adjunto');
      // Puede estar en la memoria de la sesión, si la orden se creó recién
      try{
        var enMem=(window._atts&&window._atts[ref+'pedido'])||[];
        enMem.forEach(function(a){
          if(/\.(xlsx|xls)$/i.test(String(a.name||'')) && a.url){
            xls.push({url:a.url, nombre_archivo:a.name});
          }
        });
        if(xls.length) console.log('[ficha] encontrado en la sesión: '+xls[0].nombre_archivo);
      }catch(e){}
      if(!xls.length) continue;
    }

    for(var k=0;k<xls.length;k++){
      try{
        var url=DOCS_BASE+String(xls[k].url).split('/').map(encodeURIComponent).join('/');
        var resp=await fetch(url);
        if(!resp.ok) continue;
        var blob=await resp.blob();
        var file=new File([blob], xls[k].nombre_archivo||'orden.xlsx');
        var fichas=await _catFichaDelExcel(file);
        if(!Object.keys(fichas).length){
          console.log('[ficha] '+file.name+': no se reconocieron columnas');
          continue;
        }

        faltos.forEach(function(f){
          if(String(f.dkc_origen||'')!==ref) return;
          var sku=String(f.itemcode||'').trim().toUpperCase().replace(/\s+/g,'');
          var ficha=fichas[sku];
          if(!ficha) return;
          var algo=false;
          Object.keys(ficha).forEach(function(c){
            if(f[c]!=null && String(f[c]).trim()!=='') return;
            _catEditSet(sku, c, ficha[c]);
            algo=true;
          });
          if(algo) puestos++;
        });
      }catch(e){ console.warn('[ficha] '+ref+':', e); }
    }
  }
  if(puestos) console.log('[ficha] '+puestos+' artículo(s) completados desde el Excel de la orden');
  return puestos;
}

function _catLeerFichaExcel(){
  var inp=document.createElement('input');
  inp.type='file';
  inp.accept='.xlsx,.xls,.csv';
  inp.onchange=async function(){
    var f=inp.files && inp.files[0];
    if(!f) return;
    showT('Leyendo el archivo…');
    var fichas=await _catFichaDelExcel(f);
    var n=Object.keys(fichas).length;
    if(!n){
      showT('No se reconocieron las columnas del archivo', 6000);
      return;
    }

    var filas=(window._catNoSap||[]).filter(function(x){
      return x.tipo!=='proveedor' && window._catSel[String(x.itemcode||'').toUpperCase()];
    });
    var puestos=0, campos=0;
    filas.forEach(function(x){
      var sku=String(x.itemcode||'').trim().toUpperCase().replace(/\s+/g,'');
      var ficha=fichas[sku];
      // Si no está por el código KCC, se prueba por el del proveedor
      if(!ficha && x.itemcode_proveedor){
        ficha=fichas[String(x.itemcode_proveedor).trim().toUpperCase().replace(/\s+/g,'')];
      }
      if(!ficha) return;
      var algo=false;
      Object.keys(ficha).forEach(function(k){
        // No se pisa lo que ya tiene valor
        if(x[k]!=null && String(x[k]).trim()!=='') return;
        _catEditSet(sku, k, ficha[k]);
        campos++; algo=true;
      });
      if(algo) puestos++;
    });

    showT(puestos
      ? ('✓ '+puestos+' artículo(s) completados · '+campos+' dato(s)')
      : 'No se encontró ninguno de los códigos en ese archivo', 6000);
    if(puestos) _catRevisarAbrir(true);
  };
  inp.click();
}

async function _catRevisarAbrir(saltarAuto){
  var skus=Object.keys(window._catSel||{});
  if(!skus.length){ showT('Elige al menos un artículo'); return; }
  var filas=_catFuenteFilas().filter(function(f){
    return f.tipo!=='proveedor' && window._catSel[String(f.itemcode||'').toUpperCase()];
  });
  if(!filas.length){ showT('No se encontraron los artículos'); return; }

  // Lo que falte se completa solo con el Excel que ya está en la orden
  if(!saltarAuto){
    var faltan=filas.filter(function(f){
      return !_catValor(f,'material') && !_catValor(f,'color') && !_catValor(f,'tamano');
    }).length;
    if(faltan){
      showT('Completando la ficha desde la orden…');
      try{
        var n=await _catAutoFicha(filas);
        if(n) showT('✓ '+n+' artículo(s) completados desde el documento de la orden');
      }catch(e){ console.warn('[ficha] auto:', e); }
    }
  }

  // Se cierra el selector: si no, quedan dos ventanas encimadas
  var sel=document.getElementById('modalCatalogo'); if(sel) sel.remove();
  var prev=document.getElementById('modalCatRev'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCatRev';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10003;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:16px;overflow-y:auto';

  var sinPrecio=filas.filter(function(f){ return !Number(_catValor(f,'precio_venta')); }).length;
  var sinFicha=filas.filter(function(f){
    return !_catValor(f,'material') && !_catValor(f,'color') && !_catValor(f,'tamano');
  }).length;

  var h='<div style="background:var(--surface-2);border-radius:14px;padding:16px;'
    +'width:100%;max-width:1180px;max-height:94vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-marron)">'
        +'<i class="ti ti-list-check"></i> Revisar antes de generar</div>'
      +'<button onclick="_catRevCerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
      +'Este catálogo va al cliente. Completá lo que falte y poné el precio de venta.</div>';

  // Cuántos van a salir sin imagen en el catálogo
  var sinFoto=filas.filter(function(f){
    return !String(f.foto||'').trim(); }).length;

  if(sinPrecio || sinFicha || sinFoto){
    h+='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;'
      +'padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--t-marron)">'
      +'<i class="ti ti-alert-circle"></i> '
      +[sinPrecio?(sinPrecio+' sin precio de venta'):'',
        sinFicha?(sinFicha+' sin datos de ficha'):'',
        sinFoto?('<b>'+sinFoto+' sin foto</b>'):''].filter(Boolean).join(' · ')
      +'</div>';
  }

  // El botón va SIEMPRE, tenga o no avisos: sirve también para actualizar
  // fotos y datos que ya estén puestos.
  h+='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin-bottom:10px">'
    +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" '
    +'onclick="_catFotosDesdeDoc()">'
    +'<i class="ti ti-photo-plus"></i> Completar o actualizar desde un Excel</button>'
    +'<span style="font-size:10.5px;color:var(--text-muted)">Adjunta el Excel del '
    +'proveedor: saca las fotos y los datos, emparejando por SKU.</span></div>';

  // Herramientas para llenar rápido
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:10px;align-items:center">'
    +'<span style="font-size:11px;color:var(--text-muted);font-weight:600">Rellenar todos</span>'
    +'<input id="catMasivoCampo" list="catCamposLst" placeholder="Campo" '
      +'style="width:120px;padding:5px 8px;border:0.5px solid var(--border);border-radius:7px;font-size:11.5px">'
    +'<datalist id="catCamposLst">'
      +_CAT_CAMPOS.map(function(c){ return '<option value="'+c.t+'">'; }).join('')
      +'<option value="Precio venta"></datalist>'
    +'<input id="catMasivoValor" placeholder="Valor para todos" '
      +'style="flex:1;min-width:150px;padding:5px 8px;border:0.5px solid var(--border);border-radius:7px;font-size:11.5px">'
    +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catMasivo()">Aplicar</button>'
    +'<span style="flex:1"></span>'
    +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catMargen()">'
      +'<i class="ti ti-percentage"></i> Precio por margen</button>'
    +(sinFicha
      ? ('<button class="btn bg2" style="font-size:11px;padding:5px 11px" '
         +'onclick="_catLeerFichaExcel()" '
         +'title="Si el documento no estaba guardado, subilo a mano">'
         +'<i class="ti ti-file-import"></i> Subir el Excel a mano</button>')
      : '')
    +'</div>';

  // La tabla editable
  h+='<div style="border:0.5px solid var(--border);border-radius:9px;overflow:auto;max-height:56vh">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
    +'<thead><tr style="background:var(--surface-1);position:sticky;top:0;z-index:2">'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Foto</th>'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">SKU</th>'
      +_CAT_CAMPOS.map(function(c){
          return '<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;'
            +'color:var(--text-muted)">'+_esc(c.t)+'</th>'; }).join('')
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--t-verde)">Precio venta</th>'
    +'</tr></thead><tbody>';

  // Las filas quedan guardadas: los campos de la tabla trabajan por POSICIÓN,
  // no metiendo el código dentro del onchange. Así no hay comillas que armar
  // y da igual lo que traiga el SKU.
  window._catRevFilas=filas;

  filas.forEach(function(f, _fi){
    var sku=String(f.itemcode||'').toUpperCase();
    var _alt=f.foto_nosap || _fotoNoSapDeSku(sku);
    var foto=f.foto || f.foto_url || _alt || '';
    // SAP a veces declara un picturname cuyo archivo no está en el bucket:
    // la imagen no carga y quedaba el hueco. Si eso pasa y tenemos la del
    // proveedor, se cambia sola sin recargar nada.
    var _onerr=(_alt && _alt!==foto)
      ? (' onerror="if(!this.dataset.alt){this.dataset.alt=1;this.src=\''+_esc(_alt)+'\';}"')
      : '';
    h+='<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:4px 6px">'
        +(foto?('<img src="'+_esc(foto)+'" class="cat-foto-mini" onclick="_catVerFoto('+_fi+')" '
                +'title="Pasá el mouse para verla grande · pulsa para abrirla"'+_onerr+'>')
              :('<span style="display:flex;width:38px;height:38px;border-radius:5px;'
                +'background:var(--surface-1);align-items:center;justify-content:center;'
                +'color:var(--text-muted)"><i class="ti ti-photo-off" style="font-size:13px"></i></span>'))
      +'</td>'
      +'<td style="padding:4px 6px;font-family:monospace;font-size:10.5px;white-space:nowrap">'
        +_esc(f.itemcode||'')+'</td>';
    _CAT_CAMPOS.forEach(function(c, _ci){
      var v=_catValor(f, c.k);
      h+='<td style="padding:3px 5px">'
        +'<input value="'+_esc(String(v||''))+'" '
        +'onchange="_catRevSet('+_fi+','+_ci+',this.value)" '
        +'placeholder="—" style="width:100%;min-width:90px;padding:4px 6px;border:0.5px solid '
        +(v?'var(--border)':'#E9C08A')+';border-radius:5px;font-size:10.5px;'
        +'background:'+(v?'var(--surface-0)':'#FEF9F3')+';color:var(--text-primary)"></td>';
    });
    var pv=_catValor(f,'precio_venta');
    var costo=Number(f.precio)||0;
    // El margen es solo para decidir el precio aquí: NO va al catálogo final.
    // Se puede escribir en cualquiera de los dos campos y el otro se ajusta,
    // para poder dar un descuento distinto a cada artículo.
    var mg=(costo>0 && Number(pv)>0) ? Math.round(((Number(pv)-costo)/Number(pv))*1000)/10 : null;
    h+='<td style="padding:3px 5px;white-space:nowrap">'
      +'<input id="catpv-'+_fi+'" type="number" step="0.01" value="'+(pv||'')+'" '
      +'onchange="_catPrecioLinea('+_fi+',this.value)" '
      +'placeholder="0.00" style="width:82px;padding:4px 6px;border:1px solid '
      +(pv?'#16a34a':'#E9C08A')+';border-radius:5px;font-size:11px;text-align:right;'
      +'font-weight:700;background:'+(pv?'#dcfce7':'#FEF9F3')+';color:var(--t-verde)">'
      +(costo>0
        ? ('<input id="catmg-'+_fi+'" type="number" step="0.1" min="0" max="99.9" '
           +'value="'+(mg==null?'':mg)+'" '
           +'onchange="_catMargenLinea('+_fi+',this.value)" '
           +'title="Margen sobre el precio de venta · costo '+fmt(costo)+'. '
           +'Cambialo y el precio se recalcula solo." '
           +'placeholder="%" style="width:52px;margin-left:5px;padding:4px 5px;border:1px solid '
           +(mg==null?'var(--border)':'#C4B5FD')+';border-radius:5px;font-size:10.5px;'
           +'text-align:right;font-weight:700;background:var(--surface-0);color:'
           +(mg==null?'var(--text-muted)':(mg>=40?'#166534':(mg>=20?'#B45309':'#991b1b')))+'">'
           +'<span style="font-size:10px;color:var(--text-muted);margin-left:2px">%</span>')
        : '<span style="font-size:9.5px;color:var(--text-muted);margin-left:5px" '
          +'title="Este artículo no tiene costo cargado: poné el precio a mano">sin costo</span>')
      +'<div id="catmgtxt-'+_fi+'" style="font-size:9.5px;color:var(--text-muted);'
      +'text-align:right;margin-top:2px">'
      +(costo>0?('costo '+fmt(costo)+(mg==null?'':(' · margen '+mg+'%'))):'')
      +'</div>'
      +'</td></tr>';
  });
  h+='</tbody></table></div>';

  h+='<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;'
    +'margin-top:12px;flex-wrap:wrap">'
    +'<span style="font-size:11px;color:var(--text-muted)">'+filas.length+' artículo(s)</span>'
    +'<div style="display:flex;gap:8px">'
      +'<button class="btn" onclick="_catRevCerrar()">Cerrar</button>'
      +'<button class="btn bg2" onclick="_catGuardarFicha()"><i class="ti ti-device-floppy"></i> Guardar los datos</button>'
      +'<button class="btn bg2" onclick="_catGenerar(\'excel\')"><i class="ti ti-file-spreadsheet"></i> Excel</button>'
      +'<button class="btn bg2" style="border-color:#C7C3F5;color:var(--t-indigo)" onclick="_catGenerar(\'pdf\',true)">'
        +'<i class="ti ti-mail"></i> Generar y enviar</button>'
      +'<button class="btn bp" style="background:#7C3D12" onclick="_catGenerar(\'pdf\')">'
        +'<i class="ti ti-file-type-pdf"></i> Generar catálogo</button>'
    +'</div></div></div>';

  ov.innerHTML=h;
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  document.body.appendChild(ov);
  _modalEsc(ov);
}

// ── Sacar las fotos que faltan de un Excel o un PDF ──
// Cuando SAP no tiene imagen de un artículo, casi siempre sí la tiene el
// documento del proveedor: la PI o nuestra orden en Excel llevan la foto
// pegada al lado del SKU. Se leen de ahí y se emparejan por código.
// Un velo con la rueda mientras se lee el Excel o se genera el catálogo.
// Sin esto parecía que el portal se había quedado colgado: leer un Excel
// con cien imágenes tarda sus segundos.
function _catTrabajando(texto){
  var ov=document.getElementById('cat-trabajando');
  if(!ov){
    ov=document.createElement('div');
    ov.id='cat-trabajando';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:10099;'
      +'display:flex;align-items:center;justify-content:center';
    document.body.appendChild(ov);
  }
  ov.innerHTML='<div style="background:var(--surface-2);border:0.5px solid var(--border);'
    +'border-radius:12px;padding:22px 30px;text-align:center;min-width:250px;'
    +'box-shadow:0 8px 30px rgba(0,0,0,.25)">'
    +'<div class="ai-ring g" style="margin:0 auto 12px;display:block"></div>'
    +'<div id="cat-trabajando-txt" style="font-size:13px;font-weight:600;'
    +'color:var(--text-primary)">'+_esc(texto||'Trabajando…')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-top:5px">'
    +'Puede tardar unos segundos</div></div>';
  ov.style.display='flex';
}

function _catTrabajandoTexto(t){
  var el=document.getElementById('cat-trabajando-txt');
  if(el) el.textContent=t;
}

function _catListo(){
  var ov=document.getElementById('cat-trabajando');
  if(ov) ov.remove();
}

async function _catFotosDesdeDoc(){
  var filas=_catFuenteFilas().filter(function(f){
    return f.tipo!=='proveedor' && window._catSel[String(f.itemcode||'').toUpperCase()];
  });
  // Antes se cortaba aquí si todos tenían algo en el campo foto. Pero "tener
  // foto" no significa que la imagen exista ni que sea la buena: puede estar
  // rota o ser vieja. Y a veces se quiere actualizar a propósito. Así que
  // siempre se deja subir el Excel.
  var sinFoto=filas.filter(function(f){ return !String(f.foto||'').trim(); });
  if(!filas.length){ showT('No hay artículos seleccionados'); return; }

  var inp=document.createElement('input');
  inp.type='file';
  inp.accept='.xlsx,.xls,.xlsm,.pdf';
  inp.multiple=true;
  inp.onchange=async function(){
    var files=Array.prototype.slice.call(inp.files||[]);
    if(!files.length) return;
    _catTrabajando('Leyendo el Excel…');
    try{ await _cargarJSZip(); }catch(e){}

    var puestas=0, delPdf=0, datos=0;
    for(var i=0;i<files.length;i++){
      var f=files[i];
      _catTrabajandoTexto('Leyendo '+f.name+(files.length>1?(' ('+(i+1)+' de '+files.length+')'):'')+'…');
      var esPdf=/\.pdf$/i.test(f.name);
      try{
        if(esPdf){
          delPdf++;
          console.log('[catálogo] '+f.name+' es un PDF: las fotos se sacan del Excel, '
            +'no del PDF. Si solo hay PDF, hay que pedirle el Excel al proveedor.');
          continue;
        }

        // Del mismo Excel salen también los datos de ficha: composición,
        // color, medida, piezas por caja, peso, código de barras y marca.
        // Traer solo la foto y dejar el resto en blanco no tiene sentido.
        try{
          var fichas=await _catFichaDelExcel(f);
          Object.keys(fichas||{}).forEach(function(sku){
            var ficha=fichas[sku];
            var destino=filas.find(function(x){
              return String(x.itemcode||'').trim().toUpperCase().replace(/\s+/g,'')===sku; });
            if(!destino) return;
            Object.keys(ficha).forEach(function(c){
              // Lo que ya está puesto no se pisa
              if(destino[c]!=null && String(destino[c]).trim()!=='') return;
              _catEditSet(String(destino.itemcode||'').toUpperCase(), c, ficha[c]);
              datos++;
            });
          });
        }catch(e){ console.warn('[catálogo] ficha del Excel:', e); }
        // Se reutiliza el lector de fotos de las órdenes NO SAP: empareja por
        // SKU y por fila, y ya sabe de celdas combinadas.
        var mapa=await _nsapFotosPorSku(f, filas.map(function(x){
          return {itemcode:x.itemcode, itemname:x.itemname,
                  barcode:x.barcode, cantidad:x.por_llegar||0}; }),
          {estricto:true});
        // El lector devuelve {mime, b64, ...}: se arma la imagen incrustada,
        // igual que hacen las órdenes NO SAP.
        Object.keys(mapa||{}).forEach(function(sku){
          var d=mapa[sku];
          if(!d || !d.b64) return;
          var url='data:'+(d.mime||'image/jpeg')+';base64,'+d.b64;
          var ficha=filas.find(function(x){
            return String(x.itemcode||'').toUpperCase()===String(sku).toUpperCase(); });
          if(!ficha) return;
          // La del Excel manda: es la que el proveedor mandó para ESA orden.
          // Solo se respeta la que ya venga incrustada (data:), que es una
          // que se puso antes desde otro Excel.
          var actual=String(ficha.foto||'');
          if(!actual.trim() || actual.indexOf('data:')!==0){
            ficha.foto=url; ficha.__fotoOk=1; puestas++;
          }
        });
      }catch(e){ console.warn('[catálogo] '+f.name+':', e); }
    }

    _catListo();
    if(puestas || datos){
      showT('✓ '+[puestas?(puestas+' foto(s)'):'', datos?(datos+' dato(s)'):'']
        .filter(Boolean).join(' y ')+' del Excel');
      _catRevisarAbrir(false);        // repintar con lo añadido
    } else {
      showT(delPdf
        ? 'Del PDF no se pueden extraer: adjuntá el Excel del proveedor'
        : 'No se encontraron fotos que emparejaran con estos SKU', 6000);
    }
  };
  inp.click();
}

function _catRevCerrar(){
  window._catFuente=null;      // se vuelve al catálogo NO SAP
  var m=document.getElementById('modalCatRev'); if(m) m.remove();
}

function _catEditSet(sku, campo, valor){
  sku=String(sku).toUpperCase();
  window._catEdit[sku]=window._catEdit[sku]||{};
  window._catEdit[sku][campo]=(campo==='precio_venta')?(Number(valor)||0):String(valor||'').trim();
}

// Rellena un campo en todos los artículos de una vez
function _catMasivo(){
  var campoTxt=((document.getElementById('catMasivoCampo')||{}).value||'').trim();
  var valor=((document.getElementById('catMasivoValor')||{}).value||'').trim();
  if(!campoTxt || !valor){ showT('Elige el campo y escribe el valor'); return; }
  var campo=null;
  if(/precio/i.test(campoTxt)) campo='precio_venta';
  else {
    var c=_CAT_CAMPOS.find(function(x){ return x.t.toLowerCase()===campoTxt.toLowerCase(); });
    campo=c?c.k:null;
  }
  if(!campo){ showT('No reconozco ese campo'); return; }
  var n=0;
  Object.keys(window._catSel||{}).forEach(function(sku){
    _catEditSet(sku, campo, valor); n++;
  });
  showT('✓ '+n+' artículo(s) actualizados');
  _catRevisarAbrir(true);
}

// La fila que se está editando, por posición en la tabla
function _catRevFila(i){ return (window._catRevFilas||[])[i]||null; }
function _catRevSku(i){ var f=_catRevFila(i); return f?String(f.itemcode||'').toUpperCase():''; }

// Un campo cualquiera de la ficha (descripción, color, medida…)
function _catRevSet(i, campoIdx, valor){
  var sku=_catRevSku(i); if(!sku) return;
  var c=_CAT_CAMPOS[campoIdx]; if(!c) return;
  _catEditSet(sku, c.k, valor);
}

// Margen de UNA línea: se escribe el % y se recalcula su precio. Sirve para
// dar un descuento distinto a cada artículo sin tocar los demás.
function _catMargenLinea(i, valor){
  var f=_catRevFila(i); if(!f) return;
  var costo=Number(f.precio)||0;
  var elP=document.getElementById('catpv-'+i);
  var elM=document.getElementById('catmg-'+i);
  if(!costo){ showT('Ese artículo no tiene costo: poné el precio a mano'); return; }
  var txt=String(valor==null?'':valor).trim();
  if(txt===''){ return; }                       // se vació: no se toca el precio
  var m=parseFloat(txt);
  if(isNaN(m) || m<0 || m>=100){
    showT('El margen tiene que estar entre 0 y 99,9', 4000);
    if(elM) elM.value='';
    return;
  }
  var pv=Math.round((costo/(1-m/100))*100)/100;
  _catEditSet(String(f.itemcode||'').toUpperCase(), 'precio_venta', pv);
  if(elP){ elP.value=pv; elP.style.borderColor='#16a34a'; elP.style.background='#dcfce7'; }
  _catPintarMargen(elM, m);
  _catPieLinea(i, costo, m);
}

// Al escribir el precio a mano, el margen se recalcula para no quedar mintiendo
function _catPrecioLinea(i, valor){
  var f=_catRevFila(i); if(!f) return;
  var costo=Number(f.precio)||0;
  _catEditSet(String(f.itemcode||'').toUpperCase(), 'precio_venta', valor);
  var pv=Number(valor)||0;
  var elP=document.getElementById('catpv-'+i);
  if(elP && pv>0){ elP.style.borderColor='#16a34a'; elP.style.background='#dcfce7'; }
  var elM=document.getElementById('catmg-'+i);
  if(costo>0 && pv>0){
    var m=Math.round(((pv-costo)/pv)*1000)/10;
    if(elM){ elM.value=m; _catPintarMargen(elM, m); }
    _catPieLinea(i, costo, m);
  } else {
    if(elM) elM.value='';
    _catPieLinea(i, costo, null);
  }
}

function _catPintarMargen(el, m){
  if(!el) return;
  var c=(m>=40?'#166534':(m>=20?'#B45309':'#991b1b'));
  el.style.color=c; el.style.borderColor='#C4B5FD';
}

// La línea de abajo: costo y a cuánto margen equivale el precio puesto
function _catPieLinea(i, costo, m){
  var el=document.getElementById('catmgtxt-'+i);
  if(!el) return;
  el.innerHTML=(costo>0)
    ? ('costo '+fmt(costo)+(m==null?'':(' · margen <b style="color:'
       +(m>=40?'#166534':(m>=20?'#B45309':'#991b1b'))+'">'+m+'%</b>')))
    : '';
}

// Ver en grande la foto de la ficha
function _catVerFoto(i){
  var f=_catRevFila(i); if(!f) return;
  var sku=String(f.itemcode||'').toUpperCase();
  var url=f.foto || f.foto_url || ((window._nsapFotos||{})[sku]||{}).url || '';
  if(!url) return;
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.82);z-index:10060;'
    +'display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
  ov.innerHTML='<div style="max-width:92vw;max-height:92vh;text-align:center">'
    +'<img src="'+_esc(url)+'" style="max-width:92vw;max-height:84vh;object-fit:contain;'
    +'border-radius:10px;background:var(--surface-2);box-shadow:0 20px 60px rgba(0,0,0,.5)">'
    +'<div style="color:#fff;font-size:12.5px;margin-top:10px">'
    +_esc(f.itemcode||'')+(f.itemname?(' — '+_esc(f.itemname)):'')+'</div></div>';
  ov.addEventListener('click', function(){ ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}
}

// Calcula el precio de venta aplicando un margen sobre el costo
// El margen es sobre el PRECIO DE VENTA, no sobre el costo:
//   precio = costo / (1 - margen/100)
// Con un costo de 100 y un 50% de margen el precio es 200, y de esos 200 la
// mitad es ganancia. (Aplicarlo sobre el costo daba 150, que es un margen
// real del 33%.)
function _catMargen(){
  var v=prompt('¿Qué margen quieres sobre el precio de venta?\n\n'
    +'Ejemplo: un costo de 100 con 50% de margen da un precio de 200.\n'
    +'El margen es la parte del precio que es ganancia.','50');
  if(v===null) return;
  var m=parseFloat(v);
  if(isNaN(m) || m<0){ showT('El margen no es válido'); return; }
  if(m>=100){ showT('El margen tiene que ser menor a 100%', 4000); return; }
  var filas=_catFuenteFilas().filter(function(f){
    return f.tipo!=='proveedor' && window._catSel[String(f.itemcode||'').toUpperCase()];
  });
  var n=0, sin=0;
  filas.forEach(function(f){
    var costo=Number(f.precio)||0;
    if(!costo){ sin++; return; }
    var pv=Math.round((costo/(1-m/100))*100)/100;
    _catEditSet(String(f.itemcode||'').toUpperCase(), 'precio_venta', pv);
    n++;
  });
  showT('✓ '+n+' precio(s) calculados'+(sin?(' · '+sin+' sin costo'):''));
  _catRevisarAbrir(true);
}

// Guarda en la base lo que se completó a mano
async function _catGuardarFicha(){
  var skus=Object.keys(window._catEdit||{});
  if(!skus.length){ showT('No hay cambios que guardar'); return; }
  showT('Guardando…');
  var n=0, err=0;
  for(var i=0;i<skus.length;i++){
    var sku=skus[i];
    var f=(window._catNoSap||[]).find(function(x){
      return x.tipo!=='proveedor' && String(x.itemcode||'').toUpperCase()===sku; });
    if(!f || !f.id) continue;
    var cambios=window._catEdit[sku];
    try{
      var r=await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+f.id,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify(cambios)});
      if(r.ok){
        Object.keys(cambios).forEach(function(k){ f[k]=cambios[k]; });
        n++;
      } else {
        err++;
        var t=await r.text();
        console.warn('[catálogo] no se guardó '+sku+':', r.status, t.slice(0,140));
        if(/column/i.test(t)){
          showT('Faltan columnas en la base · corré catalogo_nosap.sql', 6000);
          return;
        }
      }
    }catch(e){ err++; console.warn('[catálogo] '+sku+':', e); }
  }
  showT(n?('✓ '+n+' artículo(s) guardados'+(err?(' · '+err+' con error'):'')):'No se pudo guardar');
  try{ if(PG==='catnosap') rCatNoSap(); }catch(e){}
}

// Botón para armar el catálogo de los SKU de una orden concreta
// ═══════════════════════════════════════════════════════════════════════════
//  CONCILIACIÓN BANCARIA
//  Compara el extracto del banco contra el libro mayor de SAP, mes a mes y
//  cuenta por cuenta. El orden y la fecha exacta no importan —el banco puede
//  registrar el 17 lo que SAP asienta el 18—, pero sí importa que no falte
//  ninguna partida y que los totales cuadren.
//
//  La comprobación clave: la diferencia entre el saldo del banco y el del
//  libro tiene que explicarse ENTERA con las partidas que quedaron sin
//  conciliar. Si no cuadra, es que falta algo por leer o por registrar.
// ═══════════════════════════════════════════════════════════════════════════

var CONCIL_CUENTAS = [
  {n:'Banco General'},
  {n:'Banistmo, S.A.',                 c:'0100154112'},
  {n:'Banistmo, S.A. - TARJETAS',      c:'0100977231'},
  {n:'Banistmo, S.A. - EUROS',         c:'0118109520'},
  {n:'Bac Intl Bank',                  c:'104000856'},
  {n:'St. Georges Bank'},
  {n:'Banco Leon, Rep. Dominicana'},
  {n:'Banco Lafise'},
  {n:'Mercantil Banco, S.A.'},
  {n:'BHD Panamá'},
  {n:'BHD Panamá (Plazo Fijo)'},
  {n:'Banesco'},
  {n:'Towerbank'},
  {n:'Multibank'},
  {n:'BCT Panamá'},
  {n:'BCT Costa Rica Colones'},
  {n:'BCT Costa Rica Dólares'},
  {n:'Profuturo'}
];

var MESES_ES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio',
                'Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

// Palabras que delatan un cargo del banco que rara vez está en el libro
var CONCIL_COMISION = /comisi|timbre|iva|itbms|anualidad|mantenimiento|cargo|manejo|sobregiro|chequera|bancanet|impuesto|interes|inter\u00e9s/i;

function _concEs(v){ return CONCIL_COMISION.test(String(v||'')); }

// ── La pantalla ───────────────────────────────────────────────────────
function rConcil(){
  var box=document.getElementById('page-concil'); if(!box) return;
  // La conciliación es de contabilidad y de la gerencia general. Una gerencia
  // acotada a un departamento (Gady en alfombras, Henry en ropa) no la ve:
  // ocultar solo el botón no basta, porque a la pantalla se puede llegar por
  // otras vías.
  if(!(CU && (CU.role==='contabilidad' || (CU.role==='gerencia' && !_deptAcotado())))){
    box.innerHTML='<div class="empty" style="padding:24px;color:var(--text-muted)">'
      +'<i class="ti ti-lock" style="font-size:22px"></i><br>'
      +'La conciliación bancaria es de contabilidad y gerencia general.</div>';
    return;
  }
  // Las cuentas salen del plan de cuentas de SAP; la lista fija es el respaldo
  if(!window._concCuentasSAP && !window._concPidiendoCtas){
    window._concPidiendoCtas=true;
    _concCargarCuentas().then(function(){ try{ rConcil(); }catch(e){} });
  }
  var hoy=new Date();
  // Primero el estado: más abajo se lee st.cuenta, y usarlo antes de crearlo
  // dejaba la pantalla en blanco.
  var st=window._concEstado||(window._concEstado={
    cuenta:'Banco Lafise', mes:hoy.getMonth(), anio:hoy.getFullYear(),
    extracto:null, libro:null, res:null
  });

  var CUENTAS=window._concCuentasSAP||CONCIL_CUENTAS;
  // El valor del desplegable es el CÓDIGO de la cuenta cuando existe: el
  // nombre de la lista fija no coincide con el de SAP.
  window._concCtaSAP={}; window._concCtaNombre={};
  CUENTAS.forEach(function(x){
    var v=x.c||x.n;
    window._concCtaSAP[v]=v;
    window._concCtaNombre[v]=x.n+(x.c?('  ·  '+x.c):'');
  });
  if(!window._concCtaNombre[st.cuenta]){
    // Se recupera la cuenta elegida por nombre, o se toma la primera
    var hall=CUENTAS.find(function(x){
      return String(x.n||'').toLowerCase().replace(/[^a-z0-9]/g,'')
           === String(st.cuenta||'').toLowerCase().replace(/[^a-z0-9]/g,''); });
    st.cuenta=hall?(hall.c||hall.n):((CUENTAS[0]&&(CUENTAS[0].c||CUENTAS[0].n))||'');
  }

  // La primera vez se comprueba el mes en curso
  if(!window._concIniciado){
    window._concIniciado=true;
    setTimeout(function(){
      try{ _concRevisarLibro(); }catch(e){}
      try{ _concBuscarExtracto(); }catch(e){}
      try{ _concBuscarConciliacion(); }catch(e){}
    }, 200);
  }

  var h='<div class="slbl"><i class="ti ti-scale"></i>Conciliación bancaria</div>'
   +'<div style="background:var(--surface-0);border:0.5px solid var(--border);'
     +'border-radius:var(--radius);padding:14px;margin-bottom:12px">'

   +'<div style="display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end;margin-bottom:12px">'
     +'<div style="flex:1;min-width:220px"><label style="font-size:11px;color:var(--text-muted);font-weight:500">Cuenta</label>'
       +'<select id="conc-cta" onchange="_concSet(\'cuenta\',this.value)" '
       +'style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;'
       +'font-size:12.5px;margin-top:3px;font-family:var(--font-sans)">'
       + CUENTAS.map(function(x){
           var v=x.c||x.n;
           return '<option value="'+_esc(v)+'"'+(st.cuenta===v?' selected':'')+'>'
             +_esc(x.n)+(x.c?('  ·  '+x.c):'')+'</option>'; }).join('')
       +'</select></div>'
     +'<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Mes</label>'
       +'<select id="conc-mes" onchange="_concSet(\'mes\',this.value)" '
       +'style="padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;'
       +'font-size:12.5px;margin-top:3px;font-family:var(--font-sans)">'
       + MESES_ES.map(function(m,i){ return '<option value="'+i+'"'+(st.mes===i?' selected':'')+'>'+m+'</option>'; }).join('')
       +'</select></div>'
     +'<div><label style="font-size:11px;color:var(--text-muted);font-weight:500">Año</label>'
       +'<input id="conc-anio" type="number" value="'+st.anio+'" onchange="_concSet(\'anio\',this.value)" '
       +'style="width:92px;padding:8px 10px;border:0.5px solid var(--border);border-radius:7px;'
       +'font-size:12.5px;margin-top:3px"></div>'
   +'</div>'

   +'<div style="display:flex;gap:10px;flex-wrap:wrap">'
     + _concCajaExtracto(st)
     + '<div id="conc-libro" style="flex:1;min-width:250px">'+_concLibroEstadoHTML()+'</div>'
   +'</div>'
   + _concCajaConciliacion(st)

   +'<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;margin-top:12px;flex-wrap:wrap">'
     +'<span style="font-size:11px;color:var(--text-muted)">'
       +'El libro mayor sale del reporte de SAP filtrando la cuenta y el mes. '
       +'Se aceptan PDF, Excel o CSV.</span>'
     +'<button class="btn bp" onclick="_concConciliar()" style="background:#72243E">'
       +'<i class="ti ti-scale"></i> Conciliar el mes</button>'
   +'</div></div>'

   +(window._concCtasError
     ? ('<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;'
        +'padding:9px 11px;font-size:11.5px;color:var(--t-marron);margin-bottom:12px">'
        +'<i class="ti ti-alert-circle"></i> No se pudo leer la lista de cuentas de SAP: '
        +_esc(window._concCtasError)
        +'. Se está usando la lista de respaldo, que no tiene los códigos y no puede '
        +'consultar el libro mayor.</div>')
     : '')
   +((!st.res && window._concGuardadaInfo)
     ? ('<div style="background:'+(window._concGuardadaInfo.cuadra?'#dcfce7':'#FEF9F3')
        +';border:1px solid '+(window._concGuardadaInfo.cuadra?'#16a34a':'#E9C08A')
        +';border-radius:9px;padding:10px 12px;font-size:11.5px;margin-bottom:12px;'
        +'color:'+(window._concGuardadaInfo.cuadra?'#166534':'#7C3D12')+'">'
        +'<i class="ti '+(window._concGuardadaInfo.cuadra?'ti-circle-check':'ti-alert-triangle')+'"></i> '
        +'Este mes ya está conciliado'
        +(window._concGuardadaInfo.por?(' por '+_esc(window._concGuardadaInfo.por)):'')
        +(window._concGuardadaInfo.cuando?(' el '+String(window._concGuardadaInfo.cuando).slice(0,10)):'')
        +' · '+(window._concGuardadaInfo.cuadra?'cuadró':'quedó con diferencia de '
              +_concFmt2(window._concGuardadaInfo.diferencia))
        +'. Volvé a conciliar para verlo en detalle, o '
        +'<a href="#" onclick="_concBorrarConciliacion();return false" '
        +'style="color:var(--text-danger)">borralo</a>.</div>')
     : '')
   +'<div id="conc-res">'+(st.res?_concResultadoHTML(st.res):'')+'</div>';

  box.innerHTML=h;
}

// El estado del libro mayor: viene de SAP, no se sube. Se comprueba que ese
// mes esté sincronizado antes de conciliar, para no descubrirlo a mitad.
// La caja del extracto: el recién subido, o el que ya estaba archivado
function _concCajaExtracto(st){
  var base='flex:1;min-width:250px;border-radius:10px;padding:12px;';
  var h='<div style="'+base+'border:1px dashed var(--border);background:var(--surface-1)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-azul);margin-bottom:7px">'
    +'<i class="ti ti-building-bank"></i> Extracto del banco</div>';

  if(st.extracto){                       // recién elegido en esta sesión
    h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px">'
      +'<i class="ti ti-file-check" style="color:var(--text-success);font-size:16px"></i>'
      +'<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'
        +_esc(st.extracto.name)+'</span>'
      +'<button onclick="_concQuitar(\'extracto\')" style="background:none;border:0;'
        +'color:var(--text-muted);cursor:pointer;font-size:15px">&times;</button></div>';
  } else if(st.extractoGuardado){        // ya archivado en un mes anterior
    var g=st.extractoGuardado;
    h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px">'
      +'<i class="ti ti-file-check" style="color:var(--text-success);font-size:16px"></i>'
      +'<a href="'+_esc(_concUrlExtracto(g))+'" target="_blank" rel="noopener" '
        +'style="flex:1;color:var(--text-accent);text-decoration:none;overflow:hidden;'
        +'text-overflow:ellipsis;white-space:nowrap">'+_esc(g.nombre_archivo||'extracto')+'</a>'
      +'</div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:3px">'
      +'Archivado'+(g.subido_por?(' por '+_esc(g.subido_por)):'')
      +(g.subido_en?(' el '+String(g.subido_en).slice(0,10)):'')+'</div>'
      +'<div style="display:flex;gap:10px;align-items:center;margin-top:5px">'
      +'<label style="cursor:pointer;font-size:10.5px;color:var(--text-accent)">'
        +'<i class="ti ti-refresh"></i> Reemplazar'
        +'<input type="file" accept=".pdf,.xlsx,.xls,.csv" style="display:none" '
        +'onchange="_concArchivo(\'extracto\',this)"></label>'
      +'<button onclick="_concBorrarExtracto()" style="background:none;border:0;padding:0;'
        +'cursor:pointer;font-size:10.5px;color:var(--text-danger)">'
        +'<i class="ti ti-trash"></i> Borrar</button>'
      +'</div>';
  } else {
    h+='<label style="cursor:pointer;font-size:11.5px;color:var(--text-accent)">'
      +'<i class="ti ti-upload"></i> Subir el extracto del mes'
      +'<input type="file" accept=".pdf,.xlsx,.xls,.csv" style="display:none" '
      +'onchange="_concArchivo(\'extracto\',this)"></label>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:5px">'
      +'Queda archivado por cuenta y mes.</div>';
  }
  return h+'</div>';
}

// El PDF de la conciliación guardada de ese mes, junto al extracto
function _concCajaConciliacion(st){
  var g=window._concGuardadaInfo;
  if(!g || !g.pdf_ruta) return '';
  var url=DOCS_BASE+String(g.pdf_ruta).split('/').map(encodeURIComponent).join('/');
  return '<div style="margin-top:10px;border-radius:10px;padding:12px;'
    +'border:1px solid '+(g.cuadra?'#16a34a':'#E9C08A')+';'
    +'background:'+(g.cuadra?'#dcfce7':'#FEF9F3')+'">'
    +'<div style="font-size:11.5px;font-weight:700;color:'+(g.cuadra?'#166534':'#7C3D12')
      +';margin-bottom:7px"><i class="ti ti-file-check"></i> Conciliación guardada</div>'
    +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;font-size:11.5px">'
      +'<i class="ti ti-file-type-pdf" style="font-size:17px;color:var(--text-accent)"></i>'
      +'<span style="flex:1;min-width:160px;overflow:hidden;text-overflow:ellipsis;'
        +'white-space:nowrap">'+_esc(g.pdf_nombre||'conciliación.pdf')+'</span>'
      +'<a href="'+_esc(url)+'" target="_blank" rel="noopener" '
        +'style="color:var(--text-accent);text-decoration:none;border:0.5px solid var(--border);'
        +'border-radius:7px;padding:4px 10px;background:var(--surface-0)">'
        +'<i class="ti ti-eye"></i> Ver</a>'
      +'<a href="'+_esc(url)+'" download="'+_esc(g.pdf_nombre||'conciliacion.pdf')+'" '
        +'style="color:var(--text-accent);text-decoration:none;border:0.5px solid var(--border);'
        +'border-radius:7px;padding:4px 10px;background:var(--surface-0)">'
        +'<i class="ti ti-download"></i> Bajar</a>'
      +'<button onclick="_concBorrarConciliacion()" style="background:none;border:0;'
        +'cursor:pointer;font-size:11.5px;color:var(--text-danger)">'
        +'<i class="ti ti-trash"></i> Borrar</button>'
    +'</div>'
    +(g.comentarios?('<div style="font-size:11px;color:var(--text-secondary);margin-top:7px;'
      +'white-space:pre-wrap">'+_esc(g.comentarios)+'</div>'):'')
    +'</div>';
}

function _concUrlExtracto(g){
  if(!g) return '';
  if(/^https?:/i.test(g.ruta||'')) return g.ruta;
  return DOCS_BASE+String(g.ruta||'').split('/').map(encodeURIComponent).join('/');
}

function _concLibroEstadoHTML(){
  var e=window._concLibroInfo;
  var base='flex:1;min-width:250px;border-radius:10px;padding:12px;';
  if(!e) return '<div style="'+base+'border:1px solid var(--border);background:var(--surface-1)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-vino);margin-bottom:7px">'
    +'<i class="ti ti-book"></i> Libro mayor de SAP</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
    +'<span class="ai-ring g" style="vertical-align:-2px"></span> Comprobando…</div></div>';

  if(e.hay) return '<div style="'+base+'border:1px solid #16a34a;background:var(--pastel-ok)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde);margin-bottom:7px">'
    +'<i class="ti ti-book"></i> Libro mayor de SAP</div>'
    +'<div style="font-size:11.5px;color:var(--t-verde)"><i class="ti ti-circle-check"></i> '
    +e.n+' asiento(s) sincronizados · saldo final '+_concFmt(e.saldo)+'</div>'
    +'<div style="font-size:10.5px;color:var(--t-verde);opacity:.8;margin-top:3px">'
    +'No hay que subir nada: lo trae el worker desde SAP.</div>'
    // El libro mayor se sincroniza UNA VEZ POR HORA. Si contabilidad asienta
    // algo y concilia enseguida, esos asientos aún no están y el saldo no
    // cuadra con SAP. Antes no había forma de saberlo: decía "sincronizados"
    // y punto.
    +'<div style="font-size:10.5px;color:var(--t-marron);margin-top:6px;'
    +'padding-top:6px;border-top:0.5px dashed var(--border)">'
    +'<i class="ti ti-clock"></i> Se actualiza una vez por hora. Si acabas de '
    +'asentar algo en SAP, puede que todavía no esté aquí: '
    +'<b>compara el saldo final con el de SAP</b> antes de dar el mes por '
    +'cuadrado.</div></div>';

  // Sincronizado pero sin movimientos: la cuenta no se movió ese mes. No es
  // un fallo y no hay nada que esperar.
  if(e.sincronizado) return '<div style="'+base+'border:1px solid var(--border);background:var(--surface-1)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-vino);margin-bottom:7px">'
    +'<i class="ti ti-book"></i> Libro mayor de SAP</div>'
    +'<div style="font-size:11.5px;color:var(--text-secondary)"><i class="ti ti-circle-minus"></i> '
    +'Sin movimientos en SAP este mes.</div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:3px">'
    +'La cuenta no tuvo asientos'
    +(e.otrasCuentas?' este mes, aunque otras cuentas sí':'')
    +'. Si el extracto del banco tampoco trae nada, '
    +'el mes cuadra sin más. Si el banco SÍ trae movimientos, falta '
    +'asentarlos en SAP.</div></div>';

  // Ni asientos ni rastro del worker: aún no lo ha traído
  return '<div style="'+base+'border:1px solid #E9C08A;background:var(--pastel-aviso)">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);margin-bottom:7px">'
    +'<i class="ti ti-book"></i> Libro mayor de SAP</div>'
    +'<div style="font-size:11.5px;color:var(--t-marron)"><i class="ti ti-alert-circle"></i> '
    +'Ese mes todavía no está sincronizado.</div>'
    +'<div style="font-size:10.5px;color:var(--t-marron);margin-top:3px">'
    +'El worker lo trae una vez por hora. Si no aparece, revisa que esté corriendo.'
    +(e.ultimo?(' Lo último que trajo de esta cuenta es '+_esc(e.ultimo)+'.'):'')
    +'</div></div>';
}

function _concFmt(v){
  return '$'+Number(v||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
}

// Comprueba en Supabase si el mes elegido ya está
async function _concRevisarLibro(){
  var st=window._concEstado; if(!st) return;
  window._concLibroInfo=null;
  var el=document.getElementById('conc-libro');
  if(el) el.innerHTML=_concLibroEstadoHTML();
  var cta=st.cuenta;      // ya es el código de la cuenta
  // "Sin asientos" puede significar dos cosas muy distintas: que el worker
  // todavía no trajo ese mes, o que la cuenta no tuvo movimientos. Se
  // distinguen mirando si el worker ya pasó por ahí.
  var info={hay:false, n:0, saldo:0, sincronizado:false};
  try{
    var r=await fetch(SB+'/rest/v1/libro_mayor?select=clave&cuenta=eq.'+encodeURIComponent(cta)
      +'&anio=eq.'+st.anio+'&mes=eq.'+(st.mes+1)+'&limit=1000',{headers:SBH});
    if(r.ok) info.n=(await r.json()||[]).length;

    // La fila de saldos existe en cuanto el worker procesa el mes, tenga
    // movimientos o no. Es la prueba de que sí se sincronizó.
    var rs=await fetch(SB+'/rest/v1/libro_mayor_saldos?select=saldo_final,saldo_inicial&cuenta=eq.'
      +encodeURIComponent(cta)+'&anio=eq.'+st.anio+'&mes=eq.'+(st.mes+1)+'&limit=1',{headers:SBH});
    if(rs.ok){
      var d=(await rs.json()||[])[0];
      if(d){ info.saldo=Number(d.saldo_final)||0; info.sincronizado=true; }
    }
    info.hay=info.n>0;

    // Y si tampoco hay saldo guardado: si el worker ya trajo meses
    // POSTERIORES de esta cuenta, es que pasó por aquí y no había nada.
    if(!info.hay && !info.sincronizado){
      var rp=await fetch(SB+'/rest/v1/libro_mayor?select=anio,mes&cuenta=eq.'
        +encodeURIComponent(cta)+'&order=anio.desc,mes.desc&limit=1',{headers:SBH});
      if(rp.ok){
        var u=(await rp.json()||[])[0];
        if(u){
          var pedido=st.anio*12+(st.mes+1);
          var ultimo=Number(u.anio)*12+Number(u.mes);
          if(ultimo>pedido) info.sincronizado=true;
          info.ultimo=String(u.anio)+'-'+String(u.mes).padStart(2,'0');
        }
      }

      // Y si esta cuenta no tiene meses posteriores —porque lleva tiempo
      // parada— se mira si el worker trajo ese mes para CUALQUIER OTRA
      // cuenta de banco. La consulta las trae todas de una vez, así que si
      // hay asientos de agosto en otra cuenta, agosto está sincronizado y
      // esta simplemente no se movió.
      //
      // Sin esto, una cuenta sin movimiento en el último mes salía siempre
      // como "todavía no sincronizado" y no dejaba conciliar.
      if(!info.sincronizado){
        try{
          var ro=await fetch(SB+'/rest/v1/libro_mayor?select=cuenta'
            +'&anio=eq.'+st.anio+'&mes=eq.'+(st.mes+1)+'&limit=1',{headers:SBH});
          if(ro.ok && (await ro.json()||[]).length){
            info.sincronizado=true;
            info.otrasCuentas=true;
          }
        }catch(e){}
      }
    }
  }catch(e){ console.warn('[conciliación] revisar libro:', e); }
  window._concLibroInfo=info;
  var el2=document.getElementById('conc-libro');
  if(el2) el2.innerHTML=_concLibroEstadoHTML();
}

function _concCaja(cual, titulo, icono, color, arch, nota){
  return '<div style="flex:1;min-width:250px;border:1px dashed var(--border);border-radius:10px;'
    +'padding:12px;background:var(--surface-1)">'
    +'<div style="font-size:11.5px;font-weight:700;color:'+color+';margin-bottom:7px">'
      +'<i class="ti '+icono+'"></i> '+titulo+'</div>'
    +(nota&&!arch?('<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">'+nota+'</div>'):'')
    +(arch
      ? ('<div style="display:flex;align-items:center;gap:7px;font-size:11.5px">'
         +'<i class="ti ti-file-check" style="color:var(--text-success);font-size:16px"></i>'
         +'<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(arch.name)+'</span>'
         +'<button onclick="_concQuitar(\''+cual+'\')" style="background:none;border:0;'
           +'color:var(--text-muted);cursor:pointer;font-size:15px">&times;</button></div>')
      : ('<label style="cursor:pointer;font-size:11.5px;color:var(--text-accent)">'
         +'<i class="ti ti-upload"></i> Subir archivo'
         +'<input type="file" accept=".pdf,.xlsx,.xls,.csv" style="display:none" '
         +'onchange="_concArchivo(\''+cual+'\',this)"></label>'))
    +'</div>';
}

function _concSet(campo, valor){
  var st=window._concEstado;
  st[campo]=(campo==='mes'||campo==='anio')?Number(valor):valor;
  st.extracto=null; st.res=null;      // cambió el periodo: se empieza de nuevo
  window._concGuardadaInfo=null;
  try{ _concRevisarLibro(); }catch(e){}
  try{ _concBuscarExtracto(); }catch(e){}
  try{ _concBuscarConciliacion(); }catch(e){}
}
function _concArchivo(cual, input){
  var f=input.files&&input.files[0]; if(!f) return;
  window._concEstado[cual]=f;
  rConcil();
  // El extracto se guarda apenas se sube: es el documento que llega de
  // afuera y hay que poder consultarlo meses después.
  if(cual==='extracto') _concGuardarExtracto(f);
}

// Guarda el extracto del mes en el almacenamiento y lo registra
async function _concGuardarExtracto(file){
  var st=window._concEstado;
  var cta=st.cuenta;
  var ref=_concRefExtracto(st.cuenta, st.mes, st.anio);
  showT('Archivando el extracto…');
  try{
    var path=await _subirDocStorage(ref, 'extracto', file);
    if(!path){ showT('No se pudo archivar el extracto'); return; }
    try{ await _registrarDoc(ref, 'extracto', file, path); }catch(e){}
    var fila={
      clave: ref,
      cuenta: cta,
      cuenta_nombre: (window._concCtaNombre&&window._concCtaNombre[st.cuenta])||st.cuenta,
      anio: st.anio, mes: st.mes+1,
      nombre_archivo: file.name,
      ruta: path,
      subido_por: (CU&&CU.name)||'',
      subido_en: new Date().toISOString()
    };
    var r=await fetch(SB+'/rest/v1/extractos_bancarios?on_conflict=clave',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify(fila)
    });
    if(!r.ok){
      var t=await r.text();
      console.warn('[conciliación] guardar extracto:', t);
      showT('El extracto se subió pero no se registró (¿falta la tabla extractos_bancarios?)', 7000);
      return;
    }
    st.extractoGuardado=fila;
    showT('✓ Extracto de '+MESES_ES[st.mes]+' '+st.anio+' archivado');
    rConcil();
  }catch(e){ console.warn('[conciliación] extracto:', e); }
}

function _concRefExtracto(cuenta, mes, anio){
  return 'EXT-'+anio+String(mes+1).padStart(2,'0')+'-'
    +String(cuenta).replace(/[^A-Za-z0-9]+/g,'').slice(0,16).toUpperCase();
}

// El extracto que ya esté archivado para esa cuenta y mes
// La conciliación que ya se haya guardado de ese mes
// ── Los documentos de referencia de la conciliación ──
// Se archivan igual que el extracto y se vuelven a mostrar cada vez que se
// consulta ese mes y esa cuenta.
function _concOtrosAdjuntos(){
  var docs=(window._concOtrosDocs||[]);
  var lista = docs.length
    ? docs.map(function(d,i){
        return '<span style="display:inline-flex;align-items:center;gap:5px;'
          +'background:var(--surface-2);border:0.5px solid var(--border);border-radius:8px;'
          +'padding:3px 9px;font-size:11px;margin:3px 5px 0 0">'
          +'<a href="'+_esc(DOCS_BASE+String(d.ruta||'').split("/").map(encodeURIComponent).join("/"))+'" '
          +'target="_blank" style="color:var(--t-azul);text-decoration:none">'
          +'<i class="ti ti-file"></i> '+_esc(d.nombre_archivo||'documento')+'</a>'
          +'<i class="ti ti-x" title="Quitar" style="cursor:pointer;color:var(--text-muted)" '
          +'onclick="_concOtrosQuitar('+i+')"></i></span>';
      }).join('')
    : '<span style="font-size:10.5px;color:var(--text-muted)">Sin documentos adjuntos.</span>';

  return '<div style="margin-top:8px">'+lista+'</div>'
    +'<button class="btn bg2" style="font-size:11px;padding:4px 10px;margin-top:7px" '
    +'onclick="_concOtrosSubir()"><i class="ti ti-upload"></i> Adjuntar documento</button>';
}

function _concOtrosSubir(){
  var st=window._concEstado; if(!st) return;
  var inp=document.createElement('input');
  inp.type='file'; inp.multiple=true;
  inp.accept='.pdf,.xlsx,.xls,.csv,.png,.jpg,.jpeg,.doc,.docx';
  inp.onchange=async function(){
    var files=Array.prototype.slice.call(inp.files||[]);
    if(!files.length) return;
    var ref=_concRefConc(st.cuenta, st.mes, st.anio);
    showT('Archivando '+files.length+' documento(s)…');
    window._concOtrosDocs=window._concOtrosDocs||[];
    for(var i=0;i<files.length;i++){
      try{
        var path=await _subirDocStorage(ref, 'otros', files[i]);
        if(!path){ showT('No se pudo archivar '+files[i].name); continue; }
        try{ await _registrarDoc(ref, 'otros', files[i], path); }catch(e){}
        window._concOtrosDocs.push({nombre_archivo:files[i].name, ruta:path,
          subido_por:(CU&&CU.name)||'', subido_en:new Date().toISOString()});
      }catch(e){ console.warn('[conciliación] adjuntar:', e); }
    }
    showT('✓ '+window._concOtrosDocs.length+' documento(s) adjuntos');
    // Se guardan de inmediato: si no, se pierden al cerrar la pantalla
    try{ await _concGuardarOtros(); }catch(e){}
    try{ rConcil(); }catch(e){}
  };
  inp.click();
}

function _concOtrosQuitar(i){
  var docs=window._concOtrosDocs||[];
  if(!docs[i]) return;
  if(!confirm('¿Quitar "'+(docs[i].nombre_archivo||'')+'" de esta conciliación?')) return;
  docs.splice(i,1);
  _concGuardarOtros().catch(function(){});
  try{ rConcil(); }catch(e){}
}

// Guarda el texto y la lista de documentos en la fila de la conciliación
async function _concGuardarOtros(){
  var st=window._concEstado; if(!st) return false;
  var ref=_concRefConc(st.cuenta, st.mes, st.anio);
  var txt='';
  try{ txt=(document.getElementById('conc-otros')||{}).value||''; }catch(e){}
  var fila={
    referencia: ref,
    cuenta: st.cuenta,
    anio: st.anio, mes: st.mes+1,
    otros_detalles: txt,
    otros_docs: JSON.stringify(window._concOtrosDocs||[])
  };
  try{
    var r=await fetch(SB+'/rest/v1/conciliaciones?on_conflict=referencia',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify(fila)
    });
    if(!r.ok){
      var t=await r.text();
      console.warn('[conciliación] guardar otros detalles:', t.slice(0,200));
      showT('No se pudo guardar. ¿Faltan las columnas otros_detalles y otros_docs?', 7000);
      return false;
    }
    if(st.res){ st.res.otros_detalles=txt; }
    return true;
  }catch(e){
    console.warn('[conciliación] otros detalles:', e);
    return false;
  }
}

async function _concBuscarConciliacion(){
  var st=window._concEstado; if(!st) return;
  try{
    var r=await fetch(SB+'/rest/v1/conciliaciones?select=*&referencia=eq.'
      +encodeURIComponent(_concRefConc(st.cuenta, st.mes, st.anio))+'&limit=1',{headers:SBH});
    if(!r.ok) return;
    var g=(await r.json()||[])[0];
    if(!g) return;
    window._concGuardadaInfo={
      referencia:g.referencia, saldo_banco:g.saldo_banco, saldo_libro:g.saldo_libro,
      diferencia:g.diferencia, cuadra:g.cuadra, por:g.hecha_por, cuando:g.creado_en,
      comentarios:g.comentarios||'', pdf_nombre:g.pdf_nombre||'', pdf_ruta:g.pdf_ruta||'',
      otros_detalles:g.otros_detalles||''
    };
    // Los documentos de referencia de ese mes, para volver a mostrarlos
    try{
      window._concOtrosDocs = g.otros_docs
        ? (typeof g.otros_docs==='string' ? JSON.parse(g.otros_docs) : g.otros_docs)
        : [];
    }catch(e){ window._concOtrosDocs=[]; }
    if(st.res){ st.res.otros_detalles=g.otros_detalles||''; }
    try{ rConcil(); }catch(e){}
  }catch(e){ console.warn('[conciliación] buscar guardada:', e); }
}

async function _concBuscarExtracto(){
  var st=window._concEstado; if(!st) return;
  st.extractoGuardado=null;
  try{
    var r=await fetch(SB+'/rest/v1/extractos_bancarios?select=*&clave=eq.'
      +encodeURIComponent(_concRefExtracto(st.cuenta, st.mes, st.anio))+'&limit=1',{headers:SBH});
    if(r.ok){ st.extractoGuardado=(await r.json()||[])[0]||null; }
  }catch(e){ console.warn('[conciliación] buscar extracto:', e); }
  try{ rConcil(); }catch(e){}
}
function _concQuitar(cual){ window._concEstado[cual]=null; rConcil(); }

// ── El libro mayor, directo de SAP ────────────────────────────────────
// Lo sincroniza el worker (sync_libro_mayor) a la tabla libro_mayor. Así
// contabilidad solo sube el extracto del banco, que es lo único que viene
// de afuera. Si no hay datos, la pantalla deja subir el PDF como antes.
// El último saldo conocido de la cuenta ANTES del mes pedido. Cuando un mes
// no tiene movimientos, su saldo es el que traía: darlo por cero hace que la
// conciliación nunca cuadre.
async function _concSaldoArrastrado(cuenta, mes, anio){
  var pedido=anio*12+(mes+1);
  try{
    var r=await fetch(SB+'/rest/v1/libro_mayor_saldos?select=anio,mes,saldo_final'
      +'&cuenta=eq.'+encodeURIComponent(cuenta)
      +'&order=anio.desc,mes.desc&limit=60',{headers:SBH});
    if(r.ok){
      var f=await r.json()||[];
      for(var i=0;i<f.length;i++){
        if((Number(f[i].anio)*12+Number(f[i].mes)) < pedido){
          var de=String(f[i].anio)+'-'+String(f[i].mes).padStart(2,'0');
          console.log('[conciliación] '+cuenta+' sin movimientos: se arrastra el saldo de '
            +de+' ('+(Number(f[i].saldo_final)||0)+')');
          return {saldo:Number(f[i].saldo_final)||0, de:de};
        }
      }
    }
  }catch(e){ console.warn('[conciliación] saldo arrastrado:', e); }
  console.warn('[conciliación] '+cuenta+': no hay ningún saldo anterior guardado, '
    +'se toma 0. Si el banco trae saldo, la diferencia será ese importe.');
  return {saldo:0, de:null};
}

async function _concLibroDeSAP(cuenta, mes, anio){
  var m1=String(anio)+'-'+String(mes+1).padStart(2,'0')+'-01';
  var r=await fetch(SB+'/rest/v1/libro_mayor?select=fecha,detalle,ref1,contra_nombre,cardname,monto'
    +'&cuenta=eq.'+encodeURIComponent(cuenta)
    +'&anio=eq.'+anio+'&mes=eq.'+(mes+1)
    +'&order=fecha.asc&limit=5000',{headers:SBH});
  if(!r.ok) throw new Error('No se pudo leer el libro mayor ('+r.status+')');
  var filas=await r.json()||[];

  var rs=await fetch(SB+'/rest/v1/libro_mayor_saldos?select=saldo_inicial,saldo_final'
    +'&cuenta=eq.'+encodeURIComponent(cuenta)
    +'&anio=eq.'+anio+'&mes=eq.'+(mes+1)+'&limit=1',{headers:SBH});
  var sal=rs.ok?(await rs.json()||[])[0]:null;

  // Sin filas y sin saldo hay dos posibilidades: que el worker no haya
  // traído el mes, o que la cuenta no se moviera. Si ya trajo meses
  // POSTERIORES de esta cuenta, es lo segundo: se concilia con un libro
  // vacío, que es lo correcto.
  if(!filas.length && !sal){
    var vacio=false;
    try{
      var rp=await fetch(SB+'/rest/v1/libro_mayor?select=anio,mes&cuenta=eq.'
        +encodeURIComponent(cuenta)+'&order=anio.desc,mes.desc&limit=1',{headers:SBH});
      if(rp.ok){
        var u=(await rp.json()||[])[0];
        if(u && (Number(u.anio)*12+Number(u.mes)) > (anio*12+(mes+1))) vacio=true;
      }
    }catch(e){}

    // Si esta cuenta no tiene meses posteriores —porque lleva tiempo
    // parada, como Banco León— se mira si el worker trajo ese mes para
    // CUALQUIER otra cuenta de banco. Las trae todas de una vez, así que
    // si hay asientos de agosto en otra cuenta, agosto está sincronizado
    // y esta simplemente no se movió.
    //
    // Sin esto, una cuenta sin movimiento en el último mes no dejaba
    // conciliar: decía que el worker no había traído el mes.
    if(!vacio){
      try{
        var ro=await fetch(SB+'/rest/v1/libro_mayor?select=cuenta'
          +'&anio=eq.'+anio+'&mes=eq.'+(mes+1)+'&limit=1',{headers:SBH});
        if(ro.ok && (await ro.json()||[]).length) vacio=true;
      }catch(e){}
    }
    if(!vacio) return null;                  // ese mes no está sincronizado
    // Sin movimientos, el saldo no es cero: es el que venía arrastrando.
    // Se busca el último saldo conocido ANTES de este mes; si no se hace,
    // el libro sale en 0 y la conciliación no cuadra nunca.
    var arr=await _concSaldoArrastrado(cuenta, mes, anio);
    return {origen:'SAP', saldo_inicial:arr.saldo, saldo_final:arr.saldo,
            movimientos:[], sinMovimientos:true, saldoDe:arr.de};
  }
  // Con saldo guardado pero sin asientos: el mes está, la cuenta no se movió
  if(!filas.length && sal){
    var si=Number(sal.saldo_inicial)||0, sf=Number(sal.saldo_final)||0;
    if(!si && !sf){
      var arr2=await _concSaldoArrastrado(cuenta, mes, anio);
      si=sf=arr2.saldo;
      return {origen:'SAP', saldo_inicial:si, saldo_final:sf,
              movimientos:[], sinMovimientos:true, saldoDe:arr2.de};
    }
    return {origen:'SAP', saldo_inicial:si, saldo_final:sf,
            movimientos:[], sinMovimientos:true};
  }

  return {
    origen:'SAP',
    saldo_inicial:Number(sal&&sal.saldo_inicial)||0,
    saldo_final:Number(sal&&sal.saldo_final)||0,
    movimientos:filas.map(function(x){
      return {fecha:String(x.fecha||''),
              detalle:String(x.detalle||x.contra_nombre||x.cardname||''),
              ref:String(x.ref1||''),
              monto:Number(x.monto)||0};
    }).filter(function(m){ return m.monto!==0; })
  };
}

// Las cuentas de banco, tal como están en el plan de cuentas de SAP
async function _concCargarCuentas(){
  window._concCtasError='';
  // 1) La lista que arma el worker
  try{
    var r=await fetch(SB+'/rest/v1/cuentas_bancos?select=cuenta,nombre,moneda'
      +'&order=cuenta.asc&limit=200',{headers:SBH});
    if(r.ok){
      var filas=await r.json()||[];
      if(filas.length){
        window._concCuentasSAP=filas.map(function(x){
          return {n:(x.nombre||x.cuenta), c:x.cuenta, moneda:x.moneda||''};
        });
        return;
      }
      window._concCtasError='La tabla cuentas_bancos está vacía';
    } else {
      var t=''; try{ t=await r.text(); }catch(e){}
      window._concCtasError='cuentas_bancos: HTTP '+r.status+' '+String(t).slice(0,120);
    }
  }catch(e){ window._concCtasError='cuentas_bancos: '+(e.message||e); }

  // 2) Si esa tabla no está, se deducen del propio libro mayor, que es donde
  //    de verdad hacen falta. Así la pantalla funciona aunque el worker no
  //    haya llegado a escribir la lista de cuentas.
  try{
    var r2=await fetch(SB+'/rest/v1/libro_mayor?select=cuenta,cuenta_nombre'
      +'&order=cuenta.asc&limit=2000',{headers:SBH});
    if(!r2.ok){
      var t2=''; try{ t2=await r2.text(); }catch(e){}
      window._concCtasError+=' · libro_mayor: HTTP '+r2.status+' '+String(t2).slice(0,120);
      return;
    }
    var vistos={}, out=[];
    (await r2.json()||[]).forEach(function(x){
      var c=String(x.cuenta||'').trim(); if(!c || vistos[c]) return;
      vistos[c]=1; out.push({n:(x.cuenta_nombre||c), c:c});
    });
    if(out.length){ window._concCuentasSAP=out; window._concCtasError=''; }
  }catch(e){ window._concCtasError+=' · libro_mayor: '+(e.message||e); }
}

// ── Leer un documento con la IA ───────────────────────────────────────
// ── Leer un documento con la IA, por tandas ───────────────────────────
// Un extracto de un mes movido puede tener 300 líneas, y la respuesta de la
// IA se corta antes de terminarlas (así se perdió todo lo posterior al 6 de
// febrero). Por eso se pide en tandas: cada llamada devuelve un tramo, y se
// le dice desde dónde seguir. Cada respuesta es corta y no se trunca.
var CONC_TANDA = 45;          // movimientos por llamada
var CONC_MAX_VUELTAS = 40;    // tope de seguridad: hasta 1.800 movimientos

async function _concPreparar(file){
  var prep=await _iaDesdeBlob(file, file.name);
  if(!prep || !prep.bloques || !prep.bloques.length)
    throw new Error('No se pudo leer '+file.name);
  // Si el archivo no se pudo interpretar, se dice AQUÍ y con claridad. Antes
  // se mandaba igual a la IA y el fallo aparecía después, disfrazado de
  // error de JSON con caracteres raros.
  if(prep.nota){
    throw new Error('No se pudo leer "'+file.name+'". '
      +'El extracto tiene que ser PDF, Excel (.xlsx/.xls) o CSV. '
      +'Si es un Excel antiguo o está protegido, ábrelo y vuelve a guardarlo '
      +'como .xlsx.');
  }
  // Un PDF muy pesado no lo admite la IA y el fallo aparece después,
  // disfrazado. Mejor decirlo aquí.
  try{
    var mb=(file.size||0)/1024/1024;
    console.log('[conciliación] leyendo '+file.name+' · '+mb.toFixed(1)+' MB · '
      +(file.type||'sin tipo'));
    if(mb>28){
      throw new Error('"'+file.name+'" pesa '+mb.toFixed(1)+' MB y no se puede '
        +'procesar entero. Súbelo en Excel o CSV, o divide el PDF por quincenas.');
    }
  }catch(e){ if(e && e.message && e.message.indexOf('pesa')>=0) throw e; }
  return (prep.bloques.length===1)?prep.bloques[0]:prep.bloques;
}

async function _concLeerTanda(contenido, cual, cuenta, mes, anio, desde, nombre){
  var comun=''
    +'Devolve SOLO un JSON valido, sin explicaciones ni markdown, con esta forma:\n'
    +'{"saldo_inicial":0,"saldo_final":0,"fin":false,"movimientos":[{"fecha":"AAAA-MM-DD",'
    +'"detalle":"...","referencia":"...","debito":0,"credito":0,"saldo":0}]}\n\n'
    +'NO interpretes ni calcules nada: copia los numeros tal como estan en el documento.\n'
    +'  debito  = lo que figura en la columna de debito (0 si esa fila no tiene).\n'
    +'  credito = lo que figura en la columna de credito (0 si esa fila no tiene).\n'
    +'  saldo   = el saldo que muestra ESA fila (0 si el documento no lo trae).\n'
    +'Manten las filas EN EL MISMO ORDEN en que aparecen en el documento.\n\n'
    +'IMPORTANTE - LEES POR TANDAS:\n'
    +'Devolve como maximo '+CONC_TANDA+' movimientos en esta respuesta.\n'
    +(desde
      ? ('Ya se leyeron los movimientos hasta este, INCLUIDO:\n'
         +'   fecha "'+desde.fecha+'", detalle "'+String(desde.detalle||'').slice(0,70)+'"'
         +(desde.saldo!=null?(', saldo '+desde.saldo):'')+'\n'
         +'Empeza EXACTAMENTE en el siguiente y no repitas ninguno anterior.\n'
         +'saldo_inicial y saldo_final pueden ir en 0 en esta tanda.\n')
      : 'Empeza por el PRIMER movimiento del documento.\n')
    +'Poné "fin":true solo si con esta tanda llegaste al ULTIMO movimiento del documento.\n\n'
    +'No inventes movimientos ni montos. Incluye TODOS los del tramo, tambien los\n'
    +'cargos chicos del banco (comisiones, timbres, IVA, ITBMS, anualidades).\n';

  var especifico = (cual==='extracto')
    ? ('Es un EXTRACTO BANCARIO de la cuenta '+cuenta+'.\n')
    : ('Es un LIBRO MAYOR de SAP Business One de la cuenta bancaria '+cuenta+'.\n'
       +'saldo_inicial es el "Periodic Opening Balance" y saldo_final el '
       +'"Periodic Closing Balance".\n');

  var prompt=especifico+'Periodo: '+MESES_ES[mes]+' '+anio+'.\n\n'+comun;

  var resp=await fetch('https://api.anthropic.com/v1/messages',{
    method:'POST',
    headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,
             'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
    body:JSON.stringify({model:IA_MODELO, max_tokens:8000,
      messages:[{role:'user', content:[contenido, {type:'text', text:prompt}]}]})
  });
  // Se lee como TEXTO y luego se interpreta. Al revés no funciona: json()
  // consume el cuerpo, y si falla, el text() posterior devuelve vacío y no
  // hay forma de ver qué llegó. Por eso el aviso no decía nada útil.
  var data, crudoTxt='';
  try{
    crudoTxt=await resp.text();
    data=JSON.parse(crudoTxt);
  }catch(errJ){
    // Sin esto, una respuesta que no sea JSON hace saltar el error con los
    // bytes crudos dentro y en pantalla sale "Unexpected token '\uFFFD'".
    var crudo=crudoTxt;
    console.error('[IA] estado '+resp.status
      +' · tipo: '+((resp.headers&&resp.headers.get&&resp.headers.get('content-type'))||'?')
      +' · '+String(crudo||'').length+' caracteres recibidos');
    console.error('[IA] primeros 300: '
      +String(crudo||'').replace(/[^\x20-\x7E]/g,'·').slice(0,300));
    console.error('[IA] error original: '+((errJ&&errJ.message)||errJ));
    throw new Error(
      resp.status===413 ? 'El documento es demasiado grande para la IA. '
                         +'Súbelo en Excel o CSV, o divídelo.'
    : resp.status===401 ? 'La clave de la IA no es válida o caducó.'
    : resp.status===429 ? 'La IA está saturada. Prueba dentro de un minuto.'
    : resp.status>=500  ? 'La IA no respondió bien (error '+resp.status+').'
    : (resp.status===200
        ? ('La IA respondió, pero el navegador no pudo leer la respuesta. '
           +'Suele ser una extensión del navegador o un antivirus que se '
           +'interponen. Prueba en una ventana de incógnito. En la consola '
           +'queda el detalle de lo que llegó.')
        : 'La IA devolvió una respuesta ilegible (estado '+resp.status+').'));
  }
  if(data.error) throw new Error(data.error.message||'Error de IA');
  var txt=(data.content||[]).map(function(c){ return c.text||''; }).join('').trim();
  txt=txt.replace(/```json|```/g,'').trim();
  var i=txt.indexOf('{');
  if(i<0) throw new Error('La IA no devolvió datos de '+nombre);
  return _concParsear(txt.slice(i), nombre);
}

async function _concLeer(file, cual, cuenta, mes, anio, aviso){
  var contenido=await _concPreparar(file);
  var todos=[], desde=null, ini=null, fin=null, cortado=false, vacias=0;

  for(var v=0; v<CONC_MAX_VUELTAS; v++){
    if(aviso) aviso(todos.length, cual);
    var o=await _concLeerTanda(contenido, cual, cuenta, mes, anio, desde, file.name);
    var ms=(o.movimientos||[]).map(function(m){
      var deb=Math.abs(Number(m.debito)||0), cre=Math.abs(Number(m.credito)||0);
      var monto=Number(m.monto);
      if(!isFinite(monto) || (deb||cre)) monto=cre-deb;
      return {fecha:String(m.fecha||''), detalle:String(m.detalle||''),
              ref:String(m.referencia||''), monto:monto||0,
              saldo:(m.saldo==null||m.saldo===''||m.saldo===0)?null:Number(m.saldo)};
    });

    if(v===0){
      if(isFinite(Number(o.saldo_inicial)) && Number(o.saldo_inicial)!==0) ini=Number(o.saldo_inicial);
    }
    if(isFinite(Number(o.saldo_final)) && Number(o.saldo_final)!==0) fin=Number(o.saldo_final);
    if(o.__cortado) cortado=true;

    // Se descartan los que ya estaban: si la IA repite, no se duplican
    var nuevos=ms.filter(function(m){
      return !todos.some(function(t){
        return t.fecha===m.fecha && t.detalle===m.detalle
            && Math.abs(t.monto-m.monto)<0.005
            && (t.saldo==null||m.saldo==null||Math.abs(t.saldo-m.saldo)<0.005);
      });
    });
    todos=todos.concat(nuevos);

    if(!nuevos.length){
      // Sin movimientos nuevos: puede ser el final o que repitió la tanda.
      // Se insiste dos veces antes de darlo por terminado.
      vacias++;
      if(vacias>=3) break;
      continue;
    }
    vacias=0;
    desde=todos[todos.length-1];

    // NO se corta por "fin":true ni porque la tanda venga corta. Esas dos
    // señales daban por terminado el extracto a mitad: primero en el día 6 y
    // después en el 26. La única parada fiable es dejar de encontrar
    // movimientos nuevos.
    // Con una excepción: si el saldo de la última fila leída coincide con el
    // saldo final del documento, se llegó de verdad al final.
    if(o.fin===true && fin!=null && desde && desde.saldo!=null
       && Math.abs(desde.saldo-fin)<0.02) break;
  }

  var o2={saldo_inicial:(ini==null?0:ini), saldo_final:(fin==null?0:fin),
          movimientos:todos.filter(function(m){ return m.monto!==0 || m.saldo!=null; })};
  if(cortado) o2.__cortado=true;

  // Comprobación de que se llegó al final: el saldo de la última fila leída
  // tiene que ser el saldo final del documento. Si no, faltan movimientos y
  // hay que decirlo: una conciliación sobre un extracto incompleto engaña.
  var ult=o2.movimientos[o2.movimientos.length-1];
  if(fin!=null && ult && ult.saldo!=null && Math.abs(ult.saldo-fin)>0.02){
    o2.__incompleto={leido:ult.saldo, esperado:fin, hasta:ult.fecha};
  }
  _concCorregirPorSaldo(o2);
  o2.movimientos=o2.movimientos.filter(function(m){ return m.monto!==0; });
  return o2;
}

// Lee el JSON de la IA aunque venga cortado. Con extractos largos la
// respuesta puede terminarse a mitad de un movimiento; en ese caso se
// recuperan los que estén completos en vez de perder todo el trabajo.
function _concParsear(txt, nombre){
  try{ return JSON.parse(txt); }catch(e){}

  // Cerrar por las bravas suele bastar cuando solo faltó el final
  var t=txt.replace(/,\s*$/,'');
  for(var cierre of ['}]}', ']}', '}}', '}']){
    try{ return JSON.parse(t+cierre); }catch(e){}
  }

  // Si no, se recortan los movimientos completos uno a uno
  var im=txt.indexOf('"movimientos"');
  var ia=(im>=0)?txt.indexOf('[', im):-1;
  if(ia>=0){
    var ultimo=-1, prof=0;
    for(var k=ia;k<txt.length;k++){
      var c=txt[k];
      if(c==='{') prof++;
      else if(c==='}'){ prof--; if(prof===0) ultimo=k; }
      else if(c===']' && prof===0) break;
    }
    if(ultimo>0){
      var cab=txt.slice(0, ia+1);
      var cuerpo=txt.slice(ia+1, ultimo+1);
      try{
        var o=JSON.parse(cab+cuerpo+']}');
        console.warn('[conciliación] la respuesta de '+nombre+' venía cortada: '
          +'se recuperaron '+(o.movimientos||[]).length+' movimientos');
        o.__cortado=true;
        return o;
      }catch(e){}
    }
  }
  throw new Error('La IA devolvió una respuesta cortada o mal formada para '+nombre
    +'. Probá de nuevo; si el extracto es muy largo, subilo en Excel o CSV.');
}

// ── El saldo manda ────────────────────────────────────────────────────
// Cada fila del extracto trae el saldo después del movimiento. La diferencia
// entre dos saldos consecutivos ES el movimiento, con su signo verdadero.
// Con eso se corrigen los débitos y créditos que la IA haya leído al revés
// (le pasó con ALMACEN RODRIGUEZ y las transferencias) y se deduce el saldo
// inicial aunque el documento no lo diga.
function _concCorregirPorSaldo(o){
  var ms=o.movimientos||[];
  var conSaldo=ms.filter(function(m){ return m.saldo!=null && isFinite(m.saldo); });
  if(conSaldo.length < 3) return;          // sin saldos no hay nada que comprobar

  // El documento puede venir del más nuevo al más viejo: se prueban los dos
  // sentidos y gana el que encadene mejor.
  function puntuar(arr){
    var ok=0;
    for(var i=1;i<arr.length;i++){
      if(arr[i].saldo==null || arr[i-1].saldo==null) continue;
      var d=arr[i].saldo-arr[i-1].saldo;
      if(Math.abs(Math.abs(d)-Math.abs(arr[i].monto))<0.02) ok++;
    }
    return ok;
  }
  var normal=ms.slice(), invertido=ms.slice().reverse();
  var usar=(puntuar(invertido) > puntuar(normal)) ? invertido : normal;
  if(puntuar(usar) < Math.floor((usar.length-1)*0.6)) return;   // no encadena: se deja como está

  var corregidos=0;
  for(var i=1;i<usar.length;i++){
    if(usar[i].saldo==null || usar[i-1].saldo==null) continue;
    var d=Math.round((usar[i].saldo-usar[i-1].saldo)*100)/100;
    if(Math.abs(Math.abs(d)-Math.abs(usar[i].monto))<0.02 && d!==usar[i].monto){
      usar[i].monto=d; corregidos++;
    }
  }

  // El saldo inicial sale de la primera fila: saldo mostrado menos su movimiento
  if(usar[0] && usar[0].saldo!=null){
    var ini=Math.round((usar[0].saldo-usar[0].monto)*100)/100;
    var declarado=Number(o.saldo_inicial);
    if(!isFinite(declarado) || Math.abs(declarado-ini)>0.02){
      // Si el declarado no encaja con la cadena, puede que la primera fila
      // tenga el signo cambiado: se prueba al revés.
      var alt=Math.round((usar[0].saldo+usar[0].monto)*100)/100;
      if(isFinite(declarado) && Math.abs(declarado-alt)<0.02){ usar[0].monto=-usar[0].monto; }
      else { o.saldo_inicial=ini; }
    }
  }
  // Y el final es el saldo de la última fila
  var ult=usar[usar.length-1];
  if(ult && ult.saldo!=null) o.saldo_final=ult.saldo;

  o.movimientos=usar;
  if(corregidos) console.info('[conciliación] '+corregidos
    +' movimiento(s) corregidos con el saldo del documento');
}

// ── El cruce ──────────────────────────────────────────────────────────
// Empareja por importe y signo. La fecha no tiene que coincidir, pero entre
// varios candidatos del mismo importe se elige el de fecha más cercana.
function _concCruzar(banco, libro){
  var B=(banco.movimientos||[]).map(function(m,i){ return Object.assign({},m,{i:i,par:null}); });
  var L=(libro.movimientos||[]).map(function(m,i){ return Object.assign({},m,{i:i,par:null}); });

  function dias(a,b){
    var x=Date.parse(a), y=Date.parse(b);
    if(isNaN(x)||isNaN(y)) return 999;
    return Math.abs(x-y)/86400000;
  }

  B.forEach(function(b){
    var mejor=null, mejorD=1e9;
    L.forEach(function(l){
      if(l.par!==null) return;
      if(Math.abs(l.monto-b.monto)>0.005) return;
      var d=dias(b.fecha,l.fecha);
      if(d<mejorD){ mejorD=d; mejor=l; }
    });
    if(mejor){ b.par=mejor; mejor.par=b; b.dist=mejorD; }
  });

  var conciliados=B.filter(function(x){ return x.par; });
  var soloBanco  =B.filter(function(x){ return !x.par; });
  var soloLibro  =L.filter(function(x){ return !x.par; });

  var sumB=function(a){ return a.reduce(function(s,x){ return s+x.monto; },0); };
  var difSaldos=(Number(banco.saldo_final)||0)-(Number(libro.saldo_final)||0);

  // ── Partidas que se compensan entre sí ──
  // Una corrección se registra en el libro con el signo contrario al del
  // banco: el banco carga -16.292 y el libro anota +16.292. El emparejado
  // normal exige el MISMO signo, así que las dejaba sueltas, y al restarlas
  // el importe se contaba dos veces (16.292 × 2 = 32.584 de descuadre
  // fantasma) aunque los dos saldos coincidieran.
  var compensadas=[];
  soloBanco.slice().forEach(function(mb){
    if(mb.__comp) return;
    var mismoImporte=soloLibro.filter(function(ml){
      return !ml.__comp
          && Math.abs(Math.abs(ml.monto)-Math.abs(mb.monto))<0.01
          && (ml.monto>0)!==(mb.monto>0);      // signo contrario
    });
    if(!mismoImporte.length) return;
    var ml=mismoImporte[0];
    mb.__comp=1; ml.__comp=1;
    compensadas.push({banco:mb, libro:ml, monto:Math.abs(mb.monto)});
  });

  var bancoLibre=soloBanco.filter(function(x){ return !x.__comp; });
  var libroLibre=soloLibro.filter(function(x){ return !x.__comp; });
  var netoSinConciliar=sumB(bancoLibre)-sumB(libroLibre);

  return {
    banco:banco, libro:libro,
    conciliados:conciliados, soloBanco:soloBanco, soloLibro:soloLibro,
    // Las que se compensan siguen listadas, pero no cuentan para el descuadre
    compensadas:compensadas,
    totalBanco:sumB(B), totalLibro:sumB(L),
    difSaldos:difSaldos, netoSinConciliar:netoSinConciliar,
    cuadra:Math.abs(difSaldos-netoSinConciliar)<0.01,
    descuadre:difSaldos-netoSinConciliar
  };
}

async function _concConciliar(){
  var st=window._concEstado;
  var fuente=st.extracto;
  if(!fuente && st.extractoGuardado){
    // Se recupera el archivado, para poder rehacer la conciliación de un mes
    try{
      var rr=await fetch(_concUrlExtracto(st.extractoGuardado));
      if(rr.ok){
        var bb=await rr.blob();
        // El nombre importa: por su extensión se decide cómo leerlo. Si se
        // usa 'extracto.pdf' por defecto y el archivo era un Excel, se manda
        // como PDF y la lectura falla con caracteres raros.
        var nom = st.extractoGuardado.nombre_archivo
               || String(st.extractoGuardado.ruta||'').split('/').pop()
               || 'extracto';
        if(!/\.[a-z0-9]{2,5}$/i.test(nom)){
          var t=(bb.type||'').toLowerCase();
          nom += /pdf/.test(t) ? '.pdf'
               : /sheet|excel/.test(t) ? '.xlsx'
               : /csv/.test(t) ? '.csv' : '.pdf';
        }
        fuente=new File([bb], nom, {type:bb.type});
        console.log('[conciliación] extracto recuperado: '+nom+' ('+(bb.type||'sin tipo')+')');
      }
    }catch(e){ console.warn('[conciliación] bajar extracto:', e); }
  }
  if(!fuente){ showT('Sube el extracto del banco de ese mes'); return; }
  st.extracto=fuente;
  var out=document.getElementById('conc-res');
  out.innerHTML='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);padding:20px;text-align:center;font-size:12.5px;color:var(--text-muted)">'
    +'<span class="ai-ring g" style="vertical-align:-2px"></span> Leyendo los dos documentos…</div>';

  try{
    var banco=await _concLeer(st.extracto,'extracto',st.cuenta,st.mes,st.anio,
      function(n){
        out.innerHTML='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
          +'border-radius:var(--radius);padding:20px;text-align:center;font-size:12.5px;'
          +'color:var(--text-muted)"><span class="ai-ring g" style="vertical-align:-2px"></span> '
          +'Leyendo el extracto… '+(n?(n+' movimientos hasta ahora'):'')+'</div>';
      });
    out.innerHTML='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
      +'border-radius:var(--radius);padding:20px;text-align:center;font-size:12.5px;color:var(--text-muted)">'
      +'<span class="ai-ring g" style="vertical-align:-2px"></span> Extracto leído ('
      +banco.movimientos.length+' movimientos). Buscando el libro mayor…</div>';

    // Primero SAP: es el dato de origen y no hay que subir nada
    var libro=null;
    try{ libro=await _concLibroDeSAP(st.cuenta, st.mes, st.anio); }
    catch(e){ console.warn('[conciliación] libro de SAP:', e); }

    if(!libro) throw new Error('El libro mayor de '+st.cuenta+' para '
      +MESES_ES[st.mes]+' '+st.anio+' todavía no está en Supabase. '
      +'Lo trae el worker desde SAP una vez por hora: revisa que esté corriendo.');

    if(libro.sinMovimientos){
      showT('En SAP esta cuenta no tuvo movimientos en '+MESES_ES[st.mes]+' '+st.anio+'. '
        +(libro.saldoDe
           ? ('El saldo del libro se arrastra desde '+libro.saldoDe+': '+_concFmt2(libro.saldo_final)+'.')
           : (libro.saldo_final
              ? ''
              : 'No hay ningún saldo anterior guardado en SAP, así que el libro parte de cero: '
                +'si el banco trae saldo, esa será toda la diferencia.'))
        +' Lo que traiga el banco quedará como partida por registrar.', 12000);
    }

    if(banco.__incompleto){
      var inc=banco.__incompleto;
      showT('Ojo: el extracto quedó leído solo hasta el '+(inc.hasta||'?')
        +'. El saldo llega a '+_concFmt2(inc.leido)+' y el documento cierra en '
        +_concFmt2(inc.esperado)+': faltan movimientos.', 12000);
    } else if(banco.__cortado){
      showT('Ojo: la lectura del extracto quedó incompleta. '
        +'Revisa que estén todos los movimientos.', 9000);
    }
    var res=_concCruzar(banco, libro);
    res.cortado=!!banco.__cortado;
    res.cuenta=st.cuenta; res.mes=st.mes; res.anio=st.anio;
    res.fecha=new Date().toLocaleString('es');
    res.por=(CU&&CU.name)||'';
    st.res=res;
    out.innerHTML=_concResultadoHTML(res);
  }catch(e){
    console.warn('[conciliación]', e);
    out.innerHTML='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;'
      +'padding:12px;font-size:12px;color:var(--t-marron)"><i class="ti ti-alert-circle"></i> '
      +'No se pudo conciliar: '+_esc(e.message||e)+'</div>';
  }
}

// ── El resultado ──────────────────────────────────────────────────────
function _concResultadoHTML(r){
  var f=_concFmt2;
  var nom=(window._concCtaNombre&&window._concCtaNombre[r.cuenta])||r.cuenta;

  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);padding:14px;margin-bottom:12px">'
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:8px">'
      +'<div><div style="font-size:13.5px;font-weight:700">'+_esc(nom)+' · '
        +MESES_ES[r.mes]+' '+r.anio+'</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">Conciliado el '
        +_esc(r.fecha||'')+(r.por?(' por '+_esc(r.por)):'')
        +(r.guardada?' · <span style="color:var(--text-success)">guardada</span>':'')+'</div></div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap">'
        +'<button class="btn bg2" style="padding:5px 11px;font-size:11.5px" onclick="_concCopiar()">'
          +'<i class="ti ti-copy"></i> Copiar</button>'
        +'<button class="btn bp" style="padding:5px 11px;font-size:11.5px" onclick="_concGuardar()">'
          +'<i class="ti ti-device-floppy"></i> Guardar</button>'
        +(r.guardada?('<button class="btn bg2" style="padding:5px 11px;font-size:11.5px;'
          +'color:var(--text-danger)" onclick="_concBorrarConciliacion()">'
          +'<i class="ti ti-trash"></i> Borrar</button>'):'')
      +'</div></div>'

    + _concVeredictoHTML(r)

    +'<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(155px,1fr));gap:9px;margin-top:12px">'
      + _concKpi('Saldo del libro (SAP)', f(r.libro.saldo_final), '#72243E')
      + _concKpi('Saldo del banco', f(r.banco.saldo_final), '#0c447c')
      + _concKpi('Diferencia', f(r.difSaldos), r.cuadra?'#166534':'#B45309')
      + _concKpi('Pendiente de registrar', f(r.netoSinConciliar), r.cuadra?'#B45309':'#991b1b')
    +'</div></div>';

  // Comentarios: lo que la persona quiera dejar dicho sobre este mes
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);padding:12px;margin-bottom:12px">'
    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">'
    +'Comentarios de la conciliación (se guardan en el PDF)</label>'
    +'<textarea id="conc-coment" rows="3" placeholder="Por ejemplo: los timbres y comisiones '
    +'se asientan en el cierre; el pago del pedido 1037422 queda pendiente de aplicar." '
    +'style="width:100%;padding:9px 11px;border:1px solid var(--border);border-radius:8px;'
    +'font-size:12px;margin-top:4px;font-family:var(--font-sans);resize:vertical">'
    +_esc(r.comentarios||'')+'</textarea></div>';

  // Otros detalles: lo que acompaña a la conciliación y conviene tener a
  // mano al volver a consultar el mes. Por ejemplo, el informe acumulado de
  // intereses de Banistmo o el Excel del banco con las correcciones.
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);padding:12px;margin-bottom:12px">'
    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">'
    +'<i class="ti ti-paperclip"></i> Otros detalles y documentos de referencia</label>'
    +'<textarea id="conc-otros" rows="3" placeholder="Por ejemplo: el informe acumulado '
    +'de intereses del mes, o el Excel del banco con las correcciones aplicadas." '
    +'style="width:100%;padding:9px 11px;border:1px solid var(--border);border-radius:8px;'
    +'font-size:12px;margin-top:4px;font-family:var(--font-sans);resize:vertical">'
    +_esc(r.otros_detalles||'')+'</textarea>'
    + _concOtrosAdjuntos()
    +'</div>';

  // ── Las dos columnas, una al lado de la otra ──
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(330px,1fr));gap:12px">'
    + _concColumna('Libro mayor · SAP', '#72243E', r.libro, r.soloLibro,
        'Sin asiento correspondiente en el banco')
    + _concColumna('Extracto del banco', '#0c447c', r.banco, r.soloBanco,
        'Sin registrar en el libro mayor')
    +'</div>';
  return h;
}

// Uno de los cuatro números de arriba
function _concKpi(t, v, c){
  return '<div style="background:var(--surface-1);border:0.5px solid var(--border);'
    +'border-radius:9px;padding:9px 11px">'
    +'<div style="font-size:9.5px;text-transform:uppercase;letter-spacing:.4px;'
    +'color:var(--text-muted)">'+t+'</div>'
    +'<div style="font-size:15px;font-weight:700;color:'+c+';margin-top:2px">'+v+'</div></div>';
}

// El veredicto. Hay TRES estados, no dos: que la aritmética cierre no
// significa que esté todo registrado. Los cargos del banco que faltan en SAP
// hacen que la conciliación cuadre igual —explican la diferencia— pero
// siguen siendo trabajo pendiente, y decir solo "cuadra" lo escondía.
// El análisis en frases sueltas. Una sola fuente para la pantalla, el PDF y
// el texto que se copia: si cambia el criterio, cambian los tres a la vez.
function _concAnalisis(r){
  var f=_concFmt2;
  // Las que se compensan entre sí no son trabajo pendiente: ya están en los
  // dos lados. Contarlas hacía que el aviso pidiera registrar algo que ya
  // estaba registrado.
  var nComp=((r.compensadas||[]).length)*2;
  var pend=Math.max(0, r.soloBanco.length+r.soloLibro.length-nComp);
    // Las que se compensan ya se explican aparte: si se listaran otra vez
  // como "sin registrar", parecería que hay que asentarlas.
  var bancoPend=r.soloBanco.filter(function(m){ return !m.__comp; });
  var libroPend=r.soloLibro.filter(function(m){ return !m.__comp; });
var cargos=bancoPend.filter(function(m){ return _concEs(m.detalle); });
  var otros =bancoPend.filter(function(m){ return !_concEs(m.detalle); });
  var sum=function(a){ return a.reduce(function(s,x){ return s+x.monto; },0); };

  var o={titulo:'', explica:'', detalles:[], estado:''};

  // Lo primero que se dice: las partidas que se anulan entre sí. Es lo que
  // antes salía como un descuadre enorme sin explicación.
  var comp=r.compensadas||[];
  if(comp.length){
    var totalComp=comp.reduce(function(a,c){ return a+c.monto; },0);
    o.detalles.push({
      n:comp.length, monto:totalComp,
      texto:comp.length+' partida(s) se compensan entre sí por '+f(totalComp)
        +': el banco y el libro llevan el mismo importe con signo contrario, '
        +'que es como se registra una corrección. '
        +comp.map(function(c){
            return (c.banco.fecha||'')+' '+String(c.banco.detalle||'').slice(0,40)
              +' contra '+(c.libro.fecha||'')+' '+String(c.libro.detalle||'').slice(0,40);
          }).join(' · ')
    });
  }

  if(!r.cuadra){
    o.estado='descuadre';
    o.titulo='No cuadra: quedan '+f(r.descuadre)+' sin explicar';
    o.explica='La diferencia entre los dos saldos no coincide con las partidas sin conciliar. '
      +'Puede faltar un movimiento por leer en el extracto, o un asiento por traer de SAP.';
  } else if(!pend){
    o.estado='limpia';
    o.titulo='Conciliada y sin pendientes';
    o.explica='Todos los movimientos cruzaron y los dos saldos coinciden. '
      +'No queda nada por registrar.';
  } else {
    o.estado='pendientes';
    o.titulo='Los saldos se explican, pero quedan '+pend+' partida(s) por registrar en SAP';
    o.explica='La diferencia de '+f(r.difSaldos)+' entre los dos saldos es exactamente lo que '
      +'falta asentar. La conciliación no está cerrada hasta que se registren.';
  }

  if(cargos.length) o.detalles.push({
    n:cargos.length, monto:sum(cargos),
    texto:cargos.length+' cargo(s) del banco por '+f(sum(cargos))+': '
      +cargos.map(function(x){ return x.detalle; }).join(', ')});
  if(otros.length) o.detalles.push({
    n:otros.length, monto:sum(otros),
    texto:otros.length+' movimiento(s) del banco sin registrar por '+f(sum(otros))+': '
      +otros.map(function(x){ return x.detalle; }).join(', ')});
  if(libroPend.length) o.detalles.push({
    n:libroPend.length, monto:sum(libroPend),
    texto:libroPend.length+' asiento(s) del libro que el banco no muestra, por '
      +f(sum(libroPend))});
  return o;
}

function _concVeredictoHTML(r){
  var f=_concFmt2;
  var an=_concAnalisis(r);
  var pend=(r.soloBanco.length+r.soloLibro.length);
  var cargos=r.soloBanco.filter(function(m){ return _concEs(m.detalle); });
  var otros =r.soloBanco.filter(function(m){ return !_concEs(m.detalle); });

  if(!r.cuadra){
    return '<div style="margin-top:12px;background:#FEE2E2;border:1px solid #dc2626;'
      +'border-radius:9px;padding:11px 13px">'
      +'<div style="font-size:13px;font-weight:700;color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> No cuadra: quedan '+f(r.descuadre)+' sin explicar</div>'
      +'<div style="font-size:11.5px;color:var(--t-rojo);margin-top:4px">'
      +'La diferencia entre los dos saldos no coincide con las partidas sin conciliar. '
      +'Puede faltar un movimiento por leer en el extracto, o un asiento por traer de SAP.'
      +'</div></div>';
  }

  if(!pend){
    return '<div style="margin-top:12px;background:var(--pastel-ok);border:1px solid #16a34a;'
      +'border-radius:9px;padding:11px 13px">'
      +'<div style="font-size:13px;font-weight:700;color:var(--t-verde)">'
      +'<i class="ti ti-circle-check"></i> Conciliada y sin pendientes</div>'
      +'<div style="font-size:11.5px;color:var(--t-verde);margin-top:4px">'
      +'Todos los movimientos cruzaron y los dos saldos coinciden. No queda nada por registrar.'
      +'</div></div>';
  }

  // Cuadra, pero hay trabajo pendiente
  var h='<div style="margin-top:12px;background:var(--pastel-aviso);border:1px solid #E9C08A;'
    +'border-radius:9px;padding:11px 13px">'
    +'<div style="font-size:13px;font-weight:700;color:var(--t-marron)">'
    +'<i class="ti ti-alert-circle"></i> Los saldos se explican, pero quedan '
    +pend+' partida(s) por registrar en SAP</div>'
    +'<div style="font-size:11.5px;color:var(--t-marron);margin-top:4px">'
    +'La diferencia de '+f(r.difSaldos)+' entre los dos saldos es exactamente lo que falta '
    +'asentar. La conciliación no está cerrada hasta que se registren.</div>';

  if(cargos.length){
    h+='<div style="font-size:11.5px;color:var(--t-marron);margin-top:7px">'
      +'<b>'+cargos.length+' cargo(s) del banco</b> por '
      +f(cargos.reduce(function(a,x){ return a+x.monto; },0))+': '
      +_esc(cargos.map(function(x){ return x.detalle; }).join(', '))+'</div>';
  }
  if(otros.length){
    h+='<div style="font-size:11.5px;color:var(--t-marron);margin-top:5px">'
      +'<b>'+otros.length+' movimiento(s)</b> por '
      +f(otros.reduce(function(a,x){ return a+x.monto; },0))+': '
      +_esc(otros.map(function(x){ return x.detalle; }).join(', '))+'</div>';
  }
  if(r.soloLibro.length){
    h+='<div style="font-size:11.5px;color:var(--t-marron);margin-top:5px">'
      +'<b>'+r.soloLibro.length+' asiento(s) del libro</b> que el banco no muestra, por '
      +f(r.soloLibro.reduce(function(a,x){ return a+x.monto; },0))+'</div>';
  }
  return h+'</div>';
}

function _concFmt2(v){
  return (v<0?'-':'')+'$'+Math.abs(Number(v)||0).toLocaleString('en-US',
    {minimumFractionDigits:2,maximumFractionDigits:2});
}

// Una de las dos mitades: todos sus movimientos, marcando los que no cruzaron
function _concColumna(titulo, color, lado, sinCruzar, notaSin){
  var f=_concFmt2;
  var sin={}; (sinCruzar||[]).forEach(function(m){ sin[m.i]=true; });
  var movs=(lado.movimientos||[]).map(function(m,i){ return Object.assign({},m,{i:i}); });

  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:var(--radius);overflow:hidden">'
    +'<div style="background:'+color+';color:#fff;padding:8px 12px;font-size:12px;font-weight:700">'
      + titulo
      +'<span style="float:right;font-weight:500">'+movs.length+' movimiento(s)</span></div>'

    +'<div style="display:flex;justify-content:space-between;padding:7px 12px;'
      +'background:var(--surface-1);font-size:11px;border-bottom:0.5px solid var(--border)">'
      +'<span>Saldo inicial <b>'+f(lado.saldo_inicial)+'</b></span>'
      +'<span>Saldo final <b>'+f(lado.saldo_final)+'</b></span></div>'

    +'<div style="max-height:520px;overflow-y:auto">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">';

  movs.forEach(function(m){
    var falta=sin[m.i];
    h+='<tr style="border-top:0.5px solid var(--border);'
      +(falta?'background:var(--pastel-aviso)':'')+'">'
      +'<td style="padding:5px 4px 5px 10px;width:16px;vertical-align:top">'
        +(falta?'<i class="ti ti-alert-triangle" style="color:var(--t-ambar);font-size:12px"></i>'
               :'<i class="ti ti-check" style="color:var(--t-verde3);font-size:12px"></i>')+'</td>'
      +'<td style="padding:5px 4px;white-space:nowrap;color:var(--text-muted);vertical-align:top">'
        +_esc(String(m.fecha||'').slice(5))+'</td>'
      +'<td style="padding:5px 6px;vertical-align:top">'+_esc(m.detalle||'')
        +(falta&&_concEs(m.detalle)
          ? ' <span style="font-size:9px;background:#FEF3C7;color:var(--t-marron);border-radius:6px;'
            +'padding:1px 6px;font-weight:700">CARGO DEL BANCO</span>' : '')
      +'</td>'
      +'<td style="padding:5px 10px 5px 4px;text-align:right;white-space:nowrap;font-weight:600;'
        +'color:'+(m.monto<0?'#991b1b':'#166534')+';vertical-align:top">'+f(m.monto)+'</td></tr>';
  });

  h+='</table></div>';

  if(sinCruzar && sinCruzar.length){
    h+='<div style="background:var(--pastel-aviso);border-top:1px solid #E9C08A;padding:8px 12px;'
      +'font-size:11px;color:var(--t-marron)">'
      +'<b>'+sinCruzar.length+' sin conciliar</b> · '+notaSin
      +' · neto '+f(sinCruzar.reduce(function(a,x){ return a+x.monto; },0))+'</div>';
  } else {
    h+='<div style="background:var(--pastel-ok);border-top:1px solid #16a34a;padding:8px 12px;'
      +'font-size:11px;color:var(--t-verde)"><i class="ti ti-circle-check"></i> '
      +'Todos sus movimientos cruzaron con el otro lado.</div>';
  }
  return h+'</div>';
}

// ── El PDF de la conciliación ─────────────────────────────────────────
// Deja constancia de lo que se vio en pantalla: los dos lados completos, qué
// cruzó y qué no, y los comentarios de quien la hizo. Se guarda junto al
// extracto para poder consultarla meses después sin rehacerla.
async function _concPDF(r, comentarios){
  var doc=new window.jspdf.jsPDF({unit:'pt', format:'a4', orientation:'landscape', compress:true});
  var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
  var M=28;
  var nom=(window._concCtaNombre&&window._concCtaNombre[r.cuenta])||r.cuenta;
  var f=function(v){ return (v<0?'-':'')+'$'+Math.abs(Number(v)||0)
    .toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); };

  function cabecera(pag){
    doc.setFillColor(114,36,62); doc.rect(0,0,W,52,'F');
    doc.setTextColor(255); doc.setFont('helvetica','bold'); doc.setFontSize(13);
    doc.text('CONCILIACIÓN BANCARIA', M, 24);
    doc.setFont('helvetica','normal'); doc.setFontSize(10);
    doc.text(nom+'  ·  '+MESES_ES[r.mes]+' '+r.anio, M, 40);
    doc.setFontSize(8);
    doc.text('KENNEDY CENTER CORP.', W-M, 24, {align:'right'});
    doc.text((r.fecha||'')+(r.por?('  ·  '+r.por):''), W-M, 40, {align:'right'});
    doc.setTextColor(20);
    if(pag>1){
      doc.setFontSize(8); doc.setTextColor(120);
      doc.text('continuación', W/2, 66, {align:'center'});
      doc.setTextColor(20);
    }
  }
  cabecera(1);

  // El veredicto y el análisis completo
  var an=_concAnalisis(r);
  var vCol=(an.estado==='descuadre')?[153,27,27]
          :(an.estado==='limpia')?[22,101,52]:[180,83,9];
  doc.setFillColor(vCol[0],vCol[1],vCol[2]);
  doc.roundedRect(M, 64, W-M*2, 22, 4, 4, 'F');
  doc.setTextColor(255); doc.setFont('helvetica','bold'); doc.setFontSize(10);
  doc.text(an.titulo, M+10, 79);
  doc.setTextColor(20);

  // La explicación y el desglose, que es lo que de verdad hay que leer
  var y=96;
  doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(70);
  var ex=doc.splitTextToSize(an.explica, W-M*2-6);
  doc.text(ex, M+3, y+8);
  y+=8+ex.length*10;

  an.detalles.forEach(function(d){
    doc.setFillColor(254,249,243);
    var ls=doc.splitTextToSize(d.texto, W-M*2-24);
    doc.roundedRect(M, y, W-M*2, 10+ls.length*10, 3, 3, 'F');
    doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(124,61,18);
    doc.text(ls, M+9, y+11);
    y+=14+ls.length*10;
  });
  doc.setTextColor(20);

  // Los cuatro números
  y+=6;
  var cw=(W-M*2-24)/4;
  [['Saldo del libro (SAP)', f(r.libro.saldo_final)],
   ['Saldo del banco',       f(r.banco.saldo_final)],
   ['Diferencia',            f(r.difSaldos)],
   ['Pendiente de registrar',f(r.netoSinConciliar)]].forEach(function(k,i){
    var x=M+i*(cw+8);
    doc.setDrawColor(210); doc.setLineWidth(0.6);
    doc.roundedRect(x, y, cw, 34, 4, 4, 'D');
    doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(120);
    doc.text(k[0], x+8, y+13);
    doc.setFont('helvetica','bold'); doc.setFontSize(12); doc.setTextColor(20);
    doc.text(k[1], x+8, y+27);
  });

  // Las dos columnas
  var top=y+48, colW=(W-M*2-14)/2, fila=13;
  if(top > H-160){ doc.addPage(); cabecera(2); top=80; }
  var lados=[
    {t:'LIBRO MAYOR · SAP', c:[114,36,62], d:r.libro, sin:r.soloLibro, x:M},
    {t:'EXTRACTO DEL BANCO', c:[12,68,124], d:r.banco, sin:r.soloBanco, x:M+colW+14}
  ];
  var maxFilas=Math.floor((H-top-60)/fila);
  var paginas=1;
  lados.forEach(function(L){
    paginas=Math.max(paginas, Math.ceil((L.d.movimientos||[]).length/maxFilas)||1);
  });

  for(var p=0; p<paginas; p++){
    if(p>0){ doc.addPage(); cabecera(p+1); }
    var ty=(p===0)?top:80;
    lados.forEach(function(L){
      var sin={}; (L.sin||[]).forEach(function(m){ sin[m.i]=true; });
      var movs=(L.d.movimientos||[]).map(function(m,i){ return Object.assign({},m,{i:i}); })
                .slice(p*maxFilas, (p+1)*maxFilas);
      doc.setFillColor(L.c[0],L.c[1],L.c[2]);
      doc.rect(L.x, ty, colW, 16, 'F');
      doc.setTextColor(255); doc.setFont('helvetica','bold'); doc.setFontSize(8);
      doc.text(L.t, L.x+7, ty+11);
      doc.text((L.d.movimientos||[]).length+' movimiento(s)', L.x+colW-7, ty+11, {align:'right'});
      doc.setTextColor(20);

      if(p===0){
        doc.setFont('helvetica','normal'); doc.setFontSize(7.5);
        doc.text('Saldo inicial '+f(L.d.saldo_inicial), L.x+7, ty+27);
        doc.text('Saldo final '+f(L.d.saldo_final), L.x+colW-7, ty+27, {align:'right'});
      }
      var ry=ty+(p===0?34:22);
      movs.forEach(function(m){
        if(sin[m.i]){ doc.setFillColor(254,249,243); doc.rect(L.x, ry-9, colW, fila, 'F'); }
        doc.setFont('helvetica','normal'); doc.setFontSize(6.5); doc.setTextColor(120);
        doc.text(sin[m.i]?'!':'ok', L.x+5, ry);
        doc.text(String(m.fecha||'').slice(5), L.x+16, ry);
        doc.setTextColor(20); doc.setFontSize(7);
        doc.text(String(m.detalle||'').slice(0,58), L.x+44, ry);
        doc.setFont('helvetica','bold');
        if(m.monto<0) doc.setTextColor(153,27,27); else doc.setTextColor(22,101,52);
        doc.text(f(m.monto), L.x+colW-7, ry, {align:'right'});
        doc.setTextColor(20);
        ry+=fila;
      });
    });
  }

  // Los comentarios, al final
  if(String(comentarios||'').trim()){
    doc.addPage(); cabecera(paginas+1);
    doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(20);
    doc.text('Comentarios', M, 80);
    doc.setFont('helvetica','normal'); doc.setFontSize(9);
    doc.text(doc.splitTextToSize(String(comentarios), W-M*2), M, 98);
  }

  // Pie con la numeración
  var tot=doc.getNumberOfPages();
  for(var q=1;q<=tot;q++){
    doc.setPage(q);
    doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(140);
    doc.text('Conciliación generada por el portal · '+(r.fecha||''), M, H-16);
    doc.text('Página '+q+' de '+tot, W-M, H-16, {align:'right'});
  }
  return doc;
}

// ── Guardar y copiar ──────────────────────────────────────────────────
function _concTexto(r){
  var f=function(v){ return (v<0?'-':'')+'$'+Math.abs(Number(v)||0).toFixed(2); };
  var L=[];
  L.push('CONCILIACIÓN BANCARIA · '+r.cuenta+' · '+MESES_ES[r.mes]+' '+r.anio);
  L.push('Hecha el '+(r.fecha||'')+(r.por?(' por '+r.por):''));
  L.push('');
  L.push('Saldo del banco:      '+f(r.banco.saldo_final));
  L.push('Saldo del libro:      '+f(r.libro.saldo_final));
  L.push('Diferencia:           '+f(r.difSaldos));
  L.push('Neto sin conciliar:   '+f(r.netoSinConciliar));
  var an=_concAnalisis(r);
  L.push('RESULTADO: '+an.titulo);
  L.push(an.explica);
  an.detalles.forEach(function(d){ L.push('  · '+d.texto); });
  function bloque(t, arr){
    if(!arr.length) return;
    L.push(''); L.push(t.toUpperCase()+' ('+arr.length+')');
    arr.forEach(function(m){
      L.push('  '+(m.fecha||'').padEnd(12)+f(m.monto).padStart(14)+'  '+(m.detalle||''));
    });
  }
  bloque('Solo en el banco', r.soloBanco);
  bloque('Solo en el libro mayor', r.soloLibro);
  L.push(''); L.push('Conciliados: '+r.conciliados.length+' partida(s)');
  return L.join('\n');
}

function _concCopiar(){
  var r=(window._concEstado||{}).res; if(!r) return;
  try{ navigator.clipboard.writeText(_concTexto(r)); showT('✓ Conciliación copiada'); }
  catch(e){ showT('No se pudo copiar'); }
}

// Borra la conciliación guardada de ese mes (el extracto no se toca)
async function _concBorrarConciliacion(){
  var st=window._concEstado, r=st&&st.res;
  var ref=(r&&r.referencia)||_concRefConc(st.cuenta, st.mes, st.anio);
  if(!confirm('¿Borrar la conciliación guardada de '+MESES_ES[st.mes]+' '+st.anio+'?\n\n'
    +'El extracto del banco no se borra: sigue archivado.')) return;
  try{
    var resp=await fetch(SB+'/rest/v1/conciliaciones?referencia=eq.'+encodeURIComponent(ref),{
      method:'DELETE', headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    if(!resp.ok){ showT('No se pudo borrar: '+resp.status); return; }
    if(r){ r.guardada=false; }
    showT('✓ Conciliación borrada');
    rConcil();
  }catch(e){ showT('No se pudo borrar: '+(e.message||e)); }
}

// Borra el extracto archivado de ese mes
async function _concBorrarExtracto(){
  var st=window._concEstado;
  var g=st&&st.extractoGuardado;
  if(!g){ showT('No hay extracto archivado de ese mes'); return; }
  if(!confirm('¿Borrar el extracto de '+MESES_ES[st.mes]+' '+st.anio+'?\n\n'
    +_esc(g.nombre_archivo||'')+'\n\nHabrá que volver a subirlo para conciliar ese mes.')) return;
  try{
    var resp=await fetch(SB+'/rest/v1/extractos_bancarios?clave=eq.'+encodeURIComponent(g.clave),{
      method:'DELETE', headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    if(!resp.ok){ showT('No se pudo borrar: '+resp.status); return; }
    st.extractoGuardado=null; st.extracto=null; st.res=null;
    showT('✓ Extracto borrado');
    rConcil();
  }catch(e){ showT('No se pudo borrar: '+(e.message||e)); }
}

function _concRefConc(cuenta, mes, anio){
  return 'CONC-'+anio+String(mes+1).padStart(2,'0')+'-'
    +String(cuenta).replace(/[^A-Za-z0-9]+/g,'').slice(0,16).toUpperCase();
}

async function _concGuardar(){
  var st=window._concEstado, r=st&&st.res;
  if(!r){ showT('Primero conciliá el mes'); return; }
  showT('Guardando…');
  var ref=_concRefConc(r.cuenta, r.mes, r.anio);

  // El comentario que se haya escrito viaja al PDF y a la base
  var coment=String(((document.getElementById('conc-coment')||{}).value)||'').trim();
  r.comentarios=coment;
  // Y los otros detalles, que se guardan en la misma fila
  var otros=String(((document.getElementById('conc-otros')||{}).value)||'').trim();
  r.otros_detalles=otros;

  // El PDF con todo lo que se ve en pantalla, archivado junto al extracto
  var pdfNombre='CONCILIACION '+((window._concCtaNombre&&window._concCtaNombre[r.cuenta])||r.cuenta)
    .replace(/[^\w .-]+/g,'')+' '+MESES_ES[r.mes]+' '+r.anio+'.pdf';
  try{
    var doc=await _concPDF(r, coment);
    var blob=doc.output('blob');
    var file=new File([blob], pdfNombre, {type:'application/pdf'});
    var pathPdf=await _subirDocStorage(ref, 'conciliacion', file);
    if(pathPdf){
      try{ await _registrarDoc(ref, 'conciliacion', file, pathPdf); }catch(e){}
      st.conciliacionPdf={nombre:pdfNombre, ruta:pathPdf};
    }
  }catch(e){
    console.warn('[conciliación] PDF:', e);
    showT('La conciliación se guarda, pero no se pudo generar el PDF: '+(e.message||e), 8000);
  }

  try{
    // on_conflict: rehacer la conciliación de un mes la reemplaza, no falla
    var resp=await fetch(SB+'/rest/v1/conciliaciones?on_conflict=referencia',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify({
        referencia:ref, cuenta:r.cuenta, mes:r.mes+1, anio:r.anio,
        saldo_banco:Number(r.banco.saldo_final)||0,
        saldo_libro:Number(r.libro.saldo_final)||0,
        diferencia:r.difSaldos, cuadra:r.cuadra,
        detalle:{conciliados:r.conciliados.length, soloBanco:r.soloBanco, soloLibro:r.soloLibro},
        comentarios:coment,
    otros_detalles: otros,
    otros_docs: JSON.stringify(window._concOtrosDocs||[]),
        pdf_nombre:(st.conciliacionPdf&&st.conciliacionPdf.nombre)||null,
        pdf_ruta:(st.conciliacionPdf&&st.conciliacionPdf.ruta)||null,
        hecha_por:(CU&&CU.name)||'', creado_en:new Date().toISOString()
      })
    });
    if(!resp.ok){
      var t=await resp.text();
      alert('Los documentos se archivaron, pero la conciliación no se pudo guardar.\n\n'
        +'Respuesta del servidor:\n'+t.slice(0,300)
        +'\n\nProbablemente falta la tabla "conciliaciones" (script conciliaciones.sql).');
      return;
    }
    r.guardada=true; r.referencia=ref;
    showT('✓ Conciliación guardada · el PDF queda junto al extracto', 7000);
    try{ await _concBuscarConciliacion(); }catch(e){}
    try{ rConcil(); }catch(e){}
  }catch(e){
    alert('No se pudo guardar: '+(e.message||e));
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  INSTRUCCIONES DE SHIPPING MARK PARA EL PROVEEDOR
//  No se genera nada: se le mandan al proveedor las PLANTILLAS de Kennedy
//  —el formato del shipping mark, el ejemplo de etiqueta de código de barras
//  y el dibujo de la caja— para que las use como referencia al marcar los
//  cartones. Van adjuntas en un correo con los destinatarios que se elijan.
// ═══════════════════════════════════════════════════════════════════════════

// Las plantillas van incrustadas para que el envío funcione sin depender de
// que estén subidas a ningún lado.
function _b64aBlob(b64, mime){
  var bin=atob(String(b64||''));
  var n=bin.length, arr=new Uint8Array(n);
  for(var i=0;i<n;i++) arr[i]=bin.charCodeAt(i);
  return new Blob([arr], {type:mime||'application/octet-stream'});
}

// ── Las plantillas que se le mandan al proveedor ──
// Antes viajaban dentro del propio archivo, en base64: eran 1,5 MB de los
// 3,3 que pesaba el portal, y se descargaban siempre aunque nadie pulsara
// el botón. Ahora viven en el bucket, junto al resto de documentos, y se
// bajan la primera vez que hacen falta.
var SM_TPL_RUTA='plantillas/';
var SM_TPL_ARCHIVOS=[
  {nombre:'SHIPPING MARK TEMPLATE - KENNEDY CENTER.xlsx',
   mime:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
  {nombre:'BARCODE LABEL EXAMPLE.pdf', mime:'application/pdf'},
  {nombre:'BOX DRAWING PRINT EXAMPLE.jpg', mime:'image/jpeg'},
  // El logo que va impreso en la caja: el proveedor lo necesita en alta
  // calidad para llevarlo a imprenta.
  {nombre:'KENNEDYS HOME LOGO.jpg', mime:'image/jpeg'}
];
window._smCache = window._smCache || null;

async function _smPlantillas(){
  if(window._smCache) return window._smCache;
  var out=[], fallos=[];
  for(var i=0;i<SM_TPL_ARCHIVOS.length;i++){
    var a=SM_TPL_ARCHIVOS[i];
    var url=DOCS_BASE+(SM_TPL_RUTA+a.nombre).split('/').map(encodeURIComponent).join('/');
    try{
      var r=await fetch(url);
      if(!r.ok){ fallos.push(a.nombre+' ('+r.status+')'); continue; }
      var b=await r.blob();
      if(!b || !b.size){ fallos.push(a.nombre+' (vacío)'); continue; }
      out.push({nombre:a.nombre, blob:b, mime:a.mime});
    }catch(e){ fallos.push(a.nombre+' ('+(e.message||e)+')'); }
  }
  if(fallos.length){
    console.error('[shipping mark] no se pudieron bajar: '+fallos.join(', ')
      +'. Tienen que estar en el bucket '+DOCS_BUCKET+', carpeta '+SM_TPL_RUTA);
  }
  // Solo se guarda en memoria si vinieron todas: si faltó alguna, la próxima
  // vez se vuelve a intentar en vez de mandarle al proveedor un envío corto.
  if(out.length===SM_TPL_ARCHIVOS.length) window._smCache=out;
  return out;
}

async function _smAbrir(ref){
  ref=String(ref||'').trim();
  showT('Preparando las plantillas…');
  var arch=await _smPlantillas();
  if(!arch.length){
    showT('No se pudieron cargar las plantillas. Mira la consola.');
    return;
  }
  if(arch.length<SM_TPL_ARCHIVOS.length){
    showT('Atención: solo se cargaron '+arch.length+' de '+SM_TPL_ARCHIVOS.length+' plantillas');
  }
  if(!arch.length){ showT('No están cargadas las plantillas de shipping mark'); return; }

  // Datos de la orden. Vale para una NO SAP y para una de SAP: en el segundo
  // caso se busca si vino de una NO SAP, porque el número que el proveedor
  // tiene que marcar en la caja es el DKC, no el docnum de SAP.
  var p=(window._pendSAP||[]).find(function(x){
    return String(x.dkc)===ref || String(x.num_orden)===ref; });
  if(!p){
    try{
      p=(window._pendSAP||[]).find(function(x){
        var o=_ordenSapDeNoSap(x);
        return o && String(o.id)===ref;
      });
    }catch(e){}
  }
  var o=(typeof orders!=='undefined')
    ? orders.find(function(x){ return String(x.id)===ref; }) : null;

  var prov=(p && p.proveedor) || (o && o.prov) || '';
  var dkc=String((p && (p.dkc||p.num_orden)) || (o && o.num_proveedor) || ref).toUpperCase();
  var po=(p && p.po) || (o && o.po) || '';

  // El correo del proveedor, si el portal lo conoce
  var correoProv='';
  try{ correoProv=_provEmailDeOrden(ref)||''; }catch(e){}

  var cuerpo=''
    +'Dear '+(prov||'Supplier')+',\n'
    +'\n'
    +'Please find attached our Shipping Marks Template for the following order:\n'
    +'\n'
    +'Supplier:      '+(prov||'')+'\n'
    +'Order No.:     '+dkc+'\n'
    +(po?('Your PO:       '+po+'\n'):'')
    +'\n'
    +'Please use the attached template as the model and prepare the shipping marks '
    +'for the complete order, following exactly the same format and information structure.\n'
    +'\n'
    +'Once all shipping marks are ready, please send them back to us for review and '
    +'final confirmation before printing.\n'
    +'\n'
    +'Please do not proceed with printing until you receive our approval.\n'
    +'\n'
    +'Thank you.\n'
    +'\n'
    +'Best regards,\n'
    +'\n'
    +((CU&&CU.name)||'')+'\n'
    +'KENNEDY CENTER CORP.';

  await _catMailAbrir(arch,
    'Shipping Marks Template \u2013 Supplier '+(prov||'')+' \u2013 Order #'+dkc,
    {para:correoProv, cuerpo:cuerpo, ref:ref});
}

// Lo que ya se le envió al proveedor de esta orden, para poder consultarlo
// La dirección real de un adjunto. Ojo: en los documentos guardados, `url`
// es la RUTA dentro del almacenamiento (12650/shipping_mark/…) y `data` es la
// dirección completa. Usar `url` a secas hacía que el navegador la buscara
// en el disco local y la descarga fallara.
function _docHref(a){
  if(!a) return '';
  var d=String(a.data||'');
  if(/^(https?:|data:|blob:)/i.test(d)) return d;
  var u=String(a.url||'');
  if(/^(https?:|data:|blob:)/i.test(u)) return u;
  var ruta=u||String(a.path||'');
  if(!ruta) return d||'';
  return DOCS_BASE + ruta.split('/').map(encodeURIComponent).join('/');
}

// Una sola línea con la cuenta; al pulsarla se abre la lista completa para
// verlos y descargarlos. Ocupa poco y no tapa las líneas de la orden.
function _smGuardadosHTML(ref){
  var lista=((window._atts||{})[String(ref)+'shipping_mark'])||[];
  lista=lista.filter(function(a){ return a && _docHref(a); });
  if(!lista.length) return '';
  return '<div onclick="_smVerGuardados(\'' + String(ref).replace(/'/g,'') + '\')" '
    +'title="Ver y descargar lo que se le envió al proveedor" '
    +'style="display:flex;align-items:center;gap:8px;cursor:pointer;background:#EEF2FF;'
    +'border:0.5px solid #C7D2FE;border-radius:9px;padding:9px 12px;margin-bottom:12px;'
    +'font-size:12px;font-weight:600;color:var(--t-indigo2)">'
    +'<i class="ti ti-box" style="font-size:15px"></i>'
    +'<span>Shipping marks enviados ('+lista.length+')</span>'
    +'<i class="ti ti-chevron-right" style="margin-left:auto;font-size:15px"></i>'
    +'</div>';
}

// La lista completa, en su propia ventana
function _smVerGuardados(ref){
  var lista=((window._atts||{})[String(ref)+'shipping_mark'])||[];
  lista=lista.filter(function(a){ return a && _docHref(a); });
  if(!lista.length){ showT('Esta orden no tiene shipping marks guardados'); return; }

  var prev=document.getElementById('modalSMFiles'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalSMFiles';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13650;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';

  var h='<div style="background:var(--surface-0);border-radius:14px;padding:18px;'
      +'max-width:620px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div><div style="font-size:14px;font-weight:700">'
        +'<i class="ti ti-box"></i> Shipping marks enviados</div>'
      +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">Orden '+_esc(String(ref))
        +' \u00b7 '+lista.length+' archivo(s)</div></div>'
      +'<button onclick="document.getElementById(\'modalSMFiles\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div><div style="display:flex;flex-direction:column;gap:6px">';

  lista.forEach(function(a){
    var u=_docHref(a);
    var ext=String(a.name||'').split('.').pop().toLowerCase();
    var ico=(ext==='pdf')?'ti-file-type-pdf'
           :(['xlsx','xls','csv'].indexOf(ext)>=0)?'ti-file-spreadsheet'
           :(['jpg','jpeg','png','gif','webp'].indexOf(ext)>=0)?'ti-photo':'ti-file';
    h+='<div style="display:flex;align-items:center;gap:9px;padding:9px 11px;'
      +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:9px">'
      +'<i class="ti '+ico+'" style="font-size:19px;color:var(--text-accent);flex-shrink:0"></i>'
      +'<span style="flex:1;font-size:12px;overflow:hidden;text-overflow:ellipsis;'
        +'white-space:nowrap">'+_esc(a.name||'archivo')+'</span>'
      +'<a href="'+_esc(u)+'" target="_blank" rel="noopener" title="Abrir" '
        +'style="color:var(--text-accent);text-decoration:none;font-size:11.5px;'
        +'border:0.5px solid var(--border);border-radius:7px;padding:4px 10px">'
        +'<i class="ti ti-eye"></i> Ver</a>'
      +'<a href="'+_esc(u)+'" download="'+_esc(a.name||'archivo')+'" title="Descargar" '
        +'style="color:var(--text-accent);text-decoration:none;font-size:11.5px;'
        +'border:0.5px solid var(--border);border-radius:7px;padding:4px 10px">'
        +'<i class="ti ti-download"></i> Bajar</a>'
      +'</div>';
  });

  h+='</div><div style="display:flex;justify-content:flex-end;margin-top:12px">'
    +'<button class="btn bg2" onclick="document.getElementById(\'modalSMFiles\').remove()">Cerrar</button>'
    +'</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{ _modalEsc(ov); }catch(e){}
}

// El botón, en la orden NO SAP
// Rojo mientras no se haya enviado nada, para que se vea que está pendiente.
// Una vez enviado pasa a verde y lleva entre paréntesis cuándo y quién lo hizo.
function _smBtn(ref){
  var r=String(ref||'').replace(/'/g,'');
  var lista=((window._atts||{})[String(ref)+'shipping_mark'])||[];
  lista=lista.filter(function(a){ return a && _docHref(a); });

  if(!lista.length){
    return '<button onclick="event.stopPropagation();_smAbrir(\'' + r + '\')" '
      +'title="Pendiente: enviar al proveedor las plantillas de shipping mark, etiqueta y dibujo de la caja" '
      +'style="background:var(--pastel-error);color:var(--t-rojo);border:0.5px solid #f0b4b4;border-radius:6px;'
      +'padding:5px 10px;font-size:11px;cursor:pointer;font-weight:600">'
      +'<i class="ti ti-box" style="font-size:11px"></i> Enviar shipping marks</button>';
  }

  // El último envío: de ahí salen la fecha, la hora y el usuario.
  // Las fechas se guardan como "19 ago 2026 · 14:32", que comparado como texto
  // da un orden equivocado entre meses distintos, así que se convierten.
  var _ord=function(a){
    var d=null;
    try{ d=parseDateStr(a&&a.date); }catch(e){}
    if(!d) return -1;
    var hm=String((a&&a.date)||'').match(/(\d{1,2}):(\d{2})/);
    return d.getTime() + (hm ? (Number(hm[1])*3600000 + Number(hm[2])*60000) : 0);
  };
  var ult=null, mejor=-2;
  lista.forEach(function(a){
    var v=_ord(a);
    if(v>=mejor){ mejor=v; ult=a; }
  });
  if(!ult) ult=lista[lista.length-1];
  var cuando=(ult&&ult.date)?String(ult.date):'';
  var quien=(ult&&ult.by)?String(ult.by):'';
  var detalle=[cuando, quien].filter(Boolean).join(' · ');

  return '<button onclick="event.stopPropagation();_smAbrir(\'' + r + '\')" '
    +'title="Ya se enviaron. Se puede volver a enviar." '
    +'style="background:var(--pastel-ok);color:var(--t-verde);border:0.5px solid #86D9AC;border-radius:6px;'
    +'padding:5px 10px;font-size:11px;cursor:pointer;font-weight:600">'
    +'<i class="ti ti-box-seam" style="font-size:11px"></i> Shipping marks enviados'
    +(detalle?(' <span style="font-weight:500;opacity:.9">('+_esc(detalle)+')</span>'):'')
    +'</button>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  CATÁLOGO DESDE UNA ORDEN DE SAP
//  Las órdenes NO SAP arman su catálogo con las fichas temporales que
//  crearon. Una orden de SAP no tiene fichas: sus artículos ya existen, así
//  que la ficha se arma al vuelo cruzando las líneas de la orden con el
//  inventario. De ahí en adelante es la misma pantalla de revisión, el mismo
//  PDF y el mismo envío por correo.
// ═══════════════════════════════════════════════════════════════════════════
async function _catDesdeOrdenSAP(docnum){
  docnum=String(docnum||'').trim();
  if(!docnum){ showT('Orden no válida'); return; }

  showT('Leyendo los artículos de la orden ' + docnum + '…');

  // 1) Las líneas de la orden (se aprovecha lo que ya haya en caché)
  var lineas=[];
  try{
    if(window._poCache && window._poCache[docnum]) lineas=window._poCache[docnum];
    else{
      var r=await fetch(SB+'/rest/v1/opor_lineas?select=*&docnum=eq.'
        +encodeURIComponent(docnum)+'&order=linenum.asc',{headers:SBH});
      if(r.ok) lineas=await r.json()||[];
    }
  }catch(e){ console.warn('[catálogo SAP] líneas:', e); }
  lineas=Array.isArray(lineas)?lineas:[];
  if(!lineas.length){ showT('Esta orden no tiene líneas para el catálogo'); return; }

  // La fecha de llegada vive en la CABECERA de la orden, no en las líneas.
  // Sin esto el catálogo salía con la ETA vacía.
  var _etaOrden='';
  try{
    var _o=(typeof orders!=='undefined')
      ? orders.find(function(x){
          return String(x.id)===String(docnum)
              || String(x.ref||'')===String(docnum)
              || String(x.docnum||'')===String(docnum); })
      : null;
    if(_o) _etaOrden=_o.fechaEst||'';
    // Si la orden no está cargada en el portal, se pide a la base
    if(!_etaOrden){
      // La cabecera de la orden de compra está en opor_ordenes, no en
      // pedidos: ahí la columna se llama "eta", y "duedate" es el respaldo.
      var _re=await fetch(SB+'/rest/v1/opor_ordenes?select=eta,duedate&docnum=eq.'
        +encodeURIComponent(docnum)+'&limit=1',{headers:SBH});
      if(_re.ok){
        var _p=(await _re.json()||[])[0]||{};
        var _v=_p.eta||_p.duedate||'';
        if(_v) _etaOrden=isoADisplay(String(_v).slice(0,10));
      }
    }
  }catch(e){ console.warn('[catálogo SAP] ETA:', e); }
  console.log('[catálogo SAP] ETA de la orden '+docnum+': '+(_etaOrden||'(sin fecha)'));

  // 2) Los datos de cada artículo, del inventario
  var codes=[], vistos={};
  lineas.forEach(function(l){
    var c=String(l.itemcode||'').trim();
    if(c && !vistos[c.toUpperCase()]){ vistos[c.toUpperCase()]=1; codes.push(c); }
  });
  var inv={};
  for(var i=0;i<codes.length;i+=200){
    var lote=codes.slice(i,i+200).map(function(c){ return '"'+c.replace(/"/g,'')+'"'; }).join(',');
    try{
      var ri=await fetch(SB+'/rest/v1/inventario?select='+_INV_CAMPOS
        +'&itemcode=in.('+encodeURIComponent(lote)+')&limit=200',{headers:SBH});
      if(ri.ok) (await ri.json()||[]).forEach(function(x){
        inv[String(x.itemcode||'').toUpperCase()]=x; });
    }catch(e){ console.warn('[catálogo SAP] inventario:', e); }
  }

  // 3) La ficha de cada línea. El costo sale del precio de la orden, que es
  //    el de esta compra en concreto y no un promedio.
  var filas=lineas.map(function(l){
    var sku=String(l.itemcode||'').trim();
    var x=inv[sku.toUpperCase()]||{};
    // La columna de opor_lineas se llama "precio", a secas. Con precio_unit
    // y price —que no existen— el costo salía en cero y la casilla de margen
    // respondía "sin costo". Detrás quedan los respaldos del inventario.
    var costo=Number(l.precio)||Number(l.precio_unit)||Number(l.price)
             ||Number(x.lastpurprc)||Number(x.avgprice)||Number(x.cif)||Number(x.fob)||0;
    return {
      tipo:'item',
      itemcode:sku,
      itemname:l.itemname||l.dscription||x.itemname||'',
      descripcion:x.itemname||l.itemname||l.dscription||'',
      marca:x.marca||'',
      _dept:String(x.grupo||'').replace(/^[.\s]+/,''),
      material:'', 
      color:x.u_color||'',
      tamano:x.u_tamano||'',
      medida:x.u_tamano||'',
      unidades_x_caja:x.unidadesbulto||x.salpackun||'',
      carton_size:'',
      peso:x.peso||'',
      cbm:x.volumen||'',
      barcode:x.codebars||'',
      precio:costo,                                   // costo, para el margen
      precio_venta:Number(x.precioventa)||0,
      disponible:_invDisp(x),
      por_llegar:Number(l.cantidad)||Number(l.quantity)||0,
      // Si SAP no tiene foto, se usa la del catálogo NO SAP. Y aunque SAP
      // declare una, se guarda la otra como respaldo: el picturname puede
      // apuntar a un archivo que no está en el bucket.
      foto:l.foto_url||_repFotoUrl(x.picturname)||_fotoNoSapDeSku(sku)||'',
      foto_nosap:_fotoNoSapDeSku(sku)||'',
      __pic:(x.picturname||l.picturname||''),
      __fotoNoSap:_fotoNoSapDeSku(sku)||'',
      __fotoOk:(l.foto_url?1:0),
      cardname:'',                                    // no va al catálogo
      // La ETA de la orden vale para todas sus líneas: llegan en el mismo
      // embarque. Si la línea trae una propia, esa manda.
      eta:(l.eta||l.u_eta||_etaOrden||''),
      dkc_origen:docnum
    };
  }).filter(function(f){ return f.itemcode; });

  if(!filas.length){ showT('No se pudo armar ninguna ficha'); return; }

  // 4) Se usa como fuente y se abre la revisión de siempre
  window._catFuente=filas;
  window._catSel={};
  filas.forEach(function(f){ window._catSel[String(f.itemcode).toUpperCase()]=true; });
  // Qué foto existe de verdad: en el PDF no hay reintento si la URL falla
  _catTrabajando('Comprobando las fotos…');
  try{ await _catResolverFotos(filas); }catch(e){ console.warn('[catálogo] fotos:',e); }
  // Las que sigan faltando: del Excel que se adjuntó en la etapa de Pedido,
  // donde el proveedor suele traerlas todas junto a su SKU.
  try{
    _catTrabajandoTexto('Buscando las fotos en el Excel de la orden…');
    var nf=await _catAutoFotos(filas);
    if(nf) showT('✓ '+nf+' foto(s) sacadas del Excel de la orden');
  }catch(e){ console.warn('[catálogo] fotos del Excel:',e); }
  _catListo();
  showT(filas.length+' artículo(s) listos para revisar');
  await _catRevisarAbrir(true);          // sin autocompletar: no hay Excel de proveedor
}

// El botón que va en el detalle de una orden de SAP
function _catBtnOrdenSAP(docnum){
  var r=String(docnum||'').replace(/'/g,'');
  return '<button onclick="event.stopPropagation();_catDesdeOrdenSAP(\'' + r + '\')" '
    +'title="Revisar y generar el catálogo con los artículos de esta orden" '
    +'style="background:var(--pastel-aviso);color:var(--t-marron);border:0.5px solid #E9C08A;border-radius:7px;'
    +'padding:4px 9px;font-size:11px;cursor:pointer;font-weight:600">'
    +'<i class="ti ti-book"></i> Catálogo</button>';
}

function _catBtnOrden(ref){
  var r=String(ref||'').replace(/'/g,'');
  // Solo si esa orden dejó SKU en el catálogo NO SAP
  var n=(window._catNoSap||[]).filter(function(f){
    return _catFichaViva(f) && String(f.dkc_origen||'')===r; }).length;
  if(!n) return '';
  return '<button onclick="event.stopPropagation();_catCatalogoAbrir(null,\''+_esc(r)+'\')" '
    +'title="Armar el catálogo con los '+n+' artículo(s) de esta orden" '
    +'style="background:var(--pastel-aviso);color:var(--t-marron);border:0.5px solid #E9C08A;border-radius:7px;'
    +'padding:4px 9px;font-size:11px;cursor:pointer;font-weight:600">'
    +'<i class="ti ti-book"></i> Catálogo ('+n+')</button>';
}

function _catBtnProv(code){
  var c=String(code||'').replace(/'/g,'');
  return '<button onclick="event.stopPropagation();_catCatalogoAbrir(\''+_esc(c)+'\')" '
    +'title="Armar el catálogo solo de este proveedor" '
    +'style="border:1px solid #7C3D12;background:var(--surface-0);color:var(--t-marron);'
    +'border-radius:16px;padding:3px 10px;font-size:10.5px;font-weight:600;'
    +'cursor:pointer;white-space:nowrap"><i class="ti ti-book"></i> Catálogo</button>';
}

function _catCatalogoAbrir(soloProv, soloOrden){
  // Solo los que TODAVÍA no existen en SAP. Los que ya están allí no son
  // mercancía por dar de alta: de ellos solo se conserva la foto.
  var filas=(window._catNoSap||[]).filter(_catFichaViva);
  // Se puede acotar a un proveedor o a una orden concreta
  if(soloProv){
    filas=filas.filter(function(f){ return _catKeyProv(f.cardcode)===_catKeyProv(soloProv); });
  }
  if(soloOrden){
    filas=filas.filter(function(f){ return String(f.dkc_origen||'')===String(soloOrden); });
  }
  // Al acotar, se marcan todos por defecto: es lo que se va a querer
  if(soloProv || soloOrden){
    window._catSel={};
    filas.forEach(function(f){ window._catSel[String(f.itemcode||'').toUpperCase()]=true; });
  }
  if(_deptAcotado()){
    filas=filas.filter(function(f){ return !f.dept || _deptPermitido(f.dept); });
  }
  if(!filas.length){ showT('No hay SKU NO SAP para armar el catálogo'); return; }

  // Agrupados por proveedor
  var porProv={};
  filas.forEach(function(f){
    var k=(f.cardcode||'sin')+'|'+(f.cardname||'Sin proveedor');
    (porProv[k]=porProv[k]||[]).push(f);
  });

  var prev=document.getElementById('modalCatalogo'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCatalogo';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';

  var h='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:840px;max-height:92vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-marron)">'
        +'<i class="ti ti-book"></i> Armar catálogo de mercancía por llegar</div>'
      +'<button onclick="_catCatalogoCerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:12px">'
      +'Elige los artículos que quieres incluir. Son los que todavía no existen en SAP, '
      +'con las fotos que se sacaron del Excel del proveedor.</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:12px">'
      +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catSelTodos(true)">'
        +'<i class="ti ti-checks"></i> Marcar todos</button>'
      +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catSelTodos(false)">'
        +'Desmarcar todos</button>'
      +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="_catSelConFoto()">'
        +'<i class="ti ti-photo"></i> Solo los que tienen foto</button>'
      +'<span style="flex:1"></span>'
      +'<span id="catSelN" style="font-size:11.5px;font-weight:700;color:var(--t-marron)"></span>'
    +'</div>';

  Object.keys(porProv).sort().forEach(function(k){
    var partes=k.split('|');
    var lista=porProv[k];
    h+='<div style="border:0.5px solid var(--border);border-radius:9px;margin-bottom:10px;overflow:hidden">'
      +'<div style="background:var(--surface-1);padding:8px 12px;display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
        +'<label style="display:flex;align-items:center;gap:6px;cursor:pointer;flex:1">'
          +'<input type="checkbox" onchange="_catSelProv(\''+_esc(k.replace(/\x27/g,''))+'\',this.checked)" style="cursor:pointer">'
          +'<span style="font-size:12px;font-weight:700;color:var(--t-marron)">'+_esc(partes[0])+' — '+_esc(partes[1])+'</span>'
        +'</label>'
        +'<span style="font-size:10.5px;color:var(--text-muted)">'+lista.length+' artículo(s)</span>'
      +'</div>'
      +'<div style="display:flex;flex-wrap:wrap;gap:8px;padding:10px 12px">';
    lista.forEach(function(f){
      var sku=String(f.itemcode||'').toUpperCase();
      var foto=f.foto || f.foto_url || _fotoNoSapDeSku(sku) || '';
      var on=!!window._catSel[sku];
      h+='<label data-catprov="'+_esc(k)+'" style="display:flex;flex-direction:column;gap:4px;'
        +'width:132px;border:1.5px solid '+(on?'#7C3D12':'var(--border)')+';border-radius:8px;'
        +'padding:7px;cursor:pointer;background:'+(on?'#FEF9F3':'var(--surface-0)')+'">'
        +'<div style="display:flex;align-items:center;gap:5px">'
          +'<input type="checkbox" data-catsku="'+_esc(sku)+'"'+(on?' checked':'')
          +' onchange="_catSelUno(\''+_esc(sku)+'\',this.checked)" style="cursor:pointer;margin:0">'
          +'<span style="font-size:10px;font-family:monospace;overflow:hidden;text-overflow:ellipsis;'
          +'white-space:nowrap">'+_esc(f.itemcode||'')+'</span></div>'
        +(foto
          ? ('<img src="'+_esc(foto)+'" style="width:100%;height:88px;object-fit:contain;'
             +'border-radius:5px;background:var(--surface-1)" onerror="this.style.display=\'none\'">')
          : ('<div style="width:100%;height:88px;border-radius:5px;background:var(--surface-1);'
             +'display:flex;align-items:center;justify-content:center;color:var(--text-muted)">'
             +'<i class="ti ti-photo-off" style="font-size:20px"></i></div>'))
        +'<div style="font-size:9.5px;color:var(--text-muted);line-height:1.25;height:24px;overflow:hidden">'
          +_esc(String(f.descripcion||f.itemname||'').slice(0,44))+'</div>'
        +(function(){
            // Cuánta ficha tiene: sin datos el catálogo queda pobre
            var n=['material','color','tamano','empaque'].filter(function(k){ return f[k]; }).length;
            return '<div style="font-size:8.5px;color:'+(n?'#166534':'#B45309')+'">'
              +(n?('<i class="ti ti-list-check"></i> '+n+' dato(s)')
                 :'<i class="ti ti-alert-circle"></i> sin ficha')+'</div>';
          })()
        +'</label>';
    });
    h+='</div></div>';
  });

  h+='<div style="display:flex;justify-content:flex-end;gap:8px;margin-top:8px;'
    +'position:sticky;bottom:0;background:var(--surface-2);padding-top:10px">'
    +'<button class="btn" onclick="_catCatalogoCerrar()">Cancelar</button>'
    +'<button class="btn bp" style="background:#7C3D12" onclick="_catRevisarAbrir()">'
      +'<i class="ti ti-list-check"></i> Revisar y generar</button>'
    +'</div></div>';

  ov.innerHTML=h;
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  document.body.appendChild(ov);
  _modalEsc(ov);
  _catSelContar();
}

function _catCatalogoCerrar(){
  var m=document.getElementById('modalCatalogo'); if(m) m.remove();
}

function _catSelUno(sku, on){
  if(on) window._catSel[sku]=true; else delete window._catSel[sku];
  var lb=document.querySelector('[data-catsku="'+sku+'"]');
  if(lb && lb.parentNode && lb.parentNode.parentNode){
    var caja=lb.parentNode.parentNode;
    caja.style.borderColor=on?'#7C3D12':'var(--border)';
    caja.style.background=on?'#FEF9F3':'var(--surface-0)';
  }
  _catSelContar();
}

function _catSelTodos(on){
  document.querySelectorAll('[data-catsku]').forEach(function(c){
    c.checked=on;
    _catSelUno(c.getAttribute('data-catsku'), on);
  });
}

function _catSelProv(k, on){
  document.querySelectorAll('[data-catprov="'+k+'"] [data-catsku]').forEach(function(c){
    c.checked=on;
    _catSelUno(c.getAttribute('data-catsku'), on);
  });
}

function _catSelConFoto(){
  document.querySelectorAll('[data-catsku]').forEach(function(c){
    var sku=c.getAttribute('data-catsku');
    var caja=c.parentNode.parentNode;
    var tiene=!!caja.querySelector('img');
    c.checked=tiene;
    _catSelUno(sku, tiene);
  });
}

function _catSelContar(){
  var n=Object.keys(window._catSel||{}).length;
  var e=document.getElementById('catSelN');
  if(e) e.textContent=n+' artículo(s) elegido(s)';
}

// Genera el catálogo con lo elegido
// ═══════════════════════════════════════════════════════════════════════════
//  EL CATÁLOGO IMPRESO
//  El formato es el de la ficha de Kennedy: una cuadrícula de 2 x 5 fichas
//  por página, cabecera negra con el logo y pie con el número de página.
//  Los datos salen del catálogo NO SAP (tabla catalogo_nosap).
// ═══════════════════════════════════════════════════════════════════════════

// El código de barras se dibuja con JsBarcode, que se pide solo cuando hace
// falta. Si no carga (sin internet, por ejemplo) el catálogo igual sale: en
// lugar del código se imprime el número.
var _jsbarcodeLoad=null;
function _ensureJsBarcode(){
  if(window.JsBarcode) return Promise.resolve(window.JsBarcode);
  if(_jsbarcodeLoad) return _jsbarcodeLoad;
  _jsbarcodeLoad=new Promise(function(res,rej){
    var sc=document.createElement('script');
    sc.src='https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.5/JsBarcode.all.min.js';
    sc.onload=function(){
      if(window.JsBarcode) res(window.JsBarcode);
      else rej(new Error('JsBarcode no quedó disponible'));
    };
    sc.onerror=function(){ rej(new Error('no se pudo cargar JsBarcode')); };
    document.head.appendChild(sc);
  });
  return _jsbarcodeLoad;
}

// Dibuja el código en un canvas y lo devuelve como PNG para meterlo en el PDF.
// Si son 13 dígitos se usa EAN-13 y si son 12 UPC; cualquier otra cosa va como
// CODE128, que acepta letras. Si el número no es válido para su formato se
// reintenta con CODE128 antes de rendirse.
function _catBarcodePNG(codigo){
  var txt=String(codigo||'').trim();
  if(!txt || !window.JsBarcode) return null;
  try{
    var cv=document.createElement('canvas');
    var fmt=/^\d{13}$/.test(txt)?'EAN13':(/^\d{12}$/.test(txt)?'UPC':'CODE128');
    var ok=true;
    var opts={width:2, height:60, margin:0, displayValue:false,
              valid:function(v){ ok=v; }};
    window.JsBarcode(cv, txt, Object.assign({format:fmt}, opts));
    if(!ok){
      ok=true;
      window.JsBarcode(cv, txt, Object.assign({format:'CODE128'}, opts));
    }
    if(!ok) return null;
    return {data:cv.toDataURL('image/png'), w:cv.width, h:cv.height};
  }catch(e){ return null; }
}

// El logo se mide una sola vez y queda guardado para las demás páginas
function _catPdfLogo(){
  if(window._catLogoImg!==undefined) return Promise.resolve(window._catLogoImg);
  return new Promise(function(res){
    var im=new Image();
    im.onload=function(){
      window._catLogoImg={data:KCC_LOGO, w:im.naturalWidth, h:im.naturalHeight};
      res(window._catLogoImg);
    };
    im.onerror=function(){ window._catLogoImg=null; res(null); };
    im.src=KCC_LOGO;
    setTimeout(function(){
      if(window._catLogoImg===undefined){ window._catLogoImg=null; res(null); }
    }, 5000);
  });
}

// Tamaño de las fotos dentro del PDF y lo ya descargado, para no repetir
// trabajo. Cuanto más chico el lado y la calidad, más liviano sale el archivo.
var // La foto de cada ficha ocupa unos 8 cm en el papel: con 220 px de lado y
// calidad 0.5 se ve igual de bien impresa y el PDF pesa menos de la mitad,
// que es lo que importa para mandarlo por correo.
_CAT_FOTO={lado:220, q:0.5};
var _catImgCache={};

// Arma el PDF completo con las fichas que se le pasen y lo devuelve sin
// guardarlo. Lo usan el catálogo NO SAP y la búsqueda con IA del inventario.
//   opts.foto = {lado, q}   tamaño y calidad de las fotos
// La ETA en formato corto: "2026-08-30" y "30 ago 2026" quedan igual de
// claras, pero en la ficha no cabe una fecha larga.
function _catEtaCorta(v){
  var t=String(v||'').trim();
  if(!t) return '';
  var m=t.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if(m){
    var mes=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    return parseInt(m[3],10)+' '+(mes[parseInt(m[2],10)-1]||'')+' '+m[1];
  }
  return t.slice(0,14);
}

async function _catPdfDocumento(filas, opts){
  opts=opts||{};
  var fotoPrev=_CAT_FOTO;
  if(opts.foto) _CAT_FOTO={lado:opts.foto.lado||220, q:(opts.foto.q==null?0.5:opts.foto.q)};

  try{
    var doc=new window.jspdf.jsPDF({unit:'pt', format:'letter', compress:true});
    var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
    var M=30, COLS=2, ROWS=5, GAPX=10, GAPY=2;
    var cw=(W-M*2-GAPX)/COLS, ch=126;
    var Y0=96;        // la cuadrícula arranca debajo de la cabecera
    var lw=152;       // ancho de la parte de datos; el resto de la ficha es la foto

    // El código de barras es un extra: si la librería no carga, va el número
    try{ await _ensureJsBarcode(); }
    catch(e){ console.warn('[catálogo] códigos de barras:', e.message||e); }
    var logo=await _catPdfLogo();

    var porPagina=COLS*ROWS;
    var totPag=Math.max(1, Math.ceil(filas.length/porPagina));
    var pag=1;
    _catPdfCabecera(doc, W, logo, pag, filas.length);
    _catPdfPie(doc, W, H, pag, totPag);

    for(var i=0;i<filas.length;i++){
      var pos=i%porPagina;
      if(i && pos===0){
        doc.addPage(); pag++;
        _catPdfCabecera(doc, W, logo, pag, filas.length);
        _catPdfPie(doc, W, H, pag, totPag);
      }
      var x=M+(pos%COLS)*(cw+GAPX);
      var y=Y0+Math.floor(pos/COLS)*(ch+GAPY);
      await _catPdfFicha(doc, filas[i], x, y, cw, ch, lw);
    }
    return doc;
  } finally {
    _CAT_FOTO=fotoPrev;
  }
}

// Cabecera: barra negra, el logo a la izquierda y "Mercancía por llegar" a la
// derecha. El logo es oscuro, así que va sobre un recuadro blanco para que se
// lea sobre el negro.
function _catPdfCabecera(doc, W, logo, pag, totalItems){
  var M=30, h=44, y=26;
  doc.setFillColor(78,78,78);          // gris, no negro
  doc.rect(M, y, W-M*2, h, 'F');

  if(logo){
    var ih=24, iw=ih*(logo.w/logo.h);
    doc.setFillColor(255,255,255);
    doc.roundedRect(M+7, y+(h-ih-10)/2, iw+16, ih+10, 3, 3, 'F');
    try{ doc.addImage(logo.data,'PNG', M+15, y+(h-ih)/2, iw, ih); }catch(e){}
  } else {
    doc.setFont('helvetica','bold'); doc.setFontSize(13); doc.setTextColor(255,255,255);
    doc.text('KENNEDY CENTER', M+14, y+h/2+4);
  }

  doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(255,255,255);
  doc.text('CATÁLOGO', W/2, y+h/2+4, {align:'center'});

  doc.setFont('helvetica','normal'); doc.setFontSize(9.5); doc.setTextColor(70,70,70);
  var f=new Date();
  var fecha=('0'+f.getDate()).slice(-2)+'/'+('0'+(f.getMonth()+1)).slice(-2)+'/'+f.getFullYear();
  doc.text((pag===1?('Items: '+totalItems+'   ·   '):'')+fecha, W/2, y+h+16, {align:'center'});
}

// Pie: barra negra con la nota y el número de página
function _catPdfPie(doc, W, H, pag, totPag){
  var M=30, h=26, y=H-M-h+6;
  doc.setFillColor(17,17,17);
  doc.rect(M, y, W-M*2, h, 'F');
  doc.setFont('helvetica','normal'); doc.setFontSize(6.5); doc.setTextColor(225,225,225);
  doc.text('Kennedy Center Corp.  ·  Mercancía en tránsito. Precios y disponibilidad sujetos a cambio sin previo aviso.',
           M+12, y+h/2+2.5);
  doc.setFont('helvetica','bold'); doc.setFontSize(8); doc.setTextColor(255,255,255);
  doc.text('Página '+pag+' de '+totPag, W-M-12, y+h/2+3, {align:'right'});
}

// Una fila de la ficha técnica: arriba los títulos en gris, abajo los valores.
// Las celdas se reparten el ancho en partes iguales y devuelve dónde termina.
function _catPdfTabla(doc, x, y, w, celdas){
  var n=celdas.length, cw=w/n;
  doc.setLineWidth(0.4); doc.setDrawColor(160,160,160);
  doc.setFillColor(241,240,236);
  doc.rect(x, y, w, 8, 'FD');
  doc.rect(x, y+8, w, 10, 'D');
  for(var i=1;i<n;i++) doc.line(x+cw*i, y, x+cw*i, y+18);

  celdas.forEach(function(c,i){
    doc.setFont('helvetica','normal'); doc.setFontSize(5.2); doc.setTextColor(95,95,95);
    doc.text(String(c.t||''), x+cw*i+cw/2, y+5.6, {align:'center'});

    var col=c.c||[25,25,25];
    doc.setFont('helvetica','bold'); doc.setFontSize(6.6);
    doc.setTextColor(col[0],col[1],col[2]);
    var v=String(c.v==null?'':c.v).replace(/\s+/g,' ').trim();
    while(v && doc.getTextWidth(v)>cw-5) v=v.slice(0,-1);
    doc.text(v||'—', x+cw*i+cw/2, y+15.4, {align:'center'});
  });
  return y+18;
}

// Una ficha completa dentro de la cuadrícula
async function _catPdfFicha(doc, f, x, y, cw, ch, lw){
  var sku=String(f.itemcode||'').toUpperCase();

  doc.setDrawColor(25,25,25); doc.setLineWidth(0.9);
  doc.rect(x, y, cw, ch, 'D');

  // El código, arriba a la izquierda
  doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(15,15,15);
  var cod=String(f.itemcode||'');
  while(cod && doc.getTextWidth(cod)>lw-14) cod=cod.slice(0,-1);
  doc.text(cod, x+7, y+14);

  // La descripción, centrada y en dos líneas como mucho
  doc.setFont('helvetica','bold'); doc.setFontSize(7); doc.setTextColor(35,35,35);
  var desc=doc.splitTextToSize(String(_catValor(f,'descripcion')||f.itemname||''), lw-14);
  doc.text(desc.slice(0,2), x+lw/2, y+25, {align:'center'});

  // La ficha técnica
  var ty=y+40;
  ty=_catPdfTabla(doc, x+7, ty, lw-14, [
    {t:'Categoría', v:dL(f._dept||f.dept||'')},
    {t:'Marca',     v:_catValor(f,'marca')}
  ]);
  ty=_catPdfTabla(doc, x+7, ty, lw-14, [
    {t:'Pzs/caja',    v:_catValor(f,'unidades_x_caja')},
    {t:'Medida',      v:_catValor(f,'medida')||_catValor(f,'carton_size')||_catValor(f,'tamano')},
    {t:'CBM',         v:f.cbm||''},
    {t:'Peso',        v:_catValor(f,'peso')}
  ]);
  var pv=Number(_catValor(f,'precio_venta'))||0;
  // La cantidad disponible solo la traen las fichas armadas desde el
  // inventario. Las del catálogo NO SAP todavía no tienen existencia, así que
  // en esas la celda ni aparece y la fila queda de dos columnas.
  var celdas3=[{t:'Color', v:_catValor(f,'color')}];
  if(f.disponible!=null && f.disponible!==''){
    celdas3.push({t:'Disponible',
                  v:(Number(f.disponible)||0).toLocaleString('es'),
                  c:[12,74,124]});
  }
  // Lo que viene en camino va SIEMPRE que haya algo, tenga o no existencia.
  // Antes salía solo si NO había disponible, así que en los catálogos hechos
  // desde el inventario nunca aparecía.
  var _pl=(_catValor(f,'por_llegar')!=null && _catValor(f,'por_llegar')!=='')
    ? Number(String(_catValor(f,'por_llegar')).replace(/[^0-9.\-]/g,''))||0
    : ((f.por_llegar!=null && f.por_llegar!=='')
        ? Number(f.por_llegar)||0
        : _catPorLlegar(f.itemcode));
  if(_pl>0) celdas3.push({t:'Por llegar', v:_pl.toLocaleString('es'), c:[180,83,9]});
  // La fecha estimada de llegada, si la hay. Va junto a la cantidad porque
  // las dos responden a la misma pregunta del cliente: cuánto y cuándo.
  var _eta=String(_catValor(f,'eta')||f.eta||f.fechaEst||'').trim();
  if(_eta) celdas3.push({t:'ETA', v:_catEtaCorta(_eta), c:[12,68,124]});
  celdas3.push({t:'Precio', v:pv?fmt(pv):'', c:[22,101,52]});
  ty=_catPdfTabla(doc, x+7, ty, lw-14, celdas3);

  // El código de barras
  var bc=String(_catValor(f,'barcode')||'').trim();
  if(bc){
    var bi=_catBarcodePNG(bc);
    if(bi){
      var bw=lw-42, bh=16;
      try{ doc.addImage(bi.data,'PNG', x+7+((lw-14)-bw)/2, ty+4, bw, bh); }catch(e){}
      doc.setFont('helvetica','normal'); doc.setFontSize(5.8); doc.setTextColor(70,70,70);
      doc.text(bc, x+7+(lw-14)/2, ty+4+bh+6.5, {align:'center'});
    } else {
      doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(70,70,70);
      doc.text(bc, x+7+(lw-14)/2, ty+14, {align:'center'});
    }
  }

  // La foto, a la derecha
  var px=x+lw+2, pw=cw-lw-8, py=y+7, ph=ch-16;
  var foto=f.foto || f.foto_url || ((window._nsapFotos||{})[sku]||{}).url || '';
  if(foto){
    try{
      var im=null;
      if(foto.indexOf('data:')===0){
        im=await new Promise(function(res){
          var i2=new Image();
          i2.onload=function(){ res({data:foto, w:i2.naturalWidth, h:i2.naturalHeight}); };
          i2.onerror=function(){ res(null); };
          i2.src=foto;
          setTimeout(function(){ res(null); }, 6000);
        });
      } else {
        // Se guarda lo ya bajado: en un catálogo largo se repiten fotos y
        // volver a descargarlas y recomprimirlas es lo que lo hace lento.
        var clave=foto+'|'+_CAT_FOTO.lado+'|'+_CAT_FOTO.q;
        if(_catImgCache[clave]!==undefined){
          im=_catImgCache[clave];
        } else {
          im=await _repCargarImg(foto, _CAT_FOTO.lado, _CAT_FOTO.q);
          _catImgCache[clave]=im||null;
        }
      }
      if(im){
        var r=Math.min(pw/im.w, ph/im.h);
        doc.addImage(im.data,'JPEG', px+(pw-im.w*r)/2, py+(ph-im.h*r)/2, im.w*r, im.h*r);
      }
    }catch(e){}
  }

  // Ojo: aquí NO va el proveedor. El catálogo lo lee el cliente y de quién
  // se compra la mercancía es información interna.
}

async function _catGenerar(tipo, porCorreo){
  var skus=Object.keys(window._catSel||{});
  if(!skus.length){ showT('Elige al menos un artículo'); return; }

  var filas=_catFuenteFilas().filter(function(f){
    return f.tipo!=='proveedor' && window._catSel[String(f.itemcode||'').toUpperCase()];
  });
  if(!filas.length){ showT('No se encontraron los artículos elegidos'); return; }

  showT('Armando el catálogo con '+filas.length+' artículo(s)…');

  if(tipo==='excel'){ return _catExcel(filas); }

  // PDF: la ficha de catálogo de Kennedy, 2 x 5 por página
  var doc=await _catPdfDocumento(filas);
  var _nom='Catalogo_'+new Date().toISOString().slice(0,10)+'.pdf';
  if(porCorreo){
    await _catMailAbrir([{nombre:_nom, blob:doc.output('blob'), mime:'application/pdf'}],
                        'Catálogo Kennedy Center');
  } else {
    doc.save(_nom);
    // La ventana queda abierta: se suele generar el PDF, mirarlo y volver a
    // ajustar precios. Se cierra con el botón Cerrar o con Escape.
    showT('✓ Catálogo generado · la ventana queda abierta para seguir ajustando');
  }
}

async function _catExcel(filas){
  // ExcelJS se carga bajo demanda: hay que pedirlo, no solo comprobarlo
  try{
    await _ensureExcelJS();
  }catch(e){
    showT('No se pudo cargar el generador de Excel: '+(e.message||e), 6000);
    console.warn('[catálogo] ExcelJS:', e);
    return;
  }
  if(typeof ExcelJS==='undefined'){
    showT('El generador de Excel no quedó disponible. Probá de nuevo.', 5000);
    return;
  }
  showT('Armando el Excel…');
  var wb=new ExcelJS.Workbook();
  var ws=wb.addWorksheet('Catálogo');
  ws.columns=[
    {header:'Foto', key:'foto', width:14},
    {header:'SKU', key:'sku', width:18},
    {header:'Descripción', key:'desc', width:42},
    {header:'Material', key:'material', width:24},
    {header:'Color', key:'color', width:16},
    {header:'Medida', key:'tamano', width:22},
    {header:'Pzs x caja', key:'upc', width:11},
    {header:'Medida caja', key:'carton', width:20},
    {header:'Peso', key:'peso', width:11},
    {header:'Marca', key:'marca', width:14},
    {header:'CBM', key:'cbm', width:9},
    {header:'Código de barras', key:'barcode', width:18},
    {header:'Precio venta', key:'precio', width:13},
    {header:'Por llegar', key:'porllegar', width:12},
    {header:'ETA', key:'eta', width:13},
    {header:'Departamento', key:'dept', width:15}
    // El proveedor NO va: este archivo también termina en manos del cliente.
  ];
  ws.getRow(1).font={bold:true, color:{argb:'FFFFFFFF'}};
  ws.getRow(1).fill={type:'pattern', pattern:'solid', fgColor:{argb:'FF7C3D12'}};

  for(var i=0;i<filas.length;i++){
    var f=filas[i];
    var sku=String(f.itemcode||'').toUpperCase();
    var fila=ws.addRow({foto:'', sku:f.itemcode||'',
                        desc:_catValor(f,'descripcion')||f.itemname||'',
                        material:_catValor(f,'material'), color:_catValor(f,'color'),
                        tamano:_catValor(f,'tamano'),
                        carton:_catValor(f,'carton_size'),
                        peso:_catValor(f,'peso'), marca:_catValor(f,'marca'),
                        precio:Number(_catValor(f,'precio_venta'))||'',
                        upc:_catValor(f,'unidades_x_caja')||'', cbm:f.cbm||'',
                        barcode:f.barcode||'',
                        porllegar:(_catValor(f,'por_llegar')||_catPorLlegar(f.itemcode)||''),
                        eta:_catEtaCorta(_catValor(f,'eta')||f.eta||f.fechaEst||''),
                        dept:f._dept?dL(f._dept):''});
    fila.alignment={vertical:'middle', wrapText:true};
    fila.height=64;
    var foto=f.foto || f.foto_url || _fotoNoSapDeSku(sku) || '';
    if(foto){
      try{
        var im=null;
        if(foto.indexOf('data:')===0){
          // Ya está embebida: no hace falta descargarla
          var pr=foto.split(',');
          im={b64:pr[1], ext:(/jpe?g/.test(pr[0])?'jpeg':'png')};
        } else {
          im=await _repImgToB64(foto, 240, 0.6);
        }
        if(im){
          var id=wb.addImage({base64:im.b64, extension:im.ext});
          ws.addImage(id, {tl:{col:0.12, row:fila.number-1+0.08},
                           ext:{width:74, height:74}, editAs:'oneCell'});
        }
      }catch(e){}
    }
  }
  var buf=await wb.xlsx.writeBuffer();
  var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  var a=document.createElement('a');
  a.href=URL.createObjectURL(blob);
  a.download='Catalogo_por_llegar_'+new Date().toISOString().slice(0,10)+'.xlsx';
  a.click();
  showT('✓ Catálogo en Excel generado · la ventana queda abierta');
}

// Sube la foto que la AI sacó del Excel y devuelve su enlace
async function _catSubirFotoSku(code, cardcode, it){
  try{
    var sku=String(code||'').trim().toUpperCase();
    if(!sku) return null;
    var pend=(window._nsapFotosPend||{})[sku];
    // Si ya la trae el propio artículo, se usa esa
    if(!pend && it && it._foto && it._foto.indexOf('data:')===0){
      var pr=it._foto.split(',');
      pend={b64:pr[1], mime:(pr[0].match(/data:([^;]+)/)||[])[1]||'image/png'};
    }
    if(!pend || !pend.b64) return null;

    var ext=(pend.mime==='image/jpeg')?'jpg':(pend.mime==='image/gif'?'gif':'png');
    var ruta='nosap/'+String(cardcode||'sin-prov').replace(/[^\w-]/g,'')+'/'
      +sku.replace(/[^\w.-]/g,'_')+'.'+ext;
    var bin=atob(pend.b64), arr=new Uint8Array(bin.length);
    for(var i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
    var r=await fetch(SB+'/storage/v1/object/'+DOCS_BUCKET+'/'+ruta,{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+KEY,'Content-Type':pend.mime,'x-upsert':'true'},
      body:arr});
    if(!r.ok && r.status!==409){
      var t='';
      try{ t=await r.text(); }catch(e){}
      console.warn('[nosap] no se subió la foto de '+sku+' ('+r.status+'):', t.slice(0,160));
      // Si el storage falla, se guarda la imagen en la propia ficha para no
      // perderla. Ocupa más, pero el catálogo la necesita.
      if(pend.b64.length < 700000){
        console.log('[nosap] '+sku+': se guarda la foto en la ficha');
        return 'data:'+pend.mime+';base64,'+pend.b64;
      }
      return null;
    }
    var url=DOCS_BASE+ruta.split('/').map(encodeURIComponent).join('/');
    window._nsapFotos[sku]={url:url, mime:pend.mime};
    console.log('[nosap] foto guardada para '+sku+' → '+ruta);
    return url;
  }catch(e){
    console.warn('[nosap] foto de '+code+':', e);
    // Último recurso: la imagen va dentro de la ficha
    try{
      var pf=(window._nsapFotosPend||{})[String(code||'').trim().toUpperCase()];
      if(pf && pf.b64 && pf.b64.length<700000) return 'data:'+pf.mime+';base64,'+pf.b64;
    }catch(e2){}
    return null;
  }
}

function _catSetDept(k){
  window._catFiltroDept=k;
  rCatNoSap();
}

// ── Pantalla: Proveedores y SKU NO SAP ──
async function rCatNoSap(){
  var box=document.getElementById('page-catnosap'); if(!box) return;
  box.innerHTML='<div class="empty" style="padding:16px"><i class="ti ti-loader-2 spin"></i> Cargando...</div>';
  await _catNoSapCargar(true);
  var filas=window._catNoSap||[];
  if(CU&& _deptAcotado()) filas=filas.filter(function(f){ return !f.dept || _deptPermitido(f.dept); });

  // El departamento de cada ficha. Muchas no lo traen guardado, así que se
  // deduce de la orden NO SAP que la creó, y los artículos heredan el de su
  // proveedor.
  _catCompletarDept(filas);

  var deptos={};
  filas.forEach(function(f){ var d=f._dept; if(d) deptos[d]=(deptos[d]||0)+1; });
  var sinDept=filas.filter(function(f){ return !f._dept; }).length;
  var fd=window._catFiltroDept||'todos';
  if(fd && fd!=='todos'){
    filas = (fd==='sin')
      ? filas.filter(function(f){ return !f._dept; })
      : filas.filter(function(f){ return f._dept===fd; });
  }

  var provs=filas.filter(function(f){ return f.tipo==='proveedor'; });
  // Se listan solo los que TODAVÍA no están en SAP. Los que ya existen allí
  // no son artículos por dar de alta: de ellos solo se aprovecha la foto,
  // y se ocultan aunque la base todavía no admita marcarlos como tales.
  var items=filas.filter(_catFichaViva);

  var h='<div style="font-size:13px;font-weight:600;margin-bottom:3px"><i class="ti ti-alert-square-rounded" style="color:var(--t-ambar)"></i> Proveedores y SKU NO SAP</div>';
  h+='<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">'
    +'Fichas temporales creadas desde órdenes NO SAP. Cuando el mismo código aparece en SAP, la ficha se elimina sola.</div>';

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:12px">'
    +'<span style="font-size:11.5px;background:var(--pastel-naranja);color:var(--t-marron);border:0.5px solid #E9C08A;border-radius:14px;padding:4px 11px;font-weight:600">'+provs.length+' proveedor(es) nuevo(s)</span>'
    +'<span style="font-size:11.5px;background:var(--pastel-lila);color:var(--t-lila);border:0.5px solid #C4B5FD;border-radius:14px;padding:4px 11px;font-weight:600">'+items.length+' SKU nuevo(s)</span>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catNoSapRevisar()"><i class="ti ti-refresh"></i> Revisar contra SAP</button>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catNoSapRellenar()"><i class="ti ti-database-import"></i> Revisar órdenes existentes</button>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catNoSapDiag()"><i class="ti ti-stethoscope"></i> Probar tabla</button>'
    +'<span style="flex:1"></span>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catTodos(true)"><i class="ti ti-chevrons-down"></i> Expandir</button>'
    +'<button class="btn bg2" style="padding:4px 11px;font-size:11px" onclick="_catTodos(false)"><i class="ti ti-chevrons-up"></i> Contraer</button>'
    +(_esGerencia()?('<button class="btn bg2" style="padding:4px 11px;font-size:11px;color:var(--text-danger)" onclick="_gerVaciarCatalogoNoSap()"><i class="ti ti-trash"></i> Vaciar todo</button>'):'')
    +'</div>';
  // Barra de departamentos: siempre visible, para poder acotar la consulta
  var totalSinFiltro=(window._catNoSap||[]).filter(_catFichaViva).length;
  h+='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:12px;'
    +'background:var(--surface-1);border-radius:9px;padding:7px 10px">'
    +'<span style="font-size:11px;color:var(--text-secondary);font-weight:700">'
    +'<i class="ti ti-filter"></i> Departamento</span>';
  var defs=[{k:'todos', l:'Todos', n:totalSinFiltro}];
  Object.keys(deptos).sort().forEach(function(d){ defs.push({k:d, l:dL(d), n:deptos[d]}); });
  if(sinDept) defs.push({k:'sin', l:'Sin asignar', n:sinDept});
  defs.forEach(function(x){
    var on=(fd===x.k)||(x.k==='todos'&&(!fd||fd==='todos'));
    h+='<button onclick="_catSetDept(\''+x.k+'\')" style="border:1px solid '+(on?'#7C3D12':'var(--border)')+';'
      +'background:'+(on?'#7C3D12':'var(--surface-0)')+';color:'+(on?'#fff':'#7C3D12')+';'
      +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap">'
      +(EMOJIS2[x.k]||'')+' '+_esc(x.l)+' <span style="opacity:.85;font-weight:400">'+x.n+'</span></button>';
  });
  if(defs.length<=1){
    h+='<span style="font-size:10.5px;color:var(--text-muted)">Ninguna ficha tiene departamento asignado.</span>';
  }
  h+='</div>';
  // Catálogo de la mercancía que todavía no está en SAP
  var conFoto=filas.filter(function(f){
    return f.tipo!=='proveedor' &&
      (f.foto || _fotoNoSapDeSku(f.itemcode));
  }).length;
  var totalSku=filas.filter(function(f){ return f.tipo!=='proveedor'; }).length;
  if(totalSku){
    h+='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;background:var(--pastel-aviso);'
      +'border:1px solid #E9C08A;border-radius:9px;padding:9px 12px;margin-bottom:12px">'
      +'<i class="ti ti-book" style="color:var(--t-marron)"></i>'
      +'<span style="font-size:11.5px;color:var(--t-marron);flex:1">'
        +'Armá un catálogo de esta mercancía por llegar · '
        +'<b>'+conFoto+'</b> de '+totalSku+' artículo(s) tienen foto</span>'
      +'<button class="btn bp" style="background:#7C3D12;padding:5px 12px;font-size:11px" '
        +'onclick="_catCatalogoAbrir()"><i class="ti ti-book"></i> Armar catálogo</button>'
      +'</div>';
  }
  h+='<div id="cat-diag"></div>';
  if(fd && fd!=='todos'){
    h+='<div style="font-size:11px;color:var(--t-marron);margin-bottom:8px">'
      +'<i class="ti ti-info-circle"></i> Mostrando solo '
      +(fd==='sin'?'las fichas sin departamento':('el departamento '+_esc(dL(fd))))
      +' · '+filas.length+' ficha(s) de '+totalSinFiltro+'</div>';
  }

  if(!filas.length){
    h+='<div class="empty" style="padding:20px;color:var(--text-muted)"><i class="ti ti-circle-check" style="font-size:22px;color:var(--text-success)"></i><br>No hay proveedores ni SKU pendientes de crearse en SAP.</div>';
    box.innerHTML=h; _catNoSapBadge(); return;
  }

  // Agrupar por proveedor
  var grupos={};
  provs.forEach(function(p){ grupos[_catKeyProv(p.cardcode)]={prov:p, items:[]}; });
  items.forEach(function(it){
    var k=_catKeyProv(it.cardcode);
    if(!grupos[k]) grupos[k]={prov:null, cardcode:it.cardcode, cardname:it.cardname, items:[]};
    grupos[k].items.push(it);
  });

  window._catGrupos=grupos;
  Object.keys(grupos).forEach(function(k){
    var g=grupos[k];
    var esProvNuevo=!!g.prov;
    var nombre=(g.prov?g.prov.cardname:g.cardname)||'(sin nombre)';
    var codigo=(g.prov?g.prov.cardcode:g.cardcode)||k;
    var col=esProvNuevo?'#B45309':'#5B21B6';
    var bg=esProvNuevo?'#FEF9F3':'var(--surface-1)';
    h+='<div style="border:0.5px solid var(--border);border-left:4px solid '+col+';border-radius:9px;margin-bottom:10px;overflow:hidden">';
    var gid='catg-'+String(k).replace(/[^A-Za-z0-9]/g,'');
    var abierto=(window._catAbiertos&&window._catAbiertos[k])?true:false;
    h+='<div onclick="_catToggleProv(\''+_esc(String(k).replace(/\\/g,''))+'\')" title="Clic para mostrar u ocultar los SKU"'
      +' style="background:'+bg+';padding:9px 12px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;cursor:pointer;user-select:none">'
      +'<i class="ti ti-chevron-down" id="'+gid+'-chev" style="color:'+col+';font-size:15px;transition:transform .15s ease;transform:rotate('+(abierto?'0':'-90')+'deg)"></i>'
      +'<b style="font-size:12.5px;color:'+col+'">'+_esc(codigo)+'</b>'
      +'<span style="font-size:12.5px;flex:1;min-width:120px">'+_esc(nombre)+'</span>'
      +(function(){
          var d=(g.prov&&g.prov._dept)||(g.items[0]&&g.items[0]._dept)||'';
          if(!d) return '';
          return '<span style="font-size:10px;font-weight:700;background:var(--surface-0);'
            +'border:0.5px solid var(--border);border-radius:10px;padding:1px 8px;color:var(--t-marron)">'
            +(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</span>';
        })()
      +(g.items.length ? _catBtnProv(g.cardcode||k) : '')
      +(esProvNuevo?'<span class="cat-nuevo">proveedor nuevo</span>':'<span style="font-size:10px;color:var(--text-muted)">proveedor ya en SAP</span>')
      +'<span style="font-size:10.5px;font-weight:700;color:'+col+';background:var(--surface-0);border-radius:10px;padding:1px 9px">'+g.items.length+' SKU</span>'
      +'</div>';
    if(g.items.length){
      h+='<div id="'+gid+'" style="padding:2px 0;display:'+(abierto?'block':'none')+'">';
      g.items.forEach(function(it){
        h+='<div style="display:flex;align-items:center;gap:9px;padding:7px 12px;border-top:0.5px solid var(--border)">'
          +(function(){
              // La foto puede estar en la ficha, en el enlace o en memoria
              var _f=it.foto || it.foto_url
                || _fotoNoSapDeSku(it.itemcode) || '';
              return _f
                ? ('<img src="'+_esc(_f)+'" style="width:34px;height:34px;object-fit:cover;'
                   +'border-radius:6px;border:0.5px solid var(--border)" '
                   +'onerror="this.outerHTML=\'<div style=&quot;width:34px;height:34px;border-radius:6px;'
                   +'background:var(--surface-1)&quot;></div>\'">')
                : '';
            })()
          +((it.foto||it.foto_url||_fotoNoSapDeSku(it.itemcode))?''
                   :'<div style="width:34px;height:34px;border-radius:6px;background:var(--surface-1);display:flex;align-items:center;justify-content:center"><i class="ti ti-photo-off" style="color:var(--text-muted);font-size:14px"></i></div>')
          +'<div style="flex:1;min-width:0">'
            +'<div style="font-size:12px;font-weight:600"><span class="cat-sku">'+_esc(it.itemcode||'')+'</span> '+_esc(it.itemname||'')+'</div>'
            // La ficha técnica que leyó la AI, para ver qué tiene el catálogo
            +(function(){
                var d=[];
                if(it.material) d.push(['Material', it.material]);
                if(it.color)    d.push(['Color', it.color]);
                if(it.tamano)   d.push(['Medida', it.tamano]);
                if(it.empaque)  d.push(['Empaque', it.empaque]);
                if(it.unidades_x_caja) d.push(['Pzs/caja', it.unidades_x_caja]);
                if(!d.length) return '';
                return '<div style="display:flex;gap:5px;flex-wrap:wrap;margin-top:3px">'
                  +d.map(function(p){
                      return '<span style="font-size:9.5px;background:var(--surface-1);'
                        +'border-radius:9px;padding:1px 7px;color:var(--text-secondary)" '
                        +'title="'+_esc(p[0])+'">'+_esc(String(p[1]).replace(/\n/g,' ').slice(0,34))+'</span>';
                    }).join('')
                  +'</div>';
              })()
            +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">'
              +(it.dkc_origen?('Orden '+_esc(it.dkc_origen)+' · '):'')
              +(it.cantidad?(Number(it.cantidad).toLocaleString('en-US')+' pcs · '):'')
              +(it.precio?(fmt(it.precio)+' c/u'):'')
              +(it.colores?(' · '+_esc(it.colores)):'')
            +'</div>'
          +'</div>'
          +'<button class="btn bg2" style="padding:4px 8px;font-size:10.5px;color:var(--text-danger)" onclick="_catNoSapBorrar('+it.id+')"><i class="ti ti-trash"></i></button>'
          +'</div>';
      });
      h+='</div>';
    }
    // El pie sale siempre que haya algo que borrar en bloque. Antes solo
    // aparecía con proveedor nuevo, así que los SKU de un proveedor que ya
    // estaba en SAP había que borrarlos de uno en uno.
    if(esProvNuevo || g.items.length){
      var _cod=_esc(String(codigo).replace(/\\/g,''));
      h+='<div id="'+gid+'-pie" style="padding:7px 12px;border-top:0.5px solid var(--border);display:'+(abierto?'flex':'none')+';justify-content:flex-end;gap:6px;flex-wrap:wrap">'
        +((_esGerencia() && g.items.length)?('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--text-danger);font-weight:600" onclick="event.stopPropagation();_gerBorrarSkuDeProveedor(\''+_cod+'\')"><i class="ti ti-trash"></i> Quitar los '+g.items.length+' SKU</button>'):'')
        +((_esGerencia() && esProvNuevo)?('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--text-danger);font-weight:600" onclick="event.stopPropagation();_gerBorrarProveedorNoSap(\''+_cod+'\')"><i class="ti ti-trash"></i> Borrar proveedor y sus '+g.items.length+' SKU</button>'):'')
        +(esProvNuevo?('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_catNoSapBorrar('+g.prov.id+')"><i class="ti ti-trash"></i> Quitar solo el proveedor</button>'):'')
        +'</div>';
    }
    h+='</div>';
  });
  box.innerHTML=h;
  _catNoSapBadge();   // el numerito rojo tiene que seguir a la lista
}

// Plegar y desplegar los SKU de un proveedor. Se arranca contraído para que
// un proveedor con 100 items nuevos no ocupe toda la pantalla.
window._catAbiertos=window._catAbiertos||{};
function _catToggleProv(k){
  window._catAbiertos[k]=!window._catAbiertos[k];
  var gid='catg-'+String(k).replace(/[^A-Za-z0-9]/g,'');
  var cont=document.getElementById(gid);
  var chev=document.getElementById(gid+'-chev');
  var pie=document.getElementById(gid+'-pie');
  var ab=window._catAbiertos[k];
  if(cont) cont.style.display=ab?'block':'none';
  if(pie)  pie.style.display=ab?'flex':'none';
  if(chev) chev.style.transform='rotate('+(ab?'0':'-90')+'deg)';
}
function _catTodos(abrir){
  var claves=Object.keys(window._catGrupos||{});
  claves.forEach(function(k){ window._catAbiertos[k]=!!abrir; });
  rCatNoSap();
}

async function _catNoSapRevisar(){
  showT('Revisando contra SAP…');
  var n=await _catNoSapDepurar();
  var esp=(window._catEsperandoFoto||[]).length;
  if(n && esp)      showT('✓ '+n+' ficha(s) quitadas · '+esp+' se conservan porque su SKU en SAP todavía no tiene foto', 7000);
  else if(n)        showT('✓ '+n+' ficha(s) ya están en SAP y se quitaron');
  else if(esp)      showT(esp+' ficha(s) ya están en SAP pero sin foto: se conservan hasta que la carguen', 7000);
  else              showT('Ninguna está todavía en SAP');
  rCatNoSap();
}

async function _catNoSapBorrar(id){
  var f0=(window._catNoSap||[]).find(function(f){ return String(f.id)===String(id); });
  var esProv=f0 && f0.tipo==='proveedor';
  var nSku=esProv?_catItemsDeProveedor(f0.cardcode).length:0;
  var quees=f0?(esProv?('el proveedor "'+(f0.cardcode||'')+' — '+(f0.cardname||'')+'"'):('el SKU "'+(f0.itemcode||'')+' — '+(f0.itemname||'')+'"')):'esta ficha temporal';
  var msg='¿Está seguro de que desea borrar '+quees+'?';
  if(esProv && nSku) msg+='\n\nOJO: este proveedor tiene '+nSku+' SKU asociado(s), que quedarán listados sin proveedor nuevo.';
  msg+='\n\nSe quita solo de este sistema, no afecta a SAP.';
  if(!confirm(msg)) return;
  try{
    var r=await fetch(SB+'/rest/v1/catalogo_nosap?id=eq.'+id,{method:'DELETE',headers:SBH});
    if(!r.ok){ showT('No se pudo eliminar'); return; }
    window._catNoSap=(window._catNoSap||[]).filter(function(f){ return String(f.id)!==String(id); });
    _catNoSapBadge();
    showT('Ficha eliminada');
    rCatNoSap();
  }catch(e){ showT('Error: '+(e.message||e)); }
}

// Bloque de SKUs temporales de un proveedor, para verlos dentro de su ficha
function _catBloqueProveedor(code){
  var its=_catItemsDeProveedor(code);
  var provNuevo=_catEsProveedorNuevo(code);
  if(!its.length && !provNuevo) return '';
  var h='<div style="border:1px solid #C4B5FD;background:#F7F5FF;border-radius:10px;padding:11px 13px;margin-bottom:14px">';
  h+='<div style="font-size:12px;font-weight:700;color:var(--t-lila);margin-bottom:'+(its.length?'7px':'0')+'">'
    +'<i class="ti ti-tags"></i> '+(provNuevo?'Proveedor nuevo':'')+(provNuevo&&its.length?' · ':'')
    +(its.length?(its.length+' SKU todavía no están en SAP'):'todavía no está en SAP')+'</div>';
  if(provNuevo && !its.length){
    h+='<div style="font-size:11px;color:var(--t-lila)">Se creó desde una orden NO SAP. Desaparece de aquí en cuanto exista en SAP.</div>';
  }
  its.forEach(function(it){
    h+='<div style="display:flex;align-items:center;gap:8px;padding:6px 0;border-top:0.5px solid #DDD6FE">'
      +'<span class="cat-sku">'+_esc(it.itemcode||'')+'</span>'
      +'<span style="flex:1;min-width:0;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(it.itemname||'')+'</span>'
      +(((window._catEsperandoFoto||[]).indexOf(it.itemcode)>=0)
        ? ('<span title="Ya existe en SAP, pero todavía sin foto: la ficha se '
           +'conserva porque guarda la única imagen que hay" '
           +'style="font-size:9px;font-weight:700;background:#FEF3C7;color:var(--t-marron);'
           +'border-radius:7px;padding:1px 6px;flex-shrink:0">EN SAP · SIN FOTO</span>')
        : '')
      +'<span style="font-size:11px;color:var(--text-muted);flex-shrink:0">'
        +(it.cantidad?(Number(it.cantidad).toLocaleString('en-US')+' pcs'):'')
        +(it.precio?(' · '+fmt(it.precio)):'')+'</span>'
      +'</div>';
  });
  h+='<div style="font-size:10px;color:var(--t-lila);margin-top:6px;opacity:.85">Se quitan solos cuando el mismo código exista en SAP.</div>';
  h+='</div>';
  return h;
}

// Contador en el menú de lo que falta crear en SAP
function _catNoSapBadge(){
  var el=document.getElementById('nbNumCat'); if(!el) return;
  // Se cuentan solo las fichas vivas: ni las degradadas a foto ni las de
  // artículos que ya existen en SAP, que no hay que dar de alta.
  var _vivas=(window._catNoSap||[]).filter(function(f){
    return f.tipo==='proveedor' ? true : _catFichaViva(f);
  });
  var n=_vivas.length;
  if(CU&& _deptAcotado()) n=_vivas.filter(function(f){ return !f.dept||_deptPermitido(f.dept); }).length;
  if(n>0){ el.textContent=(n>99?'99+':String(n)); el.style.display='block'; el.title=n+' ficha(s) pendientes de crearse en SAP'; }
  else { el.textContent=''; el.style.display='none'; }
}
function _catNoSapIniciar(){
  try{ _margenHistCargar(); }catch(e){}
  _catNoSapCargar(true).then(_catNoSapBadge).catch(function(){});
}

// ═══════════════════════════════════════════════════════════════════════════
//  CONSULTA DE INVENTARIO
//  Listado de todos los items con scroll infinito, zoom de foto al pasar el
//  mouse y ficha técnica al hacer clic. Desde la ficha se puede saltar al
//  proveedor y arrancar una reposición con él ya cargado.
// ═══════════════════════════════════════════════════════════════════════════
var _invRows=[];            // lo que se ha traído hasta ahora
var _invOffset=0;
var _invTanda=60;
var _invFin=false;
var _invCargando=false;
var _invQ='';
var _invOrden='fechaentrada.desc.nullslast';   // lo más nuevo primero
var _invDept='todos';
var _invBuscarTimer=null;

var _INV_CAMPOS='itemcode,itemname,frgnname,onhand,iscommited,onorder,disponible,'
  +'prox_llegada,ultima_llegada,ordenes_abiertas,'
  +'precioventa,fob,cif,picturname,cardcode,nombre_proveedor,marca,grupo,subg,'
  +'peso,volumen,unidadesbulto,salpackun,codebars,usertext,caracteristicas,'
  +'u_color,u_tamano,lastpurprc,avgprice,u_cant_ult_ent,hist_comprado,fechaentrada';

// Una columna de la cabecera que ordena al pulsarla. Alterna entre mayor a
// menor y menor a mayor, y muestra la flecha del sentido activo.
// La fecha en que llega lo pendiente. Sin fecha, el número solo no dice
// si la mercancía llega la semana que viene o en tres meses.
// Comprueba si las fechas de llegada ya están sincronizadas.
// Se escribe _verFechas() en la consola del navegador (F12).
// Revisa una vez si las fechas están cargadas y lo dice en pantalla
async function _invChequearFechas(){
  var box=document.getElementById('invFechasAviso');
  if(!box) return;
  try{
    var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,prox_llegada'
      +'&onorder=gt.0&limit=40',{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      if(/prox_llegada/.test(t)){
        box.innerHTML='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;'
          +'padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--t-rojo)">'
          +'<i class="ti ti-alert-triangle"></i> <b>Falta la columna de fechas de llegada.</b> '
          +'Hay que correr el script <code>llegadas.sql</code> en Supabase.</div>';
      }
      return;
    }
    var filas=await r.json()||[];
    if(!filas.length){ box.innerHTML=''; return; }
    var con=filas.filter(function(f){ return f.prox_llegada; }).length;
    if(con){ box.innerHTML=''; return; }     // todo bien, no molesta
    box.innerHTML='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:8px;'
      +'padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--t-marron)">'
      +'<i class="ti ti-clock"></i> Las fechas de llegada todavía no se sincronizaron. '
      +'Aparecerán en cuanto el worker corra la próxima sincronización de inventario.</div>';
  }catch(e){}
}

async function _verFechas(){
  try{
    var url=SB+'/rest/v1/inventario?select=itemcode,onorder,prox_llegada,ordenes_abiertas'
      +'&onorder=gt.0&order=onorder.desc&limit=15';
    var r=await fetch(url,{headers:SBH});
    if(!r.ok){
      var t=await r.text();
      if(/prox_llegada/.test(t) && /does not exist|column/i.test(t)){
        console.log('%c FALTA LA COLUMNA ','background:#dc2626;color:#fff;font-weight:700');
        console.log('Hay que correr el script llegadas.sql en Supabase.');
      } else {
        console.log('Error '+r.status+': '+t.slice(0,200));
      }
      return;
    }
    var filas=await r.json()||[];
    if(!filas.length){
      console.log('No hay artículos con cantidad por llegar.');
      return;
    }
    var con=filas.filter(function(f){ return f.prox_llegada; }).length;
    console.log('%c FECHAS DE LLEGADA ','background:#0c447c;color:#fff;font-weight:700');
    console.log(con+' de '+filas.length+' artículos revisados tienen fecha.');
    if(!con){
      console.log('La columna existe pero está vacía: falta reiniciar el worker '
        +'y esperar a que sincronice el inventario.');
    }
    console.table(filas.map(function(f){
      return {SKU:f.itemcode, 'Por llegar':f.onorder,
              'Llega el':f.prox_llegada||'(sin fecha)',
              'Órdenes':f.ordenes_abiertas||0};
    }));
  }catch(e){ console.log('No se pudo consultar:', e.message||e); }
}

function _invLlegadaTxt(x){
  var f=(x&&(x.prox_llegada||x.ultima_llegada))||'';
  if(!f) return '';
  var d=_repParseFecha(f);
  var txt=_fmtFechaCorta(f);
  if(!d) return txt;
  var dias=Math.round((d.getTime()-Date.now())/86400000);
  return txt+(dias<0 ? ' · vencida'
            : (dias===0 ? ' · hoy'
            : (dias<=30 ? (' · en '+dias+'d') : '')));
}

function _invLlegadaColor(x){
  var f=(x&&(x.prox_llegada||x.ultima_llegada))||'';
  var d=f?_repParseFecha(f):null;
  if(!d) return 'var(--text-muted)';
  var dias=Math.round((d.getTime()-Date.now())/86400000);
  if(dias<0)  return '#991b1b';     // debía haber llegado
  if(dias<=15) return '#166534';    // ya viene en camino
  return '#B45309';
}

function _invColOrden(titulo, campo, clase, estilo){
  var act=String(_invOrden||'');
  var esta=(act.indexOf(campo+'.')===0);
  var desc=esta && act.indexOf('.desc')>0;
  var flecha=esta ? (desc?' ▼':' ▲') : '';
  return '<div class="inv-num'+(clase?(' '+clase):'')+'"'
    +(estilo?(' style="'+estilo+';cursor:pointer;user-select:none"'):' style="cursor:pointer;user-select:none"')
    +' onclick="_invOrdenarPor(\''+campo+'\')"'
    +' title="Pulsa para ordenar por '+_esc(titulo)+'">'
    +'<span'+(esta?' style="color:var(--text-accent);font-weight:700"':'')+'>'
    +_esc(titulo)+flecha+'</span></div>';
}

// Alterna el sentido y recarga
function _invOrdenarPor(campo){
  var act=String(_invOrden||'');
  var esta=(act.indexOf(campo+'.')===0);
  var desc=esta && act.indexOf('.desc')>0;
  // La primera vez, de mayor a menor: es lo que se suele querer ver
  var nuevo = esta ? (desc ? (campo+'.asc.nullslast') : (campo+'.desc.nullslast'))
                   : (campo+'.desc.nullslast');
  // El desplegable de arriba refleja el orden elegido
  var sel=document.querySelector('select[onchange^="_invSetOrden"]');
  if(sel){
    if(!Array.prototype.some.call(sel.options, function(o){ return o.value===nuevo; })){
      var op=document.createElement('option');
      op.value=nuevo;
      op.textContent=(_INV_ORDENES[nuevo]||_invNombreOrden(campo, nuevo.indexOf('.desc')>0));
      sel.appendChild(op);
    }
    sel.value=nuevo;
  }
  _invSetOrden(nuevo);
  // Se repinta la cabecera para mover la flecha
  setTimeout(function(){
    var hdr=document.querySelector('.inv-hdr');
    if(!hdr) return;
    var cols=hdr.querySelectorAll('.inv-num');
    var defs=[['Existencia','onhand'],['Reservado','iscommited'],['Disponible','disponible'],
              ['Por llegar','onorder'],['Precio venta','precioventa']];
    // (la última columna es el ganchito del catálogo, sin orden)
    for(var i=0;i<cols.length && i<defs.length;i++){
      var esta=(String(_invOrden||'').indexOf(defs[i][1]+'.')===0);
      var desc=esta && String(_invOrden).indexOf('.desc')>0;
      cols[i].innerHTML='<span'+(esta?' style="color:var(--text-accent);font-weight:700"':'')+'>'
        +defs[i][0]+(esta?(desc?' ▼':' ▲'):'')+'</span>';
    }
  }, 30);
}

function _invNombreOrden(campo, desc){
  var n={onhand:'Existencia', iscommited:'Reservado', disponible:'Disponible',
         onorder:'Por llegar', precioventa:'Precio venta'}[campo]||campo;
  return n+(desc?'  mayor primero':'  menor primero');
}

var _INV_ORDENES={
  'fechaentrada.desc.nullslast': 'Más nueva primero',
  'fechaentrada.asc.nullslast':  'Más vieja primero',
  'itemcode.asc':   'SKU  A → Z',
  'itemcode.desc':  'SKU  Z → A',
  'itemname.asc':   'Descripción  A → Z',
  'onhand.desc':    'Más stock primero',
  'onhand.asc':     'Menos stock primero',
  'onorder.desc':   'Más por llegar primero',
  'precioventa.desc':'Precio venta  mayor primero'
};

// Departamentos del inventario. El valor es el trozo que se busca dentro del
// campo `grupo` de SAP (que llega como "..Hogar", "Home Deco", etc.).
var _INV_DEPTS=[
  {k:'todos',       l:'Todos',       p:''},
  {k:'hogar',       l:'Hogar',       p:'hogar'},
  {k:'muebles',     l:'Muebles',     p:'mueble'},
  {k:'alfombras',   l:'Alfombras',   p:'alfombra'},
  {k:'ropa',        l:'Ropa',        p:'ropa'},
  {k:'homedeco',    l:'Home Deco',   p:'deco'},
  {k:'campamento',  l:'Campamento',  p:'campamento'},
  {k:'electronica', l:'Electrónica', p:'electr'}
];
function _invDeptPatron(k){
  var d=_INV_DEPTS.find(function(x){ return x.k===k; });
  return d?d.p:'';
}

function _invNum(v){ return Number(v)||0; }
function _invDisp(x){
  if(x.disponible!=null && x.disponible!=='') return _invNum(x.disponible);
  return _invNum(x.onhand)-_invNum(x.iscommited);
}

// ═══════════════════════════════════════════════════════════════════════════
//  CATÁLOGO POR CORREO
//  El archivo generado se manda adjunto usando la misma cola de correos que
//  el resto del portal (correos_queue), así que sale con el remitente y las
//  reglas de siempre. Se usa desde todos los sitios donde se arma un catálogo.
// ═══════════════════════════════════════════════════════════════════════════

// El PDF/Excel se convierte a base64, que es como viajan los adjuntos
function _catBlobBase64(blob){
  return new Promise(function(res, rej){
    var fr=new FileReader();
    fr.onload=function(){
      var s=String(fr.result||'');
      res(s.slice(s.indexOf(',')+1));      // se quita el "data:...;base64,"
    };
    fr.onerror=function(){ rej(new Error('no se pudo leer el archivo')); };
    fr.readAsDataURL(blob);
  });
}

// archivos: [{nombre, blob, mime}]
// opciones = {para, cuerpo}: sirve para abrir el correo ya encaminado, como
// en las instrucciones de shipping mark, que van dirigidas al proveedor.
async function _catMailAbrir(archivos, titulo, opciones){
  opciones=opciones||{};
  archivos=(archivos||[]).filter(function(a){ return a && a.blob; });
  if(!archivos.length){ showT('No hay ningún archivo que enviar'); return; }

  // Los adjuntos se guardan como archivos vivos: así se pueden agregar más
  // o quitar alguno antes de enviar, y el peso se recalcula solo.
  window._catMailArch=archivos.map(function(a){
    return {nombre:a.nombre, blob:a.blob,
            mime:a.mime||a.blob.type||'application/octet-stream',
            url:URL.createObjectURL(a.blob)};
  });
  window._catMailRef=String(opciones.ref||'');       // orden donde se guardarán
  var limite=(typeof MAIL_MAX_MB!=='undefined')?MAIL_MAX_MB:20;

  var prev=document.getElementById('modalCatMail'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCatMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13700;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';

  var chips=(typeof USERS!=='undefined'?USERS:[])
    .filter(function(u){ return u && u.email; })
    .map(function(u){
      return '<span onclick="_catMailAgregar(\'' + '' + '\')" data-mail="'+_esc(u.email)+'" '
        +'class="cat-mail-chip" style="cursor:pointer;font-size:10.5px;background:var(--surface-1);'
        +'border:0.5px solid var(--border);border-radius:12px;padding:3px 9px;'
        +'color:var(--text-secondary)">'+_esc(u.name||u.email)+'</span>';
    }).join('');

  ov.innerHTML='<div style="background:var(--surface-0);border-radius:14px;padding:18px;'
      +'max-width:620px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px">'
      +'<div style="font-size:14px;font-weight:700"><i class="ti ti-mail"></i> Enviar el catálogo por correo</div>'
      +'<button onclick="document.getElementById(\'modalCatMail\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'
    +'<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px">'
      +'<span style="font-size:10px;font-weight:700;color:var(--text-muted);'
        +'text-transform:uppercase;letter-spacing:.4px">Se adjunta</span>'
      +'<label style="cursor:pointer;font-size:10.5px;color:var(--text-accent);'
        +'border:0.5px dashed var(--border-accent);border-radius:7px;padding:2px 9px">'
        +'<i class="ti ti-paperclip"></i> Agregar archivo'
        +'<input type="file" multiple style="display:none" '
        +'onchange="_catMailAdjuntarArchivos(this)"></label>'
    +'</div>'
    +'<div id="catmail-adj"></div>'

    +'<div style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase;'
      +'letter-spacing:.4px;margin-bottom:4px">Del equipo (clic para agregar)</div>'
    +'<div style="display:flex;gap:5px;flex-wrap:wrap;max-height:96px;overflow-y:auto;margin-bottom:10px">'
      +chips+'</div>'

    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">Para (uno o varios, separados por coma)</label>'
    +'<textarea id="catmail-para" rows="2" placeholder="cliente@ejemplo.com, otro@ejemplo.com" '
      +'data-pre="'+_esc(opciones.para||'')+'" '
      +'style="width:100%;padding:9px 11px;border:1px solid var(--border);border-radius:8px;'
      +'font-size:12.5px;margin:3px 0 10px;font-family:var(--font-sans);resize:vertical"></textarea>'

    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">Asunto</label>'
    +'<input id="catmail-asunto" value="'+_esc(titulo||'Catálogo')+'" '
      +'style="width:100%;padding:9px 11px;border:1px solid var(--border);border-radius:8px;'
      +'font-size:12.5px;margin:3px 0 10px">'

    +'<label style="font-size:11px;color:var(--text-muted);font-weight:500">Mensaje</label>'
    +'<textarea id="catmail-cuerpo" rows="5" style="width:100%;padding:9px 11px;'
      +'border:1px solid var(--border);border-radius:8px;font-size:12.5px;margin:3px 0 4px;'
      +'font-family:var(--font-sans);resize:vertical">'
      +_esc(opciones.cuerpo || ('Buen día,\n\nAdjunto el catálogo.\n\nSaludos,\n'
        +((typeof CU!=='undefined'&&CU.name)||'')+'\nKENNEDY CENTER CORP.'))+'</textarea>'

    +'<div id="catmail-msg" style="font-size:11.5px;margin:6px 0;min-height:16px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="document.getElementById(\'modalCatMail\').remove()">Cancelar</button>'
      +'<button class="btn bp" id="catmail-btn" onclick="_catMailEnviar()">'
        +'<i class="ti ti-send"></i> Enviar</button>'
    +'</div></div>';

  // A propósito NO se cierra al hacer clic fuera: se perdía el texto escrito
  // y los adjuntos ya preparados. Solo con Cancelar, con la × o al enviar.
  document.body.appendChild(ov);
  // Los chips agregan su dirección al campo
  ov.querySelectorAll('.cat-mail-chip').forEach(function(el){
    el.onclick=function(){ _catMailAgregar(el.getAttribute('data-mail')); };
  });
  // El destinatario que venga dado (el proveedor, por ejemplo)
  var _pa=document.getElementById('catmail-para');
  if(_pa && _pa.getAttribute('data-pre')) _pa.value=_pa.getAttribute('data-pre');
  _catMailPintarAdj();
  try{ _modalEsc(ov); }catch(e){}
}

// Pinta la lista de adjuntos con su peso y el aviso si se pasa del límite
function _catMailPintarAdj(){
  var d=document.getElementById('catmail-adj'); if(!d) return;
  var lista=(window._catMailArch||[]);
  var limite=(typeof MAIL_AVISO_MB!=='undefined')?MAIL_AVISO_MB:3;
  var kb=lista.reduce(function(a,x){ return a+Math.round((x.blob.size||0)/1024); },0);
  var mb=kb/1024;

  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:4px">';
  lista.forEach(function(a,i){
    var ext=String(a.nombre).split('.').pop().toLowerCase();
    var ico=(ext==='pdf')?'ti-file-type-pdf'
           :(['xlsx','xls','csv'].indexOf(ext)>=0)?'ti-file-spreadsheet'
           :(['jpg','jpeg','png','gif','webp'].indexOf(ext)>=0)?'ti-photo':'ti-file';
    var p=Math.round((a.blob.size||0)/1024);
    h+='<span style="display:inline-flex;align-items:center;gap:6px;padding:6px 8px 6px 11px;'
      +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:11.5px;max-width:330px">'
      +'<a href="'+a.url+'" target="_blank" rel="noopener" title="Abrir para revisarlo antes de enviar" '
        +'style="display:inline-flex;align-items:center;gap:7px;color:var(--text-accent);'
        +'text-decoration:none;overflow:hidden">'
        +'<i class="ti '+ico+'" style="font-size:16px"></i>'
        +'<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.nombre)+'</span>'
        +'<span style="color:var(--text-muted);font-size:10px;white-space:nowrap">'
        +(p<1024?(p+' KB'):((p/1024).toFixed(1)+' MB'))+'</span></a>'
      +'<button onclick="_catMailQuitarAdj('+i+')" title="Quitar este adjunto" '
        +'style="background:none;border:0;color:var(--text-muted);cursor:pointer;'
        +'font-size:15px;line-height:1;padding:0 2px">&times;</button>'
      +'</span>';
  });
  h+='</div><div style="font-size:10.5px;color:var(--text-muted);margin-bottom:12px">'
    +lista.length+' archivo(s) · '+(mb<1?(kb+' KB'):(mb.toFixed(1)+' MB'))
    +' · clic para abrirlos antes de enviar'
    +(mb>limite?(' · <b style="color:var(--t-ambar)">son más de '+limite+' MB: Outlook puede '
      +'rechazarlo, pero se intenta igual</b>'):'')
    +'</div>';
  d.innerHTML=h;
}

// Agrega archivos elegidos por la persona (logo, fotos, instrucciones…)
function _catMailAdjuntarArchivos(input){
  var fs=input && input.files ? Array.prototype.slice.call(input.files) : [];
  if(!fs.length) return;
  if(!window._catMailArch) window._catMailArch=[];
  fs.forEach(function(f){
    window._catMailArch.push({
      nombre:f.name, blob:f, mime:f.type||'application/octet-stream',
      url:URL.createObjectURL(f)
    });
  });
  input.value='';
  _catMailPintarAdj();
  showT(fs.length+' archivo(s) agregado(s)');
}

function _catMailQuitarAdj(i){
  var l=(window._catMailArch||[]);
  if(i<0 || i>=l.length) return;
  if(l.length===1){ showT('Tiene que quedar al menos un adjunto'); return; }
  l.splice(i,1);
  _catMailPintarAdj();
}

function _catMailAgregar(email){
  var t=document.getElementById('catmail-para'); if(!t || !email) return;
  var actual=String(t.value||'').split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  if(actual.indexOf(email)>=0) return;      // ya estaba
  actual.push(email);
  t.value=actual.join(', ');
}

function _catMailMsg(txt, tipo){
  var d=document.getElementById('catmail-msg'); if(!d) return;
  var c=(tipo==='err')?'var(--text-danger)':(tipo==='ok'?'var(--text-success)':'var(--text-muted)');
  d.innerHTML='<span style="color:'+c+'">'+txt+'</span>';
}

async function _catMailEnviar(){
  var para=String(((document.getElementById('catmail-para')||{}).value)||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  if(!para.length){ _catMailMsg('Poné al menos un destinatario.','err'); return; }
  var malos=para.filter(function(x){ return !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(x); });
  if(malos.length){ _catMailMsg('Dirección no válida: '+_esc(malos[0]),'err'); return; }

  var asunto=String(((document.getElementById('catmail-asunto')||{}).value)||'').trim();
  if(!asunto){ _catMailMsg('Escribe un asunto.','err'); return; }
  var cuerpo=String(((document.getElementById('catmail-cuerpo')||{}).value)||'');

  var btn=document.getElementById('catmail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }
  _catMailMsg('','info');

  // Los adjuntos se convierten ahora, para que entren también los que se
  // hayan agregado a mano después de abrir la ventana.
  var lista=(window._catMailArch||[]);
  if(!lista.length){ _catMailMsg('No hay ningún adjunto.','err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; } return; }
  _catMailMsg('Preparando '+lista.length+' adjunto(s)…','info');
  var adj=[];
  for(var i=0;i<lista.length;i++){
    try{
      var b64=await _catBlobBase64(lista[i].blob);
      adj.push({nombre:lista[i].nombre, contenido:b64, mime:lista[i].mime});
    }catch(e){ console.warn('[correo] adjunto:', e); }
  }
  if(!adj.length){ _catMailMsg('No se pudieron preparar los adjuntos.','err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; } return; }
  window._catMailAdj=adj;

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(window._catMailRef||'catalogo'),
        para_lista:para, para_email:para[0],
        asunto:asunto, cuerpo:cuerpo,
        adjuntos:(window._catMailAdj||[]),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Catálogo', estado:'pendiente'
      })
    });
    if(!r.ok){
      var t=await r.text();
      _catMailMsg('No se pudo enviar: '+_esc(t.slice(0,180)),'err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
    _catMailMsg('✓ En cola. Sale en unos segundos, cuando el worker lo procese.','ok');
    showT('✓ Enviado a '+para.length+' destinatario(s)');
    // Los adjuntos quedan guardados en la orden, para poder revisarlos
    // después: lo que se le mandó al proveedor no debe perderse.
    try{ await _catMailGuardarEnOrden(); }catch(e){ console.warn('[correo] guardar:', e); }
    setTimeout(function(){
      var m=document.getElementById('modalCatMail'); if(m) m.remove();
    }, 1600);
  }catch(e){
    _catMailMsg('Error de conexión: '+_esc(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
  }
}

// Guarda en la orden (SAP o NO SAP) todo lo que se acaba de enviar, en su
// propia etapa, para poder consultarlo en cualquier momento.
async function _catMailGuardarEnOrden(){
  var ref=String(window._catMailRef||'').trim();
  var lista=(window._catMailArch||[]);
  if(!ref || !lista.length) return;

  var k=ref+'shipping_mark';
  if(!window._atts) window._atts={};
  if(!window._atts[k]) window._atts[k]=[];

  var n=0, fallos=[];
  for(var i=0;i<lista.length;i++){
    try{
      var f=(lista[i].blob instanceof File)
        ? lista[i].blob
        : new File([lista[i].blob], lista[i].nombre, {type:lista[i].mime});
      var path=await _subirDocStorage(ref, 'shipping_mark', f);
      if(!path){ fallos.push(lista[i].nombre+' (no se pudo subir)'); continue; }
      // Si el registro falla, el archivo existe pero la orden no lo ve nunca:
      // por eso el error se muestra en vez de quedar solo en la consola.
      try{ await _registrarDoc(ref, 'shipping_mark', f, path); }
      catch(e){ fallos.push(lista[i].nombre+' (no se registró: '+(e.message||e)+')'); continue; }
      window._atts[k].push({
        name:lista[i].nombre,
        url:DOCS_BASE+path.split('/').map(encodeURIComponent).join('/')
      });
      n++;
    }catch(e){ console.warn('[correo] guardar adjunto:', e); }
  }
  if(n){
    try{ window._atts[k]=_dedupDocs(window._atts[k]); }catch(e){}
    showT('✓ '+n+' adjunto(s) guardados en la orden '+ref);
  }
  if(fallos.length){
    alert('El correo se envió, pero NO se pudieron guardar en la orden '+ref+':\n\n  \u00b7 '
      +fallos.join('\n  \u00b7 ')
      +'\n\nSe pueden volver a adjuntar a mano desde \"Ver / adjuntos\".');
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  SELECCIÓN DE ARTÍCULOS EN LA CONSULTA DE INVENTARIO
//  Un ganchito por fila para armar el catálogo con lo que se elija.
// ═══════════════════════════════════════════════════════════════════════════
window._invSel = window._invSel || {};

function _invSelMarcar(sku, on, ev){
  if(ev && ev.stopPropagation) ev.stopPropagation();
  sku=String(sku||'').toUpperCase();
  if(on) window._invSel[sku]=true; else delete window._invSel[sku];
  _invSelBadge();
  // Si se está viendo solo lo marcado, lo que se desmarca sale de la lista
  if(window._invSoloSel && !on){
    var sel=_invSelFilas();
    var b=document.getElementById('invBody');
    if(b){
      b.innerHTML='';
      if(sel.length) _invPintar(sel);
      else { window._invSoloSel=false; _invVerSoloSel(); _invVerSoloSel(); }
    }
    var mas=document.getElementById('invMas');
    if(mas && sel.length) mas.innerHTML='Mostrando solo los '+sel.length+' artículo(s) marcados';
  }
}

function _invSelBadge(){
  var n=Object.keys(window._invSel||{}).length;
  var b=document.getElementById('invSelN');
  if(b) b.textContent=n;
  var btn=document.getElementById('invSelBtn');
  if(btn){ btn.style.display=n?'inline-flex':'none'; }
}

function _invSelLimpiar(){
  window._invSel={};
  document.querySelectorAll('.inv-check').forEach(function(c){ c.checked=false; });
  if(window._invSoloSel) _invVerSoloSel();      // se sale del modo "solo marcados"
  _invSelBadge();
}

// Muestra únicamente los artículos marcados, para revisar la selección antes
// de generar el catálogo. Se vuelve a la lista completa con el mismo botón.
function _invVerSoloSel(){
  var b=document.getElementById('invBody'); if(!b) return;
  window._invSoloSel=!window._invSoloSel;

  var btn=document.getElementById('invVerSelBtn');
  var mas=document.getElementById('invMas');

  if(window._invSoloSel){
    var sel=_invSelFilas();
    if(!sel.length){
      window._invSoloSel=false;
      showT('No hay artículos marcados');
      return;
    }
    b.innerHTML=''; _invPintar(sel);
    if(btn){
      btn.innerHTML='<i class="ti ti-list"></i> Ver todos';
      btn.style.background='#EEEDFE'; btn.style.color='#3C3489'; btn.style.borderColor='#C7C3F5';
    }
    if(mas) mas.innerHTML='Mostrando solo los '+sel.length+' artículo(s) marcados';
  } else {
    b.innerHTML=''; _invPintar(_invRows||[]);
    if(btn){
      btn.innerHTML='<i class="ti ti-list-check"></i> Ver marcados';
      btn.style.background='var(--surface-1)'; btn.style.color='var(--text-secondary)';
      btn.style.borderColor='var(--border)';
    }
    if(mas) mas.innerHTML=_invFin
      ? (_invRows.length?('Fin del listado · '+_invRows.length+' artículos'):'')
      : 'Baja para cargar más…';
  }
}

// Los artículos elegidos, tomados de lo que está cargado en la tabla
function _invSelFilas(){
  var sel=window._invSel||{};
  return (_invRows||[]).filter(function(x){
    return sel[String(x.itemcode||'').toUpperCase()];
  });
}

// Un artículo del inventario con la forma de ficha del catálogo. A
// diferencia de _invIAFicha, esta SÍ se puede editar en la revisión: lleva el
// costo para calcular el margen y no trae la marca __sinEdit.
// ── Averiguar qué foto existe de verdad, antes de generar el catálogo ──
// SAP guarda el nombre del archivo con mayúsculas o con otra extensión que
// la del bucket. En pantalla eso se salva reintentando cuando la imagen
// falla, pero en el PDF no hay segunda oportunidad: si la URL está mal, el
// artículo sale sin foto. Aquí se prueban las variantes con antelación y se
// deja la que carga.
function _catFotoVariantes(pic){
  var base=String(pic||'').trim();
  if(!base) return [];
  var sinExt=base.replace(/\.[^.]+$/,'');
  var out=[];
  ['', '.jpg', '.JPG', '.jpeg', '.png', '.PNG', '.webp'].forEach(function(ext){
    var n = ext ? (sinExt+ext) : base;
    [n, n.toLowerCase(), n.toUpperCase()].forEach(function(v){
      var u=FOTO_BASE+encodeURIComponent(v);
      if(out.indexOf(u)<0) out.push(u);
    });
  });
  return out;
}

function _catProbarFoto(url){
  return new Promise(function(res){
    var im=new Image();
    var listo=false;
    var fin=function(ok){ if(!listo){ listo=true; res(ok?url:null); } };
    im.onload =function(){ fin(im.naturalWidth>0); };
    im.onerror=function(){ fin(false); };
    setTimeout(function(){ fin(false); }, 7000);   // que no se quede colgado
    im.src=url;
  });
}

async function _catResolverFotos(fichas){
  var pend=(fichas||[]).filter(function(f){ return f.__pic && !f.__fotoOk; });
  if(!pend.length) return 0;
  var arreglos=0, i=0;
  // De ocho en ocho: ni una a una (lento) ni todas de golpe (satura)
  async function unaTanda(){
    while(i<pend.length){
      var f=pend[i++];
      var alts=_catFotoVariantes(f.__pic);
      for(var k=0;k<alts.length;k++){
        var ok=await _catProbarFoto(alts[k]);
        if(ok){
          if(f.foto!==ok){ f.foto=ok; arreglos++; }
          f.__fotoOk=1;
          break;
        }
      }
      if(!f.__fotoOk && f.__fotoNoSap){    // último recurso: la del catálogo NO SAP
        f.foto=f.__fotoNoSap; f.__fotoOk=1; arreglos++;
      }
    }
  }
  await Promise.all([unaTanda(),unaTanda(),unaTanda(),unaTanda(),
                     unaTanda(),unaTanda(),unaTanda(),unaTanda()]);
  var sin=pend.filter(function(f){ return !f.__fotoOk; }).length;
  console.log('[catálogo] fotos: '+arreglos+' corregida(s)'
    +(sin?(' · '+sin+' sin imagen en el bucket'):''));
  return arreglos;
}

function _invFichaCatalogo(x){
  // Orden de preferencia para el costo: última compra, promedio, CIF y FOB.
  // Sin costo, la casilla de margen no puede calcular el precio de venta, y
  // en artículos viejos lastpurprc suele venir en cero.
  var costo=Number(x.lastpurprc)||Number(x.avgprice)||Number(x.cif)||Number(x.fob)||0;
  return {
    tipo:'item',
    itemcode:x.itemcode||'',
    itemname:x.itemname||'',
    descripcion:x.itemname||x.frgnname||'',
    marca:x.marca||'',
    _dept:String(x.grupo||'').replace(/^[.\s]+/,''),
    material:'',
    color:x.u_color||'',
    tamano:x.u_tamano||'',
    medida:x.u_tamano||'',
    unidades_x_caja:x.unidadesbulto||x.salpackun||'',
    carton_size:'',
    peso:x.peso||'',
    cbm:x.volumen||'',
    barcode:x.codebars||'',
    precio:costo,                                  // costo, para el margen
    precio_venta:Number(x.precioventa)||0,
    disponible:_invDisp(x),
    foto:(x.foto || _repFotoUrl(x.picturname) || ''),
    __pic:(x.picturname||''),                       // para probar variantes
    __fotoNoSap:(function(){ try{ return _fotoNoSapDeSku(x.itemcode)||''; }catch(e){ return ''; } })(),
    __fotoOk:(x.foto?1:0)                           // la del catálogo NO SAP ya vale
  };
}

// Igual que en las órdenes: primero la revisión, y desde ahí se genera o se
// envía. Así el precio de venta se puede ajustar antes de que salga.

// ══════════════════════════════════════════════════════════════════════
//  VENTAS POR DEPARTAMENTO  ·  solo gerencia
//  El año fiscal en curso hasta hoy, contra el mismo periodo del año
//  pasado. Sale de la consulta que gerencia ya usa en SAP: facturas menos
//  notas de crédito, con los cancelados invertidos.
// ══════════════════════════════════════════════════════════════════════
window._vtaDep      = window._vtaDep || null;
window._vtaDepVista = window._vtaDepVista || 'tabla';

async function _vtaDepCargar(forzar){
  if(window._vtaDep && window._vtaDep.length && !forzar) return window._vtaDep;
  window._vtaDepError=null;
  try{
    var r=await fetch(SB+'/rest/v1/ventas_departamento?select=*&order=monto.desc&limit=200',
      {headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      window._vtaDepError = r.status+' · '+t.slice(0,200);
      console.error('[ventas dept] '+r.status+': '+t.slice(0,300));
      window._vtaDep=[];
      return window._vtaDep;
    }
    window._vtaDep = await r.json() || [];
    console.log('[ventas dept] '+window._vtaDep.length+' fila(s) leídas');
  }catch(e){
    window._vtaDepError = e && e.message || String(e);
    console.error('[ventas dept]',e);
    window._vtaDep=window._vtaDep||[];
  }
  return window._vtaDep;
}

async function _vtaDepRecargar(){
  showT('Actualizando las ventas…');
  window._vtaDep=null; window._vtaDepError=null; window._vtaDepReintento=0;
  await _vtaDepCargar(true);
  try{ rDash(); }catch(e){}
}

function _vtaDepSetVista(v){ window._vtaDepVista=v; try{ rDash(); }catch(e){} }

// La variación contra el año pasado, en color
function _vtaDepVar(actual, previo){
  var a=Number(actual)||0, p=Number(previo)||0;
  if(!p) return '<span style="color:var(--text-muted)">—</span>';
  var pct=(a-p)/Math.abs(p)*100;
  var col = pct>=0 ? '#166534' : '#b91c1c';
  var ic  = pct>=0 ? '▲' : '▼';
  return '<span style="color:'+col+';font-weight:700;white-space:nowrap">'
    +ic+' '+Math.abs(pct).toFixed(1)+'%</span>';
}

function _vtaDepPanel(){
  if(!CU || CU.role!=='gerencia') return '';
  if(window._vtaDep===null || (!window._vtaDep.length && !window._vtaDepError
                               && !window._vtaDepReintento)){
    if(window._vtaDep!==null) window._vtaDepReintento=1;
    _vtaDepCargar(true).then(function(){ try{ rDash(); }catch(e){} });
    return '<div class="slbl" style="margin-top:16px"><i class="ti ti-trending-up"></i>'
      +'Ventas por departamento</div>'
      +'<div class="empty" style="padding:16px;color:var(--text-muted);font-size:12px">'
      +'Calculando…</div>';
  }

  var filas=window._vtaDep||[];
  if(!filas.length){
    var err=window._vtaDepError;
    return '<div class="slbl" style="margin-top:16px"><i class="ti ti-trending-up"></i>'
      +'Ventas por departamento</div>'
      +'<div class="empty" style="padding:16px;color:var(--text-muted);font-size:12px">'
      +(err ? ('<b style="color:var(--t-rojo3)">No se pudo leer la tabla</b><br>'
               +'<span style="font-size:11px">'+_esc(err)+'</span>')
            : ('Todavía no hay datos. '
               +'<button onclick="_vtaDepRecargar()" class="btn bg2" '
               +'style="padding:2px 9px;font-size:10.5px">Reintentar</button><br>'
               +'<span style="font-size:11px">Si el worker ya cargó filas, revisa la '
               +'política de lectura de <b>ventas_departamento</b>.</span>'))
      +'</div>';
  }

  // Solo departamentos con movimiento: los de todo a cero estorban
  filas=filas.filter(function(f){
    return (Number(f.monto)||0)!==0 || (Number(f.monto_prev)||0)!==0; });
  // Y acotado al departamento de quien mira, si lo tiene
  if(_deptAcotado()) filas=filas.filter(function(f){
    return _deptPermitido(normDept(f.grupo)); });

  var tot=filas.reduce(function(a,f){
    a.cant+=Number(f.cantidad)||0;   a.cantP+=Number(f.cantidad_prev)||0;
    a.monto+=Number(f.monto)||0;     a.montoP+=Number(f.monto_prev)||0;
    a.bruto+=Number(f.bruto)||0;     a.brutoP+=Number(f.bruto_prev)||0;
    return a;
  },{cant:0,cantP:0,monto:0,montoP:0,bruto:0,brutoP:0});

  var vista=window._vtaDepVista||'tabla';
  var btnV=function(k,t,ic){
    var on=(vista===k);
    return '<button onclick="_vtaDepSetVista(\''+k+'\')" class="btn '+(on?'bp':'bg2')+'" '
      +'style="padding:3px 11px;font-size:10.5px'+(on?';background:#0F6E56':'')+'">'
      +'<i class="ti '+ic+'"></i> '+t+'</button>';
  };

  // El periodo, para que se sepa qué se está comparando
  var per='';
  try{
    var d1=new Date(filas[0].desde), d2=new Date(filas[0].hasta);
    if(!isNaN(d1)&&!isNaN(d2)){
      per='Año fiscal desde el '+d1.toLocaleDateString('es')+' hasta hoy, '
        +'comparado con el mismo periodo del año pasado.';
    }
  }catch(e){}

  var h='<div class="slbl" style="margin-top:16px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
    +'<span><i class="ti ti-trending-up"></i>Ventas por departamento</span>'
    +'<span style="flex:1"></span>'
    +btnV('tabla','Tabla','ti-table')+btnV('grafica','Gráfica','ti-chart-pie')
    +'<button onclick="_vtaDepRecargar()" class="btn bg2" '
    +'style="padding:3px 10px;font-size:10.5px"><i class="ti ti-refresh"></i> Actualizar</button></div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin:-4px 0 8px">'+_esc(per)+'</div>';

  if(vista==='grafica'){
    var datos=filas.filter(function(f){ return (Number(f.monto)||0)>0; })
      .map(function(f){ return {nombre:_invValNombre(f.grupo), valor:Number(f.monto)||0}; });
    h+=_invValRueda(datos, datos.reduce(function(a,d){return a+d.valor;},0),
                    'VENTAS DEL AÑO FISCAL');
    return h;
  }

  var cuerpo=filas.map(function(f){
    var m=Number(f.monto)||0, b=Number(f.bruto)||0;
    var margen = m ? (b/m*100) : 0;
    return '<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:6px 9px"><b>'+_esc(_invValNombre(f.grupo))+'</b></td>'
      +'<td style="padding:6px 9px;text-align:right">'+_fmtN2(Math.round(Number(f.cantidad)||0))+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:#0F6E56">'+fmt(m)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--text-muted)">'+fmt(f.monto_prev)+'</td>'
      +'<td style="padding:6px 9px;text-align:right">'+_vtaDepVar(m, f.monto_prev)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--t-lila)">'+fmt(b)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:600;color:'
        +(margen<15?'#b91c1c':'var(--text-primary)')+'">'+margen.toFixed(1)+'%</td>'
      +'</tr>';
  }).join('');

  var margenTot = tot.monto ? (tot.bruto/tot.monto*100) : 0;
  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden;'
    +'background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +'<th style="padding:7px 9px;text-align:left;font-size:9.5px;text-transform:uppercase">Departamento</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Unidades</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Vendido</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Año pasado</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Variación</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Ganancia</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Margen</th>'
    +'</tr></thead><tbody>'+cuerpo+'</tbody>'
    +'<tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
      +'<td style="padding:8px 9px;font-weight:800">GRAN TOTAL</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+_fmtN2(Math.round(tot.cant))+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:#0F6E56">'+fmt(tot.monto)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;color:var(--text-muted)">'+fmt(tot.montoP)+'</td>'
      +'<td style="padding:8px 9px;text-align:right">'+_vtaDepVar(tot.monto, tot.montoP)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-lila)">'+fmt(tot.bruto)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+margenTot.toFixed(1)+'%</td>'
    +'</tr></tfoot></table></div>';
  return h;
}

// ══════════════════════════════════════════════════════════════════════
//  VALOR DEL INVENTARIO  ·  solo gerencia
//  Cuánto vale en dinero lo que hay hoy en existencias, por departamento y
//  por proveedor. Sale del "Pivote de Inventario" de SAP, que el worker
//  agrega y deja en la tabla inventario_valores.
//
//  Tres niveles: departamentos → proveedores de uno → artículos de uno.
//  Desde el último se arma un catálogo o cotización para el cliente.
// ══════════════════════════════════════════════════════════════════════

window._invVal      = window._invVal || null;   // filas de la tabla
window._invValDept  = null;                     // departamento abierto
window._invValCard  = null;                     // proveedor abierto

async function _invValCargar(forzar){
  // OJO: un array vacío también es "truthy". Si una carga anterior falló
  // —por ejemplo antes de crear la política de lectura— quedaba guardado
  // como [] y no se volvía a pedir nunca, aunque la tabla ya tuviera datos.
  if(window._invVal && window._invVal.length && !forzar) return window._invVal;
  window._invValError=null;
  try{
    var out=[], desde=0;
    while(true){
      var url=SB+'/rest/v1/inventario_valores?select=*&offset='+desde+'&limit=1000';
      var r=await fetch(url,{headers:SBH});
      if(!r.ok){
        var t=''; try{ t=await r.text(); }catch(e){}
        // "Vacío" y "no se pudo leer" son cosas distintas: si se confunden,
        // se busca el fallo donde no está.
        window._invValError = r.status+' · '+t.slice(0,200);
        console.error('[inv valor] '+r.status+' al leer inventario_valores: '+t.slice(0,300));
        break;
      }
      var lote=await r.json()||[];
      out=out.concat(lote);
      if(lote.length<1000) break;
      desde+=1000;
    }
    window._invVal=out;
    console.log('[inv valor] '+out.length+' fila(s) leídas de inventario_valores');
    if(!out.length && !window._invValError){
      console.warn('[inv valor] la consulta funcionó pero devolvió 0 filas. '
        +'Si el worker ya cargó datos, casi seguro es que falta la política de '
        +'lectura: la tabla tiene RLS activo y la clave anónima no ve nada.');
    }
  }catch(e){
    window._invValError = e && e.message || String(e);
    console.error('[inv valor]',e);
    window._invVal=window._invVal||[];
  }
  return window._invVal;
}

// Vuelve a pedir los datos, sin usar lo que hubiera guardado.
async function _invValRecargar(){
  showT('Actualizando el valor del inventario…');
  window._invVal=null; window._invValError=null; window._invValReintento=0;
  await _invValCargar(true);
  try{ rDash(); }catch(e){}
  var n=(window._invVal||[]).length;
  showT(n ? (n+' fila(s) cargadas') : 'Sigue sin devolver filas · mira la consola');
}

// ── La rueda de colores, como el pivote de SAP ──
// Se dibuja con SVG: nada de librerías, y así funciona también sin red.
window._invValVista = window._invValVista || 'tabla';

var INVVAL_COLORES = ['#5B21B6','#0F6E56','#B45309','#0c447c','#72243E','#3C3489',
                      '#D4537E','#7C3D12','#166534','#9D174D','#1D4ED8','#A16207',
                      '#0E7490','#4D7C0F','#6D28D9','#BE123C'];

function _invValRueda(datos, total, titulo){
  if(!total) return '';
  var R=118, CX=150, CY=140, ang=-Math.PI/2, partes='', leyenda='';
  datos.forEach(function(d, i){
    var frac=(d.valor||0)/total;
    if(frac<=0) return;
    var col=INVVAL_COLORES[i%INVVAL_COLORES.length];
    var fin=ang+frac*Math.PI*2;
    var x1=CX+R*Math.cos(ang),  y1=CY+R*Math.sin(ang);
    var x2=CX+R*Math.cos(fin),  y2=CY+R*Math.sin(fin);
    var grande = frac>0.5 ? 1 : 0;
    // Una porción del 100% no se puede dibujar con un arco: se usa un círculo
    if(frac>0.999){
      partes+='<circle cx="'+CX+'" cy="'+CY+'" r="'+R+'" fill="'+col+'"></circle>';
    } else {
      partes+='<path d="M '+CX+' '+CY+' L '+x1.toFixed(2)+' '+y1.toFixed(2)
        +' A '+R+' '+R+' 0 '+grande+' 1 '+x2.toFixed(2)+' '+y2.toFixed(2)+' Z" '
        +'fill="'+col+'" stroke="var(--surface-0)" stroke-width="1.5">'
        +'<title>'+_esc(d.nombre)+': '+fmt(d.valor)+' · '+(frac*100).toFixed(2)+'%</title>'
        +'</path>';
    }
    leyenda+='<div style="display:flex;align-items:center;gap:7px;padding:2px 0;font-size:11px'
      +(d.onclick?';cursor:pointer':'')+'"'+(d.onclick?(' onclick="'+d.onclick+'"'):'')+'>'
      +'<span style="width:11px;height:11px;border-radius:3px;background:'+col+';flex-shrink:0"></span>'
      +'<span style="flex:1">'+_esc(d.nombre)+'</span>'
      +'<b style="white-space:nowrap">'+(frac*100).toFixed(2)+'%</b>'
      +'<span style="color:var(--text-muted);white-space:nowrap;min-width:96px;text-align:right">'
      +fmt(d.valor)+'</span></div>';
    ang=fin;
  });

  return '<div style="display:flex;gap:18px;flex-wrap:wrap;align-items:flex-start;'
    +'border:0.5px solid var(--border);border-radius:10px;padding:14px;background:var(--surface-0)">'
    +'<div style="flex-shrink:0"><div style="font-size:12px;font-weight:700;color:var(--t-azul);'
    +'text-align:center;margin-bottom:4px">'+_esc(titulo||'MONTO CIF')+'</div>'
    +'<svg viewBox="0 0 300 280" style="width:300px;max-width:100%;height:auto">'+partes
    +'<circle cx="'+CX+'" cy="'+CY+'" r="46" fill="var(--surface-0)"></circle>'
    +'<text x="'+CX+'" y="'+(CY-4)+'" text-anchor="middle" style="font-size:11px;'
    +'fill:var(--text-muted)">TOTAL</text>'
    +'<text x="'+CX+'" y="'+(CY+13)+'" text-anchor="middle" style="font-size:12.5px;'
    +'font-weight:700;fill:var(--text-primary)">'+_esc(fmt(total))+'</text>'
    +'</svg></div>'
    +'<div style="flex:1;min-width:280px">'+leyenda+'</div></div>';
}

function _invValSetVista(v){ window._invValVista=v; try{ rDash(); }catch(e){} }

function _invValSuma(filas){
  var t={cantidad:0, fob:0, cif:0, precio:0, promedio:0};
  (filas||[]).forEach(function(f){
    t.cantidad += Number(f.cantidad)||0;
    t.fob      += Number(f.fob)||0;
    t.cif      += Number(f.cif)||0;
    t.precio   += Number(f.precio)||0;
    t.promedio += Number(f.promedio)||0;
  });
  return t;
}

// El nombre del grupo de SAP viene con puntos: '..Hogar'
function _invValNombre(g){ return String(g||'').replace(/^\.+/,'').trim(); }

function _invValPanel(){
  if(!CU || CU.role!=='gerencia') return '';
  // Se pide cuando no hay nada, y también cuando lo guardado quedó vacío
  // sin error: eso pasa si la primera carga se hizo antes de que la tabla
  // tuviera datos o permisos. Antes solo se pedía con null, así que el
  // panel se quedaba clavado en el mensaje de vacío para siempre.
  // Lo pendiente por llegar se usa en las tarjetas de departamento: se pide
  // una vez y el tablero se repinta al llegar.
  if(window._ocPend===null && !window._ocPendPidiendo){
    window._ocPendPidiendo=1;
    _ocPendCargar(true).then(function(){ try{ rDash(); }catch(e){} });
  }
  if(window._invVal===null || (!window._invVal.length && !window._invValError
                               && !window._invValReintento)){
    if(window._invVal!==null) window._invValReintento=1;   // solo una vez
    _invValCargar(true).then(function(){ try{ rDash(); }catch(e){} });
    return '<div class="slbl" style="margin-top:16px"><i class="ti ti-coin"></i>'
      +'Valor del inventario</div>'
      +'<div class="empty" style="padding:16px;color:var(--text-muted);font-size:12px">'
      +'Calculando…</div>';
  }
  var filas=window._invVal||[];
  // Quien lleva un departamento ve solo el suyo: Gady alfombras, Henry ropa.
  if(_deptAcotado()) filas=filas.filter(function(f){
    return _deptPermitido(normDept(f.grupo)); });
  if(!filas.length){
    var err=window._invValError;
    return '<div class="slbl" style="margin-top:16px"><i class="ti ti-coin"></i>'
      +'Valor del inventario</div>'
      +'<div class="empty" style="padding:16px;color:var(--text-muted);font-size:12px">'
      +(err
        ? ('<b style="color:var(--t-rojo3)">No se pudo leer la tabla</b><br>'
           +'<span style="font-size:11px">'+_esc(err)+'</span><br>'
           +'<span style="font-size:11px">Comprueba que exista <b>inventario_valores</b> '
           +'y que tenga política de lectura.</span>')
        : ('La tabla responde pero está vacía para el portal. '
           +'<button onclick="_invValRecargar()" class="btn bg2" '
           +'style="padding:2px 9px;font-size:10.5px"><i class="ti ti-refresh"></i> '
           +'Reintentar</button><br>'
           +'<span style="font-size:11px">Si el worker ya cargó filas (lo dice su log), '
           +'lo más probable es que falte la <b>política de lectura</b>: con RLS activo '
           +'y sin política, la clave del portal no ve nada. Está en el paso 2 de '
           +'crear_tabla_inventario_valores.sql.</span>'))
      +'</div>';
  }

  // Agrupar por departamento
  var porDept={};
  filas.forEach(function(f){
    var g=f.grupo||'(sin grupo)';
    (porDept[g]=porDept[g]||[]).push(f);
  });
  var deps=Object.keys(porDept).sort(function(a,b){
    return _invValSuma(porDept[b]).cif - _invValSuma(porDept[a]).cif;
  });
  var gran=_invValSuma(filas);

  var vista=window._invValVista||'tabla';
  var btnV=function(k,t,ic){
    var on=(vista===k);
    return '<button onclick="_invValSetVista(\''+k+'\')" class="btn '+(on?'bp':'bg2')+'" '
      +'style="padding:3px 11px;font-size:10.5px'+(on?';background:#5B21B6':'')+'">'
      +'<i class="ti '+ic+'"></i> '+t+'</button>';
  };
  var h='<div class="slbl" style="margin-top:16px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
    +'<span><i class="ti ti-coin"></i>Valor del inventario · lo que hay hoy en existencias</span>'
    +'<span style="flex:1"></span>'
    +btnV('tabla','Tabla','ti-table')
    +btnV('grafica','Gráfica','ti-chart-pie')
    +'<button onclick="_invValRecargar()" class="btn bg2" '
    +'style="padding:3px 10px;font-size:10.5px">'
    +'<i class="ti ti-refresh"></i> Actualizar</button></div>'
    // La hora de la carga es importante: comparado con el pivote de SAP en
    // vivo, los departamentos con venta ese día NO van a cuadrar, y sin este
    // dato parece un error de cálculo cuando solo es diferencia de momento.
    +'<div style="font-size:11px;color:var(--text-muted);margin:-4px 0 8px">'
    +'Pulsa un departamento para ver sus proveedores. '
    +(function(){
        var f=(filas[0]||{}).actualizado;
        if(!f) return 'Lo actualiza el worker una vez por hora.';
        var d=new Date(f);
        if(isNaN(d)) return 'Lo actualiza el worker una vez por hora.';
        var min=Math.round((Date.now()-d.getTime())/60000);
        var hace = min<1 ? 'ahora mismo'
                 : (min<60 ? ('hace '+min+' min')
                 : ('hace '+Math.round(min/60)+' h'));
        return '<b>Existencias de las '+d.toLocaleTimeString('es',{hour:'2-digit',minute:'2-digit'})
          +'</b> ('+hace+'). Si lo comparas con SAP en vivo, los departamentos que '
          +'hayan vendido desde entonces darán menos.';
      })()
    +'</div>';

  // La rueda: cada porción es un departamento, por monto CIF
  if(vista==='grafica'){
    var datos=deps.map(function(g){
      return {nombre:_invValNombre(g), valor:_invValSuma(porDept[g]).cif,
              onclick:"_invValAbrirDept('"+_esc(String(g).replace(/'/g,''))+"')"};
    });
    h+=_invValRueda(datos, gran.cif, 'MONTO CIF POR DEPARTAMENTO');
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">'
      +'Pulsa un departamento de la lista para ver sus proveedores.</div>';
    return h;
  }

  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden;'
    +'background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +'<th style="padding:7px 9px;text-align:left;font-size:9.5px;text-transform:uppercase">Departamento</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Cantidad</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">FOB</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Promedio</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">CIF</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Precio venta</th>'
    +'</tr></thead><tbody>';

  deps.forEach(function(g){
    var t=_invValSuma(porDept[g]);
    var pct = gran.cif ? (t.cif/gran.cif*100) : 0;
    h+='<tr onclick="_invValAbrirDept(\''+_esc(String(g).replace(/'/g,''))+'\')" '
      +'style="border-top:0.5px solid var(--border);cursor:pointer">'
      +'<td style="padding:6px 9px">'
        +'<b>'+_esc(_invValNombre(g))+'</b>'
        +'<div style="font-size:9.5px;color:var(--text-muted)">'
          +porDept[g].length+' proveedor(es) · '+pct.toFixed(1)+'% del CIF</div></td>'
      +'<td style="padding:6px 9px;text-align:right">'+_fmtN2(Math.round(t.cantidad))+'</td>'
      +'<td style="padding:6px 9px;text-align:right">'+fmt(t.fob)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--text-muted)">'+fmt(t.promedio)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:var(--t-lila)">'+fmt(t.cif)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:600;color:var(--t-verde)">'+fmt(t.precio)+'</td>'
      +'</tr>';
  });

  h+='</tbody><tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
    +'<td style="padding:8px 9px;font-weight:800">GRAN TOTAL</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+_fmtN2(Math.round(gran.cantidad))+'</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+fmt(gran.fob)+'</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:700;color:var(--text-muted)">'+fmt(gran.promedio)+'</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-lila)">'+fmt(gran.cif)+'</td>'
    +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-verde)">'+fmt(gran.precio)+'</td>'
    +'</tr></tfoot></table></div>';
  return h;
}

// ── Nivel 2: los proveedores de un departamento ──
function _invValAbrirDept(grupo){
  // Aunque el panel ya viene filtrado, esta función se puede llamar con
  // cualquier grupo: se vuelve a comprobar aquí.
  if(_deptAcotado() && !_deptPermitido(normDept(grupo))){
    showT('Ese departamento no es tuyo'); return;
  }
  window._invValDept=grupo;
  var filas=(window._invVal||[]).filter(function(f){
    return String(f.grupo||'').replace(/'/g,'')===grupo; });
  filas.sort(function(a,b){ return (Number(b.cif)||0)-(Number(a.cif)||0); });
  var t=_invValSuma(filas);

  var cuerpo=filas.map(function(f){
    return '<tr onclick="_invValAbrirProv(\''+_esc(String(f.cardcode||'').replace(/'/g,''))+'\')" '
      +'style="border-top:0.5px solid var(--border);cursor:pointer">'
      +'<td style="padding:6px 9px"><b>'+_esc(f.cardname||'')+'</b>'
        +'<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(f.cardcode||'')+'</div></td>'
      +'<td style="padding:6px 9px;text-align:right">'+_fmtN2(Math.round(Number(f.cantidad)||0))+'</td>'
      +'<td style="padding:6px 9px;text-align:right">'+fmt(f.fob)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--text-muted)">'+fmt(f.promedio)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:var(--t-lila)">'+fmt(f.cif)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:600;color:var(--t-verde)">'+fmt(f.precio)+'</td>'
      +'</tr>';
  }).join('');

  // La rueda del departamento: una porción por proveedor, como en el pivote
  var vistaD=window._invValVistaDept||'tabla';
  var btnD=function(k,t,ic){
    var on=(vistaD===k);
    return '<button onclick="window._invValVistaDept=\''+k+'\';_invValAbrirDept(\''
      +_esc(String(grupo).replace(/'/g,''))+'\')" class="btn '+(on?'bp':'bg2')+'" '
      +'style="padding:3px 11px;font-size:10.5px'+(on?';background:#5B21B6':'')+'">'
      +'<i class="ti '+ic+'"></i> '+t+'</button>';
  };
  var rueda='';
  if(vistaD==='grafica'){
    // Con muchos proveedores la rueda se vuelve ilegible: se muestran los 12
    // mayores y el resto se agrupa.
    var top=filas.slice(0,12).map(function(f){
      return {nombre:(f.cardname||f.cardcode||''), valor:Number(f.cif)||0,
              onclick:"_invValAbrirProv('"+_esc(String(f.cardcode||'').replace(/'/g,''))+"')"};
    });
    var resto=filas.slice(12).reduce(function(a,f){ return a+(Number(f.cif)||0); },0);
    if(resto>0) top.push({nombre:'Otros ('+(filas.length-12)+' proveedores)', valor:resto});
    rueda=_invValRueda(top, t.cif, 'MONTO CIF · '+_invValNombre(grupo).toUpperCase());
  }

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">📦</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">'+_esc(_invValNombre(grupo))+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'
      +filas.length+' proveedor(es) · pulsa uno para ver su inventario</div></div>'
    +btnD('tabla','Tabla','ti-table')+btnD('grafica','Gráfica','ti-chart-pie')
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'
    +(rueda?('<div style="margin-top:10px">'+rueda+'</div>'):'')
    +'<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden;margin-top:10px">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +'<th style="padding:7px 9px;text-align:left;font-size:9.5px;text-transform:uppercase">Proveedor</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Cantidad</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">FOB</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Promedio</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">CIF</th>'
      +'<th style="padding:7px 9px;text-align:right;font-size:9.5px;text-transform:uppercase">Precio venta</th>'
    +'</tr></thead><tbody>'+cuerpo+'</tbody>'
    +'<tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
      +'<td style="padding:8px 9px;font-weight:800">TOTAL</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+_fmtN2(Math.round(t.cantidad))+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+fmt(t.fob)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;color:var(--text-muted)">'+fmt(t.promedio)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-lila)">'+fmt(t.cif)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-verde)">'+fmt(t.precio)+'</td>'
    +'</tr></tfoot></table></div>';
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
  document.getElementById('modal').style.display='flex';
}

// ── Nivel 3: los artículos de un proveedor ──
async function _invValAbrirProv(cardcode){
  window._invValCard=cardcode;
  var mc=document.getElementById('mc');
  mc.innerHTML='<div class="empty" style="padding:26px;color:var(--text-muted)">'
    +'<i class="ti ti-package" style="font-size:22px"></i><br>Buscando su inventario…</div>';
  document.getElementById('modal').style.display='flex';

  var items=[];
  try{
    var r=await fetch(SB+'/rest/v1/inventario?select=itemcode,itemname,grupo,onhand,iscommited,'
      // El costo hace falta para el margen del catálogo: sin lastpurprc ni
      // avgprice, la casilla de margen dice "no tiene costo" y no calcula.
      +'fob,cif,precioventa,picturname,ultima_venta,fechaentrada,vendido_3a,unidadesbulto,'
      +'lastpurprc,avgprice,codebars,u_color,u_tamano,marca,peso,volumen,salpackun,frgnname'
      +'&cardcode=eq.'+encodeURIComponent(cardcode)+'&onhand=gt.0&order=onhand.desc&limit=3000',
      {headers:SBH});
    if(r.ok) items=await r.json()||[];
    else {
      var t=''; try{ t=await r.text(); }catch(e){}
      console.error('[inv valor] artículos '+r.status+': '+t.slice(0,200));
    }
  }catch(e){ console.warn('[inv valor]',e); }

  window._invValItems=items;
  _invValPintarProv();
}

function _invValPintarProv(){
  var items=window._invValItems||[];
  var cardcode=window._invValCard;
  var f=(window._invVal||[]).find(function(x){ return String(x.cardcode)===String(cardcode); })||{};
  var filtro=window._invValFiltro||'todos';

  var lista=items.slice();
  if(filtro==='antiguos') lista=lista.filter(_invValEsAntiguo);
  if(filtro==='sinventa') lista=lista.filter(function(x){ return !(Number(x.vendido_3a)>0); });

  var tot=lista.reduce(function(a,x){
    var q=Number(x.onhand)||0;
    a.cant+=q; a.fob+=q*(Number(x.fob)||0);
    a.cif+=q*(Number(x.cif)||0); a.pv+=q*(Number(x.precioventa)||0);
    return a;
  },{cant:0,fob:0,cif:0,pv:0});

  var pastilla=function(k,t,n){
    var on=(filtro===k);
    return '<span onclick="window._invValFiltro=\''+k+'\';_invValPintarProv()" '
      +'style="cursor:pointer;border:1px solid '+(on?'#5B21B6':'var(--border)')+';'
      +'background:'+(on?'#5B21B6':'var(--surface-0)')+';color:'+(on?'#fff':'#5B21B6')+';'
      +'border-radius:20px;padding:4px 12px;font-size:11px;font-weight:600">'
      +t+' <span style="opacity:.8">'+n+'</span></span>';
  };

  var cuerpo=lista.slice(0,400).map(function(x){
    var q=Number(x.onhand)||0;
    var ant=_invValEsAntiguo(x);
    return '<tr style="border-top:0.5px solid var(--border);'+(ant?'background:var(--pastel-aviso)':'')+'">'
      +'<td style="padding:5px 8px;font-size:10.5px"><b>'+_esc(x.itemcode||'')+'</b>'
        +(ant?' <span style="font-size:9px;color:var(--t-ambar);font-weight:700">ANTIGUO</span>':'')+'</td>'
      +'<td style="padding:5px 8px;font-size:10.5px">'+_esc(x.itemname||'')+'</td>'
      +'<td style="padding:5px 8px;text-align:right">'+_fmtN2(q)+'</td>'
      +'<td style="padding:5px 8px;text-align:right">'+fmt(q*(Number(x.fob)||0))+'</td>'
      +'<td style="padding:5px 8px;text-align:right;color:var(--t-lila)">'+fmt(q*(Number(x.cif)||0))+'</td>'
      +'<td style="padding:5px 8px;text-align:right;color:var(--t-verde)">'+fmt(q*(Number(x.precioventa)||0))+'</td>'
      +'<td style="padding:5px 8px;font-size:10px;color:var(--text-muted);white-space:nowrap">'
        +_esc(_invValUltMov(x))+'</td>'
      +'</tr>';
  }).join('');

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">🏭</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">'+_esc(f.cardname||cardcode)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'+_esc(cardcode)+' · '
      +items.length+' artículo(s) con existencias</div></div>'
    +'<button class="btn bg2" onclick="_invValAbrirDept(\''
      +_esc(String(window._invValDept||'').replace(/'/g,''))+'\')">'
      +'<i class="ti ti-arrow-left"></i> Proveedores</button>'
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'

    +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin:10px 0">'
      +pastilla('todos','Todos', items.length)
      +pastilla('antiguos','Sin movimiento +2 años', items.filter(_invValEsAntiguo).length)
      +pastilla('sinventa','Nunca vendidos', items.filter(function(x){return !(Number(x.vendido_3a)>0);}).length)
      +'<span style="flex:1"></span>'
      +'<button class="btn bp" style="background:#5B21B6" onclick="_invValCatalogo()">'
        +'<i class="ti ti-book"></i> Armar catálogo o cotización</button>'
    +'</div>'

    +'<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +'<th style="padding:6px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">SKU</th>'
      +'<th style="padding:6px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Descripción</th>'
      +'<th style="padding:6px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">Existencia</th>'
      +'<th style="padding:6px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">FOB</th>'
      +'<th style="padding:6px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">CIF</th>'
      +'<th style="padding:6px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">Precio venta</th>'
      +'<th style="padding:6px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Último mov.</th>'
    +'</tr></thead><tbody>'+cuerpo+'</tbody>'
    +'<tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
      +'<td colspan="2" style="padding:7px 8px;font-weight:800">TOTAL '
        +(filtro==='todos'?'':'(filtrado)')+'</td>'
      +'<td style="padding:7px 8px;text-align:right;font-weight:800">'+_fmtN2(Math.round(tot.cant))+'</td>'
      +'<td style="padding:7px 8px;text-align:right;font-weight:800">'+fmt(tot.fob)+'</td>'
      +'<td style="padding:7px 8px;text-align:right;font-weight:800;color:var(--t-lila)">'+fmt(tot.cif)+'</td>'
      +'<td style="padding:7px 8px;text-align:right;font-weight:800;color:var(--t-verde)">'+fmt(tot.pv)+'</td>'
      +'<td></td></tr></tfoot></table></div>'
    +(lista.length>400?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">'
      +'Se muestran los 400 primeros de '+lista.length+'. El catálogo los incluye todos.</div>'):'');
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
}

// Sin movimiento en más de dos años
function _invValEsAntiguo(x){
  var f=x.ultima_venta || x.fechaentrada;
  if(!f) return true;                       // sin rastro: cuenta como antiguo
  var d=new Date(f);
  if(isNaN(d)) return true;
  return (Date.now()-d.getTime()) > 730*24*3600*1000;
}

function _invValUltMov(x){
  var f=x.ultima_venta || x.fechaentrada;
  if(!f) return 'sin datos';
  var d=new Date(f);
  if(isNaN(d)) return String(f).slice(0,10);
  var meses=(Date.now()-d.getTime())/(1000*60*60*24*30.4);
  return String(f).slice(0,10)+' · '+Math.round(meses)+' meses';
}

// El catálogo con lo que hay en pantalla: reutiliza el armador que ya
// existe, donde se editan precios y se genera el PDF para el cliente.
async function _invValCatalogo(){
  var items=window._invValItems||[];
  var filtro=window._invValFiltro||'todos';
  var lista=items.slice();
  if(filtro==='antiguos') lista=lista.filter(_invValEsAntiguo);
  if(filtro==='sinventa') lista=lista.filter(function(x){ return !(Number(x.vendido_3a)>0); });
  if(!lista.length){ showT('No hay artículos con este filtro'); return; }
  if(lista.length>400 && !confirm(lista.length+' artículos son '+Math.ceil(lista.length/10)
      +' páginas. ¿Seguimos?')) return;

  // Se reutiliza el armador de catálogos que ya existe: allí se revisan los
  // datos, se cambian los precios de venta y se genera el PDF para el
  // cliente. Solo hay que darle los artículos con la forma que espera.
  try{
    window._catFuente = lista.map(_invFichaCatalogo);
    window._catSel = {};
    window._catFuente.forEach(function(f){
      window._catSel[String(f.itemcode).toUpperCase()] = true; });
    _catTrabajando('Comprobando las fotos…');
    try{ await _catResolverFotos(window._catFuente); }catch(e){ console.warn('[catálogo] fotos:',e); }
    _catListo();
    CM();
    try{ _accRegistrar('accion','Generó catálogo de '+lista.length+' artículo(s)'); }catch(e){}
  showT(lista.length+' artículo(s) listos para revisar');
    await _catRevisarAbrir(true);     // sin autocompletar: no hay Excel de proveedor
  }catch(e){
    showT('No se pudo abrir el catálogo');
    console.warn('[inv valor] catálogo:', e);
  }
}

async function _invSelCatalogo(){
  var sel=_invSelFilas();
  if(!sel.length){ showT('Marca al menos un artículo'); return; }
  if(sel.length>400 && !confirm(sel.length+' artículos son '+Math.ceil(sel.length/10)
      +' páginas. ¿Seguimos?')) return;

  window._catFuente=sel.map(_invFichaCatalogo);
  window._catSel={};
  window._catFuente.forEach(function(f){
    window._catSel[String(f.itemcode).toUpperCase()]=true; });
  // Antes de abrir, se comprueba qué foto existe: en el PDF no hay reintento
  _catTrabajando('Comprobando las fotos…');
  try{ await _catResolverFotos(window._catFuente); }catch(e){ console.warn('[catálogo] fotos:',e); }
  _catListo();
  showT(sel.length+' artículo(s) listos para revisar');
  await _catRevisarAbrir(true);      // sin autocompletar: no hay Excel de proveedor
}

// ═══════════════════════════════════════════════════════════════════════════
//  SKU NO SAP DENTRO DE LA CONSULTA DE INVENTARIO
//  Son los artículos que todavía no existen en SAP, creados desde una orden
//  NO SAP. Se muestran arriba y en ámbar, para no confundirlos con los reales.
// ═══════════════════════════════════════════════════════════════════════════
function _invNoSapFilas(){
  var q=String(_invQ||'').trim().toLowerCase();
  var patron=((CU&&_deptAcotado())?_deptPrimero():_invDeptPatron(_invDept)||'').toLowerCase();

  return (window._catNoSap||[]).filter(function(f){
    // Solo los artículos que TODAVÍA no están en SAP. Las fichas degradadas
    // a tipo 'foto' ya existen en SAP: su artículo real sale de la consulta
    // normal y de ellas solo se aprovecha la imagen.
    if(!_catFichaViva(f)) return false;
    if(patron){
      var d=String(f.dept||f._dept||'').toLowerCase();
      if(d && d.indexOf(patron)<0) return false;
    }
    if(!q) return true;
    var blob=[f.itemcode,f.itemname,f.descripcion,f.cardname,f.marca,f.barcode]
      .map(function(v){ return String(v==null?'':v); }).join(' ').toLowerCase();
    return blob.indexOf(q)>=0;
  }).map(function(f){
    // Se le da la forma de una fila de inventario para poder pintarla igual
    var sku=String(f.itemcode||'');
    return {
      itemcode:sku,
      itemname:f.itemname||f.descripcion||'',
      onhand:0, iscommited:0, disponible:0,
      onorder:_catPorLlegar(sku),
      precioventa:Number(_catValor(f,'precio_venta'))||0,
      picturname:'', foto:f.foto||f.foto_url||'',
      marca:f.marca||'', grupo:f.dept||f._dept||'',
      nombre_proveedor:f.cardname||'', cardcode:f.cardcode||'',
      u_color:_catValor(f,'color')||'', u_tamano:_catValor(f,'tamano')||'',
      peso:_catValor(f,'peso')||'', volumen:f.cbm||'',
      unidadesbulto:_catValor(f,'unidades_x_caja')||'',
      codebars:_catValor(f,'barcode')||'',
      _nosap:true
    };
  });
}

// ═══════════════════════════════════════════════════════════════════════════
//  BÚSQUEDA CON IA EN EL INVENTARIO
//  Se escribe lo que se busca en español ("mesas negras de madera con
//  existencia, del proveedor Luoyang") y la IA lo traduce a un filtro sobre
//  las columnas del inventario. La IA NO ve el inventario: solo arma el
//  filtro. El cruce contra los artículos se hace aquí, en el navegador, así
//  que da igual que haya diez mil referencias y no se manda nada afuera.
//  Con lo que sale se puede armar el catálogo, con el mismo formato de ficha.
// ═══════════════════════════════════════════════════════════════════════════

window._invIARes = window._invIARes || [];   // lo que devolvió la última búsqueda
window._invIASel = window._invIASel || {};   // itemcode -> true
window._invIAPlan = null;                    // el filtro que armó la IA

// Texto comparable: sin mayúsculas, sin acentos y sin espacios de más
function _invNorm(s){
  if(s && typeof s==='object'){ try{ s=JSON.stringify(s); }catch(e){ s=''; } }
  return String(s==null?'':s).toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/\s+/g,' ').trim();
}

// Todo el texto de un artículo, para buscar dentro
function _invBlob(x){
  return _invNorm([x.itemcode, x.itemname, x.frgnname, x.marca, x.grupo, x.subg,
                   x.u_color, x.u_tamano, x.usertext, x.caracteristicas,
                   x.nombre_proveedor, x.cardcode].map(function(v){
    return (v && typeof v==='object') ? JSON.stringify(v) : (v||'');
  }).join(' '));
}

function _invIAAbrir(){
  var prev=document.getElementById('modalInvIA'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalInvIA';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10004;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto';

  var ejemplos=[
    'mesas negras de madera con existencia',
    'sillas sin existencia pero con mercancía por llegar',
    'alfombras del proveedor Luoyang con disponible mayor a 50',
    'todo lo que tenga cantidad reservada y precio de venta arriba de 100',
    'lámparas doradas sin nada por llegar'
  ];

  var h='<div style="background:var(--surface-0);border-radius:14px;padding:20px;'
    +'max-width:620px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px">'
      +'<div style="font-size:14px;font-weight:700;color:var(--t-indigo)">'
        +'<i class="ti ti-sparkles"></i> Buscar en el inventario con IA</div>'
      +'<button onclick="_invIACerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:12px">'
      +'Escribe lo que buscas como se lo dirías a una persona. Puedes pedir por color, '
      +'material, proveedor, marca y por cualquier columna: con o sin existencia, '
      +'con o sin reservado, con o sin mercancía por llegar, rango de precio…</div>'

    +'<textarea id="invIAQ" rows="3" placeholder="Ej: mesas negras de madera con existencia y sin nada por llegar" '
      +'style="width:100%;padding:10px 12px;border:1px solid var(--border);border-radius:9px;'
      +'font-size:13px;font-family:var(--font-sans);background:var(--surface-1);'
      +'color:var(--text-primary);resize:vertical"></textarea>'

    +'<div style="margin:9px 0 4px;font-size:10px;font-weight:700;color:var(--text-muted);'
      +'text-transform:uppercase;letter-spacing:.5px">Ejemplos</div>'
    +'<div style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:14px">'
      +ejemplos.map(function(e){
        return '<span onclick="document.getElementById(\'invIAQ\').value='
          +JSON.stringify(e).replace(/"/g,'&quot;')+'" '
          +'style="cursor:pointer;font-size:10.5px;background:var(--surface-1);'
          +'border:0.5px solid var(--border);border-radius:12px;padding:3px 9px;'
          +'color:var(--text-secondary)">'+_esc(e)+'</span>';
      }).join('')
    +'</div>'

    +'<div id="invIAEstado" style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_invIACerrar()">Cancelar</button>'
      +'<button class="btn bp" id="invIABtnBuscar" style="background:#3C3489" onclick="_invIABuscar()">'
        +'<i class="ti ti-search"></i> Buscar</button>'
    +'</div>'
    +'</div>';

  ov.innerHTML=h;
  ov.addEventListener('click', function(e){ if(e.target===ov) _invIACerrar(); });
  document.body.appendChild(ov);
  setTimeout(function(){
    var t=document.getElementById('invIAQ');
    if(t){
      t.focus();
      t.addEventListener('keydown', function(ev){
        if(ev.key==='Enter' && (ev.ctrlKey||ev.metaKey)) _invIABuscar();
      });
    }
  }, 60);
}

function _invIACerrar(){
  var m=document.getElementById('modalInvIA'); if(m) m.remove();
}

function _invIAEstado(txt, color){
  var e=document.getElementById('invIAEstado');
  if(e) e.innerHTML='<span style="color:'+(color||'var(--text-muted)')+'">'+txt+'</span>';
}

// ── 1) La IA traduce la frase a un filtro ────────────────────────────────
async function _invIAPlanear(frase){
  var sistema='Sos un traductor de búsquedas para el inventario de una tienda de importación.\n'
    +'Recibís una frase en español y devolvés SOLO un objeto JSON, sin explicaciones y sin markdown.\n\n'
    +'Columnas disponibles del inventario:\n'
    +'  itemcode (SKU), itemname y frgnname (descripción), marca, grupo (departamento),\n'
    +'  subg (subgrupo), u_color (color), u_tamano (medida), usertext y caracteristicas (ficha),\n'
    +'  nombre_proveedor y cardcode (proveedor), codebars,\n'
    +'  onhand (existencia), iscommited (reservado), disponible, onorder (por llegar),\n'
    +'  precioventa, lastpurprc (último costo), peso, volumen (CBM), unidadesbulto.\n\n'
    +'Formato de la respuesta:\n'
    +'{\n'
    +'  "texto": [["mesa","table"],["negro","negra","black"],["madera","wood","wooden"]],\n'
    +'  "excluir": ["plastico"],\n'
    +'  "proveedores": [],\n'
    +'  "marca": "",\n'
    +'  "numeros": {"onhand": {"op": ">", "v": 0}},\n'
    +'  "orden": "onhand.desc",\n'
    +'  "limite": 300,\n'
    +'  "resumen": "Mesas negras de madera con existencia"\n'
    +'}\n\n'
    +'Reglas:\n'
    +'- "texto" es una lista de condiciones que se cumplen TODAS. Cada condición es una lista de\n'
    +'  sinónimos de los que basta que aparezca UNO. Como las descripciones vienen mezcladas en\n'
    +'  español y en inglés, incluí siempre las dos variantes y el singular/plural.\n'
    +'- "numeros" acepta las columnas numéricas con op entre >, >=, <, <=, =, !=.\n'
    +'  "con existencia" es {"onhand":{"op":">","v":0}} y "sin existencia" es {"op":"=","v":0}.\n'
    +'  Lo mismo con iscommited (reservado), onorder (por llegar), disponible y precioventa.\n'
    +'  Si la frase no dice nada de una columna, NO la incluyas: no filtres de más.\n'
    +'- NO existe un campo de departamento. Si la frase nombra uno (muebles, hogar, ropa…),\n'
    +'  metelo como una condición más dentro de "texto", con sus variantes. El grupo de SAP\n'
    +'  se llama distinto en cada caso, así que nunca inventes el departamento de un artículo:\n'
    +'  una silla de oficina NO tiene por qué estar en el grupo "muebles".\n'
    +'- "proveedores" solo si nombra proveedores.\n'
    +'- "limite": cuántos artículos como mucho. Por defecto 300.\n'
    +'- "resumen": una línea en español describiendo lo que se buscó.\n'
    +'Devolvé únicamente el JSON.';

  var resp=await fetch('https://api.anthropic.com/v1/messages',{
    method:'POST',
    headers:{'Content-Type':'application/json','x-api-key':ANTHROPIC_KEY_ARTES,
             'anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
    body:JSON.stringify({model:IA_MODELO, max_tokens:900, system:sistema,
                         messages:[{role:'user', content:String(frase||'')}]})
  });
  // Se lee como TEXTO y luego se interpreta. Al revés no funciona: json()
  // consume el cuerpo, y si falla, el text() posterior devuelve vacío y no
  // hay forma de ver qué llegó. Por eso el aviso no decía nada útil.
  var data, crudoTxt='';
  try{
    crudoTxt=await resp.text();
    data=JSON.parse(crudoTxt);
  }catch(errJ){
    // Sin esto, una respuesta que no sea JSON hace saltar el error con los
    // bytes crudos dentro y en pantalla sale "Unexpected token '\uFFFD'".
    var crudo=crudoTxt;
    console.error('[IA] estado '+resp.status
      +' · tipo: '+((resp.headers&&resp.headers.get&&resp.headers.get('content-type'))||'?')
      +' · '+String(crudo||'').length+' caracteres recibidos');
    console.error('[IA] primeros 300: '
      +String(crudo||'').replace(/[^\x20-\x7E]/g,'·').slice(0,300));
    console.error('[IA] error original: '+((errJ&&errJ.message)||errJ));
    throw new Error(
      resp.status===413 ? 'El documento es demasiado grande para la IA. '
                         +'Súbelo en Excel o CSV, o divídelo.'
    : resp.status===401 ? 'La clave de la IA no es válida o caducó.'
    : resp.status===429 ? 'La IA está saturada. Prueba dentro de un minuto.'
    : resp.status>=500  ? 'La IA no respondió bien (error '+resp.status+').'
    : (resp.status===200
        ? ('La IA respondió, pero el navegador no pudo leer la respuesta. '
           +'Suele ser una extensión del navegador o un antivirus que se '
           +'interponen. Prueba en una ventana de incógnito. En la consola '
           +'queda el detalle de lo que llegó.')
        : 'La IA devolvió una respuesta ilegible (estado '+resp.status+').'));
  }
  if(data.error) throw new Error(data.error.message||'Error de IA');
  var txt=(data.content||[]).map(function(c){ return c.text||''; }).join('').trim();
  txt=txt.replace(/```json/gi,'').replace(/```/g,'').trim();
  var ini=txt.indexOf('{'), fin=txt.lastIndexOf('}');
  if(ini<0 || fin<ini) throw new Error('La IA no devolvió un filtro válido');
  var plan=JSON.parse(txt.slice(ini, fin+1));
  plan.texto=Array.isArray(plan.texto)?plan.texto:[];
  plan.excluir=Array.isArray(plan.excluir)?plan.excluir:[];
  plan.proveedores=Array.isArray(plan.proveedores)?plan.proveedores.filter(Boolean):[];
  plan.numeros=(plan.numeros&&typeof plan.numeros==='object')?plan.numeros:{};
  plan.limite=Math.min(1000, Math.max(1, Number(plan.limite)||300));
  return plan;
}

// ── 2) Se traen los candidatos de Supabase ───────────────────────────────
// Lo que se puede filtrar en la base (departamento, proveedor, números) va en
// la consulta. El texto se cruza después aquí, porque una descripción puede
// decir "black wooden table" y la frase pedir "mesa negra de madera".
var _INV_IA_OPS={'>':'gt','>=':'gte','<':'lt','<=':'lte','=':'eq','!=':'neq'};

// Lo que se lee para decidir. El resto de las columnas se piden después, solo
// de los artículos que quedaron.
var _INV_IA_SCAN='itemcode,itemname,frgnname,marca,grupo,subg,u_color,u_tamano,'
  +'usertext,caracteristicas,nombre_proveedor,cardcode,'
  +'onhand,iscommited,onorder,disponible,precioventa,picturname';

// La comprobación exacta de los números, ya con el artículo en la mano.
// "disponible" se calcula con _invDisp, que cubre el caso de que la columna
// venga vacía (existencia menos reservado).
function _invIANumOk(x, plan){
  var nums=plan.numeros||{};
  var cols=Object.keys(nums);
  for(var i=0;i<cols.length;i++){
    var c=cols[i], n=nums[c];
    if(!n || !_INV_IA_OPS[n.op]) continue;
    var v=(c==='disponible') ? _invDisp(x) : (Number(x[c])||0);
    var t=Number(n.v)||0;
    var ok = n.op==='>'  ? v>t  : n.op==='>=' ? v>=t
           : n.op==='<'  ? v<t  : n.op==='<=' ? v<=t
           : n.op==='='  ? v===t : n.op==='!=' ? v!==t : true;
    if(!ok) return false;
  }
  return true;
}

// Con los artículos ya elegidos se piden todas sus columnas, por tandas
async function _invIACompletar(res){
  var TANDA=200, mapa={};
  for(var i=0;i<res.length;i+=TANDA){
    var lote=res.slice(i,i+TANDA).map(function(x){
      return '"'+String(x.itemcode||'').replace(/"/g,'')+'"'; }).join(',');
    try{
      var r=await fetch(SB+'/rest/v1/inventario?select='+_INV_CAMPOS
        +'&itemcode=in.('+encodeURIComponent(lote)+')&limit='+TANDA,{headers:SBH});
      if(!r.ok) continue;
      (await r.json()||[]).forEach(function(x){ mapa[String(x.itemcode)]=x; });
    }catch(e){ console.warn('[inventario IA] completar:', e); }
  }
  // Se conserva el orden con el que venían
  return res.map(function(x){ return mapa[String(x.itemcode)]||x; });
}

// Las condiciones en palabras, para poder ver por qué no salió nada
function _invIAPlanTxt(plan){
  var p=[];
  (plan.texto||[]).forEach(function(c){
    var alts=(Array.isArray(c)?c:[c]).filter(Boolean);
    if(alts.length) p.push(alts.join(' / '));
  });
  (plan.excluir||[]).forEach(function(e){ if(e) p.push('sin "'+e+'"'); });
  if((plan.proveedores||[]).length) p.push('proveedor: '+plan.proveedores.join(' / '));
  if(plan.marca) p.push('marca: '+plan.marca);
  var ETI={onhand:'existencia', iscommited:'reservado', onorder:'por llegar',
           disponible:'disponible', precioventa:'precio venta'};
  Object.keys(plan.numeros||{}).forEach(function(c){
    var n=plan.numeros[c];
    if(n && _INV_IA_OPS[n.op]) p.push((ETI[c]||c)+' '+n.op+' '+(Number(n.v)||0));
  });
  return p;
}

async function _invIATraer(plan, aviso){
  // Se leen solo las columnas que hacen falta para decidir si el artículo
  // entra o no. Las demás se piden después, y únicamente de los que quedaron:
  // así se puede recorrer un inventario grande sin traerlo entero.
  var url=SB+'/rest/v1/inventario?select='+_INV_IA_SCAN;

  // El departamento sale del filtro de la pantalla (o del usuario, que manda
  // siempre). NO del que adivine la IA: el grupo de SAP se llama a su manera
  // y una silla de oficina puede no estar en "muebles".
  var patron=(CU&&_deptAcotado()) ? _deptPrimero() : _invDeptPatron(_invDept);
  if(patron) url+='&grupo=ilike.*'+encodeURIComponent(patron)+'*';

  // Un solo proveedor se filtra en la base; si son varios, se cruzan aquí
  if(plan.proveedores.length===1){
    var p=encodeURIComponent(plan.proveedores[0]);
    url+='&or=(nombre_proveedor.ilike.*'+p+'*,cardcode.ilike.*'+p+'*)';
  }
  if(plan.marca) url+='&marca=ilike.*'+encodeURIComponent(plan.marca)+'*';

  // Los números se vuelven a comprobar aquí abajo, artículo por artículo. En la
  // consulta solo van los que acotan sin riesgo de dejar fuera algo válido.
  ['onhand','iscommited','onorder','precioventa'].forEach(function(c){
    var n=plan.numeros[c];
    if(!n || !_INV_IA_OPS[n.op]) return;
    url+='&'+c+'='+_INV_IA_OPS[n.op]+'.'+(Number(n.v)||0);
  });
  // "disponible" puede venir vacío en la tabla, y filtrarlo en la consulta
  // dejaría fuera esas filas. Como disponible = existencia - reservado, nunca
  // es mayor que la existencia: se acota por ahí y el corte exacto se hace aquí.
  var nd=plan.numeros.disponible;
  if(nd && (nd.op==='>' || nd.op==='>=')){
    url+='&onhand='+_INV_IA_OPS[nd.op]+'.'+(Number(nd.v)||0);
  }

  var orden=(plan.orden && /^[a-z_]+\.(asc|desc)/.test(plan.orden)) ? plan.orden : 'itemcode.asc';
  url+='&order='+orden;

  var TOPE=20000, TANDA=1000, out=[], off=0, reintento=false;
  while(off<TOPE){
    var r=await fetch(url+'&limit='+TANDA+'&offset='+off,{headers:SBH});
    if(!r.ok){
      // Alguna columna opcional puede no existir todavía, igual que en la tabla
      if(!reintento){
        reintento=true;
        var basico=_INV_IA_SCAN.split(',').filter(function(c){
          return ['caracteristicas','subg','u_color','u_tamano'].indexOf(c)<0;
        }).join(',');
        url=url.replace('select='+_INV_IA_SCAN, 'select='+basico);
        continue;
      }
      throw new Error('No se pudo consultar el inventario (HTTP '+r.status+')');
    }
    var rows=await r.json();
    if(!Array.isArray(rows)) rows=[];
    out=out.concat(rows);
    if(aviso) aviso(out.length);
    if(rows.length<TANDA) break;
    off+=TANDA;
  }
  return out;
}

// ── 3) Se cruza el texto aquí ─────────────────────────────────────────────
function _invIAFiltrar(rows, plan){
  var cond=(plan.texto||[]).map(function(c){
    return (Array.isArray(c)?c:[c]).map(_invNorm).filter(Boolean);
  }).filter(function(c){ return c.length; });

  // Varios proveedores: se piden como una condición más
  if((plan.proveedores||[]).length>1){
    cond.push(plan.proveedores.map(_invNorm).filter(Boolean));
  }
  var fuera=(plan.excluir||[]).map(_invNorm).filter(Boolean);

  return rows.filter(function(x){
    if(!_invIANumOk(x, plan)) return false;
    var blob=_invBlob(x);
    for(var i=0;i<cond.length;i++){
      var ok=false;
      for(var j=0;j<cond[i].length;j++){
        if(blob.indexOf(cond[i][j])>=0){ ok=true; break; }
      }
      if(!ok) return false;
    }
    for(var k=0;k<fuera.length;k++){ if(blob.indexOf(fuera[k])>=0) return false; }
    return true;
  });
}

// ── El botón: planear, traer, filtrar y mostrar ──────────────────────────
async function _invIABuscar(){
  var frase=String((document.getElementById('invIAQ')||{}).value||'').trim();
  if(!frase){ _invIAEstado('Escribe qué quieres buscar.', 'var(--text-danger)'); return; }
  if(ANTHROPIC_KEY_ARTES==='PEGA_TU_API_KEY_AQUI'){
    _invIAEstado('Falta configurar la API key de la IA.', 'var(--text-danger)'); return;
  }
  var btn=document.getElementById('invIABtnBuscar');
  if(btn){ btn.disabled=true; btn.style.opacity=.6; }

  try{
    _invIAEstado('<span class="ai-ring g" style="vertical-align:-2px"></span> Entendiendo la búsqueda…');
    var plan=await _invIAPlanear(frase);
    window._invIAPlan=plan;

    _invIAEstado('<span class="ai-ring g" style="vertical-align:-2px"></span> Revisando el inventario…');
    var rows=await _invIATraer(plan, function(n){
      _invIAEstado('<span class="ai-ring g" style="vertical-align:-2px"></span> Revisando el inventario… '
        +n+' artículo(s) leídos');
    });

    var res=_invIAFiltrar(rows, plan);
    var recortado=false;
    if(res.length>plan.limite){ res=res.slice(0, plan.limite); recortado=true; }

    if(res.length){
      _invIAEstado('<span class="ai-ring g" style="vertical-align:-2px"></span> '
        +'Completando la ficha de '+res.length+' artículo(s)…');
      res=await _invIACompletar(res);
    }

    window._invIARes=res;
    window._invIASel={};
    res.forEach(function(x){ window._invIASel[x.itemcode]=true; });

    if(!res.length){
      // Se muestra el filtro que armó la IA: casi siempre se ve enseguida cuál
      // es la condición que sobra.
      var cond=_invIAPlanTxt(plan);
      _invIAEstado('No encontré artículos que cumplan con todo esto '
        +'(revisé '+rows.length+'):<br>'
        +cond.map(function(c){
            return '<span style="display:inline-block;background:var(--surface-1);'
              +'border:0.5px solid var(--border);border-radius:10px;padding:2px 8px;'
              +'margin:3px 3px 0 0;font-size:10.5px;color:var(--text-secondary)">'
              +_esc(c)+'</span>'; }).join('')
        +'<br><span style="font-size:10.5px">Quitá alguna condición y probá de nuevo.</span>',
        'var(--text-warning)');
      if(btn){ btn.disabled=false; btn.style.opacity=1; }
      return;
    }
    _invIACerrar();
    _invIAResultados(plan, res, rows.length, recortado);
  }catch(e){
    console.warn('[inventario IA]', e);
    _invIAEstado('<i class="ti ti-alert-triangle"></i> '+_esc(e.message||String(e)), 'var(--text-danger)');
  }
  if(btn){ btn.disabled=false; btn.style.opacity=1; }
}

// ── Resultados, con la selección para el catálogo ────────────────────────
function _invIAResultados(plan, res, leidos, recortado){
  var prev=document.getElementById('modalInvIARes'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalInvIARes';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10004;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div id="invIAResBox" style="background:var(--surface-0);border-radius:14px;'
    +'padding:18px;max-width:980px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.3)"></div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  _invIAPintarRes(plan, res, leidos, recortado);
}

function _invIAPintarRes(plan, res, leidos, recortado){
  var box=document.getElementById('invIAResBox'); if(!box) return;
  res=res||window._invIARes||[];
  var sel=Object.keys(window._invIASel||{}).filter(function(k){ return window._invIASel[k]; }).length;

  var h='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:3px">'
    +'<div><div style="font-size:14px;font-weight:700;color:var(--t-indigo)">'
      +'<i class="ti ti-sparkles"></i> '+_esc((plan&&plan.resumen)||'Resultado de la búsqueda')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-top:2px">'
      +res.length+' artículo(s) de '+leidos+' revisados'
      +(recortado?(' · recortado al tope de '+plan.limite):'')+'</div></div>'
    +'<button onclick="document.getElementById(\'modalInvIARes\').remove()" '
      +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>';

  h+='<div style="display:flex;gap:7px;align-items:center;flex-wrap:wrap;margin:10px 0">'
    +'<button class="btn bg2" style="padding:4px 10px;font-size:11px" onclick="_invIATodos(true)">Marcar todos</button>'
    +'<button class="btn" style="padding:4px 10px;font-size:11px" onclick="_invIATodos(false)">Ninguno</button>'
    +'<span id="invIASelN" style="font-size:11px;color:var(--text-muted)">'+sel+' elegidos</span>'
    +'<div style="flex:1"></div>'
    +'<button class="btn" style="padding:5px 11px;font-size:11px" onclick="_invIAAbrir()">'
      +'<i class="ti ti-search"></i> Otra búsqueda</button>'
    +'<button class="btn bp" style="background:#7C3D12;padding:6px 13px;font-size:11.5px" '
      +'onclick="_invIACatalogo()"><i class="ti ti-file-type-pdf"></i> Generar catálogo</button>'
    +'<button class="btn bg2" style="padding:6px 13px;font-size:11.5px;border-color:#C7C3F5;color:var(--t-indigo)" '
      +'onclick="_invIACatalogo(true)"><i class="ti ti-mail"></i> Generar y enviar</button>'
    +'</div>';

  h+='<div style="max-height:56vh;overflow-y:auto;border:0.5px solid var(--border);border-radius:10px">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<thead><tr style="background:var(--surface-1);position:sticky;top:0;z-index:2">'
      +'<th style="padding:6px 8px;width:30px"></th>'
      +'<th style="padding:6px;width:46px;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Foto</th>'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">SKU</th>'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Descripción</th>'
      +'<th style="padding:6px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Proveedor</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Exist.</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Reserv.</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Dispon.</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Por llegar</th>'
      +'<th style="padding:6px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--t-verde)">Precio</th>'
    +'</tr></thead><tbody>';

  res.forEach(function(x){
    var sku=String(x.itemcode||'');
    var foto=_repFotoUrl(x.picturname);
    var on=!!(window._invIASel||{})[sku];
    h+='<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:4px 8px;text-align:center">'
        +'<input type="checkbox"'+(on?' checked':'')+' onchange="_invIAMarcar(\''
        +_esc(sku.replace(/'/g,''))+'\',this.checked)"></td>'
      +'<td style="padding:3px 4px">'
        +(foto?('<img src="'+_esc(foto)+'" loading="lazy" style="width:34px;height:34px;'
                +'object-fit:contain;border-radius:4px;background:var(--surface-1)">')
              :'<span style="color:var(--text-muted)"><i class="ti ti-photo-off"></i></span>')
      +'</td>'
      +'<td style="padding:4px 6px;font-family:monospace;font-size:10.5px;white-space:nowrap">'+_esc(sku)+'</td>'
      +'<td style="padding:4px 6px">'+_esc(x.itemname||'')+'</td>'
      +'<td style="padding:4px 6px;color:var(--text-secondary);white-space:nowrap;'
        +'max-width:150px;overflow:hidden;text-overflow:ellipsis" title="'
        +_esc((x.nombre_proveedor||'')+(x.cardcode?(' · '+x.cardcode):''))+'">'
        +_esc(x.nombre_proveedor||x.cardcode||'—')+'</td>'
      +'<td style="padding:4px 6px;text-align:right">'+_fmtN2(x.onhand)+'</td>'
      +'<td style="padding:4px 6px;text-align:right;color:var(--t-rojo)">'+_fmtN2(x.iscommited)+'</td>'
      +'<td style="padding:4px 6px;text-align:right;font-weight:600">'+_fmtN2(_invDisp(x))+'</td>'
      +'<td style="padding:4px 6px;text-align:right;color:var(--t-ambar)">'+_fmtN2(x.onorder)+'</td>'
      +'<td style="padding:4px 6px;text-align:right;color:var(--t-verde);font-weight:600">'
        +(Number(x.precioventa)?fmt(x.precioventa):'—')+'</td>'
    +'</tr>';
  });
  h+='</tbody></table></div>';
  box.innerHTML=h;
}

function _invIAMarcar(sku, on){
  window._invIASel=window._invIASel||{};
  if(on) window._invIASel[sku]=true; else delete window._invIASel[sku];
  var n=document.getElementById('invIASelN');
  if(n) n.textContent=Object.keys(window._invIASel).length+' elegidos';
}

function _invIATodos(on){
  window._invIASel={};
  if(on) (window._invIARes||[]).forEach(function(x){ window._invIASel[x.itemcode]=true; });
  _invIAPintarRes(window._invIAPlan, window._invIARes, (window._invIARes||[]).length, false);
}

// ── El artículo del inventario, con la forma que espera la ficha ─────────
function _invIAFicha(x){
  return {
    __sinEdit:true,                     // no mezclar con lo editado del catálogo NO SAP
    itemcode: x.itemcode||'',
    itemname: x.itemname||'',
    descripcion: x.itemname||x.frgnname||'',
    marca: x.marca||'',
    _dept: String(x.grupo||'').replace(/^[.\s]+/,''),
    unidades_x_caja: x.unidadesbulto||x.salpackun||'',
    medida: x.u_tamano||'',
    cbm: x.volumen||'',
    peso: x.peso||'',
    color: x.u_color||'',
    disponible: _invDisp(x),
    precio_venta: Number(x.precioventa)||0,
    barcode: x.codebars||'',
    foto: _repFotoUrl(x.picturname)||''
  };
}

// ── El catálogo de lo seleccionado ───────────────────────────────────────
async function _invIACatalogo(porCorreo){
  var sel=(window._invIARes||[]).filter(function(x){
    return (window._invIASel||{})[x.itemcode]; });
  if(!sel.length){ showT('Elige al menos un artículo'); return; }
  if(sel.length>400 && !confirm(sel.length+' artículos son '+Math.ceil(sel.length/10)
      +' páginas. ¿Seguimos?')) return;

  showT('Armando el catálogo con '+sel.length+' artículo(s)…');
  try{
    // Fotos chicas y bien comprimidas: es lo único que hace pesado el PDF.
    // A 200 px y calidad 0.42 cada foto queda en 8-12 KB y en el papel se
    // ve igual, así que 300 artículos dan un archivo de pocos MB.
    var doc=await _catPdfDocumento(sel.map(_invIAFicha), {foto:{lado:200, q:0.42}});
    var _nom='Catalogo_'+new Date().toISOString().slice(0,10)+'.pdf';
    if(porCorreo){
      await _catMailAbrir([{nombre:_nom, blob:doc.output('blob'), mime:'application/pdf'}],
                          'Catálogo Kennedy Center — '+sel.length+' artículo(s)');
    } else {
      doc.save(_nom);
      showT('✓ Catálogo generado · la lista queda abierta');
    }
  }catch(e){
    console.warn('[catálogo inventario]', e);
    showT('No se pudo generar: '+(e.message||e), 5000);
  }
}

// ══════════════════════════════════════════════════════════════════════
//  ÓRDENES DE COMPRA PENDIENTES POR PROVEEDOR
//
//  Una orden sigue abierta hasta que llega toda la mercancía. Si llegó una
//  parte, SAP la factura con una factura de reserva y en POR1.OpenQty queda
//  lo que falta. Aquí se ve esa diferencia, que es el dinero que de verdad
//  está por recibir.
//
//  Dos situaciones distintas, con color distinto:
//    · Sin recibir       — no ha llegado nada de la orden
//    · Recibida a medias — llegó parte y queda un resto abierto
// ══════════════════════════════════════════════════════════════════════
window._ocPend      = window._ocPend || null;
window._ocPendFiltro= window._ocPendFiltro || 'todas';
window._ocPendDept  = window._ocPendDept || 'todos';
window._ocPendQ     = window._ocPendQ || '';

async function _ocPendCargar(forzar){
  if(window._ocPend && window._ocPend.length && !forzar) return window._ocPend;
  window._ocPendError=null;
  try{
    var out=[], desde=0;
    while(true){
      var r=await fetch(SB+'/rest/v1/ordenes_pendientes?select=*'
        +'&order=monto_pendiente.desc&offset='+desde+'&limit=1000',{headers:SBH});
      if(!r.ok){
        var t=''; try{ t=await r.text(); }catch(e){}
        window._ocPendError=r.status+' · '+t.slice(0,200);
        console.error('[oc pendientes] '+r.status+': '+t.slice(0,300));
        break;
      }
      var lote=await r.json()||[];
      out=out.concat(lote);
      if(lote.length<1000) break;
      desde+=1000;
    }
    window._ocPend=out;
    console.log('[oc pendientes] '+out.length+' línea(s) pendientes');
  }catch(e){
    window._ocPendError=(e&&e.message)||String(e);
    console.error('[oc pendientes]',e);
    window._ocPend=window._ocPend||[];
  }
  return window._ocPend;
}

// Las líneas agrupadas por orden: una fila por orden, como en el listado
// que usa gerencia en SAP.
function _ocPendPorOrden(){
  var por={};
  (window._ocPend||[]).forEach(function(l){
    var k=String(l.docnum);
    var o=por[k];
    if(!o){
      o=por[k]={docnum:l.docnum, referencia:l.referencia||'', cardcode:l.cardcode||'',
        cardname:l.cardname||'', grupo:l.grupo||'', fecha:l.fecha||'',
        fecha_llegada:l.fecha_llegada||'', eta:l.eta||'', estado:l.estado_compra||'',
        terminos:l.terminos||'', abono_pct:Number(l.abono_pct)||0,
        fecha_abono:l.fecha_abono||'', contenedor:l.contenedor||'',
        doc_total:Number(l.doc_total)||0, pendiente:0, lineas:[]};
    }
    o.pendiente += Number(l.monto_pendiente)||0;
    o.lineas.push(l);
  });
  return Object.keys(por).map(function(k){
    var o=por[k];
    o.despachado = Math.max(0, o.doc_total - o.pendiente);
    // Si no se ha recibido nada, lo pendiente es prácticamente el total
    o.completa = (o.despachado <= Math.max(0.5, o.doc_total*0.005));
    return o;
  });
}

function _ocPendSetFiltro(v){ window._ocPendFiltro=v; rOcPend(); }
function _ocPendSetDept(v){ window._ocPendDept=v; rOcPend(); }
function _ocPendBuscar(v){ window._ocPendQ=String(v||''); rOcPend(); }

function _ocPendLista(){
  var todas=_ocPendPorOrden();
  var f=window._ocPendFiltro, d=window._ocPendDept;
  if(f==='sinrecibir') todas=todas.filter(function(o){ return o.completa; });
  if(f==='parciales')  todas=todas.filter(function(o){ return !o.completa; });
  if(d && d!=='todos') todas=todas.filter(function(o){
    return (normDept(o.grupo)||'otros')===d; });
  // El departamento del usuario acota, como en el resto del portal
  if(_deptAcotado()) todas=todas.filter(function(o){
    return _deptPermitido(normDept(o.grupo)||'otros'); });
  // Buscador: proveedor, código, número de orden o referencia
  var q=String(window._ocPendQ||'').toLowerCase().trim();
  if(q) todas=todas.filter(function(o){
    return String(o.cardname||'').toLowerCase().indexOf(q)>=0
        || String(o.cardcode||'').toLowerCase().indexOf(q)>=0
        || String(o.referencia||'').toLowerCase().indexOf(q)>=0
        || String(o.docnum||'').toLowerCase().indexOf(q)>=0;
  });
  return todas.sort(function(a,b){ return b.pendiente-a.pendiente; });
}

function rOcPend(){
  var box=document.getElementById('page-ocpend'); if(!box) return;

  if(window._ocPend===null || (!window._ocPend.length && !window._ocPendError
                               && !window._ocPendReintento)){
    if(window._ocPend!==null) window._ocPendReintento=1;
    _ocPendCargar(true).then(function(){ try{ rOcPend(); }catch(e){} });
    box.innerHTML='<div class="empty" style="padding:22px;color:var(--text-muted)">'
      +'<span class="ai-ring g"></span> Buscando lo que falta por llegar…</div>';
    return;
  }

  if(!(window._ocPend||[]).length){
    box.innerHTML='<div class="slbl"><i class="ti ti-package-off"></i> '
      +'Órdenes pendientes por proveedor</div>'
      +'<div class="empty" style="padding:20px;color:var(--text-muted);font-size:12px">'
      +(window._ocPendError
        ? ('<b style="color:var(--t-rojo3)">No se pudo leer la tabla</b><br>'
           +'<span style="font-size:11px">'+_esc(window._ocPendError)+'</span><br>'
           +'<span style="font-size:11px">Comprueba que exista <b>ordenes_pendientes</b> '
           +'y que tenga política de lectura.</span>')
        : ('<i class="ti ti-mood-check" style="font-size:22px;color:var(--t-verde)"></i><br>'
           +'No hay nada pendiente de llegar.'))
      +'</div>';
    return;
  }

  var lista=_ocPendLista();
  // Las cuentas de las pastillas tienen que respetar el departamento
  // elegido: antes salían siempre las de la empresa entera, así que al
  // filtrar Hogar los números de abajo no cuadraban con la tabla.
  var todas=_ocPendPorOrden().filter(function(o){
    var d=normDept(o.grupo)||'otros';
    if(_deptAcotado()) return _deptPermitido(d);
    if(window._ocPendDept && window._ocPendDept!=='todos') return d===window._ocPendDept;
    return true;
  });
  // Y el buscador también
  var _q=String(window._ocPendQ||'').toLowerCase().trim();
  if(_q) todas=todas.filter(function(o){
    return String(o.cardname||'').toLowerCase().indexOf(_q)>=0
        || String(o.cardcode||'').toLowerCase().indexOf(_q)>=0
        || String(o.referencia||'').toLowerCase().indexOf(_q)>=0
        || String(o.docnum||'').toLowerCase().indexOf(_q)>=0;
  });
  var tot=lista.reduce(function(a,o){
    a.pedido+=o.doc_total; a.desp+=o.despachado; a.pend+=o.pendiente; return a;
  },{pedido:0,desp:0,pend:0});

  var pastilla=function(k,t,n,col){
    var on=(window._ocPendFiltro===k);
    return '<span onclick="_ocPendSetFiltro(\'' + k + '\')" style="cursor:pointer;'
      +'border:1px solid '+(on?col:'var(--border)')+';background:'+(on?col:'var(--surface-0)')
      +';color:'+(on?'#fff':col)+';border-radius:20px;padding:4px 12px;font-size:11px;'
      +'font-weight:600;white-space:nowrap">'+t+' <span style="opacity:.8">'+n+'</span></span>';
  };

  var h='<div class="slbl"><i class="ti ti-package-off"></i> '
    +'Órdenes de compra abiertas</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin:-4px 0 9px">'
    +'Lo que falta por recibir de cada orden abierta. Cuando llega una parte, SAP la '
    +'factura con una factura de reserva y aquí queda solo el resto. '
    +'Pulsa una orden para ver qué artículos faltan.</div>';

  // Departamentos: los que el usuario puede ver. Si tiene uno asignado,
  // esta barra no aparece porque no hay nada que elegir.
  if(!_deptAcotado()){
    // Estos chips cuentan sobre TODO: si contaran sobre lo filtrado, al
    // elegir Hogar los demás saldrían a cero y no se podría cambiar.
    var conDept={}, _todasSinDept=_ocPendPorOrden();
    _todasSinDept.forEach(function(o){ var k=normDept(o.grupo)||'otros'; conDept[k]=(conDept[k]||0)+1; });
    var chip=function(k,t,n){
      var on=(window._ocPendDept===k);
      return '<span onclick="_ocPendSetDept(\''+k+'\')" style="cursor:pointer;'
        +'border:1px solid '+(on?'#5B21B6':'var(--border)')+';background:'+(on?'#5B21B6':'var(--surface-0)')
        +';color:'+(on?'#fff':'var(--text-primary)')+';border-radius:20px;padding:3px 11px;'
        +'font-size:10.5px;font-weight:600;white-space:nowrap">'+t
        +(n!=null?(' <span style="opacity:.75">'+n+'</span>'):'')+'</span>';
    };
    h+='<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:8px">'
      + chip('todos','Todos', _todasSinDept.length)
      + _deptsVisibles().filter(function(d){ return conDept[d]; })
          .map(function(d){ return chip(d, dL(d), conDept[d]); }).join('')
      +'</div>';
  }

  h+='<div style="margin-bottom:8px">'
    +'<input id="ocp-q" value="'+_esc(window._ocPendQ||'')+'" '
    +'placeholder="Buscar proveedor, código, número de orden o DKC…" '
    +'oninput="clearTimeout(window._ocpT);window._ocpT=setTimeout(function(){'
    +'_ocPendBuscar(document.getElementById(\'ocp-q\').value)},300)" '
    +'style="width:100%;padding:8px 12px;border:1px solid var(--border);border-radius:8px;'
    +'font-size:12px;font-family:var(--font-sans);background:var(--surface-2);'
    +'color:var(--text-primary)"></div>';

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
    + pastilla('todas','Todas', todas.length, '#0c447c')
    + pastilla('sinrecibir','Sin recibir', todas.filter(function(o){return o.completa;}).length, '#B45309')
    + pastilla('parciales','Recibidas a medias', todas.filter(function(o){return !o.completa;}).length, '#5B21B6')
    +'<span style="flex:1"></span>'
    +'<span style="font-size:11px;color:var(--text-muted)">Pendiente de llegar: '
    +'<b style="color:var(--t-ambar);font-size:13px">'+fmt(tot.pend)+'</b></span>'
    +'</div>';

  var filas=lista.slice(0,300).map(function(o){
    var pct = o.doc_total ? (o.despachado/o.doc_total*100) : 0;
    return '<tr onclick="_ocPendDetalle('+o.docnum+')" '
      +'style="border-top:0.5px solid var(--border);cursor:pointer;'
      +'background:'+(o.completa?'var(--pastel-aviso)':'var(--pastel-lila)')+'">'
      +'<td style="padding:6px 9px"><b>'+_esc(o.cardcode)+'</b>'
        +'<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(o.cardname).slice(0,34)+'</div></td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:600">'+_esc(o.docnum)+'</td>'
      +'<td style="padding:6px 9px;font-weight:600;color:var(--t-azul)">'+_esc(o.referencia)+'</td>'
      +'<td style="padding:6px 9px;font-size:10.5px">'+_esc(dL(normDept(o.grupo)||o.grupo))+'</td>'
      +'<td style="padding:6px 9px;font-size:10.5px;white-space:nowrap">'+_esc(o.fecha)+'</td>'
      +'<td style="padding:6px 9px;font-size:10.5px;white-space:nowrap">'+_esc(o.fecha_llegada)+'</td>'
      +'<td style="padding:6px 9px;text-align:right">'+fmt(o.doc_total)+'</td>'
      +'<td style="padding:6px 9px;text-align:right;color:var(--t-verde)">'
        +(o.despachado>0.5?fmt(o.despachado):'—')+'</td>'
      +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:var(--t-ambar)">'
        +fmt(o.pendiente)+'</td>'
      +'<td style="padding:6px 9px;text-align:center;font-size:10px">'
        +(o.completa
          ? '<span style="color:var(--t-marron);font-weight:700">Sin recibir</span>'
          : ('<span style="color:var(--t-lila);font-weight:700">'+pct.toFixed(0)+'% recibido</span>'))
        +'</td>'
      +'<td style="padding:6px 9px;font-size:10.5px">'+_esc(o.terminos)+'</td>'
      +'</tr>';
  }).join('');

  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:auto;'
    +'background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px;min-width:1050px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +['Proveedor','Pedido','Orden','Depto','Fec. orden','Fec. llegada',
        'Monto pedido','Despachado','Pendiente','Estado','Cond.']
        .map(function(t,i){
          var der=(i>=6&&i<=8);
          return '<th style="padding:7px 9px;text-align:'+(der?'right':'left')
            +';font-size:9.5px;text-transform:uppercase;white-space:nowrap">'+t+'</th>';
        }).join('')
    +'</tr></thead><tbody>'+filas+'</tbody>'
    +'<tfoot><tr style="border-top:1.5px solid var(--border);background:var(--surface-2)">'
      +'<td colspan="6" style="padding:8px 9px;font-weight:800">'
        +lista.length+' orden(es)</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800">'+fmt(tot.pedido)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-verde)">'+fmt(tot.desp)+'</td>'
      +'<td style="padding:8px 9px;text-align:right;font-weight:800;color:var(--t-ambar)">'+fmt(tot.pend)+'</td>'
      +'<td colspan="2"></td></tr></tfoot></table></div>'
    +(lista.length>300?('<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">'
      +'Se muestran las 300 primeras de '+lista.length+'.</div>'):'');

  box.innerHTML=h;
}

// El detalle: qué artículos faltan de esa orden
function _ocPendDetalle(docnum){
  var lineas=(window._ocPend||[]).filter(function(l){
    return String(l.docnum)===String(docnum); });
  if(!lineas.length) return;
  var o=_ocPendPorOrden().find(function(x){ return String(x.docnum)===String(docnum); })||{};

  var cuerpo=lineas.sort(function(a,b){ return (a.linenum||0)-(b.linenum||0); })
    .map(function(l){
      var recibido=(Number(l.cantidad)||0)-(Number(l.pendiente)||0);
      return '<tr style="border-top:0.5px solid var(--border)">'
        +'<td style="padding:5px 8px"><b>'+_esc(l.itemcode||'')+'</b></td>'
        +'<td style="padding:5px 8px;font-size:10.5px">'+_esc(l.descripcion||'')+'</td>'
        +'<td style="padding:5px 8px;text-align:right">'+_fmtN2(l.cantidad)+'</td>'
        +'<td style="padding:5px 8px;text-align:right;color:var(--t-verde)">'
          +(recibido>0?_fmtN2(recibido):'—')+'</td>'
        +'<td style="padding:5px 8px;text-align:right;font-weight:700;color:var(--t-ambar)">'
          +_fmtN2(l.pendiente)+'</td>'
        +'<td style="padding:5px 8px;text-align:right">'+fmt(l.precio)+'</td>'
        +'<td style="padding:5px 8px;text-align:right;font-weight:700">'
          +fmt(l.monto_pendiente)+'</td>'
        +'</tr>';
    }).join('');

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">📦</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">Orden '+_esc(docnum)
      +' · '+_esc(o.referencia||'')+'</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">'+_esc(o.cardname||'')
      +' · '+_esc(dL(normDept(o.grupo)||o.grupo))+'</div></div>'
    +'<button class="btn bp" style="background:var(--t-rojo3)" '
      +'onclick="_ocPendReclamo('+docnum+')">'
      +'<i class="ti ti-mail-forward"></i> Reclamar</button>'
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'

    +'<div style="display:flex;gap:9px;flex-wrap:wrap;margin:10px 0">'
      +'<div style="flex:1;min-width:130px;border:0.5px solid var(--border);border-radius:9px;padding:9px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Monto pedido</div>'
        +'<div style="font-size:14px;font-weight:700">'+fmt(o.doc_total)+'</div></div>'
      +'<div style="flex:1;min-width:130px;border:0.5px solid var(--border);border-radius:9px;padding:9px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Ya despachado</div>'
        +'<div style="font-size:14px;font-weight:700;color:var(--t-verde)">'+fmt(o.despachado)+'</div></div>'
      +'<div style="flex:1;min-width:130px;border:0.5px solid var(--border);border-radius:9px;padding:9px;'
        +'background:var(--pastel-aviso)">'
        +'<div style="font-size:9.5px;color:var(--t-marron);text-transform:uppercase">Falta por llegar</div>'
        +'<div style="font-size:14px;font-weight:800;color:var(--t-ambar)">'+fmt(o.pendiente)+'</div></div>'
    +'</div>'

    +'<div style="border:0.5px solid var(--border);border-radius:10px;overflow:auto">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +['SKU','Descripción','Pedido','Recibido','Falta','Precio','Monto pendiente']
        .map(function(t,i){
          return '<th style="padding:6px 8px;text-align:'+(i>=2?'right':'left')
            +';font-size:9.5px;text-transform:uppercase">'+t+'</th>';
        }).join('')
    +'</tr></thead><tbody>'+cuerpo+'</tbody></table></div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:8px">'
    +'Solo salen las líneas con algo pendiente. Las que llegaron completas ya no '
    +'aparecen: SAP las cerró con la factura de reserva.</div>';
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
  document.getElementById('modal').style.display='flex';
}

// El resumen que va bajo el nombre del departamento en el tablero: cuánto
// falta de verdad por llegar, separando las órdenes de las que no ha
// llegado nada de las que llegaron a medias. Cada una con su color, el
// mismo que en la pantalla de pendientes.
function _ocPendResumenDept(dept){
  var r=_ocPendDeptDetalle(dept);
  if(!r || (!r.sinRecibir && !r.parcial)) return '';
  var trozos=[];
  if(r.sinRecibir) trozos.push('<span style="color:var(--t-marron);font-weight:600" '
    +'title="Órdenes de las que todavía no ha llegado nada">'
    +r.nSinRecibir+' sin recibir</span>');
  if(r.parcial) trozos.push('<span style="color:var(--t-lila);font-weight:600" '
    +'title="Órdenes de las que ya llegó una parte">'
    +r.nParcial+' a medias</span>');
  return '<div class="dept-sem-count" style="margin-top:2px;cursor:pointer" '
    +'onclick="event.stopPropagation();window._ocPendDept=\''+dept+'\';'
    +'window._ocPendFiltro=\'todas\';go(\'ocpend\')">'
    +'<i class="ti ti-package-off"></i> '+trozos.join(' · ')+'</div>';
}

// ── Reclamar al proveedor lo que no ha llegado ──
// Reutiliza el reclamo que ya existe para faltantes de una entrada, pero
// alimentado con las líneas abiertas de la orden: lo que se pidió, lo que
// llegó y lo que falta, con su importe.
function _ocPendReclamo(docnum){
  var lineas=(window._ocPend||[]).filter(function(l){
    return String(l.docnum)===String(docnum); });
  if(!lineas.length){ showT('Esa orden no tiene nada pendiente'); return; }
  var o=_ocPendPorOrden().find(function(x){ return String(x.docnum)===String(docnum); })||{};

  // La forma que espera el reclamo
  var filas=lineas.map(function(l){
    var pedido=Number(l.cantidad)||0, falta=Number(l.pendiente)||0;
    return {
      sku:l.itemcode||'', descripcion:l.descripcion||'',
      cantidad:pedido, cantidad_recibida:Math.max(0,pedido-falta),
      cantidad_abierta:falta, precio:Number(l.precio)||0,
      monto_faltante:Number(l.monto_pendiente)||0,
      factura:'', fecha:l.fecha||''
    };
  });

  window._mailAdj=[];
  window._reclamoCtx={oid:(o.referencia||String(docnum)), lineas:filas, _desdeOC:true,
    proveedor:(o.cardname||''), dept:(normDept(o.grupo)||''), docnum:docnum};

  var dept=normDept(o.grupo)||'';
  var comprasDept=(USERS||[]).filter(function(u){
    return u.role==='compras' && u.email && dept && String(u.dept||'')===String(dept); });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    var marcado=comprasDept.some(function(c){ return c.id===u.id; });
    return '<label style="display:inline-flex;align-items:center;gap:5px;font-size:11px;'
      +'background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;'
      +'padding:3px 9px;margin:0 5px 5px 0;cursor:pointer">'
      +'<input type="checkbox" value="'+_esc(u.email)+'"'+(marcado?' checked':'')+'> '
      +_esc(u.name)+'</label>';
  }).join('');

  var tot=filas.reduce(function(a,l){ return a+l.monto_faltante; },0);
  // El proveedor es chino, indio o egipcio: el correo va en inglés.
  var asunto='Pending delivery · PO '+(o.referencia||docnum)
    +' · '+(o.cardname||'');

  var cuerpo='Dear Sirs,\n\n'
    +'Reviewing our purchase order '+(o.referencia||docnum)
    +(o.docnum?(' (SAP order '+o.docnum+')'):'')+' dated '+(o.fecha||'')+', '
    +'we note that the following items are still pending delivery:\n\n';
  filas.forEach(function(l){
    cuerpo+='  · '+l.sku+' — '+l.descripcion+'\n'
      +'      ordered '+_fmtN2(l.cantidad)+' · received '+_fmtN2(l.cantidad_recibida)
      +' · pending '+_fmtN2(l.cantidad_abierta)
      +'  =  '+fmt(l.monto_faltante)+'\n';
  });
  cuerpo+='\nTotal pending: '+fmt(tot)+'\n'
    +'Total order value: '+fmt(o.doc_total)+'\n'
    +(o.despachado>0.5?('Already shipped and invoiced: '+fmt(o.despachado)+'\n'):'')
    +'\nPlease confirm the shipping date for the pending quantities, or let us '
    +'know if any reference will not be shipped so we can close the order.\n\n'
    +'The purchase order is attached for your reference.\n\n'
    +'Best regards,\n'+((CU&&CU.name)||'')+'\nKennedy Center Corp.';

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">📧</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">Reclamar lo que falta por llegar</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">Orden '+_esc(o.referencia||docnum)
      +' · '+_esc(o.cardname||'')+' · pendiente <b>'+fmt(tot)+'</b></div></div>'
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">Para</div>'
    +'<div id="reclamo-dests" style="margin-bottom:8px">'+chips+'</div>'
    +'<input id="reclamo-extra" placeholder="Otros correos, separados por coma" '
      +'style="width:100%;padding:7px 10px;border:1px solid var(--border);border-radius:8px;'
      +'font-size:12px;margin-bottom:9px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">Asunto</div>'
    +'<input id="reclamo-asunto" value="'+_esc(asunto)+'" '
      +'style="width:100%;padding:7px 10px;border:1px solid var(--border);border-radius:8px;'
      +'font-size:12px;margin-bottom:9px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">Mensaje</div>'
    +'<textarea id="reclamo-cuerpo" rows="14" style="width:100%;padding:9px 11px;'
      +'border:1px solid var(--border);border-radius:8px;font-size:12px;'
      +'font-family:var(--font-sans);resize:vertical;background:var(--surface-2);'
      +'color:var(--text-primary)">'+_esc(cuerpo)+'</textarea>'

    // Los adjuntos usan los mismos identificadores que el reclamo de
    // faltantes: así el envío funciona sin duplicar nada.
    +'<div style="font-size:11px;color:var(--text-muted);margin:9px 0 4px">ADJUNTOS</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" '
      +'style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">'
      +'Adjunta la orden de compra para que el proveedor la tenga a la vista.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:10px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:10px">'
      +'<button class="btn bg2" onclick="CM()">Cancelar</button>'
      +'<button class="btn bp" id="reclamo-btn" onclick="_reclamoEnviar()">'
      +'<i class="ti ti-send"></i> Enviar reclamo</button></div>';
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
  document.getElementById('modal').style.display='flex';
}

// La fila de "por despachar" dentro de la tarjeta del departamento: el
// dinero de las órdenes abiertas descontando lo que YA llegó con factura
// de reserva. Sumar el total de la orden abultaba la cifra.
function _ocPendFilaDept(dept){
  var r=_ocPendDeptDetalle(dept);
  if(!r || r.total<=0.5) return '';
  return '<div class="sem-row" style="cursor:pointer" '
    +'onclick="event.stopPropagation();window._ocPendDept=\''+dept+'\';'
    +'window._ocPendFiltro=\'todas\';go(\'ocpend\')" '
    +'title="Órdenes abiertas, ya descontado lo que llegó con factura de reserva. '
    +'Pulsa para ver el detalle.">'
    +'<span class="sem-label" style="color:var(--t-ambar)">Por despachar</span>'
    +'<span class="sem-val" style="color:var(--t-ambar);font-weight:700;'
    +'text-decoration:underline">'+fmt(r.total)+'</span></div>';
}

// Para cruzar una orden del portal con lo que le falta por llegar. El
// portal las identifica por su referencia (DKC-25066) y SAP por su número
// de pedido (12095): se indexan las dos formas.
function _ocPendClave(o){
  return String((o&&(o.ref||o.referencia||o.id))||'').trim().toUpperCase();
}

function _ocPendIndice(){
  if(window._ocPendIdx && window._ocPendIdxN===(window._ocPend||[]).length)
    return window._ocPendIdx;
  var idx={};
  _ocPendPorOrden().forEach(function(o){
    if(o.referencia) idx[String(o.referencia).trim().toUpperCase()]=o;
    if(o.docnum)     idx[String(o.docnum).trim().toUpperCase()]=o;
  });
  window._ocPendIdx=idx;
  window._ocPendIdxN=(window._ocPend||[]).length;
  return idx;
}

// El desglose dentro del detalle de la orden: cuánto ya tiene factura de
// reserva y cuánto sigue por llegar. Solo aparece si falta algo.
function _ocPendPanelOrden(o){
  var p=null;
  try{ p=_ocPendDeOrden(o); }catch(e){}
  if(!p || p.pendiente<=0.5) return '';

  var pct = p.doc_total ? Math.round(p.despachado/p.doc_total*100) : 0;
  var col = p.completa ? 'var(--t-marron)' : 'var(--t-lila)';
  var bg  = p.completa ? 'var(--pastel-aviso)' : 'var(--pastel-lila)';

  return '<div style="background:'+bg+';border:0.5px solid var(--border);'
    +'border-radius:9px;padding:10px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:7px">'
      +'<i class="ti ti-package-off" style="color:'+col+'"></i>'
      +'<b style="font-size:12px;color:'+col+'">'
      +(p.completa ? 'Todavía no ha llegado nada de esta orden'
                   : 'Recibida a medias · falta el '+(100-pct)+'%')+'</b>'
      +'<span style="flex:1"></span>'
      +'<button class="btn bg2" style="padding:3px 10px;font-size:10.5px" '
      +'onclick="event.stopPropagation();_ocPendDetalle('+p.docnum+')">'
      +'<i class="ti ti-list-details"></i> Ver qué falta</button>'
      +'<button class="btn bg2" style="padding:3px 10px;font-size:10.5px;'
      +'color:var(--t-rojo3)" '
      +'onclick="event.stopPropagation();_ocPendReclamo('+p.docnum+')">'
      +'<i class="ti ti-mail-forward"></i> Reclamar al proveedor</button>'
    +'</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:110px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Pedido</div>'
        +'<div style="font-size:13px;font-weight:700">'+fmt(p.doc_total)+'</div></div>'
      +'<div style="flex:1;min-width:110px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">'
        +'Ya llegó · con factura reserva</div>'
        +'<div style="font-size:13px;font-weight:700;color:var(--t-verde)">'
        +(p.despachado>0.5?fmt(p.despachado):'—')+'</div></div>'
      +'<div style="flex:1;min-width:110px">'
        +'<div style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Falta por llegar</div>'
        +'<div style="font-size:13px;font-weight:800;color:var(--t-ambar)">'
        +fmt(p.pendiente)+'</div></div>'
    +'</div>'
    +'<div style="height:5px;background:var(--border);border-radius:3px;overflow:hidden;margin-top:7px">'
      +'<div style="height:100%;width:'+pct+'%;background:var(--t-verde)"></div></div>'
    +'</div>';
}

// Lo que falta por llegar de UNA orden, si es que falta algo
function _ocPendDeOrden(o){
  return _ocPendIndice()[_ocPendClave(o)] || null;
}

// Lo pendiente de un departamento, separado por situación
function _ocPendDeptDetalle(dept){
  var r={sinRecibir:0, parcial:0, nSinRecibir:0, nParcial:0, total:0, despachado:0};
  if(!(window._ocPend||[]).length) return r;
  _ocPendPorOrden().forEach(function(o){
    if((normDept(o.grupo)||'otros')!==dept) return;
    r.total+=o.pendiente;
    r.despachado+=o.despachado;
    if(o.completa){ r.sinRecibir+=o.pendiente; r.nSinRecibir++; }
    else          { r.parcial   +=o.pendiente; r.nParcial++; }
  });
  return r;
}

// Lo pendiente de un departamento, para restarlo de los totales
function _ocPendDeDept(dept){
  var t=0;
  (window._ocPend||[]).forEach(function(l){
    if((normDept(l.grupo)||'otros')===dept) t+=Number(l.monto_pendiente)||0;
  });
  return t;
}

// ── La pantalla: quién entró y qué hizo ──
// Solo para la gerencia general. Los encargados por departamento no la ven:
// es información de todo el equipo.
window._acc      = window._acc || null;
window._accUser  = window._accUser || 'todos';
window._accDesde = window._accDesde || '';
window._accHasta = window._accHasta || '';
window._accTipo  = window._accTipo || 'todos';

function _accPuedeVer(){
  return !!(CU && CU.role==='gerencia' && !_deptAcotado());
}

async function _accCargar(forzar){
  if(window._acc && !forzar) return window._acc;
  window._accError=null;
  try{
    // Por defecto, los últimos treinta días: el registro crece rápido y
    // traerlo entero no aporta nada.
    var desde=window._accDesde
      || new Date(Date.now()-30*24*3600*1000).toISOString().slice(0,10);
    var url=SB+'/rest/v1/accesos?select=*&creado_en=gte.'+desde
      +'&order=creado_en.desc&limit=3000';
    if(window._accHasta) url+='&creado_en=lte.'+window._accHasta+'T23:59:59';
    var r=await fetch(url,{headers:SBH});
    if(!r.ok){
      var t=''; try{ t=await r.text(); }catch(e){}
      window._accError=r.status+' · '+t.slice(0,180);
      console.error('[accesos] '+r.status+': '+t.slice(0,200));
      window._acc=[];
      return window._acc;
    }
    window._acc=await r.json()||[];
    console.log('[accesos] '+window._acc.length+' registro(s) desde '+desde);
  }catch(e){
    window._accError=(e&&e.message)||String(e);
    window._acc=window._acc||[];
  }
  return window._acc;
}

function _accSetUser(v){ window._accUser=v; rAccesos(); }
function _accSetTipo(v){ window._accTipo=v; rAccesos(); }
async function _accSetFechas(){
  window._accDesde=(document.getElementById('acc-desde')||{}).value||'';
  window._accHasta=(document.getElementById('acc-hasta')||{}).value||'';
  await _accCargar(true);
  rAccesos();
}

function _accFiltrado(){
  var l=(window._acc||[]).slice();
  if(window._accUser!=='todos') l=l.filter(function(x){
    return String(x.usuario_id||'')===window._accUser; });
  if(window._accTipo!=='todos') l=l.filter(function(x){
    return String(x.tipo||'')===window._accTipo; });
  return l;
}

// Cuándo entró cada uno por última vez
function _accResumen(){
  var por={};
  (window._acc||[]).forEach(function(x){
    var k=x.usuario_id||'?';
    var o=por[k]||(por[k]={id:k, nombre:x.usuario||k, rol:x.rol||'',
                           entradas:0, acciones:0, ultima:'', ultimaEntrada:''});
    if(x.tipo==='entrada'){
      o.entradas++;
      if(!o.ultimaEntrada || x.creado_en>o.ultimaEntrada) o.ultimaEntrada=x.creado_en;
    }
    if(x.tipo==='accion') o.acciones++;
    if(!o.ultima || x.creado_en>o.ultima) o.ultima=x.creado_en;
  });
  return Object.keys(por).map(function(k){ return por[k]; })
    .sort(function(a,b){ return String(b.ultima).localeCompare(String(a.ultima)); });
}

function _accCuando(iso){
  if(!iso) return 'nunca';
  var d=new Date(iso);
  if(isNaN(d)) return String(iso).slice(0,16);
  var min=Math.round((Date.now()-d.getTime())/60000);
  if(min<1)    return 'ahora mismo';
  if(min<60)   return 'hace '+min+' min';
  if(min<1440) return 'hace '+Math.round(min/60)+' h';
  var dias=Math.round(min/1440);
  if(dias<30)  return 'hace '+dias+' día(s)';
  return d.toLocaleDateString('es');
}

function _accFechaHora(iso){
  var d=new Date(iso);
  if(isNaN(d)) return String(iso||'').slice(0,16);
  return d.toLocaleDateString('es')+' '
    +d.toLocaleTimeString('es',{hour:'2-digit',minute:'2-digit'});
}

var _ACC_TIPOS={entrada:{t:'Entradas', c:'var(--t-verde)'},
                salida:{t:'Salidas',   c:'var(--text-muted)'},
                pantalla:{t:'Pantallas', c:'var(--t-azul)'},
                accion:{t:'Acciones', c:'var(--t-lila)'}};

function rAccesos(){
  var box=document.getElementById('page-accesos'); if(!box) return;
  if(!_accPuedeVer()){
    box.innerHTML='<div class="empty" style="padding:22px;color:var(--text-muted)">'
      +'Esta pantalla es solo para gerencia.</div>';
    return;
  }

  if(window._acc===null){
    _accCargar().then(function(){ try{ rAccesos(); }catch(e){} });
    box.innerHTML='<div class="empty" style="padding:22px;color:var(--text-muted)">'
      +'<span class="ai-ring g"></span> Leyendo el registro…</div>';
    return;
  }

  if(!(window._acc||[]).length){
    box.innerHTML='<div class="slbl"><i class="ti ti-history"></i> Registro de accesos</div>'
      +'<div class="empty" style="padding:20px;color:var(--text-muted);font-size:12px">'
      +(window._accError
        ? ('<b style="color:var(--t-rojo3)">No se pudo leer el registro</b><br>'
           +'<span style="font-size:11px">'+_esc(window._accError)+'</span><br>'
           +'<span style="font-size:11px">Comprueba que exista la tabla <b>accesos</b>. '
           +'Está en crear_tabla_accesos.sql.</span>')
        : 'Todavía no hay actividad registrada en este periodo.')
      +'</div>';
    return;
  }

  var res=_accResumen();
  var lista=_accFiltrado();

  var h='<div class="slbl"><i class="ti ti-history"></i> Registro de accesos y actividad</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin:-4px 0 10px">'
    +'Entradas, pantallas abiertas y acciones que dejan rastro. '
    +'No se guardan contraseñas ni lo que la gente escribe.</div>';

  // Último acceso de cada persona
  h+='<div class="slbl" style="font-size:11px"><i class="ti ti-users"></i> Último acceso</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px">'
    + res.map(function(u){
        var act=(window._accUser===u.id);
        return '<div onclick="_accSetUser(\'' + (act?'todos':u.id) + '\')" '
          +'style="cursor:pointer;border:1px solid '+(act?'#5B21B6':'var(--border)')+';'
          +'background:'+(act?'var(--pastel-lila)':'var(--surface-0)')+';'
          +'border-radius:10px;padding:8px 12px;min-width:150px">'
          +'<div style="font-size:12px;font-weight:700">'+_esc(u.nombre)+'</div>'
          +'<div style="font-size:10px;color:var(--text-muted)">'+_esc(u.rol)+'</div>'
          +'<div style="font-size:11px;margin-top:3px;color:'
            +(u.ultimaEntrada?'var(--t-verde)':'var(--text-muted)')+'">'
            +'<i class="ti ti-login" style="font-size:10px"></i> '
            +_accCuando(u.ultimaEntrada)+'</div>'
          +'<div style="font-size:9.5px;color:var(--text-muted)">'
            +u.entradas+' entrada(s) · '+u.acciones+' acción(es)</div>'
          +'</div>';
      }).join('')
    +'</div>';

  // Filtros
  var desde=window._accDesde
    || new Date(Date.now()-30*24*3600*1000).toISOString().slice(0,10);
  h+='<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:9px">'
    +'<select onchange="_accSetUser(this.value)" style="padding:6px 9px;border-radius:8px;'
      +'border:1px solid var(--border);font-size:11.5px;background:var(--surface-2);'
      +'color:var(--text-primary)">'
      +'<option value="todos">Todos los usuarios</option>'
      + res.map(function(u){
          return '<option value="'+_esc(u.id)+'"'
            +((window._accUser===u.id)?' selected':'')+'>'+_esc(u.nombre)+'</option>';
        }).join('')
    +'</select>'
    +'<label style="font-size:11px;color:var(--text-muted)">Desde</label>'
    +'<input type="date" id="acc-desde" value="'+_esc(desde)+'" onchange="_accSetFechas()" '
      +'style="padding:5px 8px;border-radius:8px;border:1px solid var(--border);'
      +'font-size:11.5px;background:var(--surface-2);color:var(--text-primary)">'
    +'<label style="font-size:11px;color:var(--text-muted)">hasta</label>'
    +'<input type="date" id="acc-hasta" value="'+_esc(window._accHasta||'')+'" '
      +'onchange="_accSetFechas()" style="padding:5px 8px;border-radius:8px;'
      +'border:1px solid var(--border);font-size:11.5px;background:var(--surface-2);'
      +'color:var(--text-primary)">'
    +'<span style="flex:1"></span>'
    +'<button class="btn bg2" style="font-size:11px;padding:5px 11px" '
      +'onclick="_accExportar()"><i class="ti ti-download"></i> Excel</button>'
    +'</div>';

  // Tipo
  var chip=function(k,t,c,n){
    var on=(window._accTipo===k);
    return '<span onclick="_accSetTipo(\'' + k + '\')" style="cursor:pointer;'
      +'border:1px solid '+(on?c:'var(--border)')+';background:'+(on?c:'var(--surface-0)')
      +';color:'+(on?'#fff':c)+';border-radius:20px;padding:3px 11px;font-size:10.5px;'
      +'font-weight:600">'+t+' <span style="opacity:.8">'+n+'</span></span>';
  };
  var base=(window._acc||[]).filter(function(x){
    return window._accUser==='todos' || String(x.usuario_id)===window._accUser; });
  h+='<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:10px">'
    + chip('todos','Todo','#0c447c', base.length)
    + Object.keys(_ACC_TIPOS).map(function(k){
        return chip(k,_ACC_TIPOS[k].t,_ACC_TIPOS[k].c,
          base.filter(function(x){ return x.tipo===k; }).length);
      }).join('')
    +'</div>';

  var filas=lista.slice(0,500).map(function(x){
    var ti=_ACC_TIPOS[x.tipo]||{t:x.tipo, c:'var(--text-muted)'};
    return '<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:5px 9px;white-space:nowrap;font-size:10.5px">'
        +_esc(_accFechaHora(x.creado_en))+'</td>'
      +'<td style="padding:5px 9px"><b>'+_esc(x.usuario||x.usuario_id||'')+'</b>'
        +'<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(x.rol||'')
        +(x.dept?(' · '+_esc(dL(x.dept))):'')+'</div></td>'
      +'<td style="padding:5px 9px"><span style="font-size:10px;font-weight:700;'
        +'color:'+ti.c+'">'+_esc(ti.t)+'</span></td>'
      +'<td style="padding:5px 9px;font-size:11px">'+_esc(x.detalle||'')+'</td>'
      +'<td style="padding:5px 9px;font-size:10.5px;color:var(--text-muted)">'
        +_esc(x.referencia||'')+'</td>'
      +'</tr>';
  }).join('');

  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:auto;'
    +'background:var(--surface-0)">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px;min-width:700px">'
    +'<thead><tr style="background:var(--surface-2)">'
      +['Cuándo','Quién','Qué','Detalle','Referencia'].map(function(t){
          return '<th style="padding:7px 9px;text-align:left;font-size:9.5px;'
            +'text-transform:uppercase;white-space:nowrap">'+t+'</th>';
        }).join('')
    +'</tr></thead><tbody>'+filas+'</tbody></table></div>'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:6px">'
    + lista.length+' registro(s)'
    +(lista.length>500?(' · se muestran los 500 más recientes'):'')+'</div>';

  box.innerHTML=h;
}

// El registro filtrado, a Excel
async function _accExportar(){
  var lista=_accFiltrado();
  if(!lista.length){ showT('No hay nada que exportar'); return; }
  try{
    await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Accesos');
    ws.columns=[
      {header:'Fecha y hora', key:'f', width:20},
      {header:'Usuario',      key:'u', width:20},
      {header:'Rol',          key:'r', width:14},
      {header:'Departamento', key:'d', width:14},
      {header:'Tipo',         key:'t', width:12},
      {header:'Detalle',      key:'x', width:44},
      {header:'Referencia',   key:'e', width:18}
    ];
    ws.getRow(1).font={bold:true};
    lista.forEach(function(a){
      ws.addRow({f:_accFechaHora(a.creado_en), u:a.usuario||a.usuario_id||'',
                 r:a.rol||'', d:a.dept?dL(a.dept):'',
                 t:(_ACC_TIPOS[a.tipo]||{t:a.tipo}).t,
                 x:a.detalle||'', e:a.referencia||''});
    });
    var buf=await wb.xlsx.writeBuffer();
    var url=URL.createObjectURL(new Blob([buf],
      {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
    var a=document.createElement('a');
    a.href=url; a.download='accesos-'+new Date().toISOString().slice(0,10)+'.xlsx';
    a.click();
    showT('✓ '+lista.length+' registro(s) exportados');
  }catch(e){
    console.warn('[accesos] exportar:', e);
    showT('No se pudo generar el Excel');
  }
}

// ── Página ──
function rInventario(){
  var box=document.getElementById('page-inventario'); if(!box) return;
  var opts=Object.keys(_INV_ORDENES).map(function(k){
    return '<option value="'+k+'"'+((_invOrden===k)?' selected':'')+'>'+_INV_ORDENES[k]+'</option>';
  }).join('');
  var h='<div style="font-size:13px;font-weight:600;margin-bottom:3px"><i class="ti ti-package" style="color:var(--text-accent)"></i> Consulta de inventario</div>';
  h+='<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:10px">Todos los artículos. Pasa el mouse por la foto para verla grande y pulsa cualquier fila para abrir su ficha técnica.</div>';
  // Estado de las fechas de llegada, para saber si ya sincronizaron
  h+='<div id="invFechasAviso"></div>';
  setTimeout(function(){ _invChequearFechas(); }, 600);

  // Acceso a la consulta de entradas de mercancía
  if(_puedeAduana()){
    h+='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;background:var(--pastel-azul);'
      +'border:0.5px solid #85B7EB;border-radius:9px;padding:8px 12px;margin-bottom:10px">'
      +'<i class="ti ti-truck-delivery" style="color:var(--t-azul)"></i>'
      +'<span style="font-size:11.5px;color:var(--t-azul);flex:1">'
        +'¿Buscas una entrada de mercancía? Consultá por su número sin abrir la orden.</span>'
      +'<button class="btn bp" style="background:#0c447c;padding:5px 12px;font-size:11px" onclick="_entBuscar()">'
        +'<i class="ti ti-search"></i> Buscar entrada</button>'
      +'</div>';
  }
  h+='<div style="display:flex;gap:9px;align-items:center;flex-wrap:wrap;background:var(--surface-1);border:0.5px solid var(--border);border-radius:10px;padding:9px 12px;margin-bottom:10px">'
    +'<div style="flex:1;min-width:190px;display:flex;align-items:center;gap:6px">'
      +'<i class="ti ti-search" style="color:var(--text-muted);font-size:13px"></i>'
      +'<input id="invQ" value="'+_esc(_invQ)+'" oninput="_invBuscar(this.value)" placeholder="SKU, descripción, código de barras o proveedor" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:12px;background:var(--surface-0);color:var(--text-primary)">'
    +'</div>'
    +'<select onchange="_invSetOrden(this.value)" style="padding:5px 9px;border:0.5px solid var(--border);border-radius:7px;background:var(--surface-0);color:var(--text-primary);font-size:12px;font-family:var(--font-sans)">'+opts+'</select>'
    +'<span id="invCnt" style="font-size:11px;color:var(--text-muted);white-space:nowrap"></span>'
    +'<button onclick="_invIAAbrir()" title="Buscar con lenguaje natural y armar el catálogo" '
      +'style="background:#EEEDFE;color:var(--t-indigo);border:0.5px solid #C7C3F5;border-radius:8px;'
      +'padding:6px 12px;font-size:11.5px;font-weight:600;cursor:pointer;white-space:nowrap;'
      +'font-family:var(--font-sans)"><i class="ti ti-sparkles"></i> Buscar con IA</button>'
    +'<span id="invSelBtn" style="display:none;align-items:center;gap:6px">'
      +'<span style="font-size:11px;color:var(--text-muted);white-space:nowrap">'
        +'<b id="invSelN">0</b> marcado(s)</span>'
      +'<button onclick="_invSelCatalogo()" title="Revisar los datos y los precios antes de generar el catálogo" '
        +'style="background:#7C3D12;color:#fff;border:0;border-radius:8px;padding:6px 12px;'
        +'font-size:11.5px;font-weight:600;cursor:pointer;white-space:nowrap;'
        +'font-family:var(--font-sans)"><i class="ti ti-book"></i> Catálogo</button>'
      +'<button id="invVerSelBtn" onclick="_invVerSoloSel()" title="Mostrar solo los marcados" '
        +'style="background:var(--surface-1);color:var(--text-secondary);border:0.5px solid var(--border);'
        +'border-radius:8px;padding:6px 12px;font-size:11.5px;font-weight:600;cursor:pointer;'
        +'white-space:nowrap;font-family:var(--font-sans)">'
        +'<i class="ti ti-list-check"></i> Ver marcados</button>'
      +'<button onclick="_invSelLimpiar()" title="Quitar todos los marcados" '
        +'style="background:var(--surface-1);color:var(--text-danger);border:0.5px solid var(--border);'
        +'border-radius:8px;padding:6px 12px;font-size:11.5px;font-weight:600;cursor:pointer;'
        +'white-space:nowrap;font-family:var(--font-sans)">'
        +'<i class="ti ti-eraser"></i> Quitar todo</button>'
    +'</span>'
    +'</div>';
  // Filtro por departamento (solo para quien ve todos los departamentos)
  if(!(CU&& _deptAcotado())){
    h+='<div style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:10px">'
      +_INV_DEPTS.map(function(d){
        var on=(_invDept===d.k);
        return '<span onclick="_invSetDept(\''+d.k+'\')" style="cursor:pointer;font-size:11px;font-weight:600;padding:4px 11px;border-radius:14px;'
          +'border:1px solid '+(on?'var(--fill-accent)':'var(--border)')+';'
          +'background:'+(on?'var(--fill-accent)':'var(--surface-1)')+';color:'+(on?'#fff':'var(--text-secondary)')+'">'
          +_esc(d.l)+'</span>';
      }).join('')
      +'</div>';
  }
  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden">'
    +'<div class="inv-hdr">'
      +'<div style="flex:0 0 52px">Foto</div>'
      +'<div class="inv-sku">SKU</div>'
      +'<div class="inv-desc">Descripción</div>'
      +_invColOrden('Existencia',   'onhand',      'inv-exi')
      +_invColOrden('Reservado',    'iscommited',  'inv-res')
      +_invColOrden('Disponible',   'disponible',  'inv-dis')
      +_invColOrden('Por llegar',   'onorder',     'inv-lle')
      +_invColOrden('Precio venta', 'precioventa', '', 'flex:0 0 96px')
      +'<div style="flex:0 0 38px;justify-content:center;text-align:center" '
        +'title="Marca los artículos que quieres en el catálogo">Catálogo</div>'
      +'<div class="inv-fill"></div>'
    +'</div>'
    +'<div id="invBody"></div>'
    +'<div id="invMas" style="padding:10px;text-align:center;font-size:11.5px;color:var(--text-muted)"></div>'
  +'</div>';
  box.innerHTML=h;

  // Al regresar desde otra pantalla se conserva lo ya cargado
  if(window._invVolviendo && _invRows.length){
    window._invVolviendo=false;
    var prev=_invRows; _invRows=[];
    _invPintar(prev); _invRows=prev;
    var c0=document.getElementById('invCnt');
    if(c0) c0.textContent=_invRows.length+(_invFin?' artículos':'+ artículos');
    var m0=document.getElementById('invMas');
    if(m0) m0.innerHTML=_invFin?('Fin del listado · '+_invRows.length+' artículos'):'Baja para cargar más…';
  } else {
    window._invVolviendo=false;
    _invRows=[]; _invOffset=0; _invFin=false;
    _invCargarMas();
  }

  // Scroll infinito sobre la ventana
  if(!window._invScrollHook){
    window._invScrollHook=true;
    window.addEventListener('scroll', function(){
      if(PG!=='inventario' || _invCargando || _invFin) return;
      var mas=document.getElementById('invMas'); if(!mas) return;
      var r=mas.getBoundingClientRect();
      if(r.top < (window.innerHeight+300)) _invCargarMas();
    }, {passive:true});
  }
}

function _invSetDept(k){
  _invDept=k;
  rInventario();
}
function _invSetOrden(v){
  _invOrden=v; _invRows=[]; _invOffset=0; _invFin=false;
  var b=document.getElementById('invBody'); if(b) b.innerHTML='';
  _invCargarMas();
}
function _invBuscar(v){
  _invQ=v;
  clearTimeout(_invBuscarTimer);
  _invBuscarTimer=setTimeout(function(){
    _invRows=[]; _invOffset=0; _invFin=false;
    var b=document.getElementById('invBody'); if(b) b.innerHTML='';
    _invCargarMas();
  }, 350);
}

async function _invCargarMas(){
  if(_invCargando||_invFin) return;
  _invCargando=true;
  var mas=document.getElementById('invMas');
  if(mas) mas.innerHTML='<span class="ai-ring g" style="vertical-align:-2px"></span> Cargando…';
  try{
    var url=SB+'/rest/v1/inventario?select='+_INV_CAMPOS
      +'&order='+_invOrden+'&limit='+_invTanda+'&offset='+_invOffset;
    // El departamento del usuario acota lo que ve, igual que en el resto del
    // portal. Si ve todos, manda el chip elegido en la tabla.
    var patron=(CU&&_deptAcotado())?_deptPrimero():_invDeptPatron(_invDept);
    if(patron) url+='&grupo=ilike.*'+encodeURIComponent(patron)+'*';
    var q=String(_invQ||'').trim();
    if(q){
      var e=encodeURIComponent(q);
      url+='&or=(itemcode.ilike.*'+e+'*,itemname.ilike.*'+e+'*,frgnname.ilike.*'+e
         +'*,codebars.ilike.*'+e+'*,nombre_proveedor.ilike.*'+e+'*,cardcode.ilike.*'+e+'*)';
    }
    var r=await fetch(url,{headers:SBH});
    if(!r.ok){
      // Alguna columna opcional puede no existir todavía (por ejemplo
      // hist_comprado o caracteristicas). Se reintenta con lo básico.
      var t=await r.text();
      console.warn('inventario, reintento sin columnas opcionales:', r.status, t);
      var basico=_INV_CAMPOS.split(',').filter(function(c){
        return ['hist_comprado','caracteristicas','subg','u_cant_ult_ent','fechaentrada','u_color','u_tamano'].indexOf(c)<0;
      }).join(',');
      url=url.replace('select='+_INV_CAMPOS, 'select='+basico);
      r=await fetch(url,{headers:SBH});
      if(!r.ok){ throw new Error('HTTP '+r.status); }
    }
    var rows=await r.json();
    if(!Array.isArray(rows)) rows=[];
    if(rows.length<_invTanda) _invFin=true;
    _invOffset+=rows.length;
    _invRows=_invRows.concat(rows);
    _invPintar(rows);
  }catch(e){
    console.warn('inventario:',e);
    if(mas) mas.innerHTML='<span style="color:var(--text-danger)">No se pudo cargar: '+_esc(e.message||String(e))+'</span>';
    _invCargando=false; return;
  }
  // Los SKU que todavía no están en SAP se agregan arriba, en la primera
  // tanda. Vienen del catálogo NO SAP, no de la consulta a inventario.
  if(_invOffset<=_invTanda){
    try{
      var _ns=_invNoSapFilas();
      // Si el mismo código ya vino de SAP, no se duplica la fila: se queda la
      // de SAP —que es la real, con existencias— y se le pasa la foto de la
      // ficha, que muchas veces es la única imagen que hay.
      var _cambioFoto=false;
      if(_ns.length && _invRows.length){
        var _ySap={};
        _invRows.forEach(function(r){
          if(!r._nosap && r.itemcode) _ySap[String(r.itemcode).trim().toUpperCase()]=r;
        });
        _ns=_ns.filter(function(n){
          var fila=_ySap[String(n.itemcode||'').trim().toUpperCase()];
          if(!fila) return true;
          if(!fila.foto && n.foto){ fila.foto=n.foto; _cambioFoto=true; }
          return false;
        });
      }
      // Se repinta si hay filas nuevas O si a alguna de SAP se le puso foto.
      // Antes solo se repintaba con filas nuevas, así que cuando el duplicado
      // se descartaba la foto se asignaba pero la pantalla no se enteraba.
      if(_ns.length || _cambioFoto){
        if(_ns.length) _invRows=_ns.concat(_invRows);
        var _b=document.getElementById('invBody');
        if(_b){ _b.innerHTML=''; _invPintar(_invRows); }
      }
    }catch(e){ console.warn('[inventario] SKU no SAP:', e); }
  }
  _invCargando=false;
  if(mas) mas.innerHTML=_invFin
    ? (_invRows.length?('Fin del listado · '+_invRows.length+' artículos'):'')
    : 'Baja para cargar más…';
  var c=document.getElementById('invCnt');
  if(c) c.textContent=_invRows.length+(_invFin?' artículos':'+ artículos');
  if(!_invRows.length){
    var b=document.getElementById('invBody');
    if(b) b.innerHTML='<div class="empty" style="padding:20px;color:var(--text-muted)"><i class="ti ti-search-off" style="font-size:20px"></i><br>Ningún artículo coincide con la búsqueda.</div>';
  }
  // Si la primera tanda no llenó la pantalla, se pide la siguiente
  if(!_invFin && document.body.scrollHeight<=window.innerHeight+50) setTimeout(_invCargarMas,60);
}

// Ajusta el ancho de la columna SKU al código más largo que se haya cargado,
// para que ninguna referencia salga cortada y la tabla siga cuadrada.
function _invAjustarSKU(){
  var max=0;
  (_invRows||[]).forEach(function(x){
    var l=String(x.itemcode||'').length;
    if(l>max) max=l;
  });
  if(!max) return;
  var w=Math.min(280, Math.max(116, Math.round(max*7.2)+22));   // ancho del texto + holgura
  var box=document.getElementById('page-inventario');
  if(box) box.style.setProperty('--inv-sku-w', w+'px');
}

// Cuando la foto que declara SAP no carga, se prueba la del catálogo NO SAP
// antes de dar el artículo por sin imagen. SAP declara el nombre aunque el
// archivo no esté en el bucket, así que el fallo solo se ve al intentarlo.
function _invFotoFalla(img){
  try{
    // El listado probaba UNA sola forma del nombre y se rendía; la ficha
    // técnica probaba veinte y por eso allí sí aparecía la imagen. Ahora el
    // listado recorre las mismas: SAP guarda el nombre con mayúsculas o
    // extensiones que no coinciden con el archivo del bucket.
    var pn=img.getAttribute('data-pic')||'';
    if(pn){
      var i=Number(img.dataset.intento||0);
      var alts=[];
      var base=String(pn).trim(), sinExt=base.replace(/\.[^.]+$/,'');
      ['', '.jpg', '.JPG', '.jpeg', '.png', '.PNG', '.webp'].forEach(function(ext){
        var n = ext ? (sinExt+ext) : base;
        [n, n.toLowerCase(), n.toUpperCase()].forEach(function(v){
          var u=FOTO_BASE+encodeURIComponent(v);
          if(alts.indexOf(u)<0) alts.push(u);
        });
      });
      if(i<alts.length){
        img.dataset.intento=String(i+1);
        img.src=alts[i];
        return;
      }
    }
    // Agotadas las de SAP: la del catálogo NO SAP, si la hay
    var alt=img.getAttribute('data-alt')||'';
    if(alt && !img.dataset.probado){
      img.dataset.probado='1';
      img.dataset.intento='999';
      img.src=alt;
      return;
    }
    if(img.classList && img.classList.contains('inv-zoom')){ img.remove(); return; }
    if(img.parentNode) img.parentNode.innerHTML='<i class="ti ti-photo-off"></i>';
  }catch(e){}
}

function _invPintar(rows){
  var b=document.getElementById('invBody'); if(!b) return;
  var h='';
  rows.forEach(function(x){
    // Los SKU no SAP traen su foto en la ficha (viene del Excel del
    // proveedor); los de SAP la arman a partir de picturname.
    // Los SKU no SAP traen su foto en la ficha (viene del Excel del
    // proveedor); los de SAP la arman a partir de picturname. Y si el
    // artículo está en SAP pero todavía sin imagen, se usa la del proveedor:
    // es la única que hay hasta que alguien la cargue en el ERP.
    // SAP declara un nombre de foto aunque el archivo no esté en el bucket,
    // así que no basta con encadenar: la URL de SAP existe pero no carga.
    // Se pinta la de SAP y, si falla, se cambia sola por la del proveedor.
    var _fotoSap=x.foto || _repFotoUrl(x.picturname);
    var _fotoAlt=_fotoNoSapDeSku(x.itemcode);
    var foto=_fotoSap || _fotoAlt;
    var idx=_invRows.indexOf(x);
    var _sku=String(x.itemcode||'').replace(/'/g,'');
    var _marcado=!!(window._invSel||{})[_sku.toUpperCase()];
    h+='<div class="inv-row'+(x._nosap?' inv-nosap':'')+'" onclick="_invFicha(\''+_esc(_sku)+'\')">'
      +'<div style="flex:0 0 52px">'
        +(foto
          ?'<div class="inv-foto"><img src="'+_esc(foto)+'" loading="lazy" data-pic="'+_esc(x.picturname||'')+'" data-alt="'+_esc(_fotoAlt||'')+'" onerror="_invFotoFalla(this)"><img class="inv-zoom" src="'+_esc(foto)+'" loading="lazy" data-pic="'+_esc(x.picturname||'')+'" data-alt="'+_esc(_fotoAlt||'')+'" onerror="_invFotoFalla(this)"></div>'
          :'<div class="inv-foto"><i class="ti ti-photo-off"></i></div>')
      +'</div>'
      +'<div class="inv-sku" title="'+_esc(x.itemcode||'')+'">'+_esc(x.itemcode||'')+'</div>'
      +'<div class="inv-desc" title="'+_esc(x.itemname||'')+'">'+_esc(x.itemname||'')+'</div>'
      +'<div class="inv-num inv-exi">'+_fmtN2(x.onhand)+'</div>'
      +'<div class="inv-num inv-res">'+_fmtN2(x.iscommited)+'</div>'
      +'<div class="inv-num inv-dis">'+_fmtN2(_invDisp(x))+'</div>'
      +(function(){
          var lleg=_invLlegadaTxt(x);
          return '<div class="inv-num inv-lle"'+(lleg?(' title="Llega el '+_esc(lleg)+'"'):'')+'>'
            +_fmtN2(x.onorder)
            +((Number(x.onorder)>0 && lleg)
              ? ('<div style="font-size:9px;font-weight:600;color:'+_invLlegadaColor(x)+'">('+_esc(lleg)+')</div>')
              : '')
            +'</div>';
        })()
      +'<div class="inv-num" style="flex:0 0 96px;font-weight:600">'+(_invNum(x.precioventa)?fmt(x.precioventa):'—')+'</div>'
      +'<div style="flex:0 0 38px;display:flex;justify-content:center" onclick="event.stopPropagation()">'
        +'<input type="checkbox" class="inv-check"'+(_marcado?' checked':'')
        +' title="Agregar al catálogo"'
        +' onchange="_invSelMarcar(\''+_esc(_sku)+'\',this.checked,event)"'
        +' style="cursor:pointer;width:15px;height:15px">'
      +'</div>'
      +'<div class="inv-fill"></div>'
    +'</div>';
  });
  b.insertAdjacentHTML('beforeend', h);
  _invAjustarSKU();
}

// ── Ficha técnica del artículo ──
function _invCarac(c, claves){
  if(!c) return '';
  if(typeof c==='string'){ try{ c=JSON.parse(c); }catch(e){ return ''; } }
  if(typeof c!=='object') return '';
  var keys=Object.keys(c);
  for(var i=0;i<keys.length;i++){
    var kl=keys[i].toLowerCase();
    for(var j=0;j<claves.length;j++){
      if(kl.indexOf(claves[j])>=0 && c[keys[i]]!=null && c[keys[i]]!=='') return String(c[keys[i]]);
    }
  }
  return '';
}

// Ficha del artículo. Se puede abrir desde Consulta de inventario, desde el
// listado de una reposición o desde cualquier otro lado: si el artículo no
// está en memoria se trae del inventario, así siempre se ve lo mismo.
window._invFichaCache = window._invFichaCache || {};

async function _invFicha(itemcode){
  var cod=String(itemcode||'').trim();
  if(!cod){ showT('Sin código de producto'); return; }
  // Se busca primero en lo que ya está cargado, para abrir al instante
  var x=(_invRows||[]).find(function(r){ return String(r.itemcode)===cod; })
     || window._invFichaCache[cod.toUpperCase()];
  if(!x){
    var enRep=(typeof _repData!=='undefined'&&_repData)
      ? _repData.find(function(r){ return String(r.itemcode)===cod; }) : null;
    // Solo sirve si trae la ficha técnica; si no, se consulta el inventario
    if(enRep && enRep.caracteristicas) x=enRep;
  }
  if(!x){
    try{
      var url=SB+'/rest/v1/inventario?select='+_INV_CAMPOS+'&itemcode=eq.'+encodeURIComponent(cod)+'&limit=1';
      var r=await fetch(url,{headers:SBH});
      if(!r.ok){
        // Alguna columna opcional puede no existir todavía
        var basico=_INV_CAMPOS.split(',').filter(function(c){
          return ['hist_comprado','caracteristicas','subg','u_cant_ult_ent','fechaentrada','u_color','u_tamano'].indexOf(c)<0;
        }).join(',');
        r=await fetch(SB+'/rest/v1/inventario?select='+basico+'&itemcode=eq.'+encodeURIComponent(cod)+'&limit=1',{headers:SBH});
      }
      if(r.ok){ var f=await r.json(); if(Array.isArray(f)&&f.length) x=f[0]; }
    }catch(e){ console.warn('ficha producto:',e); }
    if(x) window._invFichaCache[cod.toUpperCase()]=x;
  }
  if(!x){
    // Puede ser un SKU nuevo que todavía no está en SAP
    var nuevo=(window._catNoSap||[]).find(function(c){
      return c.tipo==='item' && String(c.itemcode||'').toUpperCase()===cod.toUpperCase();
    });
    if(nuevo){
      x={ itemcode:nuevo.itemcode, itemname:nuevo.itemname, onhand:0, iscommited:0, onorder:0,
          precioventa:0, fob:nuevo.precio||0, cif:0, picturname:'',
          cardcode:nuevo.cardcode, nombre_proveedor:nuevo.cardname,
          colores:nuevo.colores||'', _skuNuevo:true };
    }
  }
  if(!x){ showT('No se encontró el artículo '+cod); return; }
  return _invFichaRender(x);
}

function _invFichaRender(x){
  var carac=x.caracteristicas;
  function cv(k){ return _invCarac(carac,k); }

  // Si SAP no tiene imagen usable, se usa la del catálogo NO SAP, igual
  // que en el listado. El onerror de abajo cubre el caso de que SAP
  // declare un nombre cuyo archivo no está en el bucket.
  var _fotoAlt=_fotoNoSapDeSku(x.itemcode);
  var foto=_repFotoUrl(x.picturname) || _fotoAlt;
  var disp=_invDisp(x);

  var ficha=[
    {ic:'ti-ruler',        c:'#E0A82E', l:'Tamaño',        v:(x.u_tamano||cv(['tamano','tama','medida','size','dimens']))},
    {ic:'ti-cube',         c:'#1FA6A6', l:'Cubicaje',      v:(x.volumen?(Math.round(x.volumen*100000)/100000)+' pies³':cv(['cxblt','cubicaje','volumen']))},
    {ic:'ti-weight',       c:'#6B7280', l:'Peso producto', v:(x.peso?(Math.round(x.peso*100)/100)+' kg':cv(['peso','weight']))},
    {ic:'ti-tag',          c:'#E0457B', l:'Marca',         v:(x.marca||cv(['marca','brand']))},
    {ic:'ti-world',        c:'#2E9E5B', l:'Origen',        v:cv(['porigen','origen','origin','pais','country'])},
    {ic:'ti-weight',       c:'#B98A3E', l:'Peso bulto',    v:cv(['pxblt','pesobulto','peso bulto'])},
    {ic:'ti-box',          c:'#D98C3A', l:'Tamaño bulto',  v:cv(['cartonsize','tamanobulto','carton'])},
    {ic:'ti-stack-2',      c:'#3B82C4', l:'Piezas por bulto', v:(x.unidadesbulto||x.salpackun||cv(['piezas','pcs']))},
    {ic:'ti-palette',      c:'#9B4DCA', l:'Color',         v:(x.u_color||cv(['color']))},
    {ic:'ti-list-details', c:'#7C6FD0', l:'Composición',   v:cv(['composic','compo','material','tela','fabric','content','hecho','confeccion','fibra','algod','poliest','composition'])},
    {ic:'ti-barcode',      c:'#4B5563', l:'Código de barras', v:x.codebars}
  ].filter(function(i){ return i.v!=null && String(i.v).trim()!==''; });

  var nota=x.usertext||cv(['nota','note','remarks','observacion','comentario']);

  var ovPrev=document.getElementById('invFichaOv'); if(ovPrev) ovPrev.remove();
  var ov=document.createElement('div');
  ov.id='invFichaOv';
  // Por encima de cualquier modal abierto: desde el costeo se abría detrás
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:12000;display:flex;align-items:center;justify-content:center;padding:16px';
  var h='<div style="background:var(--surface-0);border-radius:12px;max-width:620px;width:100%;max-height:92vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;padding:15px 18px;border-bottom:0.5px solid var(--border);gap:10px">'
    +'<div style="min-width:0"><div style="font-size:15px;font-weight:700">'+_esc(x.itemcode||'')+'</div>'
    +'<div style="font-size:12px;color:var(--text-secondary);margin-top:2px">'+_esc(x.itemname||'')+'</div>'
    +(x.frgnname?('<div style="font-size:11px;color:var(--text-muted);margin-top:1px">'+_esc(x.frgnname)+'</div>'):'')
    +'</div>'
    +'<button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>';

  h+='<div style="padding:16px 18px">';
  if(x._skuNuevo){
    h+='<div style="background:var(--pastel-lila);border:1px solid #C4B5FD;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-lila)">'
      +'<i class="ti ti-tags"></i> <b>SKU nuevo:</b> todavía no existe en SAP, así que no tiene stock ni precios. '
      +'Está registrado en <b>Proveedores y SKU NO SAP</b>.</div>';
  }
  // Foto + stocks
  h+='<div style="display:flex;gap:14px;flex-wrap:wrap;margin-bottom:14px">';
  h+=foto
    ?'<img data-nosap="'+_esc(_fotoAlt||'')+'" src="'+_esc(foto)+'" onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(String(x.itemcode||'')+' '+String(x.itemname||'').replace(/\x27/g,''))+'\')" onerror="_costFotoAlt(this,\''+_esc(String(x.picturname||'').replace(/\x27/g,''))+'\')" title="Clic para ver la foto en grande" style="width:130px;height:130px;object-fit:contain;border:0.5px solid var(--border);border-radius:9px;background:var(--surface-2);flex-shrink:0;cursor:zoom-in">'
    :'<div style="width:130px;height:130px;border:0.5px solid var(--border);border-radius:9px;display:flex;align-items:center;justify-content:center;background:var(--surface-1);flex-shrink:0"><i class="ti ti-photo-off" style="font-size:26px;color:var(--text-muted)"></i></div>';
  h+='<div style="flex:1;min-width:190px;display:grid;grid-template-columns:1fr 1fr;gap:7px">'
    +_invCaja('Existencia', _fmtN2(x.onhand), '#1D4ED8')
    +_invCajaClic('Reservado', _fmtN2(x.iscommited), '#DC2626',
        _invNum(x.iscommited)>0 ? ('verSeparado(\''+_esc(String(x.itemcode||'').replace(/'/g,''))+'\')') : '',
        'Ver quién tiene esta mercancía separada')
    +_invCaja('Disponible', _fmtN2(disp), '#15803D')
    +_invCaja('Por llegar', _fmtN2(x.onorder)
        +((Number(x.onorder)>0 && _invLlegadaTxt(x))
          ? ('<div style="font-size:10px;font-weight:600;color:'+_invLlegadaColor(x)+';margin-top:2px">'
             +'llega '+_esc(_invLlegadaTxt(x))
             +((Number(x.ordenes_abiertas)||0)>1
               ? ('<br><span style="font-weight:400;color:var(--text-muted)">'
                  +x.ordenes_abiertas+' órdenes abiertas</span>')
               : '')
             +'</div>')
          : ''), '#EA580C')
    +'</div>';
  h+='</div>';

  // Precios
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:14px">'
    +_invPrecio('Precio venta', x.precioventa, '#166534')
    +(CU.verCostos?_invPrecio('FOB', x.fob, '#B45309'):'')
    +(CU.verCostos?_invPrecio('CIF', x.cif, '#5B21B6'):'')
    +(CU.verCostos&&_invNum(x.lastpurprc)?_invPrecio('Última compra', x.lastpurprc, '#0c447c'):'')
    // El margen histórico: la ganancia de todas las ventas del artículo,
    // igual que el Gross Profit % del reporte de ventas de SAP.
    +(function(){
        var hm=_margenHistDe(x.itemcode);
        if(!hm) return '';
        var m=Number(hm.margen_pct);
        var col=(m<0)?'#b91c1c':(m<REP_MARGEN_MIN?'#B45309':'#166534');
        var t='Sobre todas las ventas del artículo: '+fmt(hm.ventas)+' facturados y '
          +fmt(hm.ganancia)+' de ganancia'
          +(hm.unidades?(', '+_fmtN2(hm.unidades)+' unidades'):'')
          +(hm.facturas?(' en '+hm.facturas+' factura(s)'):'')+'.';
        return '<div title="'+_esc(t)+'" style="border:0.5px solid var(--border);border-radius:9px;'
          +'padding:6px 11px;background:var(--surface-1);cursor:help">'
          +'<div style="font-size:9px;color:var(--text-muted);text-transform:uppercase;letter-spacing:.03em">'
            +'Margen histórico</div>'
          +'<div style="font-size:15px;font-weight:800;color:'+col+'">'+m.toFixed(1)+'%'
          +(m<REP_MARGEN_MIN?' <i class="ti ti-arrow-down" style="font-size:12px;color:var(--t-rojo3)"></i>':'')
          +'</div></div>';
      })()
    +'</div>';

  // Proveedor
  if(x.cardcode||x.nombre_proveedor){
    var cc=String(x.cardcode||'').replace(/'/g,'');
    h+='<div style="border:1px solid #85B7EB;background:var(--pastel-azul);border-radius:9px;padding:10px 12px;margin-bottom:14px">'
      +'<div style="font-size:10.5px;text-transform:uppercase;letter-spacing:.05em;color:var(--t-azul);font-weight:700;margin-bottom:4px">Proveedor</div>'
      +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
      +(cc?('<span onclick="_invIrAProveedor(\''+_esc(cc)+'\')" title="Ver este proveedor y hacer reposición" style="background:#0c447c;color:#fff;border-radius:6px;padding:3px 9px;font-size:12px;font-weight:700;cursor:pointer">'+_esc(cc)+' <i class="ti ti-arrow-right" style="font-size:11px"></i></span>'):'')
      +'<span style="font-size:12.5px;color:var(--t-azul);flex:1;min-width:120px">'+_esc(x.nombre_proveedor||'')+'</span>'
      +'</div>'
      +(cc?'<div style="font-size:10px;color:var(--t-azul);opacity:.8;margin-top:5px">Pulsa el código para ir al proveedor y arrancar una reposición.</div>':'')
      +'</div>';
  }

  // Ficha técnica
  if(ficha.length){
    h+='<div style="font-size:12px;font-weight:700;margin-bottom:4px"><i class="ti ti-clipboard-list"></i> Ficha técnica</div>';
    h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(170px,1fr));gap:2px 18px;margin-bottom:6px">';
    ficha.forEach(function(i){
      h+='<div style="display:flex;gap:10px;align-items:flex-start;padding:9px 2px">'
        +'<div style="flex:0 0 34px;height:34px;border-radius:9px;background:'+i.c+'1f;display:flex;align-items:center;justify-content:center;color:'+i.c+'"><i class="'+i.ic+'" style="font-size:16px"></i></div>'
        +'<div style="min-width:0"><div style="font-size:10px;letter-spacing:.05em;text-transform:uppercase;color:var(--text-muted);font-weight:600">'+_esc(i.l)+'</div>'
        +'<div style="font-size:13px;font-weight:600;word-break:break-word">'+_esc(String(i.v))+'</div></div></div>';
    });
    h+='</div>';
  }

  // Movimiento de compra
  if(_invNum(x.hist_comprado)||_invNum(x.u_cant_ult_ent)||x.fechaentrada){
    h+='<div style="border-top:0.5px solid var(--border);margin-top:8px;padding-top:9px;display:flex;gap:14px;flex-wrap:wrap;font-size:11.5px;color:var(--text-secondary)">'
      +(_invNum(x.u_cant_ult_ent)?('<span>Últ. compra: <b>'+_fmtN2(x.u_cant_ult_ent)+'</b></span>'):'')
      +(_invNum(x.hist_comprado)?('<span>Hist. comprado: <b style="color:var(--t-lila)">'+_fmtN2(x.hist_comprado)+'</b></span>'):'')
      +(x.fechaentrada?('<span>Fecha entrada: <b>'+_esc(String(x.fechaentrada).slice(0,10))+'</b></span>'):'')
      +'</div>';
  }

  if(nota && String(nota).trim()){
    h+='<div style="margin-top:12px;padding:11px 13px;background:#FEF9E7;border-left:4px solid #E0A82E;border-radius:8px">'
      +'<div style="font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:var(--t-oro);font-weight:700;margin-bottom:3px">Nota</div>'
      +'<div style="font-size:12.5px;color:#5A4A1F;line-height:1.5;white-space:pre-wrap;word-break:break-word">'+_esc(String(nota))+'</div></div>';
  }

  h+='</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
}

// Recuadro con acción (el de Reservado abre los pedidos que la tienen separada)
function _invCajaClic(lbl, val, col, accion, titulo){
  if(!accion) return _invCaja(lbl, val, col);
  return '<div onclick="event.stopPropagation();'+accion+'" title="'+_esc(titulo||'')+'"'
    +' style="background:var(--surface-1);border:1px solid '+col+'66;border-radius:8px;padding:7px 10px;cursor:pointer">'
    +'<div style="font-size:9.5px;text-transform:uppercase;letter-spacing:.04em;color:var(--text-muted);font-weight:600">'+lbl
      +' <i class="ti ti-external-link" style="font-size:10px;color:'+col+'"></i></div>'
    +'<div style="font-size:15px;font-weight:700;color:'+col+';text-decoration:underline;text-decoration-style:dotted;text-underline-offset:3px">'+val+'</div></div>';
}
// Foto del artículo a pantalla completa
function _invFotoGrande(url, titulo){
  if(!url) return;
  var ov=document.createElement('div');
  ov.id='invFotoOv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.88);z-index:12500;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
  // Si la imagen tampoco carga aquí, se dice: antes quedaba un hueco negro
  // y no había forma de saber si el problema era la foto o el visor.
  ov.innerHTML='<img src="'+_esc(url)+'" onerror="this.style.display=\'none\';'
    +'var a=this.nextElementSibling; if(a) a.style.display=\'block\';"'
    +' style="max-width:96vw;max-height:84vh;object-fit:contain;border-radius:10px;background:var(--surface-2)">'
    +'<div style="display:none;color:#fff;background:rgba(255,255,255,.08);'
    +'border:1px solid rgba(255,255,255,.25);border-radius:10px;padding:18px 22px;'
    +'text-align:center;max-width:520px">'
    +'<div style="font-size:26px">🖼️</div>'
    +'<div style="font-size:14px;margin-top:8px">Esta imagen no está en el bucket</div>'
    +'<div style="font-size:11.5px;color:#bbb;margin-top:6px;word-break:break-all">'
    +_esc(url)+'</div></div>'
    +'<div style="color:#fff;font-size:13px;margin-top:12px;text-align:center;max-width:90vw">'+_esc(titulo||'')+'</div>'
    +'<div style="color:#bbb;font-size:11px;margin-top:5px">Clic en cualquier lado para cerrar</div>'
    +'<button onclick="event.stopPropagation();window.open(\''+_esc(url)+'\',\'_blank\')" style="margin-top:10px;background:rgba(255,255,255,.15);color:#fff;border:1px solid rgba(255,255,255,.35);border-radius:8px;padding:6px 14px;cursor:pointer;font-size:12px"><i class="ti ti-external-link"></i> Abrir en pestaña nueva</button>';
  ov.addEventListener('click', function(){ ov.remove(); });
  document.body.appendChild(ov);
}

function _invCaja(lbl, val, col){
  return '<div style="background:var(--surface-1);border:0.5px solid var(--border);border-radius:8px;padding:7px 10px">'
    +'<div style="font-size:9.5px;text-transform:uppercase;letter-spacing:.04em;color:var(--text-muted);font-weight:600">'+lbl+'</div>'
    +'<div style="font-size:15px;font-weight:700;color:'+col+'">'+val+'</div></div>';
}
function _invPrecio(lbl, v, col){
  if(!_invNum(v)) return '';
  return '<div style="border:1px solid '+col+'55;border-radius:8px;padding:5px 11px">'
    +'<div style="font-size:9.5px;text-transform:uppercase;color:var(--text-muted);font-weight:600">'+lbl+'</div>'
    +'<div style="font-size:13.5px;font-weight:700;color:'+col+'">'+fmt(v)+'</div></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  BARRA DE "VOLVER"
//  Cuando se salta de una pantalla a otra (por ejemplo del inventario a
//  reposiciones), queda una barra arriba para regresar de donde se vino.
//  Se pinta sobre el body, así sobrevive a los repintados de la página.
// ═══════════════════════════════════════════════════════════════════════════
window._navVolver=null;   // {a:'inventario', l:'Consulta inventario', en:'reposiciones'}

function _navSetVolver(a, etiqueta, en){
  window._navVolver={a:a, l:etiqueta, en:en};
  _navPintarVolver();
}
function _navLimpiarVolver(){
  window._navVolver=null;
  var b=document.getElementById('navVolverBar');
  if(b) b.remove();
}
function _navPintarVolver(){
  var v=window._navVolver;
  var b=document.getElementById('navVolverBar');
  if(!v || PG!==v.en){ if(b) b.remove(); return; }
  if(b) return;
  var d=document.createElement('div');
  d.id='navVolverBar';
  d.innerHTML='<span onclick="_navHacerVolver()" style="display:inline-flex;align-items:center;gap:6px;cursor:pointer">'
    +'<i class="ti ti-arrow-left"></i> Volver a '+_esc(v.l)+'</span>'
    +'<span onclick="_navLimpiarVolver()" title="Quitar" style="cursor:pointer;opacity:.6;font-size:15px;line-height:1">&times;</span>';
  document.body.appendChild(d);
}
function _navHacerVolver(){
  var v=window._navVolver; if(!v) return;
  var destino=v.a;
  _navLimpiarVolver();
  if(destino==='inventario') window._invVolviendo=true;   // no recargar la lista
  go(destino);
}

// ── Saltar al proveedor y ofrecer la reposición ──
function _invIrAProveedor(cardcode){
  var nombre='';
  var it=_invRows.find(function(r){ return String(r.cardcode)===String(cardcode); });
  if(it) nombre=it.nombre_proveedor||'';
  var msg='Proveedor '+cardcode+(nombre?('\n'+nombre):'')+'\n\n¿Quieres hacer una reposición de este proveedor?';
  if(!confirm(msg)) return;
  var ovF=document.getElementById('invFichaOv'); if(ovF) ovF.remove();   // cerrar la ficha
  _navSetVolver('inventario', 'Consulta inventario', 'reposiciones');
  // Se deja el proveedor pendiente: rReposiciones() lo toma cuando termina de
  // dibujar. Así no depende de cuánto tarde en cargar el catálogo.
  window._repPrefill=cardcode;
  showT('Abriendo reposición de '+cardcode+'…');
  go('reposiciones');
  // Respaldo por si la página ya estaba dibujada y no se vuelve a renderizar
  _invEsperarCampo(cardcode, 0);
}

function _invEsperarCampo(cardcode, intento){
  if(!window._repPrefill) return;          // ya lo tomó rReposiciones()
  if(PG!=='reposiciones') return;          // el usuario se fue a otro lado
  var inp=document.getElementById('rep-code');
  if(!inp){
    if(intento>100) return;                // ~15 s y se rinde en silencio
    return setTimeout(function(){ _invEsperarCampo(cardcode, intento+1); }, 150);
  }
  window._repPrefill=null;
  inp.value=cardcode;
  var d=document.getElementById('rep-provdrop'); if(d) d.style.display='none';
  try{
    var r=repGenerar();
    if(r && typeof r.catch==='function') r.catch(function(e){ console.warn('repGenerar:',e); });
  }catch(e){
    console.warn('repGenerar:',e);
    showT('No se pudo cargar el proveedor '+cardcode);
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  SOLICITUDES DE PAGO (ABONO / CANCELACIÓN)
//  Compras pide a contabilidad que deposite un abono o que cancele el saldo
//  final de una orden. Contabilidad las ve agrupadas por departamento en
//  Alertas y puede sacar un reporte imprimible con los totales.
//  Tabla Supabase: solicitudes_pago
// ═══════════════════════════════════════════════════════════════════════════
window._solPago=[];

async function _solPagoCargar(silencioso){
  try{
    var r=await fetch(SB+'/rest/v1/solicitudes_pago?select=*&order=solicitado_en.desc&limit=600',{headers:SBH});
    if(!r.ok){ if(!silencioso) console.warn('solicitudes_pago:', r.status); window._solPago=[]; return []; }
    var rows=await r.json();
    window._solPago=Array.isArray(rows)?rows:[];
  }catch(e){ console.warn('cargar solicitudes_pago:',e); window._solPago=[]; }
  return window._solPago;
}

// Datos de la orden (SAP o NO SAP) para completar la solicitud
function _solPagoDatosOrden(oid){
  var o=(orders||[]).find(function(x){ return String(x.id)===String(oid); });
  if(o) return { proveedor:o.prov||'', dkc:o.num_proveedor||'', dept:o.dept||'',
                 total:Number(o.valor)||0, abonado:Number(o.abono)||0,
                 saldo:(Number(o.valor)||0)-(Number(o.abono)||0), eta:o.fechaEst||'' };
  var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
  if(p) return { proveedor:p.proveedor||'', dkc:p.dkc||p.num_orden||'', dept:p.dept||'',
                 total:Number(p.total)||0, abonado:Number(p.abonado)||0,
                 saldo:Number(p.saldo!=null?p.saldo:((Number(p.total)||0)-(Number(p.abonado)||0))), eta:'' };
  return { proveedor:'', dkc:'', dept:'', total:0, abonado:0, saldo:0, eta:'' };
}

// Crea (o actualiza) una solicitud
async function _solPagoCrear(oid, tipo, monto, nota){
  var d=_solPagoDatosOrden(oid);
  var fila={
    docnum:String(oid), tipo:tipo,
    proveedor:d.proveedor, dkc:d.dkc, dept:d.dept,
    monto:Number(monto)||0, eta:d.eta||null, nota:nota||null,
    estado:'pendiente',
    solicitado_por:(CU&&CU.name)||'', solicitado_en:new Date().toISOString()
  };
  try{
    var r=await fetch(SB+'/rest/v1/solicitudes_pago',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text();
      console.warn('crear solicitud', r.status, t);
      showT('⚠ No se registró la solicitud: '+(/does not exist/i.test(t)?'falta la tabla solicitudes_pago':('error '+r.status)));
      return null;
    }
    var cr=null; try{ cr=await r.json(); }catch(e){}
    var nueva=(cr&&cr[0])||fila;
    window._solPago.unshift(nueva);
    try{ addNotif('contabilidad','💵 '+(tipo==='abono'?'Solicitud de abono':'Solicitud de cancelación')+' — orden '+oid+' · '+fmt(fila.monto), oid, 'ti-coin', true); }catch(e){}
    // Y el aviso persistente, que no se pierde al recargar
    try{
      await _avSolicitud(_avUsuariosPorRol('contabilidad'), nueva,
        (tipo==='abono'?'Nueva solicitud de abono':'Nueva solicitud de cancelación')
        +' · '+(nueva.proveedor||'')+' · '+fmt(nueva.monto),
        (tipo==='abono'?'Solicitud de abono':'Solicitud de cancelación'));
    }catch(e){ console.warn('aviso a contabilidad:',e); }
    return nueva;
  }catch(e){ console.warn('crear solicitud:',e); return null; }
}

// Botón para pedir la cancelación del saldo final
function _solPagoBotonCancelacion(oid){
  var d=_solPagoDatosOrden(oid);
  if(d.saldo<=0) return '';
  return '<div style="background:var(--pastel-aviso);border:0.5px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-top:8px">'
    +'<div style="font-size:11.5px;font-weight:600;color:var(--t-marron);margin-bottom:5px"><i class="ti ti-file-invoice"></i> Solicitar cancelación del saldo final</div>'
    +'<div style="font-size:11px;color:var(--t-marron);margin-bottom:7px">Saldo pendiente: <b>'+fmt(d.saldo)+'</b></div>'
    +'<button class="btn bp" style="background:#B45309;font-size:11px;padding:6px 12px" onclick="_solPagoAbrirModal(\''+_esc(String(oid))+'\',\'cancelacion\')">'
    +'<i class="ti ti-send"></i> Solicitar cancelación a contabilidad</button></div>';
}

// Botón para pedir el abono
function _solPagoBotonAbono(oid){
  var d=_solPagoDatosOrden(oid);
  return '<div style="background:var(--pastel-ok);border:0.5px solid #16a34a;border-radius:8px;padding:9px 11px;margin-top:8px">'
    +'<div style="font-size:11.5px;font-weight:600;color:var(--t-verde);margin-bottom:5px"><i class="ti ti-coin"></i> Solicitar abono a contabilidad</div>'
    +'<div style="font-size:11px;color:var(--t-verde);margin-bottom:7px">Total '+fmt(d.total)+' · Abonado '+fmt(d.abonado)+' · Saldo <b>'+fmt(d.saldo)+'</b></div>'
    +'<button class="btn bp" style="background:#166534;font-size:11px;padding:6px 12px" onclick="_solPagoAbrirModal(\''+_esc(String(oid))+'\',\'abono\')">'
    +'<i class="ti ti-send"></i> Enviar solicitud de abono</button></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  SOLICITUD DE ABONO / CANCELACIÓN — pantalla emergente
//  Funciona igual que los correos de las etapas: sale por Azure desde el
//  correo de la compradora, con la orden firmada por gerencia ya adjunta y la
//  posibilidad de sumar otros documentos (debida diligencia, instrucciones de
//  abono, etc.). Al enviar, queda registrada para contabilidad y entra al
//  reporte de abonos y cancelaciones.
// ═══════════════════════════════════════════════════════════════════════════

// Descarga un archivo del storage y lo deja listo como adjunto en base64
// Busca el comprobante del abono ya pagado y lo suma a los adjuntos
async function _solPagoComprobanteAbono(oid, yaPuestos){
  yaPuestos=yaPuestos||{};
  // Los archivos del paso donde contabilidad sube el comprobante
  var claves=[];
  try{
    claves.push(oid+_subKeyDeposito(_PASO_DEP_PROV));
    claves.push(oid+_subKeyDeposito(_PASO_COMP_PROV));
  }catch(e){}
  claves.push(oid+'deposito_step1', oid+'deposito_step2');

  var vistos={}, cand=[];
  claves.forEach(function(k){
    if(!k || vistos[k]) return;
    vistos[k]=1;
    ((window._atts&&window._atts[k])||[]).forEach(function(a){
      if(a && a.url && !yaPuestos[a.url]) cand.push(a);
    });
  });
  if(!cand.length) return {puesto:false, motivo:'todavía no se subió'};

  // Se prefiere lo que parezca un comprobante de pago
  cand.sort(function(a,b){
    function pts(x){
      var n=String(x.name||'').toLowerCase();
      return (/comprob|transfer|pago|swift|wire|abono|deposit/.test(n)?0:1);
    }
    return pts(a)-pts(b);
  });

  var a=cand[0];
  var motivo={};
  var adj=await _solPagoAdjuntarDeStorage(a.url, a.name||('Comprobante_abono_'+oid+'.pdf'), motivo);
  if(!adj) return {puesto:false, motivo:motivo.txt||'no se pudo adjuntar'};
  window._mailAdj.push(adj);
  yaPuestos[a.url]=1;
  return {puesto:true, nombre:a.name};
}

async function _solPagoAdjuntarDeStorage(path, nombre, motivo){
  if(!path) return null;
  try{
    var url=DOCS_BASE + String(path).split('/').map(encodeURIComponent).join('/');
    var r=await fetch(url);
    if(!r.ok){
      if(motivo) motivo.txt='no se pudo descargar del servidor (error '+r.status+')';
      return null;
    }
    var blob=await r.blob();
    if(blob.size>MAIL_MAX_MB*1024*1024){
      // Antes se devolvía null sin decir nada y parecía un fallo cualquiera
      if(motivo) motivo.txt='pesa '+(blob.size/1048576).toFixed(1)+' MB y el límite del correo son '+MAIL_MAX_MB+' MB';
      return null;
    }
    var b64=await new Promise(function(res,rej){
      var fr=new FileReader();
      fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
      fr.onerror=rej;
      fr.readAsDataURL(blob);
    });
    return { nombre:nombre||String(path).split('/').pop(),
             mime:blob.type||'application/octet-stream',
             contenido:b64, kb:Math.round(blob.size/1024) };
  }catch(e){ console.warn('adjuntar de storage:',e); return null; }
}

// Busca la orden firmada por gerencia para esta orden de compra
async function _solPagoOrdenFirmada(oid){
  var d=_solPagoDatosOrden(oid);
  var ors=[];
  var claves=[String(oid), d.dkc||''].filter(Boolean);
  for(var i=0;i<claves.length;i++){
    try{
      var url=SB+'/rest/v1/ordenes_firma?select=id,num_orden,dkc,archivo_firmado_path,archivo_firmado_nombre,estado'
        +'&or=(num_orden.eq.'+encodeURIComponent(claves[i])+',dkc.eq.'+encodeURIComponent(claves[i])+')'
        +'&archivo_firmado_path=not.is.null&limit=3';
      var r=await fetch(url,{headers:SBH});
      if(r.ok){ var f=await r.json(); if(Array.isArray(f)&&f.length){ ors=f; break; } }
    }catch(e){}
  }
  return ors[0]||null;
}

// Base del porcentaje: el total de la orden
function _solPagoBase(){
  var ctx=window._solPagoCtx; if(!ctx) return 0;
  var d=_solPagoDatosOrden(ctx.oid);
  return Number(d.total)||0;
}
// Se escribe el %: se calcula el monto
function _solPagoCalcMonto(){
  var pc=parseFloat((document.getElementById('sp-pct')||{}).value);
  var base=_solPagoBase();
  var inp=document.getElementById('sp-monto'); if(!inp) return;
  if(isNaN(pc)){ _solPagoNota(''); return; }
  var monto=Math.round(base*(pc/100)*100)/100;
  inp.value=monto.toFixed(2);
  _solPagoNota(pc.toFixed(2)+'% de '+fmt(base)+' = <b>'+fmt(monto)+'</b>');
  _solPagoSyncCuerpo();
}
// Se escribe el monto: se calcula el %
function _solPagoCalcPct(){
  var monto=parseFloat((document.getElementById('sp-monto')||{}).value);
  var base=_solPagoBase();
  var inp=document.getElementById('sp-pct'); if(!inp||!base) return;
  if(isNaN(monto)){ _solPagoNota(''); return; }
  var pc=Math.round((monto/base)*10000)/100;
  inp.value=pc.toFixed(2);
  _solPagoNota(fmt(monto)+' es el <b>'+pc.toFixed(2)+'%</b> de '+fmt(base));
  _solPagoSyncCuerpo();
}
function _solPagoSetPct(v, modo){
  var inp=document.getElementById('sp-pct'); if(!inp) return;
  inp.value=v; _solPagoCalcMonto();
  // "100% contra B/L" es el caso sin abono: se deja dicho en el correo, que es
  // lo que contabilidad necesita saber para no buscar un depósito anterior.
  if(modo==='bl'){
    _solPagoNota('Base: total de la orden '+fmt(_solPagoBase())
      +' · <b style="color:var(--t-verde)">100% contra copia de B/L, sin abono previo</b>');
    try{
      var c=document.getElementById('mail-cuerpo');
      if(c && c.value.indexOf('contra copia de B/L')<0){
        c.value=c.value.replace(/\n\nSaludos,/,
          '\n\nEsta orden se paga al 100% contra copia del B/L: no lleva abono previo.\n\nSaludos,');
      }
    }catch(e){}
  }
}
function _solPagoNota(txt){
  var d=document.getElementById('sp-calc'); if(!d) return;
  d.innerHTML=txt||('Base: total de la orden '+fmt(_solPagoBase()));
}

// Refleja el monto calculado en el cuerpo del correo, en la línea
// "Monto solicitado:". Si la persona reescribió el texto, respeta lo suyo y
// solo cambia esa línea.
function _solPagoSyncCuerpo(){
  var ta=document.getElementById('mail-cuerpo'); if(!ta) return;
  var monto=parseFloat((document.getElementById('sp-monto')||{}).value);
  if(isNaN(monto)) return;
  var pc=parseFloat((document.getElementById('sp-pct')||{}).value);
  var linea='Monto solicitado: '+fmt(monto)+(isNaN(pc)?'':(' ('+pc.toFixed(2)+'% de la orden)'));
  var lineas=String(ta.value||'').split('\n');
  var i=lineas.findIndex(function(l){ return /^\s*Monto solicitado\s*:/i.test(l); });
  if(i>=0) lineas[i]=linea;
  else {
    // Si no existe, se agrega antes de la despedida
    var j=lineas.findIndex(function(l){ return /^\s*(Adjunto|Saludos)/i.test(l); });
    if(j<0) j=lineas.length;
    lineas.splice(j,0,linea,'');
  }
  ta.value=lineas.join('\n');
}
// Chips de CC: se marcan y se escriben en el campo
function _solPagoToggleCC(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i){ i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus'); i.style.fontSize='10px'; }
  var inp=document.getElementById('sp-cc'); if(!inp) return;
  var chips=Array.prototype.slice.call(document.querySelectorAll('.sp-cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); })
                   .map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}

// ═══════════════════════════════════════════════════════════════════════════
//  SOLICITUD DE ABONO — ADJUNTOS Y DATOS DE TRANSFERENCIA
//  Se adjuntan solas las DOS órdenes firmadas por gerencia (la nuestra y la
//  del proveedor), la compradora suma la debida diligencia, y la IA lee las
//  instrucciones bancarias de esos documentos para escribirlas en el correo.
// ═══════════════════════════════════════════════════════════════════════════

// Trae las dos órdenes firmadas de la compra
async function _solPagoFirmadas(oid){
  var d=_solPagoDatosOrden(oid);
  var claves=[String(oid), d.dkc||''].filter(Boolean);
  for(var i=0;i<claves.length;i++){
    try{
      var url=SB+'/rest/v1/ordenes_firma?select=id,num_orden,dkc,proveedor,'
        +'archivo_firmado_path,archivo_firmado_nombre,archivo_firmado_path2,archivo_firmado_nombre2,'
        +'archivo_path,archivo_nombre,archivo_path2,archivo_nombre2,estado'
        +'&or=(num_orden.eq.'+encodeURIComponent(claves[i])+',dkc.eq.'+encodeURIComponent(claves[i])+')&limit=3';
      var r=await fetch(url,{headers:SBH});
      if(r.ok){
        var f=await r.json();
        if(Array.isArray(f)&&f.length){
          // Se prefiere la que ya está firmada
          var firmada=f.find(function(x){ return x.archivo_firmado_path; });
          return firmada||f[0];
        }
      }
    }catch(e){ console.warn('firmadas:',e); }
  }
  return null;
}

// Adjunta las dos órdenes firmadas y avisa qué se pudo y qué no
// Cortina con rueda grande mientras se preparan los adjuntos y se leen los
// datos bancarios: son varias descargas y una llamada a la IA.
function _spCargando(txt, sub){
  var ov=document.getElementById('spCargandoOv');
  if(!ov){
    ov=document.createElement('div');
    ov.id='spCargandoOv';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.62);z-index:10050;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px';
    ov.innerHTML='<div class="ai-ring" style="width:58px;height:58px;border-width:5px"></div>'
      +'<div id="spCargandoTxt" style="color:#fff;font-size:15px;font-weight:600;text-align:center;padding:0 24px"></div>'
      +'<div id="spCargandoSub" style="color:#c9c9c9;font-size:12px;text-align:center;padding:0 24px"></div>';
    document.body.appendChild(ov);
  }
  var t=document.getElementById('spCargandoTxt'); if(t) t.textContent=txt||'Preparando…';
  var u=document.getElementById('spCargandoSub'); if(u) u.textContent=sub||'';
}
function _spCargandoFin(){
  var ov=document.getElementById('spCargandoOv'); if(ov) ov.remove();
}

async function _solPagoAdjuntarFirmadas(oid){
  var res={puestos:[], faltan:[]};
  var yaPuestos={};

  // 1) Los documentos que compras subió al crear la orden NO SAP: son la
  //    orden de KCC y la del proveedor, y ya están en la etapa Pedido.
  var base=[];
  try{ base=_docsBaseOrden(oid); }catch(e){}
  // Se confirma contra la base que cada documento es DE ESTA ORDEN. En memoria
  // pueden quedar archivos de otras órdenes vistas antes, y así se colaba
  // cualquier cosa en la solicitud.
  var deLaOrden=null;
  try{
    var rv=await fetch(SB+'/rest/v1/compras_documentos?select=url&docnum=eq.'
      +encodeURIComponent(oid)+'&limit=200',{headers:SBH});
    if(rv.ok){
      deLaOrden={};
      (await rv.json()||[]).forEach(function(d){ if(d.url) deLaOrden[d.url]=1; });
    }
  }catch(e){ console.warn('verificar documentos:',e); }

  for(var b=0;b<base.length;b++){
    var a=base[b];
    if(!a.url || yaPuestos[a.url]) continue;
    // No pertenece a esta orden: se descarta
    if(deLaOrden && !deLaOrden[a.url]){
      console.warn('[solicitud] se descarta un documento que no es de la orden '+oid+':', a.name);
      continue;
    }
    // Solo documentos de compra: la orden y la proforma son PDF. Un Excel o
    // una foto sueltos no tienen nada que hacer en una solicitud de pago.
    // La orden y la proforma llegan en PDF, en imagen o en Excel: los tres
    // valen. Lo que se quiere dejar fuera es cualquier otro adjunto suelto.
    var ext=String(a.name||'').split('.').pop().toLowerCase();
    if(['pdf','jpg','jpeg','png','xlsx','xls','doc','docx'].indexOf(ext)<0){
      console.warn('[solicitud] se descarta por tipo de archivo:', a.name);
      continue;
    }
    var adjB=await _solPagoAdjuntarDeStorage(a.url, a.name||('documento_'+(b+1)+'.pdf'));
    if(adjB){ window._mailAdj.push(adjB); yaPuestos[a.url]=1; res.puestos.push(a.name||'documento de la orden'); }
  }

  // 2) Si la compra pasó por firma, se prefieren las versiones FIRMADAS
  var fr=await _solPagoFirmadas(oid);
  if(!fr){
    if(!res.puestos.length) res.faltan.push('las órdenes de compra (no se encontraron documentos de esta orden)');
    return res;
  }

  var docs=[
    {path:fr.archivo_firmado_path,  nombre:fr.archivo_firmado_nombre  || ('Orden_KCC_firmada_'+oid+'.pdf'), etiqueta:'orden de Kennedy firmada'},
    {path:fr.archivo_firmado_path2, nombre:fr.archivo_firmado_nombre2 || ('PI_proveedor_firmada_'+oid+'.pdf'), etiqueta:'orden del proveedor firmada'}
  ];
  // Si alguna no está firmada todavía, se manda la original
  if(!docs[0].path && fr.archivo_path)  docs[0]={path:fr.archivo_path,  nombre:fr.archivo_nombre  || 'Orden_KCC.pdf',      etiqueta:'orden de Kennedy (sin firmar)'};
  if(!docs[1].path && fr.archivo_path2) docs[1]={path:fr.archivo_path2, nombre:fr.archivo_nombre2 || 'PI_proveedor.pdf',   etiqueta:'orden del proveedor (sin firmar)'};

  for(var i=0;i<docs.length;i++){
    if(!docs[i].path){ if(!res.puestos.length) res.faltan.push(docs[i].etiqueta); continue; }
    if(yaPuestos[docs[i].path]) continue;                    // ya iba adjunto
    var adj=await _solPagoAdjuntarDeStorage(docs[i].path, docs[i].nombre);
    if(!adj){ res.faltan.push(docs[i].etiqueta+' (pesa demasiado o no se pudo leer)'); continue; }
    // Si es la versión firmada del mismo documento, reemplaza a la sin firmar
    var mismoNombre=String(docs[i].nombre||'').toLowerCase();
    window._mailAdj=window._mailAdj.filter(function(x){
      return !(x._base && String(x.nombre||'').toLowerCase()===mismoNombre);
    });
    window._mailAdj.push(adj);
    yaPuestos[docs[i].path]=1;
    res.puestos.push(docs[i].etiqueta);
  }
  // En una cancelación se adjunta también el comprobante del abono que ya se
  // pagó: contabilidad necesita verlo para calcular el saldo a cancelar.
  if(String(tipo||'')==='cancelacion'){
    try{
      var comp=await _solPagoComprobanteAbono(oid, yaPuestos);
      if(comp && comp.puesto) res.puestos.push('comprobante del abono');
      else if(comp && comp.motivo) res.faltan.push('el comprobante del abono ('+comp.motivo+')');
    }catch(e){ console.warn('comprobante del abono:',e); }
  }

  // Una sola copia de cada documento, comparando por nombre normalizado
  var vistos={};
  window._mailAdj=(window._mailAdj||[]).filter(function(a){
    var k=_docClave({name:a.nombre});
    if(!k) return true;
    if(vistos[k]) return false;
    vistos[k]=1; return true;
  });
  // El aviso también sin repetir
  var vp={};
  res.puestos=res.puestos.filter(function(x){ var k=String(x).toLowerCase(); if(vp[k]) return false; vp[k]=1; return true; });
  return res;
}

// ── Instrucciones bancarias leídas con IA ──
var _SP_CAMPOS=[
  {k:'beneficiary_customer', l:'BENEFICIARY CUSTOMER'},
  {k:'beneficiary_bank',     l:'BENEFICIARY BANK'},
  {k:'swift_code',           l:'SWIFT CODE'},
  {k:'account_number',       l:'ACCOUNT NUMBER'},
  {k:'beneficiary_address',  l:'BENEFICIARY ADDRESS'},
  {k:'bank_address',         l:'BANK ADDRESS'}
];
var _SP_FALTA='SOLICITAR INFO AL PROVEEDOR';

function _solPagoBloqueBanco(b){
  var t='\nDATOS DE TRANSFERENCIA:\n';
  _SP_CAMPOS.forEach(function(c){
    var v=String((b&&b[c.k])||'').trim();
    t+=c.l+': '+(v||_SP_FALTA)+'\n';
  });
  return t;
}

// Lee las instrucciones bancarias de los documentos ya adjuntos
async function _solPagoLeerBanco(oid){
  // Las rutas se buscan en TODOS lados: antes solo miraba `ordenes_firma`, así
  // que en una orden NO SAP que no pasó por firma no encontraba nada que leer.
  var rutas=[];
  function agregar(r){ if(r && rutas.indexOf(r)<0) rutas.push(r); }

  // 1) Los documentos que compras subió a la orden (aquí está la PI del proveedor)
  try{ _docsBaseOrden(oid).forEach(function(a){ agregar(a.url); }); }catch(e){}

  // 2) Lo que haya en compras_documentos por si no está en memoria
  try{
    var rd=await fetch(SB+'/rest/v1/compras_documentos?select=url,nombre_archivo&docnum=eq.'
      +encodeURIComponent(oid)+'&order=subido_en.asc&limit=50',{headers:SBH});
    if(rd.ok) (await rd.json()||[]).forEach(function(d){ agregar(d.url); });
  }catch(e){}

  // 3) Y las versiones firmadas, si la compra pasó por firma
  try{
    var fr=await _solPagoFirmadas(oid);
    if(fr) [fr.archivo_path2, fr.archivo_firmado_path2, fr.archivo_path, fr.archivo_firmado_path].forEach(agregar);
  }catch(e){}

  if(!rutas.length){ console.warn('[banco] no hay documentos donde buscar para', oid); return null; }

  // Los datos bancarios están en el documento del PROVEEDOR, así que ese va
  // primero. Nuestra orden (DKC/SKC) se deja para el final.
  function prioridad(r){
    // Solo el nombre del archivo: la ruta lleva el DKC y confundiría el orden
    var n=String(r||'').split('/').pop().toLowerCase();
    if(/proforma|invoice|\bpi\b|bank/.test(n)) return 0;   // el del proveedor primero
    if(/^dkc|^skc|kcc|kennedy/.test(n)) return 3;          // el nuestro al final
    return 1;
  }
  rutas.sort(function(a,b){ return prioridad(a)-prioridad(b); });
  rutas=rutas.slice(0,5);   // con 5 basta; no se gasta IA de más
  console.info('[banco] revisando '+rutas.length+' documento(s) de '+oid, rutas);

  var prompt='Del documento adjunto extrae UNICAMENTE las instrucciones bancarias del PROVEEDOR.\n'
    +'DONDE BUSCAR: suele estar al final del documento, en una seccion titulada BANK INSTRUCTIONS, BANK INFORMATION, '
    +'BANK DETAILS, BANKING DETAILS, BENEFICIARY, BENEFICIARY INFORMATION, WIRE INSTRUCTIONS, PAYMENT INSTRUCTIONS, '
    +'DATOS BANCARIOS o INSTRUCCIONES BANCARIAS. A veces viene resaltada en amarillo o en un recuadro aparte. '
    +'Revisa TODAS las paginas, incluida la ultima, antes de responder.\n'
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues, con estas claves exactas:\n'
    +'{"beneficiary_customer":"","beneficiary_bank":"","swift_code":"","account_number":"","beneficiary_address":"","bank_address":"","deposito_pct":0,"terminos_pago":""}\n'
    +'REGLAS:\n'
    +'- "beneficiary_customer": el nombre de la empresa beneficiaria (BENEFICIARY / ACCOUNT NAME / NAME).\n'
    +'- "beneficiary_bank": el nombre del banco (BANK NAME / ADVISING BANK).\n'
    +'- "swift_code": el codigo SWIFT o BIC, tal cual, sin espacios.\n'
    +'- "account_number": el numero de cuenta o IBAN (A/C, ACCOUNT NO., ACCOUNT NUMBER).\n'
    +'- "beneficiary_address": la direccion de la empresa beneficiaria (BENEFICIARY ADDRESS).\n'
    +'- "bank_address": la direccion del banco (BANK ADDRESS / BANK ADD).\n'
    +'- Copia los valores EXACTAMENTE como aparecen. No los traduzcas ni los reformatees.\n'
    +'- "deposito_pct": el PORCENTAJE DE ANTICIPO que pide el proveedor, como numero sin el simbolo %. '
    +'Buscalo en los terminos de pago (PAYMENT TERMS, TERMS OF PAYMENT, CONDICIONES DE PAGO). '
    +'Ejemplos: "30% deposit, 70% balance" -> 30. "20% T/T in advance" -> 20. "50% down payment" -> 50. '
    +'"100% T/T before shipment" -> 100. Si no encontras ningun porcentaje, deja 0.\n'
    +'- "terminos_pago": la frase completa de los terminos, tal cual aparece.\n'
    +'- Si un dato NO aparece en el documento, deja esa clave como cadena vacia "". Nunca lo inventes.';

  for(var i=0;i<rutas.length;i++){
    try{
      var url=DOCS_BASE + String(rutas[i]).split('/').map(encodeURIComponent).join('/');
      var r=await fetch(url);
      if(!r.ok) continue;
      var blob=await r.blob();
      if(blob.size>8*1024*1024) continue;
      // Cualquier formato, no solo PDF o imagen
      var prep=await _iaDesdeBlob(blob, String(rutas[i]).split('/').pop());
      if(!prep) continue;
      var contenido=prep.bloques.concat([{type:'text', text:prompt}]);
      var obj=await _iaJSON(contenido, 1500);
      if(obj && (obj.swift_code||obj.account_number||obj.beneficiary_bank||obj.beneficiary_customer)){
        console.info('[banco] datos encontrados en', rutas[i]);
        return obj;
      }
    }catch(e){ console.warn('leer banco:',e); }
  }
  console.warn('[banco] ninguno de los '+rutas.length+' documentos traía instrucciones bancarias');
  return null;
}

// Vuelve a escribir el bloque bancario en el cuerpo del correo
function _solPagoPonerBanco(b){
  var ta=document.getElementById('mail-cuerpo'); if(!ta) return;
  var txt=String(ta.value||'');
  var bloque=_solPagoBloqueBanco(b).replace(/^\n/,'');
  var re=/DATOS DE TRANSFERENCIA:[\s\S]*?(?=\n\s*\n|$)/;
  if(re.test(txt)) ta.value=txt.replace(re, bloque.trim());
  else {
    // Se inserta antes de la despedida
    var lineas=txt.split('\n');
    var j=lineas.findIndex(function(l){ return /^\s*(Adjunto|Saludos|Best regards)/i.test(l); });
    if(j<0) j=lineas.length;
    lineas.splice(j,0,bloque.trim(),'');
    ta.value=lineas.join('\n');
  }
  window._spBanco=b;
}

// Botón para releer las instrucciones bancarias
async function _solPagoReleerBanco(){
  var ctx=window._solPagoCtx; if(!ctx) return;
  var av=document.getElementById('sp-banco');
  if(av) av.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo las instrucciones bancarias con AI…</span>';
  _spCargando('Leyendo las instrucciones bancarias con AI…','Puede tardar unos segundos');
  try{
    var b=await _solPagoLeerBanco(ctx.oid);
    _solPagoPonerBanco(b||{});
    _solPagoAvisoBanco(b);
  }catch(e){ _solPagoAvisoBanco(null); }
  _spCargandoFin();
}

// Escribe el % de anticipo que leyó la AI. Se puede editar a mano.
function _solPagoAplicarPct(b){
  var pc=Number(b&&b.deposito_pct)||0;
  var inp=document.getElementById('sp-pct');
  if(!inp || pc<=0 || pc>100) return;
  // No se pisa lo que la persona ya escribió
  var actual=parseFloat(inp.value);
  if(!isNaN(actual) && actual>0) return;
  inp.value=pc;
  _solPagoCalcMonto();
  var nota=document.getElementById('sp-calc');
  if(nota){
    nota.innerHTML+=' <span style="color:var(--t-lila);font-weight:600">\u00b7 '+pc+'% leído del documento'
      +(b.terminos_pago?(' ('+_esc(String(b.terminos_pago).slice(0,60))+')'):'')+'</span>';
  }
}

function _solPagoAvisoBanco(b){
  var av=document.getElementById('sp-banco'); if(!av) return;
  var faltan=_SP_CAMPOS.filter(function(c){ return !String((b&&b[c.k])||'').trim(); });
  if(!b){
    av.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No se pudieron leer las instrucciones bancarias. '
      +'En el correo quedan como <b>'+_SP_FALTA+'</b>. '
      +'<span onclick="_solPagoReleerBanco()" style="text-decoration:underline;cursor:pointer">Reintentar</span></span>';
    return;
  }
  if(!faltan.length){
    av.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Datos de transferencia leídos del documento del proveedor.</span>';
  } else {
    av.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Faltan '+faltan.length+' dato(s) bancario(s): <b>'
      +faltan.map(function(c){return c.l;}).join(', ')+'</b>. Quedan marcados como '+_SP_FALTA+' en el correo. '
      +'<span onclick="_solPagoReleerBanco()" style="text-decoration:underline;cursor:pointer">Reintentar</span></span>';
  }
}

// La compradora adjunta la debida diligencia
function _solPagoDD(input){
  var f=input.files&&input.files[0]; if(!f) return;
  _solPagoAdjuntarFile(f, 'dd');
}
async function _solPagoAdjuntarFile(f, marca){
  var kb=Math.round(f.size/1024);
  var b64=await new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
    fr.onerror=rej; fr.readAsDataURL(f);
  });
  window._mailAdj=window._mailAdj||[];
  // Si ya había una debida diligencia, se reemplaza
  if(marca==='dd') window._mailAdj=window._mailAdj.filter(function(a){ return a._marca!=='dd'; });
  window._mailAdj.push({nombre:f.name, mime:f.type||'application/octet-stream', contenido:b64, kb:kb, _marca:marca});
  mailPintarAdjuntos();
  var lbl=document.getElementById('sp-dd-lbl');
  if(lbl && marca==='dd'){
    lbl.innerHTML='<i class="ti ti-circle-check" style="color:var(--text-success)"></i> '+_esc(f.name);
  }
}

// ═══════════════════════════════════════════════════════════════════════════
//  COMPROBANTE DE PAGO — de contabilidad a compras
//  Contabilidad procesa el depósito o la cancelación y le manda el comprobante
//  a las compradoras que lo pidieron. Al enviarlo, el paso queda en verde y
//  compras solo puede consultar: ver los adjuntos, leer el correo y chatear.
// ═══════════════════════════════════════════════════════════════════════════

// Quién pidió el abono/cancelación de esta orden. Si no hay solicitud
// registrada, se cae al equipo de compras del departamento de la orden.
// Índice de un paso de Depósito por su nombre. Antes estaban escritos a mano
// (0, 1, 2) y al insertar pasos nuevos quedaban corridos.
function _pasoIdxDeposito(nombre){
  var st=STAGES.find(function(z){ return z.key==='deposito'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
var _PASO_SOL_ABONO   = 'Solicitud de depósito enviada';
var _PASO_DEP_PROV    = 'Depósito enviado al proveedor';
var _PASO_COMP_PROV   = 'Comprobante enviado al proveedor';
var _PASO_PAGO_FINAL  = 'Solicitud de final del balance';
var _PASO_COMP_FINAL  = 'Comprobante de pago final';
function _subKeyDeposito(nombre){
  var i=_pasoIdxDeposito(nombre);
  return i<0 ? '' : ('deposito_step'+i);
}

function _compDestinatarios(oid, tipo){
  var sols=(window._solPago||[]).filter(function(x){
    return String(x.docnum)===String(oid) && (!tipo || x.tipo===tipo);
  });
  var nombres={}, dept='';
  sols.forEach(function(x){
    if(x.solicitado_por) nombres[String(x.solicitado_por).toLowerCase()]=1;
    if(x.dept && !dept) dept=x.dept;
  });
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(z){return String(z.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
    if(!dept){
      var p=(window._pendSAP||[]).find(function(z){ return String(z.dkc)===String(oid)||String(z.num_orden)===String(oid); });
      if(p) dept=p.dept||'';
    }
  }
  var out=[];
  (USERS||[]).forEach(function(u){
    if(u.role!=='compras' || !u.email) return;
    var pidio = nombres[String(u.name||'').toLowerCase()];
    var mismoDept = dept && String(u.dept||'')===String(dept);
    if(pidio || mismoDept) out.push({u:u, pidio:!!pidio});
  });
  // Los que pidieron van primero y marcados
  out.sort(function(a,b){ return (b.pidio?1:0)-(a.pidio?1:0); });
  return {lista:out, dept:dept, solicitudes:sols};
}

// Monto ya solicitado, para escribirlo en el correo
function _compMonto(oid, tipo){
  var sols=(window._solPago||[]).filter(function(x){ return String(x.docnum)===String(oid) && x.tipo===tipo; });
  if(sols.length) return Number(sols[0].monto)||0;
  var d=_solPagoDatosOrden(oid);
  return (tipo==='abono') ? (Number(d.abonado)||0) : (Number(d.saldo)||0);
}

// ═══════════════════════════════════════════════════════════════════════════
//  COMPROBANTE AL PROVEEDOR — lo manda compras
//  Contabilidad deja el comprobante en su paso; compras lo reenvía al
//  proveedor desde el paso siguiente, con el correo que tenga en SAP.
// ═══════════════════════════════════════════════════════════════════════════

// Correo del proveedor según SAP, buscando por la orden y por el nombre
// ── HUB de diseño: tres bloques de documentos ──
// 1) la orden de KCC firmada, que llega sola desde la etapa de firma
// 2) el Excel de la orden, que se sube a mano
// 3) los archivos de arte que manda el proveedor
// ═══════════════════════════════════════════════════════════════════════════
//  ARTES → GERENCIA
//  Diseño manda los artes terminados a la gerencia que elija. Los archivos del
//  paso viajan solos, el paso queda en verde y a gerencia le llega una alerta
//  que la lleva directo a revisar.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_ARTES_FIN   = 'Artes terminados';
var _PASO_ARTES_APROB = 'Artes aprobados por gerencia';

function _pasoIdxArtes(nombre){
  var st=STAGES.find(function(z){ return z.key==='artes'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
function _subKeyArtes(nombre){
  var i=_pasoIdxArtes(nombre);
  return i<0 ? '' : ('artes_step'+i);
}

// Archivos que hay en un paso de artes
function _artesArchivos(oid, nombrePaso){
  var sk=_subKeyArtes(nombrePaso);
  if(!sk) return [];
  var a=(window._atts&&window._atts[oid+sk])?window._atts[oid+sk]:[];
  return _dedupDocs(a);
}

// ── Botón: enviar artes a gerencia ──
function _artesBotonEnviar(oid){
  var files=_artesArchivos(oid, _PASO_ARTES_FIN);
  var env=_solEnvioLeer(oid,'artes_gerencia');
  var h='<div style="background:#F7F5FF;border:1px solid #C4B5FD;border-radius:9px;padding:10px 12px;margin-bottom:10px">';
  if(env){
    h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-verde);margin-bottom:4px"><i class="ti ti-circle-check"></i> Artes enviados a gerencia</div>'
      +'<div style="font-size:11px;color:var(--t-verde)">'
        +(env.por?('Enviado por <b>'+_esc(env.por)+'</b>'):'')
        +(env.fecha?(' · '+_esc(_fechaHora(env.fecha))):'')
        +(env.para&&env.para.length?('<br>Para revisar: '+_esc(env.para.join(', '))):'')
        +(env.copia&&env.copia.length?('<br>Copia a compras: '+_esc(env.copia.join(', '))):'')
        +(env.adjuntos&&env.adjuntos.length?('<br>'+env.adjuntos.length+' archivo(s): '+_esc(env.adjuntos.map(function(a){return a.nombre;}).join(', '))):'')
      +'</div>';
  }
  if(CU && (CU.role==='diseno'||CU.role==='gerencia')){
    h+='<div style="font-size:11.5px;font-weight:600;color:var(--t-lila);margin:'+(env?'8px 0 5px':'0 0 5px')+'">'
      +'<i class="ti ti-send"></i> '+(env?'Volver a enviar los artes':'Enviar los artes a gerencia para revisar')+'</div>'
      +'<div style="font-size:10.5px;color:var(--t-lila);margin-bottom:7px">'+files.length+' archivo(s) en este paso se enviarán con la solicitud.</div>'
      +'<button class="btn bp" style="background:#5B21B6;font-size:11px;padding:6px 12px" onclick="_artesEnviarModal(\'' + oid + '\')">'
      +'<i class="ti ti-send"></i> Enviar artes a gerencia</button>';
  }
  return h+'</div>';
}

function _artesEnviarModal(oid){
  var files=_artesArchivos(oid, _PASO_ARTES_FIN);
  var d=_solPagoDatosOrden(oid);
  var gers=(USERS||[]).filter(function(u){ return u.role==='gerencia'; });
  if(!gers.length){ showT('No hay usuarios de gerencia cargados'); return; }

  // Compradores: primero los del departamento de la orden, que son quienes
  // llevan esta compra y tienen que enterarse del envío.
  var dept=d.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  var compDept=(USERS||[]).filter(function(u){ return u.role==='compras' && dept && String(u.dept||'')===String(dept); });
  var compOtros=(USERS||[]).filter(function(u){ return u.role==='compras' && compDept.indexOf(u)<0; });

  function chip(u, marcado, etiqueta){
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#5B21B6':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#F7F5FF':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.id)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(u.color||'#eee')+';color:'+(u.tc||'#333')
      +';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700">'
      +_esc(String(u.name||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join(''))+'</span>'
      +'<span>'+_esc(u.name)+'</span>'
      +(etiqueta?('<span style="font-size:9px;color:var(--t-lila);font-weight:700">'+etiqueta+'</span>'):'')
      +'</label>';
  }
  var chips=gers.map(function(u){ return chip(u,false,''); }).join('');
  var chipsComp=compDept.map(function(u){ return chip(u,true,'lleva la orden'); }).join('')
              + compOtros.map(function(u){ return chip(u,false,''); }).join('');

  var prev=document.getElementById('modalArtes'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalArtes';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:center;justify-content:center;padding:20px';
  var h='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:520px;max-height:90vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-lila)"><i class="ti ti-palette"></i> Enviar artes a gerencia</div>'
      +'<button onclick="document.getElementById(\'modalArtes\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="background:#F7F5FF;border:1px solid #C4B5FD;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-lila)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> · orden '+_esc(d.dkc||oid)+'</div>';

  if(files.length){
    h+='<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">SE ENVÍAN ESTOS ARCHIVOS</div>'
      +'<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:8px 10px;margin-bottom:12px">';
    files.forEach(function(a){
      h+='<div style="font-size:11.5px;padding:2px 0"><i class="ti ti-file" style="color:var(--t-lila)"></i> '+_esc(a.name||'')+'</div>';
    });
    h+='</div>';
  } else {
    h+='<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
      +'<i class="ti ti-alert-circle"></i> No hay archivos en "Artes terminados". Puedes enviarlo igual, pero gerencia no verá los artes.</div>';
  }

  h+='<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">GERENCIA — quién revisa los artes</div>'
    +'<div id="artes-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'+chips+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">COMPRAS — a quién más le aviso'
      +(dept?(' <span style="color:var(--t-lila)">· '+_esc(dL(dept))+' viene marcado</span>'):'')+'</div>'
    +'<div id="artes-comp" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'
      +(chipsComp||'<span style="font-size:11.5px;color:var(--text-muted)">No hay compradores cargados.</span>')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">NOTA (opcional)</div>'
    +'<textarea id="artes-nota" rows="3" placeholder="Algo que gerencia deba tener en cuenta…" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical"></textarea>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="document.getElementById(\'modalArtes\').remove()">Cancelar</button>'
      +'<button class="btn bp" id="artes-btn" style="background:#5B21B6" onclick="_artesEnviarConfirmar(\'' + oid + '\')"><i class="ti ti-send"></i> Enviar a gerencia</button>'
    +'</div></div>';
  ov.innerHTML=h;
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
}

async function _artesEnviarConfirmar(oid){
  var box=document.getElementById('artes-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ showT('Elige al menos una persona de gerencia'); return; }
  var boxC=document.getElementById('artes-comp');
  var marcadosC=boxC?Array.prototype.slice.call(boxC.querySelectorAll('input:checked')):[];

  var nombres=marcados.map(function(c){ return c.getAttribute('data-nom'); });
  var nombresC=marcadosC.map(function(c){ return c.getAttribute('data-nom'); });
  var files=_artesArchivos(oid, _PASO_ARTES_FIN);
  var nota=(document.getElementById('artes-nota')||{}).value||'';

  if(!confirm('¿Está seguro de enviar los artes a gerencia?\n\n'
    +'Para revisar: '+nombres.join(', ')+'\n'
    +(nombresC.length?('Con copia a compras: '+nombresC.join(', ')+'\n'):'')
    +files.length+' archivo(s)\n\n'
    +'El paso "Artes terminados" quedará completado y pasará a revisión.')) return;

  var btn=document.getElementById('artes-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  // Los archivos se copian al paso de revisión, apuntando al mismo archivo
  var skDestino=_subKeyArtes(_PASO_ARTES_APROB);
  try{
    if(skDestino && files.length){
      if(!window._atts) window._atts={};
      var k=oid+skDestino;
      if(!window._atts[k]) window._atts[k]=[];
      files.forEach(function(a){
        if(!window._atts[k].some(function(z){ return _docClave(z)===_docClave(a); })){
          window._atts[k].push(Object.assign({}, a));
        }
      });
    }
  }catch(e){ console.warn('copiar artes:',e); }

  // El paso "Artes terminados" queda completado
  try{
    var st=STAGES.find(function(z){ return z.key==='artes'; });
    var pasoIdx=_pasoIdxArtes(_PASO_ARTES_FIN);
    initP(oid);
    var sp=stageProgress[oid].artes;
    if(pasoIdx>=0 && (sp.stepIdx||0)<=pasoIdx){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pasoIdx+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pasoIdx]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pasoIdx]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pasoIdx]=hoyIso;
      if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
      guardarEtapa(oid,'artes');
    }
  }catch(e){ console.warn('marcar artes:',e); }

  // Alerta para la gerencia que tiene que revisar
  var texto='Tienes artes pendientes de confirmar'+(nota?(' — '+nota):'');
  var destinos=marcados.map(function(c){
    return (USERS||[]).find(function(u){ return u.id===c.value; });
  }).filter(Boolean);
  try{
    await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Artes', texto:texto,
      etiqueta:'Artes — pendientes de confirmar',
      paso:_PASO_ARTES_APROB
    });
  }catch(e){ console.warn('alerta artes:',e); }

  // Aviso a compras: es informativo, no les toca aprobar nada
  var destC=marcadosC.map(function(c){
    return (USERS||[]).find(function(u){ return u.id===c.value; });
  }).filter(Boolean).filter(function(u){ return !destinos.some(function(g){ return g.id===u.id; }); });
  if(destC.length){
    try{
      await _menNotificar(destC, {
        docnum:oid, contexto:'etapa', etapa:'Artes',
        texto:'Los artes se enviaron a gerencia para revisar ('+nombres.join(', ')+')'+(nota?(' — '+nota):''),
        etiqueta:'Artes — enviados a revisión',
        paso:_PASO_ARTES_APROB
      });
    }catch(e){ console.warn('alerta compras:',e); }
  }

  var info={ fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:nombres, copia:nombresC,
             nota:nota, adjuntos:files.map(function(a){ return {nombre:a.name}; }) };
  _solEnvioGuardar(oid, 'artes_gerencia', info);

  var m=document.getElementById('modalArtes'); if(m) m.remove();
  showT('✓ Artes enviados a '+nombres.join(', ')+(nombresC.length?(' · copia a '+nombresC.join(', ')):''));
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  REVISIÓN DE ARTES POR GERENCIA
//  Gerencia revisa con AI o a mano, y notifica los errores a quien elija.
// ═══════════════════════════════════════════════════════════════════════════
function _artesRevisionPanel(oid){
  var rev=_solEnvioLeer(oid,'artes_revision');
  var h='<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;padding:10px 12px;margin-bottom:10px">';
  h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);margin-bottom:6px"><i class="ti ti-eye-check"></i> Revisión de los artes</div>';

  if(rev && rev.observaciones){
    h+='<div style="background:var(--surface-0);border-radius:8px;padding:8px 10px;margin-bottom:8px">'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:3px">'
        +'Última revisión de <b>'+_esc(rev.por||'')+'</b> · '+_esc(_fechaHora(rev.fecha))
        +(rev.para&&rev.para.length?(' · avisado a '+_esc(rev.para.join(', '))):'')+'</div>'
      +'<div style="font-size:12px;white-space:pre-wrap">'+_esc(rev.observaciones)+'</div></div>';
  }

  if(CU && CU.role==='gerencia'){
    h+='<div style="display:flex;gap:6px;flex-wrap:wrap">'
      +'<button class="btn bp" style="background:#5B21B6;font-size:11px;padding:6px 12px" onclick="_artesRevisarIA(\'' + oid + '\')">'
        +'<i class="ti ti-sparkles"></i> Revisar con AI</button>'
      +'<button class="btn bp" style="background:#B45309;font-size:11px;padding:6px 12px" onclick="_artesNotificarModal(\'' + oid + '\')">'
        +'<i class="ti ti-message-report"></i> Notificar errores / comentarios</button>'
      +'</div>';
    h+='<div id="artes-ia-'+oid+'" style="margin-top:8px"></div>';
  } else if(rev && rev.observaciones){
    h+='<div style="font-size:10.5px;color:var(--t-marron)">Estas observaciones las escribió gerencia.</div>';
  }
  return h+'</div>';
}

// Revisión con AI de los artes adjuntos
async function _artesRevisarIA(oid){
  var files=_artesArchivos(oid, _PASO_ARTES_APROB);
  if(!files.length) files=_artesArchivos(oid, _PASO_ARTES_FIN);
  var cont=document.getElementById('artes-ia-'+oid);
  if(!files.length){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No hay artes adjuntos para revisar.</div>';
    return;
  }
  if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Revisando los artes con AI…</span>';

  var d=_solPagoDatosOrden(oid);
  // Cualquier formato: PDF, imagen, Excel, Word o texto
  var contenido=[], puestos=0, notas=[];
  for(var i=0;i<files.length && puestos<5;i++){
    if(!files[i].url) continue;
    var prep=await _iaDesdeStorage(files[i].url, files[i].name||('arte_'+(i+1)), 7);
    if(!prep) { notas.push((files[i].name||'archivo')+': no se pudo abrir'); continue; }
    contenido.push({type:'text', text:'ARCHIVO: '+(files[i].name||'')});
    prep.bloques.forEach(function(b){ contenido.push(b); });
    if(prep.nota) notas.push(prep.nota);
    puestos++;
  }
  if(!puestos){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">No se pudo leer ninguno de los archivos.'
      +(notas.length?('<br>'+_esc(notas.join(' · '))):'')+'</div>';
    return;
  }
  window._artesNotas=notas;

  contenido.push({type:'text', text:
     'Sos el revisor de artes de KENNEDY CENTER CORP. Revisa el arte adjunto de este producto:\n'
    +'Proveedor: '+(d.proveedor||'')+'\nOrden: '+(d.dkc||oid)+'\n\n'
    +'QUE REVISAR:\n'
    +'- Ortografia y gramatica en TODOS los textos, en español y en ingles.\n'
    +'- Que el nombre del producto y la descripcion sean coherentes entre si.\n'
    +'- Codigo de barras: que este presente y legible.\n'
    +'- Datos obligatorios: pais de origen, contenido, medidas, marca.\n'
    +'- Que la marca y el logo esten bien escritos.\n'
    +'- Textos cortados, superpuestos o ilegibles.\n'
    +'- Cualquier dato que se contradiga entre partes del arte.\n\n'
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\n'
    +'{"observaciones":[{"gravedad":"alta","punto":"","detalle":""}],"resumen":"","todo_bien":true}\n'
    +'REGLAS:\n'
    +'- "gravedad": "alta" si es un error que no puede salir a produccion (ortografia visible, dato equivocado, codigo de barras ilegible); "media" si conviene corregirlo; "baja" si es una sugerencia.\n'
    +'- "punto": donde esta, en pocas palabras.\n'
    +'- "detalle": que esta mal y como deberia decir.\n'
    +'- "todo_bien": true solo si no hay observaciones de gravedad alta ni media.\n'
    +'- Si no podes leer bien el arte, decilo en "resumen" en vez de inventar.'});

  try{
    var obj=await _iaJSON(contenido, 3000);
    var obs=(obj && Array.isArray(obj.observaciones))?obj.observaciones:[];
    window._artesIA=window._artesIA||{};
    window._artesIA[oid]=obj;
    if(!cont) return;
    var avisoArch=(window._artesNotas&&window._artesNotas.length)
      ? ('<div style="background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:7px 10px;font-size:11px;color:var(--t-marron);margin-bottom:7px">'
         +'<i class="ti ti-alert-circle"></i> '+_esc(window._artesNotas.join(' · '))+'</div>')
      : '';
    if(!obs.length){
      cont.innerHTML=avisoArch+'<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde)">'
        +'<i class="ti ti-circle-check"></i> La AI no encontró problemas.'
        +(obj&&obj.resumen?('<div style="margin-top:3px">'+_esc(obj.resumen)+'</div>'):'')+'</div>';
      return;
    }
    var h=avisoArch+'<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden">'
      +'<div style="background:var(--pastel-error);padding:8px 11px;font-size:11.5px;font-weight:700;color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> '+obs.length+' observación(es) de la AI</div>';
    obs.forEach(function(o){
      var g=String(o.gravedad||'media').toLowerCase();
      var c=g==='alta'?'#dc2626':(g==='baja'?'#6b7280':'#B45309');
      h+='<div style="padding:7px 11px;border-top:0.5px solid var(--border);background:var(--surface-0)">'
        +'<span style="font-size:9px;font-weight:800;color:#fff;background:'+c+';border-radius:6px;padding:1px 6px;text-transform:uppercase">'+_esc(g)+'</span> '
        +(o.punto?('<b style="font-size:11.5px">'+_esc(o.punto)+'</b>'):'')
        +'<div style="font-size:11.5px;color:var(--text-secondary);margin-top:2px">'+_esc(o.detalle||'')+'</div></div>';
    });
    h+='<div style="padding:8px 11px;border-top:0.5px solid var(--border);background:var(--surface-1)">'
      +'<button class="btn bp" style="background:#B45309;font-size:11px;padding:5px 11px" onclick="_artesNotificarModal(\'' + oid + '\',true)">'
      +'<i class="ti ti-send"></i> Notificar estas observaciones</button></div></div>';
    cont.innerHTML=h;
  }catch(e){
    console.error('revisar artes:',e);
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">No se pudo revisar: '+_esc(e.message||String(e))+'</div>';
  }
}

// Modal para notificar los errores a quien elija gerencia
function _artesNotificarModal(oid, conIA){
  var texto='';
  if(conIA && window._artesIA && window._artesIA[oid]){
    var obs=window._artesIA[oid].observaciones||[];
    texto=obs.map(function(o){
      return '• ['+String(o.gravedad||'media').toUpperCase()+'] '+(o.punto?(o.punto+': '):'')+(o.detalle||'');
    }).join('\n');
  }
  var cand=(USERS||[]).filter(function(u){
    return u.id!==((CU&&CU.id)||'') && ['diseno','compras','gerencia'].indexOf(u.role)>=0;
  });
  var chips=cand.map(function(u){
    var marcado=(u.role==='diseno');   // por defecto, a diseño
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#5B21B6':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#F7F5FF':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.id)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)+'</span></label>';
  }).join('');

  var prev=document.getElementById('modalArtesNot'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalArtesNot';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;display:flex;align-items:center;justify-content:center;padding:20px';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:520px;max-height:90vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-ambar)"><i class="ti ti-message-report"></i> Notificar observaciones</div>'
      +'<button onclick="document.getElementById(\'modalArtesNot\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">OBSERVACIONES</div>'
    +'<textarea id="artesnot-txt" rows="8" placeholder="Escribe lo que hay que corregir…" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(texto)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">¿A QUIÉN LE AVISO?</div>'
    +'<div id="artesnot-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'+chips+'</div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="document.getElementById(\'modalArtesNot\').remove()">Cancelar</button>'
      +'<button class="btn bp" id="artesnot-btn" style="background:#B45309" onclick="_artesNotificarEnviar(\'' + oid + '\')"><i class="ti ti-send"></i> Enviar observaciones</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
}

async function _artesNotificarEnviar(oid){
  var txt=(document.getElementById('artesnot-txt')||{}).value||'';
  if(!txt.trim()){ showT('Escribe las observaciones'); return; }
  var box=document.getElementById('artesnot-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ showT('Elige a quién avisarle'); return; }

  var btn=document.getElementById('artesnot-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var nombres=marcados.map(function(c){ return c.getAttribute('data-nom'); });
  var destinos=marcados.map(function(c){
    return (USERS||[]).find(function(u){ return u.id===c.value; });
  }).filter(Boolean);

  // Queda como comentario del paso, para que el hilo no se pierda
  try{
    var sk=_subKeyArtes(_PASO_ARTES_APROB);
    var comKey='sub_'+oid+'_'+sk;
    if(!window._subComs) window._subComs={};
    if(!window._subComs[comKey]) window._subComs[comKey]=[];
    window._subComs[comKey].push({autor:(CU&&CU.name)+' ('+(CU&&CU.role)+')', ini:(CU&&CU.ini)||'--',
                                  texto:txt, time:now2(), role:(CU&&CU.role)||'', by:(CU&&CU.name)||''});
    guardarComentario(oid, sk, txt);
  }catch(e){ console.warn('comentario artes:',e); }

  try{
    await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Artes', texto:txt,
      etiqueta:'Artes — observaciones de gerencia',
      paso:_PASO_ARTES_APROB
    });
  }catch(e){ console.warn('notificar artes:',e); }

  _solEnvioGuardar(oid, 'artes_revision', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:nombres, observaciones:txt
  });

  var m=document.getElementById('modalArtesNot'); if(m) m.remove();
  showT('✓ Observaciones enviadas a '+nombres.join(', '));
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  ARTES AL PROVEEDOR
//  Compras manda al proveedor los artes que aprobó gerencia, más los enlaces
//  de descarga que se hayan cargado en el HUB.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_ARTES_PROV = 'Artes enviados al proveedor';

function _artesPanelProveedor(oid){
  var aprob=_artesArchivos(oid, _PASO_ARTES_APROB);
  if(!aprob.length) aprob=_artesArchivos(oid, _PASO_ARTES_FIN);
  var env=_solEnvioLeer(oid,'artes_proveedor');
  var h='<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:10px 12px;margin-bottom:10px">';
  if(env){
    h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-verde);margin-bottom:4px"><i class="ti ti-circle-check"></i> Artes enviados al proveedor</div>'
      +'<div style="font-size:11px;color:var(--t-verde)">'
        +(env.por?('Enviado por <b>'+_esc(env.por)+'</b>'):'')
        +(env.fecha?(' \u00b7 '+_esc(_fechaHora(env.fecha))):'')
        +(env.para&&env.para.length?('<br>Para: '+_esc(env.para.join(', '))):'')
        +(env.adjuntos&&env.adjuntos.length?('<br>'+env.adjuntos.length+' archivo(s) adjunto(s)'):'')
      +'</div>';
    if(env.cuerpo){
      h+='<details style="margin-top:5px"><summary style="font-size:10.5px;color:var(--t-verde);cursor:pointer;font-weight:600">Ver el correo enviado</summary>'
        +'<div style="font-size:11px;color:var(--t-verde);white-space:pre-wrap;background:var(--surface-0);border-radius:7px;padding:8px 10px;margin-top:5px;max-height:240px;overflow-y:auto">'+_esc(env.cuerpo)+'</div></details>';
    }
  }
  if(CU && (CU.role==='compras'||CU.role==='gerencia')){
    h+='<div style="font-size:11.5px;font-weight:600;color:var(--t-azul);margin:'+(env?'8px 0 5px':'0 0 5px')+'">'
      +'<i class="ti ti-mail"></i> '+(env?'Volver a enviar los artes':'Enviar los artes al proveedor')+'</div>'
      +'<div style="font-size:10.5px;color:var(--t-azul);margin-bottom:7px">'+aprob.length+' arte(s) aprobado(s) se adjuntan solos.</div>'
      +'<button class="btn bp" style="font-size:11px;padding:6px 12px" onclick="_artesProvModal(\'' + oid + '\')">'
      +'<i class="ti ti-send"></i> Redactar correo al proveedor</button>';
  }
  return h+'</div>';
}

async function _artesProvModal(oid){
  var d=_solPagoDatosOrden(oid);
  var ordenTxt=d.dkc||String(oid);
  var provEmail=_provEmailDeOrden(oid);
  var aprob=_artesArchivos(oid, _PASO_ARTES_APROB);
  if(!aprob.length) aprob=_artesArchivos(oid, _PASO_ARTES_FIN);
  var links=[];
  try{ links=_hubLeerLinks(oid); }catch(e){}
  window._mailAdj=[];
  window._artesProvCtx={oid:oid, paso:_pasoIdxArtes(_PASO_ARTES_PROV)};

  var asunto=(d.proveedor||'')+' - '+ordenTxt;

  var cuerpo='Dear '+(d.proveedor||'Vendor')+',\n\n'
    +'Order Number: '+ordenTxt+'\n\n'
    +'Check attached the link and all artwork files for this order.\n\n'
    +'Please check all files carefully. If you have any questions or find any problem, please let us know before you start.\n\n'
    +'Kindly reply to this email to confirm that you received the link and all artwork files.\n\n'
    +'Very important: After you print the artwork, please send us clear photos of the packaging and production with the printed artwork. '
    +'We want to check that everything is correct and make sure there are no mistakes.\n\n'
    +'Thank you for your support. We look forward to your confirmation.\n\n'
    +'Best regards,\n\n'
    +_firmaNombre()+'\n'
    +'KENNEDY CENTER CORP.';

  // Los enlaces del HUB van dentro del cuerpo
  if(links.length){
    var bloque='\nDownload link'+(links.length>1?'s':'')+':\n'
      +links.map(function(l){ return l.url; }).join('\n')+'\n';
    cuerpo=cuerpo.replace('Please check all files carefully.', bloque+'\nPlease check all files carefully.');
  }

  var ccChips=(USERS||[]).filter(function(u){
    if(!u.email) return false;
    return String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){
    var marcado=(u.role==='diseno');
    return '<span class="sp-cc-chip'+(marcado?' on':'')+'" data-mail="'+_esc(u.email)+'" onclick="_artesProvCC(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti '+(marcado?'ti-check':'ti-plus')+'" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');
  var ccIni=(USERS||[]).filter(function(u){
    return u.email && u.role==='diseno' && String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){ return u.email; }).join(', ');

  var prev=document.getElementById('modalArtesProv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalArtesProv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:700px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)"><i class="ti ti-palette"></i> Enviar artes al proveedor</div>'
      +'<button onclick="_artesProvCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-azul)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> \u00b7 orden '+_esc(ordenTxt)+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">PARA — proveedor</div>'
    +'<input id="ap-para" value="'+_esc(provEmail)+'" placeholder="correo@proveedor.com" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:10px;margin:3px 0 12px">'
      +(provEmail?'<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Correo tomado de SAP. Puedes cambiarlo.</span>'
                 :'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Este proveedor no tiene correo en SAP: escríbelo a mano.</span>')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">CC</div>'
    +'<div id="ap-cc-chips" style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:5px">'+ccChips+'</div>'
    +'<input id="ap-cc" value="'+_esc(ccIni)+'" placeholder="otros@correo.com, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="ap-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="ap-cuerpo" rows="16" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ARTES APROBADOS</div>'
    +'<div id="ap-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando los artes…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_artesProvCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="ap-btn" onclick="_artesProvEnviar()"><i class="ti ti-send"></i> Enviar al proveedor</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // Los artes aprobados se adjuntan solos
  var aviso=document.getElementById('ap-auto');
  if(!aprob.length){
    if(aviso) aviso.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No hay artes aprobados adjuntos. Súbelos a mano o usa los enlaces del HUB.</span>';
    return;
  }
  var puestos=[], pesados=[];
  for(var i=0;i<aprob.length;i++){
    if(!aprob[i].url) continue;
    try{
      var adj=await _solPagoAdjuntarDeStorage(aprob[i].url, aprob[i].name||('arte_'+(i+1)));
      if(adj){ window._mailAdj.push(adj); puestos.push(aprob[i].name); }
      else pesados.push(aprob[i].name);
    }catch(e){ pesados.push(aprob[i].name); }
  }
  mailPintarAdjuntos();
  if(aviso){
    var h2='';
    if(puestos.length) h2+='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado: '+_esc(puestos.join(', '))+'</span>';
    if(pesados.length) h2+=(h2?'<br>':'')+'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No se pudieron adjuntar (muy pesados): '+_esc(pesados.join(', '))
      +'. Manda el enlace de descarga en el cuerpo.</span>';
    aviso.innerHTML=h2;
  }
}

function _artesProvCerrar(){
  var m=document.getElementById('modalArtesProv'); if(m) m.remove();
  window._mailAdj=[]; window._artesProvCtx=null;
}

function _artesProvCC(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i){ i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus'); i.style.fontSize='10px'; }
  var inp=document.getElementById('ap-cc'); if(!inp) return;
  var chips=Array.prototype.slice.call(document.querySelectorAll('#ap-cc-chips .sp-cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); }).map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}

async function _artesProvEnviar(){
  var ctx=window._artesProvCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid;
  var para=((document.getElementById('ap-para')||{}).value||'').split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var cc=((document.getElementById('ap-cc')||{}).value||'').split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var asunto=(document.getElementById('ap-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('ap-cuerpo')||{}).value||'';
  if(!para.length){ _mailMsg('Escribe el correo del proveedor.','err'); return; }
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }
  if(!(window._mailAdj||[]).length){
    if(!confirm('No hay artes adjuntos.\n\n¿Enviar el correo igual? (asegúrate de que el enlace de descarga esté en el mensaje)')) return;
  }
  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB. Manda el enlace de descarga en el cuerpo.','err');
    return;
  }
  var btn=document.getElementById('ap-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var todos=para.concat(cc), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:para[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:_dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
                 .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Artes al proveedor \u00b7 '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      var t=await r.text(); console.error('artes proveedor:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
    return;
  }

  // El paso queda completado
  try{
    var st=STAGES.find(function(z){ return z.key==='artes'; });
    var pi=ctx.paso;
    initP(oid);
    var sp=stageProgress[oid].artes;
    if(pi>=0 && (sp.stepIdx||0)<=pi){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pi]=hoyIso;
      guardarEtapa(oid,'artes');
    }
  }catch(e){ console.warn('marcar artes proveedor:',e); }

  _solEnvioGuardar(oid, 'artes_proveedor', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo,
    adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, kb:a.kb||0}; })
  });

  _artesProvCerrar();
  showT('✓ Artes enviados al proveedor');
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  ARCHIVOS PARA LA IA
//  Un solo lugar que convierte cualquier archivo al formato que entiende la
//  AI. Antes cada pantalla lo resolvía a su manera y varias trataban todo lo
//  que no fuera PDF como si fuera una imagen, así que un Excel o un AI se
//  mandaban rotos.
// ═══════════════════════════════════════════════════════════════════════════
var _IA_IMG  = ['jpg','jpeg','png','gif','webp','bmp'];
var _IA_XLS  = ['xlsx','xls','csv','tsv'];
var _IA_TXT  = ['txt','md','json','xml','html','htm','csv','log'];
// Formatos que la AI no lee directo, pero se pueden describir
var _IA_OTRO = ['ai','psd','psb','eps','indd','idml','cdr','sketch','fig','zip','rar','7z','dwg','tiff','tif'];

function _iaExt(nombre){
  return String(nombre||'').split('?')[0].split('.').pop().toLowerCase();
}

// Convierte un Blob al bloque que entiende la AI.
// Devuelve {bloques:[…], nota:'' } o null si no se puede leer.
// ¿Esto es texto de verdad o son bytes de un binario? Se mira una muestra:
// si hay bytes nulos, muchos caracteres de reemplazo, o menos del 85% de
// caracteres legibles, es binario y no se le manda a la IA.
function _iaPareceTexto(t){
  var m=String(t||'').slice(0, 3000);
  if(!m) return false;
  if(m.indexOf('\u0000')>=0) return false;              // byte nulo: binario
  var repl=(m.match(/\uFFFD/g)||[]).length;
  if(repl > m.length*0.02) return false;                // demasiada basura
  var buenos=(m.match(/[\x09\x0A\x0D\x20-\x7E\u00A0-\u024F\u20AC]/g)||[]).length;
  return (buenos / m.length) >= 0.85;
}

async function _iaDesdeBlob(blob, nombre){
  var ext=_iaExt(nombre);
  var mime=(blob.type||'').toLowerCase();

  // Formatos de diseño y comprimidos primero: algunos declaran un mime de
  // imagen (el .psd dice image/vnd.adobe.photoshop) pero la AI no los abre.
  if(_IA_OTRO.indexOf(ext)>=0){
    return {bloques:[{type:'text', text:'ARCHIVO ADJUNTO: '+nombre+' (formato .'+ext+'). '
      +'No se puede leer su contenido: tenelo en cuenta al revisar y pedí una versión en PDF o imagen si hace falta.'}],
            nota:nombre+': formato .'+ext+' no legible, pedí PDF o imagen'};
  }
  // PDF
  if(ext==='pdf' || /pdf/.test(mime)){
    var b64=await _blobB64(blob);
    return {bloques:[{type:'document', source:{type:'base64', media_type:'application/pdf', data:b64}}]};
  }
  // Imágenes
  if(_IA_IMG.indexOf(ext)>=0 || /^image\//.test(mime)){
    var mt=mime && /^image\//.test(mime) ? mime
         : (ext==='png'?'image/png':ext==='gif'?'image/gif':ext==='webp'?'image/webp':'image/jpeg');
    var b64i=await _blobB64(blob);
    return {bloques:[{type:'image', source:{type:'base64', media_type:mt, data:b64i}}]};
  }
  // Excel y CSV: se leen las hojas como texto
  if(_IA_XLS.indexOf(ext)>=0){
    try{
      if(typeof XLSX==='undefined') throw new Error('sin lector de Excel');
      var buf=await blob.arrayBuffer();
      var wb=XLSX.read(buf,{type:'array'});
      var txt=_iaLibroTexto(wb, 60000);
      if(!txt.trim()) throw new Error('hoja vacía');
      return {bloques:[{type:'text', text:'CONTENIDO DE '+nombre+':\n'+txt}]};
    }catch(e){
      return {bloques:[{type:'text', text:'ARCHIVO '+nombre+': no se pudo leer el Excel ('+(e.message||e)+').'}],
              nota:nombre+': no se pudo leer'};
    }
  }
  // Texto plano
  if(_IA_TXT.indexOf(ext)>=0 || /^text\//.test(mime)){
    try{
      var t=await blob.text();
      return {bloques:[{type:'text', text:'CONTENIDO DE '+nombre+':\n'+String(t).slice(0,14000)}]};
    }catch(e){ return null; }
  }
  // Word: el navegador puede sacar el texto con mammoth
  if(ext==='docx'){
    try{
      if(typeof mammoth==='undefined') throw new Error('sin lector de Word');
      var ab=await blob.arrayBuffer();
      var res=await mammoth.extractRawText({arrayBuffer:ab});
      var tx=(res&&res.value)||'';
      if(!tx.trim()) throw new Error('documento vacío');
      return {bloques:[{type:'text', text:'CONTENIDO DE '+nombre+':\n'+tx.slice(0,14000)}]};
    }catch(e){
      return {bloques:[{type:'text', text:'ARCHIVO '+nombre+': documento de Word que no se pudo leer.'}],
              nota:nombre+': no se pudo leer'};
    }
  }
  // Cualquier otro: se intenta como texto, pero SOLO si de verdad lo es.
  // Antes bastaba con encontrar un carácter legible entre los 200 primeros,
  // y casi cualquier binario tiene alguno: así se mandaban los bytes crudos
  // de un Excel o un ZIP a la IA, que respondía cualquier cosa y reventaba
  // al interpretarla ("Unexpected token '\uFFFD'").
  try{
    var t2=await blob.text();
    if(t2 && _iaPareceTexto(t2)){
      return {bloques:[{type:'text', text:'CONTENIDO DE '+nombre+':\n'+String(t2).slice(0,10000)}]};
    }
  }catch(e){}
  return {bloques:[{type:'text', text:'ARCHIVO ADJUNTO: '+nombre+' (no se pudo interpretar).'}],
          nota:nombre+': no se pudo interpretar'};
}

function _blobB64(blob){
  return new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
    fr.onerror=rej; fr.readAsDataURL(blob);
  });
}

// Baja un archivo del storage y lo prepara para la AI
async function _iaDesdeStorage(urlRel, nombre, topeMB){
  try{
    var url=DOCS_BASE + String(urlRel).split('/').map(encodeURIComponent).join('/');
    var r=await fetch(url);
    if(!r.ok) return null;
    var blob=await r.blob();
    if(blob.size > (topeMB||8)*1024*1024){
      return {bloques:[{type:'text', text:'ARCHIVO '+nombre+': pesa '
        +(blob.size/1048576).toFixed(1)+' MB y no se pudo enviar a revisar.'}],
              nota:nombre+': demasiado pesado'};
    }
    return await _iaDesdeBlob(blob, nombre);
  }catch(e){ console.warn('preparar para IA:',e); return null; }
}

// ═══════════════════════════════════════════════════════════════════════════
//  PRODUCCIÓN — INSPECCIÓN
//  La compradora sube fotos, documentos y enlaces de la inspección, y al
//  marcarla como revisada le avisa al encargado del departamento. El encargado
//  da el visto bueno y la etapa pasa a verde.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_INSPECCION = 'Producción terminada — Inspección de producción finalizada';
var _PASO_INSP_OK    = _PASO_INSPECCION;   // todo ocurre en el mismo paso

function _pasoIdxProd(nombre){
  var st=STAGES.find(function(z){ return z.key==='produccion'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
function _subKeyProd(nombre){
  var i=_pasoIdxProd(nombre);
  return i<0 ? '' : ('produccion_step'+i);
}

// ── Panel de la compradora ──
// Cuántas evidencias hay cargadas
function _inspCuantos(oid){
  var sk=_subKeyProd(_PASO_INSPECCION);
  var f=((window._atts&&window._atts[oid+sk+'_fotos'])||[]).length;
  var d=((window._atts&&window._atts[oid+sk+'_docs'])||[]).length;
  var l=_inspLeerLinks(oid).length;
  return {fotos:f, docs:d, links:l, total:f+d+l};
}

function _inspPanel(oid){
  var sk=_subKeyProd(_PASO_INSPECCION);
  var rev=_solEnvioLeer(oid,'inspeccion');
  var n=_inspCuantos(oid);
  var listo=!!rev;

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';

  // El semáforo del paso, siempre a la vista
  var col = listo ? ['#166534','#dcfce7','#16a34a','Revisada']
          : (n.total ? ['#B45309','#FEF3E8','#E9C08A','Pendiente de revisar']
                     : ['#991b1b','#FEF2F2','#dc2626','Sin evidencia cargada']);
  h+='<div style="display:flex;align-items:center;gap:8px;background:'+col[1]+';border:1px solid '+col[2]
    +';border-radius:8px;padding:8px 11px;margin-bottom:9px">'
    +'<span class="sem '+(listo?'sem-g':(n.total?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="flex:1;min-width:0">'
      +'<div style="font-size:12px;font-weight:700;color:'+col[0]+'">'+col[3]+'</div>'
      +'<div style="font-size:10.5px;color:'+col[0]+';opacity:.85">'
        +n.fotos+' foto(s) · '+n.docs+' documento(s) · '+n.links+' enlace(s)'
        +(listo?(' · revisada por '+_esc(rev.por||'')+' el '+_esc(_fechaHora(rev.fecha))):'')
      +'</div>'
    +'</div></div>';

  h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-marron);margin-bottom:8px">'
    +'<i class="ti ti-clipboard-check"></i> Inspección de la producción</div>';

  // Tres formas de cargar evidencia, igual que en el HUB de diseño
  h+=_inspZona(oid, sk+'_fotos', '1 · FOTOS DE LA INSPECCIÓN',
               'Fotos de los productos, empaque y etiquetado', '#B45309', 'ti-photo', 'image/*');
  h+=_inspZona(oid, sk+'_docs', '2 · DOCUMENTOS',
               'Reporte de inspección, certificados, packing list', '#0c447c', 'ti-file-text',
               '.pdf,.xlsx,.xls,.doc,.docx,.csv');
  h+=_inspLinks(oid);

  if(rev){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;margin-top:8px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> Inspección revisada</div>'
      +'<div style="font-size:11px;color:var(--t-verde);margin-top:2px">'
        +'Por <b>'+_esc(rev.por||'')+'</b> · '+_esc(_fechaHora(rev.fecha))
        +(rev.para&&rev.para.length?('<br>Avisado a: '+_esc(rev.para.join(', '))):'')
        +(rev.nota?('<br>'+_esc(rev.nota)):'')
      +'</div></div>';
  }

  // Compras y gerencia marcan la revisión desde aquí mismo
  if(CU && (CU.role==='compras'||CU.role==='gerencia')){
    h+='<div style="margin-top:9px;display:flex;gap:7px;flex-wrap:wrap">';
    if(!listo){
      h+='<button class="btn bp" style="background:'+(n.total?'#16a34a':'#9ca3af')+';font-size:12px;padding:8px 15px;font-weight:700"'
        +(n.total?'':' title="Primero cargá fotos, documentos o enlaces"')
        +' onclick="_inspRevisadoModal(\'' + oid + '\')">'
        +'<i class="ti ti-check"></i> Marcar inspección como revisada</button>';
    } else {
      h+='<button class="btn bg2" style="font-size:11.5px;padding:7px 13px" onclick="_inspRevisadoModal(\'' + oid + '\')">'
        +'<i class="ti ti-refresh"></i> Volver a marcar</button>'
        +'<button class="btn bg2" style="font-size:11.5px;padding:7px 13px;color:var(--t-ambar)" onclick="_inspReabrir(\'' + oid + '\')">'
        +'<i class="ti ti-arrow-back-up"></i> Reabrir para corregir</button>';
    }
    h+='</div>';
  }
  return h+'</div>';
}

// Vuelve a dejar el paso pendiente, para seguir cargando o corrigiendo
async function _inspReabrir(oid){
  if(!CU || (CU.role!=='compras' && CU.role!=='gerencia')) return;
  if(!confirm('¿Reabrir la inspección?\n\nEl paso vuelve a quedar pendiente y puedes seguir cargando o corrigiendo la evidencia.')) return;
  try{
    initP(oid);
    var pi=_pasoIdxProd(_PASO_INSPECCION);
    var sp=stageProgress[oid].produccion;
    if(pi>=0 && (sp.stepIdx||0)>pi){
      sp.stepIdx=pi;
      if(sp.stepDates) sp.stepDates[pi]='';
      guardarEtapa(oid,'produccion');
    }
  }catch(e){}
  _solEnvioGuardar(oid, 'inspeccion', null);
  showT('Inspección reabierta');
  _inspRepintar(oid);
}

// Zona de subida, con lista y borrado
function _inspZona(oid, sub, titulo, ayuda, color, icono, accept){
  var files=(window._atts&&window._atts[oid+sub])?_dedupDocs(window._atts[oid+sub]):[];
  var h='<div style="background:var(--surface-0);border:0.5px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:7px">'
    +'<div style="font-size:11px;font-weight:700;color:'+color+';margin-bottom:4px">'+titulo
    +' <span style="font-weight:400;color:var(--text-muted)">('+files.length+')</span></div>';
  if(files.length){
    // Las fotos se muestran como miniaturas
    var esFoto=/fotos$/.test(sub);
    if(esFoto){
      h+='<div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:4px">';
      files.forEach(function(a,i){
        h+='<div style="position:relative">'
          +'<img src="'+_esc(a.data||'')+'" onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')" '
          +'style="width:62px;height:62px;object-fit:cover;border-radius:6px;border:0.5px solid var(--border);cursor:zoom-in" title="'+_esc(a.name||'')+'">'
          +((CU&&CU.role!=='bodega')?('<span onclick="event.stopPropagation();_inspBorrar(\''+oid+'\',\''+sub+'\','+i+')" style="position:absolute;top:-5px;right:-5px;background:#e24b4a;color:#fff;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center;font-size:10px;cursor:pointer">×</span>'):'')
          +'</div>';
      });
      h+='</div>';
    } else {
      files.forEach(function(a,i){
        h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
          +'<i class="ti '+icono+'" style="color:'+color+'"></i>'
          +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
          +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px"'+_prevAttrs(a.data||a.url,a.name)+' onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button>'
          +((CU&&CU.role!=='bodega')?('<button class="btn bg2" style="padding:3px 7px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_inspBorrar(\''+oid+'\',\''+sub+'\','+i+')"><i class="ti ti-trash"></i></button>'):'')
          +'</div>';
      });
    }
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(ayuda)+'</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:6px;padding:6px 9px;border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+';margin-top:6px">'
    +'<i class="ti ti-upload"></i> Adjuntar'
    +'<input type="file" multiple'+(accept?(' accept="'+accept+'"'):'')+' style="display:none" onchange="_inspSubir(\''+oid+'\',\''+sub+'\',this.files)"></label>';
  return h+'</div>';
}

// Enlaces externos de la inspección
function _inspLinks(oid){
  var links=_inspLeerLinks(oid);
  var h='<div style="background:var(--surface-0);border:0.5px solid #E9C08A;border-radius:8px;padding:9px 11px;margin-bottom:7px">'
    +'<div style="font-size:11px;font-weight:700;color:var(--t-lila);margin-bottom:4px">3 · ENLACES DE DESCARGA '
    +'<span style="font-weight:400;color:var(--text-muted)">(WeTransfer, TransferNow…)</span></div>';
  if(links.length){
    links.forEach(function(l,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:4px 0;border-top:0.5px solid var(--border)">'
        +'<i class="ti ti-link" style="color:var(--t-lila)"></i>'
        +'<div style="flex:1;min-width:0">'
          +'<a href="'+_esc(l.url)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" style="color:var(--text-accent);text-decoration:underline;word-break:break-all">'+_esc(l.url)+'</a>'
          +'<div style="font-size:10px;color:var(--text-muted)">'+_esc(l.por||'')+(l.fecha?(' \u00b7 '+_esc(l.fecha)):'')+(l.nota?(' \u00b7 '+_esc(l.nota)):'')+'</div>'
        +'</div>'
        +'<button class="btn bg2" style="padding:3px 8px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_inspBorrarLink(\''+oid+'\','+i+')"><i class="ti ti-trash"></i></button>'
      +'</div>';
    });
  }
  h+=_inspDescargasPanel(oid);
  h+='<div style="display:flex;gap:5px;margin-top:6px">'
    +'<input id="insplink-'+oid+'" placeholder="Pegá el enlace de descarga" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:11px;background:var(--surface-0);color:var(--text-primary)" onclick="event.stopPropagation()">'
    +'<button class="btn bp" style="padding:6px 11px;font-size:11px" onclick="event.stopPropagation();_inspAgregarLink(\''+oid+'\')">Guardar</button>'
    +'</div>'
    +'<div style="font-size:10px;color:var(--text-muted);margin-top:4px">'
    +'El servidor descarga el contenido solo y lo deja aquí arriba.</div>';
  return h+'</div>';
}

function _inspDescargasPanel(oid){
  var ds=(window._hubDesc['insp_'+oid]||[]);
  if(!ds.length) return '';
  var col={pendiente:['#B45309','#FEF3E8','En cola'], procesando:['#5B21B6','#EDE9FE','Descargando…'],
           listo:['#166534','#dcfce7','Descargado'], error:['#991b1b','#FEF2F2','No se pudo']};
  var h='';
  ds.forEach(function(d){
    var c=col[d.estado]||col.pendiente;
    var arch=d.archivos;
    if(typeof arch==='string'){ try{ arch=JSON.parse(arch); }catch(e){ arch=null; } }
    h+='<div style="border-top:0.5px solid var(--border);padding:5px 0;font-size:10.5px">'
      +'<span style="background:'+c[1]+';color:'+c[0]+';border-radius:6px;padding:1px 7px;font-weight:700">'+c[2]+'</span> '
      +'<span style="color:var(--text-muted)">'+_esc(String(d.url||'').slice(0,46))+'…</span>'
      +(d.detalle?('<div style="color:'+c[0]+';margin-top:2px">'+_esc(d.detalle)+'</div>'):'')
      +(arch&&arch.length?('<div style="color:var(--text-success);margin-top:2px"><i class="ti ti-check"></i> '+_esc(arch.join(', '))+'</div>'):'')
      +(_esGerencia()?('<span onclick="event.stopPropagation();_inspBorrarLog(\''+oid+'\','+(d.id||0)+')" style="float:right;color:var(--text-danger);cursor:pointer;margin-top:-14px"><i class="ti ti-x"></i></span>'):'')
      +'</div>';
  });
  return h;
}

async function _inspSubir(oid, sub, files){
  if(!files||!files.length) return;
  showT('Subiendo '+files.length+' archivo(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sub, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sub, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
      window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir inspeccion:',e); }
  }
  showT('✓ Archivos adjuntados');
  _inspRepintar(oid);
}

async function _inspBorrar(oid, sub, i){
  var a=(window._atts&&window._atts[oid+sub])?window._atts[oid+sub][i]:null;
  if(!a) return;
  if(!confirm('¿Está seguro de que desea borrar "'+(a.name||'')+'"?\n\nEsta acción no se puede deshacer.')) return;
  await _borrarArchivoStorage(a.url, a.id);
  window._atts[oid+sub].splice(i,1);
  showT('Archivo eliminado');
  _inspRepintar(oid);
}

// Repinta solo el panel de inspección, sin cerrar la etapa
function _inspRepintar(oid){
  var c=document.getElementById('insppanel-'+oid);
  if(c) c.innerHTML=_inspPanel(oid);
  // Si el panel no está en pantalla no se reconstruye nada: reconstruir
  // sacaba al usuario del subpaso donde estaba trabajando.
  else { console.log('[panel] no está visible: no se repinta'); }
  // El semáforo del subpaso vive fuera del panel: se repinta también para
  // que el color cambie apenas se sube o se borra algo.
  try{ _inspRepintarPaso(oid); }catch(e){}
}

// Repinta el subpaso completo dejando todo como estaba
function _inspRepintarPaso(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='produccion'; });
  if(idx<0) return;
  var i=_pasoIdxProd(_PASO_INSPECCION);
  if(i<0) return;
  var body=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
  var abierto=!!(body && body.style.display!=='none');
  var cont=document.getElementById('egb-'+oid+'-'+idx);
  if(!cont) return;
  var scrollY=window.scrollY;
  var borrador='';
  try{ var inp=document.getElementById('subcin-'+oid+'-'+idx+'-'+i); if(inp) borrador=inp.value||''; }catch(e){}

  try{ buildEGB(oid, idx, cont); }catch(e){ console.warn('repintar inspeccion:',e); return; }

  if(abierto){
    var b2=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
    if(b2) b2.style.display='block';
    var ch=document.getElementById('ssch-'+oid+'-'+idx+'-'+i);
    if(ch) ch.style.transform='rotate(180deg)';
  }
  if(borrador){
    var inp2=document.getElementById('subcin-'+oid+'-'+idx+'-'+i);
    if(inp2) inp2.value=borrador;
  }
  window.scrollTo(0, scrollY);
}

// ── Enlaces de la inspección ──
function _inspLinksKey(oid){ return 'insplinks_'+oid; }
function _inspLeerLinks(oid){
  if(window._inspLinks && window._inspLinks[oid]) return window._inspLinks[oid];
  try{ var v=localStorage.getItem(_inspLinksKey(oid)); if(v){ var l=JSON.parse(v); if(Array.isArray(l)) return l; } }catch(e){}
  return [];
}
function _inspGuardarLinks(oid, links){
  window._inspLinks=window._inspLinks||{};
  window._inspLinks[oid]=links;
  try{ localStorage.setItem(_inspLinksKey(oid), JSON.stringify(links)); }catch(e){}
}
async function _inspAgregarLink(oid){
  var inp=document.getElementById('insplink-'+oid);
  var url=(inp&&inp.value||'').trim();
  if(!url){ showT('Pegá un enlace primero'); return; }
  if(!/^https?:\/\//i.test(url)){ showT('El enlace tiene que empezar con http:// o https://'); return; }
  var links=_inspLeerLinks(oid).slice();
  if(links.some(function(l){ return l.url===url; })){ showT('Ese enlace ya está guardado'); return; }
  var nota=prompt('¿Qué contiene este enlace? (opcional)\n\nPor ejemplo: fotos de la inspección','')||'';
  links.push({url:url, por:(CU&&CU.name)||'', fecha:now2(), nota:nota});
  _inspGuardarLinks(oid, links);
  if(inp) inp.value='';
  showT('Enlace guardado. Poniéndolo en cola de descarga…');
  try{
    var r=await fetch(SB+'/rest/v1/descargas_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({ docnum:String(oid), etapa:_subKeyProd(_PASO_INSPECCION)+'_fotos',
        url:url, nota:nota, pedido_por:(CU&&CU.name)||'', estado:'pendiente',
        creado_en:new Date().toISOString() })});
    if(r.ok) showT('✓ En cola. Los archivos van a aparecer solos aquí.');
  }catch(e){ console.warn('encolar:',e); }
  await _inspDescargasCargar(oid);
  _inspRepintar(oid);
  _inspVigilar(oid);
}
function _inspBorrarLink(oid, i){
  var links=_inspLeerLinks(oid).slice();
  if(!links[i]) return;
  if(!confirm('¿Borrar este enlace?\n\n'+links[i].url)) return;
  links.splice(i,1);
  _inspGuardarLinks(oid, links);
  _inspRepintar(oid);
}
async function _inspBorrarLog(oid, id){
  if(!_esGerencia() || !id) return;
  try{ await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+id,{method:'DELETE',headers:SBH}); }catch(e){}
  window._hubDesc['insp_'+oid]=(window._hubDesc['insp_'+oid]||[]).filter(function(d){ return String(d.id)!==String(id); });
  _inspRepintar(oid);
}
async function _inspDescargasCargar(oid){
  try{
    var et=_subKeyProd(_PASO_INSPECCION)+'_fotos';
    var r=await fetch(SB+'/rest/v1/descargas_queue?select=*&docnum=eq.'+encodeURIComponent(oid)
      +'&etapa=eq.'+encodeURIComponent(et)+'&order=creado_en.desc&limit=20',{headers:SBH});
    if(!r.ok) return [];
    var rows=await r.json();
    window._hubDesc['insp_'+oid]=Array.isArray(rows)?rows:[];
    return window._hubDesc['insp_'+oid];
  }catch(e){ return []; }
}
function _inspVigilar(oid, intento){
  intento=intento||0;
  var espera = intento===0 ? 1500 : (intento<20 ? 3000 : 8000);
  setTimeout(function(){
    var antes=(window._hubDesc['insp_'+oid]||[]).map(function(d){return d.id+':'+d.estado;}).join('|');
    _inspDescargasCargar(oid).then(async function(ds){
      ds=ds||[];
      var ahora=ds.map(function(d){return d.id+':'+d.estado;}).join('|');
      if(ahora!==antes){
        try{ await cargarDocsOrden(oid); }catch(e){}
        _inspRepintar(oid);
      }
      if(ds.some(function(d){ return d.estado==='pendiente'||d.estado==='procesando'; }) && intento<100){
        _inspVigilar(oid, intento+1);
      }
    });
  }, espera);
}

// ── Marcar la inspección como revisada y avisar al encargado ──
function _inspRevisadoModal(oid){
  var d=_solPagoDatosOrden(oid);
  var dept=d.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  // El encargado: gerencia del departamento, o toda la gerencia
  var gers=(USERS||[]).filter(function(u){ return u.role==='gerencia'; });
  var delDept=gers.filter(function(u){ return dept && String(u.dept||'')===String(dept); });
  var chips=gers.map(function(u){
    var marcado=delDept.length ? delDept.some(function(z){return z.id===u.id;}) : true;
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#B45309':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#FEF9F3':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.id)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +(delDept.some(function(z){return z.id===u.id;})?'<span style="font-size:9px;color:var(--t-ambar);font-weight:700">'+_esc(dL(dept))+'</span>':'')
      +'</label>';
  }).join('');

  var sk=_subKeyProd(_PASO_INSPECCION);
  var nF=((window._atts&&window._atts[oid+sk+'_fotos'])||[]).length;
  var nD=((window._atts&&window._atts[oid+sk+'_docs'])||[]).length;

  var prev=document.getElementById('modalInsp'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalInsp';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:center;justify-content:center;padding:20px';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:500px;max-height:90vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-ambar)"><i class="ti ti-clipboard-check"></i> Inspección revisada</div>'
      +'<button onclick="document.getElementById(\'modalInsp\').remove()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +'<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> · orden '+_esc(d.dkc||oid)
      +'<div style="margin-top:3px">'+nF+' foto(s) · '+nD+' documento(s) adjuntos</div></div>'
    +(nF+nD===0?'<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-rojo)"><i class="ti ti-alert-triangle"></i> No hay nada adjunto todavía. El encargado no va a poder revisar.</div>':'')
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">¿A QUIÉN LE AVISO? (opcional)</div>'
    +'<div id="insp-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'+chips+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">NOTA (opcional)</div>'
    +'<textarea id="insp-nota" rows="3" placeholder="Algo que el encargado deba mirar…" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical"></textarea>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="document.getElementById(\'modalInsp\').remove()">Cancelar</button>'
      +'<button class="btn bp" id="insp-btn" style="background:#B45309" onclick="_inspRevisadoEnviar(\'' + oid + '\')"><i class="ti ti-send"></i> Marcar revisada y avisar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
}

async function _inspRevisadoEnviar(oid){
  var box=document.getElementById('insp-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  var nombres=marcados.map(function(c){ return c.getAttribute('data-nom'); });
  var nota=(document.getElementById('insp-nota')||{}).value||'';
  var n=_inspCuantos(oid);

  if(!n.total){
    if(!confirm('No hay fotos, documentos ni enlaces cargados.\n\n¿Marcarla como revisada igual?')) return;
  }
  if(!confirm('¿Marcar la inspección como revisada?\n\n'
    +(nombres.length?('Se le avisa a: '+nombres.join(', ')+'\n\n'):'')
    +'La etapa de Producción queda en verde. Puedes seguir subiendo o borrando archivos después.')) return;

  var btn=document.getElementById('insp-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  // El paso de la compradora queda completado
  try{
    var st=STAGES.find(function(z){ return z.key==='produccion'; });
    var pi=_pasoIdxProd(_PASO_INSPECCION);
    initP(oid);
    var sp=stageProgress[oid].produccion;
    if(pi>=0 && (sp.stepIdx||0)<=pi){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pi]=hoyIso;
      if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
      guardarEtapa(oid,'produccion');
    }
  }catch(e){ console.warn('marcar inspeccion:',e); }

  // Alerta al encargado, que lo lleva al paso de aprobación
  var destinos=marcados.map(function(c){
    return (USERS||[]).find(function(u){ return u.id===c.value; });
  }).filter(Boolean);
  if(destinos.length){
    try{
      await _menNotificar(destinos, {
        docnum:oid, contexto:'etapa', etapa:'Producción',
        texto:'Inspección de producción finalizada'+(nota?(' — '+nota):''),
        etiqueta:'Producción — inspección finalizada',
        paso:_PASO_INSPECCION
      });
    }catch(e){ console.warn('alerta inspeccion:',e); }
  }

  _solEnvioGuardar(oid, 'inspeccion', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:nombres, nota:nota
  });

  var m=document.getElementById('modalInsp'); if(m) m.remove();
  showT('✓ Inspección revisada. Se avisó a '+nombres.join(', '));
  _inspRepintar(oid);
}

// ── Panel del encargado: aprobar o devolver ──
function _inspAprobarPanel(oid){
  var rev=_solEnvioLeer(oid,'inspeccion');
  var apr=_solEnvioLeer(oid,'inspeccion_ok');
  var sk=_subKeyProd(_PASO_INSPECCION);
  var fotos=(window._atts&&window._atts[oid+sk+'_fotos'])?_dedupDocs(window._atts[oid+sk+'_fotos']):[];
  var docs=(window._atts&&window._atts[oid+sk+'_docs'])?_dedupDocs(window._atts[oid+sk+'_docs']):[];

  var h='<div style="background:var(--pastel-verde2);border:1px solid #A9DFD0;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="font-size:11.5px;font-weight:700;color:var(--t-verde2);margin-bottom:6px">'
    +'<i class="ti ti-eye-check"></i> Revisión del encargado</div>';

  if(!rev){
    h+='<div style="font-size:11px;color:var(--t-verde2)">La compradora todavía no marcó la inspección como revisada.</div>';
    return h+'</div>';
  }

  h+='<div style="font-size:11px;color:var(--t-verde2);margin-bottom:7px">'
    +'Enviada por <b>'+_esc(rev.por||'')+'</b> · '+_esc(_fechaHora(rev.fecha))
    +(rev.nota?('<div style="margin-top:3px;font-style:italic">'+_esc(rev.nota)+'</div>'):'')+'</div>';

  // La evidencia, a la vista
  if(fotos.length){
    h+='<div style="font-size:10.5px;color:var(--t-verde2);font-weight:700;margin-bottom:4px">FOTOS ('+fotos.length+')</div>'
      +'<div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:7px">';
    fotos.forEach(function(a){
      h+='<img src="'+_esc(a.data||'')+'" onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')" '
        +'style="width:70px;height:70px;object-fit:cover;border-radius:6px;border:0.5px solid var(--border);cursor:zoom-in" title="'+_esc(a.name||'')+'">';
    });
    h+='</div>';
  }
  if(docs.length){
    h+='<div style="font-size:10.5px;color:var(--t-verde2);font-weight:700;margin-bottom:4px">DOCUMENTOS ('+docs.length+')</div>';
    docs.forEach(function(a){
      h+='<div style="font-size:11.5px;padding:2px 0"><i class="ti ti-file" style="color:var(--t-verde2)"></i> '
        +'<span'+_prevAttrs(a.data||a.url,a.name)+' onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')" style="color:var(--text-accent);text-decoration:underline;cursor:pointer">'+_esc(a.name||'')+'</span></div>';
    });
  }

  if(apr){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;margin-top:8px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> Inspección aprobada</div>'
      +'<div style="font-size:11px;color:var(--t-verde);margin-top:2px">Por <b>'+_esc(apr.por||'')+'</b> · '+_esc(_fechaHora(apr.fecha))
      +(apr.nota?('<br>'+_esc(apr.nota)):'')+'</div></div>';
  } else if(CU && CU.role==='gerencia'){
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-top:9px">'
      +'<button class="btn bp" style="background:#16a34a;font-size:12px;padding:8px 16px;font-weight:700" onclick="_inspAprobar(\'' + oid + '\')">'
        +'<i class="ti ti-check"></i> OK — Aprobar inspección</button>'
      +'<button class="btn bp" style="background:#B45309;font-size:11.5px;padding:8px 13px" onclick="_inspDevolver(\'' + oid + '\')">'
        +'<i class="ti ti-arrow-back-up"></i> Devolver con observaciones</button>'
      +'</div>';
  }
  return h+'</div>';
}

async function _inspAprobar(oid){
  if(!CU || CU.role!=='gerencia'){ showT('Solo el encargado puede aprobar'); return; }
  if(!confirm('¿Aprobar la inspección de producción?\n\nLa etapa queda completada y la orden pasa a Logística.')) return;
  var nota=prompt('Comentario (opcional):','')||'';

  try{
    var st=STAGES.find(function(z){ return z.key==='produccion'; });
    var pi=_pasoIdxProd(_PASO_INSP_OK);
    initP(oid);
    var sp=stageProgress[oid].produccion;
    if(pi>=0 && (sp.stepIdx||0)<=pi){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pi]=hoyIso;
      guardarEtapa(oid,'produccion');
    }
  }catch(e){ console.warn('aprobar inspeccion:',e); }

  _solEnvioGuardar(oid, 'inspeccion_ok', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', nota:nota
  });

  // Se le avisa a quien la envió
  try{
    var rev=_solEnvioLeer(oid,'inspeccion');
    var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String((rev&&rev.por)||''); });
    if(quien) await _menNotificar([quien], {
      docnum:oid, contexto:'etapa', etapa:'Producción',
      texto:'Inspección aprobada'+(nota?(' — '+nota):'')+'. La orden pasa a Logística.',
      etiqueta:'Producción — inspección aprobada',
      paso:_PASO_INSP_OK
    });
  }catch(e){}

  showT('✓ Inspección aprobada. La orden pasa a Logística.');
  try{ openDetail(oid); }catch(e){}
}

async function _inspDevolver(oid){
  if(!CU || CU.role!=='gerencia'){ showT('Solo el encargado puede devolverla'); return; }
  var obs=prompt('¿Qué hay que corregir?\n\nSe le avisa a quien envió la inspección.','');
  if(obs===null) return;
  obs=String(obs).trim();
  if(!obs){ showT('Escribe las observaciones'); return; }

  // El paso de la compradora vuelve a quedar pendiente
  try{
    initP(oid);
    var pi=_pasoIdxProd(_PASO_INSPECCION);
    var sp=stageProgress[oid].produccion;
    if(pi>=0 && (sp.stepIdx||0)>pi){
      sp.stepIdx=pi;
      if(sp.stepDates) sp.stepDates[pi]='';
      guardarEtapa(oid,'produccion');
    }
  }catch(e){}

  try{
    var rev=_solEnvioLeer(oid,'inspeccion');
    var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String((rev&&rev.por)||''); });
    var destinos=quien?[quien]:(USERS||[]).filter(function(u){ return u.role==='compras'; });
    await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Producción',
      texto:'Inspección devuelta: '+obs,
      etiqueta:'Producción — inspección con observaciones',
      paso:_PASO_INSPECCION
    });
  }catch(e){}

  _solEnvioGuardar(oid, 'inspeccion', null);
  showT('Inspección devuelta con observaciones');
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  LOGÍSTICA — BOOKING, B/L Y AVISO DE LLEGADA
//  Cada subetapa recibe su documento, la IA lo lee y llena los datos. Las
//  tarifas se separan por moneda: lo que está en dólares lo paga Kennedy y lo
//  que viene en otra moneda lo paga el proveedor. Al cargar el B/L y el aviso
//  de llegada, los montos se cotejan contra el booking.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_BOOKING = 'Booking';
var _PASO_BL      = 'Bill of Lading (B/L)';
var _PASO_ARRIVAL = 'Aviso de llegada';

// ── Control de la revisión con AI ──
// Los pasos que tienen lectura por AI no se pueden enviar sin haberla hecho:
// antes se podía mandar un documento sin que nadie lo hubiera revisado.
window._iaRevisado=window._iaRevisado||{};

function _iaClave(oid, paso){ return String(oid)+'|'+String(paso||''); }

function _iaMarcarRevisado(oid, paso){
  window._iaRevisado[_iaClave(oid,paso)]={por:(CU&&CU.name)||'', en:new Date().toISOString()};
  try{ localStorage.setItem('iarev_'+_iaClave(oid,paso), JSON.stringify(window._iaRevisado[_iaClave(oid,paso)])); }catch(e){}
}

function _iaEstaRevisado(oid, paso){
  var k=_iaClave(oid,paso);
  if(window._iaRevisado[k]) return window._iaRevisado[k];
  try{
    var v=localStorage.getItem('iarev_'+k);
    if(v){ window._iaRevisado[k]=JSON.parse(v); return window._iaRevisado[k]; }
  }catch(e){}
  return null;
}

// Devuelve true si se puede seguir; si no, avisa y devuelve false
function _iaExigirRevision(oid, paso, queEs){
  var r=_iaEstaRevisado(oid, paso);
  if(r) return true;
  alert('Falta la revisión con AI.\n\n'
    +'Antes de enviar hay que revisar '+(queEs||'los documentos')+' con el botón '
    +'"Revisar con AI" o "Leer con AI" de este paso.\n\n'
    +'Así se confirma que los datos del documento son correctos.');
  return false;
}

// Aviso visible cuando un panel de etapa falla, en vez de desaparecer callado
function _panelErrLog(nombre, e){
  console.error('[panel '+nombre+']', e);
  return '<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;margin-bottom:8px;font-size:11.5px;color:var(--t-rojo)">'
    +'<b><i class="ti ti-alert-triangle"></i> No se pudo mostrar el panel de '+_esc(nombre)+'</b>'
    +'<div style="margin-top:3px;font-family:monospace;font-size:10.5px">'+_esc(e&&(e.message||String(e)))+'</div></div>';
}

// ═══════════════════════════════════════════════════════════════════════════
//  CIERRE MANUAL DE SUBETAPAS
//  Algunas subetapas se cierran solas al enviar un correo o adjuntar un
//  documento. Las que no, necesitan un botón para poder dejarlas en verde.
// ═══════════════════════════════════════════════════════════════════════════
function _cerrarPaso(oid, stageKey, nombrePaso, silencioso){
  var st=STAGES.find(function(z){ return z.key===stageKey; });
  if(!st) return false;
  var pi=st.steps.findIndex(function(p){ return p.name===nombrePaso; });
  if(pi<0) return false;
  initP(oid);
  var sp=stageProgress[oid][stageKey];
  if(!sp) return false;
  if((sp.stepIdx||0)>pi) return true;        // ya estaba cerrado
  var hoyIso=new Date().toISOString().slice(0,10);
  sp.stepIdx=pi+1;
  if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
  sp.stepDates[pi]=now2();
  if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
  sp.stepBy[pi]=(CU&&CU.name)||'';
  if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
  sp._isoPasos[pi]=hoyIso;
  if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
  guardarEtapa(oid, stageKey);
  if(!silencioso) showT('✓ "'+nombrePaso+'" marcado como hecho');
  return true;
}

// Botón para dejar un paso en verde a mano, con lo que falta si falta algo
function _btnCerrarPaso(oid, stageKey, nombrePaso, opts){
  opts=opts||{};
  var st=STAGES.find(function(z){ return z.key===stageKey; });
  if(!st) return '';
  var pi=st.steps.findIndex(function(p){ return p.name===nombrePaso; });
  if(pi<0) return '';
  initP(oid);
  var sp=(stageProgress[oid]||{})[stageKey]||{};
  var hecho=((sp.stepIdx||0)>pi);
  var quien=(sp.stepBy||[])[pi]||'';
  var cuando=(sp.stepDates||[])[pi]||'';

  if(hecho){
    return '<div style="display:flex;align-items:center;gap:8px;background:var(--pastel-ok);border:1px solid #16a34a;'
      +'border-radius:8px;padding:8px 11px;margin-top:8px">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde)"></i>'
      +'<div style="flex:1;font-size:11.5px;color:var(--t-verde)">'
        +'<b>Paso completado</b>'+(quien?(' · '+_esc(quien)):'')+(cuando?(' · '+_esc(cuando)):'')+'</div>'
      +((CU && (CU.role===st.steps[pi].role || CU.role==='gerencia'))
        ? ('<button class="btn bg2" style="padding:3px 9px;font-size:10px" onclick="event.stopPropagation();_reabrirPaso(\''+oid+'\',\''+stageKey+'\',\''+String(nombrePaso).replace(/'/g,'')+'\')">Reabrir</button>')
        : '')
      +'</div>';
  }

  var puede = CU && (CU.role===st.steps[pi].role || CU.role==='gerencia'
              || (opts.roles && opts.roles.indexOf(CU.role)>=0));
  if(!puede) return '';

  var falta=opts.falta||'';
  return '<div style="display:flex;align-items:center;gap:8px;background:var(--surface-0);'
    +'border:0.5px solid var(--border);border-radius:8px;padding:8px 11px;margin-top:8px;flex-wrap:wrap">'
    +'<div style="flex:1;min-width:150px;font-size:11px;color:var(--text-muted)">'
      +(falta?('<i class="ti ti-alert-circle" style="color:var(--t-ambar)"></i> '+_esc(falta))
             :'Cuando termines este paso, marcalo para que quede en verde.')+'</div>'
    +'<button class="btn bp" style="background:#639922;padding:5px 12px;font-size:11px;font-weight:600" '
    +'onclick="event.stopPropagation();_cerrarPasoUI(\''+oid+'\',\''+stageKey+'\',\''+String(nombrePaso).replace(/'/g,'')+'\')">'
    +'<i class="ti ti-check"></i> Marcar como realizado</button>'
    +'</div>';
}

function _cerrarPasoUI(oid, stageKey, nombrePaso){
  if(!confirm('¿Marcar "'+nombrePaso+'" como realizado?')) return;
  if(_cerrarPaso(oid, stageKey, nombrePaso)){
    try{ _avisarGerenciaPaso(oid, stageKey, _pasoIdxDe(stageKey, nombrePaso)); }catch(e){}
    try{ openDetail(oid); }catch(e){}
  }
}

function _pasoIdxDe(stageKey, nombrePaso){
  var st=STAGES.find(function(z){ return z.key===stageKey; });
  return st ? st.steps.findIndex(function(p){ return p.name===nombrePaso; }) : -1;
}

function _reabrirPaso(oid, stageKey, nombrePaso){
  if(!confirm('¿Reabrir "'+nombrePaso+'"?\n\nLa etapa vuelve a este punto.')) return;
  var pi=_pasoIdxDe(stageKey, nombrePaso);
  if(pi<0) return;
  initP(oid);
  var sp=stageProgress[oid][stageKey];
  if(!sp) return;
  sp.stepIdx=pi;
  if(sp.stepDates) sp.stepDates[pi]='';
  if(sp.stepBy) sp.stepBy[pi]='';
  guardarEtapa(oid, stageKey);
  showT('Paso reabierto');
  try{ openDetail(oid); }catch(e){}
}

function _pasoIdxLog(nombre){
  var st=STAGES.find(function(z){ return z.key==='logistica'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
function _subKeyLog(nombre){
  var i=_pasoIdxLog(nombre);
  return i<0 ? '' : ('logistica_step'+i);
}

// ── Datos de logística guardados por orden ──
window._logData=window._logData||{};

function _logLeer(oid){
  if(window._logData[oid]) return window._logData[oid];
  var d=null;
  try{ var v=localStorage.getItem('log_'+oid); if(v) d=JSON.parse(v); }catch(e){}
  if(!d){
    // Puede venir guardado en la propia orden
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p && p.logistica){
      d=p.logistica;
      if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(e){ d=null; } }
    }
  }
  d=d||{booking:{}, bl:{}, arrival:{}, contenedores:[]};
  d.booking=d.booking||{}; d.bl=d.bl||{}; d.arrival=d.arrival||{};
  d.contenedores=d.contenedores||[];
  window._logData[oid]=d;
  return d;
}

async function _logGuardar(oid){
  var d=_logLeer(oid);
  try{ localStorage.setItem('log_'+oid, JSON.stringify(d)); }catch(e){}
  try{
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p){
      p.logistica=d;
      await fetch(SB+'/rest/v1/compras_pend_sap?dkc=eq.'+encodeURIComponent(p.dkc||p.num_orden),{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({logistica:d})});
    } else {
      await fetch(SB+'/rest/v1/compras_logistica?on_conflict=docnum',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
        body:JSON.stringify({docnum:String(oid), datos:d, actualizado_en:new Date().toISOString()})});
    }
  }catch(e){ console.warn('guardar logistica:',e); }
}

// ── Tarifas: lo que paga Kennedy vs el proveedor ──
function _logTotales(tarifas){
  var kcc=0, prov=0, monedas={};
  (tarifas||[]).forEach(function(t){
    var m=String(t.moneda||'').toUpperCase().trim();
    var v=Number(t.monto)||0;
    monedas[m]=(monedas[m]||0)+v;
    // Los cargos en dólares los paga Kennedy; el resto, el proveedor
    if(m==='USD' || m==='US$' || m==='$' || m==='DOLAR' || m==='DÓLAR') kcc+=v;
    else prov+=v;
  });
  return {kcc:kcc, prov:prov, monedas:monedas};
}

function _logTablaTarifas(tarifas, editable, oid, donde){
  var t=_logTotales(tarifas);
  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;overflow:hidden;margin-bottom:8px">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
    +'<tr style="background:var(--surface-1)">'
      +'<th style="text-align:left;padding:6px 9px;font-size:10px;text-transform:uppercase;color:var(--text-muted)">Concepto</th>'
      +'<th style="text-align:right;padding:6px 9px;font-size:10px;text-transform:uppercase;color:var(--text-muted)">Monto</th>'
      +'<th style="text-align:center;padding:6px 9px;font-size:10px;text-transform:uppercase;color:var(--text-muted)">Moneda</th>'
      +'<th style="text-align:center;padding:6px 9px;font-size:10px;text-transform:uppercase;color:var(--text-muted)">Paga</th>'
      +(editable?'<th style="width:28px"></th>':'')
    +'</tr>';
  if(!(tarifas||[]).length){
    h+='<tr><td colspan="'+(editable?5:4)+'" style="padding:9px;text-align:center;color:var(--text-muted);font-size:11px">Sin tarifas cargadas</td></tr>';
  }
  (tarifas||[]).forEach(function(x,i){
    var m=String(x.moneda||'').toUpperCase().trim();
    var esKcc=(m==='USD'||m==='US$'||m==='$');
    // Todo editable: la AI puede leer mal un monto o una moneda
    h+='<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:3px 6px">'+(editable
          ? ('<input value="'+_esc(x.concepto||'')+'" onclick="event.stopPropagation()" onchange="_logSetTarifa(\'' + oid + '\',\'' + donde + '\','+i+',\'concepto\',this.value)" style="width:100%;padding:3px 6px;border:0.5px solid transparent;border-radius:5px;font-size:11.5px;background:transparent;color:var(--text-primary)" onfocus="this.style.borderColor=\'var(--border)\';this.style.background=\'var(--surface-0)\'" onblur="this.style.borderColor=\'transparent\';this.style.background=\'transparent\'">')
          : _esc(x.concepto||''))+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+(editable
          ? ('<input value="'+_esc(_fmtN2(x.monto))+'" onclick="event.stopPropagation()" onchange="_logSetTarifa(\'' + oid + '\',\'' + donde + '\','+i+',\'monto\',this.value)" style="width:92px;padding:3px 6px;border:0.5px solid transparent;border-radius:5px;font-size:11.5px;font-weight:600;text-align:right;background:transparent;color:var(--text-primary)" onfocus="this.style.borderColor=\'var(--border)\';this.style.background=\'var(--surface-0)\'" onblur="this.style.borderColor=\'transparent\';this.style.background=\'transparent\'">')
          : ('<span style="font-weight:600">'+_fmtN2(x.monto)+'</span>'))+'</td>'
      +'<td style="padding:3px 6px;text-align:center">'+(editable
          ? ('<input value="'+_esc(m)+'" placeholder="USD" onclick="event.stopPropagation()" onchange="_logSetTarifa(\'' + oid + '\',\'' + donde + '\','+i+',\'moneda\',this.value)" style="width:58px;padding:3px 6px;border:0.5px solid transparent;border-radius:5px;font-size:11.5px;text-align:center;text-transform:uppercase;background:transparent;color:var(--text-primary)" onfocus="this.style.borderColor=\'var(--border)\';this.style.background=\'var(--surface-0)\'" onblur="this.style.borderColor=\'transparent\';this.style.background=\'transparent\'">')
          : _esc(m||'—'))+'</td>'
      +'<td style="padding:5px 9px;text-align:center">'
        +'<span style="font-size:10px;font-weight:700;border-radius:6px;padding:1px 7px;background:'
        +(esKcc?'#e6f1fb;color:var(--t-azul)':'#FEF3E8;color:var(--t-marron)')+'">'+(esKcc?'KENNEDY':'PROVEEDOR')+'</span></td>'
      +(editable?('<td style="text-align:center"><span onclick="event.stopPropagation();_logBorrarTarifa(\'' + oid + '\',\'' + donde + '\','+i+')" style="color:var(--text-danger);cursor:pointer">×</span></td>'):'')
      +'</tr>';
  });
  h+='</table>'
    +'<div style="display:flex;gap:9px;padding:8px 9px;background:var(--surface-1);border-top:0.5px solid var(--border);flex-wrap:wrap">'
      +'<div style="flex:1;min-width:130px"><div style="font-size:9.5px;color:var(--t-azul);font-weight:700;text-transform:uppercase">Paga Kennedy</div>'
        +'<div style="font-size:14px;font-weight:700;color:var(--t-azul)">'+fmt(t.kcc)+'</div></div>'
      +'<div style="flex:1;min-width:130px"><div style="font-size:9.5px;color:var(--t-marron);font-weight:700;text-transform:uppercase">Paga el proveedor</div>'
        +'<div style="font-size:14px;font-weight:700;color:var(--t-marron)">'
        +Object.keys(t.monedas).filter(function(m){ return !(m==='USD'||m==='US$'||m==='$'); })
           .map(function(m){ return _fmtN2(t.monedas[m])+' '+m; }).join(' · ')
        +(t.prov?'':'—')+'</div></div>'
    +'</div></div>';
  if(editable){
    h+='<button class="btn bg2" style="font-size:10.5px;padding:4px 10px;margin-bottom:8px" onclick="event.stopPropagation();_logAgregarTarifa(\'' + oid + '\',\'' + donde + '\')">'
      +'<i class="ti ti-plus"></i> Agregar cargo a mano</button>';
  }
  return h;
}

// Corrige un dato de una tarifa que la AI pudo leer mal
function _logSetTarifa(oid, donde, i, campo, valor){
  var d=_logLeer(oid);
  if(!d[donde] || !d[donde].tarifas || !d[donde].tarifas[i]) return;
  if(campo==='monto'){
    var n=parseFloat(String(valor).replace(/,/g,''));
    if(isNaN(n)){ showT('Ese monto no es válido'); _logRepintar(oid); return; }
    d[donde].tarifas[i].monto=n;
  } else if(campo==='moneda'){
    d[donde].tarifas[i].moneda=String(valor||'').toUpperCase().trim();
  } else {
    d[donde].tarifas[i][campo]=String(valor||'').trim();
  }
  _logGuardar(oid);
  _logRepintar(oid);       // los totales y el cotejo se recalculan
}

function _logAgregarTarifa(oid, donde){
  var concepto=prompt('Concepto del cargo:\n\nPor ejemplo: OCEAN FREIGHT, THC, BL FEE','');
  if(concepto===null || !concepto.trim()) return;
  var montoTxt=prompt('Monto:','');
  if(montoTxt===null) return;
  var monto=parseFloat(String(montoTxt).replace(/,/g,''));
  if(isNaN(monto)){ showT('El monto no es válido'); return; }
  var moneda=(prompt('Moneda (USD, CNY, EUR…):','USD')||'USD').toUpperCase().trim();
  var d=_logLeer(oid);
  d[donde].tarifas=d[donde].tarifas||[];
  d[donde].tarifas.push({concepto:concepto.trim(), monto:monto, moneda:moneda});
  _logGuardar(oid);
  _logRepintar(oid);
}

function _logBorrarTarifa(oid, donde, i){
  var d=_logLeer(oid);
  if(!d[donde].tarifas || !d[donde].tarifas[i]) return;
  if(!confirm('¿Borrar el cargo "'+(d[donde].tarifas[i].concepto||'')+'"?')) return;
  d[donde].tarifas.splice(i,1);
  _logGuardar(oid);
  _logRepintar(oid);
}

// ── Contenedores: los que hagan falta por booking ──
function _logContenedores(oid, editable){
  var d=_logLeer(oid);
  var cs=d.contenedores||[];
  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:8px">'
    +'<div style="font-size:10.5px;font-weight:700;color:var(--text-secondary);margin-bottom:5px">'
    +'No. OF CONTAINERS <span style="font-weight:400;color:var(--text-muted)">('+cs.length+')</span>'
    +'<span style="font-weight:400;color:var(--text-muted);font-size:10px"> \u00b7 container no. y sello</span></div>';
  if(cs.length){
    h+='<div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:5px">';
    cs.forEach(function(c,i){
      var nav=d.booking.naviera||'';
      var url=_trackURL(nav,'contenedor',c.numero);
      h+='<span style="display:inline-flex;align-items:center;gap:5px;background:var(--surface-1);border:0.5px solid var(--border);border-radius:20px;padding:3px 10px;font-size:11.5px;font-family:monospace">'
        +(url?('<a href="'+_esc(url)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" style="color:var(--text-accent);text-decoration:none" title="Rastrear '+_esc(c.numero||'')+(nav?(' en '+_esc(nav)):'')+'">'+_esc(c.numero||'')+'</a>')
             :_esc(c.numero||''))
        +(c.tipo?('<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(c.tipo)+'</span>'):'')
        +(c.sello?('<span style="font-size:9.5px;color:var(--t-marron);background:var(--pastel-naranja);border-radius:5px;padding:0 5px" title="Sello">\ud83d\udd12 '+_esc(c.sello)+'</span>'):'')
        +(editable?('<span onclick="event.stopPropagation();_logEditarCont(\'' + oid + '\','+i+')" title="Corregir" style="color:var(--text-muted);cursor:pointer;font-size:10px"><i class="ti ti-pencil"></i></span>'):'')
        +(editable?('<span onclick="event.stopPropagation();_logBorrarCont(\'' + oid + '\','+i+')" style="color:var(--text-danger);cursor:pointer;font-weight:700">×</span>'):'')
        +'</span>';
    });
    h+='</div>';
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:5px">Todavía no hay contenedores cargados.</div>';
  }
  if(editable){
    h+='<button class="btn bg2" style="font-size:10.5px;padding:4px 10px" onclick="event.stopPropagation();_logAgregarCont(\'' + oid + '\')">'
      +'<i class="ti ti-plus"></i> Agregar contenedor</button>';
  }
  return h+'</div>';
}

function _logAgregarCont(oid){
  var txt=prompt('Número(s) de contenedor:\n\nPuedes pegar varios separados por coma o salto de línea.','');
  if(txt===null) return;
  var nums=String(txt).split(/[,;\n]/).map(function(x){return x.trim().toUpperCase();}).filter(Boolean);
  if(!nums.length) return;
  var tipo=prompt('Tipo (40HQ, 20GP, 40GP…) — opcional, se aplica a todos:','')||'';
  var sello=(nums.length===1)?(prompt('Sello / No. — opcional:','')||''):'';
  var d=_logLeer(oid);
  d.contenedores=d.contenedores||[];
  var nuevos=0;
  nums.forEach(function(n){
    if(d.contenedores.some(function(c){ return String(c.numero||'').toUpperCase()===n; })) return;
    d.contenedores.push({numero:n, tipo:tipo.trim().toUpperCase(), sello:sello.trim().toUpperCase()});
    nuevos++;
  });
  _logGuardar(oid);
  showT(nuevos?('✓ '+nuevos+' contenedor(es) agregado(s)'):'Ya estaban cargados');
  _logRepintar(oid);
}

// Corrige un contenedor mal leído
function _logEditarCont(oid, i){
  var d=_logLeer(oid);
  if(!d.contenedores[i]) return;
  var num=prompt('Número de contenedor:', d.contenedores[i].numero||'');
  if(num===null) return;
  num=String(num).toUpperCase().trim();
  if(!num){ showT('El número no puede quedar vacío'); return; }
  var tipo=prompt('Tipo (40HQ, 20GP…):', d.contenedores[i].tipo||'');
  if(tipo===null) tipo=d.contenedores[i].tipo||'';
  var sello=prompt('Sello / No.:', d.contenedores[i].sello||'');
  if(sello===null) sello=d.contenedores[i].sello||'';
  d.contenedores[i].numero=num;
  d.contenedores[i].tipo=String(tipo).toUpperCase().trim();
  d.contenedores[i].sello=String(sello).toUpperCase().trim();
  _logGuardar(oid);
  _logRepintar(oid);
}

function _logBorrarCont(oid, i){
  var d=_logLeer(oid);
  if(!d.contenedores[i]) return;
  if(!confirm('¿Borrar el contenedor '+(d.contenedores[i].numero||'')+'?')) return;
  d.contenedores.splice(i,1);
  _logGuardar(oid);
  _logRepintar(oid);
}

// Repinta los paneles de logística sin cerrar la etapa
function _logRepintar(oid){
  ['booking','bl','arrival'].forEach(function(k){
    var c=document.getElementById('logpanel-'+k+'-'+oid);
    if(c){
      try{
        c.innerHTML = k==='booking' ? _logPanelBooking(oid)
                    : k==='bl'      ? _logPanelBL(oid)
                                    : _logPanelArrival(oid);
      }catch(e){ console.warn('repintar logistica:',e); }
    }
  });
}

// Campo editable de un dato
function _logCampo(oid, donde, clave, etiqueta, valor, ancho){
  return '<div style="flex:1;min-width:'+(ancho||140)+'px">'
    +'<div style="font-size:9.5px;color:var(--text-muted);font-weight:600;text-transform:uppercase;margin-bottom:2px">'+_esc(etiqueta)+'</div>'
    +'<input value="'+_esc(valor||'')+'" placeholder="—" onclick="event.stopPropagation()" '
    +'onchange="_logSetCampo(\'' + oid + '\',\'' + donde + '\',\'' + clave + '\',this.value)" '
    +'style="width:100%;padding:5px 8px;border:0.5px solid var(--border);border-radius:6px;font-size:12px;background:var(--surface-0);color:var(--text-primary)"></div>';
}

function _logSetCampo(oid, donde, clave, valor){
  var d=_logLeer(oid);
  d[donde]=d[donde]||{};
  d[donde][clave]=valor;
  _logGuardar(oid);
}

// ── A) BOOKING ──
// ═══════════════════════════════════════════════════════════════════════════
//  SOLICITUD DE PAGO DE FLETE
//  Logística le pide a contabilidad el pago del flete, con copia a las
//  compradoras del departamento. Se adjuntan solos el aviso de llegada y el B/L.
// ═══════════════════════════════════════════════════════════════════════════
async function _fleteModal(oid){
  // Sin la lectura por AI del aviso de llegada no se pide el pago
  if(!_iaExigirRevision(oid, _PASO_ARRIVAL, 'el aviso de llegada')) return;
  var d=_logLeer(oid);
  // El número de entrada es obligatorio: va en el cuerpo del correo
  var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();
  if(!entrada){
    var txt=prompt('Falta el NÚMERO DE ENTRADA y es obligatorio para pedir el pago del flete.\n\n'
      +'Escribilo ahora:','');
    if(txt===null) return;
    entrada=String(txt).trim();
    if(!entrada){ showT('Sin el número de entrada no se puede enviar la solicitud'); return; }
    d.arrival=d.arrival||{};
    d.arrival.entrada=entrada;
    await _logGuardar(oid);
    _logRepintar(oid);
  }
  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var dept=dat.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  window._mailAdj=[];
  window._fleteCtx={oid:oid};

  // Destinatarios: contabilidad y las compradoras del departamento
  var contab=(USERS||[]).filter(function(u){ return u.role==='contabilidad' && u.email; });
  var compras=(USERS||[]).filter(function(u){ return u.role==='compras' && u.email && (!dept || String(u.dept||'')===String(dept)); });
  function chip(u, marcado, etiqueta, color){
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?color:'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'var(--surface-1)':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +(etiqueta?('<span style="font-size:9px;color:'+color+';font-weight:700">'+etiqueta+'</span>'):'')
      +'</label>';
  }
  var chipsC=contab.map(function(u){ return chip(u,true,'contabilidad','#166534'); }).join('');
  var chipsP=compras.map(function(u){ return chip(u,true,dept?dL(dept):'compras','#0c447c'); }).join('');

  // El total que paga Kennedy sale del aviso; si no hay, del booking
  var tar=(d.arrival&&d.arrival.tarifas&&d.arrival.tarifas.length)?d.arrival.tarifas:(d.booking.tarifas||[]);
  var tot=_logTotales(tar);
  var cs=d.contenedores||[];
  var tipos={};
  cs.forEach(function(c){ var t=String(c.tipo||'').trim()||'—'; tipos[t]=(tipos[t]||0)+1; });
  var tipoTxt=Object.keys(tipos).map(function(t){ return (tipos[t]>1?(tipos[t]+' x '):'')+t; }).join(', ')||'—';

  var asunto='SOLICITUD DE PAGO DE FLETE '+ordenTxt;
  var cuerpo='Estimados,\n\n'
    +'Información del embarque:\n\n'
    +'  • NUMERO-DKC: '+ordenTxt+'\n'
    +'  • Fecha de llegada (ETA): '+((d.arrival&&d.arrival.fecha_llegada)||(d.bl&&d.bl.fecha_llegada)||'—')+'\n'
    +'  • Departamento: '+(dept?dL(dept):'—')+'\n'
    +'  • Número de BL: '+((d.arrival&&d.arrival.bl)||(d.bl&&d.bl.numero)||'—')+'\n'
    +'  • Número de entrada: '+entrada+'\n'
    +'  • Proveedor: '+(dat.proveedor||'—')+'\n'
    +'  • Cantidad de contenedores: '+(cs.length||'—')+'\n'
    +'  • Tipo de contenedor: '+tipoTxt+'\n'
    +'  • Naviera: '+((d.booking&&d.booking.naviera)||'—')+'\n'
    +'  • Total a pagar: '+fmt(tot.kcc)+'\n\n'
    +'Agradecemos realizar el pago a la mayor brevedad posible y, una vez efectuado, '
    +'agradeceremos compartir el comprobante por este mismo medio para continuar con el proceso.\n\n'
    +'Quedamos atentos.\n\n'
    +'Saludos cordiales,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalFlete'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalFlete';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:680px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-marron)"><i class="ti ti-cash"></i> Solicitud de pago de flete</div>'
      +'<button onclick="_fleteCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="background:var(--pastel-aviso);border:1px solid #E9C08A;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-marron)">'
      +'<b>'+_esc(dat.proveedor||'')+'</b> · orden '+_esc(ordenTxt)
      +'<div style="margin-top:3px">Total a pagar por Kennedy: <b>'+fmt(tot.kcc)+'</b> · '+cs.length+' contenedor(es)</div></div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA — contabilidad</div>'
    +'<div id="flete-contab" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px">'
      +(chipsC||'<span style="font-size:11.5px;color:var(--text-danger)">No hay usuarios de contabilidad</span>')+'</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">COPIA — compras'
      +(dept?(' · '+_esc(dL(dept))):'')+'</div>'
    +'<div id="flete-compras" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'
      +(chipsP||'<span style="font-size:11.5px;color:var(--text-muted)">Sin compradoras en este departamento</span>')+'</div>'
    +'<input id="flete-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="flete-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="flete-cuerpo" rows="18" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="flete-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando el aviso de llegada y el B/L…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_fleteCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="flete-btn" style="background:#7C3D12" onclick="_fleteEnviar()"><i class="ti ti-send"></i> Enviar solicitud</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // El aviso de llegada y el B/L se adjuntan solos
  var aviso=document.getElementById('flete-auto');
  var puestos=[], faltan=[];
  var pares=[[_subKeyLog(_PASO_ARRIVAL),'aviso de llegada'], [_subKeyLog(_PASO_BL),'B/L']];
  for(var p=0;p<pares.length;p++){
    var fs=(window._atts&&window._atts[oid+pares[p][0]])?_dedupDocs(window._atts[oid+pares[p][0]]):[];
    if(!fs.length){ faltan.push(pares[p][1]); continue; }
    for(var i=0;i<fs.length;i++){
      if(!fs[i].url) continue;
      try{
        var adj=await _solPagoAdjuntarDeStorage(fs[i].url, fs[i].name||(pares[p][1]+'.pdf'));
        if(adj){ window._mailAdj.push(adj); puestos.push(fs[i].name); }
      }catch(e){ console.warn('adjuntar flete:',e); }
    }
  }
  mailPintarAdjuntos();
  if(aviso){
    var h2='';
    if(puestos.length) h2+='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado: '+_esc(puestos.join(', '))+'</span>';
    if(faltan.length)  h2+=(h2?'<br>':'')+'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Falta el '+_esc(faltan.join(' y el '))+'. Adjuntalo a mano.</span>';
    aviso.innerHTML=h2||'<span style="color:var(--t-ambar)">No hay documentos para adjuntar.</span>';
  }
}

function _fleteCerrar(){
  var m=document.getElementById('modalFlete'); if(m) m.remove();
  window._mailAdj=[]; window._fleteCtx=null;
}

async function _fleteEnviar(){
  var ctx=window._fleteCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid;
  function marcados(id){
    var b=document.getElementById(id);
    return b?Array.prototype.slice.call(b.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  }
  var para=marcados('flete-contab');
  var cc=marcados('flete-compras');
  var extra=((document.getElementById('flete-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  if(!para.length && !cc.length && !extra.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }

  var asunto=(document.getElementById('flete-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('flete-cuerpo')||{}).value||'';
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }

  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('flete-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var todos=para.concat(cc).concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:(para[0]||todos[0]),
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:_dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
                 .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Solicitud de pago de flete · '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      var t=await r.text(); console.error('flete:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar solicitud'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar solicitud'; }
    return;
  }

  _solEnvioGuardar(oid, 'flete', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo,
    adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, kb:a.kb||0}; })
  });

  // Aviso en el portal a contabilidad y compras
  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Logística',
      texto:'Solicitud de pago de flete enviada',
      etiqueta:'Logística — pago de flete', paso:_PASO_ARRIVAL
    });
  }catch(e){}

  _fleteCerrar();
  showT('✓ Solicitud de pago de flete enviada a '+todos.length+' destinatario(s)');
  try{ openDetail(oid); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  ADUANIZACIÓN — DMCE Y SIGA
//  Se adjuntan los dos documentos, la AI los lee y los valores se cotejan
//  contra la orden de compra y contra el flete del aviso de llegada.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_DMCE    = 'DMCE y SIGA';
var _PASO_DMCE_SAL= 'DMCE de salida';
var _PASO_COSTEO  = 'Costeo de importación';
var _PASO_PRECIOS = 'Precios de venta por gerencia';
var _PASO_SAP     = 'Precios de venta por gerencia';   // el paso final de la etapa

// Quién puede operar Aduanización & Costeo y Logística.
// Compras también participa: las compradoras siguen sus propias órdenes hasta
// el final, y antes quedaban sin los botones aunque veían la etapa.
function _puedeAduana(){
  return !!(CU && ['importacion','gerencia','compras','contabilidad'].indexOf(CU.role)>=0);
}

function _pasoIdxCost(nombre){
  var st=STAGES.find(function(z){ return z.key==='costeo'; });
  if(!st) return -1;
  return st.steps.findIndex(function(p){ return p.name===nombre; });
}
function _subKeyCost(nombre){
  var i=_pasoIdxCost(nombre);
  return i<0 ? '' : ('costeo_step'+i);
}

// Los datos de aduana viven junto a los de logística
function _aduLeer(oid){
  var d=_logLeer(oid);
  d.dmce=d.dmce||{};
  d.siga=d.siga||{};
  return d;
}

function _aduPanel(oid){
  var d=_aduLeer(oid);
  var sk=_subKeyCost(_PASO_DMCE);
  var dmce=(window._atts&&window._atts[oid+sk+'_dmce'])?_dedupDocs(window._atts[oid+sk+'_dmce']):[];
  var siga=(window._atts&&window._atts[oid+sk+'_siga'])?_dedupDocs(window._atts[oid+sk+'_siga']):[];
  var leido=!!(d.dmce.total_cif || d.dmce.total_fob);

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(leido?'sem-g':((dmce.length||siga.length)?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-file-certificate"></i> DMCE y SIGA</div></div>';

  // Accesos a los portales donde se sacan los documentos
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:9px">'
    +'<a href="https://dmce2.zonalibredecolon.gob.pa/TFBFTZ/cusLogin/login.cl?language=es" target="_blank" rel="noopener" onclick="event.stopPropagation()" '
      +'style="display:inline-flex;align-items:center;gap:6px;background:var(--surface-0);border:0.5px solid #7C3D12;border-radius:8px;padding:7px 12px;font-size:11.5px;font-weight:700;color:var(--t-marron);text-decoration:none">'
      +'<i class="ti ti-external-link"></i> Abrir DMCE <span style="font-weight:400;font-size:10px;color:var(--text-muted)">Zona Libre de Colón</span></a>'
    +'<a href="https://siga.ana.gob.pa/pcus/jsf/homepage/home.jsf" target="_blank" rel="noopener" onclick="event.stopPropagation()" '
      +'style="display:inline-flex;align-items:center;gap:6px;background:var(--surface-0);border:0.5px solid #0c447c;border-radius:8px;padding:7px 12px;font-size:11.5px;font-weight:700;color:var(--t-azul);text-decoration:none">'
      +'<i class="ti ti-external-link"></i> Abrir SIGA <span style="font-weight:400;font-size:10px;color:var(--text-muted)">Aduanas Panamá</span></a>'
    +'</div>';
  h+=_aduZona(oid, sk+'_dmce', 'DOCUMENTO DMCE', 'Adjunta la declaración DMCE', '#7C3D12');
  h+=_aduZona(oid, sk+'_siga', 'DOCUMENTO SIGA', 'Adjunta el SIGA', '#0c447c');

  if((dmce.length||siga.length) && _puedeAduana()){
    h+='<button class="btn bp" style="background:#5B21B6;font-size:11.5px;padding:7px 13px;margin-bottom:9px" onclick="event.stopPropagation();_aduLeerIA(\'' + oid + '\')">'
      +'<i class="ti ti-sparkles"></i> Leer con AI y verificar</button>'
      +'<div id="aduia-'+oid+'" style="margin-bottom:9px"></div>';
  }

  // Los datos que salieron del DMCE
  var m=d.dmce;
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'dmce','numero','N° de DMCE', m.numero, 150)
    +_logCampo(oid,'dmce','conocimiento','Conocimiento de guía / embarque', m.conocimiento, 190)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'dmce','total_fob','Total FOB', m.total_fob, 120)
    +_logCampo(oid,'dmce','flete','Flete', m.flete, 110)
    +_logCampo(oid,'dmce','otros','Otros', m.otros, 110)
    +_logCampo(oid,'dmce','total_cif','Total CIF', m.total_cif, 120)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'dmce','bultos','Total de bultos', m.bultos, 120)
    +_logCampo(oid,'dmce','puerto_origen','Puerto de origen', m.puerto_origen, 150)
    +_logCampo(oid,'dmce','puerto_entrada','Puerto de entrada', m.puerto_entrada, 150)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'dmce','embarcante','Nombre del embarcante', m.embarcante, 200)
    +_logCampo(oid,'dmce','pais_embarcante','País del embarcante', m.pais_embarcante, 150)
    +'</div>';

  // El SIGA solo aporta su número de DMCE, para cotejarlo
  if(d.siga.numero || siga.length){
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:8px">'
      +'<div style="font-size:10px;font-weight:700;color:var(--t-azul);margin-bottom:4px">N° DE DMCE SEGÚN EL SIGA</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:flex-end">'
      +_logCampo(oid,'siga','numero','N° de DMCE en el SIGA', d.siga.numero, 170)
      +'</div>'
      +_aduCotejoSiga(d)
      +'</div>';
  }

  h+=_aduComparaciones(oid);
  h+=_btnCerrarPaso(oid, 'costeo', _PASO_DMCE,
      {falta: completo ? '' : 'Faltan datos del DMCE. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// ¿El número de DMCE coincide entre los dos documentos?
function _aduCotejoSiga(d){
  var a=String(d.dmce.numero||'').replace(/[\s-]/g,'').toUpperCase();
  var b=String(d.siga.numero||'').replace(/[\s-]/g,'').toUpperCase();
  if(!a || !b) return '';
  if(a===b){
    return '<div style="font-size:11px;color:var(--t-verde);font-weight:600;margin-top:5px">'
      +'<i class="ti ti-circle-check"></i> El número de DMCE coincide en los dos documentos.</div>';
  }
  return '<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:7px;padding:7px 9px;margin-top:5px">'
    +'<div style="font-size:11px;font-weight:700;color:var(--t-rojo)">'
    +'<i class="ti ti-alert-triangle"></i> El número de DMCE NO coincide</div>'
    +'<div style="font-size:11px;color:var(--t-rojo);margin-top:2px">'
    +'DMCE: <b>'+_esc(d.dmce.numero||'')+'</b> · SIGA: <b>'+_esc(d.siga.numero||'')+'</b></div></div>';
}

// Total de la orden y bultos, para comparar
function _aduDatosOrden(oid){
  var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
  var total=0, bultos=0;
  if(o){
    total=Number(o.total)||0;
    (o.lines||[]).forEach(function(l){ bultos+=Number(l.quantity||l.cantidad||0)||0; });
  }
  if(!total){
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p){
      total=Number(p.total)||0;
      var its=p.items;
      if(typeof its==='string'){ try{ its=JSON.parse(its); }catch(e){ its=null; } }
      if(Array.isArray(its)) its.forEach(function(l){ bultos+=Number(l.cantidad||l.quantity||0)||0; });
    }
  }
  return {total:total, bultos:bultos};
}

// Las tres comparaciones que pediste
function _aduComparaciones(oid){
  var d=_aduLeer(oid);
  var m=d.dmce;
  if(!m.total_fob && !m.flete && !m.bultos) return '';
  var ord=_aduDatosOrden(oid);
  // El flete que paga Kennedy sale del aviso de llegada, o del booking
  var tar=(d.arrival&&d.arrival.tarifas&&d.arrival.tarifas.length)?d.arrival.tarifas:((d.booking&&d.booking.tarifas)||[]);
  var flete=_logTotales(tar).kcc;

  function num(v){ return Number(String(v==null?'':v).replace(/[^\d.-]/g,''))||0; }
  var filas=[
    {q:'Total FOB', doc:num(m.total_fob), ref:ord.total,  refNom:'total de la orden de compra', money:true},
    {q:'Flete',     doc:num(m.flete),     ref:flete,      refNom:'flete del aviso de llegada',  money:true},
    {q:'Total de bultos', doc:num(m.bultos), ref:ord.bultos, refNom:'bultos de la orden',       money:false}
  ].filter(function(f){ return f.doc || f.ref; });
  if(!filas.length) return '';

  var h='<div style="border:0.5px solid var(--border);border-radius:8px;overflow:hidden;background:var(--surface-0)">'
    +'<div style="background:var(--surface-1);padding:7px 10px;font-size:10.5px;font-weight:700;color:var(--text-secondary)">'
    +'VERIFICACIÓN CONTRA LA ORDEN Y EL FLETE</div>';
  var hayDif=false;
  filas.forEach(function(f){
    var dif=Math.abs(f.doc-f.ref);
    var ok=(f.ref===0)? null : (dif<0.01 || (f.money && dif<1));
    if(ok===false) hayDif=true;
    var col = ok===null ? '#6b7280' : (ok?'#166534':'#991b1b');
    h+='<div style="padding:7px 10px;border-top:0.5px solid var(--border)">'
      +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">'
        +'<span style="font-size:11.5px;font-weight:600;flex:1;min-width:110px">'+_esc(f.q)+'</span>'
        +'<span style="font-size:11.5px">DMCE: <b>'+(f.money?fmt(f.doc):_fmtN2(f.doc))+'</b></span>'
        +'<span style="font-size:11.5px;color:var(--text-muted)">vs</span>'
        +'<span style="font-size:11.5px">'+(f.money?fmt(f.ref):_fmtN2(f.ref))+'</span>'
        +'<span style="font-size:9.5px;font-weight:700;border-radius:6px;padding:1px 7px;color:#fff;background:'+col+'">'
          +(ok===null?'SIN REFERENCIA':(ok?'COINCIDE':'DIFIERE'))+'</span>'
      +'</div>'
      +'<div style="font-size:10px;color:var(--text-muted);margin-top:2px">Comparado con el '+_esc(f.refNom)
        +(ok===false?(' · diferencia de <b style="color:var(--t-rojo)">'+(f.money?fmt(dif):_fmtN2(dif))+'</b>'):'')+'</div>'
      +'</div>';
  });
  if(hayDif){
    h+='<div style="padding:7px 10px;border-top:0.5px solid var(--border);background:var(--pastel-error);font-size:11px;color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> Revisa las diferencias antes de seguir con el costeo.</div>';
  }
  return h+'</div>';
}

// Zona de documentos de aduana
function _aduZona(oid, sub, titulo, ayuda, color){
  var files=(window._atts&&window._atts[oid+sub])?_dedupDocs(window._atts[oid+sub]):[];
  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:8px">'
    +'<div style="font-size:10px;font-weight:700;color:'+color+';margin-bottom:4px">'+titulo
    +' <span style="font-weight:400;color:var(--text-muted)">('+files.length+')</span></div>';
  if(files.length){
    files.forEach(function(a,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
        +'<i class="ti ti-file" style="color:'+color+'"></i>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
        +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px" onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button>'
        +'<button class="btn bg2" style="padding:3px 7px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_aduBorrarDoc(\'' + oid + '\',\'' + sub + '\','+i+')"><i class="ti ti-trash"></i></button>'
        +'</div>';
    });
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(ayuda)+'</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:6px;padding:6px 9px;border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+';margin-top:6px">'
    +'<i class="ti ti-upload"></i> Adjuntar'
    +'<input type="file" multiple accept=".pdf,.xlsx,.xls,.csv,.doc,.docx,image/*" style="display:none" onchange="_aduSubirDoc(\'' + oid + '\',\'' + sub + '\',this.files)"></label>';
  return h+'</div>';
}

async function _aduSubirDoc(oid, sub, files){
  if(!files||!files.length) return;
  var _y=window.scrollY;
  showT('Subiendo '+files.length+' archivo(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sub, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sub, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
      window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir aduana:',e); }
  }
  showT('✓ Adjuntado. Pulsa "Leer con AI" para llenar los datos.');
  _aduRefrescarPanel(oid, sub);          // solo el panel de esa subetapa
  setTimeout(function(){ window.scrollTo(0,_y); }, 0);
}

async function _aduBorrarDoc(oid, sub, i){
  var a=(window._atts&&window._atts[oid+sub])?window._atts[oid+sub][i]:null;
  if(!a) return;
  if(!confirm('¿Está seguro de que desea borrar este archivo?\n\n'
    +(a.name||'')+'\n\nEsta acción no se puede deshacer.')) return;

  // Desaparece de la pantalla al instante; el borrado sigue por detrás
  window._atts[oid+sub].splice(i,1);
  _aduRefrescarPanel(oid, sub);
  showT('Eliminando…');

  var ok=true;
  try{ ok=await _borrarArchivoStorage(a.url, a.id); }catch(e){ ok=false; }
  if(ok===false){
    showT('⚠ No se pudo borrar del servidor. Va a reaparecer al recargar.');
  } else {
    showT('✓ Archivo eliminado');
  }
  _aduRefrescarPanel(oid, sub);
}

// Repinta el panel al que pertenece ese archivo, y solo ese: cada subetapa
// tiene el suyo y antes se repintaba siempre el de aduana.
function _aduRefrescarPanel(oid, sub){
  var s=String(sub||'');
  if(s.indexOf(_subKeyCost(_PASO_COSTEO))===0){ _costRepintar(oid); return; }
  if(s.indexOf(_subKeyCost(_PASO_DMCE_SAL))===0){
    var c=document.getElementById('dmcesal-'+oid);
    if(c){ c.innerHTML=_dmceSalidaPanel(oid); return; }
  }
  _aduRepintar(oid);
}

function _aduRepintar(oid){
  var c=document.getElementById('adupanel-'+oid);
  if(c) c.innerHTML=_aduPanel(oid);
  // Si el panel no está en pantalla no se reconstruye nada: reconstruir
  // sacaba al usuario del subpaso donde estaba trabajando.
  else { console.log('[panel] no está visible: no se repinta'); }
}

// ── Lectura con AI del DMCE y el SIGA ──
async function _aduLeerIA(oid){
  var sk=_subKeyCost(_PASO_DMCE);
  var cont=document.getElementById('aduia-'+oid);
  if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo los documentos…</span>';

  var d=_aduLeer(oid);
  var resumen=[];

  for(var par=0; par<2; par++){
    var sub = par===0 ? (sk+'_dmce') : (sk+'_siga');
    var quien = par===0 ? 'dmce' : 'siga';
    var files=(window._atts&&window._atts[oid+sub])?_dedupDocs(window._atts[oid+sub]):[];
    if(!files.length) continue;

    var contenido=[], puestos=0;
    for(var i=0;i<files.length && puestos<3;i++){
      if(!files[i].url) continue;
      var prep=await _iaDesdeStorage(files[i].url, files[i].name||('doc_'+(i+1)), 7);
      if(!prep) continue;
      contenido.push({type:'text', text:'ARCHIVO: '+(files[i].name||'')});
      prep.bloques.forEach(function(b){ contenido.push(b); });
      puestos++;
    }
    if(!puestos) continue;
    contenido.push({type:'text', text:_aduPrompt(quien)});

    try{
      var obj=await _iaJSON(contenido, 3000);
      d[quien]=d[quien]||{};
      var n=0;
      Object.keys(obj||{}).forEach(function(k){
        if(k==='nota') return;
        var v=obj[k];
        if(v==null || String(v).trim()==='') return;
        d[quien][k]=String(v).trim();
        n++;
      });
      resumen.push((quien==='dmce'?'DMCE':'SIGA')+': '+n+' dato(s)');
    }catch(e){
      console.error('leer aduana '+quien+':',e);
      resumen.push((quien==='dmce'?'DMCE':'SIGA')+': no se pudo leer');
    }
  }

  await _logGuardar(oid);
  _iaMarcarRevisado(oid, _PASO_DMCE);
  _aduRepintar(oid);

  // Aviso si algo no cuadra
  var a=String(d.dmce.numero||'').replace(/[\s-]/g,'').toUpperCase();
  var b=String(d.siga.numero||'').replace(/[\s-]/g,'').toUpperCase();
  if(a && b && a!==b) showT('⚠ El número de DMCE no coincide entre el DMCE y el SIGA');

  var cont2=document.getElementById('aduia-'+oid);
  if(cont2) cont2.innerHTML='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde)">'
    +'<i class="ti ti-circle-check"></i> '+_esc(resumen.join(' · ')||'sin datos')+'</div>';
}

function _aduPrompt(quien){
  if(quien==='siga'){
    return 'Sos el analista de aduanas de KENNEDY CENTER CORP en Panama. Lee el documento SIGA adjunto '
      +'y extrae UNICAMENTE el numero de DMCE que figura en el.\\n\\n'
      +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\\n'
      +'{"numero":"","nota":""}\\n\\n'
      +'REGLAS:\\n'
      +'- "numero": el numero de DMCE (Declaracion de Mercancia, DMCE No., No. de declaracion). '
      +'Copialo tal cual, con guiones si los tiene.\\n'
      +'- Si no lo encontras, deja "" y explicalo en "nota".';
  }
  return 'Sos el analista de aduanas de KENNEDY CENTER CORP en Panama. Lee la declaracion DMCE adjunta.\\n\\n'
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\\n'
    +'{"numero":"","total_fob":"","flete":"","otros":"","total_cif":"","bultos":"",'
    +'"conocimiento":"","puerto_origen":"","puerto_entrada":"","embarcante":"","pais_embarcante":"","nota":""}\\n\\n'
    +'QUE ES CADA CAMPO:\\n'
    +'- "numero": el numero de DMCE (Declaracion de Mercancia, DMCE No.).\\n'
    +'- "total_fob": el TOTAL FOB (valor FOB de la mercancia). Solo el numero.\\n'
    +'- "flete": el monto del FLETE. Solo el numero.\\n'
    +'- "otros": OTROS gastos (seguro u otros cargos). Solo el numero.\\n'
    +'- "total_cif": el TOTAL CIF. Solo el numero.\\n'
    +'- "bultos": el TOTAL DE BULTOS (cantidad de bultos o piezas). Solo el numero.\\n'
    +'- "conocimiento": el CONOCIMIENTO DE GUIA O EMBARQUE (numero de B/L o guia aerea).\\n'
    +'- "puerto_origen": el PUERTO DE ORIGEN o de embarque.\\n'
    +'- "puerto_entrada": el PUERTO DE ENTRADA a Panama (Manzanillo, Cristobal, Balboa, Colon...).\\n'
    +'- "embarcante": el NOMBRE DEL EMBARCANTE (shipper, exportador).\\n'
    +'- "pais_embarcante": el PAIS DEL EMBARCANTE.\\n\\n'
    +'REGLAS:\\n'
    +'- Los montos van como numero, sin simbolos ni separadores de miles. Ejemplo: 13006.19\\n'
    +'- Si un dato no aparece, deja "". Nunca lo inventes.\\n'
    +'- El documento puede venir en espanol o ingles.';
}

// ── DMCE DE SALIDA ──
// Se adjunta el documento y con eso el paso queda hecho.
function _dmceSalidaPanel(oid){
  var sk=_subKeyCost(_PASO_DMCE_SAL);
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var listo=files.length>0;
  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(listo?'sem-g':'sem-r')+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-file-export"></i> DMCE de salida</div>'
    +'<span style="font-size:10.5px;color:var(--t-marron)">'+files.length+' documento(s)</span></div>';
  h+=_aduZona(oid, sk, 'DOCUMENTO DMCE DE SALIDA', 'Adjunta el DMCE de salida', '#7C3D12');
  if(listo){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Adjuntado: el paso queda completado.</div>';
  }
  h+=_btnCerrarPaso(oid, 'costeo', _PASO_DMCE_SAL,
      {falta: listo ? '' : 'Todavía no hay documento adjunto. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// Al adjuntar el DMCE de salida, el paso se marca solo
async function _dmceSalidaCheck(oid){
  var sk=_subKeyCost(_PASO_DMCE_SAL);
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  if(!files.length) return;
  try{
    var pi=_pasoIdxCost(_PASO_DMCE_SAL);
    initP(oid);
    var sp=stageProgress[oid].costeo;
    var st=STAGES.find(function(z){ return z.key==='costeo'; });
    if(pi>=0 && (sp.stepIdx||0)<=pi){
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      guardarEtapa(oid,'costeo');
    }
  }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  COSTEO DE IMPORTACIÓN
//  Importación sube el costeo o lo genera desde SAP, lo manda a revisar, y
//  cuando los precios ya están cargados en SAP marca el visto.
// ═══════════════════════════════════════════════════════════════════════════
function _costPanel(oid){
  var sk=_subKeyCost(_PASO_COSTEO);
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var env=_solEnvioLeer(oid,'costeo');
  var d=_logLeer(oid);
  // El paso se da por hecho cuando el costeo se envió a gerencia
  var enviado=!!env;

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(enviado?'sem-g':(files.length?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-table"></i> Costeo de importación</div>'
    +(enviado?'<span style="font-size:10px;font-weight:700;color:var(--t-verde);background:var(--pastel-ok);border-radius:6px;padding:2px 8px">ENVIADO A GERENCIA</span>':'')
    +'</div>';

  h+=_aduZona(oid, sk, 'ARCHIVO DEL COSTEO', 'Sube el Excel o el PDF del costeo, o generalo desde SAP', '#7C3D12');

  if(_puedeAduana()){
    var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();
    var yaBajado=!!(d.costeo && d.costeo.sap);

    // Se explica de dónde sale el costeo, para no tener que adivinarlo
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;margin-bottom:9px">'
      +'<div style="font-size:10.5px;font-weight:700;color:var(--t-azul);margin-bottom:3px">'
        +'<i class="ti ti-database"></i> TRAER EL COSTEO DESDE SAP</div>'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:7px">'
        +(entrada
          ? ('Número de entrada <b style="color:var(--t-azul);font-size:12px">'+_esc(entrada)+'</b> '
             +'<span style="font-size:10px">(tomado del aviso de llegada)</span>. '
             +'Se consulta la pantalla Landed Costs de SAP y primero se muestra aquí.')
          : '<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Falta el número de entrada del aviso de llegada. Al pulsar te lo va a pedir.</span>')
      +'</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap">'
        +'<button class="btn bp" style="background:#0c447c;font-size:12px;padding:8px 15px;font-weight:700" onclick="event.stopPropagation();_costGenerar(\'' + oid + '\')">'
          +'<i class="ti ti-database-import"></i> '+(yaBajado?'Volver a consultar SAP':'Generar costeo desde SAP')+'</button>'
        +(yaBajado?('<button class="btn bp" style="background:#166534;font-size:12px;padding:8px 15px;font-weight:700" onclick="event.stopPropagation();_costVerUltimo(\'' + oid + '\')">'
          +'<i class="ti ti-file-spreadsheet"></i> Ver y descargar el Excel</button>'):'')
        +(files.length?('<button class="btn bp" style="background:#7C3D12;font-size:12px;padding:8px 15px" onclick="event.stopPropagation();_costEnviarModal(\'' + oid + '\')">'
          +'<i class="ti ti-mail"></i> Enviar por correo</button>'):'')
      +'</div>'
      +'<div id="costgen-'+oid+'" style="margin-top:8px"></div>'
      +'</div>';
  }

  if(env){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;margin-bottom:8px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> Costeo enviado a revisión</div>'
      +'<div style="font-size:11px;color:var(--t-verde);margin-top:2px">'
        +'Por <b>'+_esc(env.por||'')+'</b> · '+_esc(_fechaHora(env.fecha))
        +(env.para&&env.para.length?('<br>A: '+_esc(env.para.join(', '))):'')
      +'</div></div>';
  }

  return h+'</div>';
}

// Genera el costeo con las líneas de la orden traídas de SAP
// ═══════════════════════════════════════════════════════════════════════════
//  COSTEO DESDE SAP
//  Se pide con el número de entrada del aviso de llegada. El worker consulta
//  la pantalla Landed Costs de SAP y devuelve las líneas y los gastos. Aquí se
//  muestran en pantalla y, si se confirma, se arma el Excel.
// ═══════════════════════════════════════════════════════════════════════════
async function _costGenerar(oid){
  var cont=document.getElementById('costgen-'+oid);
  var d=_logLeer(oid);
  var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();

  if(!entrada){
    var txt=prompt('Para traer el costeo de SAP hace falta el NÚMERO DE ENTRADA.\n\n'
      +'Es el que se carga en el aviso de llegada (por ejemplo: 153/26).\n\nEscribilo:','');
    if(txt===null) return;
    entrada=String(txt).trim();
    if(!entrada){ showT('Sin número de entrada no se puede consultar SAP'); return; }
    d.arrival=d.arrival||{};
    d.arrival.entrada=entrada;
    await _logGuardar(oid);
  }

  if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> '
    +'Consultando SAP con la entrada '+_esc(entrada)+'…</span>';

  // Se encola el pedido para el worker
  var fid=null;
  try{
    var r=await fetch(SB+'/rest/v1/costeo_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify({docnum:String(oid), entrada:entrada,
                           pedido_por:(CU&&CU.name)||'', estado:'pendiente',
                           creado_en:new Date().toISOString()})});
    if(!r.ok){
      var t=await r.text();
      if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">'
        +(/does not exist|Could not find the table/i.test(t)
          ? 'Falta la tabla costeo_queue en Supabase (script costeo_sap.sql).'
          : ('No se pudo pedir el costeo (error '+r.status+').'))+'</div>';
      return;
    }
    var f=await r.json();
    fid=(Array.isArray(f)&&f[0])?f[0].id:null;
  }catch(e){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">Error de conexión: '+_esc(e.message||e)+'</div>';
    return;
  }
  if(!fid){ if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">No se pudo registrar el pedido.</div>'; return; }
  _costEsperar(oid, fid, 0);
}

// Espera la respuesta del worker
function _costEsperar(oid, fid, intento){
  var cont=document.getElementById('costgen-'+oid);
  var espera = intento===0 ? 2000 : (intento<20 ? 3000 : 6000);
  setTimeout(async function(){
    var fila=null;
    try{
      var r=await fetch(SB+'/rest/v1/costeo_queue?select=*&id=eq.'+fid+'&limit=1',{headers:SBH});
      if(r.ok){ var a=await r.json(); fila=(Array.isArray(a)&&a[0])?a[0]:null; }
    }catch(e){}
    if(!fila){
      if(intento<40) return _costEsperar(oid, fid, intento+1);
      if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">SAP no respondió. Probá de nuevo en un momento.</div>';
      return;
    }
    if(fila.estado==='pendiente'||fila.estado==='procesando'){
      if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> '
        +(fila.estado==='procesando'?'Leyendo el costeo en SAP':'En cola')+'… ('+(intento*3)+'s)</span>';
      if(intento<60) return _costEsperar(oid, fid, intento+1);
      if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">La consulta está tardando demasiado. Revisa que el worker esté corriendo.</div>';
      return;
    }
    if(fila.estado==='error'){
      if(cont) cont.innerHTML='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-rojo)">'
        +'<i class="ti ti-alert-triangle"></i> '+_esc(fila.detalle||'No se pudo traer el costeo')+'</div>';
      return;
    }
    // Llegó el costeo
    var datos=fila.datos;
    if(typeof datos==='string'){ try{ datos=JSON.parse(datos); }catch(e){ datos=null; } }
    if(!datos || !Array.isArray(datos.lineas)){
      if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">SAP respondió pero sin líneas.</div>';
      return;
    }
    window._costDatos=window._costDatos||{};
    window._costDatos[oid]=datos;
    if(cont) cont.innerHTML='';
    _costPreview(oid, datos);
  }, espera);
}

// Vista previa antes de descargar
// Vista previa con el mismo formato que el PDF de SAP
// Completa las líneas del costeo con los datos del inventario del portal:
// la foto y el precio de venta que ya se ven bien en Consulta de inventario.
// Antes cada uno se resolvía por separado y no coincidían.
async function _costEnriquecer(datos){
  if(!datos || !Array.isArray(datos.lineas) || !datos.lineas.length) return datos;
  var codigos=Array.from(new Set(datos.lineas
    .map(function(l){ return String(l.referencia||'').trim(); })
    .filter(Boolean)));
  if(!codigos.length) return datos;

  var mapa={};
  // Lo que ya esté cargado en memoria
  try{
    (_invRows||[]).forEach(function(r){
      if(r && r.itemcode) mapa[String(r.itemcode).trim().toUpperCase()]=r;
    });
  }catch(e){}

  // Y lo que falte, del inventario
  var faltan=codigos.filter(function(c){ return !mapa[c.toUpperCase()]; });
  for(var i=0;i<faltan.length;i+=120){
    var lote=faltan.slice(i,i+120);
    var lst=lote.map(function(c){ return '"'+c.replace(/"/g,'')+'"'; }).join(',');
    try{
      // Los mismos campos que usa la ficha, para que el precio sea idéntico
      var url=SB+'/rest/v1/inventario?select='+_INV_CAMPOS
        +'&itemcode=in.('+encodeURIComponent(lst)+')&limit=500';
      var r=await fetch(url,{headers:SBH});
      if(!r.ok) continue;
      (await r.json()||[]).forEach(function(x){
        if(!x || !x.itemcode) return;
        var k=String(x.itemcode).trim().toUpperCase();
        mapa[k]=x;
        // Se guarda para que la ficha abra al instante
        window._invFichaCache=window._invFichaCache||{};
        window._invFichaCache[k]=x;
      });
    }catch(e){ console.warn('inventario para el costeo:',e); }
  }

  var conFoto=0, conPV=0;
  datos.lineas.forEach(function(l){
    var x=mapa[String(l.referencia||'').trim().toUpperCase()];
    if(!x) return;
    // La foto del inventario manda: usa el mismo nombre que ya funciona ahí
    if(x.picturname){ l.foto=x.picturname; conFoto++; }
    // Y el precio de venta también: es el que se ve en Consulta de inventario
    var pv=Number(x.precioventa)||Number(x.precio1)||0;
    if(pv>0){
      l.precio_venta=pv;
      var cif=Number(l.cif_unit)||0;
      l.margen=pv?Number((((pv-cif)/pv)*100).toFixed(4)):0;
      conPV++;
    }
    if(!l.descripcion && x.itemname) l.descripcion=x.itemname;
  });
  var sinPV=datos.lineas.filter(function(l){ return !(Number(l.precio_venta)>0); })
                       .map(function(l){ return l.referencia; });
  console.log('[costeo] inventario: '+conFoto+' foto(s) y '+conPV+' precio(s) de '+datos.lineas.length+' línea(s)');
  if(sinPV.length) console.warn('[costeo] sin precio de venta en el inventario:', sinPV);
  datos._enriquecido={fotos:conFoto, precios:conPV, total:datos.lineas.length, sinPrecio:sinPV};
  return datos;
}

async function _costPreview(oid, datos){
  // Las fotos y los precios se traen del inventario SIEMPRE, venga el costeo
  // recién de SAP o se esté reabriendo uno guardado.
  try{ datos=await _costEnriquecer(datos); }catch(e){ console.warn('enriquecer:',e); }
  window._costDatos=window._costDatos||{};
  window._costDatos[oid]=datos;
  var t=datos.totales||{};
  var prev=document.getElementById('modalCostPrev'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCostPrev';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:14px;overflow-y:auto';

  // Siempre en-US: con el navegador en español salía "1305,04" en vez de "1,305.04"
  function n2(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function n4(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:4,maximumFractionDigits:4}); }
  function n5(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:5,maximumFractionDigits:5}); }
  function ent(v){ return (Number(v)||0).toLocaleString('en-US'); }

  var filas=datos.lineas.map(function(l,i){
    var ref=String(l.referencia||'');
    // Se resuelve igual que en el inventario, con sus alternativas de nombre
    var foto='';
    try{ foto=l.foto?_repFotoUrl(l.foto):''; }catch(e){ foto=l.foto?(FOTO_BASE+encodeURIComponent(l.foto)):''; }
    return '<tr style="border-bottom:0.5px solid var(--border)">'
      +'<td style="padding:3px 6px;color:var(--text-muted);text-align:right">'+(l.nro||i+1)+'</td>'
      // La miniatura crece al pasar el mouse, sin abrir nada
      +'<td style="padding:2px 4px;width:38px">'
        +(foto?('<img src="'+_esc(foto)+'" class="cost-mini" alt="" '
                +'onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(ref.replace(/\x27/g,''))+'\')" '
                +'onerror="_costFotoAlt(this,\''+_esc(String(l.foto||'').replace(/\x27/g,''))+'\')">')
             :'<span style="display:inline-block;width:30px;height:30px;border-radius:5px;background:var(--surface-1)"></span>')
      +'</td>'
      +'<td style="padding:3px 6px;font-family:monospace;font-size:10.5px;white-space:nowrap">'
        +'<span onclick="event.stopPropagation();_invFicha(\''+_esc(ref.replace(/\x27/g,''))+'\')" '
        +'style="color:var(--text-accent);cursor:pointer;text-decoration:underline" title="Ver la ficha del producto">'
        +_esc(ref)+'</span></td>'
      +'<td style="padding:3px 6px;max-width:240px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" title="'+_esc(l.descripcion||'')+'">'+_esc(l.descripcion||'')+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n2(l.piezas_x_bulto)+'</td>'
      +'<td style="padding:3px 6px;text-align:center">'+_esc(l.empaque||'PZA')+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+ent(l.bultos)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n5(l.medida)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n5(l.medida_total)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+ent(l.cantidad)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n4(l.fob_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;font-weight:600">'+n4(l.fob_total)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;color:var(--t-marron)">'+n4(l.gasto_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n4(l.cif_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;font-weight:700">'+n2(l.cif_total)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;color:var(--t-verde)">'+n2(l.precio_venta)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;color:var(--t-verde);font-weight:600">'+n4(l.margen)+'</td>'
      +'</tr>';
  }).join('');

  var gastos=(datos.gastos||[]).map(function(g){
    var cod=String(g.codigo||'');
    var solocod=(cod && String(g.concepto||'')===cod);   // no se encontró el nombre
    return '<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:3px 7px">'
        +(solocod?('<span style="color:var(--t-ambar)" title="No se encontró el nombre de este código en SAP">'+_esc(cod)+'</span>')
                 :(_esc(g.concepto||'')+(cod?('<span style="font-size:9.5px;color:var(--text-muted);margin-left:6px">'+_esc(cod)+'</span>'):'')))
      +'</td>'
      +'<td style="padding:3px 7px;text-align:right;font-weight:600">'+n2(g.monto)+'</td>'
      +'<td style="padding:3px 7px;font-size:10px;color:var(--text-muted)">'+_esc(g.prorrateo||'')+'</td>'
      +'</tr>';
  }).join('');

  function th(txt, ali){
    return '<th style="padding:5px 6px;text-align:'+(ali||'left')+';font-size:9px;text-transform:uppercase;'
      +'color:var(--text-muted);font-weight:700;white-space:nowrap;background:var(--surface-1);'
      +'position:sticky;top:0;z-index:2;border-bottom:1px solid var(--border)">'+txt+'</th>';
  }

  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:16px;width:100%;max-width:1240px;max-height:94vh;overflow-y:auto">'
    // Cabecera igual al PDF
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:10px">'
      +'<div style="font-size:12px;line-height:1.5">'
        +'<div style="font-size:14px;font-weight:800">KENNEDY CENTER CORP.</div>'
        +'<div><b>COSTO DE IMPORTACION:</b> '+_esc(datos.costo_importacion||'')+'</div>'
        +'<div><b>ENTRADA No:</b> '+_esc(datos.entrada||'')+(datos.fecha?('   <b>FECHA:</b> '+_esc(datos.fecha)):'')+'</div>'
        +'<div><b>FACTURA No:</b> '+_esc(datos.factura||'')
          +'   <b>SUPLIDOR:</b> '+_esc(datos.suplidor_codigo||'')+' '+_esc(datos.suplidor||'')+'</div>'
      +'</div>'
      +'<button onclick="_costPrevCerrar(\'' + oid + '\')" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>'

    +'<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden;margin-bottom:12px">'
      +'<div style="max-height:430px;overflow:auto">'
      +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
      +'<thead><tr>'
        +th('','left')+th('#','right')+th('Referencia')+th('Descripción')
        +th('Blt x/c','right')+th('Empaque','center')+th('Cant. blts','right')
        +th('Medida x bto','right')+th('Medida total','right')+th('Cant.','right')
        +th('F.O.B.','right')+th('Costo total','right')
        +th('Gastos','right')+th('C.I.F.','right')+th('Costo total','right')
        +th('Precio venta','right')+th('%','right')
      +'</tr></thead><tbody>'+filas+'</tbody>'
      +'<tfoot><tr style="background:var(--surface-1);font-weight:800;position:sticky;bottom:0">'
        +'<td colspan="6" style="padding:6px;text-align:right">TOTAL</td>'
        +'<td style="padding:6px;text-align:right">'+ent(t.bultos)+'</td>'
        +'<td></td>'
        +'<td style="padding:6px;text-align:right">'+n5(t.medida)+'</td>'
        +'<td style="padding:6px;text-align:right">'+ent(t.cantidad)+'</td>'
        +'<td></td>'
        +'<td style="padding:6px;text-align:right">'+n4(t.fob)+'</td>'
        +'<td></td><td></td>'
        +'<td style="padding:6px;text-align:right">$ '+n2(t.cif)+'</td>'
        +'<td></td><td></td>'
      +'</tr></tfoot></table></div></div>'

    +((datos.gastos||[]).length?('<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden;margin-bottom:14px;max-width:640px">'
      +'<table style="width:100%;border-collapse:collapse;font-size:11.5px">'
      +'<tbody>'+gastos+'</tbody>'
      +'<tfoot><tr style="background:var(--surface-1);font-weight:800;border-top:1px solid var(--border)">'
        +'<td style="padding:5px 7px">TOTAL GASTOS</td>'
        +'<td style="padding:5px 7px;text-align:right">'+n2(t.gastos)+'</td><td></td>'
      +'</tr></tfoot></table></div>'):'')

    // Control: FOB + gastos = CIF
    // De dónde salieron los precios, para poder contrastarlo
    +((datos._enriquecido)?('<div style="background:'+(datos._enriquecido.sinPrecio&&datos._enriquecido.sinPrecio.length?'#FEF3E8':'#e6f1fb')
      +';border:1px solid '+(datos._enriquecido.sinPrecio&&datos._enriquecido.sinPrecio.length?'#E9C08A':'#85B7EB')
      +';border-radius:8px;padding:7px 11px;margin-bottom:10px;font-size:11px;color:'
      +(datos._enriquecido.sinPrecio&&datos._enriquecido.sinPrecio.length?'#7C3D12':'#0c447c')+'">'
      +'<i class="ti ti-info-circle"></i> Precio de venta y fotos tomados del inventario del portal · '
      +datos._enriquecido.precios+'/'+datos._enriquecido.total+' con precio · '
      +datos._enriquecido.fotos+'/'+datos._enriquecido.total+' con foto'
      +((datos._enriquecido.sinPrecio&&datos._enriquecido.sinPrecio.length)
        ?('<br>Sin precio en el inventario: '+_esc(datos._enriquecido.sinPrecio.slice(0,8).join(', '))
          +(datos._enriquecido.sinPrecio.length>8?(' y '+(datos._enriquecido.sinPrecio.length-8)+' más'):''))
        :'')
      +'</div>'):'')
    +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px">'
      +_costKpi('Total F.O.B.', n2(t.fob), '#166534')
      +_costKpi('Total gastos', n2(t.gastos), '#7C3D12')
      +_costKpi('Total C.I.F.', n2(t.cif), '#991b1b')
      +(Math.abs(((t.fob||0)+(t.gastos||0))-(t.cif||0))<1
        ? '<div style="flex:1;min-width:170px;background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px">'
          +'<div style="font-size:9.5px;color:var(--t-verde);font-weight:700;text-transform:uppercase">Verificación</div>'
          +'<div style="font-size:12px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> FOB + gastos = CIF</div></div>'
        : '<div style="flex:1;min-width:170px;background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:7px 10px">'
          +'<div style="font-size:9.5px;color:var(--t-rojo);font-weight:700;text-transform:uppercase">Verificación</div>'
          +'<div style="font-size:11.5px;font-weight:700;color:var(--t-rojo)">No cuadra por '
          +n2(Math.abs(((t.fob||0)+(t.gastos||0))-(t.cif||0)))+'</div></div>')
    +'</div>'

    +'<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div id="costprev-pie" style="font-size:11.5px;color:var(--text-muted)">'+datos.lineas.length+' línea(s). ¿Descargar en Excel y adjuntar a la etapa?</div>'
      +'<div style="display:flex;gap:8px">'
        +'<button class="btn" onclick="_costPrevCerrar(\'' + oid + '\')">Cerrar</button>'
        +'<button class="btn bp" id="costpdf-btn" style="background:#B91C1C" onclick="_costPDF(\'' + oid + '\')">'
          +'<i class="ti ti-file-type-pdf"></i> Descargar PDF</button>'
        +'<button class="btn bp" id="costprev-btn" style="background:#166534" onclick="_costDescargar(\'' + oid + '\')">'
          +'<i class="ti ti-file-spreadsheet"></i> Descargar Excel y adjuntar</button>'
      +'</div></div>'
    +'</div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
}

// Si la foto no cargó con el primer nombre, se prueban las variantes
// (minúsculas, otra extensión) igual que hace el inventario.
// ═══════════════════════════════════════════════════════════════════════════
//  VISTA PREVIA DE ADJUNTOS
//  Al pasar el mouse sobre el nombre de un archivo se ve una miniatura sin
//  tener que abrirlo. Las imágenes se muestran directo y los PDF con su
//  primera página.
// ═══════════════════════════════════════════════════════════════════════════
window._prevCache=window._prevCache||{};

function _prevTipo(nombre){
  var e=String(nombre||'').split('?')[0].split('.').pop().toLowerCase();
  if(['jpg','jpeg','png','gif','webp','bmp','svg'].indexOf(e)>=0) return 'img';
  if(e==='pdf') return 'pdf';
  if(['xlsx','xls','csv'].indexOf(e)>=0) return 'xls';
  if(['doc','docx'].indexOf(e)>=0) return 'doc';
  return 'otro';
}

// Atributos para que un elemento muestre la vista previa al pasar el mouse
function _prevAttrs(url, nombre){
  if(!url) return '';
  return ' onmouseenter="_prevMostrar(event,\''+_esc(String(url).replace(/'/g,''))+'\',\''
    +_esc(String(nombre||'').replace(/'/g,''))+'\')"'
    +' onmouseleave="_prevOcultar()"';
}

function _prevOcultar(){
  var p=document.getElementById('prevFlota');
  if(p) p.remove();
  if(window._prevTimer){ clearTimeout(window._prevTimer); window._prevTimer=null; }
}

function _prevMostrar(ev, url, nombre){
  _prevOcultar();
  var tipo=_prevTipo(nombre);
  if(tipo==='otro') return;

  var x=(ev&&ev.clientX)||100, y=(ev&&ev.clientY)||100;
  var caja=document.createElement('div');
  caja.id='prevFlota';
  caja.style.cssText='position:fixed;z-index:13000;background:var(--surface-0);'
    +'border:1px solid var(--border);border-radius:12px;box-shadow:0 14px 44px rgba(0,0,0,.32);'
    +'padding:9px;pointer-events:none;max-width:660px';
  // El tamaño se ajusta a la pantalla, sin pasarse de lo que entra
  var ANCHO=Math.min(620, Math.max(320, window.innerWidth-120));
  var ALTO =Math.min(430, Math.max(220, window.innerHeight-180));
  caja.innerHTML='<div style="font-size:11px;color:var(--text-secondary);margin-bottom:6px;font-weight:600;'
    +'max-width:'+ANCHO+'px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(nombre||'')+'</div>'
    +'<div id="prev-cuerpo" style="width:'+ANCHO+'px;height:'+ALTO+'px;display:flex;align-items:center;'
    +'justify-content:center;background:var(--surface-1);border-radius:8px;color:var(--text-muted);font-size:11px">'
    +'<span class="ai-ring g"></span></div>';
  document.body.appendChild(caja);

  // Se coloca sin salirse de la pantalla. Si no entra a la derecha del cursor,
  // se pone a la izquierda; lo mismo arriba y abajo.
  var an=ANCHO+22, al=ALTO+46;
  var izq=x+18;
  if(izq+an > window.innerWidth-10) izq=Math.max(10, x-an-18);
  var arr=y+18;
  if(arr+al > window.innerHeight-10) arr=Math.max(10, window.innerHeight-al-10);
  caja.style.left=izq+'px';
  caja.style.top =arr+'px';

  var cuerpo=document.getElementById('prev-cuerpo');
  if(tipo==='img'){
    var im=new Image();
    im.onload=function(){
      if(!document.getElementById('prevFlota')) return;
      cuerpo.innerHTML='';
      im.style.cssText='max-width:'+ANCHO+'px;max-height:'+ALTO+'px;object-fit:contain;border-radius:7px';
      cuerpo.appendChild(im);
    };
    im.onerror=function(){ if(cuerpo) cuerpo.innerHTML='No se pudo cargar la imagen'; };
    im.src=url;
    return;
  }
  if(tipo==='pdf'){
    // La primera página del PDF, en un visor sin controles
    cuerpo.innerHTML='<iframe src="'+_esc(url)+'#page=1&toolbar=0&navpanes=0&view=FitH" '
      +'style="width:'+ANCHO+'px;height:'+ALTO+'px;border:0;border-radius:7px;background:var(--surface-2)"></iframe>';
    return;
  }
  if(tipo==='xls' || tipo==='doc'){
    cuerpo.innerHTML='<div style="text-align:center;padding:14px">'
      +'<i class="ti ti-'+(tipo==='xls'?'file-spreadsheet':'file-text')+'" '
      +'style="font-size:56px;color:'+(tipo==='xls'?'#15803D':'#0c447c')+'"></i>'
      +'<div style="margin-top:9px;font-size:12.5px">Pulsa el archivo para abrirlo</div></div>';
  }
}

function _costFotoAlt(img, nombre){
  if(!img) return;
  if(!nombre){ _costFotoVacia(img); return; }
  var i=Number(img.getAttribute('data-alt')||0);
  var alts=[];
  // Primero las variantes que ya conoce el portal
  try{ if(typeof _fotoUrls==='function') alts=_fotoUrls(nombre)||[]; }catch(e){}
  var base=String(nombre).trim();
  var sinExt=base.replace(/\.[^.]+$/,'');
  ['', '.jpg', '.JPG', '.jpeg', '.png', '.PNG', '.webp'].forEach(function(ext){
    var n = ext ? (sinExt+ext) : base;
    [n, n.toLowerCase(), n.toUpperCase()].forEach(function(v){
      var u=FOTO_BASE+encodeURIComponent(v);
      if(alts.indexOf(u)<0) alts.push(u);
    });
  });
  // Antes de rendirse: la foto del catálogo NO SAP, si el artículo tiene una.
  // SAP declara nombres de imágenes que no están en el bucket, y esa suele
  // ser la única que existe de verdad.
  if(i>=alts.length){
    try{
      var _alt=img.getAttribute('data-nosap')||'';
      if(_alt && !img.dataset.nosapProbado){
        img.dataset.nosapProbado='1';
        img.src=_alt;
        return;
      }
    }catch(e){}
    _costFotoVacia(img); return;
  }
  img.setAttribute('data-alt', i+1);
  img.src=alts[i];
}

// Cuando ninguna variante sirve: en vez de un icono roto, un recuadro gris
function _costFotoVacia(img){
  try{
    var w=img.offsetWidth||img.width||30, h=img.offsetHeight||img.height||30;
    var rep=document.createElement('div');
    rep.style.cssText='width:'+w+'px;height:'+h+'px;border-radius:6px;background:var(--surface-1);'
      +'border:0.5px solid var(--border);display:flex;align-items:center;justify-content:center;'
      +'color:var(--text-muted);font-size:'+Math.max(9,Math.round(w/4))+'px';
    rep.innerHTML='<i class="ti ti-photo-off"></i>';
    rep.title='Este artículo no tiene foto en el sistema';
    if(img.parentNode) img.parentNode.replaceChild(rep, img);
  }catch(e){ img.style.visibility='hidden'; }
}

function _costKpi(etiqueta, valor, color){
  return '<div style="flex:1;min-width:112px;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:7px 10px">'
    +'<div style="font-size:9.5px;color:var(--text-muted);font-weight:600;text-transform:uppercase">'+_esc(etiqueta)+'</div>'
    +'<div style="font-size:14px;font-weight:700;color:'+color+'">'+valor+'</div></div>';
}

// Arma el Excel con el formato del PDF de SAP y lo adjunta
// Arma el Excel con el formato del PDF de SAP, con las fotos incrustadas
// ── PDF del costeo, con el mismo contenido que el Excel ──
// Cierra la ventana del costeo y recién ahí refresca la etapa
function _costPrevCerrar(oid){
  var m=document.getElementById('modalCostPrev');
  if(m) m.remove();
  try{ _costRepintar(oid); }catch(e){}
}

async function _costPDF(oid){
  var datos=(window._costDatos||{})[oid];
  if(!datos){ showT('No hay datos del costeo'); return; }
  if(!window.jspdf || !window.jspdf.jsPDF){ showT('No se pudo cargar el generador de PDF'); return; }

  var btn=document.getElementById('costpdf-btn');
  function estado(t){ if(btn) btn.innerHTML=t; }
  if(btn) btn.disabled=true;
  estado('Armando el PDF…');

  try{
    var t=datos.totales||{};
    var dat=_solPagoDatosOrden(oid);
    var jsPDF=window.jspdf.jsPDF;
    // Apaisado: son 16 columnas
    var doc=new jsPDF({orientation:'landscape', unit:'pt', format:'letter', compress:true});
    var W=doc.internal.pageSize.getWidth();

    function n2(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
    function n4(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:4,maximumFractionDigits:4}); }
    function n5(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:5,maximumFractionDigits:5}); }
    function ent(v){ return (Number(v)||0).toLocaleString('en-US'); }

    // Las fotos, para incrustarlas en la tabla
    estado('Bajando fotos…');
    var fotos={};
    for(var i=0;i<datos.lineas.length;i++){
      var l=datos.lineas[i];
      if(!l.foto) continue;
      if(i%10===0) estado('Bajando fotos… '+i+'/'+datos.lineas.length);
      try{
        // Comprimida, igual que en el Excel
        var im=await _costFotoChica(l.foto, 140, 0.5);
        if(im) fotos[i]=im.dataUrl;
      }catch(e){}
    }
    estado('Generando…');

    // Cabecera, igual que el PDF de SAP
    doc.setFont('helvetica','bold'); doc.setFontSize(13);
    doc.text('KENNEDY CENTER CORP.', 30, 34);
    doc.setFontSize(9);
    doc.text('COSTO DE IMPORTACION: '+(datos.costo_importacion||''), 30, 50);
    doc.text('ENTRADA No: '+(datos.entrada||'')+(datos.fecha?('    FECHA: '+datos.fecha):''), 30, 63);
    doc.text('FACTURA No: '+(datos.factura||'')
      +'    SUPLIDOR: '+(datos.suplidor_codigo||'')+' '+(datos.suplidor||''), 30, 76);
    doc.setFont('helvetica','normal'); doc.setFontSize(8);
    doc.text('Generado el '+now2()+' por '+((CU&&CU.name)||''), W-30, 34, {align:'right'});

    var cuerpo=datos.lineas.map(function(l,i){
      return ['', String(l.nro||i+1), l.referencia||'', l.descripcion||'',
        n2(l.piezas_x_bulto), l.empaque||'PZA', ent(l.bultos),
        n5(l.medida), n5(l.medida_total||((l.medida||0)*(l.bultos||0))),
        ent(l.cantidad), n4(l.fob_unit), n4(l.fob_total),
        n4(l.gasto_unit), n4(l.cif_unit), n2(l.cif_total),
        n2(l.precio_venta), n4(l.margen)];
    });
    cuerpo.push(['', '', 'TOTAL', '', '', '', ent(t.bultos), '', n5(t.medida),
                 ent(t.cantidad), '', n4(t.fob), '', '', '$ '+n2(t.cif), '', '']);

    doc.autoTable({
      startY: 88,
      head: [['FOTO','#','REFERENCIA','DESCRIPCION','BLT X/C','EMPAQUE','CANT. BLTS',
              'MEDIDA X BTO','MEDIDA TOTAL','CANT.','F.O.B.','COSTO TOTAL',
              'GASTOS','C.I.F.','COSTO TOTAL','PRECIO VENTA','%']],
      body: cuerpo,
      theme: 'grid',
      styles: {fontSize:6.2, cellPadding:2, overflow:'ellipsize', valign:'middle'},
      headStyles: {fillColor:[240,240,240], textColor:[40,40,40], fontStyle:'bold', fontSize:5.8, halign:'center'},
      columnStyles: {
        0:{cellWidth:26, minCellHeight:26},
        1:{cellWidth:16, halign:'right'},
        2:{cellWidth:52},
        3:{cellWidth:120},
        4:{cellWidth:32, halign:'right'}, 5:{cellWidth:34, halign:'center'},
        6:{cellWidth:36, halign:'right'}, 7:{cellWidth:46, halign:'right'},
        8:{cellWidth:48, halign:'right'}, 9:{cellWidth:36, halign:'right'},
        10:{cellWidth:40, halign:'right'}, 11:{cellWidth:48, halign:'right'},
        12:{cellWidth:38, halign:'right'}, 13:{cellWidth:38, halign:'right'},
        14:{cellWidth:48, halign:'right'}, 15:{cellWidth:42, halign:'right'},
        16:{cellWidth:34, halign:'right'}
      },
      // La última fila es la de totales
      didParseCell: function(d){
        if(d.section==='body' && d.row.index===cuerpo.length-1){
          d.cell.styles.fontStyle='bold';
          d.cell.styles.fillColor=[245,245,245];
        }
      },
      // Las fotos se dibujan dentro de su celda
      didDrawCell: function(d){
        if(d.section!=='body' || d.column.index!==0) return;
        if(d.row.index>=datos.lineas.length) return;
        var src=fotos[d.row.index];
        if(!src) return;
        try{
          doc.addImage(src, 'JPEG', d.cell.x+2, d.cell.y+2,
                       d.cell.width-4, Math.min(d.cell.height-4, d.cell.width-4));
        }catch(e){}
      },
      margin: {left:20, right:20, bottom:40}
    });

    // Los gastos
    var y=doc.lastAutoTable.finalY+18;
    if((datos.gastos||[]).length){
      if(y > doc.internal.pageSize.getHeight()-120){ doc.addPage(); y=40; }
      doc.autoTable({
        startY: y,
        head: [['CONCEPTO','MONTO','PRORRATEO']],
        body: (datos.gastos||[]).map(function(g){
          return [ (g.concepto||'')+(g.codigo&&g.concepto!==g.codigo?('  ('+g.codigo+')'):''),
                   n2(g.monto), g.prorrateo||'' ];
        }).concat([['TOTAL GASTOS', n2(t.gastos), '']]),
        theme: 'grid',
        styles: {fontSize:7.5, cellPadding:3},
        headStyles: {fillColor:[240,240,240], textColor:[40,40,40], fontStyle:'bold', fontSize:7},
        columnStyles: {0:{cellWidth:230}, 1:{cellWidth:80, halign:'right'}, 2:{cellWidth:160}},
        didParseCell: function(d){
          if(d.section==='body' && d.row.index===(datos.gastos||[]).length){
            d.cell.styles.fontStyle='bold';
            d.cell.styles.fillColor=[245,245,245];
          }
        },
        margin: {left:20, right:20}
      });
      y=doc.lastAutoTable.finalY+16;
    }

    // Resumen
    if(y > doc.internal.pageSize.getHeight()-70){ doc.addPage(); y=40; }
    doc.setFont('helvetica','bold'); doc.setFontSize(9);
    doc.text('TOTAL F.O.B.: '+n2(t.fob)
      +'      TOTAL GASTOS: '+n2(t.gastos)
      +'      TOTAL C.I.F.: '+n2(t.cif), 20, y);

    // Numeración de páginas
    var n=doc.internal.getNumberOfPages();
    for(var pg=1; pg<=n; pg++){
      doc.setPage(pg);
      doc.setFont('helvetica','normal'); doc.setFontSize(7.5);
      doc.text('Costo de importación '+(datos.costo_importacion||'')+' · entrada '+(datos.entrada||''),
               20, doc.internal.pageSize.getHeight()-18);
      doc.text('Página '+pg+' de '+n, W-20, doc.internal.pageSize.getHeight()-18, {align:'right'});
    }

    var nombre='Costeo_'+String(datos.costo_importacion||dat.dkc||oid).replace(/[^\w.\-]+/g,'_')+'.pdf';
    doc.save(nombre);

    // Y se adjunta a la etapa, sin cerrar la ventana
    try{
      var blob=doc.output('blob');
      var file=new File([blob], nombre, {type:'application/pdf'});
      await _costAdjuntarSilencioso(oid, _subKeyCost(_PASO_COSTEO), file);
    }catch(e){ console.warn('adjuntar PDF:',e); }

    showT('✓ PDF descargado y adjuntado a la etapa');
    if(btn){
      btn.disabled=false;
      btn.style.background='#0c447c';
      btn.innerHTML='<i class="ti ti-check"></i> PDF listo · volver a bajar';
    }
    var pie=document.getElementById('costprev-pie');
    if(pie) pie.innerHTML='<span style="color:var(--text-success);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> PDF descargado y adjuntado a la etapa</span>';
  }catch(e){
    console.error('pdf costeo:',e);
    showT('No se pudo armar el PDF: '+(e.message||e));
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-file-type-pdf"></i> Descargar PDF'; }
  }
}

// Adjunta un archivo al paso sin repintar la pantalla, para no cerrar
// la ventana que el usuario está mirando.
async function _costAdjuntarSilencioso(oid, sub, file){
  try{
    var pth=await _subirDocStorage(oid, sub, file);
    if(!pth) return false;
    var reg=await _registrarDoc(oid, sub, file, pth);
    if(!window._atts) window._atts={};
    if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
    window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:file.name,
      data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
      url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    return true;
  }catch(e){ console.warn('adjuntar costeo:',e); return false; }
}

async function _costDescargar(oid){
  var datos=(window._costDatos||{})[oid];
  if(!datos){ showT('No hay datos del costeo'); return; }
  var btn=document.getElementById('costprev-btn');
  function estado(t){ if(btn) btn.innerHTML=t; }
  if(btn) btn.disabled=true;
  estado('Armando el Excel…');

  try{
    var t=datos.totales||{};
    var dat=_solPagoDatosOrden(oid);
    var nombre='Costeo_'+String(datos.costo_importacion||dat.dkc||oid).replace(/[^\w.\-]+/g,'_')+'.xlsx';

    var ExcelJS=await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Costeo');

    // Cabecera, igual que el PDF
    ws.addRow(['KENNEDY CENTER CORP.']);
    ws.addRow(['COSTO DE IMPORTACION:', datos.costo_importacion||'']);
    ws.addRow(['ENTRADA No:', datos.entrada||'', 'FECHA:', datos.fecha||'']);
    ws.addRow(['FACTURA No:', datos.factura||'', 'SUPLIDOR:',
               (datos.suplidor_codigo||'')+' '+(datos.suplidor||'')]);
    ws.addRow([]);
    ws.getRow(1).font={bold:true, size:13};
    for(var r=2;r<=4;r++) ws.getRow(r).font={bold:true, size:10};

    var enc=['FOTO','#','REFERENCIA','DESCRIPCION','BLT X/C','EMPAQUE','CANT. BLTS',
             'MEDIDA X BTO','MEDIDA TOTAL','CANT.','F.O.B.','COSTO TOTAL',
             'GASTOS','C.I.F.','COSTO TOTAL','PRECIO VENTA','%'];
    var filaEnc=ws.addRow(enc);
    filaEnc.font={bold:true, size:9};
    filaEnc.alignment={vertical:'middle', horizontal:'center', wrapText:true};
    filaEnc.eachCell(function(c){
      c.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEEEEEE'}};
      c.border={bottom:{style:'thin'}};
    });

    var filaBase=ws.rowCount;
    datos.lineas.forEach(function(l,i){
      var f=ws.addRow(['', l.nro||i+1, l.referencia||'', l.descripcion||'',
        Number(l.piezas_x_bulto)||0, l.empaque||'PZA', Number(l.bultos)||0,
        Number((l.medida||0).toFixed(5)),
        Number((l.medida_total||((l.medida||0)*(l.bultos||0))).toFixed(5)),
        Number(l.cantidad)||0,
        Number((l.fob_unit||0).toFixed(4)), Number((l.fob_total||0).toFixed(4)),
        Number((l.gasto_unit||0).toFixed(4)), Number((l.cif_unit||0).toFixed(4)),
        Number((l.cif_total||0).toFixed(2)),
        Number((l.precio_venta||0).toFixed(2)), Number((l.margen||0).toFixed(4))]);
      f.height=46;                       // alto para que entre la foto
      f.alignment={vertical:'middle'};
    });

    // Totales
    ws.addRow([]);
    var ft=ws.addRow(['', '', 'TOTAL', '', '', '', Number(t.bultos)||0, '',
                      Number(t.medida)||0, Number(t.cantidad)||0, '',
                      Number(t.fob)||0, '', '', Number(t.cif)||0, '', '']);
    ft.font={bold:true};

    // Gastos
    if((datos.gastos||[]).length){
      ws.addRow([]);
      datos.gastos.forEach(function(g){
        ws.addRow(['', g.concepto||'', Number(g.monto)||0, g.prorrateo||'', g.codigo||'']);
      });
      var fg=ws.addRow(['', 'TOTAL GASTOS', Number(t.gastos)||0]);
      fg.font={bold:true};
    }

    ws.columns=[{width:8},{width:5},{width:15},{width:44},{width:9},{width:10},
                {width:11},{width:13},{width:14},{width:10},{width:11},{width:13},
                {width:11},{width:11},{width:13},{width:13},{width:10}];

    // Las fotos, una por línea
    var conFoto=0, pesoFotos=0;
    for(var i=0;i<datos.lineas.length;i++){
      var l=datos.lineas[i];
      if(!l.foto) continue;
      if(i%10===0) estado('Agregando fotos… '+i+'/'+datos.lineas.length);
      try{
        // Comprimida: el archivo tiene que poder mandarse por correo
        var im=await _costFotoChica(l.foto, 150, 0.55);
        if(!im) continue;
        pesoFotos+=im.kb||0;
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id, { tl:{col:0.15, row:(filaBase+i)+0.10},
                          ext:{width:52, height:52}, editAs:'oneCell' });
        conFoto++;
      }catch(e){}
    }

    estado('Descargando…');
    var buf=await wb.xlsx.writeBuffer();
    var blob=new Blob([buf], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

    // Se descarga en el equipo
    var a=document.createElement('a');
    a.href=URL.createObjectURL(blob);
    a.download=nombre;
    document.body.appendChild(a); a.click();
    setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 3000);

    // Y se adjunta a la etapa, sin repintar nada por debajo: el repintado
    // reconstruía la pantalla y cerraba esta ventana.
    var file=new File([blob], nombre, {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    await _costAdjuntarSilencioso(oid, _subKeyCost(_PASO_COSTEO), file);

    var d=_logLeer(oid);
    d.costeo=d.costeo||{};
    d.costeo.sap=datos;
    d.costeo.generado_en=new Date().toISOString();
    d.costeo.generado_por=(CU&&CU.name)||'';
    await _logGuardar(oid);

    // La ventana se queda abierta: la cierra el usuario cuando quiera
    showT('✓ Costeo descargado'+(conFoto?(' con '+conFoto+' foto(s), '+Math.round(pesoFotos/1024*10)/10+' MB en imágenes'):'')+' y adjuntado a la etapa');
    if(btn){
      btn.disabled=false;
      btn.style.background='#0c447c';
      btn.innerHTML='<i class="ti ti-check"></i> Descargado · volver a bajar';
    }
    // Aviso dentro de la ventana, para no depender del mensaje que se va
    try{
      var pie=document.getElementById('costprev-pie');
      if(pie) pie.innerHTML='<span style="color:var(--text-success);font-weight:600">'
        +'<i class="ti ti-circle-check"></i> Descargado y adjuntado a la etapa'
        +(conFoto?(' · '+conFoto+' foto(s)'):'')+'</span>';
    }catch(e){}

    try{
      var gers=(USERS||[]).filter(function(u){ return u.role==='gerencia' && u.id!==((CU&&CU.id)||''); });
      if(gers.length) await _menNotificar(gers, {
        docnum:oid, contexto:'etapa', etapa:'Aduanización & Costeo',
        texto:'Nuevo costeo en espera de precios de venta · costo de importación '+(datos.costo_importacion||''),
        etiqueta:'Costeo — pendiente de precios', paso:_PASO_PRECIOS
      });
    }catch(e){}
    // El panel de la etapa se refresca al cerrar esta ventana
  }catch(e){
    console.error('excel costeo:',e);
    showT('No se pudo armar el Excel: '+(e.message||e));
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-file-spreadsheet"></i> Descargar Excel y adjuntar'; }
  }
}


// Vuelve a abrir el último costeo consultado, sin pedirlo otra vez a SAP
function _costVerUltimo(oid){
  var d=_logLeer(oid);
  var datos=(d.costeo&&d.costeo.sap)||((window._costDatos||{})[oid]);
  if(!datos){ showT('Todavía no se consultó ningún costeo. Pulsa "Generar costeo desde SAP".'); return; }
  window._costDatos=window._costDatos||{};
  window._costDatos[oid]=datos;
  _costPreview(oid, datos);
}

function _costRepintar(oid){
  var _y=window.scrollY;
  setTimeout(function(){ window.scrollTo(0,_y); }, 0);
  var c=document.getElementById('costpanel-'+oid);
  if(c) c.innerHTML=_costPanel(oid);
  // Si el panel no está en pantalla no se reconstruye nada: reconstruir
  // sacaba al usuario del subpaso donde estaba trabajando.
  else { console.log('[panel] no está visible: no se repinta'); }
}

// Marca que los precios ya están en SAP
async function _costPreciosSap(oid, valor){
  var d=_logLeer(oid);
  d.costeo=d.costeo||{};
  if(valor){
    d.costeo.precios_sap=true;
    d.costeo.precios_sap_por=(CU&&CU.name)||'';
    d.costeo.precios_sap_en=new Date().toISOString();
  } else {
    if(!confirm('¿Desmarcar "Precios en SAP"?\n\nLa etapa vuelve a quedar pendiente.')){ _costRepintar(oid); return; }
    d.costeo.precios_sap=false;
    d.costeo.precios_sap_por='';
    d.costeo.precios_sap_en='';
  }
  await _logGuardar(oid);

  // El paso avanza o retrocede según el visto
  try{
    var st=STAGES.find(function(z){ return z.key==='costeo'; });
    var pi=_pasoIdxCost(_PASO_COSTEO);
    initP(oid);
    var sp=stageProgress[oid].costeo;
    if(valor && pi>=0 && (sp.stepIdx||0)<=pi){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pi+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pi]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pi]=(CU&&CU.name)||'';
      if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
      guardarEtapa(oid,'costeo');
    } else if(!valor && pi>=0 && (sp.stepIdx||0)>pi){
      sp.stepIdx=pi;
      if(sp.stepDates) sp.stepDates[pi]='';
      guardarEtapa(oid,'costeo');
    }
  }catch(e){}

  showT(valor?'✓ Precios en SAP. La etapa pasa a verde.':'Precios en SAP desmarcado');
  _costRepintar(oid);
  try{ openDetail(oid); }catch(e){}
}

// ── Enviar el costeo por correo ──
// Los archivos del costeo son los que empiezan por "Costeo"
function _costArchivos(oid){
  var sk=_subKeyCost(_PASO_COSTEO);
  var todos=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  return todos.filter(function(a){
    var n=String(a.name||'').trim().toLowerCase();
    return n.indexOf('costeo')===0 && /\.(xlsx|xls|pdf)$/i.test(n);
  });
}

// Arma un Excel liviano del costeo, sin fotos, para poder mandarlo por
// correo: el que lleva las fotos supera el límite de adjuntos.
// Baja una foto y la comprime para que quepa en el correo.
// En el Excel se ve a unos 52 puntos, así que 150 px de lado sobran: el peso
// pasa de ~200 KB a ~10 KB por foto y el archivo entra sin problema.
async function _costFotoChica(nombreArchivo, lado, calidad){
  lado=lado||150; calidad=(calidad==null?0.55:calidad);
  var urls=[];
  try{ urls.push(_repFotoUrl(nombreArchivo)); }catch(e){}
  urls.push(FOTO_BASE+encodeURIComponent(nombreArchivo));
  urls.push(FOTO_BASE+encodeURIComponent(String(nombreArchivo).toLowerCase()));
  urls.push(FOTO_BASE+encodeURIComponent(String(nombreArchivo).replace(/\.[^.]+$/,'.jpg')));

  for(var i=0;i<urls.length;i++){
    var u=urls[i];
    if(!u) continue;
    try{
      var img=await new Promise(function(res,rej){
        var im=new Image();
        im.crossOrigin='anonymous';
        im.onload=function(){ res(im); };
        im.onerror=function(){ rej(new Error('no carga')); };
        im.src=u;
        setTimeout(function(){ rej(new Error('tardó demasiado')); }, 30000);
      });
      // Se redimensiona manteniendo la proporción
      var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
      if(!w || !h) continue;
      var esc=Math.min(1, lado/Math.max(w,h));
      var cw=Math.max(1, Math.round(w*esc)), ch=Math.max(1, Math.round(h*esc));
      var cv=document.createElement('canvas');
      cv.width=cw; cv.height=ch;
      var cx=cv.getContext('2d');
      cx.fillStyle='#ffffff';           // fondo blanco: los PNG con transparencia salen negros
      cx.fillRect(0,0,cw,ch);
      cx.drawImage(img, 0, 0, cw, ch);
      var dataUrl=cv.toDataURL('image/jpeg', calidad);
      var b64=dataUrl.split(',')[1]||'';
      if(!b64) continue;
      return {b64:b64, ext:'jpeg', dataUrl:dataUrl,
              kb:Math.round(b64.length*0.75/1024), w:cw, h:ch};
    }catch(e){ /* se prueba la siguiente URL */ }
  }
  return null;
}

// Arma el Excel para el correo: mismos datos y con fotos, pero comprimidas
// para no pasarse del límite de adjuntos.
async function _costExcelCorreo(oid){
  var datos=(window._costDatos||{})[oid] || ((_logLeer(oid).costeo||{}).sap);
  if(!datos || !Array.isArray(datos.lineas) || !datos.lineas.length) return null;
  try{
    var t=datos.totales||{};
    var ExcelJS=await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Costeo');

    ws.addRow(['KENNEDY CENTER CORP.']);
    ws.addRow(['COSTO DE IMPORTACION:', datos.costo_importacion||'']);
    ws.addRow(['ENTRADA No:', datos.entrada||'', 'FECHA:', datos.fecha||'']);
    ws.addRow(['FACTURA No:', datos.factura||'', 'SUPLIDOR:',
               (datos.suplidor_codigo||'')+' '+(datos.suplidor||'')]);
    ws.addRow([]);
    ws.getRow(1).font={bold:true, size:13};
    for(var r=2;r<=4;r++) ws.getRow(r).font={bold:true, size:10};

    var filaEnc=ws.addRow(['FOTO','#','REFERENCIA','DESCRIPCION','BLT X/C','EMPAQUE','CANT. BLTS',
      'MEDIDA X BTO','MEDIDA TOTAL','CANT.','F.O.B.','COSTO TOTAL','GASTOS','C.I.F.',
      'COSTO TOTAL','PRECIO VENTA','%']);
    filaEnc.font={bold:true, size:9};
    filaEnc.alignment={vertical:'middle', horizontal:'center', wrapText:true};
    filaEnc.eachCell(function(c){
      c.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEEEEEE'}};
      c.border={bottom:{style:'thin'}};
    });

    var filaBase=ws.rowCount;
    datos.lineas.forEach(function(l,i){
      var f=ws.addRow(['', l.nro||i+1, l.referencia||'', l.descripcion||'',
        Number(l.piezas_x_bulto)||0, l.empaque||'PZA', Number(l.bultos)||0,
        Number((l.medida||0).toFixed(5)),
        Number((l.medida_total||((l.medida||0)*(l.bultos||0))).toFixed(5)),
        Number(l.cantidad)||0,
        Number((l.fob_unit||0).toFixed(4)), Number((l.fob_total||0).toFixed(4)),
        Number((l.gasto_unit||0).toFixed(4)), Number((l.cif_unit||0).toFixed(4)),
        Number((l.cif_total||0).toFixed(2)),
        Number((l.precio_venta||0).toFixed(2)), Number((l.margen||0).toFixed(4))]);
      f.height=46;
      f.alignment={vertical:'middle'};
    });

    ws.addRow([]);
    var ft=ws.addRow(['', '', 'TOTAL', '', '', '', Number(t.bultos)||0, '',
                      Number(t.medida)||0, Number(t.cantidad)||0, '',
                      Number(t.fob)||0, '', '', Number(t.cif)||0, '', '']);
    ft.font={bold:true};

    if((datos.gastos||[]).length){
      ws.addRow([]);
      datos.gastos.forEach(function(g){
        ws.addRow(['', g.concepto||'', Number(g.monto)||0, g.prorrateo||'', g.codigo||'']);
      });
      var fg=ws.addRow(['', 'TOTAL GASTOS', Number(t.gastos)||0]);
      fg.font={bold:true};
    }

    ws.columns=[{width:8},{width:5},{width:15},{width:44},{width:9},{width:10},
                {width:11},{width:13},{width:14},{width:10},{width:11},{width:13},
                {width:11},{width:11},{width:13},{width:13},{width:10}];

    // Las fotos, bien comprimidas para que el correo las acepte
    var conFoto=0;
    for(var i=0;i<datos.lineas.length;i++){
      var l=datos.lineas[i];
      if(!l.foto) continue;
      try{
        var im=await _costFotoChica(l.foto, 120, 0.45);
        if(!im) continue;
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id, { tl:{col:0.15, row:(filaBase+i)+0.10},
                          ext:{width:52, height:52}, editAs:'oneCell' });
        conFoto++;
      }catch(e){}
    }

    var buf=await wb.xlsx.writeBuffer();
    var dat=_solPagoDatosOrden(oid);
    var nombre='Costeo_'+String(datos.costo_importacion||dat.dkc||oid).replace(/[^\w.\-]+/g,'_')+'.xlsx';
    var b64=await new Promise(function(res,rej){
      var fr=new FileReader();
      fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
      fr.onerror=rej;
      fr.readAsDataURL(new Blob([buf]));
    });
    var kb=Math.round(buf.byteLength/1024);
    if(buf.byteLength > MAIL_MAX_MB*1024*1024){
      console.warn('[costeo] el excel comprimido sigue pesando', kb, 'KB');
      return null;
    }
    return { nombre:nombre,
             mime:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
             contenido:b64, kb:kb, fotos:conFoto };
  }catch(e){ console.warn('excel para el correo:',e); return null; }
}

// ═══════════════════════════════════════════════════════════════════════════
//  PRECIOS DE VENTA POR GERENCIA
//  Se muestra el mismo costeo de la etapa anterior, pero con el precio de
//  venta editable. Al cambiarlo se recalcula el margen de esa línea. Cuando
//  gerencia guarda, puede enviarlo a las compradoras del departamento con el
//  Excel de los precios nuevos.
// ═══════════════════════════════════════════════════════════════════════════
function _pvDatos(oid){
  var d=_logLeer(oid);
  // Los precios editados se guardan aparte, para no pisar el costeo original
  d.precios=d.precios||{};
  var base=(window._costDatos&&window._costDatos[oid]) || (d.costeo&&d.costeo.sap) || null;
  return {d:d, base:base};
}

// Marca un paso de Aduanización como completado. Se usa cuando se envía el
// correo: ese envío es lo que da el paso por terminado.
function _costeoMarcarPaso(oid, nombrePaso){
  var pi=_pasoIdxCost(nombrePaso);
  if(pi<0) return;
  var st=STAGES.find(function(z){ return z.key==='costeo'; });
  initP(oid);
  var sp=stageProgress[oid].costeo;
  if((sp.stepIdx||0)>pi) return;          // ya estaba completado
  var hoyIso=new Date().toISOString().slice(0,10);
  sp.stepIdx=pi+1;
  if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
  sp.stepDates[pi]=now2();
  if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
  sp.stepBy[pi]=(CU&&CU.name)||'';
  if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
  sp._isoPasos[pi]=hoyIso;
  if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
  guardarEtapa(oid,'costeo');
}

function _pvPanel(oid){
  var r=_pvDatos(oid);
  var base=r.base, d=r.d;
  var guardado=d.precios&&d.precios.guardado_en;
  var env=_solEnvioLeer(oid,'precios');

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(env?'sem-g':(guardado?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-tag"></i> Precios de venta</div>'
    +(env?('<span style="font-size:10px;color:var(--t-verde);background:var(--pastel-ok);border-radius:6px;padding:2px 8px;font-weight:700">ENVIADO A COMPRAS</span>')
          :(guardado?('<span style="font-size:10px;color:var(--t-ambar);background:var(--pastel-naranja);border-radius:6px;padding:2px 8px;font-weight:700">GUARDADOS · falta enviar</span>'):''))
    +'</div>';

  if(!base || !Array.isArray(base.lineas) || !base.lineas.length){
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;font-size:11.5px;color:var(--text-muted)">'
      +'<i class="ti ti-alert-circle" style="color:var(--t-ambar)"></i> Todavía no hay costeo cargado. '
      +'Primero hay que traerlo desde SAP en el paso <b>Costeo de importación</b>.'
      +(CU && _puedeAduana()
        ? '<div style="margin-top:7px"><button class="btn bg2" style="font-size:11px;padding:5px 11px" onclick="event.stopPropagation();_pvTraer(\'' + oid + '\')">'
          +'<i class="ti ti-refresh"></i> Buscar el costeo guardado</button></div>'
        : '')
      +'</div>';
    return h+'</div>';
  }

  var puedeEditar = CU && (CU.role==='gerencia');
  h+='<div style="font-size:11px;color:var(--t-marron);margin-bottom:8px">'
    +'Costo de importación <b>'+_esc(base.costo_importacion||'')+'</b>'
    +(base.entrada?(' · entrada <b>'+_esc(base.entrada)+'</b>'):'')
    +' · '+base.lineas.length+' línea(s)'
    +(puedeEditar?' · <span style="color:var(--t-verde);font-weight:600">puedes editar los precios de venta</span>'
                 :' · <span style="color:var(--text-muted)">solo gerencia puede editarlos</span>')
    +'</div>';

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:9px">'
    +'<button class="btn bp" style="background:#0c447c;font-size:11.5px;padding:7px 13px" onclick="event.stopPropagation();_pvAbrir(\'' + oid + '\')">'
      +'<i class="ti ti-table"></i> '+(puedeEditar?'Abrir y editar los precios':'Ver el costeo con precios')+'</button>'
    +((guardado && _puedeAduana())?('<button class="btn bp" style="background:#7C3D12;font-size:11.5px;padding:7px 13px" onclick="event.stopPropagation();_pvEnviarModal(\'' + oid + '\')">'
      +'<i class="ti ti-mail"></i> Enviar a las compradoras</button>'):'')
    +'</div>';

  if(guardado){
    var n=Object.keys(d.precios.valores||{}).length;
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:8px 11px;font-size:11px;margin-bottom:8px">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde)"></i> '
      +n+' precio(s) modificado(s) · guardado por <b>'+_esc(d.precios.guardado_por||'')+'</b> · '
      +_esc(_fechaHora(d.precios.guardado_en))+'</div>';
  }

  if(env){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde)">'
      +'<div style="font-weight:700"><i class="ti ti-mail-check"></i> Precios enviados a compras</div>'
      +'<div style="margin-top:2px;font-size:11px">Por <b>'+_esc(env.por||'')+'</b> · '+_esc(_fechaHora(env.fecha))
      +(env.para&&env.para.length?('<br>A: '+_esc(env.para.join(', '))):'')+'</div></div>';
  }
  return h+'</div>';
}

function _pvRepintar(oid){
  var c=document.getElementById('pvpanel-'+oid);
  if(c) c.innerHTML=_pvPanel(oid);
}

// Trae el costeo guardado en la orden, si no está en memoria
async function _pvTraer(oid){
  var d=_logLeer(oid);
  if(d.costeo && d.costeo.sap){
    window._costDatos=window._costDatos||{};
    window._costDatos[oid]=d.costeo.sap;
    showT('✓ Costeo recuperado');
    _pvRepintar(oid);
    return;
  }
  showT('No hay ningún costeo guardado en esta orden. Generalo en el paso anterior.');
}

// ── La tabla editable ──
async function _pvAbrir(oid){
  var r=_pvDatos(oid);
  var base=r.base, d=r.d;
  if(!base){ showT('No hay costeo cargado'); return; }

  // Se enriquece por si faltaran fotos o precios
  try{ base=await _costEnriquecer(base); }catch(e){}

  // Los precios ya editados mandan sobre los del costeo
  var editados=(d.precios&&d.precios.valores)||{};
  var puedeEditar = CU && (CU.role==='gerencia');

  var prev=document.getElementById('modalPV'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalPV';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:14px;overflow-y:auto';

  function n2(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function n4(v){ return (Number(v)||0).toLocaleString('en-US',{minimumFractionDigits:4,maximumFractionDigits:4}); }

  var filas=base.lineas.map(function(l,i){
    var ref=String(l.referencia||'');
    var refSeguro=ref.replace(/'/g,'');           // para meterlo en el onclick
    var pvOrig=Number(l.precio_venta)||0;
    var pv=(editados[ref]!=null)?Number(editados[ref]):pvOrig;
    var cif=Number(l.cif_unit)||0;
    var mg=pv?(((pv-cif)/pv)*100):0;
    var foto='';
    try{ foto=l.foto?_repFotoUrl(l.foto):''; }catch(e){ foto=l.foto?(FOTO_BASE+encodeURIComponent(l.foto)):''; }
    var fotoNom=String(l.foto||'').replace(/'/g,'');
    var cambiado=(editados[ref]!=null && Math.abs(pv-pvOrig)>0.001);

    var celdaFoto = foto
      ? ('<img src="'+_esc(foto)+'" class="cost-mini" alt="" '
         +'onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(refSeguro)+'\')" '
         +'onerror="_costFotoAlt(this,\''+_esc(fotoNom)+'\')">')
      : '<span style="display:inline-block;width:30px;height:30px;border-radius:5px;background:var(--surface-1)"></span>';

    return '<tr style="border-bottom:0.5px solid var(--border)" data-ref="'+_esc(ref)+'">'
      +'<td style="padding:2px 4px;width:38px">'+celdaFoto+'</td>'
      +'<td style="padding:3px 6px;color:var(--text-muted);text-align:right">'+(l.nro||i+1)+'</td>'
      +'<td style="padding:3px 6px;font-family:monospace;font-size:10.5px;white-space:nowrap">'
        +'<span onclick="event.stopPropagation();_invFicha(\''+_esc(refSeguro)+'\')" '
        +'style="color:var(--text-accent);cursor:pointer;text-decoration:underline" title="Ver la ficha del producto">'
        +_esc(ref)+'</span></td>'
      +'<td style="padding:3px 6px;max-width:250px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" title="'+_esc(l.descripcion||'')+'">'+_esc(l.descripcion||'')+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n2(l.cantidad)+'</td>'
      +'<td style="padding:3px 6px;text-align:right">'+n4(l.fob_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;color:var(--t-marron)">'+n4(l.gasto_unit)+'</td>'
      +'<td style="padding:3px 6px;text-align:right;font-weight:700">'+n4(cif)+'</td>'
      +'<td style="padding:2px 5px;text-align:right;background:'+(cambiado?'#FEF9E7':'transparent')+'">'
        +(puedeEditar
          ? ('<input type="number" step="0.01" min="0" value="'+(pv?pv.toFixed(2):'')+'" '
             +'id="pv-'+i+'" data-ref="'+_esc(ref)+'" data-cif="'+cif+'" data-orig="'+pvOrig+'" '
             +'oninput="_pvCambio('+i+')" onclick="event.stopPropagation()" '
             +'style="width:88px;padding:4px 7px;border:0.5px solid '+(cambiado?'#E0A82E':'var(--border)')+';'
             +'border-radius:6px;font-size:12px;font-weight:700;text-align:right;'
             +'background:var(--surface-0);color:'+(cambiado?'#7C3D12':'var(--text-primary)')+'">')
          : ('<b>'+n2(pv)+'</b>'))
      +'</td>'
      +'<td style="padding:3px 6px;text-align:right;font-weight:700" id="mg-'+i+'">'
        +'<span style="color:'+(mg<0?'#991b1b':(mg<25?'#B45309':'#166534'))+'">'+n4(mg)+'</span></td>'
      +'<td style="padding:3px 6px;text-align:right;font-size:10px;color:var(--text-muted)">'
        +(pvOrig?n2(pvOrig):'—')+'</td>'
      +'</tr>';
  }).join('');

  function th(txt, ali, w){
    return '<th style="padding:5px 6px;text-align:'+(ali||'left')+';font-size:9px;text-transform:uppercase;'
      +'color:var(--text-muted);font-weight:700;white-space:nowrap;background:var(--surface-1);'
      +'position:sticky;top:0;z-index:2;border-bottom:1px solid var(--border)'+(w?(';width:'+w):'')+'">'+txt+'</th>';
  }

  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:16px;width:100%;max-width:1120px;max-height:94vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:10px">'
      +'<div style="font-size:12px;line-height:1.5">'
        +'<div style="font-size:14px;font-weight:800">PRECIOS DE VENTA</div>'
        +'<div><b>COSTO DE IMPORTACION:</b> '+_esc(base.costo_importacion||'')
          +'   <b>ENTRADA:</b> '+_esc(base.entrada||'')+'</div>'
        +'<div style="color:var(--text-muted)">'+_esc(base.suplidor||'')+'</div>'
      +'</div>'
      +'<button onclick="_pvCerrar(\'' + oid + '\')" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted);line-height:1">&times;</button></div>'

    +(puedeEditar
      ? '<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:8px;padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--t-azul)">'
        +'<i class="ti ti-pencil"></i> Escribe el precio de venta que corresponda en cada línea. '
        +'El porcentaje se recalcula solo. Las líneas que cambies quedan resaltadas.</div>'
      : '<div style="background:var(--surface-1);border-radius:8px;padding:8px 11px;margin-bottom:10px;font-size:11.5px;color:var(--text-muted)">'
        +'<i class="ti ti-lock"></i> Solo gerencia puede modificar los precios de venta.</div>')

    +'<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden;margin-bottom:12px">'
      +'<div style="max-height:440px;overflow:auto">'
      +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
      +'<thead><tr>'
        +th('','left')+th('#','right')+th('Referencia')+th('Descripción')
        +th('Cant.','right')+th('F.O.B.','right')+th('Gastos','right')+th('C.I.F.','right')
        +th('Precio venta','right','100px')+th('%','right')+th('Precio anterior','right')
      +'</tr></thead><tbody>'+filas+'</tbody></table></div></div>'

    +'<div id="pv-resumen" style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px"></div>'

    +'<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div id="pv-pie" style="font-size:11.5px;color:var(--text-muted)">'+base.lineas.length+' línea(s)</div>'
      +'<div style="display:flex;gap:8px">'
        +'<button class="btn" onclick="_pvCerrar(\'' + oid + '\')">Cerrar</button>'
        +(puedeEditar
          ? ('<button class="btn bg2" onclick="_pvRestaurar(\'' + oid + '\')"><i class="ti ti-arrow-back-up"></i> Volver a los originales</button>'
             +'<button class="btn bp" id="pv-btn" style="background:#166534" onclick="_pvGuardar(\'' + oid + '\')">'
             +'<i class="ti ti-device-floppy"></i> Guardar precios</button>')
          : '')
      +'</div></div>'
    +'</div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);
  window._pvCtx={oid:oid, base:base};
  _pvResumen();
}

// Al escribir un precio se recalcula su margen
function _pvCambio(i){
  var inp=document.getElementById('pv-'+i);
  if(!inp) return;
  var pv=parseFloat(inp.value);
  var cif=parseFloat(inp.getAttribute('data-cif'))||0;
  var orig=parseFloat(inp.getAttribute('data-orig'))||0;
  var celda=document.getElementById('mg-'+i);
  var mg=(pv>0)?(((pv-cif)/pv)*100):0;
  if(celda){
    var col=(!pv||isNaN(pv))?'var(--text-muted)':(mg<0?'#991b1b':(mg<25?'#B45309':'#166534'));
    celda.innerHTML='<span style="color:'+col+'">'
      +((!pv||isNaN(pv))?'—':(mg).toLocaleString('en-US',{minimumFractionDigits:4,maximumFractionDigits:4}))+'</span>';
  }
  // Se marca la línea si cambió
  var cambiado=(!isNaN(pv) && Math.abs(pv-orig)>0.001);
  inp.style.borderColor=cambiado?'#E0A82E':'var(--border)';
  inp.style.color=cambiado?'#7C3D12':'var(--text-primary)';
  if(inp.parentElement) inp.parentElement.style.background=cambiado?'#FEF9E7':'transparent';
  // Aviso si el precio queda por debajo del costo
  if(!isNaN(pv) && pv>0 && pv<cif){
    inp.style.borderColor='#dc2626';
    inp.title='Este precio está por debajo del costo CIF ('+cif.toFixed(4)+')';
  } else {
    inp.title='';
  }
  _pvResumen();
}

// Resumen de lo que se lleva editado
function _pvResumen(){
  var cont=document.getElementById('pv-resumen');
  if(!cont) return;
  var inputs=Array.prototype.slice.call(document.querySelectorAll('input[id^="pv-"]'));
  var cambiados=0, bajoCosto=0, sinPrecio=0, sumaMg=0, conMg=0;
  inputs.forEach(function(inp){
    var pv=parseFloat(inp.value);
    var cif=parseFloat(inp.getAttribute('data-cif'))||0;
    var orig=parseFloat(inp.getAttribute('data-orig'))||0;
    if(isNaN(pv) || pv<=0){ sinPrecio++; return; }
    if(Math.abs(pv-orig)>0.001) cambiados++;
    if(pv<cif) bajoCosto++;
    sumaMg+=((pv-cif)/pv)*100; conMg++;
  });
  cont.innerHTML=
     _costKpi('Líneas', String(inputs.length), '#0c447c')
    +_costKpi('Precios cambiados', String(cambiados), cambiados?'#B45309':'#6b7280')
    +_costKpi('Margen promedio', conMg?((sumaMg/conMg).toFixed(2)+'%'):'—', '#166534')
    +(bajoCosto?('<div style="flex:1;min-width:150px;background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:7px 10px">'
      +'<div style="font-size:9.5px;color:var(--t-rojo);font-weight:700;text-transform:uppercase">Atención</div>'
      +'<div style="font-size:12px;font-weight:700;color:var(--t-rojo)">'+bajoCosto+' bajo el costo</div></div>'):'')
    +(sinPrecio?('<div style="flex:1;min-width:150px;background:var(--pastel-naranja);border:1px solid #E9C08A;border-radius:8px;padding:7px 10px">'
      +'<div style="font-size:9.5px;color:var(--t-marron);font-weight:700;text-transform:uppercase">Sin precio</div>'
      +'<div style="font-size:12px;font-weight:700;color:var(--t-marron)">'+sinPrecio+' línea(s)</div></div>'):'');
}

function _pvCerrar(oid){
  var m=document.getElementById('modalPV');
  if(m) m.remove();
  window._pvCtx=null;
  try{ _pvRepintar(oid); }catch(e){}
}

// Vuelve a los precios que trajo el costeo
async function _pvRestaurar(oid){
  if(!confirm('¿Volver a los precios originales del costeo?\n\nSe pierden los cambios que hiciste.')) return;
  var d=_logLeer(oid);
  d.precios={};
  await _logGuardar(oid);
  var m=document.getElementById('modalPV'); if(m) m.remove();
  showT('Precios restaurados');
  _pvAbrir(oid);
}

// Guarda los precios editados
async function _pvGuardar(oid){
  var ctx=window._pvCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var inputs=Array.prototype.slice.call(document.querySelectorAll('input[id^="pv-"]'));
  var valores={}, cambiados=0, bajoCosto=[];
  inputs.forEach(function(inp){
    var ref=inp.getAttribute('data-ref');
    var pv=parseFloat(inp.value);
    var cif=parseFloat(inp.getAttribute('data-cif'))||0;
    var orig=parseFloat(inp.getAttribute('data-orig'))||0;
    if(isNaN(pv) || pv<=0) return;
    valores[ref]=Number(pv.toFixed(2));
    if(Math.abs(pv-orig)>0.001) cambiados++;
    if(pv<cif) bajoCosto.push(ref);
  });

  if(bajoCosto.length){
    if(!confirm(bajoCosto.length+' artículo(s) quedaron con el precio por debajo del costo CIF:\n\n'
      +bajoCosto.slice(0,10).join(', ')+(bajoCosto.length>10?'…':'')
      +'\n\n¿Guardar igual?')) return;
  }

  var btn=document.getElementById('pv-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Guardando…'; }

  var d=_logLeer(oid);
  d.precios={ valores:valores,
              guardado_por:(CU&&CU.name)||'',
              guardado_en:new Date().toISOString(),
              cambiados:cambiados };
  await _logGuardar(oid);

  // Guardar no cierra el paso: lo cierra el envío del correo a compras

  showT('✓ '+Object.keys(valores).length+' precio(s) guardado(s)'
    +(cambiados?(' · '+cambiados+' modificado(s)'):''));
  if(btn){
    btn.disabled=false;
    btn.style.background='#0c447c';
    btn.innerHTML='<i class="ti ti-check"></i> Guardado';
  }
  var pie=document.getElementById('pv-pie');
  if(pie) pie.innerHTML='<span style="color:var(--text-success);font-weight:600">'
    +'<i class="ti ti-circle-check"></i> Precios guardados. Cerrá y pulsa "Enviar a las compradoras" '
    +'para dar por terminada la etapa.</span>';
}

// Los datos con los precios ya editados, para el Excel y el correo
function _pvConEditados(oid){
  var r=_pvDatos(oid);
  if(!r.base) return null;
  var editados=(r.d.precios&&r.d.precios.valores)||{};
  var copia=JSON.parse(JSON.stringify(r.base));
  copia.lineas.forEach(function(l){
    var ref=String(l.referencia||'');
    if(editados[ref]!=null){
      var pv=Number(editados[ref])||0;
      var cif=Number(l.cif_unit)||0;
      l.precio_venta=pv;
      l.margen=pv?Number((((pv-cif)/pv)*100).toFixed(4)):0;
    }
  });
  copia._precios={ por:(r.d.precios&&r.d.precios.guardado_por)||'',
                   en:(r.d.precios&&r.d.precios.guardado_en)||'',
                   cambiados:(r.d.precios&&r.d.precios.cambiados)||0 };
  return copia;
}

// ── Enviar los precios a las compradoras del departamento ──
async function _pvEnviarModal(oid){
  var datos=_pvConEditados(oid);
  if(!datos){ showT('No hay costeo con precios para enviar'); return; }
  var d=_logLeer(oid);
  if(!(d.precios && d.precios.guardado_en)){
    alert('Primero guarda los precios.\n\nAbrí la tabla, revisa los precios de venta y pulsa "Guardar precios".');
    return;
  }

  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var entrada=String((d.arrival&&d.arrival.entrada)||datos.entrada||'').trim();
  var dept=dat.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  window._mailAdj=[];
  window._pvMailCtx={oid:oid};

  // Las compradoras del departamento, marcadas por defecto
  var comprasDept=(USERS||[]).filter(function(u){
    return u.role==='compras' && u.email && dept && String(u.dept||'')===String(dept);
  });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    var marcado = comprasDept.length
      ? comprasDept.some(function(z){ return z.id===u.id; })
      : (u.role==='compras');
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#0c447c':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#e6f1fb':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)
        +(u.dept?(' · '+_esc(dL(u.dept))):'')+'</span></label>';
  }).join('');

  var nCambios=(d.precios&&d.precios.cambiados)||0;
  var asunto='PRECIOS DE VENTA - '+ordenTxt+(entrada?(' - ENTRADA '+entrada):'');
  var cuerpo='Estimadas,\n\n'
    +'Adjunto el costeo con los precios de venta ya asignados por gerencia.\n\n'
    +'  • Orden: '+ordenTxt+'\n'
    +(entrada?('  • Número de entrada: '+entrada+'\n'):'')
    +(datos.costo_importacion?('  • Costo de importación: '+datos.costo_importacion+'\n'):'')
    +(dat.proveedor?('  • Proveedor: '+dat.proveedor+'\n'):'')
    +(dept?('  • Departamento: '+dL(dept)+'\n'):'')
    +'  • Artículos: '+datos.lineas.length+'\n'
    +(nCambios?('  • Precios modificados: '+nCambios+'\n'):'')
    +'\nQuedamos atentos.\n\n'
    +'Saludos cordiales,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalPVMail'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalPVMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:640px">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)"><i class="ti ti-tag"></i> Enviar los precios a compras</div>'
      +'<button onclick="_pvMailCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA'
      +(comprasDept.length?(' <span style="color:var(--t-azul);font-weight:600">· compras de '+_esc(dL(dept))+' marcadas</span>'):'')+'</div>'
    +'<div id="pvmail-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'+chips+'</div>'
    +'<input id="pvmail-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="pvmail-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="pvmail-cuerpo" rows="13" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTO</div>'
    +'<div id="pvmail-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Armando el Excel con los precios nuevos…</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_pvMailCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="pvmail-btn" style="background:#0c447c" onclick="_pvMailEnviar()"><i class="ti ti-send"></i> Enviar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // El Excel con los precios editados
  var aviso=document.getElementById('pvmail-auto');
  var arch=await _pvExcel(oid, datos, true);
  if(arch){
    window._mailAdj.push(arch);
    mailPintarAdjuntos();
    if(aviso) aviso.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> '
      +_esc(arch.nombre)+' · '+arch.kb+' KB'+(arch.fotos?(' · '+arch.fotos+' fotos'):'')+'</span>';
  } else {
    if(aviso) aviso.innerHTML='<span style="color:var(--text-danger)"><i class="ti ti-alert-triangle"></i> '
      +'No se pudo armar el Excel. Probá de nuevo.</span>';
  }
}

function _pvMailCerrar(){
  var m=document.getElementById('modalPVMail'); if(m) m.remove();
  window._mailAdj=[]; window._pvMailCtx=null;
}

async function _pvMailEnviar(){
  var ctx=window._pvMailCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var oid=ctx.oid;
  var box=document.getElementById('pvmail-dests');
  var para=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  var extra=((document.getElementById('pvmail-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=para.concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });
  if(!todos.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }
  if(!(window._mailAdj||[]).length){
    _mailMsg('No hay adjunto. El correo tiene que llevar el Excel con los precios.','err');
    return;
  }

  var asunto=(document.getElementById('pvmail-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('pvmail-cuerpo')||{}).value||'';
  var btn=document.getElementById('pvmail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:todos[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Precios de venta · '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      _mailMsg('No se pudo encolar el correo.','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
    return;
  }

  // El Excel queda también adjunto al paso, para que puedan bajarlo desde ahí
  try{
    var a=(window._mailAdj||[])[0];
    if(a && a.blob){
      var file=new File([a.blob], a.nombre, {type:a.mime});
      await _costAdjuntarSilencioso(oid, _subKeyCost(_PASO_PRECIOS), file);
    }
  }catch(e){ console.warn('adjuntar al paso:',e); }

  _solEnvioGuardar(oid, 'precios', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo
  });

  // El envío del correo cierra el paso y con él la etapa
  try{ _costeoMarcarPaso(oid, _PASO_PRECIOS); }catch(e){ console.warn('marcar precios:',e); }

  // Aviso en el portal, que las lleva a este paso
  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Aduanización & Costeo',
      texto:'Precios de venta asignados por gerencia. El Excel está adjunto en el paso.',
      etiqueta:'Precios de venta listos', paso:_PASO_PRECIOS
    });
  }catch(e){}

  _pvMailCerrar();
  showT('✓ Precios enviados a '+todos.length+' destinatario(s)');
  _pvRepintar(oid);
}

// Arma el Excel de precios, con el mismo formato del costeo
async function _pvExcel(oid, datos, paraCorreo){
  datos=datos||_pvConEditados(oid);
  if(!datos) return null;
  try{
    var t=datos.totales||{};
    var ExcelJS=await _ensureExcelJS();
    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Precios');

    ws.addRow(['KENNEDY CENTER CORP.']);
    ws.addRow(['PRECIOS DE VENTA']);
    ws.addRow(['COSTO DE IMPORTACION:', datos.costo_importacion||'']);
    ws.addRow(['ENTRADA No:', datos.entrada||'', 'FECHA:', datos.fecha||'']);
    ws.addRow(['SUPLIDOR:', (datos.suplidor_codigo||'')+' '+(datos.suplidor||'')]);
    if(datos._precios && datos._precios.por){
      ws.addRow(['PRECIOS ASIGNADOS POR:', datos._precios.por,
                 datos._precios.en?_fechaHora(datos._precios.en):'']);
    }
    ws.addRow([]);
    ws.getRow(1).font={bold:true, size:13};
    ws.getRow(2).font={bold:true, size:11};
    for(var r=3;r<=6;r++) ws.getRow(r).font={bold:true, size:10};

    var filaEnc=ws.addRow(['FOTO','#','REFERENCIA','DESCRIPCION','BLT X/C','EMPAQUE','CANT. BLTS',
      'MEDIDA X BTO','MEDIDA TOTAL','CANT.','F.O.B.','COSTO TOTAL','GASTOS','C.I.F.',
      'COSTO TOTAL','PRECIO VENTA','%']);
    filaEnc.font={bold:true, size:9};
    filaEnc.alignment={vertical:'middle', horizontal:'center', wrapText:true};
    filaEnc.eachCell(function(c){
      c.fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFEEEEEE'}};
      c.border={bottom:{style:'thin'}};
    });

    var filaBase=ws.rowCount;
    datos.lineas.forEach(function(l,i){
      var f=ws.addRow(['', l.nro||i+1, l.referencia||'', l.descripcion||'',
        Number(l.piezas_x_bulto)||0, l.empaque||'PZA', Number(l.bultos)||0,
        Number((l.medida||0).toFixed(5)),
        Number((l.medida_total||((l.medida||0)*(l.bultos||0))).toFixed(5)),
        Number(l.cantidad)||0,
        Number((l.fob_unit||0).toFixed(4)), Number((l.fob_total||0).toFixed(4)),
        Number((l.gasto_unit||0).toFixed(4)), Number((l.cif_unit||0).toFixed(4)),
        Number((l.cif_total||0).toFixed(2)),
        Number((l.precio_venta||0).toFixed(2)), Number((l.margen||0).toFixed(4))]);
      f.height=46;
      f.alignment={vertical:'middle'};
      // El precio de venta, resaltado: es lo que se revisó en esta etapa
      f.getCell(16).font={bold:true};
      f.getCell(16).fill={type:'pattern', pattern:'solid', fgColor:{argb:'FFFEF9E7'}};
    });

    ws.addRow([]);
    var ft=ws.addRow(['', '', 'TOTAL', '', '', '', Number(t.bultos)||0, '',
                      Number(t.medida)||0, Number(t.cantidad)||0, '',
                      Number(t.fob)||0, '', '', Number(t.cif)||0, '', '']);
    ft.font={bold:true};

    if((datos.gastos||[]).length){
      ws.addRow([]);
      datos.gastos.forEach(function(g){
        ws.addRow(['', g.concepto||'', Number(g.monto)||0, g.prorrateo||'', g.codigo||'']);
      });
      var fg=ws.addRow(['', 'TOTAL GASTOS', Number(t.gastos)||0]);
      fg.font={bold:true};
    }

    ws.columns=[{width:8},{width:5},{width:15},{width:44},{width:9},{width:10},
                {width:11},{width:13},{width:14},{width:10},{width:11},{width:13},
                {width:11},{width:11},{width:13},{width:13},{width:10}];

    var conFoto=0;
    var lado=paraCorreo?120:150, cal=paraCorreo?0.45:0.55;
    for(var i=0;i<datos.lineas.length;i++){
      var l=datos.lineas[i];
      if(!l.foto) continue;
      try{
        var im=await _costFotoChica(l.foto, lado, cal);
        if(!im) continue;
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id, { tl:{col:0.15, row:(filaBase+i)+0.10},
                          ext:{width:52, height:52}, editAs:'oneCell' });
        conFoto++;
      }catch(e){}
    }

    var buf=await wb.xlsx.writeBuffer();
    var dat=_solPagoDatosOrden(oid);
    var nombre='Precios_'+String(datos.costo_importacion||dat.dkc||oid).replace(/[^\w.\-]+/g,'_')+'.xlsx';
    var blob=new Blob([buf], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

    if(!paraCorreo){
      var a=document.createElement('a');
      a.href=URL.createObjectURL(blob);
      a.download=nombre;
      document.body.appendChild(a); a.click();
      setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 3000);
      return {nombre:nombre, kb:Math.round(buf.byteLength/1024), fotos:conFoto, blob:blob};
    }

    var b64=await new Promise(function(res,rej){
      var fr=new FileReader();
      fr.onload=function(){ res(String(fr.result).split(',')[1]||''); };
      fr.onerror=rej;
      fr.readAsDataURL(blob);
    });
    return { nombre:nombre,
             mime:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
             contenido:b64, kb:Math.round(buf.byteLength/1024), fotos:conFoto, blob:blob };
  }catch(e){ console.warn('excel de precios:',e); return null; }
}

async function _costEnviarModal(oid){
  // El DMCE tiene que estar revisado con AI antes de mandar el costeo
  if(!_iaExigirRevision(oid, _PASO_DMCE, 'el DMCE y el SIGA')) return;
  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var d=_logLeer(oid);
  var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();
  var sk=_subKeyCost(_PASO_COSTEO);
  var files=_costArchivos(oid);

  // Sin el costeo adjunto no tiene sentido enviar el correo
  if(!files.length){
    var todos=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
    alert('No se puede enviar el correo todavía.\n\n'
      +'No hay ningún archivo de costeo adjunto en este paso.\n'
      +'Tiene que ser un Excel o un PDF cuyo nombre empiece por "Costeo".\n\n'
      +(todos.length
        ? ('Archivos que hay ahora:\n'+todos.map(function(a){ return '  · '+(a.name||''); }).join('\n')
           +'\n\nGenerá el costeo desde SAP o subilo a mano.')
        : 'Generá el costeo desde SAP con el botón de arriba, o subilo a mano.'));
    return;
  }

  window._mailAdj=[];
  window._costCtx={oid:oid};

  // Por defecto solo la gerencia DEL DEPARTAMENTO de esta orden
  var _dept=dat.dept||'';
  if(!_dept){
    var _o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(_o) _dept=_o.dept||'';
  }
  var gersDept=(USERS||[]).filter(function(u){
    return u.role==='gerencia' && u.email && _dept && String(u.dept||'')===String(_dept);
  });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    // Si el departamento tiene su gerencia, solo esa; si no, toda la gerencia
    var marcado = gersDept.length
      ? gersDept.some(function(z){ return z.id===u.id; })
      : (u.role==='gerencia');
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#7C3D12':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#FBEEDD':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)
        +(u.dept?(' · '+_esc(dL(u.dept))):'')+'</span></label>';
  }).join('');

  var asunto='COSTEO - '+ordenTxt+(entrada?(' - ENTRADA '+entrada):'');
  var cimp=(d.costeo&&d.costeo.sap&&d.costeo.sap.costo_importacion)||'';
  var cuerpo='Estimados,\n\n'
    +'Adjunto costeo para su revisión y colocación de precios.\n\n'
    +'  • Orden: '+ordenTxt+'\n'
    +(entrada?('  • Número de entrada: '+entrada+'\n'):'')
    +(cimp?('  • Costo de importación: '+cimp+'\n'):'')
    +(dat.proveedor?('  • Proveedor: '+dat.proveedor+'\n'):'')
    +(dat.dept?('  • Departamento: '+dL(dat.dept)+'\n'):'')
    +'\nQuedamos atentos.\n\n'
    +'Saludos cordiales,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalCosteo'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalCosteo';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:640px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-marron)"><i class="ti ti-table"></i> Enviar costeo</div>'
      +'<button onclick="_costCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA</div>'
    +'<div id="cost-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'+chips+'</div>'
    +'<input id="cost-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="cost-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="cost-cuerpo" rows="12" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="cost-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando el costeo…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_costCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="cost-btn" style="background:#7C3D12" onclick="_costEnviar()"><i class="ti ti-send"></i> Enviar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  var aviso=document.getElementById('cost-auto');
  var puestos=[], fallidos=[];
  for(var i=0;i<files.length;i++){
    if(!files[i].url) continue;
    var motivo={};
    try{
      var adj=await _solPagoAdjuntarDeStorage(files[i].url, files[i].name||'Costeo.xlsx', motivo);
      if(adj){ window._mailAdj.push(adj); puestos.push(files[i].name); }
      else fallidos.push((files[i].name||'')+': '+(motivo.txt||'no se pudo adjuntar'));
    }catch(e){ fallidos.push((files[i].name||'')+': '+(e.message||e)); }
  }
  mailPintarAdjuntos();
  // Si el del paso no entró por peso, se arma uno nuevo con las fotos
  // comprimidas, que sí cabe en el correo.
  if(!puestos.length){
    if(aviso) aviso.innerHTML='<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> '
      +'El archivo del paso es muy pesado: armando una versión con las fotos comprimidas…</span>';
    var liv=await _costExcelCorreo(oid);
    if(liv){
      window._mailAdj.push(liv);
      puestos.push(liv.nombre+' ('+liv.kb+' KB'+(liv.fotos?(', '+liv.fotos+' fotos'):'')+')');
      mailPintarAdjuntos();
    }
  }

  if(aviso){
    if(puestos.length){
      aviso.innerHTML='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado: '
        +_esc(puestos.join(', '))+'</span>'
        +(fallidos.length?('<br><span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> '+_esc(fallidos.join(' · '))+'</span>'):'');
    } else {
      aviso.innerHTML='<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:8px;padding:8px 10px;color:var(--t-rojo)">'
        +'<b><i class="ti ti-alert-triangle"></i> No se pudo adjuntar el costeo</b>'
        +(fallidos.length?('<div style="margin-top:3px">'+_esc(fallidos.join(' · '))+'</div>'):'')
        +'<div style="margin-top:4px">Generá el PDF, que pesa mucho menos que el Excel con fotos, '
        +'y adjuntalo con el botón de abajo.</div></div>';
    }
  }
}

function _costCerrar(){
  var m=document.getElementById('modalCosteo'); if(m) m.remove();
  window._mailAdj=[]; window._costCtx=null;
}

async function _costEnviar(){
  var ctx=window._costCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid;
  var box=document.getElementById('cost-dests');
  var para=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  var extra=((document.getElementById('cost-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=para.concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });
  if(!todos.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }
  // El correo tiene que llevar el costeo: sin eso no se envía
  if(!(window._mailAdj||[]).length){
    _mailMsg('No hay ningún archivo adjunto. El correo tiene que llevar el costeo en Excel o PDF.','err');
    return;
  }
  var traeCosteo=(window._mailAdj||[]).some(function(a){
    return String(a.nombre||'').trim().toLowerCase().indexOf('costeo')===0;
  });
  if(!traeCosteo){
    if(!confirm('Ninguno de los adjuntos parece ser el costeo.\n\n'
      +'Se esperaba un archivo cuyo nombre empiece por "Costeo".\n\n¿Enviar igual?')) return;
  }

  var asunto=(document.getElementById('cost-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('cost-cuerpo')||{}).value||'';
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }

  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('cost-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }
  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:todos[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Costeo · '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      var t=await r.text(); console.error('costeo:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
    return;
  }

  _solEnvioGuardar(oid, 'costeo', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo
  });

  // El envío del correo es lo que cierra este paso
  try{ _costeoMarcarPaso(oid, _PASO_COSTEO); }catch(e){ console.warn('marcar costeo:',e); }

  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Aduanización & Costeo',
      texto:'Costeo enviado para revisión y colocación de precios',
      etiqueta:'Costeo — pendiente de precios', paso:_PASO_COSTEO
    });
  }catch(e){}

  _costCerrar();
  showT('✓ Costeo enviado a '+todos.length+' destinatario(s)');
  _costRepintar(oid);
}

function _logPanelBooking(oid){
  var d=_logLeer(oid), b=d.booking||{};
  var sk=_subKeyLog(_PASO_BOOKING);
  var docs=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var t=_logTotales(b.tarifas);
  var completo=!!(b.numero && b.origen && b.destino);

  var h='<div style="background:#D6EFE7;border:1px solid #7FC9B4;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(completo?'sem-g':(docs.length?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-verde2);flex:1"><i class="ti ti-ship"></i> Booking</div>'
    +(b.naviera?('<span style="font-size:10.5px;font-weight:700;color:var(--t-verde2)">'+_esc(b.naviera)+'</span>'):'')
    +'</div>';

  // Documentos del booking
  h+=_logZonaDocs(oid, sk, 'DOCUMENTO DEL BOOKING Y TARIFAS',
                  'Adjunta el booking y el tarifario para que la AI los lea', '#085041');

  if(docs.length && _puedeAduana()){
    h+='<button class="btn bp" style="background:#5B21B6;font-size:11.5px;padding:7px 13px;margin-bottom:9px" onclick="event.stopPropagation();_logLeerIA(\'' + oid + '\',\'booking\')">'
      +'<i class="ti ti-sparkles"></i> Leer con AI y llenar los datos</button>'
      +'<div id="logia-booking-'+oid+'" style="margin-bottom:9px"></div>';
  }

  // Datos del booking
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'booking','numero','Booking No.', b.numero, 160)
    +_logCampo(oid,'booking','naviera','Naviera', b.naviera, 140)
    +_logCampo(oid,'booking','service_type','Service Type', b.service_type, 140)
    +_logCampo(oid,'booking','service_contract','Service Contract', b.service_contract, 150)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'booking','shipper','Shipper', b.shipper, 200)
    +_logCampo(oid,'booking','consignee','Consignee', b.consignee, 200)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'booking','origen','Origin', b.origen, 150)
    +_logCampo(oid,'booking','destino','Destination', b.destino, 150)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'booking','fecha_salida','ETD', b.fecha_salida, 130)
    +_logCampo(oid,'booking','fecha_llegada','ETA', b.fecha_llegada, 130)
    +'</div>';

  h+=_trackBarra(oid,'booking');
  h+=_logContenedores(oid, true);
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px">'
    +'<span style="font-size:10.5px;font-weight:700;color:var(--t-verde2);flex:1">TARIFAS DEL BOOKING</span>'
    +((b.numero||(b.tarifas||[]).length)?('<button class="btn bg2" style="padding:3px 9px;font-size:10px;color:var(--text-danger)" onclick="event.stopPropagation();_logVaciarDatos(\'' + oid + '\',\'booking\',\'Booking\')" title="Borra los datos, deja los documentos"><i class="ti ti-eraser"></i> Vaciar datos</button>'):'')
    +'</div>';
  h+=_logTablaTarifas(b.tarifas, true, oid, 'booking');
  h+=_entResumenSeguro(oid);
  h+=_btnCerrarPaso(oid, 'logistica', _PASO_BOOKING,
      {falta: completo ? '' : 'Faltan datos del booking. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// ── B) BILL OF LADING ──
function _logPanelBL(oid){
  var d=_logLeer(oid), b=d.bl||{}, bk=d.booking||{};
  var sk=_subKeyLog(_PASO_BL);
  var docs=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var completo=!!(b.numero && b.shipper && b.consignee);

  var h='<div style="background:#D5E6F7;border:1px solid #6BA5DF;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(completo?'sem-g':(docs.length?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-azul);flex:1"><i class="ti ti-file-text"></i> Bill of Lading</div></div>';

  h+=_logZonaDocs(oid, sk, 'DOCUMENTO DEL B/L', 'Adjunta el B/L para que la AI lo lea', '#0c447c');

  if(docs.length && _puedeAduana()){
    h+='<button class="btn bp" style="background:#5B21B6;font-size:11.5px;padding:7px 13px;margin-bottom:9px" onclick="event.stopPropagation();_logLeerIA(\'' + oid + '\',\'bl\')">'
      +'<i class="ti ti-sparkles"></i> Leer con AI y verificar contra el booking</button>'
      +'<div id="logia-bl-'+oid+'" style="margin-bottom:9px"></div>';
  }

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'bl','numero','B/L No.', b.numero, 160)
    +_logCampo(oid,'bl','vessel','Vessel No.', b.vessel, 150)
    +_logCampo(oid,'bl','viaje','Voyage', b.viaje, 120)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'bl','shipper','Shipper', b.shipper, 200)
    +_logCampo(oid,'bl','consignee','Consignee', b.consignee, 200)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'bl','origen','Puerto de origen', b.origen, 150)
    +_logCampo(oid,'bl','destino','Puerto de destino', b.destino, 150)
    +_logCampo(oid,'bl','fecha_salida','ETD', b.fecha_salida, 120)
    +'</div>';

  h+=_trackBarra(oid,'bl');
  h+=_logContenedores(oid, true);
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px">'
    +'<span style="font-size:10.5px;font-weight:700;color:var(--t-azul);flex:1">TARIFAS DEL B/L</span>'
    +((b.numero||(b.tarifas||[]).length)?('<button class="btn bg2" style="padding:3px 9px;font-size:10px;color:var(--text-danger)" onclick="event.stopPropagation();_logVaciarDatos(\'' + oid + '\',\'bl\',\'B/L\')" title="Borra los datos, deja los documentos"><i class="ti ti-eraser"></i> Vaciar datos</button>'):'')
    +'</div>';
  h+=_logTablaTarifas(b.tarifas, true, oid, 'bl');
  h+=_logComparar(bk.tarifas, b.tarifas, 'booking', 'B/L');
  h+=_entResumenSeguro(oid);
  h+=_btnCerrarPaso(oid, 'logistica', _PASO_BL,
      {falta: completo ? '' : 'Faltan datos del B/L. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// ── C) AVISO DE LLEGADA ──
// ═══════════════════════════════════════════════════════════════════════════
//  ENTRADA DE MERCANCÍA
//  Los datos que contabilidad carga en SAP en la pestaña "Entradas" de la
//  factura de compra: número de entrada, BL, naviera, contenedores, puerto
//  y todas las fechas del proceso.
// ═══════════════════════════════════════════════════════════════════════════
// Versión compacta para la cabecera de la orden: una línea con lo esencial
// Envoltura segura: la cabecera se arma con plantillas y un error ahí
// dejaría toda la orden en blanco.
// Buscar una entrada sin abrir ninguna orden
async function _entBuscar(){
  var q=prompt('Buscar por número de entrada\n\n'
    +'Escribe el número tal como está en SAP, por ejemplo 145/26:','');
  if(q===null) return;
  q=String(q).trim();
  if(!q){ return; }

  showT('Buscando la entrada '+q+'…');
  var fid=null;
  try{
    var r=await fetch(SB+'/rest/v1/entradas_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify({docnum:'', entrada:q, pedido_por:(CU&&CU.name)||'',
                           estado:'pendiente', creado_en:new Date().toISOString()})});
    if(!r.ok){
      var t=await r.text();
      showT(/does not exist|Could not find the table/i.test(t)
        ? 'Falta la tabla entradas_queue en Supabase'
        : 'No se pudo buscar (error '+r.status+')');
      return;
    }
    var f=await r.json();
    fid=(Array.isArray(f)&&f[0])?f[0].id:null;
  }catch(e){ showT('Error de conexión'); return; }
  if(!fid) return;
  _entBuscarEsperar(q, fid, 0);
}

function _entBuscarEsperar(q, fid, intento){
  setTimeout(async function(){
    var fila=null;
    try{
      var r=await fetch(SB+'/rest/v1/entradas_queue?select=*&id=eq.'+fid+'&limit=1',{headers:SBH});
      if(r.ok){ var a=await r.json(); fila=(Array.isArray(a)&&a[0])?a[0]:null; }
    }catch(e){}
    if(!fila || fila.estado==='pendiente' || fila.estado==='procesando'){
      if(intento<40) return _entBuscarEsperar(q, fid, intento+1);
      showT('SAP no respondió. Revisa que el worker esté corriendo.');
      return;
    }
    if(fila.estado==='error'){ showT(fila.detalle||'No se encontró esa entrada'); return; }
    var datos=fila.datos;
    if(typeof datos==='string'){ try{ datos=JSON.parse(datos); }catch(e){ datos=null; } }
    var lista=(datos&&datos.entradas)||[];
    if(!lista.length){ showT('No se encontró la entrada '+q); return; }

    var prev=document.getElementById('modalEnt'); if(prev) prev.remove();
    var ov=document.createElement('div');
    ov.id='modalEnt';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;'
      +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
    ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
      +'width:100%;max-width:760px;max-height:92vh;overflow-y:auto">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
        +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)">'
          +'<i class="ti ti-search"></i> Entrada '+_esc(q)+'</div>'
        +'<button onclick="document.getElementById(\'modalEnt\').remove()" '
          +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
      +lista.map(function(e,i){ return _entFicha(e, lista.length>1?(i+1):0); }).join('')
      +'<div style="display:flex;justify-content:flex-end;margin-top:6px">'
        +'<button class="btn" onclick="document.getElementById(\'modalEnt\').remove()">Cerrar</button>'
      +'</div></div>';
    // No se cierra al tocar fuera: se perdía lo que se estaba mirando por un
  // clic al costado. Solo con el botón Cerrar, la ✕ o la tecla Esc.
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  _modalEsc(ov);
    document.body.appendChild(ov);
    showT('✓ '+lista.length+' entrada(s) encontrada(s)');
  }, intento===0?1800:3000);
}

function _entResumenSeguro(oid){
  try{
    var h=_entResumen(oid)||'';
    // Se marca para poder reemplazarlo sin reconstruir toda la orden
    return h ? h.replace('<div ', '<div data-entresumen="1" ') : '';
  }catch(e){ console.warn('resumen de entrada:',e); return ''; }
}

function _entResumen(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  if(!ents.length){
    if(!_puedeAduana()) return '';
    return '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;'
      +'background:var(--surface-1);border:0.5px dashed var(--border);border-radius:8px;'
      +'padding:6px 11px;margin-bottom:8px">'
      +'<i class="ti ti-truck-delivery" style="color:var(--text-muted);font-size:13px"></i>'
      +'<span style="font-size:11px;color:var(--text-muted);flex:1">Entrada de mercancía en SAP</span>'
      +'<button class="btn bg2" style="padding:3px 10px;font-size:10px" onclick="event.stopPropagation();_entTraer(\''+oid+'\')">'
      +'<i class="ti ti-database-import"></i> Traer de SAP</button>'
      +'<span id="entcarga-'+oid+'"></span></div>';
  }
  var e=ents[0];
  return '<div onclick="event.stopPropagation();_entVerModal(\''+oid+'\')" '
    +'title="Ver todos los datos de la entrada" '
    +'style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;background:var(--pastel-azul);'
    +'border:0.5px solid #85B7EB;border-radius:8px;padding:7px 11px;margin-bottom:8px;cursor:pointer">'
    +'<i class="ti ti-truck-delivery" style="color:var(--t-azul)"></i>'
    +'<span style="font-size:11.5px;font-weight:700;color:var(--t-azul)">Entrada '+_esc(e.entrada||'—')+'</span>'
    +(e.bl?('<span style="font-size:11px;color:var(--t-azul)">B/L '+_esc(e.bl)+'</span>'):'')
    +(e.naviera?('<span style="font-size:11px;color:var(--t-azul)">'+_esc(e.naviera)+'</span>'):'')
    +(e.num_contenedores?('<span style="font-size:11px;color:var(--t-azul)">'+_esc(e.num_contenedores)+' cont.'
      +(e.tipo_contenedor?(' '+_esc(e.tipo_contenedor)):'')+'</span>'):'')
    +(e.eta?('<span style="font-size:11px;color:var(--t-azul)">ETA '+_esc(_fmtFechaCorta(e.eta))+'</span>'):'')
    +(e.estatus_bodega?('<span style="font-size:9.5px;font-weight:700;background:var(--pastel-ok);color:var(--t-verde);'
      +'border-radius:9px;padding:1px 8px">'+_esc(e.estatus_bodega)+'</span>'):'')
    +'<span style="flex:1"></span>'
    +(ents.length>1?('<span style="font-size:10px;color:var(--text-muted)">+'+(ents.length-1)+' más</span>'):'')
    +'<i class="ti ti-maximize" style="color:var(--t-azul);font-size:12px"></i>'
    +'</div>';
}

// La ficha completa, en una ventana
function _entVerModal(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  if(!ents.length){ _entTraer(oid); return; }
  var prev=document.getElementById('modalEnt'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalEnt';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:760px;max-height:92vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)">'
        +'<i class="ti ti-truck-delivery"></i> Entrada de mercancía · orden '+_esc(oid)+'</div>'
      +'<button onclick="document.getElementById(\'modalEnt\').remove()" '
        +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +ents.map(function(e,i){ return _entFicha(e, ents.length>1?(i+1):0); }).join('')
    +'<div style="display:flex;justify-content:flex-end;gap:8px;margin-top:6px">'
      +'<button class="btn bg2" onclick="_entTraer(\''+oid+'\')"><i class="ti ti-refresh"></i> Actualizar desde SAP</button>'
      +'<button class="btn" onclick="document.getElementById(\'modalEnt\').remove()">Cerrar</button>'
    +'</div><div id="entcarga-'+oid+'" style="margin-top:8px"></div></div>';
  // No se cierra al tocar fuera: se perdía lo que se estaba mirando por un
  // clic al costado. Solo con el botón Cerrar, la ✕ o la tecla Esc.
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  _modalEsc(ov);
  document.body.appendChild(ov);
}

// ═══════════════════════════════════════════════════════════════════════════
//  BODEGA & VENTA
//  Recibido en bodega: los datos de la entrada y las fotos de la descarga.
//  Disponible en SAP: qué se facturó contra qué llegó de verdad.
//  En sala de venta: las muestras enviadas y recibidas en oficina.
// ═══════════════════════════════════════════════════════════════════════════
var _PASO_BOD_REC  = 'Recibido en bodega';
var _PASO_BOD_SAP  = 'Disponible en SAP';
var _PASO_BOD_SALA = 'En sala de venta';

function _subKeyBodega(nombre){
  var st=STAGES.find(function(z){ return z.key==='bodega'; });
  if(!st) return '';
  var i=st.steps.findIndex(function(p){ return p.name===nombre; });
  return i<0?'':('bodega_step'+i);
}

// ── Recibido en bodega ──
// El número de entrada, editable. Es la clave con la que se consulta SAP,
// así que conviene poder corregirlo antes de pedir los datos.
function _bodEntradaCampo(oid){
  var d=_logLeer(oid);
  var val=String((d.arrival&&d.arrival.entrada)||'').trim();
  var puede=CU && ['bodega','importacion','gerencia','compras','contabilidad'].indexOf(CU.role)>=0;
  var ents=(d.entradas&&d.entradas.lista)||[];

  return '<div style="background:'+(val?'#e6f1fb':'#FEF9F3')+';border:1px solid '
    +(val?'#85B7EB':'#E9C08A')+';border-radius:9px;padding:10px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
      +'<i class="ti ti-hash" style="color:'+(val?'#0c447c':'#7C3D12')+'"></i>'
      +'<span style="font-size:10px;font-weight:700;color:'+(val?'#0c447c':'#7C3D12')
        +';text-transform:uppercase">Número de entrada</span>'
      +(puede
        ? ('<input id="bodent-'+oid+'" value="'+_esc(val)+'" placeholder="Por ejemplo 153/26" '
           +'onclick="event.stopPropagation()" '
           +'onchange="_bodSetEntrada(\''+oid+'\',this.value)" '
           +'style="padding:5px 10px;border:0.5px solid var(--border);border-radius:7px;'
           +'font-size:13px;font-weight:700;width:140px;background:var(--surface-0);color:var(--text-primary)">')
        : ('<span style="font-size:14px;font-weight:800;color:var(--t-azul)">'+_esc(val||'—')+'</span>'))
      +'<span style="flex:1"></span>'
      +(puede
        ? ('<button class="btn bp" style="background:'+(val?'#0c447c':'#9ca3af')+';padding:5px 12px;font-size:11px" '
           +(val?'':'title="Escribe primero el número de entrada" ')
           +'onclick="event.stopPropagation();_bodConsultar(\''+oid+'\')">'
           +'<i class="ti ti-database-import"></i> '+(ents.length?'Actualizar de SAP':'Consultar SAP')+'</button>')
        : '')
    +'</div>'
    +(val
      ? ''
      : '<div style="font-size:10.5px;color:var(--t-marron);margin-top:5px">'
        +'<i class="ti ti-alert-circle"></i> Sin este número no se puede consultar la entrada en SAP. '
        +'Está en la factura de reserva, campo «# de Entrada».</div>')
    +'<div id="entcarga-'+oid+'" style="margin-top:7px"></div>'
    +'</div>';
}

async function _bodSetEntrada(oid, valor){
  var d=_logLeer(oid);
  d.arrival=d.arrival||{};
  d.arrival.entrada=String(valor||'').trim();
  await _logGuardar(oid);
  _bodRepintar(oid);
  try{ _logRepintar(oid); }catch(e){}
}

// Consulta usando lo que esté escrito en el campo, aunque no se haya guardado
async function _bodConsultar(oid){
  var inp=document.getElementById('bodent-'+oid);
  if(inp){
    var v=String(inp.value||'').trim();
    if(!v){
      showT('Escribe el número de entrada antes de consultar');
      inp.focus();
      return;
    }
    var d=_logLeer(oid);
    if(String((d.arrival&&d.arrival.entrada)||'').trim()!==v){
      d.arrival=d.arrival||{};
      d.arrival.entrada=v;
      await _logGuardar(oid);
    }
  }
  _entTraer(oid);
}

function _bodRecibidoPanel(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var h=_bodEntradaCampo(oid);
  h+='';

  // Todos los campos de la entrada, que es lo que bodega necesita ver
  if(ents.length){
    h+=ents.map(function(e,i){ return _entFicha(e, ents.length>1?(i+1):0); }).join('');
  } else {
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:9px;'
      +'padding:10px 12px;margin-bottom:10px;font-size:11.5px;color:var(--text-muted)">'
      +'<i class="ti ti-truck-delivery" style="color:var(--t-azul)"></i> '
      +'Todavía no se trajeron los datos de la entrada.'
      +'<div style="margin-top:5px;font-size:10.5px">Usá el botón <b>Consultar SAP</b> de arriba.</div>'
      +'</div>';
  }

  // Las fotos de la descarga y de la salida del contenedor
  h+=_bodFotos(oid, 'descarga', 'Fotos de la descarga del contenedor',
               'Cómo venía la mercancía al abrir el contenedor', '#0c447c');
  h+=_bodFotos(oid, 'salida', 'Fotos de la salida',
               'El contenedor vacío y precintado al retirarse', '#7C3D12');
  return h;
}

// Un bloque de fotos con miniaturas
function _bodFotos(oid, clave, titulo, ayuda, color){
  var sub=_subKeyBodega(_PASO_BOD_REC)+'_'+clave;
  var fotos=(window._atts&&window._atts[oid+sub])?_dedupDocs(window._atts[oid+sub]):[];
  var puede=CU && ['bodega','importacion','gerencia','compras'].indexOf(CU.role)>=0;

  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:9px;'
    +'padding:10px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:7px">'
      +'<i class="ti ti-camera" style="color:'+color+'"></i>'
      +'<span style="font-size:11.5px;font-weight:700;color:'+color+';flex:1">'+_esc(titulo)+'</span>'
      +'<span style="font-size:10.5px;color:var(--text-muted)">'+fotos.length+'</span>'
    +'</div>';

  if(fotos.length){
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:7px">';
    fotos.forEach(function(a,i){
      var url=a.data||a.url||'';
      var esImg=/\.(jpe?g|png|gif|webp|heic)$/i.test(String(a.name||''));
      h+='<div style="position:relative">'
        +(esImg
          ? ('<img src="'+_esc(url)+'" class="cost-mini" style="width:82px;height:82px" '
             +'onclick="event.stopPropagation();_invFotoGrande(this.src,\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')" '
             +'onerror="this.style.opacity=.3">')
          : ('<span style="display:flex;width:82px;height:82px;border-radius:6px;background:var(--surface-1);'
             +'border:0.5px solid var(--border);align-items:center;justify-content:center;font-size:10px;'
             +'padding:4px;text-align:center;overflow:hidden">'+_esc(a.name||'')+'</span>'))
        +(puede?('<span onclick="event.stopPropagation();_bodBorrarFoto(\'' + oid + '\',\'' + clave + '\','+i+')" '
          +'title="Borrar" style="position:absolute;top:-5px;right:-5px;background:var(--text-danger);'
          +'color:#fff;width:18px;height:18px;border-radius:50%;display:flex;align-items:center;'
          +'justify-content:center;font-size:11px;cursor:pointer;font-weight:700">×</span>'):'')
        +'</div>';
    });
    h+='</div>';
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:7px">'+_esc(ayuda)+'</div>';
  }

  if(puede){
    h+='<label style="display:inline-flex;align-items:center;gap:6px;padding:6px 11px;'
      +'border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+'">'
      +'<i class="ti ti-camera-plus"></i> Agregar fotos'
      +'<input type="file" multiple accept="image/*,.pdf" style="display:none" '
      +'onchange="_bodSubirFotos(\'' + oid + '\',\'' + clave + '\',this.files)"></label>';
  }
  return h+'</div>';
}

async function _bodSubirFotos(oid, clave, files){
  if(!files||!files.length) return;
  var sub=_subKeyBodega(_PASO_BOD_REC)+'_'+clave;
  showT('Subiendo '+files.length+' foto(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sub, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sub, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
      window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir foto:',e); }
  }
  showT('✓ Fotos agregadas');
  _bodRepintar(oid);
}

async function _bodBorrarFoto(oid, clave, i){
  var sub=_subKeyBodega(_PASO_BOD_REC)+'_'+clave;
  var a=(window._atts&&window._atts[oid+sub])?window._atts[oid+sub][i]:null;
  if(!a) return;
  if(!confirm('¿Borrar esta foto?\n\n'+(a.name||'')+'\n\nNo se puede deshacer.')) return;
  window._atts[oid+sub].splice(i,1);
  _bodRepintar(oid);
  try{ await _borrarArchivoStorage(a.url, a.id); }catch(e){}
  showT('Foto eliminada');
}

// El paso de sala se cierra solo cuando hay fecha de muestras recibidas
function _bodSalaCerrar(oid){
  var st=STAGES.find(function(z){ return z.key==='bodega'; });
  if(!st) return false;
  var pi=st.steps.findIndex(function(p){ return p.name===_PASO_BOD_SALA; });
  if(pi<0) return false;
  initP(oid);
  var sp=stageProgress[oid].bodega;
  if(!sp || (sp.stepIdx||0)>pi) return true;      // ya estaba cerrado
  var hoyIso=new Date().toISOString().slice(0,10);
  sp.stepIdx=pi+1;
  if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
  sp.stepDates[pi]=now2();
  if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
  sp.stepBy[pi]='Muestras recibidas en SAP';
  if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
  sp._isoPasos[pi]=hoyIso;
  if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
  guardarEtapa(oid,'bodega');
  console.log('[bodega] paso "En sala de venta" cerrado por muestras recibidas');
  return true;
}

function _bodRepintar(oid){
  ['rec','sap','sala'].forEach(function(k){
    var c=document.getElementById('bod'+k+'-'+oid);
    if(!c) return;
    try{
      c.innerHTML = k==='rec' ? _bodRecibidoPanel(oid)
                  : k==='sap' ? _bodFaltantesPanel(oid)
                              : _bodSalaPanel(oid);
    }catch(e){ console.warn('bodega:',e); }
  });
}

// ── Disponible en SAP: lo facturado contra lo recibido ──
// Bodega reporta mercancía en mal estado. No sale de SAP: la ve al abrir
// el contenedor, así que se carga a mano.
// El estado del reclamo, con su historial y el botón de enviar.
// Antes solo se podía cambiar desde Alertas, y ahí no se ve el detalle.
function _reclEstadoBloque(oid){
  var d=_logLeer(oid);
  var env=_solEnvioLeer(oid,'reclamo');
  var re=d.reclamo||{};
  var estado=re.estado || (env?'enviado':'pendiente');
  var st=_RECL_ESTADOS[estado]||_RECL_ESTADOS.pendiente;
  var puede=CU && ['compras','importacion','gerencia','bodega'].indexOf(CU.role)>=0;

  var h='<div style="border:1px solid '+st.c+';border-radius:9px;overflow:hidden;margin-top:9px">'
    +'<div style="background:'+st.bg+';padding:9px 12px;display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
      +'<i class="ti '+st.i+'" style="color:'+st.c+'"></i>'
      +'<span style="font-size:11.5px;font-weight:700;color:'+st.c+'">Estado del reclamo</span>'
      +'<span style="flex:1"></span>'
      +(puede
        ? ('<select onclick="event.stopPropagation()" '
           +'onchange="_reclSetEstado(\''+oid+'\',this.value)" '
           +'style="padding:4px 10px;border:1px solid '+st.c+';border-radius:14px;font-size:11px;'
           +'font-weight:700;background:var(--surface-0);color:'+st.c+';cursor:pointer">'
           +Object.keys(_RECL_ESTADOS).map(function(k){
               return '<option value="'+k+'"'+((estado===k)?' selected':'')+'>'+_RECL_ESTADOS[k].t+'</option>';
             }).join('')
           +'</select>'
        // Anotar la respuesta del proveedor y borrar el reclamo si se creó
        // por error. Antes solo se podía cambiar el estado.
        +'<button class="btn bg2" style="padding:4px 9px;font-size:10.5px" '
          +'title="Anotar la respuesta del proveedor" '
          +'onclick="event.stopPropagation();_reclNota(&quot;'+_esc(String(r.oid))+'&quot;)">'
          +'<i class="ti ti-message-2"></i></button>'
        +'<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--t-rojo3)" '
          +'title="Borrar este reclamo" '
          +'onclick="event.stopPropagation();_reclBorrar(&quot;'+_esc(String(r.oid))+'&quot;)">'
          +'<i class="ti ti-trash"></i></button>')
        : ('<span style="font-size:11px;font-weight:700;color:'+st.c+'">'+st.t+'</span>'))
    +'</div>';

  // El historial de lo que fue pasando
  h+='<div style="padding:9px 12px;background:var(--surface-0);font-size:11px">';
  if(env){
    h+='<div style="margin-bottom:5px"><i class="ti ti-mail-check" style="color:var(--t-verde)"></i> '
      +'<b>Enviado</b> por '+_esc(env.por||'')+' · '+_esc(_fechaHora(env.fecha))
      +(env.para&&env.para.length?('<br><span style="color:var(--text-muted);margin-left:17px">A: '
        +_esc(env.para.join(', '))+'</span>'):'')+'</div>';
  } else {
    h+='<div style="margin-bottom:5px;color:var(--text-muted)">'
      +'<i class="ti ti-alert-circle" style="color:var(--t-ambar)"></i> Todavía no se envió el reclamo.</div>';
  }
  if(re.resuelto_en){
    h+='<div style="margin-bottom:5px"><i class="ti ti-circle-check" style="color:var(--t-verde)"></i> '
      +'<b>Resuelto</b> por '+_esc(re.resuelto_por||'')+' · '+_esc(_fechaHora(re.resuelto_en))+'</div>';
  }
  if(re.nota){
    h+='<div style="background:var(--surface-1);border-radius:7px;padding:7px 9px;margin-bottom:5px">'
      +'<b style="font-size:9.5px;color:var(--text-muted);text-transform:uppercase">Cómo se resolvió</b><br>'
      +'<span style="white-space:pre-wrap">'+_esc(re.nota)+'</span></div>';
  }

  if(puede){
    h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-top:7px">'
      +'<button class="btn bp" style="background:#991b1b;font-size:11px;padding:6px 12px" '
        +'onclick="event.stopPropagation();_reclamoModal(\''+oid+'\')">'
        +'<i class="ti ti-mail"></i> '+(env?'Volver a enviar':'Preparar reclamo al proveedor')+'</button>'
      +(estado!=='resuelto'
        ? ('<button class="btn bp" style="background:#166534;font-size:11px;padding:6px 12px" '
           +'onclick="event.stopPropagation();_reclSetEstado(\''+oid+'\',\'resuelto\')">'
           +'<i class="ti ti-circle-check"></i> Marcar como resuelto</button>')
        : ('<button class="btn bg2" style="font-size:11px;padding:6px 12px" '
           +'onclick="event.stopPropagation();_reclSetEstado(\''+oid+'\',\'enviado\')">'
           +'<i class="ti ti-arrow-back-up"></i> Reabrir el reclamo</button>'))
      +'</div>';
    if(estado!=='resuelto'){
      h+='<div style="font-size:10px;color:var(--text-muted);margin-top:5px">'
        +'Cuando el proveedor mande la nota de crédito, marcalo como resuelto '
        +'y anotá el número: sale del listado de reclamos abiertos.</div>';
    }
  }
  return h+'</div></div>';
}

function _bodDaniosPanel(oid){
  var d=_logLeer(oid);
  var lista=(d.danios&&d.danios.lista)||[];
  var puede=CU && ['bodega','importacion','gerencia','compras'].indexOf(CU.role)>=0;
  var total=lista.reduce(function(a,x){ return a+((Number(x.cantidad)||0)*(Number(x.precio)||0)); },0);

  var h='<div style="background:var(--surface-0);border:0.5px solid '
    +(lista.length?'#dc2626':'var(--border)')+';border-radius:9px;padding:11px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
      +'<i class="ti ti-alert-octagon" style="color:var(--t-rojo)"></i>'
      +'<span style="font-size:12px;font-weight:700;color:var(--t-rojo);flex:1">Mercancía en mal estado</span>'
      +(lista.length?('<span style="font-size:12px;font-weight:700;color:var(--t-rojo)">'+fmt(total)+'</span>'):'')
    +'</div>';

  if(lista.length){
    h+='<table style="width:100%;border-collapse:collapse;font-size:11px;margin-bottom:8px">'
      +'<tr style="background:var(--surface-1)">'
      +'<th style="padding:5px 7px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">SKU</th>'
      +'<th style="padding:5px 7px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Problema</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Cant.</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Precio</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Monto</th>'
      +(puede?'<th style="width:26px"></th>':'')+'</tr>';
    lista.forEach(function(x,i){
      h+='<tr style="border-top:0.5px solid var(--border)">'
        +'<td style="padding:4px 7px;font-family:monospace;font-size:10.5px">'+_esc(x.sku||'')+'</td>'
        +'<td style="padding:4px 7px">'+_esc(x.motivo||'')+'</td>'
        +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(x.cantidad)+'</td>'
        +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(x.precio)+'</td>'
        +'<td style="padding:4px 7px;text-align:right;font-weight:700;color:var(--t-rojo)">'
          +fmt((Number(x.cantidad)||0)*(Number(x.precio)||0))+'</td>'
        +(puede?('<td style="text-align:center"><span onclick="event.stopPropagation();_bodBorrarDanio(\''+oid+'\','+i+')" '
          +'style="color:var(--text-danger);cursor:pointer;font-weight:700">×</span></td>'):'')
        +'</tr>';
    });
    h+='</table>';
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:7px">'
      +'Si al abrir el contenedor hay mercancía rota, mojada o incompleta, cargala aquí '
      +'para sumarla al reclamo.</div>';
  }

  if(puede){
    h+='<button class="btn bg2" style="font-size:10.5px;padding:5px 11px" '
      +'onclick="event.stopPropagation();_bodAgregarDanio(\''+oid+'\')">'
      +'<i class="ti ti-plus"></i> Reportar mercancía dañada</button>';
  }
  return h+'</div>';
}

async function _bodAgregarDanio(oid){
  var sku=prompt('SKU del artículo dañado:','');
  if(sku===null || !String(sku).trim()) return;
  var motivo=prompt('¿Qué le pasó?\n\nPor ejemplo: cajas mojadas, producto roto, empaque abierto.','');
  if(motivo===null) return;
  var cantTxt=prompt('¿Cuántas unidades?','');
  if(cantTxt===null) return;
  var cant=parseFloat(String(cantTxt).replace(/,/g,''));
  if(isNaN(cant) || cant<=0){ showT('La cantidad no es válida'); return; }

  // El precio se busca en las líneas de la factura, si está
  var precio=0;
  var d=_logLeer(oid);
  ((d.entradas&&d.entradas.lista)||[]).forEach(function(e){
    (e.lineas||[]).forEach(function(l){
      if(String(l.sku||'').toUpperCase()===String(sku).trim().toUpperCase()){
        precio=Number(l.precio)||0;
      }
    });
  });
  if(!precio){
    var pTxt=prompt('Precio unitario (no se encontró en la factura):','');
    if(pTxt===null) return;
    precio=parseFloat(String(pTxt).replace(/,/g,''))||0;
  }

  d.danios=d.danios||{lista:[]};
  d.danios.lista.push({sku:String(sku).trim().toUpperCase(), motivo:String(motivo).trim(),
                       cantidad:cant, precio:precio,
                       por:(CU&&CU.name)||'', en:new Date().toISOString()});
  await _logGuardar(oid);
  showT('✓ Registrado');
  _bodRepintar(oid);
}

async function _bodBorrarDanio(oid, i){
  var d=_logLeer(oid);
  if(!d.danios || !d.danios.lista[i]) return;
  if(!confirm('¿Borrar este reporte?\n\n'+(d.danios.lista[i].sku||''))) return;
  d.danios.lista.splice(i,1);
  await _logGuardar(oid);
  _bodRepintar(oid);
}

function _bodFaltantesPanel(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var lineas=[];
  ents.forEach(function(e){
    (e.lineas||[]).forEach(function(l){
      lineas.push(Object.assign({}, l, {factura:e.apri_numero, entrada:e.entrada}));
    });
  });

  var h=_bodEntradaCampo(oid);
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:9px;'
    +'padding:11px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
      +'<i class="ti ti-package-import" style="color:var(--t-azul)"></i>'
      +'<span style="font-size:12px;font-weight:700;color:var(--t-azul);flex:1">Facturado contra recibido</span>'

    +'</div>';

  if(!lineas.length){
    return h+'<div style="font-size:11px;color:var(--text-muted)">'
      +'Se necesita traer la entrada desde SAP para comparar lo facturado con lo que llegó.</div></div>';
  }

  var faltantes=lineas.filter(function(l){ return (Number(l.cantidad_abierta)||0)>0; });
  var totalFact=lineas.reduce(function(a,l){ return a+(Number(l.total_linea)||0); },0);
  var totalFalta=faltantes.reduce(function(a,l){ return a+(Number(l.monto_faltante)||0); },0);
  var uFalta=faltantes.reduce(function(a,l){ return a+(Number(l.cantidad_abierta)||0); },0);

  h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:9px">'
    +_costKpi('Líneas', String(lineas.length), '#0c447c')
    +_costKpi('Total facturado', fmt(totalFact), '#166534')
    +_costKpi('Líneas con faltante', String(faltantes.length), faltantes.length?'#991b1b':'#6b7280')
    +_costKpi('Unidades faltantes', _fmtN2(uFalta), faltantes.length?'#991b1b':'#6b7280')
    +_costKpi('Valor del faltante', fmt(totalFalta), faltantes.length?'#991b1b':'#6b7280')
    +'</div>';

  var hayDanios=((d.danios&&d.danios.lista)||[]).length>0;
  if(!faltantes.length && !hayDanios){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;'
      +'font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Llegó todo lo facturado. No hay cantidades abiertas.</div>';
    h+=_bodDaniosPanel(oid);
    return h+'</div>';
  }
  if(!faltantes.length){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;'
      +'font-size:11.5px;color:var(--t-verde);font-weight:600;margin-bottom:9px">'
      +'<i class="ti ti-circle-check"></i> Las cantidades llegaron completas.</div>'
      +_bodDaniosPanel(oid);
    h+=_reclEstadoBloque(oid);
    return h+'</div>';
  }

  h+='<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden;margin-bottom:9px">'
    +'<div style="background:var(--pastel-error);padding:7px 11px;font-size:11.5px;font-weight:700;color:var(--t-rojo)">'
      +'<i class="ti ti-alert-triangle"></i> '+faltantes.length+' artículo(s) no llegaron completos</div>'
    +'<div style="max-height:320px;overflow:auto">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
    +'<thead><tr style="background:var(--surface-1);position:sticky;top:0">'
      +'<th style="padding:5px 7px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">SKU</th>'
      +'<th style="padding:5px 7px;text-align:left;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Descripción</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Facturado</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Recibido</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Falta</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Precio</th>'
      +'<th style="padding:5px 7px;text-align:right;font-size:9px;text-transform:uppercase;color:var(--text-muted)">Monto</th>'
    +'</tr></thead><tbody>';
  faltantes.forEach(function(l){
    h+='<tr style="border-top:0.5px solid var(--border)">'
      +'<td style="padding:4px 7px;font-family:monospace;font-size:10.5px">'+_esc(l.sku||'')+'</td>'
      +'<td style="padding:4px 7px;max-width:230px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" '
        +'title="'+_esc(l.descripcion||'')+'">'+_esc(l.descripcion||'')+'</td>'
      +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(l.cantidad)+'</td>'
      +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(l.cantidad_recibida)+'</td>'
      +'<td style="padding:4px 7px;text-align:right;font-weight:700;color:var(--t-rojo)">'+_fmtN2(l.cantidad_abierta)+'</td>'
      +'<td style="padding:4px 7px;text-align:right">'+_fmtN2(l.precio)+'</td>'
      +'<td style="padding:4px 7px;text-align:right;font-weight:700;color:var(--t-rojo)">'+fmt(l.monto_faltante)+'</td>'
    +'</tr>';
  });
  h+='<tr style="background:var(--surface-1);font-weight:800">'
    +'<td colspan="4" style="padding:6px 7px;text-align:right">TOTAL</td>'
    +'<td style="padding:6px 7px;text-align:right;color:var(--t-rojo)">'+_fmtN2(uFalta)+'</td>'
    +'<td></td>'
    +'<td style="padding:6px 7px;text-align:right;color:var(--t-rojo)">'+fmt(totalFalta)+'</td>'
    +'</tr></tbody></table></div></div>';

  h+=_bodDaniosPanel(oid);

  h+=_reclEstadoBloque(oid);
  return h+'</div>';
}

// ── En sala de venta: las muestras ──
function _bodSalaPanel(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var e=ents[0]||{};
  var env=e.muestras_enviadas, rec=e.muestras_recibidas;

  var h=_bodEntradaCampo(oid);
  h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:9px;'
    +'padding:11px 12px;margin-bottom:10px">'
    +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
      +'<i class="ti ti-box-seam" style="color:#3B6D11"></i>'
      +'<span style="font-size:12px;font-weight:700;color:#3B6D11;flex:1">Muestras de oficina</span>'

    +'</div>';

  if(!ents.length){
    return h+'<div style="font-size:11px;color:var(--text-muted)">'
      +'Se necesita traer la entrada desde SAP para ver las muestras.</div></div>';
  }

  h+='<div style="display:flex;gap:10px;flex-wrap:wrap">'
    +'<div style="flex:1;min-width:190px;background:var(--surface-1);border-radius:8px;padding:9px 11px">'
      +'<div style="font-size:9.5px;color:var(--text-muted);font-weight:700;text-transform:uppercase;margin-bottom:3px">'
        +'<i class="ti ti-arrow-up-right" style="color:var(--t-azul)"></i> Muestras enviadas a oficina</div>'
      +'<div style="font-size:13px;font-weight:700;color:'+(env?'#0c447c':'var(--text-muted)')+'">'
        +_esc(env||'Sin registrar')+'</div></div>'
    +'<div style="flex:1;min-width:190px;background:var(--surface-1);border-radius:8px;padding:9px 11px">'
      +'<div style="font-size:9.5px;color:var(--text-muted);font-weight:700;text-transform:uppercase;margin-bottom:3px">'
        +'<i class="ti ti-arrow-down-left" style="color:var(--t-verde)"></i> Muestras recibidas en oficina</div>'
      +'<div style="font-size:13px;font-weight:700;color:'+(rec?'#166534':'var(--text-muted)')+'">'
        +_esc(rec||'Sin registrar')+'</div></div>'
    +'</div>';

  if(!env && !rec){
    h+='<div style="font-size:10.5px;color:var(--text-muted);margin-top:7px">'
      +'Estos datos se cargan en SAP, en la factura de reserva de esta orden.</div>';
  }

  // Con las muestras recibidas el paso se da por terminado
  if(rec){
    var cerrado=false;
    try{ cerrado=_bodSalaCerrar(oid); }catch(e){}
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;'
      +'padding:8px 11px;margin-top:8px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Muestras recibidas en oficina: el paso queda completado.</div>';
  }
  return h+'</div>';
}

// ── Reclamo al proveedor por mercancía faltante ──
async function _reclamoModal(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var lineas=[];
  ents.forEach(function(e){
    (e.lineas||[]).forEach(function(l){
      if((Number(l.cantidad_abierta)||0)>0){
        lineas.push(Object.assign({}, l, {factura:e.apri_numero, fecha:e.fecha}));
      }
    });
  });
  // La mercancía dañada se reclama igual que la faltante
  ((d.danios&&d.danios.lista)||[]).forEach(function(x){
    lineas.push({
      sku:x.sku, descripcion:(x.motivo?('DAMAGED · '+x.motivo):'DAMAGED'),
      cantidad:Number(x.cantidad)||0, cantidad_recibida:0,
      cantidad_abierta:Number(x.cantidad)||0, precio:Number(x.precio)||0,
      monto_faltante:(Number(x.cantidad)||0)*(Number(x.precio)||0),
      _danio:true
    });
  });
  if(!lineas.length){ showT('No hay faltantes ni daños que reclamar'); return; }

  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var e0=ents[0]||{};
  var dept=dat.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  window._mailAdj=[];
  window._reclamoCtx={oid:oid, lineas:lineas};

  // Las compradoras del departamento, marcadas por defecto
  var comprasDept=(USERS||[]).filter(function(u){
    return u.role==='compras' && u.email && dept && String(u.dept||'')===String(dept);
  });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    var marcado = comprasDept.length
      ? comprasDept.some(function(z){ return z.id===u.id; })
      : (u.role==='compras');
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;'
      +'border:0.5px solid '+(marcado?'#991b1b':'var(--border)')+';border-radius:8px;cursor:pointer;'
      +'font-size:12px;background:'+(marcado?'#FEF2F2':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)
        +(u.dept?(' · '+_esc(dL(u.dept))):'')+'</span></label>';
  }).join('');

  var totalU=lineas.reduce(function(a,l){ return a+(Number(l.cantidad_abierta)||0); },0);
  var totalM=lineas.reduce(function(a,l){ return a+(Number(l.monto_faltante)||0); },0);
  var po=dat.po||dat.numAtCard||ordenTxt;

  // La tabla, alineada para que se lea bien en el correo
  var anchoSku=Math.max(6, Math.max.apply(null, lineas.map(function(l){ return String(l.sku||'').length; })));
  var anchoDes=Math.min(40, Math.max(12, Math.max.apply(null, lineas.map(function(l){ return String(l.descripcion||'').length; }))));
  function col(t,n,der){
    t=String(t==null?'':t);
    if(t.length>n) t=t.slice(0,n-1)+'…';
    return der ? (' '.repeat(n-t.length)+t) : (t+' '.repeat(n-t.length));
  }
  var tabla=col('SKU',anchoSku)+'  '+col('DESCRIPTION',anchoDes)+'  '
    +col('INVOICED',10,1)+'  '+col('RECEIVED',10,1)+'  '+col('MISSING',9,1)+'  '+col('AMOUNT',13,1)+'\n'
    +'-'.repeat(anchoSku+anchoDes+52)+'\n'
    +lineas.map(function(l){
        return col(l.sku,anchoSku)+'  '+col(l.descripcion,anchoDes)+'  '
          +col(_fmtN2(l.cantidad),10,1)+'  '+col(_fmtN2(l.cantidad_recibida),10,1)+'  '
          +col(_fmtN2(l.cantidad_abierta),9,1)+'  '+col('US$ '+_fmtN2(l.monto_faltante),13,1);
      }).join('\n');

  var hayDanio=lineas.some(function(l){ return l._danio; });
  var asunto=(hayDanio?'Missing / Damaged Merchandise Claim - PO #'
                      :'Missing Merchandise Claim - PO #')+po+' / Credit Note Request';
  var cuerpo='Dear Supplier,\n\n'
    +'After reviewing the merchandise received for PO #'+po+', we found some missing items '
    +'when comparing the quantities on your invoice with the quantities we actually received.\n\n'
    +'Order Information:\n'
    +'  * Supplier: '+(dat.proveedor||'')+'\n'
    +'  * PO Number: '+po+'\n'
    +'  * Invoice Number: '+(e0.apri_numero||'')+'\n'
    +'  * Invoice Date: '+(e0.fecha?_fmtFechaCorta(e0.fecha):'')+'\n\n'
    +(lineas.some(function(l){ return l._danio; })
      ? 'Missing and Damaged Merchandise:\n\n'
      : 'Missing Merchandise:\n\n')
    +tabla+'\n\n'
    +'Total Missing Units: '+_fmtN2(totalU)+'\n'
    +'Total Value of Missing Merchandise: US$ '+_fmtN2(totalM)+'\n\n'
    +'Please review the above information and issue a CREDIT NOTE for the total amount of '
    +'US$ '+_fmtN2(totalM)+' corresponding to the missing merchandise.\n\n'
    +'Please send us the official credit note document as soon as possible. This credit will '
    +'remain on our account and will be used toward our future orders with you.\n\n'
    +'Please give priority to this claim and confirm once the credit note has been issued.\n\n'
    +'Thank you for your prompt attention and cooperation.\n\n'
    +'Best regards,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalReclamo'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalReclamo';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;'
    +'display:flex;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;'
    +'width:100%;max-width:820px;max-height:92vh;overflow-y:auto">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-rojo)">'
        +'<i class="ti ti-alert-triangle"></i> Reclamo por mercancía faltante</div>'
      +'<button onclick="_reclamoCerrar()" style="background:none;border:none;font-size:22px;'
        +'cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="background:var(--pastel-error);border:1px solid #dc2626;border-radius:9px;padding:9px 11px;'
      +'margin-bottom:12px;font-size:11.5px;color:var(--t-rojo)">'
      +'<b>'+lineas.length+' artículo(s)</b> · '+_fmtN2(totalU)+' unidades · '
      +'<b>US$ '+_fmtN2(totalM)+'</b> a reclamar</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA'
      +(comprasDept.length?(' <span style="color:var(--t-rojo);font-weight:600">· compras de '+_esc(dL(dept))+' marcadas</span>'):'')
      +'</div>'
    +'<div id="reclamo-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'+chips+'</div>'
    +'<input id="reclamo-extra" placeholder="Otros correos, separados por coma" '
      +'style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;'
      +'font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="reclamo-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;'
      +'border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="reclamo-cuerpo" rows="20" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);'
      +'border-radius:8px;font-size:11.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);'
      +'font-family:monospace;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">'
      +'Puedes adjuntar las fotos de la descarga como respaldo del reclamo.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_reclamoCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="reclamo-btn" style="background:#991b1b" onclick="_reclamoEnviar()">'
        +'<i class="ti ti-send"></i> Enviar reclamo</button>'
    +'</div></div>';
  ov.addEventListener('click', function(ev){ ev.stopPropagation(); });
  document.body.appendChild(ov);
}

function _reclamoCerrar(){
  var m=document.getElementById('modalReclamo'); if(m) m.remove();
  window._mailAdj=[]; window._reclamoCtx=null;
}

async function _reclamoEnviar(){
  var ctx=window._reclamoCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var oid=ctx.oid;
  var box=document.getElementById('reclamo-dests');
  var para=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  var extra=((document.getElementById('reclamo-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=para.concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });
  if(!todos.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }

  var asunto=(document.getElementById('reclamo-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('reclamo-cuerpo')||{}).value||'';
  var btn=document.getElementById('reclamo-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:todos[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Reclamo por faltantes · '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      _mailMsg('No se pudo encolar el correo.','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar reclamo'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar reclamo'; }
    return;
  }

  // Desde aquí, PASE LO QUE PASE el botón se libera. Es la única forma de
  // garantizar que no se quede en "Enviando…": cualquier paso de los de
  // abajo puede fallar según desde dónde se abriera el reclamo.
  try{
  var totalM=(ctx.lineas||[]).reduce(function(a,l){ return a+(Number(l.monto_faltante)||0); },0);
  // Esto NO estaba protegido: si fallaba —por ejemplo al reclamar desde una
  // orden abierta, donde el identificador es la referencia y no un id de
  // orden— la función se cortaba aquí. El correo salía, pero el botón se
  // quedaba en "Enviando…" para siempre.
  try{
    _solEnvioGuardar(oid, 'reclamo', {
      fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
      asunto:asunto, cuerpo:cuerpo, monto:totalM, lineas:(ctx.lineas||[]).length,
      estado:'enviado'
    });
  }catch(e){ console.warn('[reclamo] guardar envío:', e); }

  // También en memoria, de inmediato. Así el reclamo aparece en las alertas
  // sin esperar a la tabla: si falta la columna o la tabla, al menos quien
  // lo envió lo ve al momento.
  try{
    window._reclEstados=window._reclEstados||{};
    window._reclEstados[String(oid)]=Object.assign(
      window._reclEstados[String(oid)]||{}, {
        estado:'enviado', enviado_en:new Date().toISOString(),
        enviado_por:(CU&&CU.name)||'', monto:totalM,
        lineas:(ctx.lineas||[]).length, para:todos.join(', '),
        proveedor:ctx.proveedor||'', dept:ctx.dept||''
      });
    console.log('[reclamo] '+oid+' · '+(ctx.lineas||[]).length+' línea(s) · '
      +totalM.toFixed(2)+' · registrado en las alertas');
  }catch(e){ console.warn('[reclamo] memoria:', e); }
  // El estado va a su tabla, para que lo vea cualquiera y no dependa
  // del navegador de quien envió el correo.
  var ahoraIso=new Date().toISOString();
  try{
    await _reclGuardarEstado(oid, {
      estado:'enviado', enviado_en:ahoraIso, enviado_por:(CU&&CU.name)||'',
      monto:totalM, lineas:(ctx.lineas||[]).length,
      para:todos.join(', '),
      proveedor:ctx.proveedor||'', dept:ctx.dept||''
    });
  }catch(e){}
  try{
    var dRe=_logLeer(oid);
    dRe.reclamo=dRe.reclamo||{};
    dRe.reclamo.estado='enviado';
    dRe.reclamo.fecha=ahoraIso;
    dRe.reclamo.por=(CU&&CU.name)||'';
    dRe.reclamo.monto=totalM;
    await _logGuardar(oid);
  }catch(e){}

  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Bodega & Venta', paso:_PASO_BOD_SAP,
      texto:'Reclamo por mercancía faltante · '+(ctx.lineas||[]).length+' artículo(s) · US$ '+_fmtN2(totalM),
      etiqueta:'Reclamo al proveedor'
    });
  }catch(e){}

  // El botón vuelve a su estado ANTES de cerrar: si algo falla al cerrar o
  // al repintar, no se queda en "Enviando…" para siempre, que es lo que
  // pasaba al reclamar desde una orden abierta.
  if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar reclamo'; }

  // El reclamo se abre desde dos sitios y cada uno tiene su ventana:
  // la de faltantes de una entrada, y la de una orden abierta. Se cierra la
  // que corresponda, y el repintado va protegido.
  try{
    if(ctx._desdeOC){ CM(); }
    else { _reclamoCerrar(); }
  }catch(e){ try{ CM(); }catch(e2){} }

  try{ _accRegistrar('accion','Envió reclamo al proveedor', oid); }catch(e){}
  showT('✓ Reclamo enviado a '+todos.length+' destinatario(s)');

  try{
    if(ctx._desdeOC){
      window._ocPend=null; window._ocPendPidiendo=0;   // se recarga el estado
      _ocPendCargar(true).then(function(){
        try{ if(PG==='ocpend') rOcPend(); else rDash(); }catch(e){}
      });
      _reclCargarEstados().then(function(){ try{ rAlertas(); }catch(e){} })
        .catch(function(){});
    } else {
      _bodRepintar(oid);
    }
    // El panel de reclamos de la pantalla de Alertas, venga de donde venga
    try{ if(PG==='alertas') rAlertas(); }catch(e){}
  }catch(e){ console.warn('[reclamo] repintar:', e); }
  }catch(errFin){
    console.error('[reclamo] falló después de encolar el correo:', errFin);
    showT('El correo salió, pero no se pudo registrar el reclamo. '
      +'Mira la consola.', 7000);
  }finally{
    var b2=document.getElementById('reclamo-btn');
    if(b2){ b2.disabled=false; b2.innerHTML='<i class="ti ti-send"></i> Enviar reclamo'; }
  }
}

// Cierra un modal con la tecla Esc, y limpia el escuchador al salir
function _modalEsc(ov){
  if(!ov) return;
  var f=function(ev){
    if(ev.key!=='Escape') return;
    // Solo el modal de más arriba responde a Esc
    var todos=document.querySelectorAll('[data-modal-esc="1"]');
    if(todos.length && todos[todos.length-1]!==ov) return;
    document.removeEventListener('keydown', f);
    if(ov.parentNode) ov.remove();
  };
  ov.setAttribute('data-modal-esc','1');
  document.addEventListener('keydown', f);
  // Si lo cierra un botón, el escuchador se quita solo
  var obs=new MutationObserver(function(){
    if(!document.body.contains(ov)){
      document.removeEventListener('keydown', f);
      obs.disconnect();
    }
  });
  obs.observe(document.body, {childList:true, subtree:true});
}

// ═══════════════════════════════════════════════════════════════════════════
//  REPORTES
//  Un lugar con los reportes del portal. El primero es el estado de las
//  entradas: dónde está cada embarque según las fechas cargadas en SAP.
// ═══════════════════════════════════════════════════════════════════════════
var _REPORTES = [
  {k:'entradas', t:'Estado de las entradas', i:'ti-truck-delivery', c:'#0c447c',
   d:'Dónde está cada embarque: en puerto, en rampa, descargando, en trámite o ya actualizado.'}
];
window._repActual='entradas';

// Las etapas por las que pasa una entrada, en orden. La última fecha con
// dato marca dónde está: si tiene fecha de rampa pero no de descarga,
// entonces está en rampa.
var _ENT_ETAPAS = [
  {k:'anunciada',  t:'Anunciada',     campo:null,                  c:'#6b7280', i:'ti-file-text',
   d:'La factura existe pero todavía no llegó el barco'},
  {k:'puerto',     t:'En puerto',     campo:'eta',                 c:'#0c447c', i:'ti-anchor',
   d:'El barco llegó a puerto'},
  {k:'rampa',      t:'En rampa',      campo:'fecha_rampa',         c:'#5B21B6', i:'ti-truck-loading',
   d:'El contenedor salió del puerto'},
  {k:'descarga',   t:'Descargado',    campo:'fecha_descarga',      c:'#B45309', i:'ti-package-import',
   d:'Se descargó la mercancía'},
  {k:'devuelto',   t:'Contenedor devuelto', campo:'fecha_devuelto', c:'#7C3D12', i:'ti-arrow-back-up',
   d:'El contenedor vacío volvió a la naviera'},
  {k:'tramite',    t:'En trámite',    campo:'fecha_tramite',       c:'#0891B2', i:'ti-file-search',
   d:'En trámite aduanero'},
  {k:'actualizada',t:'Actualizada',   campo:'fecha_actualizacion', c:'#166534', i:'ti-circle-check',
   d:'Ya está en el inventario'}
];

// En qué etapa está una entrada
function _entEtapaDe(e){
  var ult=_ENT_ETAPAS[0];
  for(var i=1;i<_ENT_ETAPAS.length;i++){
    var c=_ENT_ETAPAS[i].campo;
    if(c && e[c]) ult=_ENT_ETAPAS[i];
  }
  // El estatus de bodega manda si dice que ya se actualizó
  if(String(e.estatus_bodega||'').toUpperCase().indexOf('ACTUALIZ')>=0){
    ult=_ENT_ETAPAS[_ENT_ETAPAS.length-1];
  }
  return ult;
}

// Días detenida en la etapa actual
function _entDiasEn(e, etapa){
  var f=etapa.campo?e[etapa.campo]:(e.fecha||'');
  if(!f) return null;
  var d=_repParseFecha(f);
  if(!d) return null;
  return Math.floor((Date.now()-d.getTime())/86400000);
}

// Todas las entradas conocidas, de todas las órdenes
function _repEntradasTodas(){
  var out=[];
  Object.keys(window._logData||{}).forEach(function(oid){
    var d=window._logData[oid];
    var lista=(d && d.entradas && d.entradas.lista)||[];
    lista.forEach(function(e){
      var dat={};
      try{ dat=_solPagoDatosOrden(oid)||{}; }catch(x){}
      var dept=dat.dept||'';
      if(!dept){
        var o=(typeof orders!=='undefined')?orders.find(function(z){return String(z.id)===String(oid);}):null;
        if(o) dept=o.dept||'';
        if(!dept){
          var p=(window._pendSAP||[]).find(function(z){
            return String(z.dkc)===String(oid)||String(z.num_orden)===String(oid); });
          if(p) dept=p.dept||'';
        }
      }
      out.push(Object.assign({}, e, {
        _oid:oid, _dept:dept||'otros',
        _proveedor:e.proveedor||dat.proveedor||''
      }));
    });
  });
  return out;
}

async function rReportes(){
  var box=document.getElementById('page-reportes'); if(!box) return;

  var h='<div style="font-size:13px;font-weight:600;margin-bottom:3px">'
    +'<i class="ti ti-report" style="color:var(--text-accent)"></i> Reportes</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted);margin-bottom:12px">'
    +'Vistas de conjunto para seguir el trabajo sin entrar orden por orden.</div>';

  // Los reportes disponibles
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:14px">';
  _REPORTES.forEach(function(r){
    var on=(window._repActual===r.k);
    h+='<button onclick="_repIr(\''+r.k+'\')" style="border:1px solid '+(on?r.c:'var(--border)')+';'
      +'background:'+(on?r.c:'var(--surface-1)')+';color:'+(on?'#fff':r.c)+';'
      +'border-radius:9px;padding:8px 14px;font-size:12px;font-weight:600;cursor:pointer;'
      +'text-align:left;max-width:280px">'
      +'<i class="ti '+r.i+'"></i> '+_esc(r.t)
      +'<div style="font-size:10px;font-weight:400;opacity:.85;margin-top:2px">'+_esc(r.d)+'</div>'
      +'</button>';
  });
  h+='</div>';

  h+='<div id="rep-cuerpo"></div>';
  box.innerHTML=h;

  // Los datos pueden no estar cargados todavía
  if(!window._reclCargado){
    var c=document.getElementById('rep-cuerpo');
    if(c) c.innerHTML='<div style="padding:20px;text-align:center;color:var(--text-muted);font-size:12px">'
      +'<span class="ai-ring g"></span> Cargando las entradas…</div>';
    try{ await _reclPrecargar(); }catch(e){}
  }
  _repPintar();
}

function _repIr(k){
  window._repActual=k;
  rReportes();
}

function _repPintar(){
  var c=document.getElementById('rep-cuerpo'); if(!c) return;
  try{
    if(window._repActual==='entradas') c.innerHTML=_repEntradasVista();
    else c.innerHTML='<div style="color:var(--text-muted);font-size:12px">Reporte no disponible.</div>';
  }catch(e){
    c.innerHTML='<div style="color:var(--text-danger);font-size:12px">No se pudo armar el reporte: '
      +_esc(e.message||e)+'</div>';
    console.error('[reportes]', e);
  }
}

// ── Reporte: estado de las entradas ──
function _repEntradasVista(){
  var todas=_repEntradasTodas();

  // Compras ve su departamento; el resto ve todo
  if(CU && CU.role==='compras' && _deptAcotado()){
    todas=todas.filter(function(e){ return _deptPermitido(e._dept); });
  }

  var fEtapa=window._repFiltroEtapa||'todas';
  var fDept=window._repFiltroDept||'todos';

  // Se clasifica cada una
  todas.forEach(function(e){
    e._etapa=_entEtapaDe(e);
    e._dias=_entDiasEn(e, e._etapa);
  });

  if(!todas.length){
    return '<div style="background:var(--surface-1);border-radius:10px;padding:24px;text-align:center;'
      +'color:var(--text-muted);font-size:12px">'
      +'<i class="ti ti-inbox" style="font-size:26px;display:block;margin-bottom:8px"></i>'
      +'No hay entradas cargadas todavía.<br>'
      +'<span style="font-size:11px">Se cargan al consultar SAP desde la etapa de Logística o Bodega.</span>'
      +'</div>';
  }

  // Conteo por etapa, para los botones
  var porEtapa={};
  todas.forEach(function(e){ porEtapa[e._etapa.k]=(porEtapa[e._etapa.k]||0)+1; });

  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
    +'<span style="font-size:11px;color:var(--text-muted);font-weight:600">Etapa</span>'
    +'<button onclick="_repSetEtapa(\'' + 'todas' + '\')" style="border:1px solid '
      +((fEtapa==='todas')?'#0c447c':'var(--border)')+';background:'
      +((fEtapa==='todas')?'#0c447c':'var(--surface-1)')+';color:'
      +((fEtapa==='todas')?'#fff':'#0c447c')+';border-radius:20px;padding:4px 12px;'
      +'font-size:11px;font-weight:600;cursor:pointer">Todas '+todas.length+'</button>';
  _ENT_ETAPAS.forEach(function(et){
    var n=porEtapa[et.k]||0;
    if(!n) return;
    var on=(fEtapa===et.k);
    h+='<button onclick="_repSetEtapa(\''+et.k+'\')" title="'+_esc(et.d)+'" '
      +'style="border:1px solid '+(on?et.c:'var(--border)')+';background:'+(on?et.c:'var(--surface-1)')
      +';color:'+(on?'#fff':et.c)+';border-radius:20px;padding:4px 12px;font-size:11px;'
      +'font-weight:600;cursor:pointer;white-space:nowrap">'
      +'<i class="ti '+et.i+'" style="font-size:11px"></i> '+_esc(et.t)+' '+n+'</button>';
  });
  h+='</div>';

  // Filtro por departamento
  var deptos={};
  todas.forEach(function(e){ deptos[e._dept]=(deptos[e._dept]||0)+1; });
  if(Object.keys(deptos).length>1){
    h+='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:12px">'
      +'<span style="font-size:11px;color:var(--text-muted);font-weight:600">Departamento</span>'
      +'<button onclick="_repSetDept(\'' + 'todos' + '\')" style="border:1px solid '
        +((fDept==='todos')?'#7C3D12':'var(--border)')+';background:'
        +((fDept==='todos')?'#7C3D12':'var(--surface-1)')+';color:'
        +((fDept==='todos')?'#fff':'#7C3D12')+';border-radius:20px;padding:4px 11px;'
        +'font-size:11px;font-weight:600;cursor:pointer">Todos</button>';
    Object.keys(deptos).sort().forEach(function(d){
      var on=(fDept===d);
      h+='<button onclick="_repSetDept(\''+d+'\')" style="border:1px solid '
        +(on?'#7C3D12':'var(--border)')+';background:'+(on?'#7C3D12':'var(--surface-1)')
        +';color:'+(on?'#fff':'#7C3D12')+';border-radius:20px;padding:4px 11px;font-size:11px;'
        +'font-weight:600;cursor:pointer">'+(EMOJIS2[d]||'')+' '+_esc(dL(d))+' '+deptos[d]+'</button>';
    });
    h+='</div>';
  }

  // Se aplican los filtros
  var lista=todas.filter(function(e){
    if(fEtapa!=='todas' && e._etapa.k!==fEtapa) return false;
    if(fDept!=='todos' && String(e._dept)!==fDept) return false;
    return true;
  });

  // De la más detenida a la más reciente
  lista.sort(function(a,b){ return (b._dias||0)-(a._dias||0); });

  h+='<div style="font-size:11px;color:var(--text-muted);margin-bottom:7px">'
    +lista.length+' entrada(s)'+(fEtapa!=='todas'?(' en '+(_ENT_ETAPAS.find(function(x){return x.k===fEtapa;})||{}).t):'')
    +' · ordenadas por tiempo detenido</div>';

  h+='<div style="border:0.5px solid var(--border);border-radius:10px;overflow:hidden">';
  lista.forEach(function(e,i){
    var et=e._etapa;
    var col=(e._dias!=null && e._dias>=15) ? '#991b1b'
          : (e._dias!=null && e._dias>=7) ? '#B45309' : 'var(--text-muted)';
    h+='<div onclick="_repIrEntrada(\''+_esc(String(e._oid).replace(/\x27/g,''))+'\')" '
      +'style="padding:9px 13px;'+(i?'border-top:0.5px solid var(--border);':'')
      +'background:var(--surface-0);cursor:pointer;display:flex;align-items:center;gap:11px;flex-wrap:wrap">'
      // La etapa, como distintivo
      +'<div style="min-width:118px">'
        +'<span style="display:inline-flex;align-items:center;gap:5px;background:'+et.c
        +';color:#fff;border-radius:14px;padding:3px 10px;font-size:10.5px;font-weight:700">'
        +'<i class="ti '+et.i+'" style="font-size:11px"></i>'+_esc(et.t)+'</span></div>'
      +'<div style="flex:1;min-width:180px">'
        +'<div style="font-size:12px;font-weight:600">Entrada '+_esc(e.entrada||'—')
          +'<span style="font-weight:400;color:var(--text-muted)"> · '+_esc(e._proveedor||'')+'</span></div>'
        +'<div style="font-size:10.5px;color:var(--text-muted)">'
          +'Orden '+_esc(e._oid)+' · '+(EMOJIS2[e._dept]||'')+' '+_esc(dL(e._dept))
          +(e.bl?(' · B/L '+_esc(e.bl)):'')
          +(e.naviera?(' · '+_esc(e.naviera)):'')
          +(e.num_contenedores?(' · '+_esc(e.num_contenedores)+' cont.'):'')
        +'</div></div>'
      +'<div style="text-align:right;min-width:92px">'
        +(e._dias!=null
          ? ('<div style="font-size:15px;font-weight:800;color:'+col+';line-height:1.1">'+e._dias+'</div>'
             +'<div style="font-size:8px;color:var(--text-muted);text-transform:uppercase">días aquí</div>')
          : '<div style="font-size:11px;color:var(--text-muted)">sin fecha</div>')
      +'</div>'
      +'<div style="min-width:86px;text-align:right">'
        +(e.eta?('<div style="font-size:10px;color:var(--text-muted)">ETA</div>'
                +'<div style="font-size:11.5px;font-weight:600">'+_esc(_fmtFechaCorta(e.eta))+'</div>'):'')
      +'</div>'
      +'</div>';
  });
  h+='</div>';

  // Resumen del recorrido
  h+='<div style="margin-top:14px;background:var(--surface-1);border-radius:10px;padding:11px 13px">'
    +'<div style="font-size:10.5px;font-weight:700;color:var(--text-secondary);margin-bottom:7px">'
    +'RECORRIDO DE UNA ENTRADA</div>'
    +'<div style="display:flex;gap:5px;flex-wrap:wrap;align-items:center">';
  _ENT_ETAPAS.forEach(function(et,i){
    h+=(i?'<i class="ti ti-chevron-right" style="color:var(--text-muted);font-size:11px"></i>':'')
      +'<span title="'+_esc(et.d)+'" style="font-size:10.5px;color:'+et.c+';font-weight:600;'
      +'background:var(--surface-0);border:0.5px solid '+et.c+'44;border-radius:12px;padding:2px 9px">'
      +_esc(et.t)+((porEtapa[et.k])?(' '+porEtapa[et.k]):'')+'</span>';
  });
  h+='</div></div>';
  return h;
}

function _repSetEtapa(k){ window._repFiltroEtapa=k; _repPintar(); }
function _repSetDept(k){ window._repFiltroDept=k; _repPintar(); }

// Abre la orden en la etapa de logística
function _repIrEntrada(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='logistica'; });
  window._abrirEtapa={oid:String(oid), key:'logistica', paso:2};
  try{ _solPagoAbrir(oid); }catch(e){ try{ openDetail(oid); }catch(e2){} }
  try{ _abrirEtapaPedida(0); }catch(e){}
}

function _entPanel(oid){
  var d=_logLeer(oid);
  var ents=(d.entradas&&d.entradas.lista)||[];
  var puede=_puedeAduana();

  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);'
    +'border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
    +'<i class="ti ti-truck-delivery" style="color:var(--t-azul)"></i>'
    +'<span style="font-size:12px;font-weight:700;color:var(--t-azul);flex:1">Entrada de mercancía en SAP</span>'
    +(puede?('<button class="btn bg2" style="padding:4px 11px;font-size:10.5px" onclick="event.stopPropagation();_entTraer(\'' + oid + '\')">'
      +'<i class="ti ti-database-import"></i> '+(ents.length?'Actualizar':'Traer de SAP')+'</button>'):'')
    +'</div>';

  if(!ents.length){
    h+='<div style="font-size:11px;color:var(--text-muted)">'
      +'Todavía no se trajeron los datos. Son los que carga contabilidad en la '
      +'factura de compra: número de entrada, B/L, naviera y las fechas del proceso.</div>'
      +'<div id="entcarga-'+oid+'" style="margin-top:7px"></div>';
    return h+'</div>';
  }

  h+='<div id="entcarga-'+oid+'"></div>';
  ents.forEach(function(e, i){
    h+=_entFicha(e, ents.length>1?(i+1):0);
  });
  if(d.entradas&&d.entradas.en){
    h+='<div style="font-size:10px;color:var(--text-muted);margin-top:6px">'
      +'Traído de SAP el '+_esc(_fechaHora(d.entradas.en))+'</div>';
  }
  return h+'</div>';
}

// Un contenedor real son 4 letras + 7 dígitos (MEDU7469395). Lo que no
// cumple ese formato suele ser un sello o una referencia, y no debería
// mostrarse como contenedor.
function _esContenedor(c){
  return /^[A-Z]{4}\s?\d{6,7}$/.test(String(c||'').trim().toUpperCase().replace(/[\s-]/g,''));
}

function _entDato(etiqueta, valor, color){
  var v=(valor==null||String(valor).trim()==='')?'—':String(valor);
  var vacio=(v==='—');
  return '<div style="min-width:118px">'
    +'<div style="font-size:9px;color:var(--text-muted);font-weight:600;text-transform:uppercase">'+_esc(etiqueta)+'</div>'
    +'<div style="font-size:12px;font-weight:'+(vacio?'400':'600')+';color:'
      +(vacio?'var(--text-muted)':(color||'var(--text-primary)'))+'">'+_esc(v)+'</div></div>';
}

function _entFicha(e, nro){
  var h='<div style="border:0.5px solid var(--border);border-radius:8px;padding:10px 12px;'
    +'margin-bottom:8px;background:var(--surface-1)">';

  // Cabecera: entrada, factura y proveedor
  h+='<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin-bottom:9px;'
    +'padding-bottom:8px;border-bottom:0.5px solid var(--border)">'
    +(nro?('<span style="font-size:10px;font-weight:700;background:#0c447c;color:#fff;'
      +'border-radius:10px;padding:1px 8px">'+nro+'</span>'):'')
    +'<span style="font-size:14px;font-weight:800;color:var(--t-azul)">Entrada '+_esc(e.entrada||'—')+'</span>'
    +(e.apri_numero?('<span style="font-size:11px;color:var(--text-muted)">Factura '+_esc(e.apri_numero)+'</span>'):'')
    +(e.fecha?('<span style="font-size:11px;color:var(--text-muted)">'+_esc(_fmtFechaCorta(e.fecha))+'</span>'):'')
    +'<span style="flex:1"></span>'
    +(e.total?('<span style="font-size:13px;font-weight:700;color:var(--t-verde)">'+fmt(e.total)+'</span>'):'')
    +'</div>';

  if(e.proveedor){
    h+='<div style="font-size:11.5px;margin-bottom:8px">'
      +'<b>'+_esc(e.proveedor_codigo||'')+'</b> '+_esc(e.proveedor)
      +(e.ref_proveedor?('<span style="color:var(--text-muted)"> · ref. '+_esc(e.ref_proveedor)+'</span>'):'')
      +'</div>';
  }

  // Embarque
  h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:9px">'
    +_entDato('B/L', e.bl, '#0c447c')
    +_entDato('Naviera', e.naviera)
    +(e.barco?_entDato('Barco', e.barco):'')
    +_entDato('Contenedores', e.num_contenedores)
    +_entDato('Tipo', e.tipo_contenedor)
    +'</div>';

  if(e.series_contenedores){
    // Se separan los contenedores de lo que no lo es: en el mismo campo
    // vienen sellos y referencias, y mezclarlos confunde al leer la ficha.
    var piezas=String(e.series_contenedores).split(/[\/,;]/)
      .map(function(c){ return c.trim(); }).filter(Boolean);
    var conts=piezas.filter(_esContenedor);
    var otros=piezas.filter(function(c){ return !_esContenedor(c); });

    h+='<div style="margin-bottom:9px">'
      +'<div style="font-size:9px;color:var(--text-muted);font-weight:600;text-transform:uppercase;margin-bottom:3px">'
        +'Series de contenedores'+(conts.length?(' ('+conts.length+')'):'')+'</div>'
      +'<div style="display:flex;gap:5px;flex-wrap:wrap">'
      +(conts.length
        ? conts.map(function(c){
            return '<span style="font-family:monospace;font-size:11px;background:var(--surface-0);'
              +'border:0.5px solid var(--border);border-radius:12px;padding:2px 9px">'+_esc(c)+'</span>';
          }).join('')
        : '<span style="font-size:11px;color:var(--text-muted)">Sin contenedores con formato válido</span>')
      +'</div>';

    if(otros.length){
      h+='<div style="margin-top:6px">'
        +'<div style="font-size:9px;color:var(--t-marron);font-weight:600;text-transform:uppercase;margin-bottom:3px">'
          +'Otros valores del campo U_Contenedor</div>'
        +'<div style="display:flex;gap:5px;flex-wrap:wrap">'
        +otros.map(function(c){
            return '<span title="Viene en el campo U_Contenedor de la factura '
              +_esc(e.apri_numero||'')+', junto al contenedor. No tiene formato de contenedor." '
              +'style="font-family:monospace;font-size:10.5px;background:var(--pastel-naranja);'
              +'border:0.5px solid #E9C08A;color:var(--t-marron);border-radius:12px;padding:2px 9px">'
              +_esc(c)+'</span>';
          }).join('')
        +'</div>'
        +'<div style="font-size:9.5px;color:var(--text-muted);margin-top:3px">'
          +'Está guardado en <b>U_Contenedor</b> de la factura '+_esc(e.apri_numero||'')
          +'. Si en SAP no aparece, puede estar en otro campo del mismo documento.</div>'
        +'</div>';
    }
    // El otro campo de contenedores, si trae algo distinto
    if(e.series_alterna && String(e.series_alterna).trim()
       && String(e.series_alterna).trim()!==String(e.series_contenedores||'').trim()){
      h+='<div style="margin-top:6px">'
        +'<div style="font-size:9px;color:var(--t-azul);font-weight:600;text-transform:uppercase;margin-bottom:3px">'
          +'Campo U_Contenedor_serie</div>'
        +'<div style="display:flex;gap:5px;flex-wrap:wrap">'
        +String(e.series_alterna).split(/[\/,;]/).map(function(c){
            c=c.trim();
            if(!c) return '';
            return '<span style="font-family:monospace;font-size:10.5px;background:var(--surface-0);'
              +'border:0.5px solid #85B7EB;color:var(--t-azul);border-radius:12px;padding:2px 9px">'+_esc(c)+'</span>';
          }).join('')
        +'</div></div>';
    }
    h+='</div>';
  }

  h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:9px">'
    +_entDato('Puerto de embarque', e.puerto_embarque)
    +(e.pais?_entDato('País', e.pais):'')
    +_entDato('Descripción de carga', e.descripcion_carga)
    +(e.terminos?_entDato('Términos', e.terminos):'')
    +'</div>';

  // Volúmenes, pesos y los costos estimados de la importación
  var med=[
    (Number(e.volumen)?_entDato('Volumen', _fmtN2(e.volumen)):''),
    (Number(e.peso)?_entDato('Peso', _fmtN2(e.peso)):''),
    (Number(e.volumen_estimado)?_entDato('Volumen estimado', _fmtN2(e.volumen_estimado)):''),
    (Number(e.flete_estimado)?_entDato('Flete estimado', fmt(e.flete_estimado), '#7C3D12'):''),
    (Number(e.gasto_estimado)?_entDato('Gasto estimado', fmt(e.gasto_estimado), '#7C3D12'):'')
  ].filter(Boolean);
  if(med.length){
    h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:9px">'+med.join('')+'</div>';
  }

  // Las fechas del proceso, en orden
  var fechas=[
    ['ETA',            e.eta,                 '#0c447c'],
    ['En rampa',       e.fecha_rampa,         ''],
    ['Descarga',       e.fecha_descarga,      ''],
    ['Devuelto',       e.fecha_devuelto,      ''],
    ['Almacenaje',     e.fecha_almacenaje,    ''],
    ['Retención',      e.fecha_retencion,     '#B45309'],
    ['Documento',      e.fecha_doc,           ''],
    ['Trámite',        e.fecha_tramite,       ''],
    ['Entrega',        e.fecha_entrega,       ''],
    ['Actualización',  e.fecha_actualizacion, '#166534']
  ].filter(function(f){ return f[1]; });

  if(fechas.length){
    h+='<div style="border-top:0.5px solid var(--border);padding-top:8px">'
      +'<div style="font-size:9px;color:var(--text-muted);font-weight:600;text-transform:uppercase;margin-bottom:5px">Fechas del proceso</div>'
      +'<div style="display:flex;gap:12px;flex-wrap:wrap">'
      +fechas.map(function(f){ return _entDato(f[0], _fmtFechaCorta(f[1]), f[2]); }).join('')
      +'</div></div>';
  }

  // Días libres de almacenaje y retención: si se pasan, hay recargo
  if(e.dias_libres_almacenaje || e.dias_libres_retencion){
    h+='<div style="display:flex;gap:12px;flex-wrap:wrap;margin-top:8px;padding-top:8px;'
      +'border-top:0.5px solid var(--border)">'
      +(e.dias_libres_almacenaje?_entDato('Días libres almacenaje', e.dias_libres_almacenaje, '#B45309'):'')
      +(e.dias_libres_retencion?_entDato('Días libres retención', e.dias_libres_retencion, '#B45309'):'')
      +'</div>';
  }

  if(e.estatus_bodega){
    h+='<div style="margin-top:8px">'
      +'<span style="font-size:10.5px;font-weight:700;background:var(--pastel-ok);color:var(--t-verde);'
      +'border-radius:10px;padding:3px 10px">'+_esc(e.estatus_bodega)+'</span></div>';
  }

  // Los comentarios que dejan importación y bodega en SAP
  [['Importación', e.comentario_importacion, '#0c447c'],
   ['Bodega',      e.comentario_bodega,      '#7C3D12']].forEach(function(c){
    if(!c[1]) return;
    h+='<div style="margin-top:7px;font-size:11px;background:var(--surface-0);'
      +'border-left:3px solid '+c[2]+';border-radius:0 7px 7px 0;padding:6px 10px">'
      +'<b style="color:'+c[2]+';font-size:9.5px;text-transform:uppercase">'+c[0]+'</b><br>'
      +'<span style="white-space:pre-wrap">'+_esc(c[1])+'</span></div>';
  });
  if(e.comentarios){
    h+='<div style="margin-top:8px;font-size:11px;color:var(--text-secondary);'
      +'background:var(--surface-0);border-radius:7px;padding:7px 9px;white-space:pre-wrap">'
      +_esc(e.comentarios)+'</div>';
  }
  return h+'</div>';
}

// Pide los datos a SAP a través del worker
// El aviso de carga aparece en varios sitios a la vez (cabecera, subetapas,
// modal) y todos usan el mismo id. Al terminar hay que limpiarlos TODOS:
// antes se limpiaba solo el primero y los demás seguían girando.
function _entAviso(oid, html){
  var els=document.querySelectorAll('[id="entcarga-'+oid+'"]');
  for(var i=0;i<els.length;i++) els[i].innerHTML=html||'';
}

async function _entTraer(oid){
  var d=_logLeer(oid);
  var entrada=String((d.arrival&&d.arrival.entrada)||'').trim();
  _entAviso(oid, '<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> Consultando SAP…</span>');

  var fid=null;
  try{
    var r=await fetch(SB+'/rest/v1/entradas_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=representation'}),
      body:JSON.stringify({docnum:String(oid), entrada:entrada,
                           pedido_por:(CU&&CU.name)||'', estado:'pendiente',
                           creado_en:new Date().toISOString()})});
    if(!r.ok){
      var t=await r.text();
      _entAviso(oid, '<div style="font-size:11px;color:var(--text-danger)">'
        +(/does not exist|Could not find the table/i.test(t)
          ? 'Falta la tabla entradas_queue en Supabase (script entradas_sap.sql).'
          : ('No se pudo pedir la información (error '+r.status+').'))+'</div>');
      return;
    }
    var f=await r.json();
    fid=(Array.isArray(f)&&f[0])?f[0].id:null;
  }catch(e){
    _entAviso(oid, '<div style="font-size:11px;color:var(--text-danger)">Error de conexión: '+_esc(e.message||e)+'</div>');
    return;
  }
  if(!fid){ _entAviso(oid, ''); return; }
  _entEsperar(oid, fid, 0);
}

function _entEsperar(oid, fid, intento){
  setTimeout(async function(){
    var fila=null;
    try{
      var r=await fetch(SB+'/rest/v1/entradas_queue?select=*&id=eq.'+fid+'&limit=1',{headers:SBH});
      if(r.ok){ var a=await r.json(); fila=(Array.isArray(a)&&a[0])?a[0]:null; }
    }catch(e){}
    if(!fila || fila.estado==='pendiente' || fila.estado==='procesando'){
      if(intento<50){
        var seg=Math.round((0.9+Math.min(intento,6)*1.2+Math.max(0,intento-6)*2.5));
        _entAviso(oid, '<span class="ai-wrap" style="color:var(--t-azul)"><span class="ai-ring g"></span> '
          +'Consultando SAP… ('+seg+'s)</span>');
        return _entEsperar(oid, fid, intento+1);
      }
      _entAviso(oid, '<div style="font-size:11px;color:var(--t-ambar)">SAP no respondió. Revisa que el worker esté corriendo.</div>');
      return;
    }
    if(fila.estado==='error'){
      // Si ya había datos, se conservan: un fallo al actualizar no debe
      // hacer parecer que la entrada no existe.
      var d0=_logLeer(oid);
      var teniaDatos=!!(d0.entradas && (d0.entradas.lista||[]).length);
      _entAviso(oid, '<div style="background:'+(teniaDatos?'#FEF3E8':'#FEF2F2')+';border:1px solid '
        +(teniaDatos?'#E9C08A':'#dc2626')+';border-radius:8px;padding:8px 11px;font-size:11.5px;color:'
        +(teniaDatos?'#7C3D12':'#991b1b')+'"><i class="ti ti-alert-triangle"></i> '
        +(teniaDatos
          ? 'No se pudo actualizar, pero se mantienen los datos traídos antes.'
          : _esc(fila.detalle||'No se encontró la información'))
        +'</div>');
      return;
    }
    var datos=fila.datos;
    if(typeof datos==='string'){ try{ datos=JSON.parse(datos); }catch(e){ datos=null; } }
    var lista=(datos&&datos.entradas)||[];
    if(!lista.length){
      _entAviso(oid, '<div style="font-size:11px;color:var(--t-ambar)">SAP respondió pero sin datos.</div>');
      return;
    }
    var d=_logLeer(oid);
    d.entradas={lista:lista, en:new Date().toISOString(), por:(CU&&CU.name)||''};

    // Lo que sirva se copia a los campos de logística, si están vacíos
    var e=lista[0];
    d.arrival=d.arrival||{}; d.bl=d.bl||{}; d.booking=d.booking||{};
    if(e.entrada && !d.arrival.entrada) d.arrival.entrada=e.entrada;
    if(e.bl){
      if(!d.bl.numero)  d.bl.numero=e.bl;
      if(!d.arrival.bl) d.arrival.bl=e.bl;
    }
    if(e.naviera && !d.booking.naviera) d.booking.naviera=String(e.naviera).toUpperCase();
    if(e.eta && !d.arrival.fecha_llegada) d.arrival.fecha_llegada=_fmtFechaCorta(e.eta);
    if(e.puerto_embarque && !d.bl.origen) d.bl.origen=e.puerto_embarque;
    // Los contenedores que vengan en la serie
    if(e.series_contenedores){
      d.contenedores=d.contenedores||[];
      var descartados=[];
      String(e.series_contenedores).split(/[\/,;]/).forEach(function(c){
        c=c.trim().toUpperCase();
        if(!c) return;
        // Solo lo que tenga formato de contenedor: antes entraban sellos
        // y referencias como si fueran contenedores.
        if(!_esContenedor(c)){ descartados.push(c); return; }
        if(d.contenedores.some(function(z){ return String(z.numero||'').toUpperCase()===c; })) return;
        d.contenedores.push({numero:c, tipo:String(e.tipo_contenedor||'').toUpperCase().trim()});
      });
      if(descartados.length){
        console.warn('[entradas] no tienen formato de contenedor:', descartados);
      }
    }
    await _logGuardar(oid);
    // Se apaga el aviso ANTES de repintar, para que no quede ninguno girando
    _entAviso(oid, '');
    showT('✓ '+lista.length+' entrada(s) traída(s) de SAP');
    _entRepintar(oid);
    try{ _logRepintar(oid); }catch(e2){}
    // Si la ventana está abierta, se refresca con los datos nuevos
    try{
      if(document.getElementById('modalEnt')){
        document.getElementById('modalEnt').remove();
        _entVerModal(oid);
      }
    }catch(e3){}
    // Se repintan SOLO los paneles afectados. Antes se llamaba a openDetail(),
    // que reconstruye la orden entera y sacaba al usuario del panel donde
    // estaba trabajando.
    try{ _bodRepintar(oid); }catch(e4){}
    try{
      // El resumen de la cabecera, sin tocar el resto
      var cab=document.querySelector('.mb');
      if(cab){
        var viejo=cab.querySelector('[data-entresumen="1"]');
        if(viejo) viejo.outerHTML=_entResumenSeguro(oid);
      }
    }catch(e5){}
    // El primer intento espera poco y luego se va espaciando: la consulta
    // suele resolverse en 1 o 2 segundos y no tiene sentido esperar 3.
  }, intento===0?900:(intento<6?1200:2500));
}

function _entRepintar(oid){
  var c=document.getElementById('entpanel-'+oid);
  if(c) c.innerHTML=_entPanel(oid);
}

function _logPanelArrival(oid){
  var d=_logLeer(oid), a=d.arrival||{}, bk=d.booking||{};
  var sk=_subKeyLog(_PASO_ARRIVAL);
  var docs=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var completo=!!(a.fecha_llegada && a.bl);

  var h='<div style="background:#FBEEDD;border:1px solid #DDA85F;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  h+='<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px">'
    +'<span class="sem '+(completo?'sem-g':(docs.length?'sem-y':'sem-r'))+'" style="width:11px;height:11px;flex-shrink:0"></span>'
    +'<div style="font-size:12px;font-weight:700;color:var(--t-marron);flex:1"><i class="ti ti-flag"></i> Aviso de llegada</div></div>';

  h+=_logZonaDocs(oid, sk, 'AVISO DE LLEGADA', 'Adjunta el arrival notice para que la AI lo lea', '#7C3D12');

  if(docs.length && _puedeAduana()){
    h+='<button class="btn bp" style="background:#5B21B6;font-size:11.5px;padding:7px 13px;margin-bottom:9px" onclick="event.stopPropagation();_logLeerIA(\'' + oid + '\',\'arrival\')">'
      +'<i class="ti ti-sparkles"></i> Leer con AI y verificar contra el booking</button>'
      +'<div id="logia-arrival-'+oid+'" style="margin-bottom:9px"></div>';
  }

  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'arrival','bl','B/L No.', a.bl, 160)
    +_logCampo(oid,'arrival','vessel','Vessel No.', a.vessel, 150)
    +_logCampo(oid,'arrival','viaje','Voyage', a.viaje, 120)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'arrival','shipper','Shipper', a.shipper, 200)
    +_logCampo(oid,'arrival','consignee','Consignee', a.consignee, 200)
    +'</div>'
    +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:8px">'
    +_logCampo(oid,'arrival','fecha_salida','ETD', a.fecha_salida, 120)
    +_logCampo(oid,'arrival','fecha_llegada','ETA', a.fecha_llegada, 120)
    +'</div>';

  // El número de entrada lo escribe importación a mano y es obligatorio
  // para pedir el pago del flete.
  var falta=!String(a.entrada||'').trim();
  h+='<div style="background:'+(falta?'#FEF2F2':'var(--surface-0)')+';border:1px solid '
    +(falta?'#dc2626':'var(--border)')+';border-radius:8px;padding:9px 11px;margin-bottom:8px">'
    +'<div style="font-size:10px;font-weight:700;color:'+(falta?'#991b1b':'#7C3D12')+';margin-bottom:4px">'
      +'NÚMERO DE ENTRADA <span style="color:var(--t-rojo2)">*</span>'
      +'<span style="font-weight:400;color:var(--text-muted);text-transform:none"> · lo escribe importación</span></div>'
    +'<input value="'+_esc(a.entrada||'')+'" placeholder="Escribe el número de entrada" onclick="event.stopPropagation()" '
    +'onchange="_logSetCampo(\'' + oid + '\',\'arrival\',\'entrada\',this.value);_logRepintar(\'' + oid + '\')" '
    +'style="width:100%;max-width:280px;padding:6px 9px;border:0.5px solid '+(falta?'#dc2626':'var(--border)')
    +';border-radius:6px;font-size:13px;font-weight:600;background:var(--surface-0);color:var(--text-primary)">'
    +(falta?('<div style="font-size:10.5px;color:var(--t-rojo);margin-top:4px">'
      +'<i class="ti ti-alert-circle"></i> Hace falta para solicitar el pago del flete: va en el cuerpo del correo.</div>'):'')
    +'</div>';

  h+=_trackBarra(oid,'arrival');
  h+=_logContenedores(oid, true);
  if(a.fecha_llegada||a.bl||a.entrada||(a.tarifas||[]).length){
    h+='<div style="display:flex;justify-content:flex-end;margin-bottom:6px">'
      +'<button class="btn bg2" style="padding:3px 9px;font-size:10px;color:var(--text-danger)" onclick="event.stopPropagation();_logVaciarDatos(\'' + oid + '\',\'arrival\',\'aviso de llegada\')" title="Borra los datos, deja los documentos"><i class="ti ti-eraser"></i> Vaciar datos</button></div>';
  }
  if((a.tarifas||[]).length){
    h+='<div style="font-size:10.5px;font-weight:700;color:var(--t-marron);margin-bottom:4px">CARGOS DEL AVISO</div>';
    h+=_logTablaTarifas(a.tarifas, true, oid, 'arrival');
    h+=_logComparar(bk.tarifas, a.tarifas, 'booking', 'aviso de llegada');
  }

  // Solicitud de pago del flete a contabilidad
  var env=_solEnvioLeer(oid,'flete');
  if(env){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;margin-top:8px">'
      +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde)"><i class="ti ti-circle-check"></i> Solicitud de pago de flete enviada</div>'
      +'<div style="font-size:11px;color:var(--t-verde);margin-top:2px">'
        +'Por <b>'+_esc(env.por||'')+'</b> · '+_esc(_fechaHora(env.fecha))
        +(env.para&&env.para.length?('<br>A: '+_esc(env.para.join(', '))):'')
        +(env.adjuntos&&env.adjuntos.length?('<br>'+env.adjuntos.length+' adjunto(s)'):'')
      +'</div>';
    if(env.cuerpo){
      h+='<details style="margin-top:5px"><summary style="font-size:10.5px;color:var(--t-verde);cursor:pointer;font-weight:600">Ver el correo enviado</summary>'
        +'<div style="font-size:11px;color:var(--t-verde);white-space:pre-wrap;background:var(--surface-0);border-radius:7px;padding:8px 10px;margin-top:5px;max-height:260px;overflow-y:auto">'+_esc(env.cuerpo)+'</div></details>';
    }
    h+='</div>';
  }
  if(_puedeAduana()){
    var sinEntrada=!String(a.entrada||'').trim();
    h+='<div style="margin-top:9px">'
      +'<button class="btn bp" style="background:'+(sinEntrada?'#9ca3af':'#7C3D12')+';font-size:11.5px;padding:7px 13px"'
      +(sinEntrada?' title="Primero escribe el número de entrada"':'')
      +' onclick="event.stopPropagation();_fleteModal(\'' + oid + '\')">'
      +'<i class="ti ti-cash"></i> '+(env?'Volver a enviar la solicitud':'Solicitar el pago del flete')+'</button>'
      +(sinEntrada?('<div style="font-size:10.5px;color:var(--t-rojo);margin-top:4px"><i class="ti ti-alert-circle"></i> Falta el número de entrada.</div>'):'')
      +'</div>';
  }
  // Los datos que carga contabilidad en SAP
  h+='<div id="entpanel-'+oid+'">';
  try{ h+=_entPanel(oid); }catch(e){ console.warn('entradas:',e); }
  h+='</div>';

  h+=_btnCerrarPaso(oid, 'logistica', _PASO_ARRIVAL,
      {falta: env ? '' : 'Todavía no se pidió el pago del flete. Puedes marcarlo igual si ya está resuelto.'});
  return h+'</div>';
}

// Zona de documentos de una subetapa
function _logZonaDocs(oid, sk, titulo, ayuda, color){
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var h='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:9px 11px;margin-bottom:8px">'
    +'<div style="font-size:10px;font-weight:700;color:'+color+';margin-bottom:4px">'+titulo
    +' <span style="font-weight:400;color:var(--text-muted)">('+files.length+')</span></div>';
  if(files.length){
    files.forEach(function(a,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
        +'<i class="ti ti-file" style="color:'+color+'"></i>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
        +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px" onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button>'
        +'<button class="btn bg2" style="padding:3px 7px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_logBorrarDoc(\'' + oid + '\',\'' + sk + '\','+i+')"><i class="ti ti-trash"></i></button>'
        +'</div>';
    });
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(ayuda)+'</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:6px;padding:6px 9px;border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+';margin-top:6px">'
    +'<i class="ti ti-upload"></i> Adjuntar'
    +'<input type="file" multiple accept=".pdf,.xlsx,.xls,.csv,.doc,.docx,image/*" style="display:none" onchange="_logSubirDoc(\'' + oid + '\',\'' + sk + '\',this.files)"></label>';
  return h+'</div>';
}

async function _logSubirDoc(oid, sk, files){
  if(!files||!files.length) return;
  showT('Subiendo '+files.length+' archivo(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sk, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sk, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sk]) window._atts[oid+sk]=[];
      window._atts[oid+sk].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir logistica:',e); }
  }
  showT('✓ Adjuntado. Pulsa "Leer con AI" para llenar los datos.');
  _logRepintar(oid);
}

// Borrar el documento borra TODA la subetapa: los datos que la AI sacó de él
// dejan de tener respaldo, así que se limpian juntos.
async function _logBorrarDoc(oid, sk, i){
  var a=(window._atts&&window._atts[oid+sk])?window._atts[oid+sk][i]:null;
  if(!a) return;

  // ¿A qué subetapa pertenece este documento?
  var mapa=[[_subKeyLog(_PASO_BOOKING),'booking','Booking'],
            [_subKeyLog(_PASO_BL),'bl','Bill of Lading'],
            [_subKeyLog(_PASO_ARRIVAL),'arrival','Aviso de llegada']];
  var cual=mapa.find(function(m){ return m[0]===sk; });
  if(!cual){
    if(!confirm('¿Borrar "'+(a.name||'')+'"?')) return;
    await _borrarArchivoStorage(a.url, a.id);
    window._atts[oid+sk].splice(i,1);
    showT('Archivo eliminado');
    _logRepintar(oid);
    return;
  }

  var donde=cual[1], nombre=cual[2];
  var d=_logLeer(oid);
  var dat=d[donde]||{};
  var campos=Object.keys(dat).filter(function(k){
    return k!=='tarifas' && String(dat[k]||'').trim();
  }).length;
  var nTar=(dat.tarifas||[]).length;
  var otros=((window._atts&&window._atts[oid+sk])||[]).length-1;

  var msg='¿Está seguro de que desea borrar el documento del '+nombre+'?\n\n'
    +'Archivo: '+(a.name||'')+'\n\n';
  if(campos||nTar){
    msg+='Se borrará TODA la subetapa:\n';
    if(campos) msg+='  · '+campos+' dato(s) cargado(s)\n';
    if(nTar)   msg+='  · '+nTar+' tarifa(s)\n';
    if(otros>0) msg+='  · '+otros+' documento(s) más de esta subetapa\n';
    msg+='\nLos contenedores NO se borran: son de la orden, no de esta subetapa.\n';
  }
  msg+='\nEsta acción no se puede deshacer.';
  if(!confirm(msg)) return;

  // Segunda confirmación cuando hay datos de por medio
  if(campos||nTar){
    if(!confirm('Confirmá una vez más.\n\nSe va a vaciar la subetapa "'+nombre+'" por completo.\n\n¿Continuar?')) return;
  }

  showT('Borrando la subetapa…');
  // Todos los documentos de esa subetapa
  var docs=((window._atts&&window._atts[oid+sk])||[]).slice();
  for(var k=0;k<docs.length;k++){
    await _borrarArchivoStorage(docs[k].url, docs[k].id);
  }
  window._atts[oid+sk]=[];

  // Y los datos que salieron de él
  d[donde]={};
  await _logGuardar(oid);

  // El paso vuelve a quedar pendiente
  try{
    var idx=_pasoIdxLog(cual===mapa[0]?_PASO_BOOKING:(cual===mapa[1]?_PASO_BL:_PASO_ARRIVAL));
    initP(oid);
    var sp=stageProgress[oid].logistica;
    if(idx>=0 && (sp.stepIdx||0)>idx){
      sp.stepIdx=idx;
      if(sp.stepDates) sp.stepDates[idx]='';
      guardarEtapa(oid,'logistica');
    }
  }catch(e){}

  showT('✓ Subetapa "'+nombre+'" vaciada. Puedes volver a cargarla.');
  _logRepintar(oid);
  try{ openDetail(oid); }catch(e){}
}

// Vacía una subetapa sin borrar los documentos
async function _logVaciarDatos(oid, donde, nombre){
  var d=_logLeer(oid);
  var dat=d[donde]||{};
  var campos=Object.keys(dat).filter(function(k){ return k!=='tarifas' && String(dat[k]||'').trim(); }).length;
  var nTar=(dat.tarifas||[]).length;
  if(!campos && !nTar){ showT('No hay datos que borrar'); return; }
  if(!confirm('¿Borrar los datos del '+nombre+'?\n\n'
    +'  · '+campos+' dato(s)\n  · '+nTar+' tarifa(s)\n\n'
    +'Los documentos adjuntos se mantienen: puedes volver a leerlos con AI.\n\n'
    +'Esta acción no se puede deshacer.')) return;
  d[donde]={};
  await _logGuardar(oid);
  showT('✓ Datos del '+nombre+' borrados');
  _logRepintar(oid);
}

// ── Comparación de montos entre documentos ──
function _logComparar(tarBase, tarNueva, nomBase, nomNueva){
  if(!(tarBase||[]).length || !(tarNueva||[]).length) return '';
  var a=_logTotales(tarBase), b=_logTotales(tarNueva);
  var difs=[];
  if(Math.abs(a.kcc-b.kcc)>0.01){
    difs.push({q:'Total que paga Kennedy', a:fmt(a.kcc), b:fmt(b.kcc), d:fmt(Math.abs(a.kcc-b.kcc))});
  }
  Object.keys(a.monedas).concat(Object.keys(b.monedas)).forEach(function(m){
    if(m==='USD'||m==='US$'||m==='$') return;
    var va=a.monedas[m]||0, vb=b.monedas[m]||0;
    if(Math.abs(va-vb)>0.01 && !difs.some(function(x){ return x.q.indexOf(m)>=0; })){
      difs.push({q:'Total en '+m+' (proveedor)', a:_fmtN2(va)+' '+m, b:_fmtN2(vb)+' '+m, d:_fmtN2(Math.abs(va-vb))+' '+m});
    }
  });
  // Conceptos que aparecen en uno y no en el otro
  function clave(x){ return String(x.concepto||'').toUpperCase().replace(/\s+/g,' ').trim(); }
  var enBase={}, enNueva={};
  (tarBase||[]).forEach(function(x){ enBase[clave(x)]=x; });
  (tarNueva||[]).forEach(function(x){ enNueva[clave(x)]=x; });
  Object.keys(enBase).forEach(function(k){
    if(!enNueva[k]) difs.push({q:k, a:_fmtN2(enBase[k].monto)+' '+(enBase[k].moneda||''), b:'no aparece', d:''});
    else if(Math.abs((Number(enBase[k].monto)||0)-(Number(enNueva[k].monto)||0))>0.01){
      difs.push({q:k, a:_fmtN2(enBase[k].monto)+' '+(enBase[k].moneda||''),
                 b:_fmtN2(enNueva[k].monto)+' '+(enNueva[k].moneda||''), d:''});
    }
  });
  Object.keys(enNueva).forEach(function(k){
    if(!enBase[k]) difs.push({q:k, a:'no aparece', b:_fmtN2(enNueva[k].monto)+' '+(enNueva[k].moneda||''), d:''});
  });

  if(!difs.length){
    return '<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:8px 11px;font-size:11.5px;color:var(--t-verde);font-weight:600">'
      +'<i class="ti ti-circle-check"></i> Los montos coinciden con el '+_esc(nomBase)+'.</div>';
  }
  var h='<div style="border:1px solid #dc2626;border-radius:8px;overflow:hidden">'
    +'<div style="background:var(--pastel-error);padding:8px 11px;font-size:11.5px;font-weight:700;color:var(--t-rojo)">'
    +'<i class="ti ti-alert-triangle"></i> '+difs.length+' diferencia(s) entre el '+_esc(nomBase)+' y el '+_esc(nomNueva)+'</div>';
  difs.forEach(function(x){
    h+='<div style="padding:7px 11px;border-top:0.5px solid var(--border);background:var(--surface-0)">'
      +'<div style="font-size:11.5px;font-weight:600">'+_esc(x.q)+'</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap;margin-top:3px;font-size:11px">'
        +'<span style="flex:1;min-width:120px;background:#E6F7F1;border-radius:6px;padding:3px 7px"><b style="color:var(--t-verde2)">'+_esc(nomBase)+':</b> '+_esc(x.a)+'</span>'
        +'<span style="flex:1;min-width:120px;background:var(--pastel-azul);border-radius:6px;padding:3px 7px"><b style="color:var(--t-azul)">'+_esc(nomNueva)+':</b> '+_esc(x.b)+'</span>'
      +'</div>'
      +(x.d?('<div style="font-size:11px;color:var(--t-rojo);margin-top:2px">Diferencia: <b>'+_esc(x.d)+'</b></div>'):'')
      +'</div>';
  });
  return h+'</div>';
}

// ── Lectura con AI de booking, B/L y aviso de llegada ──
async function _logLeerIA(oid, tipo){
  var nombres={booking:_PASO_BOOKING, bl:_PASO_BL, arrival:_PASO_ARRIVAL};
  var sk=_subKeyLog(nombres[tipo]);
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  var cont=document.getElementById('logia-'+tipo+'-'+oid);
  if(!files.length){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">No hay documentos adjuntos.</div>';
    return;
  }
  if(cont) cont.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo el documento…</span>';

  // Cualquier formato: PDF, imagen, Excel o texto
  var contenido=[], puestos=0, notas=[];
  for(var i=0;i<files.length && puestos<5;i++){
    if(!files[i].url) continue;
    var prep=await _iaDesdeStorage(files[i].url, files[i].name||('doc_'+(i+1)), 7);
    if(!prep){ notas.push((files[i].name||'archivo')+': no se pudo abrir'); continue; }
    contenido.push({type:'text', text:'ARCHIVO: '+(files[i].name||'')});
    prep.bloques.forEach(function(b){ contenido.push(b); });
    if(prep.nota) notas.push(prep.nota);
    puestos++;
  }
  if(!puestos){
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--t-ambar)">No se pudo leer ningún archivo.'
      +(notas.length?('<br>'+_esc(notas.join(' · '))):'')+'</div>';
    return;
  }
  contenido.push({type:'text', text:_logPrompt(tipo)});

  try{
    var obj=await _iaJSON(contenido, 4000);
    var d=_logLeer(oid);
    d[tipo]=d[tipo]||{};
    var puestas=[];

    function set(clave, valor){
      if(valor==null || String(valor).trim()==='') return;
      d[tipo][clave]=String(valor).trim();
      puestas.push(clave);
    }
    set('numero', obj.numero);
    set('naviera', obj.naviera);
    set('service_type', obj.service_type);
    set('service_contract', obj.service_contract);
    set('vessel', obj.vessel);
    set('origen', obj.origen);
    set('destino', obj.destino);
    set('fecha_salida', obj.fecha_salida);
    set('fecha_llegada', obj.fecha_llegada);
    set('shipper', obj.shipper);
    set('consignee', obj.consignee);
    set('viaje', obj.viaje);
    // El número de entrada NO lo llena la AI: lo escribe importación a mano,
    // porque se asigna en destino y no viene en el documento.
    if(tipo==='arrival') set('bl', obj.bl||obj.numero);

    // Contenedores: se suman los que no estaban
    var nuevos=0;
    if(Array.isArray(obj.contenedores)){
      d.contenedores=d.contenedores||[];
      obj.contenedores.forEach(function(c){
        var num=String((typeof c==='string'?c:(c.numero||c.number||''))||'').toUpperCase().trim();
        if(!num) return;
        if(d.contenedores.some(function(z){ return String(z.numero||'').toUpperCase()===num; })) return;
        d.contenedores.push({numero:num,
                             tipo:String((c&&c.tipo)||'').toUpperCase().trim(),
                             sello:String((c&&(c.sello||c.seal))||'').toUpperCase().trim()});
        nuevos++;
      });
    }

    // Tarifas
    var nTar=0;
    if(Array.isArray(obj.tarifas) && obj.tarifas.length){
      d[tipo].tarifas=obj.tarifas.map(function(t){
        return {concepto:String(t.concepto||'').trim(),
                monto:Number(t.monto)||0,
                moneda:String(t.moneda||'').toUpperCase().trim()};
      }).filter(function(t){ return t.concepto || t.monto; });
      nTar=d[tipo].tarifas.length;
    }

    await _logGuardar(oid);
    _iaMarcarRevisado(oid, nombres[tipo]);
    _logRepintar(oid);

    // Resumen de lo que encontró
    var tot=_logTotales(d[tipo].tarifas);
    var h='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:9px 11px;font-size:11.5px;color:var(--t-verde)">'
      +'<div style="font-weight:700"><i class="ti ti-circle-check"></i> Documento leído</div>'
      +'<div style="margin-top:3px">'
        +(puestas.length?(puestas.length+' dato(s) completados'):'sin datos nuevos')
        +(nuevos?(' · '+nuevos+' contenedor(es)'):'')
        +(nTar?(' · '+nTar+' cargo(s): Kennedy '+fmt(tot.kcc)
                +(tot.prov?(' / proveedor '+Object.keys(tot.monedas).filter(function(m){return !(m==='USD'||m==='US$'||m==='$');})
                    .map(function(m){ return _fmtN2(tot.monedas[m])+' '+m; }).join(' · ')):'')):'')
      +'</div>';
    if(obj.nota) h+='<div style="margin-top:3px;font-style:italic">'+_esc(obj.nota)+'</div>';
    if(notas.length) h+='<div style="margin-top:3px;color:var(--t-ambar)">'+_esc(notas.join(' · '))+'</div>';
    h+='</div>';
    if(cont) cont.innerHTML=h;

    // Al leer el B/L o el aviso, se avisa si los montos no cuadran
    if(tipo!=='booking'){
      var difs=_logHayDiferencias(d.booking.tarifas, d[tipo].tarifas);
      if(difs){
        showT('⚠ Los montos del '+(tipo==='bl'?'B/L':'aviso de llegada')+' no coinciden con el booking');
        try{ await _logAvisarDiferencia(oid, tipo, difs); }catch(e){}
      }
    }
  }catch(e){
    console.error('leer logistica:',e);
    if(cont) cont.innerHTML='<div style="font-size:11px;color:var(--text-danger)">No se pudo leer: '+_esc(e.message||String(e))+'</div>';
  }
}

// ¿Hay diferencias de monto entre dos juegos de tarifas?
function _logHayDiferencias(tarBase, tarNueva){
  if(!(tarBase||[]).length || !(tarNueva||[]).length) return 0;
  var a=_logTotales(tarBase), b=_logTotales(tarNueva);
  var n=0;
  if(Math.abs(a.kcc-b.kcc)>0.01) n++;
  Object.keys(a.monedas).forEach(function(m){
    if(m==='USD'||m==='US$'||m==='$') return;
    if(Math.abs((a.monedas[m]||0)-(b.monedas[m]||0))>0.01) n++;
  });
  return n;
}

// Aviso a importación y gerencia cuando los montos no cuadran
async function _logAvisarDiferencia(oid, tipo, cuantas){
  var d=_logLeer(oid);
  var a=_logTotales(d.booking.tarifas), b=_logTotales(d[tipo].tarifas);
  var quien=(tipo==='bl')?'B/L':'aviso de llegada';
  var texto='Los montos del '+quien+' no coinciden con el booking: '
    +'Kennedy pagaría '+fmt(b.kcc)+' y el booking decía '+fmt(a.kcc)+'.';
  var destinos=(USERS||[]).filter(function(u){
    return (u.role==='importacion' || u.role==='gerencia') && u.id!==((CU&&CU.id)||'');
  });
  if(!destinos.length) return;
  await _menNotificar(destinos, {
    docnum:oid, contexto:'etapa', etapa:'Logística', texto:texto,
    etiqueta:'Logística — diferencia de montos',
    paso:(tipo==='bl')?_PASO_BL:_PASO_ARRIVAL
  });
}

// El prompt de cada documento
function _logPrompt(tipo){
  var comun='IDIOMA: el documento puede venir en ingles, chino, espanol u otro. Reconoce los campos '
    +'aunque esten en otro idioma y devolve los valores tal como figuran. Si un dato NO aparece, '
    +'deja "" o []. Nunca inventes.\n\n'
    +'CONTENEDORES: traelos TODOS, cada uno con su numero, su tipo (40HQ, 20GP, 40GP...) y su '
    +'SELLO (Seal No., Seal, precinto, 铅封号). El sello suele ir al lado del numero de contenedor.\n\n'
    +'RATE / TARIFAS, muy importante:\n'
    +'- Sacá TODOS los cargos con su concepto, su monto y su MONEDA.\n'
    +'- La moneda define quien paga: los cargos en USD los paga Kennedy y los que estan en otra '
    +'moneda (CNY, RMB, EUR...) los paga el proveedor. Por eso hay que registrar bien la moneda.\n'
    +'- Si un cargo no dice moneda pero el documento tiene una moneda principal, usa esa.\n'
    +'- Los montos van como numero, sin simbolos ni separadores de miles.\n'
    +'- Las fechas van en formato DD/MM/AAAA.\n\n';

  if(tipo==='booking'){
    return 'Sos el analista de importaciones de KENNEDY CENTER CORP. Lee el BOOKING adjunto '
      +'(y el tarifario, si viene).\n\n'+comun
      +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\n'
      +'{"numero":"","shipper":"","consignee":"","service_type":"","service_contract":"","naviera":"",'
      +'"origen":"","destino":"","fecha_salida":"","fecha_llegada":"",'
      +'"contenedores":[{"numero":"","tipo":"","sello":""}],'
      +'"tarifas":[{"concepto":"","monto":0,"moneda":""}],"nota":""}\n\n'
      +'QUE ES CADA CAMPO:\n'
      +'- "numero": Booking No. (Booking Number, Booking Ref, No. de reserva, 订舱号).\n'
      +'- "shipper": el embarcador, quien envia (Shipper, Consignor, 发货人).\n'
      +'- "consignee": el consignatario (Consignee, 收货人).\n'
      +'- "service_type": Service Type (CY/CY, CY/DOOR, FCL/FCL, LCL, Door to Door...).\n'
      +'- "service_contract": SERVICE CONTRACT, el numero del contrato de servicio con la naviera. '
      +'Puede figurar como Service Contract No., S/C No., SC No., Contract No., o en chino como '
      +'服务合同, 服务合同号 o 合同号. Suele ser un codigo alfanumerico. Si no aparece, deja "".\n'
      +'- "naviera": la linea naviera (MAERSK, CMA CGM, MSC, EVERGREEN, COSCO...).\n'
      +'- "origen": Origin (Port of Loading, POL, puerto o ciudad de salida, 起运港).\n'
      +'- "destino": Destination (Port of Discharge, POD, puerto o ciudad de llegada, 目的港).\n'
      +'- "fecha_salida": ETD (Estimated Time of Departure, Sailing Date, fecha de zarpe).\n'
      +'- "fecha_llegada": ETA (Estimated Time of Arrival, fecha estimada de llegada).\n'
      +'- "tarifas": el RATE con todos sus cargos.';
  }
  if(tipo==='bl'){
    return 'Sos el analista de importaciones de KENNEDY CENTER CORP. Lee el BILL OF LADING (B/L).\n\n'+comun
      +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\n'
      +'{"numero":"","shipper":"","consignee":"","vessel":"","viaje":"",'
      +'"origen":"","destino":"","fecha_salida":"",'
      +'"contenedores":[{"numero":"","tipo":"","sello":""}],'
      +'"tarifas":[{"concepto":"","monto":0,"moneda":""}],"nota":""}\n\n'
      +'QUE ES CADA CAMPO:\n'
      +'- "numero": B/L No. (Bill of Lading Number, documento de transporte, 提单号).\n'
      +'- "shipper": el embarcador (Shipper, Consignor, 发货人).\n'
      +'- "consignee": el consignatario (Consignee, 收货人).\n'
      +'- "vessel": Vessel No., el NOMBRE del buque (Vessel, Vessel Name, nave, 船名). '
      +'Ejemplo: "MSC LEANNE".\n'
      +'- "viaje": Voyage (Voy., Voyage No., viaje, 航次). Ejemplo: "528W". '
      +'Va SEPARADO del nombre del buque.\n'
      +'- "origen": Port of Loading (puerto de embarque).\n'
      +'- "destino": Port of Discharge o Place of Delivery (puerto de destino).\n'
      +'- "fecha_salida": ETD (Shipped on Board, fecha de embarque o de emision).\n'
      +'- "contenedores": No. of Containers, con Container No., tipo y Sello / No.\n'
      +'- "tarifas": el Rate con todos sus cargos (Freight, THC, BL Fee...).';
  }
  return 'Sos el analista de importaciones de KENNEDY CENTER CORP. Lee el AVISO DE LLEGADA '
    +'(Arrival Notice).\n\n'+comun
    +'Devuelve SOLO un JSON valido, sin texto antes ni despues:\n'
    +'{"bl":"","shipper":"","consignee":"","vessel":"","viaje":"",'
    +'"fecha_salida":"","fecha_llegada":"",'
    +'"contenedores":[{"numero":"","tipo":"","sello":""}],'
    +'"tarifas":[{"concepto":"","monto":0,"moneda":""}],"nota":""}\n\n'
    +'QUE ES CADA CAMPO:\n'
    +'- "bl": B/L No., el numero de conocimiento de embarque.\n'
    +'- "shipper": el embarcador (Shipper, Consignor).\n'
    +'- "consignee": el consignatario (Consignee).\n'
    +'- "vessel": Vessel No., el NOMBRE del buque.\n'
    +'- "viaje": Voyage, el numero de viaje. Va SEPARADO del nombre del buque.\n'

    +'- "fecha_salida": ETD, la fecha de zarpe.\n'
    +'- "fecha_llegada": ETA, la FECHA DE LLEGADA del buque (Arrival Date, fecha de arribo).\n'
    +'- "contenedores": No. of Containers, con Container No., tipo y Sello / No.\n'
    +'- "tarifas": el Rate, los cargos a pagar en destino.';
}


// Correo para avisar a diseño que ya tiene todo para arrancar los artes
async function _hubMailDiseno(oid){
  var dat=_solPagoDatosOrden(oid);
  var ordenTxt=dat.dkc||String(oid);
  var dept=dat.dept||'';
  window._mailAdj=[];
  window._hubMailCtx={oid:oid};

  var disenadores=(USERS||[]).filter(function(u){ return u.role==='diseno' && u.email; });
  var cand=(USERS||[]).filter(function(u){ return u.email && u.id!==((CU&&CU.id)||''); });
  var chips=cand.map(function(u){
    var marcado=(u.role==='diseno');
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(marcado?'#3C3489':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(marcado?'#F7F5FF':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" data-nom="'+_esc(u.name)+'"'+(marcado?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span>'+_esc(u.name)+'</span>'
      +'<span style="font-size:9.5px;color:var(--text-muted)">'+_esc(u.role)+'</span></label>';
  }).join('');

  // Los enlaces de descarga que haya cargados
  var d=_logLeer(oid);
  var enlaces=((d.hub&&d.hub.enlaces)||[]).map(function(e){ return e.url||e; }).filter(Boolean);

  var asunto='ARTES - '+ordenTxt+(dat.proveedor?(' - '+dat.proveedor):'');
  var cuerpo='Hola,\n\n'
    +'Ya está lista la información para trabajar los artes de esta orden.\n\n'
    +'  • Orden: '+ordenTxt+'\n'
    +(dat.proveedor?('  • Proveedor: '+dat.proveedor+'\n'):'')
    +(dept?('  • Departamento: '+dL(dept)+'\n'):'')
    +'\nEn el portal, dentro de la etapa Artes, está el HUB de diseño con la orden '
    +'de compra y los archivos para arte.\n'
    +(enlaces.length?('\nEnlaces de descarga:\n'+enlaces.map(function(u){ return '  '+u; }).join('\n')+'\n'):'')
    +'\nCualquier duda me avisan por el chat del paso.\n\n'
    +'Saludos,\n'
    +_firmaNombre()+'\n'
    +'Kennedy Center Corp.';

  var prev=document.getElementById('modalHubMail'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalHubMail';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10002;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:620px">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-indigo)"><i class="ti ti-palette"></i> Avisar a diseño</div>'
      +'<button onclick="_hubMailCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button></div>'
    +_firmaAvisoNombre()
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;</div>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA · diseño marcado</div>'
    +'<div id="hubmail-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'+chips+'</div>'
    +'<input id="hubmail-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="hubmail-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="hubmail-cuerpo" rows="13" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="hubmail-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Adjuntando los documentos del HUB…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'
    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_hubMailCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="hubmail-btn" style="background:#3C3489" onclick="_hubMailEnviar()"><i class="ti ti-send"></i> Enviar</button>'
    +'</div></div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // Los documentos del HUB
  var aviso=document.getElementById('hubmail-auto');
  var sk=_subKeyArtes ? _subKeyArtes(_PASO_HUB) : (oid+'artes_step0');
  var puestos=[];
  try{
    var files=(window._atts&&window._atts[oid+'artes_step0'])?_dedupDocs(window._atts[oid+'artes_step0']):[];
    for(var i=0;i<files.length && puestos.length<6;i++){
      if(!files[i].url) continue;
      var adj=await _solPagoAdjuntarDeStorage(files[i].url, files[i].name||'documento.pdf');
      if(adj){ window._mailAdj.push(adj); puestos.push(files[i].name); }
    }
  }catch(e){}
  mailPintarAdjuntos();
  if(aviso) aviso.innerHTML=puestos.length
    ? '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> '+_esc(puestos.join(', '))+'</span>'
    : '<span style="color:var(--text-muted)">Sin documentos en el HUB. Puedes adjuntar a mano.</span>';
}

function _hubMailCerrar(){
  var m=document.getElementById('modalHubMail'); if(m) m.remove();
  window._mailAdj=[]; window._hubMailCtx=null;
}

async function _hubMailEnviar(){
  var ctx=window._hubMailCtx;
  if(!ctx){ showT('Se perdió el contexto'); return; }
  var oid=ctx.oid;
  var box=document.getElementById('hubmail-dests');
  var para=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')).map(function(c){return c.value;}):[];
  var extra=((document.getElementById('hubmail-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=para.concat(extra), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });
  if(!todos.length){ _mailMsg('Elige al menos un destinatario.','err'); return; }

  var asunto=(document.getElementById('hubmail-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('hubmail-cuerpo')||{}).value||'';
  var btn=document.getElementById('hubmail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), para_lista:todos, para_email:todos[0],
        asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
        adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
        de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
        origen:'Aviso a diseño · '+oid, estado:'pendiente'
      })});
    if(!r.ok){
      _mailMsg('No se pudo encolar el correo.','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar'; }
    return;
  }

  _solEnvioGuardar(oid, 'diseno', {
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos, asunto:asunto, cuerpo:cuerpo
  });
  try{
    var destinos=(USERS||[]).filter(function(u){
      return todos.some(function(e){ return String(e).toLowerCase()===String(u.email||'').toLowerCase(); });
    }).filter(function(u){ return u.id!==((CU&&CU.id)||''); });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:oid, contexto:'etapa', etapa:'Artes',
      texto:'Ya tienes todo para trabajar los artes de esta orden',
      etiqueta:'Artes — listo para diseñar', paso:'HUB de diseño'
    });
  }catch(e){}

  _hubMailCerrar();
  showT('✓ Aviso enviado a '+todos.length+' persona(s)');
}

function _hubDisenoPanel(oid){
  return '<div id="hubpanel-'+oid+'">'+_hubDisenoInterior(oid)+'</div>';
}
// Repinta SOLO el HUB. Antes se llamaba a openDetail() y eso reconstruía el
// modal entero, cerrando las etapas que estaban abiertas.
function _hubRepintar(oid){
  var c=document.getElementById('hubpanel-'+oid);
  if(c) c.innerHTML=_hubDisenoInterior(oid);
  // Si el panel no está en pantalla no se reconstruye nada: reconstruir
  // sacaba al usuario del subpaso donde estaba trabajando.
  else { console.log('[panel] no está visible: no se repinta'); }
  // Los archivos bajados viven en el subpaso "Archivos para arte": ese
  // bloque está fuera del panel del HUB, así que se repinta aparte.
  try{ _hubRepintarArchivos(oid); }catch(e){}
}

// Repinta la lista de "Archivos de este paso" del HUB dejando todo como
// estaba: la etapa abierta, el subpaso abierto y el scroll donde iba.
function _hubRepintarArchivos(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='artes'; });
  if(idx<0) return;
  var st=STAGES[idx];
  var i=st.steps.findIndex(function(p){ return p.name==='HUB de diseño'; });
  if(i<0) return;

  var body=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
  var abierto = !!(body && body.style.display!=='none');
  var cont=document.getElementById('egb-'+oid+'-'+idx);
  if(!cont) return;                       // la etapa no está desplegada

  // Qué estaba escrito y dónde iba el scroll, para no perderlo
  var borrador='';
  try{ var inp=document.getElementById('subcin-'+oid+'-'+idx+'-'+i); if(inp) borrador=inp.value||''; }catch(e){}
  var scrollY=window.scrollY;
  var chatTop=0;
  try{ var lst=document.getElementById('subcms-'+oid+'-'+idx+'-'+i); if(lst) chatTop=lst.scrollTop; }catch(e){}

  try{ buildEGB(oid, idx, cont); }catch(e){ console.warn('repintar archivos:',e); return; }

  // Se deja el subpaso como estaba
  if(abierto){
    var b2=document.getElementById('ssb-'+oid+'-'+idx+'-'+i);
    if(b2) b2.style.display='block';
    var ch=document.getElementById('ssch-'+oid+'-'+idx+'-'+i);
    if(ch) ch.style.transform='rotate(180deg)';
  }
  if(borrador){
    var inp2=document.getElementById('subcin-'+oid+'-'+idx+'-'+i);
    if(inp2) inp2.value=borrador;
  }
  try{
    var lst2=document.getElementById('subcms-'+oid+'-'+idx+'-'+i);
    if(lst2 && chatTop) lst2.scrollTop=chatTop;
  }catch(e){}
  window.scrollTo(0, scrollY);
}
function _hubDisenoInterior(oid){
  var kcc=_hubOrdenKcc(oid);
  var h='<div style="background:#F7F5FF;border:1px solid #C4B5FD;border-radius:9px;padding:11px 12px;margin-bottom:10px">';
  var envDis=_solEnvioLeer(oid,'diseno');
  h+='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
    +'<span style="font-size:11.5px;font-weight:700;color:var(--t-lila);flex:1"><i class="ti ti-folders"></i> Documentos para diseñar</span>'
    +(CU && ['compras','gerencia','importacion'].indexOf(CU.role)>=0
      ? ('<button class="btn bp" style="background:#3C3489;padding:4px 11px;font-size:10.5px" onclick="event.stopPropagation();_hubMailDiseno(\'' + oid + '\')">'
         +'<i class="ti ti-mail"></i> '+(envDis?'Volver a avisar a diseño':'Avisar a diseño')+'</button>')
      : '')
    +'</div>';
  if(envDis){
    h+='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:8px;padding:7px 10px;margin-bottom:8px;font-size:11px;color:var(--t-verde)">'
      +'<i class="ti ti-mail-check"></i> Aviso enviado por <b>'+_esc(envDis.por||'')+'</b> · '+_esc(_fechaHora(envDis.fecha))
      +(envDis.para&&envDis.para.length?('<br>A: '+_esc(envDis.para.join(', '))):'')+'</div>';
  }

  // 1) PDF de la orden de compra (automático)
  h+='<div style="background:var(--surface-0);border:0.5px solid #C4B5FD;border-radius:8px;padding:9px 11px;margin-bottom:7px">'
    +'<div style="font-size:11px;font-weight:700;color:var(--t-azul);margin-bottom:4px">1 · PDF ORDEN DE COMPRA KCC <span style="font-weight:400;color:var(--text-muted)">(automático, de la orden firmada)</span></div>';
  if(kcc.length){
    kcc.forEach(function(a){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
        +'<i class="ti ti-file-type-pdf" style="color:var(--t-rojo2)"></i>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
        +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px"'+_prevAttrs(a.data||a.url,a.name)+' onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button></div>';
    });
  } else {
    h+='<div style="font-size:10.5px;color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Todavía no hay orden de KCC firmada para esta compra.</div>';
  }
  h+='</div>';

  // 2) Excel de la orden (manual)
  h+=_hubZona(oid,'artes_excel','2 · EXCEL ORDEN DE COMPRA','Sube el Excel de la orden','#166534','ti-file-spreadsheet','.xlsx,.xls,.csv');
  // 3) Archivos de arte del proveedor (manual)
  h+=_hubZona(oid,'artes_files','3 · ARCHIVOS PARA ARTE','Diecuts, fotos HD, certificados que manda el proveedor','#B45309','ti-palette','');
  // 4) Enlaces externos: WeTransfer, TransferNow, Drive, etc.
  h+=_hubLinks(oid);
  h+='</div>';
  return h;
}

// ── Enlaces externos de descarga ──
// El navegador no puede bajar el contenido de WeTransfer o TransferNow: esas
// páginas no permiten lectura desde otro sitio y el archivo real vive detrás
// de un token temporal. Así que el enlace se guarda aquí, a la vista y con un
// clic para abrirlo, y los archivos que se bajen se suben al bloque 3.
function _hubLinks(oid){
  var links=_hubLeerLinks(oid);
  var h='<div style="background:var(--surface-0);border:0.5px solid #C4B5FD;border-radius:8px;padding:9px 11px">'
    +'<div style="font-size:11px;font-weight:700;color:var(--t-lila);margin-bottom:4px">4 · ENLACES DE DESCARGA '
    +'<span style="font-weight:400;color:var(--text-muted)">(WeTransfer, TransferNow, Drive…)</span></div>';
  if(links.length){
    links.forEach(function(l,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:4px 0;border-top:0.5px solid var(--border)">'
        +'<i class="ti ti-link" style="color:var(--t-lila)"></i>'
        +'<div style="flex:1;min-width:0">'
          +'<a href="'+_esc(l.url)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()" style="color:var(--text-accent);text-decoration:underline;word-break:break-all">'+_esc(l.url)+'</a>'
          +'<div style="font-size:10px;color:var(--text-muted)">'+_esc(l.por||'')+(l.fecha?(' \u00b7 '+_esc(l.fecha)):'')+(l.nota?(' \u00b7 '+_esc(l.nota)):'')+'</div>'
        +'</div>'
        +'<button class="btn bg2" style="padding:3px 8px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_hubBorrarLink(\''+oid+'\','+i+')"><i class="ti ti-trash"></i></button>'
      +'</div>';
    });
  }
  h+=_hubDescargasPanel(oid);
  h+='<div style="display:flex;gap:5px;margin-top:6px">'
    +'<input id="hublink-'+oid+'" placeholder="Pegá el enlace de descarga" style="flex:1;padding:6px 9px;border:0.5px solid var(--border);border-radius:7px;font-size:11px;background:var(--surface-0);color:var(--text-primary)" onclick="event.stopPropagation()">'
    +'<button class="btn bp" style="padding:6px 11px;font-size:11px" onclick="event.stopPropagation();_hubAgregarLink(\''+oid+'\')">Guardar</button>'
    +'</div>'
    +'<div style="font-size:10px;color:var(--text-muted);margin-top:4px">'
    +'El servidor descarga el contenido solo y lo deja en <b>Archivos para arte</b>. Suele tardar un par de minutos. '
    +'<span onclick="event.stopPropagation();_hubLimpiarBasura(\''+oid+'\')" style="text-decoration:underline;cursor:pointer;color:var(--text-accent)">Revisar los archivos bajados</span></div>';
  return h+'</div>';
}

function _hubLinksKey(oid){ return 'hublinks_'+oid; }
function _hubLeerLinks(oid){
  if(window._hubLinks && window._hubLinks[oid]) return window._hubLinks[oid];
  try{
    var v=localStorage.getItem(_hubLinksKey(oid));
    if(v){ var l=JSON.parse(v); if(Array.isArray(l)) return l; }
  }catch(e){}
  return [];
}
function _hubGuardarLinks(oid, links){
  window._hubLinks=window._hubLinks||{};
  window._hubLinks[oid]=links;
  try{ localStorage.setItem(_hubLinksKey(oid), JSON.stringify(links)); }catch(e){}
  // También en la orden, para que lo vean los demás
  try{
    var p=(window._pendSAP||[]).find(function(x){ return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
    if(p){ p.links_arte=links; guardarPendSAP(p.dkc||p.num_orden); }
  }catch(e){}
}
async function _hubAgregarLink(oid){
  var inp=document.getElementById('hublink-'+oid);
  var url=(inp&&inp.value||'').trim();
  if(!url){ showT('Pegá un enlace primero'); return; }
  if(!/^https?:\/\//i.test(url)){ showT('El enlace tiene que empezar con http:// o https://'); return; }
  var links=_hubLeerLinks(oid).slice();
  if(links.some(function(l){ return l.url===url; })){ showT('Ese enlace ya está guardado'); return; }
  var nota=prompt('¿Qué contiene este enlace? (opcional)\n\nPor ejemplo: diecuts y fotos HD','')||'';
  links.push({url:url, por:(CU&&CU.name)||'', fecha:now2(), nota:nota});
  _hubGuardarLinks(oid, links);
  if(inp) inp.value='';

  // Se encola para que el worker lo descargue y suba los archivos solo
  showT('Enlace guardado. Poniéndolo en cola de descarga…');
  try{
    var r=await fetch(SB+'/rest/v1/descargas_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({
        docnum:String(oid), etapa:'artes_files', url:url, nota:nota,
        pedido_por:(CU&&CU.name)||'', estado:'pendiente',
        creado_en:new Date().toISOString()
      })});
    if(r.ok) showT('✓ En cola. Los archivos van a aparecer solos aquí abajo, sin salir de la etapa.');
    else {
      var t=await r.text();
      console.warn('descargas_queue', r.status, t);
      showT(/does not exist|Could not find the table/i.test(t)
        ? '⚠ Falta la tabla descargas_queue (script descargas_queue.sql). El enlace igual quedó guardado.'
        : '⚠ El enlace quedó guardado, pero no se pudo encolar la descarga.');
    }
  }catch(e){ console.warn('encolar descarga:',e); showT('⚠ El enlace quedó guardado, pero no se pudo encolar.'); }
  await _hubDescargasCargar(oid);
  _hubRepintar(oid);
  // Se arranca la vigilancia AHORA. Antes solo se activaba al abrir el paso,
  // así que tras pegar un enlace nadie miraba si la descarga terminaba y los
  // archivos no aparecían hasta salir y volver a entrar.
  window._hubVig[oid]=false;      // por si quedó una vigilancia vieja
  _hubVigilarCiclo(oid, 0);
  // El cursor vuelve al campo, por si hay más enlaces que pegar
  setTimeout(function(){
    var i=document.getElementById('hublink-'+oid);
    if(i) i.focus();
  }, 120);
}

// ── Estado de las descargas automáticas ──
window._hubDesc=window._hubDesc||{};
async function _hubDescargasCargar(oid){
  try{
    var r=await fetch(SB+'/rest/v1/descargas_queue?select=*&docnum=eq.'+encodeURIComponent(oid)
      +'&order=creado_en.desc&limit=20',{headers:SBH});
    if(!r.ok) return [];
    var rows=await r.json();
    window._hubDesc[oid]=Array.isArray(rows)?rows:[];
    return window._hubDesc[oid];
  }catch(e){ return []; }
}

// ── Vigilancia de las descargas del HUB ──
// Mientras hay algo bajando se consulta cada 4 segundos. Al terminar, se
// traen los archivos de la orden y se repinta el HUB de inmediato.
window._hubVig=window._hubVig||{};

function _hubVigilar(oid){
  if(window._hubVig[oid]) return;          // ya hay una vigilancia activa
  var primera=!window._hubDesc[oid];
  _hubDescargasCargar(oid).then(function(ds){
    ds=ds||[];
    if(primera && ds.length) _hubRepintar(oid);
    var enCurso=ds.some(function(d){ return d.estado==='pendiente'||d.estado==='procesando'; });
    if(enCurso) _hubVigilarCiclo(oid, 0);
  });
}

function _hubVigilarCiclo(oid, intento){
  window._hubVig[oid]=true;
  // Al principio se pregunta seguido; después se espacia para no cargar la base.
  // El worker revisa su cola cada 5 s, así que 3 s de arranque alcanza para
  // ver el cambio a "procesando" casi al instante.
  var espera = intento===0 ? 1500 : (intento<20 ? 3000 : (intento<45 ? 8000 : 15000));
  setTimeout(function(){
    var antes=(window._hubDesc[oid]||[]).map(function(d){ return d.id+':'+d.estado; }).join('|');
    _hubDescargasCargar(oid).then(async function(ds){
      ds=ds||[];
      var ahora=ds.map(function(d){ return d.id+':'+d.estado; }).join('|');
      var listas=ds.filter(function(d){ return d.estado==='listo'; });
      var enCurso=ds.some(function(d){ return d.estado==='pendiente'||d.estado==='procesando'; });

      if(ahora!==antes){
        // Cambió algo: se recargan los archivos y se repinta
        if(listas.length){
          try{ await cargarDocsOrden(oid); }catch(e){}
          var nuevos=[];
          listas.forEach(function(d){
            var a=d.archivos;
            if(typeof a==='string'){ try{ a=JSON.parse(a); }catch(e){ a=null; } }
            if(Array.isArray(a)) nuevos=nuevos.concat(a);
          });
          if(nuevos.length) showT('✓ '+nuevos.length+' archivo(s) descargado(s): '+nuevos.slice(0,3).join(', '));
        }
        var conError=ds.filter(function(d){ return d.estado==='error'; });
        if(conError.length && conError.length!==(window._hubErrAvisado||{})[oid]){
          window._hubErrAvisado=window._hubErrAvisado||{};
          window._hubErrAvisado[oid]=conError.length;
          showT('⚠ Una descarga no se pudo completar. Mira el detalle en el HUB.');
        }
        _hubRepintar(oid);
      }

      if(enCurso && intento<150){          // ~15 min de vigilancia
        _hubVigilarCiclo(oid, intento+1);
      } else {
        window._hubVig[oid]=false;
        if(!enCurso && listas.length){
          try{ await cargarDocsOrden(oid); }catch(e){}
          _hubRepintar(oid);
        }
      }
    }).catch(function(){ window._hubVig[oid]=false; });
  }, espera);
}

// ── Limpiar el historial de descargas (solo gerencia) ──
async function _hubBorrarLog(oid, id){
  if(!_esGerencia()){ showT('Solo gerencia puede borrar los registros'); return; }
  if(!id){ showT('Registro sin identificar'); return; }
  try{
    var r=await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+id,{method:'DELETE',headers:SBH});
    if(!r.ok){ showT('No se pudo borrar el registro'); return; }
  }catch(e){ showT('Error de conexión'); return; }
  window._hubDesc[oid]=(window._hubDesc[oid]||[]).filter(function(d){ return String(d.id)!==String(id); });
  showT('Registro eliminado');
  _hubRepintar(oid);
}

async function _hubLimpiarLogs(oid, soloCerradas){
  if(!_esGerencia()){ showT('Solo gerencia puede limpiar el historial'); return; }
  var ds=window._hubDesc[oid]||[];
  var objetivo=soloCerradas
    ? ds.filter(function(d){ return d.estado==='listo'||d.estado==='error'; })
    : ds.slice();
  if(!objetivo.length){ showT('No hay registros que limpiar'); return; }
  var enCurso=ds.filter(function(d){ return d.estado==='pendiente'||d.estado==='procesando'; }).length;
  if(!confirm('¿Borrar '+objetivo.length+' registro(s) de descarga?\n\n'
    +(soloCerradas
        ? 'Se quitan los terminados y los que fallaron.'+(enCurso?(' Los '+enCurso+' en curso se mantienen.'):'')
        : 'Se borra TODO el historial'+(enCurso?(', incluidos '+enCurso+' que siguen bajando'):'')+'.')
    +'\n\nLos archivos ya descargados NO se tocan.')) return;

  var ok=0;
  for(var i=0;i<objetivo.length;i++){
    try{
      var r=await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+objetivo[i].id,{method:'DELETE',headers:SBH});
      if(r.ok) ok++;
    }catch(e){}
  }
  var ids={};
  objetivo.forEach(function(d){ ids[String(d.id)]=1; });
  window._hubDesc[oid]=(window._hubDesc[oid]||[]).filter(function(d){ return !ids[String(d.id)]; });
  showT('✓ '+ok+' registro(s) eliminado(s)');
  _hubRepintar(oid);
}

function _hubDescargasPanel(oid){
  var ds=window._hubDesc[oid]||[];
  if(!ds.length) return '';
  var col={pendiente:['#B45309','#FEF3E8','En cola'],
           procesando:['#5B21B6','#EDE9FE','Descargando…'],
           listo:['#166534','#dcfce7','Descargado'],
           error:['#991b1b','#FEF2F2','No se pudo']};
  var h='';
  // Gerencia puede limpiar el historial de descargas
  if(_esGerencia() && ds.length){
    var cerradas=ds.filter(function(d){ return d.estado==='listo'||d.estado==='error'; }).length;
    h+='<div style="display:flex;align-items:center;gap:6px;padding:4px 0;border-top:0.5px solid var(--border)">'
      +'<span style="font-size:10px;color:var(--text-muted);flex:1">'+ds.length+' registro(s) de descarga</span>'
      +(cerradas?('<button class="btn bg2" style="padding:2px 8px;font-size:10px" onclick="event.stopPropagation();_hubLimpiarLogs(\''+oid+'\',true)" title="Quita los terminados y con error, deja los que siguen bajando"><i class="ti ti-eraser"></i> Limpiar</button>'):'')
      +'<button class="btn bg2" style="padding:2px 8px;font-size:10px;color:var(--text-danger)" onclick="event.stopPropagation();_hubLimpiarLogs(\''+oid+'\',false)" title="Borra todo el historial"><i class="ti ti-trash"></i> Borrar todo</button>'
      +'</div>';
  }
  ds.forEach(function(d){
    var c=col[d.estado]||col.pendiente;
    var archivos=d.archivos;
    if(typeof archivos==='string'){ try{ archivos=JSON.parse(archivos); }catch(e){ archivos=null; } }
    h+='<div style="border-top:0.5px solid var(--border);padding:5px 0;font-size:10.5px">'
      +'<span style="background:'+c[1]+';color:'+c[0]+';border-radius:6px;padding:1px 7px;font-weight:700">'+c[2]+'</span> '
      +'<span style="color:var(--text-muted)">'+_esc(String(d.url||'').slice(0,52))+(String(d.url||'').length>52?'…':'')+'</span>'
      +(d.detalle?('<div style="color:'+c[0]+';margin-top:2px">'+_esc(d.detalle)+'</div>'):'')
      +(d.diagnostico?('<details style="margin-top:3px"><summary style="cursor:pointer;color:var(--text-muted);font-size:10px">Ver el detalle técnico</summary>'
        +'<pre style="white-space:pre-wrap;word-break:break-all;font-size:9.5px;background:var(--surface-1);border-radius:6px;padding:6px;margin-top:3px;max-height:220px;overflow:auto">'
        +_esc(String(d.diagnostico).slice(0,3000))+'</pre></details>'):'')
      +(archivos&&archivos.length?('<div style="color:var(--text-success);margin-top:2px"><i class="ti ti-check"></i> '+_esc(archivos.join(', '))+'</div>'):'')
      +(_esGerencia()?('<span onclick="event.stopPropagation();_hubBorrarLog(\''+oid+'\','+(d.id||0)+')" title="Borrar este registro" style="float:right;color:var(--text-danger);cursor:pointer;font-size:11px;margin-top:-16px"><i class="ti ti-x"></i></span>'):'')
      +'</div>';
  });
  return h;
}
// Revisa los archivos bajados y quita los que no sirven.
// Las descargas anteriores pudieron guardar la página web del servicio como
// si fuera el archivo: pesan poco y no abren.
async function _hubLimpiarBasura(oid){
  var sk='artes_files';
  var files=(window._atts&&window._atts[oid+sk])?_dedupDocs(window._atts[oid+sk]):[];
  if(!files.length){ showT('No hay archivos descargados que revisar'); return; }
  showT('Revisando '+files.length+' archivo(s)…');
  var malos=[];
  for(var i=0;i<files.length;i++){
    var a=files[i];
    if(!a.url) continue;
    try{
      var url=DOCS_BASE + String(a.url).split('/').map(encodeURIComponent).join('/');
      var r=await fetch(url, {headers:{'Range':'bytes=0-31'}});
      if(!r.ok) continue;
      var buf=new Uint8Array(await r.arrayBuffer());
      var ext=String(a.name||'').split('.').pop().toLowerCase();
      var cab=String.fromCharCode.apply(null, buf.slice(0,20)).toLowerCase().replace(/^\s+/,'');
      var esWeb=/^(<!doctype|<html|<\?xml|<head|<script|<meta)/.test(cab);
      var firmas={zip:[[0x50,0x4B]], xlsx:[[0x50,0x4B]], docx:[[0x50,0x4B]],
                  pdf:[[0x25,0x50,0x44,0x46]], png:[[0x89,0x50,0x4E,0x47]],
                  jpg:[[0xFF,0xD8,0xFF]], jpeg:[[0xFF,0xD8,0xFF]], rar:[[0x52,0x61,0x72,0x21]]};
      var esp=firmas[ext];
      var mal=esWeb || (esp && !esp.some(function(f){
        return f.every(function(b,ix){ return buf[ix]===b; }); }));
      if(mal) malos.push({a:a, i:i, motivo:esWeb?'es una página web':'no es un .'+ext+' válido'});
    }catch(e){ console.warn('revisar archivo:',e); }
  }
  if(!malos.length){ showT('✓ Todos los archivos descargados están bien'); return; }
  if(!confirm('Se encontraron '+malos.length+' archivo(s) que no sirven:\n\n'
    +malos.map(function(m){ return '· '+(m.a.name||'')+' — '+m.motivo; }).join('\n')
    +'\n\nEstos quedaron de descargas que fallaron. ¿Borrarlos?')) return;
  for(var k=0;k<malos.length;k++){
    await _borrarArchivoStorage(malos[k].a.url, malos[k].a.id);
  }
  window._atts[oid+sk]=(window._atts[oid+sk]||[]).filter(function(x){
    return !malos.some(function(m){ return m.a.url===x.url; });
  });
  showT('✓ '+malos.length+' archivo(s) dañado(s) eliminado(s)');
  _hubRepintar(oid);
}

async function _hubBorrarLink(oid, i){
  var links=_hubLeerLinks(oid).slice();
  if(!links[i]) return;
  var url=links[i].url;

  // Lo que se descargó de ese enlace, para poder limpiarlo también
  var cola=(window._hubDesc[oid]||[]).filter(function(d){ return String(d.url)===String(url); });
  var nombres=[];
  cola.forEach(function(d){
    var a=d.archivos;
    if(typeof a==='string'){ try{ a=JSON.parse(a); }catch(e){ a=null; } }
    if(Array.isArray(a)) nombres=nombres.concat(a);
  });
  var sk='artes_files';
  var bajados=((window._atts&&window._atts[oid+sk])||[]).filter(function(f){
    return nombres.some(function(n){ return _docClave({name:n})===_docClave(f); });
  });

  var msg='¿Está seguro de que desea borrar este enlace?\n\n'+url;
  if(bajados.length) msg+='\n\nSe borrarán también '+bajados.length+' archivo(s) que se bajaron de él:\n'
    +bajados.map(function(f){ return '  · '+(f.name||''); }).join('\n');
  msg+='\n\nDespués vas a poder volver a subirlo.';
  if(!confirm(msg)) return;

  showT('Borrando…');
  // Los archivos que vinieron de ese enlace
  for(var b=0;b<bajados.length;b++){
    await _borrarArchivoStorage(bajados[b].url, bajados[b].id);
  }
  if(bajados.length){
    window._atts[oid+sk]=(window._atts[oid+sk]||[]).filter(function(f){
      return !bajados.some(function(z){ return z.url===f.url; });
    });
  }
  // El registro de la descarga, para que el estado no quede en verde
  for(var c=0;c<cola.length;c++){
    try{ await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+cola[c].id,{method:'DELETE',headers:SBH}); }catch(e){}
  }
  window._hubDesc[oid]=(window._hubDesc[oid]||[]).filter(function(d){ return String(d.url)!==String(url); });

  links.splice(i,1);
  _hubGuardarLinks(oid, links);
  showT(bajados.length
    ? ('✓ Enlace y '+bajados.length+' archivo(s) eliminados. Puedes volver a subirlo.')
    : '✓ Enlace eliminado. Puedes volver a subirlo.');
  _hubRepintar(oid);
}

// La orden de KCC firmada, nunca la del proveedor
function _hubOrdenKcc(oid){
  var out=[], vistos={};
  // 1) De la etapa de firma, si existe
  var fr=(window._firmaRows||[]).find(function(f){
    return String(f.num_orden)===String(oid) || String(f.dkc)===String(oid);
  });
  if(fr && (fr.archivo_firmado_path||fr.archivo_path)){
    var pth=fr.archivo_firmado_path||fr.archivo_path;
    var nom=fr.archivo_firmado_nombre||fr.archivo_nombre||('Orden_KCC_'+oid+'.pdf');
    out.push({name:nom, url:pth, data:DOCS_BASE+String(pth).split('/').map(encodeURIComponent).join('/')});
    vistos[_docClave({name:nom})]=1;
  }
  // 2) Si no, el documento de la orden cuyo nombre NO es del proveedor
  if(!out.length){
    try{
      _docsBaseOrden(oid).forEach(function(a){
        var n=String(a.name||'').toLowerCase();
        var esProveedor=/proforma|\bpi\b|invoice|fut|supplier/.test(n);
        var esPdf=/\.pdf$/.test(n);
        if(!esProveedor && esPdf && !vistos[_docClave(a)]){ vistos[_docClave(a)]=1; out.push(a); }
      });
    }catch(e){}
  }
  return out;
}

// Zona de subida para una clave concreta
function _hubZona(oid, sub, titulo, ayuda, color, icono, accept){
  var k=oid+sub;
  var files=(window._atts&&window._atts[k])?_dedupDocs(window._atts[k]):[];
  var h='<div style="background:var(--surface-0);border:0.5px solid #C4B5FD;border-radius:8px;padding:9px 11px;margin-bottom:7px">'
    +'<div style="font-size:11px;font-weight:700;color:'+color+';margin-bottom:4px">'+titulo
    +' <span style="font-weight:400;color:var(--text-muted)">('+files.length+')</span></div>';
  if(files.length){
    files.forEach(function(a,i){
      h+='<div style="display:flex;align-items:center;gap:7px;font-size:11.5px;padding:3px 0">'
        +'<i class="ti '+icono+'" style="color:'+color+'"></i>'
        +'<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_esc(a.name||'')+'</span>'
        +'<button class="btn bg2" style="padding:3px 9px;font-size:10.5px"'+_prevAttrs(a.data||a.url,a.name)+' onclick="event.stopPropagation();verArchivo(\''+_esc(a.data||a.url||'')+'\',\''+_esc(String(a.name||'').replace(/\x27/g,''))+'\')">ver</button>'
        +((CU&&CU.role!=='bodega')?('<button class="btn bg2" style="padding:3px 7px;font-size:10.5px;color:var(--text-danger)" onclick="event.stopPropagation();_hubBorrar(\''+oid+'\',\''+sub+'\','+i+')"><i class="ti ti-trash"></i></button>'):'')
        +'</div>';
    });
  } else {
    h+='<div style="font-size:10.5px;color:var(--text-muted)">'+_esc(ayuda)+'</div>';
  }
  h+='<label style="display:flex;align-items:center;gap:6px;padding:6px 9px;border:1.5px dashed '+color+'55;border-radius:7px;cursor:pointer;font-size:11px;color:'+color+';margin-top:6px">'
    +'<i class="ti ti-upload"></i> Adjuntar'
    +'<input type="file" multiple'+(accept?(' accept="'+accept+'"'):'')+' style="display:none" onchange="_hubSubir(\''+oid+'\',\''+sub+'\',this.files)"></label>';
  return h+'</div>';
}

async function _hubSubir(oid, sub, files){
  if(!files||!files.length) return;
  showT('Subiendo '+files.length+' archivo(s)…');
  for(var i=0;i<files.length;i++){
    try{
      var pth=await _subirDocStorage(oid, sub, files[i]);
      if(!pth) continue;
      var reg=await _registrarDoc(oid, sub, files[i], pth);
      if(!window._atts) window._atts={};
      if(!window._atts[oid+sub]) window._atts[oid+sub]=[];
      window._atts[oid+sub].push({ id:reg?reg.id:undefined, name:files[i].name,
        data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
        url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
    }catch(e){ console.warn('subir hub:',e); }
  }
  showT('✓ Archivos adjuntados');
  _hubRepintar(oid);
}

async function _hubBorrar(oid, sub, i){
  var a=(window._atts&&window._atts[oid+sub])?window._atts[oid+sub][i]:null;
  if(!a) return;
  if(!confirm('¿Está seguro de que desea borrar el archivo "'+(a.name||'')+'"?\n\nEsta acción no se puede deshacer.')) return;
  await _borrarArchivoStorage(a.url, a.id);
  window._atts[oid+sub].splice(i,1);
  // Si venía de una descarga, se corrige ese registro para que el estado no
  // siga diciendo "Descargado" con archivos que ya no están.
  try{ await _hubDepurarDescargas(oid); }catch(e){}
  showT('Archivo eliminado');
  _hubRepintar(oid);
}

// Revisa los registros de descarga contra los archivos que quedan.
// Si de un registro ya no queda nada, se elimina; si quedan algunos, se
// actualiza la lista para que el estado refleje la realidad.
async function _hubDepurarDescargas(oid){
  var ds=window._hubDesc[oid]||[];
  if(!ds.length) return;
  var presentes=((window._atts&&window._atts[oid+'artes_files'])||[]).map(_docClave);
  for(var i=0;i<ds.length;i++){
    var d=ds[i];
    if(d.estado!=='listo') continue;
    var arch=d.archivos;
    if(typeof arch==='string'){ try{ arch=JSON.parse(arch); }catch(e){ arch=null; } }
    if(!Array.isArray(arch) || !arch.length) continue;
    var quedan=arch.filter(function(n){ return presentes.indexOf(_docClave({name:n}))>=0; });
    if(quedan.length===arch.length) continue;      // no cambió nada

    if(!quedan.length){
      // No queda ninguno: el registro pasa a pendiente para poder rebajarlo
      try{
        await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+d.id,{
          method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify({estado:'error', archivos:null,
            detalle:'Los archivos se borraron a mano. Volvé a pegar el enlace si los necesitás.'})});
        d.estado='error'; d.archivos=null;
        d.detalle='Los archivos se borraron a mano. Volvé a pegar el enlace si los necesitás.';
      }catch(e){}
    } else {
      try{
        await fetch(SB+'/rest/v1/descargas_queue?id=eq.'+d.id,{
          method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
          body:JSON.stringify({archivos:JSON.stringify(quedan),
            detalle:quedan.length+' archivo(s) · '+(arch.length-quedan.length)+' borrado(s) a mano'})});
        d.archivos=JSON.stringify(quedan);
        d.detalle=quedan.length+' archivo(s) · '+(arch.length-quedan.length)+' borrado(s) a mano';
      }catch(e){}
    }
  }
}

function _provEmailDeOrden(oid){
  var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
  if(o && o.vendorEmail) return o.vendorEmail;
  var d=_solPagoDatosOrden(oid);
  try{ var e=_firmaCorreoProveedor(d.proveedor||''); if(e) return e; }catch(err){}
  return '';
}

// Encargado de compras del departamento de la orden
function _encargadosCompras(oid){
  var d=_solPagoDatosOrden(oid);
  var dept=d.dept||'';
  if(!dept){
    var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
    if(o) dept=o.dept||'';
  }
  return (USERS||[]).filter(function(u){
    return u.role==='compras' && u.email && (!dept || String(u.dept||'')===String(dept));
  });
}

async function _provAbrirModal(oid, tipo){
  // tipo: 'abono' -> comprobante del depósito | 'cancelacion' -> pago final
  var esAbono=(tipo!=='cancelacion');
  var d=_solPagoDatosOrden(oid);
  var monto=_compMonto(oid, tipo);
  var ordenTxt=d.dkc||String(oid);
  window._mailAdj=[];
  window._provCtx={oid:oid, tipo:tipo,
    paso:_pasoIdxDeposito(esAbono?_PASO_COMP_PROV:_PASO_COMP_FINAL)};

  var provEmail=_provEmailDeOrden(oid);
  var encargados=_encargadosCompras(oid);

  var palabra = esAbono ? 'depósito' : 'pago final';
  var titulo  = esAbono ? 'Deposit Payment Confirmation' : 'Final Balance Payment Confirmation';
  var asunto  = titulo+' '+ordenTxt;

  // El concepto lleva el % del anticipo si se conoce
  var pct=0;
  try{ if(d.total>0 && monto>0) pct=Math.round((monto/d.total)*100); }catch(e){}
  var concepto = esAbono
    ? ((pct>0&&pct<100)?(pct+'% Deposit'):'Deposit')
    : 'Final Balance';

  var cuerpo='Dear Vendor,\n\n'
    +'Subject:    '+titulo+' '+ordenTxt+'\n\n'
    +'Please be informed that the following '+(esAbono?'deposit':'final balance')+' payment has been sent to your account:\n\n'
    +'PO:                                 '+ordenTxt+'\n'
    +'Supplier:                      '+(d.proveedor||'')+'\n'
    +'Description:               '+concepto+'\n'
    +'Amount:                       US'+fmt(monto)+'\n\n'
    +'Kindly confirm receipt of the funds at your earliest convenience.\n\n'
    +(esAbono
      ? 'Please start production to comply with shipment schedule on time.\n\n'
      : 'Please proceed with the shipment as agreed.\n\n')
    +'Thank you for your cooperation.\n\n'
    +'Best Regards,\n\n'
    +_firmaNombre()+'\n'
    +'KENNEDY CENTER CORP.';

  // CC: el equipo de compras del departamento, marcado por defecto
  var ccChips=encargados.filter(function(u){
    return String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){
    return '<span class="sp-cc-chip on" data-mail="'+_esc(u.email)+'" onclick="_provToggleCC(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti ti-check" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');
  var ccOtros=(USERS||[]).filter(function(u){
    if(!u.email) return false;
    if(String(u.email).toLowerCase()===String((CU&&CU.email)||'').toLowerCase()) return false;
    return !encargados.some(function(e){ return e.id===u.id; });
  }).map(function(u){
    return '<span class="sp-cc-chip" data-mail="'+_esc(u.email)+'" onclick="_provToggleCC(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti ti-plus" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');
  var ccIniciales=encargados.filter(function(u){
    return String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){ return u.email; }).join(', ');

  var prev=document.getElementById('modalProv'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalProv';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:680px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-azul)"><i class="ti ti-send"></i> Enviar comprobante de '+palabra+' al proveedor</div>'
      +'<button onclick="_provCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'

    +'<div style="background:var(--pastel-azul);border:1px solid #85B7EB;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-azul)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> \u00b7 orden '+_esc(ordenTxt)
      +(monto?('<div style="margin-top:3px">Monto del '+palabra+': <b>'+fmt(monto)+'</b></div>'):'')
    +'</div>'

    +_firmaAvisoNombre()
    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc(_firmaNombre())+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">Firmarás el correo como <b>'+_esc(_firmaNombre())+'</b>'
      +' \u00b7 <span onclick="_firmaPedirNombre()" style="text-decoration:underline;cursor:pointer">cambiar</span></div></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">PARA — proveedor</div>'
    +'<input id="prov-para" value="'+_esc(provEmail)+'" placeholder="correo@proveedor.com (uno o varios, separados por coma)" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;background:var(--surface-2);color:var(--text-primary)">'
    +'<div style="font-size:10px;margin:3px 0 12px">'
      +(provEmail
        ?'<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Correo tomado de SAP. Puedes cambiarlo.</span>'
        :'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Este proveedor no tiene correo en SAP: escríbelo a mano.</span>')
    +'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">CC — copia</div>'
    +'<div id="prov-cc-chips" style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:5px">'+ccChips+ccOtros+'</div>'
    +'<input id="prov-cc" value="'+_esc(ccIniciales)+'" placeholder="otros@correo.com, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="prov-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="prov-cuerpo" rows="12" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="prov-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Buscando el comprobante de contabilidad…</div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_provCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="prov-btn" onclick="_provEnviar()"><i class="ti ti-send"></i> Enviar al proveedor</button>'
    +'</div>'
  +'</div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // Se trae el comprobante que dejó contabilidad en su paso.
  // OJO: la clave de adjuntos es SIEMPRE oid+subKey. Antes se buscaba solo por
  // subKey y nunca encontraba nada, de ahí el aviso falso de "no lo subió".
  var origen=_subKeyDeposito(esAbono?_PASO_DEP_PROV:_PASO_PAGO_FINAL);
  var aviso=document.getElementById('prov-auto');
  var docs=[];
  if(origen){
    // Si todavía no está en memoria, se leen los documentos de la orden
    if(!(window._atts && window._atts[oid+origen] && window._atts[oid+origen].length)){
      try{ await cargarDocsOrden(oid); }catch(e){ console.warn('cargar docs:',e); }
    }
    docs=(window._atts&&window._atts[oid+origen])?_dedupDocs(window._atts[oid+origen]):[];
  }
  var base={};
  try{ _docsBaseOrden(oid).forEach(function(a){ base[_docClave(a)]=1; }); }catch(e){}
  docs=docs.filter(function(a){ return !base[_docClave(a)]; });

  // Si no hay nada en el paso, se cae al comprobante que se mandó por correo
  if(!docs.length){
    var env=_solEnvioLeer(oid,'comprobante_'+(esAbono?'abono':'cancelacion'));
    if(env && env.adjuntos && env.adjuntos.length && aviso){
      aviso.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> El comprobante se envió por correo pero no quedó archivado en el paso. Adjuntalo a mano: '
        +_esc(env.adjuntos.map(function(a){return a.nombre;}).join(', '))+'</span>';
      return;
    }
    if(aviso) aviso.innerHTML='<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Contabilidad todavía no subió el comprobante en su paso. Adjuntalo a mano.</span>';
    return;
  }
  var puestos=[];
  for(var i=0;i<docs.length;i++){
    if(!docs[i].url) continue;
    try{
      var adj=await _solPagoAdjuntarDeStorage(docs[i].url, docs[i].name||('comprobante_'+(i+1)+'.pdf'));
      if(adj){ window._mailAdj.push(adj); puestos.push(docs[i].name); }
    }catch(e){ console.warn('adjuntar comprobante:',e); }
  }
  mailPintarAdjuntos();
  if(aviso) aviso.innerHTML=puestos.length
    ? '<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado de contabilidad: '+_esc(puestos.join(', '))+'</span>'
    : '<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> No se pudo adjuntar el comprobante. Subilo a mano.</span>';
}

function _provCerrar(){
  var m=document.getElementById('modalProv'); if(m) m.remove();
  window._mailAdj=[]; window._provCtx=null;
}

function _provToggleCC(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i){ i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus'); i.style.fontSize='10px'; }
  var inp=document.getElementById('prov-cc'); if(!inp) return;
  var chips=Array.prototype.slice.call(document.querySelectorAll('#prov-cc-chips .sp-cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); })
                   .map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}

async function _provEnviar(){
  var ctx=window._provCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid, tipo=ctx.tipo, pasoIdx=ctx.paso;

  var para=((document.getElementById('prov-para')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var cc=((document.getElementById('prov-cc')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var asunto=(document.getElementById('prov-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('prov-cuerpo')||{}).value||'';

  if(!para.length){ _mailMsg('Escribe el correo del proveedor.','err'); return; }
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }
  if(!(window._mailAdj||[]).length){
    if(!confirm('No hay ningún comprobante adjunto.\n\n¿Enviar el correo igual?')) return;
  }
  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('prov-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var todos=para.concat(cc), vistos={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });

  var fila={
    docnum:String(oid), para_lista:todos, para_email:para[0],
    asunto:asunto, cuerpo:_repCuerpoTexto(cuerpo),
    adjuntos:_dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
             .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
    de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
    origen:'Comprobante al proveedor · '+(tipo==='cancelacion'?'pago final':'depósito')+' · '+oid,
    estado:'pendiente'
  };
  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text(); console.error('correo proveedor:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar al proveedor'; }
    return;
  }

  // El paso queda en verde
  try{
    var st=STAGES.find(function(z){ return z.key==='deposito'; });
    initP(oid);
    var sp=stageProgress[oid].deposito;
    if((sp.stepIdx||0)<=pasoIdx){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pasoIdx+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pasoIdx]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pasoIdx]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pasoIdx]=hoyIso;
      guardarEtapa(oid,'deposito');
    }
  }catch(e){ console.warn('marcar paso proveedor:',e); }

  var info={ fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
             asunto:asunto, cuerpo:cuerpo,
             adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, kb:a.kb||0}; }) };
  _solEnvioGuardar(oid, 'proveedor_'+tipo, info);

  // Queda registrado en la solicitud, para verlo en las alertas
  try{
    var sols=(window._solPago||[]).filter(function(x){ return String(x.docnum)===String(oid) && x.tipo===tipo; });
    var campo=(tipo==='cancelacion')?'envio_final_proveedor':'envio_prov';
    for(var i=0;i<sols.length;i++){
      sols[i][campo]=info;
      var patch={}; patch[campo]=info;
      await _solPagoPatch(sols[i].id, patch);
    }
  }catch(e){ console.warn('registrar envio proveedor:',e); }

  _provCerrar();
  showT('✓ Comprobante enviado al proveedor');
  try{ openDetail(oid); }catch(e){}
  try{ _solPagoRefrescar(); }catch(e){}
}


// Archivos ya adjuntos en el subpaso: el comprobante que contabilidad subió
// ahí tiene que viajar en el correo a la compradora.
function _compAdjuntosDelPaso(oid, tipo){
  var esDeposito=(tipo!=='cancelacion');
  var subKey=_subKeyDeposito(esDeposito?_PASO_DEP_PROV:_PASO_PAGO_FINAL);
  var propios=(window._atts&&window._atts[oid+subKey])?window._atts[oid+subKey]:[];
  // Sin los documentos base de la orden: esos ya los tiene compras
  var base={};
  try{ _docsBaseOrden(oid).forEach(function(a){ base[_docClave(a)]=1; }); }catch(e){}
  return _dedupDocs(propios).filter(function(a){ return !base[_docClave(a)]; });
}

async function _compAbrirModal(oid, tipo){
  // tipo: 'abono' -> depósito | 'cancelacion' -> cancelación
  var esDeposito=(tipo!=='cancelacion');
  var d=_solPagoDatosOrden(oid);
  var dest=_compDestinatarios(oid, tipo);
  var monto=_compMonto(oid, tipo);
  window._mailAdj=[];
  window._compCtx={oid:oid, tipo:tipo, paso:_pasoIdxDeposito(esDeposito?_PASO_DEP_PROV:_PASO_PAGO_FINAL)};

  var palabra = esDeposito ? 'depósito' : 'cancelación';
  var frase   = esDeposito ? 'del depósito realizado' : 'de la cancelación realizada';
  var pasoNom = esDeposito ? 'Depósito enviado al proveedor' : 'Solicitud de final del balance';
  var ordenTxt = d.dkc || String(oid);

  var asunto='['+ordenTxt+'] COMPROBANTE DE PAGO \u2192 '+pasoNom
    +(monto?(' \u00b7 '+fmt(monto)):'');

  var cuerpo='Estimada compradora,\n\n'
    +'Adjunto encontrará el comprobante '+frase+' al proveedor correspondiente.\n\n'
    +'Detalles del pago:\n'
    +'  \u2022 Proveedor: '+(d.proveedor||'')+'\n'
    +'  \u2022 Orden de Compra: '+ordenTxt+'\n'
    +(monto?('  \u2022 Monto: '+fmt(monto)+'\n'):'')
    +'\n'
    +'Favor de enviar este comprobante al proveedor y solicitar la confirmación de recibido.\n\n'
    +'Una vez que el proveedor confirme la recepción, le agradecemos responder este mismo correo '
    +'informando que el pago fue recibido, para mantener el seguimiento y control del proceso.\n\n'
    +'Quedamos atentos a cualquier consulta.\n\n'
    +'Saludos cordiales,\n'
    +'Departamento de Contabilidad\n'
    +(_firmaNombre()?(_firmaNombre()+'\n'):'')
    +'Kennedy Center Corp.';

  var chips=dest.lista.map(function(x){
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid '
      +(x.pidio?'#085041':'var(--border)')+';border-radius:8px;cursor:pointer;font-size:12px;background:'
      +(x.pidio?'#E1F5EE':'var(--surface-0)')+'">'
      +'<input type="checkbox" value="'+_esc(x.u.email)+'"'+(x.pidio?' checked':'')+' style="margin:0;cursor:pointer">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(x.u.color||'#eee')+';color:'+(x.u.tc||'#333')
      +';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700">'
      +_esc((x.u.name||'?').split(' ').map(function(p){return p[0];}).slice(0,2).join(''))+'</span>'
      +'<span>'+_esc(x.u.name)+'</span>'
      +(x.pidio?'<span style="font-size:9px;color:var(--t-verde2);font-weight:700">solicitó</span>':'')
      +'</label>';
  }).join('');

  // Los demás del equipo, para sumarlos con un clic
  var yaEn={}; dest.lista.forEach(function(x){ yaEn[String(x.u.email).toLowerCase()]=1; });
  var chipsOtros=(USERS||[]).filter(function(u){
    return u.email && !yaEn[String(u.email).toLowerCase()]
        && String(u.email).toLowerCase()!==String((CU&&CU.email)||'').toLowerCase();
  }).map(function(u){
    return '<span class="sp-cc-chip" data-mail="'+_esc(u.email)+'" onclick="_compToggleExtra(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti ti-plus" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');

  var prev=document.getElementById('modalComprob'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='modalComprob';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:680px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:var(--t-verde2)"><i class="ti ti-receipt"></i> Comprobante de '+palabra+'</div>'
      +'<button onclick="_compCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'

    +'<div style="background:var(--pastel-verde2);border:1px solid #A9DFD0;border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:var(--t-verde2)">'
      +'<b>'+_esc(d.proveedor||'')+'</b> \u00b7 orden '+_esc(ordenTxt)
      +'<div style="margin-top:3px">Total '+fmt(d.total)+' \u00b7 Abonado '+fmt(d.abonado)+' \u00b7 Saldo <b>'+fmt(d.saldo)+'</b></div>'
    +'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc((CU&&CU.name)||'')+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">Sale con tu dirección: las respuestas de compras te llegan a ti.</div></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA — compradoras que solicitaron'
      +(dest.dept?(' \u00b7 '+_esc(dL(dest.dept))):'')+'</div>'
    +'<div id="comp-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">'
      +(chips||'<span style="font-size:12px;color:var(--text-danger)">No se encontraron compradoras para esta orden.</span>')+'</div>'
    +'<div id="comp-mas-chips" style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:6px">'+chipsOtros+'</div>'
    +'<input id="comp-extra" placeholder="Otros correos, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="comp-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="comp-cuerpo" rows="14" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">COMPROBANTE</div>'
    +'<label style="display:flex;align-items:center;gap:8px;padding:9px 11px;border:1.5px dashed #A9DFD0;border-radius:8px;cursor:pointer;background:var(--pastel-verde2);margin-bottom:7px">'
      +'<i class="ti ti-file-dollar" style="color:var(--t-verde2);font-size:16px"></i>'
      +'<div style="flex:1;min-width:0"><div style="font-size:11.5px;font-weight:700;color:var(--t-verde2)">COMPROBANTE DE LA TRANSFERENCIA</div>'
      +'<div id="comp-file-lbl" style="font-size:10.5px;color:var(--t-verde2);opacity:.8">Adjunta el comprobante del banco</div></div>'
      +'<input type="file" accept=".pdf,image/*,.xlsx,.xls,.doc,.docx" style="display:none" onchange="_compArchivo(this)"></label>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_compCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="comp-btn" style="background:#085041" onclick="_compEnviar()"><i class="ti ti-send"></i> Enviar comprobante a compras</button>'
    +'</div>'
  +'</div>';
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // Se adjunta solo lo que ya está en este paso: el comprobante que
  // contabilidad subió ahí viaja en el correo a la compradora.
  var yaDelPaso=_compAdjuntosDelPaso(oid, tipo);
  if(yaDelPaso.length){
    _spCargando('Adjuntando el comprobante del paso…', yaDelPaso.length+' archivo(s)');
    var puestos=[];
    for(var i=0;i<yaDelPaso.length;i++){
      var a=yaDelPaso[i];
      if(!a.url) continue;
      try{
        var adj=await _solPagoAdjuntarDeStorage(a.url, a.name||('comprobante_'+(i+1)+'.pdf'));
        if(adj){ adj._marca='comprobante'; window._mailAdj.push(adj); puestos.push(a.name); }
      }catch(e){ console.warn('adjuntar del paso:',e); }
    }
    _spCargandoFin();
    mailPintarAdjuntos();
    var lbl=document.getElementById('comp-file-lbl');
    if(lbl && puestos.length){
      lbl.innerHTML='<i class="ti ti-circle-check" style="color:var(--text-success)"></i> '
        +_esc(puestos.join(', '))+' <span style="opacity:.75">(ya estaba en el paso)</span>';
    }
  }
}

// Marca o desmarca un destinatario extra
function _compToggleExtra(el){
  el.classList.toggle('on');
  var i=el.querySelector('i');
  if(i){ i.className='ti '+(el.classList.contains('on')?'ti-check':'ti-plus'); i.style.fontSize='10px'; }
  var inp=document.getElementById('comp-extra'); if(!inp) return;
  var chips=Array.prototype.slice.call(document.querySelectorAll('#comp-mas-chips .sp-cc-chip'));
  var todos=chips.map(function(c){ return (c.getAttribute('data-mail')||'').toLowerCase(); });
  var activos=chips.filter(function(c){ return c.classList.contains('on'); })
                   .map(function(c){ return c.getAttribute('data-mail'); });
  var manuales=(inp.value||'').split(/[,;]/).map(function(x){return x.trim();})
                .filter(function(x){ return x && todos.indexOf(x.toLowerCase())<0; });
  inp.value=activos.concat(manuales).join(', ');
}

function _compCerrar(){
  var m=document.getElementById('modalComprob'); if(m) m.remove();
  window._mailAdj=[]; window._compCtx=null;
}

function _compArchivo(input){
  var f=input.files&&input.files[0]; if(!f) return;
  _solPagoAdjuntarFile(f, 'comprobante');
  var lbl=document.getElementById('comp-file-lbl');
  if(lbl) lbl.innerHTML='<i class="ti ti-circle-check" style="color:var(--text-success)"></i> '+_esc(f.name);
}

async function _compEnviar(){
  var ctx=window._compCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid, tipo=ctx.tipo, pasoIdx=ctx.paso;

  var box=document.getElementById('comp-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ _mailMsg('Marca al menos una compradora.','err'); return; }

  var asunto=(document.getElementById('comp-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('comp-cuerpo')||{}).value||'';
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }
  if(!(window._mailAdj||[]).length){
    if(!confirm('No adjuntaste el comprobante.\n\n¿Enviar el correo igual?')) return;
  }

  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('comp-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }

  var extra=((document.getElementById('comp-extra')||{}).value||'')
    .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=marcados.map(function(c){ return c.value; }).concat(extra);
  // Sin repetidos, por si un correo está marcado y además escrito
  var vistosD={};
  todos=todos.filter(function(e){ var k=String(e).toLowerCase(); if(vistosD[k]) return false; vistosD[k]=1; return true; });
  var fila={
    docnum:String(oid),
    para_lista: todos,
    para_email: todos[0],
    asunto: asunto,
    cuerpo: _repCuerpoTexto(cuerpo),
    adjuntos: _dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
              .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
    de_nombre:(CU&&CU.name)||'',
    de_email:(CU&&CU.email)||'',
    origen:'Comprobante de '+(tipo==='cancelacion'?'cancelación':'depósito')+' · '+oid,
    estado:'pendiente'
  };
  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text(); console.error('correo comprobante:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar comprobante a compras'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar comprobante a compras'; }
    return;
  }

  // El paso queda en verde y se guarda lo que se envió
  try{
    var st=STAGES.find(function(z){ return z.key==='deposito'; });
    initP(oid);
    var sp=stageProgress[oid].deposito;
    if((sp.stepIdx||0)<=pasoIdx){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pasoIdx+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pasoIdx]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pasoIdx]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pasoIdx]=hoyIso;
      guardarEtapa(oid,'deposito');
    }
  }catch(e){ console.warn('marcar paso comprobante:',e); }

  var info={
    fecha:new Date().toISOString(), por:(CU&&CU.name)||'', para:todos,
    asunto:asunto, cuerpo:cuerpo,
    adjuntos:(window._mailAdj||[]).map(function(a){ return {nombre:a.nombre, kb:a.kb||0}; })
  };
  _solEnvioGuardar(oid, 'comprobante_'+tipo, info);

  // Lo que se adjuntó en el correo y todavía no estaba en el paso, se sube ahí:
  // así el comprobante queda archivado en la etapa aunque se haya elegido
  // desde el modal.
  try{
    var subKey=_subKeyDeposito((tipo==='cancelacion')?_PASO_PAGO_FINAL:_PASO_DEP_PROV);
    var yaEnPaso={};
    ((window._atts&&window._atts[oid+subKey])||[]).forEach(function(a){ yaEnPaso[_docClave(a)]=1; });
    var baseOrden={};
    try{ _docsBaseOrden(oid).forEach(function(a){ baseOrden[_docClave(a)]=1; }); }catch(e){}
    var nuevos=(window._mailAdj||[]).filter(function(a){
      var k=_docClave({name:a.nombre});
      return k && !yaEnPaso[k] && !baseOrden[k] && a.contenido;
    });
    for(var n=0;n<nuevos.length;n++){
      var a=nuevos[n];
      var bin=atob(a.contenido);
      var arr=new Uint8Array(bin.length);
      for(var b=0;b<bin.length;b++) arr[b]=bin.charCodeAt(b);
      var file=new File([arr], a.nombre, {type:a.mime||'application/octet-stream'});
      var pth=await _subirDocStorage(oid, subKey, file);
      if(pth){
        var regDoc=await _registrarDoc(oid, subKey, file, pth);
        if(!window._atts) window._atts={};
        if(!window._atts[oid+subKey]) window._atts[oid+subKey]=[];
        window._atts[oid+subKey].push({ id:regDoc?regDoc.id:undefined, name:a.nombre,
          data: DOCS_BASE + pth.split('/').map(encodeURIComponent).join('/'),
          url:pth, date:now2(), by:(CU&&CU.name)||'', remoto:true });
      }
    }
  }catch(e){ console.warn('guardar comprobante en el paso:',e); }

  // La solicitud pasa a "abono enviado" o "cancelación realizada"
  try{
    var sols=(window._solPago||[]).filter(function(x){ return String(x.docnum)===String(oid) && x.tipo===tipo; });
    var nuevo=(tipo==='cancelacion')?'cancelacion_realizada':'abono_enviado';
    for(var i=0;i<sols.length;i++){
      sols[i].estado=nuevo; sols[i].finalizado_en=new Date().toISOString();
      await _solPagoPatch(sols[i].id,{estado:nuevo, finalizado_en:sols[i].finalizado_en, envio_comprobante:info});
      try{ _solPagoAvisarSolicitante(sols[i], null); }catch(e){}
    }
  }catch(e){ console.warn('estado solicitud:',e); }

  _compCerrar();
  showT('✓ Comprobante enviado a '+todos.length+' compradora(s)');
  try{ openDetail(oid); }catch(e){}
  try{ _solPagoRefrescar(); }catch(e){}
}

async function _solPagoAbrirModal(oid, tipo){
  var d=_solPagoDatosOrden(oid);
  var esAbono=(tipo==='abono');
  // El abono ya viene leído de la proforma cuando se cargó la orden (los
  // términos de pago dicen el porcentaje del depósito), así que se propone ese
  // monto en vez de arrancar en cero. Sigue siendo editable, por monto o por
  // porcentaje, igual que hasta ahora.
  // En cancelación se propone el saldo pendiente, que es lo que se cancela.
  var montoSug=esAbono ? (Number(d.abonado)||0) : d.saldo;
  if(montoSug<0) montoSug=0;
  var pctSug=(d.total>0 && montoSug>0) ? (Math.round((montoSug/d.total)*10000)/100) : null;
  var _abonoDeProforma=esAbono && montoSug>0;
  window._mailAdj=[];
  window._solPagoCtx={oid:oid, tipo:tipo};

  var cts=(USERS||[]).filter(function(u){ return u.role==='contabilidad' && u.email; });
  var chips=cts.map(function(u){
    return '<label class="mail-dest" style="display:flex;align-items:center;gap:6px;padding:5px 9px;border:0.5px solid var(--border);border-radius:8px;cursor:pointer;font-size:12px;background:var(--surface-0)">'
      +'<input type="checkbox" value="'+_esc(u.email)+'" checked style="margin:0;cursor:pointer">'
      +'<span style="width:20px;height:20px;border-radius:50%;background:'+(u.color||'#eee')+';color:'+(u.tc||'#333')+';display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700">'
      +_esc((u.name||'?').split(' ').map(function(x){return x[0];}).slice(0,2).join(''))+'</span>'
      +'<span>'+_esc(u.name)+'</span></label>';
  }).join('');

  // Sugerencias de CC: el equipo de compras del departamento y gerencia
  var yo=((CU&&CU.email)||'').toLowerCase();
  var ccCand=(USERS||[]).filter(function(u){
    if(!u.email || u.email.toLowerCase()===yo) return false;
    if(u.role==='gerencia') return true;
    return CU && u.role===CU.role && (_deptPermitido(u.dept)||(!u.dept&&!_deptAcotado()));
  });
  var ccChips=ccCand.map(function(u){
    return '<span class="sp-cc-chip" data-mail="'+_esc(u.email)+'" onclick="_solPagoToggleCC(this)" title="'+_esc(u.email)+'">'
      +'<i class="ti ti-plus" style="font-size:10px"></i>'+_esc(u.name)+'</span>';
  }).join('');

  var titulo=esAbono?'Solicitud de abono':'Solicitud de cancelación de saldo';
  var color=esAbono?'#166534':'#B45309';
  var bg=esAbono?'#dcfce7':'#FEF9F3';
  var bd=esAbono?'#16a34a':'#E9C08A';

  var asunto=titulo+' - Orden '+oid+(d.dkc?(' / '+d.dkc):'')+(d.proveedor?(' - '+d.proveedor):'');
  var cuerpo='Estimados Contabilidad,\n\n'
    +(esAbono
      ? 'Solicito el envío del abono para la siguiente orden de compra:\n\n'
      : 'Solicito la cancelación del saldo final de la siguiente orden de compra:\n\n')
    +'Orden: '+oid+'\n'
    +(d.dkc?('DKC (Vendor Ref No): '+d.dkc+'\n'):'')
    +'Proveedor: '+d.proveedor+'\n'
    +'Departamento: '+dL(d.dept||'')+'\n'
    +'Total de la orden: '+fmt(d.total)+'\n'
    +(d.eta?('ETA (fecha de llegada): '+d.eta+'\n'):'')
    +'\nMonto solicitado: '+fmt(montoSug)+'\n\n'
    +_solPagoBloqueBanco(null)
    +'\nAdjunto la orden de Kennedy y la del proveedor firmadas por gerencia, y la debida diligencia.\n\n'
    +'Saludos,\n'+_firmaNombre()+'\nKennedy Center Corp.';

  var ov=document.createElement('div');
  ov.id='modalSolPago';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10001;display:flex;align-items:flex-start;justify-content:center;padding:22px;overflow-y:auto';
  ov.innerHTML='<div style="background:var(--surface-2);border-radius:14px;padding:18px;width:100%;max-width:680px;box-shadow:0 18px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">'
      +'<div style="font-size:15px;font-weight:700;color:'+color+'"><i class="ti '+(esAbono?'ti-coin':'ti-file-invoice')+'"></i> '+titulo+'</div>'
      +'<button onclick="_solPagoCerrar()" style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text-muted)">&times;</button>'
    +'</div>'

    +'<div style="background:'+bg+';border:1px solid '+bd+';border-radius:9px;padding:9px 11px;margin-bottom:12px;font-size:11.5px;color:'+color+'">'
      +'<b>'+_esc(d.proveedor||'')+'</b> · orden '+_esc(String(oid))+(d.dkc?(' · DKC <b>'+_esc(d.dkc)+'</b>'):'')
      +'<div style="margin-top:3px">Total '+fmt(d.total)+' · Abonado '+fmt(d.abonado)+' · Saldo <b>'+fmt(d.saldo)+'</b>'+(d.eta?(' · ETA '+_esc(d.eta)):'')+'</div>'
    +'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">DE</div>'
    +'<div style="font-size:13px;margin-bottom:12px;padding:7px 10px;background:var(--surface-1);border-radius:8px">'
      +_esc((CU&&CU.name)||'')+' &lt;'+_esc((CU&&CU.email)||'')+'&gt;'
      +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:2px">Sale con tu dirección y las respuestas te llegan a ti.</div></div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">PARA — equipo de contabilidad</div>'
    +'<div id="mail-dests" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px">'
      +(chips||'<span style="font-size:12px;color:var(--text-danger)">No hay usuarios de contabilidad con correo.</span>')+'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">CC — copia (opcional)</div>'
    +'<div id="sp-cc-chips" style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:5px">'+ccChips+'</div>'
    +'<input id="sp-cc" placeholder="otros@correo.com, separados por coma" style="width:100%;padding:7px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MONTO SOLICITADO</div>'
    +'<div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap;margin-bottom:4px">'
      +'<div><div style="font-size:10px;color:var(--text-muted);margin-bottom:2px">% de la factura</div>'
        +'<div style="display:flex;align-items:center;gap:4px">'
          +'<input id="sp-pct" type="number" step="0.01" min="0" max="100" value="'+(esAbono?(pctSug!=null?pctSug:''):'100')+'" placeholder="0" oninput="_solPagoCalcMonto()" '
          +'style="width:92px;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:14px;font-weight:700;background:var(--surface-2);color:var(--text-primary)">'
          +'<span style="font-size:14px;font-weight:700;color:var(--text-muted)">%</span></div></div>'
      +'<div style="font-size:18px;color:var(--text-muted);padding-bottom:6px">=</div>'
      +'<div><div style="font-size:10px;color:var(--text-muted);margin-bottom:2px">Monto a enviar</div>'
        +'<input id="sp-monto" type="number" step="0.01" value="'+montoSug.toFixed(2)+'" oninput="_solPagoCalcPct()" '
        +'style="width:170px;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:15px;font-weight:700;background:var(--surface-2);color:var(--text-primary)"></div>'
      +'<div style="display:flex;gap:4px;padding-bottom:6px">'
        +'<span onclick="_solPagoSetPct(10)" class="sp-q">10%</span>'
        +'<span onclick="_solPagoSetPct(20)" class="sp-q">20%</span>'
        +'<span onclick="_solPagoSetPct(25)" class="sp-q">25%</span>'
        +'<span onclick="_solPagoSetPct(50)" class="sp-q">50%</span>'
        +'<span onclick="_solPagoSetPct(100,\'bl\')" class="sp-q" '
        +'style="border-color:var(--t-verde3);color:var(--t-verde);background:var(--pastel-ok)" '
        +'title="Sin abono previo: se paga el total contra la copia del B/L">'
        +'100% contra B/L</span>'
      +'</div>'
    +'</div>'
    +'<div id="sp-calc" style="font-size:10.5px;color:var(--text-muted);margin-bottom:12px">Base: total de la orden '+fmt(d.total)+'</div>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">ASUNTO</div>'
    +'<input id="mail-asunto" value="'+_esc(asunto)+'" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:13px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary)">'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:4px">MENSAJE</div>'
    +'<textarea id="mail-cuerpo" rows="9" style="width:100%;padding:8px 10px;border:0.5px solid var(--border);border-radius:8px;font-size:12.5px;margin-bottom:12px;background:var(--surface-2);color:var(--text-primary);font-family:inherit;resize:vertical">'+_esc(cuerpo)+'</textarea>'

    +'<div style="font-size:11px;color:var(--text-muted);margin-bottom:5px">ADJUNTOS</div>'
    +'<div id="sp-auto" style="font-size:11.5px;color:var(--text-muted);margin-bottom:7px"><span class="ai-ring g" style="vertical-align:-2px"></span> Buscando las órdenes firmadas…</div>'
    +'<label style="display:flex;align-items:center;gap:8px;padding:9px 11px;border:1.5px dashed #C4B5FD;border-radius:8px;cursor:pointer;background:#F7F5FF;margin-bottom:7px">'
      +'<i class="ti ti-file-certificate" style="color:var(--t-lila);font-size:16px"></i>'
      +'<div style="flex:1;min-width:0"><div style="font-size:11.5px;font-weight:700;color:var(--t-lila)">DEBIDA DILIGENCIA DEL PROVEEDOR</div>'
      +'<div id="sp-dd-lbl" style="font-size:10.5px;color:var(--t-lila);opacity:.8">Adjunta el documento de debida diligencia</div></div>'
      +'<input type="file" accept=".pdf,.doc,.docx,.xlsx,.xls,image/*" style="display:none" onchange="_solPagoDD(this)"></label>'
    +'<div id="sp-banco" style="font-size:11px;margin-bottom:7px"></div>'
    +'<input type="file" id="mail-files" multiple onchange="mailAddFiles(this.files)" style="font-size:12px;margin-bottom:4px">'
    +'<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:6px">Otros documentos que quieras sumar.</div>'
    +'<div id="mail-adjs" style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px"></div>'

    +'<div id="mail-msg" style="display:none;font-size:12px;margin-bottom:10px;line-height:1.4"></div>'

    +'<div style="display:flex;justify-content:flex-end;gap:8px">'
      +'<button class="btn" onclick="_solPagoCerrar()">Cancelar</button>'
      +'<button class="btn bp" id="mail-btn" style="background:'+color+'" onclick="_solPagoEnviar()"><i class="ti ti-send"></i> Enviar a contabilidad</button>'
    +'</div>'
  +'</div>';
  // No se cierra al hacer clic fuera: hay datos escritos
  ov.addEventListener('click', function(e){ e.stopPropagation(); });
  document.body.appendChild(ov);

  // El monto propuesto viene de la proforma: se deja dicho para que se sepa
  // de dónde salió y se pueda cambiar con confianza.
  if(_abonoDeProforma){
    try{ _solPagoNota('Monto tomado de la proforma: '+(pctSug!=null?(pctSug.toFixed(2)+'% de '+fmt(d.total)+' = '):'')
      +'<b>'+fmt(montoSug)+'</b>. Puedes cambiarlo por monto o por porcentaje.'); }catch(e){}
  }

  // Adjuntar solas las DOS órdenes firmadas por gerencia
  var aviso=document.getElementById('sp-auto');
  _spCargando('Analizando los documentos de la orden…','Buscando las órdenes firmadas por gerencia');
  try{
    var r=await _solPagoAdjuntarFirmadas(oid);
    mailPintarAdjuntos();
    if(aviso){
      var h2='';
      if(r.puestos.length) h2+='<span style="color:var(--text-success)"><i class="ti ti-circle-check"></i> Adjuntado: '+r.puestos.join(' y ')+'.</span>';
      if(r.faltan.length)  h2+=(h2?'<br>':'')+'<span style="color:var(--t-ambar)"><i class="ti ti-alert-circle"></i> Falta '+r.faltan.join(' y ')+'. Adjuntalo a mano.</span>';
      aviso.innerHTML=h2||'<span style="color:var(--t-ambar)">No se encontraron documentos firmados para esta compra.</span>';
    }
  }catch(e){ console.warn('adjuntar firmadas:',e); if(aviso) aviso.innerHTML='<span style="color:var(--text-danger)">No se pudieron adjuntar las órdenes firmadas.</span>'; }

  // Leer las instrucciones bancarias del documento del proveedor
  if(esAbono){
    var av=document.getElementById('sp-banco');
    if(av) av.innerHTML='<span class="ai-wrap" style="color:var(--t-lila)"><span class="ai-ring"></span> Leyendo las instrucciones bancarias con AI…</span>';
    _spCargando('Leyendo las instrucciones bancarias con AI…','Puede tardar unos segundos según el tamaño del documento');
    try{
      var banco=await _solPagoLeerBanco(oid);
      _solPagoPonerBanco(banco||{});
      _solPagoAvisoBanco(banco);
      // El porcentaje de anticipo que pide el proveedor se escribe solo
      try{ _solPagoAplicarPct(banco); }catch(e){}
    }catch(e){ console.warn('banco:',e); _solPagoAvisoBanco(null); }
  } else {
    var av2=document.getElementById('sp-banco'); if(av2) av2.style.display='none';
  }
  _spCargandoFin();
}

function _solPagoCerrar(){
  _spCargandoFin();
  var m=document.getElementById('modalSolPago'); if(m) m.remove();
  window._mailAdj=[];
  window._solPagoCtx=null;
}

async function _solPagoEnviar(){
  var ctx=window._solPagoCtx;
  if(!ctx){ showT('Se perdió el contexto, vuelve a abrir'); return; }
  var oid=ctx.oid, tipo=ctx.tipo;

  var box=document.getElementById('mail-dests');
  var marcados=box?Array.prototype.slice.call(box.querySelectorAll('input:checked')):[];
  if(!marcados.length){ _mailMsg('Marca al menos un destinatario de contabilidad.','err'); return; }

  var asunto=(document.getElementById('mail-asunto')||{}).value||'';
  var cuerpo=(document.getElementById('mail-cuerpo')||{}).value||'';
  var monto=parseFloat((document.getElementById('sp-monto')||{}).value)||0;
  if(!asunto.trim()){ _mailMsg('Escribe un asunto.','err'); return; }
  if(monto<=0){ _mailMsg('El monto solicitado tiene que ser mayor a cero.','err'); return; }

  var totalKb=(window._mailAdj||[]).reduce(function(a,x){return a+(x.kb||0);},0);
  if(totalKb/1024 > MAIL_MAX_MB){
    _mailMsg('Los adjuntos suman '+(totalKb/1024).toFixed(1)+' MB y el límite son '+MAIL_MAX_MB+' MB.','err');
    return;
  }

  var btn=document.getElementById('mail-btn');
  if(btn){ btn.disabled=true; btn.innerHTML='Enviando…'; }
  _mailMsg('','info');

  var d=_solPagoDatosOrden(oid);
  var cc=((document.getElementById('sp-cc')||{}).value||'')
          .split(/[,;]/).map(function(x){return x.trim();}).filter(Boolean);
  var todos=marcados.map(function(c){return c.value;}).concat(cc);
  var fila={
    docnum: String(oid),
    para_lista: todos,
    para_email: marcados[0].value,
    asunto: asunto,
    cuerpo: _repCuerpoTexto(cuerpo),
    adjuntos: _dedupDocs((window._mailAdj||[]).map(function(a){ return {name:a.nombre, nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }))
                .map(function(a){ return {nombre:a.nombre, contenido:a.contenido, mime:a.mime}; }),
    de_nombre: (CU&&CU.name)||'',
    de_email:  (CU&&CU.email)||'',
    origen: (tipo==='abono'?'Solicitud de abono · ':'Solicitud de cancelación · ')+oid,
    estado: 'pendiente'
  };

  try{
    var r=await fetch(SB+'/rest/v1/correos_queue',{
      method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text();
      console.error('correo solicitud:', r.status, t);
      _mailMsg('No se pudo encolar el correo (error '+r.status+').','err');
      if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar a contabilidad'; }
      return;
    }
  }catch(e){
    _mailMsg('Error de conexión: '+(e.message||e),'err');
    if(btn){ btn.disabled=false; btn.innerHTML='<i class="ti ti-send"></i> Enviar a contabilidad'; }
    return;
  }

  // Registrar la solicitud para las alertas y el reporte de contabilidad
  var nota=(window._mailAdj||[]).length+' adjunto(s) · enviado a '+fila.para_lista.join(', ');
  var reg=await _solPagoCrear(oid, tipo, monto, nota);
  // OJO: el resumen del correo se arma MÁS ABAJO. Aquí todavía no existe, así
  // que este era el motivo de que el correo nunca llegara a la solicitud y
  // contabilidad viera "el detalle se ve desde el equipo que lo envió".
  // Se guarda al final, ya con el id de la solicitud.

  // El paso queda en verde y se guarda todo lo que se envió
  try{
    var pasoIdx=_pasoIdxDeposito((tipo==='abono')?_PASO_SOL_ABONO:_PASO_PAGO_FINAL);
    var st=STAGES.find(function(z){ return z.key==='deposito'; });
    initP(oid);
    var sp=stageProgress[oid].deposito;
    if((sp.stepIdx||0)<=pasoIdx){
      var hoyIso=new Date().toISOString().slice(0,10);
      sp.stepIdx=pasoIdx+1;
      if(!sp.stepDates) sp.stepDates=Array(st.steps.length).fill('');
      sp.stepDates[pasoIdx]=now2();
      if(!sp.stepBy) sp.stepBy=Array(st.steps.length).fill('');
      sp.stepBy[pasoIdx]=(CU&&CU.name)||'';
      if(!sp._isoPasos) sp._isoPasos=Array(st.steps.length).fill('');
      sp._isoPasos[pasoIdx]=hoyIso;
      if(!sp.startDate){ sp.startDate=now2(); sp._isoInicio=hoyIso; }
      guardarEtapa(oid,'deposito');
    }
    // Resumen del correo, para que contabilidad vea qué se mandó.
    // Se guarda también la ruta de cada adjunto: así cualquier equipo puede
    // abrirlos e imprimirlos, no solo el que envió.
    window._solEnvioPendiente={
      fecha:new Date().toISOString(),
      por:(CU&&CU.name)||'',
      para:todos,
      asunto:asunto,
      cuerpo:cuerpo,
      adjuntos:(window._mailAdj||[]).map(function(a){
        return {nombre:a.nombre, kb:a.kb||0, path:a.path||a.url||'', mime:a.mime||''};
      }),
      monto:monto
    };
    if(reg) reg.envio=window._solEnvioPendiente;
    _solEnvioGuardar(oid, tipo, window._solEnvioPendiente, reg && reg.id);
  }catch(e){ console.warn('marcar paso deposito:',e); }

  _solPagoCerrar();
  showT('✓ '+(tipo==='abono'?'Solicitud de abono':'Solicitud de cancelación')+' enviada a contabilidad'
        +(reg?'':' (el correo salió, pero no se registró en el listado)'));
  try{ renderNP(); }catch(e){}
}

// ═══════════════════════════════════════════════════════════════════════════
//  Solicitudes de pago — recibido, comentarios, estados y avisos (v45)
// ═══════════════════════════════════════════════════════════════════════════
function _fechaHora(iso){ if(!iso) return ''; try{ var d=new Date(iso); if(isNaN(d)) return String(iso); return d.toLocaleDateString('es-PA',{day:'2-digit',month:'short',year:'numeric'})+' · '+d.toLocaleTimeString('es-PA',{hour:'2-digit',minute:'2-digit'}); }catch(e){ return String(iso); } }
function _solPagoPorId(id){ return (window._solPago||[]).find(function(x){ return String(x.id)===String(id); }); }
function _solMias(x){ return CU && (String(x.solicitado_por||'')===String(CU.name||'') || (_deptAcotado() && _deptPermitido(normDept(x.dept||'')))); }
function _solComents(x){ var c=x&&x.comentarios; if(!c) return []; if(typeof c==='string'){ try{ c=JSON.parse(c); }catch(e){ return []; } } return Array.isArray(c)?c:[]; }
function _solSeenKey(){ return 'solpago_seen_'+((CU&&CU.id)||'x'); }
// Respaldo en memoria: si localStorage está bloqueado (modo privado, iframe de
// Shopify, cookies restringidas) el marcador de leído se perdía y el punto rojo
// volvía a aparecer en cada repintado.
window._solSeenMem = window._solSeenMem || {};
function _solSeenGet(){
  var m={};
  try{ m=JSON.parse(localStorage.getItem(_solSeenKey())||'{}')||{}; }catch(e){ m={}; }
  var mem=window._solSeenMem||{};
  for(var k in mem){ if(Number(mem[k]||0) > Number(m[k]||0)) m[k]=mem[k]; }
  return m;
}
function _solSeenSet(m){
  window._solSeenMem=Object.assign({}, window._solSeenMem||{}, m||{});
  try{ localStorage.setItem(_solSeenKey(), JSON.stringify(m)); }catch(e){}
}
// Cuántos comentarios leyó cada usuario, guardado en la propia solicitud.
// Así el estado sobrevive al recargar y lo ve también la otra parte.
function _solLeidos(x){
  var l=x&&x.leidos;
  if(typeof l==='string'){ try{ l=JSON.parse(l); }catch(e){ l={}; } }
  return (l&&typeof l==='object')?l:{};
}
function _solMarcarLeido(x){
  if(!x||!CU) return;
  var cs=_solComents(x);
  var l=_solLeidos(x);
  if(Number(l[CU.id]||0)>=cs.length) { var s0=_solSeenGet(); s0[x.id]=cs.length; _solSeenSet(s0); return; }
  l[CU.id]=cs.length;
  l['_n_'+CU.id]=(CU.name||'');
  l['_f_'+CU.id]=new Date().toISOString();
  x.leidos=l;
  var seen=_solSeenGet(); seen[x.id]=cs.length; _solSeenSet(seen);
  _solPagoPatch(x.id,{leidos:l});   // si la columna no existe, el patch la descarta solo
}
function _solTieneComentNuevo(x){
  var cs=_solComents(x);
  if(!cs.length) return false;
  var last=cs[cs.length-1];
  if(!last) return false;
  if(String(last.autor||'')===String((CU&&CU.name)||'')) return false;
  // Primero lo guardado en la solicitud; si no, el respaldo local
  var l=_solLeidos(x);
  if(CU && l.hasOwnProperty(CU.id)) return Number(l[CU.id]||0) < cs.length;
  var seen=_solSeenGet();
  return (Number(seen[x.id]||0) < cs.length);
}
// Quién leyó los comentarios, para que el solicitante lo sepa
function _solLeidoPor(x){
  var l=_solLeidos(x), cs=_solComents(x);
  if(!cs.length) return '';
  var yo=(CU&&CU.id)||'';
  var otros=[];
  for(var k in l){
    if(k.indexOf('_n_')===0 || k.indexOf('_f_')===0) continue;
    if(k===yo) continue;
    if(Number(l[k]||0)>=cs.length) otros.push(l['_n_'+k]||k);
  }
  if(!otros.length) return '';
  return '<span title="Ya vio los comentarios" style="font-size:10px;color:#2a9df4;font-weight:600;white-space:nowrap">'
    +'<i class="ti ti-checks" style="font-size:12px;vertical-align:-2px"></i> Leído por '+_esc(otros.join(', '))+'</span>';
}

// Resumen de lo que compras envió, para que contabilidad lo vea en la etapa
window._solEnvios=window._solEnvios||{};
function _solEnvioKey(oid,tipo){ return String(oid)+'_'+tipo; }
function _solEnvioGuardar(oid,tipo,info,solId){
  window._solEnvios[_solEnvioKey(oid,tipo)]=info;
  try{ localStorage.setItem('sol_envio_'+_solEnvioKey(oid,tipo), JSON.stringify(info)); }catch(e){}
  // También en la solicitud, para que el correo se vea desde CUALQUIER equipo
  // y no solo desde el navegador de quien lo envió.
  if(solId){
    try{
      Promise.resolve(_solPagoPatch(solId, {envio:info})).then(function(ok){
        if(!ok){
          console.error('[solicitud] el correo no se pudo guardar en la base. '
            +'Si falta la columna "envio" en solicitudes_pago, hay que crearla; '
            +'mientras tanto el detalle solo se verá en este equipo.');
        }
      });
    }catch(e){ console.warn('guardar envío:',e); }
  } else {
    console.warn('[solicitud] sin id: el correo queda solo en este equipo.');
  }
}
function _solEnvioLeer(oid,tipo){
  var k=_solEnvioKey(oid,tipo);
  // 1) Lo guardado en la solicitud: lo ve cualquiera, también contabilidad
  var x=(window._solPago||[]).find(function(s){ return String(s.docnum)===String(oid) && s.tipo===tipo; });
  if(x && x.envio){
    var e=x.envio;
    if(typeof e==='string'){ try{ e=JSON.parse(e); }catch(err){ e=null; } }
    if(e && (e.cuerpo||e.asunto)) return e;
  }
  // 2) Lo del propio navegador
  if(window._solEnvios[k]) return window._solEnvios[k];
  try{ var v=localStorage.getItem('sol_envio_'+k); if(v) return JSON.parse(v); }catch(e){}
  // 3) Como último recurso, lo básico de la solicitud
  if(x) return {fecha:x.solicitado_en, por:x.solicitado_por, monto:x.monto, nota:x.nota, _parcial:true};
  return null;
}

// Panel de solo lectura con lo que se envió
var _SOL_TITULOS={
  'abono':'Solicitud de abono enviada a contabilidad',
  'cancelacion':'Solicitud de cancelación enviada a contabilidad',
  'comprobante_abono':'Comprobante del depósito enviado a compras',
  'comprobante_cancelacion':'Comprobante del pago final enviado a compras',
  'proveedor_abono':'Comprobante del depósito enviado al proveedor',
  'proveedor_cancelacion':'Comprobante del pago final enviado al proveedor'
};
function _solEnvioPanel(oid, tipo){
  var e=_solEnvioLeer(oid,tipo);
  if(!e) return '';
  var titulo=_SOL_TITULOS[tipo]||'Correo enviado';
  var h='<div style="background:var(--pastel-ok);border:1px solid #16a34a;border-radius:9px;padding:10px 12px;margin-bottom:10px">'
    +'<div style="font-size:11.5px;font-weight:700;color:var(--t-verde);margin-bottom:5px"><i class="ti ti-circle-check"></i> '+titulo+'</div>'
    +'<div style="font-size:11px;color:var(--t-verde);line-height:1.6">'
      +(e.por?('Enviado por <b>'+_esc(e.por)+'</b>'):'')
      +(e.fecha?(' · '+_esc(_fechaHora(e.fecha))):'')
      +(e.monto?('<br>Monto solicitado: <b>'+fmt(e.monto)+'</b>'):'')
      +(e.para&&e.para.length?('<br>Para: '+_esc(e.para.join(', '))):'')
      +(e.asunto?('<br>Asunto: '+_esc(e.asunto)):'')
    +'</div>';
  if(e.adjuntos&&e.adjuntos.length){
    h+='<div style="margin-top:6px"><div style="font-size:10px;text-transform:uppercase;color:var(--t-verde);font-weight:700;margin-bottom:3px">Adjuntos enviados</div>';
    e.adjuntos.forEach(function(a){
      h+='<div style="font-size:11px;color:var(--t-verde)"><i class="ti ti-paperclip" style="font-size:11px"></i> '+_esc(a.nombre)+(a.kb?(' · '+a.kb+' KB'):'')+'</div>';
    });
    h+='</div>';
  }
  if(e.cuerpo){
    // Para contabilidad el cuerpo es lo que tiene que leer para trabajar la
    // solicitud, así que en las solicitudes viene abierto en vez de plegado.
    var _abierto=(tipo==='abono'||tipo==='cancelacion') && CU && (CU.role==='contabilidad'||CU.role==='gerencia');
    h+='<details'+(_abierto?' open':'')+' style="margin-top:6px"><summary style="font-size:10.5px;color:var(--t-verde);cursor:pointer;font-weight:600">Ver el mensaje enviado</summary>'
      +'<div style="font-size:11px;color:var(--t-verde);white-space:pre-wrap;background:var(--surface-0);border-radius:7px;padding:8px 10px;margin-top:5px;max-height:260px;overflow-y:auto">'+_esc(e.cuerpo)+'</div></details>';
  }
  // Imprimir la solicitud tal como llegó: el cuerpo del correo y la lista de
  // adjuntos (PI del proveedor, orden de KCC y debida diligencia si la hubo).
  if(tipo==='abono'||tipo==='cancelacion'){
    h+='<div style="margin-top:8px">'
      +'<button class="btn bg2" style="padding:5px 11px;font-size:10.5px;font-weight:600;color:var(--t-verde)"'
      +' onclick="_solImprimirSolicitud(\''+_esc(String(oid))+'\',\''+tipo+'\')">'
      +'<i class="ti ti-printer"></i> Imprimir solicitud</button></div>';
  }
  if(e._parcial) h+='<div style="font-size:10px;color:var(--t-verde);opacity:.8;margin-top:5px">El detalle completo del correo se ve desde el equipo que lo envió.</div>';
  h+='</div>';
  return h;
}

// Hitos del proceso con fecha, hora y quién lo hizo
// Los archivos que acompañan a un hito, para poder abrirlos desde la alerta
function _solHitoAdjuntos(info){
  var a=(info&&info.adjuntos)||[];
  if(!a.length) return '';
  return '<div style="display:flex;gap:4px;flex-wrap:wrap;margin-top:3px">'
    +a.map(function(f){
      var nom=String(f.nombre||f.name||'');
      var url=f.url?(DOCS_BASE+String(f.url).split('/').map(encodeURIComponent).join('/')):'';
      var t=_prevTipo(nom);
      var ico=(t==='img')?'ti-photo':((t==='pdf')?'ti-file-type-pdf':'ti-file');
      return '<span'+(url?_prevAttrs(url,nom):'')
        +(url?(' onclick="event.stopPropagation();verArchivo(\''+_esc(url)+'\',\''+_esc(nom.replace(/\x27/g,''))+'\')"'):'')
        +' style="display:inline-flex;align-items:center;gap:4px;background:var(--surface-1);'
        +'border:0.5px solid var(--border);border-radius:14px;padding:2px 8px;font-size:10px;'
        +(url?'cursor:pointer;color:var(--text-accent)':'color:var(--text-muted)')+'" title="'+_esc(nom)+'">'
        +'<i class="ti '+ico+'" style="font-size:11px"></i>'
        +_esc(nom.length>26?(nom.slice(0,24)+'…'):nom)+'</span>';
    }).join('')+'</div>';
}

function _solHitos(x){
  if(!x) return '';
  var hitos=[];
  if(x.solicitado_en) hitos.push({t:'Solicitada', q:x.solicitado_por, f:x.solicitado_en, c:'#0c447c'});
  if(x.recibido_en)   hitos.push({t:'Recibida en contabilidad', q:x.recibido_por, f:x.recibido_en, c:'#B45309'});
  var ec=x.envio_comprobante;
  if(typeof ec==='string'){ try{ ec=JSON.parse(ec); }catch(e){ ec=null; } }
  if(ec && ec.fecha) hitos.push({t:(x.tipo==='cancelacion'?'Pago final enviado a compras':'Abono enviado a compras'),
                                 q:ec.por, f:ec.fecha, c:'#166534', info:ec});
  else if(x.finalizado_en) hitos.push({t:(x.tipo==='cancelacion'?'Cancelación realizada':'Abono enviado'), q:'', f:x.finalizado_en, c:'#166534'});
  var ep=(x.tipo==='cancelacion')?x.envio_final_proveedor:x.envio_prov;
  if(typeof ep==='string'){ try{ ep=JSON.parse(ep); }catch(e){ ep=null; } }
  if(ep && ep.fecha) hitos.push({t:(x.tipo==='cancelacion'?'Pago final enviado al proveedor':'Comprobante enviado al proveedor'),
                                 q:ep.por, f:ep.fecha, c:'#5B21B6', info:ep});
  if(!hitos.length) return '';
  return '<div style="margin-top:5px;display:flex;flex-direction:column;gap:2px">'
    +hitos.map(function(z){
      return '<div style="font-size:10px;color:var(--text-muted);display:flex;align-items:center;gap:5px">'
        +'<span style="width:6px;height:6px;border-radius:50%;background:'+z.c+';flex-shrink:0"></span>'
        +'<b style="color:'+z.c+'">'+_esc(z.t)+'</b>'
        +(z.q?(' \u00b7 '+_esc(z.q)):'')
        +' \u00b7 '+_esc(_fechaHora(z.f))
        +(z.info?_solHitoAdjuntos(z.info):'')+'</div>';
    }).join('')+'</div>';
}

// ── La casilla de "pagada", solo para las cargadas del Excel ──
// Las 21 solicitudes que venían del Excel de pagos son órdenes viejas que
// contabilidad trabaja a mano: no pasan por las etapas del portal, así que
// no tienen forma de darse por cerradas. Con esta casilla se marcan como
// pagadas y dejan de aparecer en las alertas.
// Las solicitudes nacidas dentro del portal NO la llevan: esas se cierran
// con su comprobante, como siempre.
function _esDelExcel(x){
  return !!(x && (x.origen==='excel' || /^Del Excel de pagos/.test(String(x.nota||''))));
}

function _solPagadaYa(x){
  return !!(x && (x.pagado===true || x.pagado==='true'));
}

// La casilla existe en dos sitios: el panel del reporte y la pantalla de
// alertas. Se repinta el que esté abierto, para no cerrar el panel al
// marcar ni dejar la otra pantalla desactualizada.
function _solRepintarDondeEste(){
  var abierto=false;
  try{
    var m=document.getElementById('modal');
    abierto = m && m.style.display==='flex'
              && (document.getElementById('mc')||{}).innerHTML.indexOf('Abonos y cancelaciones')>=0;
  }catch(e){}
  if(abierto){ try{ _solPagoPanel(); }catch(e){} return; }
  try{ rAlertas(); }catch(e){}
}

// La marca de financiada, tal como venía en la columna FINAN del Excel.
// Es informativa: dice que ese pago se financió con el banco.
function _solFinanciadoChip(x){
  if(!_esDelExcel(x) || x.financiado!==true) return '';
  return '<span title="Pago financiado con el banco'
    + (x.banco?(' · '+_esc(x.banco)):'') + '" '
    + 'style="font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;'
    + 'background:#EEF2FF;color:var(--t-indigo2);border:0.5px solid #C7D2FE">Financiada'
    + (x.banco?(' · '+_esc(x.banco)):'') + '</span>';
}

function _solPagadoCheck(x){
  if(!_esDelExcel(x)) return '';
  // El mismo desplegable que en el panel del reporte: así se marca igual
  // desde los dos sitios y no hay dos formas de hacer lo mismo.
  var t = _solPagadaYa(x)
    ? ('Pagada' + (x.pagado_por?(' por '+x.pagado_por):'')
       + (x.pagado_en?(' · '+_fechaHora(x.pagado_en)):''))
    : 'Marcar cuando el pago salga';
  return '<span title="'+_esc(t)+'">'
    + _solDesplegable(x,'pagado',[
        {v:null,  t:'—',        c:'var(--text-muted)'},
        {v:true,  t:'Pagada',   c:'#166534'},
        {v:false, t:'Por pagar',c:'#B45309'}
      ],'95px')
    + '</span>';
}

function _solEstadoLabel(x){
  var e=x&&x.estado;
  // Una vez recibida, queda recibida: si hay fecha de recepción manda esa,
  // aunque el estado guardado se haya quedado atrás.
  if(x && x.recibido_en && (!e || e==='pendiente')) e='recibida';
  if(e==='abono_enviado') return {t:'Abono enviado'+(x.finalizado_en?(' · '+_fechaHora(x.finalizado_en)):''), c:'#166534', bg:'#dcfce7'};
  if(e==='cancelacion_realizada') return {t:'Cancelación realizada'+(x.finalizado_en?(' · '+_fechaHora(x.finalizado_en)):''), c:'#166534', bg:'#dcfce7'};
  if(e==='recibida') return {t:'Recibida'+(x.recibido_por?(' por '+x.recibido_por):'')+(x.recibido_en?(' · '+_fechaHora(x.recibido_en)):''), c:'#B45309', bg:'#FEF9F3'};
  if(e==='devuelta') return {t:'Devuelta a compras'+((x.devuelta&&x.devuelta.motivo)?(' · '+x.devuelta.motivo):''), c:'#991b1b', bg:'#FEF2F2'};
  if(e==='procesada') return {t:'Trabajada', c:'#555', bg:'#eceae4'};
  return {t:'Pendiente de recibir', c:'#9a3412', bg:'#FEF3E8'};
}

// PATCH con reintento quitando columnas que aún no existan en Supabase
async function _solPagoPatch(id, campos){
  if(!id) return false;
  var body=Object.assign({}, campos);
  for(var intento=0;intento<5;intento++){
    try{
      var r=await fetch(SB+'/rest/v1/solicitudes_pago?id=eq.'+id,{
        method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify(body)});
      if(r.ok) return true;
      var t=await r.text();
      // Columna que todavía no existe: se quita y se reintenta sin ella
      var m=t.match(/column "?([a-z_]+)"? .*does not exist/i) || t.match(/Could not find the '([a-z_]+)' column/i);
      if(m && body.hasOwnProperty(m[1])){ delete body[m[1]]; if(Object.keys(body).length===0) return false; continue; }
      // La tabla rechaza el estado: le falta la restricción actualizada.
      // Es un problema de configuración, así que hay que decirlo claro en vez
      // de fallar en silencio y dejar el estado como estaba.
      if(/violates check constraint|estado_check/i.test(t)){
        window._solPagoAvisoEstado=true;
        console.error('[solicitudes_pago] la tabla no acepta el estado "'+(body.estado||'')+'".'
          +' Hay que correr solicitudes_pago_fix.sql en Supabase.');
        try{ showT('⚠ La base no acepta ese estado. Hay que actualizar la tabla solicitudes_pago (script solicitudes_pago_fix.sql).'); }catch(e){}
        return false;
      }
      console.warn('solPagoPatch', r.status, t); return false;
    }catch(e){ console.warn('solPagoPatch', e); return false; }
  }
  return false;
}

// ITEM 1 — al abrir la solicitud, contabilidad la marca como recibida
async function _solPagoMarcarRecibidas(docnum){
  // Solo las que NUNCA se recibieron. Con fecha de recepción ya no se tocan:
  // una vez recibida, queda recibida.
  var pend=(window._solPago||[]).filter(function(x){ return String(x.docnum)===String(docnum) && !x.recibido_en && (x.estado==='pendiente'||!x.estado); });
  if(!pend.length) return;
  for(var i=0;i<pend.length;i++){
    var x=pend[i];
    x.recibido_por=(CU&&CU.name)||''; x.recibido_en=new Date().toISOString(); x.estado='recibida';
    var _ok=await _solPagoPatch(x.id,{recibido_por:x.recibido_por, recibido_en:x.recibido_en, estado:'recibida'});
    if(!_ok) await _solPagoPatch(x.id,{recibido_por:x.recibido_por, recibido_en:x.recibido_en});
    try{ var u=(USERS||[]).find(function(us){return us.name===x.solicitado_por;}); addNotif((u&&u.id)||'compras','📩 Solicitud recibida por '+(CU&&CU.name)+' — orden '+x.docnum, x.docnum, 'ti-check'); }catch(e){}
  }
  try{ _solPagoBadges(); }catch(e){}
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

// ITEM 5 — comentarios
function _solComentBtn(x){
  var cs=_solComents(x); var nuevo=_solTieneComentNuevo(x);
  var abierto=(String(window._solComentOpen)===String(x.id));
  return '<button class="btn bg2" title="Comentarios de esta solicitud"'
    +' style="padding:6px 13px;font-size:13px;font-weight:600;position:relative;display:inline-flex;align-items:center;gap:6px;'
    +(abierto?'border-color:var(--fill-accent);color:var(--fill-accent);':'')+'"'
    +' onclick="_solToggleComent(\''+x.id+'\')">'
    +'<i class="ti ti-message-2" style="font-size:18px"></i>'
    +'<span>'+cs.length+'</span>'
    +(nuevo?'<span style="position:absolute;top:-5px;right:-5px;width:12px;height:12px;background:#dc2626;border-radius:50%;border:2px solid var(--surface-0)"></span>':'')
    +'</button>';
}
function _solComentBox(x, color){
  var abierto=(String(window._solComentOpen)===String(x.id));
  var cs=_solComents(x);
  var lst=cs.map(function(c,ci){
    var mio=(String(c.autor||'')===String((CU&&CU.name)||''));
    // Solo el autor (o gerencia) puede editar o borrar su comentario
    var puede=mio||(CU&&CU.role==='gerencia');
    var acciones=puede?('<span style="margin-left:auto;display:inline-flex;gap:6px;flex-shrink:0">'
        +'<i class="ti ti-pencil" title="Editar" onclick="_solEditarComent(\''+x.id+'\','+ci+')" style="cursor:pointer;color:var(--text-muted);font-size:14px"></i>'
        +'<i class="ti ti-trash" title="Borrar" onclick="_solBorrarComent(\''+x.id+'\','+ci+')" style="cursor:pointer;color:var(--text-danger);font-size:14px"></i>'
      +'</span>'):'';
    return '<div style="font-size:11px;padding:5px 8px;background:'+(mio?'#eef5fd':'var(--surface-1)')+';border-radius:7px;margin-bottom:4px">'
      +'<div style="display:flex;align-items:center;gap:5px;font-weight:600;color:'+(color||'#333')+'">'+_esc(c.autor||'')+(c.rol?(' <span style="font-weight:400;color:var(--text-muted)">('+_esc(c.rol)+')</span>'):'')+' <span style="font-weight:400;color:var(--text-muted);font-size:9.5px">'+_esc(_fechaHora(c.en))+'</span>'+acciones+'</div>'
      +'<div style="margin-top:1px">'+_menResaltar(_esc(c.texto||''))
      +(c.editado?'<span style="font-size:9.5px;color:var(--text-muted);font-style:italic"> \u00b7 editado</span>':'')
      +'</div></div>';
  }).join('') || '<div style="font-size:10.5px;color:var(--text-muted);margin-bottom:5px">Sin comentarios todavía.</div>';
  return '<div id="solcom-box-'+x.id+'" style="display:'+(abierto?'block':'none')+';margin-top:7px;padding:8px;border:0.5px solid var(--border);border-radius:8px;background:var(--surface-0)">'
    +lst
    +'<div style="display:flex;gap:5px;margin-top:5px">'
      +'<div style="flex:1;position:relative">'
        +'<input id="solcom-in-'+x.id+'" value="'+_esc(_solPreTag(x))+'" placeholder="Escribe un comentario... usa @ para mencionar" autocomplete="off" style="width:100%;padding:5px 8px;border:0.5px solid var(--border);border-radius:7px;font-size:11px;background:var(--surface-0);color:var(--text-primary)"'
        +' oninput="_menRefrescar(\'solcom-in-'+x.id+'\',\'solmen-'+x.id+'\')"'
        +' onblur="setTimeout(function(){_menCerrar(\'solmen-'+x.id+'\');},150)"'
        +' onkeydown="if(event.key===\'Escape\'){_menCerrar(\'solmen-'+x.id+'\');} else if(event.key===\'Enter\'){event.preventDefault();_solAddComent(\''+x.id+'\');}">'
        +'<div id="solmen-'+x.id+'" style="display:none;position:absolute;bottom:100%;left:0;right:0;margin-bottom:4px;background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.18);max-height:220px;overflow-y:auto;z-index:60"></div>'
      +'</div>'
      +'<button class="btn bp" style="padding:5px 9px" onclick="_solAddComent(\''+x.id+'\')"><i class="ti ti-send"></i></button>'
    +'</div></div>';
}
// Si el último comentario me mencionó, la respuesta arranca con esa persona
// ya etiquetada: contestar a quien te habló es lo normal.
function _solPreTag(x){
  var cs=_solComents(x);
  if(!cs.length || !CU) return '';
  // Se busca el comentario más reciente que me haya mencionado
  for(var i=cs.length-1;i>=0;i--){
    var c=cs[i];
    if(String(c.autor||'')===String(CU.name||'')) return '';   // el último es mío: sin pre-tag
    var men=_menExtraer(c.texto||'');
    if(men.some(function(u){ return u.id===CU.id; })){
      var quien=(USERS||[]).find(function(u){ return String(u.name||'')===String(c.autor||''); });
      return quien?(_menToken(quien)+' '):'';
    }
  }
  return '';
}

function _solToggleComent(id){
  if(String(window._solComentOpen)===String(id)){ window._solComentOpen=null; }
  else{
    window._solComentOpen=id;
    var x=_solPagoPorId(id);
    if(x) _solMarcarLeido(x);
  }
  _solPagoRefrescar();
}
// Edita un comentario propio
async function _solEditarComent(id, ci){
  var x=_solPagoPorId(id); if(!x) return;
  var cs=_solComents(x); var c=cs[ci]; if(!c) return;
  if(!(String(c.autor||'')===String((CU&&CU.name)||'') || (CU&&CU.role==='gerencia'))){
    showT('Solo puedes editar tus propios comentarios'); return; }
  var txt=prompt('Editar comentario:', c.texto||'');
  if(txt===null) return;
  txt=String(txt).trim();
  if(!txt){ showT('El comentario no puede quedar vacío'); return; }
  if(txt===c.texto) return;
  cs[ci]=Object.assign({},c,{texto:txt, editado:true, editado_en:new Date().toISOString(), editado_por:(CU&&CU.name)||''});
  x.comentarios=cs;
  window._solComentOpen=id;
  var ok=await _solPagoPatch(id,{comentarios:cs});
  showT(ok?'Comentario actualizado':'\u26a0 No se pudo guardar el cambio');
  _solPagoRefrescar();
}

// Borra un comentario propio
async function _solBorrarComent(id, ci){
  var x=_solPagoPorId(id); if(!x) return;
  var cs=_solComents(x); var c=cs[ci]; if(!c) return;
  if(!(String(c.autor||'')===String((CU&&CU.name)||'') || (CU&&CU.role==='gerencia'))){
    showT('Solo puedes borrar tus propios comentarios'); return; }
  if(!confirm('¿Borrar este comentario?\n\n"'+String(c.texto||'').slice(0,120)+'"\n\nNo se puede deshacer.')) return;
  cs.splice(ci,1);
  x.comentarios=cs;
  window._solComentOpen=id;
  var seen=_solSeenGet(); seen[id]=cs.length; _solSeenSet(seen);
  var ok=await _solPagoPatch(id,{comentarios:cs});
  showT(ok?'Comentario borrado':'\u26a0 No se pudo borrar');
  _solPagoRefrescar();
}

async function _solAddComent(id){
  var inp=document.getElementById('solcom-in-'+id); if(!inp) return;
  var txt=(inp.value||'').trim(); if(!txt) return;
  var x=_solPagoPorId(id); if(!x){ showT('No se encontró la solicitud'); return; }
  var cs=_solComents(x);
  cs.push({autor:(CU&&CU.name)||'', rol:(CU&&CU.role)||'', texto:txt, en:new Date().toISOString()});
  // Aviso a los usuarios mencionados con @
  try{
    var mencionados=_menExtraer(txt);
    if(mencionados.length) _menNotificar(mencionados, {
      docnum:x.docnum, contexto:'solicitud', solId:x.id, texto:txt,
      etiqueta:'una solicitud de '+(x.tipo==='abono'?'abono':'cancelación')
    });
  }catch(e){ console.warn('menciones:',e); }
  x.comentarios=cs; inp.value='';
  var seen=_solSeenGet(); seen[id]=cs.length; _solSeenSet(seen);
  window._solComentOpen=id;
  // Se repinta solo la caja de comentarios, para no perder el foco
  try{
    var caja=document.getElementById('solcom-box-'+id);
    if(caja){
      var tmp=document.createElement('div');
      tmp.innerHTML=_solComentBox(x,'#0c447c');
      var nueva=tmp.firstChild;
      if(nueva){ caja.parentNode.replaceChild(nueva, caja); }
      var i2=document.getElementById('solcom-in-'+id); if(i2) i2.focus();
    }
  }catch(e){}
  var ok=await _solPagoPatch(id,{comentarios:cs});
  if(!ok) showT('⚠ No se pudo guardar el comentario (revisa la columna comentarios en Supabase)');
  // avisar a la otra parte
  try{
    if(CU && CU.role==='compras'){
      addNotif('contabilidad','💬 Nuevo comentario en solicitud — orden '+x.docnum, x.docnum, 'ti-message-2', true);
      // Aviso persistente: el de arriba se pierde al recargar
      _avSolicitud(_avUsuariosPorRol('contabilidad'), x,
        'Nuevo comentario de '+((CU&&CU.name)||'compras')+' en la solicitud',
        'Comentario en solicitud');
    } else {
      var u=(USERS||[]).find(function(us){ return us.name===x.solicitado_por; });
      addNotif((u&&u.id)||'compras','💬 Nuevo comentario de contabilidad — orden '+x.docnum, x.docnum, 'ti-message-2', true);
      _avSolicitud(_avSolicitante(x), x,
        'Nuevo comentario de contabilidad ('+((CU&&CU.name)||'')+') en tu solicitud',
        'Comentario en solicitud');
    }
  }catch(e){}
  try{ _solPagoBadges(); }catch(e){}
}

// ITEM 1 — badges / refresco
function _solPagoBadges(){
  var n=0;
  if(CU){
    // El número del menú cuenta lo que está SIN VER. Una vez que contabilidad
    // abre la solicitud queda 'recibida' y sigue en la lista hasta trabajarla,
    // pero deja de contar como aviso: si no, el número no bajaba nunca.
    if(CU.role==='contabilidad'||CU.role==='gerencia'){
      n=_solPagoPendientes(null).filter(function(x){
        return !x.recibido_en && (!x.estado || x.estado==='pendiente');
      }).length;
    }
    else if(CU.role==='compras'){ n=(window._solPago||[]).filter(function(x){ return _solMias(x) && _solTieneComentNuevo(x); }).length; }
  }
  var el=document.getElementById('nbNumSol');
  if(el){ if(n>0){ el.textContent=n; el.style.display='inline-flex'; } else el.style.display='none'; }
}
function _solPagoRefrescar(){ try{ if(PG==='alertas') rAlertas(); }catch(e){} try{ _solPagoBadges(); }catch(e){} }

// Recarga las solicitudes desde la base y repinta. Se usa al entrar a
// Alertas para que compras vea de inmediato si contabilidad ya la recibió.
async function _solPagoRecargar(){
  try{ await _solPagoCargar(true); }catch(e){}
  try{ _solPagoBadges(); }catch(e){}
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

async function _solPagoBadgeIniciar(){
  if(!CU) return;
  if(CU.role==='contabilidad'||CU.role==='gerencia'||CU.role==='compras'){
    try{ await _solPagoCargar(true); }catch(e){}
    window._solPagoListo=true;
    try{ _solPagoBadges(); }catch(e){}
    try{ if(PG==='dashboard') rDash(); }catch(e){}
    try{ if(PG==='alertas') rAlertas(); }catch(e){}
    if(!window._solPagoPoller){
      window._solPagoPoller=true;
      setInterval(function(){
        // No repintar si hay una caja de comentarios abierta o con texto:
        // el repintado borraría lo que la persona está escribiendo.
        var escribiendo=false;
        try{
          var act=document.activeElement;
          if(act && /^(solcom-in-|subcin-)/.test(act.id||'')) escribiendo=true;
          document.querySelectorAll('input[id^="solcom-in-"]').forEach(function(i){ if(i.value) escribiendo=true; });
        }catch(e){}
        _solPagoCargar(true).then(function(){
          try{ _solPagoBadges(); }catch(e){}
          if(escribiendo) return;
          if(PG==='alertas'){ try{ rAlertas(); }catch(e){} }
          if(PG==='dashboard'){ try{ rDash(); }catch(e){} }
        });
      }, 30000);
    }
  }
}

// ITEM 1 — banner rojo en el dashboard de contabilidad
function _solPagoDashBanner(){
  if(!CU || CU.role!=='contabilidad') return '';
  var lista=_solPagoPendientes(null);
  if(!lista.length) return '';
  var ab=lista.filter(function(x){return x.tipo==='abono';}).length;
  var ca=lista.filter(function(x){return x.tipo==='cancelacion';}).length;
  return '<div style="background:#FBEAF0;border:0.5px solid #e6a9bf;border-radius:var(--radius);padding:10px 12px;margin-bottom:10px;display:flex;align-items:center;gap:11px;cursor:pointer" onclick="go(\'alertas\')">'
    +'<span style="position:relative;display:inline-flex"><i class="ti ti-coin" style="font-size:20px;color:var(--t-vino)"></i>'
    +'<span style="position:absolute;top:-7px;right:-9px;background:#dc2626;color:#fff;border-radius:10px;min-width:17px;height:17px;padding:0 4px;font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;border:1.5px solid #fff">'+lista.length+'</span></span>'
    +'<div style="flex:1"><div style="font-size:12px;color:var(--t-vino);font-weight:600">'+lista.length+' solicitud'+(lista.length>1?'es':'')+' de abono o cancelación pendiente'+(lista.length>1?'s':'')+'</div>'
    +'<div style="font-size:10.5px;color:var(--t-vino);margin-top:2px">'+ab+' de abono · '+ca+' de cancelación</div></div>'
    +'<button class="btn" style="background:#72243E;color:#fff;padding:5px 11px;font-size:11px"><i class="ti ti-eye"></i> Ver</button></div>';
}

// ITEM 1 — sección para el que solicita (compras): ve sus solicitudes y el estado
function _solPagoMisSeccion(){
  var mias=(window._solPago||[]).filter(_solMias);
  if(!mias.length){
    return '<div style="border:1px solid #cfe0f5;background:#eef5fd;border-radius:10px;margin-bottom:12px;padding:10px 13px;font-size:11.5px;color:var(--t-azul)"><i class="ti ti-coin"></i> No tienes solicitudes de abono o cancelación enviadas.</div>';
  }
  mias=mias.slice().sort(function(a,b){ return String(b.solicitado_en||'').localeCompare(String(a.solicitado_en||'')); });
  var h='<div style="border:1px solid #cfe0f5;background:#eef5fd;border-radius:10px;margin-bottom:12px;overflow:hidden">';
  h+='<div style="padding:9px 13px;font-size:12.5px;font-weight:700;color:var(--t-azul)"><i class="ti ti-coin"></i> Mis solicitudes de abono / cancelación <span style="font-weight:400;font-size:11px">· '+mias.length+'</span></div>';
  mias.forEach(function(x){
    var st=_solEstadoLabel(x);
    h+='<div style="border-top:0.5px solid #cfe0f5;padding:8px 13px;background:var(--surface-0)">'
      +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
        +'<div style="flex:1;min-width:150px">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+' <span style="font-weight:400;color:var(--text-muted);font-size:10.5px">'+(x.tipo==='abono'?'Abono':'Cancelación')+'</span></div>'
          +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">'+_solRefLinks(x)+(x.solicitado_en?(' \u00b7 '+_esc(_fechaHora(x.solicitado_en))):'')+'</div>'
        +'</div>'
        +'<div style="text-align:right;flex-shrink:0"><div style="font-size:13px;font-weight:700;color:var(--t-azul)">'+fmt(x.monto)+'</div></div>'
      +'</div>'
      +'<div style="margin-top:5px;display:flex;align-items:center;gap:6px;flex-wrap:wrap">'
        +'<span style="font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;background:'+st.bg+';color:'+st.c+'">'+_esc(st.t)+'</span>'
        +(x.comprobante_path?('<a href="'+DOCS_BASE+String(x.comprobante_path).split('/').map(encodeURIComponent).join('/')+'" target="_blank" style="font-size:10px;color:var(--text-accent);text-decoration:underline"><i class="ti ti-paperclip"></i> Comprobante</a>'):'')
        +_solComentBtn(x)
        +_solLeidoPor(x)
      +'</div>'
      +_solHitos(x)
      +_solComentBox(x,'#0c447c')
    +'</div>';
  });
  return h+'</div>';
}

// ITEM 6 — al adjuntar el comprobante en la etapa de depósito, cambiar estado + avisar
async function _solPagoDepositoAdjunto(oid, stageKey, path, nombre){
  if(!CU || (CU.role!=='contabilidad' && CU.role!=='gerencia')) return;
  var tipo=null;
  if(stageKey===_subKeyDeposito(_PASO_DEP_PROV)) tipo='abono';
  else if(stageKey===_subKeyDeposito(_PASO_PAGO_FINAL)) tipo='cancelacion';
  else return;
  if(!(window._solPago && window._solPago.length)){ try{ await _solPagoCargar(true); }catch(e){} }
  var cand=(window._solPago||[]).filter(function(x){
    return String(x.docnum)===String(oid) && x.tipo===tipo && x.estado!=='abono_enviado' && x.estado!=='cancelacion_realizada';
  });
  if(!cand.length) return;
  var nuevoEstado=(tipo==='abono')?'abono_enviado':'cancelacion_realizada';
  for(var i=0;i<cand.length;i++){
    var x=cand[i];
    x.estado=nuevoEstado; x.comprobante_path=path; x.comprobante_nombre=nombre||'';
    x.finalizado_por=(CU&&CU.name)||''; x.finalizado_en=new Date().toISOString();
    await _solPagoPatch(x.id,{estado:nuevoEstado, comprobante_path:path, comprobante_nombre:x.comprobante_nombre, finalizado_por:x.finalizado_por, finalizado_en:x.finalizado_en});
    try{ await _solPagoAvisarSolicitante(x); }catch(e){}
  }
  showT('✓ Solicitud de '+(tipo==='abono'?'abono':'cancelación')+' actualizada a "'+(tipo==='abono'?'Abono enviado':'Cancelación realizada')+'"');
  try{ _solPagoBadges(); }catch(e){}
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

// ITEM 6 — avisar al solicitante y mandarle el comprobante adjunto
async function _solPagoAvisarSolicitante(x, texto){
  var u=(USERS||[]).find(function(us){ return us.name===x.solicitado_por; });
  var correo=u&&u.email;
  var esAbono=(x.tipo==='abono');
  // Lo que le queda por hacer a la compradora: reenviarle el comprobante al
  // proveedor. Se lo dice la alerta y el clic la deja en ese mismo subpaso.
  var _pendiente=esAbono
    ? 'Pendiente: enviar el comprobante del abono al proveedor'
    : 'Pendiente: enviar el comprobante de la cancelación al proveedor';
  var _pasoDestino=esAbono?_PASO_COMP_PROV:_PASO_COMP_FINAL;
  try{ addNotif((u&&u.id)||'compras', '📤 '+_pendiente+' — orden '+x.docnum, x.docnum, 'ti-send', true); }catch(e){}

  // Y la alerta con globo rojo, que es la que se ve arriba. addNotif sola no
  // alimenta ese contador, por eso el solicitante no se enteraba.
  try{
    if(u) await _menNotificar([u], {
      docnum:x.docnum, contexto:'etapa', etapa:'deposito', paso:_pasoDestino, solId:x.id,
      texto: texto || (_pendiente+' · '+(x.proveedor||'')+' · '+fmt(x.monto)
              +' · '+(esAbono?'el abono ya salió':'la cancelación ya se hizo')),
      etiqueta:_pendiente
    });
  }catch(e){ console.warn('alerta al solicitante:',e); }
  if(!correo) return;
  var adj=[];
  try{ var a=await _solPagoAdjuntarDeStorage(x.comprobante_path, x.comprobante_nombre||('Comprobante_'+x.docnum+'.pdf')); if(a) adj.push({nombre:a.nombre, contenido:a.contenido, mime:a.mime}); }catch(e){}
  var fila={
    docnum:String(x.docnum),
    para_lista:[correo], para_email:correo,
    asunto:(esAbono?'Abono enviado':'Cancelación realizada')+' - Orden '+x.docnum+(x.proveedor?(' - '+x.proveedor):''),
    cuerpo:_repCuerpoTexto('Hola '+(x.solicitado_por||'')+',\n\n'+(esAbono?'El abono que solicitaste ya fue enviado al proveedor.':'La cancelación del saldo final que solicitaste ya fue realizada.')+'\n\nOrden: '+x.docnum+'\nProveedor: '+(x.proveedor||'')+'\nMonto: '+fmt(x.monto)+'\n'+(adj.length?'\nAdjunto el comprobante.\n':'')+'\nContabilidad — Kennedy Center Corp.'),
    adjuntos:adj,
    de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
    origen:(esAbono?'Abono enviado · ':'Cancelación realizada · ')+x.docnum,
    estado:'pendiente'
  };
  try{ await fetch(SB+'/rest/v1/correos_queue',{ method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}), body:JSON.stringify(fila) }); }catch(e){}
}

// ── Vista para contabilidad dentro de Alertas ──
// Filtro de departamento (solo gerencia)
window._solDeptFiltro='todos';
// Una solicitud no se da por cerrada hasta que el comprobante llegó al
// proveedor. Que contabilidad haya pagado no cierra el circuito: el proveedor
// tiene que recibir el comprobante, y hasta entonces sigue habiendo algo que
// hacer. Los pasos son los de la etapa Depósito & Pago:
//   0 solicitud · 1 depósito enviado · 2 comprobante al proveedor
//   3 solicitud del balance · 4 comprobante del pago final
function _solComprobanteEnviado(x){
  var todo=(typeof stageProgress!=='undefined')?stageProgress:null;
  var sp=(todo && todo[String(x.docnum)] && todo[String(x.docnum)].deposito) || null;
  // Si no hay avance cargado para esa orden —a contabilidad no siempre le
  // llegan todas— NO se puede saber si el comprobante salió. En ese caso se
  // respeta el estado de la solicitud: dejarla pendiente por falta de dato la
  // dejaba en Alertas para siempre, incluso con el abono ya hecho.
  if(!sp) return true;
  var idx=Number(sp.stepIdx)||0;
  return (x.tipo==='cancelacion') ? idx>=5 : idx>=3;
}

function _solPagoPendientes(tipo){
  var esGer=(CU&&CU.role==='gerencia');
  var cerradas=['procesada','abono_enviado','cancelacion_realizada'];
  return (window._solPago||[]).filter(function(x){
    // Quien tiene departamento asignado ve solo el suyo. Contabilidad y la
    // gerencia general los ven todos, que es su trabajo.
    if(CU && _deptAcotado() && !_deptPermitido(normDept(x.dept||''))) return false;
    // Las cargadas del Excel se cierran con su casilla de "pagada": son
    // órdenes viejas que no recorren las etapas del portal, así que no hay
    // comprobante que esperar. Una vez marcadas, salen de las alertas para
    // todos, incluida gerencia.
    if(_esDelExcel(x) && _solPagadaYa(x)) return false;
    // Gerencia ve TODAS, también las cerradas, para poder auditarlas
    if(!esGer && cerradas.indexOf(x.estado)>=0 && _solComprobanteEnviado(x)) return false;
    if(tipo && x.tipo!==tipo) return false;
    if(esGer && window._solDeptFiltro && window._solDeptFiltro!=='todos'
       && String(x.dept||'otros')!==window._solDeptFiltro) return false;
    return true;
  });
}

// Botones de departamento para gerencia
function _solPagoBarraDept(){
  if(!CU || CU.role!=='gerencia') return '';
  var todas=(window._solPago||[]);
  if(!todas.length) return '';
  var depts={};
  todas.forEach(function(x){ depts[x.dept||'otros']=(depts[x.dept||'otros']||0)+1; });
  var act=window._solDeptFiltro||'todos';
  function btn(k,txt,n){
    var on=(act===k);
    return '<button onclick="_solSetDept(\''+k+'\')" style="border:1px solid '+(on?'var(--fill-accent)':'var(--border)')+';'
      +'background:'+(on?'var(--fill-accent)':'var(--surface-1)')+';color:'+(on?'#fff':'var(--text-secondary)')+';'
      +'border-radius:20px;padding:4px 11px;font-size:11px;font-weight:600;cursor:pointer">'
      +txt+' <span style="opacity:.8;font-weight:400">'+n+'</span></button>';
  }
  var h='<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
    +'<span style="font-size:11.5px;color:var(--text-secondary);font-weight:600"><i class="ti ti-filter"></i> Departamento</span>'
    +btn('todos','Todos',todas.length);
  Object.keys(depts).sort().forEach(function(d){
    h+=btn(d, (EMOJIS2[d]||'')+' '+_esc(dL(d)), depts[d]);
  });
  return h+'</div>';
}
function _solSetDept(d){ window._solDeptFiltro=d; try{ rAlertas(); }catch(e){} }

// Editar el monto de una solicitud (solo gerencia)
async function _solPagoEditar(id){
  if(!CU || CU.role!=='gerencia'){ showT('Solo gerencia puede editar solicitudes'); return; }
  var x=_solPagoPorId(id);
  if(!x){ showT('Solicitud no encontrada'); return; }
  var txt=prompt('Editar el monto de la solicitud\n\n'+(x.proveedor||'')+' \u00b7 orden '+(x.docnum||'')
    +'\nConcepto: '+(x.tipo==='abono'?'Abono':'Cancelación')
    +'\n\nMonto actual: '+fmt(x.monto), String(Number(x.monto||0).toFixed(2)));
  if(txt===null) return;
  var m=parseFloat(String(txt).replace(/,/g,''));
  if(isNaN(m)||m<=0){ showT('El monto tiene que ser mayor a cero'); return; }
  var nota=prompt('Motivo del cambio (queda registrado):','')||'';
  var antes=Number(x.monto)||0;
  x.monto=m;
  x.nota=(x.nota?(x.nota+' | '):'')+'Editado por '+((CU&&CU.name)||'')+': '+fmt(antes)+' \u2192 '+fmt(m)+(nota?(' ('+nota+')'):'');
  var ok=await _solPagoPatch(id,{monto:m, nota:x.nota});
  showT(ok?('✓ Monto actualizado a '+fmt(m)):'⚠ No se pudo guardar el cambio');
  _solPagoRefrescar();
}

// ═══════════════════════════════════════════════════════════════════════════
//  PENDIENTES DE GERENCIA
//  Tres listados de lo que todavía espera una acción, agrupados por
//  departamento. Se arman con los estados que ya usa el portal, así que en
//  cuanto la acción se completa la fila desaparece sola.
// ═══════════════════════════════════════════════════════════════════════════

// Los días y horas desde una fecha
// ═══════════════════════════════════════════════════════════════════════════
//  ESCALAMIENTO POR DEMORA
//  Cuando una solicitud lleva demasiados días sin resolverse, se avisa a
//  gerencia. Antes los días se veían en el panel pero nadie recibía nada.
// ═══════════════════════════════════════════════════════════════════════════
var ESCALAR_DIAS = 5;          // a partir de aquí se considera atrasada

function _escClave(x){ return 'esc_'+String(x.id||x.docnum||''); }

// La marca de "ya se avisó" va en la BASE, no en el navegador.
// Antes se guardaba en localStorage, que es privado de cada equipo: el
// navegador de cada persona que entraba creía que avisaba por primera vez
// y volvía a mandarlo todo. Con 29 usuarios y 20 solicitudes atrasadas
// salían cientos de avisos repetidos.
function _escYaAvisado(x, nivel){
  var n=Number(x.escalado_nivel)||0;
  if(n>=nivel) return true;
  // Respaldo local, por si falta la columna en la base
  try{ return localStorage.getItem(_escClave(x)+'_'+nivel)==='1'; }catch(e){ return false; }
}

async function _escMarcar(x, nivel){
  x.escalado_nivel=nivel;
  try{ localStorage.setItem(_escClave(x)+'_'+nivel,'1'); }catch(e){}
  try{
    await _solPagoPatch(x.id, {escalado_nivel:nivel, escalado_en:new Date().toISOString()});
  }catch(e){
    console.warn('[escalamiento] no se pudo marcar en la base. '
      +'¿Faltan las columnas escalado_nivel y escalado_en? '
      +'Están en escalamiento_columnas.sql');
  }
}

// Revisa las solicitudes atrasadas y avisa a gerencia UNA vez por nivel.
// El aviso va agrupado: una notificación con el resumen, no una por
// solicitud, que era lo que llenaba la pantalla.
async function _escRevisar(){
  if(!CU) return;
  // Solo lo dispara contabilidad, que es quien lleva las solicitudes. Antes
  // corría en el navegador de todos, y cada uno mandaba su tanda.
  if(CU.role!=='contabilidad' && CU.role!=='gerencia') return;
  if(window._escCorriendo) return;
  window._escCorriendo=1;

  try{
    var pend=(window._solPago||[]).filter(function(x){
      var e=String(x.estado||'');
      return e!=='abono_enviado' && e!=='cancelacion_realizada'
          && e!=='anulada' && e!=='procesada';
    });
    if(!pend.length) return;

    var porNivel={1:[], 2:[]};
    pend.forEach(function(x){
      var ref=x.creado_en||x.solicitado_en;
      if(!ref) return;
      var dias=Math.floor((Date.now()-new Date(ref).getTime())/86400000);
      if(isNaN(dias)) return;
      var nivel=(dias>=ESCALAR_DIAS*2)?2:(dias>=ESCALAR_DIAS?1:0);
      if(!nivel || _escYaAvisado(x, nivel)) return;
      x.__dias=dias;
      porNivel[nivel].push(x);
    });

    for(var nivel=2; nivel>=1; nivel--){
      var lista=porNivel[nivel];
      if(!lista.length) continue;

      var gers=(USERS||[]).filter(function(u){
        return u.role==='gerencia' && u.id;
      });
      if(!gers.length) continue;

      // UNA notificación con el resumen, no una por solicitud
      var total=lista.reduce(function(a,x){ return a+(Number(x.monto)||0); },0);
      var muestra=lista.slice(0,5).map(function(x){
        return (x.proveedor||'')+' '+fmt(x.monto)+' ('+x.__dias+'d)';
      }).join(' · ');

      try{
        await _menNotificar(gers, {
          docnum:'', contexto:'solicitud',
          texto:(nivel===2?'MUY ATRASADAS: ':'Atrasadas: ')
            +lista.length+' solicitud(es) de pago por '+fmt(total)
            +' llevan más de '+(nivel===2?ESCALAR_DIAS*2:ESCALAR_DIAS)+' días'
            +'. '+muestra+(lista.length>5?(' y '+(lista.length-5)+' más'):''),
          etiqueta:(nivel===2?'Solicitudes muy atrasadas':'Solicitudes atrasadas')
        });
        for(var k=0;k<lista.length;k++) await _escMarcar(lista[k], nivel);
        console.log('[escalamiento] aviso agrupado de nivel '+nivel+': '
          +lista.length+' solicitud(es)');
      }catch(e){ console.warn('[escalamiento]', e); }
    }
  } finally {
    window._escCorriendo=0;
  }
}

// Se revisa al entrar y cada media hora
function _escIniciar(){
  setTimeout(function(){ try{ _escRevisar(); }catch(e){} }, 12000);
  setInterval(function(){ try{ _escRevisar(); }catch(e){} }, 30*60*1000);
}

// ═══════════════════════════════════════════════════════════════════════════
//  DEVOLVER UNA SOLICITUD A COMPRAS
//  Contabilidad puede devolverla con un motivo, en vez de solo comentar.
// ═══════════════════════════════════════════════════════════════════════════
async function _solDevolver(id){
  var x=_solPagoPorId(id);
  if(!x){ showT('Solicitud no encontrada'); return; }
  if(!CU || (CU.role!=='contabilidad' && CU.role!=='gerencia')){
    showT('Solo contabilidad puede devolver una solicitud'); return;
  }

  var motivo=prompt('¿Por qué devolvés esta solicitud a compras?\n\n'
    +'Por ejemplo: faltan las instrucciones bancarias, el monto no coincide '
    +'con la proforma, falta la orden firmada…\n\n'
    +'El motivo le llega a quien la pidió.','');
  if(motivo===null) return;
  motivo=String(motivo).trim();
  if(!motivo){ showT('Hace falta escribir el motivo'); return; }

  var info={
    por:(CU&&CU.name)||'', en:new Date().toISOString(), motivo:motivo
  };
  x.estado='devuelta';
  x.devuelta=info;
  _solPagoRefrescar();

  var ok=await _solPagoPatch(id,{estado:'devuelta', devuelta:info});
  if(!ok){
    // Si la columna no existe, al menos queda como comentario
    try{
      var cs=_solComents(x);
      cs.push({por:(CU&&CU.name)||'', en:new Date().toISOString(),
               txt:'DEVUELTA: '+motivo});
      x.comentarios=cs;
      await _solPagoPatch(id,{comentarios:cs});
    }catch(e){}
  }

  // Aviso al solicitante y a su gerencia
  try{
    var destinos=_avSolicitante(x);
    (USERS||[]).forEach(function(u){
      if(u.role==='gerencia' && u.id && (!x.dept || !u.dept || String(u.dept)===String(x.dept))
         && !destinos.some(function(z){ return z.id===u.id; })) destinos.push(u);
    });
    if(destinos.length) await _menNotificar(destinos, {
      docnum:x.docnum, contexto:'solicitud', solId:x.id,
      texto:'Contabilidad devolvió la solicitud: '+motivo,
      etiqueta:'Solicitud devuelta'
    });
  }catch(e){}

  // Y el correo, para que no dependa de que entren al portal
  try{
    var u=(USERS||[]).find(function(us){ return us.name===x.solicitado_por; });
    if(u && u.email){
      await fetch(SB+'/rest/v1/correos_queue',{
        method:'POST', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({
          docnum:String(x.docnum), para_lista:[u.email], para_email:u.email,
          asunto:'Solicitud devuelta - Orden '+x.docnum+(x.proveedor?(' - '+x.proveedor):''),
          cuerpo:_repCuerpoTexto('Hola '+(x.solicitado_por||'')+',\n\n'
            +'Contabilidad devolvió tu solicitud de '
            +(x.tipo==='cancelacion'?'cancelación':'abono')+' por este motivo:\n\n'
            +'  '+motivo+'\n\n'
            +'Orden: '+x.docnum+'\n'
            +(x.proveedor?('Proveedor: '+x.proveedor+'\n'):'')
            +'Monto: '+fmt(x.monto)+'\n\n'
            +'Cuando lo corrijas, volvé a enviarla desde el portal.\n\n'
            +'Saludos,\n'+((CU&&CU.name)||'')+'\nKennedy Center Corp.'),
          adjuntos:[], de_nombre:(CU&&CU.name)||'', de_email:(CU&&CU.email)||'',
          origen:'Solicitud devuelta · '+x.docnum, estado:'pendiente'
        })});
    }
  }catch(e){ console.warn('correo de devolución:',e); }

  showT('✓ Solicitud devuelta a compras');
  _solPagoRefrescar();
}

// ═══════════════════════════════════════════════════════════════════════════
//  RECLAMOS A PROVEEDORES
//  Faltantes y mercancía en mal estado que bodega detecta al recibir.
//  Cada reclamo tiene un estado y sale del listado cuando se resuelve.
// ═══════════════════════════════════════════════════════════════════════════
// El estado del reclamo vive en su propia tabla. Antes dependía de
// localStorage, así que solo lo veía quien había enviado el correo, y de
// _logGuardar, que puede fallar según el tipo de orden.
window._reclEstados=window._reclEstados||{};

async function _reclCargarEstados(){
  try{
    var r=await fetch(SB+'/rest/v1/reclamos?select=*&limit=2000',{headers:SBH});
    if(!r.ok) return false;
    var filas=await r.json()||[];
    filas.forEach(function(f){
      if(f.docnum) window._reclEstados[String(f.docnum)]=f;
    });
    console.log('[reclamos] '+filas.length+' estado(s) cargados de la base');
    return true;
  }catch(e){ console.warn('[reclamos] estados:',e); return false; }
}

async function _reclGuardarEstado(oid, datos){
  var fila=Object.assign({
    docnum:String(oid),
    actualizado_en:new Date().toISOString(),
    actualizado_por:(CU&&CU.name)||''
  }, datos);
  window._reclEstados[String(oid)]=Object.assign(
    window._reclEstados[String(oid)]||{}, fila);
  try{
    var r=await fetch(SB+'/rest/v1/reclamos?on_conflict=docnum',{
      method:'POST',
      headers:Object.assign({},SBH,{'Prefer':'resolution=merge-duplicates,return=minimal'}),
      body:JSON.stringify(fila)});
    if(!r.ok){
      var t=await r.text();
      if(/does not exist|Could not find the table/i.test(t)){
        console.warn('[reclamos] falta la tabla "reclamos" en Supabase (reclamos.sql)');
      } else {
        console.warn('[reclamos] no se pudo guardar:', r.status, t.slice(0,140));
      }
      return false;
    }
    return true;
  }catch(e){ console.warn('[reclamos] guardar:',e); return false; }
}

// El estado que manda, mirando las tres fuentes
function _reclEstadoDe(oid, info){
  var rank={pendiente:0, enviado:1, resuelto:2};
  var cands=[];
  var base=window._reclEstados[String(oid)];
  if(base && base.estado) cands.push(base.estado);
  if(info && info.estado) cands.push(info.estado);
  try{
    var d=(window._logData||{})[oid];
    if(d && d.reclamo && d.reclamo.estado) cands.push(d.reclamo.estado);
  }catch(e){}
  var mejor='', r=-1;
  cands.forEach(function(c){
    var v=rank[c]!=null?rank[c]:-1;
    if(v>r){ r=v; mejor=c; }
  });
  // Si hay fecha de envío en cualquier lado, al menos está enviado
  if(r<1){
    var hayFecha=(base&&base.enviado_en) || (info&&info.fecha);
    try{
      var d2=(window._logData||{})[oid];
      if(d2&&d2.reclamo&&d2.reclamo.fecha) hayFecha=true;
    }catch(e){}
    if(hayFecha) return 'enviado';
  }
  return mejor||'pendiente';
}

var _RECL_ESTADOS = {
  pendiente: {t:'Pendiente',  c:'#991b1b', bg:'#FEF2F2', i:'ti-alert-circle'},
  enviado:   {t:'Enviado',    c:'#B45309', bg:'#FEF3E8', i:'ti-mail-forward'},
  resuelto:  {t:'Resuelto',   c:'#166534', bg:'#dcfce7', i:'ti-circle-check'}
};

// Todos los reclamos guardados, con lo que hace falta para el listado
// Precarga los datos de logística de TODAS las órdenes. Sin esto, los
// reclamos solo aparecían después de abrir cada orden a mano, porque
// _logLeer carga bajo demanda.
window._reclCargado=false;

async function _reclPrecargar(){
  if(window._reclCargando) return;
  window._reclCargando=true;
  var n=0;
  // Los estados primero: son los que definen qué sigue abierto
  try{ await _reclCargarEstados(); }catch(e){}

  // 1) Lo que ya está en la memoria del navegador
  try{
    for(var i=0;i<localStorage.length;i++){
      var k=localStorage.key(i);
      if(!k || k.indexOf('log_')!==0) continue;
      var oid=k.slice(4);
      if(window._logData[oid]) continue;
      try{
        var d=JSON.parse(localStorage.getItem(k));
        if(d){ window._logData[oid]=d; n++; }
      }catch(e){}
    }
  }catch(e){}

  // 2) Lo guardado en las órdenes NO SAP
  try{
    (window._pendSAP||[]).forEach(function(p){
      var oid=p.dkc||p.num_orden;
      if(!oid || window._logData[oid]) return;
      var d=p.logistica;
      if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(e){ d=null; } }
      if(d){ window._logData[oid]=d; n++; }
    });
  }catch(e){}

  // 3) Y lo de las órdenes de SAP, que vive en su propia tabla
  try{
    var r=await fetch(SB+'/rest/v1/compras_logistica?select=docnum,datos&limit=2000',{headers:SBH});
    if(r.ok){
      (await r.json()||[]).forEach(function(f){
        var oid=String(f.docnum||'');
        if(!oid) return;
        var d=f.datos;
        if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(e){ d=null; } }
        if(!d) return;
        // Lo que ya está en memoria manda: puede tener cambios sin guardar
        if(!window._logData[oid]){ window._logData[oid]=d; n++; }
      });
    }
  }catch(e){ console.warn('[reclamos] no se pudo precargar de la base:', e); }

  window._reclCargado=true;
  window._reclCargando=false;

  // Las entradas traídas de SAP se guardan aparte: si una orden tiene datos
  // de entrada pero no de logística, igual puede tener faltantes.
  try{
    var r2=await fetch(SB+'/rest/v1/entradas_queue?select=docnum,datos&estado=eq.listo'
      +'&order=creado_en.desc&limit=500',{headers:SBH});
    if(r2.ok){
      var puestas=0;
      (await r2.json()||[]).forEach(function(f){
        var oid=String(f.docnum||'');
        if(!oid) return;
        var d=window._logData[oid];
        // Solo si esa orden no tiene ya sus entradas cargadas
        if(d && d.entradas && (d.entradas.lista||[]).length) return;
        var dd=f.datos;
        if(typeof dd==='string'){ try{ dd=JSON.parse(dd); }catch(e){ dd=null; } }
        var lista=(dd&&dd.entradas)||[];
        if(!lista.length) return;
        window._logData[oid]=window._logData[oid]||{booking:{}, bl:{}, arrival:{}, contenedores:[]};
        window._logData[oid].entradas={lista:lista, en:'', por:''};
        puestas++;
      });
      if(puestas) console.log('[reclamos] '+puestas+' orden(es) con entradas recuperadas');
    }
  }catch(e){}
  console.log('[reclamos] precargadas '+n+' orden(es) con datos de logística');
  // Si el usuario ya está mirando las alertas, se refrescan
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
  return n;
}

function _reclTodos(){
  var out=[];
  var vistos={};

  function agregar(oid, info){
    if(!info || vistos[oid]) return;
    vistos[oid]=1;
    // El estado vive en dos sitios: el envío del correo y la orden. Si
    // cualquiera dice que ya se envió, se respeta: antes el listado seguía
    // marcándolo "sin enviar" aunque el correo ya hubiera salido.
    try{
      info.estado=_reclEstadoDe(oid, info);
      var base=window._reclEstados[String(oid)]||{};
      var dOrd=(window._logData||{})[oid]||{};
      var re=dOrd.reclamo||{};
      if(!info.fecha) info.fecha=base.enviado_en||re.fecha||'';
      if(!info.por)   info.por=base.enviado_por||re.por||'';
      if(!info.nota)  info.nota=base.nota||re.nota||'';
      if(!info.resuelto_en)  info.resuelto_en=base.resuelto_en||re.resuelto_en||'';
      if(!info.resuelto_por) info.resuelto_por=base.resuelto_por||re.resuelto_por||'';
    }catch(e){}
    var dat={};
    try{ dat=_solPagoDatosOrden(oid)||{}; }catch(e){}
    // El departamento que trae el reclamo manda: al reclamar desde una orden
    // abierta se guarda ahí, y buscarlo por el id no funciona porque el
    // identificador es la referencia DKC. Por eso salía como "otros".
    var dept=info.dept||dat.dept||'';
    if(!dept){
      var o=(typeof orders!=='undefined')?orders.find(function(x){return String(x.id)===String(oid);}):null;
      if(o) dept=o.dept||'';
      if(!dept){
        var p=(window._pendSAP||[]).find(function(x){
          return String(x.dkc)===String(oid)||String(x.num_orden)===String(oid); });
        if(p) dept=p.dept||'';
      }
    }
    out.push({
      oid:oid,
      dept:dept||'otros',
      proveedor:info.proveedor||dat.proveedor||'',
      monto:Number(info.monto)||0,
      lineas:Number(info.lineas)||0,
      tipo:info.tipo||'faltante',
      estado:info.estado||(info.fecha?'enviado':'pendiente'),
      fecha:info.fecha||'',
      por:info.por||'',
      para:info.para||[],
      resuelto_en:info.resuelto_en||'',
      resuelto_por:info.resuelto_por||'',
      nota:info.nota||''
    });
  }

  // Los reclamos ya enviados
  try{
    var envios=window._solEnvios||{};
    Object.keys(envios).forEach(function(k){
      if(k.indexOf('|reclamo')<0) return;
      var oid=k.split('|')[0];
      agregar(oid, envios[k]);
    });
  }catch(e){}

  // Y los que están en la tabla de reclamos. Es la fuente que sobrevive al
  // navegador, y la única que recoge los enviados desde una orden abierta:
  // ahí el envío no pasa por el registro de la orden y se quedaban fuera
  // del listado de alertas.
  try{
    var est=window._reclEstados||{};
    Object.keys(est).forEach(function(oid){
      if(vistos[oid]) return;
      var e=est[oid]||{};
      if(!e.estado && !e.enviado_en) return;
      agregar(oid, {
        estado:e.estado||'enviado',
        fecha:e.enviado_en||'', por:e.enviado_por||'',
        monto:Number(e.monto)||0, lineas:Number(e.lineas)||0,
        para:e.para||'', nota:e.nota||'',
        resuelto_en:e.resuelto_en||'', resuelto_por:e.resuelto_por||'',
        proveedor:e.proveedor||'', dept:e.dept||''
      });
    });
  }catch(e){}

  // Y los detectados en bodega que todavía no se enviaron
  try{
    Object.keys(window._logData||{}).forEach(function(oid){
      if(vistos[oid]) return;
      var d=window._logData[oid];
      var ents=(d && d.entradas && d.entradas.lista)||[];
      var falt=[], monto=0;
      ents.forEach(function(e){
        (e.lineas||[]).forEach(function(l){
          if((Number(l.cantidad_abierta)||0)>0){
            falt.push(l);
            monto+=Number(l.monto_faltante)||0;
          }
        });
      });
      // La mercancía dañada también es motivo de reclamo
      var dan=(d.danios&&d.danios.lista)||[];
      dan.forEach(function(x){
        falt.push(x);
        monto+=(Number(x.cantidad)||0)*(Number(x.precio)||0);
      });
      if(!falt.length) return;
      // Si ya se marcó resuelto a mano, no vuelve a aparecer
      var st=(d.reclamo&&d.reclamo.estado)||'pendiente';
      agregar(oid, {monto:monto, lineas:falt.length, estado:st,
                    fecha:(d.reclamo&&d.reclamo.fecha)||'',
                    resuelto_en:(d.reclamo&&d.reclamo.resuelto_en)||'',
                    resuelto_por:(d.reclamo&&d.reclamo.resuelto_por)||'',
                    nota:(d.reclamo&&d.reclamo.nota)||''});
    });
  }catch(e){}
  return out;
}

// Los que siguen abiertos: los resueltos salen del listado
function _reclAbiertos(){
  var todos=_reclTodos().filter(function(r){ return r.estado!=='resuelto'; });
  // Compras solo ve su departamento; gerencia ve todo
  if(CU && CU.role==='compras' && _deptAcotado()){
    todos=todos.filter(function(r){ return _deptPermitido(r.dept); });
  }
  return todos;
}

// Anotar la respuesta del proveedor
async function _reclNota(oid){
  var base=(window._reclEstados||{})[String(oid)]||{};
  var txt=prompt('Respuesta del proveedor o nota para "'+oid+'":', base.nota||'');
  if(txt===null) return;
  try{
    window._reclEstados=window._reclEstados||{};
    window._reclEstados[String(oid)]=Object.assign(
      window._reclEstados[String(oid)]||{}, {nota:txt});
    await _reclGuardarEstado(oid, {nota:txt});
    showT(txt?'Nota guardada':'Nota borrada');
  }catch(e){ console.warn('[reclamo] nota:', e); showT('No se pudo guardar la nota'); }
  try{ rAlertas(); }catch(e){}
}

// Quitar un reclamo del listado
async function _reclBorrar(oid){
  if(!confirm('¿Borrar el reclamo de la orden '+oid+'?\n\n'
    +'Desaparece del listado. El correo que ya salió no se deshace.')) return;
  try{
    var r=await fetch(SB+'/rest/v1/reclamos?docnum=eq.'+encodeURIComponent(oid),
      {method:'DELETE', headers:Object.assign({},SBH,{'Prefer':'return=minimal'})});
    if(!r.ok && r.status!==404) console.warn('[reclamo] borrar:', r.status);
  }catch(e){ console.warn('[reclamo] borrar:', e); }
  // Y de las dos fuentes en memoria, o volvería a salir al repintar
  try{ delete (window._reclEstados||{})[String(oid)]; }catch(e){}
  try{ delete (window._solEnvios||{})[oid+'|reclamo']; }catch(e){}
  try{
    var d=(window._logData||{})[oid];
    if(d && d.reclamo) d.reclamo.estado='resuelto';
  }catch(e){}
  showT('Reclamo borrado');
  try{ rAlertas(); }catch(e){}
}

function _reclPanel(){
  if(!CU || ['gerencia','compras','importacion','bodega'].indexOf(CU.role)<0) return '';
  var lista=_reclAbiertos();
  var abierto=!!window._reclAbierto;

  var totalM=lista.reduce(function(a,r){ return a+r.monto; },0);
  var pend=lista.filter(function(r){ return r.estado==='pendiente'; }).length;

  var cargando=!!window._reclCargando;
  var h='<div style="border:1px solid '+(pend?'#dc2626':'#E9C08A')+';border-radius:11px;'
    +'background:'+(pend?'#FEF2F2':'#FEF9F3')+';margin-bottom:12px;overflow:hidden">';
  h+='<div onclick="_reclToggle()" style="padding:10px 14px;display:flex;align-items:center;'
    +'gap:9px;flex-wrap:wrap;cursor:pointer">'
    +'<i class="ti ti-package-off" style="color:'+(pend?'#991b1b':'#7C3D12')+';font-size:16px"></i>'
    +'<span style="font-size:13px;font-weight:700;color:'+(pend?'#991b1b':'#7C3D12')+'">'
      +'Reclamos a proveedores</span>'
    +(cargando
      ? '<span class="ai-wrap" style="font-size:11px;color:var(--t-marron)"><span class="ai-ring g"></span> buscando…</span>'
      : ('<span style="font-size:11.5px;color:'+(pend?'#991b1b':'#7C3D12')+';opacity:.9">'
         +lista.length+' abierto(s) · '+fmt(totalM)+'</span>'))
    +(pend?('<span style="font-size:10px;font-weight:800;background:#dc2626;color:#fff;'
      +'border-radius:11px;padding:2px 9px">'+pend+' sin enviar</span>'):'')
    +'<span style="flex:1"></span>'
    +'<span onclick="event.stopPropagation();_reclRefrescar()" title="Volver a buscar en todas las órdenes" '
      +'style="font-size:11px;color:var(--text-muted);cursor:pointer;padding:2px 6px">'
      +'<i class="ti ti-refresh"></i></span>'
    +'<i class="ti ti-chevron-'+(abierto?'up':'down')+'" style="color:var(--text-muted)"></i>'
    +'</div>';

  if(!lista.length){
    return h+'<div style="padding:10px 14px;font-size:11.5px;color:var(--text-muted);'
      +'border-top:0.5px solid var(--border)">'
      +(cargando
        ? 'Buscando reclamos en las órdenes…'
        : ('<i class="ti ti-circle-check" style="color:var(--t-verde3)"></i> No hay reclamos abiertos.'))
      +'</div></div>';
  }

  // Totales por departamento, siempre visibles
  var porDept={};
  lista.forEach(function(r){ (porDept[r.dept]=porDept[r.dept]||[]).push(r); });
  h+='<div style="display:flex;gap:6px;flex-wrap:wrap;padding:0 14px 10px">';
  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    var m=g.reduce(function(a,r){ return a+r.monto; },0);
    var sinEnviar=g.filter(function(r){ return r.estado==='pendiente'; }).length;
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;'
      +'padding:7px 11px;min-width:140px">'
      +'<div style="font-size:10px;color:var(--text-muted);font-weight:600">'
        +(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</div>'
      +'<div style="font-size:14px;font-weight:700;color:var(--t-rojo)">'+fmt(m)+'</div>'
      +'<div style="font-size:10px;color:var(--text-muted)">'+g.length+' reclamo(s)'
        +(sinEnviar?(' · <b style="color:var(--t-rojo2)">'+sinEnviar+' sin enviar</b>'):'')+'</div>'
      +'</div>';
  });
  h+='</div>';

  if(!abierto) return h+'</div>';

  // El detalle, por departamento y del más caro al más barato
  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d].sort(function(a,b){ return b.monto-a.monto; });
    h+='<div style="padding:6px 14px;background:rgba(0,0,0,.03);font-size:11px;font-weight:700;color:var(--t-marron)">'
      +(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</div>';
    g.forEach(function(r){
      var st=_RECL_ESTADOS[r.estado]||_RECL_ESTADOS.pendiente;
      h+='<div style="padding:9px 14px;border-top:0.5px solid var(--border);background:var(--surface-0);'
        +'display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
        +'<div style="flex:1;min-width:180px;cursor:pointer" onclick="_reclIr(\''+_esc(String(r.oid).replace(/\x27/g,''))+'\')">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(r.proveedor||'(sin proveedor)')+'</div>'
          +'<div style="font-size:10.5px;color:var(--text-muted)">Orden '+_esc(r.oid)
            +' · '+r.lineas+' artículo(s)'
            +(r.fecha?(' · enviado el '+_esc(_fechaHora(r.fecha))):'')
            +(r.por?(' por '+_esc(r.por)):'')
            +(r.nota?('<br><i>'+_esc(r.nota)+'</i>'):'')
          +'</div></div>'
        +'<div style="text-align:right;min-width:96px">'
          +'<div style="font-size:14px;font-weight:700;color:var(--t-rojo)">'+fmt(r.monto)+'</div></div>'
        +'<select onclick="event.stopPropagation()" onchange="_reclSetEstado(\''+_esc(String(r.oid).replace(/\x27/g,''))+'\',this.value)" '
          +'style="padding:4px 9px;border:1px solid '+st.c+';border-radius:14px;font-size:10.5px;'
          +'font-weight:700;background:'+st.bg+';color:'+st.c+';cursor:pointer">'
          +Object.keys(_RECL_ESTADOS).map(function(k){
              return '<option value="'+k+'"'+((r.estado===k)?' selected':'')+'>'+_RECL_ESTADOS[k].t+'</option>';
            }).join('')
        +'</select>'
        +'</div>';
    });
  });
  return h+'</div>';
}

// Vuelve a buscar en todas las órdenes
async function _reclRefrescar(){
  window._reclCargado=false;
  window._logData=window._logData||{};
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
  var n=await _reclPrecargar();
  showT('✓ Revisadas '+(n||0)+' orden(es)');
}

function _reclToggle(){
  window._reclAbierto=!window._reclAbierto;
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

// Lleva a la orden, al paso donde está el comparativo
function _reclIr(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='bodega'; });
  if(idx<0) return;
  var st=STAGES[idx];
  var pi=st.steps.findIndex(function(p){ return p.name===_PASO_BOD_SAP; });
  if(pi<0) pi=0;

  window._abrirEtapa={oid:String(oid), key:'bodega', paso:pi};
  try{ _solPagoAbrir(oid); }catch(e){ try{ openDetail(oid); }catch(e2){} }

  // Se espera a que la orden esté realmente en pantalla. Con un tiempo fijo
  // a veces el detalle todavía no se había armado y no pasaba nada.
  _reclIrPaso(oid, idx, pi, 0);
}

function _reclIrPaso(oid, idx, pi, intento){
  setTimeout(function(){
    var eg=document.getElementById('egb-'+oid+'-'+idx);
    if(!eg){
      if(intento<40) return _reclIrPaso(oid, idx, pi, intento+1);
      console.warn('[reclamos] no se encontró la etapa en pantalla');
      return;
    }
    // La etapa, si viene plegada
    try{ toggleEG(String(oid), idx, true); }catch(e){}

    setTimeout(function(){
      var cuerpo=document.getElementById('ssb-'+oid+'-'+idx+'-'+pi);
      if(!cuerpo){
        if(intento<40) return _reclIrPaso(oid, idx, pi, intento+1);
        return;
      }
      if(cuerpo.style.display==='none'){
        try{ toggleSubStep(String(oid), idx, pi); }catch(e){}
      }
      // Ya abierto, se baja hasta el panel del reclamo
      setTimeout(function(){
        var destino=document.getElementById('bodsap-'+oid)
                 || cuerpo.previousElementSibling
                 || cuerpo;
        if(destino && destino.scrollIntoView){
          destino.scrollIntoView({behavior:'smooth', block:'center'});
          destino.style.transition='box-shadow .3s';
          destino.style.boxShadow='0 0 0 3px var(--fill-accent)';
          setTimeout(function(){ destino.style.boxShadow='none'; }, 2600);
        }
      }, 180);
    }, 200);
  }, intento===0?260:180);
}


// Cambia el estado del reclamo
async function _reclSetEstado(oid, estado){
  var d=_logLeer(oid);
  d.reclamo=d.reclamo||{};
  var antes=d.reclamo.estado||'pendiente';
  if(estado==='resuelto'){
    var nota=prompt('¿Cómo se resolvió el reclamo?\n\n'
      +'Por ejemplo: nota de crédito NC-4471 recibida, o el proveedor envió la reposición.\n\n'
      +'Queda registrado en el historial:','');
    if(nota===null){ try{ if(PG==='alertas') rAlertas(); }catch(e){} return; }
    d.reclamo.nota=String(nota).trim();
    d.reclamo.resuelto_en=new Date().toISOString();
    d.reclamo.resuelto_por=(CU&&CU.name)||'';
  }
  d.reclamo.estado=estado;
  if(estado!=='resuelto'){
    d.reclamo.resuelto_en=''; d.reclamo.resuelto_por='';
  }
  await _logGuardar(oid);
  // Y en su tabla, que es la fuente que ven todos
  try{
    await _reclGuardarEstado(oid, {
      estado:estado,
      nota:d.reclamo.nota||'',
      resuelto_en:d.reclamo.resuelto_en||null,
      resuelto_por:d.reclamo.resuelto_por||''
    });
  }catch(e){}

  // El estado también se guarda en el envío, para que no se pierda
  try{
    var k=String(oid)+'|reclamo';
    if(window._solEnvios && window._solEnvios[k]){
      window._solEnvios[k].estado=estado;
      window._solEnvios[k].nota=d.reclamo.nota||'';
      window._solEnvios[k].resuelto_en=d.reclamo.resuelto_en||'';
      window._solEnvios[k].resuelto_por=d.reclamo.resuelto_por||'';
      _solEnvioGuardar(oid, 'reclamo', window._solEnvios[k]);
    }
  }catch(e){}

  showT('Reclamo marcado como '+((_RECL_ESTADOS[estado]||{}).t||estado).toLowerCase());

  // Al resolverse se avisa a gerencia y a quien lo hizo
  if(estado==='resuelto' && antes!=='resuelto'){
    try{
      var dat=_solPagoDatosOrden(oid);
      var dept=dat.dept||'';
      var destinos=(USERS||[]).filter(function(u){
        if(!u.id || u.id===((CU&&CU.id)||'')) return false;
        if(u.role==='gerencia') return !dept || !u.dept || String(u.dept)===String(dept);
        return u.role==='compras' && dept && String(u.dept||'')===String(dept);
      });
      if(destinos.length) await _menNotificar(destinos, {
        docnum:oid, contexto:'etapa', etapa:'Bodega & Venta', paso:_PASO_BOD_SAP,
        texto:'Reclamo resuelto · '+(dat.proveedor||'')+(d.reclamo.nota?(' · '+d.reclamo.nota):''),
        etiqueta:'Reclamo resuelto'
      });
    }catch(e){}
  }
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
  try{ _bodRepintar(oid); }catch(e){}
}

function _pgDesde(iso){
  if(!iso) return {txt:'—', dias:null};
  var d=new Date(iso);
  if(isNaN(d)) return {txt:'—', dias:null};
  var ms=Date.now()-d.getTime();
  var dias=Math.floor(ms/86400000);
  var hs=Math.floor((ms%86400000)/3600000);
  return {
    dias:dias,
    txt:(dias>0?(dias+'d '):'')+hs+'h',
    fecha:_fechaHora(iso)
  };
}

function _pgColor(dias){
  if(dias==null) return 'var(--text-muted)';
  if(dias>=7) return '#991b1b';
  if(dias>=3) return '#B45309';
  return '#166534';
}

// ── 1) Abonos pedidos y sin comprobante al proveedor ──
function _pgAbonos(){
  return (window._solPago||[]).filter(function(x){
    if(String(x.tipo||'')!=='abono') return false;
    var e=String(x.estado||'');
    // El comprobante al proveedor es lo que la cierra
    if(e==='abono_enviado' || e==='anulada' || e==='procesada') return false;
    return true;
  });
}

// ── 2) Cancelaciones recibidas y sin enviar al proveedor ──
function _pgCancelaciones(){
  return (window._solPago||[]).filter(function(x){
    if(String(x.tipo||'')!=='cancelacion') return false;
    var e=String(x.estado||'');
    if(e==='cancelacion_realizada' || e==='anulada' || e==='procesada') return false;
    return true;
  });
}

// ── 3) Órdenes esperando artes ──
// Entran cuando la orden llega al HUB y salen cuando gerencia aprueba los artes.
function _pgArtes(){
  var out=[];
  var st=STAGES.find(function(z){ return z.key==='artes'; });
  if(!st) return out;
  var iAprob=st.steps.findIndex(function(p){ return p.name===_PASO_ARTES_APROB; });
  if(iAprob<0) return out;

  function revisar(oid, dept, proveedor, docTxt){
    if(!oid) return;
    var sp=(stageProgress[oid]||{}).artes;
    if(!sp) return;
    var idx=sp.stepIdx||0;
    // Ya pasó la aprobación de gerencia: deja de estar pendiente
    if(idx>iAprob) return;
    // Todavía no llegó a artes
    var iPedido=STAGES.findIndex(function(z){ return z.key==='pedido'; });
    var iArtes=STAGES.findIndex(function(z){ return z.key==='artes'; });
    var actual=(typeof getStageIdx==='function')?getStageIdx({id:oid}):null;
    if(actual!=null && actual<iArtes) return;

    // Desde cuándo espera: la fecha del archivo que subió compras al HUB
    var desde='';
    try{
      var sk=oid+'artes_step0';
      var docs=(window._atts&&window._atts[sk])?_dedupDocs(window._atts[sk]):[];
      // El Excel de compra es el que marca el arranque
      var excel=docs.find(function(a){ return /\.(xlsx|xls|csv)$/i.test(String(a.name||'')); });
      var ref=excel||docs[0];
      if(ref && ref.date) desde=ref.date;
    }catch(e){}
    if(!desde && sp.startDate) desde=sp.startDate;
    if(!desde){
      try{ desde=(sp.stepDates||[])[0]||''; }catch(e){}
    }

    out.push({
      oid:oid, dept:dept||'otros', proveedor:proveedor||'', doc:docTxt||oid,
      desde:_pgIsoDe(desde),
      paso:(st.steps[Math.min(idx, st.steps.length-1)]||{}).name||''
    });
  }

  (typeof orders!=='undefined'?orders:[]).forEach(function(o){
    if(o.pend || o.comp) return;
    revisar(o.id, o.dept, o.prov||o.proveedor, o.id);
  });
  (window._pendSAP||[]).forEach(function(p){
    var oid=p.dkc||p.num_orden;
    revisar(oid, p.dept, p.proveedor||p.cardname, p.dkc||oid);
  });
  return out;
}

// Las fechas del portal vienen como "dd/mm/aaaa hh:mm"; se pasan a ISO
function _pgIsoDe(f){
  if(!f) return '';
  var s=String(f).trim();
  if(/^\d{4}-\d{2}-\d{2}/.test(s)) return s;
  var m=s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ ,]+(\d{1,2}):(\d{2}))?/);
  if(m){
    var yy=+m[3], mm=+m[2], dd=+m[1], hh=+(m[4]||0), mi=+(m[5]||0);
    var d=new Date(yy, mm-1, dd, hh, mi);
    return isNaN(d)?'':d.toISOString();
  }
  var d2=new Date(s);
  return isNaN(d2)?'':d2.toISOString();
}

// ── El panel ──
function _pgPanel(){
  if(!CU || CU.role!=='gerencia') return '';

  var abonos=_pgAbonos();
  var cancel=_pgCancelaciones();
  var artes=_pgArtes();
  var total=abonos.length+cancel.length+artes.length;

  var h='<div style="border:1px solid #E0A82E;border-radius:11px;background:var(--surface-0);'
    +'margin-bottom:14px;overflow:hidden">';
  h+='<div style="padding:10px 14px;background:var(--pastel-aviso);display:flex;align-items:center;gap:9px;flex-wrap:wrap;'
    +'border-bottom:0.5px solid #E9C08A">'
    +'<i class="ti ti-checklist" style="color:var(--t-marron);font-size:16px"></i>'
    +'<span style="font-size:13px;font-weight:700;color:var(--t-marron)">Pendientes de seguimiento</span>'
    +'<span style="font-size:11px;color:var(--t-marron);opacity:.85">'+total+' en total</span>'
    +'<span style="flex:1"></span>'
    +'<span style="font-size:10.5px;color:var(--text-muted)">Desaparecen solos al completarse</span>'
    +'</div>';

  h+=_pgBloque('Solicitudes de abono', 'ti-coin', '#166534', abonos, 'abono');
  h+=_pgBloque('Solicitudes de cancelación', 'ti-file-invoice', '#B45309', cancel, 'cancelacion');
  h+=_pgBloqueArtes(artes);

  return h+'</div>';
}

function _pgBloque(titulo, icono, color, lista, tipo){
  var h='<div style="border-bottom:0.5px solid var(--border)">'
    +'<div style="padding:8px 14px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;background:var(--surface-1)">'
      +'<i class="ti '+icono+'" style="color:'+color+'"></i>'
      +'<span style="font-size:12px;font-weight:700;color:'+color+'">'+_esc(titulo)+'</span>'
      +'<span style="font-size:11px;color:var(--text-muted)">'+lista.length+' pendiente(s)'
      +(lista.length?(' · '+fmt(lista.reduce(function(a,x){return a+(Number(x.monto)||0);},0))):'')+'</span>'
    +'</div>';

  if(!lista.length){
    return h+'<div style="padding:9px 14px;font-size:11.5px;color:var(--text-muted)">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde3)"></i> Nada pendiente.</div></div>';
  }

  // Agrupadas por departamento
  var porDept={};
  lista.forEach(function(x){ var d=x.dept||'otros'; (porDept[d]=porDept[d]||[]).push(x); });

  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    var tot=g.reduce(function(a,x){return a+(Number(x.monto)||0);},0);
    var peor=0;
    g.forEach(function(x){
      var t=_pgDesde(x.creado_en||x.solicitado_en);
      if(t.dias!=null && t.dias>peor) peor=t.dias;
    });
    h+='<div style="padding:6px 14px;background:rgba(0,0,0,.02);font-size:11px;font-weight:700;color:'+color+'">'
      +(EMOJIS2[d]||'')+' '+_esc(dL(d))
      +' <span style="font-weight:400;color:var(--text-muted)">· '+g.length+' · '+fmt(tot)
      +' · el más viejo '+peor+' día(s)</span></div>';

    g.sort(function(a,b){
      var da=_pgDesde(a.creado_en||a.solicitado_en).dias||0;
      var db=_pgDesde(b.creado_en||b.solicitado_en).dias||0;
      return db-da;
    }).forEach(function(x){
      // El reloj arranca cuando se generó la solicitud; en cancelaciones,
      // cuando contabilidad la recibió.
      var refIso=(tipo==='cancelacion')
        ? (x.recibido_en||x.creado_en||x.solicitado_en)
        : (x.creado_en||x.solicitado_en);
      var t=_pgDesde(refIso);
      var col=_pgColor(t.dias);
      var st=_solEstadoLabel(x);
      h+='<div id="solcard-'+_esc(String(x.id||''))+'" data-soldoc="'+_esc(String(x.docnum||''))+'"'
        +' onclick="_solPagoVerSolicitud('+(x.id||0)+')"'
        +' style="padding:8px 14px;border-top:0.5px solid var(--border);display:flex;align-items:center;'
        +'gap:10px;flex-wrap:wrap;cursor:pointer">'
        +'<div style="min-width:56px;text-align:center">'
          +'<div style="font-size:15px;font-weight:800;color:'+col+';line-height:1.1">'+_esc(t.txt)+'</div>'
          +'<div style="font-size:8px;color:var(--text-muted);text-transform:uppercase">esperando</div></div>'
        +'<div style="flex:1;min-width:170px">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+'</div>'
          +'<div style="font-size:10.5px;color:var(--text-muted)">Orden '+_esc(x.docnum||'')
            +' · pedido por '+_esc(x.solicitado_por||'')
            +'<br>'+(tipo==='cancelacion'?'Recibida en contabilidad: ':'Solicitada: ')+_esc(t.fecha||'—')+'</div></div>'
        +'<div style="text-align:right;min-width:110px">'
          +'<div style="font-size:13px;font-weight:700;color:'+color+'">'+fmt(x.monto)+'</div>'
          +'<span style="font-size:9.5px;font-weight:700;background:'+(st.bg||'#eee')+';color:'+(st.c||'#333')
            +';border-radius:10px;padding:1px 8px">'+_esc(String(st.t||'').split(' · ')[0])+'</span>'
        +'</div>'
        +'<span style="font-size:9.5px;font-weight:800;color:#fff;background:#dc2626;border-radius:10px;padding:2px 9px">PENDIENTE</span>'
        +'</div>';
    });
  });
  return h+'</div>';
}

function _pgBloqueArtes(lista){
  var h='<div>'
    +'<div style="padding:8px 14px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;background:var(--surface-1)">'
      +'<i class="ti ti-palette" style="color:var(--t-lila)"></i>'
      +'<span style="font-size:12px;font-weight:700;color:var(--t-lila)">Órdenes esperando artes</span>'
      +'<span style="font-size:11px;color:var(--text-muted)">'+lista.length+' pendiente(s)</span>'
    +'</div>';

  if(!lista.length){
    return h+'<div style="padding:9px 14px;font-size:11.5px;color:var(--text-muted)">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde3)"></i> Nada pendiente.</div></div>';
  }

  var porDept={};
  lista.forEach(function(x){ var d=x.dept||'otros'; (porDept[d]=porDept[d]||[]).push(x); });

  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    var peor=0;
    g.forEach(function(x){ var t=_pgDesde(x.desde); if(t.dias!=null && t.dias>peor) peor=t.dias; });
    h+='<div style="padding:6px 14px;background:rgba(0,0,0,.02);font-size:11px;font-weight:700;color:var(--t-lila)">'
      +(EMOJIS2[d]||'')+' '+_esc(dL(d))
      +' <span style="font-weight:400;color:var(--text-muted)">· '+g.length+' orden(es)'
      +' · la más vieja '+peor+' día(s)</span></div>';

    g.sort(function(a,b){
      return (_pgDesde(b.desde).dias||0)-(_pgDesde(a.desde).dias||0);
    }).forEach(function(x){
      var t=_pgDesde(x.desde);
      var col=_pgColor(t.dias);
      h+='<div onclick="_pgIrAArtes(\''+_esc(String(x.oid).replace(/\x27/g,''))+'\')"'
        +' style="padding:8px 14px;border-top:0.5px solid var(--border);display:flex;align-items:center;'
        +'gap:10px;flex-wrap:wrap;cursor:pointer">'
        +'<div style="min-width:56px;text-align:center">'
          +'<div style="font-size:15px;font-weight:800;color:'+col+';line-height:1.1">'+_esc(t.txt)+'</div>'
          +'<div style="font-size:8px;color:var(--text-muted);text-transform:uppercase">esperando</div></div>'
        +'<div style="flex:1;min-width:170px">'
          +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+'</div>'
          +'<div style="font-size:10.5px;color:var(--text-muted)">Orden '+_esc(x.doc||'')
            +'<br>Compras subió el Excel: '+_esc(t.fecha||'—')+'</div></div>'
        +'<div style="text-align:right;min-width:120px">'
          +'<div style="font-size:10.5px;color:var(--t-lila);font-weight:600">'+_esc(x.paso||'')+'</div></div>'
        +'<span style="font-size:9.5px;font-weight:800;color:#fff;background:#dc2626;border-radius:10px;padding:2px 9px">PENDIENTE</span>'
        +'</div>';
    });
  });
  return h+'</div>';
}

// Abre la orden directamente en la etapa de artes
function _pgIrAArtes(oid){
  var idx=STAGES.findIndex(function(s){ return s.key==='artes'; });
  if(idx<0) return;
  initP(oid);
  var sp=(stageProgress[oid]||{}).artes||{};
  window._abrirEtapa={oid:String(oid), key:'artes', paso:(sp.stepIdx||0)};
  try{ _solPagoAbrir(oid); }catch(e){ try{ openDetail(oid); }catch(e2){} }
  _abrirEtapaPedida(0);
}

// ═══════════════════════════════════════════════════════════════════════════
//  SEGUIMIENTO DE ABONOS
//  Los que compras ya pidió a contabilidad y todavía no salieron al proveedor.
//  Muestra los días que llevan esperando y los totales por departamento.
// ═══════════════════════════════════════════════════════════════════════════
function _segDias(iso){
  if(!iso) return null;
  var d=new Date(iso);
  if(isNaN(d)) return null;
  return Math.floor((Date.now()-d.getTime())/(1000*60*60*24));
}

function _segColorDias(n){
  if(n==null) return 'var(--text-muted)';
  if(n>=7)  return '#991b1b';       // más de una semana: urge
  if(n>=4)  return '#B45309';
  return '#166534';
}

// Las solicitudes pedidas y sin comprobante enviado al proveedor
function _segPendientes(){
  return (window._solPago||[]).filter(function(x){
    if(String(x.tipo||'')!=='abono') return false;
    var e=String(x.estado||'');
    // Ya salió al proveedor: deja de estar en seguimiento
    if(e==='abono_enviado' || e==='cancelacion_realizada' || e==='anulada') return false;
    return true;
  });
}

function _segPanel(){
  if(!CU || ['gerencia','compras','contabilidad'].indexOf(CU.role)<0) return '';
  var todas=_segPendientes();

  // Compras ve lo de su departamento; gerencia, todo
  var lista=todas;
  if(CU.role==='compras' && _deptAcotado()){
    lista=todas.filter(function(x){ return _deptPermitido(normDept(x.dept||'')); });
  }
  var abierto=!!window._segAbierto;

  var porDept={}, totalGeneral=0, masViejo=0;
  lista.forEach(function(x){
    var d=x.dept||'otros';
    if(!porDept[d]) porDept[d]={n:0, monto:0, dias:0};
    porDept[d].n++;
    porDept[d].monto+=Number(x.monto)||0;
    var dd=_segDias(x.creado_en||x.solicitado_en);
    if(dd!=null){
      if(dd>porDept[d].dias) porDept[d].dias=dd;
      if(dd>masViejo) masViejo=dd;
    }
    totalGeneral+=Number(x.monto)||0;
  });

  var h='<div style="border:1px solid '+(masViejo>=7?'#dc2626':'#E9C08A')+';border-radius:10px;'
    +'background:'+(masViejo>=7?'#FEF2F2':'#FEF9F3')+';margin-bottom:12px;overflow:hidden">';
  h+='<div onclick="_segToggle()" style="padding:9px 13px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;cursor:pointer">'
    +'<i class="ti ti-clock-dollar" style="color:'+(masViejo>=7?'#991b1b':'#B45309')+'"></i>'
    +'<span style="font-size:12.5px;font-weight:700;color:'+(masViejo>=7?'#991b1b':'#7C3D12')+'">'
      +'Abonos pedidos y sin enviar al proveedor</span>'
    +'<span style="font-size:11px;color:'+(masViejo>=7?'#991b1b':'#7C3D12')+';opacity:.9">'
      +lista.length+' solicitud(es) · '+fmt(totalGeneral)+'</span>'
    +(masViejo>0?('<span style="font-size:10.5px;font-weight:700;background:'+(masViejo>=7?'#dc2626':'#E0A82E')
      +';color:#fff;border-radius:12px;padding:2px 9px">el más viejo: '+masViejo+' día(s)</span>'):'')
    +'<span style="flex:1"></span>'
    +'<i class="ti ti-chevron-'+(abierto?'up':'down')+'" style="color:var(--text-muted)"></i>'
    +'</div>';

  if(!lista.length){
    h+='<div style="padding:10px 13px;font-size:11.5px;color:var(--text-muted);border-top:0.5px solid var(--border)">'
      +'<i class="ti ti-circle-check" style="color:var(--t-verde3)"></i> No hay abonos esperando.</div>';
    return h+'</div>';
  }

  // Totales por departamento, siempre visibles
  h+='<div style="display:flex;gap:6px;flex-wrap:wrap;padding:0 13px 9px">';
  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    h+='<div style="background:var(--surface-0);border:0.5px solid var(--border);border-radius:8px;padding:6px 10px;min-width:130px">'
      +'<div style="font-size:10px;color:var(--text-muted);font-weight:600">'+(EMOJIS2[d]||'')+' '+_esc(dL(d))+'</div>'
      +'<div style="font-size:13px;font-weight:700;color:var(--t-marron)">'+fmt(g.monto)+'</div>'
      +'<div style="font-size:10px;color:'+_segColorDias(g.dias)+'">'+g.n+' orden(es) · hasta '+g.dias+' día(s)</div>'
      +'</div>';
  });
  h+='</div>';

  if(!abierto) return h+'</div>';

  // El detalle, ordenado por antigüedad
  var orden=lista.slice().sort(function(a,b){
    var da=_segDias(a.creado_en||a.solicitado_en)||0;
    var db=_segDias(b.creado_en||b.solicitado_en)||0;
    return db-da;
  });
  orden.forEach(function(x){
    var dd=_segDias(x.creado_en||x.solicitado_en);
    var col=_segColorDias(dd);
    var st=_solEstadoLabel(x);
    h+='<div id="solcard-'+_esc(String(x.id||''))+'" data-soldoc="'+_esc(String(x.docnum||''))+'"'
      +' onclick="_solPagoAbrir(\''+_esc(String(x.docnum||''))+'\')"'
      +' style="border-top:0.5px solid var(--border);padding:8px 13px;background:var(--surface-0);cursor:pointer;display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
      +'<div style="min-width:52px;text-align:center">'
        +'<div style="font-size:17px;font-weight:800;color:'+col+';line-height:1">'+(dd==null?'—':dd)+'</div>'
        +'<div style="font-size:8.5px;color:var(--text-muted);text-transform:uppercase">días</div></div>'
      +'<div style="flex:1;min-width:160px">'
        +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+'</div>'
        +'<div style="font-size:10.5px;color:var(--text-muted)">'
          +'Orden '+_esc(x.docnum||'')+' · '+(EMOJIS2[x.dept]||'')+' '+_esc(dL(x.dept||''))
          +' · pedido por '+_esc(x.solicitado_por||'')+'</div></div>'
      +'<div style="text-align:right;min-width:100px">'
        +'<div style="font-size:13px;font-weight:700;color:var(--t-verde)">'+fmt(x.monto)+'</div>'
        +(st?('<div style="font-size:9.5px;color:var(--text-muted)">'+_esc(st.t||st)+'</div>'):'')
      +'</div>'
      +'</div>';
  });
  return h+'</div>';
}

function _segToggle(){
  window._segAbierto=!window._segAbierto;
  try{ if(PG==='alertas') rAlertas(); }catch(e){}
}

function _solPagoSeccion(tipo, titulo, icono, color, bg, bd){
  var lista=_solPagoPendientes(tipo);
  var h='<div style="border:1px solid '+bd+';background:'+bg+';border-radius:10px;margin-bottom:12px;overflow:hidden">';
  h+='<div style="padding:9px 13px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
    +'<i class="'+icono+'" style="color:'+color+'"></i>'
    +'<span style="font-size:12.5px;font-weight:700;color:'+color+'">'+titulo+'</span>'
    +'<span style="font-size:11px;color:'+color+';opacity:.85">'+lista.length+' orden(es) · '+fmt(lista.reduce(function(a,x){return a+(Number(x.monto)||0);},0))+'</span>'
    +'<button class="btn bg2" style="margin-left:auto;padding:3px 10px;font-size:10.5px" onclick="_solPagoReporte(\''+tipo+'\')"><i class="ti ti-printer"></i> Reporte</button>'
    +'</div>';
  if(!lista.length){
    h+='<div style="padding:10px 13px;font-size:11.5px;color:var(--text-muted);border-top:0.5px solid '+bd+'">Sin solicitudes pendientes.</div>';
    return h+'</div>';
  }
  // Agrupadas por departamento solicitante
  var porDept={};
  lista.forEach(function(x){ var d=x.dept||'otros'; (porDept[d]=porDept[d]||[]).push(x); });
  Object.keys(porDept).sort().forEach(function(d){
    var g=porDept[d];
    var tot=g.reduce(function(a,x){return a+(Number(x.monto)||0);},0);
    h+='<div style="border-top:0.5px solid '+bd+';padding:7px 13px;background:rgba(255,255,255,.45);font-size:11px;font-weight:700;color:'+color+'">'
      +(EMOJIS2[d]||'')+' '+dL(d)+' <span style="font-weight:400">· '+g.length+' orden(es) · '+fmt(tot)+'</span></div>';
    g.forEach(function(x){
      var st=_solEstadoLabel(x);
      // Con id y docnum se puede llegar a esta solicitud desde una alerta
      h+='<div id="solcard-'+_esc(String(x.id||''))+'" data-soldoc="'+_esc(String(x.docnum||''))+'"'
        +' style="border-top:0.5px solid '+bd+';padding:8px 13px;background:var(--surface-0)">'
        +'<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap">'
          +'<div style="flex:1;min-width:150px">'
            +'<div style="font-size:12px;font-weight:600">'+_esc(x.proveedor||'(sin proveedor)')+'</div>'
            +'<div style="font-size:10.5px;color:var(--text-muted);margin-top:1px">'
              +_solRefLinks(x)
              +(x.eta?(' · ETA '+_esc(x.eta)):'')
            +'</div>'
            +'<div style="font-size:10px;color:var(--text-muted);margin-top:1px">'+(x.solicitado_por?('Solicitó '+_esc(x.solicitado_por)):'')+(x.solicitado_en?(' · '+_esc(_fechaHora(x.solicitado_en))):'')+'</div>'
          +'</div>'
          +'<div style="text-align:right;flex-shrink:0"><div style="font-size:13px;font-weight:700;color:'+color+'">'+fmt(x.monto)+'</div></div>'
          +'<button class="btn bp" style="padding:5px 11px;font-size:10.5px;font-weight:600" onclick="_solPagoVerSolicitud('+(x.id||0)+')" title="Abrir la orden en la etapa de Depósito y revisar los adjuntos"><i class="ti ti-folder-open"></i> Ver solicitud</button>'
        +((CU && (CU.role==='contabilidad'||CU.role==='gerencia') && String(x.estado||'')!=='devuelta')
          ? ('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--t-rojo)" onclick="_solDevolver('+(x.id||0)+')" title="Devolver a compras con un motivo"><i class="ti ti-arrow-back-up"></i> Devolver</button>')
          : '')
        +'<button class="btn bg2" style="padding:4px 9px;font-size:10.5px" onclick="_solPagoProcesar('+(x.id||0)+')" title="Marcar como trabajada"><i class="ti ti-check"></i></button>'
        +(_esGerencia()?('<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--t-ambar)" onclick="_solPagoEditar('+(x.id||0)+')" title="Editar el monto"><i class="ti ti-pencil"></i></button>'
          +'<button class="btn bg2" style="padding:4px 9px;font-size:10.5px;color:var(--text-danger)" onclick="_gerBorrarSolicitud('+(x.id||0)+')" title="Borrar esta solicitud"><i class="ti ti-trash"></i></button>'):'')
        +'</div>'
      +_solHitos(x)
        +'<div style="margin-top:5px;display:flex;align-items:center;gap:6px;flex-wrap:wrap">'
          +'<span style="font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;background:'+st.bg+';color:'+st.c+'">'+_esc(st.t)+'</span>'
          +_solFinanciadoChip(x)
          +_solPagadoCheck(x)
          +_solComentBtn(x)
          +_solLeidoPor(x)
        +'</div>'
        +_solComentBox(x, color)
      +'</div>';
    });
  });
  return h+'</div>';
}

// Número de orden y Vendor Ref No, ambos clickeables hacia la orden
function _solRefLinks(x, colorDkc){
  var oid=String(x.docnum||'').replace(/'/g,'');
  var est='color:var(--text-accent);text-decoration:underline;cursor:pointer;font-weight:700';
  var estD='color:'+(colorDkc||'#B45309')+';text-decoration:underline;cursor:pointer;font-weight:700';
  var h='<span onclick="event.stopPropagation();_solPagoAbrir(\''+oid+'\')" title="Abrir la orden" style="'+est+'">#'+_esc(oid)+'</span>';
  if(x.dkc) h+=' - <span onclick="event.stopPropagation();_solPagoAbrir(\''+oid+'\')" title="Abrir la orden" style="'+estD+'">'+_esc(x.dkc)+'</span>';
  return h;
}

// Abre la orden en la etapa de Depósito & Pago, que es donde contabilidad
// trabaja, y marca la solicitud como recibida.
async function _solPagoVerSolicitud(id){
  var x=_solPagoPorId(id);
  if(!x){ showT('Solicitud no encontrada'); return; }
  var oid=String(x.docnum||'');

  // Gerencia solo mira: al abrirla, su alerta se da por leída y desaparece.
  // Antes quedaba en el contador aunque ya la hubiera visto.
  try{
    var mias=(window._menciones||[]).filter(function(m){
      return String(m.docnum)===oid
        && (String(m.contexto||'')==='solicitud'
            || /solicitud|abono|dep[oó]sito|pago/i.test(String(m.etiqueta||'')+' '+String(m.texto||'')));
    });
    for(var i=0;i<mias.length;i++){
      await fetch(SB+'/rest/v1/menciones?id=eq.'+mias[i].id,{method:'PATCH',
        headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
        body:JSON.stringify({leido:true, leido_en:new Date().toISOString()})});
    }
    if(mias.length){
      var ids={};
      mias.forEach(function(m){ ids[String(m.id)]=1; });
      window._menciones=(window._menciones||[]).filter(function(m){ return !ids[String(m.id)]; });
      _menBadge();
    }
  }catch(e){ console.warn('marcar alerta como leída:',e); }
  // Al abrirla, contabilidad la da por recibida. Se espera a que el cambio
  // quede guardado: si el PATCH falla, hay que avisar en vez de fingir.
  if(CU && CU.role==='contabilidad' && !x.recibido_en && (!x.estado || x.estado==='pendiente')){
    x.estado='recibida';
    x.recibido_por=(CU&&CU.name)||'';
    x.recibido_en=new Date().toISOString();
    _solPagoRefrescar();   // se ve el cambio de inmediato
    var ok=await _solPagoPatch(id,{estado:'recibida', recibido_por:x.recibido_por, recibido_en:x.recibido_en});
    if(!ok){
      // Si la tabla rechazó el estado, al menos se guarda la fecha y quién la
      // abrió: con eso el portal ya la muestra como recibida y no se pierde.
      ok=await _solPagoPatch(id,{recibido_por:x.recibido_por, recibido_en:x.recibido_en});
    }
    if(ok){
      try{
        _avSolicitud(_avSolicitante(x), x,
          'Contabilidad recibió tu solicitud · '+(x.recibido_por||''),
          'Solicitud recibida');
      }catch(e){}
      showT('Solicitud RECIBIDA · '+_fechaHora(x.recibido_en)+' — compras ya lo ve');
    } else {
      showT('⚠ No se pudo guardar la recepción. Revisa la conexión o la tabla solicitudes_pago.');
    }
    _solPagoRefrescar();
  }
  // Se deja pedido que al abrir el detalle se despliegue la etapa de depósito,
  // y dentro de ella el subpaso exacto de esta solicitud: el abono se pide en
  // "Solicitud de depósito enviada" y la cancelación en "Solicitud de final
  // del balance". Antes se abría la etapa entera y había que buscarlo.
  var _pasoNombre=(x.tipo==='cancelacion')?'Solicitud de final del balance':'Solicitud de depósito enviada';
  var _et=STAGES.find(function(s){ return s.key==='deposito'; });
  var _pasoIdx=_et?_et.steps.findIndex(function(p){ return p.name===_pasoNombre; }):-1;
  window._abrirEtapa={oid:oid, key:'deposito', paso:(_pasoIdx>=0?_pasoIdx:null)};
  _solPagoAbrir(oid);
  _abrirEtapaPedida(0);
}

// Despliega la etapa que quedó pedida y hace scroll hasta ella.
// Espera a que el detalle esté dibujado en vez de asumir un tiempo fijo:
// abrir una orden NO SAP puede tardar en cargar sus líneas.
function _abrirEtapaPedida(intento){
  var p=window._abrirEtapa; if(!p) return;
  intento=intento||0;
  var idx=STAGES.findIndex(function(s){ return s.key===p.key; });
  if(idx<0){ window._abrirEtapa=null; return; }
  var cab=document.getElementById('egb-'+p.oid+'-'+idx);
  if(!cab){
    if(intento>40){ window._abrirEtapa=null; return; }   // ~6 s y se rinde
    return setTimeout(function(){ _abrirEtapaPedida(intento+1); }, 150);
  }
  var paso=p.paso;               // el subpaso concreto, si se sabe cuál
  window._abrirEtapa=null;
  try{ toggleEG(p.oid, idx, true); }catch(e){ return; }
  setTimeout(function(){
    // Si se sabe el subpaso, se va directo a él; si no, a la etapa
    var destino=null;
    if(paso!=null && paso>=0){
      var cuerpo=document.getElementById('ssb-'+p.oid+'-'+idx+'-'+paso);
      if(cuerpo){
        // El subpaso viene plegado: se abre para que se vea el contenido
        if(cuerpo.style.display==='none'){
          try{ toggleSubStep(p.oid, idx, paso); }catch(e){}
        }
        destino=cuerpo.previousElementSibling || cuerpo;
      }
    }
    var el=destino || document.getElementById('egb-'+p.oid+'-'+idx);
    if(el && el.scrollIntoView) el.scrollIntoView({behavior:'smooth', block:'center'});
    if(el){
      el.style.transition='box-shadow .3s';
      el.style.boxShadow='0 0 0 3px var(--fill-accent)';
      setTimeout(function(){ el.style.boxShadow='none'; }, 2200);
    }
  }, 260);
}

function _solPagoAbrir(oid){
  try{
    if(CU && CU.role==='contabilidad'){
      // Se marca como recibida y se repinta: antes el aviso quedaba igual
      // hasta recargar la página.
      Promise.resolve(_solPagoMarcarRecibidas(oid))
        .then(function(){ try{ _solPagoRefrescar(); }catch(e){} });
    }
  }catch(e){}
  // Siempre el detalle CON ETAPAS. Antes, si la orden era NO SAP, se abría la
  // ficha simple de adjuntos y contabilidad no veía el proceso.
  if((orders||[]).some(function(o){return String(o.id)===String(oid);})) openDetail(oid);
  else if((window._pendSAP||[]).some(function(p){return String(p.dkc)===String(oid)||String(p.num_orden)===String(oid);})) abrirDetalleNoSap(oid);
  else abrirPendSAP(oid);
}

async function _solPagoProcesar(id){
  if(!id){ return; }
  if(!confirm('¿Marcar esta solicitud como trabajada?\n\nDejará de aparecer en el listado de pendientes.')) return;
  try{
    var r=await fetch(SB+'/rest/v1/solicitudes_pago?id=eq.'+id,{
      method:'PATCH', headers:Object.assign({},SBH,{'Prefer':'return=minimal'}),
      body:JSON.stringify({estado:'procesada', procesado_por:(CU&&CU.name)||'', procesado_en:new Date().toISOString()})});
    if(!r.ok){ showT('No se pudo actualizar'); return; }
    (window._solPago||[]).forEach(function(x){ if(String(x.id)===String(id)) x.estado='procesada'; });
    showT('Solicitud marcada como trabajada');
    rAlertas();
  }catch(e){ showT('Error: '+(e.message||e)); }
}

// Entrada desde el menú: se asegura de tener las solicitudes cargadas
async function _solPagoReporteMenu(){
  // Mismo criterio que la conciliación: contabilidad y gerencia general.
  if(!(CU && (CU.role==='contabilidad' || (CU.role==='gerencia' && !_deptAcotado())))){
    showT('Ese reporte es de contabilidad y gerencia general');
    return;
  }
  showT('Cargando las solicitudes…');
  await _solPagoCargar(true);
  _solPagoPanel();
}

// ══════════════════════════════════════════════════════════════════════
//  PANEL PREVIO AL REPORTE
//  Antes se iba directo a imprimir. Contabilidad necesita ver la lista,
//  marcar lo que ya se pagó y solo entonces sacar el papel.
// ══════════════════════════════════════════════════════════════════════
window._solPanelFiltro = window._solPanelFiltro || 'todas';

// ── Edición en el propio panel ──
// Contabilidad necesita corregir sobre la marcha: la ETA que cambió, el
// estado, quién lo preparó, si va financiado… Cada celda se guarda al salir
// de ella, y si la base lo rechaza se avisa y se deja el valor anterior.
function _solEditable(x, campo, valor, extra){
  var puede = CU && (CU.role==='contabilidad' || CU.role==='gerencia');
  if(!puede) return _esc(valor||'');
  return '<span contenteditable="true" spellcheck="false"'
    +' data-id="'+(x.id||0)+'" data-campo="'+campo+'"'
    +' onblur="_solGuardarCampo(this)"'
    +' onkeydown="if(event.key===\'Enter\'){event.preventDefault();this.blur();}'
    +'if(event.key===\'Escape\'){this.textContent=this.dataset.orig||\'\';this.blur();}"'
    +' onfocus="this.dataset.orig=this.textContent"'
    +' style="display:inline-block;min-width:34px;border-bottom:1px dashed var(--border);'
    +'padding:1px 3px;border-radius:3px;outline:none;'+(extra||'')+'"'
    +' title="Pulsa para editar · Intro guarda · Escape cancela">'
    +_esc(valor||'')+'</span>';
}

// Los campos de dos o tres valores van con desplegable: se ve de un vistazo
// qué opciones hay y no hace falta adivinar qué pasa al pulsar.
function _solDesplegable(x, campo, opciones, ancho){
  var puede = CU && (CU.role==='contabilidad' || CU.role==='gerencia');
  var v=x[campo];
  var actual = opciones.find(function(o){ return o.v===v; }) || opciones[0];
  if(!puede) return '<b style="color:'+(actual.c||'inherit')+'">'+_esc(actual.t)+'</b>';
  return '<select onchange="_solElegir('+(x.id||0)+',\''+campo+'\', this.value)" '
    +'style="font-size:10.5px;font-weight:600;padding:2px 4px;border-radius:7px;cursor:pointer;'
    +'border:0.5px solid var(--border);background:var(--surface-0);'
    +'color:'+(actual.c||'inherit')+';'+(ancho?('width:'+ancho+';'):'')+'">'
    + opciones.map(function(o){
        return '<option value="'+_esc(String(o.v))+'"'
          +((o.v===v)?' selected':'')+'>'+_esc(o.t)+'</option>';
      }).join('')
    +'</select>';
}

// SÍ / NO / sin dato, para financiado y pagado
function _solSiNo(x, campo){
  return _solDesplegable(x, campo, [
    {v:null,  t:'—',  c:'var(--text-muted)'},
    {v:true,  t:'SÍ', c:'#3730A3'},
    {v:false, t:'NO', c:'var(--text-muted)'}
  ], '62px');
}

// Guarda la opción elegida. El valor viaja como texto desde el desplegable,
// así que hay que devolverlo a su tipo antes de guardarlo.
async function _solElegir(id, campo, valor){
  var x=(window._solPago||[]).find(function(s){ return String(s.id)===String(id); });
  if(!x) return;
  var nuevo = (valor==='true') ? true : (valor==='false' ? false
              : (valor==='null'||valor==='') ? null : valor);
  var antes = x[campo];
  if(nuevo===antes) return;
  var envio={}; envio[campo]=nuevo;
  // Al marcarla como pagada se guarda también quién y cuándo, que es lo que
  // se enseña debajo y lo que sale en el reporte.
  if(campo==='pagado'){
    if(nuevo===true){
      envio.pagado_en=new Date().toISOString();
      envio.pagado_por=(CU&&CU.name)||'';
    } else {
      envio.pagado_en=null; envio.pagado_por=null;
    }
  }
  var ok=false;
  try{ ok = await _solPagoPatch(id, envio); }catch(e){}
  if(!ok){
    showT('No se pudo guardar "'+campo+'". ¿Falta esa columna en solicitudes_pago?');
    console.error('[solicitud] no se guardó '+campo+' de la solicitud '+id);
    _solRepintarDondeEste();          // devuelve el desplegable a su valor
    return;
  }
  Object.keys(envio).forEach(function(k){ x[k]=envio[k]; });
  showT(campo==='pagado'
    ? (nuevo===true?'Marcada como pagada · sale de las alertas'
       : (nuevo===false?'Queda por pagar':'Sin dato de pago'))
    : 'Guardado');
  _solRepintarDondeEste();
}

// Los campos que se pueden escribir a mano y cómo se guardan
var SOL_CAMPOS = {
  dkc:            {col:'dkc',            texto:true},
  monto:          {col:'monto',          numero:true},
  eta:            {col:'eta_texto',      texto:true},
  estado_excel:   {col:'estado_excel',   texto:true, mayus:true},
  solicitado_por: {col:'solicitado_por', texto:true},
  banco:          {col:'banco',          texto:true},
  proveedor:      {col:'proveedor',      texto:true}
};

async function _solGuardarCampo(el){
  if(!el) return;
  var id=el.getAttribute('data-id'), campo=el.getAttribute('data-campo');
  var def=SOL_CAMPOS[campo];
  var antes=String(el.dataset.orig||'');
  var texto=String(el.textContent||'').trim();
  if(!def || texto===antes.trim()) return;          // nada que hacer

  var x=(window._solPago||[]).find(function(s){ return String(s.id)===String(id); });
  if(!x){ el.textContent=antes; return; }

  var valor=texto;
  if(def.mayus) valor=texto.toUpperCase();
  if(def.numero){
    var n=parseFloat(texto.replace(/[^0-9.\-]/g,''));
    if(isNaN(n)){
      showT('"'+texto+'" no es un número');
      el.textContent=antes; return;
    }
    valor=n;
  }

  var envio={}; envio[def.col]=valor;
  // La ETA escrita a mano se guarda como texto: puede ser "ANTES DE ARRIBO"
  if(campo==='eta') envio.eta=null;

  var ok=false;
  try{ ok = await _solPagoPatch(id, envio); }catch(e){}
  if(!ok){
    showT('No se pudo guardar. ¿Falta la columna "'+def.col+'" en solicitudes_pago?');
    console.error('[solicitud] no se guardó '+def.col+' de la solicitud '+id);
    el.textContent=antes;
    return;
  }
  x[def.col]=valor;
  if(campo==='eta'){ x.eta=null; x.eta_texto=valor; }
  el.dataset.orig=el.textContent;
  el.style.background='#dcfce7';
  setTimeout(function(){ try{ el.style.background=''; }catch(e){} }, 900);
  showT('Guardado');
  // El monto cambia los totales de arriba
  if(def.numero) _solRepintarDondeEste();
}

function _solPanelLista(){
  var todas=(window._solPago||[]).slice();
  var f=window._solPanelFiltro;
  if(f==='excel')   todas=todas.filter(_esDelExcel);
  if(f==='pagadas') todas=todas.filter(function(x){ return _solPagadaYa(x); });
  if(f==='abiertas')todas=todas.filter(function(x){ return !_solPagadaYa(x); });
  return todas.sort(function(a,b){
    var d=String(a.dept||'').localeCompare(String(b.dept||''));
    if(d) return d;
    return String(a.proveedor||'').localeCompare(String(b.proveedor||''));
  });
}

function _solPanelSetFiltro(v){ window._solPanelFiltro=v; _solPagoPanel(); }

function _solPagoPanel(){
  var lista=_solPanelLista();
  var todas=(window._solPago||[]);
  var pastilla=function(k,t,n){
    var on=(window._solPanelFiltro===k);
    return '<span onclick="_solPanelSetFiltro(\''+k+'\')" style="cursor:pointer;'
      +'border:1px solid '+(on?'#72243E':'var(--border)')+';background:'+(on?'#72243E':'var(--surface-0)')
      +';color:'+(on?'#fff':'#72243E')+';border-radius:20px;padding:4px 12px;font-size:11px;'
      +'font-weight:600;white-space:nowrap">'+t+' <span style="opacity:.8">'+n+'</span></span>';
  };

  var totAb=lista.filter(function(x){return x.tipo==='abono';})
                 .reduce(function(a,x){return a+(Number(x.monto)||0);},0);
  var totCa=lista.filter(function(x){return x.tipo==='cancelacion';})
                 .reduce(function(a,x){return a+(Number(x.monto)||0);},0);

  var filas=lista.map(function(x){
    var esEx=_esDelExcel(x);
    var pag=_solPagadaYa(x);
    var st=_solEstadoLabel(x);
    var puede = CU && (CU.role==='contabilidad' || CU.role==='gerencia');
    return '<tr style="border-top:0.5px solid var(--border);'
        +(pag?'background:var(--pastel-ok2)':'')+'">'
      +'<td style="padding:6px 8px">'
        +'<div style="font-size:11.5px;font-weight:600">'
          +_solEditable(x,'proveedor',x.proveedor,'font-weight:600')+'</div>'
        +'<div style="font-size:10px;color:var(--text-muted)">'+_esc(dL(x.dept||''))+'</div></td>'
      +'<td style="padding:6px 8px;font-size:10.5px;max-width:230px;word-break:break-word">'
        +_solEditable(x,'dkc',(x.dkc||x.docnum||''))+'</td>'
      +'<td style="padding:6px 8px;text-align:right;font-weight:700;font-size:12px;'
        +'color:'+(x.tipo==='abono'?'#166534':'#B45309')+';white-space:nowrap">'
        +_solEditable(x,'monto',fmt(x.monto),'font-weight:700;text-align:right')+'</td>'
      +'<td style="padding:6px 8px;font-size:10.5px">'
        +_solDesplegable(x,'tipo',[
            {v:'abono',      t:'Abono',       c:'#166534'},
            {v:'cancelacion',t:'Cancelación', c:'#B45309'}
          ],'110px')+'</td>'
      +'<td style="padding:6px 8px;font-size:10.5px;white-space:nowrap">'
        +_solEditable(x,'eta',(x.eta||x.eta_texto||''))+'</td>'
      // En las cargadas del Excel manda el STATUS de la hoja de contabilidad
      // (REVISADO…), que es como Yeini las tiene clasificadas. En las nacidas
      // dentro del portal se sigue mostrando el estado del proceso.
      +'<td style="padding:6px 8px"><span style="font-size:9.5px;font-weight:600;padding:2px 7px;'
        +'border-radius:8px;white-space:nowrap;background:'+(esEx?'#EEF2FF':st.bg)+';'
        +'color:'+(esEx?'#3730A3':st.c)+'">'
        +(esEx ? _solEditable(x,'estado_excel',(x.estado_excel||'SIN ESTADO'),
                   'font-weight:600;color:var(--t-indigo2);border-bottom-color:#c7d2fe')
               : _esc(st.t))
        +'</span></td>'
      +'<td style="padding:6px 8px;font-size:10.5px">'
        +_solEditable(x,'solicitado_por',x.solicitado_por)
        +(x.solicitado_en?('<div style="font-size:9px;color:#666">'
            +_esc(_fechaHora(x.solicitado_en))+'</div>'):'')+'</td>'
      +'<td style="padding:6px 8px;text-align:center;font-size:10.5px">'
        +_solSiNo(x,'financiado')+'</td>'
      +'<td style="padding:6px 8px;text-align:center">'
        +(esEx
          ? (_solDesplegable(x,'pagado',[
               {v:null,  t:'—',        c:'var(--text-muted)'},
               {v:true,  t:'Pagada',   c:'#166534'},
               {v:false, t:'Por pagar',c:'#B45309'}
             ],'95px')
             +(pag&&x.pagado_en?('<div style="font-size:9px;color:#666">'+_esc(_fechaHora(x.pagado_en))+'</div>'):''))
          : '<span style="font-size:10px;color:var(--text-muted)">—</span>')
        +'</td>'
      +'</tr>';
  }).join('');

  document.getElementById('mc').innerHTML =
     '<div class="mt"><div style="font-size:26px">💵</div><div style="flex:1">'
    +'<div style="font-size:14px;font-weight:600">Abonos y cancelaciones</div>'
    +'<div style="font-size:11.5px;color:var(--text-muted)">Revisa la lista, marca lo que '
    +'ya se pagó y genera el reporte cuando esté al día. '
    +'<b>Pulsa cualquier dato para corregirlo</b>: se guarda solo al salir de la celda.</div></div>'
    +'<button class="btn bg2" onclick="CM()"><i class="ti ti-x"></i></button></div>'

    +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;margin:10px 0">'
      +pastilla('abiertas','Por pagar', todas.filter(function(x){return !_solPagadaYa(x);}).length)
      +pastilla('pagadas','Pagadas',   todas.filter(_solPagadaYa).length)
      +pastilla('excel','Del Excel',   todas.filter(_esDelExcel).length)
      +pastilla('todas','Todas',       todas.length)
      +'<span style="flex:1"></span>'
      +'<span style="font-size:11px;color:var(--text-muted)">'
        +'Abonos <b>'+fmt(totAb)+'</b> · Cancelaciones <b>'+fmt(totCa)+'</b></span>'
    +'</div>'

    +(lista.length
      // Sin altura tope: la tabla se ve entera y el que hace scroll es el
      // modal, no una caja dentro de otra caja.
      ? ('<div style="border:0.5px solid var(--border);border-radius:9px;overflow:hidden">'
        +'<table style="width:100%;border-collapse:collapse;font-size:11px">'
        +'<thead><tr style="background:var(--surface-2)">'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Proveedor</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Orden / Factura</th>'
          +'<th style="padding:7px 8px;text-align:right;font-size:9.5px;text-transform:uppercase">Monto</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Concepto</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">ETA</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Estado</th>'
          +'<th style="padding:7px 8px;text-align:left;font-size:9.5px;text-transform:uppercase">Preparado por</th>'
          +'<th style="padding:7px 8px;text-align:center;font-size:9.5px;text-transform:uppercase">Financ.</th>'
          +'<th style="padding:7px 8px;text-align:center;font-size:9.5px;text-transform:uppercase">Pagado</th>'
        +'</tr></thead><tbody>'+filas+'</tbody></table></div>')
      : '<div class="empty" style="padding:22px;color:var(--text-muted)">'
        +'<i class="ti ti-mood-check" style="font-size:22px;color:var(--t-verde)"></i><br>'
        +'Nada que mostrar con este filtro.</div>')

    +'<div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;margin-top:12px">'
      +'<span style="flex:1;font-size:10.5px;color:var(--text-muted);align-self:center">'
        +lista.length+' solicitud(es) · el reporte sale con lo que ves aquí</span>'
      +'<button class="btn bg2" onclick="_solPagoReporte(\'abono\')">'
        +'<i class="ti ti-printer"></i> Solo abonos</button>'
      +'<button class="btn bg2" onclick="_solPagoReporte(\'cancelacion\')">'
        +'<i class="ti ti-printer"></i> Solo cancelaciones</button>'
      +'<button class="btn bp" style="background:#72243E" onclick="_solPagoReporte(\'\')">'
        +'<i class="ti ti-printer"></i> Generar reporte</button>'
    +'</div>';
  try{ document.getElementById('mc').classList.add('md-ancho'); }catch(e){}
  document.getElementById('modal').style.display='flex';
}

// ── Reporte imprimible ──
// tipo: 'abono' | 'cancelacion' | '' (ambos)
function _solPagoReporte(tipo){
  var lista=(window._solPago||[]).filter(function(x){ return !tipo || x.tipo===tipo; });
  if(!lista.length){ showT('No hay solicitudes para el reporte'); return; }
  lista=lista.slice().sort(function(a,b){
    var d=String(a.dept||'').localeCompare(String(b.dept||''));
    return d!==0?d:String(a.proveedor||'').localeCompare(String(b.proveedor||''));
  });
  var totAb=lista.filter(function(x){return x.tipo==='abono';}).reduce(function(a,x){return a+(Number(x.monto)||0);},0);
  var totCa=lista.filter(function(x){return x.tipo==='cancelacion';}).reduce(function(a,x){return a+(Number(x.monto)||0);},0);

  var filas=lista.map(function(x){
    var conc=(x.tipo==='abono')?'ABONO':'CANCELACIÓN';
    var col=(x.tipo==='abono')?'#166534':'#B45309';
    return '<tr>'
      +'<td>'+_esc(x.proveedor||'')+'</td>'
      +'<td class="ref"><a href="#" onclick="_solPagoAbrir(\''+_esc(String(x.docnum))+'\');return false;">#'+_esc(String(x.docnum))+'</a>'
        +(x.dkc?('<br><a href="#" class="dkc" onclick="_solPagoAbrir(\''+_esc(String(x.docnum))+'\');return false;">'+_esc(x.dkc)+'</a>'):'')+'</td>'
      +'<td class="num">'+fmt(x.monto)+'</td>'
      +'<td>'+_esc(dL(x.dept||''))+'</td>'
      +'<td><span class="conc" style="color:'+col+'">'+conc+'</span></td>'
      +'<td>'+_esc(x.eta||'—')+'</td>'
      +'<td>'+_esc(x.solicitado_por||'')+(x.solicitado_en?('<br><span style="font-size:9.5px;color:#666">'+_esc(_fechaHora(x.solicitado_en))+'</span>'):'')+'</td>'
      +'<td>'+_esc(_solEstadoLabel(x).t)+(x.recibido_en&&x.estado==='recibida'?'':'')+'</td>'
      +'<td>'+(_esDelExcel(x) ? (x.financiado===true?'SÍ':(x.financiado===false?'NO':'—')) : '')+'</td>'
      +'<td>'+(_esDelExcel(x)
          ? (_solPagadaYa(x)
              ? ('SÍ'+(x.pagado_en?('<br><span style="font-size:9px;color:#666">'
                    +_esc(_fechaHora(x.pagado_en))+'</span>'):''))
              : 'NO')
          : '')+'</td>'
      +'</tr>';
  }).join('');

  var titulo=tipo==='abono'?'Solicitudes de abono'
           :tipo==='cancelacion'?'Solicitudes de cancelación'
           :'Solicitudes de abono y cancelación';

  var w=window.open('','_blank');
  if(!w){ showT('El navegador bloqueó la ventana del reporte'); return; }
  w.document.write('<!DOCTYPE html><html lang="es"><head><meta charset="utf-8"><title>'+titulo+'</title>'
    +'<style>:root{--surface-0:#fff;--surface-1:#fff;--surface-2:#fff;--text-primary:#111;--text-secondary:#444;--text-muted:#666;--border:rgba(0,0,0,.15);--border-strong:rgba(0,0,0,.3)}body{background:#fff;color:#111}</style>'
    +'<style>'
    +'*{box-sizing:border-box}'
    +'body{font-family:Segoe UI,Helvetica,Arial,sans-serif;color:var(--text-primary);margin:24px;font-size:12px}'
    +'h1{font-size:17px;margin:0 0 2px}'
    +'.sub{font-size:11px;color:#666;margin-bottom:14px}'
    +'table{width:100%;border-collapse:collapse}'
    +'th{background:var(--pastel-gris);text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.04em;padding:7px 8px;border-bottom:1.5px solid #d9d7d0}'
    +'td{padding:7px 8px;border-bottom:.5px solid #e6e4dd;vertical-align:top}'
    +'tr:nth-child(even) td{background:var(--surface-0)}'
    +'.num{text-align:right;white-space:nowrap;font-variant-numeric:tabular-nums}'
    +'th.num{text-align:right}'
    +'.ref a{color:var(--t-azul);font-weight:700;text-decoration:underline}'
    +'.dkc{font-size:10px;color:var(--t-ambar);font-weight:700;text-decoration:underline}'
    +'.conc{font-weight:700;font-size:10.5px}'
    +'tfoot td{border-top:1.5px solid #d9d7d0;font-weight:700;background:var(--surface-2)}'
    +'.gt td{border-top:2px solid #1a1a18;font-size:13px}'
    +'@media print{body{margin:10mm}.noprint{display:none}}'
    +'</style></head><body>'
    +'<h1>'+titulo+'</h1>'
    +'<div class="sub">Kennedy Center Corp. · '+lista.length+' solicitud(es) · Generado el '
      +new Date().toLocaleString('es')+' por '+((CU&&CU.name)||'')+'</div>'
    +'<table><thead><tr>'
      +'<th>Proveedor</th><th>Orden / DKC</th><th class="num">Monto</th>'
      +'<th>Departamento</th><th>Concepto</th><th>ETA</th><th>Solicitó</th><th>Estado</th>'
      // Financiado y Pagado vienen del Excel de contabilidad. Solo tienen
      // valor en las solicitudes cargadas de ahí; en las demás van vacías.
      +'<th>Financ.</th><th>Pagado</th>'
    +'</tr></thead><tbody>'+filas+'</tbody>'
    +'<tfoot>'
      +'<tr><td colspan="2">TOTAL ABONOS</td><td class="num">'+fmt(totAb)+'</td><td colspan="5"></td></tr>'
      +'<tr><td colspan="2">TOTAL CANCELACIONES</td><td class="num">'+fmt(totCa)+'</td><td colspan="5"></td></tr>'
      +'<tr class="gt"><td colspan="2">GRAN TOTAL</td><td class="num">'+fmt(totAb+totCa)+'</td><td colspan="5"></td></tr>'
    +'</tfoot></table>'
    +'<div class="noprint" style="margin-top:16px"><button onclick="window.print()" '
      +'style="background:#0c447c;color:#fff;border:none;border-radius:7px;padding:9px 18px;font-size:13px;cursor:pointer">Imprimir</button></div>'
    +'</body></html>');
  w.document.close();
  // El clic en la orden vuelve a esta ventana
  try{ w._solPagoAbrir=function(id){ w.close(); _solPagoAbrir(id); }; }catch(e){}
}

// ── Imprimir UNA solicitud tal como llegó a contabilidad ──
// Solo la solicitud: los datos de la orden y el cuerpo del correo que escribió
// la compradora. Los adjuntos se listan por su nombre, pero no se vuelcan:
// se abren desde la propia solicitud si hace falta verlos.
function _solImprimirSolicitud(oid, tipo){
  var e=_solEnvioLeer(oid, tipo);
  if(!e){ showT('No hay correo guardado para esta solicitud'); return; }
  var x=(window._solPago||[]).find(function(s){ return String(s.docnum)===String(oid) && s.tipo===tipo; });
  var d=_solPagoDatosOrden(oid);
  var titulo=(tipo==='abono')?'Solicitud de abono':'Solicitud de cancelación de saldo';

  var meta=[];
  meta.push(['Orden', String(oid)+((x&&x.dkc)?(' · '+x.dkc):(d.dkc?(' · '+d.dkc):''))]);
  meta.push(['Proveedor', (x&&x.proveedor)||d.proveedor||'—']);
  meta.push(['Departamento', dL((x&&x.dept)||d.dept||'')||'—']);
  if(d.total) meta.push(['Total de la orden', fmt(d.total)]);
  meta.push(['Monto solicitado', fmt((e.monto!=null?e.monto:(x&&x.monto))||0)]);
  meta.push(['Solicitó', (e.por||(x&&x.solicitado_por)||'—')+(e.fecha?(' · '+_fechaHora(e.fecha)):'')]);
  if(e.para && e.para.length) meta.push(['Enviado a', e.para.join(', ')]);
  if(e.asunto) meta.push(['Asunto', e.asunto]);
  if(x && x.recibido_en) meta.push(['Recibida por', (x.recibido_por||'')+' · '+_fechaHora(x.recibido_en)]);

  var filasMeta=meta.map(function(m){
    return '<tr><th>'+_esc(m[0])+'</th><td>'+_esc(String(m[1]))+'</td></tr>';
  }).join('');

  var adj=(e.adjuntos||[]);
  var listaAdj=adj.length
    ? '<ul class="adj">'+adj.map(function(a){
        return '<li>'+_esc(a.nombre||'')+(a.kb?(' <span class="kb">· '+a.kb+' KB</span>'):'')+'</li>';
      }).join('')+'</ul>'
    : '<div class="vacio">No quedó registro de adjuntos en esta solicitud.</div>';

  var w=window.open('','_blank');
  if(!w){ showT('El navegador bloqueó la ventana de impresión'); return; }
  w.document.write('<!DOCTYPE html><html lang="es"><head><meta charset="utf-8"><title>'+_esc(titulo+' - '+oid)+'</title>'
    +'<style>:root{--surface-0:#fff;--surface-1:#fff;--surface-2:#fff;--text-primary:#111;--text-secondary:#444;--text-muted:#666;--border:rgba(0,0,0,.15);--border-strong:rgba(0,0,0,.3)}body{background:#fff;color:#111}</style>'
    +'<style>'
    +'*{box-sizing:border-box}'
    +'body{font-family:Segoe UI,Helvetica,Arial,sans-serif;color:var(--text-primary);margin:24px;font-size:12px}'
    +'h1{font-size:17px;margin:0 0 2px}'
    +'.sub{font-size:11px;color:#666;margin-bottom:14px}'
    +'table.meta{width:100%;border-collapse:collapse;margin-bottom:16px}'
    +'table.meta th{background:var(--pastel-gris);text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.04em;'
      +'padding:6px 8px;border-bottom:.5px solid #e6e4dd;width:170px;vertical-align:top}'
    +'table.meta td{padding:6px 8px;border-bottom:.5px solid #e6e4dd;vertical-align:top}'
    +'h2{font-size:12px;text-transform:uppercase;letter-spacing:.04em;color:#555;margin:16px 0 6px}'
    +'.cuerpo{white-space:pre-wrap;background:var(--surface-0);border:.5px solid #e6e4dd;border-radius:6px;padding:12px 14px;line-height:1.55}'
    +'ul.adj{margin:0;padding-left:18px}'
    +'ul.adj li{padding:2px 0}'
    +'.kb{color:#666;font-size:10.5px}'
    +'.vacio{color:#888;font-style:italic}'
    +'@page{size:A4 portrait;margin:14mm}'
    +'@media print{body{margin:0}.noprint{display:none}}'
    +'</style></head><body>'
    +'<h1>'+_esc(titulo)+'</h1>'
    +'<div class="sub">Kennedy Center Corp. · Impreso el '+new Date().toLocaleString('es')
      +' por '+_esc((CU&&CU.name)||'')+'</div>'
    +'<table class="meta">'+filasMeta+'</table>'
    +'<h2>Mensaje enviado</h2>'
    +'<div class="cuerpo">'+_esc(e.cuerpo||'(no quedó guardado el cuerpo del mensaje)')+'</div>'
    +'<h2>Adjuntos enviados</h2>'+listaAdj
    +'<div class="noprint" style="margin-top:18px"><button onclick="window.print()" '
      +'style="background:#0c447c;color:#fff;border:none;border-radius:7px;padding:9px 18px;font-size:13px;cursor:pointer">Imprimir</button></div>'
    +'</body></html>');
  w.document.close();
}

function go(id,btn){
  // Al cambiar de pantalla se sale del modo completo, si estaba puesto
  if(window._repFull && id!=='reposiciones'){
    try{ _repPantallaCompleta(); }catch(e){}
  }
  PG=id;try{ _accPantalla(id); }catch(e){}
  try{document.getElementById('modal').style.display='none';document.getElementById('qmodal').style.display='none';}catch(e){}document.querySelectorAll('.page').forEach(p=>p.classList.remove('active'));document.querySelectorAll('.nb').forEach(b=>b.classList.remove('active'));const pg=document.getElementById('page-'+id);if(pg)pg.classList.add('active');if(btn)btn.classList.add('active');else document.querySelectorAll('.nb').forEach(b=>{if((b.getAttribute('onclick')||'').includes(`'${id}'`))b.classList.add('active');});if(id==='dashboard')rDash();else if(id==='ordenes')rOrdenes(dO);else if(id==='completadas')rCompletadas(dComp);else if(id==='pendientes')rPendientes(dP);else if(id==='contab')rContab(dC);else if(id==='deptos')rDeptos();else if(id==='mistarea')rMiTarea(dMT);else if(id==='alertas')rAlertas();else if(id==='reposiciones')rReposiciones();else if(id==='reppedidos')rReposiciones();else if(id==='nueva')rNueva();else if(id==='livechat')rLiveChat();else if(id==='reportes')rReportes();else if(id==='catnosap')rCatNoSap();else if(id==='inventario')rInventario();else if(id==='ocpend')rOcPend();else if(id==='accesos')rAccesos();else if(id==='concil')rConcil();
  // Al entrar a Alertas se releen las solicitudes, una sola vez
  if(id==='alertas' && CU && ['contabilidad','gerencia','compras'].indexOf(CU.role)>=0 && window._solPagoListo){
    if(!window._solPagoRefrescando){
      window._solPagoRefrescando=true;
      _solPagoCargar(true).then(function(){
        window._solPagoRefrescando=false;
        if(PG==='alertas'){ try{ rAlertas(); }catch(e){} }
      }).catch(function(){ window._solPagoRefrescando=false; });
    }
  }try{_navPintarVolver();}catch(e){}}
function showT(msg, ms){
  const t=document.createElement('div');
  t.className='toast';
  t.textContent=msg;
  document.body.appendChild(t);
  // Los avisos largos necesitan más tiempo para poder leerse
  setTimeout(()=>t.remove(), Number(ms)>0?Number(ms):3500);
}
renderLogin();
